/* Generated by scripts/build-ancestors.js from data/millsfamily.ged, plus generations through 10 from aq.ged. Do not edit by hand. */

export const LINEAGE_META = {
  "count": 1227,
  "generations": 11,
  "earliest": 1646,
  "latest": 2025
};

export const LINEAGE_PLACES = [
  {
    "id": "united-states",
    "label": "United States",
    "color": "#90abde"
  },
  {
    "id": "england",
    "label": "England",
    "color": "#e4a8b6"
  },
  {
    "id": "germany",
    "label": "Germany",
    "color": "#e4d078"
  },
  {
    "id": "unknown",
    "label": "Unrecorded",
    "color": "#8d948e"
  },
  {
    "id": "switzerland",
    "label": "Switzerland",
    "color": "#c44738"
  },
  {
    "id": "wales",
    "label": "Wales",
    "color": "#72c99c"
  },
  {
    "id": "ireland",
    "label": "Ireland",
    "color": "#4eaea6"
  },
  {
    "id": "france",
    "label": "France",
    "color": "#3e5f9a"
  },
  {
    "id": "denmark",
    "label": "Denmark",
    "color": "#d15a9a"
  },
  {
    "id": "scotland",
    "label": "Scotland",
    "color": "#8b78d0"
  },
  {
    "id": "canada",
    "label": "Canada",
    "color": "#c9a0d4"
  },
  {
    "id": "holy-roman-empire",
    "label": "Holy Roman Empire",
    "color": "#9a6230"
  },
  {
    "id": "netherlands",
    "label": "Netherlands",
    "color": "#e07a32"
  },
  {
    "id": "austria",
    "label": "Austria",
    "color": "#a84b6a"
  },
  {
    "id": "belgium",
    "label": "Belgium",
    "color": "#9aaf52"
  }
];

const BIRTHPLACE_BY_ID = Object.fromEntries(LINEAGE_PLACES.map((place) => [place.id, place]));

export const ANCESTORS = [
  {
    "id": "I1",
    "name": "Kai Micah Mills",
    "sex": "M",
    "gen": 0,
    "slot": 0,
    "side": "self",
    "birthplace": "united-states",
    "childId": null,
    "birthYear": 1998,
    "deathYear": null,
    "birthDate": "5 Jun 1998",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Frederick, Maryland, United States",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "L1Z5-D33",
    "photo": null,
    "living": true,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "I2",
    "name": "Tad Mills",
    "sex": "M",
    "gen": 1,
    "slot": 0,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "I1",
    "birthYear": 1966,
    "deathYear": null,
    "birthDate": "20 Mar 1966",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Pocatello, Bannock, Idaho, United States",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "L1Z5-GLG",
    "photo": "/ancestors/bubbles/tad.jpg",
    "living": true,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/tad.jpg"
  },
  {
    "id": "I5",
    "name": "Brent Mills",
    "sex": "M",
    "gen": 2,
    "slot": 0,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "I2",
    "birthYear": 1941,
    "deathYear": null,
    "birthDate": "1941",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "United States",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "L1ZR-SJK",
    "photo": "/ancestors/bubbles/brent.jpg",
    "living": true,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/brent.jpg"
  },
  {
    "id": "I29",
    "name": "Paul Henry Mills",
    "sex": "M",
    "gen": 3,
    "slot": 0,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "I5",
    "birthYear": 1917,
    "deathYear": 1989,
    "birthDate": "11 Sep 1917",
    "deathDate": "4 May 1989",
    "burialDate": "8 May 1989",
    "christeningDate": null,
    "birthPlace": "Malad, Oneida, Idaho, United States",
    "deathPlace": "Malad, Oneida, Idaho, United States",
    "burialPlace": "Malad, Oneida, Idaho, United States",
    "christeningPlace": null,
    "fsId": "KWZ8-6KJ",
    "photo": "/ancestors/bubbles/008_KWZ8-6KJ.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [
      {
        "kind": "Blessing",
        "date": "4 November 1917",
        "place": null,
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1920",
        "place": "Malad, Oneida, Idaho, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1930",
        "place": "Malad, Oneida, Idaho, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1935",
        "place": "Same House",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1940",
        "place": "Malad Election Precinct 2, Oneida, Idaho, United States",
        "note": null
      },
      {
        "kind": "Social Program Application",
        "date": "January 1956",
        "place": null,
        "note": null
      },
      {
        "kind": "Obituary",
        "date": "1989",
        "place": "Idaho, United States",
        "note": null
      },
      {
        "kind": "Membership",
        "date": null,
        "place": "Malad, Utah, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Paul Henry Mills, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7QFC-JJF",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:65QT-63RQ : Thu Mar 26 19:02:26 UTC 2026), Entry for Paul Henry Mills and Henry I."
      },
      {
        "title": "Paul H Mills, \"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q7LF-LL1",
        "citation": "\"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6KWK-637P : Tue Jun 30 23:04:29 UTC 2026), Entry for Paul Henry Mills and Henry I Mills."
      },
      {
        "title": "Paul Henry Mills, \"United States, Census, 1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3PHW-T81",
        "citation": "\"United States, Census, 1950\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6XK2-36KL : Tue Mar 18 08:41:47 UTC 2025), Entry for Boyd S and Paul Henry Mills, April 11, 1950."
      },
      {
        "title": "Paul Mills, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3WRD-DRX",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:ZP8R-S3T2 : Sun Mar 29 10:25:47 UTC 2026), Entry for Paul Mills, 1935."
      },
      {
        "title": "Mr Paul H Mills, \"Utah, Box Elder, Tremonton and Garland Obituaries, 1959-2013\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3SY6-L3C",
        "citation": "\"Utah, Box Elder, Tremonton and Garland Obituaries, 1959-2013\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2QP-5F31 : Sat Mar 09 12:54:40 UTC 2024), Entry for Boyd Stuart Mills and Mr Paul H Mills, 1967."
      },
      {
        "title": "Paul Mills, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3SYM-5GQ",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:D6SD-KLMM : Mon Mar 30 07:39:40 UTC 2026), Entry for Paul Mills, 1955."
      },
      {
        "title": "Paul Henry Mills, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3SRT-J3P",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:D6SX-ZP2M : Sun Mar 29 11:51:34 UTC 2026), Entry for Paul Henry Mills, 1960."
      },
      {
        "title": "Paul Henry Mills, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3SRT-N1J",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:8ZDM-4T6Z : Mon Mar 30 07:27:30 UTC 2026), Entry for Paul Henry Mills, 1940."
      },
      {
        "title": "Paul Henry Mills, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3SRT-NK3",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:D6SD-KG6Z : Sun Mar 29 12:32:41 UTC 2026), Entry for Paul Henry Mills, 1950."
      },
      {
        "title": "Paul Henry Mills, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3SRT-NCT",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Z175-SJW2 : Fri Aug 01 16:26:51 UTC 2025), Entry for Paul Henry Mills, 1950."
      },
      {
        "title": "Paul H Mills, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3SJ4-VSY",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:ZP8R-S3N2 : Mon Mar 30 07:16:04 UTC 2026), Entry for Paul H Mills, 1930."
      },
      {
        "title": "Henry Paul Mills, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3SJ4-63V",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:ZP8C-NLW2 : Mon Mar 30 07:21:55 UTC 2026), Entry for Henry Paul Mills."
      },
      {
        "title": "Paul Mills, \"Utah, Box Elder, Tremonton and Garland Obituaries, 1959-2013\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3SM2-QGR",
        "citation": "\"Utah, Box Elder, Tremonton and Garland Obituaries, 1959-2013\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2QP-T1QQ : Thu Oct 09 15:07:54 UTC 2025), Entry for George Bartho Stuart and William E Stuart, 1986."
      },
      {
        "title": "Paul Mills, \"Utah, Box Elder, Brigham City Family History Center, Obituary Collection, 1930-2016\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SYLB-LGZ",
        "citation": "\"Utah, Box Elder, Brigham City Family History Center, Obituary Collection, 1930-2016\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:ZTBW-ZBMM : Sat Jan 18 16:10:07 UTC 2025), Entry for Rex Frederick Mills and Lowell Mills, 1942."
      },
      {
        "title": "Paul Henry Mills, \"Idaho, World War II Draft Registration Cards, 1940-1945\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SFXN-1L7",
        "citation": "\"Idaho, World War II Draft Registration Cards, 1940-1945\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2CP-CP6S : Mon Apr 07 19:46:53 UTC 2025), Entry for Paul Henry Mills and Merle Stuart Mills, 16 Oct 1940."
      },
      {
        "title": "Paul H Mills, \"Utah, Davis County Records, 1869-1953\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SH77-L9V",
        "citation": "\"Utah, Davis County Records, 1869-1953\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QPQ6-VT2H : Sat Mar 09 08:30:34 UTC 2024), Entry for Paul H Mills and Merle Stuart."
      },
      {
        "title": "Paul H Mills, \"Utah, Davis County Records, 1869-1953\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SH77-262",
        "citation": "\"Utah, Davis County Records, 1869-1953\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QPQX-D72Y : Sat Mar 09 01:05:30 UTC 2024), Entry for Paul H Mills and Merle Stuart, 27 May 1936."
      },
      {
        "title": "Paul H Mills, \"United States, Western States Marriage Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SQNT-9HM",
        "citation": "\"United States, Western States Marriage Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZJK-3XP : Tue Feb 11 23:15:58 UTC 2025), Entry for Paul H Mills and Merle Stuart, 29 Sep 1936."
      },
      {
        "title": "Paul H Mills, \"United States Social Security Death Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9G19-N2M",
        "citation": "\"United States, Social Security Death Index,\" database, FamilySearch (https://familysearch.org/ark:/61903/1:1:J1TZ-76J : 11 January 2021), Paul H Mills, 04 May 1989; citing U.S. Social Security Administration, Death Master File, database (Alexandria, Virginia: National Technical Information Service, ongoing)."
      },
      {
        "title": "Paul Mills in entry for Mr William Evans Stuart, \"Utah, Tremonton and Garland Obituaries, 1959-2013\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9G19-NHR",
        "citation": "\"Utah, Box Elder, Tremonton and Garland Obituaries, 1959-2013\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2QP-T114 : Wed Oct 08 03:19:15 UTC 2025), Entry for Mr William Evans Stuart and George Stuart, 1962."
      },
      {
        "title": "Paul Mills in entry for William Evans Stuart, \"Idaho, Southern Counties Obituaries, 1943-2013\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9G19-FG6",
        "citation": "\"Idaho, Southern Counties Obituaries, 1943-2013\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QLWX-JV1M : Wed Jun 04 22:31:26 UTC 2025), Entry for William Evans Stuart and George Stuart."
      },
      {
        "title": "Paul Henry Mills, \"BillionGraves Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/92NH-9XR",
        "citation": "\"BillionGraves Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KBYK-DR1 : Fri Sep 25 01:07:43 UTC 2026), Entry for Paul Henry Mills."
      },
      {
        "title": "Paul Henry Mills, \"Find A Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/92NH-9QG",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QV26-DD7M : Thu Oct 01 16:17:23 UTC 2026), Entry for Paul Henry Mills."
      },
      {
        "title": "Paul Henry Mills, \"BillionGraves Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/92NH-MMH",
        "citation": "\"BillionGraves Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KBY8-9J5 : Thu Sep 24 19:08:26 UTC 2026), Entry for Paul Henry Mills."
      },
      {
        "title": "Paul H Mills, \"Utah, Box Elder, Tremonton and Garland Obituaries, 1959-2013\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9N6H-7FV",
        "citation": "\"Utah, Box Elder, Tremonton and Garland Obituaries, 1959-2013\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2QP-5J3M : Sat Mar 09 00:01:30 UTC 2024), Entry for Milbourne Lehman Mills and Bishop Myron Jones, 1975."
      },
      {
        "title": "Paul H Mills, \"United States, Census, 1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9F8F-L3Y",
        "citation": "\"United States, Census, 1940\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VY4Y-HJP : Wed Jan 15 18:21:39 UTC 2025), Entry for Paul H Mills and Merle Mills, 1940."
      },
      {
        "title": "Paul Henry Mills, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9F8F-FMJ",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSX-WHKZ : Sat Sep 27 20:28:20 UTC 2025), Entry for Boyd Stuart Mills and Paul Henry Mills, 1967."
      },
      {
        "title": "Paul H Mills, \"Utah, County Marriages, 1871-1941\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9F8F-6JQ",
        "citation": "\"Utah, County Marriages, 1871-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VRLB-WMX : Thu Sep 19 19:33:25 UTC 2024), Entry for Paul H Mills and Henry I Mills, 29 Sep 1936."
      },
      {
        "title": "Paul H Mills, \"Utah, County Marriages, 1871-1941\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9F8F-DB7",
        "citation": "\"Utah, County Marriages, 1871-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VRLL-DZJ : Thu Sep 19 18:36:40 UTC 2024), Entry for Paul H Mills and Merle Stuart, 29 Sep 1936."
      },
      {
        "title": "Paul Henry Mills, \"Utah, County Marriages, 1871-1941\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9F8F-CK2",
        "citation": "\"Utah, County Marriages, 1871-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VRLT-GRL : Thu Sep 19 20:20:14 UTC 2024), Entry for Paul Henry Mills and Merle Stuart, 29 Sep 1936."
      },
      {
        "title": "Paul Mills, \"United States, Census, 1920\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9X6V-BKN",
        "citation": "\"United States, Census, 1920\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MDC1-8VF : Fri Oct 02 19:04:39 UTC 2026), Entry for H I Mills and Mary Mills, 1920."
      },
      {
        "title": "Paul Henry Mills, \"BillionGraves Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/96M9-8W9",
        "citation": "\"BillionGraves Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:279X-55F : Thu Sep 24 19:16:56 UTC 2026), Entry for Paul Henry Mills."
      },
      {
        "title": "Paul H Mills, \"United States, Census, 1930\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9D8D-XLP",
        "citation": "\"United States, Census, 1930\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XH6M-755 : Fri Oct 10 00:42:23 UTC 2025), Entry for H I Mills and Mary L Mills, 1930."
      },
      {
        "title": "Paul Henry Mills, \"Idaho, Southern Counties Obituaries, 1943-2013\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/98YF-5Q2",
        "citation": "\"Idaho, Southern Counties Obituaries, 1943-2013\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSD-S3T9 : Thu Sep 19 20:17:31 UTC 2024), Entry for Paul Henry Mills and Henry Isaac Mills."
      },
      {
        "title": "Paul Henry Mills, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/98T3-NZV",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSX-WC7H : Sat Sep 27 20:28:25 UTC 2025), Entry for Paul Henry Mills and Henry Isaac Mills, Jr, 1989."
      },
      {
        "title": "Headstone image of Paul Henry Mills from billiongraves.com",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZV4-T7R",
        "citation": "Transcription of headstone image from billiongraves.com. Image taken at Malad City Cemetery (Malad City, Idaho, United States) on 23 August 2013"
      },
      {
        "title": "Headstone image of Paul Henry Mills from billiongraves.com",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSP7-H33",
        "citation": "Transcription of headstone image from billiongraves.com. Image taken at Malad City Cemetery (Malad City, Oneida, Idaho, United States) on 30 September 2013"
      },
      {
        "title": "Legacy NFS Source: Paul Henry Mills - Published information: burial: 8 May 1989; Malad, Oneida, Idaho, United States",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSXM-R4D",
        "citation": ""
      },
      {
        "title": "Headstone image of Paul Henry Mills from billiongraves.com",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMHN-9CR",
        "citation": "Transcription of headstone image from billiongraves.com. Image taken at Malad City Cemetery (Malad City, Oneida, Idaho, United States) on 11 August 2013"
      }
    ],
    "portrait": "/ancestors/portraits/008_KWZ8-6KJ.jpg"
  },
  {
    "id": "I121",
    "name": "Henry Isaac Mills",
    "sex": "M",
    "gen": 4,
    "slot": 0,
    "side": "paternal",
    "birthplace": "england",
    "childId": "I29",
    "birthYear": 1870,
    "deathYear": 1949,
    "birthDate": "15 May 1870",
    "deathDate": "19 Feb 1949",
    "burialDate": null,
    "christeningDate": "24 Jul 1870",
    "birthPlace": "Brighton, Sussex, England, United Kingdom",
    "deathPlace": "Malad, Oneida, Idaho, United States",
    "burialPlace": "Malad City Cemetery, Malad, Oneida, Idaho",
    "christeningPlace": "St. Peter's Church Brighton, Brighton, Sussex, England",
    "fsId": "KWCY-TVC",
    "photo": "/ancestors/bubbles/016_KWCY-TVC.jpg",
    "living": false,
    "alternateNames": [
      "Henery Isaac Mills",
      "Henry Isaac Jr. Mills",
      "Isaac Mills",
      "Harry James Mills"
    ],
    "facts": [
      {
        "kind": "Immigration",
        "date": "1871",
        "place": null,
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1871",
        "place": "Brighton, Sussex, England, United Kingdom",
        "note": null
      },
      {
        "kind": "Immigration",
        "date": "1872",
        "place": null,
        "note": null
      },
      {
        "kind": "Baptism",
        "date": "22 September 1878",
        "place": null,
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1880",
        "place": "Centerville, Davis, Utah, United States",
        "note": null
      },
      {
        "kind": "Immigration",
        "date": "1890",
        "place": null,
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1900",
        "place": "Centerville Election Precinct, Davis, Utah, United States",
        "note": null
      },
      {
        "kind": "Mission",
        "date": "1905",
        "place": "Southern States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1910",
        "place": "Centerville, Davis, Utah, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1920",
        "place": "Malad, Oneida, Idaho, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1930",
        "place": "Malad, Oneida, Idaho, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "2 October 1942",
        "place": "Malad",
        "note": null
      },
      {
        "kind": "Obituary",
        "date": "1949",
        "place": "Idaho, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": null,
        "place": "Centerville, Davis, Utah, United States",
        "note": null
      },
      {
        "kind": "Event Registration",
        "date": null,
        "place": "Brighton, Sussex, England, United Kingdom",
        "note": null
      }
    ],
    "sketch": "Henry never drove a car.  He was a farmer.  He died of cancer.  He would walk wherever he went.  He was a member of the Church of Jesus Christ of LDS all of his life.  When asked to go and give someone a blessing he would always walk to their home.  Flora Mills Evans remembers living right next door to him while she was growing up in Malad, Idaho.",
    "sources": [
      {
        "title": "Henry I, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/776F-BPV",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6RBF-B589 : Fri Mar 27 02:27:06 UTC 2026), Entry for Marion Mills and Henry I Mills."
      },
      {
        "title": "Henry I, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/776F-YW3",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6RF9-GPL4 : Fri Mar 27 01:26:08 UTC 2026), Entry for Lowell Severn Mills and David D Thomas."
      },
      {
        "title": "Henry I, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7QFC-JG7",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:65QT-63RQ : Thu Mar 26 19:02:26 UTC 2026), Entry for Paul Henry Mills and Henry I."
      },
      {
        "title": "Henry Isaac, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7QC6-Y66",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6PNY-9CZR : Sun Sep 13 05:31:35 UTC 2026), Entry for Frederick Rex Mills and Henry Isaac Mills."
      },
      {
        "title": "Henry I, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7QCW-R5Q",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6PRJ-M1J5 : Fri Mar 27 04:01:21 UTC 2026), Entry for Melbourne Mills and Robert G Jones."
      },
      {
        "title": "Henry Isaac, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q2XV-5VX",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6KJ1-ZW6Y : Sun Sep 13 04:01:56 UTC 2026), Entry for Gladys Mills and Henry Isaac Mills."
      },
      {
        "title": "Henry Isaac Mills, \"Utah, Birth Certificates, 1903-1914\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q2XF-HHY",
        "citation": "\"Utah, Birth Certificates, 1903-1914\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QL2N-DMHG : Sun Mar 10 19:41:23 UTC 2024), Entry for and Henry Isaac Mills, 13 November 1908."
      },
      {
        "title": "Henry Isaac, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QJXV-5TN",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6KV6-78CC : Sun Sep 13 05:31:15 UTC 2026), Entry for Milbourne Layman Mills and Henry Isaac."
      },
      {
        "title": "Henry Isaac, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QJXV-5JP",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6KK8-WSTN : Sun Sep 13 03:42:01 UTC 2026), Entry for Marian Mills and Henry Isaac."
      },
      {
        "title": "Henry Isaac, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QJXV-PBC",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6KKQ-XBG9 : Sun Sep 13 05:09:35 UTC 2026), Entry for Milbourne L Mills and Henry Isaac."
      },
      {
        "title": "Henry Isaac, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QJXV-PJR",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:627C-KP2P : Fri Mar 27 00:07:03 UTC 2026), Entry for Milbourne L. Mills and Henry Isaac."
      },
      {
        "title": "Henry Isaac Mills, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QJXV-PHM",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6K2M-JVBS : Sun Sep 13 03:48:21 UTC 2026), Entry for Marian Mill and Henry Isaac Mills."
      },
      {
        "title": "Henry Isaac, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QJXD-CRD",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6KKB-Z2XH : Sun Sep 13 04:00:55 UTC 2026), Entry for Frederick Rex Mills and Jos. E Williams."
      },
      {
        "title": "Henry Isaac, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QJXD-CNT",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6KKN-CDJ3 : Sun Sep 13 04:01:28 UTC 2026), Entry for Frederick Rex Mills and Henry Isaac Mills."
      },
      {
        "title": "Isaac Mills, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QJXD-H6X",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6KVY-5KS1 : Sun Sep 13 05:09:16 UTC 2026), Entry for Frederick Rex Mills and Isaac Mills."
      },
      {
        "title": "Henry Isaac Mills, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QJ6R-JSN",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6K2P-GD4B : Sun Sep 13 05:24:31 UTC 2026), Entry for Lowell Serberne Mills and Henry Isaac Mills."
      },
      {
        "title": "Henry Isaac, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QJ6R-NTB",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6KK8-WSTK : Sun Sep 13 05:18:26 UTC 2026), Entry for Lowell Gerberne Mills and Henry Isaac."
      },
      {
        "title": "Isaac H Mills, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QJ6R-NVP",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6KKF-2NPJ : Sun Sep 13 03:59:45 UTC 2026), Entry for Irene Mills and Isaac H Mills."
      },
      {
        "title": "Henry Isaac, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QJ6R-MLL",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6KJ1-ZWX9 : Sun Sep 13 05:12:37 UTC 2026), Entry for Isaac Varral Mills and Henry Isaac Mills."
      },
      {
        "title": "Henery I Mills, \"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q7LF-PVV",
        "citation": "\"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6K4S-CQ4K : Wed Jul 01 14:12:42 UTC 2026), Entry for Alene Parsons and Henery I Mills."
      },
      {
        "title": "Henry I Mills, \"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q7LF-L4C",
        "citation": "\"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6KWK-637P : Tue Jun 30 23:04:29 UTC 2026), Entry for Paul Henry Mills and Henry I Mills."
      },
      {
        "title": "Isaac Mills letter, Centerville, Utah, to Joseph F. Smith",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3TTF-LGF",
        "citation": "First Presidency missionary calls and recommendations, 1877-1918; 1901-1905; Mill, 1905; Isaac Mills letter, Centerville, Utah, to Joseph F. Smith; Church History Library, https://catalog.churchofjesuschrist.org/assets/61592f7b-da5a-41a7-8c7d-61e2da30f643/0/0 (accessed: September 15, 2022)"
      },
      {
        "title": "Isaac Mills, \"Utah, County Marriages, 1871-1941\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3RH2-ZNV",
        "citation": "\"Utah, County Marriages, 1871-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:X2BW-VL6 : Thu Sep 19 18:33:51 UTC 2024), Entry for Isaac Mills and Mary Layman, 01 Feb 1893."
      },
      {
        "title": "Isaac Mills, \"United States, Western States Marriage Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3RH2-ZC3",
        "citation": "\"United States, Western States Marriage Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZZN-NV7 : Tue Feb 11 23:08:32 UTC 2025), Entry for Isaac Mills and Mary Layman, 1 Feb 1893."
      },
      {
        "title": "Isaac Mills, \"United States, Western States Marriage Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3RH2-ZMN",
        "citation": "\"United States, Western States Marriage Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZVJ-72R : Tue Feb 11 22:35:41 UTC 2025), Entry for Isaac Mills and Mary Layman, 1 Feb 1893."
      },
      {
        "title": "Mr Henry Mills, \"United States, GenealogyBank Historical Newspaper Obituaries, 1815-2013\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3KLP-4HM",
        "citation": "\"United States, GenealogyBank Historical Newspaper Obituaries, 1815-2013\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q576-GHV4 : Sun Jul 26 09:28:27 UTC 2026), Entry for Rex Mills and Mr Henry Mills, 05 Oct 1942."
      },
      {
        "title": "Mills, \"California, Death Index, 1940-1997\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3KH2-W9N",
        "citation": "\"California, Death Index, 1940-1997\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VG5M-6VG : Tue Feb 25 16:30:17 UTC 2025), Entry for Aline Parsons and Mills, 09 Jul 1994."
      },
      {
        "title": "Henry Isaac Mills, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3WRD-63H",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:ZP8R-S32M : Sun Mar 29 10:25:47 UTC 2026), Entry for Henry Isaac Mills, 1935."
      },
      {
        "title": "Henry Isaic Mills, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3SJ4-5MQ",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:8Z8X-FMN2 : Mon Mar 30 07:19:07 UTC 2026), Entry for Henry Isaic Mills, 1940."
      },
      {
        "title": "Henry Isaac Mills, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3SJ4-JGV",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:ZP8R-S33Z : Mon Mar 30 07:16:04 UTC 2026), Entry for Henry Isaac Mills, 1930."
      },
      {
        "title": "Henry Isaac Mills, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3SJ4-DGY",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:ZP8C-N26Z : Mon Mar 30 07:21:55 UTC 2026), Entry for Henry Isaac Mills."
      },
      {
        "title": "H I Mills, \"Utah, Box Elder, Brigham City Family History Center, Obituary Collection, 1930-2016\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SYLB-LK8",
        "citation": "\"Utah, Box Elder, Brigham City Family History Center, Obituary Collection, 1930-2016\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:ZTBW-ZBMM : Sat Jan 18 16:10:07 UTC 2025), Entry for Rex Frederick Mills and Lowell Mills, 1942."
      },
      {
        "title": "Isaac Horsley, \"Utah, Obituaries from Utah Newspapers, 1850-2005\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SK5G-2WG",
        "citation": "\"Utah, Obituaries from Utah Newspapers, 1850-2005\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSF-YLHX : Tue Mar 11 16:07:44 UTC 2025), Entry for Mr George R Horsley and Mrs Genevieve Garbett Horsley, 15 Dec 1923."
      },
      {
        "title": "Isaac Horsley, \"Utah, Obituaries from Utah Newspapers, 1850-2005\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SJBS-2CR",
        "citation": "\"Utah, Obituaries from Utah Newspapers, 1850-2005\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSF-NL8D : Tue Mar 11 14:55:29 UTC 2025), Entry for Bert Horsley and David Horsley, 04 Mar 1927."
      },
      {
        "title": "Isaac Horsley, \"Utah, Obituaries from Utah Newspapers, 1850-2005\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SJBS-FQQ",
        "citation": "\"Utah, Obituaries from Utah Newspapers, 1850-2005\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSF-NPB7 : Tue Mar 11 14:54:37 UTC 2025), Entry for Mr David Horsley and Charlotte C Mills, 18 Apr 1930."
      },
      {
        "title": "Henry I. Mills, \"United States, Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SV65-MND",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MNSJ-5FF : Wed Sep 09 15:09:18 UTC 2026), Entry for David Horsley and Charlotte Horsley, 1880."
      },
      {
        "title": "H. Mills in entry for James H. Robertson, \"Utah, Marriages, 1887-1935\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SV65-MQM",
        "citation": "\"Utah, Marriages, 1887-1935\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:F8P7-QMB : 28 January 2020), H. Mills in entry for James H. Robertson, 1925."
      },
      {
        "title": "Henry Isaac Mills in entry for Irene Mills, \"Utah, Deaths and Burials, 1888-1946\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SV6P-129",
        "citation": "\"Utah, Deaths and Burials, 1888-1946\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:HFYX-T4ZM : 11 June 2020), Henry Isaac Mills in entry for Irene Mills, ."
      },
      {
        "title": "Henry Isaac Mills in entry for Mills, \"Utah, Deaths and Burials, 1888-1946\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SV6P-B8H",
        "citation": "\"Utah, Deaths and Burials, 1888-1946\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:HFYF-9JZM : 11 June 2020), Henry Isaac Mills in entry for Mills, 1898."
      },
      {
        "title": "Issac Mills, \"California, County Birth and Death Records, 1800-1994\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S446-CF2",
        "citation": "\"California, County Birth and Death Records, 1800-1994\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QPWN-PKF6 : Tue Feb 18 22:03:12 UTC 2025), Entry for Issag or Ivan Varsel Mills and Issac Mills, 17 July 1960."
      },
      {
        "title": "Henry S Mills, \"United States, Census, 1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S3T6-355",
        "citation": "\"United States, Census, 1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M5XS-ZYQ : Wed Aug 13 17:31:32 UTC 2025), Entry for Henry S Mills and Mary Mills, 1910."
      },
      {
        "title": "H I Mills, \"California, County Marriages, 1849-1957\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/954H-C65",
        "citation": "\"California, County Marriages, 1849-1957\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:K8N9-G99 : Fri Mar 08 06:29:49 UTC 2024), Entry for Ivan V Mills and A J Frances Hoffman, 15 December 1922."
      },
      {
        "title": "H. Mills in entry for James H. Robertson and Mariam Mills, \"Utah, County Marriages, 1887-1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9G19-LLX",
        "citation": "\"Utah, County Marriages, 1871-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KSP9-Y23 : Thu Sep 19 19:39:31 UTC 2024), Entry for James H. Robertson and Wm. A. Robertson, 12 Sep 1925."
      },
      {
        "title": "Henry Mills in entry for Milbourne Mills and Margaret Hess, \"Utah, County Marriages, 1887-1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9G19-J2X",
        "citation": "\"Utah, County Marriages, 1871-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KSP3-16G : Thu Sep 19 20:12:12 UTC 2024), Entry for Milbourne Mills and Henry Mills, 26 Dec 1928."
      },
      {
        "title": "Henry Mills in entry for Milbourne Mills and Margaret Hess, \"Utah Marriages, 1887-1935\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9G19-JZG",
        "citation": "\"Utah, Marriages, 1887-1935\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:F8P3-6M4 : 28 January 2020), Henry Mills in entry for Milbourne Mills, 1928."
      },
      {
        "title": "Henry Mills, \"BillionGraves Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9GB8-3XM",
        "citation": "\"BillionGraves Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KBYX-8R4 : Mon Oct 05 04:08:25 UTC 2026), Entry for Isaac Henry Mills."
      },
      {
        "title": "Henry Isaac Mills in entry for Lowell Severn Mills and Marie Lavalleur, \"California, County Marriages, 1850-1952\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9GTH-TJZ",
        "citation": "\"California, County Marriages, 1849-1957\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:K8KS-BCY : Sat Mar 09 09:51:44 UTC 2024), Entry for Lowell Severn Mills and Marie Lavalleur, 4 December 1945."
      },
      {
        "title": "Henry Isaac Mills Jr in entry for Paul Henry Mills, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9LRK-YSB",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSX-WC7H : Sat Sep 27 20:28:25 UTC 2025), Entry for Paul Henry Mills and Henry Isaac Mills, Jr, 1989."
      },
      {
        "title": "Isaac Mills, \"Utah Marriages, 1887-1935\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9LRK-TKL",
        "citation": "\"Utah, Marriages, 1887-1935\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:F8PJ-8MV : 28 January 2020), Isaac Mills, 1893."
      },
      {
        "title": "Henry Isaac Mills, \"BillionGraves Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9LRK-RS6",
        "citation": "\"BillionGraves Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KBYH-TM2 : Thu Sep 24 17:53:05 UTC 2026), Entry for Henry Isaac Mills."
      },
      {
        "title": "Harry J Mills in household of Harry Mills, \"England and Wales Census, 1871\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9LRK-P4M",
        "citation": "\"England and Wales, Census, 1871\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VFDW-1W7 : Tue Sep 08 20:55:35 UTC 2026), Entry for Harry Mills and Charlotte Mills, 1871."
      },
      {
        "title": "Henry Isaac Mills, \"Early Mormon Missionaries\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/926P-KVL",
        "citation": "\"Henry Isaac Mills\", Early Mormon Missionaries, accessed July 5, 2017, https://history.lds.org/missionary/individual/henry-isaac-mills-1870"
      },
      {
        "title": "Henry Isaac Mills, \"Early Mormon Missionaries\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/926P-KX6",
        "citation": "\"Henry Isaac Mills\", Early Mormon Missionaries, accessed July 5, 2017, https://history.lds.org/missionary/individual/henry-isaac-mills-1870"
      },
      {
        "title": "Henry I Mills in entry for Ernest L Crowton and Mariam M Robertson, \"Utah, County Marriages, 1887-1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9K9G-9GP",
        "citation": "\"Utah, County Marriages, 1871-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2MB-3VPN : Thu Sep 19 18:30:55 UTC 2024), Entry for Ernest L Crowton and William, 20 Nov 1934."
      },
      {
        "title": "Henry I Mills in entry for Paul H Mills and Merle Stuart, \"Utah, County Marriages, 1887-1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9V5M-RNV",
        "citation": "\"Utah, County Marriages, 1871-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VRLB-WMX : Thu Sep 19 19:33:25 UTC 2024), Entry for Paul H Mills and Henry I Mills, 29 Sep 1936."
      },
      {
        "title": "Henry Isaac Mills in entry for Lowell S Mills and Kathereen Maurine Watts, \"California, County Marriages, 1850-1952\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9V5M-FJ6",
        "citation": "\"California, County Marriages, 1849-1957\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:K8JC-YXF : Sat Mar 09 12:14:51 UTC 2024), Entry for Lowell S Mills and Kathereen Maurine Watts, 8 April 1933."
      },
      {
        "title": "Henry Isaac Mills, \"The Church of Jesus Christ of Latter-day Saints, Missionary Registers (Worldwide), 1860-1937\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9J6F-BRF",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Missionary Registers (Worldwide), 1860-1937\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QKDW-YK6Z : Tue Mar 11 16:26:27 UTC 2025), Entry for Henry Isaac Mills and James Baird, 1905."
      },
      {
        "title": "Harry James Mills, \"England, Sussex, Parish Registers, 1538-1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9JDY-GY2",
        "citation": "\"England, Sussex, Parish Registers, 1538-1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KFG8-QFD : Tue Sep 08 21:36:07 UTC 2026), Entry for Harry James Mills and Henry Isaac Mills, 24 Jul 1870."
      },
      {
        "title": "Henry Isaac Mills, \"Utah, Box Elder, Tremonton and Garland Obituaries, 1959-2013\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9N6H-7CT",
        "citation": "\"Utah, Box Elder, Tremonton and Garland Obituaries, 1959-2013\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2QP-5J3M : Sat Mar 09 00:01:30 UTC 2024), Entry for Milbourne Lehman Mills and Bishop Myron Jones, 1975."
      },
      {
        "title": "Henry Isaac Mills, Jr, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9FXH-ZNX",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSX-WCQ4 : Sat Sep 27 20:28:23 UTC 2025), Entry for Milbourne Lehmann Mills and Henry Isaac Mills, Jr, 1975."
      },
      {
        "title": "Henry Isaac Mills, \"The Church of Jesus Christ of Latter-day Saints, Missionary Registers (Worldwide), 1860-1937\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9FXH-CVZ",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Missionary Registers (Worldwide), 1860-1937\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QKDW-1C9H : Tue Mar 11 16:31:45 UTC 2025), Entry for Fredrick Rex Mills and Jos E Williams, 1919."
      },
      {
        "title": "Henry Isaac Mills, \"Idaho, Death Certificates, 1938-1961\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9FXH-HK3",
        "citation": "\"Idaho, Death Certificates, 1938-1961\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2M1-NQNG : Fri Feb 21 22:44:07 UTC 2025), Entry for Frederick Rex Mills and Henry Isaac Mills, 10 Feb 1942."
      },
      {
        "title": "Henry Isaac Mills, \"Idaho, Death Certificates, 1938-1961\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9XTZ-39T",
        "citation": "\"Idaho, Death Certificates, 1938-1961\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2M1-5XWM : Fri Feb 21 22:53:22 UTC 2025), Entry for Henry Isaac Mills and Isaac Mills, 19 Feb 1949."
      },
      {
        "title": "Henry Isaac Mills, Jr, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9XTC-14F",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSX-WCQ3 : Sat Sep 27 20:28:23 UTC 2025), Entry for Mary Lehmann Mills and Frederick Lehmann, 1961."
      },
      {
        "title": "Mills, \"California, Death Index, 1940-1997\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9X2K-YH3",
        "citation": "\"California, Death Index, 1940-1997\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VP21-QTW : Tue Feb 25 19:11:31 UTC 2025), Entry for Mariam Crowton and Mills, 12 Jul 1988."
      },
      {
        "title": "Isaac Mills, \"United States, Census, 1900\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9X6Y-QMK",
        "citation": "\"United States, Census, 1900\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MMRV-ZCG : Sat Aug 01 22:21:28 UTC 2026), Entry for Isaac Mills and Mary Mills, 1900."
      },
      {
        "title": "Isaac Mills, \"Utah, County Marriages, 1871-1941\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9X6Y-3XK",
        "citation": "\"Utah, County Marriages, 1871-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VRLB-5YP : Thu Sep 19 18:35:27 UTC 2024), Entry for Isaac Mills and Mary Layman, 01 Feb 1893."
      },
      {
        "title": "H I Mills, \"United States, Census, 1920\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9X6V-BDD",
        "citation": "\"United States, Census, 1920\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MDC1-8VF : Fri Oct 02 19:04:39 UTC 2026), Entry for H I Mills and Mary Mills, 1920."
      },
      {
        "title": "Henry Mills, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9X6V-YZS",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSX-WC7B : Sat Sep 27 20:28:24 UTC 2025), Entry for Rex Mills and Henry Mills, 1942."
      },
      {
        "title": "Isaac Mills, \"Utah, County Marriages, 1871-1941\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9X6V-5JB",
        "citation": "\"Utah, County Marriages, 1871-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VRLZ-ZM4 : Thu Sep 19 19:19:51 UTC 2024), Entry for Fredrick Rex Mills and Isaac Mills, 20 Nov 1923."
      },
      {
        "title": "Isaac Mills, \"Utah, County Marriages, 1871-1941\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9XH3-41X",
        "citation": "\"Utah, County Marriages, 1871-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VRL4-GYF : Thu Sep 19 19:53:17 UTC 2024), Entry for Isaac Mills and Mary Layman, 01 Feb 1893."
      },
      {
        "title": "Father Henry Isaac Mills, \"BillionGraves Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9XH9-KB3",
        "citation": "\"BillionGraves Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:279Q-8W5 : Mon Oct 05 04:28:25 UTC 2026), Entry for Father Henry Isaac Mills."
      },
      {
        "title": "Isaac Mills, \"Utah, Marriages, 1887-1935\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9XH9-K33",
        "citation": "\"Utah, Marriages, 1887-1935\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:F8G4-XZ5 : 28 January 2020), Isaac Mills, 1893."
      },
      {
        "title": "Isaac Mills in entry for Fredrick Rex Mills, \"Utah, Marriages, 1887-1935\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/96F6-YTP",
        "citation": "\"Utah, Marriages, 1887-1935\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:F8P2-QLK : 28 January 2020), Isaac Mills in entry for Fredrick Rex Mills, 1923."
      },
      {
        "title": "Henry Isaac Mills, Jr, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/96F6-YXD",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSX-WH2G : Sat Sep 27 20:28:21 UTC 2025), Entry for Fredrick Rex Mills and Henry Isaac Mills, Jr, 1942."
      },
      {
        "title": "Henry Isaac Mills, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9D1Y-GM8",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QV26-DDQ1 : Fri Oct 02 10:44:52 UTC 2026), Entry for Henry Isaac Mills."
      },
      {
        "title": "H I Mills, \"United States, Census, 1930\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9D8D-XF6",
        "citation": "\"United States, Census, 1930\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XH6M-755 : Fri Oct 10 00:42:23 UTC 2025), Entry for H I Mills and Mary L Mills, 1930."
      },
      {
        "title": "Henry Isaac Mills, \"Idaho, Southern Counties Obituaries, 1943-2013\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/98YF-R7R",
        "citation": "\"Idaho, Southern Counties Obituaries, 1943-2013\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSD-S3T9 : Thu Sep 19 20:17:31 UTC 2024), Entry for Paul Henry Mills and Henry Isaac Mills."
      },
      {
        "title": "Henry Isaac Mills, \"Idaho, Southern Counties Obituaries, 1943-2013\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/98G4-3GZ",
        "citation": "\"Idaho, Southern Counties Obituaries, 1943-2013\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSD-S35R : Thu Sep 19 18:48:05 UTC 2024), Entry for Mr Milbourne L Mills and Henry Isaac Mills."
      },
      {
        "title": "Henry Isaac Mills Jr, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/98Z5-WYY",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSX-WHPH : Sat Sep 27 20:28:22 UTC 2025), Entry for Henry Isaac Mills Jr and Henry Isaac Mills, 1949."
      }
    ],
    "portrait": "/ancestors/portraits/016_KWCY-TVC.jpg"
  },
  {
    "id": "I294",
    "name": "Henry Isaac Mills",
    "sex": "M",
    "gen": 5,
    "slot": 0,
    "side": "paternal",
    "birthplace": "england",
    "childId": "I121",
    "birthYear": 1850,
    "deathYear": 1872,
    "birthDate": "15 Aug 1850",
    "deathDate": "15 Oct 1872",
    "burialDate": "Oct 1872",
    "christeningDate": "15 Sep 1850",
    "birthPlace": "Bignor, Sussex, England, United Kingdom",
    "deathPlace": "Centerville, Davis, Utah, United States",
    "burialPlace": "Centerville Memorial Park, Centerville, Davis, Utah, United States",
    "christeningPlace": "South Bersted, Sussex, England",
    "fsId": "KWJ8-TDL",
    "photo": "/ancestors/bubbles/032_KWJ8-TDL.jpg",
    "living": false,
    "alternateNames": [
      "Harry Mills",
      "Henry Mills"
    ],
    "facts": [
      {
        "kind": "Christened",
        "date": "15 September 1850",
        "place": "South Bersted, Sussex, England, United Kingdom",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1851",
        "place": "South Bersted, Sussex, England, United Kingdom",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1861",
        "place": "South Bersted, Sussex, England, United Kingdom",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1871",
        "place": "Brighton, Sussex, England, United Kingdom",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1881",
        "place": "Bedminster, Somerset, England, United Kingdom",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1891",
        "place": "Bedminster, Somerset, England, United Kingdom",
        "note": null
      },
      {
        "kind": "Residence",
        "date": null,
        "place": "Centerville, Davis, Utah, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": null,
        "place": "South Bersted, Sussex, England, United Kingdom",
        "note": null
      },
      {
        "kind": "Event Registration",
        "date": null,
        "place": "St Peter's Church, Brighton, Sussex, England, United Kingdom",
        "note": null
      },
      {
        "kind": "Residence",
        "date": null,
        "place": "Whitehouse, Manitoba, Canada",
        "note": null
      },
      {
        "kind": "Unknown",
        "date": null,
        "place": "Bedminster, Somerset, England, United Kingdom",
        "note": null
      }
    ],
    "sketch": "Occupation: Interior Decorator\n\nBaptism certificate of Henry Isaac Mills done in Funtington, England, per research received from the Geneological Society, 28 Oct 1955.  Sealings and birth of the children at the Salt Lake Temple archives by correspondence.  The sealing for the children was in St. George.  There is also a record of the sealing of the parents at both St. George and Salt Lake Temples.\nWife's name listed at CHESSLEY at the St. George Temple records, husband's name listed as ISAAC MILLS in the St. George Temple records.",
    "sources": [
      {
        "title": "Henry Mills, \"England, Somerset, Church Records, 1501-1999\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7X2G-62Y",
        "citation": "\"England, Somerset, Church Records, 1501-1999\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6DMG-G3R7 : Wed Nov 19 12:08:28 UTC 2025), Entry for Henry Mills and , 30 July 1876."
      },
      {
        "title": "Henry Mills, \"England, Somerset, Church Records, 1501-1999\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7X2G-8WC",
        "citation": "\"England, Somerset, Church Records, 1501-1999\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6DMG-L3ZX : Wed Nov 19 11:37:16 UTC 2025), Entry for Elizabeth Mary Brown and , 30 July 1876."
      },
      {
        "title": "Henry Mills, \"England, Bristol, Parish Registers, 1538-1900\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7X2D-CSM",
        "citation": "\"England, Bristol, Parish Registers, 1538-1900\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XTS2-1N1 : Fri Jul 25 01:40:24 UTC 2025), Entry for Henry Mills and Thomas Mills, 30 Jul 1876."
      },
      {
        "title": "Henry Mills, \"England, Bristol, Parish Registers, 1538-1900\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/343X-BQ9",
        "citation": "\"England, Bristol, Parish Registers, 1538-1900\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XTS2-1N1 : Fri Jul 25 01:40:24 UTC 2025), Entry for Henry Mills and Thomas Mills, 30 Jul 1876."
      },
      {
        "title": "Henry Mills, \"England Marriages, 1538–1973\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/343X-Y7W",
        "citation": "\"England Marriages, 1538–1973\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:NNXT-KWZ : Sat Aug 01 18:59:14 UTC 2026), Entry for Henry Mills and Thomas Mills, 30 July 1876."
      },
      {
        "title": "Henry Mills, \"England, Bristol, Parish Registers, 1538-1900\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/343X-VFC",
        "citation": "\"England, Bristol, Parish Registers, 1538-1900\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XTSV-ZLS : Fri Jul 25 18:58:18 UTC 2025), Entry for Emily Elizabeth and Henry Mills, 28 Sep 1879."
      },
      {
        "title": "Henry Mills, \"England and Wales, Census, 1881\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3436-4ZK",
        "citation": "\"England and Wales, Census, 1881\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q276-JBHK : Fri Aug 21 09:17:20 UTC 2026), Entry for Henry Mills and Elizabeth Mills, 1881."
      },
      {
        "title": "Henry Mills, \"England and Wales, Census, 1891\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/343D-5XT",
        "citation": "\"England and Wales, Census, 1891\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:WR7W-XW2 : Tue Jan 14 14:20:09 UTC 2025), Entry for Henry Mills and Elizabeth M Mills, 1891."
      },
      {
        "title": "Henry Miles, \"England and Wales, Census, 1901\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3438-TCX",
        "citation": "\"England and Wales, Census, 1901\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XS6Q-XS6 : Wed Feb 12 23:27:03 UTC 2025), Entry for Henry Miles and Elizabeth Miles, 31 Mar 1901."
      },
      {
        "title": "Henry Mills, \"England, Somerset, Church Records, 1501-1999\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7XKY-5YK",
        "citation": "\"England, Somerset, Church Records, 1501-1999\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6DML-BLSW : Wed Nov 19 07:14:42 UTC 2025), Entry for Elizabeth Mary Brown and , 30 July 1876."
      },
      {
        "title": "Henry Mills, \"England, Somerset, Church Records, 1501-1999\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7XKY-JM7",
        "citation": "\"England, Somerset, Church Records, 1501-1999\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6DML-BLMZ : Wed Nov 19 12:16:33 UTC 2025), Entry for Henry Mills and , 30 July 1876."
      },
      {
        "title": "Isaac Mills, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QN1F-FXF",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6KKP-M5DL : Sun Sep 13 03:27:40 UTC 2026), Entry for Charlotte E. Mills and James Baird."
      },
      {
        "title": "Isaac Mills, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QN1F-XR3",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6KV8-Y1GK : Sun Sep 13 03:59:45 UTC 2026), Entry for Charlote E W Mills and Isaac Mills."
      },
      {
        "title": "Henry Isaac Mills, \"Utah, Deaths and Burials, 1888-1946\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SVFJ-KSJ",
        "citation": "\"Utah, Deaths and Burials, 1888-1946\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:HFYX-TWPZ : 11 June 2020), Henry Isaac Mills, 1872."
      },
      {
        "title": "Harry Mills, \"England and Wales Census, 1871\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9LRK-P77",
        "citation": "\"England and Wales, Census, 1871\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VFDW-1W7 : Tue Sep 08 20:55:35 UTC 2026), Entry for Harry Mills and Charlotte Mills, 1871."
      },
      {
        "title": "Henry Isaac Mills, \"Find A Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9K2Y-SSH",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVVH-XWMQ : Sun Oct 04 08:45:41 UTC 2026), Entry for Henry Isaac Mills, 1872."
      },
      {
        "title": "Henry Isaac Mills, \"England, Sussex, Parish Registers, 1538-1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9J62-6T2",
        "citation": "\"England, Sussex, Parish Registers, 1538-1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2QW-2K8N : Tue Sep 08 21:33:33 UTC 2026), Entry for Henry Isaac Mills and Charlotte Chessell White, 01 Aug 1869."
      },
      {
        "title": "Isaac Mills, \"The Church of Jesus Christ of Latter-day Saints, Missionary Registers (Worldwide), 1860-1937\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9J6F-B6N",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Missionary Registers (Worldwide), 1860-1937\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QKDW-YK6Z : Tue Mar 11 16:26:27 UTC 2025), Entry for Henry Isaac Mills and James Baird, 1905."
      },
      {
        "title": "Henry Isaac Mills, \"England, Sussex, Parish Registers, 1538-1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9JDY-GG1",
        "citation": "\"England, Sussex, Parish Registers, 1538-1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KFG8-QFD : Tue Sep 08 21:36:07 UTC 2026), Entry for Harry James Mills and Henry Isaac Mills, 24 Jul 1870."
      },
      {
        "title": "Henry Isaac Mills, \"England, Sussex, Parish Registers, 1538-1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9J8B-H91",
        "citation": "\"England, Sussex, Parish Registers, 1538-1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2QW-2K8J : Tue Sep 08 21:35:29 UTC 2026), Entry for Henry Isaac Mills and Thomas Mills, 14 Aug 1869."
      },
      {
        "title": "Henry Isaac Mills, \"England, Sussex, Parish Registers, 1538-1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9N57-S7T",
        "citation": "\"England, Sussex, Parish Registers, 1538-1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2Q7-2Q33 : Tue Sep 08 21:33:08 UTC 2026), Entry for Henry Isaac Mills and Thomas Mills, 15 Sep 1850."
      },
      {
        "title": "Henry Mills, \"England and Wales, Census, 1851\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9NN9-S1V",
        "citation": "\"England and Wales, Census, 1851\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:SG84-L9M : Fri Aug 21 09:06:58 UTC 2026), Entry for Thomas Mills and Charlotte Mills, 1851."
      },
      {
        "title": "namesinstone.com",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9FVY-8HW",
        "citation": "database (namesinstone.com). Rec. Date: 29 May 2016. Cit. Date: 25 Jun 2016."
      },
      {
        "title": "Isaac Mills, \"Idaho, Death Certificates, 1938-1961\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9XTZ-3QQ",
        "citation": "\"Idaho, Death Certificates, 1938-1961\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2M1-5XWM : Fri Feb 21 22:53:22 UTC 2025), Entry for Henry Isaac Mills and Isaac Mills, 19 Feb 1949."
      },
      {
        "title": "Isaac Mills, \"England and Wales, Census, 1861\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9X52-8B3",
        "citation": "\"England and Wales, Census, 1861\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M71N-BYX : Wed Sep 09 23:24:59 UTC 2026), Entry for Thomas Mills and Charlotte Mills, 1861."
      },
      {
        "title": "Henry Isaac Mills, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/98Z5-WTG",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSX-WHPH : Sat Sep 27 20:28:22 UTC 2025), Entry for Henry Isaac Mills Jr and Henry Isaac Mills, 1949."
      },
      {
        "title": "Henry I. Mills, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/98Z5-WV3",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZP2-PJN : Mon Feb 03 19:01:56 UTC 2025), Entry for Charlotte Elizabeth Mills John and Henry I. Mills, 03 Mar 1951."
      },
      {
        "title": "Henry Isaac Mills, \"England Marriages, 1538–1973\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9CZY-QLK",
        "citation": "\"England Marriages, 1538–1973\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:N29M-3JX : Sat Aug 01 20:31:06 UTC 2026), Entry for Henry Isaac Mills and Charlotte Chessell White, 14 August 1869."
      },
      {
        "title": "Henry Isaac Mills, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9Z46-XVK",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:N53W-Y5X : 5 February 2023), Henry Isaac Mills, 1850."
      },
      {
        "title": "Henry Isaac Mills, \"England Marriages, 1538–1973\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9Z46-XZ7",
        "citation": "\"England Marriages, 1538–1973\", database, FamilySearch (https://familysearch.org/ark:/61903/1:1:N6ZF-LL7 : 13 March 2020), Henry Isaac Mills, 1869."
      },
      {
        "title": "Henry Isaac Mills, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9Z46-XMK",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:NBJJ-LMN : 5 February 2023), Henry Isaac Mills, 1850."
      },
      {
        "title": "Legacy NFS Source: Henry Issac Mills -",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MS6H-9WL",
        "citation": "Ancestral File (TM), The Church of Jesus Christ of Latter-day Saints, June 1998 (c), data as of 5 JAN 1998, Family History Library, 35 N West Temple Street, Salt Lake City, UT 84150 USA"
      },
      {
        "title": "Legacy NFS Source: Henry Issac Mills -",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MS6H-9QY",
        "citation": "Ancestral File, The Church of Jesus Christ of Latter-day Saints, Copyright (c) 1987, June 1998, data as of 5 January 1998, Family History Library, 35 N. West Temple Street, Salt Lake City, Utah 84150, USA, www.familysearch.org"
      }
    ],
    "portrait": "/ancestors/portraits/032_KWJ8-TDL.jpg"
  },
  {
    "id": "I525",
    "name": "Thomas Mills",
    "sex": "M",
    "gen": 6,
    "slot": 0,
    "side": "paternal",
    "birthplace": "england",
    "childId": "I294",
    "birthYear": 1802,
    "deathYear": 1883,
    "birthDate": "9 Mar 1802",
    "deathDate": "11 Nov 1883",
    "burialDate": "Aft Abt 11 Nov 1883",
    "christeningDate": "10 Apr 1803",
    "birthPlace": "Shripney, Sussex, England, United Kingdom",
    "deathPlace": "Centerville, Davis, Utah, United States",
    "burialPlace": "Centerville Memorial Park, Centerville, Davis, Utah, United States",
    "christeningPlace": "South Bersted, Sussex, England, United Kingdom",
    "fsId": "KWJ8-197",
    "photo": "/ancestors/bubbles/064_KWJ8-197.jpg",
    "living": false,
    "alternateNames": [
      "Robert Thomas Mills"
    ],
    "facts": [
      {
        "kind": "Residence",
        "date": "1841",
        "place": "Bersted, Sussex, England, United Kingdom",
        "note": null
      },
      {
        "kind": "Baptism",
        "date": "9 March 1844",
        "place": null,
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1851",
        "place": "South Bersted, Sussex, England, United Kingdom",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1861",
        "place": "South Bersted, Sussex, England, United Kingdom",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1871",
        "place": "London, England",
        "note": null
      },
      {
        "kind": "immigration",
        "date": "6 September 1879",
        "place": null,
        "note": null
      },
      {
        "kind": "Find A Grave #",
        "date": null,
        "place": "90510454",
        "note": null
      },
      {
        "kind": "Residence",
        "date": null,
        "place": "South Bersted, Sussex, England, United Kingdom",
        "note": null
      }
    ],
    "sketch": "Short life sketch of Thomas Mills (please edit, add, correct, information etc. as needed)\n\nThomas Mills was born 9 March 1802 in Shripney, Sussex, England, to parents Thomas Mills Sr and Letitia Hammond.  He was their fourth child, having an older brother and 2 older sisters.  (note: in 2014 I searched google maps for “Shripney” and found Shripney Road in Bersted, West Sussex.  This could likely be the area where Thomas was born.)\n\nHe was christened 10 April 1803 in South Bersted, Sussex, England.\n\nA little information on Sussex, where Thomas was born and raised:  \n“Sussex is a maritime County in south-east England.  The seaports are now small and comparatively unimportant.  Sussex was the scene of much of the early history of the country, and is rich in archeological remains. \nThe Sussex coast was greatly modified by the social movement of sea bathing for health which became fashionable among the wealthy in the second half of the 18th century. Resorts developed all along the coast, including at Brighton, Hastings, Worthing, and Bognor. At the beginning of the 19th century (when Thomas was born) agricultural labourers' conditions took a turn for the worse with an increasing amount of them becoming unemployed.\nSussex has a centuries-old reputation for being separate and culturally distinct from the rest of England.  The people of Sussex have a reputation for independence of thought and have an aversion to being pushed around, as expressed through the Sussex motto, We wunt be druv. Sussex is known for its strong tradition of bonfire celebrations and its proud musical heritage.”\nHe married Charlotte Coles on 7 February, 1827 at South Bersted, Sussex, England.  She brought her young son John Rambridge (born in 1823) into their marriage.  They had 11 other children from 1827 to 1842.\n\nHe was baptized in the LDS church on 9 March, 1844.\nOn September 6, 1879 Thomas sailed from England to America on the ship \"Wyoming.\"\nIn the 1880 US Census Thomas and Charlotte Mills are found visiting their daughter Fanny Horsley in Joseph, Sevier County, Utah. The census lists Thomas and Charlotte at age 78. Thomas' occupation is listed as being a \"Laborer\" and being unemployed for 3 months during the census year. Charlotte is listed as \"Keeping house\".\nThomas died November 11, 1883 in Centerville, Utah.  He was buried in the Centerville City Cemetery, Davis County, Utah.",
    "sources": [
      {
        "title": "Thomas Mills in entry for George Mills, \"England Marriages, 1538–1973\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/WZ8Q-BNX",
        "citation": "\"England Marriages, 1538–1973\", database, FamilySearch (https://familysearch.org/ark:/61903/1:1:N66J-453 : 13 March 2020), Thomas Mills in entry for George Mills, 1859."
      },
      {
        "title": "Thomas Mills, \"England Marriages, 1538–1973\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/W727-6SF",
        "citation": "\"England Marriages, 1538–1973\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:NNXT-KWZ : Sat Aug 01 18:59:14 UTC 2026), Entry for Henry Mills and Thomas Mills, 30 July 1876."
      },
      {
        "title": ", \"England, Somerset, Church Records, 1501-1999\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7XKY-PPB",
        "citation": "\"England, Somerset, Church Records, 1501-1999\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6DML-BLSW : Wed Nov 19 07:14:42 UTC 2025), Entry for Elizabeth Mary Brown and , 30 July 1876."
      },
      {
        "title": ", \"England, Somerset, Church Records, 1501-1999\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7XKY-NFS",
        "citation": "\"England, Somerset, Church Records, 1501-1999\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6DML-BLMZ : Wed Nov 19 12:16:33 UTC 2025), Entry for Henry Mills and , 30 July 1876."
      },
      {
        "title": "Thomas Mills, \"England, Sussex, Parish Registers, 1538-1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QJDL-L8V",
        "citation": "\"England, Sussex, Parish Registers, 1538-1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2Q7-2DFS : Tue Sep 08 21:37:36 UTC 2026), Entry for George Mills and Thomas Mills, 02 Jul 1859."
      },
      {
        "title": "Thomas Mills, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QNBW-B71",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZGH-6WY : Mon Feb 03 19:08:07 UTC 2025), Entry for George Mills and Thomas Mills, 30 Mar 1913."
      },
      {
        "title": "Thomas Mills, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QNBW-Y1L",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6K29-7GC6 : Sun Sep 13 04:42:11 UTC 2026), Entry for Richard Mills and Thomas Mills."
      },
      {
        "title": "Thos Mills, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QNBW-Y5D",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6KK9-WZL5 : Sun Sep 13 05:09:52 UTC 2026), Entry for Richard Mills and Thos Mills."
      },
      {
        "title": "Thomas, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QC5H-V5Q",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6KV3-FB3J : Sun Sep 13 04:01:28 UTC 2026), Entry for Richard Mills and Thomas."
      },
      {
        "title": "Thomas Mills in the Millennium File",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3869-7KT",
        "citation": ""
      },
      {
        "title": "Thomas Mills in entry for Richard Mills, \"Utah, Deaths and Burials, 1888-1946\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SVN3-9N6",
        "citation": "\"Utah, Deaths and Burials, 1888-1946\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:HFB6-L9N2 : 11 June 2020), Thomas Mills in entry for Richard Mills, 1921."
      },
      {
        "title": "Thomas Mills in entry for Margaret Mills Bennett, \"Utah, Deaths and Burials, 1888-1946\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SVN3-M8W",
        "citation": "\"Utah, Deaths and Burials, 1888-1946\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:HFBQ-M2W2 : 11 June 2020), Thomas Mills in entry for Margaret Mills Bennett, 1919."
      },
      {
        "title": "Thomas Mills in entry for Henry Isaac Mills, \"Utah, Deaths and Burials, 1888-1946\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SVFJ-2QJ",
        "citation": "\"Utah, Deaths and Burials, 1888-1946\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:HFYX-TWT2 : 11 June 2020), Thomas Mills in entry for Henry Isaac Mills, 1872."
      },
      {
        "title": "Thomas Mills in entry for Joseph Mills, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SCJP-8X5",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:N5SH-PV5 : 5 February 2023), Thomas Mills in entry for Joseph Mills, 1829."
      },
      {
        "title": "Thomas Mills in entry for Joseph Mills, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SZ8G-VT8",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:J9C6-SXP : 5 February 2023), Thomas Mills in entry for Joseph Mills, 1829."
      },
      {
        "title": "Thomas Mills, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S43J-9F2",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZGP-ZZ8 : Mon Feb 03 19:10:10 UTC 2025), Entry for Frances Jane Mills Horsley and Thomas Mills, 20 Oct 1926."
      },
      {
        "title": "Thomas Mills, \"England, Sussex, Parish Registers, 1538-1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9G9K-V3H",
        "citation": "\"England, Sussex, Parish Registers, 1538-1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2QW-KRNL : Tue Sep 08 21:39:09 UTC 2026), Entry for Thomas Mills and Thomas Mills, 10 Apr 1803."
      },
      {
        "title": "Thomas Mills in entry for Margaret Bennett, \"Utah Death Certificates, 1904-1964\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9K2B-HDS",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZGF-THK : Mon Feb 03 19:14:16 UTC 2025), Entry for Margaret Bennett and Thomas Mills, 17 Aug 1919."
      },
      {
        "title": "Thomas Mills, \"England, Sussex, Parish Registers, 1538-1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9JPM-3HJ",
        "citation": "\"England, Sussex, Parish Registers, 1538-1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2Q7-249S : Tue Sep 08 21:33:01 UTC 2026), Entry for Fanny Mills and Thomas Mills, 17 Aug 1845."
      },
      {
        "title": "Thomas Mills, \"England, Sussex, Parish Registers, 1538-1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9J62-26R",
        "citation": "\"England, Sussex, Parish Registers, 1538-1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2Q7-2739 : Tue Sep 08 21:38:23 UTC 2026), Entry for Mercy Mills and Thomas Mills, 09 Sep 1843."
      },
      {
        "title": "Thomas Mills, \"England, Sussex, Parish Registers, 1538-1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9J8B-4BP",
        "citation": "\"England, Sussex, Parish Registers, 1538-1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2QW-2K8J : Tue Sep 08 21:35:29 UTC 2026), Entry for Henry Isaac Mills and Thomas Mills, 14 Aug 1869."
      },
      {
        "title": "Thomas Mills, \"England, Sussex, Parish Registers, 1538-1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9N58-JYV",
        "citation": "\"England, Sussex, Parish Registers, 1538-1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2Q7-2JJK : Tue Sep 08 21:37:41 UTC 2026), Entry for James Bennett and John Bennett, 23 Oct 1852."
      },
      {
        "title": "Thomas Mills, \"England, Sussex, Parish Registers, 1538-1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9N57-S7H",
        "citation": "\"England, Sussex, Parish Registers, 1538-1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2Q7-2Q33 : Tue Sep 08 21:33:08 UTC 2026), Entry for Henry Isaac Mills and Thomas Mills, 15 Sep 1850."
      },
      {
        "title": "Thomas Mills, \"England, Sussex, Parish Registers, 1538-1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9N57-SS1",
        "citation": "\"England, Sussex, Parish Registers, 1538-1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2QW-2SVM : Tue Sep 08 21:40:03 UTC 2026), Entry for Charles Mills and Thomas Mills, 23 Sep 1832."
      },
      {
        "title": "Thomas Mills, \"England, Sussex, Parish Registers, 1538-1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9N57-S93",
        "citation": "\"England, Sussex, Parish Registers, 1538-1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2Q7-2MDY : Tue Sep 08 20:51:55 UTC 2026), Entry for George Mills and Thomas Mills, 31 Jul 1836."
      },
      {
        "title": "Thomas Mills, \"England, Sussex, Parish Registers, 1538-1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9N57-9B8",
        "citation": "\"England, Sussex, Parish Registers, 1538-1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2QW-29J5 : Tue Sep 08 21:36:33 UTC 2026), Entry for Margaret Mills and Thomas Mills, 17 Apr 1831."
      },
      {
        "title": "Thomas Mills, \"England, Sussex, Parish Registers, 1538-1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9N57-9T8",
        "citation": "\"England, Sussex, Parish Registers, 1538-1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2QW-2SBW : Tue Sep 08 21:41:07 UTC 2026), Entry for Robert Thomas Mills and Thomas Mills, 06 Jan 1828."
      },
      {
        "title": "Thomas Mills, \"England, Sussex, Parish Registers, 1538-1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9NG3-PL9",
        "citation": "\"England, Sussex, Parish Registers, 1538-1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2Q7-2NDP : Tue Sep 08 21:36:56 UTC 2026), Entry for Robert Thomas Mills and Thomas Mills, 13 Mar 1852."
      },
      {
        "title": "Thomas Mills, \"England, Sussex, Parish Registers, 1538-1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9NG3-GY6",
        "citation": "\"England, Sussex, Parish Registers, 1538-1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2QW-29SV : Tue Sep 08 20:57:33 UTC 2026), Entry for Joseph Mills and Thomas Mills, 03 Nov 1829."
      },
      {
        "title": "Thomas Mills, \"England, Sussex, Parish Registers, 1538-1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9NNQ-RVZ",
        "citation": "\"England, Sussex, Parish Registers, 1538-1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2QW-2WQN : Tue Sep 08 21:39:57 UTC 2026), Entry for Richard Mills and Thomas Mills, 31 Aug 1834."
      },
      {
        "title": "Thomas Mills, \"England, Sussex, Parish Registers, 1538-1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9NN9-WR9",
        "citation": "\"England, Sussex, Parish Registers, 1538-1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2Q7-27T8 : Tue Sep 08 21:35:49 UTC 2026), Entry for Joseph Mills and Thomas Mills, 11 May 1842."
      },
      {
        "title": "Thomas Mills, \"England, Sussex, Parish Registers, 1538-1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9NN9-Q4N",
        "citation": "\"England, Sussex, Parish Registers, 1538-1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2Q7-246P : Tue Sep 08 21:37:22 UTC 2026), Entry for Charlotte Anne Mills and Thomas Mills, 08 Dec 1839."
      },
      {
        "title": "Thomas Mills, \"England and Wales, Census, 1851\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9NN9-92N",
        "citation": "\"England and Wales, Census, 1851\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:SG84-L9M : Fri Aug 21 09:06:58 UTC 2026), Entry for Thomas Mills and Charlotte Mills, 1851."
      },
      {
        "title": "Thomas Mills, \"England and Wales, Census, 1851\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9NN9-MPB",
        "citation": "\"England and Wales, Census, 1851\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:SG84-L9M : Fri Aug 21 09:06:58 UTC 2026), Entry for Thomas Mills and Charlotte Mills, 1851."
      },
      {
        "title": "Thomas Mills, \"England, Sussex, Parish Registers, 1538-1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9NF2-8JP",
        "citation": "\"England, Sussex, Parish Registers, 1538-1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2Q7-29C4 : Tue Sep 08 21:38:24 UTC 2026), Entry for Thomas Mills and Charlotte Coles, 07 Feb 1827."
      },
      {
        "title": "Thomas Mills, \"England Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MM9Y-5NB",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:J364-6TP : 4 February 2023), Thomas Mills, 1803."
      },
      {
        "title": "Thomas Mills, \"England and Wales, Census, 1841\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/96M2-FQS",
        "citation": "\"England and Wales, Census, 1841\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M7SF-8F5 : Tue Sep 08 21:48:39 UTC 2026), Entry for Thomas Mills and Charlotte Mills, 1841."
      },
      {
        "title": "Thomas Mills, \"England and Wales, Census, 1861\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9X52-8G2",
        "citation": "\"England and Wales, Census, 1861\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M71N-BYX : Wed Sep 09 23:24:59 UTC 2026), Entry for Thomas Mills and Charlotte Mills, 1861."
      },
      {
        "title": "Thomas Mills in household of George Mills, \"England and Wales Census, 1871\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9F5Q-8XN",
        "citation": "\"England and Wales, Census, 1871\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VFD8-G88 : Tue Sep 08 21:16:43 UTC 2026), Entry for George Mills and Caroline Mills, 1871."
      },
      {
        "title": "Thomas Mills, \"England and Wales Census, 1851\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9F5Q-8TS",
        "citation": ""
      },
      {
        "title": "Thomas Mills, \"United States Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMS5-QCS",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MNS2-Y55 : Wed Sep 09 15:06:22 UTC 2026), Entry for Thomas Mills and Charlotte Mills, 1880."
      },
      {
        "title": "Thomas Mills, \"England Marriages, 1538–1973\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9X52-DX5",
        "citation": "\"England Marriages, 1538–1973\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:N66J-6VM : Sat Aug 01 18:20:27 UTC 2026), Entry for Thomas Mills and Charlotte Coles, 7 February 1827."
      },
      {
        "title": "Thomas Mills, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9Z2D-5WF",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVVH-XWMF : Sun Oct 04 03:23:04 UTC 2026), Entry for Thomas Mills, 1883."
      },
      {
        "title": "Thomas Mills in entry for Margaret Mills, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9X52-JF6",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:J9C6-382 : 5 February 2023), Thomas Mills in entry for Margaret Mills, 1831."
      },
      {
        "title": "Thomas Mills in entry for Charles Mills, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9X52-NHM",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:NBJJ-GBK : 5 February 2023), Thomas Mills in entry for Charles Mills, 1832."
      },
      {
        "title": "Thomas Mills in entry for Joseph Mills, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9X52-FDN",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:ND3H-XBY : 5 February 2023), Thomas Mills in entry for Joseph Mills, 1842."
      },
      {
        "title": "Thomas Mills, \"Utah, Salt Lake County Death Records, 1849-1949\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9X52-6W6",
        "citation": "\"Utah, Salt Lake County Death Records, 1849-1949\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:NQ46-4F5 : Sat Mar 09 06:04:53 UTC 2024), Entry for Margaret Bennett and Thomas Mills, 17 Aug 1919."
      },
      {
        "title": "Thomas Mills in entry for Robert Thomas Mills, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/96JM-Y3L",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:ND3H-J27 : 5 February 2023), Thomas Mills in entry for Robert Thomas Mills, 1828."
      },
      {
        "title": "Thomas Mills in entry for Fanny Mills, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/96MR-HRF",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:J9C6-3F6 : 5 February 2023), Thomas Mills in entry for Fanny Mills, 1845."
      },
      {
        "title": "Thomas Mills in household of George Mills, \"England and Wales Census, 1871\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MM6X-486",
        "citation": "\"England and Wales, Census, 1871\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VFD8-G88 : Tue Sep 08 21:16:43 UTC 2026), Entry for George Mills and Caroline Mills, 1871."
      },
      {
        "title": "Thomas Mills in entry for George Mills, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9D7L-LV2",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:ND3H-DLR : 5 February 2023), Thomas Mills in entry for George Mills, 1836."
      },
      {
        "title": "Thomas Mills in entry for Margaret Bennett, \"Utah, Deaths and Burials, 1888-1946\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9D7V-ZS3",
        "citation": "\"Utah, Deaths and Burials, 1888-1946\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:F85F-NDJ : 28 January 2020), Thomas Mills in entry for Margaret Bennett, 1919."
      },
      {
        "title": "Thomas Mills in entry for Mercy Mills, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9D7V-C3W",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:J7CK-YM1 : 5 February 2023), Thomas Mills in entry for Mercy Mills, 1843."
      },
      {
        "title": "Thomas Mills in entry for Joseph Mills, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/93RN-5HH",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:N5SH-PVY : 5 February 2023), Thomas Mills in entry for Joseph Mills, 1842."
      },
      {
        "title": "Thomas Mills in entry for George Mills, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MN9H-H3Z",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:JM5M-9PY : 5 February 2023), Thomas Mills in entry for George Mills, 1836."
      },
      {
        "title": "Thomas Mills in entry for Charles Mills, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MJFK-87S",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:NBSW-W4Y : 5 February 2023), Thomas Mills in entry for Charles Mills, 1832."
      },
      {
        "title": "Thomas Mills in entry for Margaret Mills, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M2DF-JFM",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:JWXV-22J : 5 February 2023), Thomas Mills in entry for Margaret Mills, 1831."
      },
      {
        "title": "Thomas Mills in entry for Fanny Mills, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MDPR-W6H",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:N5SH-Y27 : 5 February 2023), Thomas Mills in entry for Fanny Mills, 1845."
      },
      {
        "title": "Thomas Mills in entry for Robert Thomas Mills, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MHBJ-FXZ",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:N5SH-RZD : 5 February 2023), Thomas Mills in entry for Robert Thomas Mills, 1828."
      },
      {
        "title": "Thomas Mills in entry for Richard Mills, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MN2N-Q55",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:J364-8V1 : 5 February 2023), Thomas Mills in entry for Richard Mills, 1834."
      },
      {
        "title": "Thomas Mills in entry for Charlotte Anne Mills, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MD5T-3T7",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:JWXX-QGW : 5 February 2023), Thomas Mills in entry for Charlotte Anne Mills, 1839."
      },
      {
        "title": "Thomas Mills in entry for Richard Mills, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9Z51-S35",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:J3LR-P2T : 5 February 2023), Thomas Mills in entry for Richard Mills, 1834."
      },
      {
        "title": "Thomas Mills in entry for Richard R. Mills, \"Utah, Deaths and Burials, 1888-1946\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9Z51-9ZG",
        "citation": "\"Utah, Deaths and Burials, 1888-1946\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:F85G-DYV : 28 January 2020), Thomas Mills in entry for Richard R. Mills, 1921."
      },
      {
        "title": "Thomas Mills, \"Utah, Salt Lake County Death Records, 1849-1949\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9Z51-MZN",
        "citation": "\"Utah, Salt Lake County Death Records, 1849-1949\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:NQ4J-W5B : Fri Mar 08 19:05:08 UTC 2024), Entry for Richard R Mills and Thomas Mills, 04 Dec 1921."
      },
      {
        "title": "Thomas Mills in entry for Charlotte Anne Mills, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9Z5B-1B9",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:J9C6-SGW : 5 February 2023), Thomas Mills in entry for Charlotte Anne Mills, 1839."
      },
      {
        "title": "Robert Thomas Mills, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9Z5B-1WW",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVL6-MRNV : Sat Oct 03 15:35:40 UTC 2026), Entry for Robert Thomas Mills."
      },
      {
        "title": "Thomas Mills, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9Z2D-5P6",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZ24-7MQ : Mon Feb 03 19:16:11 UTC 2025), Entry for Richard R. Mills and Thomas Mills, 04 Dec 1921."
      },
      {
        "title": "Thomas Mills in entry for Mercy Mills, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9Z8Y-NV7",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:J794-GHD : 5 February 2023), Thomas Mills in entry for Mercy Mills, 1843."
      },
      {
        "title": "Thomas Mills in entry for Henry Isaac Mills, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9Z46-XK1",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:N53W-Y5F : 5 February 2023), Thomas Mills in entry for Henry Isaac Mills, 1850."
      },
      {
        "title": "Thomas Mills in entry for Henry Isaac Mills, \"England Marriages, 1538–1973\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9Z46-XDM",
        "citation": "\"England Marriages, 1538–1973\", database, FamilySearch (https://familysearch.org/ark:/61903/1:1:N6ZF-LLW : 13 March 2020), Thomas Mills in entry for Henry Isaac Mills, 1869."
      },
      {
        "title": "Thomas Mills in entry for Henry Isaac Mills, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9Z46-X9R",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:NBJJ-LMJ : 5 February 2023), Thomas Mills in entry for Henry Isaac Mills, 1850."
      },
      {
        "title": "Thomas Mills, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9Z4D-D1K",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:J3LR-R9Q : 5 February 2023), Thomas Mills, 1803."
      }
    ],
    "portrait": "/ancestors/portraits/064_KWJ8-197.jpg"
  },
  {
    "id": "I526",
    "name": "Charlotte Coles",
    "sex": "F",
    "gen": 6,
    "slot": 1,
    "side": "paternal",
    "birthplace": "england",
    "childId": "I294",
    "birthYear": 1803,
    "deathYear": 1889,
    "birthDate": "16 Dec 1803",
    "deathDate": "6 Feb 1889",
    "burialDate": "Aft 6 Feb 1889",
    "christeningDate": "18 Dec 1803",
    "birthPlace": "Funtington, Sussex, England, United Kingdom",
    "deathPlace": "Bountiful, Davis, Utah, United States",
    "burialPlace": "Bountiful Memorial Park, Bountiful, Davis, Utah, United States",
    "christeningPlace": "Funtington, Sussex, England, United Kingdom",
    "fsId": "LR64-K4X",
    "photo": "/ancestors/bubbles/065_LR64-K4X.jpg",
    "living": false,
    "alternateNames": [
      "Charlotte Mills"
    ],
    "facts": [
      {
        "kind": "Residence",
        "date": "1851",
        "place": null,
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1851",
        "place": "Sussex, England, United Kingdom",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1851",
        "place": "South Bersted, Sussex, England, United Kingdom",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1861",
        "place": "South Bersted, Sussex, England, United Kingdom",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1870",
        "place": "Centerville, Davis, Utah, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1880",
        "place": "Joseph, Sevier, Utah, United States",
        "note": null
      },
      {
        "kind": "Find A Grave #",
        "date": null,
        "place": "90511011",
        "note": null
      },
      {
        "kind": "Membership",
        "date": null,
        "place": "Centerville, Davis, Utah, United States",
        "note": null
      }
    ],
    "sketch": "Short life sketch of Charlotte Coles Mills (please add, edit, correct info, as needed)\n\nCharlotte Coles was born 16 December 1803 in Sussex, England, to parents John Coles and Margaret Proudley.   She was the first of seven children, and was christened on December 18, 1803 in Funtington, Sussex, England.  \n\nA little information on Sussex, where Charlotte was born and raised:  \n“Sussex is a maritime County in south-east England.  The seaports are now small and comparatively unimportant.  Sussex was the scene of much of the early history of the country, and is rich in archeological remains. \nThe Sussex coast was greatly modified by the social movement of sea bathing for health which became fashionable among the wealthy in the second half of the 18th century. Resorts developed all along the coast, including at Brighton, Hastings, Worthing, and Bognor. At the beginning of the 19th century (when Charlotte was born) agricultural labourers' conditions took a turn for the worse with an increasing amount of them becoming unemployed.\nSussex has a centuries-old reputation for being separate and culturally distinct from the rest of England.  The people of Sussex have a reputation for independence of thought and have an aversion to being pushed around, as expressed through the Sussex motto, We wunt be druv. Sussex is known for its strong tradition of bonfire celebrations and its proud musical heritage.”\n\nCharlotte likely had one illegitimate son, John Rambridge (born in 1823). (Marriage to Joseph Coles disproved due to distance of different Joseph Coles and Charlottes). John Rambridge's birth record showed only mother, no mention of father at all.)\n\nCharlotte then married Thomas Mills on February 7, 1827 in South Bersted, Sussex, England.  They were the parents of eleven more children from 1827 to 1842.\n\nShe probably joined the LDS church about the same time her husband Thomas did (he was baptized in the LDS church on 9 March, 1844.)\n\nOn September 6, 1879 (we presume) Charlotte sailed with Thomas from England to America on the ship \"Wyoming.\"\nIn the 1880 US Census Thomas and Charlotte Mills are found visiting their daughter Fanny Horsley in Joseph, Sevier County, Utah. The census lists Thomas and Charlotte at age 78. Thomas' occupation is listed as being a \"Laborer\" and being unemployed for 3 months during the census year. Charlotte is listed as \"Keeping house\".\n\nJust four years after their immigration to the USA, Thomas died November 11, 1883 in Centerville, Utah.  \n\nCharlotte died February 6, 1889 in Centerville, Utah.  She was buried in the Bountiful Memorial Park, Bountiful, Davis County, Utah.",
    "sources": [
      {
        "title": "Charlote Coles, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QNBW-YPW",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6KK9-WZL5 : Sun Sep 13 05:09:52 UTC 2026), Entry for Richard Mills and Thos Mills."
      },
      {
        "title": "Charlotte Coles, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QC5H-VVP",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6KV3-FB3J : Sun Sep 13 04:01:28 UTC 2026), Entry for Richard Mills and Thomas."
      },
      {
        "title": "Charlotte Coles, \"Utah, Salt Lake County Death Records, 1849-1949\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9Z51-MJC",
        "citation": "\"Utah, Salt Lake County Death Records, 1849-1949\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:NQ4J-W5B : Fri Mar 08 19:05:08 UTC 2024), Entry for Richard R Mills and Thomas Mills, 04 Dec 1921."
      },
      {
        "title": "Charlotte Coles, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9Z2D-55T",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZ24-7MQ : Mon Feb 03 19:16:11 UTC 2025), Entry for Richard R. Mills and Thomas Mills, 04 Dec 1921."
      },
      {
        "title": "Charlotte Cole in entry for Henry Isaac Mills, \"Utah, Deaths and Burials, 1888-1946\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SVFJ-2H3",
        "citation": "\"Utah, Deaths and Burials, 1888-1946\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:HFYX-T4MM : 11 June 2020), Charlotte Cole in entry for Henry Isaac Mills, 1872."
      },
      {
        "title": "Charlotte Cole in entry for Richard Mills, \"Utah, Deaths and Burials, 1888-1946\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SVN3-MTX",
        "citation": "\"Utah, Deaths and Burials, 1888-1946\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:HFB6-L92M : 11 June 2020), Charlotte Cole in entry for Richard Mills, 1921."
      },
      {
        "title": "Coles, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QNBW-BDX",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZGH-6WY : Mon Feb 03 19:08:07 UTC 2025), Entry for George Mills and Thomas Mills, 30 Mar 1913."
      },
      {
        "title": "Charlote Coles, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QNBW-YBL",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6K29-7GC6 : Sun Sep 13 04:42:11 UTC 2026), Entry for Richard Mills and Thomas Mills."
      },
      {
        "title": "Charlotte Coles, \"Utah, Obituaries from Utah Newspapers, 1850-2005\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/96M4-6D3",
        "citation": "\"Utah, Obituaries from Utah Newspapers, 1850-2005\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSF-GDVL : Tue Mar 11 15:44:40 UTC 2025), Entry for Brother John R Coles and Joseph Coles, 14 Sep 1893."
      },
      {
        "title": "Charlotte Poles in entry for Margaret Bennett, \"Utah Death Certificates, 1904-1964\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9K2B-H6L",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZGF-THK : Mon Feb 03 19:14:16 UTC 2025), Entry for Margaret Bennett and Thomas Mills, 17 Aug 1919."
      },
      {
        "title": "Charlote T Mills, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7XK9-M2Z",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6KGF-29SK : Sun Sep 13 04:05:19 UTC 2026), Entry for Charlote T Mills and John Coles."
      },
      {
        "title": "Charlotte Cole Mills, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/98GP-DDL",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVL6-M52X : Fri Oct 02 12:13:55 UTC 2026), Entry for Charlotte Cole Mills, 1889."
      },
      {
        "title": "Charlotte Coles in entry for Margaret Bennett, \"Utah, Deaths and Burials, 1888-1946\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9D7V-C1V",
        "citation": "\"Utah, Deaths and Burials, 1888-1946\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:F85F-NDV : 28 January 2020), Charlotte Coles in entry for Margaret Bennett, 1919."
      },
      {
        "title": "Charlotta Mills, \"United States, Census, 1870\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9F57-6GH",
        "citation": "\"United States, Census, 1870\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MNCR-G7Q : Thu Oct 23 03:14:58 UTC 2025), Entry for Charlotta Mills and David Orsley, 1870."
      },
      {
        "title": "Charlotte Mills, \"United States, Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9F57-XN7",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MNS2-Y55 : Wed Sep 09 15:06:22 UTC 2026), Entry for Thomas Mills and Charlotte Mills, 1880."
      },
      {
        "title": "Charlotte Cole in entry for Margaret Mills Bennett, \"Utah, Deaths and Burials, 1888-1946\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SVNS-16J",
        "citation": "\"Utah, Deaths and Burials, 1888-1946\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:HFBQ-M2ZM : 11 June 2020), Charlotte Cole in entry for Margaret Mills Bennett, 1919."
      },
      {
        "title": "Charlotte Gales, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S43J-9XM",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZGP-ZZ8 : Mon Feb 03 19:10:10 UTC 2025), Entry for Frances Jane Mills Horsley and Thomas Mills, 20 Oct 1926."
      },
      {
        "title": "Charlotte Coles in entry for Richard R. Mills, \"Utah, Deaths and Burials, 1888-1946\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9Z51-9FL",
        "citation": "\"Utah, Deaths and Burials, 1888-1946\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:F85G-DYK : 28 January 2020), Charlotte Coles in entry for Richard R. Mills, 1921."
      },
      {
        "title": "Charlotte Coles, \"Utah, Salt Lake County Death Records, 1849-1949\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9X52-6Q1",
        "citation": "\"Utah, Salt Lake County Death Records, 1849-1949\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:NQ46-4F5 : Sat Mar 09 06:04:53 UTC 2024), Entry for Margaret Bennett and Thomas Mills, 17 Aug 1919."
      },
      {
        "title": "Charlotte Cole in entry for John Cole, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q114-VDH",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:NRVZ-JS9 : 5 February 2023), Charlotte Cole in entry for John Cole, 1823."
      },
      {
        "title": "1861 England Census, Thomas Mills family",
        "href": "https://www.familysearch.org/tree/sources/viewedit/96MG-LY4",
        "citation": "findmypast.com"
      },
      {
        "title": "Charlotte in entry for Fanny Mills, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MDPR-W66",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:N5SH-Y2W : 5 February 2023), Charlotte in entry for Fanny Mills, 1845."
      },
      {
        "title": "Charlotte in entry for Joseph Mills, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/93RN-5H6",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:N5SH-PVB : 5 February 2023), Charlotte in entry for Joseph Mills, 1842."
      },
      {
        "title": "Charlotte Mills, \"England, Sussex, Parish Registers, 1538-1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9NN9-Q8X",
        "citation": "\"England, Sussex, Parish Registers, 1538-1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2Q7-246P : Tue Sep 08 21:37:22 UTC 2026), Entry for Charlotte Anne Mills and Thomas Mills, 08 Dec 1839."
      },
      {
        "title": "Charlotte Mills, \"England, Sussex, Parish Registers, 1538-1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9NN9-WBZ",
        "citation": "\"England, Sussex, Parish Registers, 1538-1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2Q7-27T8 : Tue Sep 08 21:35:49 UTC 2026), Entry for Joseph Mills and Thomas Mills, 11 May 1842."
      },
      {
        "title": "Charlotte in entry for Mercy Mills, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9D7V-CQJ",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:J7CK-Y9M : 5 February 2023), Charlotte in entry for Mercy Mills, 1843."
      },
      {
        "title": "Charlotte Mills, \"England and Wales, Census, 1851\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/96M2-VRW",
        "citation": "\"England and Wales, Census, 1851\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:SG84-L9M : Fri Aug 21 09:06:58 UTC 2026), Entry for Thomas Mills and Charlotte Mills, 1851."
      },
      {
        "title": "Charlotte Mills in household of Thomas Mills, \"England and Wales Census, 1841\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9F5Q-DB4",
        "citation": "\"England and Wales, Census, 1841\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M7SF-8F5 : Tue Sep 08 21:48:39 UTC 2026), Entry for Thomas Mills and Charlotte Mills, 1841."
      },
      {
        "title": "Charlotte in entry for Charlotte Anne Mills, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9Z51-M9W",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:J9C6-SG4 : 5 February 2023), Charlotte in entry for Charlotte Anne Mills, 1839."
      },
      {
        "title": "Charlotte Mills, \"England, Sussex, Parish Registers, 1538-1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9N57-S7K",
        "citation": "\"England, Sussex, Parish Registers, 1538-1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2Q7-2Q33 : Tue Sep 08 21:33:08 UTC 2026), Entry for Henry Isaac Mills and Thomas Mills, 15 Sep 1850."
      },
      {
        "title": "Charlotte, \"England, Sussex, Parish Registers, 1538-1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9J62-28N",
        "citation": "\"England, Sussex, Parish Registers, 1538-1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2Q7-2739 : Tue Sep 08 21:38:23 UTC 2026), Entry for Mercy Mills and Thomas Mills, 09 Sep 1843."
      },
      {
        "title": "Charlotte Mills, \"England and Wales, Census, 1841\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/96M2-F9M",
        "citation": "\"England and Wales, Census, 1841\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M7SF-8F5 : Tue Sep 08 21:48:39 UTC 2026), Entry for Thomas Mills and Charlotte Mills, 1841."
      },
      {
        "title": "Charlotte in entry for Henry Isaac Mills, \"England Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9VDB-MF5",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:NBJJ-LMV : 5 February 2023), Charlotte in entry for Henry Isaac Mills, 1850."
      },
      {
        "title": "Charlotte Mills, \"England and Wales, Census, 1861\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9X52-8F6",
        "citation": "\"England and Wales, Census, 1861\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M71N-BYX : Wed Sep 09 23:24:59 UTC 2026), Entry for Thomas Mills and Charlotte Mills, 1861."
      },
      {
        "title": "Charlotte in entry for Joseph Mills, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9X52-FXL",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:ND3H-XBB : 5 February 2023), Charlotte in entry for Joseph Mills, 1842."
      },
      {
        "title": "Charlotte Mills, \"England, Sussex, Parish Registers, 1538-1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9JPM-S2T",
        "citation": "\"England, Sussex, Parish Registers, 1538-1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2Q7-249S : Tue Sep 08 21:33:01 UTC 2026), Entry for Fanny Mills and Thomas Mills, 17 Aug 1845."
      },
      {
        "title": "Charlotte in entry for Henry Isaac Mills, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9W92-CM4",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:N53W-Y5N : 5 February 2023), Charlotte in entry for Henry Isaac Mills, 1850."
      },
      {
        "title": "Charlotte in entry for Fanny Mills, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/96MR-HPC",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:J9C6-3FX : 5 February 2023), Charlotte in entry for Fanny Mills, 1845."
      },
      {
        "title": "Charlotte Mills, \"England and Wales Census, 1851\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9F5Q-63H",
        "citation": ""
      },
      {
        "title": "Charlotte in entry for Mercy Mills, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9Z8Y-NKJ",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:J794-GH6 : 5 February 2023), Charlotte in entry for Mercy Mills, 1843."
      },
      {
        "title": "Charlotte Mills, \"England, Sussex, Parish Registers, 1538-1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9N57-S99",
        "citation": "\"England, Sussex, Parish Registers, 1538-1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2Q7-2MDY : Tue Sep 08 20:51:55 UTC 2026), Entry for George Mills and Thomas Mills, 31 Jul 1836."
      },
      {
        "title": "Charlotte in entry for Richard Mills, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MN2N-QRM",
        "citation": "\"England, Births and Christenings, 1538-1975\", , FamilySearch (https://www.familysearch.org/ark:/61903/1:1:J364-8KM : 5 February 2023), Charlotte in entry for Richard Mills, 1834."
      },
      {
        "title": "Charlotte Mills, \"England, Sussex, Parish Registers, 1538-1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9N57-913",
        "citation": "\"England, Sussex, Parish Registers, 1538-1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2QW-29J5 : Tue Sep 08 21:36:33 UTC 2026), Entry for Margaret Mills and Thomas Mills, 17 Apr 1831."
      },
      {
        "title": "England, Select Births and Christenings, 1538-1975",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SQF1-HXS",
        "citation": ""
      },
      {
        "title": "Charlotte in entry for Margaret Mills, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M2DF-JFH",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:JWXV-22V : 5 February 2023), Charlotte in entry for Margaret Mills, 1831."
      },
      {
        "title": "Charlotte in entry for Margaret Mills, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9X52-JPL",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:J9C6-38L : 5 February 2023), Charlotte in entry for Margaret Mills, 1831."
      },
      {
        "title": "Charlotte in entry for Charles Mills, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MJFK-87W",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:NBSW-W4B : 5 February 2023), Charlotte in entry for Charles Mills, 1832."
      },
      {
        "title": "Charlotte in entry for George Mills, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MN9H-H3D",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:JM5M-9PB : 5 February 2023), Charlotte in entry for George Mills, 1836."
      },
      {
        "title": "Charlotte in entry for Charlotte Anne Mills, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MD5T-3TN",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:JWXX-QG4 : 5 February 2023), Charlotte in entry for Charlotte Anne Mills, 1839."
      },
      {
        "title": "Charlotte Mills, \"England, Sussex, Parish Registers, 1538-1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9NG3-GY7",
        "citation": "\"England, Sussex, Parish Registers, 1538-1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2QW-29SV : Tue Sep 08 20:57:33 UTC 2026), Entry for Joseph Mills and Thomas Mills, 03 Nov 1829."
      },
      {
        "title": "Charlotte in entry for Joseph Mills, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SZ8G-V5V",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:J9C6-SX5 : 5 February 2023), Charlotte in entry for Joseph Mills, 1829."
      },
      {
        "title": "Charlotte in entry for Robert Thomas Mills, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/96JM-Y3T",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:ND3H-J2W : 5 February 2023), Charlotte in entry for Robert Thomas Mills, 1828."
      },
      {
        "title": "Charlotte Mills, \"England, Sussex, Parish Registers, 1538-1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9N57-9TJ",
        "citation": "\"England, Sussex, Parish Registers, 1538-1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2QW-2SBW : Tue Sep 08 21:41:07 UTC 2026), Entry for Robert Thomas Mills and Thomas Mills, 06 Jan 1828."
      },
      {
        "title": "Charlotte in entry for Robert Thomas Mills, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MHBJ-FXN",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:N5SH-RZ6 : 5 February 2023), Charlotte in entry for Robert Thomas Mills, 1828."
      },
      {
        "title": "Charlotte Mills, \"England, Sussex, Parish Registers, 1538-1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9N57-S36",
        "citation": "\"England, Sussex, Parish Registers, 1538-1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2QW-2SVM : Tue Sep 08 21:40:03 UTC 2026), Entry for Charles Mills and Thomas Mills, 23 Sep 1832."
      },
      {
        "title": "Charlotte in entry for Joseph Mills, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SCJP-8SP",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:N5SH-PVR : 5 February 2023), Charlotte in entry for Joseph Mills, 1829."
      },
      {
        "title": "Charlotte Mills, \"England, Sussex, Parish Registers, 1538-1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9NNQ-RB2",
        "citation": "\"England, Sussex, Parish Registers, 1538-1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2QW-2WQN : Tue Sep 08 21:39:57 UTC 2026), Entry for Richard Mills and Thomas Mills, 31 Aug 1834."
      },
      {
        "title": "Charlotte in entry for Richard Mills, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9Z51-SS8",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:J3LR-P2Y : 5 February 2023), Charlotte in entry for Richard Mills, 1834."
      },
      {
        "title": "Charlotte in entry for George Mills, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9D7L-LV7",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:ND3H-DLT : 5 February 2023), Charlotte in entry for George Mills, 1836."
      },
      {
        "title": "Charlotte in entry for Charles Mills, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9X52-N7Q",
        "citation": "\"England, Births and Christenings, 1538-1975\", , FamilySearch (https://www.familysearch.org/ark:/61903/1:1:NBJJ-GB2 : 5 February 2023), Charlotte in entry for Charles Mills, 1832."
      },
      {
        "title": "Charlotte Coles in the England, Select Marriages, 1538–1973 in \"Ancestry.com\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9BGS-7VV",
        "citation": "\"Charlotte Coles in the England, Select Marriages, 1538–1973.\" Charlotte Coles in the England, Select Marriages, 1538–1973. N.p., n.d. Web. 12 Jun. 2018. ."
      },
      {
        "title": "Charlotte Cole. Christening. in the Millennium File. on \"Ancestry.com\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3869-QNJ",
        "citation": ""
      },
      {
        "title": "Charlotte Cole in the England, Select Births and Christenings, 1538-1975. on \"Ancestry.com\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/386M-GM8",
        "citation": ""
      },
      {
        "title": "Charlotte Coles, \"England, Sussex, Parish Registers, 1538-1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9PYF-HKM",
        "citation": "\"England, Sussex, Parish Registers, 1538-1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2QW-2QTK : Tue Sep 08 21:39:59 UTC 2026), Entry for John Coles and Charlotte Coles, 22 Feb 1824."
      },
      {
        "title": "Charlotte Cole, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9WB2-M5J",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:N5H1-JHL : 5 February 2023), Charlotte Cole, 1803."
      },
      {
        "title": "Charlotte Coles, \"England Marriages, 1538–1973\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9X52-DVR",
        "citation": "\"England Marriages, 1538–1973\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:N66J-6VM : Sat Aug 01 18:20:27 UTC 2026), Entry for Thomas Mills and Charlotte Coles, 7 February 1827."
      },
      {
        "title": "Charlotte Coles in entry for John Coles, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SQWK-B81",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:ND3H-TR7 : 5 February 2023), Charlotte Coles in entry for John Coles, 1824."
      },
      {
        "title": "Charlotte Coles in entry for John Coles, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/99BT-D9F",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:N53W-59X : 5 February 2023), Charlotte Coles in entry for John Coles, 1824."
      },
      {
        "title": "Charlotte Coles, \"England, Sussex, Parish Registers, 1538-1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9NF2-8DS",
        "citation": "\"England, Sussex, Parish Registers, 1538-1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2Q7-29C4 : Tue Sep 08 21:38:24 UTC 2026), Entry for Thomas Mills and Charlotte Coles, 07 Feb 1827."
      },
      {
        "title": "Charlott Cole, \"England, Sussex, Parish Registers, 1538-1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3865-W67",
        "citation": "\"England, Sussex, Parish Registers, 1538-1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2QQ-8QFZ : Tue Sep 08 21:39:58 UTC 2026), Entry for Charlott Cole and John Cole, 18 Dec 1803."
      }
    ],
    "portrait": "/ancestors/portraits/065_LR64-K4X.jpg"
  },
  {
    "id": "I310",
    "name": "Charlotte Chessel White",
    "sex": "F",
    "gen": 5,
    "slot": 1,
    "side": "paternal",
    "birthplace": "england",
    "childId": "I121",
    "birthYear": 1848,
    "deathYear": 1926,
    "birthDate": "22 Sep 1848",
    "deathDate": "21 Aug 1926",
    "burialDate": "25 Aug 1926",
    "christeningDate": "29 Oct 1848",
    "birthPlace": "Climping, Sussex, England, United Kingdom",
    "deathPlace": "Salt Lake City, Salt Lake, Utah, United States",
    "burialPlace": "Centerville, Davis, Utah, United States",
    "christeningPlace": "Climping, Sussex, England, United Kingdom",
    "fsId": "KWXS-H7K",
    "photo": "/ancestors/bubbles/033_KWXS-H7K.jpg",
    "living": false,
    "alternateNames": [
      "Charlotte",
      "Charlotte Mills",
      "Charlotte Horsley"
    ],
    "facts": [
      {
        "kind": "Residence",
        "date": "1861",
        "place": "Climping, Sussex, England, United Kingdom",
        "note": null
      },
      {
        "kind": "Immigration",
        "date": "1871",
        "place": null,
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1871",
        "place": "Brighton, Sussex, England, United Kingdom",
        "note": null
      },
      {
        "kind": "Initiatories (LDS)",
        "date": "17 March 1873",
        "place": "Endowment House, Salt Lake City, Salt Lake, Utah, United States",
        "note": null
      },
      {
        "kind": "Confirmation (LDS)",
        "date": "15 July 1874",
        "place": "Endowment House, Salt Lake City, Salt Lake, Utah, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1880",
        "place": "Centerville, Davis, Utah, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1900",
        "place": "Centerville Election Precinct, Davis, Utah, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1910",
        "place": "Centerville, Davis, Utah, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1920",
        "place": "Salt Lake, Utah, United States",
        "note": null
      },
      {
        "kind": "Find A Grave #",
        "date": null,
        "place": "49579",
        "note": null
      },
      {
        "kind": "Residence",
        "date": null,
        "place": "Salt Lake City, Salt Lake, Utah, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": null,
        "place": "Climping, Sussex, England, United Kingdom",
        "note": null
      },
      {
        "kind": "Event Registration",
        "date": null,
        "place": "St Peter's Church, Brighton, Sussex, England, United Kingdom",
        "note": null
      },
      {
        "kind": "Membership",
        "date": null,
        "place": "Centerville, Davis, Utah, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Charlotte White Horsley, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7XDJ-MD4",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6KVK-LK4X : Sun Sep 13 03:40:37 UTC 2026), Entry for Charlotte White Horsley and James White."
      },
      {
        "title": "Charlotte Chessell White, \"The Church of Jesus Christ of Latter-day Saints, Missionary Registers (Worldwide), 1860-1937\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q57G-K12",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Missionary Registers (Worldwide), 1860-1937\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6G87-D9QC : Tue Apr 29 03:42:03 UTC 2025), Entry for Susetta Horsley Bowers and Wm H Streeper."
      },
      {
        "title": "Charlotte White, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QJK3-BGR",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6KVK-LK4Z : Sun Sep 13 03:41:31 UTC 2026), Entry for Joseph Leroy Horsley and Wm Barber."
      },
      {
        "title": "Charlotte Mills White, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QJZC-D3D",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6KKS-MVHH : Sun Sep 13 03:27:32 UTC 2026), Entry for David Horsley and W Barber."
      },
      {
        "title": "Charlotte White, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QJZC-8GJ",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6KKP-M567 : Sun Sep 13 05:23:53 UTC 2026), Entry for Ernest Horsley and C. H. Smith."
      },
      {
        "title": "Charlotte White, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QJZC-8DP",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6KKG-W25L : Sun Sep 13 03:44:27 UTC 2026), Entry for George R. Horsely and Thos. H. Whitaker."
      },
      {
        "title": "Charlote White, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QJZC-ZB2",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6KV5-6YDW : Sun Sep 13 05:23:12 UTC 2026), Entry for Lusetta Horseley and David Horseley."
      },
      {
        "title": "Charlote C White, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QJZC-ZJ7",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6KKT-VWTL : Sun Sep 13 05:30:07 UTC 2026), Entry for Charles A Horsley and Jno J Smith."
      },
      {
        "title": "Charlotte White, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QJZC-WYD",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6KKP-M5DB : Sun Sep 13 03:24:47 UTC 2026), Entry for Susetta Horsley and W. H. Streeper."
      },
      {
        "title": "Charlotte White, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QJZC-WJV",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6KVX-32XG : Sun Sep 13 03:53:52 UTC 2026), Entry for David Horseley and Wm Barber."
      },
      {
        "title": "Charlotte White, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QJZC-W73",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6KGS-TLV6 : Sun Sep 13 05:29:20 UTC 2026), Entry for Joseph L Horsley and Wm Barber."
      },
      {
        "title": "Charlotte White, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QJZH-FWH",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6KKP-M56S : Sun Sep 13 05:22:34 UTC 2026), Entry for Arthur Horsley and David Horsley."
      },
      {
        "title": "Charlotte White, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QJZH-XPD",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6KKP-M5DR : Sun Sep 13 05:19:43 UTC 2026), Entry for Rose Ann Horsley and David Horsley."
      },
      {
        "title": "Charlotte White, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QN1F-F2F",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6KKP-M5DL : Sun Sep 13 03:27:40 UTC 2026), Entry for Charlotte E. Mills and James Baird."
      },
      {
        "title": "Charlote White, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QN1F-XB5",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6KV8-Y1GK : Sun Sep 13 03:59:45 UTC 2026), Entry for Charlote E W Mills and Isaac Mills."
      },
      {
        "title": "Charlotte White, \"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q7LF-KZ7",
        "citation": "\"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6KWG-QZL4 : Tue Jun 30 12:20:55 UTC 2026), Entry for Susetta Horsley and David Horsley."
      },
      {
        "title": "Charlotte White Horsley in entry for Joseph Le Roy Horsley, \"Utah, Obituaries from Utah Newspapers, 1850-2005\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SVND-R6S",
        "citation": "\"Utah, Obituaries from Utah Newspapers, 1850-2005,\" , FamilySearch (https://familysearch.org/ark:/61903/1:1:QVSF-VB55 : 17 March 2018), Charlotte White Horsley in entry for Joseph Le Roy Horsley, 04 Jun 1976; citing Davis County Clipper, 1976-1982, The University of Utah. J. Willard Marriott Library, Salt Lake City."
      },
      {
        "title": "Charlotte Chessell White Mills Horsley, \"Utah, Deaths and Burials, 1888-1946\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SVND-53N",
        "citation": "\"Utah, Deaths and Burials, 1888-1946\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:HFYN-NLW2 : 11 June 2020), Charlotte Chessell White Mills Horsley, ."
      },
      {
        "title": "Charlotte Chessell White in entry for Rose Ann Horsley, \"Utah, Deaths and Burials, 1888-1946\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SVND-LFG",
        "citation": "\"Utah, Deaths and Burials, 1888-1946\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:HFBW-J36Z : 11 June 2020), Charlotte Chessell White in entry for Rose Ann Horsley, ."
      },
      {
        "title": "Charlotte Chessell White in entry for George Robert Horsley, \"Utah, Deaths and Burials, 1888-1946\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SVND-KJV",
        "citation": "\"Utah, Deaths and Burials, 1888-1946\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:HFBQ-LVW2 : 11 June 2020), Charlotte Chessell White in entry for George Robert Horsley, ."
      },
      {
        "title": "Charlotte Chessell White in entry for Arthur Horsley, \"Utah, Deaths and Burials, 1888-1946\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SVFS-ZVB",
        "citation": "\"Utah, Deaths and Burials, 1888-1946\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:HFB6-6FMM : 11 June 2020), Charlotte Chessell White in entry for Arthur Horsley, ."
      },
      {
        "title": "Charlotte C Mills, \"Utah, Obituaries from Utah Newspapers, 1850-2005\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SJBS-XJY",
        "citation": "\"Utah, Obituaries from Utah Newspapers, 1850-2005\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSF-NPB7 : Tue Mar 11 14:54:37 UTC 2025), Entry for Mr David Horsley and Charlotte C Mills, 18 Apr 1930."
      },
      {
        "title": "Mrs David Horsley, \"Utah, Obituaries from Utah Newspapers, 1850-2005\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9P1F-55B",
        "citation": "\"Utah, Obituaries from Utah Newspapers, 1850-2005\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSF-YLHX : Tue Mar 11 16:07:44 UTC 2025), Entry for Mr George R Horsley and Mrs Genevieve Garbett Horsley, 15 Dec 1923."
      },
      {
        "title": "Charlotte Mills in household of Harry Mills, \"England and Wales Census, 1871\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9LRK-PM2",
        "citation": "\"England and Wales, Census, 1871\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VFDW-1W7 : Tue Sep 08 20:55:35 UTC 2026), Entry for Harry Mills and Charlotte Mills, 1871."
      },
      {
        "title": "Charlotte Chessel White Mills in entry for Henry Isaac Mills Jr, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9LRK-GJK",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSX-WHPH : Sat Sep 27 20:28:22 UTC 2025), Entry for Henry Isaac Mills Jr and Henry Isaac Mills, 1949."
      },
      {
        "title": "Charlotte Chissel White, \"England, Sussex, Parish Registers, 1538-1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9VM5-G1Q",
        "citation": "\"England, Sussex, Parish Registers, 1538-1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2QW-2NN7 : Tue Sep 08 21:32:17 UTC 2026), Entry for Charlotte Chissel White and James White, 29 Oct 1848."
      },
      {
        "title": "Charlotte Chessell White, \"England, Sussex, Parish Registers, 1538-1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9J62-6RX",
        "citation": "\"England, Sussex, Parish Registers, 1538-1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2QW-2K8N : Tue Sep 08 21:33:33 UTC 2026), Entry for Henry Isaac Mills and Charlotte Chessell White, 01 Aug 1869."
      },
      {
        "title": "Charlotte White, \"The Church of Jesus Christ of Latter-day Saints, Missionary Registers (Worldwide), 1860-1937\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9J6F-BV1",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Missionary Registers (Worldwide), 1860-1937\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QKDW-YK6Z : Tue Mar 11 16:26:27 UTC 2025), Entry for Henry Isaac Mills and James Baird, 1905."
      },
      {
        "title": "Charlotte Mills, \"England, Sussex, Parish Registers, 1538-1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9JDY-GRJ",
        "citation": "\"England, Sussex, Parish Registers, 1538-1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KFG8-QFD : Tue Sep 08 21:36:07 UTC 2026), Entry for Harry James Mills and Henry Isaac Mills, 24 Jul 1870."
      },
      {
        "title": "Charlotte Chessell White, \"England, Sussex, Parish Registers, 1538-1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9J8B-H7R",
        "citation": "\"England, Sussex, Parish Registers, 1538-1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2QW-2K8J : Tue Sep 08 21:35:29 UTC 2026), Entry for Henry Isaac Mills and Thomas Mills, 14 Aug 1869."
      },
      {
        "title": "Charlotte C White, \"England and Wales, Census, 1851\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9JSX-RHS",
        "citation": "\"England and Wales, Census, 1851\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:SG14-98W : Fri Aug 21 08:23:58 UTC 2026), Entry for James White and Martha White, 1851."
      },
      {
        "title": "Charlotte White Horsley, \"Utah, Box Elder, Tremonton and Garland Obituaries, 1959-2013\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9NX2-KD8",
        "citation": "\"Utah, Box Elder, Tremonton and Garland Obituaries, 1959-2013\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2QP-G8LF : Sat Mar 09 16:18:20 UTC 2024), Entry for Mr Ernest Horsley and David Horsley, 1977."
      },
      {
        "title": "Charlotte White Horsley, \"Idaho, Southern Counties Obituaries, 1943-2013\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9FJ8-4M8",
        "citation": "\"Idaho, Southern Counties Obituaries, 1943-2013\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVS8-1Q7C : Thu Sep 19 19:30:11 UTC 2024), Entry for Ernest Horsley and David Horsley."
      },
      {
        "title": "Charlotte Chessell White, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9FFP-N7J",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QKDV-X3PZ : Wed Dec 10 05:49:34 UTC 2025), Entry for Susetta Horsley Bowers and David Horsley, 27 Dec 1964."
      },
      {
        "title": "Charlot White, \"England and Wales, Census, 1861\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9F75-ML7",
        "citation": "\"England and Wales, Census, 1861\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M71S-32F : Thu Sep 10 00:39:29 UTC 2026), Entry for James White and Martha White, 1861."
      },
      {
        "title": "Charlotte White, \"The Church of Jesus Christ of Latter-day Saints, Missionary Registers (Worldwide), 1860-1937\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9F3L-6BX",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Missionary Registers (Worldwide), 1860-1937\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QKDW-TTG3 : Tue Mar 11 16:21:37 UTC 2025), Entry for David Wm Horsley and Wm Barber, 1897."
      },
      {
        "title": "Charlotte C White, \"The Church of Jesus Christ of Latter-day Saints, Missionary Registers (Worldwide), 1860-1937\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9XTZ-3VZ",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Missionary Registers (Worldwide), 1860-1937\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QKDW-BLFN : Tue Mar 11 16:30:00 UTC 2025), Entry for Joseph Leroy Horsley and William Barber, 1916."
      },
      {
        "title": "Charlotte C White, \"Idaho, Death Certificates, 1938-1961\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9XTZ-371",
        "citation": "\"Idaho, Death Certificates, 1938-1961\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2M1-5XWM : Fri Feb 21 22:53:22 UTC 2025), Entry for Henry Isaac Mills and Isaac Mills, 19 Feb 1949."
      },
      {
        "title": "Charlotte White Horsley, \"Utah, Obituaries from Utah Newspapers, 1850-2005\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9XTC-ZLJ",
        "citation": "\"Utah, Obituaries from Utah Newspapers, 1850-2005\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSF-NL8D : Tue Mar 11 14:55:29 UTC 2025), Entry for Bert Horsley and David Horsley, 04 Mar 1927."
      },
      {
        "title": "Charlotte Chapel White, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/96NG-85F",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:NBNF-6S9 : 4 February 2023), Charlotte Chapel White, 1848."
      },
      {
        "title": "Charlette White in entry for George Robert Horsley, \"Utah, Marriages, 1887-1935\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9DZV-RW8",
        "citation": "\"Utah, Marriages, 1887-1935\", database, FamilySearch (https://familysearch.org/ark:/61903/1:1:F8GR-CPN : 28 January 2020), Charlette White in entry for George Robert Horsley, 1921."
      },
      {
        "title": "Charlotte White in the New York, Passenger Lists, 1820-1957",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9D7J-8WM",
        "citation": "Ancestry.com"
      },
      {
        "title": "Charlette White, \"Utah, County Marriages, 1871-1941\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9DSN-DYJ",
        "citation": "\"Utah, County Marriages, 1871-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KSG1-PSP : Thu Sep 19 20:17:36 UTC 2024), Entry for George Robert Horsley and David Wm. Horsley, 08 Jun 1921."
      },
      {
        "title": "Charlotte White, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/98Z5-WVX",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZP2-PJN : Mon Feb 03 19:01:56 UTC 2025), Entry for Charlotte Elizabeth Mills John and Henry I. Mills, 03 Mar 1951."
      },
      {
        "title": "Charlotte Chessell White, \"England Marriages, 1538–1973\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9CZY-QLJ",
        "citation": "\"England Marriages, 1538–1973\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:N29M-3JX : Sat Aug 01 20:31:06 UTC 2026), Entry for Henry Isaac Mills and Charlotte Chessell White, 14 August 1869."
      },
      {
        "title": "Charlotte C. White, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZLT-RDJ",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZPP-CW3 : Thu Jan 09 14:08:47 UTC 2025), Entry for David William Horsley and David Horsley, 17 Aug 1953."
      },
      {
        "title": "Charlotte Chessel White Horsley, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZLT-RSJ",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVVH-X7P4 : Sat Oct 03 01:11:27 UTC 2026), Entry for Charlotte Chessel White Horsley, 1926."
      },
      {
        "title": "Charlotte Chessel Horsley, \"Utah, Salt Lake County Death Records, 1849-1949\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZLT-5CT",
        "citation": "\"Utah, Salt Lake County Death Records, 1849-1949\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:NQ45-GJC : Sat Mar 09 08:22:24 UTC 2024), Entry for Charlotte Chessel Horsley and James White, 21 Aug 1926."
      },
      {
        "title": "Charlotte Chessell White in entry for Henry Isaac Mills, \"England Marriages, 1538–1973\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9Z46-X88",
        "citation": "\"England Marriages, 1538–1973\", database, FamilySearch (https://familysearch.org/ark:/61903/1:1:N6ZF-LL3 : 13 March 2020), Charlotte Chessell White in entry for Henry Isaac Mills, 1869."
      },
      {
        "title": "Charlette White, \"Utah, County Marriages, 1871-1941\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9Z4M-6TV",
        "citation": "\"Utah, County Marriages, 1871-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KSP9-MVD : Thu Sep 19 19:25:40 UTC 2024), Entry for Joseph Leroy Horsley and David Horsley, 01 Feb 1923."
      },
      {
        "title": "Charlotte Chessel Horsley, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZQ6-7BV",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZGP-R56 : Mon Feb 03 19:19:32 UTC 2025), Entry for Charlotte Chessel Horsley and James White, 21 Aug 1926."
      },
      {
        "title": "Charlotte Chessel Horsley, \"Utah, Deaths and Burials, 1888-1946\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZQ6-736",
        "citation": "\"Utah, Deaths and Burials, 1888-1946\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:F859-6XP : 28 January 2020), Charlotte Chessel Horsley, 1926."
      },
      {
        "title": "Charlotte White, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZQS-CM8",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZG5-GRQ : Mon Feb 03 19:19:20 UTC 2025), Entry for Charles Albert Horsley and David Horsley, 01 Mar 1927."
      },
      {
        "title": "Charlotte White in entry for Charles Albert Horsley, \"Utah, Deaths and Burials, 1888-1946\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZQS-H5Y",
        "citation": "\"Utah, Deaths and Burials, 1888-1946\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:F859-TYW : 28 January 2020), Charlotte White in entry for Charles Albert Horsley, 1927."
      },
      {
        "title": "Charlette White in entry for Joseph Leroy Horsley, \"Utah, Marriages, 1887-1935\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSLT-YZN",
        "citation": "\"Utah, Marriages, 1887-1935\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:F8G1-CNB : 28 January 2020), Charlette White in entry for Joseph Leroy Horsley, 1923."
      },
      {
        "title": "Charlotte C. White, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSLT-YQK",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZPL-4V1 : Mon Feb 03 19:18:19 UTC 2025), Entry for George Robert Horsley and David Horsley, 13 Dec 1923."
      },
      {
        "title": "Charlotte C White, \"California, County Marriages, 1849-1957\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSLT-RPP",
        "citation": "\"California, County Marriages, 1849-1957\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:K8JX-M71 : Wed Jul 10 00:34:24 UTC 2024), Entry for David Wm Horsley and David Horsley, 21 Apr 1934."
      },
      {
        "title": "Charlott Horsley, \"United States, Census, 1920\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSLT-RJ2",
        "citation": "\"United States, Census, 1920\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M8PY-8LZ : Mon Sep 28 23:37:18 UTC 2026), Entry for David Horsley and Charlott Horsley, 1920."
      },
      {
        "title": "Charlotte White, \"Utah, Salt Lake County Death Records, 1849-1949\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSLR-9SC",
        "citation": "\"Utah, Salt Lake County Death Records, 1849-1949\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:NQ4R-88W : Sun Mar 10 06:40:50 UTC 2024), Entry for Charles Albert Horsley and David Horsley, 01 Mar 1927."
      },
      {
        "title": "Charlotte C Horsley, \"United States, Census, 1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSLR-MP9",
        "citation": "\"United States, Census, 1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M5XS-FJP : Wed Aug 13 17:31:07 UTC 2025), Entry for David Horsley and Charlotte C Horsley, 1910."
      },
      {
        "title": "Charlotte Horseley, \"United States, Census, 1900\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSLR-MHD",
        "citation": "\"United States, Census, 1900\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MMRV-MYP : Sun Oct 19 02:37:51 UTC 2025), Entry for David Horseley and Charlotte Horseley, 1900."
      },
      {
        "title": "Charlotte Horsley, \"United States, Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSL5-1RD",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MNSJ-5FF : Wed Sep 09 15:09:18 UTC 2026), Entry for David Horsley and Charlotte Horsley, 1880."
      },
      {
        "title": "Legacy NFS Source: Charlotte White - Individual or family possessions: Family genealogies: birth-name: Charlotte Chessell White",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MS6N-8FY",
        "citation": "Paper, Family Group Sheet, Charlotte Elizabeth Mills, Individual, John McAfee Jones, 2451 East Hale Street, Mesa, Arizona, United States, 85213, 480-962-8580"
      },
      {
        "title": "Legacy NFS Source: Charlotte White -",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MS6N-8XW",
        "citation": "Ancestral File (TM), The Church of Jesus Christ of Latter-day Saints, June 1998 (c), data as of 5 JAN 1998, Family History Library, 35 N West Temple Street, Salt Lake City, UT 84150 USA"
      },
      {
        "title": "Legacy NFS Source: Charlotte White - Government record: Burial record or certificate: married-name: Charlotte Horsley",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MS6N-869",
        "citation": "Internet, Utah Death Certificate"
      },
      {
        "title": "Legacy NFS Source: Charlotte White - Individual or family possessions: Family genealogies: married-name: Charlotte Mills",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MS6N-88B",
        "citation": "Book"
      },
      {
        "title": "Legacy NFS Source: Charlotte White - death:",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MS6N-8ZV",
        "citation": "International Genealogical index, The Church of Jesus Christ of Latter-day Saints, Family History Library, 35 N. West Temple Street, Salt Lake City, Utah 84150, USA, www.familysearch.org"
      },
      {
        "title": "Legacy NFS Source: Charlotte White - Published information: Marriage record or certificate: birth-name: Annie Elmira Roberts Archer",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MS6N-8HH",
        "citation": "Microfilm, MF # 429132, Library, Family History Library, 2nd floor, Salt Lake City-, Utah, USA"
      },
      {
        "title": "James White in entry for Charlotte Chessel Horsley, \"Utah, Salt Lake County Death Records, 1908-1949\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMWY-CJS",
        "citation": "\"Utah, Salt Lake County Death Records, 1849-1949\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:NQ45-GJC : Sat Mar 09 08:22:24 UTC 2024), Entry for Charlotte Chessel Horsley and James White, 21 Aug 1926."
      }
    ],
    "portrait": "/ancestors/portraits/033_KWXS-H7K.jpg"
  },
  {
    "id": "I529",
    "name": "James White",
    "sex": "M",
    "gen": 6,
    "slot": 2,
    "side": "paternal",
    "birthplace": "england",
    "childId": "I310",
    "birthYear": 1818,
    "deathYear": 1869,
    "birthDate": "3 Apr 1818",
    "deathDate": "12 Feb 1869",
    "burialDate": "16 Feb 1869",
    "christeningDate": "21 Jun 1818",
    "birthPlace": "Clymping, Sussex, England",
    "deathPlace": "Clymping, Sussex, England",
    "burialPlace": "St. Mary the Virgin Church, Clymping, Sussex, England",
    "christeningPlace": "Yapton, Sussex, England",
    "fsId": "LKMT-79Q",
    "photo": "/ancestors/bubbles/066_LKMT-79Q.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [
      {
        "kind": "Residence",
        "date": "1861",
        "place": "Climping, Sussex, England, United Kingdom",
        "note": null
      },
      {
        "kind": "Residence",
        "date": null,
        "place": "Yapton, Sussex, England, United Kingdom",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "James White (1818–1869) | Person | Family Tree",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3P4Z-SGC",
        "citation": "\"James White (1818–1869) | Person | Family Tree.\" FamilySearch https://www.familysearch.org/tree/person/sources/LKMT-79Q. Accessed 30 Jun. 2022."
      },
      {
        "title": "James White, \"England, Sussex, Parish Registers, 1538-1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9JN3-J2X",
        "citation": "\"England, Sussex, Parish Registers, 1538-1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2QQ-XNHL : Tue Sep 08 21:34:39 UTC 2026), Entry for James White and James White, 21 Jun 1818."
      },
      {
        "title": "James White, \"England, Sussex, Parish Registers, 1538-1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3KH6-D6D",
        "citation": "\"England, Sussex, Parish Registers, 1538-1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2QW-2K8J : Tue Sep 08 21:35:29 UTC 2026), Entry for Henry Isaac Mills and Thomas Mills, 14 Aug 1869."
      },
      {
        "title": "James, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QJ1C-2NQ",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:623V-8PC8 : Sun Sep 13 05:35:44 UTC 2026), Entry for Charles W C White and Reuben R Bladell."
      },
      {
        "title": "James White, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QVCB-CKB",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6KKF-2N56 : Sun Sep 13 03:45:22 UTC 2026), Entry for Chas Wm C White and Rueben Blasdell."
      },
      {
        "title": "James White in entry for Charlotte Chissel White, \"England, Sussex, Parish Registers, 1538-1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9VM5-GPY",
        "citation": "\"England, Sussex, Parish Registers, 1538-1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2QW-2NN7 : Tue Sep 08 21:32:17 UTC 2026), Entry for Charlotte Chissel White and James White, 29 Oct 1848."
      },
      {
        "title": "James White, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9HTQ-HM4",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:J3F2-RBF : 15 September 2026), James White, 1818."
      },
      {
        "title": "James White, \"England, Sussex, Parish Registers, 1538-1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7QHH-BCH",
        "citation": "\"England, Sussex, Parish Registers, 1538-1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2QW-22JZ : Tue Sep 08 21:32:47 UTC 2026), Entry for James White, 16 Feb 1869."
      },
      {
        "title": "James White, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7XDJ-MNY",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6KVK-LK4X : Sun Sep 13 03:40:37 UTC 2026), Entry for Charlotte White Horsley and James White."
      },
      {
        "title": "James White, \"England and Wales, Census, 1861\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S9JK-4S2",
        "citation": "\"England and Wales, Census, 1861\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M71S-32F : Thu Sep 10 00:39:29 UTC 2026), Entry for James White and Martha White, 1861."
      },
      {
        "title": "James White in entry for Charles William Chessell White, \"Utah, Deaths and Burials, 1888-1946\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SVFS-W85",
        "citation": "\"Utah, Deaths and Burials, 1888-1946\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:HFBH-DXT2 : 11 June 2020), James White in entry for Charles William Chessell White, ."
      },
      {
        "title": "James White in entry for Alice Mary White Blaisdel, \"Utah, Deaths and Burials, 1888-1946\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SVFS-4YP",
        "citation": "\"Utah, Deaths and Burials, 1888-1946\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:HFY6-6CN2 : 11 June 2020), James White in entry for Alice Mary White Blaisdel, ."
      },
      {
        "title": "James White, \"England Marriages, 1538–1973\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7QF8-2MM",
        "citation": "\"England Marriages, 1538–1973\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:N66J-BSR : Sat Aug 01 18:20:28 UTC 2026), Entry for Charles William Chessell White and James White, 6 February 1875."
      },
      {
        "title": "James White in entry for Charlotte Chessell White Mills Horsley, \"Utah, Deaths and Burials, 1888-1946\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SVND-PFQ",
        "citation": "\"Utah, Deaths and Burials, 1888-1946\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:HFYN-NLZM : 11 June 2020), James White in entry for Charlotte Chessell White Mills Horsley, ."
      },
      {
        "title": "James White, \"England, Sussex, Parish Registers, 1538-1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7QF8-V8K",
        "citation": "\"England, Sussex, Parish Registers, 1538-1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KG8T-XT8 : Tue Sep 08 21:37:16 UTC 2026), Entry for Charles William Chessell White and James White, 06 Feb 1875."
      },
      {
        "title": "James White, \"England, Sussex, Parish Registers, 1538-1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9JDY-L4Y",
        "citation": "\"England, Sussex, Parish Registers, 1538-1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2QW-226N : Tue Sep 08 20:45:32 UTC 2026), Entry for Alice Mary White and James White, 01 Jul 1860."
      },
      {
        "title": "James White, \"England Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9VLB-PDC",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:NDS5-3SM : 4 February 2023), James White, 1818."
      },
      {
        "title": "James White, \"England Marriages, 1538–1973\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/91Z9-J91",
        "citation": "\"England Marriages, 1538–1973\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:N6ZN-SJJ : Sat Aug 01 17:42:22 UTC 2026), Entry for George Chessell White and James White, 8 February 1879."
      },
      {
        "title": "James White, \"England, Sussex, Parish Registers, 1538-1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9J8B-ZSN",
        "citation": "\"England, Sussex, Parish Registers, 1538-1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2QW-2VXS : Tue Sep 08 21:33:57 UTC 2026), Entry for George Che* White and James White, 02 Apr 1854."
      },
      {
        "title": "James White in entry for George Chessell White, \"England Marriages, 1538–1973\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/91Z9-JHB",
        "citation": "\"England Marriages, 1538–1973\", database, FamilySearch (https://familysearch.org/ark:/61903/1:1:NNY2-55X : 13 March 2020), James White in entry for George Chessell White, 1879."
      },
      {
        "title": "England, Select Births and Christenings, 1538-1975",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9NL5-7M6",
        "citation": ""
      },
      {
        "title": "1861 England Census",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9NL5-7MZ",
        "citation": "Class: RG 9; Piece: 615; Folio: 49; Page: 5; GSU roll: 542672"
      },
      {
        "title": "James White, \"England, Sussex, Parish Registers, 1538-1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9JZQ-VLT",
        "citation": "\"England, Sussex, Parish Registers, 1538-1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2QQ-XVTT : Tue Sep 08 21:34:47 UTC 2026), Entry for James White and Martha Chessell, 28 Jun 1846."
      },
      {
        "title": "James White, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZLW-HST",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZ25-LTY : Mon Feb 03 19:17:49 UTC 2025), Entry for Charles William Chessell White and James White, 25 Aug 1924."
      },
      {
        "title": "James White, \"England, Sussex, Parish Registers, 1538-1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9JZQ-VKS",
        "citation": "\"England, Sussex, Parish Registers, 1538-1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2QW-2LF4 : Tue Sep 08 21:32:30 UTC 2026), Entry for James White and James White, 11 Jul 1846."
      },
      {
        "title": "James White in entry for Charlotte Chapel White, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/96NG-8YX",
        "citation": "\"England, Births and Christenings, 1538-1975\", , FamilySearch (https://www.familysearch.org/ark:/61903/1:1:NBNF-6SS : 4 February 2023), James White in entry for Charlotte Chapel White, 1848."
      },
      {
        "title": "James White, \"England and Wales, Census, 1851\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9JSX-RSH",
        "citation": "\"England and Wales, Census, 1851\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:SG14-98W : Fri Aug 21 08:23:58 UTC 2026), Entry for James White and Martha White, 1851."
      },
      {
        "title": "James White, \"England, Sussex, Parish Registers, 1538-1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9JZT-GXS",
        "citation": "\"England, Sussex, Parish Registers, 1538-1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2QW-2GT7 : Tue Sep 08 21:35:29 UTC 2026), Entry for James White and Martha Chessell, 28 Jun 1846."
      },
      {
        "title": "White, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZB9-ZYH",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZLY-PJF : Mon Feb 03 19:04:35 UTC 2025), Entry for Alice Mary White Blasdell and White, 25 May 1909."
      },
      {
        "title": "James White, \"England, Sussex, Parish Registers, 1538-1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9JZQ-VRM",
        "citation": "\"England, Sussex, Parish Registers, 1538-1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2QW-2KXK : Tue Sep 08 21:30:22 UTC 2026), Entry for Susan Chessell White and James White, 30 Aug 1857."
      },
      {
        "title": "James White, \"England, Sussex, Parish Registers, 1538-1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9JZY-985",
        "citation": "\"England, Sussex, Parish Registers, 1538-1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2QW-2FRG : Tue Sep 08 21:35:21 UTC 2026), Entry for Elizabeth Chessell White and James White, 27 Jun 1847."
      },
      {
        "title": "James White, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZQ6-7FY",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZPF-7XM : Mon Feb 03 19:27:57 UTC 2025), Entry for Susan White Harmon and James White, 30 Oct 1942."
      },
      {
        "title": "James White, \"England, Sussex, Parish Registers, 1538-1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9JZT-186",
        "citation": "\"England, Sussex, Parish Registers, 1538-1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2QW-2JG3 : Tue Sep 08 20:45:32 UTC 2026), Entry for Charles William White and James White, 06 Apr 1851."
      },
      {
        "title": "James White in entry for Alice Mary White, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MD41-JCK",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:N53H-LYS : 4 February 2023), James White in entry for Alice Mary White, 1860."
      },
      {
        "title": "James White, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZQ6-7T1",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZGP-R56 : Mon Feb 03 19:19:32 UTC 2025), Entry for Charlotte Chessel Horsley and James White, 21 Aug 1926."
      },
      {
        "title": "James White in entry for Charles William White, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MQG7-QZT",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:JWXV-148 : 4 February 2023), James White in entry for Charles William White, 1851."
      },
      {
        "title": "James White in entry for Charles White, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MNR9-MMF",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:NPF7-VY4 : 5 February 2023), James White in entry for Charles White, 1851."
      },
      {
        "title": "James White in entry for George Chessel White, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9QVF-BDY",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:J796-MQH : 4 February 2023), James White in entry for George Chessel White, 1854."
      },
      {
        "title": "James White in entry for Elizabeth Chessel White, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/975F-1NB",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:N53H-LR6 : 4 February 2023), James White in entry for Elizabeth Chessel White, 1847."
      },
      {
        "title": "James White, \"England, Sussex, Parish Registers, 1538-1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9NTC-1JH",
        "citation": "\"England, Sussex, Parish Registers, 1538-1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2QQ-6ZD3 : Tue Sep 08 20:47:22 UTC 2026), Entry for Charles William Chessel White and James White, 06 Feb 1875."
      },
      {
        "title": "Legacy NFS Source: James White Jr - burial: 16 February 1869; Climping, Sussex, England, United Kingdom",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M9LS-PM7",
        "citation": "Pedigree Resource File, Family Search, Family Search, Page number: Compact Disc #103 Pin #947051"
      },
      {
        "title": "Legacy NFS Source: James White Jr -",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M9LS-G1T",
        "citation": "International Genealogical Index (R), The Church of Jesus Christ of Latter-Day Saints, The Church of Jesus Christ of Latter-Day Saints"
      },
      {
        "title": "Legacy NFS Source: James White Jr - Church record: Baptism record or certificate: birth: 3 April 1818; Yapton, Sussex, England",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M9LS-GBB",
        "citation": "Parish registers of Yapton"
      },
      {
        "title": "Legacy NFS Source: James White Jr -",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M9LS-GB2",
        "citation": "International Genealogical Index (R), The Church of Jesus Christ of Latter-day Saints, Copyright (c) 1980, 2002, data as of March 21, 2004, Family History Library, 35 N West Temple Street, Salt Lake City, Utah 84150 USA"
      },
      {
        "title": "Legacy NFS Source: James White Jr -",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M9LS-GB6",
        "citation": "Ordinance Index (TM), The Church of Jesus Christ of Latter-day Saints, 25 Jan 2000 Edition, Family History Library, 35 N. West Temple Street, Salt Lake City, UT 84150 USA"
      },
      {
        "title": "Legacy NFS Source: James White Jr - birth: 3 April 1818; Sussex, England, United Kingdom",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M9LS-GYG",
        "citation": "Ancestry.com., Source citations * South Dakota Marriages, 1905-1949, Source citations * South Dakota Marriages, 1905-1949"
      },
      {
        "title": "James White in entry for Charlotte Chessel Horsley, \"Utah, Salt Lake County Death Records, 1908-1949\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMWY-CJS",
        "citation": "\"Utah, Salt Lake County Death Records, 1849-1949\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:NQ45-GJC : Sat Mar 09 08:22:24 UTC 2024), Entry for Charlotte Chessel Horsley and James White, 21 Aug 1926."
      },
      {
        "title": "James White in entry for Susan Chessell White, \"England Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMWY-CR3",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:NRXC-2VZ : 4 February 2023), James White in entry for Susan Chessell White, 1857."
      },
      {
        "title": "James White in entry for Alice Mary White, \"England Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMWY-CRP",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:N8YB-62T : 4 February 2023), James White in entry for Alice Mary White, 1860."
      },
      {
        "title": "James White in entry for Charles William White, \"England Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMWY-CBY",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:NRXC-PY9 : 4 February 2023), James White in entry for Charles William White, 1851."
      },
      {
        "title": "James White in entry for Charlotte Chessel Horsley, \"Utah, Deaths and Burials, 1888-1946\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZQ6-77M",
        "citation": "\"Utah, Deaths and Burials, 1888-1946\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:F859-6X5 : 28 January 2020), James White in entry for Charlotte Chessel Horsley, 1926."
      },
      {
        "title": "James White, \"England Marriages, 1538–1973 \"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMWY-C5H",
        "citation": "\"England Marriages, 1538–1973\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:N2M1-BYB : Sat Aug 01 20:30:40 UTC 2026), Entry for James White and Martha Chessell, 11 July 1846."
      },
      {
        "title": "James White in entry for George Chessell White, \"England Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMWY-CTB",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:N8YB-2QW : 4 February 2023), James White in entry for George Chessell White, 1854."
      },
      {
        "title": "James White in entry for Elizabeth Chessell White, \"England Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMWY-CY5",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:N8YB-GM1 : 4 February 2023), James White in entry for Elizabeth Chessell White, 1847."
      }
    ],
    "portrait": "/ancestors/portraits/066_LKMT-79Q.jpg"
  },
  {
    "id": "I530",
    "name": "Martha Chessel",
    "sex": "F",
    "gen": 6,
    "slot": 3,
    "side": "paternal",
    "birthplace": "england",
    "childId": "I310",
    "birthYear": 1825,
    "deathYear": 1870,
    "birthDate": "13 Jan 1825",
    "deathDate": "8 Jan 1870",
    "burialDate": "12 Jan 1870",
    "christeningDate": "13 Feb 1825",
    "birthPlace": "Clymping, Sussex, England, United Kingdom",
    "deathPlace": "Clymping, Sussex, England, United Kingdom",
    "burialPlace": "Climping, Sussex, England, United Kingdom",
    "christeningPlace": "Clymping, Sussex, England, United Kingdom",
    "fsId": "LKMT-7S1",
    "photo": "/ancestors/bubbles/067_LKMT-7S1.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [
      {
        "kind": "Residence",
        "date": "1841",
        "place": "Sussex, England, United Kingdom",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1841",
        "place": "Sussex, England, United Kingdom",
        "note": "residence"
      },
      {
        "kind": "Residence",
        "date": "1861",
        "place": "Climping, Sussex, England, United Kingdom",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "England, Select Marriages, 1538–1973",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3JZJ-FG4",
        "citation": ""
      },
      {
        "title": "England, Select Births and Christenings, 1538-1975",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3JZJ-FGQ",
        "citation": ""
      },
      {
        "title": "1861 England Census",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3JZJ-FG9",
        "citation": "Class: RG 9; Piece: 615; Folio: 49; Page: 5; GSU roll: 542672"
      },
      {
        "title": "Martha Chessell in entry for Charles William Chessell White, \"Utah, Deaths and Burials, 1888-1946\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SVFS-W6X",
        "citation": "\"Utah, Deaths and Burials, 1888-1946\", database, FamilySearch (https://familysearch.org/ark:/61903/1:1:HFBH-DFMM : 11 June 2020), Martha Chessell in entry for Charles William Chessell White, ."
      },
      {
        "title": "Martha White, \"England, Deaths and Burials, 1538-1991\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SCL9-Z96",
        "citation": "\"England, Deaths and Burials, 1538-1991\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:J87S-3MP : Sat Jul 25 12:07:03 UTC 2026), Entry for Martha White, 12 Jan 1870."
      },
      {
        "title": "Martha Clessel, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7XDJ-M2X",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6KVK-LK4X : Sun Sep 13 03:40:37 UTC 2026), Entry for Charlotte White Horsley and James White."
      },
      {
        "title": "Martha Chessel in entry for Alice Mary White Blaisdel, \"Utah, Deaths and Burials, 1888-1946\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SVFS-419",
        "citation": "\"Utah, Deaths and Burials, 1888-1946\", database, FamilySearch (https://familysearch.org/ark:/61903/1:1:HFY6-6C2M : 11 June 2020), Martha Chessel in entry for Alice Mary White Blaisdel, ."
      },
      {
        "title": "Martha Chassel, \"England and Wales, Census, 1841\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SYGT-6QM",
        "citation": "\"England and Wales, Census, 1841\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M7SZ-KRF : Tue Sep 08 21:39:06 UTC 2026), Entry for William Stephens and Mary Stephens, 1841."
      },
      {
        "title": "Martha Clessel, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QVCB-CFP",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6KKF-2N56 : Sun Sep 13 03:45:22 UTC 2026), Entry for Chas Wm C White and Rueben Blasdell."
      },
      {
        "title": "Martha White in entry for Charlotte Chissel White, \"England, Sussex, Parish Registers, 1538-1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9VM5-GRR",
        "citation": "\"England, Sussex, Parish Registers, 1538-1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2QW-2NN7 : Tue Sep 08 21:32:17 UTC 2026), Entry for Charlotte Chissel White and James White, 29 Oct 1848."
      },
      {
        "title": "Martha White, \"England, Sussex, Parish Registers, 1538-1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S3PK-FWJ",
        "citation": "\"England, Sussex, Parish Registers, 1538-1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2QW-22TR : Tue Sep 08 21:33:00 UTC 2026), Entry for Martha White, 12 Jan 1870."
      },
      {
        "title": "Martha Chessell, \"England and Wales, Marriage Registration Index, 1837-2005\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3KH6-69P",
        "citation": "\"England and Wales, Marriage Registration Index, 1837-2005\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:2DHR-167 : Mon Jul 06 04:30:51 UTC 2026), Entry for Martha Chessell and James, 1846."
      },
      {
        "title": "George Chessell, \"England and Wales, Marriage Registration Index, 1837-2005\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3KH6-6PY",
        "citation": "\"England and Wales, Marriage Registration Index, 1837-2005\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:26WK-L4C : Sat Jul 04 09:31:09 UTC 2026), Entry for George Chessell and Eliza, 1846."
      },
      {
        "title": "Martha White, \"England, Sussex, Parish Registers, 1538-1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9JZY-9D1",
        "citation": "\"England, Sussex, Parish Registers, 1538-1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2QW-2FRG : Tue Sep 08 21:35:21 UTC 2026), Entry for Elizabeth Chessell White and James White, 27 Jun 1847."
      },
      {
        "title": "Martha in entry for Susan Chessell White, \"England Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9LTP-TGB",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:NRXC-2V8 : 4 February 2023), Martha in entry for Susan Chessell White, 1857."
      },
      {
        "title": "Martha Chessell in entry for Charlotte Chessell White Mills Horsley, \"Utah, Deaths and Burials, 1888-1946\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SVND-PKG",
        "citation": "\"Utah, Deaths and Burials, 1888-1946\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:HFYN-NL6Z : 11 June 2020), Martha Chessell in entry for Charlotte Chessell White Mills Horsley, ."
      },
      {
        "title": "Martha Chessell, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QJ1C-2LM",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:623V-8PC8 : Sun Sep 13 05:35:44 UTC 2026), Entry for Charles W C White and Reuben R Bladell."
      },
      {
        "title": "Martha White, \"England, Sussex, Parish Registers, 1538-1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9JDY-LZH",
        "citation": "\"England, Sussex, Parish Registers, 1538-1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2QW-226N : Tue Sep 08 20:45:32 UTC 2026), Entry for Alice Mary White and James White, 01 Jul 1860."
      },
      {
        "title": "Martha White, \"England, Sussex, Parish Registers, 1538-1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9J8B-Z3B",
        "citation": "\"England, Sussex, Parish Registers, 1538-1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2QW-2VXS : Tue Sep 08 21:33:57 UTC 2026), Entry for George Che* White and James White, 02 Apr 1854."
      },
      {
        "title": "Martha Chissel, \"England, Sussex, Parish Registers, 1538-1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9JN3-NV7",
        "citation": "\"England, Sussex, Parish Registers, 1538-1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2QW-2NHY : Tue Sep 08 20:45:34 UTC 2026), Entry for Martha Chissel and Charles Chissel, 13 Feb 1825."
      },
      {
        "title": "Martha in entry for George Chessel White, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9QVF-BD1",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:J796-MQC : 4 February 2023), Martha in entry for George Chessel White, 1854."
      },
      {
        "title": "Martha in entry for Elizabeth Chessel White, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/975F-1JM",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:N53H-LRX : 4 February 2023), Martha in entry for Elizabeth Chessel White, 1847."
      },
      {
        "title": "Mary in entry for Thomas White, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M4YN-V87",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:N5XG-F9C : 4 February 2023), Mary in entry for Thomas White, 1833."
      },
      {
        "title": "Martha Chassel, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/983X-WHT",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:NRXC-PB4 : 4 February 2023), Martha Chassel, 1825."
      },
      {
        "title": "Martha White, \"England and Wales, Census, 1851\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9JSX-RQT",
        "citation": "\"England and Wales, Census, 1851\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:SG14-98W : Fri Aug 21 08:23:58 UTC 2026), Entry for James White and Martha White, 1851."
      },
      {
        "title": "Martha Chessell, \"England, Sussex, Parish Registers, 1538-1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9JZQ-V2F",
        "citation": "\"England, Sussex, Parish Registers, 1538-1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2QW-2LF4 : Tue Sep 08 21:32:30 UTC 2026), Entry for James White and James White, 11 Jul 1846."
      },
      {
        "title": "Martha White, \"England, Sussex, Parish Registers, 1538-1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9JZT-16V",
        "citation": "\"England, Sussex, Parish Registers, 1538-1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2QW-2JG3 : Tue Sep 08 20:45:32 UTC 2026), Entry for Charles William White and James White, 06 Apr 1851."
      },
      {
        "title": "Martha in entry for Charlotte Chapel White, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/96NG-8T9",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:NBNF-6S3 : 4 February 2023), Martha in entry for Charlotte Chapel White, 1848."
      },
      {
        "title": "Martha in entry for Alice Mary White, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9NHJ-DQ7",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:N8YB-62Y : 4 February 2023), Martha in entry for Alice Mary White, 1860."
      },
      {
        "title": "Martha Chessell, \"England, Sussex, Parish Registers, 1538-1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9JZT-GKY",
        "citation": "\"England, Sussex, Parish Registers, 1538-1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2QW-2GT7 : Tue Sep 08 21:35:29 UTC 2026), Entry for James White and Martha Chessell, 28 Jun 1846."
      },
      {
        "title": "Elizabeth Chepell, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MQ9D-4M3",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:JQFX-XYX : 5 February 2023), Elizabeth Chepell, 1823."
      },
      {
        "title": "Martha White, \"England and Wales, Census, 1861\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9F75-9JL",
        "citation": "\"England and Wales, Census, 1861\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M71S-32F : Thu Sep 10 00:39:29 UTC 2026), Entry for James White and Martha White, 1861."
      },
      {
        "title": "Martha in entry for Charles White, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MNR9-MMK",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:NPF7-VYH : 5 February 2023), Martha in entry for Charles White, 1851."
      },
      {
        "title": "Elizabeth Chessell, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9MV2-2GP",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:J73V-783 : 5 February 2023), Elizabeth Chessell, 1823."
      },
      {
        "title": "Mary in entry for Elizabeth Simmons, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/93HG-PF4",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:J792-LQQ : 4 February 2023), Mary in entry for Elizabeth Simmons, 1829."
      },
      {
        "title": "Martha in entry for George Chessell White, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/983X-WKV",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:N8YB-2Q4 : 4 February 2023), Martha in entry for George Chessell White, 1854."
      },
      {
        "title": "Martha in entry for Elizabeth Chessell White, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9NHJ-4JW",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:N8YB-G9M : 4 February 2023), Martha in entry for Elizabeth Chessell White, 1847."
      },
      {
        "title": "Martha Chessell, \"England, Sussex, Parish Registers, 1538-1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9JZQ-VP8",
        "citation": "\"England, Sussex, Parish Registers, 1538-1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2QQ-XVTT : Tue Sep 08 21:34:47 UTC 2026), Entry for James White and Martha Chessell, 28 Jun 1846."
      },
      {
        "title": "Martha White, \"England, Sussex, Parish Registers, 1538-1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9JZQ-VRL",
        "citation": "\"England, Sussex, Parish Registers, 1538-1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2QW-2KXK : Tue Sep 08 21:30:22 UTC 2026), Entry for Susan Chessell White and James White, 30 Aug 1857."
      },
      {
        "title": "Martha in entry for Charles William White, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MQG7-Q8S",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:JWXV-14D : 4 February 2023), Martha in entry for Charles William White, 1851."
      },
      {
        "title": "Legacy NFS Source: Martha Chessel - birth: 13 January 1825; Sussex, England, United Kingdom",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M9WF-Q2V",
        "citation": "Ancestry.com., Source citations * South Dakota Marriages, 1905-1949, Source citations * South Dakota Marriages, 1905-1949"
      },
      {
        "title": "Legacy NFS Source: Martha Chessel - birth-name: Martha Chessell",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M9WF-Q24",
        "citation": "Pedigree Resource File, Family Search, Family Search, Page number: Disc #120 Pin #370926"
      },
      {
        "title": "Legacy NFS Source: Martha Chessel -",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M9WF-Q29",
        "citation": "International Genealogical Index (R), The Church of Jesus Christ of Latter-Day Saints, The Church of Jesus Christ of Latter-Day Saints"
      },
      {
        "title": "Legacy NFS Source: Martha Chessel - Church record: birth-name: Martha Chessel",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M9WF-QK6",
        "citation": ""
      },
      {
        "title": "Legacy NFS Source: Martha Chessel -",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M9WF-QK4",
        "citation": "International Genealogical Index (R), The Church of Jesus Christ of Latter-day Saints, Copyright (c) 1980, 2002, data as of March 21, 2004, Family History Library, 35 N West Temple Street, Salt Lake City, Utah 84150 USA"
      },
      {
        "title": "Legacy NFS Source: Martha Chessel -",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M9WF-QVY",
        "citation": "Ordinance Index (TM), The Church of Jesus Christ of Latter-day Saints, 25 Jan 2000 Edition, Family History Library, 35 N. West Temple Street, Salt Lake City, UT 84150 USA"
      },
      {
        "title": "Martha in entry for Charles William White, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSPW-6DD",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:NRXC-PYS : 4 February 2023), Martha in entry for Charles William White, 1851."
      },
      {
        "title": "Martha Chessel in entry for Charlotte Chessel Horsley, \"Utah, Deaths and Burials, 1888-1946\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZQ6-Q1H",
        "citation": "\"Utah, Deaths and Burials, 1888-1946\", database, FamilySearch (https://familysearch.org/ark:/61903/1:1:F859-6XR : 28 January 2020), Martha Chessel in entry for Charlotte Chessel Horsley, 1926."
      },
      {
        "title": "Martha Chessel, \"Utah, Salt Lake County Death Records, 1849-1949\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZLT-5XJ",
        "citation": "\"Utah, Salt Lake County Death Records, 1849-1949\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:NQ45-GJC : Sat Mar 09 08:22:24 UTC 2024), Entry for Charlotte Chessel Horsley and James White, 21 Aug 1926."
      },
      {
        "title": "Martha Chessel, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZQ6-7DZ",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZPF-7XM : Mon Feb 03 19:27:57 UTC 2025), Entry for Susan White Harmon and James White, 30 Oct 1942."
      },
      {
        "title": "Martha Chessel, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSPW-DB5",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:J36D-G4Y : 4 February 2023), Martha Chessel, 1825."
      },
      {
        "title": "Martha Chessel, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZQ6-7P5",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZGP-R56 : Mon Feb 03 19:19:32 UTC 2025), Entry for Charlotte Chessel Horsley and James White, 21 Aug 1926."
      },
      {
        "title": "Martha Chessell, \"England Marriages, 1538–1973\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSGB-YZV",
        "citation": "\"England Marriages, 1538–1973\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:N2M1-BYB : Sat Aug 01 20:30:40 UTC 2026), Entry for James White and Martha Chessell, 11 July 1846."
      },
      {
        "title": "Martha in entry for Alice Mary White, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MS2C-Z13",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:N53H-LY3 : 4 February 2023), Martha in entry for Alice Mary White, 1860."
      },
      {
        "title": "Martha Chessell, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZQD-VQX",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZ25-LTY : Mon Feb 03 19:17:49 UTC 2025), Entry for Charles William Chessell White and James White, 25 Aug 1924."
      },
      {
        "title": "Chester, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZB9-ZBH",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZLY-PJF : Mon Feb 03 19:04:35 UTC 2025), Entry for Alice Mary White Blasdell and White, 25 May 1909."
      }
    ],
    "portrait": "/ancestors/portraits/067_LKMT-7S1.jpg"
  },
  {
    "id": "I111",
    "name": "Mary E. Lehmann",
    "sex": "F",
    "gen": 4,
    "slot": 1,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "I29",
    "birthYear": 1876,
    "deathYear": 1961,
    "birthDate": "24 Mar 1876",
    "deathDate": "6 Jul 1961",
    "burialDate": "Jul 1961",
    "christeningDate": null,
    "birthPlace": "Worb, Bern, Switzerland",
    "deathPlace": "Malad, Oneida, Idaho, United States",
    "burialPlace": "Malad City Cemetery, Malad, Oneida, Idaho, United States",
    "christeningPlace": null,
    "fsId": "KWCT-QPQ",
    "photo": "/ancestors/bubbles/017_KWCT-QPQ.jpg",
    "living": false,
    "alternateNames": [
      "Marie Lehmann",
      "Maria Lehmann",
      "Mary Lehmann",
      "Maria Lehmann Mills"
    ],
    "facts": [
      {
        "kind": "Immigration",
        "date": "1881",
        "place": null,
        "note": null
      },
      {
        "kind": "Immigration",
        "date": "1882",
        "place": null,
        "note": null
      },
      {
        "kind": "Immigration",
        "date": "1895",
        "place": null,
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1900",
        "place": "Centerville Election Precinct, Davis, Utah, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1910",
        "place": "Centerville, Davis, Utah, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1920",
        "place": "Malad, Oneida, Idaho, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1930",
        "place": "Malad, Oneida, Idaho, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "2 October 1942",
        "place": "Malad, Oneida, Idaho, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Mary Layman, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/776F-B1V",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6RBF-B589 : Fri Mar 27 02:27:06 UTC 2026), Entry for Marion Mills and Henry I Mills."
      },
      {
        "title": "Mary Layman, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/776F-YL1",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6RF9-GPL4 : Fri Mar 27 01:26:08 UTC 2026), Entry for Lowell Severn Mills and David D Thomas."
      },
      {
        "title": "Mary Layman, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7QFC-JRW",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:65QT-63RQ : Thu Mar 26 19:02:26 UTC 2026), Entry for Paul Henry Mills and Henry I."
      },
      {
        "title": "Mary Lazman or Layman, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7QC6-YCQ",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6PNY-9CZR : Sun Sep 13 05:31:35 UTC 2026), Entry for Frederick Rex Mills and Henry Isaac Mills."
      },
      {
        "title": "Mary Lehman, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7QCW-RT6",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6PRJ-M1J5 : Fri Mar 27 04:01:21 UTC 2026), Entry for Melbourne Mills and Robert G Jones."
      },
      {
        "title": "Mary Layman, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q2XV-P4K",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6KJ1-ZW6Y : Sun Sep 13 04:01:56 UTC 2026), Entry for Gladys Mills and Henry Isaac Mills."
      },
      {
        "title": "Mary Layman, \"Utah, Birth Certificates, 1903-1914\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q2XF-4BQ",
        "citation": "\"Utah, Birth Certificates, 1903-1914\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QL2N-DMHG : Sun Mar 10 19:41:23 UTC 2024), Entry for and Henry Isaac Mills, 13 November 1908."
      },
      {
        "title": "Mary Layman, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QJXV-55T",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6KV6-78CC : Sun Sep 13 05:31:15 UTC 2026), Entry for Milbourne Layman Mills and Henry Isaac."
      },
      {
        "title": "Mary Layman, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QJXV-5NQ",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6KK8-WSTN : Sun Sep 13 03:42:01 UTC 2026), Entry for Marian Mills and Henry Isaac."
      },
      {
        "title": "Mary Layman, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QJXV-PYS",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6KKQ-XBG9 : Sun Sep 13 05:09:35 UTC 2026), Entry for Milbourne L Mills and Henry Isaac."
      },
      {
        "title": "Mary Layman, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QJXV-PNW",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:627C-KP2P : Fri Mar 27 00:07:03 UTC 2026), Entry for Milbourne L. Mills and Henry Isaac."
      },
      {
        "title": "Mary Layman, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QJXV-PWX",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6K2M-JVBS : Sun Sep 13 03:48:21 UTC 2026), Entry for Marian Mill and Henry Isaac Mills."
      },
      {
        "title": "Mary Layman, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QJXD-CYS",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6KKB-Z2XH : Sun Sep 13 04:00:55 UTC 2026), Entry for Frederick Rex Mills and Jos. E Williams."
      },
      {
        "title": "Mary Layman, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QJXD-CV7",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6KKN-CDJ3 : Sun Sep 13 04:01:28 UTC 2026), Entry for Frederick Rex Mills and Henry Isaac Mills."
      },
      {
        "title": "Mary Layman, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QJXD-CHJ",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6KVY-5KS1 : Sun Sep 13 05:09:16 UTC 2026), Entry for Frederick Rex Mills and Isaac Mills."
      },
      {
        "title": "Mary Layman, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QJ6R-J3S",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6K2P-GD4B : Sun Sep 13 05:24:31 UTC 2026), Entry for Lowell Serberne Mills and Henry Isaac Mills."
      },
      {
        "title": "Mary Layman, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QJ6R-NYR",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6KK8-WSTK : Sun Sep 13 05:18:26 UTC 2026), Entry for Lowell Gerberne Mills and Henry Isaac."
      },
      {
        "title": "Mary Saman, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QJ6R-NKF",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6KKF-2NPJ : Sun Sep 13 03:59:45 UTC 2026), Entry for Irene Mills and Isaac H Mills."
      },
      {
        "title": "Mary Layman, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QJ6R-MGN",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6KJ1-ZWX9 : Sun Sep 13 05:12:37 UTC 2026), Entry for Isaac Varral Mills and Henry Isaac Mills."
      },
      {
        "title": "Mary Lehman, \"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q7LF-5WN",
        "citation": "\"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6K4S-CQ4K : Wed Jul 01 14:12:42 UTC 2026), Entry for Alene Parsons and Henery I Mills."
      },
      {
        "title": "Mary Lehman, \"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q7LF-L6G",
        "citation": "\"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6KWK-637P : Tue Jun 30 23:04:29 UTC 2026), Entry for Paul Henry Mills and Henry I Mills."
      },
      {
        "title": "Mary Lehman, \"Utah, County Marriages, 1871-1941\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3RH2-ZKW",
        "citation": "\"Utah, County Marriages, 1871-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:X2BW-VL6 : Thu Sep 19 18:33:51 UTC 2024), Entry for Isaac Mills and Mary Layman, 01 Feb 1893."
      },
      {
        "title": "Mary Lehman, \"United States Western States Marriage Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3RH2-Z8R",
        "citation": "\"United States, Western States Marriage Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZZN-NV7 : Tue Feb 11 23:08:32 UTC 2025), Entry for Isaac Mills and Mary Layman, 1 Feb 1893."
      },
      {
        "title": "Mary Lehman, \"United States Western States Marriage Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3RH2-Z3P",
        "citation": "\"United States, Western States Marriage Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZVJ-72R : Tue Feb 11 22:35:41 UTC 2025), Entry for Isaac Mills and Mary Layman, 1 Feb 1893."
      },
      {
        "title": "Mrs Henry Mills, \"United States, GenealogyBank Historical Newspaper Obituaries, 1815-2013\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3KLP-4DK",
        "citation": "\"United States, GenealogyBank Historical Newspaper Obituaries, 1815-2013\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q576-GHV4 : Sun Jul 26 09:28:27 UTC 2026), Entry for Rex Mills and Mr Henry Mills, 05 Oct 1942."
      },
      {
        "title": "Lehman, \"California, Death Index, 1940-1997\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3KH2-W6X",
        "citation": "\"California, Death Index, 1940-1997\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VG5M-6VG : Tue Feb 25 16:30:17 UTC 2025), Entry for Aline Parsons and Mills, 09 Jul 1994."
      },
      {
        "title": "Mary Lehman Mills, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3WRD-6WD",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:ZP8R-S3PZ : Sun Mar 29 10:25:47 UTC 2026), Entry for Mary Lehman Mills, 1935."
      },
      {
        "title": "Mary Layman Mills, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3SJ4-57G",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:8Z8X-FM2M : Mon Mar 30 07:19:07 UTC 2026), Entry for Mary Layman Mills, 1940."
      },
      {
        "title": "Mary Lyman Mills, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3SJ4-JYP",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:ZP8R-S3W2 : Mon Mar 30 07:16:04 UTC 2026), Entry for Mary Lyman Mills, 1930."
      },
      {
        "title": "Mary Layman Mills, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3SJ4-X7P",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:ZP8C-N2N2 : Mon Mar 30 07:21:55 UTC 2026), Entry for Mary Layman Mills."
      },
      {
        "title": "Mary Mills, \"Utah, Box Elder, Brigham City Family History Center, Obituary Collection, 1930-2016\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SYLB-LLM",
        "citation": "\"Utah, Box Elder, Brigham City Family History Center, Obituary Collection, 1930-2016\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:ZTBW-ZBMM : Sat Jan 18 16:10:07 UTC 2025), Entry for Rex Frederick Mills and Lowell Mills, 1942."
      },
      {
        "title": "Maria Lahmann in entry for James H. Robertson, \"Utah, Marriages, 1887-1935\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SV65-M7P",
        "citation": "\"Utah, Marriages, 1887-1935\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:F8P7-QM1 : 28 January 2020), Maria Lahmann in entry for James H. Robertson, 1925."
      },
      {
        "title": "Marie (Mary) Lehman in entry for Irene Mills, \"Utah, Deaths and Burials, 1888-1946\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SV6P-15G",
        "citation": "\"Utah, Deaths and Burials, 1888-1946\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:HFYX-T46Z : 11 June 2020), Marie (Mary) Lehman in entry for Irene Mills, ."
      },
      {
        "title": "Marie (Mary) Lehman in entry for Mills, \"Utah, Deaths and Burials, 1888-1946\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SV6P-BDY",
        "citation": "\"Utah, Deaths and Burials, 1888-1946\", database, FamilySearch (https://familysearch.org/ark:/61903/1:1:HFYF-9J6Z : 11 June 2020), Marie (Mary) Lehman in entry for Mills, 1898."
      },
      {
        "title": "Mary Leiman, \"California, County Birth and Death Records, 1800-1994\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S446-CZG",
        "citation": "\"California, County Birth and Death Records, 1800-1994\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QPWN-PKF6 : Tue Feb 18 22:03:12 UTC 2025), Entry for Issag or Ivan Varsel Mills and Issac Mills, 17 July 1960."
      },
      {
        "title": "Mary Mills, \"United States, Census, 1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S3T6-3GL",
        "citation": "\"United States, Census, 1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M5XS-ZYQ : Wed Aug 13 17:31:32 UTC 2025), Entry for Henry S Mills and Mary Mills, 1910."
      },
      {
        "title": "Mary Lehmann Mills, \"BillionGraves Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9YCY-YMW",
        "citation": "\"BillionGraves Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:279W-XQ9 : Fri Sep 25 00:16:55 UTC 2026), Entry for Mary Lehmann Mills."
      },
      {
        "title": "Mary Lehman, \"California, County Marriages, 1849-1957\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/954H-CD7",
        "citation": "\"California, County Marriages, 1849-1957\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:K8N9-G99 : Fri Mar 08 06:29:49 UTC 2024), Entry for Ivan V Mills and A J Frances Hoffman, 15 December 1922."
      },
      {
        "title": "Leiman in entry for Issac Mills, \"California Death Index, 1940-1997\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9G19-P4Z",
        "citation": "\"California, Death Index, 1940-1997\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VPZJ-XG3 : Tue Feb 25 18:05:56 UTC 2025), Entry for Issac Mills and Leiman, 17 Jul 1960."
      },
      {
        "title": "Maria Lahmann in entry for James H. Robertson and Mariam Mills, \"Utah, County Marriages, 1887-1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9G19-LP2",
        "citation": "\"Utah, County Marriages, 1871-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KSP9-Y23 : Thu Sep 19 19:39:31 UTC 2024), Entry for James H. Robertson and Wm. A. Robertson, 12 Sep 1925."
      },
      {
        "title": "Mary L. Lechmann in entry for Milbourne Mills and Margaret Hess, \"Utah, County Marriages, 1887-1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9G19-JLF",
        "citation": "\"Utah, County Marriages, 1871-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KSP3-16G : Thu Sep 19 20:12:12 UTC 2024), Entry for Milbourne Mills and Henry Mills, 26 Dec 1928."
      },
      {
        "title": "Mary L. Lechmann in entry for Milbourne Mills and Margaret Hess, \"Utah Marriages, 1887-1935\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9G19-J8Y",
        "citation": "\"Utah, Marriages, 1887-1935\", database, FamilySearch (https://familysearch.org/ark:/61903/1:1:F8P3-6MH : 28 January 2020), Mary L. Lechmann in entry for Milbourne Mills, 1928."
      },
      {
        "title": "Mary Lehman in entry for Lowell Severn Mills and Marie Lavalleur, \"California, County Marriages, 1850-1952\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9GTH-Y24",
        "citation": "\"California, County Marriages, 1849-1957\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:K8KS-BCY : Sat Mar 09 09:51:44 UTC 2024), Entry for Lowell Severn Mills and Marie Lavalleur, 4 December 1945."
      },
      {
        "title": "Mary Lehmann Mills, \"Idaho Death Certificates, 1938-1961\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9GJV-FV9",
        "citation": "\"Idaho, Death Certificates, 1938-1961\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2M1-5F65 : Fri Feb 21 22:50:53 UTC 2025), Entry for Mary Lehmann Mills and Friederich Lehmann, 7 Jun 1961."
      },
      {
        "title": "Mary Lehmann Mills in entry for Henry Isaac Mills Jr, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9LR2-7KP",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSX-WHPH : Sat Sep 27 20:28:22 UTC 2025), Entry for Henry Isaac Mills Jr and Henry Isaac Mills, 1949."
      },
      {
        "title": "Mary Lehmann, \"BillionGraves Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9LR2-7F8",
        "citation": "\"BillionGraves Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:2HXB-GSY : Thu Sep 24 23:01:59 UTC 2026), Entry for Mary Lehmann."
      },
      {
        "title": "Mary Lehmann in entry for Fredrick Rex Mills, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9LR2-7S1",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSX-WH2G : Sat Sep 27 20:28:21 UTC 2025), Entry for Fredrick Rex Mills and Henry Isaac Mills, Jr, 1942."
      },
      {
        "title": "Mary Lehmann Mills, \"Find A Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9LR2-QBB",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVK3-NQGP : Fri Oct 02 06:23:31 UTC 2026), Entry for Mary Lehmann Mills."
      },
      {
        "title": "Mary Lehmann, \"BillionGraves Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9LR2-Q5C",
        "citation": "\"BillionGraves Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KBYN-P44 : Thu Sep 24 21:52:46 UTC 2026), Entry for Mary Lehmann."
      },
      {
        "title": "Mary Lehmann in entry for Paul Henry Mills, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9LRK-Y3B",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSX-WC7H : Sat Sep 27 20:28:25 UTC 2025), Entry for Paul Henry Mills and Henry Isaac Mills, Jr, 1989."
      },
      {
        "title": "Mary Layman, \"Utah Marriages, 1887-1935\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9LRK-TGS",
        "citation": "\"Utah, Marriages, 1887-1935\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:F8PJ-8MJ : 28 January 2020), Mary Layman in entry for Isaac Mills, 1893."
      },
      {
        "title": "Maryine Leyman in entry for Ernest L Crowton and Mariam M Robertson, \"Utah, County Marriages, 1887-1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9K9G-9LC",
        "citation": "\"Utah, County Marriages, 1871-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2MB-3VPN : Thu Sep 19 18:30:55 UTC 2024), Entry for Ernest L Crowton and William, 20 Nov 1934."
      },
      {
        "title": "Mary Lehmann in entry for Paul H Mills and Merle Stuart, \"Utah, County Marriages, 1887-1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9V5M-RVX",
        "citation": "\"Utah, County Marriages, 1871-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VRLB-WMX : Thu Sep 19 19:33:25 UTC 2024), Entry for Paul H Mills and Henry I Mills, 29 Sep 1936."
      },
      {
        "title": "Mary Lehman in entry for Lowell S Mills and Kathereen Maurine Watts, \"California, County Marriages, 1850-1952\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9V5M-FFF",
        "citation": "\"California, County Marriages, 1849-1957\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:K8JC-YXF : Sat Mar 09 12:14:51 UTC 2024), Entry for Lowell S Mills and Kathereen Maurine Watts, 8 April 1933."
      },
      {
        "title": "Mary Lehman Mills, \"Utah, Box Elder, Tremonton and Garland Obituaries, 1959-2013\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9N6H-78W",
        "citation": "\"Utah, Box Elder, Tremonton and Garland Obituaries, 1959-2013\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2QP-5J3M : Sat Mar 09 00:01:30 UTC 2024), Entry for Milbourne Lehman Mills and Bishop Myron Jones, 1975."
      },
      {
        "title": "Leiman, \"California, Death Index, 1940-1997\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9FT6-F5S",
        "citation": "\"California, Death Index, 1940-1997\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VPWT-68X : Tue Feb 25 18:26:34 UTC 2025), Entry for Ivan V Mills and Leiman, 17 Jul 1960."
      },
      {
        "title": "Mary Lehmann, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9FXH-ZV3",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSX-WCQ4 : Sat Sep 27 20:28:23 UTC 2025), Entry for Milbourne Lehmann Mills and Henry Isaac Mills, Jr, 1975."
      },
      {
        "title": "Mary Layman, \"The Church of Jesus Christ of Latter-day Saints, Missionary Registers (Worldwide), 1860-1937\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9FXH-CVR",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Missionary Registers (Worldwide), 1860-1937\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QKDW-1C9H : Tue Mar 11 16:31:45 UTC 2025), Entry for Fredrick Rex Mills and Jos E Williams, 1919."
      },
      {
        "title": "Mary Lehmann, \"Idaho, Death Certificates, 1938-1961\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9FXH-HL9",
        "citation": "\"Idaho, Death Certificates, 1938-1961\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2M1-NQNG : Fri Feb 21 22:44:07 UTC 2025), Entry for Frederick Rex Mills and Henry Isaac Mills, 10 Feb 1942."
      },
      {
        "title": "Lehman, \"California, Death Index, 1940-1997\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9X2K-YHV",
        "citation": "\"California, Death Index, 1940-1997\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VP21-QTW : Tue Feb 25 19:11:31 UTC 2025), Entry for Mariam Crowton and Mills, 12 Jul 1988."
      },
      {
        "title": "Mary Mills, \"United States, Census, 1900\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9X6Y-QQW",
        "citation": "\"United States, Census, 1900\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MMRV-ZCG : Sat Aug 01 22:21:28 UTC 2026), Entry for Isaac Mills and Mary Mills, 1900."
      },
      {
        "title": "Mary Layman, \"Utah, County Marriages, 1871-1941\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9X6Y-3DG",
        "citation": "\"Utah, County Marriages, 1871-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VRLB-5YP : Thu Sep 19 18:35:27 UTC 2024), Entry for Isaac Mills and Mary Layman, 01 Feb 1893."
      },
      {
        "title": "Mary Mills, \"United States, Census, 1920\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9X6V-B8M",
        "citation": "\"United States, Census, 1920\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MDC1-8VF : Fri Oct 02 19:04:39 UTC 2026), Entry for H I Mills and Mary Mills, 1920."
      },
      {
        "title": "Mary E Lehman, \"Utah, County Marriages, 1871-1941\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9X6V-5NH",
        "citation": "\"Utah, County Marriages, 1871-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VRLZ-ZM4 : Thu Sep 19 19:19:51 UTC 2024), Entry for Fredrick Rex Mills and Isaac Mills, 20 Nov 1923."
      },
      {
        "title": "Mary Layman, \"Utah, County Marriages, 1871-1941\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9XH3-4Y2",
        "citation": "\"Utah, County Marriages, 1871-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VRL4-GYF : Thu Sep 19 19:53:17 UTC 2024), Entry for Isaac Mills and Mary Layman, 01 Feb 1893."
      },
      {
        "title": "Mary Layman in entry for Isaac Mills, \"Utah, Marriages, 1887-1935\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9XH9-KQB",
        "citation": "\"Utah, Marriages, 1887-1935\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:F8G4-XZP : 28 January 2020), Mary Layman in entry for Isaac Mills, 1893."
      },
      {
        "title": "Mary E. Lehman in entry for Fredrick Rex Mills, \"Utah, Marriages, 1887-1935\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/96F6-YTW",
        "citation": "\"Utah, Marriages, 1887-1935\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:F8P2-QL2 : 28 January 2020), Mary E. Lehman in entry for Fredrick Rex Mills, 1923."
      },
      {
        "title": "Mary L Mills, \"United States, Census, 1930\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9D8D-XDH",
        "citation": "\"United States, Census, 1930\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XH6M-755 : Fri Oct 10 00:42:23 UTC 2025), Entry for H I Mills and Mary L Mills, 1930."
      },
      {
        "title": "Mary Lehmann Mills, \"Idaho, Southern Counties Obituaries, 1943-2013\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/98YF-R4H",
        "citation": "\"Idaho, Southern Counties Obituaries, 1943-2013\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSD-S3T9 : Thu Sep 19 20:17:31 UTC 2024), Entry for Paul Henry Mills and Henry Isaac Mills."
      },
      {
        "title": "Mary Lehmann Mills, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/98G4-4C7",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSX-WCQ3 : Sat Sep 27 20:28:23 UTC 2025), Entry for Mary Lehmann Mills and Frederick Lehmann, 1961."
      },
      {
        "title": "Headstone image of Mary Lehmann from billiongraves.com",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMHF-15V",
        "citation": "Transcription of headstone image from billiongraves.com. Image taken at Malad City Cemetery (Malad City, Oneida, Idaho, United States) on 20 August 2013"
      }
    ],
    "portrait": "/ancestors/portraits/017_KWCT-QPQ.jpg"
  },
  {
    "id": "I273",
    "name": "Friedrich Lehmann",
    "sex": "M",
    "gen": 5,
    "slot": 2,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "I111",
    "birthYear": 1840,
    "deathYear": 1899,
    "birthDate": "3 Oct 1840",
    "deathDate": "28 Mar 1899",
    "burialDate": "30 Mar 1899",
    "christeningDate": "1 Nov 1840",
    "birthPlace": "Nennigkofen, Solothurn, Schweiz",
    "deathPlace": "Salt Lake City, Salt Lake, Utah, United States",
    "burialPlace": "Taylorsville Memorial Park Cemetery, Taylorsville, Salt Lake, Utah, United States",
    "christeningPlace": "Worb, Bern, Schweiz",
    "fsId": "KWJJ-7F9",
    "photo": "/ancestors/bubbles/034_KWJJ-7F9.jpg",
    "living": false,
    "alternateNames": [
      "Frederick Lehmann",
      "Fredrich Lehmann",
      "Friederick Lehman",
      "Friederick Lehmann",
      "Friedrich Lehman",
      "Fritz Lehmann"
    ],
    "facts": [
      {
        "kind": "Baptism",
        "date": "1 November 1840",
        "place": "Worb, Bern, Switzerland",
        "note": null
      },
      {
        "kind": "Baptism",
        "date": "11 May 1879",
        "place": null,
        "note": null
      },
      {
        "kind": "Membership",
        "date": null,
        "place": "Swiss-German Mission, Central Europe, Europe",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Fredrich Lehmann, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7GML-1X9",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:62DL-JWVB : Sun Sep 13 05:26:54 UTC 2026), Entry for Fredrich Lehmann and J Spori."
      },
      {
        "title": "Friedrich Lehmann, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QPFL-2JG",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:66JV-8WVB : Wed Sep 09 01:11:49 UTC 2026), Entry for Friedrich Lehmann and Joh, 25 May 1867."
      },
      {
        "title": "Friedrich Lehmann, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QPFL-2WR",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:66JV-ZM81 : Tue Sep 08 16:36:39 UTC 2026), Entry for Friedrich Lehmann and Johannes, 25 May 1867."
      },
      {
        "title": "Friedrich Lehmann, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3KZ1-347",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:66JD-F2PZ : Tue Sep 08 21:54:56 UTC 2026), Entry for Lina Lehmann and Friedrich Lehmann, 6 Dec 1868."
      },
      {
        "title": "Friedrich Lehmann, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3KZ1-SDF",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:66J6-ZLYB : Tue Sep 08 21:52:20 UTC 2026), Entry for Friedrich Lehmann and Friedrich Lehmann, 31 Dec 1871."
      },
      {
        "title": "Friedrich Lehmann, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3N1P-51M",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:68VB-RTWD : Wed Sep 09 01:23:22 UTC 2026), Entry for Friedrich Lehmann and Johannis, 25 May 1867."
      },
      {
        "title": "Friedrich, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3NTN-W92",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:68VY-G6H5 : Tue Sep 08 23:15:33 UTC 2026), Entry for Gottfried Lehmann and Friedrich, 8 Dec 1867."
      },
      {
        "title": "Friedrich Lehmann, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/36HZ-YD1",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:68V1-HW6T : Tue Sep 08 22:46:42 UTC 2026), Entry for Friedrich Lehmann and Johannes, 25 May 1867."
      },
      {
        "title": "Friedrich Lehmann, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/36HZ-R3Z",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:68V2-PVV8 : Tue Sep 08 22:59:22 UTC 2026), Entry for Friedrich Lehmann and Johannes Lehmann, 1 Nov 1840."
      },
      {
        "title": "Friedrich Lehmann, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/36HC-23Z",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:68VL-6FQG : Tue Sep 08 23:38:05 UTC 2026), Entry for Friedrich Lehmann and Friedrich Lehmann, 23 Sep 1866."
      },
      {
        "title": "Friedrich, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/36HC-KL9",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:68VY-431V : Tue Sep 08 19:45:17 UTC 2026), Entry for Friedrich Lehmann and Friedrich, 11 Dec 1870."
      },
      {
        "title": "Friedrich Lehmann, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/36HC-JKD",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:68VR-N69W : Tue Sep 08 22:00:44 UTC 2026), Entry for Friedrich Lehmann and Friedrich Lehmann, 26 Jun 1870."
      },
      {
        "title": "Friedrich Lehmann, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/36HC-J8V",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:68VR-XW6T : Wed Sep 09 00:18:32 UTC 2026), Entry for Friedrich Lehmann and Friedrich Lehmann, 31 Dec 1871."
      },
      {
        "title": "Friedrich Lehmann, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/36HC-JMF",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:68VR-XNVY : Tue Sep 08 20:13:33 UTC 2026), Entry for Gottfried Lehmann and Friedrich Lehmann, 24 Nov 1867."
      },
      {
        "title": "Friedrich Lehmann, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3646-MN7",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:68VR-TN3Y : Tue Sep 08 21:34:10 UTC 2026), Entry for Lina Lehmann and Friedrich Lehmann, 6 Dec 1868."
      },
      {
        "title": "Friedrich Lehmann, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3677-1LC",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:68VR-6Z7S : Tue Sep 08 17:30:15 UTC 2026), Entry for Ernst Lehmann and Friedrich Lehmann, 29 Mar 1874."
      },
      {
        "title": "Switzerland, Church Records, 1277-1992; https://familysearch.org/ark:/61903/3:1:939L-LQS4-Z4?cc=1640373&wc=M598-PTL%3A125783201%2C132039801%2C125782803%2C132039802",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3HL7-XYB",
        "citation": "\"Schweiz, Kirchenbücher, 1277-1992,\" images, FamilySearch (https://familysearch.org/ark:/61903/3:1:939L-LQS4-Z4?cc=1640373&wc=M598-PTL%3A125783201%2C132039801%2C125782803%2C132039802 : 22 May 2014), Bern > Thun > Evangelisch-Reformierte > Heiraten, Tote 1729-1875 > image 373 of 563; Staatsarchiven von Basel-Stadt, Bern und Schaffhausen, Schweiz (Basel-Stadt, Bern, and Schaffhausen State Archives, Switzerland)."
      },
      {
        "title": "Friedrich Lehmann in entry for Friedrich Lehmann, \"Switzerland, Baptisms, 1491-1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SXLC-B9T",
        "citation": "\"Schweiz Taufen, 1491-1940\", , FamilySearch (https://www.familysearch.org/ark:/61903/1:1:FVDC-T4B : 22 September 2026), Friedrich Lehmann in entry for Friedrich Lehmann, 1866."
      },
      {
        "title": "Friedrich Lehmann in entry for Friedrich Lehmann, \"Switzerland, Baptisms, 1491-1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/95WG-Y9G",
        "citation": "\"Schweiz Taufen, 1491-1940\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:FVD2-722 : 22 September 2026), Friedrich Lehmann in entry for Friedrich Lehmann, 1866."
      },
      {
        "title": "Frederick Lehmann in entry for Mary Lehmann Mills, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9GJK-SPH",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSX-WCQ3 : Sat Sep 27 20:28:23 UTC 2025), Entry for Mary Lehmann Mills and Frederick Lehmann, 1961."
      },
      {
        "title": "Friederich Lehmann in entry for Mary Lehmann Mills, \"Idaho Death Certificates, 1938-1961\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9GJV-F51",
        "citation": "\"Idaho, Death Certificates, 1938-1961\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2M1-5F65 : Fri Feb 21 22:50:53 UTC 2025), Entry for Mary Lehmann Mills and Friederich Lehmann, 7 Jun 1961."
      },
      {
        "title": "Friedrich Lehmann, \"Find A Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9VTG-Q2Z",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVKH-RNPR : Fri Oct 02 22:35:18 UTC 2026), Entry for Friedrich Lehmann."
      },
      {
        "title": "Friedrich Lehmann, \"BillionGraves Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9VTG-SCT",
        "citation": "\"BillionGraves Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VT7Z-L4R : Thu Sep 24 19:16:24 UTC 2026), Entry for Friedrich Lehmann and ."
      },
      {
        "title": "Frederick Lahmann in entry for Gus Aristidis Theodoll and Emma Bertha Mauchle, \"Montana, County Marriages, 1865-1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9VCZ-D1N",
        "citation": "\"Montana, County Marriages, 1865-1950\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:F343-VB9 : Thu Jan 09 14:57:45 UTC 2025), Entry for Gus Aristidis Theodoll and Aristidis Theodoll, 16 Jun 1927."
      },
      {
        "title": "Frederick Lahmann in entry for Gus Aristidis Theodoll and Emma Bertha Mauchle, \"Montana Marriages, 1889-1947\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9VHP-F4H",
        "citation": "\"Montana, Marriages, 1889-1947\", database, FamilySearch (https://familysearch.org/ark:/61903/1:1:FZSY-Y92 : 18 January 2020), Frederick Lahmann in entry for Gus Aristidis Theodoll, 1927."
      },
      {
        "title": "Frederick Lahmann, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9629-6VB",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QKDV-HCJV : Mon Jan 13 14:57:10 UTC 2025), Entry for Emma Bertha Lahmann Thepdoll or Theodoracopoulos and Frederick Lahmann, 27 Apr 1958."
      },
      {
        "title": "Fredrick Lahmann, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9D9F-9L4",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZGP-26G : Mon Feb 03 19:19:38 UTC 2025), Entry for Anna Barba Lahmann and Jacob Berger, 07 May 1926."
      },
      {
        "title": "Frederick Lehmann, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/98JN-Y5H",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZP9-ZCG : Mon Feb 03 19:24:41 UTC 2025), Entry for Ernest Lehmann and Frederick Lehmann, 10 Aug 1933."
      },
      {
        "title": "Jhannes Lehman, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSPW-FZM",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZPW-DPL : Mon Feb 03 19:26:15 UTC 2025), Entry for Eliza Matilda Kohler and Jhannes Lehman, 12 Mar 1936."
      },
      {
        "title": "Headstone image of Friedrich Lehmann from billiongraves.com",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M97V-8CP",
        "citation": "Transcription of headstone image from billiongraves.com. Image taken at Taylorsville Memorial Park Cemetery (Taylorsville, Salt Lake, Utah, United States) on 19 September 2011"
      }
    ],
    "portrait": "/ancestors/portraits/034_KWJJ-7F9.jpg"
  },
  {
    "id": "I505",
    "name": "Johannes Lehmann",
    "sex": "M",
    "gen": 6,
    "slot": 4,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "I273",
    "birthYear": 1802,
    "deathYear": 1872,
    "birthDate": "11 Jul 1802",
    "deathDate": "26 Nov 1872",
    "burialDate": "29 Nov 1872",
    "christeningDate": "11 Jul 1802",
    "birthPlace": "Worb, Bern, Switzerland",
    "deathPlace": "Steinbach Belp, Bern, Switzerland",
    "burialPlace": "Belp, Bern, Switzerland",
    "christeningPlace": "Worb, Bern, Switzerland",
    "fsId": "LZVL-12R",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Johannas Lehmann"
    ],
    "facts": [
      {
        "kind": "Baptism",
        "date": "11 July 1802",
        "place": "Worb, Bern, Switzerland",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Johann, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3KR8-2DB",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:66JV-2LKC : Mon Jan 20 14:37:09 UTC 2025), Entry for Christoph Lehmann and Johann, 24 Jun 1865."
      },
      {
        "title": "Joh, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3RDR-GP5",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:66JV-J4C9 : Tue Sep 08 23:49:12 UTC 2026), Entry for Franz Christian Alexander Sigen and Chr, 1870."
      },
      {
        "title": "Johannes Lehmann, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3KRZ-51D",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:66JV-XMDH : Wed Sep 09 01:13:33 UTC 2026), Entry for Johannes Lehmann and Christen, 7 Oct 1825."
      },
      {
        "title": "Joh, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3KR8-783",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:66JJ-Q9R5 : Tue Sep 08 18:27:20 UTC 2026), Entry for Rudolf Abraham Lehmann and Joh, 3 Mar 1833."
      },
      {
        "title": "Joh, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3KR8-4KG",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:66JV-NYKG : Tue Sep 08 20:56:01 UTC 2026), Entry for Christian Lehmann and Joh, 16 Mar 1861."
      },
      {
        "title": "Joh, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3KR8-ZW7",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:66JV-D7LW : Tue Sep 08 23:04:38 UTC 2026), Entry for Johannes Lehmann and Joh, 11 Dec 1857."
      },
      {
        "title": "Johannes Lehmann, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3KR8-MNQ",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:66J6-6H3Q : Tue Sep 08 22:27:19 UTC 2026), Entry for Christian Lehmann and Johannes Lehmann, 19 Mar 1826."
      },
      {
        "title": "Joh, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3KR8-JYQ",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:66JV-N7FN : Wed Sep 09 01:15:10 UTC 2026), Entry for Christoph Lehmann and Joh, 24 Jun 1865."
      },
      {
        "title": "Johanns, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7QF8-G84",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:68VB-3191 : Tue Sep 08 19:51:05 UTC 2026), Entry for Christian Lehmann and Johanns, 16 Mar 1861."
      },
      {
        "title": "Johann, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7GMG-6NW",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:68VB-7LWK : Wed Sep 09 00:23:00 UTC 2026), Entry for Johannes Lehmann and Johann, 11 Dec 1857."
      },
      {
        "title": "Johannes, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3KRZ-YGG",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:68VY-L5QK : Wed Aug 19 05:26:17 UTC 2026), Entry for Elisabeth Lehmann Maurer and Johannes, 28 Jun 1862."
      },
      {
        "title": "Johann Lehmann, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3KRZ-BL1",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:66JN-QG81 : Fri Jul 05 23:14:11 UTC 2024), Entry for Johann Lehmann and Elis, 29 Nov 1872."
      },
      {
        "title": "Joh, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3KRD-M7J",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:66JV-8F2F : Wed Sep 09 01:22:49 UTC 2026), Entry for Johannes Schmid and Peter, 28 Oct 1865."
      },
      {
        "title": "Johannes Lehmann, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3X7L-BZF",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:68VR-VZ3X : Tue Sep 08 19:51:49 UTC 2026), Entry for Christian Lehmann and Johannes Lehmann, 19 Mar 1826."
      },
      {
        "title": "Johannes Leeman, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3KR8-QT9",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:66JF-96F8 : Tue Sep 08 22:36:26 UTC 2026), Entry for Johannes Leeman and Christen Leeman, 11 Jul 1802."
      },
      {
        "title": "Johann, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3TXQ-CXC",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6FZP-W2D7 : Tue Sep 08 22:34:27 UTC 2026), Entry for Christian Lehmann and Johann, 16 Mar 1861."
      },
      {
        "title": "Joh Lehmann, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3KR8-3J1",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:68V1-9VHD : Wed Sep 09 01:28:01 UTC 2026), Entry for Joh Lehmann and Christ, 1825."
      },
      {
        "title": "Joh, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3KRD-9MV",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:66JJ-DKGY : Tue Sep 08 21:40:11 UTC 2026), Entry for Johann Schmied and Peter, 28 Oct 1865."
      },
      {
        "title": "Joh, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QPFL-TM5",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:66JV-8WVB : Wed Sep 09 01:11:49 UTC 2026), Entry for Friedrich Lehmann and Joh, 25 May 1867."
      },
      {
        "title": "Johannes, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7QF8-GSN",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:66JV-ZM81 : Tue Sep 08 16:36:39 UTC 2026), Entry for Friedrich Lehmann and Johannes, 25 May 1867."
      },
      {
        "title": "Johannes and Elisabeth's marriage record, with birth information on it too.",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9RCQ-LHM",
        "citation": "Switzerland, Church Records, 1277-1992"
      },
      {
        "title": "Johannes Lehmann in entry for Friedrich Lehmann, \"Switzerland, Baptisms, 1491-1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/36HZ-RC1",
        "citation": "\"Schweiz Taufen, 1491-1940\", , FamilySearch (https://www.familysearch.org/ark:/61903/1:1:HTX4-QQPZ : 22 September 2026), Johannes Lehmann in entry for Friedrich Lehmann, 1866."
      },
      {
        "title": "Johannis, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/36HZ-YHG",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:68VB-RTWD : Wed Sep 09 01:23:22 UTC 2026), Entry for Friedrich Lehmann and Johannis, 25 May 1867."
      },
      {
        "title": "Johannes, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/36HZ-Y6F",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:68V1-HW6T : Tue Sep 08 22:46:42 UTC 2026), Entry for Friedrich Lehmann and Johannes, 25 May 1867."
      },
      {
        "title": "Johannes, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/36LR-G5F",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:68V1-DSZM : Tue Sep 08 22:43:38 UTC 2026), Entry for Christoph Lehmann and Johannes, 1865."
      },
      {
        "title": "Johannes, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3657-9P8",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:68V1-67QB : Wed Sep 09 00:52:53 UTC 2026), Entry for Johannes Schmid and Peter, 1865."
      },
      {
        "title": "Johannes Lehmann, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/36TM-2Z1",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:68VT-6YTS : Tue Sep 08 23:09:45 UTC 2026), Entry for Elisabeth Lehmann and Johannes Lehmann, 17 Nov 1833."
      },
      {
        "title": "Johannes Lehmann, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/36GP-BLH",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:68VB-DSNP : Wed Sep 09 00:35:07 UTC 2026), Entry for Johannes Lehmann and Elisabeth Maurer, 5 Oct 1825."
      },
      {
        "title": "Switzerland, Church Records, 1277-1992; https://familysearch.org/ark:/61903/3:1:939L-GJZC-X?cc=1640373&wc=M59N-DPV%3A125783201%2C126507301%2C125782803%2C126651101",
        "href": "https://www.familysearch.org/tree/sources/viewedit/388T-LFJ",
        "citation": "\"Schweiz, Kirchenbücher, 1277-1992,\" images, FamilySearch (https://familysearch.org/ark:/61903/3:1:939L-GJZC-X?cc=1640373&wc=M59N-DPV%3A125783201%2C126507301%2C125782803%2C126651101 : 22 May 2014), Bern > Belp > Evangelisch-Reformierte > Toten, Index 1863-1875 > image 39 of 84; Staatsarchiven von Basel-Stadt, Bern und Schaffhausen, Schweiz (Basel-Stadt, Bern, and Schaffhausen State Archives, Switzerland)."
      },
      {
        "title": "Johannes Lehmann, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/36ZQ-5GT",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:68VL-WY3G : Tue Sep 08 22:52:55 UTC 2026), Entry for Rosina Lehmann and Johannes Lehmann, 15 Feb 1846."
      },
      {
        "title": "Johannes Lehmann, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/36GP-GJ1",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:68V1-QM4F : Tue Sep 08 21:12:41 UTC 2026), Entry for Johannes Lehmann and Christian, 7 Oct 1825."
      },
      {
        "title": "Johann Lehmann in entry for Friedrich Lehmann, \"Germany, Births and Baptisms, 1558-1898\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SP9P-5ZW",
        "citation": "\"Deutschland Geburten und Taufen, 1558-1898\", database, FamilySearch (https://familysearch.org/ark:/61903/1:1:C3BT-GMMM : 2 December 2025), Johann Lehmann in entry for Friedrich Lehmann, 1862."
      },
      {
        "title": "Johannes Lehmann, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/36HZ-RQW",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:68V2-PVV8 : Tue Sep 08 22:59:22 UTC 2026), Entry for Friedrich Lehmann and Johannes Lehmann, 1 Nov 1840."
      },
      {
        "title": "Johann, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/36LR-GVW",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:68VY-65PB : Tue Sep 08 17:45:02 UTC 2026), Entry for Christoph Lehmann and Johann, 24 Jun 1865."
      },
      {
        "title": "Johann Lehmann, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/36GP-GBN",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:68VY-L3M6 : Wed Aug 19 04:59:48 UTC 2026), Entry for Johann Lehmann and Elisab Maurer, 29 Nov 1872."
      },
      {
        "title": "Johannes Lehmann, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/36GP-RRT",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:68VL-8ZXS : Tue Sep 08 19:26:10 UTC 2026), Entry for Johannes Lehmann and Johannes Lehmann, 20 Apr 1828."
      },
      {
        "title": "Johannes Lehmann, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/36GP-YLF",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:68VL-X279 : Tue Sep 08 19:04:37 UTC 2026), Entry for Anna Lehmann and Johannes Lehmann, 21 Oct 1838."
      },
      {
        "title": "Johannes Lehmann, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/36GP-TT7",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:68VL-NFD2 : Tue Sep 08 19:40:11 UTC 2026), Entry for Rudolf Abraham Lehmann and Johannes Lehmann, 7 Aug 1831."
      },
      {
        "title": "Johann, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3657-9S7",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:68VB-SVT5 : Tue Sep 08 19:08:52 UTC 2026), Entry for Johannes Schmied and Peter, 28 Oct 1865."
      },
      {
        "title": "Johannes Lehmann, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/36GP-PCL",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:68VL-X2QK : Wed Sep 09 00:21:07 UTC 2026), Entry for Christoph Lehmann and Johannes Lehmann, 17 Jul 1836."
      }
    ]
  },
  {
    "id": "I500",
    "name": "Elisabetha Maurer",
    "sex": "F",
    "gen": 6,
    "slot": 5,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "I273",
    "birthYear": 1804,
    "deathYear": 1862,
    "birthDate": "3 Dec 1804",
    "deathDate": "26 Jun 1862",
    "burialDate": "28 Jun 1862",
    "christeningDate": "16 Dec 1804",
    "birthPlace": "Niederwichtrach, Bern, Switzerland",
    "deathPlace": "Bern, Switzerland",
    "burialPlace": "Belp, Bern, Schweiz",
    "christeningPlace": "Bern, Switzerland",
    "fsId": "LLM9-NZ4",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Elisabetha Mauer",
      "Elisabeth Maurer"
    ],
    "facts": [
      {
        "kind": "Baptism",
        "date": "16 December 1804",
        "place": "Münsingen, Bern, Switzerland",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Elisabeth Maumer, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/36ZQ-5R5",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:68VL-WY3G : Tue Sep 08 22:52:55 UTC 2026), Entry for Rosina Lehmann and Johannes Lehmann, 15 Feb 1846."
      },
      {
        "title": "Elisabeth Maurer, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/36GP-GGK",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:68V1-QM4F : Tue Sep 08 21:12:41 UTC 2026), Entry for Johannes Lehmann and Christian, 7 Oct 1825."
      },
      {
        "title": "Elisabeth Maurer, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/36GP-TYH",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:68VL-NFD2 : Tue Sep 08 19:40:11 UTC 2026), Entry for Rudolf Abraham Lehmann and Johannes Lehmann, 7 Aug 1831."
      },
      {
        "title": "Elisabeth Maurer, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/36GP-B5M",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:68VB-DSNP : Wed Sep 09 00:35:07 UTC 2026), Entry for Johannes Lehmann and Elisabeth Maurer, 5 Oct 1825."
      },
      {
        "title": "Elisabeth Maurer, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3KRZ-526",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:66JV-XMDH : Wed Sep 09 01:13:33 UTC 2026), Entry for Johannes Lehmann and Christen, 7 Oct 1825."
      },
      {
        "title": "Elisabeth Maurer, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3KR8-M63",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:66J6-6H3Q : Tue Sep 08 22:27:19 UTC 2026), Entry for Christian Lehmann and Johannes Lehmann, 19 Mar 1826."
      },
      {
        "title": "Elisab Maurer, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/36GP-G1J",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:68VY-L3M6 : Wed Aug 19 04:59:48 UTC 2026), Entry for Johann Lehmann and Elisab Maurer, 29 Nov 1872."
      },
      {
        "title": "Elisabeth Maurer, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/36GP-RYN",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:68VL-8ZXS : Tue Sep 08 19:26:10 UTC 2026), Entry for Johannes Lehmann and Johannes Lehmann, 20 Apr 1828."
      },
      {
        "title": "Elisabeth, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/36TM-WZ9",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:68VR-856H : Wed Sep 09 00:34:02 UTC 2026), Entry for Elisabeth and Hanss Maurer, 16 Dec 1804."
      },
      {
        "title": "Elisabeth Maurer, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/36GP-P89",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:68VL-X2QK : Wed Sep 09 00:21:07 UTC 2026), Entry for Christoph Lehmann and Johannes Lehmann, 17 Jul 1836."
      },
      {
        "title": "Elisabeth Maurer, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/36TM-7ZC",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:68VG-G8FW : Tue Sep 08 19:50:41 UTC 2026), Entry for Elisabeth Maurer and Hans Maurer, 16 Dec 1804."
      },
      {
        "title": "Elisabeth Maurer, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/36TM-28Y",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:68VT-6YTS : Tue Sep 08 23:09:45 UTC 2026), Entry for Elisabeth Lehmann and Johannes Lehmann, 17 Nov 1833."
      },
      {
        "title": "Elisabeth Lehmann Maurer, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3KRZ-YNF",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:68VY-L5QK : Wed Aug 19 05:26:17 UTC 2026), Entry for Elisabeth Lehmann Maurer and Johannes, 28 Jun 1862."
      },
      {
        "title": "Elisabeth Maurer, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3RDR-G5L",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:66JV-J4C9 : Tue Sep 08 23:49:12 UTC 2026), Entry for Franz Christian Alexander Sigen and Chr, 1870."
      },
      {
        "title": "Elisabeth Maurer, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/36GP-YG1",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:68VL-X279 : Tue Sep 08 19:04:37 UTC 2026), Entry for Anna Lehmann and Johannes Lehmann, 21 Oct 1838."
      },
      {
        "title": "Elisabeth Maurer, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/36HZ-RQG",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:68V2-PVV8 : Tue Sep 08 22:59:22 UTC 2026), Entry for Friedrich Lehmann and Johannes Lehmann, 1 Nov 1840."
      },
      {
        "title": "Elisab Maurer, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3X7L-BZB",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:68VR-VZ3X : Tue Sep 08 19:51:49 UTC 2026), Entry for Christian Lehmann and Johannes Lehmann, 19 Mar 1826."
      },
      {
        "title": "Elis, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3KRZ-B6B",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:66JN-QG81 : Fri Jul 05 23:14:11 UTC 2024), Entry for Johann Lehmann and Elis, 29 Nov 1872."
      },
      {
        "title": "Elisabeth Lehman Maurer, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3KR8-9HF",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:66JN-QGZH : Sun Jan 19 17:42:03 UTC 2025), Entry for Elisabeth Lehman Maurer, 28 Jun 1862."
      },
      {
        "title": "Elisab Maurer, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3KR8-QQ9",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:68V1-9VHD : Wed Sep 09 01:28:01 UTC 2026), Entry for Joh Lehmann and Christ, 1825."
      },
      {
        "title": "Elisabeth Mauwer in entry for Friedrich Lehmann, \"Germany, Births and Baptisms, 1558-1898\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SP9P-583",
        "citation": "\"Deutschland Geburten und Taufen, 1558-1898\", database, FamilySearch (https://familysearch.org/ark:/61903/1:1:C3BT-GM3Z : 2 December 2025), Elisabeth Mauwer in entry for Friedrich Lehmann, 1862."
      }
    ]
  },
  {
    "id": "I272",
    "name": "Magdalena Mattie Jacob",
    "sex": "F",
    "gen": 5,
    "slot": 3,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "I111",
    "birthYear": 1848,
    "deathYear": 1882,
    "birthDate": "25 Sep 1848",
    "deathDate": "14 Oct 1882",
    "burialDate": "1882",
    "christeningDate": "13 Oct 1848",
    "birthPlace": "Lauperswil, Bern, Switzerland",
    "deathPlace": "Midway, Wasatch, Utah, United States",
    "burialPlace": ", Midway, Wasatch, Utah",
    "christeningPlace": "Lauperswil, Bern, Switzerland",
    "fsId": "2WM6-SJB",
    "photo": "/ancestors/bubbles/035_2WM6-SJB.jpg",
    "living": false,
    "alternateNames": [
      "Magdalena Jacob",
      "Magdalena Jakob",
      "Madlena Jacob",
      "Magdalena Lehmann Jacob",
      "Leni Jacob"
    ],
    "facts": [
      {
        "kind": "Baptism",
        "date": "13 October 1848",
        "place": "Lauperswil, Bern, Switzerland",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1880",
        "place": "Washington Township, Nemaha, Kansas, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Magdalena Jakob, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QPT1-T9G",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:66JV-8WVB : Wed Sep 09 01:11:49 UTC 2026), Entry for Friedrich Lehmann and Joh, 25 May 1867."
      },
      {
        "title": "Magdalena Jakob, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QPFL-K7P",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:66JV-ZM81 : Tue Sep 08 16:36:39 UTC 2026), Entry for Friedrich Lehmann and Johannes, 25 May 1867."
      },
      {
        "title": "Magdalena Jakob, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3KLP-6KF",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:66JF-K7RH : Wed Sep 09 00:05:59 UTC 2026), Entry for Magdalena Jakob and Ulrich Jakob, 13 Oct 1848."
      },
      {
        "title": "Magdalena Jakob, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3KJ8-7GB",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:68VY-G6H5 : Tue Sep 08 23:15:33 UTC 2026), Entry for Gottfried Lehmann and Friedrich, 8 Dec 1867."
      },
      {
        "title": "Magd Jakob, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3KZ1-3N8",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:66JD-F2PZ : Tue Sep 08 21:54:56 UTC 2026), Entry for Lina Lehmann and Friedrich Lehmann, 6 Dec 1868."
      },
      {
        "title": "Magd Jakob, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3KZ1-STJ",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:66J6-ZLYB : Tue Sep 08 21:52:20 UTC 2026), Entry for Friedrich Lehmann and Friedrich Lehmann, 31 Dec 1871."
      },
      {
        "title": "Magdalena Jakob, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3N1P-RKB",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:68VB-RTWD : Wed Sep 09 01:23:22 UTC 2026), Entry for Friedrich Lehmann and Johannis, 25 May 1867."
      },
      {
        "title": "Magdalena Jacob, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3NTN-7N7",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:68V1-HW6T : Tue Sep 08 22:46:42 UTC 2026), Entry for Friedrich Lehmann and Johannes, 25 May 1867."
      },
      {
        "title": "Magdalena Lehmann, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/36HC-294",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:68VL-6FQG : Tue Sep 08 23:38:05 UTC 2026), Entry for Friedrich Lehmann and Friedrich Lehmann, 23 Sep 1866."
      },
      {
        "title": "Magdl Jakob, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/36HC-KJN",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:68VY-431V : Tue Sep 08 19:45:17 UTC 2026), Entry for Friedrich Lehmann and Friedrich, 11 Dec 1870."
      },
      {
        "title": "Magdalena Jakob, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/36HC-JVR",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:68VR-N69W : Tue Sep 08 22:00:44 UTC 2026), Entry for Friedrich Lehmann and Friedrich Lehmann, 26 Jun 1870."
      },
      {
        "title": "Magdalena Jakob, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/36HC-JZ2",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:68VR-XW6T : Wed Sep 09 00:18:32 UTC 2026), Entry for Friedrich Lehmann and Friedrich Lehmann, 31 Dec 1871."
      },
      {
        "title": "Magdalena Jakob, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/36HC-NGV",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:68VR-XNVY : Tue Sep 08 20:13:33 UTC 2026), Entry for Gottfried Lehmann and Friedrich Lehmann, 24 Nov 1867."
      },
      {
        "title": "Magdalena Jakob, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3646-MNL",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:68VR-TN3Y : Tue Sep 08 21:34:10 UTC 2026), Entry for Lina Lehmann and Friedrich Lehmann, 6 Dec 1868."
      },
      {
        "title": "Magdalena Jakob, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3677-1LT",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:68VR-6Z7S : Tue Sep 08 17:30:15 UTC 2026), Entry for Ernst Lehmann and Friedrich Lehmann, 29 Mar 1874."
      },
      {
        "title": "Switzerland, Church Records, 1277-1992; https://familysearch.org/ark:/61903/3:1:939L-LQS4-Z4?cc=1640373&wc=M598-PTL%3A125783201%2C132039801%2C125782803%2C132039802",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3HL7-XYB",
        "citation": "\"Schweiz, Kirchenbücher, 1277-1992,\" images, FamilySearch (https://familysearch.org/ark:/61903/3:1:939L-LQS4-Z4?cc=1640373&wc=M598-PTL%3A125783201%2C132039801%2C125782803%2C132039802 : 22 May 2014), Bern > Thun > Evangelisch-Reformierte > Heiraten, Tote 1729-1875 > image 373 of 563; Staatsarchiven von Basel-Stadt, Bern und Schaffhausen, Schweiz (Basel-Stadt, Bern, and Schaffhausen State Archives, Switzerland)."
      },
      {
        "title": "Magdalena Lehmann, \"Utah, FamilySearch, Early Church Information File, 1830-1900\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SL82-W2G",
        "citation": "\"Utah, FamilySearch, Early Church Information File, 1830-1900\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QPH7-J55R : Wed Jan 21 15:41:46 UTC 2026), Entry for Magdalena Lehmann, 1882."
      },
      {
        "title": "Magdalena Lehmann in entry for Friedrich Lehmann, \"Switzerland, Baptisms, 1491-1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SXLC-YBF",
        "citation": "\"Schweiz Taufen, 1491-1940\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:FVDC-T41 : 22 September 2026), Magdalena Lehmann in entry for Friedrich Lehmann, 1866."
      },
      {
        "title": "Magdalena Lehmann in entry for Friedrich Lehmann, \"Switzerland, Baptisms, 1491-1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/95WG-YSR",
        "citation": "\"Schweiz Taufen, 1491-1940\", , FamilySearch (https://www.familysearch.org/ark:/61903/1:1:FVD2-72L : 22 September 2026), Magdalena Lehmann in entry for Friedrich Lehmann, 1866."
      },
      {
        "title": "Magdalena Jakob in entry for Mary Lehmann Mills, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9GJK-SRD",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSX-WCQ3 : Sat Sep 27 20:28:23 UTC 2025), Entry for Mary Lehmann Mills and Frederick Lehmann, 1961."
      },
      {
        "title": "Magdalene Jacobs in entry for Mary Lehmann Mills, \"Idaho Death Certificates, 1938-1961\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9GJV-FGH",
        "citation": "\"Idaho, Death Certificates, 1938-1961\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2M1-5F65 : Fri Feb 21 22:50:53 UTC 2025), Entry for Mary Lehmann Mills and Friederich Lehmann, 7 Jun 1961."
      },
      {
        "title": "Jacobson in entry for Louise Papineau, \"California Death Index, 1940-1997\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9VT5-79K",
        "citation": "\"California, Death Index, 1940-1997\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VP4V-N94 : Tue Feb 25 17:41:26 UTC 2025), Entry for Louise Papineau and Jacobson, 23 Sep 1965."
      },
      {
        "title": "in entry for Friedrich Lehmann, \"BillionGraves Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9VTG-SXQ",
        "citation": "\"BillionGraves Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VT7Z-L4R : Thu Sep 24 19:16:24 UTC 2026), Entry for Friedrich Lehmann and ."
      },
      {
        "title": "Magdalena Jakob in the Millennium File",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9JSZ-QJF",
        "citation": "\"Magdalena Jakob in the Millennium File.\" Magdalena Jakob in the Millennium File. N.p., n.d. Web. 25 Nov. 2016. ."
      },
      {
        "title": "Magdalena Jakob Lehmann, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/963M-SJM",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVKH-5JW7 : Sun Oct 04 03:54:19 UTC 2026), Entry for Magdalena Jakob Lehmann."
      },
      {
        "title": "Magdalena J Lehmann, \"BillionGraves Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9D47-PLC",
        "citation": "\"BillionGraves Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VT7Y-D3H : Fri Sep 25 00:48:08 UTC 2026), Entry for Magdalena J Lehmann."
      },
      {
        "title": "Magdalena Jakob, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/98JN-YVK",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZP9-ZCG : Mon Feb 03 19:24:41 UTC 2025), Entry for Ernest Lehmann and Frederick Lehmann, 10 Aug 1933."
      },
      {
        "title": "Grave marker Photo, Midway Cemetery",
        "href": "https://www.familysearch.org/tree/sources/viewedit/98CK-48T",
        "citation": "Midway Cemetery , Wasatch County, Utah"
      },
      {
        "title": "Magdelena Jacobs, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSPW-FHY",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZPW-DPL : Mon Feb 03 19:26:15 UTC 2025), Entry for Eliza Matilda Kohler and Jhannes Lehman, 12 Mar 1936."
      }
    ],
    "portrait": "/ancestors/portraits/035_2WM6-SJB.jpg"
  },
  {
    "id": "I499",
    "name": "John Krebs",
    "sex": "M",
    "gen": 6,
    "slot": 6,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "I272",
    "birthYear": 1822,
    "deathYear": 1908,
    "birthDate": "5 Apr 1822",
    "deathDate": "12 Aug 1908",
    "burialDate": "15 Aug 1908",
    "christeningDate": "14 Apr 1822",
    "birthPlace": "Kirchdorf, Bern,, Switzerland",
    "deathPlace": "Midway, Wasatch, Utah, United States",
    "burialPlace": "Midway, Wasatch, Utah, United States",
    "christeningPlace": "Kirchdorf, Bern, Switzerland",
    "fsId": "KWJN-RHQ",
    "photo": "/ancestors/bubbles/070_KWJN-RHQ.jpg",
    "living": false,
    "alternateNames": [
      "Johannes",
      "Johannas Krebs",
      "Johannes Krebs",
      "Hans Krebs"
    ],
    "facts": [
      {
        "kind": "Immigration",
        "date": "1866",
        "place": null,
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1880",
        "place": "Richfield, Sevier, Utah, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1900",
        "place": "Midway, Wasatch, Utah, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Headstone image of John Krebs from billiongraves.com",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9Z5M-RH3",
        "citation": "Transcription of headstone image from billiongraves.com. Image taken at Midway City Cemetery (Midway, Utah, United States) on 04 July 2013"
      },
      {
        "title": "Headstone image of John Krebs from billiongraves.com",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSCL-527",
        "citation": "Transcription of headstone image from billiongraves.com. Image taken at Midway City Cemetery (Midway, Wasatch, Utah, United States) on 08 July 2013"
      },
      {
        "title": "John Krebs, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZK6-P3Y",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZLY-N9C : Mon Feb 03 19:03:31 UTC 2025), Entry for John Krebs and John Krebs, 12 Aug 1908."
      },
      {
        "title": "John Krebs, \"United States, Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/STRD-1ZV",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MNS2-CDB : Wed Sep 09 15:07:53 UTC 2026), Entry for John Krebs and Elizabeth Krebs, 1880."
      },
      {
        "title": "John Krebs, \"BillionGraves Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M9NY-X61",
        "citation": "\"BillionGraves Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KPSR-SJN : Thu Sep 24 19:28:17 UTC 2026), Entry for John Krebs."
      },
      {
        "title": "Johannes Krebs, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/W66P-9J3",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:66JJ-2G1B : Tue Sep 08 21:47:23 UTC 2026), Entry for Johannes Krebs and Hansen, 21 Jan 1853."
      },
      {
        "title": "John Krebs, \"BillionGraves Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M9NY-XZC",
        "citation": "\"BillionGraves Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KPSB-B2M : Thu Sep 24 19:28:17 UTC 2026), Entry for John Krebs."
      },
      {
        "title": "Johannes Krebs, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/368M-76Q",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:68VG-1MHH : Tue Sep 08 20:59:41 UTC 2026), Entry for Ida Krebs and Johannes Krebs, 18 Feb 1866."
      },
      {
        "title": "Johannes Krebs, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3KZB-L7Y",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:66JF-DFB9 : Tue Sep 08 22:07:01 UTC 2026), Entry for Rosette Krebs and Johannes Krebs, 29 May 1859."
      },
      {
        "title": "John Krebs, \"United States, Census, 1900\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S1MN-6XN",
        "citation": "\"United States, Census, 1900\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MMRY-Z51 : Sat Jan 11 02:41:34 UTC 2025), Entry for Gottlieb Buhler and Louisa Buhler, 1900."
      },
      {
        "title": "Johannes Krebs, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3NQN-VTM",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:68V2-PRDT : Tue Sep 08 20:58:45 UTC 2026), Entry for Johannes Krebs and Hans Krebs, 14 Apr 1822."
      },
      {
        "title": "Johannes Krebs, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3249-45C",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:66JV-3TDW : Wed Sep 09 00:47:39 UTC 2026), Entry for Johannes Krebs and Hansen, 25 Jul 1845."
      },
      {
        "title": "John Krebs in entry for Mrs Louisa K Buhler, \"Utah, Obituaries from Utah Newspapers, 1850-2005\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QJGN-YM3",
        "citation": "\"Utah, Obituaries from Utah Newspapers, 1850-2005,\" , FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSF-R9WL : 10 August 2024), John Krebs in entry for Mrs Louisa K Buhler, 02 Feb 1945; citing Pleasant Grove Review, The University of Utah. J. Willard Marriott Library, Salt Lake City."
      },
      {
        "title": "Johannes Krebs, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZK6-GPX",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVVH-FCYK : Fri Oct 02 15:17:58 UTC 2026), Entry for John."
      },
      {
        "title": "Johannes Krebs, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3X3Z-PR3",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:68V1-SXDP : Tue Sep 08 17:24:45 UTC 2026), Entry for Johannes Krebs and Johannis, 21 Jan 1853."
      },
      {
        "title": "Hans Krebs, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3249-ZS3",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:68VG-9WG6 : Wed Sep 09 00:05:24 UTC 2026), Entry for Anna Elisabeth Krebs and Hans Krebs, 1 Nov 1846."
      },
      {
        "title": "John Krebs, \"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q7BY-5W5",
        "citation": "\"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6KWG-JXRY : Sun Jul 05 07:20:00 UTC 2026), Entry for Robert Krebs and John Krebs."
      },
      {
        "title": "Johannes Krebs, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7R25-1Y2",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:68V1-QHSL : Wed Sep 09 01:30:05 UTC 2026), Entry for Johannes Krebs and Hansen, 24 Jul 1845."
      },
      {
        "title": "Johannes Krebs, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/36GP-N2H",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:68VY-PX68 : Fri Jan 17 00:28:40 UTC 2025), Entry for Johannes Krebs and Hansen, 25 Jul 1845."
      },
      {
        "title": "Johannes Krebs, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/32C9-83W",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:66JF-FJ1C : Tue Sep 08 19:10:29 UTC 2026), Entry for Johannes Krebs and Johannes Krebs, 30 Aug 1857."
      },
      {
        "title": "John Krebs, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSL5-S2R",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZPJ-4YJ : Mon Feb 03 19:24:22 UTC 2025), Entry for Louisa Buhler and John Krebs, 25 Jan 1945."
      },
      {
        "title": "John Krebs, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSJW-BRB",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZGY-98F : Mon Feb 03 19:14:36 UTC 2025), Entry for Rosetta Bigler and John Krebs, 21 Jul 1930."
      }
    ],
    "portrait": "/ancestors/portraits/070_KWJN-RHQ.jpg"
  },
  {
    "id": "I501",
    "name": "Elisabetha Probst",
    "sex": "F",
    "gen": 6,
    "slot": 7,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "I272",
    "birthYear": 1829,
    "deathYear": 1890,
    "birthDate": "26 Jan 1829",
    "deathDate": "23 Dec 1890",
    "burialDate": "25 Dec 1890",
    "christeningDate": "8 Feb 1829",
    "birthPlace": "Lützelflüh, Bern, Switzerland",
    "deathPlace": "Midway, Wasatch, Utah Territory, United States",
    "burialPlace": "Midway, Wasatch, Utah Territory, United States",
    "christeningPlace": "Lützelflüh, Bern, Switzerland",
    "fsId": "KWJN-RH3",
    "photo": "/ancestors/bubbles/071_KWJN-RH3.jpg",
    "living": false,
    "alternateNames": [
      "Elisabeth Probst"
    ],
    "facts": [
      {
        "kind": "Baptism",
        "date": "8 February 1829",
        "place": "Trachselwald, Bern, Schweiz",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1870",
        "place": "New York City, New York County, New York, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1880",
        "place": "Richfield, Sevier, Utah, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1900",
        "place": "Brooklyn, Kings, New York, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Elisabeth, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3X62-63T",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:68VG-882S : Tue Sep 08 22:07:19 UTC 2026), Entry for Elisabeth and Christian Probst, 8 Feb 1829."
      },
      {
        "title": "Elisabetha Probst, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/32GL-VQX",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:66JJ-X4MS : Tue Sep 08 19:40:17 UTC 2026), Entry for Ulrich Jakob and Ulrich, 20 Feb 1846."
      },
      {
        "title": "Elisabeth Probst, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/36DQ-SZF",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:68VT-G31Q : Wed Sep 09 00:13:52 UTC 2026), Entry for Verena Jakob and Ulrich, 18 Mar 1863."
      },
      {
        "title": "Elisabetha Probst, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3622-JJR",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:68VG-7V7B : Tue Sep 08 18:30:32 UTC 2026), Entry for and Ulrich Jakob, 3 Jan 1847."
      },
      {
        "title": "Elisabeth Probst, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3KZB-LCM",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:66JF-DFB9 : Tue Sep 08 22:07:01 UTC 2026), Entry for Rosette Krebs and Johannes Krebs, 29 May 1859."
      },
      {
        "title": "Elizabeth Probst, \"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q7BY-5XT",
        "citation": "\"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6KWG-JXRY : Sun Jul 05 07:20:00 UTC 2026), Entry for Robert Krebs and John Krebs."
      },
      {
        "title": "Elisabeth Jakob Probst, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/W66P-9VF",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:66JJ-2G1B : Tue Sep 08 21:47:23 UTC 2026), Entry for Johannes Krebs and Hansen, 21 Jan 1853."
      },
      {
        "title": "Elizabeth Krebs, \"BillionGraves Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZK6-PPK",
        "citation": "\"BillionGraves Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KPSB-129 : Thu Sep 24 21:05:20 UTC 2026), Entry for Elizabeth Krebs."
      },
      {
        "title": "Elisabeth Probst, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3KLP-656",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:66JF-K7RH : Wed Sep 09 00:05:59 UTC 2026), Entry for Magdalena Jakob and Ulrich Jakob, 13 Oct 1848."
      },
      {
        "title": "Elizabeth Probst Krebs in entry for Mrs Louisa K Buhler, \"Utah, Obituaries from Utah Newspapers, 1850-2005\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7R25-D8H",
        "citation": "\"Utah, Obituaries from Utah Newspapers, 1850-2005,\" , FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSF-R9WG : 10 August 2024), Elizabeth Probst Krebs in entry for Mrs Louisa K Buhler, 02 Feb 1945; citing Pleasant Grove Review, The University of Utah. J. Willard Marriott Library, Salt Lake City."
      },
      {
        "title": "Elisabeth Probst, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/36GP-6NC",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:68V1-SXDP : Tue Sep 08 17:24:45 UTC 2026), Entry for Johannes Krebs and Johannis, 21 Jan 1853."
      },
      {
        "title": "Elisabeth Probst, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/36GP-X9Z",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:68V1-Q1FN : Tue Sep 08 22:41:07 UTC 2026), Entry for Ulrich Jakob and Ulrich, 20 Feb 1846."
      },
      {
        "title": "Elisabetha Probst, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3G14-6T8",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:66JF-MPV9 : Wed Sep 09 00:34:31 UTC 2026), Entry for Elisabetha Probst and Christian Probst, 8 Feb 1829."
      },
      {
        "title": "Elizabetha Probst Krebs, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZK6-5GT",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVVH-FCYV : Fri Oct 02 02:25:31 UTC 2026), Entry for Elizabeth."
      },
      {
        "title": "Anna Elisabeth Jakob, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/368M-7X4",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:68VG-1MHH : Tue Sep 08 20:59:41 UTC 2026), Entry for Ida Krebs and Johannes Krebs, 18 Feb 1866."
      },
      {
        "title": "Elisabetha Probst, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3KRD-2X8",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:66JF-D6W4 : Tue Sep 08 19:40:47 UTC 2026), Entry for Jakob Jakob and Ulrich Jakob, 3 Jan 1847."
      },
      {
        "title": "Elisabeth Jakob, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/32C9-8Q7",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:66JF-FJ1C : Tue Sep 08 19:10:29 UTC 2026), Entry for Johannes Krebs and Johannes Krebs, 30 Aug 1857."
      },
      {
        "title": "Elizabeth Krebs, \"BillionGraves Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZK6-5HQ",
        "citation": "\"BillionGraves Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KPSR-SJK : Thu Sep 24 21:02:03 UTC 2026), Entry for Elizabeth Krebs."
      },
      {
        "title": "Elisabeth Probst, “Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3K5F-123",
        "citation": "\"Schweiz, Katholische und Reformiert Kirchenbücher, 1418-1996\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:66JF-DM3S : Wed Sep 09 00:06:42 UTC 2026), Entry for Verena Jakob and Ulrich Jakob, 7 Jul 1850."
      },
      {
        "title": "Proppes, \"California, Death Index, 1940-1997\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSG4-MLY",
        "citation": "\"California, Death Index, 1940-1997\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VGR2-C8R : Tue Feb 25 16:09:20 UTC 2025), Entry for Robert Krebs and Proppes, 01 Mar 1965."
      },
      {
        "title": "Elizabeth Probst, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSL5-SP4",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZPJ-4YJ : Mon Feb 03 19:24:22 UTC 2025), Entry for Louisa Buhler and John Krebs, 25 Jan 1945."
      },
      {
        "title": "Elizabeth Krebs, \"United States, Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M9KQ-87F",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MNS2-CDB : Wed Sep 09 15:07:53 UTC 2026), Entry for John Krebs and Elizabeth Krebs, 1880."
      },
      {
        "title": "Elizabeth Probst, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSJW-BTW",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZGY-98F : Mon Feb 03 19:14:36 UTC 2025), Entry for Rosetta Bigler and John Krebs, 21 Jul 1930."
      }
    ],
    "portrait": "/ancestors/portraits/071_KWJN-RH3.jpg"
  },
  {
    "id": "I21",
    "name": "Merle Stuart",
    "sex": "F",
    "gen": 3,
    "slot": 1,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "I5",
    "birthYear": 1918,
    "deathYear": 2016,
    "birthDate": "31 Jul 1918",
    "deathDate": "6 Mar 2016",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Malad, Oneida, Idaho, United States",
    "deathPlace": "Ogden, Weber, Utah, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LFXC-FJM",
    "photo": "/ancestors/bubbles/009_LFXC-FJM.jpg",
    "living": false,
    "alternateNames": [
      "Merle S Mills"
    ],
    "facts": [
      {
        "kind": "Residence",
        "date": "1920",
        "place": "Malad, Oneida, Idaho, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1930",
        "place": "Malad, Oneida, Idaho, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1935",
        "place": "Same Place",
        "note": null
      },
      {
        "kind": "Marriage",
        "date": "27 May 1936",
        "place": "Davis, Utah, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1940",
        "place": "Malad Election Precinct 2, Oneida, Idaho, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Merle S Mills, \"United States, Census, 1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3PHW-BD3",
        "citation": "\"United States, Census, 1950\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6XK2-36KL : Tue Mar 18 08:41:47 UTC 2025), Entry for Boyd S and Paul Henry Mills, April 11, 1950."
      },
      {
        "title": "Merle Stuart, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3WPX-XPP",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:8W89-HKW2 : Mon Mar 30 05:35:10 UTC 2026), Entry for Merle Stuart, 1920."
      },
      {
        "title": "Merle Stuart, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3WPX-DFH",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:8WJ6-HBZM : Mon Mar 30 07:15:51 UTC 2026), Entry for Merle Stuart, 1925."
      },
      {
        "title": "Household of William E Stuart, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3WPX-9QX",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:8WJ6-HB2M : Sun Mar 29 22:36:18 UTC 2026), Entry for William E Stuart, 1930."
      },
      {
        "title": "Mrs Paul H Mills, \"Utah, Box Elder, Tremonton and Garland Obituaries, 1959-2013\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3SY6-2YH",
        "citation": "\"Utah, Box Elder, Tremonton and Garland Obituaries, 1959-2013\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2QP-5F31 : Sat Mar 09 12:54:40 UTC 2024), Entry for Boyd Stuart Mills and Mr Paul H Mills, 1967."
      },
      {
        "title": "Merle Stuart Mills, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3SYM-5TD",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:D6SD-KL3Z : Mon Mar 30 07:39:40 UTC 2026), Entry for Merle Stuart Mills, 1955."
      },
      {
        "title": "Merle Stuart Mills, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3SRT-J76",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:D6SX-ZPPZ : Sun Mar 29 11:51:34 UTC 2026), Entry for Merle Stuart Mills, 1960."
      },
      {
        "title": "Merle Stuart Mills, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3SRT-JMY",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:8ZDM-4TN2 : Mon Mar 30 07:27:30 UTC 2026), Entry for Merle Stuart Mills, 1940."
      },
      {
        "title": "Merle Stuart Mills, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3SRT-N2F",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:D6SD-KGN2 : Sun Mar 29 12:32:41 UTC 2026), Entry for Merle Stuart Mills, 1950."
      },
      {
        "title": "Merle Stuart Mills, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3SRT-N8G",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Z175-SJZM : Fri Aug 01 20:53:26 UTC 2025), Entry for Merle Stuart Mills, 1950."
      },
      {
        "title": "Merle Stuart, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3SRN-LXF",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:8WJ6-CM6Z : Mon Mar 30 07:19:44 UTC 2026), Entry for Merle Stuart, 1935."
      },
      {
        "title": "Mrs Merle Mills, \"Utah, Box Elder, Tremonton and Garland Obituaries, 1959-2013\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3SMK-TL8",
        "citation": "\"Utah, Box Elder, Tremonton and Garland Obituaries, 1959-2013\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2QP-T1QQ : Thu Oct 09 15:07:54 UTC 2025), Entry for George Bartho Stuart and William E Stuart, 1986."
      },
      {
        "title": "Merle Stuart Mills, \"Idaho, World War II Draft Registration Cards, 1940-1945\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SFXN-1YL",
        "citation": "\"Idaho, World War II Draft Registration Cards, 1940-1945\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2CP-CP6S : Mon Apr 07 19:46:53 UTC 2025), Entry for Paul Henry Mills and Merle Stuart Mills, 16 Oct 1940."
      },
      {
        "title": "Merle Stuart Mills, \"BillionGraves Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SHDB-1RC",
        "citation": "\"BillionGraves Index,\" database, FamilySearch (https://familysearch.org/ark:/61903/1:1:QK7P-CWX3 : 27 June 2019), Merle Stuart Mills, died ; citing BillionGraves (http://www.billiongraves.com : 2012), Burial at Malad City Cemetery, Malad City, Oneida, Idaho, United States."
      },
      {
        "title": "Merle Stuart Mills, \"BillionGraves Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SHWG-PFB",
        "citation": "\"BillionGraves Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QK7P-ZK3X : Thu Sep 24 18:46:06 UTC 2026), Entry for Merle Stuart Mills."
      },
      {
        "title": "Merle Stuart, \"Utah, Davis County Records, 1869-1953\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SH77-L7L",
        "citation": "\"Utah, Davis County Records, 1869-1953\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QPQ6-VT2H : Sat Mar 09 08:30:34 UTC 2024), Entry for Paul H Mills and Merle Stuart."
      },
      {
        "title": "Merle Stuart, \"Utah, Davis County Records, 1869-1953\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SH77-2GT",
        "citation": "\"Utah, Davis County Records, 1869-1953\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QPQX-D72Y : Sat Mar 09 01:05:30 UTC 2024), Entry for Paul H Mills and Merle Stuart, 27 May 1936."
      },
      {
        "title": "Merle Stuart, \"United States, Western States Marriage Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SQNT-M1B",
        "citation": "\"United States, Western States Marriage Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZJK-3XP : Tue Feb 11 23:15:58 UTC 2025), Entry for Paul H Mills and Merle Stuart, 29 Sep 1936."
      },
      {
        "title": "Mrs Merle Mills in entry for Mr William Evans Stuart, \"Utah, Tremonton and Garland Obituaries, 1959-2013\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9G19-NH9",
        "citation": "\"Utah, Box Elder, Tremonton and Garland Obituaries, 1959-2013\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2QP-T114 : Wed Oct 08 03:19:15 UTC 2025), Entry for Mr William Evans Stuart and George Stuart, 1962."
      },
      {
        "title": "Mrs Merle Mills in entry for William Evans Stuart, \"Idaho, Southern Counties Obituaries, 1943-2013\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9G19-F52",
        "citation": "\"Idaho, Southern Counties Obituaries, 1943-2013\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QLWX-JV1M : Wed Jun 04 22:31:26 UTC 2025), Entry for William Evans Stuart and George Stuart."
      },
      {
        "title": "Merle Stewart in household of William E Stewart, \"United States Census, 1920\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9VP6-2Y4",
        "citation": "\"United States, Census, 1920\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MDC1-MT3 : Fri Oct 02 19:04:03 UTC 2026), Entry for William E Stewart and Mary Ann Stewart, 1920."
      },
      {
        "title": "Merle Stuart in household of William E Stuart, \"United States Census, 1930\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9VP6-27V",
        "citation": "\"United States, Census, 1930\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XH6M-PWR : Sun Oct 19 07:30:54 UTC 2025), Entry for William E Stuart and Mary A Stuart, 1930."
      },
      {
        "title": "Merle Mills, \"United States, Census, 1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9F8F-L3H",
        "citation": "\"United States, Census, 1940\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VY4Y-HJP : Wed Jan 15 18:21:39 UTC 2025), Entry for Paul H Mills and Merle Mills, 1940."
      },
      {
        "title": "Merle Stuart, \"Idaho, Southern Counties Obituaries, 1943-2013\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9F8F-J47",
        "citation": "\"Idaho, Southern Counties Obituaries, 1943-2013\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSD-S3T9 : Thu Sep 19 20:17:31 UTC 2024), Entry for Paul Henry Mills and Henry Isaac Mills."
      },
      {
        "title": "Merle Stuart, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9F8F-FJV",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSX-WC7H : Sat Sep 27 20:28:25 UTC 2025), Entry for Paul Henry Mills and Henry Isaac Mills, Jr, 1989."
      },
      {
        "title": "Merle Stuart, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9F8F-XTG",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSX-WHKZ : Sat Sep 27 20:28:20 UTC 2025), Entry for Boyd Stuart Mills and Paul Henry Mills, 1967."
      },
      {
        "title": "Utah, Select County Marriages",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9FMB-524",
        "citation": ""
      },
      {
        "title": "Merle Stuart, \"Utah, County Marriages, 1871-1941\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9F8F-6NH",
        "citation": "\"Utah, County Marriages, 1871-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VRLB-WMX : Thu Sep 19 19:33:25 UTC 2024), Entry for Paul H Mills and Henry I Mills, 29 Sep 1936."
      },
      {
        "title": "Merle Stuart, \"Utah, County Marriages, 1871-1941\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9F8F-DYY",
        "citation": "\"Utah, County Marriages, 1871-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VRLL-DZJ : Thu Sep 19 18:36:40 UTC 2024), Entry for Paul H Mills and Merle Stuart, 29 Sep 1936."
      },
      {
        "title": "Merle Stuart, \"Utah, County Marriages, 1871-1941\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9F8F-CK4",
        "citation": "\"Utah, County Marriages, 1871-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VRLT-GRL : Thu Sep 19 20:20:14 UTC 2024), Entry for Paul Henry Mills and Merle Stuart, 29 Sep 1936."
      }
    ],
    "portrait": "/ancestors/portraits/009_LFXC-FJM.jpg"
  },
  {
    "id": "I81",
    "name": "William Evans Stuart",
    "sex": "M",
    "gen": 4,
    "slot": 2,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "I21",
    "birthYear": 1877,
    "deathYear": 1962,
    "birthDate": "15 Jun 1877",
    "deathDate": "8 May 1962",
    "burialDate": "11 May 1962",
    "christeningDate": null,
    "birthPlace": "Malad, Oneida, Idaho Territory, United States",
    "deathPlace": "Malad, Oneida, Idaho, United States",
    "burialPlace": "Malad City Cemetery, Oneida, Idaho, United States",
    "christeningPlace": null,
    "fsId": "KWCT-3PQ",
    "photo": "/ancestors/bubbles/018_KWCT-3PQ.jpg",
    "living": false,
    "alternateNames": [
      "William Huddlestone Evans Stuart"
    ],
    "facts": [
      {
        "kind": "Residence",
        "date": "1900",
        "place": "Malad, Oneida, Idaho, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1910",
        "place": "Malad, Oneida, Idaho, United States",
        "note": null
      },
      {
        "kind": "Military Draft Registration",
        "date": "from 1917 to 1918",
        "place": "Oneida, Idaho, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1920",
        "place": "Malad, Oneida, Idaho, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1930",
        "place": "Malad, Oneida, Idaho, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1935",
        "place": "Malad, Oneida, Idaho, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1940",
        "place": "Malad Election Precinct 1, Oneida, Idaho, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "5 April 1950",
        "place": "Malad, Oneida, Idaho, United States",
        "note": null
      },
      {
        "kind": "Obituary",
        "date": "1962",
        "place": "Box Elder, Utah, United States",
        "note": null
      },
      {
        "kind": "Obituary",
        "date": "1962",
        "place": "Idaho, United States",
        "note": null
      },
      {
        "kind": "Social Program Claim",
        "date": "30 November 1965",
        "place": null,
        "note": null
      },
      {
        "kind": "Obituary",
        "date": null,
        "place": "Pocatello, Bannock, Idaho, United States",
        "note": null
      },
      {
        "kind": "Citizenship",
        "date": null,
        "place": "United States",
        "note": null
      }
    ],
    "sketch": "Ogden Standard-Examiner\nThursday, May 10, 1962\npage 3B\n\nWILLIAM E. STUART\nMalad - William Evans Stuart, 84, 54 W. 3rd N., died Tuesday at his home of a heart ailment.\nMr. Stuart was born June 15, 1877, in Malad, a son of George and Jemima Evans Stuart.\nHe was a lifelong resident of Malad and had been a painter and decorator.\nHe was married to Mary Ann Thomas on Nov. 16, 1904, in the Salt Lake Temple.\nAn active LDS Church worker, he was a high priest in the Malad Fourth Ward and had been a ward teacher for 40 years. He was a charter member of Malad City Volunteer Fire Department.\nSurviving are his widow, the following sons and daughters: G. Bartha Stuart, Ogden; Grant and Max Stuart, Twin Falls, Idaho; Mrs. G. E. (Hannah) Harris, Mrs. Paul (Merle) Mills, both of Malad; Mrs. Ralph (Jennie) Cate, Compton, Calif.; Mrs. Fenton (Elsie) Briggs, Pocatello; Mrs. Lonnie E. (Christie) Smith, Sheridan, Wyo.; Mrs. Leonard (Anita) Swanson, Salt Lake City; 25 grandchildren, 13 great-grandchildren, one brother and four sisters, Evan Stuart and Mrs. Jemima Opperman, Malad; Mrs. Agnes Burnett, Riverside, Utah; Mrs. Zina Robitaille, Seattle, Wash.; Mrs. Ann Coleman, Salt Lake City.\nFuneral services will be held Friday at 1 p.m. in the Malad Fourth Ward Chapel with Bishop J. A. Servoss officiating. Friends may call at the family home tonight from 7 to 9 and Friday until 12:30 p.m. Interment in Malad City Cemetery, directed by Benson Funeral Home.",
    "sources": [
      {
        "title": "William Stuart, \"California, County Marriages, 1849-1957\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7X6L-P5F",
        "citation": "\"California, County Marriages, 1849-1957\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:K8KK-VY3 : Wed Jul 10 00:43:10 UTC 2024), Entry for George Adolfe Coenen and Joseph D Coenen, 08 Dec 1947."
      },
      {
        "title": "William E. Stuart in entry for William Huddleston Stuart, \"Texas Deaths, 1890-1976\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/74TC-QZB",
        "citation": "\"Texas Deaths, 1890-1976,\" , FamilySearch (https://familysearch.org/ark:/61903/1:1:JDTT-TDW : 9 March 2018), William E. Stuart in entry for William Huddleston Stuart, 21 Feb 1943; citing Amarillo, Potter, Texas, reference cn 9263, State Registrar Office, Austin; FHL microfilm 2,137,250."
      },
      {
        "title": "William, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/747Y-T2K",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6PD8-LCD1 : Fri Mar 27 00:00:10 UTC 2026), Entry for Christie Stuart and William."
      },
      {
        "title": "William, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/747Y-TFW",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:65K3-ZDNR : Fri Mar 27 03:12:17 UTC 2026), Entry for Hanna Stuart and Gomer Hughes."
      },
      {
        "title": "William, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/747Y-TM1",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:62JJ-FZVX : Fri Mar 27 01:02:15 UTC 2026), Entry for William E Stuart and Henry I Mills."
      },
      {
        "title": "William, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/747Y-R6V",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6RTJ-3ZFJ : Fri Mar 27 01:23:23 UTC 2026), Entry for Christie Stuart and James McKay."
      },
      {
        "title": "William, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/747Y-RMV",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6PD8-LCZS : Fri Mar 27 00:00:39 UTC 2026), Entry for Christie Stuart and William."
      },
      {
        "title": "William, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/747Y-55L",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:65LN-CR73 : Fri Mar 27 03:44:14 UTC 2026), Entry for Geo Bartho Stuart and William."
      },
      {
        "title": "William, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/747Y-5KG",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6R1Z-FPYY : Fri Mar 27 03:44:39 UTC 2026), Entry for Jemima Stuart and William."
      },
      {
        "title": "William Stuart, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/747Y-5FV",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6RT2-22CK : Fri Mar 27 00:25:22 UTC 2026), Entry for Jemima and William Stuart."
      },
      {
        "title": "William Stuart, \"United States, GenealogyBank Obituaries, Births, and Marriages, 1980-2015\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/776P-4NN",
        "citation": "\"United States, GenealogyBank Obituaries, Births, and Marriages, 1980-2015\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6YL8-JL56 : Sun Jul 07 12:32:33 UTC 2024), Entry for Elsie Stuart Briggs and Annette Selders, 25 February 2020."
      },
      {
        "title": "Wm Stuart in entry for Jess C Littlejohn and Jean Stuart, \"California, County Marriages, 1850-1952\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9P3W-RM6",
        "citation": "\"California, County Marriages, 1849-1957\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:K8JZ-4X7 : Wed Jul 10 00:34:20 UTC 2024), Entry for Jess C Littlejohn and Earl H Littlejohn, 19 May 1933."
      },
      {
        "title": "William Stuart, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QJFF-4NH",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:62WY-4W2Q : Fri Mar 27 03:39:09 UTC 2026), Entry for William Huddleson Stuart and William Stuart."
      },
      {
        "title": "William Stuart, \"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QWXR-K3R",
        "citation": "\"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6KWJ-SVPY : Wed Jul 01 11:57:40 UTC 2026), Entry for Grant Stuart and William Stuart."
      },
      {
        "title": "William E Stuart, \"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QWH7-J47",
        "citation": "\"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6KWJ-P1GZ : Sat Jul 04 01:47:55 UTC 2026), Entry for William E Stuart and George Stuart."
      },
      {
        "title": "William E Stuart, \"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q7RC-X84",
        "citation": "\"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6KWL-P4Y7 : Sat Jul 04 15:36:19 UTC 2026), Entry for Max T Stuart and William E Stuart."
      },
      {
        "title": "William E Stuart, \"United States, Census, 1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/35TG-HPH",
        "citation": "\"United States, Census, 1950\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6XKK-YFWK : Mon Mar 17 19:01:42 UTC 2025), Entry for William E Stuart and Mary A Stuart, April 5, 1950."
      },
      {
        "title": "William E Stuart, \"California, World War II Draft Registration Cards, 1940-1947\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3WRD-VY5",
        "citation": "\"California, World War II Draft Registration Cards, 1940-1947\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QGXY-2NHV : Fri Apr 04 01:10:06 UTC 2025), Entry for Max Thomas Stuart and William E Stuart, 14 Feb 1942."
      },
      {
        "title": "William Stuart, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3WPF-8DH",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:8WJG-YCN2 : Mon Mar 30 07:16:37 UTC 2026), Entry for William Stuart, 1914."
      },
      {
        "title": "William E Stuart, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3WPX-6J3",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:8W89-HVZM : Mon Mar 30 05:35:10 UTC 2026), Entry for William E Stuart, 1920."
      },
      {
        "title": "William E Stuart, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3WPX-8ZJ",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:8WJ6-HYN2 : Mon Mar 30 07:15:51 UTC 2026), Entry for William E Stuart, 1925."
      },
      {
        "title": "William E Stuart, \"United States, World War I Draft Registration Cards, 1917-1918\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3WPX-SLC",
        "citation": "\"United States, World War I Draft Registration Cards, 1917-1918\", database with images, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:K8Q8-KFV : 1 July 2024), William E Stuart, 1917-1918."
      },
      {
        "title": "William E Stuart, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3WP6-1G8",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:8WJ6-HB2M : Sun Mar 29 22:36:18 UTC 2026), Entry for William E Stuart, 1930."
      },
      {
        "title": "William E Stuart, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3SRN-GBG",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:8C22-Z1N2 : Mon Mar 30 05:40:03 UTC 2026), Entry for William E Stuart, 1940."
      },
      {
        "title": "William Stuart, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3SRN-KYT",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:8WJ6-H1T2 : Mon Mar 30 07:19:44 UTC 2026), Entry for William Stuart, 1935."
      },
      {
        "title": "William Evans Stuart, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3SRN-DTK",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:DL7T-373Z : Wed Oct 15 10:34:48 UTC 2025), Entry for William Evans Stuart and Mary Ann Thomas Stuart, 1950."
      },
      {
        "title": "William Evans Stuart, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3SRN-DMH",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:DJS4-R2ZM : Fri Aug 01 17:00:00 UTC 2025), Entry for William Evans Stuart, 1955."
      },
      {
        "title": "William Evans Stuart, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3SRN-8MV",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:DJ4R-44MM : Fri Aug 01 17:01:27 UTC 2025), Entry for William Evans Stuart, 1960."
      },
      {
        "title": "William Evans Stuart, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3SRN-CT6",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:DJS4-R23Z : Fri Aug 01 16:58:34 UTC 2025), Entry for William Evans Stuart, 1950."
      },
      {
        "title": "William Evans Stuart, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S1GB-PW7",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:73F2-VX3Z : Sun Mar 10 06:46:29 UTC 2024), Entry for Hannah Adelia Stuart Harris and William Evans Stuart, 1983."
      },
      {
        "title": "Wm Stuart, \"California, County Marriages, 1849-1957\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SK4C-ZKX",
        "citation": "\"California, County Marriages, 1849-1957\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:K8JZ-4X7 : Wed Jul 10 00:34:20 UTC 2024), Entry for Jess C Littlejohn and Earl H Littlejohn, 19 May 1933."
      },
      {
        "title": "William Stuart in entry for William H. Stuart, \"Utah, Marriages, 1887-1935\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SVG9-WR1",
        "citation": "\"Utah, Marriages, 1887-1935\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:HN81-JW6Z : 3 November 2021), William Stuart in entry for William H. Stuart, 1940."
      },
      {
        "title": "William E. Stuart, \"United States, Western States Marriage Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S4N2-JZ7",
        "citation": "\"United States, Western States Marriage Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZV4-9Q7 : Tue Feb 11 23:16:39 UTC 2025), Entry for William E. Stuart and Mary Ann Thomas, 16 Nov 1904."
      },
      {
        "title": "William Evans Stuart, \"Idaho, Southern Counties Obituaries, 1943-2013\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9P6Y-34C",
        "citation": "\"Idaho, Southern Counties Obituaries, 1943-2013\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QLWX-JV1M : Wed Jun 04 22:31:26 UTC 2025), Entry for William Evans Stuart and George Stuart."
      },
      {
        "title": "Mr William Evans Stuart, \"Utah, Tremonton and Garland Obituaries, 1959-2013\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9G19-NWF",
        "citation": "\"Utah, Box Elder, Tremonton and Garland Obituaries, 1959-2013\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2QP-T114 : Wed Oct 08 03:19:15 UTC 2025), Entry for Mr William Evans Stuart and George Stuart, 1962."
      },
      {
        "title": "William Evans Stuart, \"Utah, Tremonton and Garland Obituaries, 1959-2013\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/92SY-8Q9",
        "citation": "\"Utah, Box Elder, Tremonton and Garland Obituaries, 1959-2013\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2QP-5BRW : Tue Apr 29 21:03:54 UTC 2025), Entry for William Evans Stuart, 1962."
      },
      {
        "title": "William E Stuart in entry for George Bartho Stuart, \"Utah, Tremonton and Garland Obituaries, 1959-2013\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9VG1-536",
        "citation": "\"Utah, Box Elder, Tremonton and Garland Obituaries, 1959-2013\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2QP-T1QQ : Thu Oct 09 15:07:54 UTC 2025), Entry for George Bartho Stuart and William E Stuart, 1986."
      },
      {
        "title": "William Stuart, \"Utah, County Marriages, 1871-1941\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9JL6-ZK3",
        "citation": "\"Utah, County Marriages, 1871-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2MY-D3FS : Wed Nov 19 05:25:27 UTC 2025), Entry for William H Stuart and William Stuart, 03 Jun 1940."
      },
      {
        "title": "William E Stuart, \"Utah, County Marriages, 1871-1941\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9F8F-6JY",
        "citation": "\"Utah, County Marriages, 1871-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VRLB-WMX : Thu Sep 19 19:33:25 UTC 2024), Entry for Paul H Mills and Henry I Mills, 29 Sep 1936."
      },
      {
        "title": "William E. Stuart, \"Utah, County Marriages, 1871-1941\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9XF5-F9R",
        "citation": "\"Utah, County Marriages, 1871-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KSGR-GQ9 : Thu Sep 19 19:05:54 UTC 2024), Entry for William E. Stuart and Mary Ann Thomas, 16 Nov 1904."
      },
      {
        "title": "William E. Stuart, \"Utah, Marriages, 1887-1935\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9XF5-F99",
        "citation": "\"Utah, Marriages, 1887-1935\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:F8G2-N5W : 28 January 2020), William E. Stuart, 1904."
      },
      {
        "title": "William Evans Stuart, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9XF5-8PT",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVK3-NQT9 : Fri Oct 02 23:10:35 UTC 2026), Entry for William Evans Stuart, 1962."
      },
      {
        "title": "William Evans Stuart, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9XW9-LKH",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSF-9G83 : Sat Sep 27 21:43:52 UTC 2025), Entry for William Evans Stuart and George Stewart, 1962."
      },
      {
        "title": "William Evans Stuart, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9X9R-RWZ",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVS6-F963 : Sat Sep 27 19:24:47 UTC 2025), Entry for Hannah Adelia Stuart Harris and William Evans Stuart, 1983."
      },
      {
        "title": "Wm. E. Stewart in entry for George Ellis Harris, \"Utah, Marriages, 1887-1935\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9X9R-5FP",
        "citation": "\"Utah, Marriages, 1887-1935\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:F8G1-X4B : 28 January 2020), Wm. E. Stewart in entry for George Ellis Harris, 1923."
      },
      {
        "title": "Wm. E. Stewart, \"Utah, County Marriages, 1871-1941\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/96BY-TSH",
        "citation": "\"Utah, County Marriages, 1871-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KSP9-FMD : Thu Sep 19 18:58:39 UTC 2024), Entry for George Ellis Harris and Robert W. Harris, 28 Nov 1923."
      },
      {
        "title": "William Evans Stuart, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/984V-SBK",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSF-9G3Y : Sat Sep 27 21:43:50 UTC 2025), Entry for Mary Ann Dredge Thomas Stuart and George Sparry Thomas, 1969."
      },
      {
        "title": "William Stuart, \"California, County Marriages, 1849-1957\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSLP-4DN",
        "citation": "\"California, County Marriages, 1849-1957\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:K8JX-MP3 : Wed Jul 10 00:35:29 UTC 2024), Entry for Bartho T Start and William Stuart, 21 Apr 1934."
      },
      {
        "title": "William E Stuart, \"United States, Census, 1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSLP-49Y",
        "citation": "\"United States, Census, 1940\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VY4Y-MDJ : Wed Jan 15 22:33:05 UTC 2025), Entry for William E Stuart and Mary Ann Stuart, 1940."
      },
      {
        "title": "William E Stuart, \"United States, Census, 1930\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSLP-WLT",
        "citation": "\"United States, Census, 1930\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XH6M-PWR : Sun Oct 19 07:30:54 UTC 2025), Entry for William E Stuart and Mary A Stuart, 1930."
      },
      {
        "title": "William H Stuart, \"United States, Census, 1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSLP-Q1Y",
        "citation": "\"United States, Census, 1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MLH1-19R : Wed Oct 29 21:03:18 UTC 2025), Entry for William H Stuart and Mary Ann Stuart, 1910."
      },
      {
        "title": "William Evans Stuart, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSLP-Q5Q",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSF-9G84 : Sat Sep 27 21:43:53 UTC 2025), Entry for William Huddlestone Stuart and William Evans Stuart, 1943."
      },
      {
        "title": "William E Stuart, \"Texas, Deaths, 1890-1977\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSLP-QLB",
        "citation": "\"Texas, Deaths, 1890-1977\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KS15-GJL : Mon Jun 09 23:41:36 UTC 2025), Entry for William Huddleston Stuart and William E Stuart, 21 February 1943."
      },
      {
        "title": "William E Stewart, \"United States, Census, 1920\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSLP-QSY",
        "citation": "\"United States, Census, 1920\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MDC1-MT3 : Fri Oct 02 19:04:03 UTC 2026), Entry for William E Stewart and Mary Ann Stewart, 1920."
      },
      {
        "title": "William Stuart, \"United States, Census, 1900\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSLG-BH8",
        "citation": "\"United States, Census, 1900\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MM5T-ZZR : Fri Jan 17 20:12:38 UTC 2025), Entry for George Stuart and Mary Stuart, 1900."
      },
      {
        "title": "William Stuart in household of George Stuart, \"United States Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMC2-PSF",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M4ZJ-KCZ : Wed Sep 09 07:33:39 UTC 2026), Entry for George Stuart and Mary Stuart, 1880."
      },
      {
        "title": "Legacy NFS Source: William Huddlestone Evans Stuart - Individual or family possessions: birth-name: William Huddlestone Evans Stuart",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MS6B-GK2",
        "citation": ""
      },
      {
        "title": "Grave Marker for William Evans Stuart",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MM9M-XYM",
        "citation": "Find a Grave website, Malad City Cemetery, Malad City, Oneida, Idaho, United States."
      },
      {
        "title": "Mary Ann Stuart in household of William H Stuart, \"United States Census, 1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MM9M-15C",
        "citation": "\"United States, Census, 1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MLH1-19R : Wed Oct 29 21:03:18 UTC 2025), Entry for William H Stuart and Mary Ann Stuart, 1910."
      }
    ],
    "portrait": "/ancestors/portraits/018_KWCT-3PQ.jpg"
  },
  {
    "id": "I212",
    "name": "George Stuart",
    "sex": "M",
    "gen": 5,
    "slot": 4,
    "side": "paternal",
    "birthplace": "england",
    "childId": "I81",
    "birthYear": 1845,
    "deathYear": 1919,
    "birthDate": "27 Feb 1845",
    "deathDate": "11 Aug 1919",
    "burialDate": "13 Aug 1919",
    "christeningDate": null,
    "birthPlace": "Kendal, Westmorland, England, United Kingdom",
    "deathPlace": "Malad, Oneida, Idaho, United States",
    "burialPlace": "Malad City Cemetery, Malad City, Oneida, Idaho, United States",
    "christeningPlace": null,
    "fsId": "KWNK-S2X",
    "photo": "/ancestors/bubbles/036_KWNK-S2X.jpg",
    "living": false,
    "alternateNames": [
      "George H. Stuart (Telegraph Operator)"
    ],
    "facts": [
      {
        "kind": "Birth Registration",
        "date": "1845",
        "place": "Kendal, Westmorland, England, United Kingdom",
        "note": null
      },
      {
        "kind": "Immigration",
        "date": "30 August 1850",
        "place": null,
        "note": null
      },
      {
        "kind": "Immigration",
        "date": "30 August 1850",
        "place": "Utah, United States",
        "note": null
      },
      {
        "kind": "Baptism",
        "date": "March 1853",
        "place": null,
        "note": null
      },
      {
        "kind": "Baptism",
        "date": "1853",
        "place": null,
        "note": null
      },
      {
        "kind": "Immigration",
        "date": "22 September 1861",
        "place": null,
        "note": null
      },
      {
        "kind": "Immigration",
        "date": "22 September 1861",
        "place": "Utah, United States",
        "note": null
      },
      {
        "kind": "Mission",
        "date": "1894",
        "place": "United Kingdom",
        "note": null
      },
      {
        "kind": "Mission",
        "date": "1905",
        "place": null,
        "note": "United States Visiting Mission"
      },
      {
        "kind": "Obituary",
        "date": "1919",
        "place": "Idaho, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": null,
        "place": "Salt Lake City, Salt Lake, Utah, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": null,
        "place": "Malad, Oneida, Idaho, United States",
        "note": null
      }
    ],
    "sketch": "George H. Stuart (Telegraph Operator) was born on 27 February 1845 in Overstavely, Westmoreland, England. He appeared in the census in 1880 in Malad, Oneida, Idaho. He appeared in the census in 1900 in Malad, Oneida, Idaho. George died on 11 August 1919 in Malad, Oneida, Idaho. He was buried in Malad, Oneida, Idaho.\n\nGeorge was the first bishop in Malad. was sent there from SLC. He served a mission to Scotland\n1894-96. He was a member of the Nauvoo guard. He was one of the last 9\nbishops to be appointed by Brigham Young. In fact, grandpa was appointed\nwithin 2 weeks of President Young's Death as bishop of the Willow Springs Branch of the Malad Stake which Brigham Young created that day from the Box Elder Stake. Malad was part of Utah Territory at the time. Got this from mom, and she said it was from the Box Elder church records.\n\nFind records for the Willow Springs Branch!!\n\nAnother item from Mom. He started the United Order in Malad Valley but the cattlemen had already started their businesses and they were annoyed with the order so George had a hard time getting it going. They fought it.\n\nGeorge spent 4 or 5 months in prison in Idaho for Polygamy--because he refused to sign a statement\nsaying he would give up one of his wives. He was let out early for good\nbehavior. 9 November 1877 is another baptism date.\n\nInformation on his children comes from Great Great Uncle Will's Bible\nWilliam E. Stuart, Malad City, Malad. Some taken from Merle Stuart Mills\n227 Samaria Lane, Malad, Oneida, Idaho.\n\nPioneers and Prominent Men of Utah, p.1195\nSTUART, GEORGE (son of Daniel Stuart and Agness Huddleston). Born Feb. 27, 1845. Came to Utah with parents.\nPioneers and Prominent Men of Utah, p.1195\nMarried Mary Evans in 1866, Salt Lake City (daughter of Thomas E. Evans and Jane Davis), who was born 1841 in Wales. Their children: Jane Agnes b. June, 1868, d. 1868; Eva Eveline b. Oct. 6, 1869, m. George Richardson 1887; Mary Margrett b. Oct. 1871, m. James McKay; George Daniel b. 1873, died; Ammie b. 1874; George S. b. March 1875, m. Rebecca Williams; Benjamin b. Nov. 22, 1875, m. Sally Jones.\nPioneers and Prominent Men of Utah, p.1195\nMissionary to Scotland 1894-96; bishop; member of Nauvoo Guard. Telegraph operator.\nPioneers and Prominent Men of Utah, p.1195\nMarried Jemima Evans April 8, 1874, Salt Lake City (daughter of Thomas L. Evans and Jane Davis, former pioneer 1868, Captain Gillett company, latter 1866, same captain). She was born April 1, 1850, in Glamorganshire, Wales. Their children: Thomas b. Jan. 1875, m. Annie Jones; William A. b. June 1877, m. Mary Ann Thomas; Ivan b. Aug. 22, 1879, m. Mary Williams; Sarah b. Sept. 13, 1882, m. William Follace; Zina b. Sept. 18, 1886, m. Frank Robert; Agness b. May 21, 1889, m. Davy Burnett; Jemima b. Nov. 18, 1891; Daniel W. b. 1899.\nPioneers and Prominent Men of Utah, p.1195\n\n[Correction to Pioneers and Prominent Men of Utah cited above: Sarah, daughter of George and Jemima Stuart, b. Sept. 13, 1882, married William Fallis not Follace. Daniel W. b. 1899 and listed as a child of George and Jemima Stuart was actually George's orphaned grandson who grew up in his grandfather's household.]\n\nGeorge spent some time in SLC in the beginning before he was sent to help settle Idaho. He was a Telegraph Operator. I'll bet he learned that trade by working with his brother in law (Christiana's husband, Charles Enos Pomeroy) who ran the Western Union Telegraph office right next door to Daniel Stuart's residence on Main street and his grocery store!!!!)\n\n\nOur Pioneer Heritage, Vol. 11, p.488\nIdaho—Arizona. During the winter of 1884–5 the Idaho Legislature enacted the celebrated test-oath law, disfranchising every Mormon in that Territory. The reputed author of the bill from which the law was framed was H. W. Smith, alias \"Kentucky\" Smith, afterwards an Associate Justice of Utah. Having passed both branches of the Assembly, it was approved by the governor, William M. Bunn. The effect of this measure was to disfranchise from fifteen hundred to two thousand citizens, most of whom had broken no law, but were simply members of the Church of Jesus Christ of Latter-day Saints. The enactment of this piece of legislation—which, to the astonishment of the Mormons, and many Gentiles as well, was declared constitutional, not only by the Idaho courts but eventually by the Supreme Court of the United States—was followed by the arrest, conviction and imprisonment of many persons.\nOur Pioneer Heritage, Vol. 11, p.488\nOne of the most active agents of the crusade was the United States Marshal, Fred T. Dubois, who subsequently represented Idaho in Congress, first as Delegate, and after the Territory became a state, as Senator. He it was who, while U.S. Marshal of the Territory, said, after selecting a jury to try a certain Mormon case, that he had a jury that would convict Jesus Christ if He were on trial for unlawful cohabitation before them.\nOur Pioneer Heritage, Vol. 11, p.488\nIn the north the most notable arrest at the outset of the crusade was that of William D. Hendricks, president of the Oneida Stake of Zion. It occurred on Sunday, April 19, 1885. This stake is in Idaho, but the warrant was served upon the defendant at Logan, Utah, by U.S. Marshal Dubois. Subsequently, Bishop George Stuart of Malad, President William Budge of the Bear Lake Stake, George C. Parkinson, afterwards president of the Oneida Stake and other prominent Mormons, with many not so prominent, were made victims of the anti-Mormon movement in Idaho. President Budge was acquitted, but Parkinson was imprisoned for a year in the penitentiary at Boise, Idaho. He was not a polygamist, but was falsely accused and unjustly convicted of secreting a suspect of whom the officers were in search. Other persons imprisoned for polygamy in Idaho were Bishop Stuart, John T. Roberts of Rexburg, William J. Pratt of Wilford, Charles W. Simpson of Montpelier and John Winn of Battle Creek. All pleaded guilty to unlawful cohabitation and were sentenced in the latter part of May.\n\n\nStuart, George 27 Feb 1845 -\nLatter-Day Saint Biographical Encyclopedia: A Compilation of Biographical Sketches of Prominent Men and Women In The Church of Jesus Christ of Latter-day Saints by Andrew Jenson. [Salt Lake City: Andrew Jenson History Company, 1901-1935.] v.4, p.523\nPioneers and Prominent Men of Utah compiled by Frank Esshom. [Salt Lake City: Western Epics, Inc., 1966.] p.1195 Photo p.238\n\nLDS Biographical Encyclopedia, Andrew Jenson, Vol. 4, p.523\nStuart, George, Bishop of the Malad Ward, Malad Stake, Idaho, from 1880 to 1890, was born Feb. 27, 1845, in Stavely, Lancashire, England, a son of Daniel Stuart and Agnes Huddliston. He was baptized in 1853, and ordained a High Priest and Bishop and set apart to preside over the Malad Ward Oct. 31, 1880, by Oliver G. Snow.\n\nAndrew Jenson, Church Chronology, May 23, 1885 (Saturday)\nIn the District Court at Blackfoot, Idaho, Judge Morgan sentenced Bishop George Stuart, of Malad, Wm. J. Pratt, of Wilford, and John T. Roberts, of Rexburg, each to four months' imprisonment in the Boise Penitentiary and $300 fine; John Winn, an old man, of Battle Creek, Oneida Co., and Charles W. Simpson, of Montpelier, each to a fine of $300, and Samuel Humphreys to six months' imprisonment and $300 fine. Mary Evans and George H. Stuart (Telegraph Operator) were married on 8 October 1865 in Salt Lake City, Salt Lake, Utah.\n\nAncestors of Susan Holley--Narrative",
    "sources": [
      {
        "title": "George Stuart, \"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QWH7-VYM",
        "citation": "\"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6KWJ-F2LL : Sat Jul 04 02:46:52 UTC 2026), Entry for Ben Stuart and George Stuart."
      },
      {
        "title": "George Stuart, \"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QWH7-NDC",
        "citation": "\"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6KWJ-P1GZ : Sat Jul 04 01:47:55 UTC 2026), Entry for William E Stuart and George Stuart."
      },
      {
        "title": "George in entry for Dan.L G. Stewart, \"Utah, Deaths and Burials, 1888-1946\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3K3L-LC2",
        "citation": "\"Utah, Deaths and Burials, 1888-1946\", , FamilySearch (https://www.familysearch.org/ark:/61903/1:1:HFB3-8LMM : 22 September 2026), George in entry for Dan.L G. Stewart, 1874."
      },
      {
        "title": "George, \"Utah, Salt Lake, Salt Lake City, Cemetery Records, 1847-1976\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3K3L-241",
        "citation": "\"Utah, Salt Lake, Salt Lake City, Cemetery Records, 1847-1976\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:ZNTB-S6W2 : Sun Mar 10 17:37:25 UTC 2024), Entry for Daniel G Stewart and George, 1874."
      },
      {
        "title": "George, \"Utah, Salt Lake County Death Records, 1849-1949\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3K3L-V1W",
        "citation": "\"Utah, Salt Lake County Death Records, 1849-1949\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:NQHG-C2K : Fri Mar 08 07:10:53 UTC 2024), Entry for Danl G Stewart and George, 01 Jan 1874."
      },
      {
        "title": "George Stuart, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3DC6-HZC",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:8Q54-WYN2 : Fri Aug 01 17:06:31 UTC 2025), Entry for George Stuart, 1914."
      },
      {
        "title": "George Stuart, \"Idaho, Southern Counties Obituaries, 1943-2013\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3W14-HLS",
        "citation": "\"Idaho, Southern Counties Obituaries, 1943-2013\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QLWF-W31Z : Thu Oct 17 16:14:38 UTC 2024), Entry for Evan Stuart and George Stuart."
      },
      {
        "title": "George, \"Utah, Salt Lake, Salt Lake City, Cemetery Records, 1847-1976\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SBFB-6C2",
        "citation": "\"Utah, Salt Lake, Salt Lake City, Cemetery Records, 1847-1976\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:ZJQ2-3WPZ : Sat Mar 09 16:34:37 UTC 2024), Entry for Jane Agnes Stewart and George, 1867."
      },
      {
        "title": "George Stuart, \"Utah, Box Elder, Brigham City Family History Center, Obituary Collection, 1930-2016\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SY7W-1S1",
        "citation": "\"Utah, Box Elder, Brigham City Family History Center, Obituary Collection, 1930-2016\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:84LW-6F6Z : Thu Feb 12 16:40:23 UTC 2026), Entry for Mrs. Agnes Stuart Burnett and Howard Capener, Bishop, 1965."
      },
      {
        "title": "George Stuart, \"Utah, Box Elder, Tremonton and Garland Obituaries, 1959-2013\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SK6D-9D5",
        "citation": "\"Utah, Box Elder, Tremonton and Garland Obituaries, 1959-2013\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2QP-Y9KN : Thu Oct 09 21:46:11 UTC 2025), Entry for Mr Evan Stuart and George Stuart."
      },
      {
        "title": "George Stewart in entry for Danl. G. Stewart, \"Utah, Deaths and Burials, 1888-1946\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SHHG-YR3",
        "citation": "\"Utah, Deaths and Burials, 1888-1946\", database, FamilySearch (https://familysearch.org/ark:/61903/1:1:F85N-789 : 28 January 2020), George Stewart in entry for Danl. G. Stewart, ."
      },
      {
        "title": "Jemima Evans, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9BG1-SM5",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSF-9L2G : Sat Sep 27 21:43:49 UTC 2025), Entry for George A Stuart and Daniel Stewart or Stuart, 1919."
      },
      {
        "title": "George Stuart in entry for Mr William Evans Stuart, \"Utah, Tremonton and Garland Obituaries, 1959-2013\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9G1Q-9K5",
        "citation": "\"Utah, Box Elder, Tremonton and Garland Obituaries, 1959-2013\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2QP-T114 : Wed Oct 08 03:19:15 UTC 2025), Entry for Mr William Evans Stuart and George Stuart, 1962."
      },
      {
        "title": "George Stuart in entry for William Evans Stuart, \"Idaho, Southern Counties Obituaries, 1943-2013\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9G13-161",
        "citation": "\"Idaho, Southern Counties Obituaries, 1943-2013\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QLWX-JV1M : Wed Jun 04 22:31:26 UTC 2025), Entry for William Evans Stuart and George Stuart."
      },
      {
        "title": "George Stuart, \"Early Mormon Missionaries\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/92C9-VF4",
        "citation": "\"George Stuart\", Early Mormon Missionaries, accessed June 26, 2017, https://history.lds.org/missionary/individual/george-stuart-1845-38296"
      },
      {
        "title": "George Stuart, \"Early Mormon Missionaries\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/92HT-4MD",
        "citation": "\"George Stuart\", Early Mormon Missionaries, accessed June 26, 2017, https://history.lds.org/missionary/individual/george-stuart-1845-38296"
      },
      {
        "title": "George Stuart in entry for Annie Stuart Coleman, \"Utah Death Certificates, 1904-1964\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9KTC-8YH",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QKDV-6TPG : Sat Mar 09 15:15:54 UTC 2024), Entry for Annie Stuart Coleman and George Stuart, 03 Jul 1964."
      },
      {
        "title": "George Stuart, \"Idaho, Death Certificates, 1938-1961\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9NSG-SYD",
        "citation": "\"Idaho, Death Certificates, 1938-1961\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2M1-5VQH : Fri Feb 21 22:53:22 UTC 2025), Entry for Benjamin Stuart and George Stuart, 13 May 1946."
      },
      {
        "title": "George Stuart, \"Idaho, Death Certificates, 1938-1961\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9NMP-6MT",
        "citation": "\"Idaho, Death Certificates, 1938-1961\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2M1-KRNR : Fri Feb 21 22:48:25 UTC 2025), Entry for Mary Margaret McKay and George Stuart, 4 Oct 1954."
      },
      {
        "title": "George Stewart, \"England and Wales, Birth Registration Index, 1837-2008\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9FRX-WYL",
        "citation": "\"England and Wales, Birth Registration Index, 1837-2008\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:26GW-RG4 : Sun May 10 10:19:54 UTC 2026), Entry for George Stewart, 1845."
      },
      {
        "title": "George Stuart, \"The Church of Jesus Christ of Latter-day Saints, Missionary Registers (Worldwide), 1860-1937\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9XR4-M22",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Missionary Registers (Worldwide), 1860-1937\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QKDW-YKHS : Tue Mar 11 16:23:10 UTC 2025), Entry for George Stuart and Woolley, 1905."
      },
      {
        "title": "George Stuart, \"The Church of Jesus Christ of Latter-day Saints, Missionary Registers (Worldwide), 1860-1937\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9XR4-M7R",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Missionary Registers (Worldwide), 1860-1937\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QKDW-YDDB : Tue Mar 11 16:25:28 UTC 2025), Entry for George Stuart and Edwin D Woolley, 1894."
      },
      {
        "title": "George Stuart, \"Idaho, Death Certificates, 1938-1961\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9XRW-Y3T",
        "citation": "\"Idaho, Death Certificates, 1938-1961\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2M1-5JFL : Fri Feb 21 22:47:55 UTC 2025), Entry for Sarah Stuart Fallis and George Stuart, 2 Apr 1959."
      },
      {
        "title": "George Stewart, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9XF5-FQ4",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSF-9G83 : Sat Sep 27 21:43:52 UTC 2025), Entry for William Evans Stuart and George Stewart, 1962."
      },
      {
        "title": "George Stuart, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9X9M-ZTD",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QKDV-X43B : Thu Mar 07 03:54:58 UTC 2024), Entry for Jemima Opperman and George Stuart, 03 Dec 1963."
      },
      {
        "title": "George Stuart, \"Utah, Mormon Pioneer Overland Travel Database, 1847-1868\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9699-ZBD",
        "citation": "\"Utah, Mormon Pioneer Overland Travel Database, 1847-1868\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QK9B-ZSY2 : Wed Feb 19 20:20:37 UTC 2025), Entry for George Stuart, 22 Sep 1861."
      },
      {
        "title": "Mr Stuart, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9DYZ-133",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSF-9GQ9 : Sat Sep 27 21:43:50 UTC 2025), Entry for Mary Athaliah Hunting Stuart and Mr Stuart, 1882."
      },
      {
        "title": "George Stuart, \"Utah, Mormon Pioneer Overland Travel Database, 1847-1868\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9DYZ-2JF",
        "citation": "\"Utah, Mormon Pioneer Overland Travel Database, 1847-1868\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QK9B-HLV7 : Wed Feb 19 20:41:16 UTC 2025), Entry for George Stuart, 30 Aug 1850."
      },
      {
        "title": "George A Stuart, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9D3C-7WM",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSF-9GQ3 : Sat Sep 27 21:43:50 UTC 2025), Entry for Mary Evans Stuart and Thomas Lewis Evans, 1934."
      },
      {
        "title": "in entry for Mary Evans Stuart, \"BillionGraves Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9R9Q-J7G",
        "citation": ""
      },
      {
        "title": "George Stuart, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZB1-TSM",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVK3-NQRB : Sat Oct 03 03:36:28 UTC 2026), Entry for George Stuart."
      },
      {
        "title": "George Stuart, \"Utah, Pioneers and Prominent Men of Utah, 1847-1868\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9Z3V-NK6",
        "citation": "\"Utah, Pioneers and Prominent Men of Utah, 1847-1868\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KL71-MPB : Sat Mar 09 11:37:16 UTC 2024), Entry for George Stuart and Daniel Stewart."
      },
      {
        "title": "George Stuart, \"Idaho, Death Certificates, 1911-1937\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSG3-J2K",
        "citation": "\"Idaho, Death Certificates, 1911-1937\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:FLYH-J2L : Thu Feb 27 18:01:24 UTC 2025), Entry for Mary Stuart and Thos L. Evans, 12 Sep 1934."
      },
      {
        "title": "George A Stuart, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSG3-FRM",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSF-9LR6 : Sat Sep 27 21:43:50 UTC 2025), Entry for Jemima Evans Stuart and Thomas Lewis Evans, 1937."
      },
      {
        "title": "George Stuart, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSG3-FLW",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZPN-HQH : Mon Feb 03 19:23:06 UTC 2025), Entry for Thomas Stuart and George Stuart, 14 Jan 1944."
      },
      {
        "title": "George Stuart, \"Idaho, Southern Counties Obituaries, 1943-2013\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSG3-XXH",
        "citation": "\"Idaho, Southern Counties Obituaries, 1943-2013\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSD-38XJ : Thu Sep 19 19:23:10 UTC 2024), Entry for Mrs Jemima Opperman and George Stuart."
      },
      {
        "title": "George Stewart, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSG3-8V5",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSX-8JGF : Sat Sep 27 20:45:52 UTC 2025), Entry for Jemima Stuart Opperman and George Stewart, 1963."
      },
      {
        "title": "George Stewart, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSLB-5YS",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVS6-WNPX : Sat Sep 27 18:58:36 UTC 2025), Entry for Sarah Stuart Fallis and George Stewart, 1959."
      },
      {
        "title": "George Stewart, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSLR-4W8",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSF-9LK3 : Sat Sep 27 21:43:47 UTC 2025), Entry for Evan Stuart and George Stewart, 1975."
      },
      {
        "title": "George Stewart, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSLP-SKL",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSF-9GC9 : Sat Sep 27 21:43:53 UTC 2025), Entry for Thomas Evans Stuart and George Stewart, 1944."
      },
      {
        "title": "George Stuart, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSLP-9JJ",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSF-9LXG : Sat Sep 27 21:43:47 UTC 2025), Entry for Benjamin Stuart and George Stuart, 1946."
      },
      {
        "title": "George Stewart, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSL2-SSQ",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSX-QH9Y : Tue Oct 21 10:11:29 UTC 2025), Entry for Mary Margaret Stuart McKay and George Stewart, 1954."
      },
      {
        "title": "George Stuart, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSLK-Y19",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZL4-J9F : Mon Feb 03 18:59:24 UTC 2025), Entry for Eve Evaline Richardson and George Stuart, 03 Nov 1947."
      },
      {
        "title": "George, \"Utah, Salt Lake County Death Records, 1849-1949\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSLV-655",
        "citation": "\"Utah, Salt Lake County Death Records, 1849-1949\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:NQH2-RXD : Wed Jan 15 19:02:19 UTC 2025), Entry for Jane Agnes Stewart and George, 26 Sep 1867."
      },
      {
        "title": "George in entry for Jane Agnes Stewart, \"Utah, Deaths and Burials, 1888-1946\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSLV-6Z9",
        "citation": "\"Utah, Deaths and Burials, 1888-1946\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:F85F-YNR : 28 January 2020), George in entry for Jane Agnes Stewart, 1867."
      },
      {
        "title": "George A Stuart, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MS23-R97",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSF-9L2G : Sat Sep 27 21:43:49 UTC 2025), Entry for George A Stuart and Daniel Stewart or Stuart, 1919."
      },
      {
        "title": "Daniel Stewart in entry for George Stuart, \"Utah, Pioneers and Prominent Men of Utah, 1847-1868\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMZZ-8N7",
        "citation": "\"Utah, Pioneers and Prominent Men of Utah, 1847-1868\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KL71-MPB : Sat Mar 09 11:37:16 UTC 2024), Entry for George Stuart and Daniel Stewart."
      },
      {
        "title": "George Stuart, \"United States Census, 1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMC2-L1Z",
        "citation": "\"United States, Census, 1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MLH1-1N8 : Wed Oct 29 21:03:18 UTC 2025), Entry for George Stuart and Mary E Stuart, 1910."
      },
      {
        "title": "Millennium File",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSL7-N81",
        "citation": ""
      },
      {
        "title": "Legacy NFS Source: George H Stuart - Church record: Marriage record or certificate: birth-name: Georg Stuart",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MS6Z-8V2",
        "citation": "Church, IGI, Page number: Film # 178060 Ref # 3186"
      },
      {
        "title": "Legacy NFS Source: George H Stuart - birth-name: George H Stuart",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MS6Z-8NJ",
        "citation": ""
      },
      {
        "title": "George Stuart in entry for Jemima Evans Stuart, \"Idaho, Death Certificates, 1911-1937\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMC2-LVJ",
        "citation": "\"Idaho, Death Certificates, 1911-1937\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:FLTG-8JC : Thu Feb 27 18:01:10 UTC 2025), Entry for Jemima Evans Stuart and Thomas L. Evans, 18 Feb 1937."
      },
      {
        "title": "George Stuart, \"United States Census, 1900\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMC2-G37",
        "citation": "\"United States, Census, 1900\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MM5T-ZZR : Fri Jan 17 20:12:38 UTC 2025), Entry for George Stuart and Mary Stuart, 1900."
      },
      {
        "title": "George Stuart, \"United States Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMC2-GLS",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M4ZJ-KCZ : Wed Sep 09 07:33:39 UTC 2026), Entry for George Stuart and Mary Stuart, 1880."
      }
    ],
    "portrait": "/ancestors/portraits/036_KWNK-S2X.jpg"
  },
  {
    "id": "I416",
    "name": "Daniel Monroe Stuart",
    "sex": "M",
    "gen": 6,
    "slot": 8,
    "side": "paternal",
    "birthplace": "england",
    "childId": "I212",
    "birthYear": 1820,
    "deathYear": 1904,
    "birthDate": "3 May 1820",
    "deathDate": "21 Aug 1904",
    "burialDate": "23 Aug 1904",
    "christeningDate": "21 May 1820",
    "birthPlace": "Lancaster, Lancashire, England, United Kingdom",
    "deathPlace": "Salt Lake City, Salt Lake, Utah, United States",
    "burialPlace": "Salt Lake City Cemetery, Salt Lake City, Salt Lake, Utah, United States",
    "christeningPlace": "St. Marys, Lancaster, Lancashire, England, United Kingdom",
    "fsId": "KWJC-65K",
    "photo": "/ancestors/bubbles/072_KWJC-65K.jpg",
    "living": false,
    "alternateNames": [
      "Daniel Monroe Stewart"
    ],
    "facts": [
      {
        "kind": "Blessing",
        "date": "December 0001",
        "place": null,
        "note": null
      },
      {
        "kind": "Baptism",
        "date": "1 December 1844",
        "place": null,
        "note": null
      },
      {
        "kind": "Immigration",
        "date": "20 February 1848",
        "place": "Liverpool, Lancashire, England, United Kingdom",
        "note": null
      },
      {
        "kind": "Seventy Ordination",
        "date": "1852",
        "place": null,
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1870",
        "place": "Utah, United States",
        "note": null
      },
      {
        "kind": "Mission",
        "date": "1878",
        "place": "United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1880",
        "place": "Salt Lake City, Salt Lake, Utah, United States",
        "note": null
      },
      {
        "kind": "High Priest Ordination",
        "date": "27 June 1891",
        "place": null,
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1900",
        "place": "Salt Lake, Utah, United States",
        "note": null
      },
      {
        "kind": "Other",
        "date": null,
        "place": null,
        "note": null
      },
      {
        "kind": "Residence",
        "date": null,
        "place": "Salt Lake City, Salt Lake, Utah, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": null,
        "place": "Salt Lake, Utah, United States",
        "note": null
      },
      {
        "kind": "Membership",
        "date": null,
        "place": "Salt Lake, Utah, United States",
        "note": "The Church of Jesus Christ of Latter-day Saints"
      },
      {
        "kind": "Membership",
        "date": null,
        "place": "Utah, United States",
        "note": null
      }
    ],
    "sketch": "LIFE OF DANIEL STUART\nBorn 1820\n\nWritten in his own words as told to his daughter, Christiana Stuart Pomeroy\n\nI, Daniel Stuart, was born May 3, 1820, at Lancaster, Lancashire, England. My Father's name was John Stuart and my mother's Christiana Monroe (Christian Munro on the records). I was the youngest of ten children. My father was a weaver of carpets and worked for his daily bread.\n\nI never had a chance to go to school, only to a night school for a short time. In Kendal I went to work at about the age of seven, setting the cards for making the wool ready to spin into yarn. I then worked in a carpet factory for a short time. At the age of fourteen I had a a chance to learn to be a boot and shoemaker and there I worked for 7 years and learned my trade. I worked hard at my trade, saving to be able to go to America to be with the \"chosen people of God.\" (the Mormons in Kendal met in an upper room in the \"Westmoreland House.\"Annals of Kendal, Nicholson, 1861)\n\nOn March 20, 1844, at the age of 24, I married Agnes Huddlestone. ( was baptised 1 December 1844---the same year he was married) At Overstaveley, Westmoreland, England on February 27, 1845 our first child was born, a son, George. He weighed less than 3 Pounds at birth but grew up to be a large man.(this was my great great grandfather).\n\nWe left home to start for Utah February 14, 1848. Our second child, a daughter, was born enroute at Liverpool, February 17, 1848. We christened her Margaret Ann Kanatta.\n\nThe ship sailed on February 20, 1848. The name of the ship was \"Kanatta.\" The captain's name was McKinsey. It was an American three-mast ship. The president of the Company was Franklin W. Richards. His first counselor was his brother Samuel Richards. His second counselor Wheelcock and his third counselor was Andrew Coohan.\n\nWe sailed into the British Channel and it was very stormy. While we were yet in the channel, the lookout warned the captain that danger was ahead. The captain gave orders to sailors and all ablebodied men to put to the ropes. After the danger was over the captain told us three more lengths of the ship and we would have been dashed upon the rocks.\n\nWe had a death in the company, an old man. He was wrapped in a canavas and put on a plank and dropped into the sea.\n\nWe landed at New Orleans, having been on the sea 8 weeks and 3 days. After leaving the ship we took the steamboat \"Mustang\" up the Missouri river to Winter quarters, Iowa. We stayed there for some time, but could not get work to do at my trade so decided to go down to St. Joseph where I could get work to make money enough to continue on our way to Utah.\n\nOur daughter died on the way down and was buried at a village called Savanna.\n\nSt. Joseph was a small town. My wife and I were sick with ague, a 3 day plague of chills and fever. We were strangers in a strange land but the Lord opened the way. I called at a house and asked if they could give us a lodging as we had no money to pay for one. We had sold our clothes for the trip down. The lady that came to the door looked at us-- my wife, my son George and myself. She said, \"You all look sick, what is the matter with you?\" I told her of our sickness and our trouble and she told me to go to the blacksmith shop and see what her husband would have to say. I went and he returned to his home with me. I said, \"We will lie on the floor.\" He said, \"No, you and your wife and son shall sleep on the bed, my boys and I shall take the floor, we are all well.\" So we were housed for the night through God's mercy.\n\nIn the morning I started out to look for work. I soon met a man going to work and said to him, \"Can you tell me where I can find a shoe shop? I want work.\" He asked where I had come from and I told him England. He replied, \"We do peg work here.\" I told him that a man had come over to England and showed me his peg shoes and I asked him if he would trade me his pair of peg shoes for a new pair of sewed ones, which he gladly did. I took the peg shoes all apart to find out how they were made and then made myself a pair of peg boots. I said to the man, \"I have them on.\" After seeing them he said, \"I will give you work.\"\n\nI worked steadily, and we prospered. I soon opened a shop of my own. Not long after opening my shop I had a chance to sell to good advantage. I sold land bought three yoke of oxen and provisions to take us across the plains to Utah. I was now on the lookout for a man to drive us across the plains as I well knew that I could not drive oxen. It was not my trade and I had been brought up to think every man to his trade. In May, 1850, I met a Mr. Hanson Tuttle. He was a member of the Battalion, capable of driving the oxen and also very anxious to go to Utah. We went to a small place called Bethlehem where a company of about fifty Latter Day Saints was formed. The Captain of the company was Milo Andrus. We started on June 1, 1850. When we came to a river we couldn't cross we made rafts and pulled the wagons and people over. I took my turn standing guard at night. We made a circle of our wagons for better protection against Indian attacks, all the cattle were kept inside the enclosure. We gathered buffalo chips for fuel.\n\nOn August 1 (30 according to Emigration records; Journal History, Church Office Building) 1850, we landed in Salt Lake City. We rented a room in the Fort and spent the winter. In the spring we bought a part of a lot on Main Street. We put four posts in the ground, put quilts around them, using a sheet for a roof. This was our living room. A covered wagon box served as a bedroom. In this covered wagon on June 4, 1851, our third child, Christiana Monroe was born.\n\nIn the spring of 1853 there was trouble with the Indians down in the southern part of the territory, Iron County. The Indians were driving the people from their homes and taking possession. President Young called for volunteers. I volunteered and was called out with the militia. We followed President Young's instructions and only drove the Indians out of the homes that they had seized, but did not follow them back into the mountains. The waring band, at that time was known as the Walker band.\n\nOn November 24, 1853, our daughter Zina Agnes, was born.\n\nIn 1854 I was called on a mission to settle Carson Valley. (Plant crops, etc.) Eighty families were going to settle in the valley, Colonel Reese had charged of the so-called Mormon Station.\n\nBrother Nine and I opened a shop together, he doing the tailoring, I boot and shoe making. We were the only two men of the 80 that did not have their wives so we batched together. Orson Hyde was our President. I was there 18 months (I have an article from the 1856 Deseret News announcing his return from the Washoe Valley, Carson County).\n\nOn October 10, 1878, I left for a mission to the Southern States. I labored under many trying difficulties but came out victorious. I was upheld in all I undertook by my Heavenly Father and His Son, Jesus Christ, and the power of the Priesthood bestowed upon me. I returned in August 1879 and was sick with scurvy, caused from lack of vegetables, the winter had been a hard one and vegetables were not often obtainable. Parley Pratt Junior and I labored together.\n\nIn the fall of 1879, I opened a grocery Store, known as Stuart and Son. In 1891 I retired from active business. The following clipping was in the Salt Lake paper in October 1903:\n\n\"Father Stuart's generous gift wiped out debt of $2,750 on the Twenty-eighth Ward meeting house and is pleasantly remembered.\n\nDaniel Stuart, and 84 year old resident of the 28th Ward, has earned the gratitude of the bishopric and residents of that eccleasiastical section of Salt Lake by donating the sum of $2, 750 toward the new chapel recently completed in the Ward. When the subscription list was circulated upon the congregation of the ward from the 22 Ward, 'Father' Stuart put his name down for $500. This week he relieved the members of all indebtedness on their place of worship by payment in full of a note which was held by Zion's Savings Bank and Trust Co., amounting to $2,500. The Chapel, including the site, cost $8,000. The Chapel is situated on Third North between Sixth and Seventh West Streets and is a modern up-t-date place of worship and thoroughly finished with an eye to the artistic. In recognition of the munificent gift of 'Father\" Stuart, the people of the ward met last night in their beautiful edifice and gave him a hearty reception and banquet. A very creditable program of songs, recitations and speeches was also given. Bishop William McMillan states that the people ofhis ward are unanimous in their praise of the whole-souled action of \"Father\" Stuart in so quickly raising the indebtedness off their place of worship.\"\n\nDaniel Stuart died August 21, 1904, at the age of 84, buried in the City Cemetery. He was survived by three living children, George Stuart of Malad City, Idaho; Mrs. Chrisitiana M. S. (Munro Stuart) Pomeroy, Mrs. Zina A. S. (Agnes Stuart) Watkins of this city. Also 29 grandchildren and 26 great-grandchildren.",
    "sources": [
      {
        "title": "Immigration",
        "href": "https://www.familysearch.org/tree/sources/viewedit/W47F-HD9",
        "citation": ""
      },
      {
        "title": "Daniel Stuart, \"Early Mormon Missionaries\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/92C9-FYV",
        "citation": "\"Daniel Stuart\", Early Mormon Missionaries, accessed June 26, 2017, https://history.lds.org/missionary/individual/daniel-stuart-1820"
      },
      {
        "title": "Daniel Stewart, \"The Church of Jesus Christ of Latter-day Saints, Missionary Registers (Worldwide), 1860-1937\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9572-MFV",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Missionary Registers (Worldwide), 1860-1937\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QKDW-TJ28 : Tue Mar 11 16:22:45 UTC 2025), Entry for Daniel Stewart and Wm Stewart, 1878."
      },
      {
        "title": "Dan'l Stuart, \"Utah, Salt Lake, Salt Lake City, Cemetery Records, 1847-1976\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SYLD-LJ2",
        "citation": "\"Utah, Salt Lake, Salt Lake City, Cemetery Records, 1847-1976\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:ZD7Z-D26Z : Sat Mar 09 10:09:48 UTC 2024), Entry for Dan'l Stuart, 23 Aug 1904."
      },
      {
        "title": "Dan'l Stuart, \"Utah, Salt Lake, Salt Lake City, Cemetery Records, 1847-1976\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SYLD-GS8",
        "citation": "\"Utah, Salt Lake, Salt Lake City, Cemetery Records, 1847-1976\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:ZXK3-FYMM : Sat Mar 09 17:21:33 UTC 2024), Entry for Dan'l Stuart, 23 Aug 1904."
      },
      {
        "title": "Daniel Stewart, \"England, Cumbria, Parish Registers, 1538-1990\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SVFV-1R8",
        "citation": "\"England, Cumbria, Parish Registers, 1538-1990\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:4G6B-Q7W2 : Mon Sep 14 22:54:29 UTC 2026), Entry for Daniel Stewart and John Stewart, 26 May 1844."
      },
      {
        "title": "Daniel Stuart, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QWHR-Z7S",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6JZP-T9NT : Sat Sep 12 23:42:14 UTC 2026), Entry for Daniel Stuart."
      },
      {
        "title": "Daniel Stuart, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QCT8-R62",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:685T-T6CW : Sun Sep 13 05:49:54 UTC 2026), Entry for Daniel Stuart and Wm Stuart."
      },
      {
        "title": "Daniel Stewart, \"England, Cumbria, Parish Registers, 1538-1990\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SVFK-3Y3",
        "citation": "\"England, Cumbria, Parish Registers, 1538-1990\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:4GH1-XXZM : Mon Sep 14 23:12:58 UTC 2026), Entry for Daniel Stewart and John Stewart, 26 May 1844."
      },
      {
        "title": "Daniel M Stuart, \"Find A Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9KY5-PP4",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2S3-V56M : Thu Oct 01 22:38:01 UTC 2026), Entry for Daniel M Stuart."
      },
      {
        "title": "Daniel Stuart, \"The Church of Jesus Christ of Latter-day Saints, Missionary Registers (Worldwide), 1860-1937\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9572-M5V",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Missionary Registers (Worldwide), 1860-1937\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QKDW-RRB7 : Tue Mar 11 16:22:48 UTC 2025), Entry for Daniel Stuart and Wm Stuart, 1878."
      },
      {
        "title": "Daniel Stewart, \"England, Cumbria, Parish Registers, 1538-1990\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SVFK-9L4",
        "citation": "\"England, Cumbria, Parish Registers, 1538-1990\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:7D6W-753Z : Mon Sep 14 23:12:58 UTC 2026), Entry for Daniel Stewart and John Stewart, 26 May 1844."
      },
      {
        "title": "Daniel Stewart, \"England, Cumbria, Parish Registers, 1538-1990\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SVFK-WPR",
        "citation": "\"England, Cumbria, Parish Registers, 1538-1990\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:7TDV-2DMM : Mon Sep 14 23:31:02 UTC 2026), Entry for Daniel Stewart and Agnes Huddleston, 19 May 1844."
      },
      {
        "title": "Daniel Stewart, \"England, Cumbria, Parish Registers, 1538-1990\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SPM6-22P",
        "citation": "\"England, Cumbria, Parish Registers, 1538-1990\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:HM1C-PNZM : Mon Sep 14 23:31:01 UTC 2026), Entry for Daniel Stewart and Agnes Huddleston, 19 May 1844."
      },
      {
        "title": "Daniel Stuart, \"Utah, Pioneers and Prominent Men of Utah, 1847-1868\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3C3D-MPW",
        "citation": "\"Utah, Pioneers and Prominent Men of Utah, 1847-1868\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KL71-MPR : Sat Mar 09 10:39:50 UTC 2024), Entry for Daniel Stuart."
      },
      {
        "title": "Daniel Stuart, \"Utah, Salt Lake County Death Records, 1849-1949\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/75T5-D91",
        "citation": "\"Utah, Salt Lake County Death Records, 1849-1949\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:NQHX-2BQ : Mon Jul 08 12:34:46 UTC 2024), Entry for Daniel Stuart and John Stuart, 21 Aug 1904."
      },
      {
        "title": "Daniel Stewart, \"England, Cumbria, Parish Registers, 1538-1990\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SVFK-72L",
        "citation": "\"England, Cumbria, Parish Registers, 1538-1990\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:7DDJ-TNN2 : Mon Sep 14 22:54:29 UTC 2026), Entry for Daniel Stewart and John Stewart, 26 May 1844."
      },
      {
        "title": "Daniel Stewart, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7FXH-34M",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6JYR-H3NT : Fri Mar 27 01:54:47 UTC 2026), Entry for Zina Agnes Lambourne and Daniel Stewart."
      },
      {
        "title": "Daniel Stuart, \"Utah, Deaths and Burials, 1888-1946\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S2V2-L4H",
        "citation": "\"Utah, Deaths and Burials, 1888-1946\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:HFYL-1CN2 : 28 January 2020), Daniel Stuart, 1904."
      },
      {
        "title": "Daniel Stuart, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QCT8-YCF",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6D1H-396N : Sat Sep 12 23:38:29 UTC 2026), Entry for Daniel Stuart and Wm Stuart."
      },
      {
        "title": "Deseret Evening News, Article dated 22 August 1904: \"Daniel Stuart Dead\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9D1S-3BC",
        "citation": "Deseret Evening News, 22 August, 1904"
      },
      {
        "title": "Legacy NFS Source: Daniel M. Stuart - Government record: Death record or certificate: burial: 21 August 1904; Salt Lake City, Salt Lake, Utah, United States",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MS68-HS7",
        "citation": "Government office, Utah vital records"
      },
      {
        "title": "Legacy NFS Source: Daniel M. Stuart - birth-name: Daniel M Stuart",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MS68-H93",
        "citation": ""
      },
      {
        "title": "Pioneers And Prominent Men of Utah, Volume 2 ... (#496)",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M99X-VMF",
        "citation": "\"Pioneers And Prominent Men of Utah, Volume 2 ... (#496).\" Pioneers And Prominent Men of Utah, Volume 2 ... (#496). N.p., n.d. Web. 12 May. 2014.."
      },
      {
        "title": "Daniel Stewart or Stuart, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/982D-N2Q",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSF-9L2G : Sat Sep 27 21:43:49 UTC 2025), Entry for George A Stuart and Daniel Stewart or Stuart, 1919."
      },
      {
        "title": "Daniel Stuart, \"The Church of Jesus Christ of Latter-day Saints, Missionary Registers (Worldwide), 1860-1937\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9XRW-11K",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Missionary Registers (Worldwide), 1860-1937\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QKDW-YDDB : Tue Mar 11 16:25:28 UTC 2025), Entry for George Stuart and Edwin D Woolley, 1894."
      },
      {
        "title": "Daniel Stewart in entry for George Stuart, \"Utah, Pioneers and Prominent Men of Utah, 1847-1868\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9Z3V-JD3",
        "citation": "\"Utah, Pioneers and Prominent Men of Utah, 1847-1868\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KL71-MPB : Sat Mar 09 11:37:16 UTC 2024), Entry for George Stuart and Daniel Stewart."
      },
      {
        "title": "Daniel Stuart, \"Utah, Mormon Pioneer Overland Travel Database, 1847-1868\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9DZL-SQ5",
        "citation": "\"Utah, Mormon Pioneer Overland Travel Database, 1847-1868\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QK9B-ZSYK : Wed Feb 19 20:20:37 UTC 2025), Entry for Daniel Stuart, 22 Sep 1861."
      },
      {
        "title": "Daniel Stuart, \"England Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M99F-1CP",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:NXH4-FPN : 4 February 2023), Daniel Stuart, 1820."
      },
      {
        "title": "Daniel Stuart, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9Z3V-V19",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZPV-VBS : Mon Feb 03 19:05:11 UTC 2025), Entry for Daniel Stuart and John Stuart, 21 Aug 1904."
      },
      {
        "title": "Daniel Stewart, \"United States, Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZBJ-HGZ",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MNSV-BQJ : Wed Sep 09 14:50:08 UTC 2026), Entry for Daniel Stewart and Agnes Stewart, 1880."
      },
      {
        "title": "Daniel Stuart, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/98Y9-RFS",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZG1-LV6 : Mon Feb 03 19:22:21 UTC 2025), Entry for Zina Agnes Watkins and Daniel Stuart, 09 Sep 1930."
      },
      {
        "title": "Daniel Stewart, \"England Marriages, 1538–1973\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M95W-C9M",
        "citation": "\"England Marriages, 1538–1973\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:NXJV-LXK : Sat Aug 01 18:00:08 UTC 2026), Entry for Daniel Stewart and John Stewart, 26 May 1844."
      },
      {
        "title": "Daniel Stuart, \"United States, Census, 1900\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9Z3V-KKF",
        "citation": "\"United States, Census, 1900\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MMRL-5GH : Sat Oct 18 05:10:48 UTC 2025), Entry for Daniel Stuart and Aness Stuart, 1900."
      },
      {
        "title": "Don Stewart, \"United States, Census, 1870\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9NVR-RW6",
        "citation": "\"United States, Census, 1870\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MNCT-R8W : Sun Oct 19 13:26:11 UTC 2025), Entry for Don Stewart and Agness Stewart, 1870."
      },
      {
        "title": "Daniel Stuart, \"Utah, Salt Lake County Death Records, 1849-1949\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9Z3V-FFL",
        "citation": "\"Utah, Salt Lake County Death Records, 1849-1949\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:NQ4Y-J4B : Sat Mar 09 07:33:57 UTC 2024), Entry for Zina Agnes Watkins and Daniel Stuart, 09 Sep 1930."
      },
      {
        "title": "Daniel Stuart, \"Utah, Mormon Pioneer Overland Travel Database, 1847-1868\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9DZL-SY9",
        "citation": "\"Utah, Mormon Pioneer Overland Travel Database, 1847-1868\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QK9B-HLVQ : Wed Feb 19 20:42:14 UTC 2025), Entry for Daniel Stuart, 30 Aug 1850."
      },
      {
        "title": "Daniel Stuart, \"England Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M9M7-B9Y",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:NXNY-6BW : 20 September 2026), Daniel Stuart, 1820."
      },
      {
        "title": "Daniel Stuart, \"The Church of Jesus Christ of Latter-day Saints, Missionary Registers (Worldwide), 1860-1937\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9XR4-MNH",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Missionary Registers (Worldwide), 1860-1937\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QKDW-YKHS : Tue Mar 11 16:23:10 UTC 2025), Entry for George Stuart and Woolley, 1905."
      },
      {
        "title": "Daniel Stuart in entry for Zina Agnes Watkins, \"Utah, Deaths and Burials, 1888-1946\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9Z3V-6R3",
        "citation": "\"Utah, Deaths and Burials, 1888-1946\", , FamilySearch (https://www.familysearch.org/ark:/61903/1:1:F85C-2MH : 22 September 2026), Daniel Stuart in entry for Zina Agnes Watkins, 1930."
      },
      {
        "title": "Daniel Stuart in entry for Christiana Monroe Pomeroy, \"Utah, Deaths and Burials, 1888-1946\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MM4W-K6Z",
        "citation": "\"Utah, Deaths and Burials, 1888-1946\", , FamilySearch (https://www.familysearch.org/ark:/61903/1:1:F85W-RGJ : 22 September 2026), Daniel Stuart in entry for Christiana Monroe Pomeroy, 1923."
      },
      {
        "title": "Daniel Stuart in entry for Christiana Monroe Pomeroy, \"Utah Death Certificates, 1904-1956\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MM4W-KJM",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZG2-4BD : Mon Feb 03 19:18:21 UTC 2025), Entry for Christiana Monroe Pomeroy and Daniel Stuart, 16 Nov 1923."
      },
      {
        "title": "Daniel Stuart in entry for Christiana Monroe Pomeroy, \"Utah, Salt Lake County Death Records, 1908-1949\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MM4W-KHZ",
        "citation": "\"Utah, Salt Lake County Death Records, 1849-1949\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:NQH4-JBZ : Thu Mar 07 14:10:30 UTC 2024), Entry for Christiana Monroe Pomeroy and Daniel Stuart, 16 Nov 1923."
      }
    ],
    "portrait": "/ancestors/portraits/072_KWJC-65K.jpg"
  },
  {
    "id": "I412",
    "name": "Agnes Huddleston",
    "sex": "F",
    "gen": 6,
    "slot": 9,
    "side": "paternal",
    "birthplace": "england",
    "childId": "I212",
    "birthYear": 1821,
    "deathYear": 1903,
    "birthDate": "17 Aug 1821",
    "deathDate": "3 Jul 1903",
    "burialDate": "6 Jul 1902",
    "christeningDate": "2 Sep 1821",
    "birthPlace": "Grassgarth, Westmorland, England, United Kingdom",
    "deathPlace": "City Park, Salt Lake City, Salt Lake, Utah, United States",
    "burialPlace": "Salt Lake City Cemetery, Salt Lake City, Salt Lake, Utah, United States",
    "christeningPlace": "Hugill, Westmorland, England, United Kingdom",
    "fsId": "KWVP-PWZ",
    "photo": "/ancestors/bubbles/073_KWVP-PWZ.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [
      {
        "kind": "Baptism",
        "date": "2 September 1821",
        "place": "Cumberland, England, United Kingdom",
        "note": null
      },
      {
        "kind": "Immigration",
        "date": "20 February 1848",
        "place": null,
        "note": "Liverpool, England to New Orleans, United States"
      },
      {
        "kind": "Residence",
        "date": "1870",
        "place": "Utah, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Immigration",
        "href": "https://www.familysearch.org/tree/sources/viewedit/W4QZ-5HW",
        "citation": "Liverpool to New Orleans 20 Feb 1848 - 20 Apr 1848"
      },
      {
        "title": "Agnes Stuart - Pioneer Overland Travel",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3QP3-HH8",
        "citation": ""
      },
      {
        "title": "Agnes Huddlston, \"The Church of Jesus Christ of Latter-day Saints, Missionary Registers (Worldwide), 1860-1937\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9XR4-MX3",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Missionary Registers (Worldwide), 1860-1937\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QKDW-YKHS : Tue Mar 11 16:23:10 UTC 2025), Entry for George Stuart and Woolley, 1905."
      },
      {
        "title": "Agnes Huddlestone, \"England, Cumbria, Parish Registers, 1538-1990\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SVFK-Q3Y",
        "citation": "\"England, Cumbria, Parish Registers, 1538-1990\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:4GH1-XXZM : Mon Sep 14 23:12:58 UTC 2026), Entry for Daniel Stewart and John Stewart, 26 May 1844."
      },
      {
        "title": "Agnes Huddleston, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7FXH-3ZR",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6JYR-H3NT : Fri Mar 27 01:54:47 UTC 2026), Entry for Zina Agnes Lambourne and Daniel Stewart."
      },
      {
        "title": "Agnes H Stuart, \"Utah, Salt Lake County Death Records, 1849-1949\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S4LR-GSM",
        "citation": "\"Utah, Salt Lake County Death Records, 1849-1949\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:NQHB-QH6 : Mon Dec 08 01:05:20 UTC 2025), Entry for Agnes H Stuart and Adam Huddleston, 03 Jul 1903."
      },
      {
        "title": "Agnes Huddleston, \"England, Cumbria, Parish Registers, 1538-1990\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SVFK-M99",
        "citation": "\"England, Cumbria, Parish Registers, 1538-1990\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:4G6B-Q7W2 : Mon Sep 14 22:54:29 UTC 2026), Entry for Daniel Stewart and John Stewart, 26 May 1844."
      },
      {
        "title": "Agnes H. Stuart, \"Utah, Deaths and Burials, 1888-1946\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SP4T-MH5",
        "citation": "\"Utah, Deaths and Burials, 1888-1946\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:HFY2-VTZM : 28 January 2020), Agnes H. Stuart, 1903."
      },
      {
        "title": "Agnes Huddlestone Stuart, \"Utah, Mormon Pioneer Overland Travel Database, 1847-1868\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9DZL-QGB",
        "citation": "\"Utah, Mormon Pioneer Overland Travel Database, 1847-1868\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QK9B-HLV3 : Wed Feb 19 20:19:59 UTC 2025), Entry for Agnes Huddlestone Stuart, 30 Aug 1850."
      },
      {
        "title": "Agness Huddleston, \"England, Cumbria, Parish Registers, 1538-1990\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SVFK-34L",
        "citation": "\"England, Cumbria, Parish Registers, 1538-1990\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:7TDM-R46Z : Mon Sep 14 23:27:04 UTC 2026), Entry for Agness Huddleston and Adam Huddleston, 2 Sep 1821."
      },
      {
        "title": "Agnes Huddlestone, \"England, Cumbria, Parish Registers, 1538-1990\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SVFK-7XQ",
        "citation": "\"England, Cumbria, Parish Registers, 1538-1990\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:7DDJ-TNN2 : Mon Sep 14 22:54:29 UTC 2026), Entry for Daniel Stewart and John Stewart, 26 May 1844."
      },
      {
        "title": "Agnes Huddleston, \"The Church of Jesus Christ of Latter-day Saints, Missionary Registers (Worldwide), 1860-1937\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9XRW-1TV",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Missionary Registers (Worldwide), 1860-1937\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QKDW-YDDB : Tue Mar 11 16:25:28 UTC 2025), Entry for George Stuart and Edwin D Woolley, 1894."
      },
      {
        "title": "Agness Stewart, \"United States, Census, 1870\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9NVR-R8W",
        "citation": "\"United States, Census, 1870\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MNCT-R8W : Sun Oct 19 13:26:11 UTC 2025), Entry for Don Stewart and Agness Stewart, 1870."
      },
      {
        "title": "Agnes Huddlestone, \"England, Cumbria, Parish Registers, 1538-1990\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SVFK-9X1",
        "citation": "\"England, Cumbria, Parish Registers, 1538-1990\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:7D6W-753Z : Mon Sep 14 23:12:58 UTC 2026), Entry for Daniel Stewart and John Stewart, 26 May 1844."
      },
      {
        "title": "Agnes Huddlestone in entry for George A Stuart, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9K42-S1C",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSF-9L2G : Sat Sep 27 21:43:49 UTC 2025), Entry for George A Stuart and Daniel Stewart or Stuart, 1919."
      },
      {
        "title": "Agnes Huddleston, \"England, Cumbria, Parish Registers, 1538-1990\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SP4R-1S6",
        "citation": "\"England, Cumbria, Parish Registers, 1538-1990\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:41D6-XH2M : Mon Sep 14 23:27:04 UTC 2026), Entry for Agnes Huddleston and Adam Huddleston, 2 Sep 1821."
      },
      {
        "title": "Agnes Huddlestone Stuart, \"Utah, Mormon Pioneer Overland Travel Database, 1847-1868\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9DZL-QCH",
        "citation": "\"Utah, Mormon Pioneer Overland Travel Database, 1847-1868\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QK9B-ZSYJ : Wed Feb 19 20:20:37 UTC 2025), Entry for Agnes Huddlestone Stuart, 22 Sep 1861."
      },
      {
        "title": "Agnes Huddlestone, \"England and Wales, Census, 1841\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S37L-BP5",
        "citation": "\"England and Wales, Census, 1841\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M77K-NL3 : Tue Sep 08 21:49:00 UTC 2026), Entry for Adam Huddlestone and Margaret Huddlestone, 1841."
      },
      {
        "title": "Agnes Huddleston, \"England, Cumbria, Parish Registers, 1538-1990\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SVFK-WJQ",
        "citation": "\"England, Cumbria, Parish Registers, 1538-1990\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:7TDV-2DMM : Mon Sep 14 23:31:02 UTC 2026), Entry for Daniel Stewart and Agnes Huddleston, 19 May 1844."
      },
      {
        "title": "Agnes Huddleston, \"England, Cumbria, Parish Registers, 1538-1990\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SPM6-2RW",
        "citation": "\"England, Cumbria, Parish Registers, 1538-1990\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:HM1C-PNZM : Mon Sep 14 23:31:01 UTC 2026), Entry for Daniel Stewart and Agnes Huddleston, 19 May 1844."
      },
      {
        "title": "Legacy NFS Source: Agnes Huddleston - birth-name: Agnes Huddleston",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MS66-FRL",
        "citation": ""
      },
      {
        "title": "Agnes Huddlestone in entry for Christiana Monroe Pomeroy, \"Utah Death Certificates, 1904-1956\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MM4W-KJ4",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZG2-4BD : Mon Feb 03 19:18:21 UTC 2025), Entry for Christiana Monroe Pomeroy and Daniel Stuart, 16 Nov 1923."
      },
      {
        "title": "Agnes Stewart, \"United States, Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZBJ-HDQ",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MNSV-BQJ : Wed Sep 09 14:50:08 UTC 2026), Entry for Daniel Stewart and Agnes Stewart, 1880."
      },
      {
        "title": "Agnes Huddleston, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/98Y9-RDL",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZG1-LV6 : Mon Feb 03 19:22:21 UTC 2025), Entry for Zina Agnes Watkins and Daniel Stuart, 09 Sep 1930."
      },
      {
        "title": "Agnes Huddlestone in entry for Christiana Monroe Pomeroy, \"Utah, Deaths and Burials, 1888-1946\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MM4W-K6N",
        "citation": "\"Utah, Deaths and Burials, 1888-1946\", , FamilySearch (https://www.familysearch.org/ark:/61903/1:1:F85W-RGV : 22 September 2026), Agnes Huddlestone in entry for Christiana Monroe Pomeroy, 1923."
      },
      {
        "title": "Agnes Huddleston, \"Utah, Salt Lake County Death Records, 1849-1949\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9Z3V-FDR",
        "citation": "\"Utah, Salt Lake County Death Records, 1849-1949\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:NQ4Y-J4B : Sat Mar 09 07:33:57 UTC 2024), Entry for Zina Agnes Watkins and Daniel Stuart, 09 Sep 1930."
      },
      {
        "title": "Aness Stuart in household of Daniel Stuart, \"United States Census, 1900\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9Z3V-2NF",
        "citation": "\"United States, Census, 1900\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MMRL-5GH : Sat Oct 18 05:10:48 UTC 2025), Entry for Daniel Stuart and Aness Stuart, 1900."
      },
      {
        "title": "Agnes Huddlestone, \"England Marriages, 1538–1973\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZBJ-2X2",
        "citation": "\"England Marriages, 1538–1973\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:NXJV-LXK : Sat Aug 01 18:00:08 UTC 2026), Entry for Daniel Stewart and John Stewart, 26 May 1844."
      },
      {
        "title": "Agnes Huddlestone, \"England and Wales, Marriage Registration Index, 1837-2005\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZBJ-5HF",
        "citation": "\"England and Wales, Marriage Registration Index, 1837-2005,\" database, FamilySearch (https://familysearch.org/ark:/61903/1:1:2DZX-NVG : 13 December 2014), Agnes Huddlestone, 1844; from \"England & Wales Marriages, 1837-2005,\" database, findmypast (http://www.findmypast.com : 2012); citing 1844, quarter 2, vol. 25, p. 487, Kendal, Westmorland, England, General Register Office, Southport, England."
      },
      {
        "title": "Agnes Huddlestone in entry for Christiana Monroe Pomeroy, \"Utah, Salt Lake County Death Records, 1908-1949\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MM4W-KHJ",
        "citation": "\"Utah, Salt Lake County Death Records, 1849-1949\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:NQH4-JBZ : Thu Mar 07 14:10:30 UTC 2024), Entry for Christiana Monroe Pomeroy and Daniel Stuart, 16 Nov 1923."
      },
      {
        "title": "Agnes Huddleston in entry for Zina Agnes Watkins, \"Utah, Deaths and Burials, 1888-1946\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9Z3V-6LR",
        "citation": "\"Utah, Deaths and Burials, 1888-1946\", , FamilySearch (https://www.familysearch.org/ark:/61903/1:1:F85C-2MC : 22 September 2026), Agnes Huddleston in entry for Zina Agnes Watkins, 1930."
      },
      {
        "title": "Agness Huddleston, \"Utah, Pioneers and Prominent Men of Utah, 1847-1868\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9Z3V-N3C",
        "citation": "\"Utah, Pioneers and Prominent Men of Utah, 1847-1868\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KL71-MPB : Sat Mar 09 11:37:16 UTC 2024), Entry for George Stuart and Daniel Stewart."
      },
      {
        "title": "Agnes H. Stuart, \"Utah, Deaths and Burials, 1888-1946\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZRH-DMN",
        "citation": "\"Utah, Deaths and Burials, 1888-1946\", database, FamilySearch (https://familysearch.org/ark:/61903/1:1:F858-9GS : 28 January 2020), Agnes H. Stuart, 1903."
      },
      {
        "title": "Agnes Huddleston, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZBJ-6BN",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:NR9F-RJV : 5 February 2023), Agnes Huddleston, 1821."
      }
    ],
    "portrait": "/ancestors/portraits/073_KWVP-PWZ.jpg"
  },
  {
    "id": "I208",
    "name": "Jemima Evans",
    "sex": "F",
    "gen": 5,
    "slot": 5,
    "side": "paternal",
    "birthplace": "wales",
    "childId": "I81",
    "birthYear": 1849,
    "deathYear": 1937,
    "birthDate": "1 Apr 1849",
    "deathDate": "18 Feb 1937",
    "burialDate": "22 Feb 1937",
    "christeningDate": null,
    "birthPlace": "Llanguick, Glamorgan, Wales",
    "deathPlace": "Malad, Oneida, Idaho, United States",
    "burialPlace": "Malad, Oneida, Idaho, United States",
    "christeningPlace": null,
    "fsId": "KWNK-S2F",
    "photo": "/ancestors/bubbles/037_KWNK-S2F.jpg",
    "living": false,
    "alternateNames": [
      "Gemima Evans",
      "Jemmina Evans"
    ],
    "facts": [
      {
        "kind": "Residence",
        "date": "1851",
        "place": "Llangiwg, Glamorgan, Wales, United Kingdom",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1861",
        "place": "Llangiwg, Glamorgan, Wales, United Kingdom",
        "note": null
      },
      {
        "kind": "Immigration",
        "date": "29 August 1866",
        "place": null,
        "note": null
      },
      {
        "kind": "Immigration",
        "date": "29 August 1866",
        "place": "Utah, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1870",
        "place": "Malad, Oneida, Idaho, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1880",
        "place": "Malad, Oneida, Idaho, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1910",
        "place": "Malad, Oneida, Idaho, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1920",
        "place": "Malad, Oneida, Idaho, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1930",
        "place": "Malad, Oneida, Idaho, United States",
        "note": null
      },
      {
        "kind": "Obituary",
        "date": "1937",
        "place": "Idaho, United States",
        "note": null
      },
      {
        "kind": "Financial Transaction",
        "date": null,
        "place": "Utah, United States",
        "note": null
      }
    ],
    "sketch": "Stuart, Jemima (Evans) - Biography\n\nMalad Valley Pioneers\nJEMIMA STUART\n(Written by Joe Wms. in 1939)\nMrs. Jemima Stuart was born in North Gemshire, South Wales on April 1, 1850.  She was the daughter of Thomas L. Evans and Jane Davis Evans.  Her parent’s nationality was Welsh.\nJemima Evans Stuart was baptized into the LDS church when she was eight years old.  She was 16 years of age when she came to America.  In May 1866, Jemima Stuart and her mother and brother, Ben D. Evans sailed from Wales on a ship called John Bright.  The voyage from Wales to New York City took six weeks and three days.  She then traveled by land to St. Joseph, Mo., then she and her mother and brother joined a wagon train led by Captain Tom Ricks which was bound for Salt Lake City, Utah.  This train was the first wagon train to make this westward journey drawn by a mule team.  They were met at Salt Lake City by her father, Thomas L. Evans, and sister, Mary, who came from Wales a short time before the rest of the family.  Then they came to Malad where Mrs. Stuart has lived ever since.\nThe only schooling she had was when she was in Wales.  The school which she attended was run by a company operating an iron works.  The teacher was Evan Jones.  Mrs. Stuart would walk two miles and if any of the children were late they would get two or three whips on the hand.  They were taught to respect their parents and teacher.\nWhen Mrs. Stuart came to this country there was a mail route which went up Bannock Street and six log houses which had dirt roofs and floors.  She lived in a dug-out.  It was built like a cellar with a dirt roof and was on the corner where Professor Powell now lives.\nShe had on outstanding ambition and it was to be a good seamstress, her father being a tailor in the old country.\nShe was married to George Stuart on April 8, 1874.  The ceremony took place in the old Endowment House in Salt Lake City, Utah.\nMrs. Jemima Stuart was the mother of seven children:  Thomas Stuart, William Stuart, Evan Stuart, Sarah Fallis and Jemima Stuart Opperman of Malad; Zina Robetaille of Klamath Falls, Oregon and Agnes Barnett of Plymouth, Ut.  She has 37 grandchildren and 20 great grandchildren.\nMrs. Stuart has taken an active part in the LDS church since she was a young girl.  She has been a Relief Society teacher since she was 17 years of age.  She has donated to the building of churches and public buildings in this town.  She has seen many outstanding improvements during her life, the automobile, radio, and airplane being the most important.\nThe persons having the most influence over Mrs. Stuart’s life were Mrs. Richard Jones, Mrs. Ellen Colton and Mrs. Evans, the mother of D.L. Evans Sr. \nOne outstanding accomplishment during her life was rearing a large family of her own; also Daniel W. Stuart, a son of her nephew.\nIncidents experienced during her life which are the most important are:  The Civil War, World War and the flu epidemic of 1918-19.\nMrs. Stuart’s advice to young people of today is:  “Be honest and live so that everyone will admire and trust you.” \nImmigrants:\n\n\nEvans, Jemima\n\nComments:\n\n\nNo comments.\n\n© 2014 Center for Family History and Genealogy at Brigham Young University. All rights reserved.",
    "sources": [
      {
        "title": "Jemima Evans, \"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QWH7-N55",
        "citation": "\"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6KWJ-P1GZ : Sat Jul 04 01:47:55 UTC 2026), Entry for William E Stuart and George Stuart."
      },
      {
        "title": "Jemmie E Stuart, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3DC6-HXZ",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:8Q54-WYPZ : Fri Aug 01 20:33:20 UTC 2025), Entry for Jemmie E Stuart, 1914."
      },
      {
        "title": "Jemima Evans Stuart, \"Idaho, Southern Counties Obituaries, 1943-2013\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3W14-HRS",
        "citation": "\"Idaho, Southern Counties Obituaries, 1943-2013\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QLWF-W31Z : Thu Oct 17 16:14:38 UTC 2024), Entry for Evan Stuart and George Stuart."
      },
      {
        "title": "Jemima Evans Stuart, \"Utah, Box Elder, Brigham City Family History Center, Obituary Collection, 1930-2016\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SY7W-1H9",
        "citation": "\"Utah, Box Elder, Brigham City Family History Center, Obituary Collection, 1930-2016\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:84LW-6F6Z : Thu Feb 12 16:40:23 UTC 2026), Entry for Mrs. Agnes Stuart Burnett and Howard Capener, Bishop, 1965."
      },
      {
        "title": "Saints by Sea: Jemima Evans",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SPLQ-FZF",
        "citation": "Brigham Young University, Saints by Sea. Jemima Evans entry, age 17, arrived 6 June 1866 on the John Bright."
      },
      {
        "title": "Welsh Mormon Profile for Jemima Evans",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SPLQ-F9Q",
        "citation": ""
      },
      {
        "title": "Research Log for Jemima Evans by BYU Center for Family History and Genealogy",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SPLQ-XXS",
        "citation": ""
      },
      {
        "title": "Jemimia Stuart, \"United States, Census, 1930\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SPVR-LMH",
        "citation": "\"United States, Census, 1930\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XH6M-8BM : Mon Jan 20 13:52:30 UTC 2025), Entry for Jemimia Stuart, 1930."
      },
      {
        "title": "Jamima Stewart, \"United States, Census, 1920\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SPVR-N52",
        "citation": "\"United States, Census, 1920\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MDCB-GQ7 : Fri Oct 02 19:04:37 UTC 2026), Entry for Jamima Stewart and Daniel W Stewart, 1920."
      },
      {
        "title": "Jamima Stuart, \"United States, Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SPVR-WZL",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M4ZJ-FCX : Wed Sep 09 03:06:07 UTC 2026), Entry for and Julia Gibson, 1880."
      },
      {
        "title": "Jennie Evens, \"United States, Census, 1870\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SPVL-3C8",
        "citation": "\"United States, Census, 1870\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MZYB-TRG : Sun Jan 19 13:52:47 UTC 2025), Entry for Thomas Evens and Jane Evens, 1870."
      },
      {
        "title": "Jemimah Evans, \"The Church of Jesus Christ of Latter-day Saints, Perpetual Emigrating Fund Company Financial Accounts (Worldwide), 1849-1886\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SPD6-4BW",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Perpetual Emigrating Fund Company Financial Accounts (Worldwide), 1849-1886\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:CQBY-C2PZ : Fri Feb 21 19:14:52 UTC 2025), Entry for Jemimah Evans."
      },
      {
        "title": "Kemima Evans Stuart, \"Utah, Box Elder, Tremonton and Garland Obituaries, 1959-2013\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SK6D-MBD",
        "citation": "\"Utah, Box Elder, Tremonton and Garland Obituaries, 1959-2013\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2QP-Y9KN : Thu Oct 09 21:46:11 UTC 2025), Entry for Mr Evan Stuart and George Stuart."
      },
      {
        "title": "Jemema Evans, \"England and Wales, Census, 1851\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S8B5-2MT",
        "citation": "\"England and Wales, Census, 1851\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:SG82-MDL : Sat Aug 22 06:51:22 UTC 2026), Entry for Thomas Evans and Jane Evans, 1851."
      },
      {
        "title": "Jemima Stuart, \"United States, Census, 1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S4N2-4RB",
        "citation": "\"United States, Census, 1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MLH1-1N6 : Wed Oct 29 21:03:19 UTC 2025), Entry for Jemima Stuart and Jemima Stuart, 1910."
      },
      {
        "title": "Jamima Evans, \"England and Wales, Census, 1861\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9YLT-T78",
        "citation": "\"England and Wales, Census, 1861\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M74N-Q2P : Thu Sep 10 04:18:28 UTC 2026), Entry for Benjamin Evans and Jamima Evans, 1861."
      },
      {
        "title": "Jemima Evans Stuart in entry for Mr William Evans Stuart, \"Utah, Tremonton and Garland Obituaries, 1959-2013\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9G1Q-9JJ",
        "citation": "\"Utah, Box Elder, Tremonton and Garland Obituaries, 1959-2013\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2QP-T114 : Wed Oct 08 03:19:15 UTC 2025), Entry for Mr William Evans Stuart and George Stuart, 1962."
      },
      {
        "title": "Jemima Evans Stuart in entry for William Evans Stuart, \"Idaho, Southern Counties Obituaries, 1943-2013\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9G13-1D1",
        "citation": "\"Idaho, Southern Counties Obituaries, 1943-2013\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QLWX-JV1M : Wed Jun 04 22:31:26 UTC 2025), Entry for William Evans Stuart and George Stuart."
      },
      {
        "title": "Jemima Evans, \"Idaho, Death Certificates, 1938-1961\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9XRW-Y95",
        "citation": "\"Idaho, Death Certificates, 1938-1961\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2M1-5JFL : Fri Feb 21 22:47:55 UTC 2025), Entry for Sarah Stuart Fallis and George Stuart, 2 Apr 1959."
      },
      {
        "title": "Jemima Evans, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9XF5-FQ6",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSF-9G83 : Sat Sep 27 21:43:52 UTC 2025), Entry for William Evans Stuart and George Stewart, 1962."
      },
      {
        "title": "Millennium File",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSL7-NX2",
        "citation": ""
      },
      {
        "title": "1900 United States Federal Census",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSL7-NXK",
        "citation": "Year: 1900; Census Place: Malad, Oneida, Idaho; Roll: 234; Page: 3A; Enumeration District: 0092; FHL microfilm: 1240234"
      },
      {
        "title": "Jemima Evans, \"Utah, Mormon Pioneer Overland Travel Database, 1847-1868\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9X9M-68K",
        "citation": "\"Utah, Mormon Pioneer Overland Travel Database, 1847-1868\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QK9B-CGGB : Wed Feb 19 20:42:44 UTC 2025), Entry for Jemima Evans, 29 Aug 1866."
      },
      {
        "title": "Jemima Evans Stuart, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9X9M-D6C",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVK3-NQR1 : Sun Oct 04 14:56:06 UTC 2026), Entry for Jemima Evans Stuart."
      },
      {
        "title": "Jemima Evans, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9X9M-ZYH",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QKDV-X43B : Thu Mar 07 03:54:58 UTC 2024), Entry for Jemima Opperman and George Stuart, 03 Dec 1963."
      },
      {
        "title": "Jemima Evans Stuart, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSG3-F59",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSF-9LR6 : Sat Sep 27 21:43:50 UTC 2025), Entry for Jemima Evans Stuart and Thomas Lewis Evans, 1937."
      },
      {
        "title": "Jemima Evans, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSG3-F28",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZPN-HQH : Mon Feb 03 19:23:06 UTC 2025), Entry for Thomas Stuart and George Stuart, 14 Jan 1944."
      },
      {
        "title": "Jemima Stuart, \"BillionGraves Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSG3-FF8",
        "citation": "\"BillionGraves Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KCXB-3G9 : Thu Sep 24 22:38:28 UTC 2026), Entry for Jemima Stuart."
      },
      {
        "title": "Jemima Evans Stuart, \"Idaho, Southern Counties Obituaries, 1943-2013\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSG3-XFX",
        "citation": "\"Idaho, Southern Counties Obituaries, 1943-2013\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSD-38XJ : Thu Sep 19 19:23:10 UTC 2024), Entry for Mrs Jemima Opperman and George Stuart."
      },
      {
        "title": "Jemina Evans, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSG3-8KV",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSX-8JGF : Sat Sep 27 20:45:52 UTC 2025), Entry for Jemima Stuart Opperman and George Stewart, 1963."
      },
      {
        "title": "Jemina Evans, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSLB-5BW",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVS6-WNPX : Sat Sep 27 18:58:36 UTC 2025), Entry for Sarah Stuart Fallis and George Stewart, 1959."
      },
      {
        "title": "Jemima Evans, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSLR-44X",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSF-9LK3 : Sat Sep 27 21:43:47 UTC 2025), Entry for Evan Stuart and George Stewart, 1975."
      },
      {
        "title": "Jemima Evans, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSLP-S2J",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSF-9GC9 : Sat Sep 27 21:43:53 UTC 2025), Entry for Thomas Evans Stuart and George Stewart, 1944."
      },
      {
        "title": "Legacy NFS Source: Jemima Evans - Individual or family possessions: birth: 1 April 1850; Llan-Giwg, Glamorgan, Wales, United Kingdom",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MS6Z-82X",
        "citation": ""
      },
      {
        "title": "Legacy NFS Source: Jemima Evans - birth-name: Jemima Evans",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MS6Z-8KP",
        "citation": ""
      },
      {
        "title": "Grave site of Jemima E. Stuart",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMC2-PP4",
        "citation": "Malad City Cemetary"
      },
      {
        "title": "Jemima Stuart in household of George Stuart, \"United States Census, 1900\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMC2-G35",
        "citation": "\"United States, Census, 1900\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MM5T-ZZR : Fri Jan 17 20:12:38 UTC 2025), Entry for George Stuart and Mary Stuart, 1900."
      },
      {
        "title": "Jemima Evans Stuart, \"Idaho, Death Certificates, 1911-1937\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMC2-LNR",
        "citation": "\"Idaho, Death Certificates, 1911-1937\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:FLTG-8JC : Thu Feb 27 18:01:10 UTC 2025), Entry for Jemima Evans Stuart and Thomas L. Evans, 18 Feb 1937."
      }
    ],
    "portrait": "/ancestors/portraits/037_KWNK-S2F.jpg"
  },
  {
    "id": "I402",
    "name": "Thomas Lewis Evans",
    "sex": "M",
    "gen": 6,
    "slot": 10,
    "side": "paternal",
    "birthplace": "wales",
    "childId": "I208",
    "birthYear": 1809,
    "deathYear": 1893,
    "birthDate": "21 Aug 1809",
    "deathDate": "2 Feb 1893",
    "burialDate": "5 Feb 1893",
    "christeningDate": null,
    "birthPlace": "Talley, Carmarthenshire, Wales, United Kingdom",
    "deathPlace": "Malad, Oneida, Idaho",
    "burialPlace": "Malad, Oneida, Idaho, United States",
    "christeningPlace": null,
    "fsId": "KWVC-4PB",
    "photo": "/ancestors/bubbles/074_KWVC-4PB.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [
      {
        "kind": "Residence",
        "date": "1861",
        "place": "Glamorgan, Wales, United Kingdom",
        "note": null
      },
      {
        "kind": "Obituary",
        "date": "1893",
        "place": "Idaho, United States",
        "note": null
      },
      {
        "kind": "Financial Transaction",
        "date": null,
        "place": "Utah, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Pioneer Database: Thomas Lewis Evans",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SPL3-RKM",
        "citation": "Church History Department, Pioneer Database. Thomas Lewis Evans entry, William S. Warren Company (1864)."
      },
      {
        "title": "Saints by Sea: Thomas Lewis Evans",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SPL3-R95",
        "citation": "Brigham Young University, Saints by Sea. Thomas Evans entry, age 53, arrived 23 June 1864 on the General McClellan."
      },
      {
        "title": "Welsh Mormon Profile for Thomas Lewis Evans",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SPL3-PY1",
        "citation": ""
      },
      {
        "title": "Research Log for Thomas Lewis Evans by BYU Center for Family History and Genealogy",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SPL3-P48",
        "citation": ""
      },
      {
        "title": "England & Wales, FreeBMD Marriage Index, 1837-1915",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9D4H-RDH",
        "citation": ""
      },
      {
        "title": "1871 Wales Census",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9D4H-R8B",
        "citation": "Class: RG10; Piece: 5543; Folio: 46; Page: 2; GSU roll: 850861"
      },
      {
        "title": "U.S., Find A Grave Index, 1600s-Current",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9D4H-R82",
        "citation": ""
      },
      {
        "title": "1840 Map of Carmarthenshire",
        "href": "https://www.familysearch.org/tree/sources/viewedit/98GC-5X4",
        "citation": "A Vision of Britain Through Time: http://www.visionofbritain.org.uk/maps/sheet/os_unions_1830s_1840_sw/Caermarthen_1830_1840"
      },
      {
        "title": "1851 England, Wales & Scotland Census King Street, Llanguick, Neath, Glamorganshire, Wales",
        "href": "https://www.familysearch.org/tree/sources/viewedit/98LG-DH7",
        "citation": "1851 England, Wales & Scotland Census King Street, Llanguick, Neath, Glamorganshire, Wales"
      },
      {
        "title": "1851 England, Wales & Scotland Census Transcription King Street, Llanguick, Neath, Glamorganshire, Wales",
        "href": "https://www.familysearch.org/tree/sources/viewedit/98LG-DM2",
        "citation": "1851 England, Wales & Scotland Census Transcription King Street, Llanguick, Neath, Glamorganshire, Wales"
      },
      {
        "title": "Tho's. L. Evans, \"The Church of Jesus Christ of Latter-day Saints, Perpetual Emigrating Fund Company Financial Accounts (Worldwide), 1849-1886\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SPD6-MVN",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Perpetual Emigrating Fund Company Financial Accounts (Worldwide), 1849-1886\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:CQBY-RJN2 : Fri Feb 21 21:23:58 UTC 2025), Entry for Tho's. L. Evans."
      },
      {
        "title": "Thomas Evans, \"England and Wales, Census, 1861\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9YLT-RKK",
        "citation": "\"England and Wales, Census, 1861\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M74N-Q2P : Thu Sep 10 04:18:28 UTC 2026), Entry for Benjamin Evans and Jamima Evans, 1861."
      },
      {
        "title": "Thomas Evans, \"England and Wales, Census, 1851\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SPD6-6Y1",
        "citation": "\"England and Wales, Census, 1851\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:SG82-MDL : Sat Aug 22 06:51:22 UTC 2026), Entry for Thomas Evans and Jane Evans, 1851."
      },
      {
        "title": "Thomas Lewis Evans, \"BillionGraves Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9DLQ-673",
        "citation": "\"BillionGraves Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KCXB-4CT : Thu Sep 24 16:13:40 UTC 2026), Entry for Thomas Lewis Evans."
      },
      {
        "title": "Thomas Lewis Evans, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9XFP-CPZ",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QV21-26LD : Fri Oct 02 12:39:55 UTC 2026), Entry for Thomas Lewis Evans."
      },
      {
        "title": "Thomas L. Evans, \"BillionGraves Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9XFP-ZMJ",
        "citation": "\"BillionGraves Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVJR-QW8L : Thu Sep 24 22:18:48 UTC 2026), Entry for Thomas L. Evans."
      },
      {
        "title": "Thomas L Evans, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SPDN-TLX",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVS6-WHV6 : Sat Sep 27 18:57:45 UTC 2025), Entry for Thomas L Evans, 1893."
      },
      {
        "title": "Thomas L. Evans, \"Idaho, Death Certificates, 1911-1937\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/98GH-RMK",
        "citation": "\"Idaho, Death Certificates, 1911-1937\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:FLTG-8JC : Thu Feb 27 18:01:10 UTC 2025), Entry for Jemima Evans Stuart and Thomas L. Evans, 18 Feb 1937."
      },
      {
        "title": "Thomas Lewis Evans, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9D3C-7SR",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSF-9GQ3 : Sat Sep 27 21:43:50 UTC 2025), Entry for Mary Evans Stuart and Thomas Lewis Evans, 1934."
      },
      {
        "title": "Thomas L. Evans, \"BillionGraves Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9XFP-CJ5",
        "citation": "\"BillionGraves Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:2798-3CZ : Thu Sep 24 16:14:39 UTC 2026), Entry for Thomas L. Evans."
      },
      {
        "title": "1861 Census Transcription",
        "href": "https://www.familysearch.org/tree/sources/viewedit/98LG-Z2Z",
        "citation": "1861 England, Wales & Scotland Census Transcription 35, Ystalyfera, Llanguick, Neath, Glamorganshire, Wales"
      },
      {
        "title": "1861 England, Wales and Scotland Census",
        "href": "https://www.familysearch.org/tree/sources/viewedit/98LK-RTC",
        "citation": "1861 England, Wales & Scotland Census 35, Ystalyfera, Llanguick, Neath, Glamorganshire, Wales"
      },
      {
        "title": "Legacy NFS Source: Thomas Lewis Evans - Published information: Cemetery record or headstone: birth: 21 August 1905; Talley, Carmarthenshire, Wales",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MS6F-Q16",
        "citation": ""
      },
      {
        "title": "Legacy NFS Source: Thomas Lewis Evans - birth-name: Thomas Lewis Evans",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MS6F-QBF",
        "citation": ""
      },
      {
        "title": "Idaho Death Records 1904 to 1930",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMSJ-P68",
        "citation": "From Idaho Death Records 1904 to 1930"
      },
      {
        "title": "Thomas Lewis Evans, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSG3-FRN",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSF-9LR6 : Sat Sep 27 21:43:50 UTC 2025), Entry for Jemima Evans Stuart and Thomas Lewis Evans, 1937."
      },
      {
        "title": "Thomas Lewis Evans, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/989H-VHJ",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVS6-714D : Sat Sep 27 18:56:52 UTC 2025), Entry for Benjamin D Evans and Thomas Lewis Evans, 1928."
      },
      {
        "title": "Thomas Evens, \"United States, Census, 1870\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M9DG-QHS",
        "citation": "\"United States, Census, 1870\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MZYB-TRG : Sun Jan 19 13:52:47 UTC 2025), Entry for Thomas Evens and Jane Evens, 1870."
      },
      {
        "title": "Thos L. Evans, \"Idaho, Death Certificates, 1911-1937\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSG3-JL7",
        "citation": "\"Idaho, Death Certificates, 1911-1937\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:FLYH-J2L : Thu Feb 27 18:01:24 UTC 2025), Entry for Mary Stuart and Thos L. Evans, 12 Sep 1934."
      },
      {
        "title": "Thomas Evans, \"United States Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMYX-3X8",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M4ZJ-F4C : Wed Sep 09 09:58:27 UTC 2026), Entry for Thomas Evans and Jane Evans, 1880."
      },
      {
        "title": "Thomas D. Evans, \"Idaho, Death Certificates, 1911-1937\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M9DG-H3K",
        "citation": "\"Idaho, Death Certificates, 1911-1937\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:FLYM-SW3 : Wed Aug 05 16:47:03 UTC 2026), Entry for Benjamin D. Evans and Thomas D. Evans, 15 May 1928."
      }
    ],
    "portrait": "/ancestors/portraits/074_KWVC-4PB.jpg"
  },
  {
    "id": "I403",
    "name": "Jane Edward Davis",
    "sex": "F",
    "gen": 6,
    "slot": 11,
    "side": "paternal",
    "birthplace": "wales",
    "childId": "I208",
    "birthYear": 1805,
    "deathYear": 1890,
    "birthDate": "24 Feb 1805",
    "deathDate": "31 Jan 1890",
    "burialDate": "4 Feb 1890",
    "christeningDate": "1 Mar 1808",
    "birthPlace": "Llanelli, Carmarthenshire, Wales, United Kingdom",
    "deathPlace": "Malad, Oneida, Idaho, United States",
    "burialPlace": "Malad City Cemetery Malad City, Oneida, Idaho, United States",
    "christeningPlace": "Llanfynydd, Carmarthenshire, Wales, United Kingdom",
    "fsId": "KWVC-4PY",
    "photo": "/ancestors/bubbles/075_KWVC-4PY.jpg",
    "living": false,
    "alternateNames": [
      "Jane Davis Or Davies"
    ],
    "facts": [
      {
        "kind": "Residence",
        "date": "1851",
        "place": "Llangiwg, Glamorgan, Wales, United Kingdom",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1861",
        "place": "Llangiwg, Glamorgan, Wales, United Kingdom",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1870",
        "place": "Malad, Oneida, Idaho, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1880",
        "place": "Malad, Oneida, Idaho, United States",
        "note": null
      },
      {
        "kind": "Obituary",
        "date": "1890",
        "place": "Idaho, United States",
        "note": null
      },
      {
        "kind": "Financial Transaction",
        "date": null,
        "place": "Utah, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Pioneer Database: Jane Edward Davis/Davies",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SPLQ-M4J",
        "citation": "Church History Department, Pioneer Database. Jane Edward Davis Evans entry, Thomas E. Ricks Company (1866)."
      },
      {
        "title": "Saints by Sea: Jane Edward Davis/Davies",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SPL3-1G3",
        "citation": "Brigham Young University, Saints by Sea. Jane Evans entry, age 55, arrived 6 June 1866 on the John Bright."
      },
      {
        "title": "Welsh Mormon Profile for Jane Edward Davis/Davies",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SPL3-1S1",
        "citation": ""
      },
      {
        "title": "Research Log for Jane Edward Davis/Davies by BYU Center for Family History and Genealogy",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SPL3-BMD",
        "citation": ""
      },
      {
        "title": "Millennium File",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9DFP-9CH",
        "citation": ""
      },
      {
        "title": "1840 Carmarthen Marriages",
        "href": "https://www.familysearch.org/tree/sources/viewedit/98L2-7HJ",
        "citation": "1840 Carmarthen Marriages"
      },
      {
        "title": "Legacy NFS Source: Jane Edward Davis - Published information: Cemetery record or headstone: burial: 4 February 1890; Malad City Cemetery, Oneida, Idaho, United States",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MS6F-QYC",
        "citation": ""
      },
      {
        "title": "Legacy NFS Source: Jane Edward Davis - birth-name: Jane Edward Davis",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MS6F-QTL",
        "citation": ""
      },
      {
        "title": "Jane Davis, \"Idaho, Death Certificates, 1911-1937\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSG3-JL6",
        "citation": "\"Idaho, Death Certificates, 1911-1937\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:FLYH-J2L : Thu Feb 27 18:01:24 UTC 2025), Entry for Mary Stuart and Thos L. Evans, 12 Sep 1934."
      },
      {
        "title": "Jane Davis or Davies, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSG3-FT7",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSF-9LR6 : Sat Sep 27 21:43:50 UTC 2025), Entry for Jemima Evans Stuart and Thomas Lewis Evans, 1937."
      },
      {
        "title": "Jane Edwards, \"Idaho, Death Certificates, 1911-1937\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M9DG-H4N",
        "citation": "\"Idaho, Death Certificates, 1911-1937\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:FLYM-SW3 : Wed Aug 05 16:47:03 UTC 2026), Entry for Benjamin D. Evans and Thomas D. Evans, 15 May 1928."
      },
      {
        "title": "Jane Edward Davis Evans, \"BillionGraves Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/966C-N8M",
        "citation": "\"BillionGraves Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KCXB-9HG : Thu Sep 24 21:41:01 UTC 2026), Entry for Jane Edward Davis Evans and ."
      },
      {
        "title": "Jane Evens, \"United States, Census, 1870\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SPVL-S52",
        "citation": "\"United States, Census, 1870\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MZYB-TRG : Sun Jan 19 13:52:47 UTC 2025), Entry for Thomas Evens and Jane Evens, 1870."
      },
      {
        "title": "Jane Davis or Davies, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9D3C-7C9",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSF-9GQ3 : Sat Sep 27 21:43:50 UTC 2025), Entry for Mary Evans Stuart and Thomas Lewis Evans, 1934."
      },
      {
        "title": "Jane Evans, \"England and Wales, Census, 1851\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S8B5-26N",
        "citation": "\"England and Wales, Census, 1851\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:SG82-MDL : Sat Aug 22 06:51:22 UTC 2026), Entry for Thomas Evans and Jane Evans, 1851."
      },
      {
        "title": "Jane Davis Or Davies, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/987L-1R4",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVS6-714D : Sat Sep 27 18:56:52 UTC 2025), Entry for Benjamin D Evans and Thomas Lewis Evans, 1928."
      },
      {
        "title": "Jane Evans, \"The Church of Jesus Christ of Latter-day Saints, Perpetual Emigrating Fund Company Financial Accounts (Worldwide), 1849-1886\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SPD6-3X9",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Perpetual Emigrating Fund Company Financial Accounts (Worldwide), 1849-1886\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:CQBY-C22M : Fri Feb 21 21:27:27 UTC 2025), Entry for Jane Evans."
      },
      {
        "title": "Jane Evans, \"United States, Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M9DG-WN2",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M4ZJ-F4C : Wed Sep 09 09:58:27 UTC 2026), Entry for Thomas Evans and Jane Evans, 1880."
      },
      {
        "title": "Jane Evans, \"England and Wales, Census, 1861\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9YLT-RPK",
        "citation": "\"England and Wales, Census, 1861\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M74N-Q2P : Thu Sep 10 04:18:28 UTC 2026), Entry for Benjamin Evans and Jamima Evans, 1861."
      },
      {
        "title": "Jane D Evans, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SP2Y-G85",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVS6-W382 : Sat Sep 27 18:57:18 UTC 2025), Entry for Jane D Evans, 1890."
      },
      {
        "title": "Jane Davis in entry for Jemima Evans Stuart, \"Idaho, Death Certificates, 1911-1937\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMC2-LJN",
        "citation": "\"Idaho, Death Certificates, 1911-1937\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:FLTG-8JC : Thu Feb 27 18:01:10 UTC 2025), Entry for Jemima Evans Stuart and Thomas L. Evans, 18 Feb 1937."
      }
    ],
    "portrait": "/ancestors/portraits/075_KWVC-4PY.jpg"
  },
  {
    "id": "I74",
    "name": "Mary Ann Dredge Thomas",
    "sex": "F",
    "gen": 4,
    "slot": 3,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "I21",
    "birthYear": 1884,
    "deathYear": 1969,
    "birthDate": "16 Jun 1884",
    "deathDate": "1 Feb 1969",
    "burialDate": "5 Feb 1969",
    "christeningDate": "3 Jul 1884",
    "birthPlace": "Malad City, Oneida, Idaho Territory, United States",
    "deathPlace": "Ogden, Weber, Utah, United States",
    "burialPlace": "Malad City Cemetery, Malad, Oneida, Idaho, United States",
    "christeningPlace": "Malad, Oneida, Idaho Territory, United States",
    "fsId": "KWCT-3P7",
    "photo": "/ancestors/bubbles/019_KWCT-3P7.jpg",
    "living": false,
    "alternateNames": [
      "Mary A. Thomas",
      "Mary Ann Thomas",
      "Mary Ann Stuart"
    ],
    "facts": [
      {
        "kind": "Marriage",
        "date": "16 November 1904",
        "place": "Salt Lake City, Salt Lake, Utah, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1920",
        "place": "Malad, Oneida, Idaho, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1930",
        "place": "Malad, Oneida, Idaho, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1935",
        "place": "Malad, Oneida, Idaho, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1940",
        "place": "Malad Election Precinct 1, Oneida, Idaho, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1949",
        "place": "United States",
        "note": null
      },
      {
        "kind": "Obituary",
        "date": "1969",
        "place": "Idaho, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Maryann Stuart, \"United States, GenealogyBank Obituaries, Births, and Marriages, 1980-2015\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7X6L-RTX",
        "citation": "\"United States, GenealogyBank Obituaries, Births, and Marriages, 1980-2015\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6YL8-JL56 : Sun Jul 07 12:32:33 UTC 2024), Entry for Elsie Stuart Briggs and Annette Selders, 25 February 2020."
      },
      {
        "title": "Mary Ann Thomas, \"California, County Marriages, 1849-1957\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7X6L-538",
        "citation": "\"California, County Marriages, 1849-1957\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:K8KK-VY3 : Wed Jul 10 00:43:10 UTC 2024), Entry for George Adolfe Coenen and Joseph D Coenen, 08 Dec 1947."
      },
      {
        "title": "Mary Ann Thomas, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/747Y-TK2",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6PD8-LCD1 : Fri Mar 27 00:00:10 UTC 2026), Entry for Christie Stuart and William."
      },
      {
        "title": "Mary Ann Thomas, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/747Y-T41",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:65K3-ZDNR : Fri Mar 27 03:12:17 UTC 2026), Entry for Hanna Stuart and Gomer Hughes."
      },
      {
        "title": "Mary A Thomas, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/747Y-RJZ",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:62JJ-FZVX : Fri Mar 27 01:02:15 UTC 2026), Entry for William E Stuart and Henry I Mills."
      },
      {
        "title": "Mary A Thomas, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/747Y-R35",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6RTJ-3ZFJ : Fri Mar 27 01:23:23 UTC 2026), Entry for Christie Stuart and James McKay."
      },
      {
        "title": "Mary Ann Thomas, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/747Y-51G",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6PD8-LCZS : Fri Mar 27 00:00:39 UTC 2026), Entry for Christie Stuart and William."
      },
      {
        "title": "Mary Ann Thomas, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/747Y-5PJ",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:65LN-CR73 : Fri Mar 27 03:44:14 UTC 2026), Entry for Geo Bartho Stuart and William."
      },
      {
        "title": "Mary A Thomas, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/747Y-5V2",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6R1Z-FPYY : Fri Mar 27 03:44:39 UTC 2026), Entry for Jemima Stuart and William."
      },
      {
        "title": "Mary Ann Thomas, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/747Y-5XF",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6RT2-22CK : Fri Mar 27 00:25:22 UTC 2026), Entry for Jemima and William Stuart."
      },
      {
        "title": "Mary Ann Thomas in entry for Jess C Littlejohn and Jean Stuart, \"California, County Marriages, 1850-1952\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9P3W-RCS",
        "citation": "\"California, County Marriages, 1849-1957\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:K8JZ-4X7 : Wed Jul 10 00:34:20 UTC 2024), Entry for Jess C Littlejohn and Earl H Littlejohn, 19 May 1933."
      },
      {
        "title": "Mary A Thomas, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QJFF-CZ1",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:62WY-4W2Q : Fri Mar 27 03:39:09 UTC 2026), Entry for William Huddleson Stuart and William Stuart."
      },
      {
        "title": "Mary A Thomas, \"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QWXR-K18",
        "citation": "\"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6KWJ-SVPY : Wed Jul 01 11:57:40 UTC 2026), Entry for Grant Stuart and William Stuart."
      },
      {
        "title": "Mary A Thomas, \"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q7RC-XPS",
        "citation": "\"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6KWL-P4Y7 : Sat Jul 04 15:36:19 UTC 2026), Entry for Max T Stuart and William E Stuart."
      },
      {
        "title": "Mrs William Stuart, \"Utah, Box Elder, Tremonton and Garland Obituaries, 1959-2013\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q3DQ-XJX",
        "citation": "\"Utah, Box Elder, Tremonton and Garland Obituaries, 1959-2013\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2QP-5F31 : Sat Mar 09 12:54:40 UTC 2024), Entry for Boyd Stuart Mills and Mr Paul H Mills, 1967."
      },
      {
        "title": "Mary A Stuart, \"United States, Census, 1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/35TG-HCV",
        "citation": "\"United States, Census, 1950\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6XKK-YFWK : Mon Mar 17 19:01:42 UTC 2025), Entry for William E Stuart and Mary A Stuart, April 5, 1950."
      },
      {
        "title": "Mary Ann Thomas, \"California, County Marriages, 1849-1957\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3GV7-J31",
        "citation": "\"California, County Marriages, 1849-1957\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:K8JZ-4X7 : Wed Jul 10 00:34:20 UTC 2024), Entry for Jess C Littlejohn and Earl H Littlejohn, 19 May 1933."
      },
      {
        "title": "Mary Ann Stuart, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3WPF-8FQ",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:8WJG-YC2M : Mon Mar 30 07:16:37 UTC 2026), Entry for Mary Ann Stuart, 1914."
      },
      {
        "title": "Mary A Thomas Stuart, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3WPX-6L7",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:8W89-HV6Z : Mon Mar 30 05:35:10 UTC 2026), Entry for Mary A Thomas Stuart, 1920."
      },
      {
        "title": "Mary Ann Thomas Stuart, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3WPX-8FN",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:8WJ6-HY2M : Mon Mar 30 07:15:51 UTC 2026), Entry for Mary Ann Thomas Stuart, 1925."
      },
      {
        "title": "Mary Ann Thomas Stuart, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3WP6-1YN",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:8WJ6-HBPZ : Sun Mar 29 22:36:18 UTC 2026), Entry for Mary Ann Thomas Stuart, 1930."
      },
      {
        "title": "Mary Ann Thomas Stuart, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3SRN-GX7",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:8C22-Z12M : Mon Mar 30 05:40:03 UTC 2026), Entry for Mary Ann Thomas Stuart, 1940."
      },
      {
        "title": "Mary Ann Thomas Stuart, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3SRN-K6P",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:8WJ6-CMMM : Mon Mar 30 07:19:44 UTC 2026), Entry for Mary Ann Thomas Stuart, 1935."
      },
      {
        "title": "Mary Ann Thomas Stuart, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3SRN-69B",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:DL7T-373Z : Wed Oct 15 10:34:48 UTC 2025), Entry for William Evans Stuart and Mary Ann Thomas Stuart, 1950."
      },
      {
        "title": "Mary Ann Thomas Stuart, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3SRN-DHK",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:DJS4-R26Z : Fri Aug 01 19:25:23 UTC 2025), Entry for Mary Ann Thomas Stuart, 1955."
      },
      {
        "title": "Mary Ann Thomas Stuart, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3SRN-8ZM",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:DJ4R-443Z : Fri Aug 01 17:59:07 UTC 2025), Entry for Mary Ann Thomas Stuart, 1960."
      },
      {
        "title": "Mary Ann Thomas Stuart, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3SRN-ZHR",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:DJS4-R2W2 : Fri Aug 01 18:02:04 UTC 2025), Entry for Mary Ann Thomas Stuart, 1950."
      },
      {
        "title": "Ann Thomas Stuart, \"Utah, Box Elder, Tremonton and Garland Obituaries, 1959-2013\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3SMK-LZ9",
        "citation": "\"Utah, Box Elder, Tremonton and Garland Obituaries, 1959-2013\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2QP-T1QQ : Thu Oct 09 15:07:54 UTC 2025), Entry for George Bartho Stuart and William E Stuart, 1986."
      },
      {
        "title": "Mary Ann Dredge Thomas, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S1GB-PSY",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:73F2-VX3Z : Sun Mar 10 06:46:29 UTC 2024), Entry for Hannah Adelia Stuart Harris and William Evans Stuart, 1983."
      },
      {
        "title": "Mary Ann Thomas in entry for William H. Stuart, \"Utah, Marriages, 1887-1935\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SVG9-WYP",
        "citation": "\"Utah, Marriages, 1887-1935\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:HN81-JWN2 : 3 November 2021), Mary Ann Thomas in entry for William H. Stuart, 1940."
      },
      {
        "title": "Mary Ann Thomas, \"United States, Western States Marriage Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S4N2-JNF",
        "citation": "\"United States, Western States Marriage Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZV4-9Q7 : Tue Feb 11 23:16:39 UTC 2025), Entry for William E. Stuart and Mary Ann Thomas, 16 Nov 1904."
      },
      {
        "title": "Mary Ann Thomas Stuart, \"Idaho, Southern Counties Obituaries, 1943-2013\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9P6Y-3HF",
        "citation": "\"Idaho, Southern Counties Obituaries, 1943-2013\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QLWX-JV1M : Wed Jun 04 22:31:26 UTC 2025), Entry for William Evans Stuart and George Stuart."
      },
      {
        "title": "Mrs Mary Ann Thomas Stuart in entry for Mr William Evans Stuart, \"Utah, Tremonton and Garland Obituaries, 1959-2013\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9G19-N4F",
        "citation": "\"Utah, Box Elder, Tremonton and Garland Obituaries, 1959-2013\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2QP-T114 : Wed Oct 08 03:19:15 UTC 2025), Entry for Mr William Evans Stuart and George Stuart, 1962."
      },
      {
        "title": "Mary Ann Dredge Thomas in entry for William Huddlestone Stuart, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/92SY-ZFN",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSF-9G84 : Sat Sep 27 21:43:53 UTC 2025), Entry for William Huddlestone Stuart and William Evans Stuart, 1943."
      },
      {
        "title": "Mary Ann Thomas, \"Utah, County Marriages, 1871-1941\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9JL6-ZGK",
        "citation": "\"Utah, County Marriages, 1871-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2MY-D3FS : Wed Nov 19 05:25:27 UTC 2025), Entry for William H Stuart and William Stuart, 03 Jun 1940."
      },
      {
        "title": "Mary Ann Thomas, \"Utah, County Marriages, 1871-1941\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9F8F-6VT",
        "citation": "\"Utah, County Marriages, 1871-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VRLB-WMX : Thu Sep 19 19:33:25 UTC 2024), Entry for Paul H Mills and Henry I Mills, 29 Sep 1936."
      },
      {
        "title": "Mary Ann Thomas Stuart, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9XF5-NJ7",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVK8-4SLQ : Sun Oct 04 19:03:40 UTC 2026), Entry for Mary Ann Thomas Stuart."
      },
      {
        "title": "Mary Ann Dredge Thomas, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9XF5-FSL",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSF-9G83 : Sat Sep 27 21:43:52 UTC 2025), Entry for William Evans Stuart and George Stewart, 1962."
      },
      {
        "title": "Mary Ann Thomas, \"Utah, County Marriages, 1871-1941\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9XF5-F9C",
        "citation": "\"Utah, County Marriages, 1871-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KSGR-GQ9 : Thu Sep 19 19:05:54 UTC 2024), Entry for William E. Stuart and Mary Ann Thomas, 16 Nov 1904."
      },
      {
        "title": "Mary Ann Thomas in entry for William E. Stuart, \"Utah, Marriages, 1887-1935\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9XF5-XK4",
        "citation": "\"Utah, Marriages, 1887-1935\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:F8G2-N57 : 28 January 2020), Mary Ann Thomas in entry for William E. Stuart, 1904."
      },
      {
        "title": "Mary Ann Dredge Thomas, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9X9R-RZL",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVS6-F963 : Sat Sep 27 19:24:47 UTC 2025), Entry for Hannah Adelia Stuart Harris and William Evans Stuart, 1983."
      },
      {
        "title": "Mary A. Thompson in entry for George Ellis Harris, \"Utah, Marriages, 1887-1935\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9X9R-5JS",
        "citation": "\"Utah, Marriages, 1887-1935\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:F8G1-X41 : 28 January 2020), Mary A. Thompson in entry for George Ellis Harris, 1923."
      },
      {
        "title": "Mary A. Thompson, \"Utah, County Marriages, 1871-1941\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/96BY-TMW",
        "citation": "\"Utah, County Marriages, 1871-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KSP9-FMD : Thu Sep 19 18:58:39 UTC 2024), Entry for George Ellis Harris and Robert W. Harris, 28 Nov 1923."
      },
      {
        "title": "Mary Ann Dredge Thomas Stuart, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/984V-STQ",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSF-9G3Y : Sat Sep 27 21:43:50 UTC 2025), Entry for Mary Ann Dredge Thomas Stuart and George Sparry Thomas, 1969."
      },
      {
        "title": "Mary Ann Thomas, \"California, County Marriages, 1849-1957\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSLP-4DS",
        "citation": "\"California, County Marriages, 1849-1957\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:K8JX-MP3 : Wed Jul 10 00:35:29 UTC 2024), Entry for Bartho T Start and William Stuart, 21 Apr 1934."
      },
      {
        "title": "Mary Ann Stuart, \"United States, Census, 1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSLP-4Q8",
        "citation": "\"United States, Census, 1940\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VY4Y-MDJ : Wed Jan 15 22:33:05 UTC 2025), Entry for William E Stuart and Mary Ann Stuart, 1940."
      },
      {
        "title": "Mary A Stuart, \"United States, Census, 1930\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSLP-WRW",
        "citation": "\"United States, Census, 1930\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XH6M-PWR : Sun Oct 19 07:30:54 UTC 2025), Entry for William E Stuart and Mary A Stuart, 1930."
      },
      {
        "title": "Mary Ann Thomas, \"Texas, Deaths, 1890-1977\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSLP-QG7",
        "citation": "\"Texas, Deaths, 1890-1977\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KS15-GJL : Mon Jun 09 23:41:36 UTC 2025), Entry for William Huddleston Stuart and William E Stuart, 21 February 1943."
      },
      {
        "title": "Mary Ann Stewart, \"United States, Census, 1920\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSLP-Q4B",
        "citation": "\"United States, Census, 1920\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MDC1-MT3 : Fri Oct 02 19:04:03 UTC 2026), Entry for William E Stewart and Mary Ann Stewart, 1920."
      },
      {
        "title": "Mary Ann Dredge Thomas Grave Marker",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MM9M-XTX",
        "citation": "Find a grave website. Malad City Cemetery, Malad City, Oneida, Idaho, United States."
      },
      {
        "title": "Mary Ann Stuart in household of William H Stuart, \"United States Census, 1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MM9M-15C",
        "citation": "\"United States, Census, 1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MLH1-19R : Wed Oct 29 21:03:18 UTC 2025), Entry for William H Stuart and Mary Ann Stuart, 1910."
      },
      {
        "title": "Mary Ann Thomas in entry for William Huddleston Stuart, \"Texas Deaths, 1890-1976\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MM9M-1PK",
        "citation": "\"Texas Deaths, 1890-1976,\" , FamilySearch (https://familysearch.org/ark:/61903/1:1:JDTT-TD4 : 9 March 2018), Mary Ann Thomas in entry for William Huddleston Stuart, 21 Feb 1943; citing Amarillo, Potter, Texas, reference cn 9263, State Registrar Office, Austin; FHL microfilm 2,137,250."
      }
    ],
    "portrait": "/ancestors/portraits/019_KWCT-3P7.jpg"
  },
  {
    "id": "I184",
    "name": "George Sparry Thomas",
    "sex": "M",
    "gen": 5,
    "slot": 6,
    "side": "paternal",
    "birthplace": "wales",
    "childId": "I74",
    "birthYear": 1858,
    "deathYear": 1910,
    "birthDate": "7 Feb 1858",
    "deathDate": "8 Jan 1910",
    "burialDate": "1910",
    "christeningDate": "6 May 1858",
    "birthPlace": "Pembrey, Carmarthenshire, Wales, United Kingdom",
    "deathPlace": "Malad City, Oneida, Idaho, United States",
    "burialPlace": "Malad City Cemetery, Malad City, Oneida, Idaho, United States",
    "christeningPlace": "Pembrey, Carmarthenshire, Wales, United Kingdom",
    "fsId": "KW8T-GP3",
    "photo": "/ancestors/bubbles/038_KW8T-GP3.jpg",
    "living": false,
    "alternateNames": [
      "George Thomas",
      "George Sperry Thomas",
      "George S Thomas",
      "George Sparrey Thomas"
    ],
    "facts": [
      {
        "kind": "Residence",
        "date": "1861",
        "place": "Carmarthenshire, Wales, United Kingdom",
        "note": null
      },
      {
        "kind": "Baptism",
        "date": "7 February 1867",
        "place": null,
        "note": null
      },
      {
        "kind": "Immigration",
        "date": "29 August 1868",
        "place": "Utah, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1870",
        "place": "Malad, Oneida, Idaho, United States",
        "note": "Census"
      },
      {
        "kind": "High Priest Ordination",
        "date": "29 March 1908",
        "place": null,
        "note": null
      },
      {
        "kind": "Residence",
        "date": null,
        "place": "Malad, Oneida, Idaho, United States",
        "note": null
      },
      {
        "kind": "Membership",
        "date": null,
        "place": "Malad, Oneida, Idaho, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Geo Sparry Thomas, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7XXR-MX1",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:625R-P8DG : Sun Sep 13 00:14:48 UTC 2026), Entry for Geo Sparry Thomas and Francis M Dischamp."
      },
      {
        "title": "George S, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7WHN-LXM",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6PGN-BY2M : Thu Mar 26 20:02:53 UTC 2026), Entry for Geo Stanford Thomas and Thomas D Evans."
      },
      {
        "title": "Geo S, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/77JL-D8R",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6R5N-3NCR : Thu Mar 26 20:30:10 UTC 2026), Entry for Stephen Thomas and R J Harding."
      },
      {
        "title": "George S Thomas, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7QD8-4HW",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6GSK-J5WT : Thu Mar 26 18:39:36 UTC 2026), Entry for Elizabeth Thomas and Jesse H Dredge."
      },
      {
        "title": "George S, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7Q7T-XTW",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6PD8-518F : Fri Mar 27 03:34:08 UTC 2026), Entry for Steven Thomas and George S."
      },
      {
        "title": "George S Thomas, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QJDL-GBM",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:62WB-WM63 : Thu Mar 26 19:36:41 UTC 2026), Entry for George Stanford Thomas and George S Thomas."
      },
      {
        "title": "George S Thomas, \"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW97-7SL",
        "citation": "\"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6K4V-NJFV : Sun Jul 05 03:44:58 UTC 2026), Entry for George Walter Thomas and George S Thomas."
      },
      {
        "title": "Research Log for George Sparry Thomas",
        "href": "https://www.familysearch.org/tree/sources/viewedit/37KC-NN8",
        "citation": ""
      },
      {
        "title": "Welsh Saints Profile for George Sparry Thomas",
        "href": "https://www.familysearch.org/tree/sources/viewedit/37KC-FBY",
        "citation": ""
      },
      {
        "title": "Pioneer Database: George Sparry Thomas",
        "href": "https://www.familysearch.org/tree/sources/viewedit/37KC-MZ3",
        "citation": "Church History Department, Pioneer Database. George Sparrey Thomas entry, William S. Seeley Company (1868)."
      },
      {
        "title": "Saints by Sea: George Sparry Thomas",
        "href": "https://www.familysearch.org/tree/sources/viewedit/37KH-18Z",
        "citation": "Brigham Young University, Saints by Sea. George Thomas entry, age 10, arrived 12 July 1868 on the Minnesota."
      },
      {
        "title": "George Sparry Thomas, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SB4W-ZS8",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QPSC-XZB7 : Sat Mar 09 20:58:35 UTC 2024), Entry for Nora Thomas Harris and George Sparry Thomas, 1931."
      },
      {
        "title": "George Thomas, \"Wales, Glamorganshire, Parish Registers, 1538-1912\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SPRG-8MC",
        "citation": "\"Wales, Glamorganshire, Parish Registers, 1538-1912\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KCB3-2WR : Sun Dec 07 08:03:39 UTC 2025), Entry for George Thomas and Sarah Griffiths."
      },
      {
        "title": "George Thomas, \"United States, Western States Marriage Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SP4X-12C",
        "citation": "\"United States, Western States Marriage Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZJC-LZP : Tue Feb 11 22:33:46 UTC 2025), Entry for George Thomas and Hannah Dredge, 28 Mar 1881."
      },
      {
        "title": "George Thomas, \"Idaho, County Marriages, 1864-1962\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SP4X-YZ5",
        "citation": "\"Idaho, County Marriages, 1864-1962\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2Z2-WSK7 : Wed Jul 31 23:15:35 UTC 2024), Entry for George Thomas and Hannah Dredge, 28 Mar 1881."
      },
      {
        "title": "George Thomas, \"United States, Census, 1870\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SKBG-HBS",
        "citation": "\"United States, Census, 1870\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MZYB-G5J : Thu Jan 16 20:22:15 UTC 2025), Entry for Hugh Thomas and Mary A Thomas, 1870."
      },
      {
        "title": "George Sperry Thomas, \"Utah, Marriages, 1887-1935\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SK7Y-FV5",
        "citation": "\"Utah, Marriages, 1887-1935\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:HN85-8VN2 : 28 January 2020), George Sperry Thomas, 1897."
      },
      {
        "title": "George S. Thomas, \"United States, Western States Marriage Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SZHB-FJL",
        "citation": "\"United States, Western States Marriage Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZZ1-259 : Tue Feb 11 23:09:07 UTC 2025), Entry for George S. Thomas and Sarah A. Griffiths, 27 May 1897."
      },
      {
        "title": "Geo. S. Thomas in entry for Virnon G. Thomas, \"Idaho, Deaths and Burials, 1907-1965\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SQNT-B3W",
        "citation": "\"Idaho, Deaths and Burials, 1907-1965\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:FW81-7MR : 18 March 2020), Geo. S. Thomas in entry for Virnon G. Thomas, 1911."
      },
      {
        "title": "George Thomas, \"England and Wales, Census, 1861\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/95VC-ZB3",
        "citation": "\"England and Wales, Census, 1861\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M7HP-Z5V : Thu Sep 10 02:17:49 UTC 2026), Entry for Hugh Thomas and Mary Thomas, 1861."
      },
      {
        "title": "George S Thomas, \"Utah, County Marriages, 1871-1941\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9PX5-VDF",
        "citation": "\"Utah, County Marriages, 1871-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:X2BC-76K : Sun Mar 10 08:13:20 UTC 2024), Entry for George S Thomas and Sarah A Griffiths, 02 Jun 1897."
      },
      {
        "title": "George Sparrey Thomas, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9PX5-VWM",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSF-3NCV : Sat Sep 27 21:49:06 UTC 2025), Entry for George Stanford Thomas and George Sparrey Thomas, 1950."
      },
      {
        "title": "George S Thomas, \"BillionGraves Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9KR7-XXD",
        "citation": "\"BillionGraves Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVJR-SXW1 : Thu Sep 24 23:14:30 UTC 2026), Entry for George S Thomas."
      },
      {
        "title": "George S Thomas, \"Find A Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9K24-LGK",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QV26-DD61 : Fri Oct 02 06:34:32 UTC 2026), Entry for George S Thomas, 1910."
      },
      {
        "title": "George S Thomas in entry for George Thomas, \"Idaho Death Certificates, 1938-1961\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9VG1-3PN",
        "citation": "\"Idaho, Death Certificates, 1938-1961\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2M1-V1FL : Fri Feb 21 22:43:45 UTC 2025), Entry for George Thomas and George S Thomas, 6 Jan 1950."
      },
      {
        "title": "George Hugh Thomas in entry for Nora Thomas Harris, \"Idaho Death Certificates, 1911-1937\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9VGB-H61",
        "citation": "\"Idaho, Death Certificates, 1911-1937\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:FLBH-58C : Thu Feb 27 18:03:24 UTC 2025), Entry for Nora Thomas Harris and George Hugh Thomas, 04 May 1931."
      },
      {
        "title": "George S Thomas, \"Utah, Box Elder, Tremonton and Garland Obituaries, 1959-2013\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9NGC-LCD",
        "citation": "\"Utah, Box Elder, Tremonton and Garland Obituaries, 1959-2013\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2QP-PSRV : Fri Jul 12 19:47:19 UTC 2024), Entry for Elizabeth Griffiths Thomas Johnson and George S Thomas, 1969."
      },
      {
        "title": "George Sperry Thomas, \"Idaho, Birth Index, 1861-1911\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9F67-6CH",
        "citation": "\"Idaho, Birth Index, 1861-1911\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2M1-3WSR : Fri Feb 14 22:13:47 UTC 2025), Entry for George Walter Thomas and George Sperry Thomas, 05 Jan 1882."
      },
      {
        "title": "George Sperry Thomas, \"Idaho, Birth Index, 1861-1911\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9F67-4TW",
        "citation": "\"Idaho, Birth Index, 1861-1911\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2M1-33MB : Fri Feb 14 22:15:19 UTC 2025), Entry for Steven Griffiths Thomas and George Sperry Thomas, 18 Oct 1906."
      },
      {
        "title": "George Sparrey Thomas, \"Utah, Mormon Pioneer Overland Travel Database, 1847-1868\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9XJR-HX5",
        "citation": "\"Utah, Mormon Pioneer Overland Travel Database, 1847-1868\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QK9B-C53N : Wed Feb 19 20:20:55 UTC 2025), Entry for George Sparrey Thomas, 29 Aug 1868."
      },
      {
        "title": "George Sparry Thomas, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/984V-SP2",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSF-9G3Y : Sat Sep 27 21:43:50 UTC 2025), Entry for Mary Ann Dredge Thomas Stuart and George Sparry Thomas, 1969."
      },
      {
        "title": "George Sparry Thomas, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/983D-VYV",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSF-3NLN : Sat Sep 27 21:49:09 UTC 2025), Entry for Horatio Dredge Thomas and George Sparry Thomas, 1986."
      },
      {
        "title": "George Sparrey Thomas, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/983D-V2T",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSF-3FYH : Sat Sep 27 21:49:06 UTC 2025), Entry for George Walter Dredge Thomas and George Sparrey Thomas, 1963."
      },
      {
        "title": "George Thomas, \"Idaho, Marriages, 1878-1898; 1903-1942\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/983D-VDR",
        "citation": "\"Idaho, Marriages, 1878-1898; 1903-1942\", , FamilySearch (https://www.familysearch.org/ark:/61903/1:1:FW6S-X9V : 19 June 2020), George Thomas, 1881."
      },
      {
        "title": "George Sparry Thomas, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/983D-JC5",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSF-3LX9 : Sat Sep 27 21:49:35 UTC 2025), Entry for William G Thomas and George Sparry Thomas, 1934."
      },
      {
        "title": "George Sparry Thomas, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/983D-JSW",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSF-3L6R : Sat Sep 27 21:49:36 UTC 2025), Entry for William G Thomas and George Sparry Thomas, 1934."
      },
      {
        "title": "George Sparry or Sperry Thomas, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/983D-NM6",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSF-32JM : Sat Sep 27 21:49:32 UTC 2025), Entry for Sarah Ann Griffiths Thomas and William Thomas Griffiths, 1947."
      },
      {
        "title": "George Thomas, \"Wales, Births and Baptisms, 1541-1907\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M5B6-VDL",
        "citation": "\"Wales, Births and Baptisms, 1541-1907\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:X1R2-B85 : 10 February 2020), George Thomas, 1858."
      },
      {
        "title": "George Thomas, \"Idaho, Marriages, 1878-1898; 1903-1942\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MT3J-KQY",
        "citation": "\"Idaho, Marriages, 1878-1898; 1903-1942\", , FamilySearch (https://www.familysearch.org/ark:/61903/1:1:FW6Z-N5Q : 19 June 2020), George Thomas, 1881."
      },
      {
        "title": "George Sparry Thomas, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZXL-NSV",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVS6-F78B : Sat Sep 27 19:25:11 UTC 2025), Entry for Nora Thomas Harris and George Sparry Thomas, 1931."
      },
      {
        "title": "George Sparry Thomas, \"Idaho, Southern Counties Obituaries, 1943-2013\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSTJ-WRH",
        "citation": "\"Idaho, Southern Counties Obituaries, 1943-2013\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSD-QPZ9 : Thu Sep 19 19:32:58 UTC 2024), Entry for Horatio Dredge Or Shorty Thomas and George Sparry Thomas."
      },
      {
        "title": "George Sparrey Thomas, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSTJ-WN3",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSF-3NSS : Sat Sep 27 21:49:06 UTC 2025), Entry for Hannah Adelia Dredge Thomas and Jesse Richard Dredge, 1895."
      },
      {
        "title": "George Sparrey Thomas, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSTX-81H",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSF-3NC6 : Sat Sep 27 21:49:07 UTC 2025), Entry for George Sparrey Thomas and Hugh Williams Thomas, 1910."
      },
      {
        "title": "George S. Thomas, \"Idaho, Deaths and Burials, 1907-1965\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMCC-4T1",
        "citation": "\"Idaho, Deaths and Burials, 1907-1965\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:FW81-WLK : 18 March 2020), George S. Thomas, 1910."
      },
      {
        "title": "George Thomas in household of Hugh Thomas, \"United States Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMCH-S71",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M4ZJ-JS5 : Wed Sep 09 07:33:35 UTC 2026), Entry for Hugh Thomas and David Thomas, 1880."
      },
      {
        "title": "Hugh Thomas Family in William S. Seeley Company (1868) - Mormon Pioneer Overland Travel, 1847–1868",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MM9K-5ZB",
        "citation": "Mormon Pioneer Overland Travel, 1847–1868 on lds.org LDS Home > Church History > Church History Library > Resources Available > Search Results"
      },
      {
        "title": "Immigration of Hugh, Mary, George, Sarah, David, and Elizabeth Thomas - 1868",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MM9K-KGD",
        "citation": "Source: BMR, p.5 Database: Mormon Immigration Index (1840-1890)"
      },
      {
        "title": "George S. Thomas in entry for William Griffiths Thomas, \"Idaho, Death Certificates, 1911-1937\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMM1-24N",
        "citation": "\"Idaho, Death Certificates, 1911-1937\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:FLYW-5JR : Thu Feb 27 18:01:42 UTC 2025), Entry for William Griffiths Thomas and George S. Thomas, 14 Oct 1934."
      },
      {
        "title": "Hugh Thomas, \"United States Census, 1870\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMM1-23G",
        "citation": "\"United States, Census, 1870\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MZYB-G5J : Thu Jan 16 20:22:15 UTC 2025), Entry for Hugh Thomas and Mary A Thomas, 1870."
      },
      {
        "title": "George S. Thomas in entry for Vernal Thomas, \"Idaho, Deaths and Burials, 1907-1965\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMM1-24G",
        "citation": "\"Idaho, Deaths and Burials, 1907-1965\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:FW81-W2R : 18 March 2020), George S. Thomas in entry for Vernal Thomas, 1909."
      },
      {
        "title": "George S. Thomas, \"Utah, Marriages, 1887-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMM1-244",
        "citation": "\"Utah, Marriages, 1887-1935\", , FamilySearch (https://www.familysearch.org/ark:/61903/1:1:F8GX-HYH : 22 September 2026), George S. Thomas, 1897."
      }
    ],
    "portrait": "/ancestors/portraits/038_KW8T-GP3.jpg"
  },
  {
    "id": "I378",
    "name": "Hugh William Thomas",
    "sex": "M",
    "gen": 6,
    "slot": 12,
    "side": "paternal",
    "birthplace": "wales",
    "childId": "I184",
    "birthYear": 1830,
    "deathYear": 1912,
    "birthDate": "29 Jan 1830",
    "deathDate": "29 May 1912",
    "burialDate": "1 Jun 1912",
    "christeningDate": "28 Feb 1830",
    "birthPlace": "Pembrey, Carmarthenshire, Wales, United Kingdom",
    "deathPlace": "Malad City, Oneida, Idaho, United States",
    "burialPlace": "Malad City, Oneida, Idaho, United States",
    "christeningPlace": "Pembrey, Carmarthenshire, Wales, United Kingdom",
    "fsId": "KWV7-6KC",
    "photo": "/ancestors/bubbles/076_KWV7-6KC.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [
      {
        "kind": "Residence",
        "date": "1841",
        "place": "Pembrey, Carmarthenshire, Wales, United Kingdom",
        "note": "England and Wales Census, 1841: Coedy Bynon - Llanelly - Pembrey, Carmarthenshire, Wales"
      },
      {
        "kind": "Residence",
        "date": "1851",
        "place": "Pembrey, Carmarthenshire, Wales, United Kingdom",
        "note": "England and Wales Census, 1851: Llanelly - Pembrey, Carmarthenshire, Wales"
      },
      {
        "kind": "Immigration",
        "date": "29 August 1868",
        "place": "Utah, United States",
        "note": null
      },
      {
        "kind": "Immigration",
        "date": "29 August 1868",
        "place": null,
        "note": null
      },
      {
        "kind": "Obituary",
        "date": "1912",
        "place": "Idaho, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Research Log for Hugh William Thomas by BYU Center for Family History and Genealogy",
        "href": "https://www.familysearch.org/tree/sources/viewedit/37KC-SPZ",
        "citation": ""
      },
      {
        "title": "Welsh Saints Profile for Hugh William Thomas",
        "href": "https://www.familysearch.org/tree/sources/viewedit/37KC-9B1",
        "citation": ""
      },
      {
        "title": "Pioneer Database: Hugh Williams Thomas",
        "href": "https://www.familysearch.org/tree/sources/viewedit/37KC-M3N",
        "citation": "Church History Department, Pioneer Database. Hugh Williams Thomas entry, William S. Seeley Company (1868)."
      },
      {
        "title": "Saints by Sea: Hugh Williams Thomas",
        "href": "https://www.familysearch.org/tree/sources/viewedit/37KH-175",
        "citation": "Brigham Young University, Saints by Sea. Hugh Thomas entry, age 38, arrived 12 July 1868 on the Minnesota."
      },
      {
        "title": "Grave Marker for Hugh William Thomas",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMM1-BW7",
        "citation": "Find a grave website. Malad City Cemetery, Malad City, Oneida, Idaho, United States."
      },
      {
        "title": "Hugh Thomas, \"England and Wales, Census, 1851\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3KTG-FG6",
        "citation": "\"England and Wales, Census, 1851\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:SGZQ-F1G : Sat Aug 22 13:22:22 UTC 2026), Entry for David Thomas and Sarah Thomas, 1851."
      },
      {
        "title": "Hugh Thomas, \"Vermont, Vital Records, 1760-1954\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3GZ9-NDW",
        "citation": "\"Vermont, Vital Records, 1760-1954\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XF3S-RPP : Fri Mar 08 23:56:00 UTC 2024), Entry for David Thomas and Hugh Thomas, 1887."
      },
      {
        "title": "Hugh W. Thomas, \"BillionGraves Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M9NV-RZ1",
        "citation": "\"BillionGraves Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:2VCR-XVD : Fri Sep 25 01:09:54 UTC 2026), Entry for Hugh W. Thomas."
      },
      {
        "title": "Hugh Thomas in entry for George S. Thomas, \"Idaho, Deaths and Burials, 1907-1965\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMM1-2SH",
        "citation": "\"Idaho, Deaths and Burials, 1907-1965\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:FW81-WL2 : 18 March 2020), Hugh Thomas in entry for George S. Thomas, 1910."
      },
      {
        "title": "Hugh William Thomas, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/983D-62J",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QV21-2X28 : Fri Oct 02 21:56:19 UTC 2026), Entry for Hugh William Thomas."
      },
      {
        "title": "Hugh William Thomas, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSRR-TGJ",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSF-3XXZ : Sat Sep 27 21:48:56 UTC 2025), Entry for David Sparrey Thomas and Hugh William Thomas, 1927."
      },
      {
        "title": "Hugh Thomas in entry for George Thomas, \"Wales, Births and Baptisms, 1541-1907\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M5B6-VDP",
        "citation": "\"Wales, Births and Baptisms, 1541-1907\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:X1R2-B8R : 10 February 2020), Hugh Thomas in entry for George Thomas, 1858."
      },
      {
        "title": "Hugh Williams Thomas, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/983D-65F",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSF-3NC6 : Sat Sep 27 21:49:07 UTC 2025), Entry for George Sparrey Thomas and Hugh Williams Thomas, 1910."
      },
      {
        "title": "Hugh Thomas, \"Wales, Carmarthenshire, Parish Registers, 1538-1912\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9XL4-DRC",
        "citation": "\"Wales, Carmarthenshire, Parish Registers, 1538-1912\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KCL6-YK8 : Mon May 12 14:50:54 UTC 2025), Entry for Hugh Thomas and Mary Anne Sparrey, 25 Jan 1857."
      },
      {
        "title": "Hugh Wm Thomas, \"The Church of Jesus Christ of Latter-day Saints, Missionary Registers (Worldwide), 1860-1937\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9XPT-2KG",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Missionary Registers (Worldwide), 1860-1937\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QKDW-YHP6 : Tue Mar 11 16:26:05 UTC 2025), Entry for David Sparry Thomas and John J Williams, 1901."
      },
      {
        "title": "Hugh W. Thomas in entry for David Spaney Thomas, \"Idaho, Death Certificates, 1911-1937\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMM1-29Q",
        "citation": "\"Idaho, Death Certificates, 1911-1937\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:FLT1-JQW : Thu Feb 27 18:01:04 UTC 2025), Entry for David Spaney Thomas and Hugh W. Thomas, 28 Oct 1927."
      },
      {
        "title": "Hugh Williams Thomas, \"Utah, Mormon Pioneer Overland Travel Database, 1847-1868\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9D7G-Q97",
        "citation": "\"Utah, Mormon Pioneer Overland Travel Database, 1847-1868\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QK9B-C53J : Wed Feb 19 20:20:56 UTC 2025), Entry for Hugh Williams Thomas, 29 Aug 1868."
      },
      {
        "title": "Hugh William Thomas, \"Utah, Pioneers and Prominent Men of Utah, 1847-1868\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMC4-TPT",
        "citation": "\"Utah, Pioneers and Prominent Men of Utah, 1847-1868\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KL71-67J : Sat Mar 09 12:11:20 UTC 2024), Entry for Hugh William Thomas."
      },
      {
        "title": "Hugh William Thomas in entry for David Sparrey Thomas, \"Utah, Pioneers and Prominent Men of Utah, 1847-1868\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMC4-T5P",
        "citation": "\"Utah, Pioneers and Prominent Men of Utah, 1847-1868\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KL71-672 : Sat Mar 09 10:34:14 UTC 2024), Entry for David Sparrey Thomas and Hugh William Thomas."
      },
      {
        "title": "Hugh Williams Thomas, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/983D-6ZV",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSF-3NL1 : Sat Sep 27 21:49:10 UTC 2025), Entry for Hugh Williams Thomas and David Thomas, 1912."
      },
      {
        "title": "Hugh Thomas, \"United States Census, 1870\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMM1-23G",
        "citation": "\"United States, Census, 1870\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MZYB-G5J : Thu Jan 16 20:22:15 UTC 2025), Entry for Hugh Thomas and Mary A Thomas, 1870."
      },
      {
        "title": "Hugh Thomas Family in William S. Seeley Company (1868) - Mormon Pioneer Overland Travel, 1847–1868",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MM9K-5ZB",
        "citation": "Mormon Pioneer Overland Travel, 1847–1868 on lds.org LDS Home > Church History > Church History Library > Resources Available > Search Results"
      },
      {
        "title": "Immigration of Hugh, Mary, George, Sarah, David, and Elizabeth Thomas - 1868",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MM9K-KGD",
        "citation": "Source: BMR, p.5 Database: Mormon Immigration Index (1840-1890)"
      },
      {
        "title": "Hugh Thomas, \"Wales, Carmarthenshire, Parish Registers, 1538-1912\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMM1-2S6",
        "citation": "\"Wales, Carmarthenshire, Parish Registers, 1538-1912\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KCL6-RG7 : Mon May 12 14:56:58 UTC 2025), Entry for Hugh Thomas and Mary Anne Sparrey, 20 Feb 1857."
      },
      {
        "title": "Hugh Thomas, \"England and Wales Census, 1841\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MM9Y-67T",
        "citation": "\"England and Wales, Census, 1841\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M7QP-CRS : Tue Sep 08 21:47:29 UTC 2026), Entry for David Thomas and Elizabeth Thomas, 1841."
      },
      {
        "title": "Hugh Thomas, \"England and Wales Census, 1861\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MM9Y-671",
        "citation": "\"England and Wales, Census, 1861\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M7HP-Z5V : Thu Sep 10 02:17:49 UTC 2026), Entry for Hugh Thomas and Mary Thomas, 1861."
      },
      {
        "title": "Hugh Thomas, \"Wales, Carmarthenshire, Parish Registers, 1538-1912\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MM9Y-6WZ",
        "citation": "\"Wales, Carmarthenshire, Parish Registers, 1538-1912\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KCLX-NWB : Mon May 12 14:52:39 UTC 2025), Entry for Hugh Thomas, 28 Feb 1830."
      },
      {
        "title": "Hugh W. Thomas, \"Idaho, Death Certificates, 1911-1937\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MM9Y-DRX",
        "citation": "\"Idaho, Death Certificates, 1911-1937\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:FLTQ-FQR : Thu Feb 27 17:58:21 UTC 2025), Entry for Hugh W. Thomas and David Thomas, 29 May 1912."
      },
      {
        "title": "Hugh W. Thomas, \"United States Census, 1900\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMM1-2Q3",
        "citation": "\"United States, Census, 1900\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MM5Y-4PD : Tue Jan 21 06:42:44 UTC 2025), Entry for Hugh W. Thomas, 1900."
      },
      {
        "title": "Hugh Thomas, \"United States Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMM1-23T",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M4ZJ-JS5 : Wed Sep 09 07:33:35 UTC 2026), Entry for Hugh Thomas and David Thomas, 1880."
      },
      {
        "title": "Hugh Thomas in household of David Sperry Thomas, \"United States Census, 1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMM1-2QQ",
        "citation": "\"United States, Census, 1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MLCM-MSM : Wed Oct 29 21:03:17 UTC 2025), Entry for David Sperry Thomas and Alice D Thomas, 1910."
      }
    ],
    "portrait": "/ancestors/portraits/076_KWV7-6KC.jpg"
  },
  {
    "id": "I375",
    "name": "Mary Ann Sparrey",
    "sex": "F",
    "gen": 6,
    "slot": 13,
    "side": "paternal",
    "birthplace": "england",
    "childId": "I184",
    "birthYear": 1836,
    "deathYear": 1871,
    "birthDate": "1836",
    "deathDate": "1871",
    "burialDate": "1871",
    "christeningDate": "28 Dec 1834",
    "birthPlace": "Aston, Warwickshire, England, United Kingdom",
    "deathPlace": "Malad, Oneida, Idaho, United States",
    "burialPlace": "Malad City Cemetery, Malad, Oneida, Idaho, United States",
    "christeningPlace": "Northfield, Worcestershire, England, United Kingdom",
    "fsId": "KWV7-6KH",
    "photo": "/ancestors/bubbles/077_KWV7-6KH.jpg",
    "living": false,
    "alternateNames": [
      "Mary Ann Sparry",
      "Marianne Sparry",
      "Mrs. Mary Ann Thomas",
      "Mary Ann Sparry Thomas"
    ],
    "facts": [
      {
        "kind": "Residence",
        "date": "1851",
        "place": "Pembrey, Carmarthenshire, Wales, United Kingdom",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1861",
        "place": "Carmarthenshire, Wales, United Kingdom",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1870",
        "place": "Malad, Oneida, Idaho, United States",
        "note": "Census"
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Research Log for Mary Ann Sparrey by BYU Center for Family History and Genealogy",
        "href": "https://www.familysearch.org/tree/sources/viewedit/37KC-8XM",
        "citation": ""
      },
      {
        "title": "Welsh Saints Profile for Mary Ann Sparrey",
        "href": "https://www.familysearch.org/tree/sources/viewedit/37KC-ZX7",
        "citation": ""
      },
      {
        "title": "Pioneer Database: Mary Ann Sparrey",
        "href": "https://www.familysearch.org/tree/sources/viewedit/37KC-MWF",
        "citation": "Church History Department, Pioneer Database. Mary Ann Thomas entry, William S. Seeley Company (1868)."
      },
      {
        "title": "Saints by Sea: Mary Ann Sparrey",
        "href": "https://www.familysearch.org/tree/sources/viewedit/37KH-1HD",
        "citation": "Brigham Young University, Saints by Sea. Mary A. Thomas entry, age 34, arrived 12 July 1868 on the Minnesota."
      },
      {
        "title": "Grave Marker for Mary Ann Sparrey Thomas",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMM1-BWP",
        "citation": "Find a grave website, Malad City Cemetery, Malad City, Oneida, Idaho, United States."
      },
      {
        "title": "Mary Ann Thomas in entry for George S. Thomas, \"Idaho, Deaths and Burials, 1907-1965\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMCC-4TF",
        "citation": "\"Idaho, Deaths and Burials, 1907-1965\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:FW81-WLL : 18 March 2020), Mary Ann Thomas in entry for George S. Thomas, 1910."
      },
      {
        "title": "Mary Ann Sparrey Thomas, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSTX-8B4",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSF-3NC6 : Sat Sep 27 21:49:07 UTC 2025), Entry for George Sparrey Thomas and Hugh Williams Thomas, 1910."
      },
      {
        "title": "Mary Ann Sparrey Thomas, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/747Y-PDH",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QV21-2XL6 : Thu Oct 01 11:39:32 UTC 2026), Entry for Mary Ann Sparrey Thomas."
      },
      {
        "title": "Mary Ann Spaney in entry for David Spaney Thomas, \"Idaho, Death Certificates, 1911-1937\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMCH-SD5",
        "citation": "\"Idaho, Death Certificates, 1911-1937\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:FLT1-JQW : Thu Feb 27 18:01:04 UTC 2025), Entry for David Spaney Thomas and Hugh W. Thomas, 28 Oct 1927."
      },
      {
        "title": "Mary Ann Sparrey in household of Thomas Sparrey, \"England and Wales Census, 1851\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/968W-G8Y",
        "citation": ""
      },
      {
        "title": "Mary Ann in entry for George Thomas, \"Wales, Births and Baptisms, 1541-1907\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M5B6-VDY",
        "citation": "\"Wales, Births and Baptisms, 1541-1907\", database, FamilySearch (https://familysearch.org/ark:/61903/1:1:X1R2-B8T : 10 February 2020), Mary Ann in entry for George Thomas, 1858."
      },
      {
        "title": "Mary Ann Sparrey, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSTX-DSM",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSF-3XXZ : Sat Sep 27 21:48:56 UTC 2025), Entry for David Sparrey Thomas and Hugh William Thomas, 1927."
      },
      {
        "title": "Mary Ann Sparrey, \"England and Wales, Census, 1851\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9JJP-7MN",
        "citation": "\"England and Wales, Census, 1851\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:SGZQ-NQN : Fri Aug 21 09:28:42 UTC 2026), Entry for Thomas Sparrey and Sarah Sparrey, 1851."
      },
      {
        "title": "Mary Thomas, \"England and Wales, Census, 1861\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/95VC-ZGM",
        "citation": "\"England and Wales, Census, 1861\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M7HP-Z5V : Thu Sep 10 02:17:49 UTC 2026), Entry for Hugh Thomas and Mary Thomas, 1861."
      },
      {
        "title": "Mary Anne Sparrey, \"Wales, Carmarthenshire, Parish Registers, 1538-1912\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9XL4-DG4",
        "citation": "\"Wales, Carmarthenshire, Parish Registers, 1538-1912\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KCL6-YK8 : Mon May 12 14:50:54 UTC 2025), Entry for Hugh Thomas and Mary Anne Sparrey, 25 Jan 1857."
      },
      {
        "title": "Mary Ann Sparry, \"The Church of Jesus Christ of Latter-day Saints, Missionary Registers (Worldwide), 1860-1937\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9XPT-2GG",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Missionary Registers (Worldwide), 1860-1937\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QKDW-YHP6 : Tue Mar 11 16:26:05 UTC 2025), Entry for David Sparry Thomas and John J Williams, 1901."
      },
      {
        "title": "Mary Ann Sparrey in entry for David Sparrey Thomas, \"Utah, Pioneers and Prominent Men of Utah, 1847-1868\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMC4-TRJ",
        "citation": "\"Utah, Pioneers and Prominent Men of Utah, 1847-1868\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KL71-672 : Sat Mar 09 10:34:14 UTC 2024), Entry for David Sparrey Thomas and Hugh William Thomas."
      },
      {
        "title": "Mary A Thomas, \"United States, Census, 1870\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SKBG-H8B",
        "citation": "\"United States, Census, 1870\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MZYB-G5J : Thu Jan 16 20:22:15 UTC 2025), Entry for Hugh Thomas and Mary A Thomas, 1870."
      },
      {
        "title": "Mary Ann Sparrey, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/ST75-JVZ",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSF-3NL1 : Sat Sep 27 21:49:10 UTC 2025), Entry for Hugh Williams Thomas and David Thomas, 1912."
      },
      {
        "title": "Mary Jones, \"Vermont, Vital Records, 1760-1954\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3GZ9-NXM",
        "citation": "\"Vermont, Vital Records, 1760-1954\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XF3S-RPP : Fri Mar 08 23:56:00 UTC 2024), Entry for David Thomas and Hugh Thomas, 1887."
      },
      {
        "title": "Hugh Thomas, \"United States Census, 1870\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMM1-23G",
        "citation": "\"United States, Census, 1870\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MZYB-G5J : Thu Jan 16 20:22:15 UTC 2025), Entry for Hugh Thomas and Mary A Thomas, 1870."
      },
      {
        "title": "Hugh Thomas Family in William S. Seeley Company (1868) - Mormon Pioneer Overland Travel, 1847–1868",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MM9K-5ZB",
        "citation": "Mormon Pioneer Overland Travel, 1847–1868 on lds.org LDS Home > Church History > Church History Library > Resources Available > Search Results"
      },
      {
        "title": "Immigration of Hugh, Mary, George, Sarah, David, and Elizabeth Thomas - 1868",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MM9K-KGD",
        "citation": "Source: BMR, p.5 Database: Mormon Immigration Index (1840-1890)"
      },
      {
        "title": "Marianne Sparry, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M9NV-T3G",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:JQZ4-1YM : 3 February 2023), Marianne Sparry, 1834."
      },
      {
        "title": "Mary Anne Sparrey, \"Wales, Carmarthenshire, Parish Registers, 1538-1912\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMCC-4RZ",
        "citation": "\"Wales, Carmarthenshire, Parish Registers, 1538-1912\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KCL6-RG7 : Mon May 12 14:56:58 UTC 2025), Entry for Hugh Thomas and Mary Anne Sparrey, 20 Feb 1857."
      }
    ],
    "portrait": "/ancestors/portraits/077_KWV7-6KH.jpg"
  },
  {
    "id": "I175",
    "name": "Hannah Adelia Dredge",
    "sex": "F",
    "gen": 5,
    "slot": 7,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "I74",
    "birthYear": 1863,
    "deathYear": 1895,
    "birthDate": "28 Mar 1863",
    "deathDate": "26 Mar 1895",
    "burialDate": "Mar 1895",
    "christeningDate": null,
    "birthPlace": "Kaysville, Davis, Utah, United States",
    "deathPlace": "Malad City, Oneida, Idaho, United States",
    "burialPlace": "Malad City Cemetery, Malad, Oneida, Idaho, United States",
    "christeningPlace": null,
    "fsId": "KW8T-GPQ",
    "photo": "/ancestors/bubbles/039_KW8T-GPQ.jpg",
    "living": false,
    "alternateNames": [
      "Hanah Dredge",
      "Hannah Dredge",
      "Mrs. Mrs. Thomas"
    ],
    "facts": [
      {
        "kind": "Residence",
        "date": "1870",
        "place": "Malad, Oneida, Idaho, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Hannah Dredge Thomas Grave Marker",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MM9M-H2V",
        "citation": "Find a grave website. Malad City Cemetery, Malad City, Oneida, Idaho, United States."
      },
      {
        "title": "Hannah Adelia Dredge Thomas, \"Idaho, Southern Counties Obituaries, 1943-2013\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSTJ-WGQ",
        "citation": "\"Idaho, Southern Counties Obituaries, 1943-2013\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSD-QPZ9 : Thu Sep 19 19:32:58 UTC 2024), Entry for Horatio Dredge Or Shorty Thomas and George Sparry Thomas."
      },
      {
        "title": "Hannah Adelia Dredge, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/983D-VVL",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSF-3FYH : Sat Sep 27 21:49:06 UTC 2025), Entry for George Walter Dredge Thomas and George Sparrey Thomas, 1963."
      },
      {
        "title": "Hannah Adelia Dredge, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/983D-V5C",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSF-3NLN : Sat Sep 27 21:49:09 UTC 2025), Entry for Horatio Dredge Thomas and George Sparry Thomas, 1986."
      },
      {
        "title": "Anna Dredge in household of Jesse Dredge, \"United States Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MM9X-JLX",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M4ZJ-6HV : Wed Sep 09 09:57:03 UTC 2026), Entry for Jesse Dredge and Ellen Dredge, 1880."
      },
      {
        "title": "Hannah Adelia Dredge, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZXL-N3M",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVS6-F78B : Sat Sep 27 19:25:11 UTC 2025), Entry for Nora Thomas Harris and George Sparry Thomas, 1931."
      },
      {
        "title": "Hannah Dredge, \"Idaho, County Marriages, 1864-1962\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SP4X-BLF",
        "citation": "\"Idaho, County Marriages, 1864-1962\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2Z2-WSK7 : Wed Jul 31 23:15:35 UTC 2024), Entry for George Thomas and Hannah Dredge, 28 Mar 1881."
      },
      {
        "title": "Hannah Adelia Dredge, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SB4W-CXP",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QPSC-XZB7 : Sat Mar 09 20:58:35 UTC 2024), Entry for Nora Thomas Harris and George Sparry Thomas, 1931."
      },
      {
        "title": "Hannah Adelia Dredge Thomas, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSTJ-WFD",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSF-3NSS : Sat Sep 27 21:49:06 UTC 2025), Entry for Hannah Adelia Dredge Thomas and Jesse Richard Dredge, 1895."
      },
      {
        "title": "Hannah Adelia Dredge Thomas, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/983D-KSM",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QV21-2X26 : Fri Oct 02 04:12:52 UTC 2026), Entry for Hannah Adelia Dredge Thomas."
      },
      {
        "title": "Hannah A. Dredge in entry for Nora Thomas Harris, \"Idaho Death Certificates, 1911-1937\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9VG5-XRQ",
        "citation": "\"Idaho, Death Certificates, 1911-1937\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:FLBH-58C : Thu Feb 27 18:03:24 UTC 2025), Entry for Nora Thomas Harris and George Hugh Thomas, 04 May 1931."
      },
      {
        "title": "Hannah Harnedge, \"United States, Census, 1870\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SGBH-PBW",
        "citation": "\"United States, Census, 1870\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MZYB-52D : Fri Oct 10 19:25:10 UTC 2025), Entry for Jesse Harnedge and Ellen Harnedge, 1870."
      },
      {
        "title": "Hanah Dredge in entry for George Thomas, \"Idaho, Marriages, 1878-1898; 1903-1942\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MT3J-KQP",
        "citation": "\"Idaho, Marriages, 1878-1898; 1903-1942\", , FamilySearch (https://www.familysearch.org/ark:/61903/1:1:FW6Z-N53 : 19 June 2020), Hanah Dredge in entry for George Thomas, 1881."
      },
      {
        "title": "Hanah Dredge in entry for George Thomas, \"Idaho, Marriages, 1878-1898; 1903-1942\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/983D-VZ6",
        "citation": "\"Idaho, Marriages, 1878-1898; 1903-1942\", , FamilySearch (https://www.familysearch.org/ark:/61903/1:1:FW6S-X9J : 19 June 2020), Hanah Dredge in entry for George Thomas, 1881."
      },
      {
        "title": "Hannah Dredge, \"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW97-7JY",
        "citation": "\"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6K4V-NJFV : Sun Jul 05 03:44:58 UTC 2026), Entry for George Walter Thomas and George S Thomas."
      },
      {
        "title": "Hannah Dredge, \"Idaho, Birth Index, 1861-1911\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9F67-DQ9",
        "citation": "\"Idaho, Birth Index, 1861-1911\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2M1-3WSR : Fri Feb 14 22:13:47 UTC 2025), Entry for George Walter Thomas and George Sperry Thomas, 05 Jan 1882."
      },
      {
        "title": "Hannah Dredge, \"United States, Western States Marriage Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SP4F-MSZ",
        "citation": "\"United States, Western States Marriage Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZJC-LZP : Tue Feb 11 22:33:46 UTC 2025), Entry for George Thomas and Hannah Dredge, 28 Mar 1881."
      },
      {
        "title": "Hannah Adelia Dredge, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/98HT-M2Z",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSF-9G3Y : Sat Sep 27 21:43:50 UTC 2025), Entry for Mary Ann Dredge Thomas Stuart and George Sparry Thomas, 1969."
      },
      {
        "title": "Hannah Adelia Dredge, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/ST75-NP5",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSF-3NC6 : Sat Sep 27 21:49:07 UTC 2025), Entry for George Sparrey Thomas and Hugh Williams Thomas, 1910."
      },
      {
        "title": "Hannah A Dredge Thomas, \"BillionGraves Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/747Y-54R",
        "citation": "\"BillionGraves Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVJR-SX4M : Thu Sep 24 19:25:16 UTC 2026), Entry for Hannah A Dredge Thomas."
      }
    ],
    "portrait": "/ancestors/portraits/039_KW8T-GPQ.jpg"
  },
  {
    "id": "I374",
    "name": "Jesse Richard Dredge",
    "sex": "M",
    "gen": 6,
    "slot": 14,
    "side": "paternal",
    "birthplace": "england",
    "childId": "I175",
    "birthYear": 1828,
    "deathYear": 1913,
    "birthDate": "14 Jan 1828",
    "deathDate": "11 Mar 1913",
    "burialDate": "14 Mar 1913",
    "christeningDate": "1 Jun 1828",
    "birthPlace": "Minchinhampton, Gloucestershire, England",
    "deathPlace": "Malad City, Oneida, Idaho, United States",
    "burialPlace": "Malad City, Oneida, Idaho, United States",
    "christeningPlace": "Minchinhampton, Gloucestershire, England,  UK",
    "fsId": "KWNJ-ZVM",
    "photo": "/ancestors/bubbles/078_KWNJ-ZVM.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [
      {
        "kind": "Residence",
        "date": "1841",
        "place": "Frome, Somerset, England, United Kingdom",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1851",
        "place": "Aberystruth, Monmouthshire, Wales, United Kingdom",
        "note": null
      },
      {
        "kind": "Emigration",
        "date": "3 August 1861",
        "place": null,
        "note": null
      },
      {
        "kind": "Immigration",
        "date": "17 October 1861",
        "place": "Deseret, Millard, Utah, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1870",
        "place": "Malad, Oneida, Idaho, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "B. H. Schettler letter to Jesse Dredge",
        "href": "https://www.familysearch.org/tree/sources/viewedit/334P-88J",
        "citation": "Perpetual Emigrating Fund Company general files, 1850-1887; Letterpress copy book, 1856-1869; B. H. Schettler letter to Jesse Dredge; Church History Library, https://catalog.churchofjesuschrist.org/assets?id=b75a87c7-fc7f-497a-abcb-b58ebfecf1dc&crate=0&index=0 (accessed: February 25, 2021)"
      },
      {
        "title": "1900 United States Federal Census",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S8DZ-5SD",
        "citation": "Year: 1900; Census Place: Malad, Oneida, Idaho; Page: 12; Enumeration District: 0092; FHL microfilm: 1240234"
      },
      {
        "title": "1880 United States Federal Census",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S8DZ-5SC",
        "citation": "Year: 1880; Census Place: Malad City, Oneida, Idaho; Roll: 173; Page: 308A; Enumeration District: 026"
      },
      {
        "title": "1861 Wales Census",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S8DZ-DGX",
        "citation": "Class: RG9; Piece: 3997; Folio: 241; Page: 13; GSU roll: 543219"
      },
      {
        "title": "Ancestry Family Trees",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S8DZ-DG6",
        "citation": "Ancestry Family Tree"
      },
      {
        "title": "Idaho, Death Records, 1890-1967",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S83H-Y4J",
        "citation": "Idaho Bureau of Vital Records and Health Statistics; Boise, Idaho"
      },
      {
        "title": "Jesse R Dredge, \"Idaho, County Marriages, 1864-1962\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S2N8-LBS",
        "citation": "\"Idaho, County Marriages, 1864-1962\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2Z2-SGLD : Wed Jul 31 23:09:57 UTC 2024), Entry for Jesse R Dredge and Rosina Kunz, 21 Apr 1905."
      },
      {
        "title": "Jesse R. Dredge, \"Idaho, Marriages, 1878-1898; 1903-1942\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3KNV-2DR",
        "citation": "\"Idaho, Marriages, 1878-1898; 1903-1942\", , FamilySearch (https://www.familysearch.org/ark:/61903/1:1:HS9S-2P6Z : 19 June 2020), Jesse R. Dredge, 1905."
      },
      {
        "title": "Jesse R Dredge, \"Idaho, County Marriages, 1864-1962\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S2XN-2NP",
        "citation": "\"Idaho, County Marriages, 1864-1962\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2Z2-WFSR : Wed Jul 31 23:22:12 UTC 2024), Entry for Jesse R Dredge and Rosina Kunz, Apr 1905."
      },
      {
        "title": "Jesse Dredge, \"New York, Passenger Lists, 1820-1920\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3J26-3Y2",
        "citation": "\"New York, Passenger Lists, 1820-1920\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QV33-H4WW : Fri Jul 03 04:13:29 UTC 2026), Entry for Jesse Dredge, 1861."
      },
      {
        "title": "Jessie Dredge, \"Idaho, Jefferson Star, County Cemetery Records, 1800-2000\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SL3J-298",
        "citation": "\"Idaho, Jefferson Star, County Cemetery Records, 1800-2000\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Z4X7-6PPZ : Thu Mar 07 15:49:11 UTC 2024), Entry for Elizabeth Roberts and Jessie Dredge."
      },
      {
        "title": "Jesse Richard Dredge, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3KNX-QYR",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVS6-3ZVQ : Sat Sep 27 18:48:55 UTC 2025), Entry for Rosina Kunz Dredge and Johannes Kunz 3rd, 1914."
      },
      {
        "title": "Jesse R Dredge, \"Idaho, County Marriages, 1864-1962\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SP4L-DZV",
        "citation": "\"Idaho, County Marriages, 1864-1962\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2Z2-9LRB : Wed Jul 31 23:06:16 UTC 2024), Entry for Jesse R Dredge and Rosina Kunz, 21 Apr 1905."
      },
      {
        "title": "Jesse R, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7V7M-YDB",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6ZPY-LC64 : Thu Mar 26 21:14:26 UTC 2026), Entry for William R Dredge and Fredrick Thomas."
      },
      {
        "title": "Jesse Harnedge, \"United States, Census, 1870\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SGBH-PST",
        "citation": "\"United States, Census, 1870\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MZYB-52D : Fri Oct 10 19:25:10 UTC 2025), Entry for Jesse Harnedge and Ellen Harnedge, 1870."
      },
      {
        "title": "Jesse R Dredge, \"Idaho, County Marriages, 1864-1962\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S2XJ-2ZC",
        "citation": "\"Idaho, County Marriages, 1864-1962\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2Z2-7N56 : Wed Jul 31 23:13:19 UTC 2024), Entry for Jesse R Dredge and Rosina Kunz, 21 Apr 1905."
      },
      {
        "title": "Jessie R Dredge, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7313-Z9T",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:62GJ-RLNM : Sun Sep 13 05:19:13 UTC 2026), Entry for Jesse H Dredge and Milton H Welling."
      },
      {
        "title": "Jesse R Dredge, \"Idaho, Jefferson Star, County Cemetery Records, 1800-2000\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SLQ7-6RM",
        "citation": "\"Idaho, Jefferson Star, County Cemetery Records, 1800-2000\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Z46D-YZT2 : Wed Jan 22 17:27:56 UTC 2025), Entry for Hattie May Dredge Lusk and Jesse R Dredge."
      },
      {
        "title": "Mr J H Dredge, \"Utah, Box Elder, Brigham City Family History Center, Obituary Collection, 1930-2016\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SYGB-F6R",
        "citation": "\"Utah, Box Elder, Brigham City Family History Center, Obituary Collection, 1930-2016\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:CYRB-GQMM : Mon Jan 20 20:18:48 UTC 2025), Entry for William Rheese Or Reese Dredge and Mr J H Dredge, 1946."
      },
      {
        "title": "Robert Rowlands, \"England and Wales, Marriage Registration Index, 1837-2005\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QHF6-WHY",
        "citation": "\"England and Wales, Marriage Registration Index, 1837-2005\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:2DSK-GMF : Fri Jul 03 21:01:37 UTC 2026), Entry for Robert Rowlands and Ellen, 1854."
      },
      {
        "title": "Millennium File",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S83H-5TT",
        "citation": ""
      },
      {
        "title": "Rosina Kunz Family Group Record Sheet and Pictures",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SCW9-VML",
        "citation": "Various sources. Look at the family group sheet sourcing section for more information."
      },
      {
        "title": "Marriage Date",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SC9Q-1YJ",
        "citation": ""
      },
      {
        "title": "Jesse Richard Dredge (1828-1913) - Find A Grave Memorial",
        "href": "https://www.familysearch.org/tree/sources/viewedit/915L-M1X",
        "citation": "Find A Grave, database and images (https://www.findagrave.com : accessed 22 July 2018), memorial page for Jesse Richard Dredge (14 Jan 1828–11 Mar 1913), Find A Grave Memorial no. 21515178, citing Malad City Cemetery, Malad City, Oneida County, Idaho, USA ; Maintained by Bruce J. Black (contributor 46816296) ."
      },
      {
        "title": "England and Wales Marriages 1837-2005",
        "href": "https://www.familysearch.org/tree/sources/viewedit/95GQ-FNX",
        "citation": "https://search.findmypast.com/record?id=bmd%2fm%2f1854%2f2%2fal%2f000565%2f018 England and Wales Marriages 1837-2005 on FindMyPast.com"
      },
      {
        "title": "Jesse R Dredge in entry for Richard Henry Dredge, \"Idaho, Southern Counties Obituaries, 1943-2013\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9LPL-D4T",
        "citation": "\"Idaho, Southern Counties Obituaries, 1943-2013\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QLWF-WXPD : Wed Jun 04 22:32:46 UTC 2025), Entry for Richard Henry Dredge and Jesse R Dredge."
      },
      {
        "title": "Jesse Richard Dredge, \"Find A Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9GNX-8D5",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVVV-Z8NF : Sun Oct 04 15:09:51 UTC 2026), Entry for Jesse Richard Dredge."
      },
      {
        "title": "Jessie Dredge, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/95QX-959",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSX-GQZ4 : Sun Oct 19 21:52:10 UTC 2025), Entry for Elizabeth Roberts and Jessie Dredge, 1921."
      },
      {
        "title": "Jessy Drudge, \"England and Wales, Census, 1851\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9NHB-Q46",
        "citation": "\"England and Wales, Census, 1851\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:SGTK-95N : Fri Aug 21 08:23:49 UTC 2026), Entry for Richard Drudge and Sarah Drudge, 1851."
      },
      {
        "title": "Jesse Richard Dredge, \"Utah Mormon Pioneer Overland Travel Database, 1847-1868\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9GNX-8V3",
        "citation": "\"Utah, Mormon Pioneer Overland Travel Database, 1847-1868\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QK9B-ZXCJ : Wed Feb 19 20:20:25 UTC 2025), Entry for Jesse Richard Dredge, 17 Oct 1861."
      },
      {
        "title": "Jesse R Dredge, \"Idaho, Death Certificates, 1938-1961\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9X5K-4G7",
        "citation": "\"Idaho, Death Certificates, 1938-1961\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2M1-5K3X : Fri Feb 21 22:49:55 UTC 2025), Entry for Alice Dredge Thomas and Jesse R Dredge, 6 May 1952."
      },
      {
        "title": "Jesse Dridge, \"England and Wales, Census, 1841\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9NHB-W6Q",
        "citation": "\"England and Wales, Census, 1841\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MQ16-4XG : Tue Sep 08 21:38:44 UTC 2026), Entry for Richd Dridge and Sarah Dridge, 1841."
      },
      {
        "title": "Jesse Richard Dredge, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/98TC-GCX",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSX-94VY : Sat Sep 27 20:13:15 UTC 2025), Entry for Hattie or Hettie May Dredge Lusk and Jesse Richard Dredge, 1957."
      },
      {
        "title": "Jesse R Dredge, \"The Church of Jesus Christ of Latter-day Saints, Missionary Registers (Worldwide), 1860-1937\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/95QX-SD2",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Missionary Registers (Worldwide), 1860-1937\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QKDW-YBQ9 : Tue Mar 11 16:24:39 UTC 2025), Entry for Wm Rhees Dredge and Fredrick W Thomas, 1908."
      },
      {
        "title": "Jesse Richard Dredge in entry for Jesse Horatia Dredge, \"Idaho Death Certificates, 1938-1961\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9KJT-3GX",
        "citation": "\"Idaho, Death Certificates, 1938-1961\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2M1-5N3D : Fri Feb 21 22:53:50 UTC 2025), Entry for Jesse Horatia Dredge and Jesse Richard Dredge, 27 May 1957."
      },
      {
        "title": "Jesse Richard Dredge, \"The Church of Jesus Christ of Latter-day Saints, Missionary Registers (Worldwide), 1860-1937\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/95QX-3WY",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Missionary Registers (Worldwide), 1860-1937\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QKDW-YNQC : Tue Mar 11 16:25:25 UTC 2025), Entry for Wm Rhees Dredge and Fredrick Thomas, 1899."
      },
      {
        "title": "Jesse Richard Dredge, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/985R-YY7",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVS6-3ZFS : Sat Sep 27 18:48:52 UTC 2025), Entry for Jesse Horatio Dredge and Jesse Richard Dredge, 1957."
      },
      {
        "title": "Jessie Richard Dredge in entry for Emma Dredge Harrison, \"Idaho Death Certificates, 1938-1961\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9L65-4K4",
        "citation": "\"Idaho, Death Certificates, 1938-1961\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2M1-5F5T : Fri Feb 21 22:52:41 UTC 2025), Entry for Emma Dredge Harrison and Jessie Richard Dredge, 31 Dec 1957."
      },
      {
        "title": "Jessie R Dredge, \"Idaho, Death Certificates, 1938-1961\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9X5K-488",
        "citation": "\"Idaho, Death Certificates, 1938-1961\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2M1-PF3J : Fri Feb 21 22:39:31 UTC 2025), Entry for Hettie May Dredge Lusk and Jessie R Dredge, 28 Dec 1957."
      },
      {
        "title": "Jesse R. Dredge, \"United States, Western States Marriage Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S3GN-YWX",
        "citation": "\"United States, Western States Marriage Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZVB-R4P : Tue Feb 11 23:17:05 UTC 2025), Entry for Jesse R. Dredge and Rosina Kunz, 21 Apr 1905."
      },
      {
        "title": "Legacy NFS Source: Jesse Richard Dredge -",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMVQ-2WG",
        "citation": ""
      },
      {
        "title": "Legacy NFS Source: Jesse Richard Dredge - Individual or family possessions: birth-name: James Dredge",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMVQ-2W2",
        "citation": ""
      },
      {
        "title": "Pioneer overland Travel Wright-Godbe/ George Stringham Freight Train 1861",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMNT-MFC",
        "citation": "Harold B. Lee Library, Brigham Young University, Provo, Utah University of Utah, J. Willard Marriott Library, Salt Lake City, Utah Church History Library, Salt Lake City"
      },
      {
        "title": "Cemetery Listing",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMQ8-Z4H",
        "citation": "Malad Idaho Cemetery website"
      },
      {
        "title": "Emigration of Jesse Dredge and family - 1861 - Mormon Migration",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MM9X-J1X",
        "citation": "Source: BMR, p. 48. Database: Mormon Immigration Index (1840-1890)"
      },
      {
        "title": "Jasse Dredge, \"England and Wales Census, 1861\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MM9X-J5T",
        "citation": "\"England and Wales, Census, 1861\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M7T4-B71 : Thu Sep 10 03:05:11 UTC 2026), Entry for Jasse Dredge and Ellen Dredge, 1861."
      },
      {
        "title": "Jesse P. Dredge in entry for Elizabeth Dredge Roberts, \"Idaho, Death Certificates, 1911-1937\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMQW-HVL",
        "citation": "\"Idaho, Death Certificates, 1911-1937\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:FLB3-CB3 : Thu Feb 27 18:04:36 UTC 2025), Entry for Elizabeth Dredge Roberts and Jesse P. Dredge, 26 Feb 1921."
      },
      {
        "title": "Dredge, Jesse R, US Citizenship, Box Elder, Utah Territory 30 June 1869",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M99B-F52",
        "citation": "\"Utah, Box Elder County Records, 1856-1960,\" images, FamilySearch (https://familysearch.org/ark:/61903/3:1:33S7-9YRP-6?cc=1935517&wc=M6LW-CNP%3A234270101%2C234270102 : 22 May 2014), Naturalization records > Certificates of citizenship, vol 1, 1868-1876 > image 32 of 38; County Courthouse, Brigham City."
      },
      {
        "title": "Jesse Richard Dredge, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSTJ-WJM",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSF-3NSS : Sat Sep 27 21:49:06 UTC 2025), Entry for Hannah Adelia Dredge Thomas and Jesse Richard Dredge, 1895."
      },
      {
        "title": "Jesse Dredge, \"United States Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MM9X-JLW",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M4ZJ-6HV : Wed Sep 09 09:57:03 UTC 2026), Entry for Jesse Dredge and Ellen Dredge, 1880."
      },
      {
        "title": "J.H. Dredge in entry for William Rheese Dredge, \"Utah Death Certificates, 1904-1956\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MM9J-BV1",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZPJ-X9L : Tue Jan 21 05:13:15 UTC 2025), Entry for William Rheese Dredge and J.H. Dredge, 08 May 1946."
      },
      {
        "title": "Jessie Richard Dredge, \"Idaho, Death Certificates, 1911-1937\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MM41-1BZ",
        "citation": "\"Idaho, Death Certificates, 1911-1937\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:FLR1-J52 : Thu Feb 27 18:02:27 UTC 2025), Entry for Jessie Richard Dredge and Richard Dredge, 11 Mar 1913."
      },
      {
        "title": "Jesse R Dredge, \"United States Census, 1900\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MM9X-J2K",
        "citation": "\"United States, Census, 1900\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MM5T-ZPN : Tue Jan 21 21:58:40 UTC 2025), Entry for Jesse R Dredge and Ellen Dredge, 1900."
      },
      {
        "title": "Jesse Richard Dredge, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSTJ-71B",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVS6-3ZF8 : Sat Sep 27 18:48:52 UTC 2025), Entry for Jesse Richard Dredge and Richard Henry Dredge, 1913."
      },
      {
        "title": "Jesse Richard Dredge, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSTJ-7RW",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVS6-3ZXL : Sat Sep 27 18:48:52 UTC 2025), Entry for Ellen Dredge and Horatio Nelson Rhees, 1903."
      },
      {
        "title": "Jesse Richard Dredge, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/984K-PRJ",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSF-36M7 : Sat Sep 27 21:48:47 UTC 2025), Entry for Alice Dredge Thomas and Jesse Richard Dredge, 1952."
      },
      {
        "title": "Jesse Dredge, \"England Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MM9X-JKB",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:NB96-FBD : 4 February 2023), Jesse Dredge, 1828."
      },
      {
        "title": "Jesse R Dredge, \"United States Census, 1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MM9X-J2Z",
        "citation": "\"United States, Census, 1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MLHR-JJH : Wed Oct 29 21:03:18 UTC 2025), Entry for Jesse R Dredge and Rosanah K Dredge, 1910."
      },
      {
        "title": "Jesse Richard Dredge, \"Utah, Pioneers and Prominent Men of Utah, 1847-1868\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMHM-SX8",
        "citation": "\"Utah, Pioneers and Prominent Men of Utah, 1847-1868\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KL71-DD7 : Wed Mar 06 15:20:55 UTC 2024), Entry for Jesse Richard Dredge."
      },
      {
        "title": "Jesse Richard Dredge, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9Z3W-K6Y",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVS6-44LJ : Sat Sep 27 19:00:40 UTC 2025), Entry for Nora Dredge Fife and Jesse Richard Dredge, 1890."
      }
    ],
    "portrait": "/ancestors/portraits/078_KWNJ-ZVM.jpg"
  },
  {
    "id": "I368",
    "name": "Ellen Rhees",
    "sex": "F",
    "gen": 6,
    "slot": 15,
    "side": "paternal",
    "birthplace": "england",
    "childId": "I175",
    "birthYear": 1836,
    "deathYear": 1903,
    "birthDate": "12 Feb 1836",
    "deathDate": "9 Dec 1903",
    "burialDate": "Dec 1903",
    "christeningDate": "6 Mar 1836",
    "birthPlace": "Widcombe, Somerset, England",
    "deathPlace": "Malad City, Oneida, Idaho, United States",
    "burialPlace": "Malad City Cemetery, Oneida, Idaho, United States",
    "christeningPlace": "Widcombe, Somerset, England, United Kingdom",
    "fsId": "LB5J-R4S",
    "photo": "/ancestors/bubbles/079_LB5J-R4S.jpg",
    "living": false,
    "alternateNames": [
      "Ellen Dredge",
      "Ellen Rees"
    ],
    "facts": [
      {
        "kind": "Baptism",
        "date": "6 March 1836",
        "place": "Widcombe, Somerset, England, United Kingdom",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1841",
        "place": "Somerset, England, United Kingdom",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1851",
        "place": "St James' Church, Winscombe, Somerset, England, United Kingdom",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1861",
        "place": "Aberystruth, Monmouthshire, Wales, United Kingdom",
        "note": null
      },
      {
        "kind": "Emigration",
        "date": "14 July 1861",
        "place": null,
        "note": null
      },
      {
        "kind": "Immigration",
        "date": "13 September 1861",
        "place": "Deseret, Millard, Utah, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1870",
        "place": "Malad, Oneida, Idaho, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1880",
        "place": "Malad, Oneida, Idaho, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1900",
        "place": "Cherry Creek, Oneida, Idaho, United States",
        "note": null
      },
      {
        "kind": "Obituary",
        "date": "1903",
        "place": "Idaho, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Somerset, England, Church of England Baptisms, 1813-1914",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S83C-MC9",
        "citation": "Somerset Heritage Service; Taunton, Somerset, England; Reference Number: D\\P\\wid/2/1/15"
      },
      {
        "title": "Millennium File",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S83H-P9W",
        "citation": ""
      },
      {
        "title": "Ellen Dredge, \"England and Wales, Census, 1861\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SFS6-SR2",
        "citation": "\"England and Wales, Census, 1861\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M7T4-B71 : Thu Sep 10 03:05:11 UTC 2026), Entry for Jasse Dredge and Ellen Dredge, 1861."
      },
      {
        "title": "Mrs J H Dredge, \"Utah, Box Elder, Brigham City Family History Center, Obituary Collection, 1930-2016\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SYGB-FJH",
        "citation": "\"Utah, Box Elder, Brigham City Family History Center, Obituary Collection, 1930-2016\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:CYRB-GQMM : Mon Jan 20 20:18:48 UTC 2025), Entry for William Rheese Or Reese Dredge and Mr J H Dredge, 1946."
      },
      {
        "title": "Ellen Reese Dredge, \"Idaho, Southern Counties Obituaries, 1943-2013\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/WMGZ-K11",
        "citation": "\"Idaho, Southern Counties Obituaries, 1943-2013\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QLWF-WXPD : Wed Jun 04 22:32:46 UTC 2025), Entry for Richard Henry Dredge and Jesse R Dredge."
      },
      {
        "title": "Ellen Rhees Dredge, \"The Church of Jesus Christ of Latter-day Saints, Missionary Registers (Worldwide), 1860-1937\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9B9F-JN5",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Missionary Registers (Worldwide), 1860-1937\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QKDW-YNQC : Tue Mar 11 16:25:25 UTC 2025), Entry for Wm Rhees Dredge and Fredrick Thomas, 1899."
      },
      {
        "title": "Ellen Rhees, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SZR7-3MK",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSX-94VY : Sat Sep 27 20:13:15 UTC 2025), Entry for Hattie or Hettie May Dredge Lusk and Jesse Richard Dredge, 1957."
      },
      {
        "title": "Ellen Rheese, \"Idaho, Death Certificates, 1911-1937\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S8C8-W4V",
        "citation": "\"Idaho, Death Certificates, 1911-1937\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:FLB3-CB3 : Thu Feb 27 18:04:36 UTC 2025), Entry for Elizabeth Dredge Roberts and Jesse P. Dredge, 26 Feb 1921."
      },
      {
        "title": "Ellen Harnedge, \"United States, Census, 1870\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SGBH-G5B",
        "citation": "\"United States, Census, 1870\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MZYB-52D : Fri Oct 10 19:25:10 UTC 2025), Entry for Jesse Harnedge and Ellen Harnedge, 1870."
      },
      {
        "title": "Ellen Rhus, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7V7M-YHF",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6ZPY-LC64 : Thu Mar 26 21:14:26 UTC 2026), Entry for William R Dredge and Fredrick Thomas."
      },
      {
        "title": "Ellen Rhees, \"Idaho, Jefferson Star, County Cemetery Records, 1800-2000\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/WMGZ-KNQ",
        "citation": "\"Idaho, Jefferson Star, County Cemetery Records, 1800-2000\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Z46D-YZT2 : Wed Jan 22 17:27:56 UTC 2025), Entry for Hattie May Dredge Lusk and Jesse R Dredge."
      },
      {
        "title": "Ellen Rhees, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9B9F-JRR",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVS6-44LJ : Sat Sep 27 19:00:40 UTC 2025), Entry for Nora Dredge Fife and Jesse Richard Dredge, 1890."
      },
      {
        "title": "Rheese, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SVXY-Q14",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZPJ-X9L : Tue Jan 21 05:13:15 UTC 2025), Entry for William Rheese Dredge and J.H. Dredge, 08 May 1946."
      },
      {
        "title": "Ellen Rhees, \"England and Wales, Census, 1841\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SPZM-9NT",
        "citation": "\"England and Wales, Census, 1841\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MQ1C-FWD : Tue Sep 08 21:43:21 UTC 2026), Entry for John Rogers and Elizabeth Rogers, 1841."
      },
      {
        "title": "Ellen Reece, \"Idaho, Jefferson Star, County Cemetery Records, 1800-2000\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SL3J-KRC",
        "citation": "\"Idaho, Jefferson Star, County Cemetery Records, 1800-2000\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Z4X7-6PPZ : Thu Mar 07 15:49:11 UTC 2024), Entry for Elizabeth Roberts and Jessie Dredge."
      },
      {
        "title": "Ellen Rhees, \"England and Wales, Census, 1851\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3X3M-JHR",
        "citation": "\"England and Wales, Census, 1851\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:SGGT-1MH : Fri Aug 21 08:59:08 UTC 2026), Entry for Sarah Rhees and Ellen Rhees, 1851."
      },
      {
        "title": "Ellen Rhees Dredge, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S86L-L8G",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVVV-Z8NX : Fri Oct 02 10:47:15 UTC 2026), Entry for Ellen Rhees Dredge."
      },
      {
        "title": "Ellen Rhees Dredge, \"The Church of Jesus Christ of Latter-day Saints, Missionary Registers (Worldwide), 1860-1937\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9B9F-V9W",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Missionary Registers (Worldwide), 1860-1937\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QKDW-YBQ9 : Tue Mar 11 16:24:39 UTC 2025), Entry for Wm Rhees Dredge and Fredrick W Thomas, 1908."
      },
      {
        "title": "Ellen Reece, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SW1C-LWY",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSX-GQZ4 : Sun Oct 19 21:52:10 UTC 2025), Entry for Elizabeth Roberts and Jessie Dredge, 1921."
      },
      {
        "title": "Ellen Rees, \"England, Somerset, Church Records, 1501-1999\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/358R-3J7",
        "citation": "\"England, Somerset, Church Records, 1501-1999\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6D9K-GXJR : Wed Nov 19 10:07:17 UTC 2025), Entry for Ellen Rees and Horatia Nelson Rees, 6 March 1836."
      },
      {
        "title": "Ellen Dredge, \"United States, Census, 1900\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9B9F-QNM",
        "citation": "\"United States, Census, 1900\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MM5T-ZPN : Tue Jan 21 21:58:40 UTC 2025), Entry for Jesse R Dredge and Ellen Dredge, 1900."
      },
      {
        "title": "Ellen Rhees Dredge, \"Utah, Mormon Pioneer Overland Travel Database, 1847-1868\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9B9F-WK5",
        "citation": "\"Utah, Mormon Pioneer Overland Travel Database, 1847-1868\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QK9B-C4C1 : Wed Feb 19 20:21:28 UTC 2025), Entry for Ellen Rhees Dredge, 13 Sep 1861."
      },
      {
        "title": "Ellen Dredge, \"United States, Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9B9F-7G4",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M4ZJ-6HV : Wed Sep 09 09:57:03 UTC 2026), Entry for Jesse Dredge and Ellen Dredge, 1880."
      },
      {
        "title": "Ellen Dredge, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9B9X-1WZ",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVS6-3ZXL : Sat Sep 27 18:48:52 UTC 2025), Entry for Ellen Dredge and Horatio Nelson Rhees, 1903."
      },
      {
        "title": "Ellen Rhees, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9B9F-DNM",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVS6-3ZFS : Sat Sep 27 18:48:52 UTC 2025), Entry for Jesse Horatio Dredge and Jesse Richard Dredge, 1957."
      },
      {
        "title": "Ellen Rhees, \"Idaho, Death Certificates, 1938-1961\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9B9F-NSN",
        "citation": "\"Idaho, Death Certificates, 1938-1961\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2M1-5N3D : Fri Feb 21 22:53:50 UTC 2025), Entry for Jesse Horatia Dredge and Jesse Richard Dredge, 27 May 1957."
      },
      {
        "title": "Ellen Rhees, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9B9F-DSY",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSF-3NSS : Sat Sep 27 21:49:06 UTC 2025), Entry for Hannah Adelia Dredge Thomas and Jesse Richard Dredge, 1895."
      },
      {
        "title": "Ellen Rhees, \"Idaho, Death Certificates, 1938-1961\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9B9F-J3B",
        "citation": "\"Idaho, Death Certificates, 1938-1961\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2M1-PF3J : Fri Feb 21 22:39:31 UTC 2025), Entry for Hettie May Dredge Lusk and Jessie R Dredge, 28 Dec 1957."
      },
      {
        "title": "Ellen Rhees, \"Idaho, Death Certificates, 1938-1961\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9B9F-JCB",
        "citation": "\"Idaho, Death Certificates, 1938-1961\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2M1-5K3X : Fri Feb 21 22:49:55 UTC 2025), Entry for Alice Dredge Thomas and Jesse R Dredge, 6 May 1952."
      },
      {
        "title": "Ellen Rhees, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9B9F-NXM",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSF-36M7 : Sat Sep 27 21:48:47 UTC 2025), Entry for Alice Dredge Thomas and Jesse Richard Dredge, 1952."
      },
      {
        "title": "Ellen Rhees, \"Idaho, Death Certificates, 1938-1961\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9B9F-NLL",
        "citation": "\"Idaho, Death Certificates, 1938-1961\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2M1-5F5T : Fri Feb 21 22:52:41 UTC 2025), Entry for Emma Dredge Harrison and Jessie Richard Dredge, 31 Dec 1957."
      },
      {
        "title": "Ellen Rhees, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9B9F-NRR",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVS6-3ZF8 : Sat Sep 27 18:48:52 UTC 2025), Entry for Jesse Richard Dredge and Richard Henry Dredge, 1913."
      }
    ],
    "portrait": "/ancestors/portraits/079_LB5J-R4S.jpg"
  },
  {
    "id": "I6",
    "name": "Jewel Hull",
    "sex": "F",
    "gen": 2,
    "slot": 1,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "I2",
    "birthYear": 1943,
    "deathYear": null,
    "birthDate": "1943",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "United States",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "L1ZR-NYM",
    "photo": "/ancestors/bubbles/jewel.jpg",
    "living": true,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/jewel.jpg"
  },
  {
    "id": "I24",
    "name": "Benjamin Bruce Hull",
    "sex": "M",
    "gen": 3,
    "slot": 2,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "I6",
    "birthYear": 1908,
    "deathYear": 1998,
    "birthDate": "6 Sep 1908",
    "deathDate": "20 May 1998",
    "burialDate": "22 May 1998",
    "christeningDate": null,
    "birthPlace": "Rawlins, Carbon, Wyoming, United States",
    "deathPlace": "American Fork, Utah, Utah, United States",
    "burialPlace": "Redwood Memorial Estates, West Jordan, Salt Lake, Utah, United States",
    "christeningPlace": null,
    "fsId": "KWZ4-F5T",
    "photo": "/ancestors/bubbles/010_KWZ4-F5T.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [
      {
        "kind": "Blessing",
        "date": "31 August 1913",
        "place": null,
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1920",
        "place": "Englewood, Arapahoe, Colorado, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1930",
        "place": "North Ogden, Weber, Utah, United States",
        "note": null
      },
      {
        "kind": "Military Draft Registration",
        "date": "16 October 1940",
        "place": "Lyman, Uinta, Wyoming, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "April 1950",
        "place": "Rockland, Power, Idaho, United States",
        "note": null
      },
      {
        "kind": "Obituary",
        "date": "21 May 1998",
        "place": "Salt Lake City, Salt Lake, Utah, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": null,
        "place": "Lyman, Uinta, Wyoming, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": null,
        "place": "North Ogden, Weber, Utah, United States",
        "note": null
      },
      {
        "kind": "Membership",
        "date": null,
        "place": "Western States Mission, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Benjamine Hull, \"United States, Census, 1920\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/745V-XN6",
        "citation": "\"United States, Census, 1920\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MX2W-314 : Fri Oct 02 07:27:42 UTC 2026), Entry for Roy E Hull and Mary J Hull, 1920."
      },
      {
        "title": "Benj Bruce Hull, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/77W7-FCQ",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6T8F-H646 : Sun Sep 13 05:43:28 UTC 2026), Entry for Benj Bruce Hull and Jos F Sellers."
      },
      {
        "title": "Benjamin Bruce Hull, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/77W7-F9C",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6T4V-M7GG : Sun Sep 13 00:17:47 UTC 2026), Entry for Benjamin Bruce Hull and Roy E Hull."
      },
      {
        "title": "Ben B Hull, \"United States, Census, 1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3PWK-FNX",
        "citation": "\"United States, Census, 1950\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6XKK-9K3L : Tue Mar 18 06:58:24 UTC 2025), Entry for Ben B Hull and Nina O Hull, April 1950."
      },
      {
        "title": "Benjamin Bruce Hull, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3ZHB-2P5",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:8WRS-F9T2 : Fri Aug 01 20:25:22 UTC 2025), Entry for Benjamin Bruce Hull, 1925."
      },
      {
        "title": "Benjamin Bruce Hull, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3ZHB-K4S",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:84SR-CSN2 : Fri Aug 01 17:24:49 UTC 2025), Entry for Benjamin Bruce Hull, 1935."
      },
      {
        "title": "Benjamin Bruce Hull, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3Z7Q-D77",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:DJS5-BNPZ : Mon Mar 30 07:38:56 UTC 2026), Entry for Benjamin Bruce Hull."
      },
      {
        "title": "Benjamin Bruce Hull, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3CW1-B32",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:DJS5-BJN2 : Mon Mar 30 05:59:40 UTC 2026), Entry for Benjamin Bruce Hull, 1955."
      },
      {
        "title": "Benjamin Bruce Hull, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3CW1-L4L",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:DJSP-N4N2 : Mon Mar 30 05:59:11 UTC 2026), Entry for Benjamin Bruce Hull, 1960."
      },
      {
        "title": "Benjamin Bruce Hull, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3HZY-KZL",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:DF6N-X8T2 : Fri Aug 01 16:56:02 UTC 2025), Entry for Benjamin Bruce Hull."
      },
      {
        "title": "Benjamin Bruce Hull, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3WLV-6PW",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:84KJ-MYPZ : Fri Aug 01 20:18:59 UTC 2025), Entry for Benjamin Bruce Hull, 1930."
      },
      {
        "title": "Ben Hull, \"Utah, Box Elder, Brigham City Family History Center, Obituary Collection, 1930-2016\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/33LN-6RY",
        "citation": "\"Utah, Box Elder, Brigham City Family History Center, Obituary Collection, 1930-2016\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:DMZC-HHMM : Wed Jul 10 06:47:41 UTC 2024), Entry for Lura Mae Hull Hadley and Roy Ernest Hull, 1989."
      },
      {
        "title": "Ben, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SBNP-J23",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QG1L-W5BF : Sat Jan 18 21:49:36 UTC 2025), Entry for Roy Earnest Hull and Dr Melcher, 1965."
      },
      {
        "title": "Ben, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SBNP-J8S",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QLGY-TVZP : Wed Jul 24 04:10:55 UTC 2024), Entry for Roy Earnest Hull and Dr Melcher, 1965."
      },
      {
        "title": "Ben Hull, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SBNP-N67",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QPST-F5Y8 : Fri Jul 19 23:45:17 UTC 2024), Entry for Roy E Hull and Frank Hull."
      },
      {
        "title": "Ben, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SBNP-N93",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QLGY-TV8W : Sat Jul 20 21:11:41 UTC 2024), Entry for Roy E Hull and Frank Hull."
      },
      {
        "title": "Ben B. Hull, \"United States, Western States Marriage Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S5ZB-MDX",
        "citation": "\"United States, Western States Marriage Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZNY-CMR : Tue Feb 11 23:14:20 UTC 2025), Entry for Ben B. Hull and Nina O. Blackner."
      },
      {
        "title": "Ben B. Hull, \"United States, Western States Marriage Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S5ZB-MMH",
        "citation": "\"United States, Western States Marriage Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZD3-62Y : Tue Feb 11 23:10:13 UTC 2025), Entry for Ben B. Hull and Nina O. Blackner, 24 Sep 1930."
      },
      {
        "title": "Ben Bruce Hull, \"Wyoming, World War II Draft Registration Cards, 1940-1945\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SXNB-66K",
        "citation": "\"Wyoming, World War II Draft Registration Cards, 1940-1945\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2WR-28K7 : Tue Apr 29 19:50:20 UTC 2025), Entry for Ben Bruce Hull and Nina Hull, 16 Oct 1940."
      },
      {
        "title": "Benjamin Bruce Hull, \"Utah, Weber County Marriages, 1887-1941\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9FLQ-XM5",
        "citation": "\"Utah, Weber County Marriages, 1887-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QK6K-H3QS : Thu Jan 16 08:08:49 UTC 2025), Entry for Benjamin Bruce Hull and Nina Oleah Blackner, 24 Sep 1930."
      },
      {
        "title": "Ben B Hull, \"Utah, County Marriages, 1887-1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9K9P-KVN",
        "citation": "\"Utah, County Marriages, 1871-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VRLN-HTK : Thu Sep 19 20:23:11 UTC 2024), Entry for Ben B Hull and Roy E Hull, 23 Sep 1930."
      },
      {
        "title": "Ben Hull, \"United States, GenealogyBank Obituaries, Births, and Marriages, 1980-2015\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/98RB-HDL",
        "citation": "\"United States, GenealogyBank Obituaries, Births, and Marriages, 1980-2015\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVP5-TGB9 : Tue Jan 21 12:55:16 UTC 2025), Entry for Leonard Mann Hull and Roy Ernest Hull, 29 Apr 2012."
      },
      {
        "title": "ben B Hull, \"Utah, Weber County Marriages, 1887-1939\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9K9P-KWM",
        "citation": "\"Utah, Weber County Marriages, 1887-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QK6K-XKLH : Tue Jul 16 22:03:30 UTC 2024), Entry for ben B Hull and Roy E Hull, 23 Sep 1930."
      },
      {
        "title": "Benjamin Bruce Hull, \"United States, GenealogyBank Obituaries, 1980-2014\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9K9P-V7D",
        "citation": "\"United States, GenealogyBank Obituaries, Births, and Marriages, 1980-2015\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QKPT-23MJ : Mon Jun 03 19:42:15 UTC 2024), Entry for Benjamin Bruce Hull and Nina Oleah Blackner, 21 May 1998."
      },
      {
        "title": "Benjamin Bruce Hull, \"United States, GenealogyBank Obituaries, Births, and Marriages, 1980-2015\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9DJS-3MJ",
        "citation": "\"United States, GenealogyBank Obituaries, Births, and Marriages, 1980-2015\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QKWZ-7PVP : Mon Jan 20 08:49:07 UTC 2025), Entry for Benjamin Bruce Hull and Roy Ernest Hull, 21 May 1998."
      },
      {
        "title": "Benjamin Bruce Hull, \"BillionGraves Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZVV-RRY",
        "citation": "\"BillionGraves Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KBYW-57X : Thu Sep 24 18:29:52 UTC 2026), Entry for Benjamin Bruce Hull."
      },
      {
        "title": "Benjamin Bruce Hull, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZVV-51Y",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVP9-4QJ9 : Sun Oct 04 05:55:34 UTC 2026), Entry for Benjamin Bruce Hull."
      },
      {
        "title": "Benjamin Bruce Hull, \"Utah, Marriages, 1887-1935\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZVV-5HK",
        "citation": "\"Utah, Marriages, 1887-1935\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:F8GN-SQK : 16 March 2020), Benjamin Bruce Hull, 1930."
      },
      {
        "title": "Ben B Hull, \"United States, Social Security Death Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSTJ-G4Y",
        "citation": "\"United States, Social Security Death Index,\" database, FamilySearch (https://familysearch.org/ark:/61903/1:1:V9TT-2X9 : 11 January 2021), Ben B Hull, 20 May 1998; citing U.S. Social Security Administration, Death Master File, database (Alexandria, Virginia: National Technical Information Service, ongoing)."
      },
      {
        "title": "Ben Hull, \"United States, Census, 1930\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MST6-D44",
        "citation": "\"United States, Census, 1930\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XH6R-QNP : Sat Jan 18 20:21:57 UTC 2025), Entry for Ray E Hull and Mary Hull, 1930."
      },
      {
        "title": "Benjamin Bruce Hull & Nina Oleah Blackner - Western state marriages",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSTJ-LQZ",
        "citation": "Western state marriages - BYUI Family History Center"
      },
      {
        "title": "Headstone image of Benjamin Bruce Hull from billiongraves.com",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMZ8-Q7V",
        "citation": "Transcription of headstone image from billiongraves.com. Image taken at Redwood Memorial Estates (Taylorsville, Salt Lake, Utah, United States) on 05 August 2013"
      },
      {
        "title": "Benjaman B Hull, \"United States Census, 1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMMP-WFT",
        "citation": "\"United States, Census, 1940\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VT4D-HKJ : Wed Jul 24 03:12:05 UTC 2024), Entry for Benjaman B Hull and Nina Hull, 1940."
      }
    ],
    "portrait": "/ancestors/portraits/010_KWZ4-F5T.jpg"
  },
  {
    "id": "I85",
    "name": "Roy Ernest Hull",
    "sex": "M",
    "gen": 4,
    "slot": 4,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "I24",
    "birthYear": 1879,
    "deathYear": 1965,
    "birthDate": "21 Jun 1879",
    "deathDate": "24 Apr 1965",
    "burialDate": "28 Apr 1965",
    "christeningDate": null,
    "birthPlace": "Hopkins, Nodaway, Missouri, United States",
    "deathPlace": "Ashton, Fremont, Idaho, United States",
    "burialPlace": "Ogden City Cemetery, Ogden, Weber, Utah, United States",
    "christeningPlace": null,
    "fsId": "KWCD-K6D",
    "photo": "/ancestors/bubbles/020_KWCD-K6D.jpg",
    "living": false,
    "alternateNames": [
      "Robert Ernest Hull"
    ],
    "facts": [
      {
        "kind": "Residence",
        "date": "1880",
        "place": "Independence Township, Nodaway, Missouri, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1910",
        "place": "Rawlins, Carbon, Wyoming, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1920",
        "place": "Englewood, Arapahoe, Colorado, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1930",
        "place": "North Ogden, Weber, Utah, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "from 1935 to 1940",
        "place": "North Ogden, Weber, Utah, United States",
        "note": "Census shows he is a Canning Factory Machinist and lives, with his wife and three sons, in the $1900 home they own on Ben Lomond Lane. In 1939 he worked 26 weeks and earned $480."
      },
      {
        "kind": "Military Draft Registration",
        "date": "27 April 1942",
        "place": "North Ogden, Weber, Utah, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "April 1950",
        "place": "Rockland, Power, Idaho, United States",
        "note": "Census shows he is widowed and lives, with his son Ben's family on Main Street. He and Ben have their own Service Station business."
      },
      {
        "kind": "Obituaries",
        "date": "1965",
        "place": "Idaho, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": null,
        "place": "North Ogden",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Ray E Hull, \"United States, Census, 1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7DHG-QTD",
        "citation": "\"United States, Census, 1940\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VT4D-MTS : Sun Mar 10 17:52:28 UTC 2024), Entry for Ray E Hull and Mary Jane C Hull, 1940."
      },
      {
        "title": "Roy E Hull, \"United States, Census, 1920\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/745V-CP1",
        "citation": "\"United States, Census, 1920\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MX2W-314 : Fri Oct 02 07:27:42 UTC 2026), Entry for Roy E Hull and Mary J Hull, 1920."
      },
      {
        "title": "Roy E Hull, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/77W7-1H8",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6T4V-M7GB : Sun Sep 13 00:07:46 UTC 2026), Entry for Glen Cranor Hull and Roy E Hull."
      },
      {
        "title": "Roy Earnest, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/77W7-TVK",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6TK8-TXLG : Sun Sep 13 05:24:03 UTC 2026), Entry for Laura May Hull and Saml C Dunn."
      },
      {
        "title": "Roy Earnest Hull, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/77W7-TW3",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6TC3-37NM : Sun Sep 13 00:13:49 UTC 2026), Entry for Roy Earnest Hull and E E Millerberg."
      },
      {
        "title": "Roy E, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/77W7-5JM",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6TNF-VKDK : Sat Sep 12 23:53:20 UTC 2026), Entry for Arthur Earnest Hull and Roy E."
      },
      {
        "title": "Roy E Hull, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/77W7-57C",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6T4V-M7GR : Sun Sep 13 05:50:47 UTC 2026), Entry for Lura May Hull and Roy E Hull."
      },
      {
        "title": "Roy E Hull, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/77W7-PG4",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6T4V-M7P9 : Sun Sep 13 00:13:57 UTC 2026), Entry for Franklin Wyatt Hull and Roy E Hull."
      },
      {
        "title": "Roy E, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/77W7-F85",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6T8F-H646 : Sun Sep 13 05:43:28 UTC 2026), Entry for Benj Bruce Hull and Jos F Sellers."
      },
      {
        "title": "Roy E Hull, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/77W7-FWD",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6T4V-M7GG : Sun Sep 13 00:17:47 UTC 2026), Entry for Benjamin Bruce Hull and Roy E Hull."
      },
      {
        "title": "Roy E Hull, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QTLS-2C9",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QLGY-TV8W : Sat Jul 20 21:11:41 UTC 2024), Entry for Roy E Hull and Frank Hull."
      },
      {
        "title": "Roy Ernest Hull (Idaho Death Certificate - 1965)",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QPSP-M3T",
        "citation": ""
      },
      {
        "title": "Roy Hull, \"Utah, Box Elder, Brigham City Family History Center, Obituary Collection, 1930-2016\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QV6T-2Z8",
        "citation": "\"Utah, Box Elder, Brigham City Family History Center, Obituary Collection, 1930-2016\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:8B5K-DBW2 : Tue Jan 21 10:51:39 UTC 2025), Entry for Kent William Hadley and Mr Roy Hadley, 1959."
      },
      {
        "title": "Roy Ernest Hull, \"United States, World War II Draft Registration Cards, 1942\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QJNB-6NR",
        "citation": "\"United States, World War II Draft Registration Cards, 1942\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QKV9-T1ND : Mon Apr 28 20:39:44 UTC 2025), Entry for Roy Ernest Hull and Mary J Hull, 27 Apr 1942."
      },
      {
        "title": "Roy E Hull, \"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW4T-84R",
        "citation": "\"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6KWY-TVHC : Tue Jun 30 06:47:44 UTC 2026), Entry for John Kenneth Hull and Roy E Hull."
      },
      {
        "title": "Roy E Hull, \"United States, Census, 1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3PWK-ZZC",
        "citation": "\"United States, Census, 1950\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6XKK-9K3L : Tue Mar 18 06:58:24 UTC 2025), Entry for Ben B Hull and Nina O Hull, April 1950."
      },
      {
        "title": "Roy Ernest Hull, \"Utah, Box Elder, Brigham City Family History Center, Obituary Collection, 1930-2016\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3WLV-D45",
        "citation": "\"Utah, Box Elder, Brigham City Family History Center, Obituary Collection, 1930-2016\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:DMZC-HHMM : Wed Jul 10 06:47:41 UTC 2024), Entry for Lura Mae Hull Hadley and Roy Ernest Hull, 1989."
      },
      {
        "title": "Roy Ernest Hull, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3W28-42P",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:84KJ-MYN2 : Fri Aug 01 15:08:09 UTC 2025), Entry for Roy Ernest Hull, 1930."
      },
      {
        "title": "Roy Ernest Hull, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3W2C-T1N",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:DJSX-K53Z : Mon Mar 30 07:36:28 UTC 2026), Entry for Roy Ernest Hull, 1950."
      },
      {
        "title": "Roy Ernest Hull, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3W2C-TW7",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:DJSX-K5W2 : Mon Mar 30 07:34:15 UTC 2026), Entry for Roy Ernest Hull, 1955."
      },
      {
        "title": "Roy Earnest Hull, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3W2C-LL9",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:84KJ-MBZM : Fri Aug 01 15:07:53 UTC 2025), Entry for Roy Earnest Hull, 1935."
      },
      {
        "title": "Roy Earnest Hull, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3W2C-2FR",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:DF65-RDMM : Fri Aug 01 16:54:51 UTC 2025), Entry for Roy Earnest Hull, 1950."
      },
      {
        "title": "Roy Earnest Hull, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3WKL-MLH",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:8WP7-CXZM : Mon Mar 30 07:28:58 UTC 2026), Entry for Roy Earnest Hull, 1940."
      },
      {
        "title": "Roy Ernest Hull, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S1HQ-DCR",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QLGY-N6TH : Fri Mar 08 02:18:27 UTC 2024), Entry for John Kenneth Hull and Roy Ernest Hull, 1999."
      },
      {
        "title": "Roy Ernest Hull, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SBL6-B2Q",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QPSF-7CX4 : Tue Jan 14 06:48:40 UTC 2025), Entry for Leonard Mann Hull and Roy Ernest Hull, 2012."
      },
      {
        "title": "Roy Ernest Hull, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SBL6-YTV",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QL61-NZT8 : Sat Jul 20 02:46:01 UTC 2024), Entry for Leonard Mann Hull and Roy Ernest Hull, 2012."
      },
      {
        "title": "Roy Ernest Hull, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SBL6-YXM",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QPSP-W128 : Fri Mar 08 15:38:54 UTC 2024), Entry for John Kenneth Hull and Roy Ernest Hull, 1999."
      },
      {
        "title": "Roy Earnest Hull, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SBNP-JYS",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QG1L-W5BF : Sat Jan 18 21:49:36 UTC 2025), Entry for Roy Earnest Hull and Dr Melcher, 1965."
      },
      {
        "title": "Roy Earnest Hull, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SBNP-J7J",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QLGY-TVZP : Wed Jul 24 04:10:55 UTC 2024), Entry for Roy Earnest Hull and Dr Melcher, 1965."
      },
      {
        "title": "Roy E Hull, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SBNP-NR3",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QPST-F5Y8 : Fri Jul 19 23:45:17 UTC 2024), Entry for Roy E Hull and Frank Hull."
      },
      {
        "title": "Roy C Hull, \"Utah, World War II Index to Army Veterans of Utah, 1939-1945\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S5ZY-YZH",
        "citation": "\"Utah, World War II Index to Army Veterans of Utah, 1939-1945\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:7M52-2G3Z : Mon Mar 17 15:12:52 UTC 2025), Entry for Howard Joseph Hull and Mary I Hull, 20 Mar 1941."
      },
      {
        "title": "Robert Ernest Hull in entry for Leonard Mann Hull, \"Utah, Births and Christenings, 1892-1941\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SV2J-YTM",
        "citation": "\"Utah, Births and Christenings, 1892-1941\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:4GMT-W66Z : 28 January 2020), Robert Ernest Hull in entry for Leonard Mann Hull, 1924."
      },
      {
        "title": "Roy Ernest Hull in entry for Hull, \"Utah, Births and Christenings, 1892-1941\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SV2J-TVJ",
        "citation": "\"Utah, Births and Christenings, 1892-1941\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:4GMT-QMPZ : 28 January 2020), Roy Ernest Hull in entry for Hull, 1927."
      },
      {
        "title": "Roy Ernest Hull, \"Utah, World War II Draft Registration Cards, 1940-1947\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SFXF-DF5",
        "citation": "\"Utah, World War II Draft Registration Cards, 1940-1947\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2WP-JNZ1 : Mon Apr 28 23:59:17 UTC 2025), Entry for Howard Joseph Hull and Roy Ernest Hull, 16 Oct 1940."
      },
      {
        "title": "Ray E Hull, \"United States, Census, 1930\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SXJQ-2JQ",
        "citation": "\"United States, Census, 1930\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XH6R-QNP : Sat Jan 18 20:21:57 UTC 2025), Entry for Ray E Hull and Mary Hull, 1930."
      },
      {
        "title": "Roy E. Hull, \"United States, Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SXJQ-KVC",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M6X1-3VX : Wed Sep 09 12:50:48 UTC 2026), Entry for John C. Benedick and Ann V. Benedick, 1880."
      },
      {
        "title": "Roy E Hull, \"Utah, World War II Draft Registration Cards, 1940-1947\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SX6F-DPH",
        "citation": "\"Utah, World War II Draft Registration Cards, 1940-1947\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2WP-JN38 : Tue Apr 29 00:08:59 UTC 2025), Entry for Harold Edwin Hull and Roy E Hull, 16 Feb 1942."
      },
      {
        "title": "R E Hull, \"Utah, World War II Draft Registration Cards, 1940-1947\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SX6F-4T3",
        "citation": "\"Utah, World War II Draft Registration Cards, 1940-1947\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2WP-JNV7 : Tue Apr 29 00:04:48 UTC 2025), Entry for Leonard Mann Hull and R E Hull, 16 Dec 1942."
      },
      {
        "title": "Roy Ernest Hull, \"Utah, World War II Index to Army Veterans of Utah, 1939-1945\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S8C2-7T5",
        "citation": "\"Utah, World War II Index to Army Veterans of Utah, 1939-1945\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:7M52-2G6Z : Tue Nov 26 20:02:39 UTC 2024), Entry for Leonard Mann Hull and Mary Cramer Hull, 8 May 1943."
      },
      {
        "title": "Roy Ernest Hull, \"Utah, World War II Index to Army Veterans of Utah, 1939-1945\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S8C2-QQN",
        "citation": "\"Utah, World War II Index to Army Veterans of Utah, 1939-1945\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:7M52-2L2M : Mon Mar 17 15:13:19 UTC 2025), Entry for Harold Edwin Hull and Mary Jane Hull, 1 Sep 1942."
      },
      {
        "title": "Roy Ernest Hull, \"Wyoming, Marriages, 1869-1923\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SQD1-3ZV",
        "citation": "\"Wyoming, Marriages, 1869-1923\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2DM-4HXH : Sun Mar 10 18:52:08 UTC 2024), Entry for Roy Ernest Hull and Mary J Cranor, 16 Nov 1904."
      },
      {
        "title": "Roy Ernest Hull, \"BillionGraves Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SQDB-R8P",
        "citation": "\"BillionGraves Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QP51-Y7NT : Thu Sep 24 22:40:44 UTC 2026), Entry for Roy Ernest Hull."
      },
      {
        "title": "Roy Ernest Hull, \"Idaho, Southern Counties Obituaries, 1943-2013\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9YHM-V49",
        "citation": "\"Idaho, Southern Counties Obituaries, 1943-2013\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QGT3-VPZ9 : Sun Oct 19 06:27:34 UTC 2025), Entry for John Kenneth Hull and Roy Ernest Hull, 1999."
      },
      {
        "title": "1900 Roy E Hull in household of John C Brown, \"United States Census, 1900\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMF7-6G2",
        "citation": "\"United States, Census, 1900\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M3VR-8RZ : Mon Jan 27 20:05:46 UTC 2025), Entry for John C Brown and Hellen Brown, 1900."
      },
      {
        "title": "1910 Roy L Hull, \"United States Census, 1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/98HC-2YF",
        "citation": "\"United States, Census, 1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MPJV-8Q4 : Wed Aug 13 17:36:19 UTC 2025), Entry for Roy L Hull and Jennie Hull, 1910."
      },
      {
        "title": "1917-1918 Roy Ernest Hull, \"United States World War I Draft Registration Cards, 1917-1918\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMF7-6ZB",
        "citation": "\"United States, World War I Draft Registration Cards, 1917-1918\", database with images, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KZKC-11V : 1 July 2024), Roy Ernest Hull, 1917-1918."
      },
      {
        "title": "20 JUNE 1927 mARRIAGE Roy E Hull in entry for WM R Hadley and Lura Hull, \"Utah, Weber County Marriages, 1887-1941\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9GKQ-49L",
        "citation": "\"Utah, Weber County Marriages, 1887-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QK6K-66VW : Wed Jan 15 09:13:22 UTC 2025), Entry for WM R Hadley and WM Hadley, 20 Jun 1927."
      },
      {
        "title": "23 SEPTEMBER MARRIAGE Roy E Hull in entry for Ben B Hull and Nina O Blackner, \"Utah, County Marriages, 1887-1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9K9P-K6X",
        "citation": "\"Utah, County Marriages, 1871-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VRLN-HTK : Thu Sep 19 20:23:11 UTC 2024), Entry for Ben B Hull and Roy E Hull, 23 Sep 1930."
      },
      {
        "title": "Roy E Hull in entry for ben B Hull and Nina O Blackner, \"Utah, Weber County Marriages, 1887-1939\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9K9P-VYK",
        "citation": "\"Utah, Weber County Marriages, 1887-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QK6K-XKLH : Tue Jul 16 22:03:30 UTC 2024), Entry for ben B Hull and Roy E Hull, 23 Sep 1930."
      },
      {
        "title": "Roy E Hull, \"Utah, County Marriages, 1871-1941\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSPV-TXN",
        "citation": "\"Utah, County Marriages, 1871-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VRLF-VD4 : Thu Sep 19 19:19:58 UTC 2024), Entry for Wm R Hadley and Wm Hadley, 20 Jun 1927."
      },
      {
        "title": "22 SEPT 1945 MARRIAGE Roy E Hull in entry for Howard J Hull and Katherine Wanha, \"California, County Marriages, 1850-1952\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSPV-TQZ",
        "citation": "\"California, County Marriages, 1849-1957\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:K8K9-X26 : Wed Jul 10 00:40:28 UTC 2024), Entry for Howard J Hull and Roy E Hull, 22 Sep 1945."
      },
      {
        "title": "24 APRIL1965 Roy Ernest Hull, \"Find A Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9GXQ-JL1",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QV2T-B73W : Fri Oct 02 08:46:10 UTC 2026), Entry for Roy Ernest Hull, 1965."
      },
      {
        "title": "Hull, Roy Ernest - Find a Grave Burial record 1965",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSTJ-BNK",
        "citation": "findagrave.com"
      },
      {
        "title": "Roy Hull, \"United States Social Security Death Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMF7-6JT",
        "citation": "\"United States, Social Security Death Index,\" database, FamilySearch (https://familysearch.org/ark:/61903/1:1:JG9X-DNB : 11 January 2021), Roy Hull, Apr 1965; citing U.S. Social Security Administration, Death Master File, database (Alexandria, Virginia: National Technical Information Service, ongoing)."
      },
      {
        "title": "Roy E . Hull, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSPV-R5B",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZ2L-WRQ : Mon Feb 03 19:17:26 UTC 2025), Entry for Arthur Ernest Hull and Roy E . Hull, 27 May 1921."
      },
      {
        "title": "Roy Ernest Hull in entry for Bessie Pearl Hull, \"Utah Death Certificates, 1904-1956\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMF7-64T",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZ2L-S4V : Mon Feb 03 19:05:52 UTC 2025), Entry for Bessie Pearl Hull and Roy Ernest Hull, 01 Mar 1921."
      },
      {
        "title": "Roy Ernest Hull in entry for Mrs Lura Mae Hull Hadley, \"Utah, Tremonton and Garland Obituaries, 1959-2013\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/92QY-9L2",
        "citation": "\"Utah, Box Elder, Tremonton and Garland Obituaries, 1959-2013\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2QP-L6BZ : Fri Mar 08 06:21:14 UTC 2024), Entry for Mrs Lura Mae Hull Hadley and Roy Ernest Hull, 1989."
      },
      {
        "title": "Roy Ernest Hull in entry for Benjamin Bruce Hull, \"United States, GenealogyBank Obituaries, 1980-2014\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9K9P-KBV",
        "citation": "\"United States, GenealogyBank Obituaries, Births, and Marriages, 1980-2015\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QKWZ-7PVP : Mon Jan 20 08:49:07 UTC 2025), Entry for Benjamin Bruce Hull and Roy Ernest Hull, 21 May 1998."
      },
      {
        "title": "Roy Ernest Hull in entry for Benjamin Bruce Hull, \"United States, GenealogyBank Obituaries, 1980-2014\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9K9P-JR9",
        "citation": "\"United States, GenealogyBank Obituaries, Births, and Marriages, 1980-2015\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QKPT-23MJ : Mon Jun 03 19:42:15 UTC 2024), Entry for Benjamin Bruce Hull and Nina Oleah Blackner, 21 May 1998."
      },
      {
        "title": "Roy E Hull, \"Idaho, Southern Counties Obituaries, 1943-2013\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZC2-LYF",
        "citation": "\"Idaho, Southern Counties Obituaries, 1943-2013\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVS8-1CYN : Thu Sep 19 19:08:59 UTC 2024), Entry for Roy E Hull and Kenneth Hull, 1965."
      },
      {
        "title": "Roy Ernest Hull (1879 - 1965) - Find A Grave Memorial",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9JVN-ZPM",
        "citation": "\"Roy Ernest Hull (1879 - 1965) - Find A Grave Memorial.\" Roy Ernest Hull (1879 - 1965) - Find A Grave Memorial. N.p., n.d. Web. 17 Jan. 2017. ."
      },
      {
        "title": "Roy Ernest Hull, \"Idaho, Southern Counties Obituaries, 1943-2013\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/96CN-SMG",
        "citation": "\"Idaho, Southern Counties Obituaries, 1943-2013\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVS8-1CPB : Thu Sep 19 19:27:36 UTC 2024), Entry for John Kenneth Hull and Roy Ernest Hull, 1999."
      },
      {
        "title": "Roy Ernest Hull, \"United States, GenealogyBank Obituaries, Births, and Marriages, 1980-2015\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/98RB-4FP",
        "citation": "\"United States, GenealogyBank Obituaries, Births, and Marriages, 1980-2015\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVP5-TGB9 : Tue Jan 21 12:55:16 UTC 2025), Entry for Leonard Mann Hull and Roy Ernest Hull, 29 Apr 2012."
      },
      {
        "title": "ROY ERNEST HULL, \"BillionGraves Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZKD-95R",
        "citation": "\"BillionGraves Index,\" database, FamilySearch (https://familysearch.org/ark:/61903/1:1:KN7P-8C4 : 25 September 2018), ROY ERNEST HULL, died 24 Apr 1965; citing BillionGraves (http://www.billiongraves.com : 2012), Burial at Ogden City Cemetery, Ogden, Weber, Utah, United States."
      }
    ],
    "portrait": "/ancestors/portraits/020_KWCD-K6D.jpg"
  },
  {
    "id": "I213",
    "name": "Edmond Frank Hull",
    "sex": "M",
    "gen": 5,
    "slot": 8,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "I85",
    "birthYear": 1851,
    "deathYear": 1911,
    "birthDate": "18 Dec 1851",
    "deathDate": "29 Jun 1911",
    "burialDate": "1 Jul 1911",
    "christeningDate": null,
    "birthPlace": "Meriden, LaSalle, Illinois, United States",
    "deathPlace": "Oklahoma City, Oklahoma, Oklahoma, United States",
    "burialPlace": "Oklahoma City, Oklahoma, Oklahoma, United States",
    "christeningPlace": null,
    "fsId": "KJMH-B42",
    "photo": "/ancestors/bubbles/040_KJMH-B42.jpg",
    "living": false,
    "alternateNames": [
      "Frank Hull"
    ],
    "facts": [],
    "sketch": "",
    "sources": [
      {
        "title": "Legacy NFS Source: Edmund Frank Hull - Published information: Family genealogies: birth-name: (Francis) Frank Hull",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMK9-LQR",
        "citation": ""
      },
      {
        "title": "Frank Hull, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/77W7-TCB",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6TC3-37NM : Sun Sep 13 00:13:49 UTC 2026), Entry for Roy Earnest Hull and E E Millerberg."
      },
      {
        "title": "Frank Hull, \"Missouri, County Marriage, Naturalization, and Court Records, 1800-1991\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7JB8-GNS",
        "citation": "\"Missouri, County Marriage, Naturalization, and Court Records, 1800-1991\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:WPQH-H5N2 : Fri Mar 08 05:24:35 UTC 2024), Entry for Frank Hull and Loui Benedict, 2 Oct 1878."
      },
      {
        "title": "Frank Hall in household of Emma Williams, \"United States Census, 1860\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMBV-QG4",
        "citation": "\"United States, Census, 1860\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MX42-WT5 : Mon Jul 08 05:16:48 UTC 2024), Entry for Emma Williams and Frank Hall, 1860."
      },
      {
        "title": "Frank Hull in household of John C Benedick, \"United States Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M9MP-L75",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M6X1-3VX : Wed Sep 09 12:50:48 UTC 2026), Entry for John C. Benedick and Ann V. Benedick, 1880."
      },
      {
        "title": "Frank Hull, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/98HH-KYH",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVPM-7D3B : Fri Oct 02 17:32:37 UTC 2026), Entry for Frank Hull, 1911."
      },
      {
        "title": "Frank Hull, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S1CQ-B59",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QLGY-TVZP : Wed Jul 24 04:10:55 UTC 2024), Entry for Roy Earnest Hull and Dr Melcher, 1965."
      },
      {
        "title": "Frank Hull, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S1CQ-1FD",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QG1L-W5BF : Sat Jan 18 21:49:36 UTC 2025), Entry for Roy Earnest Hull and Dr Melcher, 1965."
      },
      {
        "title": "Frank Hull, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S1C7-M9J",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QLGY-TV8W : Sat Jul 20 21:11:41 UTC 2024), Entry for Roy E Hull and Frank Hull."
      },
      {
        "title": "Frank Hull, \"Missouri, Marriages, 1750-1920\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMKZ-QVR",
        "citation": "\"Missouri, Marriages, 1750-1920\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:V28Y-ZLF : 18 January 2020), Frank Hull, 1878."
      },
      {
        "title": "Frank Hull, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S1C7-M5Z",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QPST-F5Y8 : Fri Jul 19 23:45:17 UTC 2024), Entry for Roy E Hull and Frank Hull."
      },
      {
        "title": "Frank Hull, \"Missouri, County Marriage, Naturalization, and Court Records, 1800-1991\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7JBD-VCR",
        "citation": "\"Missouri, County Marriage, Naturalization, and Court Records, 1800-1991\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:WPQ3-RX3Z : Sun Mar 10 18:14:18 UTC 2024), Entry for Frank Hull and Loui Benedict, 2 Oct 1878."
      }
    ],
    "portrait": "/ancestors/portraits/040_KJMH-B42.jpg"
  },
  {
    "id": "I418",
    "name": "Vinal Francis Hull",
    "sex": "M",
    "gen": 6,
    "slot": 16,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "I213",
    "birthYear": 1830,
    "deathYear": 1879,
    "birthDate": "22 Oct 1830",
    "deathDate": "Jul 1879",
    "burialDate": "1879",
    "christeningDate": null,
    "birthPlace": "New York, United States",
    "deathPlace": "Sonoma, Sonoma, California, United States",
    "burialPlace": "Sonoma, Sonoma, California, United States of America",
    "christeningPlace": null,
    "fsId": "LZCP-7BB",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Vinal Frank Hull",
      "C F Hull",
      "Vinal F. Hull",
      "V F Hull",
      "C. F. Hull"
    ],
    "facts": [
      {
        "kind": "Military service",
        "date": "from 1861 to 1865",
        "place": "Illinois, United States",
        "note": null
      },
      {
        "kind": "Voter Registration",
        "date": "26 July 1866",
        "place": "San Francisco, California, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Frank Hull, \"United States, Civil War Soldiers Index, 1861-1865\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7XJP-C93",
        "citation": "\"United States, Civil War Soldiers Index, 1861-1865\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:F9GP-HZ9 : Wed Feb 12 22:39:11 UTC 2025), Entry for Frank Hull, from 1861 to 1865."
      },
      {
        "title": "V Francis Hull, \"California, Great Registers, 1848-1921\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S8DV-TQ7",
        "citation": "\"California, Great Registers, 1848-1921\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VT6V-8GR : Fri Jan 17 21:31:53 UTC 2025), Entry for V Francis Hull, 26 Jul 1866."
      },
      {
        "title": "V Francis Hull, \"California, Great Registers, 1848-1921\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S8DV-RWV",
        "citation": "\"California, Great Registers, 1848-1921\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VT6V-8T7 : Mon Jan 20 00:52:24 UTC 2025), Entry for V Francis Hull, 26 Jul 1866."
      },
      {
        "title": "California, Voter Registers, 1866-1898",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9TPX-SYY",
        "citation": "California State Library, California History Section; Great Registers, 1866-1898; Collection Number: 4 - 2A; CSL Roll Number: 44; FHL Roll Number: 977099"
      },
      {
        "title": "California, Voter Registers, 1866-1898",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9TPX-SYD",
        "citation": ""
      },
      {
        "title": "California, Voter Registers, 1866-1898",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9TPX-STR",
        "citation": ""
      },
      {
        "title": "California, Voter Registers, 1866-1898",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9TPX-ST8",
        "citation": ""
      },
      {
        "title": "California, Voter Registers, 1866-1898",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9TPX-SRT",
        "citation": ""
      },
      {
        "title": "1850 United States Federal Census",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9TPX-SR8",
        "citation": "Year: 1850; Census Place: Meriden, Lasalle, Illinois; Roll: M432_115; Page: 302; Image: 252."
      },
      {
        "title": "Vinal Francis Hull, \"Find A Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/929X-HMK",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QK1K-D3N4 : Thu Oct 01 12:54:32 UTC 2026), Entry for Vinal Francis Hull."
      },
      {
        "title": "Legacy NFS Source: Vinal Francis Hull - Published information: birth-name: Vinal Francis Hull",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M9DW-DWT",
        "citation": ""
      },
      {
        "title": "Vinal F Hall in household of Frederich M Baldwin, \"United States Census, 1850\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMVJ-SNT",
        "citation": "\"United States, Census, 1850\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M8RS-XX7 : Tue Oct 21 08:39:20 UTC 2025), Entry for Frederich M Baldwin and Elizabeth Baldwin, 1850."
      },
      {
        "title": "W F Hull, \"California, State Census, 1852\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M97L-QFJ",
        "citation": "\"California, State Census, 1852\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:V4NC-TSN : Sat Jan 18 19:32:30 UTC 2025), Entry for W F Hull, 1852."
      },
      {
        "title": "V F Hull in household of Jas Mc Cornell, \"United States Census, 1860\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M97L-Q4G",
        "citation": "\"United States, Census, 1860\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MDKV-R7S : Mon Jul 08 04:06:10 UTC 2024), Entry for Jas Mc Cornell and V F Hull, 1860."
      },
      {
        "title": "V Francis Hull, \"California, Great Registers, 1866-1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMKH-GJG",
        "citation": "\"California, Great Registers, 1848-1921\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VT6N-2C8 : Sun Jan 19 10:47:01 UTC 2025), Entry for V Francis Hull, 26 Jul 1866."
      },
      {
        "title": "Vinal Francis Hull, \"California, Great Registers, 1866-1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMKH-GJ7",
        "citation": "\"California, Great Registers, 1848-1921\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VYDH-8XH : Fri Jan 17 17:41:21 UTC 2025), Entry for Vinal Francis Hull, 06 Nov 1876."
      },
      {
        "title": "Venal Francis Hull, \"California, Great Registers, 1866-1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMKH-GVP",
        "citation": "\"California, Great Registers, 1848-1921\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VT6L-CPC : Thu Jan 16 11:14:33 UTC 2025), Entry for Venal Francis Hull, 06 Nov 1876."
      }
    ]
  },
  {
    "id": "I417",
    "name": "Emaline C Lindsay",
    "sex": "F",
    "gen": 6,
    "slot": 17,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "I213",
    "birthYear": 1831,
    "deathYear": 1907,
    "birthDate": "16 May 1831",
    "deathDate": "21 Sep 1907",
    "burialDate": "Sep 1907",
    "christeningDate": null,
    "birthPlace": "Bangor, Maine, USA",
    "deathPlace": "Kansas City, Jackson, Missouri, USA",
    "burialPlace": "Clinton, Henry Co., Missouri, USA",
    "christeningPlace": null,
    "fsId": "KF4P-YN2",
    "photo": "/ancestors/bubbles/081_KF4P-YN2.jpg",
    "living": false,
    "alternateNames": [
      "Hanna",
      "Emoline G Lindsay",
      "Emiline C Lindsay",
      "Emeline G Hanna Lindsey",
      "Emaline G Lindsay"
    ],
    "facts": [
      {
        "kind": "Residence",
        "date": "1850",
        "place": "Meriden, LaSalle, Illinois, United States",
        "note": null
      },
      {
        "kind": "census",
        "date": "1880",
        "place": "Clinton, Henry, Missouri, United States",
        "note": null
      },
      {
        "kind": "census",
        "date": "1900",
        "place": "Clinton, Henry, Missouri, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Legacy NFS Source: Emaline C Lindsay - Obituary: death: 21 September 1907; Kansas City, Jackson, Missouri, United States",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MS81-GFL",
        "citation": "Article"
      },
      {
        "title": "Legacy NFS Source: Emaline C Lindsay - Cemetery record or headstone: birth-name: Emaline C Lindsay",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MS81-GN8",
        "citation": "Internet, Jean Swann, Betty Johnson, Linda Everhart, www.rootsweb.com/~mohenry/cemetery/eng23.htm, Archive, Englewood Cemetery WF-WI aka: Clinton City Cemetery, 400 S Vansant Rd, Clinton, Missouri, USA"
      },
      {
        "title": "Emeline Lindsey in household of Frederich M Baldwin, \"United States Census, 1850\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/929X-8BK",
        "citation": "\"United States, Census, 1850\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M8RS-XX7 : Tue Oct 21 08:39:20 UTC 2025), Entry for Frederich M Baldwin and Elizabeth Baldwin, 1850."
      },
      {
        "title": "Emma Williams, \"United States Census, 1860\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMBV-498",
        "citation": "\"United States, Census, 1860\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MX42-WT5 : Mon Jul 08 05:16:48 UTC 2024), Entry for Emma Williams and Frank Hall, 1860."
      },
      {
        "title": "Emoline C Williams in household of Isaac P Williams, \"United States Census, 1870\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMX9-NLK",
        "citation": "\"United States, Census, 1870\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M46W-MMK : Wed Jan 22 00:22:18 UTC 2025), Entry for Isaac P Williams and Emoline C Williams, 1870."
      },
      {
        "title": "Emma Williams in household of Isaac Williams, \"United States Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMVJ-94W",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M6X7-5HJ : Wed Sep 09 13:43:21 UTC 2026), Entry for Isaac Williams and Emma Williams, 1880."
      },
      {
        "title": "Emaline Lindsey in entry for Lee Williams, \"Ohio, Deaths, 1908-1953\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M9SF-F59",
        "citation": "\"Ohio, Deaths, 1908-1953\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:X8PL-6LR : Tue Mar 05 05:30:25 UTC 2024), Entry for Lee Williams and Isaac Williams, 15 Dec 1921."
      },
      {
        "title": "Emma C Williamson in household of I P Williamson, \"United States Census, 1900\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMX9-JFN",
        "citation": "\"United States, Census, 1900\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M3CP-NV9 : Tue Mar 04 17:20:53 UTC 2025), Entry for I P Williamson and Emma C Williamson, 1900."
      },
      {
        "title": "Emeline Lindsey in household of Frederich M Baldwin, \"United States Census, 1850\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMVJ-955",
        "citation": "\"United States, Census, 1850\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M8RS-XX7 : Tue Oct 21 08:39:20 UTC 2025), Entry for Frederich M Baldwin and Elizabeth Baldwin, 1850."
      },
      {
        "title": "Emeline Lindsey in household of Frederich M Baldwin, \"United States Census, 1850\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/929X-D78",
        "citation": "\"United States, Census, 1850\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M8RS-XX7 : Tue Oct 21 08:39:20 UTC 2025), Entry for Frederich M Baldwin and Elizabeth Baldwin, 1850."
      },
      {
        "title": "Emiline C Lindsay Williams, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3LK9-GQL",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVVD-BK81 : Fri Oct 02 18:48:39 UTC 2026), Entry for Emma, 1907."
      }
    ],
    "portrait": "/ancestors/portraits/081_KF4P-YN2.jpg"
  },
  {
    "id": "I214",
    "name": "Allura Benedict",
    "sex": "F",
    "gen": 5,
    "slot": 9,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "I85",
    "birthYear": 1859,
    "deathYear": 1901,
    "birthDate": "23 Jan 1859",
    "deathDate": "7 Feb 1901",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "West Point, Lee, Iowa, United States",
    "deathPlace": "Crabill Ranch on Turkey Creek, near Red Cliff, Eagle County, Colorado, United States",
    "burialPlace": "Mountain View Cemetery, Longmont, Boulder County, Colorado, United States",
    "christeningPlace": null,
    "fsId": "KJMH-B6C",
    "photo": "/ancestors/bubbles/041_KJMH-B6C.jpg",
    "living": false,
    "alternateNames": [
      "Loni Benedict",
      "BENNEDICT Lori Lou"
    ],
    "facts": [
      {
        "kind": "Residence",
        "date": "1860",
        "place": "Pleasant Ridge Township, Lee, Iowa, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1870",
        "place": "Iowa, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Headstone image of Allura H. Oxford from billiongraves.com",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SS2N-MT5",
        "citation": "Transcription of headstone image from billiongraves.com. Image taken at Mountain View Cemetery (Longmont, Boulder, Colorado, United States) on 31 August 2018"
      },
      {
        "title": "Obituary of Allura Benedict",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMKZ-B7H",
        "citation": "Eagle County, Colorado – O - Obituaries"
      },
      {
        "title": "Allura Benedict Hull, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S1C7-M4Z",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QLGY-TV8W : Sat Jul 20 21:11:41 UTC 2024), Entry for Roy E Hull and Frank Hull."
      },
      {
        "title": "Allura B Hull, \"Colorado Statewide Marriage Index, 1853-2006\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M93T-L3S",
        "citation": "\"Colorado, Statewide Marriage Index, 1853-2006\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KNQJ-W63 : Sat Feb 07 05:43:41 UTC 2026), Entry for Samuel Oxford and Allura B Hull, 24 Dec 1897."
      },
      {
        "title": "Loui Benedict, \"Missouri, County Marriage, Naturalization, and Court Records, 1800-1991\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7JBD-VLQ",
        "citation": "\"Missouri, County Marriage, Naturalization, and Court Records, 1800-1991\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:WPQ3-RX3Z : Sun Mar 10 18:14:18 UTC 2024), Entry for Frank Hull and Loui Benedict, 2 Oct 1878."
      },
      {
        "title": "Loni Benedict, \"Missouri, Marriages, 1750-1920\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMKZ-Q24",
        "citation": "\"Missouri, Marriages, 1750-1920\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:V28Y-ZLN : 18 January 2020), Loni Benedict in entry for Frank Hull, 1878."
      },
      {
        "title": "Allura Benedict Oxford, \"Find A Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9GKP-RCS",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVKZ-F2Y2 : Sun Oct 04 16:31:41 UTC 2026), Entry for Allura Benedict Oxford."
      },
      {
        "title": "Allura Benedict, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S1CQ-1SY",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QLGY-TVZP : Wed Jul 24 04:10:55 UTC 2024), Entry for Roy Earnest Hull and Dr Melcher, 1965."
      },
      {
        "title": "Lura Benedick, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/77W7-THN",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6TC3-37NM : Sun Sep 13 00:13:49 UTC 2026), Entry for Roy Earnest Hull and E E Millerberg."
      },
      {
        "title": "Aldora Hull in household of John C Benedick, \"United States Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMBV-SXG",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M6X1-3VX : Wed Sep 09 12:50:48 UTC 2026), Entry for John C. Benedick and Ann V. Benedick, 1880."
      },
      {
        "title": "Allura Benedict, \"United States, Census, 1870\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/96VL-HLY",
        "citation": "\"United States, Census, 1870\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MDVG-JCZ : Sun Oct 19 12:20:51 UTC 2025), Entry for J P Benedict and Ann V Benedict, 1870."
      },
      {
        "title": "Allura Benedict Hull, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S1C7-9MT",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QPST-F5Y8 : Fri Jul 19 23:45:17 UTC 2024), Entry for Roy E Hull and Frank Hull."
      },
      {
        "title": "Loui Benedict, \"Missouri, County Marriage, Naturalization, and Court Records, 1800-1991\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7JB8-GLH",
        "citation": "\"Missouri, County Marriage, Naturalization, and Court Records, 1800-1991\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:WPQH-H5N2 : Fri Mar 08 05:24:35 UTC 2024), Entry for Frank Hull and Loui Benedict, 2 Oct 1878."
      },
      {
        "title": "Allma Oxford in household of Saml Oxford, \"United States Census, 1900\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M93Y-W38",
        "citation": "\"United States, Census, 1900\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MQMK-8YY : Wed Oct 15 15:44:08 UTC 2025), Entry for Saml Oxford and Allma Oxford, 1900."
      },
      {
        "title": "Allura Benedict, \"United States, Census, 1860\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/96VL-C7R",
        "citation": "\"United States, Census, 1860\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M8LM-VDY : Mon Jul 08 07:09:36 UTC 2024), Entry for John Benedict and Ann Benedict, 1860."
      },
      {
        "title": "Allura Benedict, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S1CQ-1LG",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QG1L-W5BF : Sat Jan 18 21:49:36 UTC 2025), Entry for Roy Earnest Hull and Dr Melcher, 1965."
      }
    ],
    "portrait": "/ancestors/portraits/041_KJMH-B6C.jpg"
  },
  {
    "id": "I414",
    "name": "John Phillips Benedict",
    "sex": "M",
    "gen": 6,
    "slot": 18,
    "side": "paternal",
    "birthplace": "canada",
    "childId": "I214",
    "birthYear": 1831,
    "deathYear": 1891,
    "birthDate": "6 Aug 1831",
    "deathDate": "28 Dec 1891",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Yonge, Leeds, Upper Canada, British Colonial America",
    "deathPlace": "Maryville, Nodaway, Missouri, United States",
    "burialPlace": "Gaynor, Nodaway, Missouri, United States",
    "christeningPlace": null,
    "fsId": "KFH6-CVS",
    "photo": "/ancestors/bubbles/082_KFH6-CVS.jpg",
    "living": false,
    "alternateNames": [
      "John Philips Benedict"
    ],
    "facts": [
      {
        "kind": "Record",
        "date": "3 August 1860",
        "place": "St. Louis, Missouri, United States",
        "note": null
      },
      {
        "kind": "Military service",
        "date": "from 1861 to 1865",
        "place": "Missouri, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1865",
        "place": "West Point, Lee, Iowa, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1868",
        "place": "Lee, Iowa, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1870",
        "place": "Red Oak Township, Montgomery, Iowa, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1880",
        "place": "Independence Township, Nodaway, Missouri, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "J P Benedict, \"United States, Census, 1870\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9X29-MGC",
        "citation": "\"United States, Census, 1870\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MDVG-JCZ : Sun Oct 19 12:20:51 UTC 2025), Entry for J P Benedict and Ann V Benedict, 1870."
      },
      {
        "title": "John P Benedict, \"United States City and Business Directories, ca. 1749 - ca. 1990\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/79T1-7F8",
        "citation": "\"United States City and Business Directories, ca. 1749 - ca. 1990\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:68Z9-4XPR : Fri May 01 14:14:52 UTC 2026), Entry for John P Benedict, 1865."
      },
      {
        "title": "John Benedict, \"United States, Census, 1860\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SKBM-2J7",
        "citation": "\"United States, Census, 1860\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M8LM-VDY : Mon Jul 08 07:09:36 UTC 2024), Entry for John Benedict and Ann Benedict, 1860."
      },
      {
        "title": "John P Benedict, \"United States City and Business Directories, ca. 1749 - ca. 1990\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/79T1-7MQ",
        "citation": "\"United States City and Business Directories, ca. 1749 - ca. 1990\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:DDNP-NYN2 : Thu Jul 18 14:17:55 UTC 2024), Entry for John P Benedict, 1868."
      },
      {
        "title": "John P. Benedict, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/98JH-TDJ",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVK6-9Z1L : Sun Oct 04 19:17:08 UTC 2026), Entry for John P. Benedict."
      },
      {
        "title": "John Benedict, \"Missouri, County Naturalization Records, 1830-1985\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7XVQ-W1M",
        "citation": "\"Missouri, County Naturalization Records, 1830-1985\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6LQN-TZC6 : Sat Mar 09 08:16:27 UTC 2024), Entry for John Benedict, 3 Aug 1860."
      },
      {
        "title": "John P. Benedict, \"Iowa, County Marriages, 1838-1934\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9X29-QWP",
        "citation": "\"Iowa, County Marriages, 1838-1934\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XJ7P-BJV : Sat Jul 26 04:09:08 UTC 2025), Entry for John P. Benedict and Ann Hammer, 04 Feb 1854."
      },
      {
        "title": "Philip Benedict, \"United States, Civil War Soldiers Index, 1861-1865\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7XVQ-HFB",
        "citation": "\"United States, Civil War Soldiers Index, 1861-1865\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:F9TY-RMX : Thu Feb 13 00:19:18 UTC 2025), Entry for Philip Benedict, from 1861 to 1865."
      },
      {
        "title": "John C. Benedick, \"United States, Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9X29-9J1",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M6X1-3VX : Wed Sep 09 12:50:48 UTC 2026), Entry for John C. Benedick and Ann V. Benedick, 1880."
      }
    ],
    "portrait": "/ancestors/portraits/082_KFH6-CVS.jpg"
  },
  {
    "id": "I415",
    "name": "Ann V Hammer",
    "sex": "F",
    "gen": 6,
    "slot": 19,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "I214",
    "birthYear": 1835,
    "deathYear": 1893,
    "birthDate": "3 Jul 1835",
    "deathDate": "28 Sep 1893",
    "burialDate": "1893",
    "christeningDate": null,
    "birthPlace": "Indiana, United States",
    "deathPlace": "Maryville, Nodaway, Missouri, United States",
    "burialPlace": "New Hope Cemetery, Independence Township, Nodaway, Missouri, United States",
    "christeningPlace": null,
    "fsId": "KP69-4RC",
    "photo": "/ancestors/bubbles/083_KP69-4RC.jpg",
    "living": false,
    "alternateNames": [
      "Ann V. Hammer",
      "Anna V Hammer"
    ],
    "facts": [
      {
        "kind": "Residence",
        "date": "1870",
        "place": "Iowa, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1880",
        "place": "Independence Township, Nodaway, Missouri, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Ann V Benedict, \"United States, Census, 1870\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9X29-991",
        "citation": "\"United States, Census, 1870\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MDVG-JCZ : Sun Oct 19 12:20:51 UTC 2025), Entry for J P Benedict and Ann V Benedict, 1870."
      },
      {
        "title": "Ann V. Hammer Benedict, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZTJ-7TP",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QV2F-3PJM : Sat Oct 03 10:54:18 UTC 2026), Entry for Ann V. Hammer Benedict."
      },
      {
        "title": "Ann V. Benedick, \"United States, Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9X29-92Y",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M6X1-3VX : Wed Sep 09 12:50:48 UTC 2026), Entry for John C. Benedick and Ann V. Benedick, 1880."
      },
      {
        "title": "Ann Benedict, \"United States, Census, 1860\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SKBM-KBN",
        "citation": "\"United States, Census, 1860\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M8LM-VDY : Mon Jul 08 07:09:36 UTC 2024), Entry for John Benedict and Ann Benedict, 1860."
      },
      {
        "title": "Ann Hammer, \"Iowa, County Marriages, 1838-1934\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MM19-4ST",
        "citation": "\"Iowa, County Marriages, 1838-1934\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XJ7P-BJV : Sat Jul 26 04:09:08 UTC 2025), Entry for John P. Benedict and Ann Hammer, 04 Feb 1854."
      }
    ],
    "portrait": "/ancestors/portraits/083_KP69-4RC.jpg"
  },
  {
    "id": "I76",
    "name": "Mary Jane Cranor",
    "sex": "F",
    "gen": 4,
    "slot": 5,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "I24",
    "birthYear": 1888,
    "deathYear": 1949,
    "birthDate": "16 Oct 1888",
    "deathDate": "21 Dec 1949",
    "burialDate": "27 Dec 1949",
    "christeningDate": null,
    "birthPlace": "Havana, Montgomery, Kansas, United States",
    "deathPlace": "Pocatello, Bannock, Idaho, United States",
    "burialPlace": "Ogden City Cemetery, Ogden, Weber, Utah, United States",
    "christeningPlace": null,
    "fsId": "KWCD-K68",
    "photo": "/ancestors/bubbles/021_KWCD-K68.jpg",
    "living": false,
    "alternateNames": [
      "Mary Jane Hull",
      "Jenny Cranor"
    ],
    "facts": [
      {
        "kind": "Residence",
        "date": "June 1900",
        "place": "Split Rock, Fremont, Wyoming, United States",
        "note": null
      },
      {
        "kind": "Baptism",
        "date": "31 August 1913",
        "place": null,
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1920",
        "place": "Englewood, Arapahoe, Colorado, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1930",
        "place": "North Ogden, Weber, Utah, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1935",
        "place": "Same Place",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1940",
        "place": "North Ogden Election Precinct, Weber, Utah, United States",
        "note": null
      },
      {
        "kind": "Membership",
        "date": null,
        "place": "Western States Mission, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Mary Jane Hull, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7DND-QPY",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6TC3-37FG : Sun Sep 13 05:47:12 UTC 2026), Entry for Mary Jane Hull and E E Millerberg."
      },
      {
        "title": "Mary J Hull, \"United States, Census, 1920\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/745V-CZJ",
        "citation": "\"United States, Census, 1920\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MX2W-314 : Fri Oct 02 07:27:42 UTC 2026), Entry for Roy E Hull and Mary J Hull, 1920."
      },
      {
        "title": "Mary Jane Cranor, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/77W7-17J",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6T4V-M7GB : Sun Sep 13 00:07:46 UTC 2026), Entry for Glen Cranor Hull and Roy E Hull."
      },
      {
        "title": "Mary J Cranor, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/77W7-TFW",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6TK8-TXLG : Sun Sep 13 05:24:03 UTC 2026), Entry for Laura May Hull and Saml C Dunn."
      },
      {
        "title": "Mary J Cranor, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/77W7-5F7",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6TNF-VKDK : Sat Sep 12 23:53:20 UTC 2026), Entry for Arthur Earnest Hull and Roy E."
      },
      {
        "title": "Mary Jane Cranor, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/77W7-5S7",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6T4V-M7GR : Sun Sep 13 05:50:47 UTC 2026), Entry for Lura May Hull and Roy E Hull."
      },
      {
        "title": "Mary Jane Cranor, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/77W7-PKD",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6T4V-M7P9 : Sun Sep 13 00:13:57 UTC 2026), Entry for Franklin Wyatt Hull and Roy E Hull."
      },
      {
        "title": "Mary J Cranor, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/77W7-FZF",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6T8F-H646 : Sun Sep 13 05:43:28 UTC 2026), Entry for Benj Bruce Hull and Jos F Sellers."
      },
      {
        "title": "Mary Jane Cranor, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/77W7-F3B",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6T4V-M7GG : Sun Sep 13 00:17:47 UTC 2026), Entry for Benjamin Bruce Hull and Roy E Hull."
      },
      {
        "title": "Mary Jane Cranor (Idaho Death Certificate",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QPSP-WWN",
        "citation": ""
      },
      {
        "title": "Mary Jane Hull, \"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QHQ3-C6M",
        "citation": "\"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6KWG-Z9LC : Fri Jul 03 23:50:23 UTC 2026), Entry for Mary Jane Cranor and Wyatt M Cranor."
      },
      {
        "title": "Mary J Unknown, \"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW4T-D45",
        "citation": "\"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6KWY-TVHC : Tue Jun 30 06:47:44 UTC 2026), Entry for John Kenneth Hull and Roy E Hull."
      },
      {
        "title": "Mary Jane Cranor Hull, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3WLV-6NV",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:84KJ-MY2M : Fri Aug 01 19:30:58 UTC 2025), Entry for Mary Jane Cranor Hull, 1930."
      },
      {
        "title": "Minnie Jane Crannor Hull, \"Utah, Box Elder, Brigham City Family History Center, Obituary Collection, 1930-2016\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3WLV-D8R",
        "citation": "\"Utah, Box Elder, Brigham City Family History Center, Obituary Collection, 1930-2016\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:DMZC-HHMM : Wed Jul 10 06:47:41 UTC 2024), Entry for Lura Mae Hull Hadley and Roy Ernest Hull, 1989."
      },
      {
        "title": "Mary Jane Cranor Hull, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3W2C-G77",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:84KJ-MB6Z : Fri Aug 01 20:19:10 UTC 2025), Entry for Mary Jane Cranor Hull, 1935."
      },
      {
        "title": "Mary Cranor Hull, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3WKL-MCW",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:8WP7-CX6Z : Mon Mar 30 07:28:58 UTC 2026), Entry for Mary Cranor Hull, 1940."
      },
      {
        "title": "Mary Jane Cranor Hull, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S1HQ-815",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QLGY-N6TH : Fri Mar 08 02:18:27 UTC 2024), Entry for John Kenneth Hull and Roy Ernest Hull, 1999."
      },
      {
        "title": "Mary Jane Cranor, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S1HQ-WFV",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QPSF-7CX4 : Tue Jan 14 06:48:40 UTC 2025), Entry for Leonard Mann Hull and Roy Ernest Hull, 2012."
      },
      {
        "title": "Mary Jane Or Jenny Cranor, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S1H3-TYB",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QL61-NZT8 : Sat Jul 20 02:46:01 UTC 2024), Entry for Leonard Mann Hull and Roy Ernest Hull, 2012."
      },
      {
        "title": "Mary Jane Cranor Hull, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SBL6-YFF",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QPSP-W128 : Fri Mar 08 15:38:54 UTC 2024), Entry for John Kenneth Hull and Roy Ernest Hull, 1999."
      },
      {
        "title": "Mary Jane Cranor, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SBNP-JK4",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QG1L-W5BF : Sat Jan 18 21:49:36 UTC 2025), Entry for Roy Earnest Hull and Dr Melcher, 1965."
      },
      {
        "title": "Mary Jane Cranor, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SBNP-J3D",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QLGY-TVZP : Wed Jul 24 04:10:55 UTC 2024), Entry for Roy Earnest Hull and Dr Melcher, 1965."
      },
      {
        "title": "Mary Jane Cranor, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SBNP-NP9",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QPST-F5Y8 : Fri Jul 19 23:45:17 UTC 2024), Entry for Roy E Hull and Frank Hull."
      },
      {
        "title": "Mary Jane Cranor Hull, \"Idaho, Southeast Counties Obituaries, 1864-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SBNP-FN9",
        "citation": "\"Idaho, Southeast Counties Obituaries, 1864-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QLGY-TV8W : Sat Jul 20 21:11:41 UTC 2024), Entry for Roy E Hull and Frank Hull."
      },
      {
        "title": "Mary I Hull, \"Utah, World War II Index to Army Veterans of Utah, 1939-1945\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S5ZY-YWN",
        "citation": "\"Utah, World War II Index to Army Veterans of Utah, 1939-1945\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:7M52-2G3Z : Mon Mar 17 15:12:52 UTC 2025), Entry for Howard Joseph Hull and Mary I Hull, 20 Mar 1941."
      },
      {
        "title": "Minnie Jane Cranor Hull, \"Utah, Box Elder, Tremonton and Garland Obituaries, 1959-2013\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SPND-GZM",
        "citation": "\"Utah, Box Elder, Tremonton and Garland Obituaries, 1959-2013\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2QP-L6BZ : Fri Mar 08 06:21:14 UTC 2024), Entry for Mrs Lura Mae Hull Hadley and Roy Ernest Hull, 1989."
      },
      {
        "title": "Mary Jane Craner in entry for Leonard Mann Hull, \"Utah, Births and Christenings, 1892-1941\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SV2J-BW6",
        "citation": "\"Utah, Births and Christenings, 1892-1941\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:4GMT-W6N2 : 28 January 2020), Mary Jane Craner in entry for Leonard Mann Hull, 1924."
      },
      {
        "title": "Mary Jane Cranor in entry for Hull, \"Utah, Births and Christenings, 1892-1941\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SV2J-Y39",
        "citation": "\"Utah, Births and Christenings, 1892-1941\", database, FamilySearch (https://familysearch.org/ark:/61903/1:1:4GMT-QMT2 : 28 January 2020), Mary Jane Cranor in entry for Hull, 1927."
      },
      {
        "title": "Mary Jane C Hull, \"United States, Census, 1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SXJQ-LZ4",
        "citation": "\"United States, Census, 1940\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VT4D-MTS : Sun Mar 10 17:52:28 UTC 2024), Entry for Ray E Hull and Mary Jane C Hull, 1940."
      },
      {
        "title": "Mary Hull, \"United States, Census, 1930\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SXJQ-2P8",
        "citation": "\"United States, Census, 1930\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XH6R-QNP : Sat Jan 18 20:21:57 UTC 2025), Entry for Ray E Hull and Mary Hull, 1930."
      },
      {
        "title": "Mary Cranor Hull, \"Utah, World War II Index to Army Veterans of Utah, 1939-1945\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S867-PBS",
        "citation": "\"Utah, World War II Index to Army Veterans of Utah, 1939-1945\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:7M52-2G6Z : Tue Nov 26 20:02:39 UTC 2024), Entry for Leonard Mann Hull and Mary Cramer Hull, 8 May 1943."
      },
      {
        "title": "Mary Jane Hull, \"BillionGraves Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S8DC-XF9",
        "citation": "\"BillionGraves Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QP51-19XX : Thu Sep 24 20:30:11 UTC 2026), Entry for Mary Jane Hull."
      },
      {
        "title": "Mary Jane Hull, \"Utah, World War II Index to Army Veterans of Utah, 1939-1945\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S8C2-S1K",
        "citation": "\"Utah, World War II Index to Army Veterans of Utah, 1939-1945\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:7M52-2L2M : Mon Mar 17 15:13:19 UTC 2025), Entry for Harold Edwin Hull and Mary Jane Hull, 1 Sep 1942."
      },
      {
        "title": "Mary J Cranor, \"Wyoming, Marriages, 1869-1923\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SQD1-39H",
        "citation": "\"Wyoming, Marriages, 1869-1923\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2DM-4HXH : Sun Mar 10 18:52:08 UTC 2024), Entry for Roy Ernest Hull and Mary J Cranor, 16 Nov 1904."
      },
      {
        "title": "Headstone image of Mary Jane Hull from billiongraves.com",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SS2N-MVY",
        "citation": "Transcription of headstone image from billiongraves.com. Image taken at Ogden City Cemetery (Ogden, Weber, Utah, United States) on 20 September 2018"
      },
      {
        "title": "Mary Jane Craner Hull, \"Idaho, Southern Counties Obituaries, 1943-2013\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9YHM-VXD",
        "citation": "\"Idaho, Southern Counties Obituaries, 1943-2013\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QGT3-VPZ9 : Sun Oct 19 06:27:34 UTC 2025), Entry for John Kenneth Hull and Roy Ernest Hull, 1999."
      },
      {
        "title": "Mary J Cranor in household of Wyatt M Cranor, \"United States Census, 1900\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9LTD-83P",
        "citation": "\"United States, Census, 1900\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M3VR-NQG : Tue Feb 18 18:24:40 UTC 2025), Entry for Wiett M Cranor and Minnie B Cranor, 1900."
      },
      {
        "title": "Jennie Hull, \"United States, Census, 1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/98HC-2BM",
        "citation": "\"United States, Census, 1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MPJV-8Q4 : Wed Aug 13 17:36:19 UTC 2025), Entry for Roy L Hull and Jennie Hull, 1910."
      },
      {
        "title": "Mary Jane Granor in entry for WM R Hadley and Lura Hull, \"Utah, Weber County Marriages, 1887-1941\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9GKQ-4SB",
        "citation": "\"Utah, Weber County Marriages, 1887-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QK6K-66VW : Wed Jan 15 09:13:22 UTC 2025), Entry for WM R Hadley and WM Hadley, 20 Jun 1927."
      },
      {
        "title": "Mary Jane Cranor Hull, \"Find A Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/928C-TKG",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QV2T-B73M : Sun Oct 04 21:24:44 UTC 2026), Entry for Jenny, 1949."
      },
      {
        "title": "Mary Jane Craner in entry for Ben B Hull and Nina O Blackner, \"Utah, County Marriages, 1887-1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9K9P-KNN",
        "citation": "\"Utah, County Marriages, 1871-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VRLN-HTK : Thu Sep 19 20:23:11 UTC 2024), Entry for Ben B Hull and Roy E Hull, 23 Sep 1930."
      },
      {
        "title": "Mary Jane Craner in entry for ben B Hull and Nina O Blackner, \"Utah, Weber County Marriages, 1887-1939\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9K9P-KSD",
        "citation": "\"Utah, Weber County Marriages, 1887-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QK6K-XKLH : Tue Jul 16 22:03:30 UTC 2024), Entry for ben B Hull and Roy E Hull, 23 Sep 1930."
      },
      {
        "title": "Mary Jane Cranor in entry for Benjamin Bruce Hull, \"United States, GenealogyBank Obituaries, 1980-2014\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9K9P-JVY",
        "citation": "\"United States, GenealogyBank Obituaries, Births, and Marriages, 1980-2015\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QKPT-23MJ : Mon Jun 03 19:42:15 UTC 2024), Entry for Benjamin Bruce Hull and Nina Oleah Blackner, 21 May 1998."
      },
      {
        "title": "Mary Jane Hull, \"Idaho, Death Certificates, 1938-1961\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9F66-RV9",
        "citation": "\"Idaho, Death Certificates, 1938-1961\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2M1-FBNV : Fri Feb 21 22:42:25 UTC 2025), Entry for Mary Jane Hull and Wyatt Mann Cranor, 22 Dec 1949."
      },
      {
        "title": "Mary Jane Cranor Hull, \"Idaho, Southern Counties Obituaries, 1943-2013\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/96CN-9RD",
        "citation": "\"Idaho, Southern Counties Obituaries, 1943-2013\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVS8-1CPB : Thu Sep 19 19:27:36 UTC 2024), Entry for John Kenneth Hull and Roy Ernest Hull, 1999."
      },
      {
        "title": "Mary Jane Cranor, \"Utah, County Marriages, 1871-1941\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSPV-TFG",
        "citation": "\"Utah, County Marriages, 1871-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VRLF-VD4 : Thu Sep 19 19:19:58 UTC 2024), Entry for Wm R Hadley and Wm Hadley, 20 Jun 1927."
      },
      {
        "title": "Mary Jane Cranor, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSTV-TGS",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZ2L-S4V : Mon Feb 03 19:05:52 UTC 2025), Entry for Bessie Pearl Hull and Roy Ernest Hull, 01 Mar 1921."
      },
      {
        "title": "Mary Jane Crann, \"California, County Marriages, 1849-1957\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSPV-T7W",
        "citation": "\"California, County Marriages, 1849-1957\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:K8K9-X26 : Wed Jul 10 00:40:28 UTC 2024), Entry for Howard J Hull and Roy E Hull, 22 Sep 1945."
      },
      {
        "title": "Mary J. Cranor, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSPV-RTZ",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZ2L-WRQ : Mon Feb 03 19:17:26 UTC 2025), Entry for Arthur Ernest Hull and Roy E . Hull, 27 May 1921."
      },
      {
        "title": "Mary Jane Cranor, \"United States, GenealogyBank Obituaries, Births, and Marriages, 1980-2015\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9DWY-1GK",
        "citation": "\"United States, GenealogyBank Obituaries, Births, and Marriages, 1980-2015\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QKWZ-7PVP : Mon Jan 20 08:49:07 UTC 2025), Entry for Benjamin Bruce Hull and Roy Ernest Hull, 21 May 1998."
      },
      {
        "title": "Mary Jane Or Jenny Cranor Hull, \"United States, GenealogyBank Obituaries, Births, and Marriages, 1980-2015\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/98RB-427",
        "citation": "\"United States, GenealogyBank Obituaries, Births, and Marriages, 1980-2015\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVP5-TGB9 : Tue Jan 21 12:55:16 UTC 2025), Entry for Leonard Mann Hull and Roy Ernest Hull, 29 Apr 2012."
      }
    ],
    "portrait": "/ancestors/portraits/021_KWCD-K68.jpg"
  },
  {
    "id": "I197",
    "name": "Wyatt Mann Cranor",
    "sex": "M",
    "gen": 5,
    "slot": 10,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "I76",
    "birthYear": 1860,
    "deathYear": 1937,
    "birthDate": "23 Jul 1860",
    "deathDate": "9 Jun 1937",
    "burialDate": "13 Jun 1937",
    "christeningDate": null,
    "birthPlace": "Madisonville, Hopkins, Kentucky, United States",
    "deathPlace": "Ogden, Weber, Utah, United States",
    "burialPlace": "Ogden City Cemetery, Ogden, Weber, Utah, United States",
    "christeningPlace": null,
    "fsId": "KWCW-5L1",
    "photo": "/ancestors/bubbles/042_KWCW-5L1.jpg",
    "living": false,
    "alternateNames": [
      "William M. Connor",
      "Wyatt Mann Cramor"
    ],
    "facts": [
      {
        "kind": "Residence",
        "date": "1870",
        "place": "Chetopa Township, Wilson, Kansas, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1880",
        "place": "Caney, Montgomery, Kansas, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "February 1886",
        "place": "Montgomery, Kansas, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "June 1900",
        "place": "Split Rock, Fremont, Wyoming, United States",
        "note": null
      },
      {
        "kind": "Membership and Baptism",
        "date": "22 September 1913",
        "place": "Colorado, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1920",
        "place": "Rawlins, Carbon, Wyoming, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1930",
        "place": "Ogden, Weber, Utah, United States",
        "note": "Census shows he lives, with his wife, two daughters and two grandchildren, in the $4000 home he owns at 110 West 30th Street. He is the Proprietor of a Rooming House and his wife is a Public Nurse.."
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Wm M Connor, \"United States, Census, 1920\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QMBF-8W9",
        "citation": "\"United States, Census, 1920\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MNB5-24M : Tue Sep 29 13:24:34 UTC 2026), Entry for Wm M Connor and Minnie B Connor, 1920."
      },
      {
        "title": "Wyatt Cranor, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3SDD-WK7",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Z1KR-SQ6Z : Fri Aug 01 16:32:22 UTC 2025), Entry for Wyatt Cranor, 1930."
      },
      {
        "title": "H M Cranor, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7WW7-3QF",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6TCW-DYCX : Sun Sep 13 00:06:54 UTC 2026), Entry for Helen Pearl Cranor and Aaron Densley."
      },
      {
        "title": "Wyatt Maun Cranor, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7CG3-ZQR",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6TCW-DYCG : Sun Sep 13 05:26:00 UTC 2026), Entry for Wyatt Maun Cranor and Aaron Densley."
      },
      {
        "title": "W M Cramer, \"Kansas County Marriages, 1855-1911\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7D31-KG1",
        "citation": "\"Kansas County Marriages, 1855-1911\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q293-PB55 : Thu Mar 07 12:55:31 UTC 2024), Entry for W M Cramer and Minnie B Mendenhall, 6 February 1886."
      },
      {
        "title": "W M Cranor, \"Utah, County Marriages, 1871-1941\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SCMR-SFH",
        "citation": "\"Utah, County Marriages, 1871-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:X212-BN7 : Thu Sep 19 18:39:12 UTC 2024), Entry for Albert Fred Atkinson and Jacob Atkinson, 11 Jun 1936."
      },
      {
        "title": "Wyatt Cranor, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7DND-7GJ",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6TC3-37FG : Sun Sep 13 05:47:12 UTC 2026), Entry for Mary Jane Hull and E E Millerberg."
      },
      {
        "title": "Wyatt Man Cranor Cranor, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3SDD-SQR",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Z1KR-SQPZ : Fri Aug 01 16:32:20 UTC 2025), Entry for Wyatt Man Cranor Cranor, 1935."
      },
      {
        "title": "Wiett M Cranor, \"United States, Census, 1900\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7D77-TLN",
        "citation": "\"United States, Census, 1900\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M3VR-NQG : Tue Feb 18 18:24:40 UTC 2025), Entry for Wiett M Cranor and Minnie B Cranor, 1900."
      },
      {
        "title": "Wyatt M. Cranor, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3CGW-6CF",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Z1KR-SQ3Z : Fri Aug 01 16:35:57 UTC 2025), Entry for Wyatt M. Cranor, 1925."
      },
      {
        "title": "Coyatt M Cranor, \"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QHQ3-49J",
        "citation": "\"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6K4W-T85J : Sun Jul 05 21:34:39 UTC 2026), Entry for Bruce Adolphus Cranor and Coyatt M Cranor."
      },
      {
        "title": "W M Cramer, \"Kansas County Marriages, 1855-1911\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7D31-KZK",
        "citation": "\"Kansas County Marriages, 1855-1911\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q293-PNKP : Sun Mar 10 00:10:32 UTC 2024), Entry for W M Cramer and Minnie B Mendenhall, 6 February 1886."
      },
      {
        "title": "Wyatt Cranor, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7QTB-WPW",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6TC3-37FT : Sun Sep 13 00:20:50 UTC 2026), Entry for Minnie May Cranor and E E Millerberg."
      },
      {
        "title": "Wyatt M, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7733-9QN",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6T9H-YF7S : Sun Sep 13 05:28:15 UTC 2026), Entry for Bruce A Cranor and L W Hyde."
      },
      {
        "title": "Wyatt M. Cranor, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3CGW-XDG",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Z1KR-S3PZ : Fri Aug 01 16:34:55 UTC 2025), Entry for Wyatt M. Cranor, 1920."
      },
      {
        "title": "W M Cranor, \"United States, Census, 1870\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7D31-14S",
        "citation": "\"United States, Census, 1870\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MCVM-MF8 : Mon Jan 20 01:09:13 UTC 2025), Entry for Jno Cranor and M A Cranor, 1870."
      },
      {
        "title": "Wyatt M Cranor, \"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QHQ3-HKW",
        "citation": "\"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6KWG-Z9LC : Fri Jul 03 23:50:23 UTC 2026), Entry for Mary Jane Cranor and Wyatt M Cranor."
      },
      {
        "title": "W N Craner, \"Utah, County Marriages, 1871-1941\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QBJL-4B3",
        "citation": "\"Utah, County Marriages, 1871-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VRLF-ZRV : Thu Sep 19 18:48:30 UTC 2024), Entry for Peter Christian Petersen and Jorgen Petersen, 20 May 1931."
      },
      {
        "title": "Wyath M. Cranor, \"United States, Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7D77-VND",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MF5Z-P2M : Wed Sep 09 15:04:25 UTC 2026), Entry for John Cranor and Mahala A. Cranor, 1880."
      },
      {
        "title": "Wyatt M Cranor, \"United States, Census, 1930\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7D7W-T3W",
        "citation": "\"United States, Census, 1930\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XH6P-LMS : Thu Jan 16 09:09:31 UTC 2025), Entry for Wyatt M Cranor and Mimie B Cranor, 1930."
      },
      {
        "title": "Headstone image of Father Wyatt M. Cranor from billiongraves.com",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SS2N-9GT",
        "citation": "Transcription of headstone image from billiongraves.com. Image taken at Ogden City Cemetery (Ogden, Weber, Utah, United States) on 04 October 2013"
      },
      {
        "title": "Utah, Death and Military Death Certificates, 1904-1961",
        "href": "https://www.familysearch.org/tree/sources/viewedit/96T6-MCC",
        "citation": ""
      },
      {
        "title": "Utah Death Registers, 1847-1966",
        "href": "https://www.familysearch.org/tree/sources/viewedit/96T6-MHL",
        "citation": "Utah State Archives and Records Service; Salt Lake City, UT; Utah State Archives and Records Service; File Number #: 1937002516"
      },
      {
        "title": "U.S. City Directories, 1821-1989",
        "href": "https://www.familysearch.org/tree/sources/viewedit/96T6-MH8",
        "citation": ""
      },
      {
        "title": "Utah, Select County Marriages, 1887-1937",
        "href": "https://www.familysearch.org/tree/sources/viewedit/96T6-M4K",
        "citation": ""
      },
      {
        "title": "1870 United States Federal Census",
        "href": "https://www.familysearch.org/tree/sources/viewedit/96T6-MWX",
        "citation": "Year: 1870; Census Place: Chetopa, Wilson, Kansas; Roll: M593_; Page: ; Image: ."
      },
      {
        "title": "1880 United States Federal Census",
        "href": "https://www.familysearch.org/tree/sources/viewedit/96T6-M7V",
        "citation": "Year: 1880; Census Place: Caney, Montgomery, Kansas; Roll: 389; Family History Film: 1254389; Page: 174C; Enumeration District: 149; Image: 0651."
      },
      {
        "title": "1900 United States Federal Census",
        "href": "https://www.familysearch.org/tree/sources/viewedit/96T6-MWR",
        "citation": "Year: 1900; Census Place: Split Rock, Fremont, Wyoming; Roll: 1826; Page: 7A; Enumeration District: 0029; FHL microfilm: 1241826"
      },
      {
        "title": "1930 United States Federal Census",
        "href": "https://www.familysearch.org/tree/sources/viewedit/96T6-M4H",
        "citation": "Year: 1930; Census Place: Ogden, Weber, Utah; Roll: 2424; Page: 6A; Enumeration District: 15; Image: 583.0; FHL microfilm: 2342158"
      },
      {
        "title": "Web: Utah, Find A Grave Index, 1850-2011",
        "href": "https://www.familysearch.org/tree/sources/viewedit/96T6-M74",
        "citation": ""
      },
      {
        "title": "Cranor, \"California, Death Index, 1940-1997\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9D26-725",
        "citation": "\"California, Death Index, 1940-1997\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VP3R-LBH : Tue Feb 25 17:07:28 UTC 2025), Entry for Bruce A Cranor and Cranor, 09 Oct 1940."
      },
      {
        "title": "Wyatt Maw Cranor, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9FZL-TZX",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZPN-Z3K : Mon Feb 03 19:29:07 UTC 2025), Entry for Minnie Bell Cranor and Absolem Mendenhall, 21 Apr 1944."
      },
      {
        "title": "Wyett M Cramor, \"United States, Census, 1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9Z72-HC6",
        "citation": "\"United States, Census, 1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MPJV-SL9 : Wed Aug 13 17:34:09 UTC 2025), Entry for Wyett M Cramor and Minnie Cramor, 1910."
      },
      {
        "title": "Wyatt Cranor, \"Utah, County Marriages, 1871-1941\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/98N4-TDJ",
        "citation": "\"Utah, County Marriages, 1871-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VRLX-6TG : Thu Sep 19 20:24:30 UTC 2024), Entry for Bruce A Cranor and Wyatt Cranor, 17 May 1928."
      },
      {
        "title": "Wyatt M Cranor, \"Utah, County Marriages, 1871-1941\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/98XF-4GL",
        "citation": "\"Utah, County Marriages, 1871-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VRLC-3WB : Thu Sep 19 18:28:58 UTC 2024), Entry for Chauncey W Burton and Robt W Burton, 21 Sep 1936."
      },
      {
        "title": "Wyatt M Cranor, \"Idaho, Death Certificates, 1938-1961\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9NR3-Q3P",
        "citation": "\"Idaho, Death Certificates, 1938-1961\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2M1-6RSR : Fri Feb 21 22:45:57 UTC 2025), Entry for Helen Pearl Hoelzle and Wyatt M Cranor, 14 Mar 1954."
      },
      {
        "title": "Wyatt Cranor, \"Utah, County Marriages, 1871-1941\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/98N4-Y7C",
        "citation": "\"Utah, County Marriages, 1871-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VRLJ-N2J : Thu Sep 19 19:51:22 UTC 2024), Entry for Karl C Hoelgle and Charles Hoelgle, 09 Feb 1921."
      },
      {
        "title": "Wyatt Cranor, \"Utah, Weber County Marriages, 1887-1941\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/96T5-2K4",
        "citation": "\"Utah, Weber County Marriages, 1887-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QK6K-65LY : Sun Mar 10 13:33:26 UTC 2024), Entry for Bruce A Cranor and Wyatt Cranor, 17 May 1928."
      },
      {
        "title": "Wyatt Mann Cranor, \"Idaho, Death Certificates, 1938-1961\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9F66-RZT",
        "citation": "\"Idaho, Death Certificates, 1938-1961\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2M1-FBNV : Fri Feb 21 22:42:25 UTC 2025), Entry for Mary Jane Hull and Wyatt Mann Cranor, 22 Dec 1949."
      },
      {
        "title": "Wyatt Cranor, \"Utah, Weber County Marriages, 1887-1941\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/96T5-LS7",
        "citation": "\"Utah, Weber County Marriages, 1887-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QK6K-ZSJJ : Mon Jan 13 15:44:14 UTC 2025), Entry for Karl C Hoelgle and Charles Hoelgle, 09 Feb 1921."
      },
      {
        "title": "Legacy NFS Source: Wyatt Mann Cranor - birth-name: Wyatt Mann Cranor",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSXZ-JT5",
        "citation": "mendenhall.FTW"
      },
      {
        "title": "Cranor, \"California, Death Index, 1940-1997\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZD5-LLG",
        "citation": "\"California, Death Index, 1940-1997\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VPF2-MPK : Tue Feb 25 19:32:16 UTC 2025), Entry for Ada Belle Burton and Cranor, 16 Apr 1997."
      },
      {
        "title": "Wyatt Mann Cranor, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/98XF-QTZ",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVVP-CJFQ : Sat Oct 03 04:00:26 UTC 2026), Entry for Wyatt Mann Cranor."
      },
      {
        "title": "Father Wyatt M. Cranor, \"BillionGraves Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/98XF-Q7N",
        "citation": "\"BillionGraves Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:2HX5-ZPC : Mon Oct 05 04:27:34 UTC 2026), Entry for Father Wyatt M. Cranor."
      },
      {
        "title": "Wiatt Mann Cranor, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZTJ-WB3",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZPZ-JQR : Mon Feb 03 19:26:33 UTC 2025), Entry for Wiatt Mann Cranor and John Cranor, 09 Jun 1937."
      }
    ],
    "portrait": "/ancestors/portraits/042_KWCW-5L1.jpg"
  },
  {
    "id": "I395",
    "name": "John M. Cranor",
    "sex": "M",
    "gen": 6,
    "slot": 20,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "I197",
    "birthYear": 1832,
    "deathYear": 1907,
    "birthDate": "15 Jun 1832",
    "deathDate": "7 Nov 1907",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Greensboro, Guilford, North Carolina, United States",
    "deathPlace": "Havana, Montgomery, Kansas, United States",
    "burialPlace": "Havana Cemetery, Havana, Montgomery, Kansas, United States",
    "christeningPlace": null,
    "fsId": "L5X4-4C1",
    "photo": "/ancestors/bubbles/084_L5X4-4C1.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [
      {
        "kind": "Residence",
        "date": "1840",
        "place": "Guilford, North Carolina, United States",
        "note": "Census shows household of Moses Ceranon age 30-40 includes male <5 (John M), male 5-10 (Jonathon), female 20-30 (Jane), female 5-10 (Hannah)."
      },
      {
        "kind": "Based on his siblings' births, the family moves over 500 miles west, from North Carolina to Kentucky.",
        "date": "from 1843 to 1848",
        "place": null,
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1850",
        "place": "Hopkins, Kentucky, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1860",
        "place": "Hopkins, Kentucky, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1 July 1863",
        "place": "Hopkins, Kentucky, United States",
        "note": "Civil War draft registration lists John M Cranor, 32 year old married farmer of this residence."
      },
      {
        "kind": "Military service",
        "date": "1865",
        "place": "Kentucky, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "October 1866",
        "place": "Hopkins, Kentucky, United States",
        "note": "He is a Justice of the Peace at this residence and is not married to Mahalia when he is witness to her pension application for her 1st husband's death in the civil war."
      },
      {
        "kind": "Early this year John, Mahalia and four children move to Kansas, more than 500 miles west.",
        "date": "from January 1870 to June 1870",
        "place": null,
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1 July 1870",
        "place": "Chetopa Township, Wilson, Kansas, United States",
        "note": "Census shows he lives with Mahalia and four children. Nearest PO is 'Verdi' which existed 1868-1876. Son John Moses is still in Kentucky with his paternal grandparents. John is a Laborer with a personal estate of $300."
      },
      {
        "kind": "Residence",
        "date": "1875",
        "place": "Chetopa Township, Wilson, Kansas, United States",
        "note": "State census Agriculture Schedule lists Altoona as the nearest PO. Between John, his father and brother Moses T. they have 160 fenced acres worth $464, 2 horses, 2 milk cows, 2 cattle, 5 pigs and recently slaughtered some livestock. They make butter, have a small orchard and grow wheat, corn, potatoes and castor beans. This sustains about a dozen family members."
      },
      {
        "kind": "Residence",
        "date": "June 1880",
        "place": "Caney Township, Montgomery, Kansas, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1895",
        "place": "Montgomery, Geary, Kansas, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1900",
        "place": "Independence, Montgomery, Kansas, United States",
        "note": null
      },
      {
        "kind": "Military service",
        "date": null,
        "place": null,
        "note": "Served as a 1st Lieutenant in the Union Army, Kentucky Cavalry, Co. B, 17th Regiment."
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "John M Cranor in Civil War Soldier details (US National Park Service).",
        "href": "https://www.familysearch.org/tree/sources/viewedit/76FH-NQ5",
        "citation": ""
      },
      {
        "title": "Approved Pension Application File for Mahala A Carner Malin, Widow of John G Malin, Company B, 17th Kentucky Cavalry Regiment",
        "href": "https://www.familysearch.org/tree/sources/viewedit/76FW-RJK",
        "citation": "National Archives Catalogue"
      },
      {
        "title": "U.S., Civil War Draft Registrations Records, 1863-1865",
        "href": "https://www.familysearch.org/tree/sources/viewedit/96T6-FD8",
        "citation": ""
      },
      {
        "title": "Web: RootsWeb Marriage Records Index",
        "href": "https://www.familysearch.org/tree/sources/viewedit/96T6-F8D",
        "citation": ""
      },
      {
        "title": "John Craner, \"Kentucky, County Marriages, 1786-1965\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SQBQ-TH3",
        "citation": "\"Kentucky, County Marriages, 1786-1965\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q28Z-P13W : Sat Feb 24 07:49:15 UTC 2024), Entry for John Craner and Mary Edwards, 1 Mar 1858."
      },
      {
        "title": "John Cranor, \"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q7Y6-8JQ",
        "citation": "\"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6KWY-C3TQ : Fri Jul 03 20:30:53 UTC 2026), Entry for Reuben Monroe Cranor and John Cranor."
      },
      {
        "title": "John Cranor, \"Kansas, State Census, 1895\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9Y6Y-ZJ3",
        "citation": "\"Kansas, State Census, 1895\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QL8V-SFXP : Thu Jun 13 22:51:37 UTC 2024), Entry for John Cranor and Mahala R Cranor, 1895."
      },
      {
        "title": "John Cranor, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7CG3-ZWP",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6TCW-DYCG : Sun Sep 13 05:26:00 UTC 2026), Entry for Wyatt Maun Cranor and Aaron Densley."
      },
      {
        "title": "John Craner, \"United States, Census, 1860\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/76FZ-N8H",
        "citation": "\"United States, Census, 1860\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MZB7-NH5 : Mon Jul 08 07:46:49 UTC 2024), Entry for John Craner and Mary Craner, 1860."
      },
      {
        "title": "Jno Cranor, \"United States, Census, 1870\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7D31-1GX",
        "citation": "\"United States, Census, 1870\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MCVM-MF8 : Mon Jan 20 01:09:13 UTC 2025), Entry for Jno Cranor and M A Cranor, 1870."
      },
      {
        "title": "Household of Moses Ceranon, \"United States, Census, 1840\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/766J-3Q4",
        "citation": "\"United States, Census, 1840\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XHTJ-PHM : Sat Mar 09 03:45:32 UTC 2024), Entry for Moses Ceranon, 1840."
      },
      {
        "title": "John Cranor, \"Oregon, Oregon State Archives, Death Records, 1864-1968\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QY3Z-ML1",
        "citation": "\"Oregon, Oregon State Archives, Death Records, 1864-1968\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:ZNW7-2TPZ : Fri Mar 08 19:10:44 UTC 2024), Entry for Reuben Monroe Cranor and John Cranor, 19 Feb 1955."
      },
      {
        "title": "John M Cranor, \"Kentucky, Civil War Service Records of Union Soldiers, 1861-1865\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7XJP-Q23",
        "citation": "\"Kentucky, Civil War Service Records of Union Soldiers, 1861-1865\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:F8F1-RFC : Thu Feb 13 22:41:26 UTC 2025), Entry for John M Cranor, 1865."
      },
      {
        "title": "J Cranor, \"Kansas, State Census, 1875\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9Y6Y-DF4",
        "citation": "\"Kansas, State Census, 1875\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QL6X-MNN1 : Thu Jun 13 00:28:37 UTC 2024), Entry for M Cranor and Mt Cranor, 1875."
      },
      {
        "title": "John Cranor, \"Kentucky, County Marriages, 1786-1965\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/91QT-MVN",
        "citation": "\"Kentucky, County Marriages, 1786-1965\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q288-SHX8 : Sat Feb 24 07:02:00 UTC 2024), Entry for John Cranor and Mahalia A Malin, 29 May 1867."
      },
      {
        "title": "John Cranor, \"Kentucky, County Marriages, 1786-1965\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/91QB-M7H",
        "citation": "\"Kentucky, County Marriages, 1786-1965\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q28Z-RD1J : Sat Feb 24 07:02:45 UTC 2024), Entry for John Cranor and Mehalah Mulin, 29 May 1867."
      },
      {
        "title": "John M Cranor, \"United States, GenealogyBank Obituaries, Births, and Marriages, 1980-2015\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S5ZB-ZZ3",
        "citation": "\"United States, GenealogyBank Obituaries, Births, and Marriages, 1980-2015\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QKP5-DM57 : Thu Jul 18 15:10:03 UTC 2024), Entry for Pauline Bynum and Gretchen, 06 Jan 2010."
      },
      {
        "title": "John Craner, \"United States, Census, 1850\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q64N-NSP",
        "citation": "\"United States, Census, 1850\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M654-XQ4 : Tue Oct 28 04:36:05 UTC 2025), Entry for Moses Craner and Jane Craner, 1850."
      },
      {
        "title": "John Cranor in entry for Rueben J. Cranor, \"Kansas, Marriages, 1840-1935\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MTZY-MP8",
        "citation": "\"Kansas, Marriages, 1840-1935\", , FamilySearch (https://www.familysearch.org/ark:/61903/1:1:FWGD-55H : 21 September 2026), John Cranor in entry for Rueben J. Cranor, 1895."
      },
      {
        "title": "John Cranor in entry for John S Cranor, \"Nebraska, Marriages, 1855-1995\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SKL8-CBD",
        "citation": "\"Nebraska, Marriages, 1855-1995\", , FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q298-N126 : 8 June 2021), John Cranor in entry for John S Cranor, 1906."
      },
      {
        "title": "Kansas State Census Collection, 1855-1925",
        "href": "https://www.familysearch.org/tree/sources/viewedit/96T6-F8Y",
        "citation": ""
      },
      {
        "title": "John Cranor, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZTJ-H88",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVKB-FCGJ : Fri Oct 02 17:51:49 UTC 2026), Entry for John Cranor."
      },
      {
        "title": "John Cranor, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZTJ-WTD",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZPZ-JQR : Mon Feb 03 19:26:33 UTC 2025), Entry for Wiatt Mann Cranor and John Cranor, 09 Jun 1937."
      },
      {
        "title": "John Cranor, \"United States, Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZTJ-6H5",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MF5Z-P2M : Wed Sep 09 15:04:25 UTC 2026), Entry for John Cranor and Mahala A. Cranor, 1880."
      },
      {
        "title": "John Cranor, \"United States, Census, 1900\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZTL-SY3",
        "citation": "\"United States, Census, 1900\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MMYH-4VH : Tue Apr 29 21:06:02 UTC 2025), Entry for John Cranor and Dollie Cranor, 1900."
      },
      {
        "title": "John Cranor in entry for Rueben J. Cranor, \"Kansas, Marriages, 1840-1935\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZTJ-Z93",
        "citation": "\"Kansas, Marriages, 1840-1935\", , FamilySearch (https://www.familysearch.org/ark:/61903/1:1:FW2X-R1G : 21 September 2026), John Cranor in entry for Rueben J. Cranor, 1895."
      }
    ],
    "portrait": "/ancestors/portraits/084_L5X4-4C1.jpg"
  },
  {
    "id": "I386",
    "name": "Mary Edwards",
    "sex": "F",
    "gen": 6,
    "slot": 21,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "I197",
    "birthYear": 1830,
    "deathYear": 1864,
    "birthDate": "3 Feb 1830",
    "deathDate": "13 Jul 1864",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Greensboro, Guilford, North Carolina, United States",
    "deathPlace": "Crofton, Christian, Kentucky, United States",
    "burialPlace": "Madison,Christian,Kentucky",
    "christeningPlace": null,
    "fsId": "L413-FMZ",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Mary Edwards Cranor",
      "Mary or Poly Edwards",
      "Polly"
    ],
    "facts": [
      {
        "kind": "Residence",
        "date": "1850",
        "place": "Hopkins, Kentucky, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1860",
        "place": "Hopkins, Kentucky, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1870",
        "place": "Kansas, United States",
        "note": null
      },
      {
        "kind": "Other",
        "date": null,
        "place": null,
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Mary Craner, \"United States, Census, 1860\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/76FZ-NSR",
        "citation": "\"United States, Census, 1860\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MZB7-NH5 : Mon Jul 08 07:46:49 UTC 2024), Entry for John Craner and Mary Craner, 1860."
      },
      {
        "title": "Mary Edwards, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7CG3-Z4Q",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6TCW-DYCG : Sun Sep 13 05:26:00 UTC 2026), Entry for Wyatt Maun Cranor and Aaron Densley."
      },
      {
        "title": "Mary Leticia Cranor, \"United States, GenealogyBank Obituaries, Births, and Marriages, 1980-2015\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S5ZB-Z9C",
        "citation": "\"United States, GenealogyBank Obituaries, Births, and Marriages, 1980-2015\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QKP5-DM57 : Thu Jul 18 15:10:03 UTC 2024), Entry for Pauline Bynum and Gretchen, 06 Jan 2010."
      },
      {
        "title": "Mary Edwards in entry for John S Cranor, \"Nebraska, Marriages, 1855-1995\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SKL8-CF5",
        "citation": "\"Nebraska, Marriages, 1855-1995\", , FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q298-N12R : 8 June 2021), Mary Edwards in entry for John S Cranor, 1906."
      },
      {
        "title": "Mary Edwards, \"Kentucky, County Marriages, 1786-1965\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SQBQ-RTK",
        "citation": "\"Kentucky, County Marriages, 1786-1965\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q28Z-P13W : Sat Feb 24 07:49:15 UTC 2024), Entry for John Craner and Mary Edwards, 1 Mar 1858."
      },
      {
        "title": "Mary Edwards, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZTJ-W5K",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZPZ-JQR : Mon Feb 03 19:26:33 UTC 2025), Entry for Wiatt Mann Cranor and John Cranor, 09 Jun 1937."
      }
    ]
  },
  {
    "id": "I196",
    "name": "Minnie Bell Mendenhall",
    "sex": "F",
    "gen": 5,
    "slot": 11,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "I76",
    "birthYear": 1869,
    "deathYear": 1944,
    "birthDate": "23 Jun 1869",
    "deathDate": "22 Apr 1944",
    "burialDate": "25 Apr 1944",
    "christeningDate": null,
    "birthPlace": "Iroquois, Iroquois, Illinois, United States",
    "deathPlace": "Ogden, Weber, Utah, United States",
    "burialPlace": "Ogden City Cemetery, Ogden, Weber, Utah, United States",
    "christeningPlace": null,
    "fsId": "KWCW-5LY",
    "photo": "/ancestors/bubbles/043_KWCW-5LY.jpg",
    "living": false,
    "alternateNames": [
      "Minnie Bell Cranor",
      "Minnie Bell Connor"
    ],
    "facts": [
      {
        "kind": "Residence",
        "date": "1880",
        "place": "Caney Township, Montgomery, Kansas, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "June 1900",
        "place": "Split Rock, Fremont, Wyoming, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1910",
        "place": "Split Rock, Fremont, Wyoming, United States",
        "note": null
      },
      {
        "kind": "Membership",
        "date": "September 1913",
        "place": "Western States Mission, United States",
        "note": null
      },
      {
        "kind": "Baptism",
        "date": "22 September 1913",
        "place": "Colorado, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1920",
        "place": "Rawlins, Carbon, Wyoming, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1930",
        "place": "Ogden, Weber, Utah, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Headstone image of Mother Minnie M. Cranor from billiongraves.com",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SS2N-SMP",
        "citation": "Transcription of headstone image from billiongraves.com. Image taken at Ogden City Cemetery (Ogden, Weber, Utah, United States) on 04 October 2013"
      },
      {
        "title": "Minnie B Mendenhall, \"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QHQ3-WNZ",
        "citation": "\"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6K4W-T85J : Sun Jul 05 21:34:39 UTC 2026), Entry for Bruce Adolphus Cranor and Coyatt M Cranor."
      },
      {
        "title": "Minnie B Cranor, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7WW7-WHV",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6TCW-DYCX : Sun Sep 13 00:06:54 UTC 2026), Entry for Helen Pearl Cranor and Aaron Densley."
      },
      {
        "title": "Minnie B Cranor, \"United States, Census, 1900\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7D77-Y6L",
        "citation": "\"United States, Census, 1900\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M3VR-NQG : Tue Feb 18 18:24:40 UTC 2025), Entry for Wiett M Cranor and Minnie B Cranor, 1900."
      },
      {
        "title": "Minnie Cranor, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3SDD-7R6",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Z1KR-SQN2 : Mon Oct 13 20:03:15 UTC 2025), Entry for Minnie Cranor, 1930."
      },
      {
        "title": "Minnie Belle Cranor, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7CG3-CXM",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6TCW-DYCV : Sun Sep 13 05:23:19 UTC 2026), Entry for Minnie Belle Cranor and Aaron Densley."
      },
      {
        "title": "Minnie Mendenhall Cranor, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3CGW-XF2",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Z1KR-S3T2 : Fri Oct 17 00:47:44 UTC 2025), Entry for Minnie Mendenhall Cranor, 1920."
      },
      {
        "title": "Minnie B Mendenhall, \"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QHQ3-H7X",
        "citation": "\"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6KWG-Z9LC : Fri Jul 03 23:50:23 UTC 2026), Entry for Mary Jane Cranor and Wyatt M Cranor."
      },
      {
        "title": "M*** Mende***, \"Utah, County Marriages, 1871-1941\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SCMR-SZ8",
        "citation": "\"Utah, County Marriages, 1871-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:X212-BN7 : Thu Sep 19 18:39:12 UTC 2024), Entry for Albert Fred Atkinson and Jacob Atkinson, 11 Jun 1936."
      },
      {
        "title": "Minnie B Mendenhall, \"Kansas County Marriages, 1855-1911\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7D31-KWT",
        "citation": "\"Kansas County Marriages, 1855-1911\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q293-PNKP : Sun Mar 10 00:10:32 UTC 2024), Entry for W M Cramer and Minnie B Mendenhall, 6 February 1886."
      },
      {
        "title": "M B Mendenhall, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7DND-75T",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6TC3-37FG : Sun Sep 13 05:47:12 UTC 2026), Entry for Mary Jane Hull and E E Millerberg."
      },
      {
        "title": "Minnie B Mendenhall, \"Idaho, Death Certificates, 1938-1961\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9NR3-QWG",
        "citation": "\"Idaho, Death Certificates, 1938-1961\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2M1-6RSR : Fri Feb 21 22:45:57 UTC 2025), Entry for Helen Pearl Hoelzle and Wyatt M Cranor, 14 Mar 1954."
      },
      {
        "title": "Minnie B Mendenhall, \"Utah, County Marriages, 1871-1941\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QBJL-4TD",
        "citation": "\"Utah, County Marriages, 1871-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VRLF-ZRV : Thu Sep 19 18:48:30 UTC 2024), Entry for Peter Christian Petersen and Jorgen Petersen, 20 May 1931."
      },
      {
        "title": "M B Mendenhall, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7QTB-WYD",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6TC3-37FT : Sun Sep 13 00:20:50 UTC 2026), Entry for Minnie May Cranor and E E Millerberg."
      },
      {
        "title": "Minnie Mendenhall in entry for Wiatt Mann Cranor, \"Utah Death Certificates, 1904-1964\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9G1L-RL4",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZPZ-JQR : Mon Feb 03 19:26:33 UTC 2025), Entry for Wiatt Mann Cranor and John Cranor, 09 Jun 1937."
      },
      {
        "title": "Minnie Mendenhall Cranor, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3CGW-6DL",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Z1KR-SQZM : Fri Aug 01 20:50:58 UTC 2025), Entry for Minnie Mendenhall Cranor, 1925."
      },
      {
        "title": "Minnie B Connor, \"United States, Census, 1920\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QMBF-8W6",
        "citation": "\"United States, Census, 1920\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MNB5-24M : Tue Sep 29 13:24:34 UTC 2026), Entry for Wm M Connor and Minnie B Connor, 1920."
      },
      {
        "title": "M B Mendenhall, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7733-9H4",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6T9H-YF7S : Sun Sep 13 05:28:15 UTC 2026), Entry for Bruce A Cranor and L W Hyde."
      },
      {
        "title": "Minnie Bell Mendenhall Cranor, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3SD8-12F",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Z1KR-SQT2 : Fri Aug 01 20:11:11 UTC 2025), Entry for Minnie Bell Mendenhall Cranor, 1935."
      },
      {
        "title": "Minnie B Mendenhall, \"Kansas County Marriages, 1855-1911\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7D31-KK9",
        "citation": "\"Kansas County Marriages, 1855-1911\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q293-PB55 : Thu Mar 07 12:55:31 UTC 2024), Entry for W M Cramer and Minnie B Mendenhall, 6 February 1886."
      },
      {
        "title": "Legacy NFS Source: Minnie Bell Mendenhall - birth-name: Mary Mendenhall",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSXZ-JR7",
        "citation": "mendenhall.FTW"
      },
      {
        "title": "Minnie Cramor, \"United States, Census, 1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9Z72-H87",
        "citation": "\"United States, Census, 1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MPJV-SL9 : Wed Aug 13 17:34:09 UTC 2025), Entry for Wyett M Cramor and Minnie Cramor, 1910."
      },
      {
        "title": "Minnie B Mendenhall, \"Utah, County Marriages, 1871-1941\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/98N4-RRJ",
        "citation": "\"Utah, County Marriages, 1871-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VRLX-6TG : Thu Sep 19 20:24:30 UTC 2024), Entry for Bruce A Cranor and Wyatt Cranor, 17 May 1928."
      },
      {
        "title": "Minnie Mendenhall in household of Absolam Mendenhall, \"United States Census, 1870\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M93Y-9PJ",
        "citation": "\"United States, Census, 1870\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M6W9-DMG : Thu Jan 16 14:16:55 UTC 2025), Entry for Absolam Mendenhall and Martha Mendenhall, 1870."
      },
      {
        "title": "Mimie B Cranor, \"United States, Census, 1930\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZD5-25D",
        "citation": "\"United States, Census, 1930\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XH6P-LMS : Thu Jan 16 09:09:31 UTC 2025), Entry for Wyatt M Cranor and Mimie B Cranor, 1930."
      },
      {
        "title": "Mendenhall, \"California, Death Index, 1940-1997\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZD5-L2R",
        "citation": "\"California, Death Index, 1940-1997\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VPF2-MPK : Tue Feb 25 19:32:16 UTC 2025), Entry for Ada Belle Burton and Cranor, 16 Apr 1997."
      },
      {
        "title": "Minnie Bell Mendenhall Cranor, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/98N4-BVN",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVVP-CJFS : Sun Oct 04 06:35:26 UTC 2026), Entry for Minnie Bell Mendenhall Cranor."
      },
      {
        "title": "Minnie Bell Cranor, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/98HF-PMP",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZPN-Z3K : Mon Feb 03 19:29:07 UTC 2025), Entry for Minnie Bell Cranor and Absolem Mendenhall, 21 Apr 1944."
      },
      {
        "title": "Minnie B Mendenhall, \"Utah, County Marriages, 1871-1941\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/98XF-4T9",
        "citation": "\"Utah, County Marriages, 1871-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VRLC-3WB : Thu Sep 19 18:28:58 UTC 2024), Entry for Chauncey W Burton and Robt W Burton, 21 Sep 1936."
      },
      {
        "title": "Minnie B Mendenhall, \"Utah, Weber County Marriages, 1887-1941\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/96T5-2NQ",
        "citation": "\"Utah, Weber County Marriages, 1887-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QK6K-65LY : Sun Mar 10 13:33:26 UTC 2024), Entry for Bruce A Cranor and Wyatt Cranor, 17 May 1928."
      },
      {
        "title": "Mother Minnie M. Cranor, \"BillionGraves Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/98N4-1FC",
        "citation": "\"BillionGraves Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:2HX5-ZPZ : Mon Oct 05 05:26:35 UTC 2026), Entry for Mother Minnie M. Cranor."
      },
      {
        "title": "Mendenhall, \"California, Death Index, 1940-1997\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9D26-7LP",
        "citation": "\"California, Death Index, 1940-1997\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VP3R-LBH : Tue Feb 25 17:07:28 UTC 2025), Entry for Bruce A Cranor and Cranor, 09 Oct 1940."
      },
      {
        "title": "Minnie Mendenhall, \"Utah, Weber County Marriages, 1887-1941\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/96T5-LQ5",
        "citation": "\"Utah, Weber County Marriages, 1887-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QK6K-ZSJJ : Mon Jan 13 15:44:14 UTC 2025), Entry for Karl C Hoelgle and Charles Hoelgle, 09 Feb 1921."
      },
      {
        "title": "Minnie B. Mendenhau, \"United States, Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9DJS-9NR",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MF5Z-TM4 : Wed Sep 09 14:44:54 UTC 2026), Entry for A. Mendenhau and Martha J. Mendenhau, 1880."
      },
      {
        "title": "Minnie Mendenhall, \"Utah, County Marriages, 1871-1941\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9D26-HPP",
        "citation": "\"Utah, County Marriages, 1871-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VRLJ-N2J : Thu Sep 19 19:51:22 UTC 2024), Entry for Karl C Hoelgle and Charles Hoelgle, 09 Feb 1921."
      },
      {
        "title": "Minnie Bell Mendenhall, \"Idaho, Death Certificates, 1938-1961\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9F66-R6K",
        "citation": "\"Idaho, Death Certificates, 1938-1961\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2M1-FBNV : Fri Feb 21 22:42:25 UTC 2025), Entry for Mary Jane Hull and Wyatt Mann Cranor, 22 Dec 1949."
      }
    ],
    "portrait": "/ancestors/portraits/043_KWCW-5LY.jpg"
  },
  {
    "id": "I383",
    "name": "Absalon Mendenhall",
    "sex": "M",
    "gen": 6,
    "slot": 22,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "I196",
    "birthYear": 1836,
    "deathYear": 1913,
    "birthDate": "12 Oct 1836",
    "deathDate": "29 Jun 1913",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Cain Township, Fountain, Indiana, United States",
    "deathPlace": "Havana, Montgomery, Kansas, United States",
    "burialPlace": "Havanna, Montgomery, Kansas",
    "christeningPlace": null,
    "fsId": "L413-FMN",
    "photo": "/ancestors/bubbles/086_L413-FMN.jpg",
    "living": false,
    "alternateNames": [
      "Absolen Mendenhall"
    ],
    "facts": [
      {
        "kind": "Residence",
        "date": "1850",
        "place": "Union Township, Fulton, Indiana, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1860",
        "place": "Madison, Kansas, United States",
        "note": null
      },
      {
        "kind": "Military",
        "date": "from 1861 to 1865",
        "place": "Illinois, United States",
        "note": null
      },
      {
        "kind": "Pension",
        "date": "1865",
        "place": null,
        "note": null
      },
      {
        "kind": "Pension",
        "date": "1880",
        "place": null,
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1880",
        "place": "Caney, Montgomery, Kansas, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1900",
        "place": "Caney, Montgomery, Kansas, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1910",
        "place": "Caney, Montgomery, Kansas, United States",
        "note": null
      },
      {
        "kind": "Pension",
        "date": "1 August 1913",
        "place": "Illinois, United States",
        "note": null
      },
      {
        "kind": "Pension",
        "date": "from 1907 to 1933",
        "place": "United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Legacy NFS Source: Absalon Mendenhall - birth-name: Absolom Mendenhall",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M9PS-88D",
        "citation": "mendenhall.FTW"
      },
      {
        "title": "Legacy NFS Source: Absalon Mendenhall - Published information: Cemetery record or headstone: birth-name: Absalon Mendenhall",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M9PS-8H4",
        "citation": ""
      },
      {
        "title": "A. Mendenhau, \"United States, Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9DJS-98Q",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MF5Z-TM4 : Wed Sep 09 14:44:54 UTC 2026), Entry for A. Mendenhau and Martha J. Mendenhau, 1880."
      },
      {
        "title": "Absolom Mendenhall, \"United States, Census, 1860\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZKD-ZSX",
        "citation": "\"United States, Census, 1860\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M66Q-HPX : Mon Jul 08 07:30:21 UTC 2024), Entry for Jacob Cain and Jane Cain, 1860."
      },
      {
        "title": "Absolum Mendenhall, \"United States, Census, 1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZKD-82J",
        "citation": "\"United States, Census, 1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M2CR-JW6 : Wed Aug 13 18:44:16 UTC 2025), Entry for Absolum Mendenhall and Martha J Mendenhall, 1910."
      },
      {
        "title": "Absolem Mendenhall, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/98HF-G1W",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZPN-Z3K : Mon Feb 03 19:29:07 UTC 2025), Entry for Minnie Bell Cranor and Absolem Mendenhall, 21 Apr 1944."
      },
      {
        "title": "Absalon Mendenhall, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/98YG-WP1",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVVT-J53D : Sun Oct 04 04:54:53 UTC 2026), Entry for Absalon Mendenhall."
      },
      {
        "title": "Absalom Mendenhall, \"United States, Civil War and Later Pension Index, 1861-1917\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9RYD-K3Y",
        "citation": "\"United States, Civil War and Later Pension Index, 1861-1917\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:NHC5-4Q9 : Sun Dec 07 08:05:57 UTC 2025), Entry for Absalom Mendenhall, 01 Aug 1913."
      },
      {
        "title": "Absalom Mendenhall or A., \"United States, Civil War Soldiers Index, 1861-1865\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9RYD-PDX",
        "citation": "\"United States, Civil War Soldiers Index, 1861-1865\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:FSRP-2MQ : Thu Feb 13 02:40:59 UTC 2025), Entry for Absalom Mendinhall, from 1861 to 1865."
      },
      {
        "title": "A Mendenhall, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7CG3-CL8",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6TCW-DYCV : Sun Sep 13 05:23:19 UTC 2026), Entry for Minnie Belle Cranor and Aaron Densley."
      },
      {
        "title": "Absolem Mendenhall, \"United States, Census, 1850\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZKD-CZJ",
        "citation": "\"United States, Census, 1850\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MHJ6-XT8 : Tue Oct 21 01:12:40 UTC 2025), Entry for Jacob Cain and Jane Cain, 1850."
      },
      {
        "title": "Absalom Mendenhall, \"United States, General Index to Pension Files, 1861-1934\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZKD-VDQ",
        "citation": "\"United States, General Index to Pension Files, 1861-1934\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KDB6-QRC : Wed Jul 08 22:06:15 UTC 2026), Entry for Absalom Mendenhall and Martha J Mendenhall, 1865."
      },
      {
        "title": "Absolam Mendenhall, \"United States Census, 1870\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M93Y-QWJ",
        "citation": "\"United States, Census, 1870\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M6W9-DMG : Thu Jan 16 14:16:55 UTC 2025), Entry for Absolam Mendenhall and Martha Mendenhall, 1870."
      },
      {
        "title": "Absolom Mendenhall, \"United States, Census, 1900\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZKD-847",
        "citation": "\"United States, Census, 1900\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MMY4-4NF : Tue Apr 29 21:06:07 UTC 2025), Entry for Absolom Mendenhall and Martha J Mendenhall, 1900."
      },
      {
        "title": "Absalom Mendenhall, \"United States, Veterans Administration Pension Payment Cards, 1907-1933\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZKD-JWR",
        "citation": "\"United States, Veterans Administration Pension Payment Cards, 1907-1933\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:2M2D-RJ5 : Sat Nov 01 01:45:27 UTC 2025), Entry for Absalom Mendenhall and Martha J, from 1907 to 1933."
      },
      {
        "title": "Absalom Mendenhall, \"Illinois, County Marriages, 1810-1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SQB7-QRG",
        "citation": "\"Illinois, County Marriages, 1810-1940\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q28Z-X8HK : Fri Mar 08 13:50:27 UTC 2024), Entry for Absalom Mendenhall and Martha Jane Hoel, 01 Nov 1866."
      },
      {
        "title": "Absalom Mendenhall, \"United States, Veterans Administration Pension Payment Cards, 1907-1933\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZKD-JPP",
        "citation": "\"United States, Veterans Administration Pension Payment Cards, 1907-1933\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:2M2D-R5Q : Fri Oct 31 18:30:15 UTC 2025), Entry for Absalom Mendenhall and Martha J Mendenhall, from 1907 to 1933."
      },
      {
        "title": "Absalom Mendenhall, \"United States, General Index to Pension Files, 1861-1934\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZKD-VYC",
        "citation": "\"United States, General Index to Pension Files, 1861-1934\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KDB6-QRZ : Wed Jul 08 22:05:37 UTC 2026), Entry for Absalom Mendenhall, 1880."
      },
      {
        "title": "Absalam Mendenhall, \"Illinois, County Marriages, 1810-1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9FB7-3WD",
        "citation": "\"Illinois, County Marriages, 1810-1940\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QK92-2LMJ : Sun Jan 19 00:47:59 UTC 2025), Entry for Absalam Mendenhall and Martha Jane Hoel, 01 Nov 1866."
      },
      {
        "title": "Absalom Mendenhall, \"Illinois, County Marriages, 1810-1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9D7T-TMW",
        "citation": "\"Illinois, County Marriages, 1810-1940\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QK92-2LMK : Fri Jan 17 17:00:38 UTC 2025), Entry for Absalom Mendenhall and Martha Jane Hoel, 01 Nov 1866."
      }
    ],
    "portrait": "/ancestors/portraits/086_L413-FMN.jpg"
  },
  {
    "id": "I384",
    "name": "Martha Jane Hoel",
    "sex": "F",
    "gen": 6,
    "slot": 23,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "I196",
    "birthYear": 1842,
    "deathYear": 1920,
    "birthDate": "20 Nov 1842",
    "deathDate": "21 Jul 1920",
    "burialDate": "1920",
    "christeningDate": null,
    "birthPlace": "Iroquois, Illinois, United States",
    "deathPlace": "Rawlins, Carbon, Wyoming, United States",
    "burialPlace": "Havana Cemetery, Havana, Montgomery, Kansas, United States",
    "christeningPlace": null,
    "fsId": "L413-FMV",
    "photo": "/ancestors/bubbles/087_L413-FMV.jpg",
    "living": false,
    "alternateNames": [
      "Martha Jane Mendenhall",
      "Martha Jane Hall"
    ],
    "facts": [
      {
        "kind": "Residence",
        "date": "1850",
        "place": "Iroquois, Iroquois, Illinois, United States",
        "note": "Jerimiah & Elizabeth Hoel in 1850 Census"
      },
      {
        "kind": "Residence",
        "date": "1860",
        "place": "Concord Township, Iroquois, Illinois, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1870",
        "place": "Iroquois, Illinois, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1880",
        "place": "Caney, Montgomery, Kansas, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1900",
        "place": "Caney, Montgomery, Kansas, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1910",
        "place": "Havana, Montgomery, Kansas, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1920",
        "place": "Rawlins, Carbon, Wyoming, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Mary J Mendehall, \"United States, Census, 1920\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QMBF-84P",
        "citation": "\"United States, Census, 1920\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MNB5-24M : Tue Sep 29 13:24:34 UTC 2026), Entry for Wm M Connor and Minnie B Connor, 1920."
      },
      {
        "title": "Martha Jane Hoel Mendenhall, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZKD-WN8",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVVD-9FD2 : Mon Oct 05 01:04:44 UTC 2026), Entry for Martha Jane Hoel Mendenhall."
      },
      {
        "title": "Martha J Mendenhall, \"United States, Census, 1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZKD-8G6",
        "citation": "\"United States, Census, 1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M2CR-JW6 : Wed Aug 13 18:44:16 UTC 2025), Entry for Absolum Mendenhall and Martha J Mendenhall, 1910."
      },
      {
        "title": "Martha J Hoel, \"United States, Census, 1860\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/98HF-59Q",
        "citation": "\"United States, Census, 1860\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MXHM-NK8 : Mon Jul 08 05:07:01 UTC 2024), Entry for Jeremiah Hoel and Mary E Hoel, 1860."
      },
      {
        "title": "Absolam Mendenhall, \"United States Census, 1870\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9J2N-FHL",
        "citation": "\"United States, Census, 1870\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M6W9-DMG : Thu Jan 16 14:16:55 UTC 2025), Entry for Absolam Mendenhall and Martha Mendenhall, 1870."
      },
      {
        "title": "Martha Jane Hoel, \"Illinois, County Marriages, 1810-1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SQB7-7MN",
        "citation": "\"Illinois, County Marriages, 1810-1940\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q28Z-X8HK : Fri Mar 08 13:50:27 UTC 2024), Entry for Absalom Mendenhall and Martha Jane Hoel, 01 Nov 1866."
      },
      {
        "title": "Martha Jane Mendenhall, \"Wyoming, Reclaim the Records, State Archives Vital Records, 1908-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S8DV-KLV",
        "citation": "\"Wyoming, Reclaim the Records, State Archives Vital Records, 1908-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:7DD6-S1ZM : Sun Mar 10 22:09:39 UTC 2024), Entry for Martha Jane Mendenhall, 21 Jul 1920."
      },
      {
        "title": "Martha J Mendenhall, \"United States, Census, 1900\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZKD-88M",
        "citation": "\"United States, Census, 1900\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MMY4-4NF : Tue Apr 29 21:06:07 UTC 2025), Entry for Absolom Mendenhall and Martha J Mendenhall, 1900."
      },
      {
        "title": "Martha J. Hoel, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/98HF-GGY",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZPN-Z3K : Mon Feb 03 19:29:07 UTC 2025), Entry for Minnie Bell Cranor and Absolem Mendenhall, 21 Apr 1944."
      },
      {
        "title": "Martha Jane Hoel, \"Illinois, County Marriages, 1810-1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9FB7-QDG",
        "citation": "\"Illinois, County Marriages, 1810-1940\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QK92-2LMJ : Sun Jan 19 00:47:59 UTC 2025), Entry for Absalam Mendenhall and Martha Jane Hoel, 01 Nov 1866."
      },
      {
        "title": "Martha Jane Hoel, \"Illinois, County Marriages, 1810-1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9D7T-YC5",
        "citation": "\"Illinois, County Marriages, 1810-1940\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QK92-2LMK : Fri Jan 17 17:00:38 UTC 2025), Entry for Absalom Mendenhall and Martha Jane Hoel, 01 Nov 1866."
      },
      {
        "title": "Martha Mendenhall in household of Absolam Mendenhall, \"United States Census, 1870\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M93Y-Q4Z",
        "citation": "\"United States, Census, 1870\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M6W9-DMG : Thu Jan 16 14:16:55 UTC 2025), Entry for Absolam Mendenhall and Martha Mendenhall, 1870."
      },
      {
        "title": "Martha J Mendenhall, \"United States, Veterans Administration Pension Payment Cards, 1907-1933\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZKD-JY3",
        "citation": "\"United States, Veterans Administration Pension Payment Cards, 1907-1933\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:2M2D-R5Q : Fri Oct 31 18:30:15 UTC 2025), Entry for Absalom Mendenhall and Martha J Mendenhall, from 1907 to 1933."
      },
      {
        "title": "Martha J Mendenhall, \"United States, General Index to Pension Files, 1861-1934\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZKD-VFW",
        "citation": "\"United States, General Index to Pension Files, 1861-1934\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KDB6-QRC : Wed Jul 08 22:06:15 UTC 2026), Entry for Absalom Mendenhall and Martha J Mendenhall, 1865."
      },
      {
        "title": "Martha J Mendenhall in household of Absolom Mendenhall, \"United States Census, 1900\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9J2N-R7S",
        "citation": "\"United States, Census, 1900\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MMY4-4NF : Tue Apr 29 21:06:07 UTC 2025), Entry for Absolom Mendenhall and Martha J Mendenhall, 1900."
      },
      {
        "title": "Martha Hoel, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7CG3-CGZ",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6TCW-DYCV : Sun Sep 13 05:23:19 UTC 2026), Entry for Minnie Belle Cranor and Aaron Densley."
      },
      {
        "title": "Martha J. Mendenhau, \"United States, Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9DJS-964",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MF5Z-TM4 : Wed Sep 09 14:44:54 UTC 2026), Entry for A. Mendenhau and Martha J. Mendenhau, 1880."
      },
      {
        "title": "Martha J Mendenhall in household of Absolum Mendenhall, \"United States Census, 1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9J2J-MZL",
        "citation": "\"United States, Census, 1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M2CR-JW6 : Wed Aug 13 18:44:16 UTC 2025), Entry for Absolum Mendenhall and Martha J Mendenhall, 1910."
      },
      {
        "title": "Martha Hall, \"United States Census, 1850\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/926H-WM3",
        "citation": "\"United States, Census, 1850\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M85T-PVB : Wed Jan 22 13:23:58 UTC 2025), Entry for Martha Hall, 1850."
      },
      {
        "title": "Martha J, \"United States, Veterans Administration Pension Payment Cards, 1907-1933\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZKD-JCJ",
        "citation": "\"United States, Veterans Administration Pension Payment Cards, 1907-1933\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:2M2D-RJ5 : Sat Nov 01 01:45:27 UTC 2025), Entry for Absalom Mendenhall and Martha J, from 1907 to 1933."
      },
      {
        "title": "Legacy NFS Source: Martha J. Hoel - birth-name: Martha Jane Hall",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M9PS-8DX",
        "citation": "mendenhall.FTW"
      },
      {
        "title": "http://www.findagrave.com/cgi-bin/fg.cgi?page=gr&GRid=26738853",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMXN-3HH",
        "citation": ""
      }
    ],
    "portrait": "/ancestors/portraits/087_L413-FMV.jpg"
  },
  {
    "id": "I27",
    "name": "Nina Oleah Blackner",
    "sex": "F",
    "gen": 3,
    "slot": 3,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "I6",
    "birthYear": 1912,
    "deathYear": 2001,
    "birthDate": "19 Jan 1912",
    "deathDate": "12 Aug 2001",
    "burialDate": "16 Aug 2001",
    "christeningDate": null,
    "birthPlace": "Lyman, Uinta, Wyoming, United States",
    "deathPlace": "American Fork, Utah, Utah, United States",
    "burialPlace": "Redwood Memorial Estates, West Jordan, Salt Lake, Utah, United States",
    "christeningPlace": null,
    "fsId": "KWZ4-F5Y",
    "photo": "/ancestors/bubbles/011_KWZ4-F5Y.jpg",
    "living": false,
    "alternateNames": [
      "Nina Oleah Blackner Hull"
    ],
    "facts": [
      {
        "kind": "Blessing",
        "date": "23 June 1912",
        "place": null,
        "note": null
      },
      {
        "kind": "Residence",
        "date": "April 1950",
        "place": "Rockland, Power, Idaho, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": null,
        "place": "United States",
        "note": "Lyman, Uinta, Wyoming"
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Nina, \"United States, Obituary Records, 2014-2023\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7HGG-XHK",
        "citation": "\"United States, Obituary Records, 2014-2023\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:611D-8Z9K : Thu Nov 14 18:40:26 UTC 2024), Entry for Bonnie Wyoma Blackner Snelson and Ray Blackner, 25 July 2020."
      },
      {
        "title": "Nina Oleah Blackner, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/77W7-NBJ",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6RFY-9TXP : Thu Mar 26 19:48:42 UTC 2026), Entry for Nina Oleah Blackner and Ray."
      },
      {
        "title": "Nina Oleah Blackner, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW4T-F8G",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6ZX7-LL2M : Sun Sep 13 05:48:28 UTC 2026), Entry for Nina Oleah Blackner and Ray."
      },
      {
        "title": "Nina O Hull, \"United States, Census, 1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3PWK-8KT",
        "citation": "\"United States, Census, 1950\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6XKK-9K3L : Tue Mar 18 06:58:24 UTC 2025), Entry for Ben B Hull and Nina O Hull, April 1950."
      },
      {
        "title": "Household of Benjamin Bruce Hull, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3ZHB-KKX",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:84SR-CSN2 : Fri Aug 01 17:24:49 UTC 2025), Entry for Benjamin Bruce Hull, 1935."
      },
      {
        "title": "Nina Oleah Blackner Hull, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3Z7Q-F1F",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:DJS5-BJ2M : Mon Mar 30 05:59:40 UTC 2026), Entry for Nina Oleah Blackner Hull, 1955."
      },
      {
        "title": "Nina Blackner Hull, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3CW1-GY5",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:DJSP-N42M : Mon Mar 30 05:59:11 UTC 2026), Entry for Nina Blackner Hull, 1960."
      },
      {
        "title": "Nina Oleah Blackner Hull, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3HBM-7GZ",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:DJS5-BNT2 : Mon Mar 30 07:38:56 UTC 2026), Entry for Nina Oleah Blackner Hull."
      },
      {
        "title": "Nina Olean Blackner Hull, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3HZY-KFF",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:DF6N-XDMM : Fri Aug 01 18:04:59 UTC 2025), Entry for Nina Olean Blackner Hull."
      },
      {
        "title": "Nina O. Blackner, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/34VH-MYK",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:ZTG9-TZT2 : Mon Mar 30 07:13:14 UTC 2026), Entry for Nina O. Blackner, 1914."
      },
      {
        "title": "Nina Oleah Blackner, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3SKT-CV9",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:ZTG9-T8ZM : Mon Mar 30 07:19:30 UTC 2026), Entry for Nina Oleah Blackner, 1930."
      },
      {
        "title": "Nina O. Blackner, \"United States, Western States Marriage Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S5ZB-MWS",
        "citation": "\"United States, Western States Marriage Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZNY-CMR : Tue Feb 11 23:14:20 UTC 2025), Entry for Ben B. Hull and Nina O. Blackner."
      },
      {
        "title": "Nina O. Blackner, \"United States, Western States Marriage Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S5ZY-1K3",
        "citation": "\"United States, Western States Marriage Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZD3-62Y : Tue Feb 11 23:10:13 UTC 2025), Entry for Ben B. Hull and Nina O. Blackner, 24 Sep 1930."
      },
      {
        "title": "https://www.deseret.com/platform/amp/2001/8/14/19625644/obituary-nina-oleah-blackner-hull",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SLHL-2RZ",
        "citation": ""
      },
      {
        "title": "Deseret News, Obituary: Nina Oleah Blackner Hull",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SV91-WTM",
        "citation": ""
      },
      {
        "title": "Nina Oleah Blackner in entry for Benjamin Bruce Hull, \"United States, GenealogyBank Obituaries, 1980-2014\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9K9P-21C",
        "citation": "\"United States, GenealogyBank Obituaries, Births, and Marriages, 1980-2015\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QKPT-23MJ : Mon Jun 03 19:42:15 UTC 2024), Entry for Benjamin Bruce Hull and Nina Oleah Blackner, 21 May 1998."
      },
      {
        "title": "Nina Oleah Blackner, \"Utah, Weber County Marriages, 1887-1941\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9FLQ-XQ9",
        "citation": "\"Utah, Weber County Marriages, 1887-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QK6K-H3QS : Thu Jan 16 08:08:49 UTC 2025), Entry for Benjamin Bruce Hull and Nina Oleah Blackner, 24 Sep 1930."
      },
      {
        "title": "Nina O Blackner, \"Utah, Weber County Marriages, 1887-1941\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/968N-F8P",
        "citation": "\"Utah, Weber County Marriages, 1887-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QK6K-XKLH : Tue Jul 16 22:03:30 UTC 2024), Entry for ben B Hull and Roy E Hull, 23 Sep 1930."
      },
      {
        "title": "Nina Oleah Blackner, \"United States, GenealogyBank Obituaries, Births, and Marriages, 1980-2015\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9D2M-9LW",
        "citation": "\"United States, GenealogyBank Obituaries, Births, and Marriages, 1980-2015\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QKWZ-7PVP : Mon Jan 20 08:49:07 UTC 2025), Entry for Benjamin Bruce Hull and Roy Ernest Hull, 21 May 1998."
      },
      {
        "title": "Nina Oleah Blackner Hull, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/98ZB-RH3",
        "citation": "\"Find a Grave Index,\" database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVVH-6GDC : 4 August 2020), Nina Oleah Blackner Hull, ; Burial, American Fork, Utah, Utah, United States of America, American Fork Cemetery; citing record ID 5740004, Find a Grave, http://www.findagrave.com."
      },
      {
        "title": "Nina Oleah Blackner Hull, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9845-GRK",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVPQ-5GWQ : Thu Oct 01 23:50:22 UTC 2026), Entry for Nina Oleah Blackner Hull."
      },
      {
        "title": "Nina O Blackner, \"Utah, County Marriages, 1871-1941\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZWP-CH4",
        "citation": "\"Utah, County Marriages, 1871-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VRLN-HTK : Thu Sep 19 20:23:11 UTC 2024), Entry for Ben B Hull and Roy E Hull, 23 Sep 1930."
      },
      {
        "title": "Nina Oliah Blackner in entry for Benjamin Bruce Hull, \"Utah, Marriages, 1887-1935\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZWP-CQQ",
        "citation": "\"Utah, Marriages, 1887-1935\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:F8GN-SQV : 16 March 2020), Nina Oliah Blackner in entry for Benjamin Bruce Hull, 1930."
      },
      {
        "title": "Nina O Hull, \"United States, Social Security Death Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSYL-6G2",
        "citation": "\"United States, Social Security Death Index,\" database, FamilySearch (https://familysearch.org/ark:/61903/1:1:JBW3-2NG : 11 January 2021), Nina O Hull, 12 Aug 2001; citing U.S. Social Security Administration, Death Master File, database (Alexandria, Virginia: National Technical Information Service, ongoing)."
      },
      {
        "title": "Nina Oleah Hull, \"BillionGraves Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSYL-692",
        "citation": "\"BillionGraves Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KBYW-576 : Thu Sep 24 19:07:18 UTC 2026), Entry for Nina Oleah Hull."
      },
      {
        "title": "Nina Hull in household of Benjaman B Hull, \"United States Census, 1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMHX-W4W",
        "citation": "\"United States, Census, 1940\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VT4D-HKJ : Wed Jul 24 03:12:05 UTC 2024), Entry for Benjaman B Hull and Nina Hull, 1940."
      },
      {
        "title": "Nina D Blackner in household of Leonard R Blackner, \"United States Census, 1930\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMHX-7BQ",
        "citation": "\"United States, Census, 1930\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:X7WH-F5Z : Sun Mar 10 16:44:31 UTC 2024), Entry for Leonard R Blackner and Bessie L Blackner, 1930."
      },
      {
        "title": "Nina Blackner in household of L Ray Blackner, \"United States Census, 1920\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MM93-FWR",
        "citation": "\"United States, Census, 1920\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MNB5-7DL : Tue Sep 29 13:39:33 UTC 2026), Entry for L Ray Blackner and Bessie S Blackner, 1920."
      },
      {
        "title": "Nina Oleah Blackner, \"Utah, County Marriages, 1887-1937\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MM93-FCC",
        "citation": "\"Utah, County Marriages, 1871-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VRLL-VYL : Thu Sep 19 19:56:24 UTC 2024), Entry for Benjamin Bruce Hull and Nina Oleah Blackner, 24 Sep 1930."
      }
    ],
    "portrait": "/ancestors/portraits/011_KWZ4-F5Y.jpg"
  },
  {
    "id": "I90",
    "name": "Leonard Ray Blackner",
    "sex": "M",
    "gen": 4,
    "slot": 6,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "I27",
    "birthYear": 1882,
    "deathYear": 1965,
    "birthDate": "18 Sep 1882",
    "deathDate": "21 Aug 1965",
    "burialDate": "24 Aug 1965",
    "christeningDate": null,
    "birthPlace": "Greenville, Beaver, Utah Territory, United States",
    "deathPlace": "Layton, Davis, Utah, United States",
    "burialPlace": "Redwood Memorial Estates, West Jordan, Salt Lake, Utah, United States",
    "christeningPlace": null,
    "fsId": "KWJ6-C5G",
    "photo": "/ancestors/bubbles/022_KWJ6-C5G.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [
      {
        "kind": "Baptism",
        "date": "5 July 1894",
        "place": null,
        "note": null
      },
      {
        "kind": "Land Assessment",
        "date": "16 May 1910",
        "place": "Evanston, Uinta, Wyoming, United States",
        "note": null
      },
      {
        "kind": "Military Draft Registration",
        "date": "27 April 1942",
        "place": "Lyman, Uinta, Wyoming, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "25 April 1950",
        "place": "Lyman, Uinta, Wyoming, United States",
        "note": null
      },
      {
        "kind": "Record",
        "date": null,
        "place": null,
        "note": "#SSN: United States Social Security No 520-07-1560, Issued in Wyoming"
      },
      {
        "kind": "Residence",
        "date": null,
        "place": "Lyman, Uinta, Wyoming, United States",
        "note": null
      },
      {
        "kind": "Membership",
        "date": null,
        "place": "Utah, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": null,
        "place": "Lyman, Burleigh, North Dakota, United States",
        "note": null
      },
      {
        "kind": "Membership",
        "date": null,
        "place": "Woodruff, Rich, Utah, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Ray L Blackner, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/WDWD-39G",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6ZXT-D7Z1 : Sun Sep 13 05:28:46 UTC 2026), Entry for Ray L Blackner and Bessie Briggs."
      },
      {
        "title": "Ray L Blackner, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/WDWD-SR8",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6ZXT-D789 : Sun Sep 13 05:13:50 UTC 2026), Entry for Bessie Briggs and Ray L Blackner."
      },
      {
        "title": "Ray L Blackner, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/WDWD-SKS",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:62WC-BP3G : Fri Mar 27 03:22:48 UTC 2026), Entry for Ray L Blackner and Bessie Briggs."
      },
      {
        "title": "Ray L Blackner, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/WD7C-77Z",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:62WC-BP35 : Thu Mar 26 20:12:15 UTC 2026), Entry for Bessie Briggs and Ray L Blackner."
      },
      {
        "title": "Leonard Ray Blackner, \"United States, Bureau of Land Management Tract Books, 1800-c. 1955\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/72HN-HZ4",
        "citation": "\"United States, Bureau of Land Management Tract Books, 1800-c. 1955\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:62X1-CTMK : Wed Oct 22 19:41:26 UTC 2025), Entry for Leonard Ray Blackner, 16 May 1910."
      },
      {
        "title": "Roy, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7F3G-8Z6",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6R29-YBF9 : Fri Mar 27 00:27:55 UTC 2026), Entry for Nedra Louise Blackner and Roy."
      },
      {
        "title": "Ray Blackner, \"United States, Obituary Records, 2014-2023\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7HGG-6XD",
        "citation": "\"United States, Obituary Records, 2014-2023\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:611D-8Z9K : Thu Nov 14 18:40:26 UTC 2024), Entry for Bonnie Wyoma Blackner Snelson and Ray Blackner, 25 July 2020."
      },
      {
        "title": "Ray, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/77W7-2YS",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:659S-2NN1 : Fri Mar 27 04:00:49 UTC 2026), Entry for Rebecca Blackner and Ray."
      },
      {
        "title": "Le Roy, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/77W7-VXP",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6RFR-3TSQ : Fri Mar 27 00:39:12 UTC 2026), Entry for Leonard Briggs Blackner and Le Roy."
      },
      {
        "title": "Ray, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/77W7-JS2",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6RFY-9TXP : Thu Mar 26 19:48:42 UTC 2026), Entry for Nina Oleah Blackner and Ray."
      },
      {
        "title": "Ray, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7QCG-5T5",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:659S-2NNT : Fri Mar 27 02:01:06 UTC 2026), Entry for Woodrow R Blackner and Ray."
      },
      {
        "title": "Leonard Ray Blackner, \"United States, World War II Draft Registration Cards, 1942\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QJST-46R",
        "citation": "\"United States, World War II Draft Registration Cards, 1942\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QKV9-BPYD : Tue Apr 29 06:31:58 UTC 2025), Entry for Leonard Ray Blackner and Bessie Blackner, 27 Apr 1942."
      },
      {
        "title": "Leonard R Blackner, \"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QWCH-PXM",
        "citation": "\"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6K4L-7ZKJ : Sun Jul 05 16:13:53 UTC 2026), Entry for Woodrow Ray Blackner and Leonard R Blackner."
      },
      {
        "title": "Ray, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW4T-FRN",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6ZX7-LL2M : Sun Sep 13 05:48:28 UTC 2026), Entry for Nina Oleah Blackner and Ray."
      },
      {
        "title": "Leonard Ray Blackner, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW46-XZW",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CTH-TWY2 : Sun Sep 13 05:50:52 UTC 2026), Entry for Leonard Ray Blackner and F D Farnsworth."
      },
      {
        "title": "Leonard Ray Blackner, \"United States, Census, 1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3LNR-L3T",
        "citation": "\"United States, Census, 1950\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6XBJ-98GX : Wed Mar 20 12:53:24 UTC 2024), Entry for Daniel Edgar Wright and Connie Wright, April 25, 1950."
      },
      {
        "title": "Leonard Ray Blackner, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/34VH-MGZ",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:ZTG9-TZ2M : Mon Mar 30 07:13:14 UTC 2026), Entry for Leonard Ray Blackner, 1914."
      },
      {
        "title": "Leonard Ray Blackner, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3SKT-NLS",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:DGPJ-F7T2 : Mon Mar 30 07:32:14 UTC 2026), Entry for Leonard Ray Blackner, 1950."
      },
      {
        "title": "Leonard Ray Blackner, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3SKT-XG8",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:ZXP2-VF3Z : Fri Aug 01 15:33:52 UTC 2025), Entry for Leonard Ray Blackner, 1950."
      },
      {
        "title": "Leonard Ray Blackner, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3SKT-DXC",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:ZTG9-TDW2 : Sun Mar 29 22:35:19 UTC 2026), Entry for Leonard Ray Blackner, 1935."
      },
      {
        "title": "Leonard Ray Blackner, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3SKT-CZT",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:ZTG9-T83Z : Mon Mar 30 07:19:30 UTC 2026), Entry for Leonard Ray Blackner, 1930."
      },
      {
        "title": "Leonard Ray Blackner, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SYTM-3H9",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Z1VK-4B2M : Sun Mar 10 21:34:49 UTC 2024), Entry for Leonard Ray Blackner and John Henry Blackner, 21 Aug 1965."
      },
      {
        "title": "Leonard R. Blackner in entry for Frank Harold Wright, \"Utah, Marriages, 1887-1935\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SV2V-G4Y",
        "citation": "\"Utah, Marriages, 1887-1935\", database, FamilySearch (https://familysearch.org/ark:/61903/1:1:HN81-8CW2 : 3 November 2021), Leonard R. Blackner in entry for Frank Harold Wright, 1940."
      },
      {
        "title": "Leonard Blackner, \"Utah, World War II Draft Registration Cards, 1940-1947\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SXB2-Y4N",
        "citation": "\"Utah, World War II Draft Registration Cards, 1940-1947\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2WP-6ND4 : Tue Apr 29 01:13:06 UTC 2025), Entry for Dennis Kent Blackner and Leonard Blackner, 30 Jun 1942."
      },
      {
        "title": "Ray Blackner, \"Utah, World War II Index to Army Veterans of Utah, 1939-1945\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SZRC-FWQ",
        "citation": "\"Utah, World War II Index to Army Veterans of Utah, 1939-1945\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QYWQ-JB2M : Mon Mar 17 15:16:29 UTC 2025), Entry for Dennis K Blackner and Bessie Blackner, 30 Oct 1944."
      },
      {
        "title": "Leonard R Blackner, \"Utah, World War II Index to Army Veterans of Utah, 1939-1945\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SZRC-6DX",
        "citation": "\"Utah, World War II Index to Army Veterans of Utah, 1939-1945\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QYWQ-JBW2 : Mon Mar 17 15:16:54 UTC 2025), Entry for Dennis Kent Blackner and Besie L Blackner, 31 Oct 1944."
      },
      {
        "title": "Leonard Ray Blackner, \"United States, Western States Marriage Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S3KZ-BYG",
        "citation": "\"United States, Western States Marriage Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZX3-43R : Tue Feb 11 23:11:57 UTC 2025), Entry for Leonard Ray Blackner and Bessie L Briggs, 19 Jan 1910."
      },
      {
        "title": "Leonard R. Blackner, \"United States, Western States Marriage Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S3KZ-KTD",
        "citation": "\"United States, Western States Marriage Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZKC-M2F : Tue Feb 11 22:36:47 UTC 2025), Entry for Leonard R. Blackner and Bessie L. Briggs, 19 Jan 1910."
      },
      {
        "title": "Ray Blackner, \"Utah, ObitsUtah Obituary Index, 2010-2013\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/987Z-XWM",
        "citation": "\"Utah, ObitsUtah Obituary Index, 2010-2013\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSC-R2C2 : Tue Mar 11 15:41:52 UTC 2025), Entry for Bonnie Snelson and Bish Snelson, 2012."
      },
      {
        "title": "Leonard Ray Blackner in entry for Nedra Louise Blackner Walker, \"United States, GenealogyBank Obituaries, 1980-2014\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9V1F-QXQ",
        "citation": "\"United States, GenealogyBank Obituaries, Births, and Marriages, 1980-2015\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QKTJ-MP2B : Sat Jan 18 05:05:47 UTC 2025), Entry for Nedra Louise Blackner Walker and Leonard Ray Blackner, 15 Mar 2007."
      },
      {
        "title": "Leonard Ray Blackner in entry for Nedra Louise Blackner Walker, \"United States, GenealogyBank Obituaries, 1980-2014\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9V1X-KVX",
        "citation": "\"United States, GenealogyBank Obituaries, Births, and Marriages, 1980-2015\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QKT9-GTPB : Tue Jan 14 06:27:01 UTC 2025), Entry for Nedra Louise Blackner Walker and Bonnie Snelson, 15 Mar 2007."
      },
      {
        "title": "Leonard Ray Blackner in entry for Woodrow Ray Blackner, \"United States, GenealogyBank Obituaries, 1980-2014\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9KMX-BDY",
        "citation": "\"United States, GenealogyBank Obituaries, Births, and Marriages, 1980-2015\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QK5P-5S4G : Sun Jan 19 17:02:47 UTC 2025), Entry for Woodrow Ray Blackner and Leonard Ray Blackner, 07 Jun 2005."
      },
      {
        "title": "Leonard Ray Blackner in entry for Woodrow Raymond Blackner, \"United States, GenealogyBank Obituaries, 1980-2014\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9V1S-Y3Y",
        "citation": "\"United States, GenealogyBank Obituaries, Births, and Marriages, 1980-2015\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QK5P-NYMD : Sat Jan 18 02:18:26 UTC 2025), Entry for Woodrow Raymond Blackner and Kathy Blackner, 05 Jun 2005."
      },
      {
        "title": "Leonard Ray Blackner, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/98W4-H37",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QV2Z-P13M : Mon Oct 05 03:48:23 UTC 2026), Entry for Leonard Ray Blackner."
      },
      {
        "title": "Leonard Ray Blackner, \"BillionGraves Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMHX-72Q",
        "citation": "\"BillionGraves Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KPSL-CYS : Thu Sep 24 21:40:23 UTC 2026), Entry for Leonard Ray Blackner."
      },
      {
        "title": "Leonard Blackner, \"United States Social Security Death Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMHX-7GN",
        "citation": "\"United States, Social Security Death Index,\" database, FamilySearch (https://familysearch.org/ark:/61903/1:1:V9L8-2YX : 11 January 2021), Leonard Blackner, Aug 1965; citing U.S. Social Security Administration, Death Master File, database (Alexandria, Virginia: National Technical Information Service, ongoing)."
      },
      {
        "title": "Leonard R Blackner, \"Utah, County Marriages, 1871-1941\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9FDL-JVH",
        "citation": "\"Utah, County Marriages, 1871-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2MY-DQ3V : Wed Nov 19 07:35:58 UTC 2025), Entry for Frank Harold Wright and Harry Wright, 22 Jun 1940."
      },
      {
        "title": "L R Blackner, \"United States Census, 1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMHX-4MC",
        "citation": "\"United States, Census, 1940\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VTHM-T8N : Mon Jan 20 06:03:56 UTC 2025), Entry for L R Blackner and Bessie L Blackner, 1940."
      },
      {
        "title": "Leonard R, \"Utah, County Marriages, 1871-1941\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9FXW-WJV",
        "citation": "\"Utah, County Marriages, 1871-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2MB-QM2V : Thu Sep 19 20:21:36 UTC 2024), Entry for Leonard Briggs Blackner and Leonard R, 03 Sep 1935."
      },
      {
        "title": "L R Blackner, \"Utah, Weber County Marriages, 1887-1941\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/968N-F32",
        "citation": "\"Utah, Weber County Marriages, 1887-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QK6K-XKLH : Tue Jul 16 22:03:30 UTC 2024), Entry for ben B Hull and Roy E Hull, 23 Sep 1930."
      },
      {
        "title": "L R Blackner, \"Utah, County Marriages, 1871-1941\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/98W4-HBJ",
        "citation": "\"Utah, County Marriages, 1871-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VRLN-HTK : Thu Sep 19 20:23:11 UTC 2024), Entry for Ben B Hull and Roy E Hull, 23 Sep 1930."
      },
      {
        "title": "Leonard R Blackner, \"United States Census, 1930\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMHX-7Y3",
        "citation": "\"United States, Census, 1930\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:X7WH-F5Z : Sun Mar 10 16:44:31 UTC 2024), Entry for Leonard R Blackner and Bessie L Blackner, 1930."
      },
      {
        "title": "L Ray Blackner, \"United States Census, 1920\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMHX-759",
        "citation": "\"United States, Census, 1920\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MNB5-7DL : Tue Sep 29 13:39:33 UTC 2026), Entry for L Ray Blackner and Bessie S Blackner, 1920."
      },
      {
        "title": "Leonard Ray Blackner, \"United States World War I Draft Registration Cards, 1917-1918\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMHX-7L9",
        "citation": "\"United States, World War I Draft Registration Cards, 1917-1918\", database with images, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:K68Q-RJV : 1 July 2024), Leonard Ray Blackner, 1917-1918."
      },
      {
        "title": "Leonard R Blackner, \"United States Census, 1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMHX-7PW",
        "citation": "\"United States, Census, 1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MPJN-3DF : Wed Aug 13 17:38:36 UTC 2025), Entry for Leonard R Blackner and Bessie L Blackner, 1910."
      },
      {
        "title": "Leonard R. Blackner, \"Utah, Marriages, 1887-1935\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/98W4-HG8",
        "citation": "\"Utah, Marriages, 1887-1935\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:F8GZ-65Q : 28 January 2020), Leonard R. Blackner, 1910."
      },
      {
        "title": "Leonard R. Blackner, \"Utah, County Marriages, 1871-1941\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSB3-R1T",
        "citation": "\"Utah, County Marriages, 1871-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KSGT-FQK : Thu Sep 19 19:12:43 UTC 2024), Entry for Leonard R. Blackner and Bessie L. Briggs, 19 Jan 1910."
      },
      {
        "title": "Leonard Ray Blackner, \"Utah, County Marriages, 1887-1937\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMHX-72X",
        "citation": "\"Utah, County Marriages, 1871-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:F8G3-DQZ : Thu Sep 19 18:58:00 UTC 2024), Entry for Leonard Ray Blackner and Miss Bessie L. Briggs, 19 Jan 1910."
      },
      {
        "title": "Lenord R Blackner in household of John Blackner, \"United States Census, 1900\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMHX-QW8",
        "citation": "\"United States, Census, 1900\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M3VB-W7S : Sat Mar 29 11:39:08 UTC 2025), Entry for John Blackner and Hannah Blackner, 1900."
      },
      {
        "title": "Ray & Bessie Blackner in 1910 census",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZQ9-VYW",
        "citation": "Ancestry.com"
      },
      {
        "title": "Legacy NFS Source: Leonard Ray Blackner - Individual or family possessions: death: 21 August 1965; Layton, Davis, Utah, United States",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MS66-JDH",
        "citation": ""
      },
      {
        "title": "Headstone image of Leonard Ray Blackner from billiongraves.com",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMD4-Z8L",
        "citation": "Transcription of headstone image from billiongraves.com. Image taken at Redwood Memorial Estates (West Jordan, Salt Lake, Utah, United States) on 30 June 2013"
      }
    ],
    "portrait": "/ancestors/portraits/022_KWJ6-C5G.jpg"
  },
  {
    "id": "I229",
    "name": "John Henry Blackner",
    "sex": "M",
    "gen": 5,
    "slot": 12,
    "side": "paternal",
    "birthplace": "england",
    "childId": "I90",
    "birthYear": 1855,
    "deathYear": 1932,
    "birthDate": "25 Mar 1855",
    "deathDate": "29 Dec 1932",
    "burialDate": "1 Jan 1933",
    "christeningDate": "3 Jun 1855",
    "birthPlace": "Dalton, Yorkshire, England, United Kingdom",
    "deathPlace": "Lyman, Uinta, Wyoming, United States",
    "burialPlace": "Lyman City Cemetery, Lyman, Uinta, Wyoming, United States",
    "christeningPlace": "Dalton, Yorkshire, England, United Kingdom",
    "fsId": "KWC1-J6F",
    "photo": "/ancestors/bubbles/044_KWC1-J6F.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [
      {
        "kind": "Birth Registration",
        "date": "1855",
        "place": "Rotherham, Yorkshire, England, United Kingdom",
        "note": null
      },
      {
        "kind": "Financial Transaction",
        "date": "1860",
        "place": "England, United Kingdom",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1870",
        "place": "Utah, United States",
        "note": null
      },
      {
        "kind": "Census",
        "date": "19 July 1870",
        "place": "Greenville, Beaver, Utah, United States",
        "note": null
      },
      {
        "kind": "Membership",
        "date": null,
        "place": "Utah, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "John Henry Blackner, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW48-BWM",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Z1W-RXJV : Sun Sep 13 05:47:04 UTC 2026), Entry for John Henry Blackner and James Henry Blackner."
      },
      {
        "title": "John H Blackner, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW46-6TJ",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CTH-TWY2 : Sun Sep 13 05:50:52 UTC 2026), Entry for Leonard Ray Blackner and F D Farnsworth."
      },
      {
        "title": "John H, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QJT2-3JS",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CY2-8C9D : Sun Sep 13 05:21:22 UTC 2026), Entry for Arnold Eyre and John H."
      },
      {
        "title": "John H, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7QXF-CYB",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:62XB-NQXN : Fri Mar 27 01:02:21 UTC 2026), Entry for Owen Grant Blackner and John W Field."
      },
      {
        "title": "John Henry, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7PHW-M2T",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6PNX-1LXG : Sun Sep 13 05:25:44 UTC 2026), Entry for Benard Blackner and C M Larson."
      },
      {
        "title": "John Henry Blackner, \"Utah, Mormon Pioneer Overland Travel Database, 1847-1868\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9DFY-PXB",
        "citation": "\"Utah, Mormon Pioneer Overland Travel Database, 1847-1868\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QK9B-C5JX : Wed Feb 19 20:20:56 UTC 2025), Entry for John Henry Blackner, 01 Sep 1860."
      },
      {
        "title": "John Henry Blackner, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW46-3D3",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Q3S-J4MM : Sun Sep 13 05:11:51 UTC 2026), Entry for John Henry Blackner and James Henry Blackner."
      },
      {
        "title": "John H. Blackner, \"The Church of Jesus Christ of Latter-day Saints, Perpetual Emigrating Fund Company Financial Accounts (Worldwide), 1849-1886\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QJY3-2B9",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Perpetual Emigrating Fund Company Financial Accounts (Worldwide), 1849-1886\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6JV6-27SN : Fri Feb 21 21:28:28 UTC 2025), Entry for John H. Blackner, 1860."
      },
      {
        "title": "John Henry Blacknar, \"England and Wales, Birth Registration Index, 1837-2008\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSBS-7H6",
        "citation": "\"England and Wales, Birth Registration Index, 1837-2008\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:26GL-C61 : Sat May 09 10:02:43 UTC 2026), Entry for John Henry Blacknar, 1855."
      },
      {
        "title": "Jno. Henry Blackner, \"The Church of Jesus Christ of Latter-day Saints, Missionary Registers (Worldwide), 1860-1937\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q5CL-77M",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Missionary Registers (Worldwide), 1860-1937\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6LRD-7TTR : Tue Apr 29 04:59:26 UTC 2025), Entry for Geo. Henry Blackner and Franklin D. Farnsworth, 3 Mar 1941."
      },
      {
        "title": "John H Blackner, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW46-DQX",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CTH-TWY5 : Sun Sep 13 05:30:28 UTC 2026), Entry for Rueben E Blackner and F D Farnsworth."
      },
      {
        "title": "John H. Blackner, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW46-6C1",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CYP-1TKR : Sun Sep 13 05:15:33 UTC 2026), Entry for Blanche Blackner and John H. Blackner."
      },
      {
        "title": "John H Blackner, \"United States, Census, 1870\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M975-3TZ",
        "citation": "\"United States, Census, 1870\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MNCR-49Z : Tue Oct 14 18:34:47 UTC 2025), Entry for Henry Blackner and Jane Blackner, 1870."
      },
      {
        "title": "John H Blackner, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QWM8-X7B",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CTH-TWYN : Sun Sep 13 05:22:10 UTC 2026), Entry for George Henry Blackner and F D Farnsworth."
      },
      {
        "title": "John Henry, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QVBS-4J7",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6ZX8-YWTG : Sun Sep 13 05:48:29 UTC 2026), Entry for Lottie Rebecca Blackner and C M Larson."
      },
      {
        "title": "John Henry, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7QXF-ZNW",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6PNX-1LF8 : Sat Sep 12 23:53:15 UTC 2026), Entry for Lottie Rebecca Blackner and C M Larson."
      },
      {
        "title": "John H Blackner, \"Wyoming, Reclaim the Records, State Archives Vital Records, 1908-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3KRP-L2F",
        "citation": "\"Wyoming, Reclaim the Records, State Archives Vital Records, 1908-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:7DHN-7NW2 : Sun Mar 10 17:56:38 UTC 2024), Entry for John H Blackner, 30 Dec 1932."
      },
      {
        "title": "John H, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW46-XVY",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6ZXS-91GN : Sat Sep 12 23:41:51 UTC 2026), Entry for Owen Grant Blackner and John W Field."
      },
      {
        "title": "John H, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7QXF-H7R",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6PD8-SDT7 : Fri Mar 27 03:30:52 UTC 2026), Entry for Druesilla Blackner and John H."
      },
      {
        "title": "John H, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7PH7-VH8",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6PD8-SDBP : Thu Mar 26 19:33:22 UTC 2026), Entry for Drusilla Blackner and John H."
      },
      {
        "title": "Authentic Wyoming frontier log cabin",
        "href": "https://www.familysearch.org/tree/sources/viewedit/33LR-N4N",
        "citation": "https://www.enjoyillinois.com/explore/listing/nauvoo-hideaway-cabin"
      },
      {
        "title": "John Henry Blackner Obituary",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SZ67-KB1",
        "citation": "Newspaper Archive Salt Lake Tribune Newspaper Archives Saturday, December 31, 1932 - Page 19"
      },
      {
        "title": "Headstone image of John H. Blackner from billiongraves.com",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M9N5-L3B",
        "citation": "Transcription of headstone image from billiongraves.com. Image taken at Lyman Cemetery (Lyman, Uinta, Wyoming, United States) on 31 July 2013"
      },
      {
        "title": "Legacy NFS Source: John Henry Blackner - Individual or family possessions: Birth announcement: birth:",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMVM-V7X",
        "citation": "Paper"
      },
      {
        "title": "John H Blackner, \"BillionGraves Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSBS-2HN",
        "citation": "\"BillionGraves Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KBYS-KVZ : Thu Sep 24 17:08:54 UTC 2026), Entry for John H Blackner."
      },
      {
        "title": "John H Blackner, \"United States Census, 1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMHX-Q6G",
        "citation": "\"United States, Census, 1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MPJN-48M : Wed Aug 13 17:37:08 UTC 2025), Entry for John H Blackner and Hanna E Blackner, 1910."
      },
      {
        "title": "J H Blackner in entry for Jennings Bernard Blackner, \"Utah, Marriages, 1887-1935\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/983V-VYS",
        "citation": "\"Utah, Marriages, 1887-1935\", database, FamilySearch (https://familysearch.org/ark:/61903/1:1:F8GK-8S1 : 28 January 2020), J H Blackner in entry for Jennings Bernard Blackner, 1921."
      },
      {
        "title": "John H Blackner, \"United States Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMHX-QQQ",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MNSN-T1G : Wed Sep 09 15:08:10 UTC 2026), Entry for John H. Blackner and Hannah Blackner, 1880."
      },
      {
        "title": "I H Blackner Sr., \"United States Census, 1930\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMHX-QRR",
        "citation": "\"United States, Census, 1930\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:X7WH-LCD : Sun Jan 12 17:26:46 UTC 2025), Entry for I H Blackner Sr. and Hannah E Blackner, 1930."
      },
      {
        "title": "John H. Blackner, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/983V-JBP",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZPL-W32 : Mon Feb 03 19:15:58 UTC 2025), Entry for Owen Grant Blackner and John H. Blackner, 15 Apr 1934."
      },
      {
        "title": "John Henry Blackner, \"Utah, Obituaries from Utah Newspapers, 1850-2005\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/968Q-3YZ",
        "citation": "\"Utah, Obituaries from Utah Newspapers, 1850-2005\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSF-2CSZ : Tue Mar 11 15:36:04 UTC 2025), Entry for Mrs Sarah Snow and Raymond Hodges, 24 Dec 1931."
      },
      {
        "title": "John H, \"Utah, County Marriages, 1871-1941\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9F9N-QTN",
        "citation": "\"Utah, County Marriages, 1871-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2MB-7VF9 : Thu Sep 19 19:25:08 UTC 2024), Entry for George Henry Blackner and John H, 15 Dec 1937."
      },
      {
        "title": "J H Blackner, \"United States Census, 1920\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMHX-QL5",
        "citation": "\"United States, Census, 1920\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MNB5-P9H : Tue Sep 29 13:39:01 UTC 2026), Entry for J H Blackner and Hanna C Blackner, 1920."
      },
      {
        "title": "John H. Blackner in entry for Owen Grant Blackner, \"Utah, Deaths and Burials, 1888-1946\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9Z4G-PG5",
        "citation": "\"Utah, Deaths and Burials, 1888-1946\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:F85D-BR9 : 28 January 2020), John H. Blackner in entry for Owen Grant Blackner, ."
      },
      {
        "title": "John H Blackner, \"Utah, Salt Lake County Death Records, 1849-1949\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/983V-VVP",
        "citation": "\"Utah, Salt Lake County Death Records, 1849-1949\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:NQ4D-7LW : Sun Mar 10 14:35:46 UTC 2024), Entry for Owen Grant Blackner and John H Blackner, 15 Apr 1934."
      },
      {
        "title": "John H Blackner, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/983V-GVT",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVVP-YPVD : Sat Oct 03 13:17:51 UTC 2026), Entry for John H Blackner."
      },
      {
        "title": "John Blackner, \"United States Census, 1900\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMHX-Q7X",
        "citation": "\"United States, Census, 1900\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M3VB-W7S : Sat Mar 29 11:39:08 UTC 2025), Entry for John Blackner and Hannah Blackner, 1900."
      },
      {
        "title": "John Henry Blackner, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/983V-VHJ",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZL7-L59 : Tue Dec 16 02:31:40 UTC 2025), Entry for George Henry Blackner and John Henry Blackner, 25 Oct 1946."
      },
      {
        "title": "J H Blackner, \"Utah, County Marriages, 1871-1941\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/983V-KWM",
        "citation": "\"Utah, County Marriages, 1871-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VRLZ-141 : Thu Sep 19 18:58:12 UTC 2024), Entry for Jennings Bernard Blackner and J H Blackner, 23 Jul 1921."
      },
      {
        "title": "John Henry Blackner, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SYTM-383",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Z1VK-4B2M : Sun Mar 10 21:34:49 UTC 2024), Entry for Leonard Ray Blackner and John Henry Blackner, 21 Aug 1965."
      }
    ],
    "portrait": "/ancestors/portraits/044_KWC1-J6F.jpg"
  },
  {
    "id": "I453",
    "name": "James Henry Blackner",
    "sex": "M",
    "gen": 6,
    "slot": 24,
    "side": "paternal",
    "birthplace": "england",
    "childId": "I229",
    "birthYear": 1832,
    "deathYear": 1902,
    "birthDate": "26 Mar 1832",
    "deathDate": "12 Mar 1902",
    "burialDate": "Mar 1902",
    "christeningDate": "26 Mar 1832",
    "birthPlace": "Hucknall Torkard, Nottinghamshire, England, United Kingdom",
    "deathPlace": "Beaver, Beaver, Utah, United States",
    "burialPlace": "Mountain View Cemetery, Beaver, Beaver, Utah, United States",
    "christeningPlace": "Hucknall Torkard, Nottinghamshire, England, United Kingdom",
    "fsId": "KWJ6-WMV",
    "photo": "/ancestors/bubbles/088_KWJ6-WMV.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [
      {
        "kind": "Residence",
        "date": "1841",
        "place": "Hucknall Torkard, Nottinghamshire, England, United Kingdom",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1851",
        "place": "Rawmarsh, Yorkshire, England, United Kingdom",
        "note": null
      },
      {
        "kind": "Departure",
        "date": "15 March 1860",
        "place": "Liverpool, Lancashire, England, United Kingdom",
        "note": null
      },
      {
        "kind": "Arrival",
        "date": "1 May 1860",
        "place": "New York City, New York County, New York, United States",
        "note": null
      },
      {
        "kind": "Arrival",
        "date": "1 September 1860",
        "place": "Utah, United States",
        "note": "Deserert"
      },
      {
        "kind": "Elder Ordination",
        "date": "1865",
        "place": null,
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1870",
        "place": "Greenville, Beaver, Utah, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1880",
        "place": "Beaver, Beaver, Utah, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1900",
        "place": "Beaver, Beaver, Utah, United States",
        "note": null
      },
      {
        "kind": "Membership",
        "date": null,
        "place": "Utah, United States",
        "note": null
      },
      {
        "kind": "Membership",
        "date": null,
        "place": "Beaver, Utah, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": null,
        "place": "Hucknall Torkard, Nottinghamshire, England, United Kingdom",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "James Henry Blackner, 'Geni World Family Tree' on MyHeritage",
        "href": "https://www.familysearch.org/tree/sources/viewedit/W69Y-91F",
        "citation": "Geni World Family Tree MyHeritage.com [online database], MyHeritage Ltd. James Henry Blackner"
      },
      {
        "title": "The Immigration - Deseret News 1860",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7FLS-YSX",
        "citation": "Deseret News. Salt Lake City, USA. 15 August 1860. The Immigration: Capt John Smith's Company. page 5. BLACKNER, Henry. https://newspapers.lib.utah.edu/ark:/87278/s6zc8x97/2584711 : accessed 29 March 2025."
      },
      {
        "title": "Henry J Blackner, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW46-W2D",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CTZ-21BW : Sun Sep 13 05:35:58 UTC 2026), Entry for Joseph Blackner and Henry J Blackner."
      },
      {
        "title": "James Henry Blackner, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW4D-T69",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Z1W-RXJ5 : Sun Sep 13 05:45:56 UTC 2026), Entry for Sarah Ann Blackner and James Henry Blackner."
      },
      {
        "title": "Henry J Blackner, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW4D-1X6",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CTZ-2119 : Sun Sep 13 05:12:53 UTC 2026), Entry for Joseph Hyrum Blackner and Henry J Blackner."
      },
      {
        "title": "Henry J Blackner, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW46-S32",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Z1D-BX6S : Sun Sep 13 05:38:37 UTC 2026), Entry for Joseph Hyrum Blackner and Henry J Blackner."
      },
      {
        "title": "James Henry Blackner, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW4D-Y9D",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Q3S-J42M : Sun Sep 13 05:29:07 UTC 2026), Entry for Sarah Ann Blackner and James Henry Blackner."
      },
      {
        "title": "Henry J Blackner, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW46-4D3",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Z1D-BXD6 : Sun Sep 13 05:16:09 UTC 2026), Entry for Emily Blackner and Henry J Blackner."
      },
      {
        "title": "Henry J Blackner, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW46-7MH",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Z1D-BXDB : Sun Sep 13 05:14:18 UTC 2026), Entry for Annie Eliza Blackner and D Grimshaw."
      },
      {
        "title": "James Henry Blackner, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW46-313",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Q3S-JHMM : Sun Sep 13 05:39:38 UTC 2026), Entry for Emile Blackner and James Henry Blackner."
      },
      {
        "title": "Henry J Blackner, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW46-7RL",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Z1D-BXD4 : Sun Sep 13 05:34:51 UTC 2026), Entry for Joseph Blackner and Henry J Blackner."
      },
      {
        "title": "James Henry Blackner, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW46-9HD",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Q3S-JCW2 : Sun Sep 13 05:29:05 UTC 2026), Entry for Sarah Elizabeth Blackner and James Henry Blackner."
      },
      {
        "title": "Henry Blackner, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7NVF-38Q",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:X3MG-TT7P : Sat Sep 12 23:42:45 UTC 2026), Entry for Sarah B Snow and Henry Blackner."
      },
      {
        "title": "James Henry Blackner, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/712B-5DW",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Z1W-RXJW : Sun Sep 13 05:20:29 UTC 2026), Entry for James Henry Blackner and Peter Betts."
      },
      {
        "title": "Henry J Blackner, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW4D-B6R",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Z1D-BXDK : Sun Sep 13 05:29:09 UTC 2026), Entry for Sarah Elizabeth Blackner and Henry J Blackner."
      },
      {
        "title": "Jas Henry Blackner, \"Utah, State Archives, Records, 1848-2001\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7Z35-F1D",
        "citation": "\"Utah, State Archives, Records, 1848-2001\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:8D6P-K9PZ : Sun Mar 10 19:02:28 UTC 2024), Entry for Jas Henry Blackner."
      },
      {
        "title": "James Henry Blackner, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW46-3H3",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Q3S-J4MM : Sun Sep 13 05:11:51 UTC 2026), Entry for John Henry Blackner and James Henry Blackner."
      },
      {
        "title": "Union. Biographies 1850–1863",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7SD6-CVQ",
        "citation": ""
      },
      {
        "title": "Henry James Blackner, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/71YK-D3L",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Z1D-BX81 : Sun Sep 13 05:11:44 UTC 2026), Entry for Henry James Blackner and Peter Betts."
      },
      {
        "title": "Henry Blacknar, \"England, Yorkshire, Parish Registers, 1538-2016\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/WD4V-FJQ",
        "citation": "\"England, Yorkshire, Parish Registers, 1538-2016\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:665V-NY8N : Wed Aug 19 19:10:29 UTC 2026), Entry for Henry Blacknar and Richard Blacknar, 25 October 1852."
      },
      {
        "title": "Henry J Blackner, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW48-PVP",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Z1D-BXDR : Sun Sep 13 04:12:15 UTC 2026), Entry for Harriet Susanah Blackner and Henry J Blackner."
      },
      {
        "title": "James Henry Blackner, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW48-BYG",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Q3S-JHZM : Sun Sep 13 04:42:11 UTC 2026), Entry for Orson Blackner and David Williams."
      },
      {
        "title": "James Henry Blackner, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW4D-967",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Z1W-RXVM : Sun Sep 13 05:21:01 UTC 2026), Entry for Orson Blackner and David Williams."
      },
      {
        "title": "James Henry Blackner, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW4D-JHL",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Q3S-JZN2 : Sun Sep 13 05:37:59 UTC 2026), Entry for Joseph Hyrum Blackner and James Henry Blackner."
      },
      {
        "title": "James Henry Blackner, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW4D-24D",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Z1W-RXV6 : Sun Sep 13 05:19:06 UTC 2026), Entry for Harriet Susannah Blackner and James Henry Blackner."
      },
      {
        "title": "Henry J Blackner, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW4D-PFB",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CTZ-21BC : Sun Sep 13 05:14:52 UTC 2026), Entry for Sarah Ann Blackner and Henry J Blackner."
      },
      {
        "title": "James Henry Blackner, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW4D-NQ9",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Z1W-RXJL : Sun Sep 13 05:40:23 UTC 2026), Entry for Mary Jane Blackner and James Henry Blackner."
      },
      {
        "title": "James Henry Blackner, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW4D-G3F",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Q3S-JCT2 : Sun Sep 13 05:44:59 UTC 2026), Entry for Harriet Susannah Blackner and James Henry Blackner."
      },
      {
        "title": "Henry J Blackner, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW48-G5S",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CTZ-21B5 : Sun Sep 13 04:45:30 UTC 2026), Entry for Harriet Susanah Blackner and Henry J Blackner."
      },
      {
        "title": "James Henry Blackner, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW48-Y99",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Q3S-JZW2 : Sun Sep 13 05:08:35 UTC 2026), Entry for Ann Eliza Blackner and James Henry Blackner."
      },
      {
        "title": "James Henry Blackner, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW48-RZ4",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Z1W-RXVN : Sun Sep 13 05:42:15 UTC 2026), Entry for Ann Eliza Blackner and James Henry Blackner."
      },
      {
        "title": "James Henry Blackner, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW4D-6HF",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Q3S-JHPZ : Sun Sep 13 05:47:50 UTC 2026), Entry for Leonard Allen Blackner and David Williams."
      },
      {
        "title": "James Henry Blackner, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW4D-KVC",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Q3S-JCN2 : Sun Sep 13 05:28:26 UTC 2026), Entry for James Edward Blackner and James Henry Blackner."
      },
      {
        "title": "Henry J Blackner, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW4D-RRV",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Z1D-BXDZ : Sun Sep 13 05:35:52 UTC 2026), Entry for Sarah Ann Blackner and Henry J Blackner."
      },
      {
        "title": "James Henry Blackner, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW4D-DL5",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Z1W-RXV4 : Sun Sep 13 05:11:42 UTC 2026), Entry for Sarah Elizabeth Blackner and James Henry Blackner."
      },
      {
        "title": "James Henry Blackner, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW4D-6Y1",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Z1W-RXVQ : Sun Sep 13 05:15:18 UTC 2026), Entry for Leonard Allen Blackner and James Henry Blackner."
      },
      {
        "title": "James Henry Blackner, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW4D-XKH",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Q3S-J4ZM : Sun Sep 13 05:08:33 UTC 2026), Entry for Mary Jane Blackner and James Henry Blackner."
      },
      {
        "title": "James Henry Blackner, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW4D-VJP",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Z1W-RXVZ : Sun Sep 13 05:31:25 UTC 2026), Entry for James Edward Blackner and James Henry Blackner."
      },
      {
        "title": "James Henry Blackner, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW48-YYS",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Z1W-RXJV : Sun Sep 13 05:47:04 UTC 2026), Entry for John Henry Blackner and James Henry Blackner."
      },
      {
        "title": "James Henry Blackner, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW4D-JY3",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Z1W-RXVK : Sun Sep 13 05:11:28 UTC 2026), Entry for Joseph Hyrum Blackner and James Henry Blackner."
      },
      {
        "title": "James Henry Blackner",
        "href": "https://www.familysearch.org/tree/sources/viewedit/353S-MGN",
        "citation": "Church History Individual - James Henry Blackner"
      },
      {
        "title": "Henry J Blackner, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q7R6-DMH",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CTZ-211Q : Sun Sep 13 05:12:42 UTC 2026), Entry for William Thomas Blackner and Henry J Blackner."
      },
      {
        "title": "Henry Blacknar, \"England, Yorkshire, Parish Registers, 1538-2016\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3K3K-Q12",
        "citation": "\"England, Yorkshire, Parish Registers, 1538-2016\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:665K-HSX6 : Wed Aug 19 19:42:14 UTC 2026), Entry for Jane Allen and Leonard Allen, 25 October 1852."
      },
      {
        "title": "James H Blackner, \"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q7R6-ZTQ",
        "citation": "\"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6KWY-BG8S : Sat Jul 04 11:10:54 UTC 2026), Entry for William Thomas Blackner and James H Blackner."
      },
      {
        "title": "Henry James Blackner, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q7YD-1VN",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CTZ-21YB : Sun Sep 13 05:27:39 UTC 2026), Entry for Henry James Blackner and Peter Betts."
      },
      {
        "title": "Henry J Blackner, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW48-NZY",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Z1D-BXDN : Sun Sep 13 05:34:32 UTC 2026), Entry for Leonard Allen Blackner and Henry J Blackner."
      },
      {
        "title": "Henry J Blackner, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW48-GQP",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CTZ-21BL : Sun Sep 13 04:34:29 UTC 2026), Entry for James Edward Blackner and Henry J Blackner."
      },
      {
        "title": "James Henry Blackner, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q7YD-RHL",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Q3S-J72M : Sun Sep 13 05:25:29 UTC 2026), Entry for James Henry Blackner and Peter Betts."
      },
      {
        "title": "Henry J Blackner, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW48-841",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Z1D-BXDG : Sun Sep 13 05:11:12 UTC 2026), Entry for James Edward Blackner and Henry J Blackner."
      },
      {
        "title": "James Henry Blackner, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW48-DY3",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Z1W-RXJF : Sun Sep 13 05:43:59 UTC 2026), Entry for Joseph Blackner and James Henry Blackner."
      },
      {
        "title": "James Henry Blackner, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW48-VWS",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Q3S-JW2M : Sun Sep 13 05:24:34 UTC 2026), Entry for Joseph Blackner and James Henry Blackner."
      },
      {
        "title": "Henry J Blackner, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW48-2QJ",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CTZ-21BV : Sun Sep 13 05:13:18 UTC 2026), Entry for Sarah Elizabeth Blackner and Henry J Blackner."
      },
      {
        "title": "James Henry Blackner, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q7R6-XP1",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Q3S-JZT2 : Sun Sep 13 05:45:07 UTC 2026), Entry for William Thomas Blackner and James Henry Blackner."
      },
      {
        "title": "Henry, \"England, Yorkshire, Parish Registers, 1538-2016\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3K38-FCR",
        "citation": "\"England, Yorkshire, Parish Registers, 1538-2016\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:66BP-K2PL : Wed Aug 19 15:30:43 UTC 2026), Entry for Joseph Blackner and Henry, 20 August 1853."
      },
      {
        "title": "Henry J Blackner, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q7R6-DB5",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Z1D-BX67 : Sun Sep 13 05:09:15 UTC 2026), Entry for William Thomas Blackner and Henry J Blackner."
      },
      {
        "title": "James Henry Blackner, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q7R6-6RZ",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Z1W-RXVG : Sun Sep 13 05:14:34 UTC 2026), Entry for William Thomas Blackner and James Henry Blackner."
      },
      {
        "title": "Henry J Blackner, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW48-V1R",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CTZ-21BY : Sun Sep 13 05:32:41 UTC 2026), Entry for Annie Eliza Blackner and D Grimshaw."
      },
      {
        "title": "Henry J Blackner, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW48-D3L",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CTZ-21BD : Sun Sep 13 04:49:20 UTC 2026), Entry for Emily Blackner and Henry J Blackner."
      },
      {
        "title": "Henry J Blackner, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW48-JZQ",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CTZ-21BF : Sun Sep 13 05:33:04 UTC 2026), Entry for Leonard Allen Blackner and Henry J Blackner."
      },
      {
        "title": "James Henry Blackner, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW48-L4W",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Z1W-RXJY : Sun Sep 13 05:26:00 UTC 2026), Entry for Emile Blackner and James Henry Blackner."
      },
      {
        "title": "1851 England and Wales Census",
        "href": "https://www.familysearch.org/tree/sources/viewedit/36R8-JDZ",
        "citation": "Ancestry"
      },
      {
        "title": "Legacy NFS Source: James Henry Blackner - birth: 25 March 1832; Hucknall Torkard, Nottinghamshire, England, United Kingdom",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MS6D-D59",
        "citation": "International Genealogical Index, The Church of Jesus Christ of Latter-day Saints, Family History Library, 35 N. West Temple Street, Salt Lake City, Utah 84150, USA, www.familysearch.org"
      },
      {
        "title": "Henry Blackner, \"United States, Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M975-SV5",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MNSN-5KX : Wed Sep 09 15:08:29 UTC 2026), Entry for Henry Blackner and Jane Blackner, 1880."
      },
      {
        "title": "John Henry Blackner, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MS27-V8Y",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZGC-7Q7 : Mon Feb 03 19:08:50 UTC 2025), Entry for Elizabeth Dobson and John Henry Blackner, 07 Feb 1914."
      },
      {
        "title": "Henry Blackner, \"United States, Census, 1870\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M975-3P9",
        "citation": "\"United States, Census, 1870\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MNCR-49Z : Tue Oct 14 18:34:47 UTC 2025), Entry for Henry Blackner and Jane Blackner, 1870."
      },
      {
        "title": "James Henry Blackner, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M975-QBD",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZGT-PJQ : Mon Feb 03 19:13:52 UTC 2025), Entry for Sarah Elizabeth Snow and James Henry Blackner, 19 Dec 1931."
      },
      {
        "title": "Henry Blackner, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M975-7CQ",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZPK-NKS : Mon Feb 03 19:02:28 UTC 2025), Entry for Mary Jane Taylor and Henry Blackner, 28 Dec 1905."
      },
      {
        "title": "Blackner, \"Utah, Salt Lake County Death Records, 1849-1949\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZF7-QNM",
        "citation": "\"Utah, Salt Lake County Death Records, 1849-1949\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:NQ4T-H7X : Sat Mar 09 03:29:23 UTC 2024), Entry for Nellie Ellison and Blackner, 23 Dec 1927."
      },
      {
        "title": "Henry Blackner, \"Utah, Obituaries from Utah Newspapers, 1850-2005\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/968Q-32K",
        "citation": "\"Utah, Obituaries from Utah Newspapers, 1850-2005\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSF-2CSZ : Tue Mar 11 15:36:04 UTC 2025), Entry for Mrs Sarah Snow and Raymond Hodges, 24 Dec 1931."
      },
      {
        "title": "Blackner in entry for Nellie Ellison, \"Utah, Deaths and Burials, 1888-1946\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9BFY-5R8",
        "citation": "\"Utah, Deaths and Burials, 1888-1946\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:F85S-4BY : 28 January 2020), Blackner in entry for Nellie Ellison, 1927."
      },
      {
        "title": "Henry Blackney in entry for Joseph Blackney, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MQV2-JGD",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:NPGP-RG8 : 4 February 2023), Henry Blackney in entry for Joseph Blackney, 1853."
      },
      {
        "title": "James Henry Blackner, \"Find A Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9KK6-C18",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVVH-6PLL : Thu Oct 01 18:14:03 UTC 2026), Entry for James Henry Blackner."
      },
      {
        "title": "Henry Blackner, \"United States, Census, 1900\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M975-3KW",
        "citation": "\"United States, Census, 1900\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MMRN-FLJ : Wed Oct 15 14:28:15 UTC 2025), Entry for Henry Blackner and Jane Blackner, 1900."
      },
      {
        "title": "James Henry Blackner, \"Utah Mormon Pioneer Overland Travel Database, 1847-1868\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9GK2-YM1",
        "citation": "\"Utah, Mormon Pioneer Overland Travel Database, 1847-1868\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QK9B-C5JD : Wed Feb 19 20:42:46 UTC 2025), Entry for James Henry Blackner, 01 Sep 1860."
      },
      {
        "title": "Henry Blackner, \"United States Index to Indian Wars Pension Files, 1892-1926\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M975-7SD",
        "citation": "\"United States, Index to Indian Wars Pension Files, 1892-1926\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KDRT-H38 : Sat Mar 09 21:14:54 UTC 2024), Entry for Henry Blackner and Jane Blackner, 1902."
      },
      {
        "title": "James Henry Blackner, \"BillionGraves Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9T64-T9J",
        "citation": "\"BillionGraves Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KD9H-6SH : Thu Sep 24 19:32:58 UTC 2026), Entry for James Henry Blackner."
      },
      {
        "title": "James Henry Blackner, \"BillionGraves Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9KK6-ZH2",
        "citation": "\"BillionGraves Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QKDP-QNSR : Thu Sep 24 20:13:46 UTC 2026), Entry for James Henry Blackner."
      },
      {
        "title": "Henry Blackner, \"Utah, Salt Lake County Death Records, 1849-1949\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/982Q-PDP",
        "citation": "\"Utah, Salt Lake County Death Records, 1849-1949\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:NQ4L-6TL : Sun Mar 10 14:19:51 UTC 2024), Entry for Leonard Allen Blackner and Henry Blackner, 15 Jan 1935."
      },
      {
        "title": "Henry Blackner, \"Utah, Salt Lake County Death Records, 1849-1949\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/982Q-R2L",
        "citation": "\"Utah, Salt Lake County Death Records, 1849-1949\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:NQ4P-3JR : Sun Mar 10 21:40:42 UTC 2024), Entry for Leonard Allen Blackner and Henry Blackner, 15 Jan 1935."
      },
      {
        "title": "Henery Blacknor, \"England and Wales, Census, 1841\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SDSL-CSL",
        "citation": "\"England and Wales, Census, 1841\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M7SH-TK6 : Tue Sep 08 21:35:38 UTC 2026), Entry for John Butler and Elizabeth Butler, 1841."
      },
      {
        "title": "Blackner, \"California, Death Index, 1940-1997\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SWTX-M6Q",
        "citation": "\"California, Death Index, 1940-1997\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VP7Q-2C2 : Tue Feb 25 17:43:21 UTC 2025), Entry for William Thomas Blackner and Blackner, 08 May 1950."
      },
      {
        "title": "Henry Blackner in entry for Leonard Allen Blackner, \"Utah, Deaths and Burials, 1888-1946\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M975-QX3",
        "citation": "\"Utah, Deaths and Burials, 1888-1946\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:F85K-YQN : 28 January 2020), Henry Blackner in entry for Leonard Allen Blackner, ."
      },
      {
        "title": "James Henry Blackner, \"California, County Birth and Death Records, 1800-1994\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SQ81-5VW",
        "citation": "\"California, County Birth and Death Records, 1800-1994\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QP34-166C : Tue Feb 18 20:20:22 UTC 2025), Entry for William Thomas Blackner and James Henry Blackner, 8 May 1950."
      },
      {
        "title": "Henry Blackner, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/982Q-GTM",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZPQ-L7K : Mon Feb 03 19:16:46 UTC 2025), Entry for Leonard Allen Blackner and Henry Blackner, 15 Jan 1935."
      },
      {
        "title": "Henry William Blackner, \"Utah, Salt Lake County Death Records, 1849-1949\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MS27-156",
        "citation": "\"Utah, Salt Lake County Death Records, 1849-1949\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:NQ4H-P7W : Fri Dec 12 18:16:11 UTC 2025), Entry for Catherine Ann Blackner English and Henry William Blackner, 01 Mar 1948."
      },
      {
        "title": "Henry William Blackner, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/96VB-2RV",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZL8-59Q : Mon Feb 03 19:01:05 UTC 2025), Entry for Catherine Ann Blackner English and Henry William Blackner, 01 Mar 1948."
      },
      {
        "title": "Henry William Blackner in entry for Catherine Ann Blackner English, \"Utah, Deaths and Burials, 1888-1946\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MS27-18S",
        "citation": "\"Utah, Deaths and Burials, 1888-1946\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:F855-MXS : 28 January 2020), Henry William Blackner in entry for Catherine Ann Blackner English, 1948."
      },
      {
        "title": "James Henry Blackner, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M975-7RQ",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZPH-QDG : Mon Feb 03 19:19:52 UTC 2025), Entry for Orson Blackner and James Henry Blackner, 22 May 1941."
      }
    ],
    "portrait": "/ancestors/portraits/088_KWJ6-WMV.jpg"
  },
  {
    "id": "I457",
    "name": "Jane Allen",
    "sex": "F",
    "gen": 6,
    "slot": 25,
    "side": "paternal",
    "birthplace": "england",
    "childId": "I229",
    "birthYear": 1833,
    "deathYear": 1915,
    "birthDate": "9 Nov 1833",
    "deathDate": "16 Sep 1915",
    "burialDate": "18 Sep 1915",
    "christeningDate": "5 Jan 1834",
    "birthPlace": "Masbrough, Yorkshire, England, United Kingdom",
    "deathPlace": "Greenville, Beaver, Utah, United States",
    "burialPlace": "Beaver, Beaver, Utah, United States",
    "christeningPlace": "Rotherham, Yorkshire, England, United Kingdom",
    "fsId": "KWJ6-WMJ",
    "photo": "/ancestors/bubbles/089_KWJ6-WMJ.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [
      {
        "kind": "Residence",
        "date": "1841",
        "place": "Rawmarsh, Yorkshire, England, United Kingdom",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "25 October 1852",
        "place": "Attercliffe, Yorkshire, England, United Kingdom",
        "note": null
      },
      {
        "kind": "Baptism",
        "date": "20 February 1857",
        "place": null,
        "note": null
      },
      {
        "kind": "Baptism",
        "date": "24 February 1857",
        "place": null,
        "note": null
      },
      {
        "kind": "Baptism",
        "date": "20 October 1857",
        "place": null,
        "note": null
      },
      {
        "kind": "Immigration",
        "date": "1860",
        "place": "Liverpool, Lancashire, England, United Kingdom",
        "note": "Departed 15 March on vessel \"Emilie\""
      },
      {
        "kind": "Pioneer",
        "date": "1 September 1860",
        "place": null,
        "note": "John Smith Company Wagon Train"
      },
      {
        "kind": "Census",
        "date": "19 July 1870",
        "place": "Greenville, Beaver, Utah, United States",
        "note": null
      },
      {
        "kind": "Census",
        "date": "5 June 1880",
        "place": "Beaver, Beaver, Utah, United States",
        "note": null
      },
      {
        "kind": "Census",
        "date": "12 June 1900",
        "place": "Beaver, Beaver, Utah, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1900",
        "place": "Beaver, Beaver, Utah, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1910",
        "place": "Beaver, Utah, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": null,
        "place": "Rotherham, Yorkshire, England, United Kingdom",
        "note": null
      },
      {
        "kind": "Residence",
        "date": null,
        "place": "Attercliffe",
        "note": null
      },
      {
        "kind": "Membership",
        "date": null,
        "place": "Salt Lake, Utah, United States",
        "note": null
      },
      {
        "kind": "Membership",
        "date": null,
        "place": "Utah, United States",
        "note": null
      },
      {
        "kind": "Membership",
        "date": null,
        "place": "Beaver, Utah, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Union. Biographies 1850–1863",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7SD6-CVQ",
        "citation": ""
      },
      {
        "title": "Jane Allen, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QJ5J-L2L",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Q3S-JHMM : Sun Sep 13 05:39:38 UTC 2026), Entry for Emile Blackner and James Henry Blackner."
      },
      {
        "title": "Jane Allen Blackner, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7FGC-H6V",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Z1W-RXJ8 : Sun Sep 13 05:44:22 UTC 2026), Entry for Jane Allen Blackner and Peter Betts."
      },
      {
        "title": "Jane Allen, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QJ5J-KW9",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Q3S-JHZM : Sun Sep 13 04:42:11 UTC 2026), Entry for Orson Blackner and David Williams."
      },
      {
        "title": "Jane Allen, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QJ5J-XXR",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Z1D-BX67 : Sun Sep 13 05:09:15 UTC 2026), Entry for William Thomas Blackner and Henry J Blackner."
      },
      {
        "title": "Mary J Allen, \"Utah, Salt Lake County Death Records, 1849-1949\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QJ5J-JPY",
        "citation": "\"Utah, Salt Lake County Death Records, 1849-1949\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:NQ4P-3JR : Sun Mar 10 21:40:42 UTC 2024), Entry for Leonard Allen Blackner and Henry Blackner, 15 Jan 1935."
      },
      {
        "title": "Jane Allen, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QJ5J-VJK",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Q3S-JHPZ : Sun Sep 13 05:47:50 UTC 2026), Entry for Leonard Allen Blackner and David Williams."
      },
      {
        "title": "Jane Allen, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QJ5V-4W4",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Q3S-J42M : Sun Sep 13 05:29:07 UTC 2026), Entry for Sarah Ann Blackner and James Henry Blackner."
      },
      {
        "title": "Jane Allen, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7SH2-M3Y",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CTZ-21BS : Sun Sep 13 05:27:47 UTC 2026), Entry for Jane Allen and Peter Betts."
      },
      {
        "title": "Jane, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7NVF-3K5",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:X3MG-TT7P : Sat Sep 12 23:42:45 UTC 2026), Entry for Sarah B Snow and Henry Blackner."
      },
      {
        "title": "Jane Allen, \"England, Yorkshire, Parish Registers, 1538-2016\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QJ5V-792",
        "citation": "\"England, Yorkshire, Parish Registers, 1538-2016\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:665K-HSX6 : Wed Aug 19 19:42:14 UTC 2026), Entry for Jane Allen and Leonard Allen, 25 October 1852."
      },
      {
        "title": "Jane Allen, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7Q9J-JGH",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Z1D-BXDZ : Sun Sep 13 05:35:52 UTC 2026), Entry for Sarah Ann Blackner and Henry J Blackner."
      },
      {
        "title": "Jane Allen, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QJ5J-NN6",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Z1W-RXJV : Sun Sep 13 05:47:04 UTC 2026), Entry for John Henry Blackner and James Henry Blackner."
      },
      {
        "title": "Jane Blackner, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q2FP-S51",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6KRQ-499R : Sat Sep 12 23:40:16 UTC 2026), Entry for Jane Blackner and Peter Betts."
      },
      {
        "title": "Jane Blackner, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q2FP-SSH",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6KR9-C919 : Sat Sep 12 23:38:10 UTC 2026), Entry for Jane Blackner and Peter Betts."
      },
      {
        "title": "Jane Allen, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/76GQ-3M1",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CTZ-21BD : Sun Sep 13 04:49:20 UTC 2026), Entry for Emily Blackner and Henry J Blackner."
      },
      {
        "title": "Jane Allen, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/76GQ-WLL",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CTZ-21BC : Sun Sep 13 05:14:52 UTC 2026), Entry for Sarah Ann Blackner and Henry J Blackner."
      },
      {
        "title": "Jane Allen, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QJ5J-2R2",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Z1D-BXDN : Sun Sep 13 05:34:32 UTC 2026), Entry for Leonard Allen Blackner and Henry J Blackner."
      },
      {
        "title": "Jane Allen, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QJ5V-QZ5",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:N5J6-BYW : 4 February 2023), Jane Allen, 1834."
      },
      {
        "title": "Jane Allen, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QJ5V-W8H",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Z1D-BXD4 : Sun Sep 13 05:34:51 UTC 2026), Entry for Joseph Blackner and Henry J Blackner."
      },
      {
        "title": "Jane Allen, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW46-M7G",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Q3S-JCW2 : Sun Sep 13 05:29:05 UTC 2026), Entry for Sarah Elizabeth Blackner and James Henry Blackner."
      },
      {
        "title": "Jane Allen, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW46-WXM",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CTZ-21BW : Sun Sep 13 05:35:58 UTC 2026), Entry for Joseph Blackner and Henry J Blackner."
      },
      {
        "title": "Jane Allen, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QJ5J-QG3",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Z1W-RXVK : Sun Sep 13 05:11:28 UTC 2026), Entry for Joseph Hyrum Blackner and James Henry Blackner."
      },
      {
        "title": "Jane Allen, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW46-33P",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Q3S-J4MM : Sun Sep 13 05:11:51 UTC 2026), Entry for John Henry Blackner and James Henry Blackner."
      },
      {
        "title": "Jane Allen, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QJ5J-S6Y",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Z1W-RXV6 : Sun Sep 13 05:19:06 UTC 2026), Entry for Harriet Susannah Blackner and James Henry Blackner."
      },
      {
        "title": "Jane Allen, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QJ5J-4JL",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Z1W-RXVN : Sun Sep 13 05:42:15 UTC 2026), Entry for Ann Eliza Blackner and James Henry Blackner."
      },
      {
        "title": "Jane Allen, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QJ5J-4RC",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Z1W-RXVZ : Sun Sep 13 05:31:25 UTC 2026), Entry for James Edward Blackner and James Henry Blackner."
      },
      {
        "title": "Jane Allen, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QJ5J-CB4",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Z1W-RXV4 : Sun Sep 13 05:11:42 UTC 2026), Entry for Sarah Elizabeth Blackner and James Henry Blackner."
      },
      {
        "title": "Jane Allen, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q6BW-S6T",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Z1D-BXD3 : Sun Sep 13 05:17:46 UTC 2026), Entry for Jane Allen and Peter Betts."
      },
      {
        "title": "Jane Allen, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QJ5J-HST",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Z1W-RXVG : Sun Sep 13 05:14:34 UTC 2026), Entry for William Thomas Blackner and James Henry Blackner."
      },
      {
        "title": "Jane Allen, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QJ5J-7R2",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Z1D-BX6S : Sun Sep 13 05:38:37 UTC 2026), Entry for Joseph Hyrum Blackner and Henry J Blackner."
      },
      {
        "title": "Jane Allen, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QJ5J-7V5",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CTZ-2119 : Sun Sep 13 05:12:53 UTC 2026), Entry for Joseph Hyrum Blackner and Henry J Blackner."
      },
      {
        "title": "Jane Allen, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QJ5J-8WG",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CTZ-211Q : Sun Sep 13 05:12:42 UTC 2026), Entry for William Thomas Blackner and Henry J Blackner."
      },
      {
        "title": "Jane Allen, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QJ5J-91T",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CTZ-21B5 : Sun Sep 13 04:45:30 UTC 2026), Entry for Harriet Susanah Blackner and Henry J Blackner."
      },
      {
        "title": "Jane Allen, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW4D-THL",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Z1W-RXJ5 : Sun Sep 13 05:45:56 UTC 2026), Entry for Sarah Ann Blackner and James Henry Blackner."
      },
      {
        "title": "Jane Allen, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QJ5J-WX6",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Z1D-BXDG : Sun Sep 13 05:11:12 UTC 2026), Entry for James Edward Blackner and Henry J Blackner."
      },
      {
        "title": "Jane Allen, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QJ5J-DZ4",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Z1D-BXDK : Sun Sep 13 05:29:09 UTC 2026), Entry for Sarah Elizabeth Blackner and Henry J Blackner."
      },
      {
        "title": "Jane Allen, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QJ5J-XWC",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Q3S-J4ZM : Sun Sep 13 05:08:33 UTC 2026), Entry for Mary Jane Blackner and James Henry Blackner."
      },
      {
        "title": "Jane Allen, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW46-QR4",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Z1D-BXDB : Sun Sep 13 05:14:18 UTC 2026), Entry for Annie Eliza Blackner and D Grimshaw."
      },
      {
        "title": "Jane Allen Blackner, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QJG3-11M",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Q3S-JWW2 : Sun Sep 13 05:37:34 UTC 2026), Entry for Jane Allen Blackner and Peter Betts."
      },
      {
        "title": "Jane Allen, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW4D-K6W",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Q3S-JCN2 : Sun Sep 13 05:28:26 UTC 2026), Entry for James Edward Blackner and James Henry Blackner."
      },
      {
        "title": "Jane Allen, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW48-N1R",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CTZ-21BF : Sun Sep 13 05:33:04 UTC 2026), Entry for Leonard Allen Blackner and Henry J Blackner."
      },
      {
        "title": "Jane Allen, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW48-LRY",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CTZ-21BL : Sun Sep 13 04:34:29 UTC 2026), Entry for James Edward Blackner and Henry J Blackner."
      },
      {
        "title": "Jane Allen, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW48-P65",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Z1D-BXDR : Sun Sep 13 04:12:15 UTC 2026), Entry for Harriet Susanah Blackner and Henry J Blackner."
      },
      {
        "title": "Jane Allen, \"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q7R6-8MS",
        "citation": "\"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6KWY-BG8S : Sat Jul 04 11:10:54 UTC 2026), Entry for William Thomas Blackner and James H Blackner."
      },
      {
        "title": "Jane Allen, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW48-D29",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Z1W-RXJF : Sun Sep 13 05:43:59 UTC 2026), Entry for Joseph Blackner and James Henry Blackner."
      },
      {
        "title": "Jane Allen, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW48-VMR",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Q3S-JW2M : Sun Sep 13 05:24:34 UTC 2026), Entry for Joseph Blackner and James Henry Blackner."
      },
      {
        "title": "Jane Allen, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW4D-6PD",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Z1W-RXVQ : Sun Sep 13 05:15:18 UTC 2026), Entry for Leonard Allen Blackner and James Henry Blackner."
      },
      {
        "title": "Jane Allen, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW4D-F18",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Z1W-RXJL : Sun Sep 13 05:40:23 UTC 2026), Entry for Mary Jane Blackner and James Henry Blackner."
      },
      {
        "title": "Jane Allen, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QWMP-4HB",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Z1D-BXD6 : Sun Sep 13 05:16:09 UTC 2026), Entry for Emily Blackner and Henry J Blackner."
      },
      {
        "title": "Jane Allen, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW48-VP8",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CTZ-21BY : Sun Sep 13 05:32:41 UTC 2026), Entry for Annie Eliza Blackner and D Grimshaw."
      },
      {
        "title": "Jane Allen, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW48-K58",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CTZ-21BV : Sun Sep 13 05:13:18 UTC 2026), Entry for Sarah Elizabeth Blackner and Henry J Blackner."
      },
      {
        "title": "Jane Allen, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW48-LMC",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Z1W-RXJY : Sun Sep 13 05:26:00 UTC 2026), Entry for Emile Blackner and James Henry Blackner."
      },
      {
        "title": "Jane Allen, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW4D-JQW",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Q3S-JZN2 : Sun Sep 13 05:37:59 UTC 2026), Entry for Joseph Hyrum Blackner and James Henry Blackner."
      },
      {
        "title": "Jane Allen, \"England, Yorkshire, Parish Registers, 1538-2016\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3K36-SN4",
        "citation": "\"England, Yorkshire, Parish Registers, 1538-2016\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:665V-NY8N : Wed Aug 19 19:10:29 UTC 2026), Entry for Henry Blacknar and Richard Blacknar, 25 October 1852."
      },
      {
        "title": "Jane Allen, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q7R6-FMP",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Q3S-JZT2 : Sun Sep 13 05:45:07 UTC 2026), Entry for William Thomas Blackner and James Henry Blackner."
      },
      {
        "title": "Jane Allen, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW48-TRV",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Q3S-JZW2 : Sun Sep 13 05:08:35 UTC 2026), Entry for Ann Eliza Blackner and James Henry Blackner."
      },
      {
        "title": "Jane, \"England, Yorkshire, Parish Registers, 1538-2016\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3K38-FSF",
        "citation": "\"England, Yorkshire, Parish Registers, 1538-2016\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:66BP-K2PL : Wed Aug 19 15:30:43 UTC 2026), Entry for Joseph Blackner and Henry, 20 August 1853."
      },
      {
        "title": "Jane Allen, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW4D-92N",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Z1W-RXVM : Sun Sep 13 05:21:01 UTC 2026), Entry for Orson Blackner and David Williams."
      },
      {
        "title": "Jane Allen, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW4D-LYW",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Q3S-JCT2 : Sun Sep 13 05:44:59 UTC 2026), Entry for Harriet Susannah Blackner and James Henry Blackner."
      },
      {
        "title": "Jane Allen Blackner - Pioneer Overland Travel",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SDYK-2XM",
        "citation": ""
      },
      {
        "title": "Headstone image of Jane Allen Blackner from billiongraves.com",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SDKM-XBP",
        "citation": "Transcription of headstone image from billiongraves.com. Image taken at Mountain View Cemetery (Beaver, Beaver, Utah, United States) on 11 August 2015"
      },
      {
        "title": "Mary J. Allen in entry for Leonard Allen Blackner, \"Utah, Deaths and Burials, 1888-1946\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M975-QXK",
        "citation": "\"Utah, Deaths and Burials, 1888-1946\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:F85K-YQJ : 28 January 2020), Mary J. Allen in entry for Leonard Allen Blackner, ."
      },
      {
        "title": "Jane Allen, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M975-QBJ",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZGT-PJQ : Mon Feb 03 19:13:52 UTC 2025), Entry for Sarah Elizabeth Snow and James Henry Blackner, 19 Dec 1931."
      },
      {
        "title": "Jane Allen Blackner, \"Utah Death Certificates, 1904-1956\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M975-428",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZGZ-DWG : Mon Feb 03 19:10:35 UTC 2025), Entry for Jane Allen Blackner and Leonard Allen, 16 Sep 1915."
      },
      {
        "title": "Jane Allen Blackner, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/98DZ-1X6",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVVH-6PL2 : Sat Oct 03 15:05:36 UTC 2026), Entry for Jane Allen Blackner."
      },
      {
        "title": "Allen, \"California, Death Index, 1940-1997\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SWTX-MZN",
        "citation": "\"California, Death Index, 1940-1997\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VP7Q-2C2 : Tue Feb 25 17:43:21 UTC 2025), Entry for William Thomas Blackner and Blackner, 08 May 1950."
      },
      {
        "title": "Jane Blackner, \"United States, Index to Indian Wars Pension Files, 1892-1926\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3VXB-C8M",
        "citation": "\"United States, Index to Indian Wars Pension Files, 1892-1926\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KDRT-H38 : Sat Mar 09 21:14:54 UTC 2024), Entry for Henry Blackner and Jane Blackner, 1902."
      },
      {
        "title": "Jane Allen, \"California, County Birth and Death Records, 1800-1994\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SQ81-52M",
        "citation": "\"California, County Birth and Death Records, 1800-1994\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QP34-166C : Tue Feb 18 20:20:22 UTC 2025), Entry for William Thomas Blackner and James Henry Blackner, 8 May 1950."
      },
      {
        "title": "Jane Allen, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M975-7Z9",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZPK-NKS : Mon Feb 03 19:02:28 UTC 2025), Entry for Mary Jane Taylor and Henry Blackner, 28 Dec 1905."
      },
      {
        "title": "Jane Allen, \"England and Wales, Census, 1841\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSB8-FJT",
        "citation": "\"England and Wales, Census, 1841\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MQPP-X1B : Tue Sep 08 21:40:43 UTC 2026), Entry for Lenard Allen and Mary Allen, 1841."
      },
      {
        "title": "Jane Allen Blackner, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9888-FMV",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZPH-QDG : Mon Feb 03 19:19:52 UTC 2025), Entry for Orson Blackner and James Henry Blackner, 22 May 1941."
      },
      {
        "title": "Jane Allen Blackner, \"BillionGraves Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/968Q-9K1",
        "citation": "\"BillionGraves Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QKDP-QNST : Thu Sep 24 23:28:41 UTC 2026), Entry for Jane Allen Blackner."
      },
      {
        "title": "Jane Allen Blackner, \"Utah, Obituaries from Utah Newspapers, 1850-2005\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/968Q-3HV",
        "citation": "\"Utah, Obituaries from Utah Newspapers, 1850-2005\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSF-2CSZ : Tue Mar 11 15:36:04 UTC 2025), Entry for Mrs Sarah Snow and Raymond Hodges, 24 Dec 1931."
      },
      {
        "title": "Jane Blackner, \"United States, Census, 1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M975-W9Y",
        "citation": "\"United States, Census, 1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XMY1-219 : Wed Aug 13 17:30:34 UTC 2025), Entry for William T Blackner and Minnie L Blackner, 1910."
      },
      {
        "title": "Jane Allin, \"England and Wales Census, 1841\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSB8-NQ6",
        "citation": "\"England and Wales, Census, 1841\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MQPP-LCR : Tue Sep 08 21:42:30 UTC 2026), Entry for Mary Ashton and John Ashton, 1841."
      },
      {
        "title": "Jane Allen Blackner, \"Utah, Mormon Pioneer Overland Travel Database, 1847-1868\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9DFY-L21",
        "citation": "\"Utah, Mormon Pioneer Overland Travel Database, 1847-1868\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QK9B-C5J6 : Wed Feb 19 20:20:56 UTC 2025), Entry for Jane Allen Blackner, 01 Sep 1860."
      },
      {
        "title": "Jane in entry for Joseph Blackney, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MQV2-JGN",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:NPGP-RGD : 4 February 2023), Jane in entry for Joseph Blackney, 1853."
      },
      {
        "title": "Mary J Allen, \"Utah, Salt Lake County Death Records, 1849-1949\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/982Q-PX8",
        "citation": "\"Utah, Salt Lake County Death Records, 1849-1949\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:NQ4L-6TL : Sun Mar 10 14:19:51 UTC 2024), Entry for Leonard Allen Blackner and Henry Blackner, 15 Jan 1935."
      },
      {
        "title": "Mary J. Allen, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/982Q-GY5",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZPQ-L7K : Mon Feb 03 19:16:46 UTC 2025), Entry for Leonard Allen Blackner and Henry Blackner, 15 Jan 1935."
      },
      {
        "title": "Jane Blackner, \"United States, Census, 1870\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M975-3PD",
        "citation": "\"United States, Census, 1870\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MNCR-49Z : Tue Oct 14 18:34:47 UTC 2025), Entry for Henry Blackner and Jane Blackner, 1870."
      },
      {
        "title": "Jane Blackner, \"United States, Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M975-SK3",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MNSN-5KX : Wed Sep 09 15:08:29 UTC 2026), Entry for Henry Blackner and Jane Blackner, 1880."
      },
      {
        "title": "Jane Blackner, \"United States, Census, 1900\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M975-32M",
        "citation": "\"United States, Census, 1900\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MMRN-FLJ : Wed Oct 15 14:28:15 UTC 2025), Entry for Henry Blackner and Jane Blackner, 1900."
      }
    ],
    "portrait": "/ancestors/portraits/089_KWJ6-WMJ.jpg"
  },
  {
    "id": "I228",
    "name": "Hannah Elizabeth Eyre",
    "sex": "F",
    "gen": 5,
    "slot": 13,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "I90",
    "birthYear": 1862,
    "deathYear": 1934,
    "birthDate": "25 Jan 1862",
    "deathDate": "10 Feb 1934",
    "burialDate": "13 Feb 1934",
    "christeningDate": null,
    "birthPlace": "Minersville, Beaver, Utah Territory, United States",
    "deathPlace": "Lyman, Uinta, Wyoming, United States",
    "burialPlace": "Lyman, Uinta, Wyoming, USA",
    "christeningPlace": null,
    "fsId": "KWC1-J6N",
    "photo": "/ancestors/bubbles/045_KWC1-J6N.jpg",
    "living": false,
    "alternateNames": [
      "Hannah Elizabeth Blackner",
      "Hanner Eyre"
    ],
    "facts": [
      {
        "kind": "Occupation",
        "date": null,
        "place": null,
        "note": "Assisting House"
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Hannah Elizabeth Blackner (born Eyre), 'Geni World Family Tree' on MyHeritage",
        "href": "https://www.familysearch.org/tree/sources/viewedit/W69Y-9Y4",
        "citation": "Geni World Family Tree MyHeritage.com [online database], MyHeritage Ltd. Hannah Elizabeth Blackner (born Eyre)"
      },
      {
        "title": "Eyre, \"California, Death Index, 1940-1997\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SV2K-HVR",
        "citation": "\"California, Death Index, 1940-1997\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VPZ3-DL7 : Tue Feb 25 18:29:45 UTC 2025), Entry for Tressa J Durrant and Eyre, 10 Aug 1968."
      },
      {
        "title": "Hannah Eyre, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7QXF-H3V",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6PD8-SDT7 : Fri Mar 27 03:30:52 UTC 2026), Entry for Druesilla Blackner and John H."
      },
      {
        "title": "Hannah E Blackner, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/983V-L1X",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVVP-YPV8 : Sat Oct 03 13:17:51 UTC 2026), Entry for Hannah E Blackner."
      },
      {
        "title": "Hannah E Blackner, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QWM8-XZZ",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CTH-TWYN : Sun Sep 13 05:22:10 UTC 2026), Entry for George Henry Blackner and F D Farnsworth."
      },
      {
        "title": "Hannah Blackner, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW46-66J",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CYP-1TKR : Sun Sep 13 05:15:33 UTC 2026), Entry for Blanche Blackner and John H. Blackner."
      },
      {
        "title": "Hannah H Eyre, \"Utah, County Marriages, 1871-1941\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/983V-K3F",
        "citation": "\"Utah, County Marriages, 1871-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VRLZ-141 : Thu Sep 19 18:58:12 UTC 2024), Entry for Jennings Bernard Blackner and J H Blackner, 23 Jul 1921."
      },
      {
        "title": "Hannah Eyre, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7PH7-VDQ",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6PD8-SDBP : Thu Mar 26 19:33:22 UTC 2026), Entry for Drusilla Blackner and John H."
      },
      {
        "title": "Hannah Elizabeth Eyre, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SYTM-3Q8",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Z1VK-4B2M : Sun Mar 10 21:34:49 UTC 2024), Entry for Leonard Ray Blackner and John Henry Blackner, 21 Aug 1965."
      },
      {
        "title": "Hannah Elizabeth Eyre Blackner, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3SF4-K1B",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:ZY6Q-7LMM : Sun Mar 29 22:32:07 UTC 2026), Entry for Hannah Elizabeth Eyre Blackner, 1930."
      },
      {
        "title": "Hannah Eyre, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QVBS-46G",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6ZX8-YWTG : Sun Sep 13 05:48:29 UTC 2026), Entry for Lottie Rebecca Blackner and C M Larson."
      },
      {
        "title": "Hannah Elizabeth Eyre, \"The Church of Jesus Christ of Latter-day Saints, Missionary Registers (Worldwide), 1860-1937\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q5DT-4LF",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Missionary Registers (Worldwide), 1860-1937\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6LRD-7TTR : Tue Apr 29 04:59:26 UTC 2025), Entry for Geo. Henry Blackner and Franklin D. Farnsworth, 3 Mar 1941."
      },
      {
        "title": "Hannah Eyre, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7PHW-M5S",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6PNX-1LXG : Sun Sep 13 05:25:44 UTC 2026), Entry for Benard Blackner and C M Larson."
      },
      {
        "title": "Hannah Eyre, \"Utah, County Marriages, 1871-1941\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9F9N-7Q5",
        "citation": "\"Utah, County Marriages, 1871-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2MB-7VF9 : Thu Sep 19 19:25:08 UTC 2024), Entry for George Henry Blackner and John H, 15 Dec 1937."
      },
      {
        "title": "Hannah E Blackner, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW46-DCR",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CTH-TWY5 : Sun Sep 13 05:30:28 UTC 2026), Entry for Rueben E Blackner and F D Farnsworth."
      },
      {
        "title": "Hannah E Blackner, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QJY3-2NB",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CY2-8C9D : Sun Sep 13 05:21:22 UTC 2026), Entry for Arnold Eyre and John H."
      },
      {
        "title": "Hannah E Blackner, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW46-X3K",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CTH-TWY2 : Sun Sep 13 05:50:52 UTC 2026), Entry for Leonard Ray Blackner and F D Farnsworth."
      },
      {
        "title": "Hannah Eyre, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7QXF-ZZJ",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6PNX-1LF8 : Sat Sep 12 23:53:15 UTC 2026), Entry for Lottie Rebecca Blackner and C M Larson."
      },
      {
        "title": "Hannah E Eyre, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW46-XPX",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6ZXS-91GN : Sat Sep 12 23:41:51 UTC 2026), Entry for Owen Grant Blackner and John W Field."
      },
      {
        "title": "Hannah E Eyre, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7QXF-CLR",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:62XB-NQXN : Fri Mar 27 01:02:21 UTC 2026), Entry for Owen Grant Blackner and John W Field."
      },
      {
        "title": "Legacy NFS Source: Hannah Elizabeth Eyre -",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MS6Y-BBD",
        "citation": "Ancestral File (R), The Church of Jesus Christ of Latter-day Saints, Copyright (c) 1987, June 1998, data as of 5 January 1998, Family History Library, 35 N West Temple Street, Salt Lake City, Utah 84150 USA"
      },
      {
        "title": "Hannah G Eyre in household of George Eyre, \"United States Census, 1870\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MM3R-WNX",
        "citation": "\"United States, Census, 1870\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MNCR-HFB : Sat Oct 18 14:17:47 UTC 2025), Entry for George Eyre and Rebecca Eyre, 1870."
      },
      {
        "title": "Hanna C Blackner in household of J H Blackner, \"United States Census, 1920\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMHX-QLF",
        "citation": "\"United States, Census, 1920\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MNB5-P9H : Tue Sep 29 13:39:01 UTC 2026), Entry for J H Blackner and Hanna C Blackner, 1920."
      },
      {
        "title": "Hannah E. Eyre, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/983V-JTP",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZPL-W32 : Mon Feb 03 19:15:58 UTC 2025), Entry for Owen Grant Blackner and John H. Blackner, 15 Apr 1934."
      },
      {
        "title": "Hannah H. Eyre in entry for Jennings Bernard Blackner, \"Utah, Marriages, 1887-1935\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/983V-VRZ",
        "citation": "\"Utah, Marriages, 1887-1935\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:F8GK-83M : 28 January 2020), Hannah H. Eyre in entry for Jennings Bernard Blackner, 1921."
      },
      {
        "title": "Hanna E Blackner in household of John H Blackner, \"United States Census, 1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMHX-Q6D",
        "citation": "\"United States, Census, 1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MPJN-48M : Wed Aug 13 17:37:08 UTC 2025), Entry for John H Blackner and Hanna E Blackner, 1910."
      },
      {
        "title": "Ann Eliza Eyre in household of George Eyre, \"United States Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMHX-2FK",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MNSN-518 : Wed Sep 09 15:05:57 UTC 2026), Entry for George Eyre and Rebecca Eyre, 1880."
      },
      {
        "title": "Hannah Eyre, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/983V-V44",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZL7-L59 : Tue Dec 16 02:31:40 UTC 2025), Entry for George Henry Blackner and John Henry Blackner, 25 Oct 1946."
      },
      {
        "title": "Hannah E Blackner in household of I H Blackner Sr., \"United States Census, 1930\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMHX-QRC",
        "citation": "\"United States, Census, 1930\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:X7WH-LCD : Sun Jan 12 17:26:46 UTC 2025), Entry for I H Blackner Sr. and Hannah E Blackner, 1930."
      },
      {
        "title": "Hannah E. Eyre in entry for Owen Grant Blackner, \"Utah, Deaths and Burials, 1888-1946\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9Z4G-PPB",
        "citation": "\"Utah, Deaths and Burials, 1888-1946\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:F85D-BRS : 28 January 2020), Hannah E. Eyre in entry for Owen Grant Blackner, ."
      },
      {
        "title": "Hannah E Eyre, \"Utah, Salt Lake County Death Records, 1849-1949\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/983V-VJC",
        "citation": "\"Utah, Salt Lake County Death Records, 1849-1949\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:NQ4D-7LW : Sun Mar 10 14:35:46 UTC 2024), Entry for Owen Grant Blackner and John H Blackner, 15 Apr 1934."
      },
      {
        "title": "Hannah Blackner in household of John Blackner, \"United States Census, 1900\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMHX-QQT",
        "citation": "\"United States, Census, 1900\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M3VB-W7S : Sat Mar 29 11:39:08 UTC 2025), Entry for John Blackner and Hannah Blackner, 1900."
      },
      {
        "title": "Hannah Blackner in household of John H Blackner, \"United States Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMHX-Q3X",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MNSN-T1G : Wed Sep 09 15:08:10 UTC 2026), Entry for John H. Blackner and Hannah Blackner, 1880."
      }
    ],
    "portrait": "/ancestors/portraits/045_KWC1-J6N.jpg"
  },
  {
    "id": "I448",
    "name": "George Hare (Eyre) (born Eyre)",
    "sex": "M",
    "gen": 6,
    "slot": 26,
    "side": "paternal",
    "birthplace": "england",
    "childId": "I228",
    "birthYear": 1838,
    "deathYear": 1916,
    "birthDate": "8 Apr 1838",
    "deathDate": "8 Oct 1916",
    "burialDate": "11 Oct 1916",
    "christeningDate": "16 Apr 1838",
    "birthPlace": "Dowsby, Lincolnshire, England, United Kingdom",
    "deathPlace": "Lyman, Uinta, Wyoming, United States",
    "burialPlace": "Lyman City Cemetery, Lyman, Uinta, Wyoming, United States",
    "christeningPlace": "Dowsby, Lincolnshire, England, United Kingdom",
    "fsId": "KWNT-PB3",
    "photo": "/ancestors/bubbles/090_KWNT-PB3.jpg",
    "living": false,
    "alternateNames": [
      "George Hare"
    ],
    "facts": [
      {
        "kind": "Baptism",
        "date": "16 April 1838",
        "place": "Dowsby, Lincolnshire, England, United Kingdom",
        "note": null
      },
      {
        "kind": "Birth Registration",
        "date": "1838",
        "place": "Bourne, Lincolnshire, England, United Kingdom",
        "note": "Mother's maiden last name is Naylor"
      },
      {
        "kind": "Immigration",
        "date": "1861",
        "place": "New York City, New York, United States",
        "note": null
      },
      {
        "kind": "Immigration",
        "date": "1861",
        "place": "Utah, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1861",
        "place": "Ecclesall Bierlow, Yorkshire, England, United Kingdom",
        "note": "Occupation - Travelling Preacher"
      },
      {
        "kind": "Missionary to England - 1891",
        "date": "13 December 1891",
        "place": "Liverpool, Lancashire, England, United Kingdom",
        "note": "Arrived in England aboard the Guion Line - Wisconsin"
      },
      {
        "kind": "Misc",
        "date": "1900",
        "place": null,
        "note": "MOVE TO BRIDGER VALLEY FROM SOUTHERN UTAH"
      },
      {
        "kind": "Biography",
        "date": null,
        "place": null,
        "note": "by daughter Rebecca Eyre Bradshaw"
      },
      {
        "kind": "Misc",
        "date": null,
        "place": null,
        "note": "Was the bishop in Minersville and later Patriarch in Wyoming"
      },
      {
        "kind": "Occupation",
        "date": null,
        "place": null,
        "note": "Farmer"
      },
      {
        "kind": "Membership",
        "date": null,
        "place": "Woodruff, Rich, Utah, United States",
        "note": null
      },
      {
        "kind": "Financial Transaction",
        "date": null,
        "place": "Utah, United States",
        "note": null
      }
    ],
    "sketch": "George Eyre, 1838-1916 \n(Added by Nancy Marshall Yardley) \n\nThis life sketch was written by his daughter, Rebecca Naylor Eyre Bradshaw \n\nMy father, George Eyre, was born in Dowsby, Lincolnshire, England, April 8, 1838. His parents, James Eyre and Ann Naylor Eyre, lived in a farming community where the farms were owned by the wealthy class of people. Very few if any of the working class owned land in England, at that time. Although they were able to make a living they had very few if any of the luxuries, so little George didn’t have a chance to go to school, except what they called an infant school, a place where mothers that had to work left their babies to be taken care of by a woman hired for that purpose. The mothers taking their babies home at night. So my fathers only schooling consisted of learning to make pot hooks, as they were called, but he was naturally very ambitious, wanted to learn, and by self effort became very proficient in the three \"R's\" at least. His penmanship was better than the average. \n\nAt a very early age he was put out to service, as they called it, when they hired out to work for other people. He worked on a farm until he was 17 years of age, when he heard and accepted the Gospel, as taught by the Latter-day Saints. He was baptized by William Padley, an Elder in the Church. In May, 1856, he was ordained an Elder and for four years labored as a missionary in the British Isles Mission, having for his traveling companion at one time the late Joseph F. Smith. While laboring as a missionary in the Sheffield branch, one evening while holding a meeting, mother and her sister, Elizabeth, came into the meeting and Brother Joseph F. Smith watched them come up the aisle, turned to my father and said, \"George, that young lady coming up the aisle will someday become your wife.\" \n\nAfter the meeting, Brother Smith told the people that they were traveling without purse or script and they would appreciate any kindness that could be shown in the way of food or shelter, and my mother, Rebecca Hopkins, who had previously joined the Church, and her sister had never seen the Elders before, came up and said that they couldn't invite them to go to their home, but gave them a Sovereign each, or 50 cents in our money. Their friendship soon ripened into love. They decided to get married and immigrate to Zion, as that was the ambition of the Saints at that time, to save enough to get with the rest of the people of their faith, was their desire. \n\nSo the Church started what they called the Emigration Fund, where the Saints could place as much of their earnings as they could spare, and when they had saved enough to pay their passage on the boat, they were permitted to come to America. Mother began to save and being a very economical person, worked extra hours. Soon she had enough saved for her fare and almost enough for fathers too. Father being a traveling Missionary wasn't able to save. They hadn't up to this time told their parents of their plans, but when they began making preparations to get married they knew it was no use waiting any longer, so they broke the news as, gently as possible, telling them that they were going to get married and emigrate to Zion. \n\nTheir marriage was not opposed, but to immigrate to America was more then the dear old parents could stand. They pleaded for them to remain in England and they would do everything in their power to help them, but when they told them that they couldn't stay, they were brokenhearted and said, \"If you insist on leaving England, please do not come home after you are married. We could not stand to see you again\". So for the Gospel's sake they left the cozy little home where Rebecca had spent 29 years of her childhood and womanhood, and the parents, brothers, sisters, and friends that had made her life so happy. So they went their way to the Little Wicker Church and were married, April 7, 1861. They stayed two weeks after their marriage with mother's Aunt Bessie Robison. She was very kind to them and gave them provisions for their journey on the boat. April 22, 1861, they set sail on the sailing vessel\" the \"Underwriter\" with Milo Andrus as Captain of the company for the saints, with Hans Duncan and Charles W. Penrose as councilors. After drifting and sailing for six weeks, they finally landed in New York. They came as far as Florence, Nebraska by rail, then hired out to some farmer there, father working in the field, and mother in the home, assisting with the housework and the family sewing. By the time the Company of Saints was ready to start, they had saved enough to come with them. The nice feather bed they had planned to bring with them proved too bulky and they had to empty the feathers out. They spread the empty tick over the ox yoke to keep them off the wet ground and that was their bed at night, though they walked the entire distance from Florence, Nebraska to Salt Lake City, giving place in the wagons to older people. Unless there was an Indian scare they would sing and dance around the camp fire. They were happy as larks. The journey across the plains was often beset with many dangers from the Indians, also from the stampeding herds of buffalo, but the Lord was on their side and brought them through in safety. They arrived in Salt Lake in September, 1861. Father worked on the Temple while he waited for his brother, John, to come from Minersville where they intended to locate. \n\nAfter arriving in Minersville, their first problem was to build them a home. The material must of necessity be native. They constructed a little shack from poles and cedar posts, daubing the cracks with mud to keep out the cold and snow. The furniture was made from cottonwood poles, with rawhide laced for chair seats and bedsprings. The only cooking utensils were a bake skillet and one pan used for dishpan, bread pan, wash tub, bathtub, and many other uses. Sand was used to scour it clean after each time it was used. After a time they built an adobe room and put a dirt roof on it. Mother traded a wool shawl for enough lumber to make a door for it, and then she took some thin material she had for her window panes. They put a small bin in one corner to put their grain in and spread poles over that for a bed, so they had things more comfortable. But no sooner had they started to raise a little grain, than their thoughts turned to their native land. \n\nFather's father and mother and two younger brothers were longing to emigrate, so they started to work toward that end. They would save what they could and put the money in the emigration fund here in Zion, and help their family get their emigration money. Father and his brother, John, both worked and finally they got enough to bring their parents and two younger brothers to Zion. They were elated to think that they would soon see their parents again and could hardly wait, but we can hardly imagine their disappointment and deep sorrow when they received word from their brothers that their mother had died on the ship and was buried at sea. Their father died crossing the plains and was buried along the trail on Hams Fork, between Granger and Fort Bridger, Wyoming. There was no marker to make it possible to go back and find it. \n\nDuring these years of hardship and privation, pioneering a new and at that time a barren country, they had nine children come to bless their home: Hannah Elizabeth born January 25, 1862, Harriet Ann born July 4, 1864 George Hopkin born April 22, 1866 James Edward born December 20, 1867, John Edwin born November 8, 1869, Joseph William born October 28, 1871, Rebecca Nay1or born January 22, 1874, Elcey Ann born November 29, 1875, Charlotte Ellen born November 21, 1876. \n\nTo support this family it required a great effort on the part of both parents; Father being in ill health a great deal of the time. But faith and determination were two outstanding characteristics of the pioneer Saints. So they did their best to rear and educate their children, giving them the best there was to be had at that time, which was not much, compared to what we have now. But the home training was not lacking insofar as teaching by example goes. Father was always a sincere Church worker and soon after coming to Minersville, on May 22, 1869: he was set apart as first councilor to Bishop James McKnight. He was ordained a High Priest and worked in the Minersville Ward. \n\nHe was in the Bishopric of that ward constantly for many years, being set apart as bishop of that ward on September 24, 1894, which office he held for eight years, at which time he was released because of poor health. He held many positions of responsibility in both town and county. He was also a member of the High Council of the Beaver Stake. He was also a member of the Church Board of Education. During the time of the United Order he had charge of the men in the fields, also of the distribution of the goods to the families, and was an outstanding character in the community; trustworthy, charitable, and a friend to all. \n\nIn November, 1903, he and his wife moved to Lyman, Wyoming, where all their children but one son, George H. then resided. Soon after arriving in Lyman they bought a city lot from Bishop Samuel R. Brough and erected one of the first homes on the Lyman town site. And soon that little corner was the Sunderland of Lyman and the Bridger Valley. Father was an expert gardener and soon had grass, flowers, garden, and trees and all it takes to make an attractive home, and he took pride in having his place the best that could be seen even in much older and more cultivated places. Even though he was growing old and his health was poor, he always remained faithful. On October 10, 1914, he was ordained a Patriarch of the Woodruff Stake, which office he held until his death which occurred on October 8, 1916. \n\nTranscribed from George Eyre's memories page on FamilySearch",
    "sources": [
      {
        "title": "George Hare (Eyre) (born Eyre), 'Geni World Family Tree' on MyHeritage",
        "href": "https://www.familysearch.org/tree/sources/viewedit/W69Y-S97",
        "citation": "Geni World Family Tree MyHeritage.com [online database], MyHeritage Ltd. George Hare (Eyre) (born Eyre)"
      },
      {
        "title": "GRO Online Index",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QP37-6HJ",
        "citation": "\"GRO Online Indexes,\" General Register Office (https://www.gro.gov.uk, accessed 1 Mar. 2024); George Hare, birth registration, 1838 J Quarter, Bourne, Lincolnshire, England.\""
      },
      {
        "title": "George Eyre, 'GenealogieOnline Family Tree Index' on MyHeritage",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QCKV-37Z",
        "citation": "GenealogieOnline Family Tree Index MyHeritage.com [online database], MyHeritage Ltd. George Eyre"
      },
      {
        "title": "George Hare (Eyre) (born Eyre), 'Geni World Family Tree' on MyHeritage",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QCKV-379",
        "citation": "Geni World Family Tree MyHeritage.com [online database], MyHeritage Ltd. George Hare (Eyre) (born Eyre)"
      },
      {
        "title": "George Hare [or Eyre], Record of Christening (Baptism) on 16 Apr 1838 in Dowsby, Lincolnshire, England",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MM7K-LMW",
        "citation": "\"England Births and Christenings, 1538-1975,\" index, FamilySearch (https://familysearch.org/pal:/MM9.1.1/N68R-K24 : accessed 12 Jul 2013), George Hare, 1838."
      },
      {
        "title": "Ancestry Family Trees",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9K5N-CDJ",
        "citation": "Ancestry Family Tree"
      },
      {
        "title": "England & Wales, Civil Registration Marriage Index, 1837-1915",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9K5N-CD6",
        "citation": ""
      },
      {
        "title": "England, Select Births and Christenings, 1538-1975",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9K5N-CDQ",
        "citation": ""
      },
      {
        "title": "Derbyshire, England, Select Church of England Parish Registers, 1538-1910",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9K5N-CD9",
        "citation": ""
      },
      {
        "title": "Derbyshire, England, Select Church of England Parish Registers, 1538-1910",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9K5N-C81",
        "citation": ""
      },
      {
        "title": "1841 England Census",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9K5N-C8Y",
        "citation": "Class: HO107; Piece: 617; Book: 1; Civil Parish: Dowsby; County: Lincolnshire; Enumeration District: 6; Folio: 8; Page: 9; Line: 18; GSU roll: 438757"
      },
      {
        "title": "1851 England Census",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9K5N-C87",
        "citation": "Class: HO107; Piece: 2095; Folio: 280; Page: 6; GSU roll: 87723-87724"
      },
      {
        "title": "1861 England Census",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9K5N-C82",
        "citation": "Class: RG 9; Piece: 3471; Folio: 10; Page: 13; GSU roll: 543137"
      },
      {
        "title": "George Eyre, \"England and Wales, Census, 1861\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3ZYM-HN1",
        "citation": "\"England and Wales, Census, 1861\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M724-BSM : Thu Sep 10 03:51:14 UTC 2026), Entry for Emma Clark and George Eyre, 1861."
      },
      {
        "title": "Martha Hopkin, \"England and Wales, Marriage Registration Index, 1837-2005\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3ZYW-29N",
        "citation": "\"England and Wales, Marriage Registration Index, 1837-2005\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:2DW6-W1J : Thu Jul 02 16:48:59 UTC 2026), Entry for Martha Hopkin and Rebekah, 1861."
      },
      {
        "title": "George Eyre, \"The Church of Jesus Christ of Latter-day Saints, Perpetual Emigrating Fund Company Financial Accounts (Worldwide), 1849-1886\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7WSL-D5M",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Perpetual Emigrating Fund Company Financial Accounts (Worldwide), 1849-1886\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:CQBY-KZ6Z : Fri Feb 21 20:31:45 UTC 2025), Entry for George Eyre."
      },
      {
        "title": "George Hare, \"England and Wales, Birth Registration Index, 1837-2008\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3Z33-LHL",
        "citation": "\"England and Wales, Birth Registration Index, 1837-2008\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:2NDP-NRT : Tue May 12 10:23:32 UTC 2026), Entry for George Hare, 1838."
      },
      {
        "title": "George Eyre, \"California, County Birth and Death Records, 1800-1994\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S356-257",
        "citation": "\"California, County Birth and Death Records, 1800-1994\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QP9Q-QK41 : Wed Feb 19 00:14:33 UTC 2025), Entry for Joseph Wm Eyre and George Eyre, 25 January 1930."
      },
      {
        "title": "George Hare, \"England, Lincolnshire, Parish Registers, 1538-1990\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S5QZ-KBV",
        "citation": "\"England, Lincolnshire, Parish Registers, 1538-1990\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QL1L-PHS5 : Sat Jul 25 11:20:37 UTC 2026), Entry for George Hare and James Hare, 16 April 1838."
      },
      {
        "title": "George Eyre, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QJNC-NZX",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6L73-QRM7 : Thu Mar 26 23:19:46 UTC 2026), Entry for George Eyre."
      },
      {
        "title": "New York, Passenger Lists, 1820-1957",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9K5N-CZL",
        "citation": "Year: 1861; Arrival: New York, New York; Microfilm Serial: M237, 1820-1897; Microfilm Roll: Roll 211; Line: 45; List Number: 452"
      },
      {
        "title": "Membership of The Church of Jesus Christ of Latter-day Saints, 1830-1848",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9K5N-C8D",
        "citation": ""
      },
      {
        "title": "1870 United States Federal Census",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9K5N-CZP",
        "citation": "Year: 1870; Census Place: District 7 Minersville, Beaver, Utah Territory; Roll: M593_1610; Page: 26B; Image: 320144; Family History Library Film: 553109"
      },
      {
        "title": "1880 United States Federal Census",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9KGL-53G",
        "citation": "Year: 1880; Census Place: Minersville, Beaver, Utah; Roll: 1335; Family History Film: 1255335; Page: 29A; Enumeration District: 002"
      },
      {
        "title": "1900 United States Federal Census",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9K5N-CZ1",
        "citation": "Year: 1900; Census Place: Minersville, Beaver, Utah; Roll: 1682; Page: 1B; Enumeration District: 0069; FHL microfilm: 1241682"
      },
      {
        "title": "1910 United States Federal Census",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9K5N-C8C",
        "citation": "Year: 1910; Census Place: Lyman, Uinta, Wyoming; Roll: T624_1747; Page: 7B; Enumeration District: 0133; FHL microfilm: 1375760"
      },
      {
        "title": "Beaver County, Utah Census, 1900",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9K5N-CZN",
        "citation": ""
      },
      {
        "title": "George Eyre, \"United States Census, 1910\" - Record Details – FamilySearch.org",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMQP-P6D",
        "citation": "\"United States Census, 1910,\" index and images, FamilySearch (https://familysearch.org/pal:/MM9.1.1/MPJN-Q3F : accessed 11 Jun 2013), George Eyre, 1910."
      },
      {
        "title": "U.S., Find A Grave Index, 1600s-Current",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9KGL-53L",
        "citation": ""
      },
      {
        "title": "George Hare, \"England and Wales Census, 1851\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MM1M-6HS",
        "citation": "\"England and Wales, Census, 1851\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:SGNS-DVW : Fri Aug 21 08:55:45 UTC 2026), Entry for James Hare and Ann Hare, 1851."
      },
      {
        "title": "George Eyre, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/983W-NLD",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVKJ-Z8J3 : Sun Oct 04 11:34:19 UTC 2026), Entry for George Eyre."
      },
      {
        "title": "George Eyre, \"Utah, Mormon Pioneer Overland Travel Database, 1847-1868\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9D7T-WZ6",
        "citation": "\"Utah, Mormon Pioneer Overland Travel Database, 1847-1868\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QK9B-ZCH5 : Wed Feb 19 20:20:30 UTC 2025), Entry for George Eyre, 1861."
      },
      {
        "title": "George Eyre, \"The Church of Jesus Christ of Latter-day Saints, Missionary Registers (Worldwide), 1860-1937\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9X5Y-NCG",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Missionary Registers (Worldwide), 1860-1937\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QKDW-1NCS : Tue Mar 11 16:33:12 UTC 2025), Entry for James E Eyre and George Eyre, 1925."
      },
      {
        "title": "George Eyre, \"United States Census, 1900\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMBW-S48",
        "citation": "\"United States, Census, 1900\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MMRN-6GC : Tue Jun 03 17:52:49 UTC 2025), Entry for George Eyre and Rebekah Eyre, 1900."
      },
      {
        "title": "George Eyre, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M98J-Z28",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZPR-YNR : Wed Jun 24 12:27:19 UTC 2026), Entry for Rebecca Eyre Bradshaw and George Eyre, 21 Mar 1954."
      },
      {
        "title": "George Eyre, \"The Church of Jesus Christ of Latter-day Saints, Missionary Registers (Worldwide), 1860-1937\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9X5Y-B1X",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Missionary Registers (Worldwide), 1860-1937\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QKDW-Y74G : Tue Mar 11 16:24:17 UTC 2025), Entry for George Hopkin Eyre and Robert Easton, 1896."
      },
      {
        "title": "George Eyre, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSKM-F44",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZL4-XT5 : Mon Feb 03 19:00:17 UTC 2025), Entry for George Hopkin Eyre and George Eyre, 28 Jul 1947."
      },
      {
        "title": "George Eyre, \"England Marriages, 1538–1973\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/945T-T57",
        "citation": "\"England Marriages, 1538–1973\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:NVY8-W8D : Sat Aug 01 17:16:45 UTC 2026), Entry for John Eyre and George Eyre, 9 April 1849."
      },
      {
        "title": "George Eyre, \"New York, Passenger Lists, 1820-1920\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/98WN-NP3",
        "citation": "\"New York, Passenger Lists, 1820-1920\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QV33-4LNX : Thu Jul 02 06:13:21 UTC 2026), Entry for George Eyre, 1861."
      },
      {
        "title": "George Hare, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZX6-YYH",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:NYLH-M26 : 5 February 2023), George Hare, 1838."
      },
      {
        "title": "Legacy NFS Source: George Eyre -",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMVQ-PLY",
        "citation": "Ancestral File (R), The Church of Jesus Christ of Latter-day Saints, Copyright (c) 1987, June 1998, data as of 5 January 1998, Family History Library, 35 N West Temple Street, Salt Lake City, Utah 84150 USA"
      },
      {
        "title": "George Eyre - Mormon Pioneer Overland Travel",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMH1-3VG",
        "citation": ""
      },
      {
        "title": "George Eyre, \"England and Wales Census, 1841\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMQP-P3M",
        "citation": "England and Wales Census, 1841,\" index, FamilySearch (https://familysearch.org/pal:/MM9.1.1/MQ1Y-GL7 : accessed 11 Jun 2013), George Eyre, 1841."
      },
      {
        "title": "Millennium File",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9K5N-CZD",
        "citation": ""
      },
      {
        "title": "George Eyre, \"United States Census, 1870\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MM3R-WNW",
        "citation": "\"United States, Census, 1870\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MNCR-HFB : Sat Oct 18 14:17:47 UTC 2025), Entry for George Eyre and Rebecca Eyre, 1870."
      },
      {
        "title": "George Hare, \"England and Wales Census, 1841\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MM7K-L9K",
        "citation": "\"England and Wales, Census, 1841\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MQ1P-KFF : Tue Sep 08 20:53:15 UTC 2026), Entry for James Hare and Ann Hare, 1841."
      },
      {
        "title": "George Eyre, \"United States Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMHX-26N",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MNSN-518 : Wed Sep 09 15:05:57 UTC 2026), Entry for George Eyre and Rebecca Eyre, 1880."
      }
    ],
    "portrait": "/ancestors/portraits/090_KWNT-PB3.jpg"
  },
  {
    "id": "I441",
    "name": "Rebecca Hopkin",
    "sex": "F",
    "gen": 6,
    "slot": 27,
    "side": "paternal",
    "birthplace": "england",
    "childId": "I228",
    "birthYear": 1832,
    "deathYear": 1923,
    "birthDate": "1 Mar 1832",
    "deathDate": "19 Mar 1923",
    "burialDate": "21 Mar 1923",
    "christeningDate": "17 Jun 1832",
    "birthPlace": "Sheffield, Yorkshire, England, United Kingdom",
    "deathPlace": "Lyman, Uinta, Wyoming, United States",
    "burialPlace": "Lyman City Cemetery, Lyman, Uinta, Wyoming, United States",
    "christeningPlace": "Sheffield St Peter and St Paul, Yorkshire, England, United Kingdom",
    "fsId": "KWNT-PBS",
    "photo": "/ancestors/bubbles/091_KWNT-PBS.jpg",
    "living": false,
    "alternateNames": [
      "Rebekah Eyre"
    ],
    "facts": [
      {
        "kind": "Baptism",
        "date": "17 June 1832",
        "place": "Cathedral Church of St Peter and St Paul, Sheffield, Yorkshire, England, United Kingdom",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1851",
        "place": "Yorkshire, England, United Kingdom",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1861",
        "place": "Ecclesall Bierlow, Yorkshire, England, United Kingdom",
        "note": null
      },
      {
        "kind": "Immigration",
        "date": "1861",
        "place": null,
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1910",
        "place": "Lyman, Uinta, Wyoming, United States",
        "note": null
      },
      {
        "kind": "Biography",
        "date": null,
        "place": null,
        "note": "by daughter Rebecca Eyre Hopkin"
      }
    ],
    "sketch": "LIFE OF REBECCA HOPKIN EYRE 1832 - 1923 \n\nThis sketch was given by her daughter, Rebecca Eyre Bradshaw \n\nRebecca Hopkin was born in Sheffield, Yorkshire, England, March 1, 1832, the second child of Edward Hopkin and Hannah Morrison. \n\nHer early childhood home was on a hill overlooking the dams that were the chief water supply of the great city of Sheffield, England, and it was in the woods on the banks of these dams that she spent her leisure times as a child. There was all kinds of nuts and berries in the woods and a profusion of wild flowers, so she and her brother, Joseph, had a merry time picking flowers, berries, and nuts in the fall of the year. Her brother used to catch the different kinds of birds and tame them several of which he taught to talk. He'd sit under the cage of the bird at night and whistle any tune he wanted to teach and the next day the bird would whistle the tune perfectly. They also had one bird called George that paraded around his cage and said \"Silence\"! Pretty George is going to whistle, \"Sweet Kitty Jones\", and would proceed to whistle the tune, \"Sweet Kitty Jones.\" So they entertained themselves with birds, flowers, and beautiful surroundings. When mother was very small she went to a school for girls sponsored by two old maiden ladies, the Harrison sisters. Here she was taught to knit and sew as well as the reading, writing and arithmetic. \n\nMother was very apt at sewing and at nine years of age, won a prize of a pair of lovely wool blankets for best samples sewing. Her father was a brick layer or a mason and made good wages, so the family always had everything they needed to make them comfortable. When still a young girl, mother went to work in a big steel factory and learned the file cutting trade, and it wasn’t long until she was making good wages. In the summer of 1850, she heard for the first time the Gospel as taught by the Latter-Day Saints. After prayerful investigation and study, she was converted and baptized in 1850 by Elder J. V. Long. She was active in the branch and was a member of the Sheffield Choir for ten years. It was after Church services one evening that she met a traveling Elder, George Eyre, and as he was laboring in that district for some time, they met often, and their friendship soon grew into love, and they decided they would get married and emigrate to Zion. \n\nThe Church at that time had what was called the Emigration Fund where the saints wishing to go to Zion, could deposit as much of their earnings as they could spare, much as we'd now deposit in a bank. When they had enough saved, they paid their fare and they could come with the first group of Saints that came. So mother began saving and it wasn't very long until she had enough to pay her passage and almost enough to pay fathers too. \n\nThe problem that was worrying her now was how to tell her father and mother. She knew her parents didn't object to her marriage as she was 29 years old, but to leave them and come to America was another thing, but she finally got courage to tell them what she intended to do. Her parents told her if they would only stay in England after they were married they would help them in every way that they could, but if they insisted on going to America, it would break their hearts, so they pleaded with them to stay. When they found it was useless to plead, they told her if she insisted that she must not come home after their marriage, as they could not stand to see her again, so on April 7, 1861, she bade her dear father and mother, family and friends, whom she knew she would never see again in this world. She and her sister, Elizabeth, who was getting married and emigrating too, went with the men of their choice and were married in what was known as the Little \"Wicker Church\" of Sheffield, England. \n\nHer sister went with her husband to his people, but mother and father could not go to her home, so they went to mother's Aunt Bessie Robison; they told her what they had done, and of their intentions to go to America and she treated them kindly. She cooked them a nice Wedding Supper and afterward gave them food to take for their trip on the boat. They stayed with her for two weeks, waiting for the ship to sail that was taking the company of saints to Zion. \n\nThey set sail, April 22, 1861, on the ship \"Underwritter\" with Milo Andrus as Captain of the company of Saints, Hanse Duncan and Charles W. Penrose as his counselors. They were on the ocean six weeks. Upon arrival in New York they found that they could take the train to Florence, Nebraska. This they did and arriving there they found that company of Saints would not start across the plains for some time, so they procured employment on a farm. Father working on the farm and mother working in the home. Here she learned a little about pioneer life, but nothing to compare with what they would learn when they arrived in Utah. They had thought to ride across the plains, but the older people were the only ones permitted to ride. So they walked the entire distance from Florence, Nebraska to Salt Lake City. The nice feather bed they had brought with them was too bulky to bring farther, so they emptied the feathers out and used the tick to spread over the ox yokes to keep them off the damp ground at night. But they didn't seem to mind the hardships and in the evening they would sing and dance and have a good time, unless they had an Indian scare, then everything was quiet and watchful. One day during the noon hour mother went into the woods to pick wild berries and got farther away from camp than she realized. While she was gone the company started, not knowing anyone was missing, but father grew frantic and got a man to go with him on a horse to try to find her. Of course, they thought that the Indians had picked her up, but when they got back to their campground they commenced looking for her, and you can imagine their delight when they found her making her way back to camp with the berries she had gathered, not knowing the worry that it had caused, not only to her husband but to the company in general. \n\nThey arrived in Salt Lake City, September 15, 1861, where they were met by fathers sister, Sarah, and her husband, Joseph Meyers. Father worked on the Temple the few weeks they, were waiting for his brother, John, to arrive from Minersville where they intended to locate. This trip from Salt Lake to Minersville was the same experience as crossing the plains. \n\nUpon arriving in Minersville, they were happy to meet another of Father's sisters, Charlotte Banks. They stayed for a time with his brother, John. But as soon as possible built them a little house from poles and cedar posts with a dirt roof. Mother said no one would ever know how she felt when she arrived in Minersville and saw how the people lived. They were more like Indians than white people. She said she stepped outside the first night and seeing a large inclosure all lit up, she went back in and said, \"OH! You don't have a circus here, do you?\" They laughed and told her that was the home of a large family and the lights she saw was the campfire shining through the cedar poles that were stood on end, and the fire in the center was all the lights that they had. She soon learned that the city training must be forgotten. The luxuries that she had always been accustomed to, were all a thing of the past and the new life as to be one of hardship and trials. But their faith in the Gospel they had embraced was everything to them and they were willing to adjust themselves to the conditions, and strive to make themselves a part of a people that were struggling for an existence, but to gain their religious freedom. \n\nGradually they were able to get enough of the materials things to make life more liveable and to help them care for the children that came to bless their home. Mother soon learned the art of gathering wool from the brush left by roving bands of sheep, washing, carding, and weaving it into cloth with which to make their clothing. Of sorting the fine straws from the straw stacks, and braiding and sewing them together to make their hats. \n\nThere were no sort of washers then as we now have, not even a washboard. Just two hands to rub the soiled clothes and the only soap was made from the carcass of perhaps a horse or cow that had died on the desert. The lye to make it with was procured by saving their wood ashes from quaking aspen, put in a burlap bag and pouring water over it, letting it drip into a kettle, then what fats they had were put into the solution and boiled till it formed a soft jelly or soap. \n\nThe clothes were few and of the coarsest kind, so their washings were not so large, but were hard to do. After the shoes she brought with her were worn out, there was nothing to replace them, so they necessarily went barefooted most of the time, to Church dances and everywhere, but all were alike so they were happy about it. \n\nI’ve heard mother say that one time they were going over to Parowan about thirty-eight miles to\na conference, so father made her a pair of shoes from rawhide.... \n\nMother had some very lovely clothes when she came from England which served to dress her first two children very nicely. She also had a lovely wool shawl which she traded for lumber enough to make a door for their adobe house which was quite unusual at the time. Mother was very skilled with a needle and what she did get in the way of clothes was made to look very nice, even if the cloth was coarse. \n\nShe was the mother of five girls and four boys making a family of nine. They made their home in Minersville for about forty-two years, then as moat of their children had moved to Lyman, Wyoming they decided to go there too, and in the fall of 1903, they moved to Lyman to spend their remaining years. \n\nMother lived seven years after father died. She came to live with me so I could take care of her. She died the 19th day of March, 1923, at the age of 91.",
    "sources": [
      {
        "title": "Rebekah Naylor Eyre (born Hopkin), 'Geni World Family Tree' on MyHeritage",
        "href": "https://www.familysearch.org/tree/sources/viewedit/W69Y-S9C",
        "citation": "Geni World Family Tree MyHeritage.com [online database], MyHeritage Ltd. Rebekah Naylor Eyre (born Hopkin)"
      },
      {
        "title": "1841 England Census for Edward Hopkin family...visual image of record",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZR1-9WV",
        "citation": "Class: HO107; Piece: 1333; Book: 3; Civil Parish: Sheffield; County: Yorkshire; Enumeration District: 2; Folio: 23; Page: 7; Line: 9; GSU roll: 464279 Ancestry.com. 1841 England Census [database on-line]. Provo, UT, USA: Ancestry.com Operations, Inc, 2010. Original data: Census Returns of England and Wales, 1841. Kew, Surrey, England: The National Archives of the UK (TNA): Public Record Office (PRO), 1841. Data imaged from the National Archives, London, England. The National Archives gives no warranty as to the accuracy, completeness or fitness for the purpose of the information provided. Images may be used only for purposes of research, private study or education. Applications for any other use should be made to the National Archives, Kew, Richmond, Surrey TW9 4DU. Ancestry.com"
      },
      {
        "title": "Legacy NFS Source: Rebecca Naylor Hopkins -",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MS64-LZ5",
        "citation": "Ancestral File (R), The Church of Jesus Christ of Latter-day Saints, Copyright (c) 1987, June 1998, data as of 5 January 1998, Family History Library, 35 N West Temple Street, Salt Lake City, Utah 84150 USA"
      },
      {
        "title": "Rebekah Eyre in household of George Eyre, \"United States Census, 1900\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMBW-36W",
        "citation": "\"United States, Census, 1900\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MMRN-6GC : Tue Jun 03 17:52:49 UTC 2025), Entry for George Eyre and Rebekah Eyre, 1900."
      },
      {
        "title": "Rebecca Hopkin, \"England and Wales, Census, 1841\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSVB-1CF",
        "citation": "\"England and Wales, Census, 1841\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MQP1-KHJ : Tue Sep 08 21:00:23 UTC 2026), Entry for Edward Hopkin and Hannah Hopkin, 1841."
      },
      {
        "title": "Rebekah Hopkin Eyre, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/983W-FXT",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVKJ-Z8JZ : Sat Oct 03 13:17:50 UTC 2026), Entry for Rebekah Hopkin Eyre, 1923."
      },
      {
        "title": "Rebecca Hopkin in household of Edward Hopkin, \"England and Wales Census, 1851\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9VLZ-J3G",
        "citation": "\"England and Wales, Census, 1851\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:SPMB-YWR : Fri Aug 21 08:48:42 UTC 2026), Entry for Edward Hopkin and Hannah Hopkin, 1851."
      },
      {
        "title": "Rebecca Eyre in household of George Eyre, \"United States Census, 1870\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MM3R-WN8",
        "citation": "\"United States, Census, 1870\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MNCR-HFB : Sat Oct 18 14:17:47 UTC 2025), Entry for George Eyre and Rebecca Eyre, 1870."
      },
      {
        "title": "Rebekah Eyre, \"United States, Census, 1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3K7L-G2R",
        "citation": "\"United States, Census, 1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MPJN-Q3F : Wed Aug 13 17:38:14 UTC 2025), Entry for George Eyre and Rebekah Eyre, 1910."
      },
      {
        "title": "Rebecca Eyre in household of George Eyre, \"United States Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMHX-2XW",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MNSN-518 : Wed Sep 09 15:05:57 UTC 2026), Entry for George Eyre and Rebecca Eyre, 1880."
      },
      {
        "title": "Rebecca Hopkin, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M98J-Z2P",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZPR-YNR : Wed Jun 24 12:27:19 UTC 2026), Entry for Rebecca Eyre Bradshaw and George Eyre, 21 Mar 1954."
      },
      {
        "title": "Rebecca Hopkin, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSKM-F4Q",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZL4-XT5 : Mon Feb 03 19:00:17 UTC 2025), Entry for George Hopkin Eyre and George Eyre, 28 Jul 1947."
      },
      {
        "title": "Rebecca Eyre, \"England and Wales, Census, 1861\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3ZYM-HZ2",
        "citation": "\"England and Wales, Census, 1861\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M724-BSM : Thu Sep 10 03:51:14 UTC 2026), Entry for Emma Clark and George Eyre, 1861."
      },
      {
        "title": "Rebeckah Hopkins, \"The Church of Jesus Christ of Latter-day Saints, Missionary Registers (Worldwide), 1860-1937\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9X5Y-NC9",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Missionary Registers (Worldwide), 1860-1937\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QKDW-1NCS : Tue Mar 11 16:33:12 UTC 2025), Entry for James E Eyre and George Eyre, 1925."
      },
      {
        "title": "Rebecca Hopkin, \"The Church of Jesus Christ of Latter-day Saints, Missionary Registers (Worldwide), 1860-1937\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9X5Y-1M7",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Missionary Registers (Worldwide), 1860-1937\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QKDW-Y74G : Tue Mar 11 16:24:17 UTC 2025), Entry for George Hopkin Eyre and Robert Easton, 1896."
      },
      {
        "title": "Rebecca Hopkin in household of Edward Hopkin, \"England and Wales Census, 1851\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/966C-FYH",
        "citation": ""
      },
      {
        "title": "Rebecca Hopkin, \"England, Yorkshire, Parish Registers, 1538-2016\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3K7L-GCM",
        "citation": "\"England, Yorkshire, Parish Registers, 1538-2016\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:66B5-X3B3 : Wed Aug 19 15:18:27 UTC 2026), Entry for Rebecca Hopkin and Edward, 17 June 1832."
      },
      {
        "title": "Rebekah Hopkin, \"England and Wales, Marriage Registration Index, 1837-1920\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMBW-9Z2",
        "citation": "\"England and Wales, Marriage Registration Index, 1837-2005\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:2DW6-LRQ : Sat Jul 04 14:45:36 UTC 2026), Entry for Rebekah Stacey and George, 1861."
      },
      {
        "title": "Rebecca Hopkins, \"California, County Birth and Death Records, 1800-1994\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S356-2R6",
        "citation": "\"California, County Birth and Death Records, 1800-1994\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QP9Q-QK41 : Wed Feb 19 00:14:33 UTC 2025), Entry for Joseph Wm Eyre and George Eyre, 25 January 1930."
      }
    ],
    "portrait": "/ancestors/portraits/091_KWNT-PBS.jpg"
  },
  {
    "id": "I91",
    "name": "Bessie Louise Briggs",
    "sex": "F",
    "gen": 4,
    "slot": 7,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "I27",
    "birthYear": 1890,
    "deathYear": 1974,
    "birthDate": "27 Oct 1890",
    "deathDate": "25 Sep 1974",
    "burialDate": "28 Sep 1974",
    "christeningDate": null,
    "birthPlace": "Beaver, Beaver, Utah, United States",
    "deathPlace": "Provo, Utah, Utah, United States",
    "burialPlace": "Redwood Memorial Cemetery, Taylorsville, Salt Lake County, Utah, United States",
    "christeningPlace": null,
    "fsId": "KWCL-BL4",
    "photo": "/ancestors/bubbles/023_KWCL-BL4.jpg",
    "living": false,
    "alternateNames": [
      "Bessie Louise Briggs Blackner"
    ],
    "facts": [
      {
        "kind": "Blessing",
        "date": "1 January 1891",
        "place": null,
        "note": null
      },
      {
        "kind": "Residence",
        "date": "25 April 1950",
        "place": "Lyman, Uinta, Wyoming, United States",
        "note": null
      },
      {
        "kind": "Membership",
        "date": null,
        "place": "Beaver, Utah, United States",
        "note": null
      },
      {
        "kind": "Membership",
        "date": null,
        "place": "Utah, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Bessie Briggs, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/WDND-M76",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:62WC-BP35 : Thu Mar 26 20:12:15 UTC 2026), Entry for Bessie Briggs and Ray L Blackner."
      },
      {
        "title": "Bessie Briggs, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/WDWD-33H",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6ZXT-D7Z1 : Sun Sep 13 05:28:46 UTC 2026), Entry for Ray L Blackner and Bessie Briggs."
      },
      {
        "title": "Bessie Briggs, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/WDWD-STH",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6ZXT-D789 : Sun Sep 13 05:13:50 UTC 2026), Entry for Bessie Briggs and Ray L Blackner."
      },
      {
        "title": "Bessie Briggs, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/WDWD-S2V",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:62WC-BP3G : Fri Mar 27 03:22:48 UTC 2026), Entry for Ray L Blackner and Bessie Briggs."
      },
      {
        "title": "Bessie Blackner, \"United States, Obituary Records, 2014-2023\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7HGG-6VT",
        "citation": "\"United States, Obituary Records, 2014-2023\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:611D-8Z9K : Thu Nov 14 18:40:26 UTC 2024), Entry for Bonnie Wyoma Blackner Snelson and Ray Blackner, 25 July 2020."
      },
      {
        "title": "Be?sey Louise Briggs, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7HS6-2HF",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:DBB5-2R3Z : Sun Sep 13 04:45:38 UTC 2026), Entry for Be?sey Louise Briggs and W S Tolton."
      },
      {
        "title": "Bessey Louise Briggs, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7HS6-KNR",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Z19-2VQN : Sun Sep 13 04:48:05 UTC 2026), Entry for Bessey Louise Briggs and W S Tolton."
      },
      {
        "title": "Bessie Briggs, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/77W7-25X",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:659S-2NN1 : Fri Mar 27 04:00:49 UTC 2026), Entry for Rebecca Blackner and Ray."
      },
      {
        "title": "Bessie Briggs, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/77W7-VJ2",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6RFR-3TSQ : Fri Mar 27 00:39:12 UTC 2026), Entry for Leonard Briggs Blackner and Le Roy."
      },
      {
        "title": "Bessie L Briggs, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/77W7-JMG",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6RFY-9TXP : Thu Mar 26 19:48:42 UTC 2026), Entry for Nina Oleah Blackner and Ray."
      },
      {
        "title": "Bessie Briggs, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7Q5S-T69",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6R29-YBF9 : Fri Mar 27 00:27:55 UTC 2026), Entry for Nedra Louise Blackner and Roy."
      },
      {
        "title": "Bessie Briggs, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7QCG-RS5",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:659S-2NNT : Fri Mar 27 02:01:06 UTC 2026), Entry for Woodrow R Blackner and Ray."
      },
      {
        "title": "Bessie Blackner, \"United States, World War II Draft Registration Cards, 1942\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QJST-HBP",
        "citation": "\"United States, World War II Draft Registration Cards, 1942\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QKV9-BPYD : Tue Apr 29 06:31:58 UTC 2025), Entry for Leonard Ray Blackner and Bessie Blackner, 27 Apr 1942."
      },
      {
        "title": "Bessie L Briggs, \"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QWCH-PRZ",
        "citation": "\"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6K4L-7ZKJ : Sun Jul 05 16:13:53 UTC 2026), Entry for Woodrow Ray Blackner and Leonard R Blackner."
      },
      {
        "title": "Bessie L Briggs, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QW4T-NQN",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6ZX7-LL2M : Sun Sep 13 05:48:28 UTC 2026), Entry for Nina Oleah Blackner and Ray."
      },
      {
        "title": "Bessie Louise Blackner, \"United States, Census, 1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3LNR-LWT",
        "citation": "\"United States, Census, 1950\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6XBJ-98GX : Wed Mar 20 12:53:24 UTC 2024), Entry for Daniel Edgar Wright and Connie Wright, April 25, 1950."
      },
      {
        "title": "Bessie Louise Blackner, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/34VH-MR2",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:ZTG9-TZPZ : Mon Mar 30 07:13:14 UTC 2026), Entry for Bessie Louise Blackner, 1914."
      },
      {
        "title": "Bessie Louise Blackner, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3SKT-NX8",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:DGPJ-FWMM : Mon Mar 30 07:32:14 UTC 2026), Entry for Bessie Louise Blackner, 1950."
      },
      {
        "title": "Bessie Louise Blackner, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3SKT-X66",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:ZXP2-VFW2 : Fri Aug 01 15:33:56 UTC 2025), Entry for Bessie Louise Blackner, 1950."
      },
      {
        "title": "Bessie Louise Briggs Blackner, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3SKT-DH4",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:ZTG9-TDZM : Sun Mar 29 22:35:19 UTC 2026), Entry for Bessie Louise Briggs Blackner, 1935."
      },
      {
        "title": "Bessie Louise Briggs Blackner, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3SKT-CQ7",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:ZTG9-T8W2 : Mon Mar 30 07:19:30 UTC 2026), Entry for Bessie Louise Briggs Blackner, 1930."
      },
      {
        "title": "Bessie Louise Briggs, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SYTM-3CX",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Z1VK-4B2M : Sun Mar 10 21:34:49 UTC 2024), Entry for Leonard Ray Blackner and John Henry Blackner, 21 Aug 1965."
      },
      {
        "title": "Bessie L. Briggs in entry for Frank Harold Wright, \"Utah, Marriages, 1887-1935\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SV2V-G8J",
        "citation": "\"Utah, Marriages, 1887-1935\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:HN81-8CZM : 3 November 2021), Bessie L. Briggs in entry for Frank Harold Wright, 1940."
      },
      {
        "title": "Bessie Blackner, \"Utah, World War II Index to Army Veterans of Utah, 1939-1945\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SZRC-XMQ",
        "citation": "\"Utah, World War II Index to Army Veterans of Utah, 1939-1945\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QYWQ-JB2M : Mon Mar 17 15:16:29 UTC 2025), Entry for Dennis K Blackner and Bessie Blackner, 30 Oct 1944."
      },
      {
        "title": "Besie L Blackner, \"Utah, World War II Index to Army Veterans of Utah, 1939-1945\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SZRC-D86",
        "citation": "\"Utah, World War II Index to Army Veterans of Utah, 1939-1945\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QYWQ-JBW2 : Mon Mar 17 15:16:54 UTC 2025), Entry for Dennis Kent Blackner and Besie L Blackner, 31 Oct 1944."
      },
      {
        "title": "Bessie L Briggs, \"United States, Western States Marriage Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S3KZ-1CX",
        "citation": "\"United States, Western States Marriage Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZX3-43R : Tue Feb 11 23:11:57 UTC 2025), Entry for Leonard Ray Blackner and Bessie L Briggs, 19 Jan 1910."
      },
      {
        "title": "Bessie L. Briggs, \"United States, Western States Marriage Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S3KZ-L7J",
        "citation": "\"United States, Western States Marriage Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZKC-M2F : Tue Feb 11 22:36:47 UTC 2025), Entry for Leonard R. Blackner and Bessie L. Briggs, 19 Jan 1910."
      },
      {
        "title": "Bessie Briggs Blackner in entry for Dennis Kent Blackner, \"ObitsUtah Obituary Index\" (Obituary Event Date: 2012)",
        "href": "https://www.familysearch.org/tree/sources/viewedit/987Z-X77",
        "citation": "\"Utah, ObitsUtah Obituary Index, 2010-2013\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSC-R2C2 : Tue Mar 11 15:41:52 UTC 2025), Entry for Bonnie Snelson and Bish Snelson, 2012."
      },
      {
        "title": "Bessie Louise Briggs in entry for Nedra Louise Blackner Walker, \"United States, GenealogyBank Obituaries, 1980-2014\" (Obituary Event Date: 15 March 2007)",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9V1F-Q85",
        "citation": "\"United States, GenealogyBank Obituaries, Births, and Marriages, 1980-2015\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QKTJ-MP2B : Sat Jan 18 05:05:47 UTC 2025), Entry for Nedra Louise Blackner Walker and Leonard Ray Blackner, 15 Mar 2007."
      },
      {
        "title": "Bessie Louise Briggs in entry for Woodrow Ray Blackner, \"United States, GenealogyBank Obituaries, 1980-2014\" (Obituary Event Date: 07 Jun 2005)",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9KMX-BZB",
        "citation": "\"United States, GenealogyBank Obituaries, Births, and Marriages, 1980-2015\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QK5P-5S4G : Sun Jan 19 17:02:47 UTC 2025), Entry for Woodrow Ray Blackner and Leonard Ray Blackner, 07 Jun 2005."
      },
      {
        "title": "Bessie Louise Briggs in entry for Woodrow Raymond Blackner, \"United States, GenealogyBank Obituaries, 1980-2014\" (Obituary Event Date: 05 Jun 2005)",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9V1S-Y9L",
        "citation": "\"United States, GenealogyBank Obituaries, Births, and Marriages, 1980-2015\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QK5P-NYMD : Sat Jan 18 02:18:26 UTC 2025), Entry for Woodrow Raymond Blackner and Kathy Blackner, 05 Jun 2005."
      },
      {
        "title": "Bessie Louise Briggs Blackner, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/98ZB-B72",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QV2Z-P1SB : Sun Oct 04 08:45:16 UTC 2026), Entry for Bessie Louise Briggs Blackner."
      },
      {
        "title": "Bessie Louise Blackner, \"BillionGraves Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/91LC-ZZM",
        "citation": "\"BillionGraves Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KPSL-CY9 : Thu Sep 24 17:54:04 UTC 2026), Entry for Bessie Louise Blackner."
      },
      {
        "title": "Bessie L Briggs in entry for Frank Harold Wright and Dorothy Alma Blackner, \"Utah, County Marriages, 1887-1940\" (Marriage Event Date: 22 Jun 1940)",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9FDL-JKW",
        "citation": "\"Utah, County Marriages, 1871-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2MY-DQ3V : Wed Nov 19 07:35:58 UTC 2025), Entry for Frank Harold Wright and Harry Wright, 22 Jun 1940."
      },
      {
        "title": "Bessie L Blackner in household of L R Blackner, \"United States Census, 1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMQB-9ZT",
        "citation": "\"United States, Census, 1940\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VTHM-T8N : Mon Jan 20 06:03:56 UTC 2025), Entry for L R Blackner and Bessie L Blackner, 1940."
      },
      {
        "title": "Bessie L Briggs in entry for Leonard Briggs Blackner and Dorothy Afton Dangerfield, \"Utah, County Marriages, 1887-1940\" (Marriage Event Date: 03 Sep 1935)",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9FXW-WVB",
        "citation": "\"Utah, County Marriages, 1871-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2MB-QM2V : Thu Sep 19 20:21:36 UTC 2024), Entry for Leonard Briggs Blackner and Leonard R, 03 Sep 1935."
      },
      {
        "title": "Bessie L Briggs in entry for ben B Hull and Nina O Blackner, \"Utah, Weber County Marriages, 1887-1939\" (Marriage Event Date: 23 Sep 1930)",
        "href": "https://www.familysearch.org/tree/sources/viewedit/968N-XBP",
        "citation": "\"Utah, Weber County Marriages, 1887-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QK6K-XKLH : Tue Jul 16 22:03:30 UTC 2024), Entry for ben B Hull and Roy E Hull, 23 Sep 1930."
      },
      {
        "title": "Bessie L Briggs in entry for Ben B Hull and Nina O Blackner, \"Utah, County Marriages, 1887-1940\" (Marriage Event Date: 23 Sep 1930)",
        "href": "https://www.familysearch.org/tree/sources/viewedit/98W4-H1P",
        "citation": "\"Utah, County Marriages, 1871-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VRLN-HTK : Thu Sep 19 20:23:11 UTC 2024), Entry for Ben B Hull and Roy E Hull, 23 Sep 1930."
      },
      {
        "title": "Bessie L Blackner in household of Leonard R Blackner, \"United States Census, 1930\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMQB-9H3",
        "citation": "\"United States, Census, 1930\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:X7WH-F5Z : Sun Mar 10 16:44:31 UTC 2024), Entry for Leonard R Blackner and Bessie L Blackner, 1930."
      },
      {
        "title": "Bessie S Blackner in household of L Ray Blackner, \"United States Census, 1920\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMQB-964",
        "citation": "\"United States, Census, 1920\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MNB5-7DL : Tue Sep 29 13:39:33 UTC 2026), Entry for L Ray Blackner and Bessie S Blackner, 1920."
      },
      {
        "title": "Miss Bessie L. Briggs, \"Utah, County Marriages, 1887-1940\" (Marriage Event Date: 19 Jan 1910)",
        "href": "https://www.familysearch.org/tree/sources/viewedit/98WF-MLC",
        "citation": "\"Utah, County Marriages, 1871-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:F8G3-DQZ : Thu Sep 19 18:58:00 UTC 2024), Entry for Leonard Ray Blackner and Miss Bessie L. Briggs, 19 Jan 1910."
      },
      {
        "title": "Bessie L. Briggs, \"Utah, Marriages, 1887-1966\" (Marriage Event Date: 19 Jan 1910)",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMQB-H92",
        "citation": "\"Utah, Marriages, 1887-1935\", database, FamilySearch (https://familysearch.org/ark:/61903/1:1:F8GZ-653 : 28 January 2020), Bessie L. Briggs in entry for Leonard R. Blackner, 1910."
      },
      {
        "title": "Bessie L. Briggs, \"Utah, County Marriages, 1887-1940\" (Marriage Event Date: 19 Jan 1910)",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSB3-RYV",
        "citation": "\"Utah, County Marriages, 1871-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KSGT-FQK : Thu Sep 19 19:12:43 UTC 2024), Entry for Leonard R. Blackner and Bessie L. Briggs, 19 Jan 1910."
      },
      {
        "title": "Bessie L Blackner in household of Leonard R Blackner, \"United States Census, 1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMQB-94M",
        "citation": "\"United States, Census, 1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MPJN-3DF : Wed Aug 13 17:38:36 UTC 2025), Entry for Leonard R Blackner and Bessie L Blackner, 1910."
      },
      {
        "title": "Bessie L. Briggs in household of Alma Briggs, \"United States Census, 1900\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMQB-9S4",
        "citation": "\"United States, Census, 1900\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MMRN-N24 : Thu Oct 09 04:19:49 UTC 2025), Entry for Alma Briggs and Louisa H. Briggs, 1900."
      },
      {
        "title": "Bessie Louise Briggs in entry for Nedra Louise Blackner Walker, \"United States, GenealogyBank Obituaries, 1980-2014\" ( Obituary Event Date: 15 Mar 2007)",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9V1X-K24",
        "citation": "\"United States, GenealogyBank Obituaries, Births, and Marriages, 1980-2015\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QKT9-GTPB : Tue Jan 14 06:27:01 UTC 2025), Entry for Nedra Louise Blackner Walker and Bonnie Snelson, 15 Mar 2007."
      },
      {
        "title": "U.S. City Directories, 1821-1989",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9KMX-B9Q",
        "citation": ""
      },
      {
        "title": "1940 United States Federal Census",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9KMX-YBG",
        "citation": "Year: 1940; Census Place: Lyman, Uinta, Wyoming; Roll: T627_4576; Page: 1A; Enumeration District: 21-15"
      },
      {
        "title": "1930 United States Federal Census",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9KMX-Y1V",
        "citation": "Year: 1930; Census Place: Lyman, Uinta, Wyoming; Roll: 2625; Page: 3A; Enumeration District: 0015; Image: 389.0; FHL microfilm: 2342359"
      },
      {
        "title": "1920 United States Federal Census",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9KMX-BMB",
        "citation": "Year: 1920; Census Place: Lyman, Uinta, Wyoming; Roll: T625_2029; Page: 7B; Enumeration District: 99; Image: 578"
      },
      {
        "title": "1910 United States Federal Census",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9KMX-BMR",
        "citation": "Year: 1910; Census Place: Lyman, Uinta, Wyoming; Roll: T624_1747; Page: 2B; Enumeration District: 0133; FHL microfilm: 1375760"
      },
      {
        "title": "Beaver County, Utah Census, 1900",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9KMX-Y1P",
        "citation": ""
      },
      {
        "title": "1900 United States Federal Census",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9KMX-YBF",
        "citation": "Year: 1900; Census Place: Beaver, Beaver, Utah; Roll: 1682; Page: 1B; Enumeration District: 0070; FHL microfilm: 1241682"
      },
      {
        "title": "============ Life and Census Records =============",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9KMX-1FD",
        "citation": ""
      },
      {
        "title": "Utah, Select County Marriages, 1887-1937",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9KMX-BMQ",
        "citation": ""
      },
      {
        "title": "Utah, Select County Marriages, 1887-1937 (Marriage Date: 19 Jan 1910)",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9KMX-Y1B",
        "citation": "Source Information Ancestry.com. Utah, Select County Marriages, 1887-1937 [database on-line]. Provo, UT, USA: Ancestry.com Operations, Inc., 2014. Original data: Utah, County Marriages, 1887-1937. Salt Lake City, Utah: FamilySearch, 2013."
      },
      {
        "title": "Utah, Select Marriages, 1887-1966 ( Marriage Date: 19 Jan 1910)",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9KMX-Y1Z",
        "citation": "Source Information Ancestry.com. Utah, Select Marriages, 1887-1966 [database on-line]. Provo, UT, USA: Ancestry.com Operations, Inc, 2014. Original data: Utah, Marriages, 1887-1966. Salt Lake City, Utah: FamilySearch, 2013."
      },
      {
        "title": "================ Marriage Records ==============",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9KMX-12Y",
        "citation": ""
      },
      {
        "title": "Web: Utah, Find A Grave Index, 1847-2012 (28 September 1974 Redwood Memorial Cemetery, Taylorsville, Salt Lake County, Utah, United States)",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9KMX-Y1Q",
        "citation": ""
      },
      {
        "title": "Blackner Bessie Louise - find a grave 1974",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSB3-BQJ",
        "citation": "findgrave.com"
      },
      {
        "title": "U.S., Find A Grave Index, 1600s-Current",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9KMX-BM6",
        "citation": ""
      },
      {
        "title": "U.S., Social Security Applications and Claims Index, 1936-2007",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9KMX-B9C",
        "citation": "Source Information Ancestry.com. U.S., Social Security Applications and Claims Index, 1936-2007 [database on-line]. Provo, UT, USA: Ancestry.com Operations, Inc., 2015. Original data: Social Security Applications and Claims, 1936-2007."
      },
      {
        "title": "Web: Utah County, Utah, Obituary Index, 1874-2010 (Publication Date: 3 Oct 1974)",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9KMX-BMV",
        "citation": "Source Information Ancestry.com. Web: Utah County, Utah, Obituary Index, 1874-2010 [database on-line]. Provo, UT, USA: Ancestry.com Operations, Inc., 2011. Original data: Utah County Obituary Index. Brigham Young University. http://www.lib.byu.edu/digital//ucoi/."
      },
      {
        "title": "=========== Death and Obituary Records =============",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9KMF-MMN",
        "citation": ""
      }
    ],
    "portrait": "/ancestors/portraits/023_KWCL-BL4.jpg"
  },
  {
    "id": "I239",
    "name": "Alma Briggs",
    "sex": "M",
    "gen": 5,
    "slot": 14,
    "side": "paternal",
    "birthplace": "england",
    "childId": "I91",
    "birthYear": 1860,
    "deathYear": 1942,
    "birthDate": "8 Jun 1860",
    "deathDate": "28 Jul 1942",
    "burialDate": "31 Jul 1942",
    "christeningDate": "8 Jun 1860",
    "birthPlace": "Accrington, Lancashire, England, United Kingdom",
    "deathPlace": "Salt Lake City, Salt Lake, Utah, United States",
    "burialPlace": "Wasatch Lawn Memorial Park, Salt Lake City, Salt Lake, Utah, United States",
    "christeningPlace": null,
    "fsId": "KWCW-DH3",
    "photo": "/ancestors/bubbles/046_KWCW-DH3.jpg",
    "living": false,
    "alternateNames": [
      "Almer Briggs"
    ],
    "facts": [
      {
        "kind": "Blessing",
        "date": "July 1860",
        "place": null,
        "note": null
      },
      {
        "kind": "Baptism (LDS)",
        "date": "1869",
        "place": "Burnley, Lancashire, England, United Kingdom",
        "note": "age 8 or 9"
      },
      {
        "kind": "Baptism",
        "date": "1869",
        "place": null,
        "note": null
      },
      {
        "kind": "Occupation",
        "date": "1871",
        "place": "Burnley, Lancashire, England, United Kingdom",
        "note": "Labourer at coal pit, age 10"
      },
      {
        "kind": "Residence",
        "date": "1871",
        "place": "Habergham Eaves, Lancashire, England, United Kingdom",
        "note": null
      },
      {
        "kind": "Immigration",
        "date": "1874",
        "place": null,
        "note": null
      },
      {
        "kind": "Occupation",
        "date": "1880",
        "place": "Beaver, Beaver, Utah, United States",
        "note": "Sheep Herder"
      },
      {
        "kind": "Residence",
        "date": "1880",
        "place": "Beaver, Beaver, Utah, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1930",
        "place": "Salt Lake City, Salt Lake, Utah, United States",
        "note": null
      },
      {
        "kind": "Burial Place",
        "date": "31 July 1942",
        "place": "Salt Lake City, Salt Lake, Utah, United States",
        "note": "Flat to the Ground, Granite Heastone"
      },
      {
        "kind": "Obituary",
        "date": "6 August 1942",
        "place": "Utah, United States",
        "note": null
      },
      {
        "kind": "Membership",
        "date": null,
        "place": "Utah, United States",
        "note": null
      }
    ],
    "sketch": "The Life Summary of Alma\nWhen Alma Briggs was born on 8 June 1860, in Oswaldtwistle, Lancashire, England, United Kingdom, his father, James Briggs, was 36 and his mother, Betsy Fielding, was 37. He married Jutta Louisa Almind on 11 January 1885, in Beaver, Beaver, Utah, United States. They were the parents of at least 4 sons and 6 daughters. In 1880, at the age of 20, his occupation is listed as sheep herder in Beaver, Beaver, Utah, United States. He died on 28 July 1942, in Salt Lake City, Salt Lake, Utah, United States, at the age of 82, and was buried in Salt Lake City, Salt Lake, Utah, United States.",
    "sources": [
      {
        "title": "Alma Briggs, 'Geni World Family Tree' on MyHeritage",
        "href": "https://www.familysearch.org/tree/sources/viewedit/W69Y-SF4",
        "citation": "Geni World Family Tree MyHeritage.com [online database], MyHeritage Ltd. Alma Briggs"
      },
      {
        "title": "Alma BRIGGS, 'Filae Family Trees' on MyHeritage",
        "href": "https://www.familysearch.org/tree/sources/viewedit/W69Y-SFQ",
        "citation": "Filae Family Trees MyHeritage.com [online database], MyHeritage Ltd. Alma BRIGGS"
      },
      {
        "title": "Alma BRIGGS, 'Filae Family Trees' on MyHeritage",
        "href": "https://www.familysearch.org/tree/sources/viewedit/W69Y-SFS",
        "citation": "Filae Family Trees MyHeritage.com [online database], MyHeritage Ltd. Alma BRIGGS"
      },
      {
        "title": "Alma Briggs, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q7TW-V6Y",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CT6-CY1K : Sun Sep 13 05:11:10 UTC 2026), Entry for Tressa L Briggs and O A Murdock."
      },
      {
        "title": "Alma Briggs, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QWBW-2HD",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:631F-5KPZ : Sun Sep 13 05:47:55 UTC 2026), Entry for Theresa Lillian Briggs and O A Murdock."
      },
      {
        "title": "Alma, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7QCG-GZJ",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6LPK-J6GM : Thu Mar 26 18:37:52 UTC 2026), Entry for Cora Briggs and Alma."
      },
      {
        "title": "Alma Briggs, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7463-379",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6ZYQ-HBQ3 : Fri Mar 27 04:59:06 UTC 2026), Entry for Ida Lovina Briggs and Alma Briggs."
      },
      {
        "title": "Alma Briggs, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7467-Q8X",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CTZ-PMN2 : Sun Sep 13 05:08:59 UTC 2026), Entry for Ida Lovina Briggs and Alma Briggs."
      },
      {
        "title": "Alma Briggs, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7HS6-P72",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CTH-15LG : Sun Sep 13 04:45:44 UTC 2026), Entry for Moran L Briggs and W.P. Baker."
      },
      {
        "title": "Alma Briggs, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7HS6-L4P",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CBM-VPV3 : Sun Sep 13 05:20:59 UTC 2026), Entry for James Alma Briggs and James Briggs."
      },
      {
        "title": "Alma Briggs, \"New York, Passenger Lists, 1820-1920\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q5GF-S34",
        "citation": "\"New York, Passenger Lists, 1820-1920\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSK-9R6Q : Thu Jul 02 23:09:08 UTC 2026), Entry for Alma Briggs, 1875."
      },
      {
        "title": "Alma Briggs, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q7TW-KR7",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Z5B-9WY6 : Fri Mar 27 04:10:13 UTC 2026), Entry for Norma Luella Briggs and Alma Briggs."
      },
      {
        "title": "Alvin Briggs, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q7TW-L77",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CYG-C89Y : Sun Sep 13 05:33:31 UTC 2026), Entry for Cora Helena Briggs and Alvin Briggs."
      },
      {
        "title": "Alma Briggs, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7HSX-8KV",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Z19-2VQN : Sun Sep 13 04:48:05 UTC 2026), Entry for Bessey Louise Briggs and W S Tolton."
      },
      {
        "title": "Alma Briggs, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7HSX-8TZ",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:DBB5-2R3Z : Sun Sep 13 04:45:38 UTC 2026), Entry for Be?sey Louise Briggs and W S Tolton."
      },
      {
        "title": "Alma Briggs, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q7TW-K9M",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:DB34-FS3Z : Sun Sep 13 05:14:52 UTC 2026), Entry for Norma Luella Briggs and Alma Briggs."
      },
      {
        "title": "Alma Briggs, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q7TW-GSM",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CLG-9P2M : Sun Sep 13 05:21:26 UTC 2026), Entry for James Alma Briggs and Alma Briggs."
      },
      {
        "title": "England, Births and Christenings, 1538-1975; https://familysearch.org/ark:/61903/3:1:S3HY-XCT7-ZKS?cc=1473014",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q26Z-632",
        "citation": "\"England, Births and Christenings, 1538-1975,\" database, FamilySearch (https://familysearch.org/ark:/61903/3:1:S3HY-XCT7-ZKS?cc=1473014 : 20 September 2026), > image 1 of 1."
      },
      {
        "title": "Alma, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7QXG-WMF",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6GFF-YJBR : Fri Mar 27 03:43:49 UTC 2026), Entry for Donald M Briggs and Alma."
      },
      {
        "title": "Alma, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7QXG-WJN",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6GFF-YJT6 : Fri Mar 27 02:20:59 UTC 2026), Entry for Donald M Briggs and Alma."
      },
      {
        "title": "Alma Briggs, \"United States Census, 1900\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMQJ-WQQ",
        "citation": "\"United States, Census, 1900\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MMRN-N24 : Thu Oct 09 04:19:49 UTC 2025), Entry for Alma Briggs and Louisa H. Briggs, 1900."
      },
      {
        "title": "Alma Briggs, \"United States Census, 1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMQJ-WQZ",
        "citation": "\"United States, Census, 1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M5X8-59H : Wed Aug 13 17:29:57 UTC 2025), Entry for Alma Briggs and Louisa Briggs, 1910."
      },
      {
        "title": "Alma Briggs, \"Utah, Salt Lake County Death Records, 1849-1949\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/95DS-4JF",
        "citation": "\"Utah, Salt Lake County Death Records, 1849-1949\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:NQHS-H2N : Fri Mar 08 01:37:10 UTC 2024), Entry for Alma Briggs and James Briggs, 28 Jul 1942."
      },
      {
        "title": "Alma Briggs, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3SKR-5JT",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:89S2-L5N2 : Fri Aug 01 16:49:03 UTC 2025), Entry for Alma Briggs and Louisa Helena Briggs, 1930."
      },
      {
        "title": "Alma Briggs, \"Utah, County Marriages, 1871-1941\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SVKQ-QBV",
        "citation": "\"Utah, County Marriages, 1871-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VRL4-17F : Thu Sep 19 19:57:55 UTC 2024), Entry for and Alma Briggs, 24 Dec 1919."
      },
      {
        "title": "Alma Briggs in household of Ida Briggs Jones, \"United States Census, 1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMQB-VCP",
        "citation": "\"United States, Census, 1940\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VT4N-51Z : Tue Jan 21 13:01:05 UTC 2025), Entry for Ida Briggs Jones and Sandra Jones, 1940."
      },
      {
        "title": "Alma Briggs, \"United States, Western States Marriage Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SQR4-V9L",
        "citation": "\"United States, Western States Marriage Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QPT4-ZNDY : Tue Feb 11 22:38:41 UTC 2025), Entry for Alma Briggs and Louisa H. Almin Christensen, 14 Sep 1892."
      },
      {
        "title": "Alma Briggs, \"United States, Census, 1930\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M9K4-3LK",
        "citation": "\"United States, Census, 1930\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XH6J-854 : Sat Jan 18 07:33:06 UTC 2025), Entry for Alma Briggs and Louise Briggs, 1930."
      },
      {
        "title": "Alma Briggs, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/32B9-BBH",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:89S2-LP6Z : Sat Oct 11 14:59:39 UTC 2025), Entry for Alma Briggs and Moroni Briggs, 1914."
      },
      {
        "title": "Alma Briggs in entry for Donald McGregor Briggs, \"Utah, Birth Certificates, 1903-1914\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/92RM-D5W",
        "citation": "\"Utah, Birth Certificates, 1903-1914\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QL37-JBPQ : Thu Mar 07 00:42:25 UTC 2024), Entry for Donald McGregor Briggs and Alma Briggs, 19 Apr 1907."
      },
      {
        "title": "Alma Briggs, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q7RT-L8J",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6ZB8-1M4V : Fri Mar 27 02:01:29 UTC 2026), Entry for Tressa L Briggs and O A Murdock."
      },
      {
        "title": "Alma Briggs in household of James Briggs, \"United States Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMQJ-W3L",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MNSN-594 : Wed Sep 09 15:08:30 UTC 2026), Entry for James Briggs and Betsy Briggs, 1880."
      },
      {
        "title": "Alma Briggs, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q7RT-VRT",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CY2-ZHPM : Sun Sep 13 05:46:47 UTC 2026), Entry for Cora H Briggs and Jas M Murdock."
      },
      {
        "title": "Alma Briggs, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q7RT-KP1",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Z13-97ML : Sun Sep 13 05:44:59 UTC 2026), Entry for James Alma Briggs and Alma Briggs."
      },
      {
        "title": "Alma Brigs, \"United States Census, 1920\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMQJ-WQG",
        "citation": "\"United States, Census, 1920\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MNB5-7DN : Tue Sep 29 13:39:33 UTC 2026), Entry for Alma Brigs and Luise Brigs, 1920."
      },
      {
        "title": "Almer Briggs in household of James Briggs, \"England and Wales Census, 1871\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMZF-T6X",
        "citation": "\"England and Wales, Census, 1871\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KDDY-LPG : Tue Sep 08 22:02:19 UTC 2026), Entry for Almer Briggs and Betsy A Briggs, 1871."
      },
      {
        "title": "Alma Briggs, \"England and Wales Census, 1861\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMZF-T1W",
        "citation": "\"England and Wales, Census, 1861\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M7LF-VP7 : Thu Sep 10 02:53:56 UTC 2026), Entry for James Briggs and Betsy Briggs, 1861."
      },
      {
        "title": "Alma Briggs, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q7G7-MGD",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Z13-1YZ4 : Sun Sep 13 05:24:26 UTC 2026), Entry for Alma Briggs and Lorin Farr."
      },
      {
        "title": "Alma Briggs, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q7G7-9X4",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CYP-6F11 : Sun Sep 13 05:10:16 UTC 2026), Entry for Alma Briggs and Lorin Farr."
      },
      {
        "title": "Alma Briggs, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q7RT-2K3",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Z13-69DQ : Sun Sep 13 05:35:14 UTC 2026), Entry for Cora Helena Briggs and Alma Briggs."
      },
      {
        "title": "1880 United States Federal Census",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZFX-SHS",
        "citation": "Year: 1880; Census Place: Beaver City, Beaver, Utah"
      },
      {
        "title": "Millennium File",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9FN1-H6N",
        "citation": ""
      },
      {
        "title": "1871 England Census",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZFX-SH9",
        "citation": "Class: RG10; Piece: 4148; Folio: 133; Page: 19; GSU roll: 846732"
      },
      {
        "title": "\"Monuments to Courage\" A History of Beaver County, Utah. (Arrival of the first settlers on February 6, 1856)",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9FGP-C95",
        "citation": "SUU Digital Library Special Collections."
      },
      {
        "title": "Ancestry Family Trees",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9FN1-HNW",
        "citation": "Ancestry Family Tree"
      },
      {
        "title": "James Alma Briggs, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/96KN-ZMH",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QKDV-ZNXV : Fri Jan 17 08:25:12 UTC 2025), Entry for Moroni Laban Briggs and James Alma Briggs, 12 Jun 1960."
      },
      {
        "title": "Alma Briggs in entry for Dennis Fielding Briggs, \"Utah, Marriages, 1887-1935\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSTT-57P",
        "citation": "\"Utah, Marriages, 1887-1935\", database, FamilySearch (https://familysearch.org/ark:/61903/1:1:F8P3-HQP : 28 January 2020), Alma Briggs in entry for Dennis Fielding Briggs, 1929."
      },
      {
        "title": "Alma in entry for William Riley Jones and Ida Lovina Briggs, \"Utah, County Marriages, 1887-1940\" ( Marriage License Event Date: 31 Aug 1937)",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9F7D-M7P",
        "citation": "\"Utah, County Marriages, 1871-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2MB-77GW : Thu Sep 19 20:15:26 UTC 2024), Entry for William Riley Jones and Hugh Alexander Jones, 31 Aug 1937."
      },
      {
        "title": "Alma Briggs in entry for Louise Almind Briggs, \"Utah Death Certificates, 1904-1964\" ( Death Event Date: 23 May 1938)",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9F45-6R1",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZP8-3J4 : Mon Feb 03 19:27:43 UTC 2025), Entry for Louise Almind Briggs and Jacob Almind, 23 May 1938."
      },
      {
        "title": "Alma Briggs in entry for Donald Mcgregor Briggs, \"Utah Death Certificates, 1904-1956\" ( Event Place: Manila, Uintah, Utah, United States ) ( Event Date: 1908 )",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M97V-NX9",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZ2D-MQK : Mon Feb 03 19:04:13 UTC 2025), Entry for Donald Mcgregor Briggs and Alma Briggs, 1908."
      },
      {
        "title": "Alma Briggs, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSTT-CRJ",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZPF-9BZ : Mon Feb 03 19:28:01 UTC 2025), Entry for Alma Briggs and James Briggs, 28 Jul 1942."
      },
      {
        "title": "Alma Briggs, \"Utah, Marriages, 1887-1935\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZFV-2GV",
        "citation": "\"Utah, Marriages, 1887-1935\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:F8P4-38H : 28 January 2020), Alma Briggs, 1892."
      },
      {
        "title": "Alma Briggs, \"Utah, Obituaries from Utah Newspapers, 1850-2005\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9DL1-3J4",
        "citation": "\"Utah, Obituaries from Utah Newspapers, 1850-2005\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSN-SPZ9 : Tue Mar 11 15:33:56 UTC 2025), Entry for Alma Briggs, 06 Aug 1942."
      },
      {
        "title": "Alma Briggs, \"BillionGraves Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZFV-K58",
        "citation": "\"BillionGraves Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KJ35-M3M : Fri Sep 25 00:22:56 UTC 2026), Entry for Alma Briggs."
      },
      {
        "title": "Alma Briggs, \"Utah, Obituaries from Utah Newspapers, 1850-2005\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9DW4-WF7",
        "citation": "\"Utah, Obituaries from Utah Newspapers, 1850-2005\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSN-SPTQ : Tue Mar 11 16:18:08 UTC 2025), Entry for Alma Briggs, 08 Aug 1942."
      },
      {
        "title": "Alma Briggs, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZB6-NKT",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVK5-JWZB : Sat Oct 03 04:00:26 UTC 2026), Entry for Alma Briggs."
      },
      {
        "title": "Alma Briggs in entry for Moroni L Briggs, \"Utah, Marriages, 1887-1935\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9DRB-SMK",
        "citation": "\"Utah, Marriages, 1887-1935\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:F8G4-HZR : 28 January 2020), Alma Briggs in entry for Moroni L Briggs, 1919."
      },
      {
        "title": "Alma Briggs, \"Utah, Deaths and Burials, 1888-1946\" Burial Date: 31 Jul 1942",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMQJ-W33",
        "citation": "\"Utah, Deaths and Burials, 1888-1946\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:F85K-XQD : 28 January 2020), Alma Briggs, 1942."
      },
      {
        "title": "Alma Briggs, \"Utah, County Marriages, 1887-1937\" (14 Sept 1892)",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMQB-JXN",
        "citation": "\"Utah, County Marriages, 1871-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VRLL-8D7 : Thu Sep 19 19:32:44 UTC 2024), Entry for Alma Briggs and Louisa Christenson Almon, 14 Sep 1892."
      },
      {
        "title": "Alma Briggs, \"Utah, County Marriages, 1871-1941\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSTN-J5F",
        "citation": "\"Utah, County Marriages, 1871-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KSPQ-8T9 : Thu Sep 19 20:19:13 UTC 2024), Entry for Dennis Fielding Briggs and Alma Briggs, 18 Oct 1929."
      },
      {
        "title": "U.S. City Directories, 1821-1989",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9FN1-HFC",
        "citation": ""
      },
      {
        "title": "1861 England Census",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZFX-SHM",
        "citation": "Class: RG 9; Piece: 3063; Folio: 9; Page: 11; GSU roll: 543072"
      },
      {
        "title": "1880 United States Federal Census",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9FN1-HXV",
        "citation": "Year: 1880; Census Place: Beaver City, Beaver, Utah; Roll: 1335; Family History Film: 1255335; Page: 1A; Enumeration District: 001"
      },
      {
        "title": "James and Betsy Briggs family in the 1880 Utah census, Beaver, Beaver, Utah Territory, USA",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMZF-BRD",
        "citation": "I have a copy of the image, if the link becomes broken, The image does not come up under a search for James Briggs. The data entry person probably misread the last name, as I look at the handwriting. I found the image while searching for either George Washington Olcott and George Agustus Olcott, who are also listed on the page."
      },
      {
        "title": "Beaver County, Utah Census, 1900",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9FN1-H6P",
        "citation": ""
      },
      {
        "title": "1940 United States Federal Census",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9FN1-H69",
        "citation": "Year: 1940; Census Place: Salt Lake, Salt Lake, Utah; Roll: T627_4224; Page: 11A; Enumeration District: 30-64"
      },
      {
        "title": "1920 United States Federal Census",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9FN1-HXS",
        "citation": "Year: 1920; Census Place: Lyman, Uinta, Wyoming; Roll: T625_2029; Page: 7B; Enumeration District: 99; Image: 578"
      },
      {
        "title": "1910 United States Federal Census",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9FN1-HDG",
        "citation": "Year: 1910; Census Place: Manila, Uintah, Utah; Roll: T624_1609; Page: 2A; Enumeration District: 0242; FHL microfilm: 1375622"
      },
      {
        "title": "1900 United States Federal Census",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9FN1-HDZ",
        "citation": "Year: 1900; Census Place: Beaver, Beaver, Utah; Roll: 1682; Page: 1B; Enumeration District: 0070; FHL microfilm: 1241682"
      },
      {
        "title": "1930 United States Federal Census",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9FN1-HX5",
        "citation": "Year: 1930; Census Place: Salt Lake City, Salt Lake, Utah; Roll: 2421; Page: 31A; Enumeration District: 0057; Image: 285.0; FHL microfilm: 2342155"
      },
      {
        "title": "Utah, Select Marriages, 1887-1966",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9FN1-HFZ",
        "citation": ""
      },
      {
        "title": "Utah, Select Marriages, 1887-1966",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9FN1-HF2",
        "citation": ""
      },
      {
        "title": "England & Wales, FreeBMD Birth Index, 1837-1915",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9FN1-HXB",
        "citation": ""
      },
      {
        "title": "Alma Briggs in entry for Donald Mcgregor Briggs, \"Utah Death Certificates, 1904-1956\" ( Death Event Date: 1908)",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9FN1-HF3",
        "citation": "\"Utah Death Certificates, 1904-1956,\" index and images, FamilySearch (https://familysearch.org/pal:/MM9.1.1/XZ2D-MQ2 : accessed 03 Jul 2014), Alma Briggs in entry for Donald Mcgregor Briggs, 1908; citing Manila, Uintah, Utah, United States, certificate , S"
      },
      {
        "title": "Utah, Select County Marriages, 1887-1937",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9FN1-HXL",
        "citation": ""
      },
      {
        "title": "Utah, Death and Military Death Certificates, 1904-1961",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9FN1-HXW",
        "citation": ""
      },
      {
        "title": "Obituary of Alma Briggs, died: 28 July 1942 (Newspaper: Salt Lake Telegram 1942 July 30, Obituaries)",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M9S3-9FL",
        "citation": "Website www.utahdigitalnewspapers.org Title: Salt Lake Telegram 1942-07-30 Publisher: Digitized by: Univ. of Utah Date.Original 1942-07-30 Type: newspaper Format: text\\PDF Language: eng Rights: Material in the public domain. No restrictions on use. Item.Year: 1942 Item.Month: July Item.Day: 30 Genre: newspaper ARK: ark:/87278/s6087dnd"
      },
      {
        "title": "Alma Briggs (1860-1942) Wasatch Lawn Memorial Park, Salt Lake City, Salt Lake, Utah, USA",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZY5-RDW",
        "citation": "Created by: Jennifer Palmer Record added: Apr 04, 2010 Find A Grave Memorial# 50643350"
      },
      {
        "title": "Utah Death Registers, 1847-1966",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9FN1-HX6",
        "citation": "Utah State Archives and Records Service; Salt Lake City, UT; Utah State Archives and Records Service; File Number #: 1942002855"
      },
      {
        "title": "Salt Lake County, Utah, Death Records, 1908-1949",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9FN1-HDB",
        "citation": ""
      },
      {
        "title": "Alma Briggs, \"Utah, Deaths and Burials, 1888-1946\" Burial Date: 31 Jul 1942",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9FN1-HFT",
        "citation": "\"Utah, Deaths and Burials, 1888-1946,\" index, FamilySearch (https://familysearch.org/pal:/MM9.1.1/F85K-XQD : accessed 03 Jul 2014), Alma Briggs, 28 Jul 1942; citing Salt Lake City, Salt Lake, Utah, reference 1440 p 323; FHL microfilm 26575."
      },
      {
        "title": "U.S., Find A Grave Index, 1600s-Current",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9FN1-HDX",
        "citation": ""
      },
      {
        "title": "Headstone image of Alma Briggs from billiongraves.com",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMZ5-QC4",
        "citation": "Transcription of headstone image from billiongraves.com. Image taken at Wasatch Lawn Memorial Park (Salt Lake City, Salt Lake, Utah, United States) on 22 June 2013"
      }
    ],
    "portrait": "/ancestors/portraits/046_KWCW-DH3.jpg"
  },
  {
    "id": "I498",
    "name": "James Briggs",
    "sex": "M",
    "gen": 6,
    "slot": 28,
    "side": "paternal",
    "birthplace": "england",
    "childId": "I239",
    "birthYear": 1823,
    "deathYear": 1913,
    "birthDate": "1 Aug 1823",
    "deathDate": "24 Jul 1913",
    "burialDate": "27 Jul 1913",
    "christeningDate": null,
    "birthPlace": "Accrington, Lancashire, England, United Kingdom",
    "deathPlace": "Beaver, Beaver, Utah, United States",
    "burialPlace": "Mountain View Cemetery, Beaver, Beaver, Utah, United States",
    "christeningPlace": null,
    "fsId": "KWJ4-W4X",
    "photo": "/ancestors/bubbles/092_KWJ4-W4X.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [
      {
        "kind": "Sister\"s Birth: ( Nehemiah Briggs )",
        "date": "4 February 1824",
        "place": "Lancashire, England, United Kingdom",
        "note": "James Briggs age: 1 year old when his sister was born on 4 February 1824, possible birthplace: Accrington, Lancashire, England, United Kingdom, ( Accrington is a town in the Hyndburn borough of Lancashire, England. It lies about 4 miles east of Blackburn, 6 miles west of Burnley, 13 miles east of Preston, 20 miles north of Manchester city centre)"
      },
      {
        "kind": "Film #025641 - 35 copied record by Lola Louise Lindsay from Film #",
        "date": "27 October 1824",
        "place": "Lancashire, England, United Kingdom",
        "note": "35 - James Briggs, Robert Briggs Mary Howarth 27 Oct 1824 Accrington, Lancashire, England"
      },
      {
        "kind": "Death of Mother",
        "date": "2 August 1832",
        "place": "Accrington, Lancashire, England, United Kingdom",
        "note": "James Briggs, was at age: 4 years old his Mother Died, about 1827 in Accrington, Lancashire, England, United Kingdom / ( History of JAMES BRIGGS August 11, 1823 - July 21, 1913 Written by Mary Ellen Olcott Raikes as dictated to her by her mother, Betsy Alice Briggs Olcott Waters (Daughter of James & Betsy Briggs) (Note: Reason This Information Is Correct She could not have died in 1828 because she had children after that date, per christening records of children Modified | History 1 May 2017 by lindahoward1) Birth of last child: (Maria Briggs KHS2-ZDJ&#8203;) - BIRTH: 2 August 1832, Whitefield, Prestwich, Lancashire, England, United Kindom"
      },
      {
        "kind": "Father (Robert Briggs) married Second Wife ( Esther Airy Tayler)",
        "date": "8 August 1836",
        "place": "Oswaldtwistle, Lancashire, England, United Kingdom",
        "note": "James Briggs at age 13 years old, his Father, (Robert Briggs) married a second Wife (Esther Airy Tayler) on 8 August 1836 in Oswaldtwistle, Lancashire, , England."
      },
      {
        "kind": "Baptism (LDS)",
        "date": "September 1844",
        "place": "Accrington, Lancashire, England, United Kingdom",
        "note": "Baptism (LDS) by Robert Parker, 1820–1901 – KWJ4-W6B &#8203;- in England - Robert Parker, himself was baptized in 1840 in Old Accrington, Lancashire, England. Robert's history states that Robert, himself, did missionary work in England before he left England with his Family in 1856 and arrived in Utah about October 1856. He Settled in Washington, Utah. His Grandson was Robert LeRoy Parker (better known as Butch Cassidy)."
      },
      {
        "kind": "Confirmation (LDS)",
        "date": "September 1844",
        "place": "Accrington, Lancashire, England, United Kingdom",
        "note": "Confirmation (LDS) for James Briggs by Beng M Wright on September 1844 in Accrington, Lancashire, England."
      },
      {
        "kind": "Occupation",
        "date": "9 August 1845",
        "place": "Oswaldtwistle, Lancashire, England, United Kingdom",
        "note": "Laborer"
      },
      {
        "kind": "Marriage too: ( Betsy Fielding age: 22  ) James Briggs age: 22",
        "date": "9 August 1845",
        "place": "Accrington, Lancashire, England, United Kingdom",
        "note": "Spouse: Betsy Fielding"
      },
      {
        "kind": "Marriage Notice",
        "date": "7 April 1847",
        "place": "Manchester, Lancashire, England, United Kingdom",
        "note": null
      },
      {
        "kind": "Daughter's Birth: Mary Briggs",
        "date": "23 June 1847",
        "place": "Oswaldtwistle, Lancashire, England, United Kingdom",
        "note": "Birth of Daughter: (Mary Briggs) on 23 June 1847 in Tinker, Oswaldtwisle, Lancashire, England by Parents: James Briggs age: 24, Married, Betsy Fielding age: 24"
      },
      {
        "kind": "Residence",
        "date": "1851",
        "place": "Accrington, Lancashire, England, United Kingdom",
        "note": "Living at Lodge Tavern in New Accrington in 1851 census"
      },
      {
        "kind": "Residence",
        "date": "1851",
        "place": "Lancashire, England, United Kingdom",
        "note": null
      },
      {
        "kind": "Occupation",
        "date": "1861",
        "place": "Accrington, Lancashire, England, United Kingdom",
        "note": "Laborer at dye works"
      },
      {
        "kind": "Residence",
        "date": "1861",
        "place": "Headlee Woods, Franklin Number 1 Township, Greene, Missouri, United States",
        "note": null
      },
      {
        "kind": "Step-Mother Died (Esther Airy Taylor - Briggs)",
        "date": "April 1862",
        "place": "Accrington, Lancashire, England, United Kingdom",
        "note": "James Briggs age: 39 - Burial: 7 April 1862 St James, Accrington, Lancashire, England"
      },
      {
        "kind": "Death of Father; Robert Briggs",
        "date": "12 May 1863",
        "place": "Lancashire, England, United Kingdom",
        "note": "James Briggs's was 40 years old when his father died on 12 May 1863 in Lancashire, England, United Kingdom, before James and Betsy Briggs left England for America to live."
      },
      {
        "kind": "Occupation",
        "date": "1871",
        "place": "Church, Lancashire, England, United Kingdom",
        "note": "Agricultural Laborer"
      },
      {
        "kind": "Immigration from Liverpool, Lancashire, England, United Kingdom",
        "date": "30 June 1875",
        "place": "Liverpool, Lancashire, England, United Kingdom",
        "note": "James and Betsy Briggs, left for Utah in the United States of America on June 30, 1875, on the ship, \"Idaho,\" with four of their children, Betsy Alice, John, Alma, and Sarah. under Capt.. Christen G. Larsen. They Arrived 14 Jul 1875 in New York City; The family arrived in Utah by rail on 22 Jul 1875 from Philadelphia, through Columbus, and Omaha... James Briggs, Betsy Briggs, John, Alma, Betsy Alice and Sarah."
      },
      {
        "kind": "James and Betsy left for the United States of America",
        "date": "30 June 1875",
        "place": "England, United Kingdom",
        "note": "James Briggs age 52. / James and Betsy left Liverpool, England for the United States of America on June 30, 1875, on the ship, \"Idaho,\" with four of their children, Betsy Alice, John, Alma, and Sarah. under Capt.. Christen G. Larsen. ( Written by Mary Ellen Olcott Raikes, as dictated to her by her mother, Betsy Alice Briggs Olcott Waters ( Daughter of James and Betsy Briggs)"
      },
      {
        "kind": "Immigration",
        "date": "14 July 1875",
        "place": "New York City, New York, United States",
        "note": "Immigration to U.S. and then to Utah"
      },
      {
        "kind": "Immigration:  Arrival into Salt Lake by Railway",
        "date": "22 July 1875",
        "place": "Salt Lake City, Salt Lake, Utah, United States",
        "note": "James and Betsy Briggs, and their children, Betsy Alice, John, Alma, and Sarah, arrived into Salt Lake Valley on 22 July 1875, by Railway from Philadelphia, through Columbus, and Omaha"
      },
      {
        "kind": "Custom event",
        "date": "1876",
        "place": null,
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1880",
        "place": "Beaver, Beaver, Utah, United States",
        "note": null
      },
      {
        "kind": "Occupation",
        "date": "1880",
        "place": "Beaver, Beaver, Utah, United States",
        "note": "Woolen Factory Worker"
      },
      {
        "kind": "Residence",
        "date": "1891",
        "place": "Tottington, Lancashire, England, United Kingdom",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1900",
        "place": "Beaver Election Precinct, Beaver, Utah, United States",
        "note": null
      },
      {
        "kind": "Literate",
        "date": null,
        "place": null,
        "note": "Able to read and write per 1910 census."
      },
      {
        "kind": "Father (John Fielding) Moved in with James and Betsy Briggs",
        "date": null,
        "place": null,
        "note": "Written by Mary Ellen Olcott Raikes, as dictated to her by her mother, Betsy Alice Briggs Olcott Waters ( Daughter of James and Betsy Briggs)"
      },
      {
        "kind": "Residence",
        "date": null,
        "place": "Stand, Lancashire, England, United Kingdom",
        "note": null
      },
      {
        "kind": "Occupation",
        "date": null,
        "place": "Beaver, Beaver, Utah, United States",
        "note": "Calico Printer"
      },
      {
        "kind": "Record",
        "date": null,
        "place": "Accrington, Lancashire, England, United Kingdom",
        "note": "James was a Methodist Minister who convereted his entire congregation to the Mormon faith."
      },
      {
        "kind": "Occupation",
        "date": null,
        "place": null,
        "note": "Retailer Of Beer"
      },
      {
        "kind": "Occupation",
        "date": null,
        "place": null,
        "note": "Retired Farmer"
      },
      {
        "kind": "Occupation",
        "date": null,
        "place": null,
        "note": "Farmer"
      }
    ],
    "sketch": "*The Life Summary of James\nWhen James Briggs was born on 1 August 1823, in Accrington, Lancashire, England, United Kingdom, his father, Robert Briggs, was 27 and his mother, Mary Hawarth, was 26. He married Betsy Fielding on 9 August 1845, in Church, Lancashire, England, United Kingdom. They were the parents of at least 7 sons and 4 daughters. He lived in Beaver Election Precinct, Beaver, Utah, United States in 1900. His occupation is listed as calico printer in Beaver, Beaver, Utah, United States. He died on 24 July 1913, in Beaver, Beaver, Utah, United States, at the age of 89, and was buried in Mountain View Cemetery, Beaver, Beaver, Utah, United States.",
    "sources": [
      {
        "title": "James Briggs, 'Geni World Family Tree' on MyHeritage",
        "href": "https://www.familysearch.org/tree/sources/viewedit/W69Y-SNM",
        "citation": "Geni World Family Tree MyHeritage.com [online database], MyHeritage Ltd. James Briggs"
      },
      {
        "title": "James Spencer BRIGGS, 'Filae Family Trees' on MyHeritage",
        "href": "https://www.familysearch.org/tree/sources/viewedit/W69Y-SFP",
        "citation": "Filae Family Trees MyHeritage.com [online database], MyHeritage Ltd. James Spencer BRIGGS"
      },
      {
        "title": "James Briggs, \"England, Manchester, Parish Registers, 1603-1954\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/WDJ9-4Z9",
        "citation": "\"England, Manchester, Parish Registers, 1603-1954\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:FMR8-JHH : Wed Sep 09 21:39:59 UTC 2026), Entry for James Briggs and James Briggs, 6 May 1849."
      },
      {
        "title": "James Briggs, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/WX4D-QQ9",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Z1C-QP91 : Sun Sep 13 05:19:34 UTC 2026), Entry for Joseph Briggs and James Briggs."
      },
      {
        "title": "James Briggs, \"England, Manchester, Parish Registers, 1603-1954\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QWMN-KZV",
        "citation": "\"England, Manchester, Parish Registers, 1603-1954\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QK1H-9Z4F : Wed Sep 09 20:10:07 UTC 2026), Entry for Mary Briggs and James Briggs, 14 March 1851."
      },
      {
        "title": "James Briggs, \"England and Wales, Census, 1851\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7Q31-9LV",
        "citation": "\"England and Wales, Census, 1851\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:SGPY-VFG : Fri Aug 21 09:30:03 UTC 2026), Entry for James Briggs and Betty Briggs, 1851."
      },
      {
        "title": "James Briggs, \"England, Manchester, Parish Registers, 1603-1954\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/WDJ9-HJC",
        "citation": "\"England, Manchester, Parish Registers, 1603-1954\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:FMR8-N32 : Wed Sep 09 23:32:52 UTC 2026), Entry for William Briggs and James Briggs, 4 June 1848."
      },
      {
        "title": "James Briggs, \"England, Manchester, Parish Registers, 1603-1954\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QWMN-5NS",
        "citation": "\"England, Manchester, Parish Registers, 1603-1954\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QK1H-39LQ : Tue Sep 08 21:22:03 UTC 2026), Entry for Mary Briggs and James Briggs, 18 March 1851."
      },
      {
        "title": "James Briggs, \"England, Manchester, Parish Registers, 1603-1954\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/WDZY-Z5M",
        "citation": "\"England, Manchester, Parish Registers, 1603-1954\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QK1H-9Z4F : Wed Sep 09 20:10:07 UTC 2026), Entry for Mary Briggs and James Briggs, 14 March 1851."
      },
      {
        "title": "James Briggs in entry for Nancy Briggs, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/WDZY-8J8",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:JQV1-NKQ : 4 February 2023), James Briggs in entry for Nancy Briggs, 1850."
      },
      {
        "title": "James Briggs in entry for James Briggs, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/WDJ9-CRP",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:NFND-5BL : 4 February 2023), James Briggs in entry for James Briggs, 1849."
      },
      {
        "title": "James Briggs, \"England Marriages, 1538–1973\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7WDV-SK3",
        "citation": "\"England Marriages, 1538–1973\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:NNT9-76J : Sat Aug 01 19:05:48 UTC 2026), Entry for John Briggs and James Briggs, 15 November 1884."
      },
      {
        "title": "James Briggs, \"England, Manchester, Parish Registers, 1603-1954\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/WDJ9-674",
        "citation": "\"England, Manchester, Parish Registers, 1603-1954\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:FMR8-1HC : Wed Sep 09 23:17:33 UTC 2026), Entry for Susannah Briggs and James Briggs, 14 February 1858."
      },
      {
        "title": "James Briggs, \"England, Manchester, Parish Registers, 1603-1954\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QCRS-N28",
        "citation": "\"England, Manchester, Parish Registers, 1603-1954\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QK1H-917X : Wed Sep 09 18:10:19 UTC 2026), Entry for Jane Briggs and James Briggs, 19 May 1856."
      },
      {
        "title": "James Briggs in entry for William Briggs, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/WDJ9-ZB6",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:NT8V-H13 : 4 February 2023), James Briggs in entry for William Briggs, 1848."
      },
      {
        "title": "James Briggs in entry for Mary Briggs, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SCGW-1J2",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:NT49-V35 : 5 February 2023), James Briggs in entry for Mary Briggs, 1851."
      },
      {
        "title": "James Briggs in entry for Jane Briggs, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QCRS-NHZ",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:NXBV-F49 : 5 February 2023), James Briggs in entry for Jane Briggs, 1856."
      },
      {
        "title": "James Briggs, \"England, Manchester, Parish Registers, 1603-1954\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/WDJ9-W38",
        "citation": "\"England, Manchester, Parish Registers, 1603-1954\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:FMRD-S4D : Wed Sep 09 23:32:43 UTC 2026), Entry for John Briggs and James Briggs, 7 October 1860."
      },
      {
        "title": "James Briggs, \"England, Manchester, Parish Registers, 1603-1954\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/WDJ9-DSS",
        "citation": "\"England, Manchester, Parish Registers, 1603-1954\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:FMR8-1HW : Wed Sep 09 22:41:07 UTC 2026), Entry for Maria Briggs and James Briggs, 14 February 1858."
      },
      {
        "title": "James Briggs, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/WXR9-WM2",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:DBQ7-SRN2 : Sun Sep 13 05:20:37 UTC 2026), Entry for Joseph Briggs and James Briggs."
      },
      {
        "title": "U.S., Find A Grave Index, 1700s-Current",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q5XZ-JZ7",
        "citation": ""
      },
      {
        "title": "England, Births and Christenings, 1538-1975; https://familysearch.org/ark:/61903/3:1:S3HY-XCT7-ZKS?cc=1473014",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q26Z-632",
        "citation": "\"England, Births and Christenings, 1538-1975,\" database, FamilySearch (https://familysearch.org/ark:/61903/3:1:S3HY-XCT7-ZKS?cc=1473014 : 20 September 2026), > image 1 of 1."
      },
      {
        "title": "James Briggs, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q7G7-S29",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Z13-1YZM : Sun Sep 13 04:40:41 UTC 2026), Entry for Mary Briggs and James Briggs."
      },
      {
        "title": "James Briggs, \"England, Deaths and Burials, 1538-1991\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SC2J-3V5",
        "citation": "\"England, Deaths and Burials, 1538-1991\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:JC1M-DWG : Sat Jul 25 02:29:34 UTC 2026), Entry for Mary Briggs and James Briggs, 18 Mar 1851."
      },
      {
        "title": "James Briggs, \"England Marriages, 1538–1973\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3W7G-YQ5",
        "citation": "\"England Marriages, 1538–1973\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:NNLB-DYN : Sat Aug 01 14:53:54 UTC 2026), Entry for Joseph Allen and William Allen, 1 January 1876."
      },
      {
        "title": "James Briggs, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q7GQ-BQL",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CYP-DPP6 : Sun Sep 13 05:43:31 UTC 2026), Entry for Sarah Briggs and John Haycock."
      },
      {
        "title": "James, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q7G7-Q94",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CT4-XC8L : Sun Sep 13 05:14:46 UTC 2026), Entry for Sarah Briggs and James."
      },
      {
        "title": "James Briggs, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q7G7-91W",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CYP-6F1G : Sun Sep 13 05:11:10 UTC 2026), Entry for Mary Briggs and James Briggs."
      },
      {
        "title": "James Briggs, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q7G7-WBC",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:DB2J-3RPZ : Sun Sep 13 05:37:31 UTC 2026), Entry for Joseph Briggs and James Briggs."
      },
      {
        "title": "James Briggs, \"England and Wales, Census, 1851\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7NT7-43Q",
        "citation": "\"England and Wales, Census, 1851\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:SGPB-P8H : Fri Aug 21 09:14:02 UTC 2026), Entry for James Briggs and Betsy Briggs, 1851."
      },
      {
        "title": "James Briggs, \"British Newspaper Archive, Family Notices\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SYH1-THZ",
        "citation": "\"British Newspaper Archive, Family Notices\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QLSH-FKMH : Sat Jul 06 13:39:56 UTC 2024), Entry for James Briggs and Betty Entwhistle, 7 Apr 1847."
      },
      {
        "title": "James Briggs in entry for John Briggs, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3W7G-13D",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:NXBV-658 : 5 February 2023), James Briggs in entry for John Briggs, 1853."
      },
      {
        "title": "James Briggs, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q7G7-WHK",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Z1L-ZNF5 : Sun Sep 13 05:47:18 UTC 2026), Entry for Joseph Briggs and James Briggs."
      },
      {
        "title": "James Briggs, \"England, Manchester, Parish Registers, 1603-1954\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/WDZY-C28",
        "citation": "\"England, Manchester, Parish Registers, 1603-1954\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:FMR8-KXX : Wed Sep 09 19:25:02 UTC 2026), Entry for Nancy Briggs and James Briggs, 13 October 1850."
      },
      {
        "title": "James Briggs, \"England, Manchester, Parish Registers, 1603-1954\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3W7G-1VC",
        "citation": "\"England, Manchester, Parish Registers, 1603-1954\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QK1H-9Y8Z : Wed Sep 09 19:34:20 UTC 2026), Entry for John Briggs and James Briggs, 5 June 1853."
      },
      {
        "title": "James Briggs, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q7G7-MJH",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Z13-1YZ4 : Sun Sep 13 05:24:26 UTC 2026), Entry for Alma Briggs and Lorin Farr."
      },
      {
        "title": "James Briggs, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q7G7-QV5",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Z13-1YZ8 : Sun Sep 13 05:12:04 UTC 2026), Entry for Sarah Briggs and John Heycock."
      },
      {
        "title": "James Briggs, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QJZ7-V9X",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CTH-TWBB : Sun Sep 13 05:19:34 UTC 2026), Entry for Robert Briggs and James Briggs."
      },
      {
        "title": "James Briggs, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q7G7-9Z3",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CYP-6F11 : Sun Sep 13 05:10:16 UTC 2026), Entry for Alma Briggs and Lorin Farr."
      },
      {
        "title": "James Briggs, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q7G7-3Z2",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CYP-6F1R : Sun Sep 13 04:41:21 UTC 2026), Entry for John Briggs and Edwin Biles."
      },
      {
        "title": "============ Life and Census Records =============",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9V13-8FS",
        "citation": ""
      },
      {
        "title": "1851 England census",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MM8K-G7Q",
        "citation": "England 1851 census, New Accrington, Lancashire, England"
      },
      {
        "title": "1880 Utah U.S. Census Beaver, Beaver, Utah",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMZF-Y11",
        "citation": "Photocopy in my possession. Can be found online, but for some reason it doesn't come up in a search of James Briggs. See link above for image."
      },
      {
        "title": "============== Marriage Records ===================",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9V13-8GC",
        "citation": ""
      },
      {
        "title": "================ Death Records ==================",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9V13-D7N",
        "citation": ""
      },
      {
        "title": "James Briggs in entry for Joseph Briggs, \"Utah Death Certificates, 1904-1956\" ( 12 Dec 1922 )",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSTT-V2K",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZ2L-V2Y : Mon Feb 03 19:16:49 UTC 2025), Entry for Joseph Briggs and James Briggs, 12 Dec 1922."
      },
      {
        "title": "James Briggs, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q7GQ-RB7",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Z13-1YZ3 : Sun Sep 13 05:22:55 UTC 2026), Entry for John Briggs and Edwin Biles."
      },
      {
        "title": "James Briggs, \"England and Wales Census, 1861\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMCZ-X75",
        "citation": "\"England and Wales, Census, 1861\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M7LF-VP7 : Thu Sep 10 02:53:56 UTC 2026), Entry for James Briggs and Betsy Briggs, 1861."
      },
      {
        "title": "James Briggs, \"England and Wales Census, 1871\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMCZ-GSQ",
        "citation": "\"England and Wales, Census, 1871\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KDDY-LPV : Tue Sep 08 21:59:55 UTC 2026), Entry for James Briggs and Betsy Briggs, 1871."
      },
      {
        "title": "James Briggs in entry for John Sr. Briggs, \"Utah Death Certificates, 1904-1956\" ( 02 Nov 1931 )",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSTT-HPT",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZGY-DD2 : Mon Feb 03 19:22:43 UTC 2025), Entry for John Sr. Briggs and James Briggs, 02 Nov 1931."
      },
      {
        "title": "James Briggs, \"England, Lancashire, Parish Registers 1538-1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9296-PV7",
        "citation": "\"England, Lancashire, Parish Registers 1538-1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QKKH-ZQ53 : Tue Sep 08 20:56:03 UTC 2026), Entry for James Briggs and Robert Briggs, 09 Aug 1845."
      },
      {
        "title": "James, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q7GQ-YZN",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CT4-XC8V : Sun Sep 13 05:10:55 UTC 2026), Entry for John Briggs and James."
      },
      {
        "title": "James Briggs, \"United States, Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M9K4-M6L",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MNSN-594 : Wed Sep 09 15:08:30 UTC 2026), Entry for James Briggs and Betsy Briggs, 1880."
      },
      {
        "title": "James Briggs in entry for Nancy Briggs Berkinshaw, \"Utah Death Certificates, 1904-1956\" ( 15 Feb 1911 )",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSTT-JDW",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZG3-545 : Mon Feb 03 19:07:05 UTC 2025), Entry for Nancy Briggs Berkinshaw and James Briggs, 15 Feb 1911."
      },
      {
        "title": "James Briggs in household of Robert Briggs, \"United States Census, 1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMQJ-WWW",
        "citation": "\"United States, Census, 1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XMY1-L1B : Wed Aug 13 17:27:25 UTC 2025), Entry for Robert Briggs and Rachel S Briggs, 1910."
      },
      {
        "title": "James Briggs, \"England Marriages, 1538–1973 \" (Marriage Event Date: 09 Aug 1845)",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMCZ-X8V",
        "citation": "\"England Marriages, 1538–1973\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:N2B8-L4H : Sat Aug 01 18:05:54 UTC 2026), Entry for James Briggs and Betsy Fielding, 9 August 1845."
      },
      {
        "title": "James Briggs in entry for John Briggs, \"Utah, Early Mormon Missionary Database\" ( Mission Event Date: 1887)",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9X5T-WRH",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Missionary Registers (Worldwide), 1860-1937\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QKDW-TTKZ : Tue Mar 11 16:23:36 UTC 2025), Entry for John Briggs and Edwin Biles, 1887."
      },
      {
        "title": "James Briggs, \"United States, Census, 1900\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M9K4-MLF",
        "citation": "\"United States, Census, 1900\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MMRN-NLR : Sat Oct 18 14:27:19 UTC 2025), Entry for James Briggs and Betsy Briggs, 1900."
      },
      {
        "title": "James Briggs in entry for Joseph Briggs and Mary Ann Waut, \"England Marriages, 1538–1973 \" (Marriage Event Date: 07 Sep 1872)",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M9K4-97P",
        "citation": "\"England Marriages, 1538–1973\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:NXDN-6QB : Sat Aug 01 17:59:28 UTC 2026), Entry for Joseph Briggs and James Briggs, 7 September 1872."
      },
      {
        "title": "James Briggs in entry for John Briggs, \"Utah, Early Mormon Missionary Database\" ( Mission Event Date: 1887)",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9XGP-H1P",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Missionary Registers (Worldwide), 1860-1937\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QKDW-TDCC : Tue Mar 11 16:23:09 UTC 2025), Entry for John Briggs and Edwin Biles, 1887."
      },
      {
        "title": "Findagrave Memorial Burial for James Briggs, Beaver Cemetery, Beaver, Utah",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMBH-PXR",
        "citation": "Mountain View Cemetery Beaver Beaver County Utah, USA Plot: Plot: D_512_2"
      },
      {
        "title": "Headstone image of James Briggs from billiongraves.com",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M9JL-BKD",
        "citation": "Transcription of headstone image from billiongraves.com. Image taken at Mountain View Cemetery (Beaver, Beaver, Utah, United States) on 28 May 2013"
      },
      {
        "title": "James Briggs, \"BillionGraves Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZFV-T6R",
        "citation": "\"BillionGraves Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KJ9H-H56 : Thu Sep 24 19:11:31 UTC 2026), Entry for James Briggs."
      },
      {
        "title": "James Briggs in entry for Alma Briggs, \"Utah, Salt Lake County Death Records, 1908-1949\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMCZ-X65",
        "citation": "\"Utah, Salt Lake County Death Records, 1849-1949\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:NQHS-H2N : Fri Mar 08 01:37:10 UTC 2024), Entry for Alma Briggs and James Briggs, 28 Jul 1942."
      },
      {
        "title": "James Briggs in entry for John Briggs Sr., \"Utah, Deaths and Burials, 1888-1946\" (Death Date: 02 Nov 1931)",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMCZ-X2L",
        "citation": "\"Utah, Deaths and Burials, 1888-1946\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:F85Z-9SX : 22 September 2026), James Briggs in entry for John Briggs Sr., 1931."
      },
      {
        "title": "James Briggs in entry for Nancy Briggs Burkinshaw, \"Utah, Deaths and Burials, 1888-1946\" ( 15 Feb 1911 )",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M9K4-MB3",
        "citation": "\"Utah, Deaths and Burials, 1888-1946\", database, FamilySearch (https://familysearch.org/ark:/61903/1:1:F85N-PFL : 28 January 2020), James Briggs in entry for Nancy Briggs Burkinshaw, 1911."
      },
      {
        "title": "James Briggs in entry for Betsy Alice Waters, \"Utah Death Certificates, 1904-1956\" (Death Event Date: 23 July 1949)",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSTT-W56",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZLJ-994 : Mon Feb 03 19:01:44 UTC 2025), Entry for Betsy Alice Waters and James Briggs, 23 Jul 1949."
      },
      {
        "title": "James Briggs in entry for Sarah Briggs Roberts, \"Utah Death Certificates, 1904-1956\" ( 31 May 1938 )",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSTT-5BG",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZP8-V6X : Mon Feb 03 19:20:00 UTC 2025), Entry for Sarah Briggs Roberts and James Briggs, 31 May 1938."
      },
      {
        "title": "James Briggs, \"Utah Death Certificates, 1904-1956\" (Death Event Date: 24 Jul 1913)",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMQJ-WWX",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZPL-35M : Mon Feb 03 19:07:52 UTC 2025), Entry for James Briggs and Robt Briggs, 24 Jul 1913."
      },
      {
        "title": "James Briggs, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZFV-G92",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVKN-2451 : Sat Oct 03 15:14:15 UTC 2026), Entry for James Briggs."
      },
      {
        "title": "Unknown in entry for Robert Briggs, \"Utah Death Certificates, 1904-1964\" ( Death Event Date: 23 May 1940)",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9X3J-K8C",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZP4-58P : Mon Feb 03 19:18:05 UTC 2025), Entry for Robert Briggs and Unknown, 23 May 1940."
      },
      {
        "title": "James Briggs in entry for Nancy Briggs Berkinshaw, \"Utah, Salt Lake County Death Records, 1908-1949\" (Death Date: 15 Feb 1911)",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M9PW-QVY",
        "citation": "\"Utah, Salt Lake County Death Records, 1849-1949\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:NQHH-KNT : Fri Mar 08 21:34:37 UTC 2024), Entry for Nancy Briggs Berkinshaw and James Briggs, 15 Feb 1911."
      },
      {
        "title": "James Briggs in entry for Alma Briggs, \"Utah Death Certificates, 1904-1956\" ( 28 Jul 1942 )",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSTT-C5Q",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZPF-9BZ : Mon Feb 03 19:28:01 UTC 2025), Entry for Alma Briggs and James Briggs, 28 Jul 1942."
      },
      {
        "title": "James Briggs in entry for Alma Briggs, \"Utah, Deaths and Burials, 1888-1946\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMCZ-XK8",
        "citation": "\"Utah, Deaths and Burials, 1888-1946\", database, FamilySearch (https://familysearch.org/ark:/61903/1:1:F85K-XQ6 : 28 January 2020), James Briggs in entry for Alma Briggs, 1942."
      },
      {
        "title": "James Briggs in entry for John Briggs, \"Utah, Salt Lake County Death Records, 1908-1949\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMCZ-XLD",
        "citation": "\"Utah, Salt Lake County Death Records, 1849-1949\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:NQ4F-BSS : Sat Mar 09 16:49:40 UTC 2024), Entry for John Briggs and James Briggs, 02 Nov 1931."
      },
      {
        "title": "James Briggs, \"Utah, Obituaries from Utah Newspapers, 1850-2005\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9DW4-744",
        "citation": "\"Utah, Obituaries from Utah Newspapers, 1850-2005\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVSF-RL7R : Tue Mar 11 15:56:57 UTC 2025), Entry for James Briggs and Ben Birkinshaw, 26 Jul 1913."
      }
    ],
    "portrait": "/ancestors/portraits/092_KWJ4-W4X.jpg"
  },
  {
    "id": "I483",
    "name": "Betsy Fielding",
    "sex": "F",
    "gen": 6,
    "slot": 29,
    "side": "paternal",
    "birthplace": "england",
    "childId": "I239",
    "birthYear": 1823,
    "deathYear": 1909,
    "birthDate": "1 Jun 1823",
    "deathDate": "31 Aug 1909",
    "burialDate": "2 Sep 1909",
    "christeningDate": "18 Jun 1823",
    "birthPlace": "Of, Accrington, Lancashire, England",
    "deathPlace": "Beaver, Beaver, Utah, United States",
    "burialPlace": "Mountain View Cemetery, Beaver, Beaver, Utah, United States",
    "christeningPlace": "Blackburn, Lancashire, England, United Kingdom",
    "fsId": "KWJ4-W4D",
    "photo": "/ancestors/bubbles/093_KWJ4-W4D.jpg",
    "living": false,
    "alternateNames": [
      "Betty or Betsy Fielding"
    ],
    "facts": [
      {
        "kind": "Residence",
        "date": "1841",
        "place": "Blackburn, Lancashire, England, United Kingdom",
        "note": null
      },
      {
        "kind": "Baptism",
        "date": "September 1844",
        "place": null,
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1851",
        "place": "Accrington, Lancashire, England, United Kingdom",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1861",
        "place": "Accrington, Lancashire, England, United Kingdom",
        "note": null
      },
      {
        "kind": "Immigration",
        "date": "1870",
        "place": null,
        "note": null
      },
      {
        "kind": "Custom event",
        "date": "1870",
        "place": null,
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1871",
        "place": "Burnley, Lancashire, England, United Kingdom",
        "note": null
      },
      {
        "kind": "Occupation",
        "date": "June 1880",
        "place": "Beaver, Beaver, Utah, United States",
        "note": "Keeping House"
      },
      {
        "kind": "Residence",
        "date": "1880",
        "place": "Beaver, Beaver, Utah, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1900",
        "place": "Beaver Election Precinct, Beaver, Utah, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1901",
        "place": "Blackpool, Lancashire, England, United Kingdom",
        "note": null
      },
      {
        "kind": "Burial Place",
        "date": "2 September 1909",
        "place": "Mountain View Cemetery, Beaver, Beaver, Utah, United States",
        "note": "Flat laying Granite Headstone, GPS: 38.281157 -112.631589"
      },
      {
        "kind": "Information on Parents",
        "date": null,
        "place": null,
        "note": "James Brigg's Written History Identifies Betsy Fielding Briggs' parents"
      },
      {
        "kind": "Membership",
        "date": null,
        "place": "Utah, United States",
        "note": null
      }
    ],
    "sketch": "*The Life Summary of Betsy\nWhen Betsy Fielding was born on 1 June 1823, in Oswaldtwistle, Lancashire, England, United Kingdom, her father, John Fielding, was 24 and her mother, Nancy Holden, was 23. She married James Briggs on 9 August 1845, in Church, Lancashire, England, United Kingdom. They were the parents of at least 7 sons and 4 daughters. She lived in Burnley, Lancashire, England, United Kingdom in 1871 and Beaver Election Precinct, Beaver, Utah, United States in 1900. In 1880, at the age of 57, her occupation is listed as keeping house in Beaver, Beaver, Utah, United States. She died on 31 August 1909, in Beaver, Beaver, Utah, United States, at the age of 86, and was buried in Mountain View Cemetery, Beaver, Beaver, Utah, United States.",
    "sources": [
      {
        "title": "Betsy Fielding, 'Geni World Family Tree' on MyHeritage",
        "href": "https://www.familysearch.org/tree/sources/viewedit/W69Y-SNN",
        "citation": "Geni World Family Tree MyHeritage.com [online database], MyHeritage Ltd. Betsy Fielding"
      },
      {
        "title": "Betsy FIELDING, 'Filae Family Trees' on MyHeritage",
        "href": "https://www.familysearch.org/tree/sources/viewedit/W69Y-SNF",
        "citation": "Filae Family Trees MyHeritage.com [online database], MyHeritage Ltd. Betsy FIELDING"
      },
      {
        "title": "England, Births and Christenings, 1538-1975; https://familysearch.org/ark:/61903/3:1:S3HY-XCT7-ZKS?cc=1473014",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q26Z-632",
        "citation": "\"England, Births and Christenings, 1538-1975,\" database, FamilySearch (https://familysearch.org/ark:/61903/3:1:S3HY-XCT7-ZKS?cc=1473014 : 20 September 2026), > image 1 of 1."
      },
      {
        "title": "Betsy Briggs, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q7G7-78G",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Z1Q-MN6W : Sun Sep 13 05:17:08 UTC 2026), Entry for Betsy Briggs and Robt Parker."
      },
      {
        "title": "Betsy Fielding, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q7G7-SFG",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Z13-1YZM : Sun Sep 13 04:40:41 UTC 2026), Entry for Mary Briggs and James Briggs."
      },
      {
        "title": "Betty Briggs, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QJZ7-V3J",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CTH-TWBB : Sun Sep 13 05:19:34 UTC 2026), Entry for Robert Briggs and James Briggs."
      },
      {
        "title": "Betsie Fielding, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q7G7-WPH",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:DB2J-3RPZ : Sun Sep 13 05:37:31 UTC 2026), Entry for Joseph Briggs and James Briggs."
      },
      {
        "title": "Betsey Fielden, \"England, Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3357-115",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:N2RV-P32 : 4 February 2023), Betsey Fielden, 1823."
      },
      {
        "title": "Betsy Fielding, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q7G7-93P",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CYP-6F11 : Sun Sep 13 05:10:16 UTC 2026), Entry for Alma Briggs and Lorin Farr."
      },
      {
        "title": "Betsy, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q7G7-3RJ",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CT4-XC8L : Sun Sep 13 05:14:46 UTC 2026), Entry for Sarah Briggs and James."
      },
      {
        "title": "Betsey Briggs, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q7G7-4FB",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CYP-6F1V : Sun Sep 13 05:40:25 UTC 2026), Entry for Betsey Briggs and Robt Parker."
      },
      {
        "title": "Betsy Fielding, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q7G7-3QW",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CYP-6F1R : Sun Sep 13 04:41:21 UTC 2026), Entry for John Briggs and Edwin Biles."
      },
      {
        "title": "Betty Briggs, \"England, Deaths and Burials, 1538-1991\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QJSC-FJX",
        "citation": "\"England, Deaths and Burials, 1538-1991\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:JDM9-3ZY : Sat Jul 25 07:14:23 UTC 2026), Entry for Mary Briggs and Betty Briggs, 10 May 1850."
      },
      {
        "title": "Betsy, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q7GQ-Y7V",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CT4-XC8V : Sun Sep 13 05:10:55 UTC 2026), Entry for John Briggs and James."
      },
      {
        "title": "Betsie Fielding, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q7G7-WQS",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Z1L-ZNF5 : Sun Sep 13 05:47:18 UTC 2026), Entry for Joseph Briggs and James Briggs."
      },
      {
        "title": "Betsy Fielding, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q7GQ-RXR",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Z13-1YZ3 : Sun Sep 13 05:22:55 UTC 2026), Entry for John Briggs and Edwin Biles."
      },
      {
        "title": "Betsy Fielding, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q7GQ-YRL",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CYP-DPP6 : Sun Sep 13 05:43:31 UTC 2026), Entry for Sarah Briggs and John Haycock."
      },
      {
        "title": "Betsy Fielding, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q7G7-MZD",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Z13-1YZ4 : Sun Sep 13 05:24:26 UTC 2026), Entry for Alma Briggs and Lorin Farr."
      },
      {
        "title": "Betsy Fielding, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q7G7-95R",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CYP-6F1G : Sun Sep 13 05:11:10 UTC 2026), Entry for Mary Briggs and James Briggs."
      },
      {
        "title": "Betsy Fielding, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q7G7-QDP",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Z13-1YZ8 : Sun Sep 13 05:12:04 UTC 2026), Entry for Sarah Briggs and John Heycock."
      },
      {
        "title": "U.S., Find A Grave Index, 1700s-Current",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SYPS-NK2",
        "citation": ""
      },
      {
        "title": "Legacy NFS Source: Betsy Fielding - Government record: Death record or certificate: birth: 1 June 1823; Accrington, Lancashire, England",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MS6C-S1S",
        "citation": "Electronic document, State of Utah-Death Certificate, Robert Briggs, Archive"
      },
      {
        "title": "Betsy Fielding, \"England Marriages, 1538–1973\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZD4-R22",
        "citation": "\"England Marriages, 1538–1973\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:N2B8-L4H : Sat Aug 01 18:05:54 UTC 2026), Entry for James Briggs and Betsy Fielding, 9 August 1845."
      },
      {
        "title": "Betsy Fielding, \"The Church of Jesus Christ of Latter-day Saints, Missionary Registers (Worldwide), 1860-1937\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9XGP-HYF",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Missionary Registers (Worldwide), 1860-1937\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QKDW-TDCC : Tue Mar 11 16:23:09 UTC 2025), Entry for John Briggs and Edwin Biles, 1887."
      },
      {
        "title": "Betsy Fielding Briggs, \"Utah Death Certificates, 1904-1956\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMZF-G6Q",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZLY-F5C : Mon Feb 03 19:03:20 UTC 2025), Entry for Betsy Fielding Briggs and John Fielding, 31 Aug 1909."
      },
      {
        "title": "Bettsie Fielding, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSTT-H58",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZGY-DD2 : Mon Feb 03 19:22:43 UTC 2025), Entry for John Sr. Briggs and James Briggs, 02 Nov 1931."
      },
      {
        "title": "Betsy Briggs in household of James Briggs, \"England and Wales Census, 1851\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9VGV-Z46",
        "citation": "\"England and Wales, Census, 1851\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:SGPB-P8H : Fri Aug 21 09:14:02 UTC 2026), Entry for James Briggs and Betsy Briggs, 1851."
      },
      {
        "title": "Betsy Briggs, \"United States, Census, 1900\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M9K4-M2W",
        "citation": "\"United States, Census, 1900\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MMRN-NLR : Sat Oct 18 14:27:19 UTC 2025), Entry for James Briggs and Betsy Briggs, 1900."
      },
      {
        "title": "Unknown, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9X3J-K88",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZP4-58P : Mon Feb 03 19:18:05 UTC 2025), Entry for Robert Briggs and Unknown, 23 May 1940."
      },
      {
        "title": "Betsey Fielding, \"The Church of Jesus Christ of Latter-day Saints, Missionary Registers (Worldwide), 1860-1937\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9X5T-WGG",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Missionary Registers (Worldwide), 1860-1937\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QKDW-TTKZ : Tue Mar 11 16:23:36 UTC 2025), Entry for John Briggs and Edwin Biles, 1887."
      },
      {
        "title": "Betsy Briggs in household of James Briggs, \"England and Wales Census, 1861\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9VG8-RXJ",
        "citation": "\"England and Wales, Census, 1861\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M7LF-VP7 : Thu Sep 10 02:53:56 UTC 2026), Entry for James Briggs and Betsy Briggs, 1861."
      },
      {
        "title": "Bettsie Fielding in entry for John Briggs, \"Utah, Salt Lake County Death Records, 1849-1949\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9VGV-87M",
        "citation": "\"Utah, Salt Lake County Death Records, 1849-1949\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:NQ4F-BSS : Sat Mar 09 16:49:40 UTC 2024), Entry for John Briggs and James Briggs, 02 Nov 1931."
      },
      {
        "title": "Betsy, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSTT-VL3",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZ2L-V2Y : Mon Feb 03 19:16:49 UTC 2025), Entry for Joseph Briggs and James Briggs, 12 Dec 1922."
      },
      {
        "title": "unknown, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SP34-8TT",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZG3-545 : Mon Feb 03 19:07:05 UTC 2025), Entry for Nancy Briggs Berkinshaw and James Briggs, 15 Feb 1911."
      },
      {
        "title": "Betsy Briggs, \"United States, Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M9K4-MD3",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MNSN-594 : Wed Sep 09 15:08:30 UTC 2026), Entry for James Briggs and Betsy Briggs, 1880."
      },
      {
        "title": "Betsy Briggs in household of James Briggs, \"England and Wales Census, 1871\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9VG8-T7R",
        "citation": "\"England and Wales, Census, 1871\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KDDY-LPV : Tue Sep 08 21:59:55 UTC 2026), Entry for James Briggs and Betsy Briggs, 1871."
      },
      {
        "title": "Betsy Fielding, \"England and Wales, Marriage Registration Index, 1837-2005\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZFV-GXF",
        "citation": "\"England and Wales, Marriage Registration Index, 1837-2005,\" database, FamilySearch (https://familysearch.org/ark:/61903/1:1:2DHL-HBS : 13 December 2014), Betsy Fielding, 1845; from \"England & Wales Marriages, 1837-2005,\" database, findmypast (http://www.findmypast.com : 2012); citing 1845, quarter 3, vol. 21, p. 46, Blackburn, Lancashire, England, General Register Office, Southport, England."
      },
      {
        "title": "Betsy Fielding, \"England, Lancashire, Parish Registers 1538-1910,\" 1845",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9296-PH1",
        "citation": "\"England, Lancashire, Parish Registers 1538-1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QKKH-ZQ53 : Tue Sep 08 20:56:03 UTC 2026), Entry for James Briggs and Robert Briggs, 09 Aug 1845."
      },
      {
        "title": "Betsey Fielden, \"England Births and Christenings, 1538-1975\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMQP-PR7",
        "citation": "\"England, Births and Christenings, 1538-1975\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:NBTG-9M9 : 4 February 2023), Betsey Fielden, 1823."
      },
      {
        "title": "Betsy Fielding, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSTT-51M",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZP8-V6X : Mon Feb 03 19:20:00 UTC 2025), Entry for Sarah Briggs Roberts and James Briggs, 31 May 1938."
      },
      {
        "title": "Legacy NFS Source: Betsy Fielding - Government record: burial: 2 September 1909; Beaver, Beaver, Utah, United States",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MS6C-SBC",
        "citation": "Death Certificate, State of Utah"
      },
      {
        "title": "Find a grave for Betsy Fielding Briggs",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MM9N-7VJ",
        "citation": ""
      },
      {
        "title": "Headstone image of Betsy F. Briggs from billiongraves.com",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M9JL-BLR",
        "citation": "Transcription of headstone image from billiongraves.com. Image taken at Mountain View Cemetery (Beaver, Beaver, Utah, United States) on 28 May 2013"
      },
      {
        "title": "Betsy F. Briggs, \"BillionGraves Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMZF-GFZ",
        "citation": "\"BillionGraves Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KJ9H-H5D : Thu Sep 24 23:09:54 UTC 2026), Entry for Betsy F. Briggs."
      },
      {
        "title": "Betsy Fielding Briggs, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZFV-GL7",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVVH-6PTS : Sun Oct 04 05:55:33 UTC 2026), Entry for Betsy Fielding Briggs."
      },
      {
        "title": "in entry for Nancy Briggs Burkinshaw, \"Utah, Deaths and Burials, 1888-1946\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M9K4-MB2",
        "citation": "\"Utah, Deaths and Burials, 1888-1946\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:F85N-PFG : 28 January 2020), Nancy Briggs Burkinshaw, 1911."
      },
      {
        "title": "Betsy Fielding, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSTT-WRT",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZLJ-994 : Mon Feb 03 19:01:44 UTC 2025), Entry for Betsy Alice Waters and James Briggs, 23 Jul 1949."
      },
      {
        "title": "Betsy Fielding, \"Utah, Salt Lake County Death Records, 1849-1949\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSTT-C25",
        "citation": "\"Utah, Salt Lake County Death Records, 1849-1949\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:NQHS-H2N : Fri Mar 08 01:37:10 UTC 2024), Entry for Alma Briggs and James Briggs, 28 Jul 1942."
      },
      {
        "title": "Betsy Flelding in entry for Alma Briggs, \"Utah, Deaths and Burials, 1888-1946\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSTT-ZMH",
        "citation": "\"Utah, Deaths and Burials, 1888-1946\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:F85K-XQX : 28 January 2020), Betsy Flelding in entry for Alma Briggs, 1942."
      },
      {
        "title": "Betsy Fielding, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSTT-CPH",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZPF-9BZ : Mon Feb 03 19:28:01 UTC 2025), Entry for Alma Briggs and James Briggs, 28 Jul 1942."
      },
      {
        "title": "Bettsie Fielding in entry for John Briggs Sr., \"Utah Deaths and Burials, 1888-1946\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9KV3-GCH",
        "citation": "\"Utah, Deaths and Burials, 1888-1946\", , FamilySearch (https://www.familysearch.org/ark:/61903/1:1:F85Z-9SF : 22 September 2026), Bettsie Fielding in entry for John Briggs Sr., 1931."
      }
    ],
    "portrait": "/ancestors/portraits/093_KWJ4-W4D.jpg"
  },
  {
    "id": "I236",
    "name": "Louise Almind",
    "sex": "F",
    "gen": 5,
    "slot": 15,
    "side": "paternal",
    "birthplace": "denmark",
    "childId": "I91",
    "birthYear": 1862,
    "deathYear": 1938,
    "birthDate": "21 Mar 1862",
    "deathDate": "23 May 1938",
    "burialDate": "26 May 1938",
    "christeningDate": "2 May 1866",
    "birthPlace": "Jutland, Brovst Hjorring, Denmark",
    "deathPlace": "Cottonwood Heights, Salt Lake City, Salt Lake, Utah, United States",
    "burialPlace": "Wasatch Lawn Memorial Park, Salt Lake City, Salt Lake, Utah, United States",
    "christeningPlace": "Brovst, Hjorring, Denmark",
    "fsId": "KWCW-DH4",
    "photo": "/ancestors/bubbles/047_KWCW-DH4.jpg",
    "living": false,
    "alternateNames": [
      "Louise Briggs",
      "Louise Helena Briggs",
      "Jutta Almind",
      "Vata Oleana ( Helena) Louisa Almind",
      "Vata (Jutta) Oleana (Helena) Louisa Almind",
      "Utah Almind",
      "Inta Almind",
      "Louisa Christian",
      "Vata Oleana Helena Louisa Almind",
      "Miss Louisa H Christensen",
      "Juta Cordis",
      "Juta Cardis",
      "Louise Christisen"
    ],
    "facts": [
      {
        "kind": "Birth Date on Death Certificate",
        "date": "21 March 1862",
        "place": "Denmark",
        "note": "Birth Date on Death Certificate for Louise Briggs on 21 March 1862 in Denmark. Age of Louise when she Died: (76 year, 2 months, 2 Days,)"
      },
      {
        "kind": "Residence",
        "date": "1870",
        "place": "Løgstør, Ålborg, Denmark",
        "note": null
      },
      {
        "kind": "Emigration",
        "date": "19 June 1874",
        "place": "Copenhagen, Denmark",
        "note": null
      },
      {
        "kind": "Inta Almind [Juta Almind] in the U.S. and Canada, Passenger and Immigration Lists Index, 1500s-1900s",
        "date": "1874",
        "place": "New York City, New York, United States",
        "note": "Name: Inta Almind [Juta Almind] Birth Year: abt 1863 Arrival Year: 1874 Arrival Place: New York, New York Age: 11 Source Publication Code: 6639 Primary Immigrant: Almind, Inta"
      },
      {
        "kind": "Immigration Arrival to New York, New York, United States",
        "date": "1874",
        "place": "New York City, New York, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1880",
        "place": "Mount Pleasant, Sanpete, Utah, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1900",
        "place": "Beaver Election Precinct, Beaver, Utah, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1910",
        "place": "Manila, Daggett, Utah, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1920",
        "place": "Lyman, Uinta, Wyoming, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1930",
        "place": "Salt Lake City, Salt Lake, Utah, United States",
        "note": null
      },
      {
        "kind": "Life History of Louise Almind Brigg",
        "date": null,
        "place": null,
        "note": "by Cora Helena Briggs Lindsay History Posted on the Discussion."
      },
      {
        "kind": "Membership",
        "date": null,
        "place": "Beaver, Utah, United States",
        "note": null
      },
      {
        "kind": "Membership",
        "date": null,
        "place": "Utah, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Utah, U.S., Death and Military Death Certificates, 1904-1961",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7H89-FWH",
        "citation": "Utah State Archives; Salt Lake City, Utah; Series Number: 81448"
      },
      {
        "title": "Web: Western States Marriage Index, 1809-2016",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7H89-FWC",
        "citation": ""
      },
      {
        "title": "Utah, U.S., Select County Marriages, 1887-1937",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7H89-FW2",
        "citation": ""
      },
      {
        "title": "Luisa C*stainson, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q7TW-GWB",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CLG-9P2M : Sun Sep 13 05:21:26 UTC 2026), Entry for James Alma Briggs and Alma Briggs."
      },
      {
        "title": "Louisa Briggs, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QWBW-26L",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:631F-5KPZ : Sun Sep 13 05:47:55 UTC 2026), Entry for Theresa Lillian Briggs and O A Murdock."
      },
      {
        "title": "Louiza Almon, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7QXG-W7T",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6GFF-YJBR : Fri Mar 27 03:43:49 UTC 2026), Entry for Donald M Briggs and Alma."
      },
      {
        "title": "Jutta Almind, \"Denmark, Church Records, 1484-1941\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7HM8-CH2",
        "citation": "\"Danmark Kirkebøger, 1484-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QG3R-NST1 : Thu Mar 27 08:02:00 UTC 2025), Entry for Jutta Almind and Cora Almind, 1862."
      },
      {
        "title": "Louisa Briggs, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7HS6-GB3",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CTH-15LG : Sun Sep 13 04:45:44 UTC 2026), Entry for Moran L Briggs and W.P. Baker."
      },
      {
        "title": "Louisa Briggs, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/WDZY-4YT",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CBQ-FPMW : Sun Sep 13 05:23:47 UTC 2026), Entry for Louisa Briggs and C Christensen."
      },
      {
        "title": "Louiza Christensen, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7QCG-GKC",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6LPK-J6GM : Thu Mar 26 18:37:52 UTC 2026), Entry for Cora Briggs and Alma."
      },
      {
        "title": "Lousa Christensen, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7463-QLZ",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6ZYQ-HBQ3 : Fri Mar 27 04:59:06 UTC 2026), Entry for Ida Lovina Briggs and Alma Briggs."
      },
      {
        "title": "Lousa Christensen, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7467-7MS",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CTZ-PMN2 : Sun Sep 13 05:08:59 UTC 2026), Entry for Ida Lovina Briggs and Alma Briggs."
      },
      {
        "title": "Louiza Alman, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7QXG-WG9",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6GFF-YJT6 : Fri Mar 27 02:20:59 UTC 2026), Entry for Donald M Briggs and Alma."
      },
      {
        "title": "Juta Almind, \"Scandinavia, Mission Emigration Records, 1852-1920\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/74VZ-D9M",
        "citation": "\"Scandinavia, Mission Emigration Records, 1852-1920\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:WWN7-42PZ : Fri Mar 08 18:26:47 UTC 2024), Entry for Juta Almind, 19 Jun 1874."
      },
      {
        "title": "Louisa Briggs, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/WDZY-77B",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:68MN-MKH6 : Sun Sep 13 05:28:01 UTC 2026), Entry for Louisa Briggs and C Christensen."
      },
      {
        "title": "Jutta Almind, \"Denmark, Church Records, 1484-1941\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7HM8-ZYY",
        "citation": "\"Danmark Kirkebøger, 1484-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QG3R-7HLS : Wed Mar 26 23:32:00 UTC 2025), Entry for Jutta Almind and Cora Almind, 1862."
      },
      {
        "title": "Louise Christisen, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7HS6-2SL",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:DBB5-2R3Z : Sun Sep 13 04:45:38 UTC 2026), Entry for Be?sey Louise Briggs and W S Tolton."
      },
      {
        "title": "Louisa Briggs, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7HS6-2YC",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CBM-VPV3 : Sun Sep 13 05:20:59 UTC 2026), Entry for James Alma Briggs and James Briggs."
      },
      {
        "title": "Louise Christisen, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7HS6-KZL",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Z19-2VQN : Sun Sep 13 04:48:05 UTC 2026), Entry for Bessey Louise Briggs and W S Tolton."
      },
      {
        "title": "Utah Almind, \"United States, Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/WS1N-58F",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MNS2-SRL : Wed Sep 09 14:50:25 UTC 2026), Entry for Soren Jacobsen and Mina Jacobsen, 1880."
      },
      {
        "title": "Information about Jutta Louisa Almind's Father",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S94N-6GL",
        "citation": "Word of Mouth passed on down too and written Letters from Daughter's Cora Helena Briggs Lindsay and Ida Lovina Briggs Mortensen."
      },
      {
        "title": "Jutta Almind, \"Denmark, Church Records, 1484-1941\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S9Q8-3NC",
        "citation": "\"Danmark Kirkebøger, 1484-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QG8T-8B4F : Thu Mar 27 01:44:56 UTC 2025), Entry for Jutta Almind and Johan Daniel Cordis, 1862."
      },
      {
        "title": "Louisa Almen, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q7RT-LYN",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6ZB8-1M4V : Fri Mar 27 02:01:29 UTC 2026), Entry for Tressa L Briggs and O A Murdock."
      },
      {
        "title": "Jutta, \"Denmark, Baptisms, 1618-1923\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S9Q8-HM9",
        "citation": "\"Denmark, Baptisms, 1618-1923\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XB8F-CPT : 23 June 2020), Jutta, 1866."
      },
      {
        "title": "Loui?a Almen, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q7TW-KCV",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:DB34-FS3Z : Sun Sep 13 05:14:52 UTC 2026), Entry for Norma Luella Briggs and Alma Briggs."
      },
      {
        "title": "Louisa Alwin, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q7TW-LZK",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CYG-C89Y : Sun Sep 13 05:33:31 UTC 2026), Entry for Cora Helena Briggs and Alvin Briggs."
      },
      {
        "title": "Louise A Briggs, \"Utah, Salt Lake County Death Records, 1849-1949\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/95DS-4FN",
        "citation": "\"Utah, Salt Lake County Death Records, 1849-1949\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:NQHS-H2N : Fri Mar 08 01:37:10 UTC 2024), Entry for Alma Briggs and James Briggs, 28 Jul 1942."
      },
      {
        "title": "Louisa Helena Briggs, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3SKR-TPC",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:89S2-L52M : Fri Aug 01 20:45:25 UTC 2025), Entry for Louisa Helena Briggs, 1930."
      },
      {
        "title": "Louisa Alwin, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q7RT-25P",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Z13-69DQ : Sun Sep 13 05:35:14 UTC 2026), Entry for Cora Helena Briggs and Alma Briggs."
      },
      {
        "title": "Louisa Almen, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q7TW-VKY",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CT6-CY1K : Sun Sep 13 05:11:10 UTC 2026), Entry for Tressa L Briggs and O A Murdock."
      },
      {
        "title": "Louiza Almen, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q7TW-K1Y",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Z5B-9WY6 : Fri Mar 27 04:10:13 UTC 2026), Entry for Norma Luella Briggs and Alma Briggs."
      },
      {
        "title": "Luisa Christainsen, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q7RT-K1L",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Z13-97ML : Sun Sep 13 05:44:59 UTC 2026), Entry for James Alma Briggs and Alma Briggs."
      },
      {
        "title": "Louise A. Briggs in entry for Alma Briggs, \"Utah, Deaths and Burials, 1888-1946\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/95DS-WBP",
        "citation": "\"Utah, Deaths and Burials, 1888-1946\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:F85K-XQF : 28 January 2020), Louise A. Briggs in entry for Alma Briggs, 1942."
      },
      {
        "title": "Louisa H. Almin Christensen, \"United States, Western States Marriage Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SQR4-J6Y",
        "citation": "\"United States, Western States Marriage Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QPT4-ZNDY : Tue Feb 11 22:38:41 UTC 2025), Entry for Alma Briggs and Louisa H. Almin Christensen, 14 Sep 1892."
      },
      {
        "title": "Louisa Briggs, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q7RT-K3N",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CY2-ZHPM : Sun Sep 13 05:46:47 UTC 2026), Entry for Cora H Briggs and Jas M Murdock."
      },
      {
        "title": "Louise A Briggs, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/95DS-H7K",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZPF-9BZ : Mon Feb 03 19:28:01 UTC 2025), Entry for Alma Briggs and James Briggs, 28 Jul 1942."
      },
      {
        "title": "Jutta Almind, \"Denmark, Church Records, 1484-1941\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S9Q8-3RR",
        "citation": "\"Danmark Kirkebøger, 1484-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QG8R-J397 : Thu Mar 27 09:11:13 UTC 2025), Entry for Jutta Almind and Johan Daniel Cordis, 1862."
      },
      {
        "title": "Louisa Christian, \"Utah, County Marriages, 1871-1941\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SVKQ-7QG",
        "citation": "\"Utah, County Marriages, 1871-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VRL4-17F : Thu Sep 19 19:57:55 UTC 2024), Entry for and Alma Briggs, 24 Dec 1919."
      },
      {
        "title": "Louisa Christenson Almon, \"Utah, County Marriages, 1871-1941\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/95DS-WZK",
        "citation": "\"Utah, County Marriages, 1871-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VRLL-8D7 : Thu Sep 19 19:32:44 UTC 2024), Entry for Alma Briggs and Louisa Christenson Almon, 14 Sep 1892."
      },
      {
        "title": "Louise Briggs, \"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/32B9-1MS",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Church Census Records (Worldwide), 1914-1960\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:89S2-LPN2 : Sat Oct 11 11:52:19 UTC 2025), Entry for Louise Briggs, 1914."
      },
      {
        "title": "1861-1875 , Brovst, Ostor Han, Hjorring, Denmark",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9VXF-1XQ",
        "citation": "http://trees.ancestryinstitution.com/tree/1031247/person/-2011395792/photo/2?pgnum=1&pg=32816&pgpl=pid%7cpgNum rtobiassonadded this on 22 Mar 2011"
      },
      {
        "title": "\"Monuments to Courage\" A History of Beaver County, Utah. (Arrival of the first settlers on February 6, 1856)",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9FGP-C95",
        "citation": "SUU Digital Library Special Collections."
      },
      {
        "title": "Jutta Almind in the Denmark, Select Baptisms, 1618-1923 ( Baptism Date: 2 May 1866)",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZTZ-56N",
        "citation": "FHL Film Number: 408198"
      },
      {
        "title": "[Juta Almind] Inta Almind in the U.S. and Canada, Passenger and Immigration Lists Index, 1500s-1900s ( Arrival Year 1874)",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZTP-TKX",
        "citation": "Date and place of arrival. Age, gender, occupation, residence also provided. Source Bibliography: ANDERSON, SHAUNA C., ET AL, COMPILERS. Passport To Paradise: The Copenhagen Mormon Passenger Lists. Two volumes. West Jordan, UT: Genealogical Services. Page: 68 Chora Almind rather than Karen AlmindEmigration from Scandinavian Mission 1874 Film #025696 Kjobenhavn Conference (FHL in SLC, UT) lists Chora Almind and Juta Almind age 11, and Anna Almind 3/4 who are her daughters. Family records list her name as Cora, not Chora Almind. (Correction submitted by Marcia W. Shelton)"
      },
      {
        "title": "Louisa Christian in entry for Moroni L Briggs, \"Utah, Marriages, 1887-1935\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9DRB-S32",
        "citation": "\"Utah, Marriages, 1887-1935\", database, FamilySearch (https://familysearch.org/ark:/61903/1:1:F8G4-HZT : 28 January 2020), Louisa Christian in entry for Moroni L Briggs, 1919."
      },
      {
        "title": "Louisa Briggs, \"United States, Census, 1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSTN-JLK",
        "citation": "\"United States, Census, 1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M5X8-59H : Wed Aug 13 17:29:57 UTC 2025), Entry for Alma Briggs and Louisa Briggs, 1910."
      },
      {
        "title": "Louise Alononst in entry for Dennis Fielding Briggs and Florence Armitage, \"Utah, County Marriages, 1887-1937\" (18 Oct 1929)",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSTN-J5L",
        "citation": "\"Utah, County Marriages, 1871-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KSPQ-8T9 : Thu Sep 19 20:19:13 UTC 2024), Entry for Dennis Fielding Briggs and Alma Briggs, 18 Oct 1929."
      },
      {
        "title": "Louisa H Christensen, \"Utah, Marriages, 1887-1966\" ( Marriage: 14 September 1892 )",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZFV-25R",
        "citation": "\"Utah, Marriages, 1887-1935\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:F8P4-384 : 28 January 2020), Louisa H Christensen in entry for Alma Briggs, 1892."
      },
      {
        "title": "Jutta, \"Denmark, Baptisms, 1618-1923\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZT5-LPH",
        "citation": "\"Denmark, Baptisms, 1618-1923\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XB62-JP1 : 23 June 2020), Jutta, 1866."
      },
      {
        "title": "Louise Almind, \"Utah, County Marriages, 1871-1941\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9F7D-M7B",
        "citation": "\"Utah, County Marriages, 1871-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2MB-77GW : Thu Sep 19 20:15:26 UTC 2024), Entry for William Riley Jones and Hugh Alexander Jones, 31 Aug 1937."
      },
      {
        "title": "Juta Cardis, \"Denmark, Census, 1870\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/95D9-1ZV",
        "citation": "\"Denmark, Census, 1870\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QL8L-K24V : Fri Aug 07 23:05:25 UTC 2026), Entry for Anthon �sted and Ane Magrethe �sted F�d Almind, 1870."
      },
      {
        "title": "Louise Briggs, \"United States, Census, 1930\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M9K4-3P4",
        "citation": "\"United States, Census, 1930\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XH6J-854 : Sat Jan 18 07:33:06 UTC 2025), Entry for Alma Briggs and Louise Briggs, 1930."
      },
      {
        "title": "Juttavata Oleana Helena Louisa Almind Briggs, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9F32-VHF",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVK5-JW83 : Fri Oct 02 10:10:44 UTC 2026), Entry for Juttavata Oleana Helena Louisa Almind Briggs."
      },
      {
        "title": "Louisa Almon in entry for Donald McGregor Briggs, \"Utah, Birth Certificates, 1903-1914\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/92RM-DPD",
        "citation": "\"Utah, Birth Certificates, 1903-1914\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QL37-JBPQ : Thu Mar 07 00:42:25 UTC 2024), Entry for Donald McGregor Briggs and Alma Briggs, 19 Apr 1907."
      },
      {
        "title": "Louise Alononst in entry for Dennis Fielding Briggs and Florence Armitage, \"Utah, Marriages, 1887-1966\" ( 18 Oct 1929 )",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSTT-5WL",
        "citation": "\"Utah, Marriages, 1887-1935\", database, FamilySearch (https://familysearch.org/ark:/61903/1:1:F8P3-HQ5 : 28 January 2020), Louise Alononst in entry for Dennis Fielding Briggs, 1929."
      },
      {
        "title": "Luise Brigs, \"United States, Census, 1920\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSTN-J19",
        "citation": "\"United States, Census, 1920\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MNB5-7DN : Tue Sep 29 13:39:33 UTC 2026), Entry for Alma Brigs and Luise Brigs, 1920."
      },
      {
        "title": "Louise Almind, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/96KN-Z3X",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QKDV-ZNXV : Fri Jan 17 08:25:12 UTC 2025), Entry for Moroni Laban Briggs and James Alma Briggs, 12 Jun 1960."
      },
      {
        "title": "Louisa H. Briggs in household of Alma Briggs, \"United States Census, 1900\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M99B-GK3",
        "citation": "\"United States, Census, 1900\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MMRN-N24 : Thu Oct 09 04:19:49 UTC 2025), Entry for Alma Briggs and Louisa H. Briggs, 1900."
      },
      {
        "title": "Lonse Almer, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M97V-NF9",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZ2D-MQK : Mon Feb 03 19:04:13 UTC 2025), Entry for Donald Mcgregor Briggs and Alma Briggs, 1908."
      },
      {
        "title": "Louise Almind Briggs, \"Utah, Death Certificates, 1904-1966\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9F45-6RX",
        "citation": "\"Utah, Death Certificates, 1904-1966\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZP8-3J4 : Mon Feb 03 19:27:43 UTC 2025), Entry for Louise Almind Briggs and Jacob Almind, 23 May 1938."
      },
      {
        "title": "Obituary of Louise Almind Briggs, died: 23 May 1938 (Newspaper: Salt Lake Telegram 1938-05-24 Obituaries)",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M9SS-3GF",
        "citation": "http://digitalnewspapers.org/ J. Willard Marriott Library 295 S 1500 E SLC, UT 84112-0860 Title: Salt Lake Telegram 1938-05-24 Obituaries Publisher: Digitized by: Univ. of Utah Date.Original: 1938-05-24 Type: death notices Format: text/PDF Language eng Rights: Material in the public domain. No restrictions on use. Item.Year: 1938 Item.Month: May Item.Day: 24 Item.Page: Page 8"
      }
    ],
    "portrait": "/ancestors/portraits/047_KWCW-DH4.jpg"
  },
  {
    "id": "I463",
    "name": "Mathias Christian Andreason",
    "sex": "M",
    "gen": 6,
    "slot": 30,
    "side": "paternal",
    "birthplace": "denmark",
    "childId": "I236",
    "birthYear": 1817,
    "deathYear": 1895,
    "birthDate": "9 May 1817",
    "deathDate": "12 Jan 1895",
    "burialDate": "Jan 1895",
    "christeningDate": null,
    "birthPlace": "Denmark",
    "deathPlace": null,
    "burialPlace": "Manti Cemetery, Manti, Sanpete, Utah, United States",
    "christeningPlace": null,
    "fsId": "LZNX-SSP",
    "photo": "/ancestors/bubbles/094_LZNX-SSP.jpg",
    "living": false,
    "alternateNames": [
      "Mathies Andreason",
      "Mathias Andressen",
      "Mathias Andreasen",
      "Matese",
      "M C Mateens Anderson",
      "Andersen"
    ],
    "facts": [
      {
        "kind": "Voyage: Hamburg to New York",
        "date": "9 April 1862",
        "place": "Athena, Umatilla, Oregon, United States",
        "note": null
      },
      {
        "kind": "Voyage: Hamburg to New York",
        "date": "9 June 1862",
        "place": "New York, United States",
        "note": "Port of Arrival on Ship: Athena / in New York, United States / Arived with hids Wife: Ane Kirstine Andreason"
      },
      {
        "kind": "Military service",
        "date": "1 April 1866",
        "place": "Manti, Sanpete, Utah, United States",
        "note": null
      },
      {
        "kind": "Military service",
        "date": "1 May 1867",
        "place": "Manti, Sanpete, Utah, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1870",
        "place": "Manti, Sanpete, Utah, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1880",
        "place": "Manti, Sanpete, Utah, United States",
        "note": null
      },
      {
        "kind": "Burial Place",
        "date": "1895",
        "place": "Manti Cemetery, Manti, Sanpete, Utah, United States",
        "note": "Manti Cemetery, Sexton Records: Plat A; Block 5; Lot 11."
      },
      {
        "kind": "Residence",
        "date": null,
        "place": "Manti, Namtu, Kyaukme, Shan, Myanmar",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Copy of Marriage Licence Issued to Mathias Chr. Adreason and Cara Petersen (Cora) / Marriage Date: 02 November 1882, Sanpete County Utah, / Marriage Certificate No.#595 / page 225",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9XXV-5VZ",
        "citation": "Marriage Licence Issued to Mathias Chr. Adreason and Cara Petersen (Cora) / Marriage Date: 02 November 1882, Sanpete County Utah, / Marriage Certificate No.#595 / page 225 Sanpete County Clerk, Sanpete, Utah, United States"
      },
      {
        "title": "Legacy NFS Source: Mathias Andreason - Church record: Passenger or voyage record: birth-name: Mathias Andressen",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MM5F-FY8",
        "citation": "Mormon Migration , Brigham Young University. , http://lib.byu.edu/mormonmigration/results.php?q=Mathias+Andreason, Church"
      },
      {
        "title": "Legacy NFS Source: Mathias Andreason - Published information: Passenger or voyage record: Voyage: Hamburg to New York : 9 April 1862; Shipp, Ashtabula, Ohio, United States",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MM5F-FTY",
        "citation": "Internet, Mormon Migration / Hamburg to New York Voyage, Brigham Young University / Intellectual Reserve, Inc., in collaboration with the Church History and Family History Departments., http://lib.byu.edu/mormonmigration/results.php?q=Mathias+Andreason, Church, Page number: SMR, p. 128; Aarhus Conference"
      },
      {
        "title": "Legacy NFS Source: Mathias Andreason - Published information: Obituary: birth-name: Mathias Andreason",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MM5F-FTZ",
        "citation": "Internet, Ogden Standard Examiner 1903-08-29 News of the State Section, PublisherDigitized by: Univ. of Utah, http://udn.lib.utah.edu/cdm4/document.php?CISOROOT=/ogden8&CISOSHOW=34657&CISOPTR=34542 // www.utahdigitalnewspaper.org // (search result: Cora Almind), Archive, Page number: Date.Original: 1903-08-29 Item.Year: 1903 Item.Month: August Item.Day: 29 Item.Page: Page 8"
      },
      {
        "title": "Legacy NFS Source: Mathias Andreason - Published information: death: 12 January 1895; Manti, Sanpete, Utah, United States",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MM5F-FR1",
        "citation": ""
      },
      {
        "title": "Legacy NFS Source: Mathias Andreason - Published information: Newspaper article: birth-name: M C \"Mateens\" Anderson",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MM5F-FRX",
        "citation": "Internet, The Manti Messanger, Newspaper, Page 4 18 Jan 1895, Archive"
      },
      {
        "title": "Mathias Chr. Andreason, \"Utah, Marriages, 1887-1935\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MHTG-87V",
        "citation": "\"Utah, Marriages, 1887-1935\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:F8PB-BW5 : 28 January 2020), Mathias Chr. Andreason, 1884."
      },
      {
        "title": "Mathias Chs. Andreason, \"Utah, Marriages, 1887-1935\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7WHR-XB1",
        "citation": "\"Utah, Marriages, 1887-1935\", database, FamilySearch (https://familysearch.org/ark:/61903/1:1:F8PW-74V : 28 January 2020), Mathias Chs. Andreason, 1884."
      },
      {
        "title": "Mathias Andreason, \"Utah, Territorial Militia Records, 1849-1877\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/WSXR-9CR",
        "citation": "\"Utah, Territorial Militia Records, 1849-1877\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q231-PVDY : Fri Mar 08 11:52:47 UTC 2024), Entry for Mathias Andreason, 01 May 1867."
      },
      {
        "title": "Christen Andersen in entry for Ole Christian Andersen, \"Denmark, Baptisms, 1618-1923\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7FW1-N5Y",
        "citation": "\"Denmark, Baptisms, 1618-1923\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:H2P9-R7W2 : 11 September 2026), Christen Andersen in entry for Ole Christian Andersen, 1855."
      },
      {
        "title": "M. C. Andreason, \"United States, Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9X8B-B4H",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MNS2-9TC : Wed Sep 09 14:50:27 UTC 2026), Entry for M. C. Andreason and Anna Andreason, 1880."
      },
      {
        "title": "Mathias Chr. Andreason, \"United States, Western States Marriage Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7HJ5-82J",
        "citation": "\"United States, Western States Marriage Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZZP-6L8 : Tue Feb 11 22:25:37 UTC 2025), Entry for Mathias Chr. Andreason and Cara Petersen, 2 Nov 1884."
      },
      {
        "title": "Matthius Anderson, \"Utah, Territorial Militia Records, 1849-1877\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/WS1K-BQK",
        "citation": "\"Utah, Territorial Militia Records, 1849-1877\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q231-5MTH : Sat Mar 09 04:26:08 UTC 2024), Entry for Matthius Anderson, 01 Apr 1866."
      },
      {
        "title": "Christen Andersen, \"Denmark, Marriages, 1635-1916\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9XJ9-TNR",
        "citation": "\"Denmark, Marriages, 1635-1916\", , FamilySearch (https://www.familysearch.org/ark:/61903/1:1:FVTH-HNB : 10 September 2026), Christen Andersen, 1854."
      },
      {
        "title": "Christen Andersen, \"Denmark, Church Records, 1484-1941\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/95MZ-9C6",
        "citation": "\"Danmark Kirkebøger, 1484-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QG8F-28WW : Wed Mar 26 19:00:57 UTC 2025), Entry for Christen Andersen and Ane Kristine Andersdatter, 10 Nov 1854."
      },
      {
        "title": "Mathias Andreisen, \"United States, Census, 1870\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/WSNL-HDP",
        "citation": "\"United States, Census, 1870\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MNCY-X81 : Thu Oct 23 07:42:01 UTC 2025), Entry for Mathias Andreisen and Anna C Andreisen, 1870."
      },
      {
        "title": "Mathias Andreasen, \"Utah, Territorial Militia Records, 1849-1877\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/WS1K-F8C",
        "citation": "\"Utah, Territorial Militia Records, 1849-1877\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q231-PVRM : Sat Mar 09 01:56:25 UTC 2024), Entry for Mathias Andreasen, 01 Apr 1866."
      },
      {
        "title": "Mathias Chr Andreason, \"Utah, County Marriages, 1871-1941\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7HJ5-ZRT",
        "citation": "\"Utah, County Marriages, 1871-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VRLG-V6J : Thu Sep 19 20:03:25 UTC 2024), Entry for Mathias Chr Andreason and Cara Petersen, 02 Nov 1884."
      }
    ],
    "portrait": "/ancestors/portraits/094_LZNX-SSP.jpg"
  },
  {
    "id": "I465",
    "name": "Cora Almind",
    "sex": "F",
    "gen": 6,
    "slot": 31,
    "side": "paternal",
    "birthplace": "denmark",
    "childId": "I236",
    "birthYear": 1838,
    "deathYear": 1903,
    "birthDate": "24 Oct 1838",
    "deathDate": "27 Aug 1903",
    "burialDate": "1903",
    "christeningDate": "17 May 1839",
    "birthPlace": "Viborg, Viborg, Denmark",
    "deathPlace": "Manti, Sanpete, Utah, United States",
    "burialPlace": "Manti, Sanpete, Utah, United States",
    "christeningPlace": "Sonder Sogn, Viborg, Viborg, Denmark",
    "fsId": "KWJH-CQ4",
    "photo": "/ancestors/bubbles/095_KWJH-CQ4.jpg",
    "living": false,
    "alternateNames": [
      "Kora Almond",
      "Kora Almind",
      "Chora or Karen",
      "Cora Almin",
      "Mrs. Cora A. Andreason ( Anderson)",
      "Mrs. Cora Christensen"
    ],
    "facts": [
      {
        "kind": "Residence",
        "date": "1845",
        "place": "Løgsted, Slet, Ålborg, Denmark",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1850",
        "place": "Løgsted, Slet, Ålborg, Denmark",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1855",
        "place": "Løgsted, Slet, Ålborg, Denmark",
        "note": null
      },
      {
        "kind": "Emigration",
        "date": "19 June 1874",
        "place": "Copenhagen, Denmark",
        "note": null
      },
      {
        "kind": "1903 ObituaryMrs. Cora A. Anderson",
        "date": "29 August 1903",
        "place": "Manti, Sanpete, Utah, United States",
        "note": null
      },
      {
        "kind": "District Court, Probate Division",
        "date": "23 December 1903",
        "place": "Manti, Sanpete, Utah, United States",
        "note": null
      },
      {
        "kind": "Children: Two Daughters",
        "date": null,
        "place": null,
        "note": "Newspaper: Ogden Standard Examiner in Obituary 1903-08-29, -Text She has two daughters living in Utah, Mrs. Alma Briggs, and Mrs. Walter T. Barrett"
      },
      {
        "kind": "Immigration",
        "date": null,
        "place": null,
        "note": "Ship Name Idaho Vessel Type Single-Screw Steamship Departure 24 Jun 1874 from Liverpool Arrival 6 Jul 1874 at New York"
      },
      {
        "kind": "Immigration",
        "date": null,
        "place": null,
        "note": "Ship Name: Idaho, Vessel: Type Single-Screw Steamship / Departure: 24 Jun 1874 from Liverpool / Arrival: 6 Jul 1874 at New York"
      },
      {
        "kind": "Residence",
        "date": null,
        "place": "United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "1900 United States Federal Census",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9NRV-LBV",
        "citation": "Year: 1900; Census Place: Manti, Sanpete, Utah; Roll: 1686; Page: 22B; Enumeration District: 0125; FHL microfilm: 1241686"
      },
      {
        "title": "Chora Almind, \"Scandinavia, Mission Emigration Records, 1852-1920\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/74VZ-XGK",
        "citation": "\"Scandinavia, Mission Emigration Records, 1852-1920\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:WWN3-96MM : Tue Mar 18 21:22:06 UTC 2025), Entry for Chora Almind, 19 Jun 1874."
      },
      {
        "title": "Cora Almind, \"Denmark, Census, 1845\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9P1M-J4M",
        "citation": "\"Denmark, Census, 1845\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QLRK-ZNMK : Fri Aug 07 22:58:46 UTC 2026), Entry for Jacob Almind and Anna Magrethe Vonne, 1845."
      },
      {
        "title": "Cora Almind in entry for Jutta, \"Denmark, Baptisms, 1618-1923\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9692-YF7",
        "citation": "\"Denmark, Baptisms, 1618-1923\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XB62-J59 : 23 June 2020), Cora Almind in entry for Jutta, 1866."
      },
      {
        "title": "Cora, \"Denmark, Census, 1855\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/95FG-YVV",
        "citation": "\"Denmark, Census, 1855\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QLD9-HTXT : Fri Aug 07 23:02:53 UTC 2026), Entry for Cora, 1855."
      },
      {
        "title": "Cara Petersen, \"Utah, County Marriages, 1871-1941\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7HJ5-8H8",
        "citation": "\"Utah, County Marriages, 1871-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VRLG-V6J : Thu Sep 19 20:03:25 UTC 2024), Entry for Mathias Chr Andreason and Cara Petersen, 02 Nov 1884."
      },
      {
        "title": "Cora Almind, \"United States Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMFW-9NS",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MNS2-SR8 : Wed Sep 09 14:50:05 UTC 2026), Entry for Cora Almind and Annie Almind, 1880."
      },
      {
        "title": "Cora, \"Denmark, Baptisms, 1618-1923\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M2SH-LXR",
        "citation": "\"Denmark, Baptisms, 1618-1923\", , FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XYL4-4LN : 23 June 2020), Cora, 1839."
      },
      {
        "title": "Cora Almind, \"Denmark, Church Records, 1484-1941\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/95M8-7FZ",
        "citation": "\"Danmark Kirkebøger, 1484-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QG8S-Q76R : Wed Mar 26 14:36:29 UTC 2025), Entry for Ane Emilie Almind and Cora Almind, 1868."
      },
      {
        "title": "Cora Almind, \"Denmark, Census, 1850\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/95D9-85Q",
        "citation": "\"Denmark, Census, 1850\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QL68-11SG : Mon Aug 10 01:40:22 UTC 2026), Entry for Jacob Almind and Ane Frederikke Jacobine Mund, 1850."
      },
      {
        "title": "Cara Peterson in entry for Mathias Chs. Andreason, \"Utah, Marriages, 1887-1935\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7WHR-X5M",
        "citation": "\"Utah, Marriages, 1887-1935\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:F8PW-74J : 28 January 2020), Cara Peterson in entry for Mathias Chs. Andreason, 1884."
      },
      {
        "title": "Cora Almen, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/WDZY-4RS",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CBQ-FPMW : Sun Sep 13 05:23:47 UTC 2026), Entry for Louisa Briggs and C Christensen."
      },
      {
        "title": "Cara Petersen in entry for Mathias Chr. Andreason, \"Utah, Marriages, 1887-1935\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MHTG-87X",
        "citation": "\"Utah, Marriages, 1887-1935\", database, FamilySearch (https://familysearch.org/ark:/61903/1:1:F8PB-BWP : 28 January 2020), Cara Petersen in entry for Mathias Chr. Andreason, 1884."
      },
      {
        "title": "Cora Almind, \"Denmark, Church Records, 1484-1941\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S9Q8-37H",
        "citation": "\"Danmark Kirkebøger, 1484-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QG8T-8B4F : Thu Mar 27 01:44:56 UTC 2025), Entry for Jutta Almind and Johan Daniel Cordis, 1862."
      },
      {
        "title": "Cora Almind, \"Denmark, Church Records, 1484-1941\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S9Q8-35J",
        "citation": "\"Danmark Kirkebøger, 1484-1941\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QG8R-J397 : Thu Mar 27 09:11:13 UTC 2025), Entry for Jutta Almind and Johan Daniel Cordis, 1862."
      },
      {
        "title": "Cora Almind in entry for Ane Emilie, \"Denmark, Baptisms, 1618-1923\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SV2K-DMT",
        "citation": "\"Denmark, Baptisms, 1618-1923\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:H2R3-ZNMM : 23 June 2020), Cora Almind in entry for Ane Emilie, 1868."
      },
      {
        "title": "Cara Petersen, \"United States, Western States Marriage Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7HJ5-8BF",
        "citation": "\"United States, Western States Marriage Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XZZP-6L8 : Tue Feb 11 22:25:37 UTC 2025), Entry for Mathias Chr. Andreason and Cara Petersen, 2 Nov 1884."
      },
      {
        "title": "Cora Almen, \"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/WDZY-79M",
        "citation": "\"The Church of Jesus Christ of Latter-day Saints, Record of Members (Worldwide), 1836-1970\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:68MN-MKH6 : Sun Sep 13 05:28:01 UTC 2026), Entry for Louisa Briggs and C Christensen."
      },
      {
        "title": "Cora Almind in entry for Jutta, \"Denmark, Baptisms, 1618-1923\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9Z19-2LY",
        "citation": "\"Denmark, Baptisms, 1618-1923\", , FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XB8F-CPB : 23 June 2020), Cora Almind in entry for Jutta, 1866."
      },
      {
        "title": "Cora Almind Andreason, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9692-TBW",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVGM-33HQ : Fri Oct 02 22:11:00 UTC 2026), Entry for Cora Almind Andreason."
      },
      {
        "title": "Utah, Wills and Probate Records, 1800-1985",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9NRV-LD4",
        "citation": "Probate Place: Sanpete, Utah"
      },
      {
        "title": "Cora Almind, \"Denmark, Baptisms, 1618-1923\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SJCR-BDZ",
        "citation": "\"Denmark, Baptisms, 1618-1923,\" index, FamilySearch (https://familysearch.org/pal:/MM9.1.1/XYL4-4LN : accessed 03 Jul 2014), Cora Almind, 17 May 1839; citing SONDER SOGN, VIBORG, VIBORG, DENMARK; FHL microfilm 54082."
      },
      {
        "title": "General History of Sanpete County, Utah (Cora is not mention) to get an Idea of the People in the Area",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9XJS-BPL",
        "citation": ""
      },
      {
        "title": "Marriage Licence Issued to Mathias Chr. Adreason and Cara Petersen (Cora) / Marriage Date: 02 November 1882, Sanpete County Utah, / Marriage Certificate No.#595 / page 225",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9XXV-P71",
        "citation": "Marriage Licence Issued to Mathias Chr. Adreason and Cara Petersen (Cora) / Marriage Date: 02 November 1882, Sanpete County Utah, / Marriage Certificate No.#595 / page 225 Sanpete County Clerk, Sanpete, Utah, United States"
      }
    ],
    "portrait": "/ancestors/portraits/095_KWJH-CQ4.jpg"
  },
  {
    "id": "I3",
    "name": "Tamera Heck",
    "sex": "F",
    "gen": 1,
    "slot": 1,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I1",
    "birthYear": 1966,
    "deathYear": null,
    "birthDate": "16 Jul 1966",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Harrisburg, Dauphin, Pennsylvania, United States",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "L1ZR-NT2",
    "photo": "/ancestors/bubbles/tamera.jpg",
    "living": true,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/tamera.jpg"
  },
  {
    "id": "I7",
    "name": "James R Heck",
    "sex": "M",
    "gen": 2,
    "slot": 2,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I3",
    "birthYear": 1937,
    "deathYear": 2025,
    "birthDate": "8 Jul 1937",
    "deathDate": "23 Jun 2025",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Pottstown, Montgomery, Pennsylvania, United States",
    "deathPlace": null,
    "burialPlace": "Lancaster, Lancaster, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "GPT5-T4N",
    "photo": "/ancestors/bubbles/006_GPT5-T4N.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [
      {
        "kind": "Residence",
        "date": "1940",
        "place": "Royersford Borough, Royersford Borough, Royersford, Ward 3, Royersford, 46-189, Montgomery, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "5 April 1950",
        "place": "Royersford, Montgomery, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Obituary",
        "date": "6 July 2025",
        "place": "Lancaster, Lancaster, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Obituary",
        "date": "6 July 2025",
        "place": "Pottstown, Montgomery, Pennsylvania, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "James R Heck, \"United States, GenealogyBank Obituaries, Births, and Marriages, 1980-2015\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7T69-SPM",
        "citation": "\"United States, GenealogyBank Obituaries, Births, and Marriages, 1980-2015\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:X3TT-5D68 : Sun Jul 13 11:58:06 UTC 2025), Entry for James R Heck, 13 July 2025."
      },
      {
        "title": "James R Heck, \"United States, GenealogyBank Obituaries, Births, and Marriages, 1980-2015\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7T69-91Y",
        "citation": "\"United States, GenealogyBank Obituaries, Births, and Marriages, 1980-2015\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:X3TT-RSRV : Sun Jul 13 12:13:16 UTC 2025), Entry for James R Heck and Jeanne Heck, 13 July 2025."
      },
      {
        "title": "James R. Heck, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7T94-8V3",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XQ96-PVPJ : Mon Oct 05 00:47:00 UTC 2026), Entry for James R. Heck."
      },
      {
        "title": "James R Heck, \"United States, GenealogyBank Obituaries, Births, and Marriages, 1980-2015\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7P6Y-7QS",
        "citation": "\"United States, GenealogyBank Obituaries, Births, and Marriages, 1980-2015\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:X3T4-W45J : Sun Jul 06 11:54:25 UTC 2025), Entry for James R Heck and Jeanne Heck, 6 July 2025."
      },
      {
        "title": "James R Heck, \"United States, GenealogyBank Obituaries, Births, and Marriages, 1980-2015\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7GKB-XM2",
        "citation": "\"United States, GenealogyBank Obituaries, Births, and Marriages, 1980-2015\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:X3TW-5LRQ : Sun Jul 06 07:34:48 UTC 2025), Entry for James R Heck and Russell O Heck, 6 July 2025."
      },
      {
        "title": "James R Heck, \"United States, GenealogyBank Obituaries, Births, and Marriages, 1980-2015\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7GKB-6FW",
        "citation": "\"United States, GenealogyBank Obituaries, Births, and Marriages, 1980-2015\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:X3T4-ZTCJ : Sun Jul 06 11:38:37 UTC 2025), Entry for James R Heck and Russell O Heck, 6 July 2025."
      },
      {
        "title": "James R Heck, \"United States, Census, 1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QP9C-C2Z",
        "citation": "\"United States, Census, 1940\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KQDB-234 : Tue Jan 21 08:47:18 UTC 2025), Entry for Russell O Heck and Alberta M Heck, 1940."
      },
      {
        "title": "James R Heck, \"United States, Census, 1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QP9C-H4N",
        "citation": "\"United States, Census, 1950\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6XBK-RNJ3 : Tue Mar 19 16:28:26 UTC 2024), Entry for Russell O Heck and M Alberta Heck, 5 April 1950."
      }
    ],
    "portrait": "/ancestors/portraits/006_GPT5-T4N.jpg"
  },
  {
    "id": "I13",
    "name": "Russell Orville Heck",
    "sex": "M",
    "gen": 3,
    "slot": 4,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I7",
    "birthYear": 1912,
    "deathYear": 1984,
    "birthDate": "25 Jul 1912",
    "deathDate": "Nov 1984",
    "burialDate": "1984",
    "christeningDate": null,
    "birthPlace": "Warwick Township, Chester, Pennsylvania, United States",
    "deathPlace": null,
    "burialPlace": "Mount Carmel Methodist Church Cemetery, Saint Peters, Chester, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "9F9W-595",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [
      {
        "kind": "Residence",
        "date": "1920",
        "place": "Chester, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1930",
        "place": "Warwick Township, Chester, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "5 April 1950",
        "place": "Royersford, Montgomery, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Military Draft Registration",
        "date": null,
        "place": "Royersford, Montgomery, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": null,
        "place": "Royersford",
        "note": null
      },
      {
        "kind": "Occupation",
        "date": null,
        "place": null,
        "note": "Manager of Food Store"
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Russell O Heck, \"United States, Census, 1920\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/W6V2-R37",
        "citation": "\"United States, Census, 1920\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MFTT-GTS : Sun Sep 27 17:01:16 UTC 2026), Entry for Maud E Heck and Russell O Heck, 1920."
      },
      {
        "title": "Russell O Heck, \"United States, GenealogyBank Obituaries, Births, and Marriages, 1980-2015\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7GKB-6RT",
        "citation": "\"United States, GenealogyBank Obituaries, Births, and Marriages, 1980-2015\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:X3TW-5LRQ : Sun Jul 06 07:34:48 UTC 2025), Entry for James R Heck and Russell O Heck, 6 July 2025."
      },
      {
        "title": "Russell O Heck, \"United States, GenealogyBank Obituaries, Births, and Marriages, 1980-2015\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7GKB-6QD",
        "citation": "\"United States, GenealogyBank Obituaries, Births, and Marriages, 1980-2015\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:X3T4-ZTCJ : Sun Jul 06 11:38:37 UTC 2025), Entry for James R Heck and Russell O Heck, 6 July 2025."
      },
      {
        "title": "Russell O Heck, \"United States, Census, 1930\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/785W-K4X",
        "citation": "\"United States, Census, 1930\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XHDW-NJL : Mon Jul 22 00:11:43 UTC 2024), Entry for Anna Noble and Lettie She?An, 1930."
      },
      {
        "title": "Russell O Heck, \"United States, Census, 1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/785W-DY5",
        "citation": "\"United States, Census, 1950\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6XBK-RNJ3 : Tue Mar 19 16:28:26 UTC 2024), Entry for Russell O Heck and M Alberta Heck, 5 April 1950."
      },
      {
        "title": "Russell Orville Heck, \"Pennsylvania, World War II Draft Registration Cards, 1940-1945\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QP9H-V2F",
        "citation": "\"Pennsylvania, World War II Draft Registration Cards, 1940-1945\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2QL-Q8HL : Fri Feb 23 22:59:39 UTC 2024), Entry for Russell Orville Heck and Alberta Heck."
      },
      {
        "title": "Russell O. Heck, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QP9H-NGZ",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVK4-RZ8Y : Thu Oct 01 20:55:03 UTC 2026), Entry for Russell O. Heck."
      },
      {
        "title": "Russell Heck, \"United States, Social Security Death Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QP9H-DDV",
        "citation": "\"United States, Social Security Death Index,\" , FamilySearch (https://familysearch.org/ark:/61903/1:1:J29G-52K : 8 January 2021), Russell Heck, Nov 1984; citing U.S. Social Security Administration, Death Master File, database (Alexandria, Virginia: National Technical Information Service, ongoing)."
      },
      {
        "title": "Russell O Heck, \"United States, Census, 1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q35N-QYJ",
        "citation": "\"United States, Census, 1940\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KQDB-234 : Tue Jan 21 08:47:18 UTC 2025), Entry for Russell O Heck and Alberta M Heck, 1940."
      },
      {
        "title": "tombstone photo",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SFPQ-BL3",
        "citation": ""
      }
    ]
  },
  {
    "id": "I23",
    "name": "Charles Raymond Heck",
    "sex": "M",
    "gen": 4,
    "slot": 8,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I13",
    "birthYear": 1886,
    "deathYear": 1945,
    "birthDate": "Nov 1886",
    "deathDate": "1945",
    "burialDate": "1945",
    "christeningDate": null,
    "birthPlace": "Pennsylvania, United States",
    "deathPlace": null,
    "burialPlace": "Mount Carmel Methodist Church Cemetery, Saint Peters, Chester, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LKTS-VWL",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [
      {
        "kind": "Residence",
        "date": "1900",
        "place": "East Nantmeal Township, Chester, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1910",
        "place": "Warwick Township, Chester, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Military Draft Registration",
        "date": "from 1917 to 1918",
        "place": "Chester, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1920",
        "place": "Chester, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1930",
        "place": "Warwick Township, Chester, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "SocialProgramApplication",
        "date": "February 1937",
        "place": null,
        "note": null
      },
      {
        "kind": "Military Draft Registration",
        "date": "1942",
        "place": "Coventry Township, Chester, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "SocialProgramApplication",
        "date": "July 1943",
        "place": null,
        "note": null
      },
      {
        "kind": "SocialProgramCorrespondence",
        "date": null,
        "place": null,
        "note": "Social Program Correspondence"
      },
      {
        "kind": "Residence",
        "date": null,
        "place": "Harmonyville, Warwick Township, Chester, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Citizenship",
        "date": null,
        "place": "United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": null,
        "place": "Coventry Township, Chester, Pennsylvania, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Charles Heck, \"United States, Census, 1920\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/W6V2-J4P",
        "citation": "\"United States, Census, 1920\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MFTT-GT9 : Sun Sep 27 17:01:16 UTC 2026), Entry for Charles Heck, 1920."
      },
      {
        "title": "Charles R Heck, \"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7GKB-DVC",
        "citation": "\"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6K9K-R6WT : Tue Jun 30 05:28:38 UTC 2026), Entry for Hazel H Fox and Charles R Heck."
      },
      {
        "title": "Charles Raymond Heck, \"United States, World War II Draft Registration Cards, 1942\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/78VC-9PG",
        "citation": "\"United States, World War II Draft Registration Cards, 1942\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VQFP-169 : Mon Mar 30 05:52:27 UTC 2026), Entry for Charles Raymond Heck, 1942."
      },
      {
        "title": "Charles Raymond Heck, \"United States, World War I Draft Registration Cards, 1917-1918\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/78VC-9QC",
        "citation": "\"United States, World War I Draft Registration Cards, 1917-1918\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:48LV-5TT2 : Sat May 16 00:29:04 UTC 2026), Entry for Charles Raymond Heck, 25 November 1918."
      },
      {
        "title": "Charles Raymond Heck, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/78VC-MSK",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVK4-RZ82 : Sun Oct 04 21:48:01 UTC 2026), Entry for Charles Raymond Heck."
      },
      {
        "title": "Charles R Heck, \"Pennsylvania, Philadelphia, Historical Society of Pennsylvania, Marriage Records, 1512-1989\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/78VH-19K",
        "citation": "\"Pennsylvania, Philadelphia, Historical Society of Pennsylvania, Marriage Records, 1512-1989\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CYX-9M5K : Thu Mar 07 23:03:19 UTC 2024), Entry for Charles R Heck and Maud E Noble, 28 February 1912."
      },
      {
        "title": "Charles R Heck, \"Pennsylvania, Philadelphia, Historical Society of Pennsylvania, Marriage Records, 1512-1989\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/78VH-YKR",
        "citation": "\"Pennsylvania, Philadelphia, Historical Society of Pennsylvania, Marriage Records, 1512-1989\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CYX-78R1 : Thu Mar 07 23:03:19 UTC 2024), Entry for Maud E Noble and Charles R Heck, 28 February 1912."
      },
      {
        "title": "Charles Heck, \"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7QGT-N66",
        "citation": "\"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6K3H-DGJP : Tue Jun 30 21:33:04 UTC 2026), Entry for Charles Heck and William D Heck."
      },
      {
        "title": "Charles Raymond Heck, \"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/79YR-654",
        "citation": "\"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6K3H-B4C2 : Tue Jun 30 21:00:53 UTC 2026), Entry for Charles Raymond Heck and William Heck."
      },
      {
        "title": "Charles R. Heck, \"Pennsylvania, County Marriages, 1775-1991\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7MMN-T9K",
        "citation": "\"Pennsylvania, County Marriages, 1775-1991\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VF93-31N : Fri May 08 00:33:47 UTC 2026), Entry for Charles R. Heck and Maud E. Noble, 28 February 1912."
      },
      {
        "title": "Charles R Heck, \"United States, Census, 1930\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3CXH-RHC",
        "citation": "\"United States, Census, 1930\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XHDW-PT5 : Mon Jan 20 19:56:35 UTC 2025), Entry for Charles R Heck and Celia G Heck, 1930."
      },
      {
        "title": "Charles R Heck, \"United States, Census, 1900\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SJ1D-N14",
        "citation": "\"United States, Census, 1900\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M39N-YPR : Wed May 21 05:55:57 UTC 2025), Entry for William D Heck and Clara Heck, 1900."
      },
      {
        "title": "Charles R. Heck, \"Pennsylvania, Marriages, 1709-1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MDRK-2GN",
        "citation": "\"Pennsylvania, Marriages, 1709-1940\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:V2XN-YZP : 7 May 2023), Charles R. Heck, 1912."
      },
      {
        "title": "tombstone photo",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SFGB-463",
        "citation": ""
      },
      {
        "title": "Charles R Heck, \"United States, Census, 1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9DG3-T4Q",
        "citation": "\"United States, Census, 1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MGZQ-8CG : Wed Aug 13 19:32:01 UTC 2025), Entry for William D Heck and Clara Heck, 1910."
      }
    ]
  },
  {
    "id": "I60",
    "name": "William D Heck",
    "sex": "M",
    "gen": 5,
    "slot": 16,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I23",
    "birthYear": 1856,
    "deathYear": 1910,
    "birthDate": "10 Oct 1856",
    "deathDate": "24 Jun 1910",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "East Vincent Township, Chester, Pennsylvania, United States",
    "deathPlace": "Elverson, Chester, Pennsylvania, United States",
    "burialPlace": "Elverson Methodist Cemetery, Elverson, Elverson, Chester, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LK69-37X",
    "photo": "/ancestors/bubbles/048_LK69-37X.jpg",
    "living": false,
    "alternateNames": [
      "Samuel Heck"
    ],
    "facts": [
      {
        "kind": "Residence",
        "date": "1870",
        "place": "Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1880",
        "place": "East Nantmeal Township, Chester, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1910",
        "place": "Warwick Township, Chester, Pennsylvania, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Legacy NFS Source: Samuel Heck - birth: about 1863; Schuylkill, Pennsylvania, United States",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSH8-BYQ",
        "citation": "Pennsylvania, Schuylkill 1870 U.S. Federal Census, U.S. Government, Ancestry.com, Online Database, Page number: Port Clinton Image 11"
      },
      {
        "title": "William D Heck, \"United States Census, 1900\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9D34-4CY",
        "citation": "\"United States, Census, 1900\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M39N-YPR : Wed May 21 05:55:57 UTC 2025), Entry for William D Heck and Clara Heck, 1900."
      },
      {
        "title": "Wm D Heck, \"Pennsylvania, Cemetery Records, ca. 1700-ca. 1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3NCL-M4Y",
        "citation": "\"Pennsylvania, Cemetery Records, ca. 1700-ca. 1950\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:8D5K-CK6Z : Sun Mar 10 04:43:30 UTC 2024), Entry for Clifton E Heck and Clara M Heck."
      },
      {
        "title": "Samuel Heck, \"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QWQH-F5N",
        "citation": "\"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6K4V-R2B4 : Sun Jul 05 09:36:27 UTC 2026), Entry for Frank M Heck and Samuel Heck."
      },
      {
        "title": "Samuel Heck, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SK31-KL2",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:4KFN-G9T2 : Sun Oct 04 22:04:23 UTC 2026), Entry for Samuel Heck."
      },
      {
        "title": "Wm D Heck, \"Pennsylvania, Cemetery Records, ca. 1700-ca. 1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3CXC-M4B",
        "citation": "\"Pennsylvania, Cemetery Records, ca. 1700-ca. 1950\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:ZKS8-16MM : Thu Mar 07 20:28:44 UTC 2024), Entry for Clifton E Heck and Clara M Heck."
      },
      {
        "title": "William Heck, \"Pennsylvania, County Marriages, 1775-1991\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/32HG-91M",
        "citation": "\"Pennsylvania, County Marriages, 1775-1991\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VF9Q-RV1 : Thu May 07 23:06:28 UTC 2026), Entry for Jos. L. Clemons and Elva Heck, 1 October 1907."
      },
      {
        "title": "W D Heck, \"Pennsylvania, Cemetery Records, ca. 1700-ca. 1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/78ZK-9DH",
        "citation": "\"Pennsylvania, Cemetery Records, ca. 1700-ca. 1950\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:ZKS8-16ZM : Thu Mar 07 20:28:44 UTC 2024), Entry for Minnie M Heck and C M Heck."
      },
      {
        "title": "W D Heck, \"Pennsylvania, Cemetery Records, ca. 1700-ca. 1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/78ZK-WDF",
        "citation": "\"Pennsylvania, Cemetery Records, ca. 1700-ca. 1950\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:ZKS8-162M : Thu Mar 07 20:28:45 UTC 2024), Entry for Virgie A Heck and C M Heck."
      },
      {
        "title": "W D Heck, \"Pennsylvania, Cemetery Records, ca. 1700-ca. 1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/78ZK-4PQ",
        "citation": "\"Pennsylvania, Cemetery Records, ca. 1700-ca. 1950\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:8D5K-C23Z : Sun Mar 10 04:43:31 UTC 2024), Entry for Virgie A Heck and C M Heck."
      },
      {
        "title": "Samuel Heck, \"United States, Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZNP-YTN",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MWVC-1V1 : Wed Sep 09 03:32:17 UTC 2026), Entry for Samuel Heck and Sophia Heck, 1880."
      },
      {
        "title": "Samuel Heck, \"United States, Census, 1870\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/988Z-TJH",
        "citation": "\"United States, Census, 1870\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MZTQ-NHP : Sun Jan 19 21:10:02 UTC 2025), Entry for Abraham Heck and Elizabeth Heck, 1870."
      },
      {
        "title": "William Heak, \"United States, Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9D7Q-PKY",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MWXL-Z3D : Wed Sep 09 08:30:20 UTC 2026), Entry for William Heak and Clara Heak, 1880."
      },
      {
        "title": "Samuel Heck, \"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QWQH-NXN",
        "citation": "\"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6K3H-3N6X : Wed Jul 01 11:00:24 UTC 2026), Entry for John Franklin Heck and Samuel Heck."
      },
      {
        "title": "W D Heck, \"Pennsylvania, Cemetery Records, ca. 1700-ca. 1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/78ZK-315",
        "citation": "\"Pennsylvania, Cemetery Records, ca. 1700-ca. 1950\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:8D5K-CKPZ : Sun Mar 10 04:43:32 UTC 2024), Entry for Minnie M Heck and C M Heck."
      },
      {
        "title": "William D Heck, \"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/74YQ-NNG",
        "citation": "\"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6K3H-DGJP : Tue Jun 30 21:33:04 UTC 2026), Entry for Charles Heck and William D Heck."
      },
      {
        "title": "William D Heck, \"Pennsylvania, Philadelphia, Historical Society of Pennsylvania, Deaths and Burials, 1627-1972\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/78ZK-D38",
        "citation": "\"Pennsylvania, Philadelphia, Historical Society of Pennsylvania, Deaths and Burials, 1627-1972\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CYD-FL1K : Thu Jan 16 17:11:29 UTC 2025), Entry for William D Heck, 1910."
      },
      {
        "title": "William D Heck, \"United States, Census, 1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9DG3-R19",
        "citation": "\"United States, Census, 1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MGZQ-8CG : Wed Aug 13 19:32:01 UTC 2025), Entry for William D Heck and Clara Heck, 1910."
      },
      {
        "title": "William D Heck, \"Pennsylvania, Cemetery Records, ca. 1700-ca. 1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/36SM-562",
        "citation": "\"Pennsylvania, Cemetery Records, ca. 1700-ca. 1950\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:ZKS8-1D2M : Thu Mar 07 20:28:44 UTC 2024), Entry for William D Heck."
      },
      {
        "title": "William Heck, \"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/79YR-6RH",
        "citation": "\"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6K3H-B4C2 : Tue Jun 30 21:00:53 UTC 2026), Entry for Charles Raymond Heck and William Heck."
      },
      {
        "title": "William D Heck Household 1860 Census",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9D34-455",
        "citation": "\"United States, Census, 1860\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MXPJ-VY8 : Mon Jul 08 19:49:26 UTC 2024), Entry for David Heck and Mary Ann Heck, 1860."
      },
      {
        "title": "William D Heck, \"Find A Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9D34-4N1",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVVG-4538 : Sat Oct 03 06:29:11 UTC 2026), Entry for William D Heck."
      }
    ],
    "portrait": "/ancestors/portraits/048_LK69-37X.jpg"
  },
  {
    "id": "I158",
    "name": "Davis Heck",
    "sex": "M",
    "gen": 6,
    "slot": 32,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I60",
    "birthYear": 1820,
    "deathYear": 1895,
    "birthDate": "1820",
    "deathDate": "16 Feb 1895",
    "burialDate": "1895",
    "christeningDate": null,
    "birthPlace": "Pennsylvania, United States",
    "deathPlace": "Pennsylvania, United States",
    "burialPlace": "Elverson Methodist Cemetery, Elverson, Elverson, Chester, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LK6M-F78",
    "photo": "/ancestors/bubbles/096_LK6M-F78.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [
      {
        "kind": "Residence",
        "date": "1850",
        "place": "East Nantmeal Township, Chester, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1860",
        "place": "Chester, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1870",
        "place": "Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1880",
        "place": "East Nantmeal Township, Chester, Pennsylvania, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "David Heck, \"United States, Census, 1860\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9D3P-D4J",
        "citation": "\"United States, Census, 1860\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MXPJ-VY8 : Mon Jul 08 19:49:26 UTC 2024), Entry for David Heck and Mary Ann Heck, 1860."
      },
      {
        "title": "Davis Heck, \"Pennsylvania, Philadelphia, Historical Society of Pennsylvania, Deaths and Burials, 1627-1972\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q2P3-R94",
        "citation": "\"Pennsylvania, Philadelphia, Historical Society of Pennsylvania, Deaths and Burials, 1627-1972\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CYD-FL13 : Sun Jan 12 14:51:06 UTC 2025), Entry for Davis Heck, 1895."
      },
      {
        "title": "Davis Heck, \"Pennsylvania, Philadelphia, Historical Society of Pennsylvania, Births and Baptisms, 1520-1999\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q2P3-T79",
        "citation": "\"Pennsylvania, Philadelphia, Historical Society of Pennsylvania, Births and Baptisms, 1520-1999\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CTR-QRXG : Sat Jan 18 17:51:35 UTC 2025), Entry for Davis Heck, 1820."
      },
      {
        "title": "David, \"Pennsylvania, County Marriages, 1775-1991\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QPQ5-9SZ",
        "citation": "\"Pennsylvania, County Marriages, 1775-1991\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2Z4-ZK7L : Fri May 08 00:03:40 UTC 2026), Entry for Charles P Heck and Katie G Hatt, 15 October 1921."
      },
      {
        "title": "Davis Heck, \"Pennsylvania, Cemetery Records, ca. 1700-ca. 1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/784F-VDF",
        "citation": "\"Pennsylvania, Cemetery Records, ca. 1700-ca. 1950\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:ZKS8-TS3Z : Thu Mar 07 20:28:45 UTC 2024), Entry for Albert L Heck and Mary A Heck."
      },
      {
        "title": "Davis Heck, \"Pennsylvania, Cemetery Records, ca. 1700-ca. 1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3C65-BVL",
        "citation": "\"Pennsylvania, Cemetery Records, ca. 1700-ca. 1950\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:ZKS8-T96Z : Thu Mar 07 20:28:44 UTC 2024), Entry for Mary A Heck and Davis Heck."
      },
      {
        "title": "Davis Heck, \"Pennsylvania, Cemetery Records, ca. 1700-ca. 1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/36S9-WV3",
        "citation": "\"Pennsylvania, Cemetery Records, ca. 1700-ca. 1950\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:ZKS8-T92M : Thu Mar 07 20:28:44 UTC 2024), Entry for Davis Heck and Mary A Heck."
      },
      {
        "title": "Davis Heck, \"Pennsylvania, Cemetery Records, ca. 1700-ca. 1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3C6R-MK4",
        "citation": "\"Pennsylvania, Cemetery Records, ca. 1700-ca. 1950\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:8D5K-CKMM : Sun Mar 10 04:43:30 UTC 2024), Entry for James C Heck and Mary A Heck."
      },
      {
        "title": "Davis Heck, \"Pennsylvania, Cemetery Records, ca. 1700-ca. 1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/784X-5BB",
        "citation": "\"Pennsylvania, Cemetery Records, ca. 1700-ca. 1950\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:8D5K-CVN2 : Sun Mar 10 04:43:32 UTC 2024), Entry for Albert L Heck and Mary Ann Heck."
      },
      {
        "title": "Davis Heck, \"Pennsylvania, Cemetery Records, ca. 1700-ca. 1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3VXV-D43",
        "citation": "\"Pennsylvania, Cemetery Records, ca. 1700-ca. 1950\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:8D5K-CVW2 : Sun Mar 10 04:43:32 UTC 2024), Entry for Davis Heck."
      },
      {
        "title": "Davis Heck, \"United States, Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9D7Q-TH2",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MWXL-F6K : Wed Sep 09 04:59:29 UTC 2026), Entry for Davis Heck and Mary Ann Heck, 1880."
      },
      {
        "title": "Davis, \"Pennsylvania, County Marriages, 1775-1991\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3C65-128",
        "citation": "\"Pennsylvania, County Marriages, 1775-1991\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VFMN-DNL : Thu May 07 23:03:39 UTC 2026), Entry for H. Morton Heck and Annie A. Haus, 5 June 1894."
      },
      {
        "title": "Davis Fleek, \"United States, Census, 1850\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/36S9-H2N",
        "citation": "\"United States, Census, 1850\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M4H9-87G : Tue Oct 21 05:00:45 UTC 2025), Entry for Davis Fleek and Mary A Fleek, 1850."
      },
      {
        "title": "Davis Heck, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9D3P-D1K",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVVG-45SK : Sat Oct 03 09:27:10 UTC 2026), Entry for Davis Heck."
      },
      {
        "title": "Davis Heck, \"United States, Census, 1870\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9D3P-6K4",
        "citation": "\"United States, Census, 1870\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MZG3-YXS : Fri Oct 10 08:48:59 UTC 2025), Entry for Davis Heck and A Mary Heck, 1870."
      },
      {
        "title": "Davis Heck, \"Pennsylvania, Cemetery Records, ca. 1700-ca. 1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3ZNG-9KS",
        "citation": "\"Pennsylvania, Cemetery Records, ca. 1700-ca. 1950\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:ZKS8-1DN2 : Thu Mar 07 20:28:44 UTC 2024), Entry for James C Heck and Mary A Heck."
      }
    ],
    "portrait": "/ancestors/portraits/096_LK6M-F78.jpg"
  },
  {
    "id": "I157",
    "name": "Mary Ann McCormick",
    "sex": "F",
    "gen": 6,
    "slot": 33,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I60",
    "birthYear": 1826,
    "deathYear": 1915,
    "birthDate": "1826",
    "deathDate": "1915",
    "burialDate": "1915",
    "christeningDate": null,
    "birthPlace": "Pennsylvania, United States",
    "deathPlace": "Pennsylvania, United States",
    "burialPlace": "Elverson Methodist Cemetery, Elverson, Elverson, Chester, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LK6M-FDM",
    "photo": "/ancestors/bubbles/097_LK6M-FDM.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [
      {
        "kind": "Residence",
        "date": "1880",
        "place": "East Nantmeal Township, Chester, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1910",
        "place": "East Nantmeal Township, Chester, Pennsylvania, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Mary, \"Pennsylvania, County Marriages, 1775-1991\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3C65-1J2",
        "citation": "\"Pennsylvania, County Marriages, 1775-1991\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VFMN-DNL : Thu May 07 23:03:39 UTC 2026), Entry for H. Morton Heck and Annie A. Haus, 5 June 1894."
      },
      {
        "title": "Mary A Heck, \"Pennsylvania, Cemetery Records, ca. 1700-ca. 1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3C65-B28",
        "citation": "\"Pennsylvania, Cemetery Records, ca. 1700-ca. 1950\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:ZKS8-T96Z : Thu Mar 07 20:28:44 UTC 2024), Entry for Mary A Heck and Davis Heck."
      },
      {
        "title": "Mary A Heck, \"Pennsylvania, Cemetery Records, ca. 1700-ca. 1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/36S9-WRC",
        "citation": "\"Pennsylvania, Cemetery Records, ca. 1700-ca. 1950\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:ZKS8-T92M : Thu Mar 07 20:28:44 UTC 2024), Entry for Davis Heck and Mary A Heck."
      },
      {
        "title": "Mary Ann Heck, \"United States, Census, 1860\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9D3P-DZ8",
        "citation": "\"United States, Census, 1860\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MXPJ-VY8 : Mon Jul 08 19:49:26 UTC 2024), Entry for David Heck and Mary Ann Heck, 1860."
      },
      {
        "title": "Mary Ann Heck, \"United States, Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9D7Q-TDS",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MWXL-F6K : Wed Sep 09 04:59:29 UTC 2026), Entry for Davis Heck and Mary Ann Heck, 1880."
      },
      {
        "title": "Mary Ann Heck, \"United States, Census, 1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3S6Y-XJY",
        "citation": "\"United States, Census, 1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MG37-4Y3 : Wed Aug 13 16:54:00 UTC 2025), Entry for Harrison Heck and Ida Heck, 1910."
      },
      {
        "title": "Mary A Heck, \"Pennsylvania, Cemetery Records, ca. 1700-ca. 1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3C6R-MDJ",
        "citation": "\"Pennsylvania, Cemetery Records, ca. 1700-ca. 1950\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:8D5K-CKMM : Sun Mar 10 04:43:30 UTC 2024), Entry for James C Heck and Mary A Heck."
      },
      {
        "title": "Mary Ann McCormie, \"Pennsylvania, County Marriages, 1775-1991\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QPQ5-MWR",
        "citation": "\"Pennsylvania, County Marriages, 1775-1991\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2Z4-ZK7L : Fri May 08 00:03:40 UTC 2026), Entry for Charles P Heck and Katie G Hatt, 15 October 1921."
      },
      {
        "title": "Mary A Heck, \"Pennsylvania, Cemetery Records, ca. 1700-ca. 1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/784F-VFB",
        "citation": "\"Pennsylvania, Cemetery Records, ca. 1700-ca. 1950\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:ZKS8-TS3Z : Thu Mar 07 20:28:45 UTC 2024), Entry for Albert L Heck and Mary A Heck."
      },
      {
        "title": "A Mary Heck, \"United States, Census, 1870\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9D3P-62R",
        "citation": "\"United States, Census, 1870\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MZG3-YXS : Fri Oct 10 08:48:59 UTC 2025), Entry for Davis Heck and A Mary Heck, 1870."
      },
      {
        "title": "Mary A Heck, \"Pennsylvania, Cemetery Records, ca. 1700-ca. 1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3ZNG-9NB",
        "citation": "\"Pennsylvania, Cemetery Records, ca. 1700-ca. 1950\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:ZKS8-1DN2 : Thu Mar 07 20:28:44 UTC 2024), Entry for James C Heck and Mary A Heck."
      },
      {
        "title": "Mary Ann Heck, \"Pennsylvania, Cemetery Records, ca. 1700-ca. 1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/784X-TVK",
        "citation": "\"Pennsylvania, Cemetery Records, ca. 1700-ca. 1950\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:8D5K-CVN2 : Sun Mar 10 04:43:32 UTC 2024), Entry for Albert L Heck and Mary Ann Heck."
      }
    ],
    "portrait": "/ancestors/portraits/097_LK6M-FDM.jpg"
  },
  {
    "id": "I56",
    "name": "Clara M Yarnall",
    "sex": "F",
    "gen": 5,
    "slot": 17,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I23",
    "birthYear": 1860,
    "deathYear": 1938,
    "birthDate": "1860",
    "deathDate": "1938",
    "burialDate": "1938",
    "christeningDate": null,
    "birthPlace": "Chester, Pennsylvania, United States",
    "deathPlace": "West Vincent Township, Chester, Pennsylvania, United States",
    "burialPlace": "Elverson Methodist Cemetery, Elverson, Elverson, Chester, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LK69-3DN",
    "photo": "/ancestors/bubbles/049_LK69-3DN.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [
      {
        "kind": "Residence",
        "date": "1870",
        "place": "West Nantmeal Township, Chester, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1880",
        "place": "East Nantmeal Township, Chester, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1880",
        "place": "West Nantmeal Township, Chester, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1900",
        "place": "East Nantmeal Township, Chester, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1910",
        "place": "Warwick Township, Chester, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1930",
        "place": "Warwick Township, Chester, Pennsylvania, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Clara Heck, \"United States, Census, 1930\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3CXH-R6D",
        "citation": "\"United States, Census, 1930\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XHDW-PT5 : Mon Jan 20 19:56:35 UTC 2025), Entry for Charles R Heck and Celia G Heck, 1930."
      },
      {
        "title": "C M Heck, \"Pennsylvania, Cemetery Records, ca. 1700-ca. 1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/78ZK-4T1",
        "citation": "\"Pennsylvania, Cemetery Records, ca. 1700-ca. 1950\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:8D5K-C23Z : Sun Mar 10 04:43:31 UTC 2024), Entry for Virgie A Heck and C M Heck."
      },
      {
        "title": "Clara Yarhall, \"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/79YR-6T4",
        "citation": "\"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6K3H-B4C2 : Tue Jun 30 21:00:53 UTC 2026), Entry for Charles Raymond Heck and William Heck."
      },
      {
        "title": "C M Heck, \"Pennsylvania, Cemetery Records, ca. 1700-ca. 1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/78ZK-QST",
        "citation": "\"Pennsylvania, Cemetery Records, ca. 1700-ca. 1950\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:8D5K-CKPZ : Sun Mar 10 04:43:32 UTC 2024), Entry for Minnie M Heck and C M Heck."
      },
      {
        "title": "Clara M Yarnall Heck, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3CKT-XYN",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVVG-45SJ : Sun Oct 04 19:42:10 UTC 2026), Entry for Clara M Yarnall Heck."
      },
      {
        "title": "Clara Heck, \"United States, Census, 1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9DG3-T7G",
        "citation": "\"United States, Census, 1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MGZQ-8CG : Wed Aug 13 19:32:01 UTC 2025), Entry for William D Heck and Clara Heck, 1910."
      },
      {
        "title": "Clara Heck, \"United States, Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3CXH-TWY",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MWXL-24V : Wed Sep 09 03:37:14 UTC 2026), Entry for Alfred Yarnall and Rebecca Yarnall, 1880."
      },
      {
        "title": "Clara M Heck, \"Pennsylvania, Cemetery Records, ca. 1700-ca. 1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3CXH-13H",
        "citation": "\"Pennsylvania, Cemetery Records, ca. 1700-ca. 1950\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:ZKS8-16MM : Thu Mar 07 20:28:44 UTC 2024), Entry for Clifton E Heck and Clara M Heck."
      },
      {
        "title": "Clara Yarnell, \"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/74YQ-NJ7",
        "citation": "\"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6K3H-DGJP : Tue Jun 30 21:33:04 UTC 2026), Entry for Charles Heck and William D Heck."
      },
      {
        "title": "C M Heck, \"Pennsylvania, Cemetery Records, ca. 1700-ca. 1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/78ZK-WV9",
        "citation": "\"Pennsylvania, Cemetery Records, ca. 1700-ca. 1950\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:ZKS8-162M : Thu Mar 07 20:28:45 UTC 2024), Entry for Virgie A Heck and C M Heck."
      },
      {
        "title": "Clara Yarnall, \"United States, Census, 1870\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3QYL-K2K",
        "citation": "\"United States, Census, 1870\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MZG4-SPF : Wed Oct 15 05:00:09 UTC 2025), Entry for Alfred Yarnall and Rebecca Yarnall, 1870."
      },
      {
        "title": "C M Heck, \"Pennsylvania, Cemetery Records, ca. 1700-ca. 1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/78ZK-94P",
        "citation": "\"Pennsylvania, Cemetery Records, ca. 1700-ca. 1950\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:ZKS8-16ZM : Thu Mar 07 20:28:44 UTC 2024), Entry for Minnie M Heck and C M Heck."
      },
      {
        "title": "Clara Heak, \"United States, Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9D7Q-PLG",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MWXL-Z3D : Wed Sep 09 08:30:20 UTC 2026), Entry for William Heak and Clara Heak, 1880."
      },
      {
        "title": "Clara Heck, \"United States, Census, 1900\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SJ1D-NWP",
        "citation": "\"United States, Census, 1900\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M39N-YPR : Wed May 21 05:55:57 UTC 2025), Entry for William D Heck and Clara Heck, 1900."
      },
      {
        "title": "Clara M Heck, \"Pennsylvania, Cemetery Records, ca. 1700-ca. 1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3CXH-TPM",
        "citation": "\"Pennsylvania, Cemetery Records, ca. 1700-ca. 1950\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:8D5K-CK6Z : Sun Mar 10 04:43:30 UTC 2024), Entry for Clifton E Heck and Clara M Heck."
      }
    ],
    "portrait": "/ancestors/portraits/049_LK69-3DN.jpg"
  },
  {
    "id": "I152",
    "name": "Alfred R Yarnall",
    "sex": "M",
    "gen": 6,
    "slot": 34,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I56",
    "birthYear": 1829,
    "deathYear": 1913,
    "birthDate": "20 Feb 1829",
    "deathDate": "1 Jul 1913",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Chester, Pennsylvania, United States",
    "deathPlace": "West Bradford Township, Chester, Pennsylvania, United States",
    "burialPlace": "Elverson Methodist Cemetery, Elverson, Elverson, Chester, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "931T-DW5",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [
      {
        "kind": "Residence",
        "date": "1850",
        "place": "West Nantmeal Township, Chester, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1860",
        "place": "Honey Brook Township, Chester, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1870",
        "place": "West Nantmeal Township, Chester, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1880",
        "place": "West Nantmeal Township, Chester, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1900",
        "place": "West Nantmeal Township, Chester, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1910",
        "place": "Honey Brook, Honey Brook Township, Chester, Pennsylvania, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Alfred Yarnall, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3CKT-FDZ",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6ZRQ-8S1R : Fri Oct 02 06:59:53 UTC 2026), Entry for Alfred Yarnall."
      },
      {
        "title": "Alfred Yarnall - Find A Grave Memorial",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3C6K-FBB",
        "citation": "Find a Grave, database and images (www.findagrave.com/memorial/227015859/alfred-yarnall : accessed 15 July 2021), memorial page for Alfred Yarnall (20 Feb 1829–1 Jul 1913), Find a Grave Memorial ID 227015859, citing Elverson Methodist Cemetery, Elverson, Chester County, Pennsylvania, USA ; Maintained by Mary Yarnall Reed (contributor 47624611) ."
      },
      {
        "title": "Alfred P Yarnall, \"United States, Census, 1850\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9JF1-ZHR",
        "citation": "\"United States, Census, 1850\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M4H9-D2T : Fri Jan 17 15:48:34 UTC 2025), Entry for Peter H Yarnall and Ann P Yarnall, 1850."
      },
      {
        "title": "Alfred Yarnell, \"United States, Census, 1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3C6K-6HH",
        "citation": "\"United States, Census, 1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MG37-Y2P : Wed Aug 13 16:55:32 UTC 2025), Entry for Thomas Aikens and Emma Aikens, 1910."
      },
      {
        "title": "Alfred Yannell, \"United States, Census, 1860\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3QYL-R3S",
        "citation": "\"United States, Census, 1860\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MXRK-ZPT : Mon Jul 08 19:34:31 UTC 2024), Entry for Alfred Yannell and Rebecca Yannell, 1860."
      },
      {
        "title": "Allred Yarnell, \"United States, Census, 1900\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3QYL-543",
        "citation": "\"United States, Census, 1900\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M392-KMR : Mon Dec 08 03:12:22 UTC 2025), Entry for Allred Yarnell and Rebecca Yarnall, 1900."
      },
      {
        "title": "Alfred Yarnall, \"United States, Census, 1870\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3QYL-K56",
        "citation": "\"United States, Census, 1870\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MZG4-SPF : Wed Oct 15 05:00:09 UTC 2025), Entry for Alfred Yarnall and Rebecca Yarnall, 1870."
      },
      {
        "title": "Alfred Yarnall, \"United States, Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9FQR-ZXW",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MWXL-24V : Wed Sep 09 03:37:14 UTC 2026), Entry for Alfred Yarnall and Rebecca Yarnall, 1880."
      }
    ]
  },
  {
    "id": "I150",
    "name": "Rebecca Reynolds",
    "sex": "F",
    "gen": 6,
    "slot": 35,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I56",
    "birthYear": 1838,
    "deathYear": null,
    "birthDate": "1838",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Pennsylvania",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "931T-D4W",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [
      {
        "kind": "Residence",
        "date": "1860",
        "place": "Honey Brook Township, Chester, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1870",
        "place": "West Nantmeal Township, Chester, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1880",
        "place": "West Nantmeal Township, Chester, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1900",
        "place": "West Nantmeal Township, Chester, Pennsylvania, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Rebecca Yannell, \"United States, Census, 1860\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3QYL-5G3",
        "citation": "\"United States, Census, 1860\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MXRK-ZPT : Mon Jul 08 19:34:31 UTC 2024), Entry for Alfred Yannell and Rebecca Yannell, 1860."
      },
      {
        "title": "Rebecca Yarnall, \"United States, Census, 1900\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3QYL-5Q4",
        "citation": "\"United States, Census, 1900\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M392-KMR : Mon Dec 08 03:12:22 UTC 2025), Entry for Allred Yarnell and Rebecca Yarnall, 1900."
      },
      {
        "title": "Rebecca Yarnall, \"United States, Census, 1870\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3QYL-VLG",
        "citation": "\"United States, Census, 1870\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MZG4-SPF : Wed Oct 15 05:00:09 UTC 2025), Entry for Alfred Yarnall and Rebecca Yarnall, 1870."
      },
      {
        "title": "Rebecca Yarnall, \"United States, Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3QYL-N3Z",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MWXL-24V : Wed Sep 09 03:37:14 UTC 2026), Entry for Alfred Yarnall and Rebecca Yarnall, 1880."
      }
    ]
  },
  {
    "id": "I22",
    "name": "Maude E Noble",
    "sex": "F",
    "gen": 4,
    "slot": 9,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I13",
    "birthYear": 1891,
    "deathYear": 1986,
    "birthDate": "1891",
    "deathDate": "1986",
    "burialDate": "1986",
    "christeningDate": null,
    "birthPlace": "Pennsylvania, United States",
    "deathPlace": null,
    "burialPlace": "Saint Matthews Lutheran Cemetery, West Vincent Township, Chester, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "9KLF-RX7",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [
      {
        "kind": "Residence",
        "date": "1900",
        "place": "Damascus Township, Wayne, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1910",
        "place": "Damascus Township, Wayne, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1920",
        "place": "Chester, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1930",
        "place": "Phoenixville, Chester, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1935",
        "place": "Same House",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1940",
        "place": "Phoenixville, Chester, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1 April 1950",
        "place": "Phoenixville, Chester, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": null,
        "place": "Harmonyville, Warwick Township, Chester, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Occupation",
        "date": null,
        "place": null,
        "note": "Housework"
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Maude E Hoffecker, \"United States, Census, 1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/W6V2-YNY",
        "citation": "\"United States, Census, 1950\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6XBV-M4S6 : Wed Mar 20 19:55:29 UTC 2024), Entry for Harry A Hoffecker and Maude E Hoffecker, 1 April 1950."
      },
      {
        "title": "Maud Hoffecker, \"United States, Census, 1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/WC3N-WYQ",
        "citation": "\"United States, Census, 1940\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KQH4-V24 : Fri Mar 08 20:46:34 UTC 2024), Entry for Howard Hoffecker and Maud Hoffecker, 1940."
      },
      {
        "title": "Maud E Heck, \"United States, Census, 1920\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/W6V2-51Y",
        "citation": "\"United States, Census, 1920\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MFTT-GTS : Sun Sep 27 17:01:16 UTC 2026), Entry for Maud E Heck and Russell O Heck, 1920."
      },
      {
        "title": "Maude E. Noble Hoffecker, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/785W-CR2",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVK4-R5QC : Sun Oct 04 09:27:11 UTC 2026), Entry for Maude E. Noble Hoffecker."
      },
      {
        "title": "Maud E. Noble, \"Pennsylvania, County Marriages, 1775-1991\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/785W-HRC",
        "citation": "\"Pennsylvania, County Marriages, 1775-1991\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VFSS-L9X : Thu May 07 23:11:00 UTC 2026), Entry for Harry A. Hoffecker and Maud E. Noble, 16 December 1922."
      },
      {
        "title": "Maud E Noble, \"Pennsylvania, Philadelphia, Historical Society of Pennsylvania, Marriage Records, 1512-1989\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/78VH-17Y",
        "citation": "\"Pennsylvania, Philadelphia, Historical Society of Pennsylvania, Marriage Records, 1512-1989\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CYX-9M5K : Thu Mar 07 23:03:19 UTC 2024), Entry for Charles R Heck and Maud E Noble, 28 February 1912."
      },
      {
        "title": "Maud E Noble, \"Pennsylvania, Philadelphia, Historical Society of Pennsylvania, Marriage Records, 1512-1989\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/78VH-YRX",
        "citation": "\"Pennsylvania, Philadelphia, Historical Society of Pennsylvania, Marriage Records, 1512-1989\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CYX-78R1 : Thu Mar 07 23:03:19 UTC 2024), Entry for Maud E Noble and Charles R Heck, 28 February 1912."
      },
      {
        "title": "Maud E. Noble, \"Pennsylvania, County Marriages, 1775-1991\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7MMN-T7P",
        "citation": "\"Pennsylvania, County Marriages, 1775-1991\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VF93-31N : Fri May 08 00:33:47 UTC 2026), Entry for Charles R. Heck and Maud E. Noble, 28 February 1912."
      },
      {
        "title": "Maude E Noble, \"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q1B9-781",
        "citation": "\"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6K9K-R6WT : Tue Jun 30 05:28:38 UTC 2026), Entry for Hazel H Fox and Charles R Heck."
      },
      {
        "title": "Maude E Hoffecker, \"United States, Census, 1930\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QZHQ-BSB",
        "citation": "\"United States, Census, 1930\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XHD4-F9Q : Wed Oct 15 23:39:41 UTC 2025), Entry for Harry A Hoffecker and Maude E Hoffecker, 1930."
      },
      {
        "title": "tombstone photo",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SFGB-CTG",
        "citation": ""
      },
      {
        "title": "Maud E Noble in household of Henry M Noble, \"United States Census, 1900\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9VJW-9S7",
        "citation": "\"United States, Census, 1900\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M34R-2NY : Fri Jan 17 23:14:09 UTC 2025), Entry for Henry M Noble and Maggie J Noble, 1900."
      },
      {
        "title": "Maude E Noble, \"United States, Census, 1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZJ2-HHT",
        "citation": "\"United States, Census, 1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MGWG-21L : Wed Aug 13 17:11:15 UTC 2025), Entry for Henry M Noble and Margarette Noble, 1910."
      }
    ]
  },
  {
    "id": "I48",
    "name": "Henry Miles Noble",
    "sex": "M",
    "gen": 5,
    "slot": 18,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I22",
    "birthYear": 1859,
    "deathYear": 1935,
    "birthDate": "26 Jan 1859",
    "deathDate": "6 May 1935",
    "burialDate": "1935",
    "christeningDate": null,
    "birthPlace": "Damascus, Wayne, Pennsylvania, United States",
    "deathPlace": "Wayne, Pennsylvania, United States",
    "burialPlace": "Milanville, Wayne, Pennsylvania, United States of America",
    "christeningPlace": null,
    "fsId": "KHVP-TMW",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [
      {
        "kind": "Residence",
        "date": "1860",
        "place": "Damascus Township, Wayne, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1870",
        "place": "Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1880",
        "place": "Damascus, Damascus Township, Wayne, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1900",
        "place": "Damascus Township, Wayne, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1910",
        "place": "Damascus, Damascus Township, Wayne, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1920",
        "place": "Damascus, Damascus Township, Wayne, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1930",
        "place": "Damascus, Damascus Township, Wayne, Pennsylvania, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "H Noble, \"United States, Census, 1860\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/WD5H-Q8M",
        "citation": "\"United States, Census, 1860\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MXRY-RS6 : Mon Jul 08 22:20:42 UTC 2024), Entry for Wm Noble and E Noble, 1860."
      },
      {
        "title": "Yale Noble, \"Pennsylvania, Delayed Birth Records, 1780-1977\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S1QH-XPK",
        "citation": "\"Pennsylvania, Delayed Birth Records, 1780-1977\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:877B-RR3Z : Fri Jan 17 10:52:46 UTC 2025), Entry for Yale Noble and Henry M Noble, 9 Sep 1895."
      },
      {
        "title": "Henry M Noble, \"Pennsylvania, Delayed Birth Records, 1780-1977\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S1QH-6NT",
        "citation": "\"Pennsylvania, Delayed Birth Records, 1780-1977\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:877B-RR3Z : Fri Jan 17 10:52:46 UTC 2025), Entry for Yale Noble and Henry M Noble, 9 Sep 1895."
      },
      {
        "title": "H M Noble, \"Pennsylvania, Delayed Birth Records, 1780-1977\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S1QH-63N",
        "citation": "\"Pennsylvania, Delayed Birth Records, 1780-1977\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:877B-RG3Z : Sat Jan 18 17:24:30 UTC 2025), Entry for Hazel M Noble and H M Noble, 29 Mar 1894."
      },
      {
        "title": "H. M. Noble in entry for Hazel M Noble, \"Pennsylvania, Births and Christenings, 1709-1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SBRS-VSK",
        "citation": "\"Pennsylvania, Births and Christenings, 1709-1950\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:HFKB-QCZM : 16 December 2023), H. M. Noble in entry for Hazel M Noble, 1893."
      },
      {
        "title": "Henry M. Noble, \"Pennsylvania, County Marriages, 1775-1991\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SBRS-7VB",
        "citation": "\"Pennsylvania, County Marriages, 1775-1991\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VF9K-9SZ : Fri May 08 00:29:12 UTC 2026), Entry for Henry M. Noble and Maggie A. Nolan, 2 January 1890."
      },
      {
        "title": "Henry M Noble in entry for Yale Noble, \"Pennsylvania, Births and Christenings, 1709-1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SRHY-PG5",
        "citation": "\"Pennsylvania, Births and Christenings, 1709-1950\", , FamilySearch (https://www.familysearch.org/ark:/61903/1:1:HFLS-SMZM : 16 December 2023), Henry M Noble in entry for Yale Noble, 1895."
      },
      {
        "title": "Henry Miles Noble in the North America, Family Histories, 1500-2000",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SMGK-CS4",
        "citation": "\"Henry Miles Noble in the North America, Family Histories, 1500-2000.\" Henry Miles Noble in the North America, Family Histories, 1500-2000. N.p., n.d. Web. 24 Aug. 2018. ."
      },
      {
        "title": "Henry M Noble, \"United States, Census, 1930\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SMGK-HF2",
        "citation": "\"United States, Census, 1930\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XHHN-J1M : Fri Mar 08 19:27:17 UTC 2024), Entry for Henry M Noble, 1930."
      },
      {
        "title": "Henry M Noble, \"United States, Census, 1870\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SMGX-BZD",
        "citation": "\"United States, Census, 1870\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MZ25-S2D : Fri Oct 17 09:44:57 UTC 2025), Entry for William Noble and Eunice Noble, 1870."
      },
      {
        "title": "Henry M. Noble, \"Pennsylvania, Marriages, 1709-1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MDTT-38T",
        "citation": "\"Pennsylvania, Marriages, 1709-1940\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:V2XZ-1F5 : 7 May 2023), Henry M. Noble, 1890."
      },
      {
        "title": "Henry M. Noble, \"United States, Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SMGX-YF3",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MWVP-9XM : Wed Sep 09 07:00:10 UTC 2026), Entry for Eunice G. Noble and Emerson Noble, 1880."
      },
      {
        "title": "Henry M Noble, \"United States Census, 1900\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9VJW-MT5",
        "citation": "\"United States, Census, 1900\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M34R-2NY : Fri Jan 17 23:14:09 UTC 2025), Entry for Henry M Noble and Maggie J Noble, 1900."
      },
      {
        "title": "Henry M Noble, \"United States, Census, 1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZJ2-41S",
        "citation": "\"United States, Census, 1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MGWG-21L : Wed Aug 13 17:11:15 UTC 2025), Entry for Henry M Noble and Margarette Noble, 1910."
      },
      {
        "title": "Henry M Noble, \"United States Census, 1920\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9VJ7-TXX",
        "citation": "\"United States, Census, 1920\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MX9W-34Z : Mon Sep 28 02:41:15 UTC 2026), Entry for Henry M Noble and Margaret A Noble, 1920."
      },
      {
        "title": "Henry Myles Noble, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SMGK-4ZH",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QV2J-54T8 : Sun Oct 04 13:57:25 UTC 2026), Entry for Henry Myles Noble."
      },
      {
        "title": "Henry M Noble in the Pennsylvania, Death Certificates, 1906-1966",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SMGX-R83",
        "citation": "\"Henry M Noble in the Pennsylvania, Death Certificates, 1906-1966.\" Henry M Noble in the Pennsylvania, Death Certificates, 1906-1966. N.p., n.d. Web. 24 Aug. 2018. ."
      },
      {
        "title": "Henry M in entry for Cleo C Stevens and Bernice B Noble, \"Pennsylvania, County Marriages, 1885-1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9VJ7-YTZ",
        "citation": "\"Pennsylvania, County Marriages, 1775-1991\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KHX1-7Z5 : Fri May 08 01:18:30 UTC 2026), Entry for Cleo C Stevens and Bernice B Noble, 1 February 1929."
      }
    ]
  },
  {
    "id": "I145",
    "name": "William Cooley Noble",
    "sex": "M",
    "gen": 6,
    "slot": 36,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I48",
    "birthYear": 1824,
    "deathYear": 1878,
    "birthDate": "2 Mar 1824",
    "deathDate": "18 Mar 1878",
    "burialDate": "1878",
    "christeningDate": null,
    "birthPlace": "Damascus, Wayne, Pennsylvania, United States",
    "deathPlace": null,
    "burialPlace": "Milanville, Wayne, Pennsylvania, United States of America",
    "christeningPlace": null,
    "fsId": "KHJ1-2BR",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [
      {
        "kind": "Residence",
        "date": "1860",
        "place": "Damascus Township, Wayne, Pennsylvania, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "William Cooley Noble in the North America, Family Histories, 1500-2000",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SMGX-PKV",
        "citation": "\"William Cooley Noble in the North America, Family Histories, 1500-2000.\" William Cooley Noble in the North America, Family Histories, 1500-2000. N.p., n.d. Web. 24 Aug. 2018. ."
      },
      {
        "title": "William Noble, \"United States Census, 1870\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMBN-Q9V",
        "citation": "\"United States, Census, 1870\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MZ25-S2D : Fri Oct 17 09:44:57 UTC 2025), Entry for William Noble and Eunice Noble, 1870."
      },
      {
        "title": "Wm Noble, \"United States, Census, 1860\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/WD5H-32D",
        "citation": "\"United States, Census, 1860\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MXRY-RS6 : Mon Jul 08 22:20:42 UTC 2024), Entry for Wm Noble and E Noble, 1860."
      },
      {
        "title": "William Noble, \"United States Census, 1850\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MMBN-QSD",
        "citation": "\"United States, Census, 1850\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M4Z4-ZGZ : Wed Oct 22 22:51:15 UTC 2025), Entry for William Noble and Unice Noble, 1850."
      },
      {
        "title": "William Cooley Noble, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SMGX-GBD",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVGW-5NLR : Sat Oct 03 11:57:32 UTC 2026), Entry for William Cooley Noble."
      }
    ]
  },
  {
    "id": "I147",
    "name": "Eunice Garrett",
    "sex": "F",
    "gen": 6,
    "slot": 37,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I48",
    "birthYear": 1831,
    "deathYear": 1900,
    "birthDate": "29 Aug 1831",
    "deathDate": "10 Jan 1900",
    "burialDate": "1900",
    "christeningDate": null,
    "birthPlace": "Berlin Township, Wayne, Pennsylvania, United States",
    "deathPlace": "Damascus, Wayne, Pennsylvania, United States",
    "burialPlace": "Milanville, Wayne, Pennsylvania, United States of America",
    "christeningPlace": null,
    "fsId": "KH5R-QVD",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [
      {
        "kind": "Residence",
        "date": "1850",
        "place": "Damascus Township, Wayne, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1860",
        "place": "Damascus Township, Wayne, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1870",
        "place": "Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1880",
        "place": "Damascus, Damascus Township, Wayne, Pennsylvania, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "E Noble, \"United States, Census, 1860\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/WD5H-35W",
        "citation": "\"United States, Census, 1860\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MXRY-RS6 : Mon Jul 08 22:20:42 UTC 2024), Entry for Wm Noble and E Noble, 1860."
      },
      {
        "title": "Unice Noble, \"United States, Census, 1850\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/39C4-9FZ",
        "citation": "\"United States, Census, 1850\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M4Z4-ZGZ : Wed Oct 22 22:51:15 UTC 2025), Entry for William Noble and Unice Noble, 1850."
      },
      {
        "title": "Eunice Garratt Noble, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SF8K-C26",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVGX-1ZZ5 : Fri Oct 02 11:22:34 UTC 2026), Entry for Eunice Garratt Noble."
      },
      {
        "title": "Eunice Noble, \"United States, Census, 1870\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SMGX-Y1L",
        "citation": "\"United States, Census, 1870\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MZ25-S2D : Fri Oct 17 09:44:57 UTC 2025), Entry for William Noble and Eunice Noble, 1870."
      },
      {
        "title": "Eunice G. Noble, \"United States, Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SMGX-Y64",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MWVP-9XM : Wed Sep 09 07:00:10 UTC 2026), Entry for Eunice G. Noble and Emerson Noble, 1880."
      }
    ]
  },
  {
    "id": "I54",
    "name": "Margaret Nolan",
    "sex": "F",
    "gen": 5,
    "slot": 19,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I22",
    "birthYear": 1863,
    "deathYear": 1925,
    "birthDate": "18 Jun 1863",
    "deathDate": "17 Sep 1925",
    "burialDate": "1925",
    "christeningDate": null,
    "birthPlace": "Riegelsville, Bucks, Pennsylvania, United States",
    "deathPlace": "Honesdale, Wayne, Pennsylvania, United States",
    "burialPlace": "Milanville, Wayne, Pennsylvania, United States of America",
    "christeningPlace": null,
    "fsId": "L6KQ-1JK",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Margaret Antoinette Nolan Noble"
    ],
    "facts": [
      {
        "kind": "Residence",
        "date": "1870",
        "place": "Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1880",
        "place": "Damascus, Damascus Township, Wayne, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1900",
        "place": "Damascus Township, Wayne, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1920",
        "place": "Damascus, Damascus Township, Wayne, Pennsylvania, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Maggie Noble, \"Pennsylvania, Delayed Birth Records, 1780-1977\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S1QH-622",
        "citation": "\"Pennsylvania, Delayed Birth Records, 1780-1977\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:877B-RR3Z : Fri Jan 17 10:52:46 UTC 2025), Entry for Yale Noble and Henry M Noble, 9 Sep 1895."
      },
      {
        "title": "Maggie Noble, \"Pennsylvania, Delayed Birth Records, 1780-1977\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S1QH-6CC",
        "citation": "\"Pennsylvania, Delayed Birth Records, 1780-1977\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:877B-RG3Z : Sat Jan 18 17:24:30 UTC 2025), Entry for Hazel M Noble and H M Noble, 29 Mar 1894."
      },
      {
        "title": "Maggie in entry for Hazel M Noble, \"Pennsylvania, Births and Christenings, 1709-1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SBRS-VJ9",
        "citation": "\"Pennsylvania, Births and Christenings, 1709-1950\", , FamilySearch (https://www.familysearch.org/ark:/61903/1:1:HFKB-QC6Z : 16 December 2023), Maggie in entry for Hazel M Noble, 1893."
      },
      {
        "title": "Maggie A. Nolan, \"Pennsylvania, County Marriages, 1775-1991\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SBRS-715",
        "citation": "\"Pennsylvania, County Marriages, 1775-1991\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VF9K-9SZ : Fri May 08 00:29:12 UTC 2026), Entry for Henry M. Noble and Maggie A. Nolan, 2 January 1890."
      },
      {
        "title": "Maggie Nolan, \"United States, Census, 1870\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SMGK-6Y9",
        "citation": "\"United States, Census, 1870\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MZ2P-SNK : Thu Jan 16 02:51:56 UTC 2025), Entry for James Nolan and Mary Nolan, 1870."
      },
      {
        "title": "Margret Nolan in household of James Nolan, \"United States Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/92W6-Y9T",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MWVP-9FJ : Wed Sep 09 06:56:29 UTC 2026), Entry for James Nolan and Susana Nolan, 1880."
      },
      {
        "title": "Maggie A. Nolan in entry for Henry M. Noble, \"Pennsylvania, Marriages, 1709-1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SMGK-4N5",
        "citation": "\"Pennsylvania, Marriages, 1709-1940\", , FamilySearch (https://www.familysearch.org/ark:/61903/1:1:V2XZ-1FR : 7 May 2023), Maggie A. Nolan in entry for Henry M. Noble, 1890."
      },
      {
        "title": "Maggie J Noble in household of Henry M Noble, \"United States Census, 1900\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9VJW-M1T",
        "citation": "\"United States, Census, 1900\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M34R-2NY : Fri Jan 17 23:14:09 UTC 2025), Entry for Henry M Noble and Maggie J Noble, 1900."
      },
      {
        "title": "Margarette Noble, \"United States, Census, 1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZJ2-HMG",
        "citation": "\"United States, Census, 1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MGWG-21L : Wed Aug 13 17:11:15 UTC 2025), Entry for Henry M Noble and Margarette Noble, 1910."
      },
      {
        "title": "Margaret A Noble in household of Henry M Noble, \"United States Census, 1920\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9VJ7-TNV",
        "citation": "\"United States, Census, 1920\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MX9W-34Z : Mon Sep 28 02:41:15 UTC 2026), Entry for Henry M Noble and Margaret A Noble, 1920."
      },
      {
        "title": "Margaret A Noble in the Pennsylvania, Death Certificates, 1906-1966",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SMGK-CZK",
        "citation": "\"Margaret A Noble in the Pennsylvania, Death Certificates, 1906-1966.\" Margaret A Noble in the Pennsylvania, Death Certificates, 1906-1966. N.p., n.d. Web. 24 Aug. 2018. ."
      },
      {
        "title": "Margaret Antoinette Nolan Noble, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SMGK-ZML",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QV2J-54TF : Sun Oct 04 22:56:30 UTC 2026), Entry for Margaret Antoinette Nolan Noble."
      },
      {
        "title": "Margaret Nolan in entry for Cleo C Stevens and Bernice B Noble, \"Pennsylvania, County Marriages, 1885-1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9VJ7-YLN",
        "citation": "\"Pennsylvania, County Marriages, 1775-1991\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KHX1-7Z5 : Fri May 08 01:18:30 UTC 2026), Entry for Cleo C Stevens and Bernice B Noble, 1 February 1929."
      }
    ]
  },
  {
    "id": "I140",
    "name": "James Nolan",
    "sex": "M",
    "gen": 6,
    "slot": 38,
    "side": "maternal",
    "birthplace": "ireland",
    "childId": "I54",
    "birthYear": 1832,
    "deathYear": null,
    "birthDate": "1832",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Ireland",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "P7VC-3H3",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [
      {
        "kind": "Residence",
        "date": "1880",
        "place": "Damascus Township, Wayne, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Occupation",
        "date": null,
        "place": null,
        "note": "Farmer"
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "James Nolan, \"United States, Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7T6X-SFC",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MWVP-9FJ : Wed Sep 09 06:56:29 UTC 2026), Entry for James Nolan and Susana Nolan, 1880."
      }
    ]
  },
  {
    "id": "I141",
    "name": "Susanna Charles",
    "sex": "F",
    "gen": 6,
    "slot": 39,
    "side": "maternal",
    "birthplace": "ireland",
    "childId": "I54",
    "birthYear": null,
    "deathYear": null,
    "birthDate": null,
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Ireland",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "L1K2-C1L",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [
      {
        "kind": "Residence",
        "date": "1880",
        "place": "Damascus, Damascus Township, Wayne, Pennsylvania, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Susana Nolan, \"United States, Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SMGK-D7Z",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MWVP-9FJ : Wed Sep 09 06:56:29 UTC 2026), Entry for James Nolan and Susana Nolan, 1880."
      }
    ]
  },
  {
    "id": "I12",
    "name": "Alberta Johnson",
    "sex": "F",
    "gen": 3,
    "slot": 5,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I7",
    "birthYear": 1914,
    "deathYear": 1992,
    "birthDate": "5 Dec 1914",
    "deathDate": "Jun 1992",
    "burialDate": "1992",
    "christeningDate": null,
    "birthPlace": "Pottstown, Montgomery, Pennsylvania, United States",
    "deathPlace": null,
    "burialPlace": "Mount Carmel Methodist Church Cemetery, Saint Peters, Chester, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "GLY5-SSK",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [
      {
        "kind": "Residence",
        "date": "1920",
        "place": "Montgomery, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1930",
        "place": "Royersford, Montgomery, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "5 April 1950",
        "place": "Royersford, Montgomery, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Occupation",
        "date": null,
        "place": null,
        "note": "Checker At Food Store"
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "tombstone photo",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SFP7-94G",
        "citation": ""
      },
      {
        "title": "Alberta Johnson, \"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QN6Z-JRM",
        "citation": "\"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6K9T-3FM9 : Sun Jul 05 14:23:04 UTC 2026), Entry for Alberta Johnson Heck and Walter H Johnson."
      },
      {
        "title": "Maggie A Johnson, \"United States, Census, 1920\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QYGN-CT9",
        "citation": "\"United States, Census, 1920\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MF19-2XV : Sun Sep 27 21:51:06 UTC 2026), Entry for Walter H Johnson and Hellen A Johnson, 1920."
      },
      {
        "title": "M Alberta Heck, \"United States, Census, 1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/785W-66F",
        "citation": "\"United States, Census, 1950\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6XBK-RNJ3 : Tue Mar 19 16:28:26 UTC 2024), Entry for Russell O Heck and M Alberta Heck, 5 April 1950."
      },
      {
        "title": "Alberta Johnson, \"United States, GenealogyBank Obituaries, Births, and Marriages, 1980-2015\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7GKB-64M",
        "citation": "\"United States, GenealogyBank Obituaries, Births, and Marriages, 1980-2015\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:X3T4-ZTCJ : Sun Jul 06 11:38:37 UTC 2025), Entry for James R Heck and Russell O Heck, 6 July 2025."
      },
      {
        "title": "Alberta Johnson, \"United States, GenealogyBank Obituaries, Births, and Marriages, 1980-2015\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7GKB-6BH",
        "citation": "\"United States, GenealogyBank Obituaries, Births, and Marriages, 1980-2015\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:X3TW-5LRQ : Sun Jul 06 07:34:48 UTC 2025), Entry for James R Heck and Russell O Heck, 6 July 2025."
      },
      {
        "title": "Alberta Johnson, \"United States, Census, 1930\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QYGL-17P",
        "citation": "\"United States, Census, 1930\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XHZ7-2SJ : Sun Mar 10 09:51:39 UTC 2024), Entry for Oliver Place and Laura Place, 1930."
      },
      {
        "title": "Alberta M Heck, \"United States, Census, 1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q35N-76P",
        "citation": "\"United States, Census, 1940\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KQDB-234 : Tue Jan 21 08:47:18 UTC 2025), Entry for Russell O Heck and Alberta M Heck, 1940."
      }
    ]
  },
  {
    "id": "I18",
    "name": "Walter Hatfield Johnson",
    "sex": "M",
    "gen": 4,
    "slot": 10,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I12",
    "birthYear": 1886,
    "deathYear": 1947,
    "birthDate": "18 Sep 1886",
    "deathDate": "27 Aug 1947",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Pennsylvania, United States",
    "deathPlace": null,
    "burialPlace": "Pottstown Cemetery, Pottstown, Montgomery, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LFL1-3Z4",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [
      {
        "kind": "Residence",
        "date": "1900",
        "place": "West Pottsgrove Township, Montgomery, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1920",
        "place": "Montgomery, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1930",
        "place": "Reading, Berks, Pennsylvania, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Walter Hatfield Johnson, \"United States, World War II Draft Registration Cards, 1942\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7T69-N6Y",
        "citation": "\"United States, World War II Draft Registration Cards, 1942\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VQFT-3VH : Mon Mar 30 02:52:38 UTC 2026), Entry for Walter Hatfield Johnson, 1942."
      },
      {
        "title": "Walter Johnson, \"United States, Census, 1930\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QYGN-Z7D",
        "citation": "\"United States, Census, 1930\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XCZP-CMB : Sun Mar 10 14:03:17 UTC 2024), Entry for Angelo Pasqualle and Evelyn Pasqualle, 1930."
      },
      {
        "title": "Walter H Johnson, \"United States, Census, 1920\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QYGN-4TL",
        "citation": "\"United States, Census, 1920\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MF19-2XV : Sun Sep 27 21:51:06 UTC 2026), Entry for Walter H Johnson and Hellen A Johnson, 1920."
      },
      {
        "title": "Walter H. Johnson, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QYGN-42Q",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QGTY-8P95 : Sun Oct 04 09:21:02 UTC 2026), Entry for Walter H. Johnson."
      },
      {
        "title": "Walter Johnson in entry for Arthur Le-Roy Johnson, \"Pennsylvania, Births and Christenings, 1709-1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QGR8-PYM",
        "citation": "\"Pennsylvania, Births and Christenings, 1709-1950\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:HFKM-TCW2 : 16 December 2023), Walter Johnson in entry for Arthur Le-Roy Johnson, 1905."
      },
      {
        "title": "Walter H Johnson, \"Pennsylvania, Civil Marriages, 1677-1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QGRZ-HD7",
        "citation": "\"Pennsylvania, Civil Marriages, 1677-1950\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q29S-5NT4 : Sat Jan 11 10:04:29 UTC 2025), Entry for Walter H Johnson and George Johnson, 01 Jun 1905."
      },
      {
        "title": "Walter H Johnson, \"Pennsylvania, Obituaries, 1977-2010\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QG9D-V1Q",
        "citation": "\"Pennsylvania, Obituaries, 1977-2010\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVF1-T42Q : Fri May 02 20:24:26 UTC 2025), Entry for Evelyn M Hohl and George I Hohl, 2000."
      },
      {
        "title": "Walter H Johnson, \"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QN6Z-J6V",
        "citation": "\"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6K9T-3FM9 : Sun Jul 05 14:23:04 UTC 2026), Entry for Alberta Johnson Heck and Walter H Johnson."
      },
      {
        "title": "Walter Johnson in entry for Laura Violette Johnson, \"Pennsylvania, Births and Christenings, 1709-1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QN6Z-NT4",
        "citation": "\"Pennsylvania, Births and Christenings, 1709-1950\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:HFKL-8Q3Z : 16 December 2023), Walter Johnson in entry for Laura Violette Johnson, 1907."
      },
      {
        "title": "Walter Johnson, \"United States, Census, 1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S143-4DV",
        "citation": "\"United States, Census, 1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MG4B-L2S : Wed Aug 13 19:17:21 UTC 2025), Entry for Walter Johnson and Maggie Johnson, 1910."
      },
      {
        "title": "Walter Johnson, \"United States, Census, 1900\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SFDH-75H",
        "citation": "\"United States, Census, 1900\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M3Q2-JJM : Wed May 14 06:57:20 UTC 2025), Entry for George Johnson and Walter Johnson, 1900."
      }
    ]
  },
  {
    "id": "I45",
    "name": "George M. Johnson",
    "sex": "M",
    "gen": 5,
    "slot": 20,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I18",
    "birthYear": 1865,
    "deathYear": 1945,
    "birthDate": "20 Jul 1865",
    "deathDate": "12 Aug 1945",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Berks, Pennsylvania, United States",
    "deathPlace": "Pottstown, Montgomery, Pennsylvania, United States",
    "burialPlace": "Pottstown Cemetery, Pottstown, Montgomery, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LYYX-FRY",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [
      {
        "title": "George Johnson, \"Pennsylvania, Civil Marriages, 1677-1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QYGG-CPN",
        "citation": "\"Pennsylvania, Civil Marriages, 1677-1950\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q29S-5NT4 : Sat Jan 11 10:04:29 UTC 2025), Entry for Walter H Johnson and George Johnson, 01 Jun 1905."
      },
      {
        "title": "George Johnson in entry for Gedude Johnson, \"Pennsylvania, Births and Christenings, 1709-1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QYVP-DN6",
        "citation": "\"Pennsylvania, Births and Christenings, 1709-1950\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:HFLS-QHT2 : 16 December 2023), George Johnson in entry for Gedude Johnson, 1899."
      },
      {
        "title": "George Johnson in entry for Johnson, \"Pennsylvania, Births and Christenings, 1709-1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QYV2-4JH",
        "citation": "\"Pennsylvania, Births and Christenings, 1709-1950\", , FamilySearch (https://www.familysearch.org/ark:/61903/1:1:HFG8-CWN2 : 16 December 2023), George Johnson in entry for Johnson, 1907."
      },
      {
        "title": "George Johnson in entry for George Johnson, \"Pennsylvania, Births and Christenings, 1709-1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QYJD-MC4",
        "citation": "\"Pennsylvania, Births and Christenings, 1709-1950\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:HFK7-VBT2 : 16 December 2023), George Johnson in entry for George Johnson, 1897."
      },
      {
        "title": "George Johnson in entry for Mabel Johnson, \"Pennsylvania, Births and Christenings, 1709-1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QYJ8-BV1",
        "citation": "\"Pennsylvania, Births and Christenings, 1709-1950\", , FamilySearch (https://www.familysearch.org/ark:/61903/1:1:HFKJ-HVMM : 16 December 2023), George Johnson in entry for Mabel Johnson, 1904."
      },
      {
        "title": "George M Johnson, \"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QYJ8-223",
        "citation": "\"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6K9L-KF5G : Fri Jul 03 11:40:34 UTC 2026), Entry for Mabel H Johnson and George M Johnson."
      },
      {
        "title": "George Johnson in entry for Edith Johnson, \"Pennsylvania, Births and Christenings, 1709-1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/35R3-255",
        "citation": "\"Pennsylvania, Births and Christenings, 1709-1950\", , FamilySearch (https://www.familysearch.org/ark:/61903/1:1:HFJT-HBMM : 16 December 2023), George Johnson in entry for Edith Johnson, 1895."
      },
      {
        "title": "George Johnson in entry for Edith Johnson, \"Pennsylvania, Births and Christenings, 1709-1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SW4R-13Z",
        "citation": "\"Pennsylvania, Births and Christenings, 1709-1950\", , FamilySearch (https://www.familysearch.org/ark:/61903/1:1:V2N3-P89 : 16 December 2023), George Johnson in entry for Edith Johnson, 1895."
      },
      {
        "title": "George M. Johnson in Pennsylvania, Death Certificates, 1906-1964",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9R3C-4JR",
        "citation": ""
      },
      {
        "title": "George M. Johnson, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9R3C-496",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVGW-YBMY : Sat Oct 03 15:47:52 UTC 2026), Entry for George M. Johnson."
      },
      {
        "title": "George Johnson, \"United States, Census, 1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9R3C-WTF",
        "citation": "\"United States, Census, 1940\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KQ7H-WCP : Fri Jan 24 02:16:56 UTC 2025), Entry for George Gross and Mamie S Gross, 1940."
      },
      {
        "title": "George Johnson, \"United States, Census, 1930\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9R3C-WR9",
        "citation": "\"United States, Census, 1930\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XHZ4-3LY : Sat Mar 09 10:18:23 UTC 2024), Entry for George Johnson and Elmira Johnson, 1930."
      },
      {
        "title": "George M Johnson, \"United States, Census, 1920\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9R3C-WPZ",
        "citation": "\"United States, Census, 1920\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MF1S-74M : Sun Sep 27 21:51:50 UTC 2026), Entry for George M Johnson and Elmira L Johnson, 1920."
      },
      {
        "title": "George Johnson, \"United States, Census, 1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9R3C-WL1",
        "citation": "\"United States, Census, 1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MG8G-4V6 : Wed Aug 13 17:05:54 UTC 2025), Entry for George Johnson and Elmira Johnson, 1910."
      },
      {
        "title": "George Johnson, \"United States, Census, 1900\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9R3C-W4H",
        "citation": "\"United States, Census, 1900\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M3Q2-JJM : Wed May 14 06:57:20 UTC 2025), Entry for George Johnson and Walter Johnson, 1900."
      },
      {
        "title": "George Johnson, \"United States, Census, 1870\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9R3Q-C77",
        "citation": "\"United States, Census, 1870\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MZLJ-NDR : Mon Jan 20 13:43:02 UTC 2025), Entry for Augustus Johnson and Sarah Johnson, 1870."
      }
    ]
  },
  {
    "id": "I136",
    "name": "Augustus Johnson",
    "sex": "M",
    "gen": 6,
    "slot": 40,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I45",
    "birthYear": 1831,
    "deathYear": 1909,
    "birthDate": "1 Sep 1831",
    "deathDate": "1 Sep 1909",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Berks, Pennsylvania, United States",
    "deathPlace": "Colebrookdale, Berks, Pennsylvania, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "L25G-5RM",
    "photo": "/ancestors/bubbles/104_L25G-5RM.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [
      {
        "kind": "Residence",
        "date": "1900",
        "place": "Earl Township, Berks, Pennsylvania, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Augustus Johnson in Pennsylvania, Death Certificates, 1906-1964",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9R3Q-C17",
        "citation": ""
      },
      {
        "title": "Johnson, Augustus b 1831 death certificate",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9X2X-Z4Z",
        "citation": "Accessed on Pennsylvania, Death Certificates 1906-1963 -- database on Ancestry.com"
      },
      {
        "title": "Burial information from Fairview Cemetery, Boyertown, Berks, Pennsylvania, United States",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9X2D-HL1",
        "citation": ""
      },
      {
        "title": "Augustus Johnson, \"United States, Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9R3Q-WRD",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MW6B-D3X : Wed Sep 09 02:31:07 UTC 2026), Entry for Augustus Johnson and Sarah Johnson, 1880."
      },
      {
        "title": "Augustus Johnson, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9R3Q-CQ3",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVL2-MTX6 : Fri Oct 02 07:10:44 UTC 2026), Entry for Augustus Johnson, 1909."
      },
      {
        "title": "Augustus Johnson, \"United States, Census, 1850\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9R3Q-HJW",
        "citation": "\"United States, Census, 1850\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M44L-1QK : Sat Oct 18 03:00:10 UTC 2025), Entry for George Johnson and Anna Johnson, 1850."
      },
      {
        "title": "Augustus Johnson, \"United States Census, 1900\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9VDZ-WWK",
        "citation": "\"United States, Census, 1900\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M3ML-KBZ : Tue Feb 04 20:04:37 UTC 2025), Entry for Augustus Johnson and Sarah Johnson, 1900."
      },
      {
        "title": "Augustus Johnson, \"Pennsylvania, County Marriages, 1775-1991\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S4V1-4X9",
        "citation": "\"Pennsylvania, County Marriages, 1775-1991\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VFM4-XWG : Thu May 07 23:02:47 UTC 2026), Entry for Warren M. Johnson and Clara F. Houck, 24 November 1904."
      },
      {
        "title": "Augustus, \"Pennsylvania, County Marriages, 1775-1991\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/78Y1-YCX",
        "citation": "\"Pennsylvania, County Marriages, 1775-1991\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VFMV-4RC : Fri May 08 00:22:49 UTC 2026), Entry for James B Nuss and Maggie M Johnson, 13 April 1895."
      },
      {
        "title": "Augustus Johnson, \"United States, Census, 1870\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9R3Q-4VS",
        "citation": "\"United States, Census, 1870\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MZLJ-NDR : Mon Jan 20 13:43:02 UTC 2025), Entry for Augustus Johnson and Sarah Johnson, 1870."
      },
      {
        "title": "Augustus Johnson, \"United States, Census, 1860\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9R3Q-4L5",
        "citation": "\"United States, Census, 1860\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MXPM-BY9 : Mon Jul 08 19:33:07 UTC 2024), Entry for George Johnson and Anna Johnson, 1860."
      }
    ],
    "portrait": "/ancestors/portraits/104_L25G-5RM.jpg"
  },
  {
    "id": "I138",
    "name": "Sarah Moser",
    "sex": "F",
    "gen": 6,
    "slot": 41,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I45",
    "birthYear": 1843,
    "deathYear": 1927,
    "birthDate": "28 Mar 1843",
    "deathDate": "24 Sep 1927",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Hill Church, Berks, Pennsylvania, United States",
    "deathPlace": "Boyertown, Berks, Pennsylvania, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "L25G-RQT",
    "photo": "/ancestors/bubbles/105_L25G-RQT.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [
      {
        "kind": "Residence",
        "date": "1850",
        "place": "Pike Township, Berks, Pennsylvania, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Sarah Johnson in Pennsylvania, Death Certificates, 1906-1964",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9R3Q-8KV",
        "citation": ""
      },
      {
        "title": "Johnson, Sarah Moser b 1843 death certificate",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9X2X-8XX",
        "citation": "from Pennsylvania, Death Certificates 1906-1963 accessed on Ancestry.,com"
      },
      {
        "title": "Burial record from Fairfiew Cemetery, Boyertown, Berks, PA",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9X2D-CN3",
        "citation": "Accessed on www.findagrave.com"
      },
      {
        "title": "Sarah Moser Johnson, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9R3Q-ZTZ",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVV1-5J4D : Fri Oct 02 13:58:53 UTC 2026), Entry for Sarah Moser Johnson, 1927."
      },
      {
        "title": "Sarah Johnson, \"United States, Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9R3Q-WTL",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MW6B-D3X : Wed Sep 09 02:31:07 UTC 2026), Entry for Augustus Johnson and Sarah Johnson, 1880."
      },
      {
        "title": "Sarah Johnson, \"United States, Census, 1860\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9R3Q-HQY",
        "citation": "\"United States, Census, 1860\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MXPM-BY9 : Mon Jul 08 19:33:07 UTC 2024), Entry for George Johnson and Anna Johnson, 1860."
      },
      {
        "title": "Sarah Moper, \"United States, Census, 1850\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QVC7-YDS",
        "citation": "\"United States, Census, 1850\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M442-P9K : Wed Oct 15 09:16:51 UTC 2025), Entry for Frederick Mosser and Christine Moper, 1850."
      },
      {
        "title": "Sarah, \"Pennsylvania, County Marriages, 1775-1991\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/78Y1-YK4",
        "citation": "\"Pennsylvania, County Marriages, 1775-1991\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VFMV-4RC : Fri May 08 00:22:49 UTC 2026), Entry for James B Nuss and Maggie M Johnson, 13 April 1895."
      },
      {
        "title": "Sarah Johnson, \"United States, Census, 1920\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9R3Q-SJQ",
        "citation": "\"United States, Census, 1920\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M6BP-BBV : Sun Sep 27 15:41:17 UTC 2026), Entry for Warren Johnson and Clara Johnson, 1920."
      },
      {
        "title": "Sarah Johnson, \"United States, Census, 1900\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9R3Q-79G",
        "citation": "\"United States, Census, 1900\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M3ML-KBZ : Tue Feb 04 20:04:37 UTC 2025), Entry for Augustus Johnson and Sarah Johnson, 1900."
      },
      {
        "title": "Sarah, \"Pennsylvania, County Marriages, 1775-1991\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S4V1-4FF",
        "citation": "\"Pennsylvania, County Marriages, 1775-1991\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VFM4-XWG : Thu May 07 23:02:47 UTC 2026), Entry for Warren M. Johnson and Clara F. Houck, 24 November 1904."
      },
      {
        "title": "Sarah W Johnson, \"United States, Census, 1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9R3Q-91G",
        "citation": "\"United States, Census, 1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MG33-CVW : Wed Aug 13 17:22:33 UTC 2025), Entry for Warren M Johnson and Clara F Johnson, 1910."
      },
      {
        "title": "Sarah Johnson, \"United States, Census, 1870\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9R3Q-4K4",
        "citation": "\"United States, Census, 1870\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MZLJ-NDR : Mon Jan 20 13:43:02 UTC 2025), Entry for Augustus Johnson and Sarah Johnson, 1870."
      }
    ],
    "portrait": "/ancestors/portraits/105_L25G-RQT.jpg"
  },
  {
    "id": "I43",
    "name": "Elmira L. Hatfield",
    "sex": "F",
    "gen": 5,
    "slot": 21,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I18",
    "birthYear": 1865,
    "deathYear": 1931,
    "birthDate": "9 Nov 1865",
    "deathDate": "22 Jul 1931",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Pennsylvania, United States",
    "deathPlace": "Pottstown, Montgomery, Pennsylvania, United States",
    "burialPlace": "Pottstown Cemetery, Pottstown, Montgomery, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LYYN-VZJ",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Elmira Levengood Hatfield"
    ],
    "facts": [
      {
        "kind": "census",
        "date": "22 July 1870",
        "place": "Earlville, Douglass Twp., Berks Co., Pennsylvania",
        "note": "1870 Fed census, Earlville, Douglass Twp., Berks Co., Pennsylvania. Page 6, Family No. 44."
      },
      {
        "kind": "census",
        "date": "11 June 1880",
        "place": "Earlville, Douglass Twp., Berks Co., Pennsylvania",
        "note": "1870 Fed census, Earlville, Douglass Twp., Berks Co., Pennsylvania. Page 6, Family No. 44."
      },
      {
        "kind": "census",
        "date": "8 June 1900",
        "place": "Upper Pottsgrove Twp., Montgomery Co., Pennsylvania",
        "note": "1900 Fed census, Upper Pottsgrove Twp., Montgomery Co., Pennsylvania. E.D. 221, Sheet 4-A, Family No. 79. Married 14 years. Mother of 6 children, 6 children living."
      },
      {
        "kind": "census",
        "date": "27 April 1910",
        "place": "Pottstown, Montgomery, Pennsylvania, United States",
        "note": "1910 Fed census, Pottstown, Montgomery Co., Pennsylvania. E.D. 140, Sheet 16-A, Family No. 317. Married 24 years. Mother of 10 children, 7 children living."
      },
      {
        "kind": "census",
        "date": "2 January 1920",
        "place": "Pottstown, Montgomery, Pennsylvania, United States",
        "note": "1920 Fed census, Pottstown, Montgomery Co., Pennsylvania. E.D. 165, Sheet 1-A, Family No. 1."
      },
      {
        "kind": "census",
        "date": "4 April 1930",
        "place": "Pottstown, Montgomery, Pennsylvania, United States",
        "note": "1930 Fed census, Pottstown, Montgomery Co., Pennsylvania. E.D. 125, Sheet 4-A, Family No. 95."
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Ella Johnson, \"Pennsylvania, Civil Marriages, 1677-1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QYGG-C2Q",
        "citation": "\"Pennsylvania, Civil Marriages, 1677-1950\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q29S-5NT4 : Sat Jan 11 10:04:29 UTC 2025), Entry for Walter H Johnson and George Johnson, 01 Jun 1905."
      },
      {
        "title": "Elmire Johnson in entry for Gedude Johnson, \"Pennsylvania, Births and Christenings, 1709-1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QYVP-DVW",
        "citation": "\"Pennsylvania, Births and Christenings, 1709-1950\", , FamilySearch (https://www.familysearch.org/ark:/61903/1:1:HFLS-QCMM : 16 December 2023), Elmire Johnson in entry for Gedude Johnson, 1899."
      },
      {
        "title": "Elmira Johnson in entry for Johnson, \"Pennsylvania, Births and Christenings, 1709-1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QYV2-429",
        "citation": "\"Pennsylvania, Births and Christenings, 1709-1950\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:HFG8-CW2M : 16 December 2023), Elmira Johnson in entry for Johnson, 1907."
      },
      {
        "title": "Elmira Johnson in entry for George Johnson, \"Pennsylvania, Births and Christenings, 1709-1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QYJD-MDQ",
        "citation": "\"Pennsylvania, Births and Christenings, 1709-1950\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:HFK7-V1MM : 16 December 2023), Elmira Johnson in entry for George Johnson, 1897."
      },
      {
        "title": "Ella Johnson in entry for Mabel Johnson, \"Pennsylvania, Births and Christenings, 1709-1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QYJ8-142",
        "citation": "\"Pennsylvania, Births and Christenings, 1709-1950\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:HFKJ-HV3Z : 16 December 2023), Ella Johnson in entry for Mabel Johnson, 1904."
      },
      {
        "title": "Elmira Hatfield, \"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QYJ8-2G7",
        "citation": "\"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6K9L-KF5G : Fri Jul 03 11:40:34 UTC 2026), Entry for Mabel H Johnson and George M Johnson."
      },
      {
        "title": "Elmira Johnson in entry for Edith Johnson, \"Pennsylvania, Births and Christenings, 1709-1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/35R3-2T6",
        "citation": "\"Pennsylvania, Births and Christenings, 1709-1950\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:HFJT-HB3Z : 16 December 2023), Elmira Johnson in entry for Edith Johnson, 1895."
      },
      {
        "title": "Elmira Johnson in entry for Edith Johnson, \"Pennsylvania, Births and Christenings, 1709-1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SW4R-1QP",
        "citation": "\"Pennsylvania, Births and Christenings, 1709-1950\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:V2N3-P8S : 16 December 2023), Elmira Johnson in entry for Edith Johnson, 1895."
      },
      {
        "title": "Elmira L. Johnson in Pennsylvania, Death Certificates, 1906-1964",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9R3C-ZY3",
        "citation": ""
      },
      {
        "title": "Elmira L. Hatfield Johnson, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9R3C-Z6P",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVGW-YBMT : Sat Oct 03 09:14:04 UTC 2026), Entry for Elmira L. Hatfield Johnson."
      },
      {
        "title": "Elmira Hatfield, \"United States, Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9R3C-CGL",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MW6B-NML : Wed Sep 09 02:28:50 UTC 2026), Entry for Samuel Hatfield and Christena Hatfield, 1880."
      },
      {
        "title": "Elmira Hutfield, \"United States, Census, 1870\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9R3C-CLZ",
        "citation": "\"United States, Census, 1870\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MZLJ-T8H : Mon Jan 20 17:05:54 UTC 2025), Entry for Samuel Hutfield and Teanna Hutfield, 1870."
      },
      {
        "title": "Elmira Johnson, \"United States, Census, 1930\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9R3C-4PP",
        "citation": "\"United States, Census, 1930\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XHZ4-3LY : Sat Mar 09 10:18:23 UTC 2024), Entry for George Johnson and Elmira Johnson, 1930."
      },
      {
        "title": "Elmira L Johnson, \"United States, Census, 1920\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9R3C-4L2",
        "citation": "\"United States, Census, 1920\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MF1S-74M : Sun Sep 27 21:51:50 UTC 2026), Entry for George M Johnson and Elmira L Johnson, 1920."
      },
      {
        "title": "Elmira Johnson, \"United States, Census, 1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9R3C-425",
        "citation": "\"United States, Census, 1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MG8G-4V6 : Wed Aug 13 17:05:54 UTC 2025), Entry for George Johnson and Elmira Johnson, 1910."
      },
      {
        "title": "Elmirah Johnson, \"United States, Census, 1900\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9R3C-4KT",
        "citation": "\"United States, Census, 1900\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M3Q2-JJM : Wed May 14 06:57:20 UTC 2025), Entry for George Johnson and Walter Johnson, 1900."
      }
    ]
  },
  {
    "id": "I126",
    "name": "Samuel G. Hatfield",
    "sex": "M",
    "gen": 6,
    "slot": 42,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I43",
    "birthYear": 1826,
    "deathYear": 1908,
    "birthDate": "3 Jan 1826",
    "deathDate": "24 Feb 1908",
    "burialDate": "Feb 1908",
    "christeningDate": "23 Apr 1826",
    "birthPlace": "Pottstown, Montgomery, Pennsylvania, United States",
    "deathPlace": "Douglass Township, Berks, Pennsylvania, United States",
    "burialPlace": "Pottstown, Montgomery Co., Pennsylvania",
    "christeningPlace": "Pottstown, Montgomery, Pennsylvania, United States",
    "fsId": "K89C-WP4",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Samuel Geiger Hatfield"
    ],
    "facts": [
      {
        "kind": "census",
        "date": "16 August 1850",
        "place": "Douglass Township, Berks, Pennsylvania, United States",
        "note": "1850 Fed census, Douglass Twp., Berks Co., Pennsylvania. Page 310, Family No. 97. Occupation: Farmer."
      },
      {
        "kind": "census",
        "date": "5 July 1860",
        "place": "Douglass Township, Berks, Pennsylvania, United States",
        "note": "1860 Fed census, Douglass Twp., Berks Co., Pennsylvania. Page 55, Family No. 418. Occupation: Inn Keeper."
      },
      {
        "kind": "census",
        "date": "22 July 1870",
        "place": "Earlville, Douglass Twp., Berks Co., Pennsylvania",
        "note": "1870 Fed census, Earlville, Douglass Twp., Berks Co., Pennsylvania. Page 6, Family No. 44. Occupation: Farmer."
      },
      {
        "kind": "census",
        "date": "11 June 1880",
        "place": "Douglass Township, Berks, Pennsylvania, United States",
        "note": "1880 Fed census, Douglass Twp., Berks Co., Pennsylvania. E.D. 13, Page 25, Family No. 183. Occupation: Farmer."
      },
      {
        "kind": "census",
        "date": "18 June 1900",
        "place": "Douglass Township, Berks, Pennsylvania, United States",
        "note": "1900 Fed census, Douglass Twp., Berks Co., Pennsylvania. E.D. 16, Sheet 10-A, Family No. 186. Occupation: Farmer."
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Samuel G. Hatfield in Pennsylvania, Death Certificates, 1906-1964",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9R3C-N2D",
        "citation": ""
      },
      {
        "title": "Samuel Hatfield, \"United States, Census, 1850\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9R3C-XYN",
        "citation": "\"United States, Census, 1850\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M442-4GF : Mon Oct 20 11:24:18 UTC 2025), Entry for Samuel Hatfield and Christena Hatfield, 1850."
      },
      {
        "title": "Samuel G. Hatfield, \"Pennsylvania, County Marriages, 1775-1991\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9TK4-GGZ",
        "citation": "\"Pennsylvania, County Marriages, 1775-1991\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VFM7-M7V : Thu May 07 23:02:25 UTC 2026), Entry for Samuel G. Hatfield and Ellen Smith, 27 May 1900."
      },
      {
        "title": "Samuel Hutfield, \"United States, Census, 1870\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9R3C-XZ4",
        "citation": "\"United States, Census, 1870\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MZLJ-T8H : Mon Jan 20 17:05:54 UTC 2025), Entry for Samuel Hutfield and Teanna Hutfield, 1870."
      },
      {
        "title": "Samuel G Hatfield, \"United States, Census, 1860\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9R3C-FMK",
        "citation": "\"United States, Census, 1860\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MXP9-425 : Mon Jul 08 19:32:43 UTC 2024), Entry for Samuel G Hatfield and Christina Hatfield, 1860."
      },
      {
        "title": "Samuel G. Hatfield, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9R3C-FBK",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q243-SVQ4 : Thu Oct 01 23:18:49 UTC 2026), Entry for Samuel G. Hatfield."
      },
      {
        "title": "Samuel G Hatfield, \"Pennsylvania, Philadelphia, Historical Society of Pennsylvania, Births and Baptisms, 1520-1999\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3VW1-N77",
        "citation": "\"Pennsylvania, Philadelphia, Historical Society of Pennsylvania, Births and Baptisms, 1520-1999\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CTR-VK6R : Sun Jan 19 11:53:30 UTC 2025), Entry for Ida Priscilla Hatfield and Samuel G Hatfield, 25 Apr 1869."
      },
      {
        "title": "Samuel Hatfield, \"Pennsylvania, Philadelphia, Historical Society of Pennsylvania, Marriage Records, 1512-1989\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3VW1-JZ8",
        "citation": "\"Pennsylvania, Philadelphia, Historical Society of Pennsylvania, Marriage Records, 1512-1989\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CYX-YF8S : Sun Mar 10 07:36:26 UTC 2024), Entry for Samuel Hatfield and Christina Liebenguth, 23 October 1849."
      },
      {
        "title": "Samuel Hatfield, \"United States, Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9R3C-X61",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MW6B-NML : Wed Sep 09 02:28:50 UTC 2026), Entry for Samuel Hatfield and Christena Hatfield, 1880."
      },
      {
        "title": "Samuel G. Hatfield, \"Pennsylvania, Marriages, 1709-1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9TK4-GYR",
        "citation": "\"Pennsylvania, Marriages, 1709-1940\", , FamilySearch (https://www.familysearch.org/ark:/61903/1:1:V2XQ-QWF : 7 May 2023), Samuel G. Hatfield, 1900."
      },
      {
        "title": "Samuel Hatfield, \"Pennsylvania, Philadelphia, Historical Society of Pennsylvania, Marriage Records, 1512-1989\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3VW1-NN1",
        "citation": "\"Pennsylvania, Philadelphia, Historical Society of Pennsylvania, Marriage Records, 1512-1989\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CYX-YFD8 : Sun Mar 10 07:36:22 UTC 2024), Entry for Christina Liebenguth and Samuel Hatfield, 23 October 1849."
      },
      {
        "title": "Samuel Hatfield, \"Pennsylvania, Philadelphia, Historical Society of Pennsylvania, Births and Baptisms, 1520-1999\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3VW1-F53",
        "citation": "\"Pennsylvania, Philadelphia, Historical Society of Pennsylvania, Births and Baptisms, 1520-1999\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CTR-YJ5C : Sun Jan 19 22:53:09 UTC 2025), Entry for Amelia Hatfield and Samuel Hatfield, 22 Jul 1860."
      },
      {
        "title": "Samuel G Hatfield, \"United States, Census, 1900\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9R3C-FT5",
        "citation": "\"United States, Census, 1900\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M3ML-J4S : Tue Feb 04 20:04:39 UTC 2025), Entry for Samuel G Hatfield and Ellen Hatfield, 1900."
      },
      {
        "title": "Samuel Hatfield in entry for Grace E. Hatfield, \"Pennsylvania, Births and Christenings, 1709-1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SB13-G3Z",
        "citation": "\"Pennsylvania, Births and Christenings, 1709-1950\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:HH28-3KMM : 15 February 2020), Samuel Hatfield in entry for Grace E. Hatfield, 1897."
      },
      {
        "title": "Samuel, \"Pennsylvania, County Marriages, 1775-1991\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SB1Q-DV9",
        "citation": "\"Pennsylvania, County Marriages, 1775-1991\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q285-CDJ2 : Fri May 08 00:09:58 UTC 2026), Entry for Joseph W Echelmeier and Grace E Hatfield, 20 July 1921."
      }
    ]
  },
  {
    "id": "I124",
    "name": "Christiana Levengood",
    "sex": "F",
    "gen": 6,
    "slot": 43,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I43",
    "birthYear": 1832,
    "deathYear": 1890,
    "birthDate": "30 May 1832",
    "deathDate": "30 Aug 1890",
    "burialDate": "Sep 1890",
    "christeningDate": null,
    "birthPlace": "Pottstown, Montgomery Co., Pennsylvania",
    "deathPlace": "Berks, Pennsylvania",
    "burialPlace": "Pottstown, Montgomery Co., Pennsylvania",
    "christeningPlace": null,
    "fsId": "KHSB-61V",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Christina Liebenguth"
    ],
    "facts": [
      {
        "kind": "Baptism",
        "date": "25 August 1832",
        "place": "Pottsgrove Township, Montgomery, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "census",
        "date": "16 August 1850",
        "place": "Douglass Township, Berks, Pennsylvania, United States",
        "note": "1850 Fed census, Douglass Twp., Berks Co., Pennsylvania. Page 310, Family No. 97."
      },
      {
        "kind": "census",
        "date": "5 July 1860",
        "place": "Douglass Township, Berks, Pennsylvania, United States",
        "note": "1860 Fed census, Douglass Twp., Berks Co., Pennsylvania. Page 55, Family No. 418."
      },
      {
        "kind": "census",
        "date": "22 July 1870",
        "place": "Earlville, Douglass Twp., Berks Co., Pennsylvania",
        "note": "1870 Fed census, Earlville, Douglass Twp., Berks Co., Pennsylvania. Page 6, Family No. 44."
      },
      {
        "kind": "census",
        "date": "11 June 1880",
        "place": "Douglass Township, Berks, Pennsylvania, United States",
        "note": "1880 Fed census, Douglass Twp., Berks Co., Pennsylvania. E.D. 13, Page 25, Family No. 183."
      },
      {
        "kind": "Residence",
        "date": "1880",
        "place": "Douglass Township, Berks, Pennsylvania, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Christena Hatfield, \"United States, Census, 1850\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9R3C-X1Q",
        "citation": "\"United States, Census, 1850\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M442-4GF : Mon Oct 20 11:24:18 UTC 2025), Entry for Samuel Hatfield and Christena Hatfield, 1850."
      },
      {
        "title": "Christina Hatfield, \"Pennsylvania, Philadelphia, Historical Society of Pennsylvania, Births and Baptisms, 1520-1999\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3VW1-D5K",
        "citation": "\"Pennsylvania, Philadelphia, Historical Society of Pennsylvania, Births and Baptisms, 1520-1999\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CTR-YJ5C : Sun Jan 19 22:53:09 UTC 2025), Entry for Amelia Hatfield and Samuel Hatfield, 22 Jul 1860."
      },
      {
        "title": "Christina Levengood, \"Pennsylvania, Philadelphia, Historical Society of Pennsylvania, Births and Baptisms, 1520-1999\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3VW1-DCM",
        "citation": "\"Pennsylvania, Philadelphia, Historical Society of Pennsylvania, Births and Baptisms, 1520-1999\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CTT-8ZHG : Tue Jan 21 16:33:54 UTC 2025), Entry for Christina Levengood and Jacob Levengood, 25 Aug 1832."
      },
      {
        "title": "Christina Hatfield, \"Pennsylvania, Philadelphia, Historical Society of Pennsylvania, Births and Baptisms, 1520-1999\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3VW1-6JF",
        "citation": "\"Pennsylvania, Philadelphia, Historical Society of Pennsylvania, Births and Baptisms, 1520-1999\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CTR-VK6R : Sun Jan 19 11:53:30 UTC 2025), Entry for Ida Priscilla Hatfield and Samuel G Hatfield, 25 Apr 1869."
      },
      {
        "title": "Teanna Hutfield, \"United States, Census, 1870\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9R3C-XD7",
        "citation": "\"United States, Census, 1870\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MZLJ-T8H : Mon Jan 20 17:05:54 UTC 2025), Entry for Samuel Hutfield and Teanna Hutfield, 1870."
      },
      {
        "title": "Christena Hatfield, \"United States, Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9R3C-X6W",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MW6B-NML : Wed Sep 09 02:28:50 UTC 2026), Entry for Samuel Hatfield and Christena Hatfield, 1880."
      },
      {
        "title": "Christiana Levengood Hatfield, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9R3C-JVK",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q243-SV3J : Sun Oct 04 00:14:30 UTC 2026), Entry for Christiana Levengood Hatfield."
      },
      {
        "title": "Christina Liebenguth, \"Pennsylvania, Philadelphia, Historical Society of Pennsylvania, Marriage Records, 1512-1989\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3VW1-ZLD",
        "citation": "\"Pennsylvania, Philadelphia, Historical Society of Pennsylvania, Marriage Records, 1512-1989\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CYX-YFD8 : Sun Mar 10 07:36:22 UTC 2024), Entry for Christina Liebenguth and Samuel Hatfield, 23 October 1849."
      },
      {
        "title": "Christina Hatfield, \"United States, Census, 1860\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9R3C-FSG",
        "citation": "\"United States, Census, 1860\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MXP9-425 : Mon Jul 08 19:32:43 UTC 2024), Entry for Samuel G Hatfield and Christina Hatfield, 1860."
      },
      {
        "title": "Christina Liebenguth, \"Pennsylvania, Philadelphia, Historical Society of Pennsylvania, Marriage Records, 1512-1989\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3VW1-8SS",
        "citation": "\"Pennsylvania, Philadelphia, Historical Society of Pennsylvania, Marriage Records, 1512-1989\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CYX-YF8S : Sun Mar 10 07:36:26 UTC 2024), Entry for Samuel Hatfield and Christina Liebenguth, 23 October 1849."
      },
      {
        "title": "Christina, \"Pennsylvania, County Marriages, 1775-1991\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3VW1-X42",
        "citation": "\"Pennsylvania, County Marriages, 1775-1991\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VFMJ-XBL : Fri May 08 00:22:31 UTC 2026), Entry for William D. Geissinger and Ida Priscilla L. Hatfield, 16 March 1889."
      }
    ]
  },
  {
    "id": "I17",
    "name": "Maggie Ethbert H Saltzer",
    "sex": "F",
    "gen": 4,
    "slot": 11,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I12",
    "birthYear": 1889,
    "deathYear": 1914,
    "birthDate": "5 Feb 1889",
    "deathDate": "6 Dec 1914",
    "burialDate": "Dec 1914",
    "christeningDate": null,
    "birthPlace": "Hubley, Schuylkill, Pennsylvania, United States",
    "deathPlace": "Pottstown, Montgomery, Pennsylvania, United States",
    "burialPlace": "Pottstown, Montgomery, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "KF2W-RXY",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [
      {
        "kind": "Residence",
        "date": "1870",
        "place": "Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1870",
        "place": "Hubley Township, Schuylkill, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1920",
        "place": "Montgomery, Pennsylvania, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Maggie Johnson in entry for Arthur Le-Roy Johnson, \"Pennsylvania, Births and Christenings, 1709-1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QYGG-Z36",
        "citation": "\"Pennsylvania, Births and Christenings, 1709-1950\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:HFKM-TCZM : 16 December 2023), Maggie Johnson in entry for Arthur Le-Roy Johnson, 1905."
      },
      {
        "title": "Maggie Elbertha H Saltzer, \"Pennsylvania, Civil Marriages, 1677-1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QYGG-WFC",
        "citation": "\"Pennsylvania, Civil Marriages, 1677-1950\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q29S-5NT4 : Sat Jan 11 10:04:29 UTC 2025), Entry for Walter H Johnson and George Johnson, 01 Jun 1905."
      },
      {
        "title": "Hellen A Johnson, \"United States, Census, 1920\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QYGN-H1T",
        "citation": "\"United States, Census, 1920\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MF19-2XV : Sun Sep 27 21:51:06 UTC 2026), Entry for Walter H Johnson and Hellen A Johnson, 1920."
      },
      {
        "title": "Maggie E. Saltzer Johnson, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QGRZ-XBV",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QGTT-K1D1 : Sun Oct 04 09:20:58 UTC 2026), Entry for Maggie E. Saltzer Johnson."
      },
      {
        "title": "Maggie E Saltzer, \"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QN6Z-JZ3",
        "citation": "\"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6K9T-3FM9 : Sun Jul 05 14:23:04 UTC 2026), Entry for Alberta Johnson Heck and Walter H Johnson."
      },
      {
        "title": "Maggie Johnson in entry for Laura Violette Johnson, \"Pennsylvania, Births and Christenings, 1709-1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QN6Z-NYF",
        "citation": "\"Pennsylvania, Births and Christenings, 1709-1950\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:HFKL-8QW2 : 16 December 2023), Maggie Johnson in entry for Laura Violette Johnson, 1907."
      },
      {
        "title": "Maggie Johnson, \"United States, Census, 1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S143-43C",
        "citation": "\"United States, Census, 1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MG4B-L2S : Wed Aug 13 19:17:21 UTC 2025), Entry for Walter Johnson and Maggie Johnson, 1910."
      },
      {
        "title": "Maggie H Solhare, \"United States, Census, 1900\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S143-WL9",
        "citation": "\"United States, Census, 1900\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M3Q2-547 : Wed May 14 04:59:25 UTC 2025), Entry for John H Solhare and Harry H Solhare, 1900."
      },
      {
        "title": "Maggie Saltzer Johnson, \"Pennsylvania, Obituaries, 1977-2010\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QG9D-VM6",
        "citation": "\"Pennsylvania, Obituaries, 1977-2010\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVF1-T42Q : Fri May 02 20:24:26 UTC 2025), Entry for Evelyn M Hohl and George I Hohl, 2000."
      },
      {
        "title": "Maggie Saltzer, \"United States, Census, 1870\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SG9Y-6LZ",
        "citation": "\"United States, Census, 1870\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MZT7-LRH : Thu Oct 09 14:20:35 UTC 2025), Entry for Josiah Saltzer and Viah Saltzer, 1870."
      }
    ]
  },
  {
    "id": "I37",
    "name": "John H Saltzer",
    "sex": "M",
    "gen": 5,
    "slot": 22,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I17",
    "birthYear": 1867,
    "deathYear": 1908,
    "birthDate": "16 May 1867",
    "deathDate": "16 Jan 1908",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Dauphin, Pennsylvania, United States",
    "deathPlace": "Pennsylvania, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LHKM-SSZ",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [
      {
        "kind": "Residence",
        "date": "1870",
        "place": "Pennsylvania, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Elmira F Hartranft, \"Pennsylvania, Philadelphia, Marriage Indexes, 1885-1951\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S9BD-91F",
        "citation": "\"Pennsylvania, Philadelphia, Marriage Indexes, 1885-1951\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:ZWVP-VFW2 : Sat Feb 24 05:24:49 UTC 2024), Entry for Elmira F Hartranft and Saltzer, 1886."
      },
      {
        "title": "John H Solhare, \"United States, Census, 1900\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S143-WVD",
        "citation": "\"United States, Census, 1900\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M3Q2-547 : Wed May 14 04:59:25 UTC 2025), Entry for John H Solhare and Harry H Solhare, 1900."
      },
      {
        "title": "John Saltzer, \"United States, Census, 1870\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S9B8-19F",
        "citation": "\"United States, Census, 1870\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MZ5H-TY2 : Sat Oct 18 16:31:00 UTC 2025), Entry for Jonas Saltzer and Matilda Saltzer, 1870."
      },
      {
        "title": "John H Saltzer, \"Pennsylvania, Philadelphia, Marriage Indexes, 1885-1951\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QMFK-BTP",
        "citation": "\"Pennsylvania, Philadelphia, Marriage Indexes, 1885-1951\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:ZWQ4-VRW2 : Sat Feb 24 05:13:01 UTC 2024), Entry for John H Saltzer and Hartranft, 1886."
      },
      {
        "title": "Saltzer, \"Pennsylvania, Philadelphia, Marriage Indexes, 1885-1951\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QMFK-YM1",
        "citation": "\"Pennsylvania, Philadelphia, Marriage Indexes, 1885-1951\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:ZWVP-VFW2 : Sat Feb 24 05:24:49 UTC 2024), Entry for Elmira F Hartranft and Saltzer, 1886."
      },
      {
        "title": "John Saltzer, \"Pennsylvania, Civil Marriages, 1677-1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QYGG-HZ5",
        "citation": "\"Pennsylvania, Civil Marriages, 1677-1950\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q29S-5NT4 : Sat Jan 11 10:04:29 UTC 2025), Entry for Walter H Johnson and George Johnson, 01 Jun 1905."
      }
    ]
  },
  {
    "id": "I107",
    "name": "Jonas D Saltzer",
    "sex": "M",
    "gen": 6,
    "slot": 44,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "I37",
    "birthYear": 1829,
    "deathYear": 1908,
    "birthDate": "8 Aug 1829",
    "deathDate": "6 Mar 1908",
    "burialDate": "1908",
    "christeningDate": "16 Aug 1829",
    "birthPlace": "Germany",
    "deathPlace": "Pottstown, Montgomery, Pennsylvania, United States",
    "burialPlace": "Fairview Cemetery, Boyertown, Berks, Pennsylvania, United States",
    "christeningPlace": "Neckarweihingen, Ludwigsburg, Württemberg, Germany",
    "fsId": "KHJZ-QPH",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [
      {
        "kind": "Residence",
        "date": "1860",
        "place": "Earl Township, Berks, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1870",
        "place": "Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1900",
        "place": "West Pottsgrove Township, Montgomery, Pennsylvania, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Jonas Salzer, “Deutschland, ausgewählte evangelische Kirchenbücher 1500-1971”",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7TG4-FZL",
        "citation": "\"Deutschland, ausgewählte evangelische Kirchenbücher 1500-1971\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QP57-XMHK : Sat Jul 26 19:15:48 UTC 2025), Entry for Jonas Salzer and Johannes Salzer, 16. August 1829."
      },
      {
        "title": "Jonas, \"Pennsylvania, County Marriages, 1775-1991\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QG9X-H2X",
        "citation": "\"Pennsylvania, County Marriages, 1775-1991\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VFMJ-NLF : Thu May 07 23:03:05 UTC 2026), Entry for Monroe G. Kepner and Kate H. Saltzer, 20 November 1893."
      },
      {
        "title": "Jonas Saltzer, \"Pennsylvania, Philadelphia, Historical Society of Pennsylvania, Births and Baptisms, 1520-1999\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q2S3-QDL",
        "citation": "\"Pennsylvania, Philadelphia, Historical Society of Pennsylvania, Births and Baptisms, 1520-1999\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CTT-8JD7 : Sat Mar 09 22:22:32 UTC 2024), Entry for Rosa Emma Saltzer and Jonas Saltzer, 26 December 1877."
      },
      {
        "title": "Jonas Saltzer, \"United States, Census, 1870\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S9B8-VNT",
        "citation": "\"United States, Census, 1870\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MZ5H-TY2 : Sat Oct 18 16:31:00 UTC 2025), Entry for Jonas Saltzer and Matilda Saltzer, 1870."
      },
      {
        "title": "Jonas Saltzer, \"United States, Census, 1900\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S9B8-NNN",
        "citation": "\"United States, Census, 1900\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M3Q2-KR3 : Wed May 14 06:29:18 UTC 2025), Entry for Jonas Saltzer and Katie Houek, 1900."
      },
      {
        "title": "Jonas D. Saltzer, \"BillionGraves Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S9B8-FQ5",
        "citation": "\"BillionGraves Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2M1-7H3K : Thu Sep 24 17:51:28 UTC 2026), Entry for Jonas D. Saltzer."
      },
      {
        "title": "Jonas D Saltzer, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S9B8-XWV",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QGVB-XY4L : Fri Oct 02 02:59:06 UTC 2026), Entry for Jonas D Saltzer."
      },
      {
        "title": "Jonas Saltzer in entry for John W. Fox, \"Pennsylvania, Marriages, 1709-1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S9B8-37J",
        "citation": "\"Pennsylvania, Marriages, 1709-1940\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:V2X6-H1D : 7 May 2023), Jonas Saltzer in entry for John W. Fox, 1888."
      },
      {
        "title": "Jonas Saltzer, \"United States, Census, 1860\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S9B8-MT9",
        "citation": "\"United States, Census, 1860\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MXPZ-YNR : Mon Jul 08 19:31:20 UTC 2024), Entry for Jonas Saltzer and Malinda Saltzer, 1860."
      },
      {
        "title": "Jonas Saltzer, \"Pennsylvania, County Marriages, 1775-1991\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9XDJ-FK9",
        "citation": "\"Pennsylvania, County Marriages, 1775-1991\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VFMF-GCS : Thu May 07 23:03:26 UTC 2026), Entry for John W. Fox and Ida H. Saltzer, 15 September 1888."
      }
    ]
  },
  {
    "id": "I106",
    "name": "Malinda Hallman",
    "sex": "F",
    "gen": 6,
    "slot": 45,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I37",
    "birthYear": 1839,
    "deathYear": 1921,
    "birthDate": "14 Aug 1839",
    "deathDate": "19 Apr 1921",
    "burialDate": "1921",
    "christeningDate": null,
    "birthPlace": "Pennsylvania, United States",
    "deathPlace": "Pottstown, Montgomery, Pennsylvania, United States",
    "burialPlace": "Fairview Cemetery, Boyertown, Berks, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "M5W5-SWC",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [
      {
        "kind": "Residence",
        "date": "1850",
        "place": "Earl Township, Berks, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1860",
        "place": "Earl Township, Berks, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1870",
        "place": "Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1900",
        "place": "West Pottsgrove Township, Montgomery, Pennsylvania, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Malinda, \"Pennsylvania, County Marriages, 1775-1991\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QG9X-C9T",
        "citation": "\"Pennsylvania, County Marriages, 1775-1991\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VFMJ-NLF : Thu May 07 23:03:05 UTC 2026), Entry for Monroe G. Kepner and Kate H. Saltzer, 20 November 1893."
      },
      {
        "title": "Malinda F. Saltzer, \"BillionGraves Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q21K-N2N",
        "citation": "\"BillionGraves Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2M1-7L8R : Fri Sep 25 00:32:39 UTC 2026), Entry for Malinda F. Saltzer."
      },
      {
        "title": "Malinda Saltzer, \"Pennsylvania, Philadelphia, Historical Society of Pennsylvania, Births and Baptisms, 1520-1999\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q2S3-Q6R",
        "citation": "\"Pennsylvania, Philadelphia, Historical Society of Pennsylvania, Births and Baptisms, 1520-1999\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CTT-8JD7 : Sat Mar 09 22:22:32 UTC 2024), Entry for Rosa Emma Saltzer and Jonas Saltzer, 26 December 1877."
      },
      {
        "title": "Copy of Descendants of Antonius Heilmann by Catherine Reuther",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QHYM-MN8",
        "citation": ""
      },
      {
        "title": "Malinda Saltzer, \"United States, Census, 1870\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S9B8-G66",
        "citation": "\"United States, Census, 1870\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MZ5H-TY2 : Sat Oct 18 16:31:00 UTC 2025), Entry for Jonas Saltzer and Matilda Saltzer, 1870."
      },
      {
        "title": "Malinda Saltzer, \"United States, Census, 1900\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S9B8-NVM",
        "citation": "\"United States, Census, 1900\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M3Q2-KR3 : Wed May 14 06:29:18 UTC 2025), Entry for Jonas Saltzer and Katie Houek, 1900."
      },
      {
        "title": "Malinda Hallman, \"United States, Census, 1850\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S9B8-69C",
        "citation": "\"United States, Census, 1850\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M442-8L4 : Sun Jan 12 22:43:40 UTC 2025), Entry for Frederick Hallman and Catharine Hallman, 1850."
      },
      {
        "title": "Malinda in entry for John W. Fox, \"Pennsylvania, Marriages, 1709-1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S9B8-33Y",
        "citation": "\"Pennsylvania, Marriages, 1709-1940\", , FamilySearch (https://www.familysearch.org/ark:/61903/1:1:V2X6-H16 : 7 May 2023), Malinda in entry for John W. Fox, 1888."
      },
      {
        "title": "Malinda F Hallman Saltzer, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S9B8-S6Y",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QGVY-8JGK : Fri Oct 02 17:35:36 UTC 2026), Entry for Malinda F Hallman Saltzer."
      },
      {
        "title": "Malinda Saltzer, \"United States, Census, 1860\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S9B8-9MK",
        "citation": "\"United States, Census, 1860\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MXPZ-YNR : Mon Jul 08 19:31:20 UTC 2024), Entry for Jonas Saltzer and Malinda Saltzer, 1860."
      },
      {
        "title": "Malinda, \"Pennsylvania, County Marriages, 1775-1991\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9XDJ-FKL",
        "citation": "\"Pennsylvania, County Marriages, 1775-1991\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VFMF-GCS : Thu May 07 23:03:26 UTC 2026), Entry for John W. Fox and Ida H. Saltzer, 15 September 1888."
      }
    ]
  },
  {
    "id": "I39",
    "name": "Elmira F Hartranft",
    "sex": "F",
    "gen": 5,
    "slot": 23,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I17",
    "birthYear": 1865,
    "deathYear": 1900,
    "birthDate": "8 Aug 1865",
    "deathDate": "15 Sep 1900",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Pennsylvania, United States",
    "deathPlace": "Pennsylvania, United States",
    "burialPlace": "Pottstown, Montgomery, Pennsylvania, United States of America",
    "christeningPlace": null,
    "fsId": "KF1V-2NM",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [
      {
        "kind": "Residence",
        "date": "1880",
        "place": "Pottstown, Montgomery, Pennsylvania, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Catherine Hartranft, \"United States, Census, 1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S143-4C5",
        "citation": "\"United States, Census, 1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MG4B-L2S : Wed Aug 13 19:17:21 UTC 2025), Entry for Walter Johnson and Maggie Johnson, 1910."
      },
      {
        "title": "Elmira F. Hartranft Saltzer, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QMFK-R1F",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:4KFV-32W2 : Sat Oct 03 06:16:44 UTC 2026), Entry for Elmira F. Hartranft Saltzer."
      },
      {
        "title": "Elmira F Hartranft, \"Pennsylvania, Philadelphia, Marriage Indexes, 1885-1951\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QMFK-TYC",
        "citation": "\"Pennsylvania, Philadelphia, Marriage Indexes, 1885-1951\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:ZWVP-VFW2 : Sat Feb 24 05:24:49 UTC 2024), Entry for Elmira F Hartranft and Saltzer, 1886."
      },
      {
        "title": "Saltzer, \"Pennsylvania, Philadelphia, Marriage Indexes, 1885-1951\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S9BD-SSZ",
        "citation": "\"Pennsylvania, Philadelphia, Marriage Indexes, 1885-1951\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:ZWVP-VFW2 : Sat Feb 24 05:24:49 UTC 2024), Entry for Elmira F Hartranft and Saltzer, 1886."
      },
      {
        "title": "Elvira Saltzer, \"Pennsylvania, Civil Marriages, 1677-1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QP94-RF9",
        "citation": "\"Pennsylvania, Civil Marriages, 1677-1950\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q29S-5NT4 : Sat Jan 11 10:04:29 UTC 2025), Entry for Walter H Johnson and George Johnson, 01 Jun 1905."
      },
      {
        "title": "Elmira F Solhare, \"United States, Census, 1900\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S143-WNF",
        "citation": "\"United States, Census, 1900\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M3Q2-547 : Wed May 14 04:59:25 UTC 2025), Entry for John H Solhare and Harry H Solhare, 1900."
      },
      {
        "title": "Elmira Hartranft, \"United States, Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QMFK-B86",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MWNL-48P : Wed Sep 09 05:34:09 UTC 2026), Entry for John Geiger and Edmund Geiger, 1880."
      },
      {
        "title": "Hartranft, \"Pennsylvania, Philadelphia, Marriage Indexes, 1885-1951\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QMFK-B5V",
        "citation": "\"Pennsylvania, Philadelphia, Marriage Indexes, 1885-1951\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:ZWQ4-VRW2 : Sat Feb 24 05:13:01 UTC 2024), Entry for John H Saltzer and Hartranft, 1886."
      }
    ]
  },
  {
    "id": "I104",
    "name": "Aaron D. Hartranft",
    "sex": "M",
    "gen": 6,
    "slot": 46,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I39",
    "birthYear": 1841,
    "deathYear": 1907,
    "birthDate": "11 Feb 1841",
    "deathDate": "22 Aug 1907",
    "burialDate": "25 Aug 1907",
    "christeningDate": null,
    "birthPlace": "Montgomery, Lycoming, Pennsylvania, United States",
    "deathPlace": "Pottstown, Montgomery, Pennsylvania, United States",
    "burialPlace": "Pottstown Cemetery, Montgomery, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "MR1R-R1M",
    "photo": "/ancestors/bubbles/110_MR1R-R1M.jpg",
    "living": false,
    "alternateNames": [
      "Aaron Hartranft"
    ],
    "facts": [
      {
        "kind": "Residence",
        "date": "1850",
        "place": "Pottsgrove, Lower Pottsgrove Township, Montgomery, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1860",
        "place": "Pottsgrove Township, Montgomery, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1870",
        "place": "Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1880",
        "place": "Pottstown, Montgomery, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1900",
        "place": "West Pottsgrove Township, Montgomery, Pennsylvania, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Aaron Hartrauft in entry for Elsworth Hartrauft, \"Pennsylvania Births and Christenings, 1709-1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9GNW-NTS",
        "citation": "\"Pennsylvania, Births and Christenings, 1709-1950\", , FamilySearch (https://www.familysearch.org/ark:/61903/1:1:V2N5-9H7 : 15 December 2023), Aaron Hartrauft in entry for Elsworth Hartrauft, 1861."
      },
      {
        "title": "Aaron Hartranft, \"United States, Census, 1850\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SQZZ-XMB",
        "citation": "\"United States, Census, 1850\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M4C7-3LM : Wed Oct 15 23:19:23 UTC 2025), Entry for Samuel Hartranft and Elizabeth Hartranft, 1850."
      },
      {
        "title": "Aaron Hartrauft, \"United States Census, 1870\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9GNW-FS2",
        "citation": "\"United States, Census, 1870\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MZP4-M9G : Wed Jan 08 15:06:48 UTC 2025), Entry for Aaron Hartrauft and Catherine Hartrauft, 1870."
      },
      {
        "title": "Aaron Hartranft, \"United States, Census, 1860\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QMFK-X62",
        "citation": "\"United States, Census, 1860\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MX5G-5LC : Mon Jul 08 21:07:39 UTC 2024), Entry for Michael Engel and Esther Engel, 1860."
      },
      {
        "title": "Aaron Hartrauft, \"Pennsylvania, Philadelphia, City Births, 1860-1915\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QQ6B-3QM",
        "citation": "\"Pennsylvania, Philadelphia, City Births, 1860-1915\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VBTW-G35 : Fri May 17 17:05:39 UTC 2024), Entry for Elsworth Hartrauft and Aaron Hartrauft, 13 May 1861."
      },
      {
        "title": "Aaron Hartranft, \"United States Census, 1900\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9KQR-1M7",
        "citation": "\"United States, Census, 1900\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M3Q2-6HV : Wed May 14 04:58:23 UTC 2025), Entry for Aaron Hartranft and Catherin Hartranft, 1900."
      },
      {
        "title": "Aaron Hartrauft in entry for Elsworth Hartrauft, \"Pennsylvania, Births and Christenings, 1709-1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3SH6-MW2",
        "citation": "\"Pennsylvania, Births and Christenings, 1709-1950\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:HWK2-KD6Z : 15 December 2023), Aaron Hartrauft in entry for Elsworth Hartrauft, ."
      },
      {
        "title": "Aaron Hartranft, \"United States, Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QMFK-J5Q",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MWNL-48P : Wed Sep 09 05:34:09 UTC 2026), Entry for John Geiger and Edmund Geiger, 1880."
      },
      {
        "title": "Aaron Hartranft, \"Find A Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9GNW-XZK",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVGP-WT62 : Fri Oct 02 18:18:08 UTC 2026), Entry for Aaron Hartranft."
      }
    ],
    "portrait": "/ancestors/portraits/110_MR1R-R1M.jpg"
  },
  {
    "id": "I110",
    "name": "Catharine B. Fryer",
    "sex": "F",
    "gen": 6,
    "slot": 47,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I39",
    "birthYear": 1838,
    "deathYear": 1923,
    "birthDate": "4 Dec 1838",
    "deathDate": "4 Mar 1923",
    "burialDate": "7 Mar 1923",
    "christeningDate": null,
    "birthPlace": "Montgomery, Lycoming, Pennsylvania, United States",
    "deathPlace": "Pottstown, Montgomery, Pennsylvania, United States",
    "burialPlace": "Pottstown Cemetery, Montgomery, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "MR1R-R1Z",
    "photo": "/ancestors/bubbles/111_MR1R-R1Z.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [
      {
        "kind": "Residence",
        "date": "1850",
        "place": "Douglass Township, Montgomery, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1860",
        "place": "New Hanover Township, Montgomery, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1870",
        "place": "Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1880",
        "place": "Pottstown, Montgomery, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1900",
        "place": "West Pottsgrove Township, Montgomery, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1935",
        "place": "Same Place, ,",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1940",
        "place": "Philadelphia, Philadelphia, Pennsylvania, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Kate in entry for Elsworth Hartrauft, \"Pennsylvania, Births and Christenings, 1709-1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3SHD-1BM",
        "citation": "\"Pennsylvania, Births and Christenings, 1709-1950\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:HWK2-KDN2 : 15 December 2023), Kate in entry for Elsworth Hartrauft, ."
      },
      {
        "title": "Catharine Fryer in household of Louis Fryer, \"United States Census, 1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/92L3-RFZ",
        "citation": "\"United States, Census, 1940\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KQXC-LF3 : Wed Jul 10 13:04:56 UTC 2024), Entry for Louis Fryer and Catharine Fryer, 1940."
      },
      {
        "title": "Kate in entry for Elsworth Hartrauft, \"Pennsylvania Births and Christenings, 1709-1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9GNW-NBK",
        "citation": "\"Pennsylvania, Births and Christenings, 1709-1950\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:V2N5-9HW : 15 December 2023), Kate in entry for Elsworth Hartrauft, 1861."
      },
      {
        "title": "Cathren Fryer in household of Jacob Fryer, \"United States Census, 1860\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9KQT-9X1",
        "citation": "\"United States, Census, 1860\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MX5D-6QP : Mon Jul 08 21:43:56 UTC 2024), Entry for Jacob Fryer and Cathren Fryer, 1860."
      },
      {
        "title": "Catharine Hartranft, \"United States, Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QMFK-J1H",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MWNL-48P : Wed Sep 09 05:34:09 UTC 2026), Entry for John Geiger and Edmund Geiger, 1880."
      },
      {
        "title": "Catharine Fryer in household of Jacob Fryer, \"United States Census, 1850\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9KQT-MC6",
        "citation": "\"United States, Census, 1850\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M4C7-97D : Thu Jan 16 14:19:09 UTC 2025), Entry for Jacob Fryer and Catharine Fryer, 1850."
      },
      {
        "title": "Catherin Hartranft in household of Aaron Hartranft, \"United States Census, 1900\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9KQR-B5Z",
        "citation": ""
      },
      {
        "title": "Kate in entry for Elsworth Hartrauft, \"Pennsylvania, Philadelphia City Births, 1860-1906\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9GNW-FBF",
        "citation": "\"Pennsylvania, Philadelphia, City Births, 1860-1915\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VBTW-G35 : Fri May 17 17:05:39 UTC 2024), Entry for Elsworth Hartrauft and Aaron Hartrauft, 13 May 1861."
      },
      {
        "title": "Catherin Hartranft, \"United States, Census, 1900\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QMFK-KDV",
        "citation": "\"United States, Census, 1900\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M3Q2-6HV : Wed May 14 04:58:23 UTC 2025), Entry for Aaron Hartranft and Catherin Hartranft, 1900."
      },
      {
        "title": "Catharine Fryer Hartranft, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QMFK-2VT",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVGP-WT6L : Thu Oct 01 14:16:19 UTC 2026), Entry for Catharine Fryer Hartranft."
      }
    ],
    "portrait": "/ancestors/portraits/111_MR1R-R1Z.jpg"
  },
  {
    "id": "I4",
    "name": "Wilma Jeanne Mock",
    "sex": "F",
    "gen": 2,
    "slot": 3,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I3",
    "birthYear": null,
    "deathYear": null,
    "birthDate": null,
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "United States",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "G83P-NFY",
    "photo": "/ancestors/bubbles/jeanne.jpg",
    "living": true,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/jeanne.jpg"
  },
  {
    "id": "I9",
    "name": "Chalmer C Mock",
    "sex": "M",
    "gen": 3,
    "slot": 6,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I4",
    "birthYear": 1910,
    "deathYear": 1981,
    "birthDate": "10 Nov 1910",
    "deathDate": "6 Oct 1981",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Blair, Pennsylvania, United States",
    "deathPlace": "Roaring Spring, Taylor Twp, Blair, Pennsylvania",
    "burialPlace": "Dry Hill Cem, Woodbury Twp, Bedford, Pennsylvania",
    "christeningPlace": null,
    "fsId": "LZNB-PV3",
    "photo": "/ancestors/bubbles/014_LZNB-PV3.jpg",
    "living": false,
    "alternateNames": [
      "Chalmer Cletus Mock"
    ],
    "facts": [
      {
        "kind": "Residence",
        "date": "1920",
        "place": "Taylor Township, Blair, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1930",
        "place": "Taylor Township, Blair, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1935",
        "place": "Same House",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1935",
        "place": "Blair, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1940",
        "place": "Taylor Township, Blair, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1940",
        "place": "Martinsburg, Blair, Pennsylvania, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Chalmer Cletus Mock, \"Pennsylvania, World War II Draft Registration Cards, 1940-1945\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7T69-312",
        "citation": "\"Pennsylvania, World War II Draft Registration Cards, 1940-1945\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2SJ-8RMT : Fri Feb 23 20:55:16 UTC 2024), Entry for Chalmer Cletus Mock and Wilma G Mock, 16 Oct 1940."
      },
      {
        "title": "Chalmer C Mock, \"United States, Census, 1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7T6M-KT8",
        "citation": "\"United States, Census, 1950\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6XB5-7WMR : Wed Mar 20 00:45:37 UTC 2024), Entry for Chalmer C Mock and Wilma G Mock, 3 April 1950."
      },
      {
        "title": "Chalmer Mack, \"United States, Census, 1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SG8Y-YBP",
        "citation": "\"United States, Census, 1940\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KQ41-21D : Tue Jan 21 06:00:15 UTC 2025), Entry for Chalmer Mack and Wilma Mack, 1940."
      },
      {
        "title": "Chalmer Mack, \"United States, Census, 1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SD82-2SP",
        "citation": "\"United States, Census, 1940\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KQ41-2BS : Wed Jan 22 05:06:33 UTC 2025), Entry for Chalmer Mack and Wilma Mack, 1940."
      },
      {
        "title": "Chalmer C Mock, \"Virginia, Marriage Certificates, 1936-1989\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SD82-V5N",
        "citation": "\"Virginia, Marriage Certificates, 1936-1989\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVYR-22XR : Fri May 01 19:59:09 UTC 2026), Entry for Chalmer Ardean Mock and Chalmer C Mock, 21 Oct 1974."
      },
      {
        "title": "Chalmer Cletus Mock, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S3KG-G58",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVGF-7VNQ : Fri Oct 02 06:48:17 UTC 2026), Entry for Chalmer Cletus Mock, 1981."
      },
      {
        "title": "Chalmer Mock, \"United States, Social Security Death Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SMZY-LCQ",
        "citation": "\"United States, Social Security Death Index,\" database, FamilySearch (https://familysearch.org/ark:/61903/1:1:J23W-8JX : 8 January 2021), Chalmer Mock, Oct 1981; citing U.S. Social Security Administration, Death Master File, database (Alexandria, Virginia: National Technical Information Service, ongoing)."
      },
      {
        "title": "Chalmer Mock, \"United States, Census, 1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9R1H-GD8",
        "citation": "\"United States, Census, 1940\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KQHM-SWC : Sun Jan 19 20:51:55 UTC 2025), Entry for John Mock and Annie Mock, 1940."
      },
      {
        "title": "Chalmer Mock, \"United States, Census, 1930\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9R1H-G46",
        "citation": "\"United States, Census, 1930\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XCHW-XWQ : Sat Mar 09 22:34:07 UTC 2024), Entry for John B Mock and Annie Mock, 1930."
      },
      {
        "title": "Chalmer Mock, \"United States, Census, 1920\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9R1H-LY8",
        "citation": "\"United States, Census, 1920\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MFTP-382 : Sun Sep 27 16:09:31 UTC 2026), Entry for John A Mock and Annie Mock, 1920."
      }
    ],
    "portrait": "/ancestors/portraits/014_LZNB-PV3.jpg"
  },
  {
    "id": "I20",
    "name": "John Albert Mock",
    "sex": "M",
    "gen": 4,
    "slot": 12,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I9",
    "birthYear": 1880,
    "deathYear": 1963,
    "birthDate": "28 Sep 1880",
    "deathDate": "Mar 1963",
    "burialDate": "1963",
    "christeningDate": null,
    "birthPlace": "Bakers Summit, Bedford, Pennsylvania, United States",
    "deathPlace": "Pennsylvania, United States",
    "burialPlace": "Holsinger Cemtery, Bakers Summit, Blair, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LZNB-PL4",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [
      {
        "kind": "Residence",
        "date": "1900",
        "place": "Bedford, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1910",
        "place": "Bloomfield Township, Bedford, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1910",
        "place": "Larksville, Luzerne, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1920",
        "place": "Taylor Township, Blair, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1930",
        "place": "Taylor Township, Blair, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1935",
        "place": "Same House",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1940",
        "place": "Taylor Township, Blair, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Military Draft Registration",
        "date": "1942",
        "place": "Roaring Spring, Blair, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": null,
        "place": "Roaring Spring, Blair, Pennsylvania, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "John Albert Mock, \"United States, World War I Draft Registration Cards, 1917-1918\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7T69-7DP",
        "citation": "\"United States, World War I Draft Registration Cards, 1917-1918\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:4Q14-V9MM : Sat May 16 01:23:24 UTC 2026), Entry for John Albert Mock and Annie Mock, from 1917 to 1918."
      },
      {
        "title": "John B Mock, \"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q6NV-WW9",
        "citation": "\"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6K3Z-7GLH : Fri Jul 10 21:44:23 UTC 2026), Entry for Earl E Mock and John B Mock."
      },
      {
        "title": "John Mock, \"Virginia, Marriage Certificates, 1936-1989\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SRGZ-GG2",
        "citation": "\"Virginia, Marriage Certificates, 1936-1989\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QV1M-7QH7 : Fri May 01 20:20:19 UTC 2026), Entry for Marion D Butler and Howard Butler, 06 Jun 1942."
      },
      {
        "title": "John Mock, \"Virginia, Marriage Certificates, 1936-1989\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SRGZ-7RY",
        "citation": "\"Virginia, Marriage Certificates, 1936-1989\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QK9J-BN8B : Fri May 01 21:39:40 UTC 2026), Entry for Earl E Mock and John Mock, 30 Jul 1942."
      },
      {
        "title": "John Mock, \"Virginia, Marriage Certificates, 1936-1989\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SRM7-RB2",
        "citation": "\"Virginia, Marriage Certificates, 1936-1989\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QK9N-KCPK : Fri May 01 21:31:05 UTC 2026), Entry for Ellis M Brumbaugh and Emory Brumbaugh, 04 Mar 1939."
      },
      {
        "title": "John Burget Mock, \"Virginia, Marriage Certificates, 1936-1989\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SRM7-8RL",
        "citation": "\"Virginia, Marriage Certificates, 1936-1989\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QK9D-6WDH : Fri May 01 21:05:03 UTC 2026), Entry for Joseph Ellis Beegle and Oscar Alonzo Beegle, 09 Feb 1973."
      },
      {
        "title": "John B. Mock, \"Pennsylvania, Marriages, 1709-1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SRM7-ZZ8",
        "citation": "\"Pennsylvania, Marriages, 1709-1940\", , FamilySearch (https://www.familysearch.org/ark:/61903/1:1:H52S-9M3Z : 7 May 2023), John B. Mock, 1910."
      },
      {
        "title": "John Albert Mock, \"United States, World War II Draft Registration Cards, 1942\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9R1H-GBH",
        "citation": "\"United States, World War II Draft Registration Cards, 1942\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VQF4-YD9 : Sun Mar 29 21:01:35 UTC 2026), Entry for John Albert Mock, 1942."
      },
      {
        "title": "John Mock, \"United States, Social Security Death Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9R1H-GR7",
        "citation": "\"United States, Social Security Death Index,\" database, FamilySearch (https://familysearch.org/ark:/61903/1:1:J27M-CMG : 8 January 2021), John Mock, Mar 1963; citing U.S. Social Security Administration, Death Master File, database (Alexandria, Virginia: National Technical Information Service, ongoing)."
      },
      {
        "title": "John Mock, \"United States, Census, 1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9R1H-GZR",
        "citation": "\"United States, Census, 1940\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KQHM-SWC : Sun Jan 19 20:51:55 UTC 2025), Entry for John Mock and Annie Mock, 1940."
      },
      {
        "title": "John B Mock, \"United States, Census, 1930\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9R1H-GW5",
        "citation": "\"United States, Census, 1930\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XCHW-XWQ : Sat Mar 09 22:34:07 UTC 2024), Entry for John B Mock and Annie Mock, 1930."
      },
      {
        "title": "John B Mock in household of John C Mock, \"United States Census, 1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9GSL-R15",
        "citation": "\"United States, Census, 1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MGQJ-4BK : Wed Aug 13 16:53:15 UTC 2025), Entry for John C Mock and John B Mock, 1910."
      },
      {
        "title": "John A Mock, \"United States, Census, 1920\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9R1H-LTB",
        "citation": "\"United States, Census, 1920\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MFTP-382 : Sun Sep 27 16:09:31 UTC 2026), Entry for John A Mock and Annie Mock, 1920."
      },
      {
        "title": "John B Mock in household of John C Mock, \"United States Census, 1900\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9GSL-RQV",
        "citation": "\"United States, Census, 1900\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M3MK-69P : Thu Jan 01 21:53:19 UTC 2026), Entry for John C Mock and Warren Mock, 1900."
      },
      {
        "title": "John B. Mock, \"Pennsylvania, County Marriages, 1775-1991\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/98HP-JGQ",
        "citation": "\"Pennsylvania, County Marriages, 1775-1991\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VFWX-9Z3 : Fri May 08 00:54:20 UTC 2026), Entry for John B. Mock and Anna Wentz, 27 March 1910."
      },
      {
        "title": "John Albert Mock, \"United States, World War I Draft Registration Cards, 1917-1918\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/98HP-JX6",
        "citation": "\"United States, World War I Draft Registration Cards, 1917-1918\", database with images, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:K6VM-C97 : 30 June 2024), John Albert Mock, 1917-1918."
      },
      {
        "title": "Legacy NFS Source: John Albert Mock - Published information: Military record or discharge: birth-name: John Albert Mock",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M9Z6-6NM",
        "citation": "Internet, WWI draft registration"
      }
    ]
  },
  {
    "id": "I47",
    "name": "John C. Mock",
    "sex": "M",
    "gen": 5,
    "slot": 24,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I20",
    "birthYear": 1831,
    "deathYear": 1928,
    "birthDate": "15 Mar 1831",
    "deathDate": "10 May 1928",
    "burialDate": "1928",
    "christeningDate": null,
    "birthPlace": "Altoona, Blair, Pennsylvania, United States",
    "deathPlace": "Roaring Spring, Blair, Pennsylvania, United States",
    "burialPlace": "Bakers Summit, Bedford, Pennsylvania, United States of America",
    "christeningPlace": null,
    "fsId": "LVZG-5XP",
    "photo": null,
    "living": false,
    "alternateNames": [
      "John Mock"
    ],
    "facts": [
      {
        "kind": "Residence",
        "date": "1870",
        "place": "Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1880",
        "place": "Bloomfield Township, Bedford, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1900",
        "place": "Bedford, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1910",
        "place": "Bloomfield Township, Bedford, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1920",
        "place": "Bloomfield Township, Bedford, Pennsylvania, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "John C Mock in the Pennsylvania, Death Certificates, 1906-1963",
        "href": "https://www.familysearch.org/tree/sources/viewedit/98T3-T7S",
        "citation": ""
      },
      {
        "title": "John Mock in entry for Geroge W. Croft, \"Pennsylvania, Marriages, 1709-1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9R1N-LBB",
        "citation": "\"Pennsylvania, Marriages, 1709-1940\", , FamilySearch (https://www.familysearch.org/ark:/61903/1:1:V2DB-RDV : 7 May 2023), John Mock in entry for Geroge W. Croft, 1886."
      },
      {
        "title": "John C. Mock in entry for John B. Mock, \"Pennsylvania, Marriages, 1709-1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SRM7-ZPC",
        "citation": "\"Pennsylvania, Marriages, 1709-1940\", , FamilySearch (https://www.familysearch.org/ark:/61903/1:1:H52S-9MW2 : 7 May 2023), John C. Mock in entry for John B. Mock, 1910."
      },
      {
        "title": "John Mack, \"Pennsylvania, County Marriages, 1775-1991\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3QYX-C3P",
        "citation": "\"Pennsylvania, County Marriages, 1775-1991\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VF3G-D8D : Fri May 08 00:41:10 UTC 2026), Entry for Edward B. Mack and Ella Moore, 24 December 1899."
      },
      {
        "title": "John Mock, \"Pennsylvania, County Marriages, 1775-1991\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3TCK-T6X",
        "citation": "\"Pennsylvania, County Marriages, 1775-1991\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VFWF-M6G : Fri May 08 00:54:21 UTC 2026), Entry for George A. Baker and Maggie Mock, 17 June 1906."
      },
      {
        "title": "John Mock, \"United States, Census, 1870\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/98T3-GSB",
        "citation": "\"United States, Census, 1870\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MZLL-12S : Tue Oct 21 23:47:36 UTC 2025), Entry for John Mock and Susan Mock, 1870."
      },
      {
        "title": "John Mock, \"United States Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9GSL-VNR",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MW6T-XMW : Wed Sep 09 03:49:59 UTC 2026), Entry for John Mock and Susan Mock, 1880."
      },
      {
        "title": "John C Mock, \"United States Census, 1900\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9GSL-PRS",
        "citation": "\"United States, Census, 1900\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M3MK-69P : Thu Jan 01 21:53:19 UTC 2026), Entry for John C Mock and Warren Mock, 1900."
      },
      {
        "title": "John C. Mock in entry for Harry B. Mock, \"Pennsylvania, Marriages, 1709-1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S257-DTQ",
        "citation": "\"Pennsylvania, Marriages, 1709-1940\", , FamilySearch (https://www.familysearch.org/ark:/61903/1:1:H52S-RD2M : 7 May 2023), John C. Mock in entry for Harry B. Mock, 1910."
      },
      {
        "title": "John C. Mock, \"Pennsylvania, County Marriages, 1775-1991\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/98T3-YS5",
        "citation": "\"Pennsylvania, County Marriages, 1775-1991\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VFW6-JJ4 : Fri May 08 00:54:13 UTC 2026), Entry for Harry B. Mock and Sarah C. Sturgeon, 16 January 1910."
      },
      {
        "title": "John C. Mock, \"Find A Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9GSL-23K",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QV29-NGDD : Sat Oct 03 15:49:08 UTC 2026), Entry for John C. Mock."
      },
      {
        "title": "John C Mock, \"United States Census, 1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9GSL-RRR",
        "citation": "\"United States, Census, 1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MGQJ-4BK : Wed Aug 13 16:53:15 UTC 2025), Entry for John C Mock and John B Mock, 1910."
      },
      {
        "title": "John Mock, \"Pennsylvania, County Marriages, 1775-1991\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9R1H-P8B",
        "citation": "\"Pennsylvania, County Marriages, 1775-1991\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VFMP-H43 : Fri May 08 00:23:27 UTC 2026), Entry for David Bishop and Minnie Mock, 24 September 1902."
      },
      {
        "title": "John Mock, \"Pennsylvania, County Marriages, 1775-1991\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/98TQ-MFM",
        "citation": "\"Pennsylvania, County Marriages, 1775-1991\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VFMT-YQ7 : Fri May 08 00:21:44 UTC 2026), Entry for Geroge W. Croft and Elizabeth Mock, 4 April 1886."
      },
      {
        "title": "John C Mock in household of Harry B Mock, \"United States Census, 1920\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9GSL-TF2",
        "citation": "\"United States, Census, 1920\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MNMW-8ND : Sun Sep 27 15:30:22 UTC 2026), Entry for Harry B Mock and Emma Mock, 1920."
      },
      {
        "title": "John Mock in entry for David Bishop, \"Pennsylvania, Marriages, 1709-1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9R1H-PCD",
        "citation": "\"Pennsylvania, Marriages, 1709-1940\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:V2D1-KQC : 7 May 2023), John Mock in entry for David Bishop, 1902."
      },
      {
        "title": "John C. Mock, \"Pennsylvania, County Marriages, 1775-1991\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7V3F-LHF",
        "citation": "\"Pennsylvania, County Marriages, 1775-1991\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VFWX-9Z3 : Fri May 08 00:54:20 UTC 2026), Entry for John B. Mock and Anna Wentz, 27 March 1910."
      },
      {
        "title": "John Mock in entry for George A. Baker, \"Pennsylvania, Marriages, 1709-1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3FWY-N7W",
        "citation": "\"Pennsylvania, Marriages, 1709-1940\", , FamilySearch (https://www.familysearch.org/ark:/61903/1:1:H52M-DMPZ : 7 May 2023), John Mock in entry for George A. Baker, 1906."
      }
    ]
  },
  {
    "id": "I143",
    "name": "Frederick Mock",
    "sex": "M",
    "gen": 6,
    "slot": 48,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I47",
    "birthYear": 1807,
    "deathYear": 1886,
    "birthDate": "7 Apr 1807",
    "deathDate": "22 Feb 1886",
    "burialDate": "Feb 1886",
    "christeningDate": null,
    "birthPlace": "Pennsylvania, United States",
    "deathPlace": "Osterburg, Bedford, Pennsylvania, United States",
    "burialPlace": "Osterburg, Bedford, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "L6Q5-KGH",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [
      {
        "kind": "Residence",
        "date": "1850",
        "place": "Pavia Township, Bedford, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1860",
        "place": "North Woodbury Township, Blair, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1880",
        "place": "King, Kimmel Township, Bedford, Pennsylvania, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Fred Mock, \"United States Census, 1850\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9KCX-XFX",
        "citation": "\"United States, Census, 1850\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M44J-GNN : Tue Oct 21 05:31:53 UTC 2025), Entry for Fred Mock and Betsy Mock, 1850."
      },
      {
        "title": "Fredeick Mock, \"United States, Census, 1860\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3QYX-S82",
        "citation": "\"United States, Census, 1860\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MXP7-8LQ : Mon Jul 08 19:37:08 UTC 2024), Entry for Fredeick Mock and Elizabeth Mock, 1860."
      },
      {
        "title": "Frederick Mock, \"United States, Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/98TC-LDM",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MW6Y-7GW : Wed Sep 09 07:54:28 UTC 2026), Entry for Frederick Mock and Elizabeth Mock, 1880."
      },
      {
        "title": "Frederick Mock, \"United States, Civil War Soldiers Index, 1861-1865\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/98YD-YD8",
        "citation": "\"United States, Civil War Soldiers Index, 1861-1865\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:FSSL-32H : Thu Feb 13 00:52:42 UTC 2025), Entry for Frederick Mock, from 1861 to 1865."
      },
      {
        "title": "Frederick Mock, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S13B-Z35",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QV2T-SYZV : Sat Oct 03 16:00:13 UTC 2026), Entry for Frederick Mock."
      }
    ]
  },
  {
    "id": "I144",
    "name": "Elizabeth Christ",
    "sex": "F",
    "gen": 6,
    "slot": 49,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I47",
    "birthYear": 1802,
    "deathYear": 1889,
    "birthDate": "3 May 1802",
    "deathDate": "25 Nov 1889",
    "burialDate": "Nov 1889",
    "christeningDate": "20 Jul 1802",
    "birthPlace": "Bedford, Pennsylvania, United States",
    "deathPlace": "Osterburg, Bedford, Pennsylvania, United States",
    "burialPlace": "Trinity United Church of Christ Cemetery, Osterburg, Bedford, Pennsylvania, United States",
    "christeningPlace": "Ladiesburg, Frederick, Maryland",
    "fsId": "KG13-XH6",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Mrs. Fred Mock",
      "Mock",
      "Elizabeth Krist",
      "Elizabeth Crist"
    ],
    "facts": [
      {
        "kind": "Residence",
        "date": "1850",
        "place": "Pavia Township, Bedford, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1880",
        "place": "United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Elizabeth Christ, \"Maryland, Births and Baptisms, 1665-1995\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/37L3-D4M",
        "citation": "\"Maryland, Births and Baptisms, 1665-1995\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:HY2T-RNZM : Thu Dec 12 19:15:27 UTC 2024), Entry for Elizabeth Christ and Johannes Christ, 3 May 1802."
      },
      {
        "title": "Elizabeth Christ, \"Maryland, Births and Christenings, 1650-1995\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SGNV-LS7",
        "citation": "\"Maryland, Births and Christenings, 1650-1995\", database, FamilySearch (https://familysearch.org/ark:/61903/1:1:HYPQ-CFMM : 12 February 2020), Elizabeth Christ, 1802."
      },
      {
        "title": "Elizabeth Christ, \"Maryland, Births and Christenings, 1650-1995\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MTV1-7V4",
        "citation": "\"Maryland, Births and Christenings, 1650-1995\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:HYPQ-CFMM : 12 February 2020), Elizabeth Christ, 1802."
      },
      {
        "title": "Elizabeth Crist Mock, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9R1H-L3K",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QV2T-SYZN : Thu Oct 01 14:29:51 UTC 2026), Entry for Elizabeth Crist Mock."
      },
      {
        "title": "Betsy Mock in household of Fred Mock, \"United States Census, 1850\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9KCX-XXX",
        "citation": "\"United States, Census, 1850\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M44J-GNN : Tue Oct 21 05:31:53 UTC 2025), Entry for Fred Mock and Betsy Mock, 1850."
      },
      {
        "title": "Elizabeth Mock, \"United States, Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/98TC-L5W",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MW6Y-7GW : Wed Sep 09 07:54:28 UTC 2026), Entry for Frederick Mock and Elizabeth Mock, 1880."
      },
      {
        "title": "Legacy NFS Source: Elizabeth Crist - Government record: Census record: birth-name: Elizabeth Crist",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MSQ7-8JV",
        "citation": "1880 Census"
      }
    ]
  },
  {
    "id": "I44",
    "name": "Susanna Burket",
    "sex": "F",
    "gen": 5,
    "slot": 25,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I20",
    "birthYear": 1838,
    "deathYear": 1909,
    "birthDate": "Abt 1838",
    "deathDate": "27 May 1909",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Pennsylvania, United States",
    "deathPlace": "North Woodbury Blair Pennsylvania USA",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "93VR-M55",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Susan Zook Burket",
      "Susan Burket"
    ],
    "facts": [
      {
        "kind": "Residence",
        "date": "1850",
        "place": "Woodbury Township, Blair, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1870",
        "place": "Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1880",
        "place": "Bloomfield Township, Bedford, Pennsylvania, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Susannah Mock, \"Pennsylvania, County Marriages, 1775-1991\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7V3F-LWS",
        "citation": "\"Pennsylvania, County Marriages, 1775-1991\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VFWX-9Z3 : Fri May 08 00:54:20 UTC 2026), Entry for John B. Mock and Anna Wentz, 27 March 1910."
      },
      {
        "title": "Susannah Mock in entry for John B. Mock, \"Pennsylvania, Marriages, 1709-1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SRM7-ZBY",
        "citation": "\"Pennsylvania, Marriages, 1709-1940\", , FamilySearch (https://www.familysearch.org/ark:/61903/1:1:H52S-9MZM : 7 May 2023), Susannah Mock in entry for John B. Mock, 1910."
      },
      {
        "title": "Susana Mock in entry for Harry B. Mock, \"Pennsylvania, Marriages, 1709-1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S257-D15",
        "citation": "\"Pennsylvania, Marriages, 1709-1940\", , FamilySearch (https://www.familysearch.org/ark:/61903/1:1:H52S-RDPZ : 7 May 2023), Susana Mock in entry for Harry B. Mock, 1910."
      },
      {
        "title": "Susan Burkett, \"United States, Census, 1850\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SXM8-YTJ",
        "citation": "\"United States, Census, 1850\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M44G-9CR : Sat Jan 18 22:10:25 UTC 2025), Entry for Isaac Burkett and Sarah Burkett, 1850."
      },
      {
        "title": "Susan Mock in household of John Mock, \"United States Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9GSL-VK2",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MW6T-XMW : Wed Sep 09 03:49:59 UTC 2026), Entry for John Mock and Susan Mock, 1880."
      },
      {
        "title": "Susana Mock, \"Pennsylvania, County Marriages, 1775-1991\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/98T3-YN4",
        "citation": "\"Pennsylvania, County Marriages, 1775-1991\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VFW6-JJ4 : Fri May 08 00:54:13 UTC 2026), Entry for Harry B. Mock and Sarah C. Sturgeon, 16 January 1910."
      },
      {
        "title": "Susan Mock, \"United States, Census, 1870\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/98T3-GQZ",
        "citation": "\"United States, Census, 1870\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MZLL-12S : Tue Oct 21 23:47:36 UTC 2025), Entry for John Mock and Susan Mock, 1870."
      }
    ]
  },
  {
    "id": "I132",
    "name": "Isaac Bulger Burket",
    "sex": "M",
    "gen": 6,
    "slot": 50,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I44",
    "birthYear": 1809,
    "deathYear": 1874,
    "birthDate": "11 Aug 1809",
    "deathDate": "2 Nov 1874",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Blair, Pennsylvania, United States",
    "deathPlace": "Henrietta, Blair, Pennsylvania, United States",
    "burialPlace": "Burget Cemetery, Henrietta, North Woodbury Township, Blair, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LCRN-L2K",
    "photo": "/ancestors/bubbles/114_LCRN-L2K.jpg",
    "living": false,
    "alternateNames": [
      "Isaac Burket",
      "Isaac Burget",
      "Isaac Burger Burket"
    ],
    "facts": [
      {
        "kind": "Residence",
        "date": "1850",
        "place": "Woodbury Township, Blair, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1850",
        "place": "Pleasant Township, Seneca, Ohio, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1860",
        "place": "Woodbury Township, Blair, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1860",
        "place": "Pleasant Township, Seneca, Ohio, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1860",
        "place": "Pleasant Township, Seneca, Ohio, United States",
        "note": "Census"
      },
      {
        "kind": "Military service",
        "date": "from 2 September 1862 to 28 June 1865",
        "place": null,
        "note": "Private, Union 138th Regiment Pennsylvania Infantry, Company D"
      },
      {
        "kind": "Residence",
        "date": "1870",
        "place": "Woodbury Township, Blair, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1870",
        "place": "Pleasant Township, Seneca, Ohio, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Issac Burkert in the U.S., Find A Grave Index, 1600s",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S5Y8-QKC",
        "citation": "\"Issac Burkert in the U.S., Find A Grave Index, 1600s.\" Current https://search.ancestry.com/cgi-bin/sse.dll?indiv=try&h=53903524&dbid=60525. Accessed 6 Aug. 2020."
      },
      {
        "title": "U.S., Civil War Pension Index: General Index to Pension Files, 1861-1934",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S528-XPG",
        "citation": "The National Archives at Washington, D.C.; Washington, D.C.; Record Group Title: Records of the Department of Veterans Affairs, 1773 - 2007; Record Group Number: 15; Series Title: U.S., Civil War Pension Index: General Index to Pension Files, 1861-1934; Se"
      },
      {
        "title": "1840 United States Federal Census",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S528-XPV",
        "citation": "Year: 1840; Census Place: North Woodbury, Bedford, Pennsylvania; Roll: 445; Page: 356; Family History Library Film: 0020538"
      },
      {
        "title": "U.S. Civil War Soldiers, 1861-1865",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S528-XP6",
        "citation": ""
      },
      {
        "title": "1830 United States Federal Census",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S528-XPH",
        "citation": "1830; Census Place: St Clair, Bedford, Pennsylvania; Series: M19; Roll: 152; Page: 135; Family History Library Film: 0020626"
      },
      {
        "title": "1850 United States Federal Census",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S528-XPQ",
        "citation": "Year: 1850; Census Place: Pleasant, Seneca, Ohio; Roll: 728; Page: 307B"
      },
      {
        "title": "1870 United States Federal Census",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S528-XGR",
        "citation": "Year: 1870; Census Place: Pleasant, Seneca, Ohio; Roll: M593_1266; Page: 207B; Family History Library Film: 552765"
      },
      {
        "title": "1860 United States Federal Census",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S528-XGL",
        "citation": "Year: 1860; Census Place: Pleasant, Seneca, Ohio; Page: 179; Family History Library Film: 805034"
      },
      {
        "title": "U.S., Find A Grave Index, 1600s-Current",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S528-XGN",
        "citation": ""
      },
      {
        "title": "Legacy NFS Source: Isaac Burket - Published information: birth-name: Isaac Burket",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M9TV-NYF",
        "citation": ""
      },
      {
        "title": "Kensigner/Brumbaugh Cemetery",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9P4Z-3LB",
        "citation": "Brumbaugh farm located at Season Lain off Orchard Road. The Burget Cemetery list is on the bottom of the Kensinger list."
      },
      {
        "title": "Isaac Burket, \"United States, Census, 1870\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3Q66-SHR",
        "citation": "\"United States, Census, 1870\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MZLG-65S : Wed Oct 15 04:31:24 UTC 2025), Entry for Isaac Burket and Mary Burket, 1870."
      },
      {
        "title": "Isaac Berget, \"United States, Census, 1860\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3NQQ-JZY",
        "citation": "\"United States, Census, 1860\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MXP7-82Y : Mon Jul 08 19:38:13 UTC 2024), Entry for Isaac Berget and Margaret Berget, 1860."
      },
      {
        "title": "Isaac Burkett, \"United States, Census, 1850\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3K13-G7Y",
        "citation": "\"United States, Census, 1850\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M44G-9CR : Sat Jan 18 22:10:25 UTC 2025), Entry for Isaac Burkett and Sarah Burkett, 1850."
      },
      {
        "title": "Isaac Burget, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/95DQ-SLL",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVKP-822N : Fri Oct 02 15:05:12 UTC 2026), Entry for Isaac Burget."
      },
      {
        "title": "Isaac Burkett, \"United States, Census, 1870\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7HHR-71H",
        "citation": "\"United States, Census, 1870\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M6LP-FT8 : Mon Jan 20 19:24:23 UTC 2025), Entry for Isaac Burkett and Sarah Burkett, 1870."
      }
    ],
    "portrait": "/ancestors/portraits/114_LCRN-L2K.jpg"
  },
  {
    "id": "I125",
    "name": "Sarah Byers Zook",
    "sex": "F",
    "gen": 6,
    "slot": 51,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I44",
    "birthYear": 1808,
    "deathYear": 1857,
    "birthDate": "2 Dec 1808",
    "deathDate": "31 Aug 1857",
    "burialDate": "1857",
    "christeningDate": null,
    "birthPlace": "Pennsylvania, United States",
    "deathPlace": null,
    "burialPlace": "Burget Cemetery, Henrietta, Blair, Pennsylvania, United States of America",
    "christeningPlace": null,
    "fsId": "LCRB-S41",
    "photo": "/ancestors/bubbles/115_LCRB-S41.jpg",
    "living": false,
    "alternateNames": [
      "Sarah Zook"
    ],
    "facts": [
      {
        "kind": "Alt. Birth",
        "date": "2 December 1808",
        "place": null,
        "note": "Alt. Birth"
      },
      {
        "kind": "Residence",
        "date": "1850",
        "place": "Woodbury Township, Blair, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1850",
        "place": "Pleasant Township, Seneca, Ohio, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Kensigner/Brumbaugh Cemetery",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9P4Z-3LB",
        "citation": "Brumbaugh farm located at Season Lain off Orchard Road. The Burget Cemetery list is on the bottom of the Kensinger list."
      },
      {
        "title": "Sarah Burkett, \"United States, Census, 1850\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SF41-D5Q",
        "citation": "\"United States, Census, 1850\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M44G-9CR : Sat Jan 18 22:10:25 UTC 2025), Entry for Isaac Burkett and Sarah Burkett, 1850."
      },
      {
        "title": "Sarah Zook Burget, \"Find A Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9GMM-2CQ",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVKP-822L : Sat Oct 03 06:51:54 UTC 2026), Entry for Sarah Zook Burget."
      }
    ],
    "portrait": "/ancestors/portraits/115_LCRB-S41.jpg"
  },
  {
    "id": "I16",
    "name": "Annie L. Wentz",
    "sex": "F",
    "gen": 4,
    "slot": 13,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I9",
    "birthYear": 1888,
    "deathYear": 1956,
    "birthDate": "4 Jun 1888",
    "deathDate": "27 Jul 1956",
    "burialDate": "1956",
    "christeningDate": null,
    "birthPlace": "Bakers Summit, Bedford, Pennsylvania, United States",
    "deathPlace": "Roaring Spring, Blair, Pennsylvania, United States",
    "burialPlace": "Holsinger Cemetery, Bakers Summit, Bedford, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LZNB-PGP",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Anna Wentz",
      "Annie Wentz"
    ],
    "facts": [
      {
        "kind": "Residence",
        "date": "1900",
        "place": "Bloomfield Township, Bedford, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1910",
        "place": "Larksville, Luzerne, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1920",
        "place": "Taylor Township, Blair, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1930",
        "place": "Taylor Township, Blair, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1935",
        "place": "Same House",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1940",
        "place": "Taylor Township, Blair, Pennsylvania, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Annie L Wentz, \"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q6NV-W4R",
        "citation": "\"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6K3Z-7GLH : Fri Jul 10 21:44:23 UTC 2026), Entry for Earl E Mock and John B Mock."
      },
      {
        "title": "Anna Wentz, \"United States, Census, 1900\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3ML1-BJ1",
        "citation": "\"United States, Census, 1900\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M3MV-Y4F : Thu Jan 01 23:13:00 UTC 2026), Entry for Joseph Wentz and Dorothy Wentz, 1900."
      },
      {
        "title": "Annie Wantz, \"Virginia, Marriage Certificates, 1936-1989\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SRGZ-GPD",
        "citation": "\"Virginia, Marriage Certificates, 1936-1989\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QV1M-7QH7 : Fri May 01 20:20:19 UTC 2026), Entry for Marion D Butler and Howard Butler, 06 Jun 1942."
      },
      {
        "title": "Annie L Wentz, \"Virginia, Marriage Certificates, 1936-1989\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SRGZ-WDF",
        "citation": "\"Virginia, Marriage Certificates, 1936-1989\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QK9J-BN8B : Fri May 01 21:39:40 UTC 2026), Entry for Earl E Mock and John Mock, 30 Jul 1942."
      },
      {
        "title": "Anna Wentz, \"Virginia, Marriage Certificates, 1936-1989\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SRM7-TSG",
        "citation": "\"Virginia, Marriage Certificates, 1936-1989\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QK9N-KCPK : Fri May 01 21:31:05 UTC 2026), Entry for Ellis M Brumbaugh and Emory Brumbaugh, 04 Mar 1939."
      },
      {
        "title": "Annie Loretta Wentz, \"Virginia, Marriage Certificates, 1936-1989\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SRM7-D95",
        "citation": "\"Virginia, Marriage Certificates, 1936-1989\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QK9D-6WDH : Fri May 01 21:05:03 UTC 2026), Entry for Joseph Ellis Beegle and Oscar Alonzo Beegle, 09 Feb 1973."
      },
      {
        "title": "Anna Wentz in entry for John B. Mock, \"Pennsylvania, Marriages, 1709-1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SRM7-ZKM",
        "citation": "\"Pennsylvania, Marriages, 1709-1940\", , FamilySearch (https://www.familysearch.org/ark:/61903/1:1:H52S-9M6Z : 7 May 2023), Anna Wentz in entry for John B. Mock, 1910."
      },
      {
        "title": "Annie Mock, \"United States, Census, 1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9R1H-GZN",
        "citation": "\"United States, Census, 1940\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KQHM-SWC : Sun Jan 19 20:51:55 UTC 2025), Entry for John Mock and Annie Mock, 1940."
      },
      {
        "title": "Annie Mock, \"United States, Census, 1930\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9R1H-GWN",
        "citation": "\"United States, Census, 1930\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XCHW-XWQ : Sat Mar 09 22:34:07 UTC 2024), Entry for John B Mock and Annie Mock, 1930."
      },
      {
        "title": "Annie Mock, \"United States, Census, 1920\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9R1H-LT6",
        "citation": "\"United States, Census, 1920\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MFTP-382 : Sun Sep 27 16:09:31 UTC 2026), Entry for John A Mock and Annie Mock, 1920."
      },
      {
        "title": "Annie Loretta Wentz Mock, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9R1H-LNR",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVLB-MGLQ : Fri Oct 02 01:09:27 UTC 2026), Entry for Annie Loretta Wentz Mock."
      },
      {
        "title": "Anna Wentz, \"Pennsylvania, County Marriages, 1775-1991\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9R1H-L6R",
        "citation": "\"Pennsylvania, County Marriages, 1775-1991\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VFWX-9Z3 : Fri May 08 00:54:20 UTC 2026), Entry for John B. Mock and Anna Wentz, 27 March 1910."
      }
    ]
  },
  {
    "id": "I40",
    "name": "Joseph Henry Wentz",
    "sex": "M",
    "gen": 5,
    "slot": 26,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I16",
    "birthYear": 1849,
    "deathYear": 1913,
    "birthDate": "1849",
    "deathDate": "1913",
    "burialDate": "1913",
    "christeningDate": null,
    "birthPlace": "Bedford, Pennsylvania, United States",
    "deathPlace": "Pennsylvania, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "PWZ7-SQ3",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Joseph Wentz",
      "Joseph H. Wentz",
      "Joseph H Wentz"
    ],
    "facts": [
      {
        "kind": "Residence",
        "date": "1850",
        "place": "Pavia Township, Bedford, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1870",
        "place": "Pavia Township, Bedford, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1880",
        "place": "King, Kimmel Township, Bedford, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1900",
        "place": "Bedford, Pennsylvania, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Joseph H Wentz, \"Pennsylvania, Philadelphia, Historical Society of Pennsylvania, Births and Baptisms, 1520-1999\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7Y5G-68G",
        "citation": "\"Pennsylvania, Philadelphia, Historical Society of Pennsylvania, Births and Baptisms, 1520-1999\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CT5-BK6M : Wed Jan 22 07:15:46 UTC 2025), Entry for Joseph H Wentz, 1849."
      },
      {
        "title": "Joseph H Wentz, \"Pennsylvania, Philadelphia, Historical Society of Pennsylvania, Deaths and Burials, 1627-1972\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7Y5G-DBW",
        "citation": "\"Pennsylvania, Philadelphia, Historical Society of Pennsylvania, Deaths and Burials, 1627-1972\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CYZ-GFRL : Thu Jan 09 05:52:00 UTC 2025), Entry for Joseph H Wentz, 1913."
      },
      {
        "title": "Joseph H Wentz, \"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/77PJ-7ZD",
        "citation": "\"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6K4K-7S71 : Sun Jul 05 12:15:48 UTC 2026), Entry for William Isaac Wentz and Joseph H Wentz."
      },
      {
        "title": "Joseph H Wentz, \"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QBN3-LJQ",
        "citation": "\"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6K9G-4PHY : Sat Jul 04 00:47:57 UTC 2026), Entry for Daniel Augusta Wentz and Joseph H Wentz."
      },
      {
        "title": "Joseph H. Wentz, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/332L-VYD",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVLB-MG5L : Sun Oct 04 13:31:55 UTC 2026), Entry for Joseph H. Wentz."
      },
      {
        "title": "Joseph Wentz, \"Pennsylvania, County Marriages, 1775-1991\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/332L-VZ7",
        "citation": "\"Pennsylvania, County Marriages, 1775-1991\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VFW6-NP7 : Fri May 08 00:53:48 UTC 2026), Entry for Henry Curtin Feathers and Lilly Florence Wentz, 17 March 1907."
      },
      {
        "title": "Joseph Wentz in entry for Henry Curtin Feathers, \"Pennsylvania, Marriages, 1709-1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/332L-JJ7",
        "citation": "\"Pennsylvania, Marriages, 1709-1940\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:H52S-MHPZ : 7 May 2023), Joseph Wentz in entry for Henry Curtin Feathers, 1907."
      },
      {
        "title": "Joseph Wentz, \"Pennsylvania, County Marriages, 1775-1991\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3MGM-N1J",
        "citation": "\"Pennsylvania, County Marriages, 1775-1991\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VFSP-KM1 : Fri May 08 00:44:08 UTC 2026), Entry for Emanuel Albright and Leah Ellen Wentz, 25 April 1908."
      },
      {
        "title": "Joseph Wentz, \"United States, Census, 1900\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3ML1-YNV",
        "citation": "\"United States, Census, 1900\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M3MV-Y4F : Thu Jan 01 23:13:00 UTC 2026), Entry for Joseph Wentz and Dorothy Wentz, 1900."
      },
      {
        "title": "Joseph Wentz in entry for John B. Mock, \"Pennsylvania, Marriages, 1709-1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SRM7-892",
        "citation": "\"Pennsylvania, Marriages, 1709-1940\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:H52S-9MN2 : 7 May 2023), Joseph Wentz in entry for John B. Mock, 1910."
      },
      {
        "title": "Household of David Wentz, \"United States, Census, 1870\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SG9V-RBQ",
        "citation": "\"United States, Census, 1870\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MZLN-LKJ : Sat Oct 18 07:39:19 UTC 2025), Entry for Daniel Wentz, 1870."
      },
      {
        "title": "Joseph H Wentz, \"United States, Census, 1850\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SXLK-ZSC",
        "citation": "\"United States, Census, 1850\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M44J-8GY : Tue Oct 21 03:28:32 UTC 2025), Entry for Saml Wentz and Elizabeth Wentz, 1850."
      },
      {
        "title": "Joseph Wentz, \"Pennsylvania, County Marriages, 1775-1991\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SH7F-JKZ",
        "citation": "\"Pennsylvania, County Marriages, 1775-1991\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VF3C-JH6 : Fri May 08 00:38:53 UTC 2026), Entry for William I. Wentz and Maud Albright, 18 July 1901."
      },
      {
        "title": "Joseph Wentz, \"Pennsylvania, County Marriages, 1775-1991\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9R1H-LXS",
        "citation": "\"Pennsylvania, County Marriages, 1775-1991\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VFWX-9Z3 : Fri May 08 00:54:20 UTC 2026), Entry for John B. Mock and Anna Wentz, 27 March 1910."
      },
      {
        "title": "Joseph H Wentz, \"United States Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9LSX-TB9",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MW6Y-3B5 : Wed Sep 09 02:26:45 UTC 2026), Entry for Joseph H. Wentz and Dorothy Wentz, 1880."
      },
      {
        "title": "Joseph Wentz in entry for James E. Shade and Harriet C. Wentz, \"Pennsylvania Marriages, 1709-1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9LSX-TGT",
        "citation": "\"Pennsylvania, Marriages, 1709-1940\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:V2X6-6BN : 7 May 2023), Joseph Wentz in entry for James E. Shade, 1895."
      },
      {
        "title": "Joseph Wentz in entry for James E. Shade and Harriet C. Wentz, \"Pennsylvania, County Marriages, 1885-1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9LSX-TQC",
        "citation": "\"Pennsylvania, County Marriages, 1775-1991\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VFMG-P24 : Thu May 07 23:09:53 UTC 2026), Entry for James E. Shade and Harriet C. Wentz, 3 March 1895."
      },
      {
        "title": "Joseph H. Wentz, \"Pennsylvania, County Marriages, 1885-1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9V3T-RR9",
        "citation": "\"Pennsylvania, County Marriages, 1775-1991\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VFMP-69G : Fri May 08 00:23:36 UTC 2026), Entry for Joseph H. Wentz and Amelia Boyer, 23 October 1902."
      },
      {
        "title": "Joseph H. Wentz, \"Pennsylvania, Marriages, 1709-1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MDR1-NMG",
        "citation": "\"Pennsylvania, Marriages, 1709-1940\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:V2D1-K7Z : 7 May 2023), Joseph H. Wentz, 1902."
      }
    ]
  },
  {
    "id": "I112",
    "name": "Daniel Augusta Wentz",
    "sex": "M",
    "gen": 6,
    "slot": 52,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I40",
    "birthYear": 1809,
    "deathYear": 1893,
    "birthDate": "17 Aug 1809",
    "deathDate": "13 Aug 1893",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Bedford, Pennsylvania, United States",
    "deathPlace": "Union Twp, Bedford, Pennsylvania",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "KHCM-3RV",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [
      {
        "kind": "Residence",
        "date": "1850",
        "place": "Pavia Township, Bedford, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1870",
        "place": "Pavia Township, Bedford, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1880",
        "place": "King, Kimmel Township, Bedford, Pennsylvania, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Daniel Wentz, \"United States, Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MS1X-FZF",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MW6Y-31M : Wed Sep 09 02:26:46 UTC 2026), Entry for Daniel Wentz and Elizabeth Wentz, 1880."
      },
      {
        "title": "Saml Wentz, \"United States, Census, 1850\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SGSD-X6Q",
        "citation": "\"United States, Census, 1850\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M44J-8GY : Tue Oct 21 03:28:32 UTC 2025), Entry for Saml Wentz and Elizabeth Wentz, 1850."
      },
      {
        "title": "Daniel Wentz in entry for Joseph H. Wentz and Amelia Boyer, \"Pennsylvania, County Marriages, 1885-1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9V3T-RGR",
        "citation": "\"Pennsylvania, County Marriages, 1775-1991\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VFMP-69G : Fri May 08 00:23:36 UTC 2026), Entry for Joseph H. Wentz and Amelia Boyer, 23 October 1902."
      },
      {
        "title": "David Wentz, \"United States, Census, 1870\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SG9V-RF7",
        "citation": "\"United States, Census, 1870\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MZLN-LKJ : Sat Oct 18 07:39:19 UTC 2025), Entry for Daniel Wentz, 1870."
      },
      {
        "title": "Daniel Wentz, \"Pennsylvania, County Marriages, 1775-1991\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SYBZ-GYQ",
        "citation": "\"Pennsylvania, County Marriages, 1775-1991\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VFMG-4PB : Thu May 07 23:03:56 UTC 2026), Entry for Daniel Feather and Catherine Wentz, 2 February 1888."
      },
      {
        "title": "Daniel Wentz in entry for Joseph H. Wentz, \"Pennsylvania, Marriages, 1709-1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9NHY-4QM",
        "citation": "\"Pennsylvania, Marriages, 1709-1940\", , FamilySearch (https://www.familysearch.org/ark:/61903/1:1:V2D1-K7H : 7 May 2023), Daniel Wentz in entry for Joseph H. Wentz, 1902."
      }
    ]
  },
  {
    "id": "I113",
    "name": "Elizabeth Ickes",
    "sex": "F",
    "gen": 6,
    "slot": 53,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I40",
    "birthYear": 1813,
    "deathYear": 1884,
    "birthDate": "5 Mar 1813",
    "deathDate": "24 Sep 1884",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Pennsylvania, United States",
    "deathPlace": "Bedford Township, Bedford, Pennsylvania, British Colonial America",
    "burialPlace": "Imler Saint Paul Brethren Cemetery, Imler, Bedford, Pennsylvania, United States of America",
    "christeningPlace": null,
    "fsId": "9681-H7B",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [
      {
        "kind": "Residence",
        "date": "1850",
        "place": "Pavia Township, Bedford, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1870",
        "place": "Pavia Township, Bedford, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1880",
        "place": "King, Kimmel Township, Bedford, Pennsylvania, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Household of David Wentz, \"United States, Census, 1870\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SG9V-RG5",
        "citation": "\"United States, Census, 1870\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MZLN-LKJ : Sat Oct 18 07:39:19 UTC 2025), Entry for Daniel Wentz, 1870."
      },
      {
        "title": "Elizabeth Wentz, \"Pennsylvania, Philadelphia, Historical Society of Pennsylvania, Births and Baptisms, 1520-1999\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QQ6N-BNX",
        "citation": "\"Pennsylvania, Philadelphia, Historical Society of Pennsylvania, Births and Baptisms, 1520-1999\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CTB-31J5 : Fri Jul 19 08:26:16 UTC 2024), Entry for Elizabeth Wentz, 3 May 1813."
      },
      {
        "title": "Elizabeth Wentz in entry for Joseph H. Wentz, \"Pennsylvania, Marriages, 1709-1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9NHY-4QX",
        "citation": "\"Pennsylvania, Marriages, 1709-1940\", , FamilySearch (https://www.familysearch.org/ark:/61903/1:1:V2D1-K7C : 7 May 2023), Elizabeth Wentz in entry for Joseph H. Wentz, 1902."
      },
      {
        "title": "Elizabeth Wentz, \"United States, Census, 1850\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SXLK-CVY",
        "citation": "\"United States, Census, 1850\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M44J-8GY : Tue Oct 21 03:28:32 UTC 2025), Entry for Saml Wentz and Elizabeth Wentz, 1850."
      },
      {
        "title": "Elizabeth, \"Pennsylvania, County Marriages, 1775-1991\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SYBZ-PSM",
        "citation": "\"Pennsylvania, County Marriages, 1775-1991\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VFMG-4PB : Thu May 07 23:03:56 UTC 2026), Entry for Daniel Feather and Catherine Wentz, 2 February 1888."
      },
      {
        "title": "Elizabeth Wentz, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3257-GLN",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVV4-WSL5 : Sat Oct 03 22:45:57 UTC 2026), Entry for Elizabeth Wentz, 1884."
      },
      {
        "title": "Elizabeth Wentz, \"Pennsylvania, Philadelphia, Historical Society of Pennsylvania, Deaths and Burials, 1627-1972\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QQ6N-BWG",
        "citation": "\"Pennsylvania, Philadelphia, Historical Society of Pennsylvania, Deaths and Burials, 1627-1972\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CYD-L8TN : Fri Jul 19 08:49:41 UTC 2024), Entry for Elizabeth Wentz, 1884."
      },
      {
        "title": "Elizabeth Ickes Wentz, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SXLK-45N",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QV2T-MD8G : Fri Oct 02 10:44:54 UTC 2026), Entry for Elizabeth Ickes Wentz."
      },
      {
        "title": "Elizabeth Wentz, \"United States, Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MS1X-FDL",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MW6Y-31M : Wed Sep 09 02:26:46 UTC 2026), Entry for Daniel Wentz and Elizabeth Wentz, 1880."
      },
      {
        "title": "Elizabeth Wentz in entry for Joseph H. Wentz and Amelia Boyer, \"Pennsylvania, County Marriages, 1885-1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9V3T-R59",
        "citation": "\"Pennsylvania, County Marriages, 1775-1991\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VFMP-69G : Fri May 08 00:23:36 UTC 2026), Entry for Joseph H. Wentz and Amelia Boyer, 23 October 1902."
      }
    ]
  },
  {
    "id": "I35",
    "name": "Dorothy C. Oldham",
    "sex": "F",
    "gen": 5,
    "slot": 27,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I16",
    "birthYear": 1848,
    "deathYear": 1901,
    "birthDate": "Dec 1848",
    "deathDate": "25 Apr 1901",
    "burialDate": "1901",
    "christeningDate": null,
    "birthPlace": "Pavia Township, Bedford, Pennsylvania, United States",
    "deathPlace": "Bakers Summit, Bloomfield Township, Bedford, Pennsylvania, United States",
    "burialPlace": "Holsinger Cemetery, Bakers Summit, Bloomfield Township, Bedford, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "943T-5JN",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [
      {
        "kind": "Residence",
        "date": "1850",
        "place": "Pavia Township, Bedford, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1860",
        "place": "Pavia Township, Bedford, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1870",
        "place": "Pavia Township, Bedford, Pennsylvania, United States",
        "note": "Census"
      },
      {
        "kind": "Residence",
        "date": "1880",
        "place": "King, Kimmel Township, Bedford, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1900",
        "place": "Bloomfield Township, Bedford, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "MOTHER OF 11 CHILDREN/8 LIVING AS OF 1900",
        "date": null,
        "place": null,
        "note": "See her statement in the 1900 Census."
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "1870 United States Federal Census",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3TDN-3ZM",
        "citation": "Year: 1870; Census Place: Union, Bedford, Pennsylvania; Roll: M593_1304; Page: 698B"
      },
      {
        "title": "Dorothy Oldham, \"United States, Census, 1850\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SKLR-GKJ",
        "citation": "\"United States, Census, 1850\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M44J-GX6 : Tue Oct 21 02:47:57 UTC 2025), Entry for Thomas Oldham and Mary Ann Oldham, 1850."
      },
      {
        "title": "Dorothy Wentz, \"United States, Census, 1900\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3ML1-YPD",
        "citation": "\"United States, Census, 1900\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M3MV-Y4F : Thu Jan 01 23:13:00 UTC 2026), Entry for Joseph Wentz and Dorothy Wentz, 1900."
      },
      {
        "title": "Dorothy C. Oldham Wentz, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/332P-WXH",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVLB-MG52 : Fri Oct 02 21:53:16 UTC 2026), Entry for Dorothy C. Oldham Wentz."
      },
      {
        "title": "Dorothy C Oldham, \"United States, Census, 1860\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/332P-WGV",
        "citation": "\"United States, Census, 1860\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MXPX-8TC : Mon Jul 08 19:32:47 UTC 2024), Entry for Thomas Oldham and Mary Ann Oldham, 1860."
      },
      {
        "title": "Dorothy Oldham, \"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/77PJ-7W9",
        "citation": "\"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6K4K-7S71 : Sun Jul 05 12:15:48 UTC 2026), Entry for William Isaac Wentz and Joseph H Wentz."
      },
      {
        "title": "Dorthy C Oldham, \"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QBN3-L6K",
        "citation": "\"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6K9G-4PHY : Sat Jul 04 00:47:57 UTC 2026), Entry for Daniel Augusta Wentz and Joseph H Wentz."
      },
      {
        "title": "Wentz in entry for James E. Shade and Harriet C. Wentz, \"Pennsylvania Marriages, 1709-1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9LSX-TG8",
        "citation": "\"Pennsylvania, Marriages, 1709-1940\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:V2X6-6BJ : 7 May 2023), Wentz in entry for James E. Shade, 1895."
      },
      {
        "title": "Dorothy, \"Pennsylvania, County Marriages, 1775-1991\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SH7F-JL9",
        "citation": "\"Pennsylvania, County Marriages, 1775-1991\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VF3C-JH6 : Fri May 08 00:38:53 UTC 2026), Entry for William I. Wentz and Maud Albright, 18 July 1901."
      },
      {
        "title": "Wentz in entry for James E. Shade and Harriet C. Wentz, \"Pennsylvania, County Marriages, 1885-1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9LSX-TQ5",
        "citation": "\"Pennsylvania, County Marriages, 1775-1991\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VFMG-P24 : Thu May 07 23:09:53 UTC 2026), Entry for James E. Shade and Harriet C. Wentz, 3 March 1895."
      },
      {
        "title": "Dorothy Wentz in household of Joseph H Wentz, \"United States Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9LSX-TB2",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MW6Y-3B5 : Wed Sep 09 02:26:45 UTC 2026), Entry for Joseph H. Wentz and Dorothy Wentz, 1880."
      },
      {
        "title": "Dorothy Wentz, \"Pennsylvania, County Marriages, 1775-1991\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9R1H-LXZ",
        "citation": "\"Pennsylvania, County Marriages, 1775-1991\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VFWX-9Z3 : Fri May 08 00:54:20 UTC 2026), Entry for John B. Mock and Anna Wentz, 27 March 1910."
      },
      {
        "title": "Dorothy Oldham, \"United States, Census, 1870\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SG9J-9Z2",
        "citation": "\"United States, Census, 1870\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MZLJ-FRV : Fri Oct 17 11:02:42 UTC 2025), Entry for Mary Oldham and Dorothy Oldham, 1870."
      },
      {
        "title": "Dorothy Wentz in entry for John B. Mock, \"Pennsylvania, Marriages, 1709-1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SRM7-875",
        "citation": "\"Pennsylvania, Marriages, 1709-1940\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:H52S-9M2M : 7 May 2023), Dorothy Wentz in entry for John B. Mock, 1910."
      }
    ]
  },
  {
    "id": "I93",
    "name": "Thomas Oldham",
    "sex": "M",
    "gen": 6,
    "slot": 54,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I35",
    "birthYear": 1824,
    "deathYear": 1868,
    "birthDate": "Abt 1824",
    "deathDate": "1868",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Fishertown, East Saint Clair Township, Bedford, Pennsylvania, United States",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "L4MY-1CD",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [
      {
        "kind": "Residence",
        "date": "1850",
        "place": "Pavia Township, Bedford, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1860",
        "place": "Union Township, Bedford, Pennsylvania, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "T Oldham, \"Pennsylvania, Philadelphia, Historical Society of Pennsylvania, Births and Baptisms, 1520-1999\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3TDN-JVY",
        "citation": "\"Pennsylvania, Philadelphia, Historical Society of Pennsylvania, Births and Baptisms, 1520-1999\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CT5-11PK : Sat Jan 11 01:07:30 UTC 2025), Entry for Thomas V Oldham and T Oldham, 12 May 1854."
      },
      {
        "title": "Pennsylvania, U.S., Death Certificates, 1906-1968",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3TDN-S31",
        "citation": ""
      },
      {
        "title": "Thomas Oldham, \"United States, Census, 1860\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3TCM-8F4",
        "citation": "\"United States, Census, 1860\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MXPX-8TC : Mon Jul 08 19:32:47 UTC 2024), Entry for Thomas Oldham and Mary Ann Oldham, 1860."
      },
      {
        "title": "Thomas Oldham, \"United States, Census, 1850\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SKLR-G43",
        "citation": "\"United States, Census, 1850\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M44J-GX6 : Tue Oct 21 02:47:57 UTC 2025), Entry for Thomas Oldham and Mary Ann Oldham, 1850."
      },
      {
        "title": "Thomas Oldham in entry for William Stewart, \"Pennsylvania, Marriages, 1709-1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SQQH-LKQ",
        "citation": "\"Pennsylvania, Marriages, 1709-1940\", , FamilySearch (https://www.familysearch.org/ark:/61903/1:1:V2X6-CNM : 7 May 2023), Thomas Oldham in entry for William Stewart, 1902."
      },
      {
        "title": "Thomas Oldham, \"Pennsylvania, County Marriages, 1775-1991\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SSM2-NJS",
        "citation": "\"Pennsylvania, County Marriages, 1775-1991\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VFMG-TJ1 : Thu May 07 23:05:08 UTC 2026), Entry for William Stewart and Emma Jane Oldham, 27 March 1902."
      },
      {
        "title": "Thomas Oldham, \"Pennsylvania, County Marriages, 1775-1991\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/915R-W4G",
        "citation": "\"Pennsylvania, County Marriages, 1775-1991\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VF3Z-TFJ : Thu May 07 23:18:12 UTC 2026), Entry for William Stewart and Emma Jane Oldham, 13 June 1902."
      },
      {
        "title": "Thomas Oldham, \"Pennsylvania, County Marriages, 1775-1991\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/915R-7FH",
        "citation": "\"Pennsylvania, County Marriages, 1775-1991\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VF3Z-TFJ : Thu May 07 23:18:12 UTC 2026), Entry for William Stewart and Emma Jane Oldham, 13 June 1902."
      }
    ]
  },
  {
    "id": "I97",
    "name": "Mary Ann Stufft",
    "sex": "F",
    "gen": 6,
    "slot": 55,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I35",
    "birthYear": 1826,
    "deathYear": 1900,
    "birthDate": "Aug 1826",
    "deathDate": "20 Dec 1900",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Bedford, Pennsylvania, United States",
    "deathPlace": "Bedford, Pennsylvania, United States",
    "burialPlace": "Holsinger Cemetery, Bloomfield Township, Bedford, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "L7LV-YGY",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Mary Ann"
    ],
    "facts": [
      {
        "kind": "Residence",
        "date": "1850",
        "place": "Pavia Township, Bedford, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1860",
        "place": "Pavia Township, Bedford, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1860",
        "place": "Pulaski Township, Beaver, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1870",
        "place": "Pavia Township, Bedford, Pennsylvania, United States",
        "note": "Census"
      },
      {
        "kind": "Residence",
        "date": "1870",
        "place": "Pulaski Township, Beaver, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1880",
        "place": "Bloomfield Township, Bedford, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "CENSUS",
        "date": "1880",
        "place": "Bloomfield Township, Bedford, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1900",
        "place": "Blomfield Township, Bedford, Pennsylvania, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Mary Ann Stufft Oldham, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/W9BN-47K",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVVG-77X4 : Sun Oct 04 09:08:22 UTC 2026), Entry for Mary Ann Stufft Oldham."
      },
      {
        "title": "M A Oldham, \"Pennsylvania, Philadelphia, Historical Society of Pennsylvania, Births and Baptisms, 1520-1999\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3TDN-JV9",
        "citation": "\"Pennsylvania, Philadelphia, Historical Society of Pennsylvania, Births and Baptisms, 1520-1999\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CT5-11PK : Sat Jan 11 01:07:30 UTC 2025), Entry for Thomas V Oldham and T Oldham, 12 May 1854."
      },
      {
        "title": "Pennsylvania and New Jersey, U.S., Church and Town Records, 1669-2013",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3TDN-X2S",
        "citation": ""
      },
      {
        "title": "Mary Croft, \"Pennsylvania, County Marriages, 1775-1991\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3TDN-DHX",
        "citation": "\"Pennsylvania, County Marriages, 1775-1991\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VFWX-ZY4 : Fri May 08 00:53:55 UTC 2026), Entry for Henry Sturgeon and Charlotte Croft, 15 August 1908."
      },
      {
        "title": "Mary Croft in entry for Henry Sturgeon, \"Pennsylvania, Marriages, 1709-1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3TDN-817",
        "citation": "\"Pennsylvania, Marriages, 1709-1940\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:H52M-2XW2 : 7 May 2023), Mary Croft in entry for Henry Sturgeon, 1908."
      },
      {
        "title": "1870 United States Federal Census",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3TDN-MVP",
        "citation": ""
      },
      {
        "title": "Pennsylvania, U.S., Death Certificates, 1906-1968",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3TDN-MV2",
        "citation": ""
      },
      {
        "title": "Mary A Croft, \"United States, Census, 1900\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3GVY-9B1",
        "citation": "\"United States, Census, 1900\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M3MV-R3C : Thu Oct 23 02:04:23 UTC 2025), Entry for George S Croft and Mary A Croft, 1900."
      },
      {
        "title": "Rachael Oldham, \"United States, Census, 1870\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3F77-K4J",
        "citation": "\"United States, Census, 1870\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MZLX-L7J : Thu Oct 23 03:05:41 UTC 2025), Entry for James Oldham and Rachael Oldham, 1870."
      },
      {
        "title": "Mary An Croft, \"United States, Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3F77-J5T",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MW6T-K3Y : Wed Sep 09 02:23:13 UTC 2026), Entry for George Croft and Mary An Croft, 1880."
      },
      {
        "title": "Rachel Oldham, \"United States, Census, 1860\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3F77-NBG",
        "citation": "\"United States, Census, 1860\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MXP9-WLX : Mon Jul 08 21:31:44 UTC 2024), Entry for James Oldham and Rachel Oldham, 1860."
      },
      {
        "title": "Mary Oldham, \"United States, Census, 1870\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SG9J-9WB",
        "citation": "\"United States, Census, 1870\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MZLJ-FRV : Fri Oct 17 11:02:42 UTC 2025), Entry for Mary Oldham and Dorothy Oldham, 1870."
      },
      {
        "title": "Mary Ann Oldham, \"United States, Census, 1850\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SKLR-GXN",
        "citation": "\"United States, Census, 1850\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M44J-GX6 : Tue Oct 21 02:47:57 UTC 2025), Entry for Thomas Oldham and Mary Ann Oldham, 1850."
      },
      {
        "title": "Mary Ann Oldham, \"United States, Census, 1860\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9BVB-RGP",
        "citation": "\"United States, Census, 1860\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MXPX-8TC : Mon Jul 08 19:32:47 UTC 2024), Entry for Thomas Oldham and Mary Ann Oldham, 1860."
      },
      {
        "title": "Mary Ann Oldham in entry for William Stewart, \"Pennsylvania, Marriages, 1709-1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9BVT-Y6N",
        "citation": "\"Pennsylvania, Marriages, 1709-1940\", , FamilySearch (https://www.familysearch.org/ark:/61903/1:1:V2X6-CN9 : 7 May 2023), Mary Ann Oldham in entry for William Stewart, 1902."
      },
      {
        "title": "Mary Ann, \"Pennsylvania, County Marriages, 1775-1991\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9BVT-F6L",
        "citation": "\"Pennsylvania, County Marriages, 1775-1991\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VF3Z-TFJ : Thu May 07 23:18:12 UTC 2026), Entry for William Stewart and Emma Jane Oldham, 13 June 1902."
      },
      {
        "title": "Mary Ann Oldham, \"Pennsylvania, County Marriages, 1775-1991\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9BVT-D6T",
        "citation": "\"Pennsylvania, County Marriages, 1775-1991\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VFMG-TJ1 : Thu May 07 23:05:08 UTC 2026), Entry for William Stewart and Emma Jane Oldham, 27 March 1902."
      }
    ]
  },
  {
    "id": "I8",
    "name": "Wilma Grace Guyer",
    "sex": "F",
    "gen": 3,
    "slot": 7,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I4",
    "birthYear": 1915,
    "deathYear": 1997,
    "birthDate": "22 Mar 1915",
    "deathDate": "11 Jan 1997",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Altoona, Blair, Pennsylvania, United States",
    "deathPlace": "Martinsburg, Blair, Pennsylvania, United States",
    "burialPlace": "Woodbury, Bedford, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LZNB-PKR",
    "photo": "/ancestors/bubbles/015_LZNB-PKR.jpg",
    "living": false,
    "alternateNames": [
      "Wilma Guyer"
    ],
    "facts": [
      {
        "kind": "Residence",
        "date": "1920",
        "place": "King, Kimmel Township, Bedford, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1930",
        "place": "Woodbury Township, Blair, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1935",
        "place": "Blair, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Social Program Application",
        "date": "November 1936",
        "place": null,
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1940",
        "place": "Martinsburg, Blair, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Previous Residence",
        "date": null,
        "place": "Martinsburg, Blair, Pennsylvania, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Wilma G Mock, \"United States, Census, 1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7T6M-K13",
        "citation": "\"United States, Census, 1950\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6XB5-7WMR : Wed Mar 20 00:45:37 UTC 2024), Entry for Chalmer C Mock and Wilma G Mock, 3 April 1950."
      },
      {
        "title": "Wilma Grace Mock, \"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QC8M-DY7",
        "citation": "\"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6K95-RBS1 : Sun Jul 05 18:44:47 UTC 2026), Entry for Wilma G Mock and Howard Guyer."
      },
      {
        "title": "Wilma Mack, \"United States, Census, 1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SG8Y-YVR",
        "citation": "\"United States, Census, 1940\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KQ41-21D : Tue Jan 21 06:00:15 UTC 2025), Entry for Chalmer Mack and Wilma Mack, 1940."
      },
      {
        "title": "Wilma Mack, \"United States, Census, 1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SD82-2QL",
        "citation": "\"United States, Census, 1940\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KQ41-2BS : Wed Jan 22 05:06:33 UTC 2025), Entry for Chalmer Mack and Wilma Mack, 1940."
      },
      {
        "title": "Wilma Guyer, \"Virginia, Marriage Certificates, 1936-1989\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SD82-VTS",
        "citation": "\"Virginia, Marriage Certificates, 1936-1989\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVYR-22XR : Fri May 01 19:59:09 UTC 2026), Entry for Chalmer Ardean Mock and Chalmer C Mock, 21 Oct 1974."
      },
      {
        "title": "Wilma G Mock, \"United States, Social Security Death Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SMZY-VKS",
        "citation": "\"United States, Social Security Death Index,\" database, FamilySearch (https://familysearch.org/ark:/61903/1:1:VMTZ-J4M : 8 January 2021), Wilma G Mock, 11 Jan 1997; citing U.S. Social Security Administration, Death Master File, database (Alexandria, Virginia: National Technical Information Service, ongoing)."
      },
      {
        "title": "Wilma Grace Guyer Mock, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SMZY-J2Z",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVGF-7VN7 : Fri Oct 02 07:00:24 UTC 2026), Entry for Wilma Grace Guyer Mock, 1997."
      },
      {
        "title": "Wilma Guyer, \"United States, Census, 1930\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9NVZ-WBW",
        "citation": "\"United States, Census, 1930\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XCHW-VZ2 : Thu Mar 07 16:31:55 UTC 2024), Entry for Howard Guyer and Ada Guyer, 1930."
      },
      {
        "title": "Wilma Guyer, \"United States, Census, 1920\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9NVZ-W43",
        "citation": "\"United States, Census, 1920\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MNM4-42R : Sun Sep 27 15:35:59 UTC 2026), Entry for Howard Guyer and Ada Guyer, 1920."
      }
    ],
    "portrait": "/ancestors/portraits/015_LZNB-PKR.jpg"
  },
  {
    "id": "I15",
    "name": "Joseph Howard Guyer",
    "sex": "M",
    "gen": 4,
    "slot": 14,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I8",
    "birthYear": 1890,
    "deathYear": 1963,
    "birthDate": "19 Jul 1890",
    "deathDate": "11 Apr 1963",
    "burialDate": "1963",
    "christeningDate": null,
    "birthPlace": "Martinsburg, Blair, Pennsylvania, United States",
    "deathPlace": "Curryville,  Pennsylvania, United States",
    "burialPlace": "Woodbury, Bedford, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "KZ1R-3QD",
    "photo": "/ancestors/bubbles/030_KZ1R-3QD.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [
      {
        "kind": "Residence",
        "date": "1900",
        "place": "Woodbury Township, Bedford, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1910",
        "place": "Woodbury, Bedford, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1920",
        "place": "King, Kimmel Township, Bedford, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1930",
        "place": "Woodbury Township, Blair, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1935",
        "place": "Same House",
        "note": null
      },
      {
        "kind": "Social Program Application",
        "date": "April 1937",
        "place": null,
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1940",
        "place": "North Woodbury Township, Blair, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Military Draft Registration",
        "date": "1942",
        "place": "Blair, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": null,
        "place": "Blair, Pennsylvania, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Howard S Guyer, \"United States, Census, 1900\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SZBH-NDG",
        "citation": "\"United States, Census, 1900\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M3M2-H1R : Tue Feb 04 20:04:08 UTC 2025), Entry for Joseph B Guyer and Rosanna Guyer, 1900."
      },
      {
        "title": "Howard Guyer, \"Pennsylvania, World War II Draft Registration Cards, 1940-1945\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7Q86-Y2Q",
        "citation": "\"Pennsylvania, World War II Draft Registration Cards, 1940-1945\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q29Z-DFH6 : Fri Feb 23 18:22:10 UTC 2024), Entry for Chester Paul Guyer and Howard Guyer, 16 Oct 1940."
      },
      {
        "title": "Howard Guyer, \"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QPWX-769",
        "citation": "\"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6K4K-WQVQ : Sun Jul 05 11:12:08 UTC 2026), Entry for Howard Guyer and Josiah Guyer."
      },
      {
        "title": "Howard Guyer, \"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QC8M-6N7",
        "citation": "\"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6K3D-46PG : Tue Jul 07 02:06:51 UTC 2026), Entry for Edward J Guyer and Howard Guyer."
      },
      {
        "title": "Howard Guyer, \"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QC8M-6W9",
        "citation": "\"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6K92-V8Y8 : Sat Jul 04 04:35:27 UTC 2026), Entry for Chester Paul Guyer and Howard Guyer."
      },
      {
        "title": "Howard Guyer, \"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QC8M-D1T",
        "citation": "\"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6K95-RBS1 : Sun Jul 05 18:44:47 UTC 2026), Entry for Wilma G Mock and Howard Guyer."
      },
      {
        "title": "Howard Guyer, \"United States, Census, 1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SMZY-PYW",
        "citation": "\"United States, Census, 1940\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KQ41-GCT : Sun Jan 19 21:06:09 UTC 2025), Entry for Howard Guyer and Ida R Guyer, 1940."
      },
      {
        "title": "Howard Guyer, \"United States, World War II Draft Registration Cards, 1942\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SMZY-PPJ",
        "citation": "\"United States, World War II Draft Registration Cards, 1942\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VQFG-Z29 : Mon Mar 30 05:56:37 UTC 2026), Entry for Howard Guyer, 1942."
      },
      {
        "title": "Howard Guyer, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SMZY-GF2",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVGF-7VFV : Sun Oct 04 10:05:53 UTC 2026), Entry for Howard Guyer, 1963."
      },
      {
        "title": "Howard Guyer, \"United States, Census, 1930\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9NVZ-WT4",
        "citation": "\"United States, Census, 1930\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XCHW-VZ2 : Thu Mar 07 16:31:55 UTC 2024), Entry for Howard Guyer and Ada Guyer, 1930."
      },
      {
        "title": "Howard Guyer, \"United States, Census, 1920\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9NVZ-W3R",
        "citation": "\"United States, Census, 1920\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MNM4-42R : Sun Sep 27 15:35:59 UTC 2026), Entry for Howard Guyer and Ada Guyer, 1920."
      },
      {
        "title": "Howard Guyer, \"United States, Census, 1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9NVC-BD8",
        "citation": "\"United States, Census, 1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MG3S-38N : Wed Aug 13 17:21:51 UTC 2025), Entry for Josiah B Guyer and Rosan Guyer, 1910."
      }
    ],
    "portrait": "/ancestors/portraits/030_KZ1R-3QD.jpg"
  },
  {
    "id": "I28",
    "name": "Josiah K. Guyer",
    "sex": "M",
    "gen": 5,
    "slot": 28,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I15",
    "birthYear": 1851,
    "deathYear": 1932,
    "birthDate": "22 Nov 1851",
    "deathDate": "1 Jan 1932",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Woodbury, Bedford, Pennsylvania, United States",
    "deathPlace": "Woodbury, Bedford, Pennsylvania, United States",
    "burialPlace": "Replogle Cemetery, Woodbury, Bedford, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "KGS8-462",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Josiah Guyer"
    ],
    "facts": [
      {
        "kind": "Residence",
        "date": "1880",
        "place": "Huston Township, Blair, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1900",
        "place": "Woodbury Township, Bedford, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1910",
        "place": "Woodbury, Bedford, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1920",
        "place": "Woodbury, Bedford, Pennsylvania, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Joseph B Guyer, \"United States, Census, 1900\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SZBH-FXK",
        "citation": "\"United States, Census, 1900\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M3M2-H1R : Tue Feb 04 20:04:08 UTC 2025), Entry for Joseph B Guyer and Rosanna Guyer, 1900."
      },
      {
        "title": "Josiah K. Guyer, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7Q8F-J5Z",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVKM-3N3N : Fri Oct 02 11:09:36 UTC 2026), Entry for Josiah K. Guyer."
      },
      {
        "title": "Josiah Guzer, \"United States, Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7MH3-M29",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MWXQ-8ZF : Wed Sep 09 02:47:09 UTC 2026), Entry for Josiah Guzer and Rosanna Guzer, 1880."
      },
      {
        "title": "Joseph B Guyer, \"Idaho, Death Certificates, 1938-1961\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7MHS-1BT",
        "citation": "\"Idaho, Death Certificates, 1938-1961\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2M1-PL12 : Fri Feb 21 22:38:15 UTC 2025), Entry for Charles David Guyer and Joseph B Guyer, 1 Apr 1952."
      },
      {
        "title": "Josiah Guyer, \"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QPWX-QM2",
        "citation": "\"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6K4K-WQVQ : Sun Jul 05 11:12:08 UTC 2026), Entry for Howard Guyer and Josiah Guyer."
      },
      {
        "title": "Josiah B Guyer, \"Pennsylvania, Delayed Birth Records, 1780-1977\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q8HF-ST5",
        "citation": "\"Pennsylvania, Delayed Birth Records, 1780-1977\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:88JX-1K3Z : Mon Jan 20 16:20:08 UTC 2025), Entry for Eldon S Guyer and Josiah B Guyer, 17 Oct."
      },
      {
        "title": "Josiah B Guyer, \"Pennsylvania, Delayed Birth Records, 1780-1977\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q8HF-95R",
        "citation": "\"Pennsylvania, Delayed Birth Records, 1780-1977\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Z3J-99MF : Mon Jan 20 08:31:57 UTC 2025), Entry for Eldon S Guyer and Josiah B Guyer, 17 Oct 1895."
      },
      {
        "title": "Josiah B Guyer, \"Pennsylvania, Delayed Birth Records, 1780-1977\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q8HF-94V",
        "citation": "\"Pennsylvania, Delayed Birth Records, 1780-1977\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Z3J-99MD : Sun Jan 12 13:55:24 UTC 2025), Entry for Eldon S. Guyer and Josiah B Guyer, 17 Oct 1895."
      },
      {
        "title": "Joseph B Guyer, \"Pennsylvania, Delayed Birth Records, 1780-1977\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/36T6-BHC",
        "citation": "\"Pennsylvania, Delayed Birth Records, 1780-1977\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:ZR9M-3M6Z : Mon Jan 13 09:51:00 UTC 2025), Entry for Trester S Guyer and Joseph B Guyer, 2 Aug 1900."
      },
      {
        "title": "Josiah B Guyer in entry for Truster S Guyer, \"Pennsylvania, Births and Christenings, 1709-1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SPBL-S1P",
        "citation": "\"Pennsylvania, Births and Christenings, 1709-1950\", database, FamilySearch (https://familysearch.org/ark:/61903/1:1:HFDS-2HT2 : 15 February 2020), Josiah B Guyer in entry for Truster S Guyer, 1900."
      },
      {
        "title": "J. B. Guyer, \"Pennsylvania, County Marriages, 1775-1991\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9NVZ-HWJ",
        "citation": "\"Pennsylvania, County Marriages, 1775-1991\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VF3G-15C : Thu May 07 23:20:08 UTC 2026), Entry for Eldon S. Guyer and Sarah Elizabeth Ritchey, 20 February 1915."
      },
      {
        "title": "J. B. Guyer, \"Pennsylvania, County Marriages, 1775-1991\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9NVC-1JS",
        "citation": "\"Pennsylvania, County Marriages, 1775-1991\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VF3G-ZXL : Fri May 08 00:41:33 UTC 2026), Entry for Joseph Frederick and Margaret A. Guyer, 1 February 1900."
      },
      {
        "title": "Josiah B Guyer, \"United States, Census, 1920\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9NVC-19Z",
        "citation": "\"United States, Census, 1920\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MNM4-KXN : Sun Sep 27 15:36:56 UTC 2026), Entry for Josiah B Guyer and Rosannia Guyer, 1920."
      },
      {
        "title": "Josiah B Guyer, \"United States, Census, 1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9NVC-BCY",
        "citation": "\"United States, Census, 1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MG3S-38N : Wed Aug 13 17:21:51 UTC 2025), Entry for Josiah B Guyer and Rosan Guyer, 1910."
      },
      {
        "title": "Josiah Guyer, \"Pennsylvania, County Marriages, 1775-1991\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/98K7-VVD",
        "citation": "\"Pennsylvania, County Marriages, 1775-1991\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VF3C-T26 : Fri May 08 00:39:08 UTC 2026), Entry for Charles D. Guyer and Hulda C. Replogle, 14 November 1901."
      }
    ]
  },
  {
    "id": "I72",
    "name": "John Guyer",
    "sex": "M",
    "gen": 6,
    "slot": 56,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I28",
    "birthYear": 1819,
    "deathYear": 1853,
    "birthDate": "1819",
    "deathDate": "9 Nov 1853",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Bedford, Pennsylvania, United States",
    "deathPlace": "Woodbury, Bedford, Pennsylvania, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LQ51-NG4",
    "photo": null,
    "living": false,
    "alternateNames": [
      "John S. Guyer"
    ],
    "facts": [
      {
        "kind": "Residence",
        "date": "1850",
        "place": "Woodbury, Bedford, Pennsylvania, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "John Geyer in entry for Elizabeth Geyer, \"Pennsylvania, Births and Christenings, 1709-1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/333V-JMH",
        "citation": "\"Pennsylvania, Births and Christenings, 1709-1950\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:V2FH-1HT : 15 December 2023), John Geyer in entry for Elizabeth Geyer, 1849."
      },
      {
        "title": "John Geyer, \"Pennsylvania, Philadelphia, Historical Society of Pennsylvania, Births and Baptisms, 1520-1999\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/333V-68T",
        "citation": "\"Pennsylvania, Philadelphia, Historical Society of Pennsylvania, Births and Baptisms, 1520-1999\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CTR-XMJD : Thu Mar 07 05:37:40 UTC 2024), Entry for Elizabeth Geyer and John Geyer, 11 November 1849."
      },
      {
        "title": "John Geyer, \"United States, Census, 1850\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/333V-48Q",
        "citation": "\"United States, Census, 1850\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M44J-2Z3 : Mon Jan 20 22:56:52 UTC 2025), Entry for John Geyer and Barbara Geyer, 1850."
      }
    ]
  },
  {
    "id": "I71",
    "name": "Barbara Bowers",
    "sex": "F",
    "gen": 6,
    "slot": 57,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I28",
    "birthYear": 1822,
    "deathYear": null,
    "birthDate": "1822",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Bedford, Pennsylvania, United States",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LQ51-NP4",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [
      {
        "kind": "Residence",
        "date": "1850",
        "place": "Woodbury, Bedford, Pennsylvania, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Barbara Geyer, \"United States, Census, 1850\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/333V-W1M",
        "citation": "\"United States, Census, 1850\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M44J-2Z3 : Mon Jan 20 22:56:52 UTC 2025), Entry for John Geyer and Barbara Geyer, 1850."
      }
    ]
  },
  {
    "id": "I31",
    "name": "Rosanna Burket Snowberger",
    "sex": "F",
    "gen": 5,
    "slot": 29,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I15",
    "birthYear": 1856,
    "deathYear": 1920,
    "birthDate": "31 Aug 1856",
    "deathDate": "22 Mar 1920",
    "burialDate": "1920",
    "christeningDate": null,
    "birthPlace": "Shellytown, Woodbury Township, Blair, Pennsylvania, United States",
    "deathPlace": "Woodbury, Bedford, Pennsylvania, United States",
    "burialPlace": "Dry Hill Cemetery, Woodbury, Bedford, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LTPV-8WQ",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [
      {
        "kind": "Residence",
        "date": "1860",
        "place": "East Providence Township, Bedford, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1870",
        "place": "Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1880",
        "place": "Huston Township, Blair, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1900",
        "place": "Woodbury Township, Bedford, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1910",
        "place": "Woodbury, Bedford, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1920",
        "place": "Woodbury, Bedford, Pennsylvania, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Anne Snowbarger, \"United States, Census, 1860\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/WQW4-27X",
        "citation": "\"United States, Census, 1860\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MXP6-Z35 : Mon Jul 08 18:42:28 UTC 2024), Entry for Joseph Snowbarger and Anne Snowbarger, 1860."
      },
      {
        "title": "Rosanna Guyer, \"United States, Census, 1900\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SZBH-NHG",
        "citation": "\"United States, Census, 1900\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M3M2-H1R : Tue Feb 04 20:04:08 UTC 2025), Entry for Joseph B Guyer and Rosanna Guyer, 1900."
      },
      {
        "title": "Rosanna Guzer, \"United States, Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7MH3-MJK",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MWXQ-8ZF : Wed Sep 09 02:47:09 UTC 2026), Entry for Josiah Guzer and Rosanna Guzer, 1880."
      },
      {
        "title": "Rose Anna Snowberger, \"Idaho, Death Certificates, 1938-1961\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7MH3-M9F",
        "citation": "\"Idaho, Death Certificates, 1938-1961\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:Q2M1-PL12 : Fri Feb 21 22:38:15 UTC 2025), Entry for Charles David Guyer and Joseph B Guyer, 1 Apr 1952."
      },
      {
        "title": "Rosanna Snowberger, \"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QPWX-QZC",
        "citation": "\"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6K4K-WQVQ : Sun Jul 05 11:12:08 UTC 2026), Entry for Howard Guyer and Josiah Guyer."
      },
      {
        "title": "Rosanne Snowberger Guyer, \"Pennsylvania, Delayed Birth Records, 1780-1977\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q8HF-3M8",
        "citation": "\"Pennsylvania, Delayed Birth Records, 1780-1977\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:88JX-1K3Z : Mon Jan 20 16:20:08 UTC 2025), Entry for Eldon S Guyer and Josiah B Guyer, 17 Oct."
      },
      {
        "title": "Mrs Josiah B Guyer, \"Pennsylvania, Delayed Birth Records, 1780-1977\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q8HF-91X",
        "citation": "\"Pennsylvania, Delayed Birth Records, 1780-1977\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Z3J-99MF : Mon Jan 20 08:31:57 UTC 2025), Entry for Eldon S Guyer and Josiah B Guyer, 17 Oct 1895."
      },
      {
        "title": "Rosanna Snowburger Guyer, \"Pennsylvania, Delayed Birth Records, 1780-1977\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q8HF-98T",
        "citation": "\"Pennsylvania, Delayed Birth Records, 1780-1977\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6Z3J-99MD : Sun Jan 12 13:55:24 UTC 2025), Entry for Eldon S. Guyer and Josiah B Guyer, 17 Oct 1895."
      },
      {
        "title": "Rosana Guyer, \"Pennsylvania, Delayed Birth Records, 1780-1977\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/36T6-BC1",
        "citation": "\"Pennsylvania, Delayed Birth Records, 1780-1977\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:ZR9M-3M6Z : Mon Jan 13 09:51:00 UTC 2025), Entry for Trester S Guyer and Joseph B Guyer, 2 Aug 1900."
      },
      {
        "title": "Roseann Snowberger, \"United States, Census, 1870\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9J55-C66",
        "citation": "\"United States, Census, 1870\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MZLG-LDR : Tue Oct 14 11:24:49 UTC 2025), Entry for Joseph Snowberger and Susan Snowberger, 1870."
      },
      {
        "title": "Rosann, \"Pennsylvania, County Marriages, 1775-1991\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9NVC-12S",
        "citation": "\"Pennsylvania, County Marriages, 1775-1991\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VF3G-ZXL : Fri May 08 00:41:33 UTC 2026), Entry for Joseph Frederick and Margaret A. Guyer, 1 February 1900."
      },
      {
        "title": "Rosannia Guyer, \"United States, Census, 1920\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9NVC-1SY",
        "citation": "\"United States, Census, 1920\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MNM4-KXN : Sun Sep 27 15:36:56 UTC 2026), Entry for Josiah B Guyer and Rosannia Guyer, 1920."
      },
      {
        "title": "Rosan Guyer, \"United States, Census, 1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9NVC-B84",
        "citation": "\"United States, Census, 1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MG3S-38N : Wed Aug 13 17:21:51 UTC 2025), Entry for Josiah B Guyer and Rosan Guyer, 1910."
      },
      {
        "title": "Rosannah Burkett Snowberger Guyer, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9NVC-Y5K",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVVF-MQ1Q : Sat Oct 03 13:54:29 UTC 2026), Entry for Rosannah Burkett Snowberger Guyer, 1920."
      },
      {
        "title": "Roseanna, \"Pennsylvania, County Marriages, 1775-1991\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/98K7-VKM",
        "citation": "\"Pennsylvania, County Marriages, 1775-1991\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VF3C-T26 : Fri May 08 00:39:08 UTC 2026), Entry for Charles D. Guyer and Hulda C. Replogle, 14 November 1901."
      },
      {
        "title": "Rosana Guyer in entry for Truster S Guyer, \"Pennsylvania, Births and Christenings, 1709-1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SPBL-39K",
        "citation": "\"Pennsylvania, Births and Christenings, 1709-1950\", database, FamilySearch (https://familysearch.org/ark:/61903/1:1:HFDS-2CMM : 15 February 2020), Rosana Guyer in entry for Truster S Guyer, 1900."
      }
    ]
  },
  {
    "id": "I83",
    "name": "Joseph Snyder Snowberger",
    "sex": "M",
    "gen": 6,
    "slot": 58,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I31",
    "birthYear": 1832,
    "deathYear": 1901,
    "birthDate": "13 Feb 1832",
    "deathDate": "4 Jan 1901",
    "burialDate": "1901",
    "christeningDate": null,
    "birthPlace": "Snake Spring Township, Bedford, Pennsylvania, United States",
    "deathPlace": "Clover Creek, North Woodbury Township, Blair, Pennsylvania, United States",
    "burialPlace": "Shellytown, Blair, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "M35S-WJH",
    "photo": "/ancestors/bubbles/122_M35S-WJH.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [
      {
        "kind": "Residence",
        "date": "1850",
        "place": "West Providence Township, Bedford, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1860",
        "place": "East Providence Township, Bedford, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1870",
        "place": "Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1870",
        "place": "Huston Township, Blair, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1880",
        "place": "Huston Township, Blair, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1900",
        "place": "Huston Township, Blair, Pennsylvania, United States",
        "note": null
      }
    ],
    "sketch": "Elder Joseph S. Snowberger\nBIRTH\t14 Feb 1832\nDEATH\t4 Jan 1901 (aged 68)\nBURIAL\t\nShellytown Fairview Cemetery\nShellytown, Blair County, Pennsylvania, USA\nMEMORIAL ID\t204148181 – View Source\n \naged 68-10-21\n\nFamily Members\nSpouse\t\nSusanna Ditch Snowberger\n1829–1915",
    "sources": [
      {
        "title": "Joseph Snowberger, \"United States, Census, 1900\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9YKN-B9Q",
        "citation": "\"United States, Census, 1900\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M3MB-PQ3 : Wed Jun 25 23:14:50 UTC 2025), Entry for Joseph Snowberger and Susan Snowberger, 1900."
      },
      {
        "title": "Joseph Snowberger, \"United States, Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/91L9-MN9",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MWXQ-8ZV : Wed Sep 09 02:47:09 UTC 2026), Entry for Joseph Snowberger and Susannah Snowberger, 1880."
      },
      {
        "title": "Joseph Snowberger, \"United States, Census, 1870\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7MQT-TTV",
        "citation": "\"United States, Census, 1870\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MZLG-LDR : Tue Oct 14 11:24:49 UTC 2025), Entry for Joseph Snowberger and Susan Snowberger, 1870."
      },
      {
        "title": "Joseph Snowberger, \"United States, Census, 1850\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9Z1S-WF2",
        "citation": "\"United States, Census, 1850\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M44N-R6Z : Sat Jan 18 20:26:58 UTC 2025), Entry for Andrew Snowberger and Rosanna Snowberger, 1850."
      },
      {
        "title": "Joseph Snowbarger, \"United States, Census, 1860\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/WQW4-K3T",
        "citation": "\"United States, Census, 1860\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MXP6-Z35 : Mon Jul 08 18:42:28 UTC 2024), Entry for Joseph Snowbarger and Anne Snowbarger, 1860."
      },
      {
        "title": "Joseph Snyder Snowberger, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9Z1S-44R",
        "citation": "\"Find a Grave Index,\" database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVKF-2VCN : 6 March 2021), Joseph Snyder Snowberger, ; Burial, Shellytown, Blair, Pennsylvania, United States of America, Shellytown Fairview Cemetery; citing record ID 44781039, Find a Grave, http://www.findagrave.com."
      },
      {
        "title": "Elder Joseph S. Snowberger, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SG2Z-RRG",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:4K64-DZT2 : Sun Oct 04 09:54:34 UTC 2026), Entry for Elder Joseph S. Snowberger."
      }
    ],
    "portrait": "/ancestors/portraits/122_M35S-WJH.jpg"
  },
  {
    "id": "I82",
    "name": "Hannah Burket",
    "sex": "F",
    "gen": 6,
    "slot": 59,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I31",
    "birthYear": 1834,
    "deathYear": 1864,
    "birthDate": "21 Nov 1834",
    "deathDate": "8 Oct 1864",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Yellow Creek, Hopewell Township, Bedford, Pennsylvania, United States",
    "deathPlace": "Yellow Creek, Hopewell Township, Bedford, Pennsylvania, United States",
    "burialPlace": "Yellow Creek, Hopewell Township, Bedford, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LQ5Y-CFV",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [
      {
        "kind": "Residence",
        "date": "1850",
        "place": "Hopewell, Bedford, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1860",
        "place": "East Providence Township, Bedford, Pennsylvania, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Anne Snowbarger, \"United States, Census, 1860\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/WQW4-KLV",
        "citation": "\"United States, Census, 1860\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MXP6-Z35 : Mon Jul 08 18:42:28 UTC 2024), Entry for Joseph Snowbarger and Anne Snowbarger, 1860."
      },
      {
        "title": "Hannah Burker in household of John Burker, \"United States Census, 1850\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9J47-LRX",
        "citation": "\"United States, Census, 1850\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M44J-XSC : Sun Jan 19 02:35:12 UTC 2025), Entry for John Burker and Elizabeth Burker, 1850."
      },
      {
        "title": "Hannah Burket Snowberger, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9NVC-P6S",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVGW-LX5T : Fri Oct 02 11:09:30 UTC 2026), Entry for Hannah Burket Snowberger, 1864."
      },
      {
        "title": "Legacy NFS Source: Hannah Burket - Government record: Census record: birth-name: Hannah Burket",
        "href": "https://www.familysearch.org/tree/sources/viewedit/M977-66R",
        "citation": "Internet, 1850 US Federal Census"
      }
    ]
  },
  {
    "id": "I14",
    "name": "Ada Gochenour",
    "sex": "F",
    "gen": 4,
    "slot": 15,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I8",
    "birthYear": 1892,
    "deathYear": 1949,
    "birthDate": "3 Oct 1892",
    "deathDate": "29 Jul 1949",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "King, Bedford, Pennsylvania, United States",
    "deathPlace": "Altoona, Blair, Pennsylvania, United States",
    "burialPlace": "Woodbury, Bedford, Pennsylvania",
    "christeningPlace": null,
    "fsId": "K838-FNQ",
    "photo": "/ancestors/bubbles/031_K838-FNQ.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [
      {
        "kind": "Residence",
        "date": "1900",
        "place": "Kimmel Township, Bedford, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1910",
        "place": "Woodbury, Bedford, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1920",
        "place": "King, Kimmel Township, Bedford, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1930",
        "place": "Woodbury Township, Blair, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1935",
        "place": "Same House",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1940",
        "place": "North Woodbury Township, Blair, Pennsylvania, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Ada R Gochnour, \"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QC8M-6XL",
        "citation": "\"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6K3D-46PG : Tue Jul 07 02:06:51 UTC 2026), Entry for Edward J Guyer and Howard Guyer."
      },
      {
        "title": "Ada R Gochnour, \"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QC8M-6QN",
        "citation": "\"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6K92-V8Y8 : Sat Jul 04 04:35:27 UTC 2026), Entry for Chester Paul Guyer and Howard Guyer."
      },
      {
        "title": "Ada R Gochnour, \"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QC8M-DRZ",
        "citation": "\"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6K95-RBS1 : Sun Jul 05 18:44:47 UTC 2026), Entry for Wilma G Mock and Howard Guyer."
      },
      {
        "title": "Ida R Guyer, \"United States, Census, 1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SMZY-PBR",
        "citation": "\"United States, Census, 1940\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KQ41-GCT : Sun Jan 19 21:06:09 UTC 2025), Entry for Howard Guyer and Ida R Guyer, 1940."
      },
      {
        "title": "Ada Gochnour Guyer, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SMZY-NWS",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVGF-7VFX : Fri Oct 02 11:22:15 UTC 2026), Entry for Ada Gochnour Guyer."
      },
      {
        "title": "Ada Gochnour in household of David Gochnour, \"United States Census, 1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9LND-HBJ",
        "citation": "\"United States, Census, 1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MG3S-2Z2 : Wed Aug 13 17:22:55 UTC 2025), Entry for David Gochnour and Elizabeth Gochnour, 1910."
      },
      {
        "title": "Ada Gochnour in household of David Gochnour, \"United States Census, 1900\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9LND-WJQ",
        "citation": "\"United States, Census, 1900\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M3MK-YYW : Thu Jan 01 21:37:32 UTC 2026), Entry for David Gochnour and Elizabeth Gochnour, 1900."
      },
      {
        "title": "Ada Guyer, \"United States, Census, 1930\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9NVZ-WYC",
        "citation": "\"United States, Census, 1930\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:XCHW-VZ2 : Thu Mar 07 16:31:55 UTC 2024), Entry for Howard Guyer and Ada Guyer, 1930."
      },
      {
        "title": "Ada Guyer, \"United States, Census, 1920\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9NVZ-W7D",
        "citation": "\"United States, Census, 1920\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MNM4-42R : Sun Sep 27 15:35:59 UTC 2026), Entry for Howard Guyer and Ada Guyer, 1920."
      }
    ],
    "portrait": "/ancestors/portraits/031_K838-FNQ.jpg"
  },
  {
    "id": "I26",
    "name": "David Gochnour",
    "sex": "M",
    "gen": 5,
    "slot": 30,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I14",
    "birthYear": 1858,
    "deathYear": 1914,
    "birthDate": "18 Jul 1858",
    "deathDate": "20 Dec 1914",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "King Township, Bedford, Pennsylvania, United States",
    "deathPlace": "King Township, Bedford, Pennsylvania, United States",
    "burialPlace": "Lower Claar Cem., Greenfield Township, Blair, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LCZM-WM4",
    "photo": null,
    "living": false,
    "alternateNames": [
      "David Gouchenour"
    ],
    "facts": [
      {
        "kind": "Residence",
        "date": "1870",
        "place": "Pavia Township, Bedford, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1880",
        "place": "King, Kimmel Township, Bedford, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1900",
        "place": "Kimmel Township, Bedford, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1910",
        "place": "Woodbury, Bedford, Pennsylvania, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "David Gouchenour, \"Pennsylvania, County Marriages, 1775-1991\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9J81-MSX",
        "citation": "\"Pennsylvania, County Marriages, 1775-1991\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VFMR-7CQ : Thu May 07 23:04:34 UTC 2026), Entry for Reuben C. Black and Gertrude S. Gouchenour, 20 January 1898."
      },
      {
        "title": "David Gouchenour in entry for Reuben C. Black, \"Pennsylvania, Marriages, 1709-1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9J81-HCW",
        "citation": "\"Pennsylvania, Marriages, 1709-1940\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:V26D-43T : 7 May 2023), David Gouchenour in entry for Reuben C. Black, 1898."
      },
      {
        "title": "David Gochenour in entry for Chester Gochenour, \"Pennsylvania, Births and Christenings, 1709-1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SLHQ-LXN",
        "citation": "\"Pennsylvania, Births and Christenings, 1709-1950\", database, FamilySearch (https://familysearch.org/ark:/61903/1:1:HFZG-5RPZ : 15 February 2020), David Gochenour in entry for Chester Gochenour, 1899."
      },
      {
        "title": "David, \"Pennsylvania, Delayed Birth Records, 1780-1977\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3TKZ-ZTL",
        "citation": "\"Pennsylvania, Delayed Birth Records, 1780-1977\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:ZR9M-3S3Z : Mon Jan 20 08:04:26 UTC 2025), Entry for Grace I Gochnour and David, 4 Jul 1901."
      },
      {
        "title": "David Gochuner, \"Pennsylvania, Deaths and Burials, 1720-1999\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QP34-8T6",
        "citation": "\"Pennsylvania, Deaths and Burials, 1720-1999\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:H58T-25PZ : Mon Sep 21 21:57:30 UTC 2026), Entry for Ralph Gochuner and David Gochuner, 12 Dec 1903."
      },
      {
        "title": "David Gochnour, \"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QC8M-CNL",
        "citation": "\"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6K4K-7FF3 : Mon Jul 06 03:36:19 UTC 2026), Entry for William Charles Gochnour and David Gochnour."
      },
      {
        "title": "David in entry for Grace I. Gochnour, \"Pennsylvania, Births and Christenings, 1709-1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SKQ9-426",
        "citation": "\"Pennsylvania, Births and Christenings, 1709-1950\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:HFZG-RSPZ : 15 February 2020), David in entry for Grace I. Gochnour, 1901."
      },
      {
        "title": "David Gochenour, \"Pennsylvania, Delayed Birth Records, 1780-1977\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q7VC-S5W",
        "citation": "\"Pennsylvania, Delayed Birth Records, 1780-1977\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:ZRT7-LJW2 : Tue Jan 21 16:38:52 UTC 2025), Entry for Chester Gochenour and David Gochenour, 6 Sep 1899."
      },
      {
        "title": "David Gochnour, \"United States Census, 1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9LND-HDW",
        "citation": "\"United States, Census, 1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MG3S-2Z2 : Wed Aug 13 17:22:55 UTC 2025), Entry for David Gochnour and Elizabeth Gochnour, 1910."
      },
      {
        "title": "David Gochnour, \"Pennsylvania, Delayed Birth Records, 1780-1977\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3KDV-7W8",
        "citation": "\"Pennsylvania, Delayed Birth Records, 1780-1977\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:ZRR2-FD6Z : Fri Jan 17 10:32:22 UTC 2025), Entry for Ralph Gochnour and David Gochnour, 12 Apr 1902."
      },
      {
        "title": "David Gochnour, \"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QC8M-C1G",
        "citation": "\"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6K4K-WQJC : Sat Jul 04 12:32:48 UTC 2026), Entry for Harold Gochnour and David Gochnour."
      },
      {
        "title": "David Gochnour, \"United States Census, 1900\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9LND-7BM",
        "citation": "\"United States, Census, 1900\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M3MK-YYW : Thu Jan 01 21:37:32 UTC 2026), Entry for David Gochnour and Elizabeth Gochnour, 1900."
      },
      {
        "title": "David Gochnour, \"Pennsylvania, Delayed Birth Records, 1780-1977\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3D5C-ZDC",
        "citation": "\"Pennsylvania, Delayed Birth Records, 1780-1977\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:ZY69-85MM : Sat Mar 09 23:04:38 UTC 2024), Entry for Herbert B Gochnour and David Gochnour, 10 Apr 1897."
      },
      {
        "title": "David Gochnour in entry for Herbert B. Gochnour, \"Pennsylvania, Births and Christenings, 1709-1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SKQ9-QYX",
        "citation": "\"Pennsylvania, Births and Christenings, 1709-1950\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:HF8M-9LN2 : 15 February 2020), David Gochnour in entry for Herbert B. Gochnour, 1897."
      },
      {
        "title": "David Gochenour, \"United States, Census, 1870\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SGY9-TJ5",
        "citation": "\"United States, Census, 1870\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MZLN-49S : Wed Oct 22 07:11:56 UTC 2025), Entry for Sarah Gochenour and Rebecca Gochenour, 1870."
      },
      {
        "title": "David, \"Pennsylvania, County Marriages, 1775-1991\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9P8P-KK1",
        "citation": "\"Pennsylvania, County Marriages, 1775-1991\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VF38-8T4 : Fri May 08 00:48:13 UTC 2026), Entry for Harold Gochnour and Mary Mock, 14 June 1913."
      },
      {
        "title": "David Gochnaser, \"Pennsylvania, County Marriages, 1775-1991\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SMZB-64R",
        "citation": "\"Pennsylvania, County Marriages, 1775-1991\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VFS8-5M3 : Fri May 08 00:32:55 UTC 2026), Entry for Chester Gochnoser and Roberta Mock, 4 August 1923."
      },
      {
        "title": "David Gowghenour, \"United States, Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SNZT-J5H",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MW6Y-9X9 : Wed Sep 09 07:56:31 UTC 2026), Entry for Sarah Gowghenour and David Gowghenour, 1880."
      },
      {
        "title": "David Gochnour in entry for Ralph Gochnour, \"Pennsylvania, Births and Christenings, 1709-1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SKQ9-HBZ",
        "citation": "\"Pennsylvania, Births and Christenings, 1709-1950\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:HF89-3LT2 : 15 February 2020), David Gochnour in entry for Ralph Gochnour, 1902."
      },
      {
        "title": "David Gochnour, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9P8P-P3Q",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVK4-X8C4 : Sat Oct 03 12:00:12 UTC 2026), Entry for David Gochnour."
      }
    ]
  },
  {
    "id": "I59",
    "name": "John Gochnour",
    "sex": "M",
    "gen": 6,
    "slot": 60,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I26",
    "birthYear": 1816,
    "deathYear": 1857,
    "birthDate": "23 Nov 1816",
    "deathDate": "2 Nov 1857",
    "burialDate": "1857",
    "christeningDate": null,
    "birthPlace": "of,, PA",
    "deathPlace": "Bedford, Pennsylvania, United States",
    "burialPlace": "King, Bedford, Pennsylvania, United States of America",
    "christeningPlace": null,
    "fsId": "KHVQ-TJJ",
    "photo": "/ancestors/bubbles/124_KHVQ-TJJ.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [
      {
        "kind": "Residence",
        "date": "1850",
        "place": "Pavia Township, Bedford, Pennsylvania, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Washington Death Index, 1940-1996",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9DM9-WP9",
        "citation": "Database online."
      },
      {
        "title": "Pennsylvania, Septennial Census, 1779-1863",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9DM9-WGG",
        "citation": "Database online. Year: 1850; Census Place: Union, Bedford, Pennsylvania; Roll: M432_751; Page: 247B; Image: ."
      },
      {
        "title": "John Gochenour, \"Find A Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9LX9-VK2",
        "citation": "\"Find a Grave Index,\" database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVL3-14KK : 17 December 2020), John Gochenour, ; Burial, King, Bedford, Pennsylvania, United States of America, Gochenour Cemetery (Defunct); citing record ID 80600606, Find a Grave, http://www.findagrave.com."
      },
      {
        "title": "John Gochnour, \"Find A Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9LX9-V5Q",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVV4-CKKR : Sun Oct 04 08:19:24 UTC 2026), Entry for John Gochnour."
      },
      {
        "title": "John Gochnour, \"Pennsylvania, Philadelphia, Historical Society of Pennsylvania, Deaths and Burials, 1627-1972\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/749P-DKM",
        "citation": "\"Pennsylvania, Philadelphia, Historical Society of Pennsylvania, Deaths and Burials, 1627-1972\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6CYZ-JX46 : Sun Jan 12 01:10:18 UTC 2025), Entry for John Gochnour, 1857."
      },
      {
        "title": "John Gochinous, \"United States, Census, 1850\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/75RF-P98",
        "citation": "\"United States, Census, 1850\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M44J-ZVR : Wed Jan 22 11:53:32 UTC 2025), Entry for John Gochinous and Sarah Gochinous, 1850."
      }
    ],
    "portrait": "/ancestors/portraits/124_KHVQ-TJJ.jpg"
  },
  {
    "id": "I62",
    "name": "Sarah Lingenfelter",
    "sex": "F",
    "gen": 6,
    "slot": 61,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I26",
    "birthYear": 1818,
    "deathYear": 1892,
    "birthDate": "12 Oct 1818",
    "deathDate": "4 Nov 1892",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Blair County, Pennsylvania, USA",
    "deathPlace": "Pennsylvania, United States",
    "burialPlace": "Gochnour Cemetary, Kimmel, Bedford, Pa",
    "christeningPlace": null,
    "fsId": "KHRZ-XXK",
    "photo": "/ancestors/bubbles/125_KHRZ-XXK.jpg",
    "living": false,
    "alternateNames": [
      "Sarah"
    ],
    "facts": [
      {
        "kind": "Residence",
        "date": "1850",
        "place": "Greenfield Township, Blair, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1850",
        "place": "Pavia Township, Bedford, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1870",
        "place": "Pavia Township, Bedford, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1880",
        "place": "King, Kimmel Township, Bedford, Pennsylvania, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Sarah Gochinous, \"United States, Census, 1850\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/75RF-PF7",
        "citation": "\"United States, Census, 1850\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M44J-ZVR : Wed Jan 22 11:53:32 UTC 2025), Entry for John Gochinous and Sarah Gochinous, 1850."
      },
      {
        "title": "Sarah Lingenfelter Gochnour, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/74M4-DS7",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVKM-SKWN : Sun Oct 04 13:07:08 UTC 2026), Entry for Sarah Lingenfelter Gochnour."
      },
      {
        "title": "Pennsylvania Births and Christenings, 1709-1950",
        "href": "https://www.familysearch.org/tree/sources/viewedit/S6TC-X47",
        "citation": ""
      },
      {
        "title": "Sarah Gowghenour, \"United States, Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SP27-YRP",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MW6Y-9X9 : Wed Sep 09 07:56:31 UTC 2026), Entry for Sarah Gowghenour and David Gowghenour, 1880."
      },
      {
        "title": "Sarah Gochenour, \"United States, Census, 1870\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SGY9-RLQ",
        "citation": "\"United States, Census, 1870\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MZLN-49S : Wed Oct 22 07:11:56 UTC 2025), Entry for Sarah Gochenour and Rebecca Gochenour, 1870."
      },
      {
        "title": "Sarah Daugherty Gochenour, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SZG6-MWS",
        "citation": "\"Find a Grave Index,\" database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVL3-14K5 : 17 December 2020), Sarah Daugherty Gochenour, ; Burial, King, Bedford, Pennsylvania, United States of America, Gochenour Cemetery (Defunct); citing record ID 80600642, Find a Grave, http://www.findagrave.com."
      },
      {
        "title": "[No source title]",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9DM9-HFY",
        "citation": "Sarah wife of John Gochnour Died Nov 4, 1892 Aged 74 yrs 22 ds., Inscription at bottom:, Rest, mother, rest in quiet sleep, While friends in sorrow, O'er thee weep."
      },
      {
        "title": "Pennsylvania, Septennial Census, 1779-1863",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9DM9-HFV",
        "citation": "Database online. Year: 1850; Census Place: Union, Bedford, Pennsylvania; Roll: M432_751; Page: 247B; Image: ."
      },
      {
        "title": "1880 United States Census",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9DM9-HF4",
        "citation": "Database online. Year: 1880; Census Place: King, Bedford, Pennsylvania; Roll: 1098; Family History Film: 1255098; Page: 191D; Enumeration District: 226; Image: 0389."
      },
      {
        "title": "Legacy NFS Source: Sarah Ickes - Government record: Census record: birth-name: Sarah Ickes",
        "href": "https://www.familysearch.org/tree/sources/viewedit/MS69-5HJ",
        "citation": "Website, 1880 census"
      }
    ],
    "portrait": "/ancestors/portraits/125_KHRZ-XXK.jpg"
  },
  {
    "id": "I34",
    "name": "Elizabeth Burket",
    "sex": "F",
    "gen": 5,
    "slot": 31,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I14",
    "birthYear": 1860,
    "deathYear": 1943,
    "birthDate": "3 Feb 1860",
    "deathDate": "3 Feb 1943",
    "burialDate": "5 Feb 1943",
    "christeningDate": null,
    "birthPlace": "Pennsylvania, United States",
    "deathPlace": "King, Bedford, Pennsylvania, USA",
    "burialPlace": "Lower Claar Cemetery, Greenfield Township, Blair, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LCZM-7YG",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Elizabeth Gouchenour"
    ],
    "facts": [
      {
        "kind": "Residence",
        "date": "1860",
        "place": "Pavia Township, Bedford, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1880",
        "place": "King Township, Bedford, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1900",
        "place": "Kimmel Township, Bedford, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1910",
        "place": "Woodbury, Bedford, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1920",
        "place": "King Township, Bedford, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1935",
        "place": "North Woodbury Township, Blair, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1940",
        "place": "North Woodbury Township, Blair, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": null,
        "place": "Imler, King Township, Bedford, Pennsylvania, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Elizabeth Gochnour, \"United States, World War I Draft Registration Cards, 1917-1918\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/WF46-W8F",
        "citation": "\"United States, World War I Draft Registration Cards, 1917-1918\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:4F67-VDN2 : Sat May 16 02:37:58 UTC 2026), Entry for Herbert Lawrence Gochnour and Elizabeth Gochnour, from 1917 to 1918."
      },
      {
        "title": "Elizabeth Gochnour in Pennsylvania, U.S., Death Certificates, 1906-1972 Kimmel Township",
        "href": "https://www.familysearch.org/tree/sources/viewedit/W88L-R41",
        "citation": ""
      },
      {
        "title": "Elizabeth Gochnour, \"United States, World War I Draft Registration Cards, 1917-1918\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/7DZD-7P4",
        "citation": "\"United States, World War I Draft Registration Cards, 1917-1918\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:4F67-VD3Z : Sat May 16 04:26:39 UTC 2026), Entry for Chester Arthur Gochnour and Elizabeth Gochnour, from 1917 to 1918."
      },
      {
        "title": "Elizabeth Gochuner, \"Pennsylvania, Deaths and Burials, 1720-1999\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QP34-DM9",
        "citation": "\"Pennsylvania, Deaths and Burials, 1720-1999\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:H58T-25PZ : Mon Sep 21 21:57:30 UTC 2026), Entry for Ralph Gochuner and David Gochuner, 12 Dec 1903."
      },
      {
        "title": "Elizabeth Burket, \"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QC8M-Z9S",
        "citation": "\"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6K4K-WQJC : Sat Jul 04 12:32:48 UTC 2026), Entry for Harold Gochnour and David Gochnour."
      },
      {
        "title": "Elizabeth Burket, \"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/QC8M-CLX",
        "citation": "\"United States, Social Security Numerical Identification Files (NUMIDENT), 1936-2007\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:6K4K-7FF3 : Mon Jul 06 03:36:19 UTC 2026), Entry for William Charles Gochnour and David Gochnour."
      },
      {
        "title": "Elizabeth Gochenour, \"Pennsylvania, Delayed Birth Records, 1780-1977\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/Q7VC-ST2",
        "citation": "\"Pennsylvania, Delayed Birth Records, 1780-1977\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:ZRT7-LJW2 : Tue Jan 21 16:38:52 UTC 2025), Entry for Chester Gochenour and David Gochenour, 6 Sep 1899."
      },
      {
        "title": "Elizabeth, \"Pennsylvania, Delayed Birth Records, 1780-1977\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3TKZ-ZB2",
        "citation": "\"Pennsylvania, Delayed Birth Records, 1780-1977\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:ZR9M-3S3Z : Mon Jan 20 08:04:26 UTC 2025), Entry for Grace I Gochnour and David, 4 Jul 1901."
      },
      {
        "title": "Elizabeth Gochnour, \"Pennsylvania, Delayed Birth Records, 1780-1977\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3KDV-7KH",
        "citation": "\"Pennsylvania, Delayed Birth Records, 1780-1977\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:ZRR2-FD6Z : Fri Jan 17 10:32:22 UTC 2025), Entry for Ralph Gochnour and David Gochnour, 12 Apr 1902."
      },
      {
        "title": "Elizabeth Gochenour, \"United States, Census, 1920\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3KDJ-P3H",
        "citation": "\"United States, Census, 1920\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MNM4-42N : Sun Sep 27 15:35:59 UTC 2026), Entry for Elizabeth Gochenour and Herbert G Gochenour, 1920."
      },
      {
        "title": "Lizzie Gochnour, \"Pennsylvania, Delayed Birth Records, 1780-1977\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3D5C-ZQY",
        "citation": "\"Pennsylvania, Delayed Birth Records, 1780-1977\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:ZY69-85MM : Sat Mar 09 23:04:38 UTC 2024), Entry for Herbert B Gochnour and David Gochnour, 10 Apr 1897."
      },
      {
        "title": "Lizzie, \"United States, Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/34ZY-BCD",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MW6Y-9X9 : Wed Sep 09 07:56:31 UTC 2026), Entry for Sarah Gowghenour and David Gowghenour, 1880."
      },
      {
        "title": "Elizabeth Gochenour in entry for Chester Gochenour, \"Pennsylvania, Births and Christenings, 1709-1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SLHQ-LPN",
        "citation": "\"Pennsylvania, Births and Christenings, 1709-1950\", , FamilySearch (https://familysearch.org/ark:/61903/1:1:HFZG-5RT2 : 15 February 2020), Elizabeth Gochenour in entry for Chester Gochenour, 1899."
      },
      {
        "title": "Elizabeth Gochnour in entry for Ralph Gochnour, \"Pennsylvania, Births and Christenings, 1709-1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SKQ9-C9D",
        "citation": "\"Pennsylvania, Births and Christenings, 1709-1950\", database, FamilySearch (https://familysearch.org/ark:/61903/1:1:HF89-3GMM : 15 February 2020), Elizabeth Gochnour in entry for Ralph Gochnour, 1902."
      },
      {
        "title": "Elizabeth in entry for Grace I. Gochnour, \"Pennsylvania, Births and Christenings, 1709-1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SKQ9-4T4",
        "citation": "\"Pennsylvania, Births and Christenings, 1709-1950\", database, FamilySearch (https://familysearch.org/ark:/61903/1:1:HFZG-RST2 : 15 February 2020), Elizabeth in entry for Grace I. Gochnour, 1901."
      },
      {
        "title": "Lizzie Gochnour in entry for Herbert B. Gochnour, \"Pennsylvania, Births and Christenings, 1709-1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SKQ9-7HS",
        "citation": "\"Pennsylvania, Births and Christenings, 1709-1950\", database, FamilySearch (https://familysearch.org/ark:/61903/1:1:HF8M-9L2M : 15 February 2020), Lizzie Gochnour in entry for Herbert B. Gochnour, 1897."
      },
      {
        "title": "Elizabeth Burket, \"Pennsylvania, County Marriages, 1775-1991\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SMZB-6CZ",
        "citation": "\"Pennsylvania, County Marriages, 1775-1991\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VFS8-5M3 : Fri May 08 00:32:55 UTC 2026), Entry for Chester Gochnoser and Roberta Mock, 4 August 1923."
      },
      {
        "title": "Elizabeth Burket, \"United States, Census, 1860\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9BNK-Y5R",
        "citation": "\"United States, Census, 1860\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MXPX-ZLF : Mon Jul 08 19:34:20 UTC 2024), Entry for Frederick Burket and Sarah Burket, 1860."
      },
      {
        "title": "Elizabeth Burket Gochenour, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9P8P-GCV",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVK4-X8CH : Sat Oct 03 12:26:10 UTC 2026), Entry for Elizabeth Burket Gochenour."
      },
      {
        "title": "Elizabeth Gochnour in household of David Gochnour, \"United States Census, 1910\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9LND-H6V",
        "citation": "\"United States, Census, 1910\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MG3S-2Z2 : Wed Aug 13 17:22:55 UTC 2025), Entry for David Gochnour and Elizabeth Gochnour, 1910."
      },
      {
        "title": "Elizabeth Gochnour in household of David Gochnour, \"United States Census, 1900\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9LND-7NN",
        "citation": "\"United States, Census, 1900\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M3MK-YYW : Thu Jan 01 21:37:32 UTC 2026), Entry for David Gochnour and Elizabeth Gochnour, 1900."
      },
      {
        "title": "Elizabeth, \"Pennsylvania, County Marriages, 1775-1991\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9P8P-KLH",
        "citation": "\"Pennsylvania, County Marriages, 1775-1991\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VF38-8T4 : Fri May 08 00:48:13 UTC 2026), Entry for Harold Gochnour and Mary Mock, 14 June 1913."
      },
      {
        "title": "Elizabeth Goughnour, \"United States, Census, 1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9P8P-K4D",
        "citation": "\"United States, Census, 1940\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:KQ41-TBG : Wed Jan 22 03:16:48 UTC 2025), Entry for Harold Goughnour and Mary E Goughnour, 1940."
      },
      {
        "title": "Elizabeth Gouchenour in entry for Reuben C. Black, \"Pennsylvania, Marriages, 1709-1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9J81-HCR",
        "citation": "\"Pennsylvania, Marriages, 1709-1940\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:V26D-43Y : 7 May 2023), Elizabeth Gouchenour in entry for Reuben C. Black, 1898."
      },
      {
        "title": "Elizabeth Gouchenour, \"Pennsylvania, County Marriages, 1775-1991\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9J81-MST",
        "citation": "\"Pennsylvania, County Marriages, 1775-1991\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VFMR-7CQ : Thu May 07 23:04:34 UTC 2026), Entry for Reuben C. Black and Gertrude S. Gouchenour, 20 January 1898."
      }
    ]
  },
  {
    "id": "I88",
    "name": "Frederick Burket",
    "sex": "M",
    "gen": 6,
    "slot": 62,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I34",
    "birthYear": 1831,
    "deathYear": 1864,
    "birthDate": "2 Aug 1831",
    "deathDate": "16 Oct 1864",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "St Clair Township, Bedford, Pennsylvania, United States",
    "deathPlace": "Andersonville Prison, Sumter, Georgia, United States",
    "burialPlace": "Andersonville National Cemetery, Macon, Georgia, United States",
    "christeningPlace": null,
    "fsId": "LHXB-7MX",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [
      {
        "kind": "Residence",
        "date": "1860",
        "place": "Pavia Township, Bedford, Pennsylvania, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Frederick Burket in Entry for Daughter Elizabeth Gochnour Pennsylvania, U.S., Death Certificates, 1906-1972",
        "href": "https://www.familysearch.org/tree/sources/viewedit/W88L-JJD",
        "citation": ""
      },
      {
        "title": "Frederick Burket in the Bedford Gazette \"Soldier's Monument\" to be Erected",
        "href": "https://www.familysearch.org/tree/sources/viewedit/W8ZL-W88",
        "citation": "Second column and top."
      },
      {
        "title": "Frederick Burket, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3L6H-DXZ",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:DM99-DWMM : Sun Oct 04 04:52:43 UTC 2026), Entry for Frederick Burket."
      },
      {
        "title": "U.S., Civil War Pension Index: General Index to Pension Files, 1861-1934",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SPHK-JGY",
        "citation": "The National Archives at Washington, D.C.; Washington, D.C.; Record Group Title: Records of the Department of Veterans Affairs, 1773 - 2007; Record Group Number: 15; Series Title: U.S., Civil War Pension Index: General Index to Pension Files, 1861-1934; Se"
      },
      {
        "title": "Frederick Burket in the U.S. National Cemetery Interment Control Forms, 1928-1962",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SPHK-JGR",
        "citation": ""
      },
      {
        "title": "Frederick Burket in the U.S., Civil War Draft Registrations Records, 1863-1865 Union Township, Bedford",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SPHK-JGL",
        "citation": "National Archives and Records Administration (NARA); Washington, D.C.; Consolidated Lists of Civil War Draft Registration Records (Provost Marshal General's Bureau; Consolidated Enrollment Lists, 1863-1865); Record Group: 110, Records of the Provost Marsha"
      },
      {
        "title": "U.S., Burial Registers, Military Posts and National Cemeteries, 1862-1960",
        "href": "https://www.familysearch.org/tree/sources/viewedit/SPHK-JGJ",
        "citation": ""
      },
      {
        "title": "Frederick Burket, \"United States, Census, 1860\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9BNK-YWT",
        "citation": "\"United States, Census, 1860\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MXPX-ZLF : Mon Jul 08 19:34:20 UTC 2024), Entry for Frederick Burket and Sarah Burket, 1860."
      },
      {
        "title": "Frederick Burket, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9BNK-TYG",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QV21-Z9R4 : Fri Oct 02 16:29:59 UTC 2026), Entry for Frederick Burket."
      },
      {
        "title": "Fredk. Burket for son Alexander, \"Pennsylvania, County Marriages, 1775-1991\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9BNK-TSM",
        "citation": "\"Pennsylvania, County Marriages, 1775-1991\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VFW6-4ZB : Fri May 08 00:54:11 UTC 2026), Entry for Alexander Burket and Emma May Dively, 2 December 1888."
      },
      {
        "title": "Frederick Burket in entry for David A. Burket and Elizabeth Eicher, \"Pennsylvania Marriages, 1709-1940\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9V7Y-7C9",
        "citation": "\"Pennsylvania, Marriages, 1709-1940\", database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:V26D-4QP : 7 May 2023), Frederick Burket in entry for David A. Burket, 1886."
      },
      {
        "title": "Frederick Burket in entry for David A. Burket and Elizabeth Eicher, \"Pennsylvania, County Marriages, 1885-1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9V7Y-QM2",
        "citation": "\"Pennsylvania, County Marriages, 1775-1991\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VFMG-W73 : Fri May 08 00:23:26 UTC 2026), Entry for David A. Burket and Elizabeth Eicher, 22 August 1886."
      }
    ]
  },
  {
    "id": "I89",
    "name": "Sarah Claar",
    "sex": "F",
    "gen": 6,
    "slot": 63,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I34",
    "birthYear": 1837,
    "deathYear": 1924,
    "birthDate": "1837",
    "deathDate": "1 Jul 1924",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Pennsylvania, United States",
    "deathPlace": "Queen, Bedford, Pennsylvania, United States",
    "burialPlace": "Upper Claar Cemetery, Queen, Bedford, Pennsylvania, USA",
    "christeningPlace": null,
    "fsId": "LCJ3-6Q1",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Sally"
    ],
    "facts": [
      {
        "kind": "Residence",
        "date": "1850",
        "place": "Greenfield Township, Blair, Pennsylvania, United States",
        "note": null
      },
      {
        "kind": "Residence",
        "date": "1900",
        "place": "Kimmel Township, Bedford, Pennsylvania, United States",
        "note": null
      }
    ],
    "sketch": "",
    "sources": [
      {
        "title": "Sarah Clarr, \"United States, Census, 1850\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/3QDB-PQ1",
        "citation": "\"United States, Census, 1850\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M442-RCQ : Tue Jan 21 07:23:46 UTC 2025), Entry for Joseph Clarr and Hetta Clarr, 1850."
      },
      {
        "title": "Sally Wisner, \"United States, Census, 1900\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9B16-RGJ",
        "citation": "\"United States, Census, 1900\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:M3MK-VNG : Tue Oct 14 10:34:34 UTC 2025), Entry for William Wisner and Sally Wisner, 1900."
      },
      {
        "title": "Sarah Misner, \"Pennsylvania, County Marriages, 1775-1991\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9B16-56J",
        "citation": "\"Pennsylvania, County Marriages, 1775-1991\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VFMP-37Z : Fri May 08 00:20:58 UTC 2026), Entry for James Adolphis Benton and Sarah Misner, 14 January 1897."
      },
      {
        "title": "Sarah, \"Pennsylvania, County Marriages, 1775-1991\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9BNK-T3Y",
        "citation": "\"Pennsylvania, County Marriages, 1775-1991\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VFW6-4ZB : Fri May 08 00:54:11 UTC 2026), Entry for Alexander Burket and Emma May Dively, 2 December 1888."
      },
      {
        "title": "Sarah Burket Claar Misner, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9BNK-5KY",
        "citation": "\"Find a Grave Index\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVV4-CQWM : Fri Oct 02 19:51:04 UTC 2026), Entry for Sally."
      },
      {
        "title": "Sarah in entry for David A. Burket and Elizabeth Eicher, \"Pennsylvania, County Marriages, 1885-1950\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9V7Y-3YL",
        "citation": "\"Pennsylvania, County Marriages, 1775-1991\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:VFMG-W73 : Fri May 08 00:23:26 UTC 2026), Entry for David A. Burket and Elizabeth Eicher, 22 August 1886."
      },
      {
        "title": "Sarah Misner, \"United States, Census, 1880\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZKX-1CY",
        "citation": "\"United States, Census, 1880\", FamilySearch (https://www.familysearch.org/ark:/61903/1:1:MW6T-RTG : Wed Sep 09 02:27:51 UTC 2026), Entry for William Misner and Sarah Misner, 1880."
      },
      {
        "title": "Sarah Claar Misner, \"Find a Grave Index\"",
        "href": "https://www.familysearch.org/tree/sources/viewedit/9ZKX-B7J",
        "citation": "\"Find a Grave Index,\" database, FamilySearch (https://www.familysearch.org/ark:/61903/1:1:QVVG-8T31 : 10 September 2021), Sarah Claar Misner, ; Burial, Queen, Bedford, Pennsylvania, United States of America, Upper Claar Cemetery; citing record ID 22052328, Find a Grave, http://www.findagrave.com."
      }
    ]
  },
  {
    "id": "AQI131",
    "name": "Thomas Mills",
    "sex": "M",
    "gen": 7,
    "slot": 0,
    "side": "paternal",
    "birthplace": "england",
    "childId": "I525",
    "birthYear": 1767,
    "deathYear": 1841,
    "birthDate": "1767",
    "deathDate": "1841",
    "burialDate": "1841",
    "christeningDate": "11 Oct 1767",
    "birthPlace": "Pagham, Sussex, England",
    "deathPlace": "Pagham, Sussex, England, United Kingdom",
    "burialPlace": null,
    "christeningPlace": "Pagham, Sussex, England",
    "fsId": "LH1G-4YC",
    "photo": "/ancestors/bubbles/0128_LH1G-4YC.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0128_LH1G-4YC.jpg"
  },
  {
    "id": "AQI132",
    "name": "Letitia Hammond",
    "sex": "F",
    "gen": 7,
    "slot": 1,
    "side": "paternal",
    "birthplace": "england",
    "childId": "I525",
    "birthYear": 1771,
    "deathYear": 1844,
    "birthDate": "14 Jul 1771",
    "deathDate": "9 Sep 1844",
    "burialDate": null,
    "christeningDate": "14 Jul 1771",
    "birthPlace": "Eastergate, Sussex, England",
    "deathPlace": "South Bersted, Sussex, England, United Kingdom",
    "burialPlace": null,
    "christeningPlace": "Eastergate, Sussex, England",
    "fsId": "L21G-DKZ",
    "photo": "/ancestors/bubbles/0129_L21G-DKZ.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0129_L21G-DKZ.jpg"
  },
  {
    "id": "AQI133",
    "name": "John Coles",
    "sex": "M",
    "gen": 7,
    "slot": 2,
    "side": "paternal",
    "birthplace": "england",
    "childId": "I526",
    "birthYear": 1785,
    "deathYear": 1862,
    "birthDate": "24 Apr 1785",
    "deathDate": "27 Feb 1862",
    "burialDate": "Feb 1862",
    "christeningDate": "24 Apr 1785",
    "birthPlace": "Westbourne, Sussex, England",
    "deathPlace": "Sussex, England, United Kingdom",
    "burialPlace": "Sussex, England, United Kingdom",
    "christeningPlace": "Westbourne, Sussex, England, United Kingdom",
    "fsId": "LT46-3WY",
    "photo": "/ancestors/bubbles/0130_LT46-3WY.jpg",
    "living": false,
    "alternateNames": [
      "Mr. Cole"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0130_LT46-3WY.jpg"
  },
  {
    "id": "AQI134",
    "name": "Margaret Proudley",
    "sex": "F",
    "gen": 7,
    "slot": 3,
    "side": "paternal",
    "birthplace": "england",
    "childId": "I526",
    "birthYear": 1777,
    "deathYear": 1853,
    "birthDate": "Jul 1777",
    "deathDate": "5 Dec 1853",
    "burialDate": "5 Dec 1853",
    "christeningDate": "10 Aug 1777",
    "birthPlace": "Eighton Banks, Durham, England",
    "deathPlace": "Brighton, Sussex, England, United Kingdom",
    "burialPlace": "Brighton, Sussex, England, United Kingdom",
    "christeningPlace": "Lamesley, Durham, England, United Kingdom",
    "fsId": "LZXD-SC3",
    "photo": "/ancestors/bubbles/0131_LZXD-SC3.jpg",
    "living": false,
    "alternateNames": [
      "Margaret Pruddoe",
      "Mary",
      "Mary Cole",
      "Mary Preader"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0131_LZXD-SC3.jpg"
  },
  {
    "id": "AQI135",
    "name": "James White",
    "sex": "M",
    "gen": 7,
    "slot": 4,
    "side": "paternal",
    "birthplace": "england",
    "childId": "I529",
    "birthYear": 1787,
    "deathYear": 1867,
    "birthDate": "8 Aug 1787",
    "deathDate": "2 Oct 1867",
    "burialDate": "6 Oct 1867",
    "christeningDate": "12 Aug 1787",
    "birthPlace": "Yapton, Sussex, England, United Kingdom",
    "deathPlace": "Climping, Sussex, England, United Kingdom",
    "burialPlace": "Climping, Sussex, England, United Kingdom",
    "christeningPlace": null,
    "fsId": "L6NJ-SY4",
    "photo": null,
    "living": false,
    "alternateNames": [
      "James White Sr",
      "James White Jr",
      "James, Jr. White"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI136",
    "name": "Charlotte Newington",
    "sex": "F",
    "gen": 7,
    "slot": 5,
    "side": "paternal",
    "birthplace": "england",
    "childId": "I529",
    "birthYear": 1789,
    "deathYear": 1820,
    "birthDate": "Oct 1789",
    "deathDate": "14 Aug 1820",
    "burialDate": "14 Aug 1820",
    "christeningDate": "22 Nov 1788",
    "birthPlace": "Yapton, Sussex, England",
    "deathPlace": "Climping, Sussex, England, United Kingdom",
    "burialPlace": "Climping, Sussex, England, United Kingdom",
    "christeningPlace": "Barnham, Sussex, England, United Kingdom",
    "fsId": "KWV5-KF5",
    "photo": "/ancestors/bubbles/0133_KWV5-KF5.jpg",
    "living": false,
    "alternateNames": [
      "Charlotte White",
      "Charlotte Grace Newington",
      "Charlotte"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0133_KWV5-KF5.jpg"
  },
  {
    "id": "AQI137",
    "name": "Charles Chessel",
    "sex": "M",
    "gen": 7,
    "slot": 6,
    "side": "paternal",
    "birthplace": "england",
    "childId": "I530",
    "birthYear": 1780,
    "deathYear": 1850,
    "birthDate": "20 Dec 1780",
    "deathDate": "22 Mar 1850",
    "burialDate": null,
    "christeningDate": "28 Jan 1781",
    "birthPlace": "Climping, Sussex, England, United Kingdom",
    "deathPlace": "Climping, Sussex, England, United Kingdom",
    "burialPlace": null,
    "christeningPlace": "Climping, Sussex, England, United Kingdom",
    "fsId": "L4BF-5W4",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Charles Chissell",
      "Charles Chessell",
      "Charles Chesel",
      "Charles Chassel"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI138",
    "name": "Elizabeth Ashley",
    "sex": "F",
    "gen": 7,
    "slot": 7,
    "side": "paternal",
    "birthplace": "england",
    "childId": "I530",
    "birthYear": 1793,
    "deathYear": null,
    "birthDate": "14 Feb 1793",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "24 Mar 1793",
    "birthPlace": "Devizes, Wiltshire, England, United Kingdom",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Wiltshire, England, United Kingdom",
    "fsId": "MVCC-BTT",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Elizabeth Ashley Chessell",
      "Elizabeth Chepell"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI139",
    "name": "Christian Lehmann",
    "sex": "M",
    "gen": 7,
    "slot": 8,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "I505",
    "birthYear": 1774,
    "deathYear": 1846,
    "birthDate": "26 Aug 1774",
    "deathDate": "3 Apr 1846",
    "burialDate": "5 Apr 1846",
    "christeningDate": "26 Aug 1774",
    "birthPlace": "Worb, Bern, Switzerland",
    "deathPlace": null,
    "burialPlace": "Worb, Bern, Switzerland",
    "christeningPlace": "Worb, Bern, Switzerland",
    "fsId": "KCMB-31J",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Christen Leemann"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI140",
    "name": "Anna Leüenberger",
    "sex": "F",
    "gen": 7,
    "slot": 9,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "I505",
    "birthYear": 1777,
    "deathYear": 1814,
    "birthDate": "1777",
    "deathDate": "6 Apr 1814",
    "burialDate": null,
    "christeningDate": "7 May 1778",
    "birthPlace": "Rüderswil, Bern, Switzerland",
    "deathPlace": "Rüderswil, Bern, Switzerland",
    "burialPlace": null,
    "christeningPlace": "Rüderswil, Bern, Switzerland",
    "fsId": "LZ6R-L23",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Anna Leuenberger"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI141",
    "name": "Johannes Maurer",
    "sex": "M",
    "gen": 7,
    "slot": 10,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "I500",
    "birthYear": 1758,
    "deathYear": 1836,
    "birthDate": "3 Dec 1758",
    "deathDate": "1 Nov 1836",
    "burialDate": "3 Nov 1836",
    "christeningDate": null,
    "birthPlace": "Niederwichtrach, Wichtrach, Bern, Switzerland",
    "deathPlace": "Wichtrach, Bern, Switzerland",
    "burialPlace": "Niederwichtrach, Wichtrach, Bern, Switzerland",
    "christeningPlace": null,
    "fsId": "9CDP-YXR",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI142",
    "name": "Magdalena Krayenbuehl",
    "sex": "F",
    "gen": 7,
    "slot": 11,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "I500",
    "birthYear": 1769,
    "deathYear": 1859,
    "birthDate": "Sep 1769",
    "deathDate": "20 Jul 1859",
    "burialDate": null,
    "christeningDate": "1 Dec 1787",
    "birthPlace": "Oberdiessbach, Bern, Switzerland",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "9CDP-YXT",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Magdalena Kraehenbuehl"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI143",
    "name": "Johannes Krebs",
    "sex": "M",
    "gen": 7,
    "slot": 12,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "I499",
    "birthYear": 1786,
    "deathYear": 1845,
    "birthDate": "9 Jun 1786",
    "deathDate": "4 Sep 1845",
    "burialDate": "7 Sep 1845",
    "christeningDate": null,
    "birthPlace": "Kirchdorf, Bern, Switzerland",
    "deathPlace": "Gysenstein, Konolfingen, Bern, Switzerland",
    "burialPlace": "Münsingen, Bern, Switzerland",
    "christeningPlace": null,
    "fsId": "2979-ZZB",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Hans Krebs",
      "Hans Krebs Joss"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI144",
    "name": "Anna Barbara Joss",
    "sex": "F",
    "gen": 7,
    "slot": 13,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "I499",
    "birthYear": 1795,
    "deathYear": 1873,
    "birthDate": "22 Apr 1795",
    "deathDate": "9 Aug 1873",
    "burialDate": "12 Aug 1873",
    "christeningDate": null,
    "birthPlace": "Kirchdorf, Bern, Switzerland",
    "deathPlace": "Sankt Gallen, Switzerland",
    "burialPlace": "St. Gallen, Sankt Gallen, Switzerland",
    "christeningPlace": null,
    "fsId": "LHQV-DBP",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Anna Barbara",
      "Anna Barbara Krebs Joss"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI145",
    "name": "Christian Probst",
    "sex": "M",
    "gen": 7,
    "slot": 14,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "I501",
    "birthYear": 1803,
    "deathYear": 1881,
    "birthDate": "1803",
    "deathDate": "Mar 1881",
    "burialDate": "3 Mar 1881",
    "christeningDate": "11 Feb 1803",
    "birthPlace": "Lützelflüh, Bern, Switzerland",
    "deathPlace": "Sevier, Utah, United States",
    "burialPlace": "Richfield, Sevier, Utah, United States",
    "christeningPlace": "Lützelflüh, Bern, Switzerland",
    "fsId": "KWNT-4J7",
    "photo": "/ancestors/bubbles/0142_KWNT-4J7.jpg",
    "living": false,
    "alternateNames": [
      "Christen Probst"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0142_KWNT-4J7.jpg"
  },
  {
    "id": "AQI146",
    "name": "Anna Barbara Steiner",
    "sex": "F",
    "gen": 7,
    "slot": 15,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "I501",
    "birthYear": 1804,
    "deathYear": 1836,
    "birthDate": "12 Oct 1804",
    "deathDate": "16 Mar 1836",
    "burialDate": "19 Mar 1836",
    "christeningDate": "12 Aug 1804",
    "birthPlace": "Trachselwald, Bern, Switzerland",
    "deathPlace": "Trachselwald, Bern, Switzerland",
    "burialPlace": "Trachselwald, Bern, Switzerland",
    "christeningPlace": "Trachselwald, Bern, Switzerland",
    "fsId": "LLQC-7KT",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Barbara Probst Steiner"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI149",
    "name": "John Stuart",
    "sex": "M",
    "gen": 7,
    "slot": 16,
    "side": "paternal",
    "birthplace": "england",
    "childId": "I416",
    "birthYear": 1781,
    "deathYear": 1853,
    "birthDate": "22 Dec 1781",
    "deathDate": "6 Jan 1853",
    "burialDate": "6 Jan 1853",
    "christeningDate": "30 Jun 1782",
    "birthPlace": "Kendal, Westmorland, England, United Kingdom",
    "deathPlace": "Kendal Ward, Westmorland, England, United Kingdom",
    "burialPlace": "Kendal, Westmorland, England, United Kingdom",
    "christeningPlace": "Kendal, Westmorland, England",
    "fsId": "LC37-38X",
    "photo": "/ancestors/bubbles/0144_LC37-38X.jpg",
    "living": false,
    "alternateNames": [
      "John Steward",
      "John Stewart"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0144_LC37-38X.jpg"
  },
  {
    "id": "AQI150",
    "name": "Christian Munro",
    "sex": "F",
    "gen": 7,
    "slot": 17,
    "side": "paternal",
    "birthplace": "scotland",
    "childId": "I416",
    "birthYear": 1785,
    "deathYear": 1836,
    "birthDate": "20 Jun 1785",
    "deathDate": "8 Feb 1836",
    "burialDate": "8 Feb 1836",
    "christeningDate": null,
    "birthPlace": "Glasgow, Lanarkshire, Scotland, United Kingdom",
    "deathPlace": "Kendal, Westmorland, England, United Kingdom",
    "burialPlace": "Holy Trinity Church, Kendal, Westmorland, England, United Kingdom",
    "christeningPlace": null,
    "fsId": "LC37-3D6",
    "photo": "/ancestors/bubbles/0145_LC37-3D6.jpg",
    "living": false,
    "alternateNames": [
      "Christiana Monrow",
      "Christiania Monroe",
      "Christina Munro"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0145_LC37-3D6.jpg"
  },
  {
    "id": "AQI151",
    "name": "Adam Huddleston",
    "sex": "M",
    "gen": 7,
    "slot": 18,
    "side": "paternal",
    "birthplace": "england",
    "childId": "I412",
    "birthYear": 1789,
    "deathYear": 1875,
    "birthDate": "5 Aug 1789",
    "deathDate": "2 Jan 1875",
    "burialDate": null,
    "christeningDate": "16 Aug 1789",
    "birthPlace": "Staveley, Westmorland, England, United Kingdom",
    "deathPlace": "Kendal, Westmorland, England, United Kingdom",
    "burialPlace": null,
    "christeningPlace": "Staveley, Lancashire, England, United Kingdom",
    "fsId": "L75D-J1M",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Adam Huddlestone"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI152",
    "name": "Margaret Nelson",
    "sex": "F",
    "gen": 7,
    "slot": 19,
    "side": "paternal",
    "birthplace": "england",
    "childId": "I412",
    "birthYear": 1787,
    "deathYear": 1869,
    "birthDate": "1787",
    "deathDate": "19 Apr 1869",
    "burialDate": null,
    "christeningDate": "13 May 1787",
    "birthPlace": "Witherslack, Westmorland, England, United Kingdom",
    "deathPlace": "Staveley, Westmorland, England, United Kingdom",
    "burialPlace": null,
    "christeningPlace": "Lindale, Lancashire, England",
    "fsId": "LCF4-FBY",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Margt Nelson",
      "Margret Melson",
      "Margaret Wilson",
      "Margt. Nelson"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI153",
    "name": "Evan Evans",
    "sex": "M",
    "gen": 7,
    "slot": 20,
    "side": "paternal",
    "birthplace": "wales",
    "childId": "I402",
    "birthYear": 1777,
    "deathYear": 1868,
    "birthDate": "1777",
    "deathDate": "15 Nov 1868",
    "burialDate": null,
    "christeningDate": "28 Aug 1785",
    "birthPlace": "Llanybyther, Carmarthenshire, Wales, United Kingdom",
    "deathPlace": "Glamorgan, Wales, United Kingdom",
    "burialPlace": null,
    "christeningPlace": "Liverpool, Lancashire, England, United Kingdom",
    "fsId": "LL97-FZG",
    "photo": "/ancestors/bubbles/0148_LL97-FZG.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0148_LL97-FZG.jpg"
  },
  {
    "id": "AQI154",
    "name": "Jemima Lewis",
    "sex": "F",
    "gen": 7,
    "slot": 21,
    "side": "paternal",
    "birthplace": "wales",
    "childId": "I402",
    "birthYear": 1787,
    "deathYear": 1867,
    "birthDate": "1787",
    "deathDate": "Jan 1867",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Pencarreg, Carmarthenshire, Wales, United Kingdom",
    "deathPlace": "Llandovery, Carmarthenshire, Wales, United Kingdom",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LL9C-ZWN",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Jeminah"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI155",
    "name": "Benjamin Davies",
    "sex": "M",
    "gen": 7,
    "slot": 22,
    "side": "paternal",
    "birthplace": "wales",
    "childId": "I403",
    "birthYear": 1777,
    "deathYear": 1887,
    "birthDate": "1777",
    "deathDate": "1887",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Llanfynydd, Carmarthenshire, Wales, United Kingdom",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LRFK-HSQ",
    "photo": "/ancestors/bubbles/0150_LRFK-HSQ.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0150_LRFK-HSQ.jpg"
  },
  {
    "id": "AQI156",
    "name": "Sarah Edwards",
    "sex": "F",
    "gen": 7,
    "slot": 23,
    "side": "paternal",
    "birthplace": "wales",
    "childId": "I403",
    "birthYear": 1781,
    "deathYear": null,
    "birthDate": "1781",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Llanfynydd, Carmarthenshire, Wales",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LR7W-G7C",
    "photo": "/ancestors/bubbles/0151_LR7W-G7C.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0151_LR7W-G7C.jpg"
  },
  {
    "id": "AQI157",
    "name": "David Thomas",
    "sex": "M",
    "gen": 7,
    "slot": 24,
    "side": "paternal",
    "birthplace": "wales",
    "childId": "I378",
    "birthYear": 1786,
    "deathYear": 1861,
    "birthDate": "Abt 1786",
    "deathDate": "7 Jun 1861",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Pembrey, Carmarthenshire, Wales",
    "deathPlace": "Pembrey, Carmarthenshire, Wales, United Kingdom",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LLMV-XFY",
    "photo": "/ancestors/bubbles/0152_LLMV-XFY.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0152_LLMV-XFY.jpg"
  },
  {
    "id": "AQI158",
    "name": "Elizabeth Williams",
    "sex": "F",
    "gen": 7,
    "slot": 25,
    "side": "paternal",
    "birthplace": "wales",
    "childId": "I378",
    "birthYear": 1794,
    "deathYear": 1832,
    "birthDate": "before about 23 August 1794",
    "deathDate": "Abt 1832",
    "burialDate": null,
    "christeningDate": "23 Aug 1794",
    "birthPlace": "Pembrey, Carmarthenshire, Wales, United Kingdom",
    "deathPlace": "Pembrey, Carmarthenshire, Wales, United Kingdom",
    "burialPlace": null,
    "christeningPlace": "Pembrey, Carmarthenshire, Wales, United Kingdom",
    "fsId": "G6P3-4T6",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Elizabeth"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI159",
    "name": "Thomas Sparrey",
    "sex": "M",
    "gen": 7,
    "slot": 26,
    "side": "paternal",
    "birthplace": "england",
    "childId": "I375",
    "birthYear": 1810,
    "deathYear": 1876,
    "birthDate": "1810",
    "deathDate": "17 Jan 1876",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Rowington, Warwickshire, England, United Kingdom",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "L5XZ-HC6",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Thomas Sparrow"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI160",
    "name": "Sarah Adams",
    "sex": "F",
    "gen": 7,
    "slot": 27,
    "side": "paternal",
    "birthplace": "england",
    "childId": "I375",
    "birthYear": 1814,
    "deathYear": null,
    "birthDate": "1814",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "1 May 1814",
    "birthPlace": "Staffordshire, England, United Kingdom",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Halesowen, Worcestershire, England, United Kingdom",
    "fsId": "KJ6Z-VBP",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Sarah Sparrey"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI161",
    "name": "Richard Henry Dredge",
    "sex": "M",
    "gen": 7,
    "slot": 28,
    "side": "paternal",
    "birthplace": "england",
    "childId": "I374",
    "birthYear": 1795,
    "deathYear": 1857,
    "birthDate": "25 Dec 1795",
    "deathDate": "1 Jan 1857",
    "burialDate": "3 Jan 1857",
    "christeningDate": "25 Dec 1795",
    "birthPlace": "Frome, Somerset, England, United Kingdom",
    "deathPlace": "Abergavenny, Monmouthshire, Wales, United Kingdom",
    "burialPlace": "Blaina, Monmouthshire, Wales, United Kingdom",
    "christeningPlace": "Frome, Somerset, England, United Kingdom",
    "fsId": "L5XZ-WKB",
    "photo": "/ancestors/bubbles/0156_L5XZ-WKB.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0156_L5XZ-WKB.jpg"
  },
  {
    "id": "AQI162",
    "name": "Sarah Sharp",
    "sex": "F",
    "gen": 7,
    "slot": 29,
    "side": "paternal",
    "birthplace": "england",
    "childId": "I374",
    "birthYear": 1798,
    "deathYear": 1869,
    "birthDate": "Abt 1798",
    "deathDate": "22 Oct 1869",
    "burialDate": "26 Oct 1869",
    "christeningDate": null,
    "birthPlace": "Minchinhampton, Gloucestershire, England, United Kingdom",
    "deathPlace": "Blaina, Monmouthshire, Wales, United Kingdom",
    "burialPlace": "Blaina, Monmouthshire, Wales, United Kingdom",
    "christeningPlace": null,
    "fsId": "L5XZ-CBG",
    "photo": "/ancestors/bubbles/0157_L5XZ-CBG.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0157_L5XZ-CBG.jpg"
  },
  {
    "id": "AQI163",
    "name": "Horatio Nelson Rhees",
    "sex": "M",
    "gen": 7,
    "slot": 30,
    "side": "paternal",
    "birthplace": "england",
    "childId": "I368",
    "birthYear": 1802,
    "deathYear": 1847,
    "birthDate": "3 Jul 1802",
    "deathDate": "20 Feb 1847",
    "burialDate": "28 Feb 1847",
    "christeningDate": "9 Oct 1809",
    "birthPlace": "Bath, Somerset, England, United Kingdom",
    "deathPlace": "Bath, Somerset, England, United Kingdom",
    "burialPlace": "Widcombe, Somerset, England, United Kingdom",
    "christeningPlace": "Widcombe, Somerset, England, United Kingdom",
    "fsId": "LB5V-QK3",
    "photo": "/ancestors/bubbles/0158_LB5V-QK3.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0158_LB5V-QK3.jpg"
  },
  {
    "id": "AQI164",
    "name": "Sarah Ann Green",
    "sex": "F",
    "gen": 7,
    "slot": 31,
    "side": "paternal",
    "birthplace": "england",
    "childId": "I368",
    "birthYear": 1798,
    "deathYear": 1869,
    "birthDate": "25 Jul 1798",
    "deathDate": "19 Dec 1869",
    "burialDate": null,
    "christeningDate": "19 Aug 1798",
    "birthPlace": "Bath St Michael, Somerset, England, United Kingdom",
    "deathPlace": "Bath, Somerset, England, United Kingdom",
    "burialPlace": null,
    "christeningPlace": "Bath St Michael, Somerset, England",
    "fsId": "L5F4-BZG",
    "photo": "/ancestors/bubbles/0159_L5F4-BZG.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0159_L5F4-BZG.jpg"
  },
  {
    "id": "AQI165",
    "name": "Francis Vinal Hull",
    "sex": "M",
    "gen": 7,
    "slot": 32,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "I418",
    "birthYear": 1801,
    "deathYear": 1857,
    "birthDate": "Abt 1801",
    "deathDate": "1857",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Pittsford, Pittsford, Monroe, New York, United States",
    "deathPlace": "Placerville, El Dorado, California, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "KF45-275",
    "photo": "/ancestors/bubbles/0160_KF45-275.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0160_KF45-275.jpg"
  },
  {
    "id": "AQI166",
    "name": "Polley Lee",
    "sex": "F",
    "gen": 7,
    "slot": 33,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "I418",
    "birthYear": 1801,
    "deathYear": 1839,
    "birthDate": "1801",
    "deathDate": "9 Jul 1839",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "New York, United States",
    "deathPlace": "Fayetteville, Manlius, Onondaga, New York, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "KN34-4KR",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Polly Lee"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI167",
    "name": "Edmund Lindsey",
    "sex": "M",
    "gen": 7,
    "slot": 34,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "I417",
    "birthYear": 1800,
    "deathYear": 1853,
    "birthDate": "29 Nov 1800",
    "deathDate": "29 Dec 1853",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Maine, United States",
    "deathPlace": "Mendota, LaSalle, Illinois, United States",
    "burialPlace": "Fourmile Grove Cemetery, Earlville, LaSalle, Illinois, United States",
    "christeningPlace": null,
    "fsId": "KF45-M7V",
    "photo": "/ancestors/bubbles/0162_KF45-M7V.jpg",
    "living": false,
    "alternateNames": [
      "Edmund Lindsay"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0162_KF45-M7V.jpg"
  },
  {
    "id": "AQI168",
    "name": "Mahittable Bunker",
    "sex": "F",
    "gen": 7,
    "slot": 35,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "I417",
    "birthYear": 1799,
    "deathYear": 1867,
    "birthDate": "1799",
    "deathDate": "1 Nov 1867",
    "burialDate": "1867",
    "christeningDate": null,
    "birthPlace": "New Hampshire, United States",
    "deathPlace": null,
    "burialPlace": "Meriden, LaSalle, Illinois, United States",
    "christeningPlace": null,
    "fsId": "9NTJ-RKY",
    "photo": "/ancestors/bubbles/0163_9NTJ-RKY.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0163_9NTJ-RKY.jpg"
  },
  {
    "id": "AQI169",
    "name": "Isaac Benedict",
    "sex": "M",
    "gen": 7,
    "slot": 36,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "I414",
    "birthYear": 1794,
    "deathYear": 1875,
    "birthDate": "18 Jan 1794",
    "deathDate": "12 Feb 1875",
    "burialDate": "1875",
    "christeningDate": null,
    "birthPlace": "Manchester, Bennington, Vermont, United States",
    "deathPlace": "Saint Paul, Lee, Iowa, United States",
    "burialPlace": "Saint Paul, Lee, Iowa, United States",
    "christeningPlace": null,
    "fsId": "KWVG-7ZC",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI170",
    "name": "Rebecca Wing",
    "sex": "F",
    "gen": 7,
    "slot": 37,
    "side": "paternal",
    "birthplace": "canada",
    "childId": "I414",
    "birthYear": 1797,
    "deathYear": 1878,
    "birthDate": "29 Jan 1797",
    "deathDate": "1 Aug 1878",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Elizabethtown-Kitley Township, Leeds and Grenville, Ontario, Canada",
    "deathPlace": "Iowa, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "2MP5-NNL",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI171",
    "name": "David Hammer",
    "sex": "M",
    "gen": 7,
    "slot": 38,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "I415",
    "birthYear": 1801,
    "deathYear": 1846,
    "birthDate": "18 Nov 1801",
    "deathDate": "26 Dec 1846",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Newberry, South Carolina, United States",
    "deathPlace": "West Point, Lee, Iowa, United States",
    "burialPlace": "Lee, Iowa, United States",
    "christeningPlace": null,
    "fsId": "KGM1-W27",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI172",
    "name": "Mary Lewellyn",
    "sex": "F",
    "gen": 7,
    "slot": 39,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "I415",
    "birthYear": 1809,
    "deathYear": 1885,
    "birthDate": "26 Mar 1809",
    "deathDate": "21 Dec 1885",
    "burialDate": "Dec 1885",
    "christeningDate": null,
    "birthPlace": "Pennsylvania, United States",
    "deathPlace": "Maryville, Missouri, United States",
    "burialPlace": "New Hope Cemetery, Independence Township, Nodaway, Missouri, United States",
    "christeningPlace": null,
    "fsId": "L8X6-VML",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Mary Lewellen",
      "Mary Llewellyn"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI173",
    "name": "Moses Cranor",
    "sex": "M",
    "gen": 7,
    "slot": 40,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "I395",
    "birthYear": 1807,
    "deathYear": 1875,
    "birthDate": "12 Sep 1807",
    "deathDate": "14 Nov 1875",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Greensboro, Guilford, North Carolina, United States",
    "deathPlace": "Altoona, Wilson, Kansas, United States",
    "burialPlace": "Altoona Cemetery, Altoona, Wilson, Kansas, United States",
    "christeningPlace": null,
    "fsId": "KH8G-H6J",
    "photo": "/ancestors/bubbles/0168_KH8G-H6J.jpg",
    "living": false,
    "alternateNames": [
      "Moses J. Cranor III"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0168_KH8G-H6J.jpg"
  },
  {
    "id": "AQI174",
    "name": "Jane Stephenson",
    "sex": "F",
    "gen": 7,
    "slot": 41,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "I395",
    "birthYear": 1809,
    "deathYear": 1882,
    "birthDate": "27 Nov 1809",
    "deathDate": "16 Sep 1882",
    "burialDate": "1882",
    "christeningDate": null,
    "birthPlace": "Greensboro, Guilford, North Carolina, United States",
    "deathPlace": "Altoona, Wilson, Kansas, United States",
    "burialPlace": "Altoona Cemetery, Altoona, Wilson, Kansas, United States",
    "christeningPlace": null,
    "fsId": "LZZH-2HM",
    "photo": "/ancestors/bubbles/0169_LZZH-2HM.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0169_LZZH-2HM.jpg"
  },
  {
    "id": "AQI175",
    "name": "James Edwards",
    "sex": "M",
    "gen": 7,
    "slot": 42,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "I386",
    "birthYear": 1800,
    "deathYear": 1837,
    "birthDate": "29 Dec 1800",
    "deathDate": "26 Jul 1837",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Guilford, North Carolina, United States",
    "deathPlace": "Guilford, North Carolina, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "L5XW-5JC",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI176",
    "name": "Sarah Cranor",
    "sex": "F",
    "gen": 7,
    "slot": 43,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "I386",
    "birthYear": 1805,
    "deathYear": 1899,
    "birthDate": "9 Apr 1805",
    "deathDate": "25 Oct 1899",
    "burialDate": "1899",
    "christeningDate": null,
    "birthPlace": "Guilford, North Carolina, United States",
    "deathPlace": null,
    "burialPlace": "Christian Privilege Cemetery, Saint Charles, Hopkins, Kentucky, United States",
    "christeningPlace": null,
    "fsId": "97P1-FGV",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Sarah Edwards"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI177",
    "name": "Taliferro Mendenhall",
    "sex": "M",
    "gen": 7,
    "slot": 44,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "I383",
    "birthYear": 1812,
    "deathYear": 1835,
    "birthDate": "Abt 1812",
    "deathDate": "5 Mar 1835",
    "burialDate": "Mar 1835",
    "christeningDate": null,
    "birthPlace": "Ohio, United States",
    "deathPlace": "Fountain, Indiana, United States",
    "burialPlace": "Spring Hill Cemetery, Hillsboro, Cain Township, Fountain, Indiana, United States",
    "christeningPlace": null,
    "fsId": "L413-F9B",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Telliferro Mendenhall",
      "Taliaferro Mendenhall",
      "Tolliferro Mendenhall"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI178",
    "name": "Jane A Bristow",
    "sex": "F",
    "gen": 7,
    "slot": 45,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "I383",
    "birthYear": 1810,
    "deathYear": 1899,
    "birthDate": "11 Mar 1810",
    "deathDate": "29 Mar 1899",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Kentucky, United States",
    "deathPlace": "Havana, Montgomery, Kansas, United States",
    "burialPlace": "Havana Cemetery, Havana, Montgomery, Kansas, United States",
    "christeningPlace": null,
    "fsId": "LHXG-X68",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Jane A Mendenhall",
      "Jane Bristo"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI179",
    "name": "Jeremiah Hoel",
    "sex": "M",
    "gen": 7,
    "slot": 46,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "I384",
    "birthYear": 1806,
    "deathYear": 1875,
    "birthDate": "18 Aug 1806",
    "deathDate": "13 Mar 1875",
    "burialDate": "1875",
    "christeningDate": null,
    "birthPlace": "Hamilton, Ohio, United States",
    "deathPlace": "Anna, Union, Illinois, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LCDW-QF4",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI180",
    "name": "Charlotte Van Meter",
    "sex": "F",
    "gen": 7,
    "slot": 47,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "I384",
    "birthYear": 1817,
    "deathYear": null,
    "birthDate": "8 Sep 1817",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "8 Sep 1817",
    "birthPlace": "Fonda, Mohawk, Montgomery, New York, United States",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Montgomery, New York, United States",
    "fsId": "KCG4-TJ7",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Charlotte Van_ Meter"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI181",
    "name": "Richard Blackner",
    "sex": "M",
    "gen": 7,
    "slot": 48,
    "side": "paternal",
    "birthplace": "england",
    "childId": "I453",
    "birthYear": 1795,
    "deathYear": 1834,
    "birthDate": "5 Apr 1795",
    "deathDate": "1834",
    "burialDate": null,
    "christeningDate": "5 Apr 1795",
    "birthPlace": "Hucknall Torkard, Nottinghamshire, England",
    "deathPlace": "Sunderland, Durham, England, United Kingdom",
    "burialPlace": null,
    "christeningPlace": "Hucknall Torkard, Nottinghamshire, England",
    "fsId": "LL9F-V9S",
    "photo": "/ancestors/bubbles/0176_LL9F-V9S.jpg",
    "living": false,
    "alternateNames": [
      "Richard Blacknar",
      "Richard Blacknell"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0176_LL9F-V9S.jpg"
  },
  {
    "id": "AQI182",
    "name": "Elizabeth Hall",
    "sex": "F",
    "gen": 7,
    "slot": 49,
    "side": "paternal",
    "birthplace": "england",
    "childId": "I453",
    "birthYear": 1797,
    "deathYear": 1893,
    "birthDate": "9 Oct 1797",
    "deathDate": "1 Aug 1893",
    "burialDate": "Aft 1 Aug 1893",
    "christeningDate": "11 Oct 1797",
    "birthPlace": "Heckington, Lincolnshire, England",
    "deathPlace": "Greenville, Beaver, Utah, United States",
    "burialPlace": "Mountain View Cemetery, Beaver, Beaver, Utah, United States",
    "christeningPlace": "Heckington, Lincolnshire, England, United Kingdom",
    "fsId": "KWJF-D3T",
    "photo": "/ancestors/bubbles/0177_KWJF-D3T.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0177_KWJF-D3T.jpg"
  },
  {
    "id": "AQI183",
    "name": "Leonard Allen",
    "sex": "M",
    "gen": 7,
    "slot": 50,
    "side": "paternal",
    "birthplace": "england",
    "childId": "I457",
    "birthYear": 1807,
    "deathYear": 1873,
    "birthDate": "29 Dec 1807",
    "deathDate": "13 Oct 1873",
    "burialDate": "16 Oct 1873",
    "christeningDate": "10 Jan 1808",
    "birthPlace": "Sheffield, Yorkshire, England, United Kingdom",
    "deathPlace": "Kimberworth, Yorkshire, England, United Kingdom",
    "burialPlace": "Kimberworth, Yorkshire, England, United Kingdom",
    "christeningPlace": "Sheffield, Yorkshire, England, United Kingdom",
    "fsId": "KP99-64X",
    "photo": "/ancestors/bubbles/0178_KP99-64X.jpg",
    "living": false,
    "alternateNames": [
      "David Leonard Allen"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0178_KP99-64X.jpg"
  },
  {
    "id": "AQI184",
    "name": "Mary Lindley",
    "sex": "F",
    "gen": 7,
    "slot": 51,
    "side": "paternal",
    "birthplace": "england",
    "childId": "I457",
    "birthYear": 1812,
    "deathYear": 1893,
    "birthDate": "13 Dec 1812",
    "deathDate": "3 Feb 1893",
    "burialDate": "5 Feb 1893",
    "christeningDate": "2 Mar 1825",
    "birthPlace": "Worksop, Nottinghamshire, England, United Kingdom",
    "deathPlace": "Kimberworth, Yorkshire, England, United Kingdom",
    "burialPlace": "Kimberworth, Yorkshire, England, United Kingdom",
    "christeningPlace": "Worksop, Nottinghamshire, England, United Kingdom",
    "fsId": "LM43-ZCM",
    "photo": "/ancestors/bubbles/0179_LM43-ZCM.jpg",
    "living": false,
    "alternateNames": [
      "Sarah Mary Linley"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0179_LM43-ZCM.jpg"
  },
  {
    "id": "AQI185",
    "name": "James Eyre",
    "sex": "M",
    "gen": 7,
    "slot": 52,
    "side": "paternal",
    "birthplace": "england",
    "childId": "I448",
    "birthYear": 1793,
    "deathYear": 1865,
    "birthDate": "29 Jul 1793",
    "deathDate": "17 Sep 1865",
    "burialDate": "Sep 1865",
    "christeningDate": "29 Jul 1795",
    "birthPlace": "Quarrington, Lincolnshire, England",
    "deathPlace": "Fort Bridger, Uinta, Wyoming, United States",
    "burialPlace": "Lincoln, Wyoming, United States",
    "christeningPlace": "Quarrington, Lincolnshire, England",
    "fsId": "KWJW-RYX",
    "photo": "/ancestors/bubbles/0180_KWJW-RYX.jpg",
    "living": false,
    "alternateNames": [
      "James Hare"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0180_KWJW-RYX.jpg"
  },
  {
    "id": "AQI186",
    "name": "Ann Naylor",
    "sex": "F",
    "gen": 7,
    "slot": 53,
    "side": "paternal",
    "birthplace": "england",
    "childId": "I448",
    "birthYear": 1798,
    "deathYear": 1865,
    "birthDate": "12 Nov 1798",
    "deathDate": "28 May 1865",
    "burialDate": "28 May 1865",
    "christeningDate": "12 Nov 1798",
    "birthPlace": "Heckington, Lincolnshire, England",
    "deathPlace": "Atlantic Ocean",
    "burialPlace": "Atlantic Ocean",
    "christeningPlace": "Heckington, Lincolnshire, England",
    "fsId": "KWJW-RY6",
    "photo": "/ancestors/bubbles/0181_KWJW-RY6.jpg",
    "living": false,
    "alternateNames": [
      "Ann Eyre",
      "Ann Hare",
      "Ann Nailor",
      "Ann Naulor"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0181_KWJW-RY6.jpg"
  },
  {
    "id": "AQI187",
    "name": "Edward Hopkins",
    "sex": "M",
    "gen": 7,
    "slot": 54,
    "side": "paternal",
    "birthplace": "england",
    "childId": "I441",
    "birthYear": 1807,
    "deathYear": 1874,
    "birthDate": "14 Feb 1807",
    "deathDate": "1 Sep 1874",
    "burialDate": "5 Sep 1874",
    "christeningDate": "29 Mar 1807",
    "birthPlace": "Wakefield, Yorkshire, England, United Kingdom",
    "deathPlace": "Sheffield, Yorkshire, England",
    "burialPlace": "Sheffield, Yorkshire, England",
    "christeningPlace": "Wakefield, Yorkshire, England, United Kingdom",
    "fsId": "KWJX-9R9",
    "photo": "/ancestors/bubbles/0182_KWJX-9R9.jpg",
    "living": false,
    "alternateNames": [
      "Edwin Hopkins",
      "Edward Hopkin"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0182_KWJX-9R9.jpg"
  },
  {
    "id": "AQI188",
    "name": "Hannah Marrison",
    "sex": "F",
    "gen": 7,
    "slot": 55,
    "side": "paternal",
    "birthplace": "england",
    "childId": "I441",
    "birthYear": 1810,
    "deathYear": 1876,
    "birthDate": "13 May 1810",
    "deathDate": "11 Jan 1876",
    "burialDate": "15 Jan 1876",
    "christeningDate": "13 May 1810",
    "birthPlace": "Castleton, Derbyshire, England, United Kingdom",
    "deathPlace": "Sheffield, Yorkshire, England, United Kingdom",
    "burialPlace": "Sheffield, Yorkshire, England, United Kingdom",
    "christeningPlace": "Castleton, Derbyshire, England, United Kingdom",
    "fsId": "KWJ4-QH3",
    "photo": "/ancestors/bubbles/0183_KWJ4-QH3.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0183_KWJ4-QH3.jpg"
  },
  {
    "id": "AQI189",
    "name": "Robert Briggs",
    "sex": "M",
    "gen": 7,
    "slot": 56,
    "side": "paternal",
    "birthplace": "england",
    "childId": "I498",
    "birthYear": 1795,
    "deathYear": 1863,
    "birthDate": "1795",
    "deathDate": "20 May 1863",
    "burialDate": "22 May 1863",
    "christeningDate": "25 Sep 1795",
    "birthPlace": "Grindleton, Yorkshire, England",
    "deathPlace": "Lancashire, England, United Kingdom",
    "burialPlace": "Lancashire, England, United Kingdom",
    "christeningPlace": "Grindleton, Yorkshire, England",
    "fsId": "L8YJ-W58",
    "photo": "/ancestors/bubbles/0184_L8YJ-W58.jpg",
    "living": false,
    "alternateNames": [
      "Robert Brigg"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0184_L8YJ-W58.jpg"
  },
  {
    "id": "AQI190",
    "name": "Mary Hawarth",
    "sex": "F",
    "gen": 7,
    "slot": 57,
    "side": "paternal",
    "birthplace": "england",
    "childId": "I498",
    "birthYear": 1797,
    "deathYear": null,
    "birthDate": "9 Mar 1797",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "21 Mar 1797",
    "birthPlace": "Accrington, Lancashire, England",
    "deathPlace": "Accrington, Lancashire, England, United Kingdom",
    "burialPlace": null,
    "christeningPlace": "St James' Church, Accrington, Lancashire, England",
    "fsId": "LC3R-TFN",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Mary Howorth",
      "Jamima Mary Howarth",
      "Nancy Howarth",
      "Mrs. Mary Briggs",
      "Mary Howarth Briggs",
      "Mary Jamima Howarth"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI191",
    "name": "John Fielding",
    "sex": "M",
    "gen": 7,
    "slot": 58,
    "side": "paternal",
    "birthplace": "england",
    "childId": "I483",
    "birthYear": 1802,
    "deathYear": 1878,
    "birthDate": "30 Sep 1802",
    "deathDate": "1 Feb 1878",
    "burialDate": null,
    "christeningDate": "5 Dec 1802",
    "birthPlace": "Blackburn, Lancashire, England, United Kingdom",
    "deathPlace": "Accrington, Lancashire, England, United Kingdom",
    "burialPlace": "Accrington, Lancashire, England, United Kingdom",
    "christeningPlace": "Blackburn Cathedral, Blackburn, Lancashire, England, United Kingdom",
    "fsId": "KV1Z-21C",
    "photo": "/ancestors/bubbles/0186_KV1Z-21C.jpg",
    "living": false,
    "alternateNames": [
      "John Fielden",
      "John F. Fielding"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0186_KV1Z-21C.jpg"
  },
  {
    "id": "AQI192",
    "name": "Nancy Holden",
    "sex": "F",
    "gen": 7,
    "slot": 59,
    "side": "paternal",
    "birthplace": "england",
    "childId": "I483",
    "birthYear": 1799,
    "deathYear": 1873,
    "birthDate": "20 Jul 1799",
    "deathDate": "14 Jun 1873",
    "burialDate": "18 Jun 1873",
    "christeningDate": "8 Sep 1799",
    "birthPlace": "Lower Darwen, Lancashire, England, United Kingdom",
    "deathPlace": "Oswaldtwistle, Lancashire, England, United Kingdom",
    "burialPlace": "Oswaldtwistle, Lancashire, England, United Kingdom",
    "christeningPlace": "Blackburn, Lancashire, England, United Kingdom",
    "fsId": "2WCM-NF1",
    "photo": "/ancestors/bubbles/0187_2WCM-NF1.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0187_2WCM-NF1.jpg"
  },
  {
    "id": "AQI193",
    "name": "Jacob Olander Henrichsen Almind",
    "sex": "M",
    "gen": 7,
    "slot": 62,
    "side": "paternal",
    "birthplace": "denmark",
    "childId": "I465",
    "birthYear": 1803,
    "deathYear": 1889,
    "birthDate": "26 Mar 1803",
    "deathDate": "5 Feb 1889",
    "burialDate": null,
    "christeningDate": "11 Apr 1803",
    "birthPlace": "Garnisons, Sokkelund, Copenhagen, Denmark",
    "deathPlace": "Manti, Sanpete, Utah, United States",
    "burialPlace": null,
    "christeningPlace": "Copenhagen, Copenhagen, Denmark",
    "fsId": "LHP4-8B4",
    "photo": "/ancestors/bubbles/0190_LHP4-8B4.jpg",
    "living": false,
    "alternateNames": [
      "Olander Almind",
      "Jacob Olander Almind",
      "Jacob Henrichsen Almind",
      "Jacob Almind"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0190_LHP4-8B4.jpg"
  },
  {
    "id": "AQI194",
    "name": "Anne Magrethe Vonne",
    "sex": "F",
    "gen": 7,
    "slot": 63,
    "side": "paternal",
    "birthplace": "denmark",
    "childId": "I465",
    "birthYear": 1801,
    "deathYear": 1856,
    "birthDate": "from 17 January 1801 to 18 January 1801",
    "deathDate": "10 Feb 1856",
    "burialDate": null,
    "christeningDate": "3 Feb 1801",
    "birthPlace": "Denmark",
    "deathPlace": "Løgstør, Ålborg, Denmark",
    "burialPlace": null,
    "christeningPlace": "Copenhagen, Copenhagen, Denmark",
    "fsId": "L7VM-RF3",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Margrethe Funder",
      "Anne Margrethe Vonno",
      "Anne Margrethe Vonne",
      "Anne Margrethe Vonnce",
      "Anne Maregrethe Vonne",
      "Anne Magrethe Almind Vonno",
      "Anna Margrethe Wonns",
      "Anna Margaretta Vunnow",
      "Anna Margaret Founer",
      "Ane Margrette Wonne",
      "Ane Margrethe Vonno",
      "Ane Margrethe Vonne",
      "Ane Margrete Vonno Almind",
      "Ane Margrete Vonno"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI199",
    "name": "Jacob Heck",
    "sex": "M",
    "gen": 7,
    "slot": 64,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "I158",
    "birthYear": 1778,
    "deathYear": 1849,
    "birthDate": "26 Mar 1778",
    "deathDate": "26 Aug 1849",
    "burialDate": "27 Aug 1849",
    "christeningDate": null,
    "birthPlace": "Germany",
    "deathPlace": "West Pikeland Township, Chester, Pennsylvania, United States",
    "burialPlace": "Saint Mary's Roman Catholic Cemetery (Defunct), Philadelphia, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LK69-QZG",
    "photo": "/ancestors/bubbles/0192_LK69-QZG.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0192_LK69-QZG.jpg"
  },
  {
    "id": "AQI200",
    "name": "Anna Maria Deery",
    "sex": "F",
    "gen": 7,
    "slot": 65,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I158",
    "birthYear": 1779,
    "deathYear": 1831,
    "birthDate": "15 Dec 1779",
    "deathDate": "13 Feb 1831",
    "burialDate": "Feb 1831",
    "christeningDate": null,
    "birthPlace": "Chester, Pennsylvania, United States",
    "deathPlace": "Chester, Pennsylvania, United States",
    "burialPlace": "Saint Mary's Roman Catholic Cemetery (Defunct), Philadelphia, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LK69-QT2",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Anna Maria Deiry"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI201",
    "name": "James McCormick",
    "sex": "M",
    "gen": 7,
    "slot": 66,
    "side": "maternal",
    "birthplace": "unknown",
    "childId": "I157",
    "birthYear": 1795,
    "deathYear": 1865,
    "birthDate": "18 May 1795",
    "deathDate": "25 Dec 1865",
    "burialDate": "Dec 1865",
    "christeningDate": null,
    "birthPlace": null,
    "deathPlace": "Elverson, Chester, Pennsylvania, United States",
    "burialPlace": "Elverson Methodist Cemetery, Elverson, Chester, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "G8WJ-HC7",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI202",
    "name": "Mary Ann",
    "sex": "F",
    "gen": 7,
    "slot": 67,
    "side": "maternal",
    "birthplace": "unknown",
    "childId": "I157",
    "birthYear": 1802,
    "deathYear": 1882,
    "birthDate": "Jul 1802",
    "deathDate": "20 Sep 1882",
    "burialDate": "Sep 1882",
    "christeningDate": null,
    "birthPlace": null,
    "deathPlace": "Chester, Pennsylvania, United States",
    "burialPlace": "Elverson Methodist Cemetery, Elverson, Chester, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "G8WJ-J62",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI203",
    "name": "Peter H Yarnall",
    "sex": "M",
    "gen": 7,
    "slot": 68,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I152",
    "birthYear": 1795,
    "deathYear": 1851,
    "birthDate": "1795",
    "deathDate": "10 Feb 1851",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Chester, Pennsylvania, United States",
    "deathPlace": "West Nantmeal Township, Chester, Pennsylvania, United States",
    "burialPlace": "Saint Mark's Episcopal Church Cemetery, Chesterville, Franklin Township, Chester, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LH8G-5J5",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Peter Yarnall",
      "Jonas P Yarnall"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI204",
    "name": "Ann P. Aitken",
    "sex": "F",
    "gen": 7,
    "slot": 69,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I152",
    "birthYear": 1798,
    "deathYear": 1851,
    "birthDate": "1798",
    "deathDate": "20 Feb 1851",
    "burialDate": "Feb 1851",
    "christeningDate": null,
    "birthPlace": "Chester, Pennsylvania, United States",
    "deathPlace": null,
    "burialPlace": "Saint Mark's Episcopal Church Cemetery, Chesterville, Franklin Township, Chester, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "KZZQ-62P",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Ann P. Atkin",
      "Ann P Aitken"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI205",
    "name": "Alva Noble",
    "sex": "M",
    "gen": 7,
    "slot": 72,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I145",
    "birthYear": 1791,
    "deathYear": 1872,
    "birthDate": "16 Jul 1791",
    "deathDate": "18 Nov 1872",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Granville, Hampden, Massachusetts, United States",
    "deathPlace": "Pennsylvania, United States",
    "burialPlace": "Calkins, Damascus Township, Wayne, Pennsylvania, United States",
    "christeningPlace": "Blandford, Hampden, Massachusetts, United States",
    "fsId": "L7HK-TMH",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Alvah Noble",
      "Alba Noble"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI206",
    "name": "Maria Amelia Buell",
    "sex": "F",
    "gen": 7,
    "slot": 73,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I145",
    "birthYear": 1795,
    "deathYear": 1842,
    "birthDate": "Abt 4 Aug 1795",
    "deathDate": "27 Aug 1842",
    "burialDate": "1842",
    "christeningDate": null,
    "birthPlace": "New Milford, Litchfield, Connecticut, United States",
    "deathPlace": "Damascus, Damascus Township, Wayne, Pennsylvania, United States",
    "burialPlace": "Overlook Cemetery, Damascus, Damascus Township, Wayne, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "G9TV-9RR",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI207",
    "name": "John Samuel Garratt",
    "sex": "M",
    "gen": 7,
    "slot": 74,
    "side": "maternal",
    "birthplace": "england",
    "childId": "I147",
    "birthYear": 1797,
    "deathYear": 1877,
    "birthDate": "13 Aug 1797",
    "deathDate": "7 Mar 1877",
    "burialDate": null,
    "christeningDate": "2 Jan 1798",
    "birthPlace": "Kent, England",
    "deathPlace": "Indian Orchard, Texas Township, Wayne, Pennsylvania, United States",
    "burialPlace": "Indian Orchard, Texas Township, Wayne, Pennsylvania, United States",
    "christeningPlace": "St Laurence in Thanet, Kent, England, United Kingdom",
    "fsId": "L8YC-6TT",
    "photo": "/ancestors/bubbles/0202_L8YC-6TT.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0202_L8YC-6TT.jpg"
  },
  {
    "id": "AQI208",
    "name": "Mary Patience Content Albro",
    "sex": "F",
    "gen": 7,
    "slot": 75,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I147",
    "birthYear": 1803,
    "deathYear": 1879,
    "birthDate": "20 Sep 1803",
    "deathDate": "17 Jun 1879",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Dutchess, New York, United States",
    "deathPlace": "Wayne, Pennsylvania, United States",
    "burialPlace": "Indian Orchard, Texas Township, Wayne, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "L4M9-82D",
    "photo": "/ancestors/bubbles/0203_L4M9-82D.jpg",
    "living": false,
    "alternateNames": [
      "Patience C Albro",
      "Patience C. Albro",
      "Patience Cortent Albro"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0203_L4M9-82D.jpg"
  },
  {
    "id": "AQI209",
    "name": "George Johnson",
    "sex": "M",
    "gen": 7,
    "slot": 80,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I136",
    "birthYear": 1806,
    "deathYear": 1896,
    "birthDate": "19 Apr 1806",
    "deathDate": "26 Sep 1896",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Berks, Pennsylvania, United States",
    "deathPlace": "Boyertown, Berks, Pennsylvania, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LRL1-DXX",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI210",
    "name": "Anna Fisher",
    "sex": "F",
    "gen": 7,
    "slot": 81,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I136",
    "birthYear": 1801,
    "deathYear": 1869,
    "birthDate": "28 Aug 1801",
    "deathDate": "9 Apr 1869",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Berks, Pennsylvania, United States",
    "deathPlace": "Boyertown, Berks, Pennsylvania, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LRL1-NR8",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI211",
    "name": "Frederick Moser",
    "sex": "M",
    "gen": 7,
    "slot": 82,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I138",
    "birthYear": 1804,
    "deathYear": null,
    "birthDate": "14 Nov 1804",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Pike Township, Berks, Pennsylvania, United States",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LD5L-Z61",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI212",
    "name": "Christina Wieand",
    "sex": "F",
    "gen": 7,
    "slot": 83,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I138",
    "birthYear": 1799,
    "deathYear": 1860,
    "birthDate": "9 Dec 1799",
    "deathDate": "19 Aug 1860",
    "burialDate": "Aug 1860",
    "christeningDate": null,
    "birthPlace": "Pike Township, Berks, Pennsylvania, United States",
    "deathPlace": "Berks, Pennsylvania, United States",
    "burialPlace": "Hill Church Union Cemetery, Boyertown, Berks, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LD5L-ZFV",
    "photo": "/ancestors/bubbles/0211_LD5L-ZFV.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0211_LD5L-ZFV.jpg"
  },
  {
    "id": "AQI213",
    "name": "George Hatfield",
    "sex": "M",
    "gen": 7,
    "slot": 84,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I126",
    "birthYear": 1794,
    "deathYear": 1859,
    "birthDate": "10 Jan 1794",
    "deathDate": "13 Oct 1859",
    "burialDate": "1846",
    "christeningDate": null,
    "birthPlace": "Pottstown, Montgomery, Pennsylvania, United States",
    "deathPlace": "Pennsylvania, United States",
    "burialPlace": "Zion Reformed Church Cemetery, Pottstown, Montgomery, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "KZFQ-S54",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI214",
    "name": "Anna Maria \"Mary\" Geiger",
    "sex": "F",
    "gen": 7,
    "slot": 85,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I126",
    "birthYear": 1801,
    "deathYear": 1877,
    "birthDate": "5 Apr 1801",
    "deathDate": "27 Apr 1877",
    "burialDate": "1877",
    "christeningDate": null,
    "birthPlace": "Pennsylvania, United States",
    "deathPlace": null,
    "burialPlace": "Zion Reformed Church Cemetery, Pottstown, Montgomery, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "MN7G-PXS",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Anna Maria",
      "Mary Pauline Geiger"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI215",
    "name": "Jacob Levengood",
    "sex": "M",
    "gen": 7,
    "slot": 86,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I124",
    "birthYear": 1794,
    "deathYear": 1856,
    "birthDate": "18 Nov 1794",
    "deathDate": "24 Aug 1856",
    "burialDate": "1856",
    "christeningDate": null,
    "birthPlace": "Berks, Pennsylvania, United States",
    "deathPlace": "Pottstown, Montgomery, Pennsylvania, United States",
    "burialPlace": "Pottstown, Montgomery, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LZV3-WGH",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI216",
    "name": "Mary S. Bechtel",
    "sex": "F",
    "gen": 7,
    "slot": 87,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I124",
    "birthYear": 1800,
    "deathYear": 1870,
    "birthDate": "8 Aug 1800",
    "deathDate": "1 May 1870",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Berks, Pennsylvania, United States",
    "deathPlace": "Pottstown, Montgomery, Pennsylvania, United States",
    "burialPlace": "Zion Reformed Church Cemetery, Pottstown, Montgomery, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LZKR-GP4",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Mary Bechtel"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI217",
    "name": "Henry Saltzer",
    "sex": "M",
    "gen": 7,
    "slot": 88,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "I107",
    "birthYear": null,
    "deathYear": null,
    "birthDate": null,
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Germany",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "GLM1-XQ6",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI218",
    "name": "Rosa Daraday",
    "sex": "F",
    "gen": 7,
    "slot": 89,
    "side": "maternal",
    "birthplace": "unknown",
    "childId": "I107",
    "birthYear": null,
    "deathYear": null,
    "birthDate": null,
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "GLM1-3S2",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI219",
    "name": "Frederick Hallman",
    "sex": "M",
    "gen": 7,
    "slot": 90,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I106",
    "birthYear": 1795,
    "deathYear": 1869,
    "birthDate": "19 Mar 1795",
    "deathDate": "3 Oct 1869",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Limerick Township, Montgomery, Pennsylvania, United States",
    "deathPlace": "Earl Township, Berks, Pennsylvania, United States",
    "burialPlace": "Saint Pauls Church Cemetery, Amityville, Amity Township, Berks, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "L5B7-HVP",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Friederich Hallmann"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI220",
    "name": "Catherine Fritz",
    "sex": "F",
    "gen": 7,
    "slot": 91,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I106",
    "birthYear": 1798,
    "deathYear": 1861,
    "birthDate": "19 Feb 1798",
    "deathDate": "10 Feb 1861",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Berks, Pennsylvania, United States",
    "deathPlace": null,
    "burialPlace": "Saint Pauls Church Cemetery, Amityville, Amity Township, Berks, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "GJ6Q-WZP",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI221",
    "name": "Samuel Hartranft",
    "sex": "M",
    "gen": 7,
    "slot": 92,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I104",
    "birthYear": 1807,
    "deathYear": 1862,
    "birthDate": "4 Sep 1807",
    "deathDate": "3 Nov 1862",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Montgomery, Pennsylvania, United States",
    "deathPlace": null,
    "burialPlace": "Pottstown, Montgomery, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "KN4X-BHN",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI222",
    "name": "Elizabeth Davidheiser",
    "sex": "F",
    "gen": 7,
    "slot": 93,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I104",
    "birthYear": 1811,
    "deathYear": 1882,
    "birthDate": "1811",
    "deathDate": "1882",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Pennsylvania, United States",
    "deathPlace": "Pennsylvania, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "MR1B-G2D",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI223",
    "name": "Jacob Fryer",
    "sex": "M",
    "gen": 7,
    "slot": 94,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I110",
    "birthYear": 1795,
    "deathYear": 1864,
    "birthDate": "4 Sep 1795",
    "deathDate": "18 Aug 1864",
    "burialDate": "21 Aug 1864",
    "christeningDate": null,
    "birthPlace": "New Hanover Township, Philadelphia, Pennsylvania, United States",
    "deathPlace": "Pottstown, Montgomery, Pennsylvania, United States",
    "burialPlace": "Pottstown, Montgomery, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LLS8-LFF",
    "photo": "/ancestors/bubbles/0222_LLS8-LFF.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0222_LLS8-LFF.jpg"
  },
  {
    "id": "AQI224",
    "name": "Catherine Bowman",
    "sex": "F",
    "gen": 7,
    "slot": 95,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I110",
    "birthYear": 1795,
    "deathYear": 1862,
    "birthDate": "12 Oct 1795",
    "deathDate": "4 Apr 1862",
    "burialDate": "7 Apr 1862",
    "christeningDate": "17 Nov 1804",
    "birthPlace": "Philadelphia, Pennsylvania, United States",
    "deathPlace": "Gloucester City, Union Township, Camden, New Jersey, United States",
    "burialPlace": "Pottstown Cemetery, Pottstown, Montgomery, Pennsylvania, United States",
    "christeningPlace": "Philadelphia Monthly Meeting, Philadelphia, Philadelphia, Pennsylvania, United States",
    "fsId": "LLS8-LYS",
    "photo": "/ancestors/bubbles/0223_LLS8-LYS.jpg",
    "living": false,
    "alternateNames": [
      "Catharine Bouman"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0223_LLS8-LYS.jpg"
  },
  {
    "id": "AQI225",
    "name": "George Peter Mock",
    "sex": "M",
    "gen": 7,
    "slot": 96,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I143",
    "birthYear": 1783,
    "deathYear": 1862,
    "birthDate": "8 May 1783",
    "deathDate": "30 Jun 1862",
    "burialDate": "3 Jul 1862",
    "christeningDate": null,
    "birthPlace": "St. Clair Township, Bedford, Pennsylvania, United States",
    "deathPlace": "St. Clair Township, Bedford, Pennsylvania, United States",
    "burialPlace": "Osterburg, East Saint Clair Township, Bedford, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LVLH-WPL",
    "photo": "/ancestors/bubbles/0224_LVLH-WPL.jpg",
    "living": false,
    "alternateNames": [
      "George P Mock"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0224_LVLH-WPL.jpg"
  },
  {
    "id": "AQI226",
    "name": "Dorothy Durintha",
    "sex": "F",
    "gen": 7,
    "slot": 97,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I143",
    "birthYear": 1785,
    "deathYear": 1850,
    "birthDate": "1785",
    "deathDate": "1850",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "St. Clair Township, Bedford, Pennsylvania, British Colonial America",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "L2M4-MVL",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Jane"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI227",
    "name": "Johannes Christ",
    "sex": "M",
    "gen": 7,
    "slot": 98,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I144",
    "birthYear": 1776,
    "deathYear": 1850,
    "birthDate": "27 Mar 1776",
    "deathDate": "1850",
    "burialDate": null,
    "christeningDate": "28 Apr 1776",
    "birthPlace": "Alsace Township, Berks, Pennsylvania, British Colonial America",
    "deathPlace": "Maryland, United States",
    "burialPlace": null,
    "christeningPlace": "Trinity Lutheran Church, Camp Hill, Cumberland, Pennsylvania, United States",
    "fsId": "KVG3-FZC",
    "photo": "/ancestors/bubbles/0226_KVG3-FZC.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0226_KVG3-FZC.jpg"
  },
  {
    "id": "AQI228",
    "name": "Mary Ann Hann",
    "sex": "F",
    "gen": 7,
    "slot": 99,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I144",
    "birthYear": 1779,
    "deathYear": null,
    "birthDate": "1 Dec 1779",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Maryland, United States",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "KLXF-DLS",
    "photo": "/ancestors/bubbles/0227_KLXF-DLS.jpg",
    "living": false,
    "alternateNames": [
      "Ann Crist"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0227_KLXF-DLS.jpg"
  },
  {
    "id": "AQI229",
    "name": "David Puderbaugh Burget",
    "sex": "M",
    "gen": 7,
    "slot": 100,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I132",
    "birthYear": 1786,
    "deathYear": 1840,
    "birthDate": "11 Feb 1786",
    "deathDate": "21 Mar 1840",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Pennsylvania, United States",
    "deathPlace": "Henrietta, North Woodbury Township, Blair, Pennsylvania, United States",
    "burialPlace": "Henrietta, North Woodbury Township, Blair, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "KPD1-RW1",
    "photo": "/ancestors/bubbles/0228_KPD1-RW1.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0228_KPD1-RW1.jpg"
  },
  {
    "id": "AQI230",
    "name": "Nancy Bulger",
    "sex": "F",
    "gen": 7,
    "slot": 101,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I132",
    "birthYear": 1774,
    "deathYear": 1866,
    "birthDate": "1774",
    "deathDate": "23 May 1866",
    "burialDate": "1866",
    "christeningDate": null,
    "birthPlace": "Blair, Pennsylvania, United States",
    "deathPlace": "Woodbury Township, Bedford, Pennsylvania, United States",
    "burialPlace": "Henrietta, North Woodbury Township, Blair, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "K2NT-W4W",
    "photo": "/ancestors/bubbles/0229_K2NT-W4W.jpg",
    "living": false,
    "alternateNames": [
      "Nancy Bergard"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0229_K2NT-W4W.jpg"
  },
  {
    "id": "AQI231",
    "name": "John Zook",
    "sex": "M",
    "gen": 7,
    "slot": 102,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I125",
    "birthYear": 1788,
    "deathYear": 1851,
    "birthDate": "1 Jan 1788",
    "deathDate": "21 Mar 1851",
    "burialDate": "Abt 23 Mar 1852",
    "christeningDate": null,
    "birthPlace": "Hagerstown, Washington, Maryland, United States",
    "deathPlace": "Hagerstown, Jefferson Township, Wayne, Indiana, United States",
    "burialPlace": "West Lawn Cemetery, Hagerstown, Jefferson Township, Wayne, Indiana, United States",
    "christeningPlace": null,
    "fsId": "LCF8-P8T",
    "photo": "/ancestors/bubbles/0230_LCF8-P8T.jpg",
    "living": false,
    "alternateNames": [
      "John Zuck"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0230_LCF8-P8T.jpg"
  },
  {
    "id": "AQI232",
    "name": "Catherine Byers",
    "sex": "F",
    "gen": 7,
    "slot": 103,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I125",
    "birthYear": 1781,
    "deathYear": 1816,
    "birthDate": "1781",
    "deathDate": "1816",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Pennsylvania, United States",
    "deathPlace": "Pennsylvania, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LWHP-N78",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI233",
    "name": "Johan Philipp E Wentz",
    "sex": "M",
    "gen": 7,
    "slot": 104,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I112",
    "birthYear": 1777,
    "deathYear": 1850,
    "birthDate": "27 Mar 1777",
    "deathDate": "28 Jan 1850",
    "burialDate": null,
    "christeningDate": "20 Apr 1777",
    "birthPlace": "York, York, Pennsylvania, United States",
    "deathPlace": "Cabell, West Virginia, United States",
    "burialPlace": "Merritt Family Cemetery, Barboursville, Cabell, West Virginia, United States",
    "christeningPlace": "Franconia Township, Montgomery, Pennsylvania, United States",
    "fsId": "L7PK-M1T",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Johan Phillip Wentz II",
      "Johan Philip Wentz",
      "Johan Peter Wentz"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI234",
    "name": "Barbara Baker",
    "sex": "F",
    "gen": 7,
    "slot": 105,
    "side": "maternal",
    "birthplace": "england",
    "childId": "I112",
    "birthYear": 1780,
    "deathYear": 1859,
    "birthDate": "Abt 1780",
    "deathDate": "Apr 1859",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Somerset Township, Somerset, Pennsylvania, United States",
    "deathPlace": "Bedford, Pennsylvania, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "G3QM-PDT",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Barbara Baker Wentz"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI235",
    "name": "Philip Ickes",
    "sex": "M",
    "gen": 7,
    "slot": 106,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I113",
    "birthYear": 1784,
    "deathYear": 1858,
    "birthDate": "11 Apr 1784",
    "deathDate": "26 Nov 1858",
    "burialDate": "1858",
    "christeningDate": null,
    "birthPlace": "Hanover, York, Pennsylvania, United States",
    "deathPlace": "Bedford, Pennsylvania, United States",
    "burialPlace": "Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LDQL-LG5",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI236",
    "name": "Elizabeth Weyant",
    "sex": "F",
    "gen": 7,
    "slot": 107,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I113",
    "birthYear": 1787,
    "deathYear": 1859,
    "birthDate": "5 Oct 1787",
    "deathDate": "2 Aug 1859",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Bedford, Pennsylvania, United States",
    "deathPlace": "Arkansas, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "GR3J-25L",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Elizabeth",
      "Mrs. Elizabeth Ickes"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI237",
    "name": "Thomas Oldham",
    "sex": "M",
    "gen": 7,
    "slot": 108,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I93",
    "birthYear": 1808,
    "deathYear": 1891,
    "birthDate": "9 Feb 1808",
    "deathDate": "17 Jun 1891",
    "burialDate": "19 Jun 1891",
    "christeningDate": null,
    "birthPlace": "St. Clair Township, Bedford, Pennsylvania, United States",
    "deathPlace": "Iowa, United States",
    "burialPlace": "Brown Cemetery, Clayton, Iowa, United States",
    "christeningPlace": null,
    "fsId": "L4MY-1XV",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI238",
    "name": "Elizabeth S. Bowen",
    "sex": "F",
    "gen": 7,
    "slot": 109,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I93",
    "birthYear": 1806,
    "deathYear": 1856,
    "birthDate": "19 Jan 1806",
    "deathDate": "26 Mar 1856",
    "burialDate": "Apr 1856",
    "christeningDate": null,
    "birthPlace": "St. Clair Township, Bedford, Pennsylvania, United States",
    "deathPlace": "Mallory Township, Clayton, Iowa, United States",
    "burialPlace": "Mallory Township, Clayton, Iowa, United States",
    "christeningPlace": null,
    "fsId": "L196-7FP",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI241",
    "name": "Adam Guyer",
    "sex": "M",
    "gen": 7,
    "slot": 112,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "I72",
    "birthYear": 1788,
    "deathYear": 1869,
    "birthDate": "12 May 1788",
    "deathDate": "11 Aug 1869",
    "burialDate": "Aug 1869",
    "christeningDate": null,
    "birthPlace": "Germany",
    "deathPlace": "Stark, Ohio, United States",
    "burialPlace": "Valley Chapel Cemetery, Canton, Stark, Ohio, United States",
    "christeningPlace": null,
    "fsId": "KLYY-R1C",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI242",
    "name": "Anna Brubaker",
    "sex": "F",
    "gen": 7,
    "slot": 113,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I72",
    "birthYear": 1797,
    "deathYear": 1876,
    "birthDate": "12 May 1797",
    "deathDate": "12 May 1876",
    "burialDate": "May 1876",
    "christeningDate": null,
    "birthPlace": "Juniata, Pennsylvania, United States",
    "deathPlace": "Stark, Ohio, United States",
    "burialPlace": "Valley Chapel Cemetery, Canton, Stark, Ohio, United States",
    "christeningPlace": null,
    "fsId": "KLBX-Z8N",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Anna Brubacher",
      "Mrs. Adam Guyer"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI243",
    "name": "Andrew Eschelman Snowberger",
    "sex": "M",
    "gen": 7,
    "slot": 116,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I83",
    "birthYear": 1802,
    "deathYear": 1874,
    "birthDate": "24 Mar 1802",
    "deathDate": "12 Sep 1874",
    "burialDate": "1874",
    "christeningDate": null,
    "birthPlace": "Everett, Bedford, Pennsylvania, British Colonial America",
    "deathPlace": "New Enterprise, South Woodbury Township, Bedford, Pennsylvania, United States",
    "burialPlace": "Ritchey Cemetery, Snake Spring Township, Bedford, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "KL12-J3M",
    "photo": "/ancestors/bubbles/0244_KL12-J3M.jpg",
    "living": false,
    "alternateNames": [
      "Andrew E. Snowberger",
      "Andrew Eshelman Snowberger",
      "Andrew Snoeberger",
      "Andrew Snowberger",
      "Andrew E Snowberger"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0244_KL12-J3M.jpg"
  },
  {
    "id": "AQI244",
    "name": "Rosanna Snyder",
    "sex": "F",
    "gen": 7,
    "slot": 117,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I83",
    "birthYear": 1805,
    "deathYear": 1888,
    "birthDate": "7 Jul 1805",
    "deathDate": "23 May 1888",
    "burialDate": "1888",
    "christeningDate": null,
    "birthPlace": "Snake Spring Township, Bedford, Pennsylvania, United States",
    "deathPlace": "Snake Spring Township, Bedford, Pennsylvania, United States",
    "burialPlace": "Snake Spring Township, Bedford, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LZ86-M85",
    "photo": "/ancestors/bubbles/0245_LZ86-M85.jpg",
    "living": false,
    "alternateNames": [
      "Rosana Snider",
      "Rosie Snider",
      "Rosanna Schneider",
      "Rosannah Snowberger",
      "Rosannah Snyder"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0245_LZ86-M85.jpg"
  },
  {
    "id": "AQI245",
    "name": "John Burket",
    "sex": "M",
    "gen": 7,
    "slot": 118,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I82",
    "birthYear": 1806,
    "deathYear": 1871,
    "birthDate": "20 Nov 1806",
    "deathDate": "11 Dec 1871",
    "burialDate": "Dec 1871",
    "christeningDate": null,
    "birthPlace": "Hopewell, Bedford, Pennsylvania, United States",
    "deathPlace": "Hopewell, Bedford, Pennsylvania, United States",
    "burialPlace": "Burket Cemetery, Hopewell, Bedford, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "MRC6-KWT",
    "photo": "/ancestors/bubbles/0246_MRC6-KWT.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0246_MRC6-KWT.jpg"
  },
  {
    "id": "AQI246",
    "name": "Elizabeth Ulrich Brown",
    "sex": "F",
    "gen": 7,
    "slot": 119,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I82",
    "birthYear": 1815,
    "deathYear": 1887,
    "birthDate": "16 Apr 1815",
    "deathDate": "11 Mar 1887",
    "burialDate": "Mar 1887",
    "christeningDate": null,
    "birthPlace": "Bedford, Pennsylvania, United States",
    "deathPlace": "Hopewell, Bedford, Pennsylvania, United States",
    "burialPlace": "Burket Cemetery, Hopewell, Bedford, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "L2KR-H6F",
    "photo": "/ancestors/bubbles/0247_L2KR-H6F.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0247_L2KR-H6F.jpg"
  },
  {
    "id": "AQI247",
    "name": "John Gochnour",
    "sex": "M",
    "gen": 7,
    "slot": 120,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I59",
    "birthYear": 1780,
    "deathYear": 1856,
    "birthDate": "3 Dec 1780",
    "deathDate": "12 Mar 1856",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Kimmel Township, Bedford, Pennsylvania, United States",
    "deathPlace": null,
    "burialPlace": "Kimmel Township, Bedford, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LLM6-C81",
    "photo": "/ancestors/bubbles/0248_LLM6-C81.jpg",
    "living": false,
    "alternateNames": [
      "John Gochnour Sr."
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0248_LLM6-C81.jpg"
  },
  {
    "id": "AQI248",
    "name": "Susannah",
    "sex": "F",
    "gen": 7,
    "slot": 121,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I59",
    "birthYear": 1781,
    "deathYear": 1858,
    "birthDate": "15 Jan 1781",
    "deathDate": "27 Aug 1858",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Pennsylvania, United States",
    "deathPlace": "Pennsylvania, United States",
    "burialPlace": "Kimmel Township, Bedford, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LLM6-CDS",
    "photo": "/ancestors/bubbles/0249_LLM6-CDS.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0249_LLM6-CDS.jpg"
  },
  {
    "id": "AQI249",
    "name": "Lingenfelter",
    "sex": "M",
    "gen": 7,
    "slot": 122,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I62",
    "birthYear": 1795,
    "deathYear": 1858,
    "birthDate": "Abt 1795",
    "deathDate": "From 1858 to 1860",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Pennsylvania, United States",
    "deathPlace": "Pennsylvania, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "G342-G48",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI250",
    "name": "Elizabeth Ickes",
    "sex": "F",
    "gen": 7,
    "slot": 123,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I62",
    "birthYear": 1798,
    "deathYear": 1885,
    "birthDate": "12 Apr 1798",
    "deathDate": "1 Mar 1885",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Pennsylvania, United States",
    "deathPlace": "Snake Spring Township, Bedford, Pennsylvania, United States",
    "burialPlace": "Snake Spring Township, Bedford, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LKD8-MT1",
    "photo": "/ancestors/bubbles/0251_LKD8-MT1.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0251_LKD8-MT1.jpg"
  },
  {
    "id": "AQI251",
    "name": "Isaac Burket",
    "sex": "M",
    "gen": 7,
    "slot": 124,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I88",
    "birthYear": 1808,
    "deathYear": 1860,
    "birthDate": "1808",
    "deathDate": "Bef 1860",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "St. Clair Township, Bedford, Pennsylvania, United States",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "GRFQ-7RG",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI252",
    "name": "Dolly Swoveland",
    "sex": "F",
    "gen": 7,
    "slot": 125,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I88",
    "birthYear": 1799,
    "deathYear": 1839,
    "birthDate": "Abt 1799",
    "deathDate": "1839",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "St. Clair Township, Bedford, Pennsylvania, United States",
    "deathPlace": "St. Clair Township, Bedford, Pennsylvania, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "PWS2-5GX",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI253",
    "name": "Joseph Claar",
    "sex": "M",
    "gen": 7,
    "slot": 126,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I89",
    "birthYear": 1811,
    "deathYear": 1889,
    "birthDate": "14 Aug 1811",
    "deathDate": "7 Mar 1889",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Klahr, Greenfield Township, Blair, Pennsylvania, United States",
    "deathPlace": "Klahr, Greenfield Township, Blair, Pennsylvania, United States",
    "burialPlace": "Klahr, Greenfield Township, Blair, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "K26N-T7S",
    "photo": "/ancestors/bubbles/0254_K26N-T7S.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0254_K26N-T7S.jpg"
  },
  {
    "id": "AQI254",
    "name": "Esther Hester Ickes",
    "sex": "F",
    "gen": 7,
    "slot": 127,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "I89",
    "birthYear": 1815,
    "deathYear": 1891,
    "birthDate": "19 Jun 1815",
    "deathDate": "2 Jun 1891",
    "burialDate": "Jun 1891",
    "christeningDate": null,
    "birthPlace": "Bedford, Pennsylvania, United States",
    "deathPlace": "United States",
    "burialPlace": "Queen, Kimmel Township, Bedford, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "K26N-TZP",
    "photo": "/ancestors/bubbles/0255_K26N-TZP.jpg",
    "living": false,
    "alternateNames": [
      "Esther",
      "Esther Ickes",
      "Hetta",
      "Hester Ickes"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0255_K26N-TZP.jpg"
  },
  {
    "id": "AQI255",
    "name": "Thomas Mills",
    "sex": "M",
    "gen": 8,
    "slot": 0,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI131",
    "birthYear": 1735,
    "deathYear": 1775,
    "birthDate": "12 May 1735",
    "deathDate": "Jul 1775",
    "burialDate": "15 Jul 1775",
    "christeningDate": "12 May 1735",
    "birthPlace": "Sussex, England",
    "deathPlace": "Pagham, Sussex, England",
    "burialPlace": "Pagham, Sussex, England",
    "christeningPlace": "Felpham, Sussex, England",
    "fsId": "2WD8-CKJ",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Thomas Sr Mills"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI256",
    "name": "Mary Wiltshire",
    "sex": "F",
    "gen": 8,
    "slot": 1,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI131",
    "birthYear": 1737,
    "deathYear": 1774,
    "birthDate": "Abt 1737",
    "deathDate": "2 May 1774",
    "burialDate": "2 May 1774",
    "christeningDate": "1 Jun 1740",
    "birthPlace": "Pagham, Sussex, England",
    "deathPlace": null,
    "burialPlace": "Pagham, Sussex, England, United Kingdom",
    "christeningPlace": "Aldingbourne, Sussex, England",
    "fsId": "2WD8-CTT",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Mary",
      "Mary Wilshire",
      "Mary Wiltshre",
      "Mrs. Mary Mills"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI257",
    "name": "Ann Hammond",
    "sex": "F",
    "gen": 8,
    "slot": 3,
    "side": "paternal",
    "birthplace": "unknown",
    "childId": "AQI132",
    "birthYear": null,
    "deathYear": null,
    "birthDate": null,
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "29 Sep 1750",
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Rodmell, Sussex, England, United Kingdom",
    "fsId": "MHG8-F3F",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI258",
    "name": "Thomas Coles",
    "sex": "M",
    "gen": 8,
    "slot": 4,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI133",
    "birthYear": 1738,
    "deathYear": 1819,
    "birthDate": "6 Jun 1738",
    "deathDate": "1819",
    "burialDate": "8 Dec 1819",
    "christeningDate": "22 May 1744",
    "birthPlace": "Funtington, Sussex, England",
    "deathPlace": "Funtington, Sussex, England",
    "burialPlace": "Funtington, Sussex, England, United Kingdom",
    "christeningPlace": "St Magnus the Martyr with St Margaret New Fish Street and St Michael Crooked Lane, London, England, United Kingdom",
    "fsId": "G8KN-VNF",
    "photo": "/ancestors/bubbles/0260_G8KN-VNF.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0260_G8KN-VNF.jpg"
  },
  {
    "id": "AQI259",
    "name": "Robert Pruddoe",
    "sex": "M",
    "gen": 8,
    "slot": 6,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI134",
    "birthYear": 1754,
    "deathYear": 1813,
    "birthDate": "18 Apr 1754",
    "deathDate": "Sep 1813",
    "burialDate": "25 Sep 1813",
    "christeningDate": "18 Apr 1754",
    "birthPlace": "Kirkharle, Northumberland, England, United Kingdom",
    "deathPlace": "Lambton, Durham, England, United Kingdom",
    "burialPlace": "Chester-le-Street, Durham, England, United Kingdom",
    "christeningPlace": "Kirkharle, Northumberland, England, United Kingdom",
    "fsId": "LD4L-CNN",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI260",
    "name": "Martha Stephenson",
    "sex": "F",
    "gen": 8,
    "slot": 7,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI134",
    "birthYear": 1757,
    "deathYear": 1828,
    "birthDate": "1757",
    "deathDate": "1828",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Lamesley, Durham, England, United Kingdom",
    "deathPlace": "Chester le Street, Durham, England, United Kingdom",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "KHWM-MXQ",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Martha Stephenson Pruddoe"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI261",
    "name": "Thomas Newington",
    "sex": "M",
    "gen": 8,
    "slot": 10,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI136",
    "birthYear": 1763,
    "deathYear": 1843,
    "birthDate": "Abt 1763",
    "deathDate": "Apr 1843",
    "burialDate": "6 Apr 1843",
    "christeningDate": "7 Apr 1763",
    "birthPlace": "Arundel, Sussex, England, United Kingdom",
    "deathPlace": "Westhampnett, Sussex, England, United Kingdom",
    "burialPlace": "Climping, Sussex, England, United Kingdom",
    "christeningPlace": "Arundel, Sussex, England",
    "fsId": "2DXP-C1K",
    "photo": "/ancestors/bubbles/0266_2DXP-C1K.jpg",
    "living": false,
    "alternateNames": [
      "Thos Newington",
      "Tho Newington"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0266_2DXP-C1K.jpg"
  },
  {
    "id": "AQI262",
    "name": "Mary Irish",
    "sex": "F",
    "gen": 8,
    "slot": 11,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI136",
    "birthYear": 1769,
    "deathYear": 1802,
    "birthDate": "3 Sep 1769",
    "deathDate": "16 Sep 1802",
    "burialDate": null,
    "christeningDate": "3 Sep 1769",
    "birthPlace": "Felpham, Sussex, England",
    "deathPlace": "Barnham, Sussex, England, United Kingdom",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "L8LF-CPQ",
    "photo": "/ancestors/bubbles/0267_L8LF-CPQ.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0267_L8LF-CPQ.jpg"
  },
  {
    "id": "AQI263",
    "name": "William Chessell",
    "sex": "M",
    "gen": 8,
    "slot": 12,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI137",
    "birthYear": 1758,
    "deathYear": 1799,
    "birthDate": "24 Sep 1758",
    "deathDate": "20 Aug 1799",
    "burialDate": null,
    "christeningDate": "24 Sep 1758",
    "birthPlace": "Angmering, Sussex, England, United Kingdom",
    "deathPlace": "Climping, Sussex, England, United Kingdom",
    "burialPlace": null,
    "christeningPlace": "Angmering, Sussex, England, United Kingdom",
    "fsId": "LTGY-995",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI264",
    "name": "Jane Suter",
    "sex": "F",
    "gen": 8,
    "slot": 13,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI137",
    "birthYear": 1757,
    "deathYear": 1849,
    "birthDate": "16 Oct 1757",
    "deathDate": "Jan 1849",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Climping, Sussex, England, United Kingdom",
    "deathPlace": "Brighton, Sussex, England, United Kingdom",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "P7FV-3MJ",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI266",
    "name": "Hugh Ashley",
    "sex": "M",
    "gen": 8,
    "slot": 14,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI138",
    "birthYear": 1755,
    "deathYear": null,
    "birthDate": "Abt 1755",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "5 Dec 1755",
    "birthPlace": "Devizes, Wiltshire, England, United Kingdom",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Devizes, Wiltshire, England, United Kingdom",
    "fsId": "K8SG-93D",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI267",
    "name": "Ann Blackman",
    "sex": "F",
    "gen": 8,
    "slot": 15,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI138",
    "birthYear": 1758,
    "deathYear": null,
    "birthDate": "Abt 1758",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Devizes, Wiltshire, England, United Kingdom",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "K8CH-3XL",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI268",
    "name": "Christen Lehmann",
    "sex": "M",
    "gen": 8,
    "slot": 16,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI139",
    "birthYear": 1737,
    "deathYear": 1804,
    "birthDate": "25 Jan 1737",
    "deathDate": "15 Oct 1804",
    "burialDate": "15 Oct 1804",
    "christeningDate": "25 Jan 1737",
    "birthPlace": "Worb, Bern, Switzerland",
    "deathPlace": null,
    "burialPlace": "Worb, Bern, Switzerland",
    "christeningPlace": "Worb, Bern, Switzerland",
    "fsId": "KLYY-9FZ",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Christian",
      "Christian Lehman"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI269",
    "name": "Anna Schindler",
    "sex": "F",
    "gen": 8,
    "slot": 17,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI139",
    "birthYear": 1739,
    "deathYear": null,
    "birthDate": "Abt 1739",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Richigen, Worb, Bern, Switzerland",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "KLYY-9FD",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Anna Schindler Lehmann",
      "Anna Mauerhofer Lehmann"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI270",
    "name": "Ulrich Leuenberger",
    "sex": "M",
    "gen": 8,
    "slot": 18,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI140",
    "birthYear": 1731,
    "deathYear": 1791,
    "birthDate": "Jan 1731",
    "deathDate": "25 Oct 1791",
    "burialDate": null,
    "christeningDate": "21 Jan 1731",
    "birthPlace": "Lützelflüh, Bern, Switzerland",
    "deathPlace": "Lützelflüh, Bern, Switzerland",
    "burialPlace": null,
    "christeningPlace": "Lützelflüh, Bern, Switzerland",
    "fsId": "LZ6R-VVK",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI271",
    "name": "Verena Schweizer",
    "sex": "F",
    "gen": 8,
    "slot": 19,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI140",
    "birthYear": 1728,
    "deathYear": 1804,
    "birthDate": "1728",
    "deathDate": "12 Dec 1804",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Lauperswil, Bern, Switzerland",
    "deathPlace": "Lützelflüh, Bern, Switzerland",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LZ6R-K8Z",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Verena Schweiser",
      "Verena Schwytzer"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI272",
    "name": "Hans Maurer",
    "sex": "M",
    "gen": 8,
    "slot": 20,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI141",
    "birthYear": 1721,
    "deathYear": 1836,
    "birthDate": "14 Mar 1721",
    "deathDate": "Bef 1836",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Niederwichtrach, Bern, Switzerland",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "G8QK-NT4",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI273",
    "name": "Christina Huber",
    "sex": "F",
    "gen": 8,
    "slot": 21,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI141",
    "birthYear": 1720,
    "deathYear": 1795,
    "birthDate": "Abt 1720",
    "deathDate": "29 Mar 1795",
    "burialDate": "31 Mar 1795",
    "christeningDate": null,
    "birthPlace": "Bern, Switzerland",
    "deathPlace": "Niederwichtrach, Bern, Switzerland",
    "burialPlace": "Niederwichtrach, Bern, Switzerland",
    "christeningPlace": null,
    "fsId": "G8QK-NY8",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Maurer"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI274",
    "name": "Jakob Krähenbühl",
    "sex": "M",
    "gen": 8,
    "slot": 22,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI142",
    "birthYear": 1749,
    "deathYear": null,
    "birthDate": "20 Apr 1749",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Grosshöchstetten, Bern, Switzerland",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "K812-XLD",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Jakob Krahenbuhl"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI275",
    "name": "Anna Barbara Aebi",
    "sex": "F",
    "gen": 8,
    "slot": 23,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI142",
    "birthYear": 1743,
    "deathYear": null,
    "birthDate": "27 Jan 1743",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "27 Jan 1743",
    "birthPlace": "Kirchberg, Bern, Switzerland",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Kirchberg, Bern, Switzerland",
    "fsId": "GHWZ-283",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI276",
    "name": "Christian Krebs",
    "sex": "M",
    "gen": 8,
    "slot": 24,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI143",
    "birthYear": 1754,
    "deathYear": 1812,
    "birthDate": "7 Apr 1754",
    "deathDate": "14 Jul 1812",
    "burialDate": "17 Jul 1812",
    "christeningDate": "9 Jul 1747",
    "birthPlace": "Kirchdorf, Bern, Switzerland",
    "deathPlace": "Kirchdorf, Bern, Switzerland",
    "burialPlace": "Kirchdorf, Bern, Switzerland",
    "christeningPlace": "Kirchdorf, Bern, Switzerland",
    "fsId": "LHQV-J32",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Christ. Krebs",
      "Christen",
      "Christen Krebs",
      "Christian"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI277",
    "name": "Rosina Riem",
    "sex": "F",
    "gen": 8,
    "slot": 25,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI143",
    "birthYear": 1756,
    "deathYear": 1808,
    "birthDate": "22 Apr 1756",
    "deathDate": "2 Apr 1808",
    "burialDate": "5 Apr 1808",
    "christeningDate": "29 Jan 1758",
    "birthPlace": "Kirchdorf, Bern, Switzerland",
    "deathPlace": "Kirchdorf, Bern, Switzerland",
    "burialPlace": "Kirchdorf, Bern, Switzerland",
    "christeningPlace": "Kirchdorf, Bern, Switzerland",
    "fsId": "MSKB-GV3",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Rosina",
      "Rosina Biern",
      "Rosina Riem Krebs"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI278",
    "name": "Ulrich Joss",
    "sex": "M",
    "gen": 8,
    "slot": 26,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI144",
    "birthYear": 1769,
    "deathYear": 1846,
    "birthDate": "20 Oct 1769",
    "deathDate": "16 Sep 1846",
    "burialDate": null,
    "christeningDate": "20 Oct 1769",
    "birthPlace": "Münsingen, Bern, Switzerland",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Herolfingen, Konolfingen, Bern, Switzerland",
    "fsId": "LCFJ-MTH",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Ulrich Foss",
      "Ulrich Jr.",
      "Ulrich Jr. Joss"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI279",
    "name": "Magdalena Keller",
    "sex": "F",
    "gen": 8,
    "slot": 27,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI144",
    "birthYear": 1774,
    "deathYear": 1826,
    "birthDate": "5 May 1774",
    "deathDate": "3 Apr 1826",
    "burialDate": "6 Apr 1826",
    "christeningDate": "15 May 1774",
    "birthPlace": "Oberthal, Bern, Switzerland",
    "deathPlace": "Münsingen, Bern, Switzerland",
    "burialPlace": "Münsingen, Bern, Switzerland",
    "christeningPlace": "Oberthal, Bern, Switzerland",
    "fsId": "LCTS-9DH",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Margaretha Keller",
      "Magdelena Keller",
      "Magdalina Keller",
      "Magdalena Keller Joss",
      "Magdalena"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI280",
    "name": "Johann Ulrich Probst",
    "sex": "M",
    "gen": 8,
    "slot": 28,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI145",
    "birthYear": 1762,
    "deathYear": 1829,
    "birthDate": "1762",
    "deathDate": "16 Apr 1829",
    "burialDate": "18 Apr 1829",
    "christeningDate": "4 Jul 1762",
    "birthPlace": "Lützelflüh, Bern, Switzerland",
    "deathPlace": "Lützelflüh, Bern, Switzerland",
    "burialPlace": "Lützelflüh, Bern, Switzerland",
    "christeningPlace": "Lützelflüh, Bern, Switzerland",
    "fsId": "L4LR-MQT",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Haus Ulrich Probst",
      "Hans Ulrich Probst",
      "Hans Ulrich Johann Probst",
      "Hans Ulrich (Johann) Probst"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI281",
    "name": "Magdalena Schertenleib",
    "sex": "F",
    "gen": 8,
    "slot": 29,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI145",
    "birthYear": 1757,
    "deathYear": 1803,
    "birthDate": "1757",
    "deathDate": "18 Feb 1803",
    "burialDate": null,
    "christeningDate": "20 Feb 1757",
    "birthPlace": "Krauchthal, Bern, Switzerland",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Krauchthal, Bern, Switzerland",
    "fsId": "LX92-W42",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI282",
    "name": "Johannes Steiner",
    "sex": "M",
    "gen": 8,
    "slot": 30,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI146",
    "birthYear": 1772,
    "deathYear": 1850,
    "birthDate": "27 Feb 1772",
    "deathDate": "8 Jul 1850",
    "burialDate": "18 Jul 1850",
    "christeningDate": "27 Nov 1772",
    "birthPlace": "Trachselwald, Bern, Switzerland",
    "deathPlace": "Trachselwald, Bern, Switzerland",
    "burialPlace": "Trachselwald, Bern, Switzerland",
    "christeningPlace": "Trachselwald, Bern, Switzerland",
    "fsId": "LHQ7-JN1",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Hans Steiner"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI283",
    "name": "Magdalena Aeschbacher",
    "sex": "F",
    "gen": 8,
    "slot": 31,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI146",
    "birthYear": 1772,
    "deathYear": 1820,
    "birthDate": "13 Dec 1772",
    "deathDate": "13 Aug 1820",
    "burialDate": "16 Aug 1820",
    "christeningDate": "13 Dec 1772",
    "birthPlace": "Trachselwald, Bern, Switzerland",
    "deathPlace": "Trachselwald, Bern, Switzerland",
    "burialPlace": "Trachselwald, Bern, Switzerland",
    "christeningPlace": "Trachselwald, Bern, Switzerland",
    "fsId": "KFRJ-QMT",
    "photo": "/ancestors/bubbles/0287_KFRJ-QMT.jpg",
    "living": false,
    "alternateNames": [
      "Magdalene Aeschbacher",
      "Magdalena Steiner Aeschbacher",
      "Magdalena Äschbacher"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0287_KFRJ-QMT.jpg"
  },
  {
    "id": "AQI288",
    "name": "John Stuart",
    "sex": "M",
    "gen": 8,
    "slot": 32,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI149",
    "birthYear": 1735,
    "deathYear": null,
    "birthDate": "7 Sep 1735",
    "deathDate": null,
    "burialDate": "24 Jun 1793",
    "christeningDate": "7 Sep 1735",
    "birthPlace": "Lancaster, Lancashire, England",
    "deathPlace": null,
    "burialPlace": "Cumbria, England, United Kingdom",
    "christeningPlace": "Lancaster, Lancashire, England",
    "fsId": "KP4Y-5F7",
    "photo": "/ancestors/bubbles/0288_KP4Y-5F7.jpg",
    "living": false,
    "alternateNames": [
      "Jhn Stuart",
      "John Srewart",
      "John Stewart"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0288_KP4Y-5F7.jpg"
  },
  {
    "id": "AQI289",
    "name": "Anne Askew",
    "sex": "F",
    "gen": 8,
    "slot": 33,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI149",
    "birthYear": 1739,
    "deathYear": 1793,
    "birthDate": "1739",
    "deathDate": "Mar 1793",
    "burialDate": "12 Mar 1793",
    "christeningDate": null,
    "birthPlace": "Kendal, Westmorland, England",
    "deathPlace": "Kendal, Westmorland, England, United Kingdom",
    "burialPlace": "Kendal, Westmorland, England, United Kingdom",
    "christeningPlace": null,
    "fsId": "LC37-3WG",
    "photo": "/ancestors/bubbles/0289_LC37-3WG.jpg",
    "living": false,
    "alternateNames": [
      "Ann",
      "Ann Stewart",
      "Anne",
      "Mrs. Ann Stuart",
      "Mrs. Anne Stuart"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0289_LC37-3WG.jpg"
  },
  {
    "id": "AQI291",
    "name": "James Munro",
    "sex": "M",
    "gen": 8,
    "slot": 34,
    "side": "paternal",
    "birthplace": "scotland",
    "childId": "AQI150",
    "birthYear": 1759,
    "deathYear": null,
    "birthDate": "Abt 1759",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Glasgow, Lanarkshire, Scotland, United Kingdom",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "KZF6-G3P",
    "photo": "/ancestors/bubbles/0290_KZF6-G3P.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0290_KZF6-G3P.jpg"
  },
  {
    "id": "AQI292",
    "name": "Mary McAllum",
    "sex": "F",
    "gen": 8,
    "slot": 35,
    "side": "paternal",
    "birthplace": "scotland",
    "childId": "AQI150",
    "birthYear": 1763,
    "deathYear": null,
    "birthDate": "Abt 1763",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Glasgow, Lanarkshire, Scotland, United Kingdom",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "K837-BG1",
    "photo": "/ancestors/bubbles/0291_K837-BG1.jpg",
    "living": false,
    "alternateNames": [
      "Mary Mc Allum"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0291_K837-BG1.jpg"
  },
  {
    "id": "AQI293",
    "name": "William Huddleston",
    "sex": "M",
    "gen": 8,
    "slot": 36,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI151",
    "birthYear": 1764,
    "deathYear": 1847,
    "birthDate": "10 Apr 1764",
    "deathDate": "Jan 1847",
    "burialDate": "11 Jan 1847",
    "christeningDate": "6 May 1764",
    "birthPlace": "Staveley, Westmorland, England, United Kingdom",
    "deathPlace": "Staveley, Westmorland, England",
    "burialPlace": "Staveley, Westmorland, England",
    "christeningPlace": "Staveley, Westmorland, England, United Kingdom",
    "fsId": "L7L2-8T7",
    "photo": "/ancestors/bubbles/0292_L7L2-8T7.jpg",
    "living": false,
    "alternateNames": [
      "William Huddlestone",
      "Wm Huddlestone",
      "Wm. Huddleston",
      "Wm. Huddlestone"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0292_L7L2-8T7.jpg"
  },
  {
    "id": "AQI294",
    "name": "Margaret Robinson",
    "sex": "F",
    "gen": 8,
    "slot": 37,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI151",
    "birthYear": 1758,
    "deathYear": 1850,
    "birthDate": "8 Jun 1758",
    "deathDate": "Jan 1850",
    "burialDate": "25 Jan 1850",
    "christeningDate": "8 Jun 1758",
    "birthPlace": "Staveley, Westmorland, England, United Kingdom",
    "deathPlace": "Staveley, Westmorland, England, United Kingdom",
    "burialPlace": "Staveley, Westmorland, England, United Kingdom",
    "christeningPlace": "Staveley, Westmorland, England",
    "fsId": "L7L2-D4W",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI295",
    "name": "William Nelson",
    "sex": "M",
    "gen": 8,
    "slot": 38,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI152",
    "birthYear": 1760,
    "deathYear": null,
    "birthDate": "Abt 1760",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Smeaton, Yorkshire, England",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "L7J5-QP1",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI296",
    "name": "Isabella Moore",
    "sex": "F",
    "gen": 8,
    "slot": 39,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI152",
    "birthYear": 1763,
    "deathYear": null,
    "birthDate": "Abt 1763",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Leake, Yorkshire, England, United Kingdom",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "47NV-WTT",
    "photo": "/ancestors/bubbles/0295_47NV-WTT.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0295_47NV-WTT.jpg"
  },
  {
    "id": "AQI297",
    "name": "John Evans",
    "sex": "M",
    "gen": 8,
    "slot": 40,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI153",
    "birthYear": 1758,
    "deathYear": null,
    "birthDate": "1758",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "11 Nov 1759",
    "birthPlace": "Bridgemere, Cheshire, England",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Wybunbury, Cheshire, England",
    "fsId": "MQHC-FCX",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI298",
    "name": "Winnefred Roberts",
    "sex": "F",
    "gen": 8,
    "slot": 41,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI153",
    "birthYear": 1760,
    "deathYear": null,
    "birthDate": "Abt 1760",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Liverpool, Lancashire, England, United Kingdom",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "9N5B-MVY",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI299",
    "name": "David Lewis",
    "sex": "M",
    "gen": 8,
    "slot": 42,
    "side": "paternal",
    "birthplace": "wales",
    "childId": "AQI154",
    "birthYear": 1761,
    "deathYear": 1815,
    "birthDate": "Abt 1761",
    "deathDate": "11 Oct 1815",
    "burialDate": null,
    "christeningDate": "15 Feb 1761",
    "birthPlace": "Swansea, Glamorgan, Wales, United Kingdom",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Glamorgan, Wales",
    "fsId": "LKNZ-1LH",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI300",
    "name": "Jess Griffeths",
    "sex": "F",
    "gen": 8,
    "slot": 43,
    "side": "paternal",
    "birthplace": "wales",
    "childId": "AQI154",
    "birthYear": 1765,
    "deathYear": null,
    "birthDate": "Abt 1765",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Swansea, Glamorgan, Wales, United Kingdom",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LH61-2Q5",
    "photo": null,
    "living": false,
    "alternateNames": [
      "David- Mrs Lewis",
      "Mrs. David Lewis"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI301",
    "name": "James Davies",
    "sex": "M",
    "gen": 8,
    "slot": 44,
    "side": "paternal",
    "birthplace": "wales",
    "childId": "AQI155",
    "birthYear": 1747,
    "deathYear": null,
    "birthDate": "1747",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Wales, United Kingdom",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "GSTT-V2L",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI302",
    "name": "James Davies",
    "sex": "F",
    "gen": 8,
    "slot": 45,
    "side": "paternal",
    "birthplace": "wales",
    "childId": "AQI155",
    "birthYear": 1750,
    "deathYear": null,
    "birthDate": "Abt 1750",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Wales, United Kingdom",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "GDLV-YWQ",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI303",
    "name": "John Edwards",
    "sex": "M",
    "gen": 8,
    "slot": 46,
    "side": "paternal",
    "birthplace": "wales",
    "childId": "AQI156",
    "birthYear": 1760,
    "deathYear": null,
    "birthDate": "Abt 1760",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Llanfynydd, Carmarthenshire, Wales, United Kingdom",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "G3MR-SH1",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI304",
    "name": "John Edwards",
    "sex": "F",
    "gen": 8,
    "slot": 47,
    "side": "paternal",
    "birthplace": "wales",
    "childId": "AQI156",
    "birthYear": 1762,
    "deathYear": null,
    "birthDate": "Abt 1762",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Wales, United Kingdom",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "GX3F-VBF",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI305",
    "name": "David Thomas",
    "sex": "M",
    "gen": 8,
    "slot": 48,
    "side": "paternal",
    "birthplace": "wales",
    "childId": "AQI157",
    "birthYear": 1749,
    "deathYear": null,
    "birthDate": "1749",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Llangan, Glamorgan, Wales",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "KZ68-LLP",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI306",
    "name": "Anne Morgan",
    "sex": "F",
    "gen": 8,
    "slot": 49,
    "side": "paternal",
    "birthplace": "wales",
    "childId": "AQI157",
    "birthYear": 1755,
    "deathYear": null,
    "birthDate": "1755",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "21 Feb 1755",
    "birthPlace": "Carmarthenshire, Wales",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Llandilofawr, Carmarthenshire, Wales",
    "fsId": "L4ZX-LZR",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI307",
    "name": "David WILLIAMS",
    "sex": "M",
    "gen": 8,
    "slot": 50,
    "side": "paternal",
    "birthplace": "wales",
    "childId": "AQI158",
    "birthYear": 1766,
    "deathYear": null,
    "birthDate": "1766",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Pembrey, Carmarthenshire, Wales, United Kingdom",
    "deathPlace": "Pontypridd, Glamorgan, Wales, United Kingdom",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "L1BG-K49",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI308",
    "name": "Sarah WILLIAMS",
    "sex": "F",
    "gen": 8,
    "slot": 51,
    "side": "paternal",
    "birthplace": "wales",
    "childId": "AQI158",
    "birthYear": 1770,
    "deathYear": null,
    "birthDate": "1770",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Pembrey, Carmarthenshire, Wales, United Kingdom",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "L1BG-KPH",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI309",
    "name": "George Sparrey",
    "sex": "M",
    "gen": 8,
    "slot": 52,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI159",
    "birthYear": 1778,
    "deathYear": null,
    "birthDate": "Abt 1778",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Rowington, Warwickshire, England, United Kingdom",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "KJPZ-Y1H",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Geo Sparrey"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI310",
    "name": "Mary Aldington",
    "sex": "F",
    "gen": 8,
    "slot": 53,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI159",
    "birthYear": 1778,
    "deathYear": null,
    "birthDate": "Abt 1778",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Rowington, Warwickshire, England, United Kingdom",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "KJPZ-YRZ",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Mary",
      "Sarah"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI311",
    "name": "Benjamin Adams",
    "sex": "M",
    "gen": 8,
    "slot": 54,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI160",
    "birthYear": 1786,
    "deathYear": 1827,
    "birthDate": "1786",
    "deathDate": "12 Oct 1827",
    "burialDate": null,
    "christeningDate": "24 Dec 1786",
    "birthPlace": "Staffordshire, England, United Kingdom",
    "deathPlace": "Dudley, Worcestershire, England, United Kingdom",
    "burialPlace": null,
    "christeningPlace": "Halesowen, Worcestershire, England, United Kingdom",
    "fsId": "KJ6Z-VPF",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI312",
    "name": "Phoebe Civeter",
    "sex": "F",
    "gen": 8,
    "slot": 55,
    "side": "paternal",
    "birthplace": "unknown",
    "childId": "AQI160",
    "birthYear": null,
    "deathYear": null,
    "birthDate": null,
    "deathDate": null,
    "burialDate": "6 Jan 1833",
    "christeningDate": "12 Aug 1787",
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": "Bedwardine, Worcestershire, England, United Kingdom",
    "christeningPlace": "Halesowen, Worcestershire, England, United Kingdom",
    "fsId": "KJ6Z-VT5",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Mrs. Phoebe Adams"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI313",
    "name": "James Dredge",
    "sex": "M",
    "gen": 8,
    "slot": 56,
    "side": "paternal",
    "birthplace": "unknown",
    "childId": "AQI161",
    "birthYear": null,
    "deathYear": 1837,
    "birthDate": null,
    "deathDate": "1837",
    "burialDate": "29 Aug 1852",
    "christeningDate": "27 Dec 1769",
    "birthPlace": null,
    "deathPlace": "Frome, Somerset, England, United Kingdom",
    "burialPlace": "Ston Easton, Somerset, England, United Kingdom",
    "christeningPlace": "Frome, Somerset, England, United Kingdom",
    "fsId": "MSDP-ZYH",
    "photo": "/ancestors/bubbles/0312_MSDP-ZYH.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0312_MSDP-ZYH.jpg"
  },
  {
    "id": "AQI314",
    "name": "Hannah Yeates",
    "sex": "F",
    "gen": 8,
    "slot": 57,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI161",
    "birthYear": 1770,
    "deathYear": 1849,
    "birthDate": "Abt 1770",
    "deathDate": "8 Jan 1849",
    "burialDate": null,
    "christeningDate": "8 Jul 1770",
    "birthPlace": "Frome, Somerset, England, United Kingdom",
    "deathPlace": "Gare Hill, Somerset, England, United Kingdom",
    "burialPlace": null,
    "christeningPlace": "Heytesbury, Wiltshire, England, United Kingdom",
    "fsId": "KPH3-WQQ",
    "photo": "/ancestors/bubbles/0313_KPH3-WQQ.jpg",
    "living": false,
    "alternateNames": [
      "Hannah Yates Or Yeates",
      "Hannah Yeats",
      "Hannah Dredge"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0313_KPH3-WQQ.jpg"
  },
  {
    "id": "AQI315",
    "name": "Philip Sharp",
    "sex": "M",
    "gen": 8,
    "slot": 58,
    "side": "paternal",
    "birthplace": "unknown",
    "childId": "AQI162",
    "birthYear": null,
    "deathYear": null,
    "birthDate": null,
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LCP8-RGB",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Philip Sharpe",
      "Phillip Sharp",
      "Phillip Sharpe"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI316",
    "name": "Sarah",
    "sex": "F",
    "gen": 8,
    "slot": 59,
    "side": "paternal",
    "birthplace": "unknown",
    "childId": "AQI162",
    "birthYear": null,
    "deathYear": null,
    "birthDate": null,
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LZW7-RJX",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Sarah Deane or Daine",
      "Sarah Deane"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI317",
    "name": "Horatio Nelson",
    "sex": "M",
    "gen": 8,
    "slot": 60,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI163",
    "birthYear": 1758,
    "deathYear": 1805,
    "birthDate": "29 Sep 1758",
    "deathDate": "21 Oct 1805",
    "burialDate": "8 Jan 1806",
    "christeningDate": "9 Oct 1758",
    "birthPlace": "Burnham Thorpe, Norfolk, England",
    "deathPlace": "Cádiz, Andalusia, Spain",
    "burialPlace": "St Paul's Cathedral, London, England, United Kingdom",
    "christeningPlace": "Burnham Thorpe, Norfolk, England",
    "fsId": "LVGL-ZR4",
    "photo": "/ancestors/bubbles/0316_LVGL-ZR4.jpg",
    "living": false,
    "alternateNames": [
      "Viscount Admiral Horatio Nelson",
      "First Viscount Nelson Duke of Bronte I",
      "Admiral Nelson",
      "The Right Honorable Nelson"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0316_LVGL-ZR4.jpg"
  },
  {
    "id": "AQI318",
    "name": "Harriet Rhees",
    "sex": "F",
    "gen": 8,
    "slot": 61,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI163",
    "birthYear": 1777,
    "deathYear": 1856,
    "birthDate": "27 Dec 1777",
    "deathDate": "26 Sep 1856",
    "burialDate": "Sep 1856",
    "christeningDate": "27 Dec 1777",
    "birthPlace": "Corsham, Wiltshire, England",
    "deathPlace": "Bath, Somerset, England, United Kingdom",
    "burialPlace": "England, United Kingdom",
    "christeningPlace": "Walcot, Somerset, England",
    "fsId": "LZGH-7N2",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI319",
    "name": "John Green",
    "sex": "M",
    "gen": 8,
    "slot": 62,
    "side": "paternal",
    "birthplace": "unknown",
    "childId": "AQI164",
    "birthYear": null,
    "deathYear": null,
    "birthDate": null,
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LZ24-QKF",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI320",
    "name": "Sarah Charmbury",
    "sex": "F",
    "gen": 8,
    "slot": 63,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI164",
    "birthYear": 1776,
    "deathYear": 1852,
    "birthDate": "1776",
    "deathDate": "24 Oct 1852",
    "burialDate": "1852",
    "christeningDate": "20 May 1781",
    "birthPlace": "Bath, Somerset, England, United Kingdom",
    "deathPlace": null,
    "burialPlace": "Bath St Michael, Somerset, England, United Kingdom",
    "christeningPlace": "Monkton Combe, Somerset, England, United Kingdom",
    "fsId": "M4YZ-KDW",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Mrs. John Green",
      "Mrs. Sarah Green",
      "Sarah Green"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI321",
    "name": "Jabez Hull",
    "sex": "M",
    "gen": 8,
    "slot": 64,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI165",
    "birthYear": 1770,
    "deathYear": 1854,
    "birthDate": "11 Jan 1770",
    "deathDate": "11 Jan 1854",
    "burialDate": null,
    "christeningDate": "11 Aug 1771",
    "birthPlace": "Dutchess, New York, United States",
    "deathPlace": "La Salle, LaSalle, Illinois, United States",
    "burialPlace": null,
    "christeningPlace": "Salem Center, North Salem, Westchester, New York, United States",
    "fsId": "LZ6X-4YZ",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI322",
    "name": "Lydia Vinal",
    "sex": "F",
    "gen": 8,
    "slot": 65,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI165",
    "birthYear": 1776,
    "deathYear": 1810,
    "birthDate": "11 Dec 1776",
    "deathDate": "1810",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Scituate, Plymouth, Massachusetts, United States",
    "deathPlace": "East Otto, Cattaraugus, New York, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LZ6X-HF9",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Lydia Vinal Hull",
      "Lydia Vianl",
      "Lydia Hull",
      "Lydia",
      "Lidia Vinal"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI323",
    "name": "Joseph Lee",
    "sex": "M",
    "gen": 8,
    "slot": 66,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI166",
    "birthYear": 1784,
    "deathYear": 1853,
    "birthDate": "Abt 1784",
    "deathDate": "18 Jun 1853",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "New York, United States",
    "deathPlace": "Erie, Pennsylvania, United States",
    "burialPlace": "Erie, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "9C1X-PXJ",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI324",
    "name": "Elizabeth Dewey",
    "sex": "F",
    "gen": 8,
    "slot": 67,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI166",
    "birthYear": 1785,
    "deathYear": 1838,
    "birthDate": "From 1785 to 1786",
    "deathDate": "24 Feb 1838",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Canaan, Canaan, Columbia, New York, United States",
    "deathPlace": "Erie, Pennsylvania, United States",
    "burialPlace": "Erie, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "KHQH-BDT",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI325",
    "name": "John Lindsay",
    "sex": "M",
    "gen": 8,
    "slot": 68,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI167",
    "birthYear": 1773,
    "deathYear": 1826,
    "birthDate": "21 Jul 1773",
    "deathDate": "18 Jun 1826",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Dracut, Middlesex, Massachusetts, United States",
    "deathPlace": "Maine, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LHPF-DW1",
    "photo": null,
    "living": false,
    "alternateNames": [
      "John Lindsey"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI326",
    "name": "Abigail M Williams",
    "sex": "F",
    "gen": 8,
    "slot": 69,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI167",
    "birthYear": 1778,
    "deathYear": 1850,
    "birthDate": "20 Feb 1778",
    "deathDate": "1850",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Maine, United States",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LZZH-8VJ",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Abigail M. Williams",
      "Abigail Williams"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI327",
    "name": "Francis Bunker",
    "sex": "M",
    "gen": 8,
    "slot": 70,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI168",
    "birthYear": 1738,
    "deathYear": 1815,
    "birthDate": "31 Dec 1738",
    "deathDate": "1815",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Durham, Strafford, New Hampshire, United States",
    "deathPlace": "Pittsfield, Merrimack, New Hampshire, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LHZS-CNM",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Francis"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI328",
    "name": "Elizabeth Jennings",
    "sex": "F",
    "gen": 8,
    "slot": 71,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI168",
    "birthYear": 1737,
    "deathYear": 1796,
    "birthDate": "Abt 1737",
    "deathDate": "1796",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Durham, Strafford, New Hampshire, British Colonial America",
    "deathPlace": "New Hampshire, British Colonial America",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LHZS-CNX",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Elizabeth ( Betsy) Bunker",
      "Mrs Elizabeth Bunker",
      "Mrs. Betsey Bunker",
      "Mrs. Elisabeth Bunker",
      "Mrs. Elizabeth ( Betsey) Bunker",
      "Mrs. Elizabeth Betsey Bunker",
      "Mrs. Elizabeth Betsy Bunker",
      "Mrs. Elizabeth Bunker",
      "Elizabeth"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI329",
    "name": "Ezra Benedict",
    "sex": "M",
    "gen": 8,
    "slot": 72,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI169",
    "birthYear": 1763,
    "deathYear": 1817,
    "birthDate": "5 Apr 1763",
    "deathDate": "Abt 8 Jan 1817",
    "burialDate": null,
    "christeningDate": "15 Apr 1763",
    "birthPlace": "New Milford, Litchfield, Connecticut, United States",
    "deathPlace": "Leeds and Grenville, Ontario, Canada",
    "burialPlace": null,
    "christeningPlace": "New Milford, Litchfield, Connecticut, United States",
    "fsId": "LZNS-QRN",
    "photo": "/ancestors/bubbles/0328_LZNS-QRN.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0328_LZNS-QRN.jpg"
  },
  {
    "id": "AQI330",
    "name": "Eunice Bull",
    "sex": "F",
    "gen": 8,
    "slot": 73,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI169",
    "birthYear": 1770,
    "deathYear": 1813,
    "birthDate": "26 Jul 1770",
    "deathDate": "Abt 14 May 1813",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Manchester, Bennington, Vermont, United States",
    "deathPlace": "Leeds and Grenville, Ontario, Canada",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LZNS-QY6",
    "photo": "/ancestors/bubbles/0329_LZNS-QY6.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0329_LZNS-QY6.jpg"
  },
  {
    "id": "AQI331",
    "name": "Jedediah Wing",
    "sex": "M",
    "gen": 8,
    "slot": 74,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI170",
    "birthYear": 1767,
    "deathYear": 1842,
    "birthDate": "Abt 1767",
    "deathDate": "Abt 1842",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Quaker Hill, Pawling, Dutchess, New York, United States",
    "deathPlace": "Front of Escott Township, Leeds and Grenville, Ontario, Canada",
    "burialPlace": "Quaker Cemetery, Athens Township, Leeds and Grenville, Ontario, Canada",
    "christeningPlace": null,
    "fsId": "LZK4-7L1",
    "photo": "/ancestors/bubbles/0330_LZK4-7L1.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0330_LZK4-7L1.jpg"
  },
  {
    "id": "AQI332",
    "name": "Elizabeth Mary Bentley",
    "sex": "F",
    "gen": 8,
    "slot": 75,
    "side": "paternal",
    "birthplace": "canada",
    "childId": "AQI170",
    "birthYear": 1782,
    "deathYear": null,
    "birthDate": "3 Oct 1782",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Young's Creek, Norfolk, Ontario, Canada",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "GDR4-2F8",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI333",
    "name": "David Hammer",
    "sex": "M",
    "gen": 8,
    "slot": 76,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI171",
    "birthYear": 1768,
    "deathYear": 1845,
    "birthDate": "1768",
    "deathDate": "26 Dec 1845",
    "burialDate": "1845",
    "christeningDate": null,
    "birthPlace": "Maryland, United States",
    "deathPlace": "Salem, Henry, Iowa, United States",
    "burialPlace": "Lanier Township, Preble, Ohio, United States",
    "christeningPlace": null,
    "fsId": "LCJF-GFY",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI334",
    "name": "Charlotte Jay",
    "sex": "F",
    "gen": 8,
    "slot": 77,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI171",
    "birthYear": 1771,
    "deathYear": 1852,
    "birthDate": "27 Apr 1771",
    "deathDate": "28 Dec 1852",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "South Carolina, British Colonial America",
    "deathPlace": "Randolph Township, Ohio, Indiana, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LCJF-G2G",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Charlotte Hammer"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI335",
    "name": "Meshach Llewellyn",
    "sex": "M",
    "gen": 8,
    "slot": 78,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI172",
    "birthYear": 1763,
    "deathYear": 1832,
    "birthDate": "29 Jan 1763",
    "deathDate": "1832",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Loudoun, Virginia, United States",
    "deathPlace": "Ridgeville, Randolph, Indiana, United States",
    "burialPlace": "Randolph, Indiana, United States",
    "christeningPlace": null,
    "fsId": "L3XJ-TZY",
    "photo": "/ancestors/bubbles/0334_L3XJ-TZY.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0334_L3XJ-TZY.jpg"
  },
  {
    "id": "AQI336",
    "name": "Hannah Brooks",
    "sex": "F",
    "gen": 8,
    "slot": 79,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI172",
    "birthYear": 1770,
    "deathYear": 1842,
    "birthDate": "1770",
    "deathDate": "Nov 1842",
    "burialDate": "1842",
    "christeningDate": null,
    "birthPlace": "Pittsburgh, Allegheny, Pennsylvania, United States",
    "deathPlace": "Randolph, Indiana, United States",
    "burialPlace": "Randolph, Indiana, United States",
    "christeningPlace": null,
    "fsId": "LHWC-JLW",
    "photo": "/ancestors/bubbles/0335_LHWC-JLW.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0335_LHWC-JLW.jpg"
  },
  {
    "id": "AQI337",
    "name": "Moses J. Cranor",
    "sex": "M",
    "gen": 8,
    "slot": 80,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI173",
    "birthYear": 1769,
    "deathYear": 1858,
    "birthDate": "28 Dec 1769",
    "deathDate": "9 May 1858",
    "burialDate": "1858",
    "christeningDate": null,
    "birthPlace": "Virginia, British Colonial America",
    "deathPlace": "Saint Charles, Hopkins, Kentucky, United States",
    "burialPlace": "Christian Privilege Cemetery, Saint Charles, Hopkins, Kentucky, United States",
    "christeningPlace": null,
    "fsId": "L41D-41J",
    "photo": "/ancestors/bubbles/0336_L41D-41J.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0336_L41D-41J.jpg"
  },
  {
    "id": "AQI338",
    "name": "Jane Trotter",
    "sex": "F",
    "gen": 8,
    "slot": 81,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI173",
    "birthYear": 1772,
    "deathYear": 1850,
    "birthDate": "1772",
    "deathDate": "1850",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Guilford, Guilford, North Carolina, United States",
    "deathPlace": "Guilford, Guilford, North Carolina, United States",
    "burialPlace": "Saint Charles, Hopkins, Kentucky, United States",
    "christeningPlace": null,
    "fsId": "L41D-41N",
    "photo": "/ancestors/bubbles/0337_L41D-41N.jpg",
    "living": false,
    "alternateNames": [
      "Jane Cranor"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0337_L41D-41N.jpg"
  },
  {
    "id": "AQI339",
    "name": "John Stevenson",
    "sex": "M",
    "gen": 8,
    "slot": 82,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI174",
    "birthYear": 1780,
    "deathYear": 1831,
    "birthDate": "1780",
    "deathDate": "15 Nov 1831",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Rowan, North Carolina, United States",
    "deathPlace": "Rowan, North Carolina, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LCJB-14T",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI340",
    "name": "Jane McClellan",
    "sex": "F",
    "gen": 8,
    "slot": 83,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI174",
    "birthYear": 1790,
    "deathYear": null,
    "birthDate": "Jun 1790",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "United States",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LR2V-CTR",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI341",
    "name": "Joshua Edwards",
    "sex": "M",
    "gen": 8,
    "slot": 84,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI175",
    "birthYear": 1773,
    "deathYear": 1826,
    "birthDate": "10 Mar 1773",
    "deathDate": "22 Feb 1826",
    "burialDate": "Feb 1826",
    "christeningDate": null,
    "birthPlace": "Chatham, North Carolina, British Colonial America",
    "deathPlace": "Chatham, North Carolina, United States",
    "burialPlace": "Chatham, North Carolina, United States",
    "christeningPlace": null,
    "fsId": "L413-FS6",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI337s86",
    "name": "Moses J. Cranor",
    "sex": "M",
    "gen": 8,
    "slot": 86,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI176",
    "birthYear": 1769,
    "deathYear": 1858,
    "birthDate": "28 Dec 1769",
    "deathDate": "9 May 1858",
    "burialDate": "1858",
    "christeningDate": null,
    "birthPlace": "Virginia, British Colonial America",
    "deathPlace": "Saint Charles, Hopkins, Kentucky, United States",
    "burialPlace": "Christian Privilege Cemetery, Saint Charles, Hopkins, Kentucky, United States",
    "christeningPlace": null,
    "fsId": "L41D-41J",
    "photo": "/ancestors/bubbles/0336_L41D-41J.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0336_L41D-41J.jpg"
  },
  {
    "id": "AQI338s87",
    "name": "Jane Trotter",
    "sex": "F",
    "gen": 8,
    "slot": 87,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI176",
    "birthYear": 1772,
    "deathYear": 1850,
    "birthDate": "1772",
    "deathDate": "1850",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Guilford, Guilford, North Carolina, United States",
    "deathPlace": "Guilford, Guilford, North Carolina, United States",
    "burialPlace": "Saint Charles, Hopkins, Kentucky, United States",
    "christeningPlace": null,
    "fsId": "L41D-41N",
    "photo": "/ancestors/bubbles/0337_L41D-41N.jpg",
    "living": false,
    "alternateNames": [
      "Jane Cranor"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0337_L41D-41N.jpg"
  },
  {
    "id": "AQI342",
    "name": "Absalom Mendenhall",
    "sex": "M",
    "gen": 8,
    "slot": 88,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI177",
    "birthYear": 1780,
    "deathYear": 1848,
    "birthDate": "18 Mar 1780",
    "deathDate": "25 Aug 1848",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Springfield, Guilford, North Carolina, United States",
    "deathPlace": "Hillsboro, Cain Township, Fountain, Indiana, United States",
    "burialPlace": "Spring Hill Cemetery, Hillsboro, Cain Township, Fountain, Indiana, United States",
    "christeningPlace": null,
    "fsId": "L413-FSF",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Absalom Mendenhall I"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI343",
    "name": "Judith Taliaferro",
    "sex": "F",
    "gen": 8,
    "slot": 89,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI177",
    "birthYear": 1780,
    "deathYear": 1845,
    "birthDate": "1780",
    "deathDate": "18 Aug 1845",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Surry, North Carolina, United States",
    "deathPlace": "Fountain, Shawnee Township, Fountain, Indiana, United States",
    "burialPlace": "Spring Hill Cemetery, Hillsboro, Cain Township, Fountain, Indiana, United States",
    "christeningPlace": null,
    "fsId": "LLW2-ZTF",
    "photo": "/ancestors/bubbles/0345_LLW2-ZTF.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0345_LLW2-ZTF.jpg"
  },
  {
    "id": "AQI344",
    "name": "Henry Bristow",
    "sex": "M",
    "gen": 8,
    "slot": 90,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI178",
    "birthYear": 1779,
    "deathYear": 1830,
    "birthDate": "1779",
    "deathDate": "9 Sep 1830",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Henry, Virginia, United States",
    "deathPlace": "Indiana, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "L7G5-TWT",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Henry Clay Bristow"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI345",
    "name": "Margaret \"Peggy\" Patterson",
    "sex": "F",
    "gen": 8,
    "slot": 91,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI178",
    "birthYear": 1785,
    "deathYear": 1830,
    "birthDate": "1785",
    "deathDate": "Abt 1830",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Virginia, United States",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LHZW-HH3",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Mrs. Peggy Bristow",
      "Mrs. Margaret Bristow",
      "Peggy Patterson"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI346",
    "name": "Richard Van Meter",
    "sex": "M",
    "gen": 8,
    "slot": 94,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI180",
    "birthYear": 1786,
    "deathYear": null,
    "birthDate": "3 Apr 1786",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "1786",
    "birthPlace": "Fonda, Mohawk, Montgomery, New York, United States",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Tennent, Manalapan Township, Monmouth, New Jersey, United States",
    "fsId": "L71X-WCH",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Richard Van Mater"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI347",
    "name": "Hannah Annatje Heagle",
    "sex": "F",
    "gen": 8,
    "slot": 95,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI180",
    "birthYear": 1787,
    "deathYear": 1865,
    "birthDate": "24 May 1787",
    "deathDate": "2 Jan 1865",
    "burialDate": null,
    "christeningDate": "28 May 1787",
    "birthPlace": "Johnstown, Fulton, New York, United States",
    "deathPlace": "Johnstown, Livingston, Columbia, New York, United States",
    "burialPlace": "Johnstown, Fulton, New York, United States",
    "christeningPlace": "Caughnawaga, Montgomery, New York, United States",
    "fsId": "K24Q-5QH",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Annatje Heagle ( Hagel)",
      "Annyte Hegel",
      "Hannah Heagle ( Hagel)",
      "Hannah Hegel",
      "Hannah Heagle [Annytee Heycl]"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI348",
    "name": "Richard Blackner",
    "sex": "M",
    "gen": 8,
    "slot": 96,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI181",
    "birthYear": 1762,
    "deathYear": 1823,
    "birthDate": "21 Nov 1762",
    "deathDate": "13 Nov 1823",
    "burialDate": "13 Nov 1823",
    "christeningDate": null,
    "birthPlace": "Hucknall Torkard, Nottinghamshire, England",
    "deathPlace": "Hucknall Torkard, Nottinghamshire, England, United Kingdom",
    "burialPlace": "Hucknall Torkard, Nottinghamshire, England, United Kingdom",
    "christeningPlace": null,
    "fsId": "LZKY-JRL",
    "photo": "/ancestors/bubbles/0352_LZKY-JRL.jpg",
    "living": false,
    "alternateNames": [
      "Richard Blakener"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0352_LZKY-JRL.jpg"
  },
  {
    "id": "AQI349",
    "name": "Hannah Caunt",
    "sex": "F",
    "gen": 8,
    "slot": 97,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI181",
    "birthYear": 1760,
    "deathYear": 1806,
    "birthDate": "6 Apr 1760",
    "deathDate": "1806",
    "burialDate": null,
    "christeningDate": "6 Apr 1760",
    "birthPlace": "Hucknall Torkard, Nottinghamshire, England, United Kingdom",
    "deathPlace": "Hucknall Torkard, Nottinghamshire, England, United Kingdom",
    "burialPlace": null,
    "christeningPlace": "Hucknall Torkard, Nottinghamshire, England, United Kingdom",
    "fsId": "LCSQ-WNB",
    "photo": "/ancestors/bubbles/0353_LCSQ-WNB.jpg",
    "living": false,
    "alternateNames": [
      "Hannah Blackner"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0353_LCSQ-WNB.jpg"
  },
  {
    "id": "AQI350",
    "name": "John Hall",
    "sex": "M",
    "gen": 8,
    "slot": 98,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI182",
    "birthYear": 1759,
    "deathYear": 1811,
    "birthDate": "3 Jan 1759",
    "deathDate": "Feb 1811",
    "burialDate": "27 Feb 1811",
    "christeningDate": "5 Jan 1759",
    "birthPlace": "Great Hale, Lincolnshire, England",
    "deathPlace": "Heckington, Lincolnshire, England, United Kingdom",
    "burialPlace": "Great Hale, Lincolnshire, England, United Kingdom",
    "christeningPlace": "Great Hale, Lincolnshire, England",
    "fsId": "MPXB-G9W",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI351",
    "name": "Eleanor Ingram",
    "sex": "F",
    "gen": 8,
    "slot": 99,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI182",
    "birthYear": 1773,
    "deathYear": 1853,
    "birthDate": "28 Mar 1773",
    "deathDate": "1853",
    "burialDate": null,
    "christeningDate": "28 Mar 1773",
    "birthPlace": "Kirkby on Bain, Lincolnshire, England",
    "deathPlace": "Sunderland, Durham, England, United Kingdom",
    "burialPlace": null,
    "christeningPlace": "Kirkby on Bain, Lincolnshire, England",
    "fsId": "M9V5-3ND",
    "photo": "/ancestors/bubbles/0355_M9V5-3ND.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0355_M9V5-3ND.jpg"
  },
  {
    "id": "AQI352",
    "name": "Richard Allen",
    "sex": "M",
    "gen": 8,
    "slot": 100,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI183",
    "birthYear": 1781,
    "deathYear": 1831,
    "birthDate": "Abt 1781",
    "deathDate": "Oct 1831",
    "burialDate": "30 Oct 1831",
    "christeningDate": "14 Mar 1781",
    "birthPlace": "Sheffield, Yorkshire, England, United Kingdom",
    "deathPlace": "Attercliffe, Yorkshire, England, United Kingdom",
    "burialPlace": "Attercliffe, Yorkshire, England, United Kingdom",
    "christeningPlace": "Sheffield, Yorkshire, England, United Kingdom",
    "fsId": "M51R-W6N",
    "photo": "/ancestors/bubbles/0356_M51R-W6N.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0356_M51R-W6N.jpg"
  },
  {
    "id": "AQI353",
    "name": "Hannah Morson",
    "sex": "F",
    "gen": 8,
    "slot": 101,
    "side": "paternal",
    "birthplace": "unknown",
    "childId": "AQI183",
    "birthYear": null,
    "deathYear": 1822,
    "birthDate": null,
    "deathDate": "Abt 28 Dec 1822",
    "burialDate": "31 Dec 1822",
    "christeningDate": "21 Oct 1781",
    "birthPlace": null,
    "deathPlace": "Attercliffe, Yorkshire, England, United Kingdom",
    "burialPlace": "Attercliffe, Yorkshire, England, United Kingdom",
    "christeningPlace": "Mexborough, Yorkshire, England, United Kingdom",
    "fsId": "LHC9-6N2",
    "photo": "/ancestors/bubbles/0357_LHC9-6N2.jpg",
    "living": false,
    "alternateNames": [
      "Hannah Mauson",
      "Hannah Manson",
      "Hannah"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0357_LHC9-6N2.jpg"
  },
  {
    "id": "AQI354",
    "name": "John Lindley",
    "sex": "M",
    "gen": 8,
    "slot": 102,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI184",
    "birthYear": 1775,
    "deathYear": 1825,
    "birthDate": "6 Sep 1775",
    "deathDate": "2 Mar 1825",
    "burialDate": "2 Mar 1825",
    "christeningDate": null,
    "birthPlace": "Worksop, Nottinghamshire, England, United Kingdom",
    "deathPlace": "Worksop, Nottinghamshire, England, United Kingdom",
    "burialPlace": "Worksop, Nottinghamshire, England, United Kingdom",
    "christeningPlace": null,
    "fsId": "L5BY-XFT",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI355",
    "name": "Mary Keeling",
    "sex": "F",
    "gen": 8,
    "slot": 103,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI184",
    "birthYear": 1779,
    "deathYear": 1865,
    "birthDate": "1779",
    "deathDate": "13 Jul 1865",
    "burialDate": "16 Jul 1865",
    "christeningDate": "30 Dec 1779",
    "birthPlace": "Heptonstall, Yorkshire, England, United Kingdom",
    "deathPlace": "Kimberworth, Yorkshire, England, United Kingdom",
    "burialPlace": "Kimberworth, Yorkshire, England, United Kingdom",
    "christeningPlace": "Worksop, Nottinghamshire, England, United Kingdom",
    "fsId": "L5BG-HZ6",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI356",
    "name": "James Hare",
    "sex": "M",
    "gen": 8,
    "slot": 104,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI185",
    "birthYear": 1764,
    "deathYear": 1845,
    "birthDate": "5 Aug 1764",
    "deathDate": "26 Feb 1845",
    "burialDate": "28 Feb 1845",
    "christeningDate": "5 Aug 1764",
    "birthPlace": "Great Gonerby, Lincolnshire, England",
    "deathPlace": "Quarrington, Lincolnshire, England, United Kingdom",
    "burialPlace": "Quarrington, Lincolnshire, England, United Kingdom",
    "christeningPlace": "Great Gonerby, Lincolnshire, England, United Kingdom",
    "fsId": "LDYC-65P",
    "photo": "/ancestors/bubbles/0360_LDYC-65P.jpg",
    "living": false,
    "alternateNames": [
      "James Eyre"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0360_LDYC-65P.jpg"
  },
  {
    "id": "AQI357",
    "name": "Ellen or Elleanor Elsey",
    "sex": "F",
    "gen": 8,
    "slot": 105,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI185",
    "birthYear": 1759,
    "deathYear": 1830,
    "birthDate": "8 Jul 1759",
    "deathDate": "30 Jun 1830",
    "burialDate": "Jul 1830",
    "christeningDate": "8 Jul 1759",
    "birthPlace": "Rippingale, Lincolnshire, England",
    "deathPlace": "Quarrington, Lincolnshire, England, United Kingdom",
    "burialPlace": "Quarrington, Lincolnshire, England, United Kingdom",
    "christeningPlace": "Rippingale, Lincolnshire, England",
    "fsId": "LZVC-76J",
    "photo": "/ancestors/bubbles/0361_LZVC-76J.jpg",
    "living": false,
    "alternateNames": [
      "Helen Elsey",
      "Ellen Elsey",
      "Helen Hare"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0361_LZVC-76J.jpg"
  },
  {
    "id": "AQI358",
    "name": "William Naylor",
    "sex": "M",
    "gen": 8,
    "slot": 106,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI186",
    "birthYear": 1761,
    "deathYear": 1811,
    "birthDate": "Abt 1761",
    "deathDate": "9 Oct 1811",
    "burialDate": "9 Oct 1811",
    "christeningDate": "11 Jan 1761",
    "birthPlace": "Helpringham, Lincolnshire, England",
    "deathPlace": "Heckington, Lincolnshire, England, United Kingdom",
    "burialPlace": "Heckington, Lincolnshire, England, United Kingdom",
    "christeningPlace": "Helpringham, Lincolnshire, England",
    "fsId": "LZVC-7FH",
    "photo": "/ancestors/bubbles/0362_LZVC-7FH.jpg",
    "living": false,
    "alternateNames": [
      "William Nailor"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0362_LZVC-7FH.jpg"
  },
  {
    "id": "AQI359",
    "name": "Ann Taylor",
    "sex": "F",
    "gen": 8,
    "slot": 107,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI186",
    "birthYear": 1766,
    "deathYear": 1833,
    "birthDate": "Abt 1766",
    "deathDate": "3 Nov 1833",
    "burialDate": "3 Nov 1833",
    "christeningDate": "15 May 1766",
    "birthPlace": "Donington, Lincolnshire, England",
    "deathPlace": "Heckington, Lincolnshire, England, United Kingdom",
    "burialPlace": "Heckington, Lincolnshire, England, United Kingdom",
    "christeningPlace": "Donington, Lincolnshire, England",
    "fsId": "27FS-PLP",
    "photo": "/ancestors/bubbles/0363_27FS-PLP.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0363_27FS-PLP.jpg"
  },
  {
    "id": "AQI360",
    "name": "John Hopkins",
    "sex": "M",
    "gen": 8,
    "slot": 108,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI187",
    "birthYear": 1785,
    "deathYear": 1833,
    "birthDate": "1785",
    "deathDate": "1833",
    "burialDate": null,
    "christeningDate": "Feb 1785",
    "birthPlace": "Wakefield, Yorkshire, England",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Llanrhidian, Glamorgan, Wales, United Kingdom",
    "fsId": "LZVC-7VW",
    "photo": null,
    "living": false,
    "alternateNames": [
      "John Hopkin"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI361",
    "name": "Mary Kershaw",
    "sex": "F",
    "gen": 8,
    "slot": 109,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI187",
    "birthYear": 1785,
    "deathYear": null,
    "birthDate": "1 Jan 1785",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "1 Jan 1785",
    "birthPlace": "Wakefield, Yorkshire, England",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Cathedral Church of All Saints, Wakefield, Yorkshire, England",
    "fsId": "L17P-SH6",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Mary Kirshaw",
      "Mary Hershaw",
      "Mary Keshaw",
      "Mary Hopkins"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI362",
    "name": "Joseph Marrison",
    "sex": "M",
    "gen": 8,
    "slot": 110,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI188",
    "birthYear": 1781,
    "deathYear": 1821,
    "birthDate": "6 May 1781",
    "deathDate": "31 May 1821",
    "burialDate": "31 May 1821",
    "christeningDate": "6 May 1781",
    "birthPlace": "Castleton, Derbyshire, England",
    "deathPlace": null,
    "burialPlace": "Castleton, Derbyshire, England, United Kingdom",
    "christeningPlace": "Castleton, Derbyshire, England, United Kingdom",
    "fsId": "LKKM-6CP",
    "photo": "/ancestors/bubbles/0366_LKKM-6CP.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0366_LKKM-6CP.jpg"
  },
  {
    "id": "AQI363",
    "name": "Betty Wright",
    "sex": "F",
    "gen": 8,
    "slot": 111,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI188",
    "birthYear": 1781,
    "deathYear": 1840,
    "birthDate": "4 Feb 1781",
    "deathDate": "1840",
    "burialDate": null,
    "christeningDate": "4 Feb 1781",
    "birthPlace": "Castleton, Derbyshire, England",
    "deathPlace": "Derby, Derbyshire, England, United Kingdom",
    "burialPlace": null,
    "christeningPlace": "Castleton, Derbyshire, England, United Kingdom",
    "fsId": "LL95-TH9",
    "photo": "/ancestors/bubbles/0367_LL95-TH9.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0367_LL95-TH9.jpg"
  },
  {
    "id": "AQI364",
    "name": "Robert Briggs",
    "sex": "M",
    "gen": 8,
    "slot": 112,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI189",
    "birthYear": 1748,
    "deathYear": null,
    "birthDate": "20 Aug 1748",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "20 Aug 1749",
    "birthPlace": "Bolton, Yorkshire, England, United Kingdom",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Sawley, Yorkshire, England, United Kingdom",
    "fsId": "LH7F-ZCN",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Robert Brigg",
      "Robert Brigge"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI365",
    "name": "Mary Parkinson",
    "sex": "F",
    "gen": 8,
    "slot": 113,
    "side": "paternal",
    "birthplace": "unknown",
    "childId": "AQI189",
    "birthYear": null,
    "deathYear": 1795,
    "birthDate": null,
    "deathDate": "Aft 1795",
    "burialDate": null,
    "christeningDate": "26 Apr 1747",
    "birthPlace": null,
    "deathPlace": "Yorkshire, England, United Kingdom",
    "burialPlace": null,
    "christeningPlace": "Bolton by Bowland, Yorkshire, England, United Kingdom",
    "fsId": "LJKQ-BDY",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Marey Parkinson"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI366",
    "name": "Peter Haworth",
    "sex": "M",
    "gen": 8,
    "slot": 114,
    "side": "paternal",
    "birthplace": "unknown",
    "childId": "AQI190",
    "birthYear": 1769,
    "deathYear": 1829,
    "birthDate": "Aug 1769",
    "deathDate": "20 Feb 1829",
    "burialDate": "20 Feb 1829",
    "christeningDate": "13 Aug 1769",
    "birthPlace": null,
    "deathPlace": "Accrington, Lancashire, England, United Kingdom",
    "burialPlace": "Accrington, Lancashire, England, United Kingdom",
    "christeningPlace": "St James' Church, Accrington, Lancashire, England",
    "fsId": "LZF5-W69",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Peter Howarth"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI367",
    "name": "Anne Riley",
    "sex": "F",
    "gen": 8,
    "slot": 115,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI190",
    "birthYear": 1768,
    "deathYear": 1814,
    "birthDate": "May 1768",
    "deathDate": "21 Mar 1814",
    "burialDate": "21 Mar 1814",
    "christeningDate": "24 May 1768",
    "birthPlace": "Haslingden, Lancashire, England",
    "deathPlace": "Baxenden, Lancashire, England, United Kingdom",
    "burialPlace": "Baxenden, Lancashire, England, United Kingdom",
    "christeningPlace": "Haslingden, Lancashire, England",
    "fsId": "LHQP-X1F",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Mrs. Joanna Howarth",
      "Mrs. Joanna Haworth",
      "Mrs. Joana Haworth",
      "Johanna",
      "Joanna Or Ann Riley",
      "Joanna MRS Haworth",
      "Joanna Howarth",
      "Joanna Ann Riley",
      "JOANNA",
      "Joana Haworth",
      "Joana",
      "Anne",
      "Ann Riley",
      "Ann Haworth",
      "Ann"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI368",
    "name": "John Fielding",
    "sex": "M",
    "gen": 8,
    "slot": 116,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI191",
    "birthYear": 1779,
    "deathYear": null,
    "birthDate": "1779",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "25 Sep 1779",
    "birthPlace": "Great Harwood, Lancashire, England, United Kingdom",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Great Harwood, Lancashire, England, United Kingdom",
    "fsId": "KHNZ-X2W",
    "photo": "/ancestors/bubbles/0372_KHNZ-X2W.jpg",
    "living": false,
    "alternateNames": [
      "john fielden"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0372_KHNZ-X2W.jpg"
  },
  {
    "id": "AQI369",
    "name": "Ellen Leaver",
    "sex": "F",
    "gen": 8,
    "slot": 117,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI191",
    "birthYear": 1762,
    "deathYear": null,
    "birthDate": "Abt 1762",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "4 Apr 1762",
    "birthPlace": "Blackburn, Lancashire, England",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Blackburn Cathedral, Blackburn, Lancashire, England, United Kingdom",
    "fsId": "9KHB-DT9",
    "photo": "/ancestors/bubbles/0373_9KHB-DT9.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0373_9KHB-DT9.jpg"
  },
  {
    "id": "AQI370",
    "name": "John Holden",
    "sex": "M",
    "gen": 8,
    "slot": 118,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI192",
    "birthYear": 1777,
    "deathYear": null,
    "birthDate": "8 Jul 1777",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "17 Aug 1777",
    "birthPlace": "Bury, Greater Manchester, England, United Kingdom",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Bury, Lancashire, England, United Kingdom",
    "fsId": "LDW2-QQF",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI371",
    "name": "Betty Thompson",
    "sex": "F",
    "gen": 8,
    "slot": 119,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI192",
    "birthYear": 1776,
    "deathYear": null,
    "birthDate": "1776",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "27 Apr 1776",
    "birthPlace": "Over Darwen, Lancashire, England",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Over Darwen, Lancashire, England",
    "fsId": "KCJL-Y7F",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Betty Holden",
      "Mrs. Betty Holden"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI372",
    "name": "Hendrich Jacobsen Almind",
    "sex": "M",
    "gen": 8,
    "slot": 124,
    "side": "paternal",
    "birthplace": "denmark",
    "childId": "AQI193",
    "birthYear": 1777,
    "deathYear": 1843,
    "birthDate": "13 Feb 1777",
    "deathDate": "15 Sep 1843",
    "burialDate": "19 Sep 1843",
    "christeningDate": "25 Feb 1777",
    "birthPlace": "Lilballe, Eltang, Brusk, Vejle, Denmark",
    "deathPlace": "Garnisons, Sokkelund, Copenhagen, Denmark",
    "burialPlace": "Garnisons, Sokkelund, Copenhagen, Denmark",
    "christeningPlace": "Lilballe, Eltang, Brusk, Vejle, Denmark",
    "fsId": "LCRJ-SLP",
    "photo": "/ancestors/bubbles/0380_LCRJ-SLP.jpg",
    "living": false,
    "alternateNames": [
      "Henrich Jacobsen Almind",
      "Henrich Jacobsen",
      "Henrich Almind"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0380_LCRJ-SLP.jpg"
  },
  {
    "id": "AQI373",
    "name": "Ellen Jacobsen Olsdatter",
    "sex": "F",
    "gen": 8,
    "slot": 125,
    "side": "paternal",
    "birthplace": "denmark",
    "childId": "AQI193",
    "birthYear": 1781,
    "deathYear": 1840,
    "birthDate": "1781",
    "deathDate": "1840",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Copenhagen, Copenhagen, Denmark",
    "deathPlace": "Copenhagen, Denmark",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LHP4-ZVM",
    "photo": "/ancestors/bubbles/0381_LHP4-ZVM.jpg",
    "living": false,
    "alternateNames": [
      "Ellen Olsdr",
      "Mrs. Jens Hendricksen Almind",
      "Ellen Jacobine"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0381_LHP4-ZVM.jpg"
  },
  {
    "id": "AQI374",
    "name": "Georg Christian Vonno",
    "sex": "M",
    "gen": 8,
    "slot": 126,
    "side": "paternal",
    "birthplace": "germany",
    "childId": "AQI194",
    "birthYear": 1759,
    "deathYear": 1839,
    "birthDate": "29 Apr 1759",
    "deathDate": "5 Jan 1839",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Germany",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "KGM1-C4C",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Christian Wanno",
      "Christian Wonno",
      "Christian Wonns",
      "Georg Vonno"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI375",
    "name": "Anne Margrethe Schroder",
    "sex": "F",
    "gen": 8,
    "slot": 127,
    "side": "paternal",
    "birthplace": "denmark",
    "childId": "AQI194",
    "birthYear": 1759,
    "deathYear": 1821,
    "birthDate": "14 Apr 1759",
    "deathDate": "20 Mar 1821",
    "burialDate": null,
    "christeningDate": "29 Apr 1759",
    "birthPlace": "Vor Frelsers, Nim, Stjernholm, Denmark",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "KFGR-PGN",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Anna Margaretha Schroder"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI384",
    "name": "Heck",
    "sex": "M",
    "gen": 8,
    "slot": 128,
    "side": "maternal",
    "birthplace": "unknown",
    "childId": "AQI199",
    "birthYear": 1755,
    "deathYear": null,
    "birthDate": "Abt 1755",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "G7ML-5WX",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI385",
    "name": "Heck",
    "sex": "F",
    "gen": 8,
    "slot": 129,
    "side": "maternal",
    "birthplace": "unknown",
    "childId": "AQI199",
    "birthYear": 1760,
    "deathYear": null,
    "birthDate": "Abt 1760",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "G7ML-XDH",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI386",
    "name": "George Diery",
    "sex": "M",
    "gen": 8,
    "slot": 130,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI200",
    "birthYear": 1744,
    "deathYear": 1822,
    "birthDate": "28 Apr 1744",
    "deathDate": "8 Apr 1822",
    "burialDate": "1822",
    "christeningDate": null,
    "birthPlace": "Chester, Pennsylvania, British Colonial America",
    "deathPlace": "Chester, Pennsylvania, United States",
    "burialPlace": "Pikeland Township, Chester, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "KLGD-TQ8",
    "photo": "/ancestors/bubbles/0386_KLGD-TQ8.jpg",
    "living": false,
    "alternateNames": [
      "George Deery"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0386_KLGD-TQ8.jpg"
  },
  {
    "id": "AQI387",
    "name": "Anna Maria Hippel",
    "sex": "F",
    "gen": 8,
    "slot": 131,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI200",
    "birthYear": 1749,
    "deathYear": 1836,
    "birthDate": "16 Jan 1749",
    "deathDate": "24 Dec 1836",
    "burialDate": "Dec 1836",
    "christeningDate": "28 Mar 1749",
    "birthPlace": "Chester, Pennsylvania, British Colonial America",
    "deathPlace": "Chester, Pennsylvania, United States",
    "burialPlace": "St. Peter's Pikeland Cemetery, Chester Springs, West Pikeland Township, Chester, Pennsylvania, United States",
    "christeningPlace": "Trappe, Montgomery, Pennsylvania, United States",
    "fsId": "2QK8-2L8",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Anna Maria Hipple"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI388",
    "name": "William Yarnall",
    "sex": "M",
    "gen": 8,
    "slot": 136,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI203",
    "birthYear": 1755,
    "deathYear": 1831,
    "birthDate": "3 Sep 1755",
    "deathDate": "5 Dec 1831",
    "burialDate": "Dec 1831",
    "christeningDate": null,
    "birthPlace": "Thornbury Township, Chester, Pennsylvania, British Colonial America",
    "deathPlace": null,
    "burialPlace": "Thornbury Township, Delaware, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LH8G-5XG",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Wm. Yarnall"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI389",
    "name": "Sarah Happersett",
    "sex": "F",
    "gen": 8,
    "slot": 137,
    "side": "maternal",
    "birthplace": "netherlands",
    "childId": "AQI203",
    "birthYear": 1756,
    "deathYear": 1825,
    "birthDate": "24 Sep 1756",
    "deathDate": "12 Jan 1825",
    "burialDate": "Jan 1825",
    "christeningDate": null,
    "birthPlace": "Delft, Holland, Netherlands",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LH8G-5F9",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Sarah",
      "Sarah Yarnall"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI390",
    "name": "John P. Noble",
    "sex": "M",
    "gen": 8,
    "slot": 144,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI205",
    "birthYear": 1731,
    "deathYear": 1807,
    "birthDate": "16 Apr 1731",
    "deathDate": "15 Sep 1807",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Westfield, Hampden, Massachusetts, United States",
    "deathPlace": "Blandford, Hampden, Massachusetts, United States",
    "burialPlace": "Blandford Cemetery, Blandford, Hampden, Massachusetts, United States",
    "christeningPlace": null,
    "fsId": "L7HK-JR2",
    "photo": "/ancestors/bubbles/0400_L7HK-JR2.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0400_L7HK-JR2.jpg"
  },
  {
    "id": "AQI391",
    "name": "Lois E. Sexton",
    "sex": "F",
    "gen": 8,
    "slot": 145,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI205",
    "birthYear": 1745,
    "deathYear": 1828,
    "birthDate": "7 Nov 1745",
    "deathDate": "1 Apr 1828",
    "burialDate": "1828",
    "christeningDate": null,
    "birthPlace": "Enfield, Hartford, Connecticut, United States",
    "deathPlace": "Blandford, Hampden, Massachusetts, United States",
    "burialPlace": "Blandford Cemetery, Blandford, Hampden, Massachusetts, United States",
    "christeningPlace": null,
    "fsId": "L7HK-LCT",
    "photo": "/ancestors/bubbles/0401_L7HK-LCT.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0401_L7HK-LCT.jpg"
  },
  {
    "id": "AQI392",
    "name": "David Buell",
    "sex": "M",
    "gen": 8,
    "slot": 146,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI206",
    "birthYear": 1741,
    "deathYear": 1841,
    "birthDate": "16 May 1741",
    "deathDate": "10 Sep 1841",
    "burialDate": "Sep 1841",
    "christeningDate": null,
    "birthPlace": "Lebanon, New London, Connecticut, United States",
    "deathPlace": "New Milford, Litchfield, Connecticut, United States",
    "burialPlace": "Center Cemetery, New Milford, Litchfield, Connecticut, United States",
    "christeningPlace": null,
    "fsId": "LHT1-V6V",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI393",
    "name": "Chloe Fisher",
    "sex": "F",
    "gen": 8,
    "slot": 147,
    "side": "maternal",
    "birthplace": "unknown",
    "childId": "AQI206",
    "birthYear": 1763,
    "deathYear": 1838,
    "birthDate": "4 Aug 1763",
    "deathDate": "11 Oct 1838",
    "burialDate": "Oct 1838",
    "christeningDate": null,
    "birthPlace": null,
    "deathPlace": "New Milford, Litchfield, Connecticut, United States",
    "burialPlace": "Center Cemetery, New Milford, Litchfield, Connecticut, United States",
    "christeningPlace": null,
    "fsId": "GMQR-B6R",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI394",
    "name": "John Garratt",
    "sex": "M",
    "gen": 8,
    "slot": 148,
    "side": "maternal",
    "birthplace": "england",
    "childId": "AQI207",
    "birthYear": 1760,
    "deathYear": 1845,
    "birthDate": "4 Jan 1760",
    "deathDate": "4 Jan 1845",
    "burialDate": "Jan 1845",
    "christeningDate": "25 Apr 1762",
    "birthPlace": "England, United Kingdom",
    "deathPlace": "Berlin Township, Wayne, Pennsylvania, United States",
    "burialPlace": "Berlin Township, Wayne, Pennsylvania, United States",
    "christeningPlace": "Nuneaton, Warwickshire, England",
    "fsId": "L8YZ-1HW",
    "photo": "/ancestors/bubbles/0404_L8YZ-1HW.jpg",
    "living": false,
    "alternateNames": [
      "John Garrett",
      "John Garrat"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0404_L8YZ-1HW.jpg"
  },
  {
    "id": "AQI395",
    "name": "Elizabeth Kelsey",
    "sex": "F",
    "gen": 8,
    "slot": 149,
    "side": "maternal",
    "birthplace": "england",
    "childId": "AQI207",
    "birthYear": 1761,
    "deathYear": 1828,
    "birthDate": "1761",
    "deathDate": "15 Jun 1828",
    "burialDate": null,
    "christeningDate": "25 Jan 1761",
    "birthPlace": "Nuneaton, Warwickshire, England, United Kingdom",
    "deathPlace": "Wayne, Pennsylvania, United States",
    "burialPlace": null,
    "christeningPlace": "Nuneaton, Warwickshire, England, United Kingdom",
    "fsId": "L2DF-35X",
    "photo": "/ancestors/bubbles/0405_L2DF-35X.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0405_L2DF-35X.jpg"
  },
  {
    "id": "AQI396",
    "name": "Samuel Albro",
    "sex": "M",
    "gen": 8,
    "slot": 150,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI208",
    "birthYear": 1777,
    "deathYear": 1865,
    "birthDate": "25 May 1777",
    "deathDate": "19 Nov 1865",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Dover, Dutchess, New York, United States",
    "deathPlace": "Towanda, Bradford, Pennsylvania, United States",
    "burialPlace": "Towanda, Bradford, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "L8RS-62N",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Samuel Albro III"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI397",
    "name": "Elizabeth Tice",
    "sex": "F",
    "gen": 8,
    "slot": 151,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI208",
    "birthYear": 1775,
    "deathYear": 1841,
    "birthDate": "13 Sep 1775",
    "deathDate": "15 Oct 1841",
    "burialDate": "Oct 1841",
    "christeningDate": null,
    "birthPlace": "Dutchess, New York, United States",
    "deathPlace": "Towanda, Bradford, Pennsylvania, United States",
    "burialPlace": "Towanda Township, Bradford, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "L8RS-62J",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI398",
    "name": "Franciscus Moser",
    "sex": "M",
    "gen": 8,
    "slot": 164,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI211",
    "birthYear": 1765,
    "deathYear": 1847,
    "birthDate": "19 Mar 1765",
    "deathDate": "1847",
    "burialDate": null,
    "christeningDate": "5 Apr 1765",
    "birthPlace": "District Township, Berks, Pennsylvania, United States",
    "deathPlace": "Pike Township, Berks, Pennsylvania, United States",
    "burialPlace": null,
    "christeningPlace": "Hill Church, Pike Township, Berks, Pennsylvania, United States",
    "fsId": "KHFV-ZRQ",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Franz Moser"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI399",
    "name": "Susanna V Endy",
    "sex": "F",
    "gen": 8,
    "slot": 165,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI211",
    "birthYear": 1764,
    "deathYear": 1835,
    "birthDate": "22 Apr 1764",
    "deathDate": "15 Jan 1835",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "New Hanover Township, Montgomery, Pennsylvania, United States",
    "deathPlace": "Pike Township, Berks, Pennsylvania, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "GXWW-VPY",
    "photo": "/ancestors/bubbles/0421_GXWW-VPY.jpg",
    "living": false,
    "alternateNames": [
      "Susanna"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0421_GXWW-VPY.jpg"
  },
  {
    "id": "AQI400",
    "name": "Andreas Wigand",
    "sex": "M",
    "gen": 8,
    "slot": 166,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI212",
    "birthYear": 1763,
    "deathYear": 1840,
    "birthDate": "26 May 1763",
    "deathDate": "1840",
    "burialDate": null,
    "christeningDate": "29 May 1763",
    "birthPlace": "Freinsheim, Bad Dürkheim, Rhineland-Palatinate, Germany",
    "deathPlace": "Pike Township, Berks, Pennsylvania, United States",
    "burialPlace": null,
    "christeningPlace": "Palatinate, Bavaria, Germany",
    "fsId": "MYYB-18F",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Andreas Wieand",
      "Andrew Wigand",
      "Andreas Wiant"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI401",
    "name": "Elizabeth",
    "sex": "F",
    "gen": 8,
    "slot": 167,
    "side": "maternal",
    "birthplace": "unknown",
    "childId": "AQI212",
    "birthYear": 1765,
    "deathYear": null,
    "birthDate": "Abt 1765",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "L5VF-KRD",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI402",
    "name": "Johannes Hatfield",
    "sex": "M",
    "gen": 8,
    "slot": 168,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI213",
    "birthYear": 1746,
    "deathYear": 1824,
    "birthDate": "1746",
    "deathDate": "29 Mar 1824",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Berks, Pennsylvania, United States",
    "deathPlace": "Pottstown, Montgomery, Pennsylvania, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "9Q99-6C1",
    "photo": "/ancestors/bubbles/0424_9Q99-6C1.jpg",
    "living": false,
    "alternateNames": [
      "John Hatfield"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0424_9Q99-6C1.jpg"
  },
  {
    "id": "AQI403",
    "name": "Mary Magdalena Yorgey",
    "sex": "F",
    "gen": 8,
    "slot": 169,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI213",
    "birthYear": 1755,
    "deathYear": 1818,
    "birthDate": "4 May 1755",
    "deathDate": "9 Apr 1818",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Germany",
    "deathPlace": "Berks, Pennsylvania, United States",
    "burialPlace": "Berks, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "GK8W-4M1",
    "photo": "/ancestors/bubbles/0425_GK8W-4M1.jpg",
    "living": false,
    "alternateNames": [
      "Ann Yorgey"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0425_GK8W-4M1.jpg"
  },
  {
    "id": "AQI404",
    "name": "George Jacob Geiger",
    "sex": "M",
    "gen": 8,
    "slot": 170,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI214",
    "birthYear": 1779,
    "deathYear": 1851,
    "birthDate": "28 Feb 1779",
    "deathDate": "7 Dec 1851",
    "burialDate": "Dec 1851",
    "christeningDate": null,
    "birthPlace": "Rockland Township, Berks, Pennsylvania, United States",
    "deathPlace": "Pottstown, Montgomery, Pennsylvania, United States",
    "burialPlace": "Zion Reformed Church Cemetery, Pottstown, Montgomery, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "L63R-8P3",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI405",
    "name": "Christina Schoener",
    "sex": "F",
    "gen": 8,
    "slot": 171,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI214",
    "birthYear": 1780,
    "deathYear": 1849,
    "birthDate": "27 Sep 1780",
    "deathDate": "29 Jan 1849",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Pottstown, Montgomery, Pennsylvania, United States",
    "deathPlace": null,
    "burialPlace": "Zion Reformed Church Cemetery, Pottstown, Montgomery, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LQRV-GST",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Christiana Schoener",
      "Christina Shaner",
      "Christina Shaner Schoener",
      "Christina Shoner",
      "Christina Schoener or Shaner"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI406",
    "name": "John or Johannes Liebenguth",
    "sex": "M",
    "gen": 8,
    "slot": 172,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI215",
    "birthYear": 1771,
    "deathYear": 1819,
    "birthDate": "8 Aug 1771",
    "deathDate": "15 Mar 1819",
    "burialDate": "Mar 1819",
    "christeningDate": null,
    "birthPlace": "Montgomery, Pennsylvania, United States",
    "deathPlace": "Berks, Pennsylvania, United States",
    "burialPlace": "Pottstown, Montgomery, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LZJL-CWZ",
    "photo": null,
    "living": false,
    "alternateNames": [
      "John Levengood",
      "Johannes Liebengut",
      "Johannes (\"John\") Levengood (Liebengut)"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI407",
    "name": "Christina Becker",
    "sex": "F",
    "gen": 8,
    "slot": 173,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI215",
    "birthYear": 1777,
    "deathYear": 1845,
    "birthDate": "26 Jun 1777",
    "deathDate": "20 Apr 1845",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Montgomery, Pennsylvania, United States",
    "deathPlace": "Douglass Township, Berks, Pennsylvania, United States",
    "burialPlace": "Pottstown, Montgomery, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LZJ2-6L2",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Christina Baker",
      "Christina Baker (Becker)",
      "Christina Beker"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI408",
    "name": "John George Bechtel",
    "sex": "M",
    "gen": 8,
    "slot": 174,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI216",
    "birthYear": 1770,
    "deathYear": null,
    "birthDate": "28 Jul 1770",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "19 Aug 1770",
    "birthPlace": "Montgomery Township, Philadelphia, Pennsylvania, British Colonial America",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Pottstown, Montgomery, Pennsylvania, United States",
    "fsId": "KC9N-275",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Georg Bechtel"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI409",
    "name": "Johanna Swinehart",
    "sex": "F",
    "gen": 8,
    "slot": 175,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI216",
    "birthYear": 1773,
    "deathYear": null,
    "birthDate": "6 Apr 1773",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "12 Apr 1773",
    "birthPlace": "New Hanover Township, Philadelphia, Pennsylvania, British Colonial America",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Gilbertsville, Douglass Township, Montgomery, Pennsylvania, United States",
    "fsId": "LZVJ-GGN",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Johanna Schweinhard",
      "Hermia Schneeinhart",
      "Hannah Swinehart",
      "Johanna \"Hannah\" Swinehart"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI410",
    "name": "Abraham Hallman",
    "sex": "M",
    "gen": 8,
    "slot": 180,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI219",
    "birthYear": 1767,
    "deathYear": 1838,
    "birthDate": "15 Aug 1767",
    "deathDate": "24 Aug 1838",
    "burialDate": "26 Aug 1838",
    "christeningDate": null,
    "birthPlace": "Limerick Township, Montgomery, Pennsylvania, United States",
    "deathPlace": "Limerick Township, Montgomery, Pennsylvania, United States",
    "burialPlace": "Augustus Lutheran Church Cemetery, Trappe, Montgomery, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "L78N-7Y6",
    "photo": "/ancestors/bubbles/0436_L78N-7Y6.jpg",
    "living": false,
    "alternateNames": [
      "Abrm",
      "Abr"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0436_L78N-7Y6.jpg"
  },
  {
    "id": "AQI411",
    "name": "Hannah Elizabeth Koons",
    "sex": "F",
    "gen": 8,
    "slot": 181,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI219",
    "birthYear": 1769,
    "deathYear": 1851,
    "birthDate": "20 Jan 1769",
    "deathDate": "20 Oct 1851",
    "burialDate": "1851",
    "christeningDate": "13 Apr 1770",
    "birthPlace": "Montgomery, Pennsylvania, United States",
    "deathPlace": "Limerick Township, Montgomery, Pennsylvania, United States",
    "burialPlace": "Augustus Lutheran Church Cemetery, Trappe, Montgomery, Pennsylvania, United States",
    "christeningPlace": "New Hanover Township, Montgomery, Pennsylvania, United States",
    "fsId": "L4NM-ZBN",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Hannah Koons",
      "Hannah Kuntz",
      "Johanna Kuntz"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI412",
    "name": "Johannes Fritz",
    "sex": "M",
    "gen": 8,
    "slot": 182,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI220",
    "birthYear": 1778,
    "deathYear": 1857,
    "birthDate": "2 Feb 1778",
    "deathDate": "11 Dec 1857",
    "burialDate": "1857",
    "christeningDate": null,
    "birthPlace": "Douglass Township, Berks, Pennsylvania, United States",
    "deathPlace": "Douglass Township, Berks, Pennsylvania, United States",
    "burialPlace": "Zion Reformed Church Cemetery, Pottstown, Montgomery, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "2JQQ-XVV",
    "photo": null,
    "living": false,
    "alternateNames": [
      "John"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI413",
    "name": "Sarah Sands",
    "sex": "F",
    "gen": 8,
    "slot": 183,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI220",
    "birthYear": 1779,
    "deathYear": 1857,
    "birthDate": "1 Nov 1779",
    "deathDate": "19 Oct 1857",
    "burialDate": "1857",
    "christeningDate": null,
    "birthPlace": "Pottsgrove, Lower Pottsgrove Township, Montgomery, Pennsylvania, United States",
    "deathPlace": null,
    "burialPlace": "Zion Reformed Church Cemetery, Pottstown, Montgomery, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "G8TY-XQV",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Mrs. Sarah Fritz",
      "Sarah"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI414",
    "name": "John Hartranft",
    "sex": "M",
    "gen": 8,
    "slot": 184,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI221",
    "birthYear": 1784,
    "deathYear": 1862,
    "birthDate": "8 Nov 1784",
    "deathDate": "23 Jan 1862",
    "burialDate": "1862",
    "christeningDate": null,
    "birthPlace": "Pennsylvania, United States",
    "deathPlace": "Pennsylvania, United States",
    "burialPlace": "Hill Church Union Cemetery, Boyertown, Berks, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "L7P9-9X9",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI415",
    "name": "Anna Maria Roth",
    "sex": "F",
    "gen": 8,
    "slot": 185,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI221",
    "birthYear": 1786,
    "deathYear": 1862,
    "birthDate": "21 Jul 1786",
    "deathDate": "19 Feb 1862",
    "burialDate": "1862",
    "christeningDate": null,
    "birthPlace": "Pennsylvania, United States",
    "deathPlace": "Pennsylvania, United States",
    "burialPlace": "Hill Church Union Cemetery, Boyertown, Berks, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "K4LS-YBW",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI416",
    "name": "Johan Heinrich Davidheiser",
    "sex": "M",
    "gen": 8,
    "slot": 186,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI222",
    "birthYear": 1773,
    "deathYear": 1853,
    "birthDate": "27 May 1773",
    "deathDate": "17 Sep 1853",
    "burialDate": "Sep 1853",
    "christeningDate": null,
    "birthPlace": "Montgomery Township, Philadelphia, Pennsylvania, United States",
    "deathPlace": "Pottsgrove Township, Montgomery, Pennsylvania, United States",
    "burialPlace": "Pottstown Cemetery, Pottstown, Montgomery, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "9XY8-S8Y",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Henry Davidheiser",
      "Henry Debertshauser"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI417",
    "name": "Anna Maria Weidner",
    "sex": "F",
    "gen": 8,
    "slot": 187,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI222",
    "birthYear": 1778,
    "deathYear": 1854,
    "birthDate": "1778",
    "deathDate": "19 Jun 1854",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Pennsylvania, United States",
    "deathPlace": "Pottsgrove, Lower Pottsgrove Township, Montgomery, Pennsylvania, United States",
    "burialPlace": "Pottstown Cemetery, Pottstown, Montgomery, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LVWS-VJ4",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI418",
    "name": "Jacob Freyer",
    "sex": "M",
    "gen": 8,
    "slot": 188,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI223",
    "birthYear": 1754,
    "deathYear": 1833,
    "birthDate": "11 Feb 1754",
    "deathDate": "29 Oct 1833",
    "burialDate": "Oct 1833",
    "christeningDate": "17 Mar 1754",
    "birthPlace": "Philadelphia Monthly Meeting, Philadelphia, Philadelphia, Pennsylvania, United States",
    "deathPlace": "New Hanover Township, Philadelphia, Pennsylvania, United States",
    "burialPlace": "New Hanover, New Hanover Township, Montgomery, Pennsylvania, United States",
    "christeningPlace": "Philadelphia Monthly Meeting, Philadelphia, Philadelphia, Pennsylvania, United States",
    "fsId": "L5XK-WYF",
    "photo": "/ancestors/bubbles/0444_L5XK-WYF.jpg",
    "living": false,
    "alternateNames": [
      "Jacob Fryer"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0444_L5XK-WYF.jpg"
  },
  {
    "id": "AQI419",
    "name": "Susan Margaretha Eigleberger",
    "sex": "F",
    "gen": 8,
    "slot": 189,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI223",
    "birthYear": 1750,
    "deathYear": 1846,
    "birthDate": "8 Nov 1750",
    "deathDate": "13 Dec 1846",
    "burialDate": "16 Dec 1846",
    "christeningDate": "8 Nov 1750",
    "birthPlace": "Bavaria, Germany",
    "deathPlace": "Montgomery, Pennsylvania, United States",
    "burialPlace": "New Hanover, New Hanover Township, Montgomery, Pennsylvania, United States",
    "christeningPlace": "Bavaria, Germany",
    "fsId": "MRJZ-1H6",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Susanna Eichelberger"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI420",
    "name": "John Bowman",
    "sex": "M",
    "gen": 8,
    "slot": 190,
    "side": "maternal",
    "birthplace": "unknown",
    "childId": "AQI224",
    "birthYear": null,
    "deathYear": null,
    "birthDate": null,
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "L5XT-JTQ",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI421",
    "name": "Anna",
    "sex": "F",
    "gen": 8,
    "slot": 191,
    "side": "maternal",
    "birthplace": "unknown",
    "childId": "AQI224",
    "birthYear": null,
    "deathYear": null,
    "birthDate": null,
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "9JZW-KYD",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI422",
    "name": "Peter Mock",
    "sex": "M",
    "gen": 8,
    "slot": 192,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI225",
    "birthYear": 1742,
    "deathYear": 1817,
    "birthDate": "1 May 1742",
    "deathDate": "18 Feb 1817",
    "burialDate": "1817",
    "christeningDate": "1742",
    "birthPlace": "Stuttgart, Baden-Württemberg, Germany",
    "deathPlace": "St. Clair Township, Bedford, Pennsylvania, United States",
    "burialPlace": "Peter Mock Graveyard, Bedford, Pennsylvania, United States",
    "christeningPlace": "Baden-Württemberg, Germany",
    "fsId": "L6R5-DT3",
    "photo": "/ancestors/bubbles/0448_L6R5-DT3.jpg",
    "living": false,
    "alternateNames": [
      "Peter Mauk",
      "Peter Mock Sr.",
      "Peter Mack",
      "Peter Mock First"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0448_L6R5-DT3.jpg"
  },
  {
    "id": "AQI423",
    "name": "Elizabeth Sample",
    "sex": "F",
    "gen": 8,
    "slot": 193,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI225",
    "birthYear": 1747,
    "deathYear": 1813,
    "birthDate": "13 Aug 1747",
    "deathDate": "18 Feb 1813",
    "burialDate": "1813",
    "christeningDate": null,
    "birthPlace": "Frederick, Frederick, Maryland, British Colonial America",
    "deathPlace": "Reynoldsdale, East Saint Clair Township, Bedford, Pennsylvania, United States",
    "burialPlace": "Peter Mock Graveyard, Bedford, Pennsylvania, United States",
    "christeningPlace": "Prince George's, Maryland, British Colonial America",
    "fsId": "LZJR-FJC",
    "photo": "/ancestors/bubbles/0449_LZJR-FJC.jpg",
    "living": false,
    "alternateNames": [
      "Mock"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0449_LZJR-FJC.jpg"
  },
  {
    "id": "AQI424",
    "name": "Johann Heinrich Christ",
    "sex": "M",
    "gen": 8,
    "slot": 196,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI227",
    "birthYear": 1755,
    "deathYear": 1784,
    "birthDate": "19 Jan 1755",
    "deathDate": "24 Dec 1784",
    "burialDate": "26 Dec 1784",
    "christeningDate": null,
    "birthPlace": "York, Pennsylvania, United States",
    "deathPlace": "Trinity Lutheran Church Cemetery, Reading, Berks, Pennsylvania, United States",
    "burialPlace": "Reading, Berks, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "KVG3-61X",
    "photo": "/ancestors/bubbles/0452_KVG3-61X.jpg",
    "living": false,
    "alternateNames": [
      "Henrich Christ",
      "Henrich Christ Jr",
      "Henry Crist",
      "Johann Heinrich III Christ",
      "Capt. John Christ",
      "Capt. Johann Heinrich Christ Jr.",
      "Capt. John Henry Christ Jr."
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0452_KVG3-61X.jpg"
  },
  {
    "id": "AQI425",
    "name": "Catharina Schumacher",
    "sex": "F",
    "gen": 8,
    "slot": 197,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI227",
    "birthYear": 1757,
    "deathYear": 1820,
    "birthDate": "18 Mar 1757",
    "deathDate": "14 Feb 1820",
    "burialDate": "18 Feb 1820",
    "christeningDate": "29 Jun 1760",
    "birthPlace": "Reading, Berks, Pennsylvania, United States",
    "deathPlace": "Union Township, Schuylkill, Pennsylvania, United States",
    "burialPlace": "Nuremberg, North Union Township, Schuylkill, Pennsylvania, United States",
    "christeningPlace": "Lehigh Township, Northampton, Pennsylvania, British Colonial America",
    "fsId": "KVG3-FHY",
    "photo": "/ancestors/bubbles/0453_KVG3-FHY.jpg",
    "living": false,
    "alternateNames": [
      "Catherinia Schumacher",
      "Fuss",
      "Catherina Shoemaker"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0453_KVG3-FHY.jpg"
  },
  {
    "id": "AQI426",
    "name": "Mathias Hann",
    "sex": "M",
    "gen": 8,
    "slot": 198,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI228",
    "birthYear": 1738,
    "deathYear": 1831,
    "birthDate": "17 May 1738",
    "deathDate": "17 Feb 1831",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Frankfurt am Main (Dom), Frankfurt, Hesse, Germany",
    "deathPlace": "Taneytown, Carroll, Maryland, United States",
    "burialPlace": "Taneytown, Carroll, Maryland, United States",
    "christeningPlace": null,
    "fsId": "L8WS-GRM",
    "photo": "/ancestors/bubbles/0454_L8WS-GRM.jpg",
    "living": false,
    "alternateNames": [
      "Mathias Hann or Hahn"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0454_L8WS-GRM.jpg"
  },
  {
    "id": "AQI427",
    "name": "Mary Elizabeth",
    "sex": "F",
    "gen": 8,
    "slot": 199,
    "side": "maternal",
    "birthplace": "unknown",
    "childId": "AQI228",
    "birthYear": 1757,
    "deathYear": 1829,
    "birthDate": "1757",
    "deathDate": "29 Mar 1829",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": "Taneytown, Carroll, Maryland, United States",
    "christeningPlace": null,
    "fsId": "983M-5Z1",
    "photo": "/ancestors/bubbles/0455_983M-5Z1.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0455_983M-5Z1.jpg"
  },
  {
    "id": "AQI428",
    "name": "Adam Burget",
    "sex": "M",
    "gen": 8,
    "slot": 200,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI229",
    "birthYear": 1760,
    "deathYear": 1846,
    "birthDate": "1760",
    "deathDate": "1846",
    "burialDate": "1846",
    "christeningDate": null,
    "birthPlace": "Montgomery Township, Franklin, Pennsylvania, United States",
    "deathPlace": "Morrisons Cove, Blair, Pennsylvania, United States",
    "burialPlace": "Henrietta, North Woodbury Township, Blair, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LZV4-RKW",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Adam Burkhurdt"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI429",
    "name": "Mary Puterbaugh",
    "sex": "F",
    "gen": 8,
    "slot": 201,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI229",
    "birthYear": 1765,
    "deathYear": 1848,
    "birthDate": "1765",
    "deathDate": "Abt 1848",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Frederick, Maryland, United States",
    "deathPlace": "Blair, Pennsylvania, United States",
    "burialPlace": "Henrietta, North Woodbury Township, Blair, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LZPG-T2G",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI430",
    "name": "Bulger",
    "sex": "M",
    "gen": 8,
    "slot": 202,
    "side": "maternal",
    "birthplace": "unknown",
    "childId": "AQI230",
    "birthYear": null,
    "deathYear": null,
    "birthDate": null,
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "L2DF-N8P",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI431",
    "name": "Johannes Zook",
    "sex": "M",
    "gen": 8,
    "slot": 204,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI231",
    "birthYear": 1763,
    "deathYear": 1830,
    "birthDate": "20 Sep 1763",
    "deathDate": "30 Apr 1830",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Warwick Township, Lancaster, Pennsylvania, United States",
    "deathPlace": "Jackson Township, Wayne, Indiana, United States",
    "burialPlace": "Hagerstown, Jefferson Township, Wayne, Indiana, United States",
    "christeningPlace": null,
    "fsId": "GFD6-VKG",
    "photo": "/ancestors/bubbles/0460_GFD6-VKG.jpg",
    "living": false,
    "alternateNames": [
      "Johannes Zug"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0460_GFD6-VKG.jpg"
  },
  {
    "id": "AQI432",
    "name": "Catherine Shively",
    "sex": "F",
    "gen": 8,
    "slot": 205,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI231",
    "birthYear": 1764,
    "deathYear": 1844,
    "birthDate": "27 Sep 1764",
    "deathDate": "28 Feb 1844",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Frederick, Maryland, United States",
    "deathPlace": "Camden, Jackson Township, Carroll, Indiana, United States",
    "burialPlace": "Snoeberger Cemetery, Carroll, Indiana, United States",
    "christeningPlace": null,
    "fsId": "LHKB-RFJ",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI433",
    "name": "Johann Wendell Wentz",
    "sex": "M",
    "gen": 8,
    "slot": 208,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI233",
    "birthYear": 1751,
    "deathYear": 1786,
    "birthDate": "16 Sep 1751",
    "deathDate": "Aft 1786",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Philadelphia, Pennsylvania, United States",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "L4M5-HMR",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Johann Wendielinus Wentz",
      "Wendel Wentz",
      "Wendel Wenz",
      "Johann Wendell Wintz"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI434",
    "name": "Maria Elizabeth Kirschner",
    "sex": "F",
    "gen": 8,
    "slot": 209,
    "side": "maternal",
    "birthplace": "england",
    "childId": "AQI233",
    "birthYear": 1752,
    "deathYear": 1855,
    "birthDate": "1752",
    "deathDate": "1855",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Somerset, Somerset, Pennsylvania, United States",
    "deathPlace": "Cabell, Virginia, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LZND-XXJ",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Elisabeth",
      "Elisabeth Kirschneck",
      "Elizabeth Kirschner",
      "Maria Elisabeth",
      "Elizabth Kirschner",
      "Maria Elizabeth Kirschner Wentz"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI437",
    "name": "Philip Baker",
    "sex": "M",
    "gen": 8,
    "slot": 210,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI234",
    "birthYear": 1746,
    "deathYear": 1785,
    "birthDate": "1746",
    "deathDate": "22 Dec 1785",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "York, Pennsylvania, United States",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "KLFD-61T",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Philip ( Beacor) Becker A Farmer"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI438",
    "name": "Elizabeth Margreth Zumwalt",
    "sex": "F",
    "gen": 8,
    "slot": 211,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI234",
    "birthYear": 1750,
    "deathYear": 1827,
    "birthDate": "1750",
    "deathDate": "1827",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Pennsylvania, United States",
    "deathPlace": "York, Pennsylvania, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "GZ45-5R1",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Elizabeth Margreth Baker"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI439",
    "name": "Johann Christian Heinrich Ickes",
    "sex": "M",
    "gen": 8,
    "slot": 212,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI235",
    "birthYear": 1742,
    "deathYear": 1829,
    "birthDate": "23 Aug 1742",
    "deathDate": "19 Jan 1829",
    "burialDate": "Jan 1829",
    "christeningDate": null,
    "birthPlace": "Hanover, York, Pennsylvania, United States",
    "deathPlace": "King Township, Bedford, Pennsylvania, United States",
    "burialPlace": "Old Union Cemetery, Buffalo Mills, Harrison Township, Bedford, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LH88-MB8",
    "photo": "/ancestors/bubbles/0468_LH88-MB8.jpg",
    "living": false,
    "alternateNames": [
      "Johann Ickes",
      "Johannes Ickes",
      "John Henry Ickes Sr"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0468_LH88-MB8.jpg"
  },
  {
    "id": "AQI440",
    "name": "Maria Elizabeth Stambaugh",
    "sex": "F",
    "gen": 8,
    "slot": 213,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI235",
    "birthYear": 1750,
    "deathYear": 1823,
    "birthDate": "17 Jun 1750",
    "deathDate": "27 Aug 1823",
    "burialDate": "Aug 1823",
    "christeningDate": "17 Jun 1750",
    "birthPlace": "Hanover, York, Pennsylvania, British Colonial America",
    "deathPlace": "Bedford, Pennsylvania, United States",
    "burialPlace": "Old Union Cemetery, Osterburg, East Saint Clair Township, Bedford, Pennsylvania, United States",
    "christeningPlace": "York, Pennsylvania, United States",
    "fsId": "LH8R-CQX",
    "photo": "/ancestors/bubbles/0469_LH8R-CQX.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0469_LH8R-CQX.jpg"
  },
  {
    "id": "AQI441",
    "name": "William J. Oldham",
    "sex": "M",
    "gen": 8,
    "slot": 216,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI237",
    "birthYear": 1780,
    "deathYear": 1854,
    "birthDate": "8 Mar 1780",
    "deathDate": "21 Aug 1854",
    "burialDate": "Aug 1854",
    "christeningDate": null,
    "birthPlace": "Menallen MM, Adams, Pennsylvania, United States",
    "deathPlace": "Shade Township, Somerset, Pennsylvania, United States",
    "burialPlace": "Crum - Oldham Cemetery, Shade Township, Somerset, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "GS1B-TRN",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI442",
    "name": "Elizabeth Callihan",
    "sex": "F",
    "gen": 8,
    "slot": 217,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI237",
    "birthYear": 1789,
    "deathYear": 1867,
    "birthDate": "25 Dec 1789",
    "deathDate": "17 Apr 1867",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Bedford, Bedford, Pennsylvania, United States",
    "deathPlace": "Ogle Township, Somerset, Pennsylvania, United States",
    "burialPlace": "Crum Cemetery, Sinnemahoning, Gibson Township, Cameron, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LWF6-H8K",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Elizabeth Calathan",
      "Elizabeth Callahan"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI443",
    "name": "Benjamin Bowen",
    "sex": "M",
    "gen": 8,
    "slot": 218,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI238",
    "birthYear": 1780,
    "deathYear": 1858,
    "birthDate": "22 Mar 1780",
    "deathDate": "16 Feb 1858",
    "burialDate": "Feb 1858",
    "christeningDate": null,
    "birthPlace": "Menallen MM, Adams, Pennsylvania, United States",
    "deathPlace": "St. Clair Township, Bedford, Pennsylvania, United States",
    "burialPlace": "Friends Cemetery, Spring Meadow, East Saint Clair Township, Bedford, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LSMJ-9XQ",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Benjamin"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI444",
    "name": "Mary Fisher",
    "sex": "F",
    "gen": 8,
    "slot": 219,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI238",
    "birthYear": 1781,
    "deathYear": 1850,
    "birthDate": "9 Feb 1781",
    "deathDate": "21 May 1850",
    "burialDate": "May 1850",
    "christeningDate": null,
    "birthPlace": "Monaghan Township, York, Pennsylvania, United States",
    "deathPlace": "St. Clair Township, Bedford, Pennsylvania, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LHK5-1J5",
    "photo": "/ancestors/bubbles/0475_LHK5-1J5.jpg",
    "living": false,
    "alternateNames": [
      "Living"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0475_LHK5-1J5.jpg"
  },
  {
    "id": "AQI449",
    "name": "Johann Sebastian Geier",
    "sex": "M",
    "gen": 8,
    "slot": 224,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI241",
    "birthYear": 1746,
    "deathYear": 1831,
    "birthDate": "30 May 1746",
    "deathDate": "Nov 1831",
    "burialDate": null,
    "christeningDate": "31 May 1746",
    "birthPlace": "Adenau, Ahrweiler, Rhineland-Palatinate, Germany",
    "deathPlace": "Philadelphia, Pennsylvania, United States",
    "burialPlace": null,
    "christeningPlace": "Adenau, Rhineland, Prussia",
    "fsId": "L2S2-JSK",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Johann Sebastian Geyer"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI450",
    "name": "Mary Bock",
    "sex": "F",
    "gen": 8,
    "slot": 225,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI241",
    "birthYear": 1759,
    "deathYear": 1844,
    "birthDate": "1759",
    "deathDate": "10 Apr 1844",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Pennsylvania, United States",
    "deathPlace": "Pennsylvania, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "L2S2-JQ2",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI451",
    "name": "Theodoris Ingold Snowberger",
    "sex": "M",
    "gen": 8,
    "slot": 232,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI243",
    "birthYear": 1764,
    "deathYear": 1859,
    "birthDate": "13 Apr 1764",
    "deathDate": "26 Jul 1859",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Cumberland, Pennsylvania, United States",
    "deathPlace": "Bedford, Bedford, Pennsylvania, United States",
    "burialPlace": "Bedford, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LHP8-3VL",
    "photo": "/ancestors/bubbles/0488_LHP8-3VL.jpg",
    "living": false,
    "alternateNames": [
      "Theodore SNOWBERGER Snowberger",
      "Theodore Snowberger",
      "Theo Snowbergen",
      "Dorst Shneeberger"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0488_LHP8-3VL.jpg"
  },
  {
    "id": "AQI452",
    "name": "Elizabeth Stauffer Eshelman",
    "sex": "F",
    "gen": 8,
    "slot": 233,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI243",
    "birthYear": 1776,
    "deathYear": 1825,
    "birthDate": "8 Dec 1776",
    "deathDate": "2 Nov 1825",
    "burialDate": "Nov 1825",
    "christeningDate": null,
    "birthPlace": "Rapho Township, Lancaster, Pennsylvania, United States",
    "deathPlace": "Loysburg, South Woodbury Township, Bedford, Pennsylvania, United States",
    "burialPlace": "Bedford, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LHP8-32C",
    "photo": "/ancestors/bubbles/0489_LHP8-32C.jpg",
    "living": false,
    "alternateNames": [
      "Elizabeth Eshleman",
      "Elizabeth ESHLEMAN (Eshleman)",
      "Elizabeth Eshlernan",
      "Elizabeth Miller"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0489_LHP8-32C.jpg"
  },
  {
    "id": "AQI453",
    "name": "Jacob Studebaker Snider",
    "sex": "M",
    "gen": 8,
    "slot": 234,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI244",
    "birthYear": 1753,
    "deathYear": 1848,
    "birthDate": "11 Nov 1753",
    "deathDate": "17 Apr 1848",
    "burialDate": "1848",
    "christeningDate": null,
    "birthPlace": "Berkeley, Virginia, British Colonial America",
    "deathPlace": "Snake Spring Township, Bedford, Pennsylvania, United States",
    "burialPlace": "Ritchey Cemetery, Snake Spring Township, Bedford, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LDB7-7QJ",
    "photo": "/ancestors/bubbles/0490_LDB7-7QJ.jpg",
    "living": false,
    "alternateNames": [
      "Jacob Snyder"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0490_LDB7-7QJ.jpg"
  },
  {
    "id": "AQI454",
    "name": "Catherine Amelia Bostetter",
    "sex": "F",
    "gen": 8,
    "slot": 235,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI244",
    "birthYear": 1755,
    "deathYear": 1854,
    "birthDate": "10 Apr 1755",
    "deathDate": "1854",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Frederick, Maryland, British Colonial America",
    "deathPlace": "Snake Spring Township, Bedford, Pennsylvania, United States",
    "burialPlace": "Snake Spring Township, Bedford, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LVCF-RSM",
    "photo": "/ancestors/bubbles/0491_LVCF-RSM.jpg",
    "living": false,
    "alternateNames": [
      "Catherine Postetter",
      "Catherine Snider"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0491_LVCF-RSM.jpg"
  },
  {
    "id": "AQI455",
    "name": "Abraham Lewis Burger",
    "sex": "M",
    "gen": 8,
    "slot": 236,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI245",
    "birthYear": 1766,
    "deathYear": 1828,
    "birthDate": "1766",
    "deathDate": "1 Apr 1828",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Franklin, Pennsylvania, United States",
    "deathPlace": "Bedford, Bedford, Pennsylvania, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LKNB-7Y3",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI456",
    "name": "Elizabeth Whetstone",
    "sex": "F",
    "gen": 8,
    "slot": 237,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI245",
    "birthYear": 1769,
    "deathYear": 1849,
    "birthDate": "31 Oct 1769",
    "deathDate": "30 Mar 1849",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Bedford Township, Bedford, Pennsylvania, United States",
    "deathPlace": "Bedford, Bedford, Pennsylvania, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LKNB-WJS",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI457",
    "name": "Jacob Brown",
    "sex": "M",
    "gen": 8,
    "slot": 238,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI246",
    "birthYear": 1779,
    "deathYear": 1854,
    "birthDate": "25 Aug 1779",
    "deathDate": "18 Feb 1854",
    "burialDate": "Feb 1854",
    "christeningDate": null,
    "birthPlace": "Frederick, Maryland, United States",
    "deathPlace": "Batavia, Jefferson, Iowa, United States",
    "burialPlace": "Brethren Cemetery, Batavia, Jefferson, Iowa, United States",
    "christeningPlace": null,
    "fsId": "LVFJ-DPL",
    "photo": "/ancestors/bubbles/0494_LVFJ-DPL.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0494_LVFJ-DPL.jpg"
  },
  {
    "id": "AQI458",
    "name": "Elizabeth Ulery",
    "sex": "F",
    "gen": 8,
    "slot": 239,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI246",
    "birthYear": 1781,
    "deathYear": 1857,
    "birthDate": "8 Apr 1781",
    "deathDate": "22 Mar 1857",
    "burialDate": "1857",
    "christeningDate": null,
    "birthPlace": "Maryland, United States",
    "deathPlace": "Batavia, Jefferson, Iowa, United States",
    "burialPlace": "Batavia, Jefferson, Iowa, United States",
    "christeningPlace": null,
    "fsId": "L5FB-BP3",
    "photo": "/ancestors/bubbles/0495_L5FB-BP3.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0495_L5FB-BP3.jpg"
  },
  {
    "id": "AQI459",
    "name": "David Gochenour",
    "sex": "M",
    "gen": 8,
    "slot": 240,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI247",
    "birthYear": 1759,
    "deathYear": 1824,
    "birthDate": "12 Apr 1759",
    "deathDate": "21 Apr 1824",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "King, Kimmel Township, Bedford, Pennsylvania, United States",
    "deathPlace": "King, Kimmel Township, Bedford, Pennsylvania, United States",
    "burialPlace": "Snake Spring Township, Bedford, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "L7JD-8KT",
    "photo": "/ancestors/bubbles/0496_L7JD-8KT.jpg",
    "living": false,
    "alternateNames": [
      "David Sr. Gochnour",
      "David Gochnour Sr.",
      "David Gochenauer"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0496_L7JD-8KT.jpg"
  },
  {
    "id": "AQI460",
    "name": "Anna Beaver",
    "sex": "F",
    "gen": 8,
    "slot": 241,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI247",
    "birthYear": 1757,
    "deathYear": 1840,
    "birthDate": "Abt 1757",
    "deathDate": "16 Feb 1840",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Huntingdon, Huntingdon, Pennsylvania, United States",
    "deathPlace": "Blair, Pennsylvania, United States",
    "burialPlace": "Kimmel Township, Bedford, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "KH2M-ZHN",
    "photo": "/ancestors/bubbles/0497_KH2M-ZHN.jpg",
    "living": false,
    "alternateNames": [
      "Anne"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0497_KH2M-ZHN.jpg"
  },
  {
    "id": "AQI461",
    "name": "Jacob Burket",
    "sex": "M",
    "gen": 8,
    "slot": 248,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI251",
    "birthYear": 1757,
    "deathYear": 1834,
    "birthDate": "1757",
    "deathDate": "1834",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Berks, Pennsylvania, United States",
    "deathPlace": "St. Clair Township, Bedford, Pennsylvania, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "GM36-V7J",
    "photo": "/ancestors/bubbles/0504_GM36-V7J.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0504_GM36-V7J.jpg"
  },
  {
    "id": "AQI462",
    "name": "Catherine",
    "sex": "F",
    "gen": 8,
    "slot": 249,
    "side": "maternal",
    "birthplace": "unknown",
    "childId": "AQI251",
    "birthYear": 1762,
    "deathYear": null,
    "birthDate": "1762",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "G9RV-DKD",
    "photo": "/ancestors/bubbles/0505_G9RV-DKD.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0505_G9RV-DKD.jpg"
  },
  {
    "id": "AQI463",
    "name": "Peter Swoveland",
    "sex": "M",
    "gen": 8,
    "slot": 250,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI252",
    "birthYear": 1748,
    "deathYear": 1814,
    "birthDate": "1748",
    "deathDate": "Abt 1814",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Baden-Württemberg, Germany",
    "deathPlace": "St. Clair Township, Bedford, Pennsylvania, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "L14Y-7FH",
    "photo": "/ancestors/bubbles/0506_L14Y-7FH.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0506_L14Y-7FH.jpg"
  },
  {
    "id": "AQI464",
    "name": "Mary Magdalena Bausser",
    "sex": "F",
    "gen": 8,
    "slot": 251,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI252",
    "birthYear": 1758,
    "deathYear": 1808,
    "birthDate": "15 Feb 1758",
    "deathDate": "3 Aug 1808",
    "burialDate": null,
    "christeningDate": "26 Feb 1758",
    "birthPlace": "Bedford, Bedford, Pennsylvania, British Colonial America",
    "deathPlace": "St. Clair Township, Bedford, Pennsylvania, United States",
    "burialPlace": null,
    "christeningPlace": "Lancaster, Lancaster, Pennsylvania, British Colonial America",
    "fsId": "GXP9-696",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Mary Magdalena Bausser\\Bowser",
      "Magdalena (Bowser) Swoveland",
      "Magdalena Mary Bowser Buser Bausser"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI465",
    "name": "Frederick Klee Claar",
    "sex": "M",
    "gen": 8,
    "slot": 252,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI253",
    "birthYear": 1780,
    "deathYear": 1864,
    "birthDate": "30 Oct 1780",
    "deathDate": "2 Mar 1864",
    "burialDate": null,
    "christeningDate": "13 Nov 1791",
    "birthPlace": "Heidelberg Township, York, Pennsylvania, United States",
    "deathPlace": "Bedford, Pennsylvania, United States",
    "burialPlace": "Klahr, Greenfield Township, Blair, Pennsylvania, United States",
    "christeningPlace": "Hanover, York, Pennsylvania, United States",
    "fsId": "L4QL-B3G",
    "photo": "/ancestors/bubbles/0508_L4QL-B3G.jpg",
    "living": false,
    "alternateNames": [
      "Frederic Claar",
      "Frederick Clar",
      "Frederick Clarin",
      "Fredrick Claar"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0508_L4QL-B3G.jpg"
  },
  {
    "id": "AQI466",
    "name": "Christena Marthe Walter",
    "sex": "F",
    "gen": 8,
    "slot": 253,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI253",
    "birthYear": 1780,
    "deathYear": 1853,
    "birthDate": "23 Jul 1780",
    "deathDate": "13 Apr 1853",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Needful, Bradford Township, Clearfield, Pennsylvania, United States",
    "deathPlace": "Klahr, Blair, Pennsylvania, United States",
    "burialPlace": "Upper Claar Cemetery, Queen, Kimmel Township, Bedford, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "KLLK-RD3",
    "photo": "/ancestors/bubbles/0509_KLLK-RD3.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0509_KLLK-RD3.jpg"
  },
  {
    "id": "AQI235s254",
    "name": "Philip Ickes",
    "sex": "M",
    "gen": 8,
    "slot": 254,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI254",
    "birthYear": 1784,
    "deathYear": 1858,
    "birthDate": "11 Apr 1784",
    "deathDate": "26 Nov 1858",
    "burialDate": "1858",
    "christeningDate": null,
    "birthPlace": "Hanover, York, Pennsylvania, United States",
    "deathPlace": "Bedford, Pennsylvania, United States",
    "burialPlace": "Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LDQL-LG5",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI236s255",
    "name": "Elizabeth Weyant",
    "sex": "F",
    "gen": 8,
    "slot": 255,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI254",
    "birthYear": 1787,
    "deathYear": 1859,
    "birthDate": "5 Oct 1787",
    "deathDate": "2 Aug 1859",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Bedford, Pennsylvania, United States",
    "deathPlace": "Arkansas, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "GR3J-25L",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Elizabeth",
      "Mrs. Elizabeth Ickes"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI467",
    "name": "Thomas Mills",
    "sex": "M",
    "gen": 9,
    "slot": 0,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI255",
    "birthYear": 1695,
    "deathYear": null,
    "birthDate": "1695",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "7 Jun 1695",
    "birthPlace": "Warminghurst, Sussex, England, United Kingdom",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Chithurst, Sussex, England, United Kingdom",
    "fsId": "MFYT-5K6",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI468",
    "name": "Elizabeth Bourn",
    "sex": "F",
    "gen": 9,
    "slot": 1,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI255",
    "birthYear": 1700,
    "deathYear": 1755,
    "birthDate": "Abt 1700",
    "deathDate": "1755",
    "burialDate": "25 Jan 1755",
    "christeningDate": "13 Mar 1700",
    "birthPlace": "Warminghurst, Sussex, England",
    "deathPlace": "Pagham, Sussex, England",
    "burialPlace": "Pagham, Sussex, England, United Kingdom",
    "christeningPlace": "St Pancras, Middlesex, England",
    "fsId": "LZJG-TZS",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Elizabeth Bowen Bourn/"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI469",
    "name": "William Wiltshire",
    "sex": "M",
    "gen": 9,
    "slot": 2,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI256",
    "birthYear": 1704,
    "deathYear": 1786,
    "birthDate": "1704",
    "deathDate": "1786",
    "burialDate": null,
    "christeningDate": "7 Sep 1704",
    "birthPlace": "Bognor, Sussex, England",
    "deathPlace": "Hazelbury Bryan, Dorset, England, United Kingdom",
    "burialPlace": null,
    "christeningPlace": "Pagham, Sussex, England",
    "fsId": "LZJG-TZH",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI470",
    "name": "Sarah Howard",
    "sex": "F",
    "gen": 9,
    "slot": 3,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI256",
    "birthYear": 1708,
    "deathYear": 1808,
    "birthDate": "24 Sep 1708",
    "deathDate": "Bef 1808",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Chichester, Sussex, England",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LZJG-TZ6",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI471",
    "name": "William Hammond",
    "sex": "M",
    "gen": 9,
    "slot": 6,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI257",
    "birthYear": 1734,
    "deathYear": null,
    "birthDate": "1734",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "10 Jul 1734",
    "birthPlace": "Lewes, Sussex, England",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Waldron, Sussex, England, United Kingdom",
    "fsId": "GVXF-M2G",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI472",
    "name": "Ann Hood",
    "sex": "F",
    "gen": 9,
    "slot": 7,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI257",
    "birthYear": 1730,
    "deathYear": 1766,
    "birthDate": "1730",
    "deathDate": "28 Oct 1766",
    "burialDate": "30 Oct 1766",
    "christeningDate": null,
    "birthPlace": "Lewes, Sussex, England",
    "deathPlace": "Waldron, Sussex, England, United Kingdom",
    "burialPlace": "Waldron, Sussex, England, United Kingdom",
    "christeningPlace": null,
    "fsId": "GVXX-RHQ",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI473",
    "name": "Thomas Coles",
    "sex": "M",
    "gen": 9,
    "slot": 8,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI258",
    "birthYear": 1699,
    "deathYear": 1790,
    "birthDate": "24 Dec 1699",
    "deathDate": "21 Oct 1790",
    "burialDate": "21 Oct 1790",
    "christeningDate": "24 Dec 1699",
    "birthPlace": "Funtington, Sussex, England",
    "deathPlace": "Funtington, Sussex, England, United Kingdom",
    "burialPlace": "Funtington, Sussex, England, United Kingdom",
    "christeningPlace": "Funtington, Sussex, England, United Kingdom",
    "fsId": "KV28-65L",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Thomas Cole"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI474",
    "name": "Mary Williamson",
    "sex": "F",
    "gen": 9,
    "slot": 9,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI258",
    "birthYear": 1718,
    "deathYear": null,
    "birthDate": "25 May 1718",
    "deathDate": null,
    "burialDate": "15 Apr 1785",
    "christeningDate": "25 May 1718",
    "birthPlace": "Harting, Sussex, England",
    "deathPlace": null,
    "burialPlace": "Funtington, Sussex, England, United Kingdom",
    "christeningPlace": "Harting, Sussex, England, United Kingdom",
    "fsId": "MNZJ-78T",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Maria Rowsell",
      "Mary",
      "Maria Williamson"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI475",
    "name": "Robert Pruddoe",
    "sex": "M",
    "gen": 9,
    "slot": 12,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI259",
    "birthYear": null,
    "deathYear": null,
    "birthDate": null,
    "deathDate": null,
    "burialDate": "5 Aug 1788",
    "christeningDate": null,
    "birthPlace": "Northumberland, England",
    "deathPlace": null,
    "burialPlace": "Ponteland, Northumberland, England, United Kingdom",
    "christeningPlace": null,
    "fsId": "M8LG-JZT",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI476",
    "name": "Margaret Lawson",
    "sex": "F",
    "gen": 9,
    "slot": 13,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI259",
    "birthYear": 1723,
    "deathYear": null,
    "birthDate": "1723",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Great Bavington, Northumberland, England",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LD4L-R5Y",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI477",
    "name": "George Stephenson",
    "sex": "M",
    "gen": 9,
    "slot": 14,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI260",
    "birthYear": 1716,
    "deathYear": null,
    "birthDate": "1716",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "England",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "GHF4-1FS",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI478",
    "name": "Mary Pawson",
    "sex": "F",
    "gen": 9,
    "slot": 15,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI260",
    "birthYear": 1726,
    "deathYear": null,
    "birthDate": "1726",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "England",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "PH93-DM9",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI479",
    "name": "Thos. Newington",
    "sex": "M",
    "gen": 9,
    "slot": 20,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI261",
    "birthYear": 1730,
    "deathYear": null,
    "birthDate": "Abt 1730",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Sussex, England",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "MN4D-41M",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Thomas Newington"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI480",
    "name": "Elizabeth Ewens",
    "sex": "F",
    "gen": 9,
    "slot": 21,
    "side": "paternal",
    "birthplace": "unknown",
    "childId": "AQI261",
    "birthYear": 1730,
    "deathYear": null,
    "birthDate": "Abt 1730",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "L8LF-FWW",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI481",
    "name": "Henry Irish",
    "sex": "M",
    "gen": 9,
    "slot": 22,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI262",
    "birthYear": 1732,
    "deathYear": 1809,
    "birthDate": "1732",
    "deathDate": "Abt 1809",
    "burialDate": null,
    "christeningDate": "30 Mar 1735",
    "birthPlace": "Eartham, Sussex, England",
    "deathPlace": "Eartham, Sussex, England",
    "burialPlace": null,
    "christeningPlace": "Eartham, Sussex, England, United Kingdom",
    "fsId": "L7J4-GLJ",
    "photo": "/ancestors/bubbles/0534_L7J4-GLJ.jpg",
    "living": false,
    "alternateNames": [
      "Henery Irisih",
      "Henry Jerish"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0534_L7J4-GLJ.jpg"
  },
  {
    "id": "AQI482",
    "name": "Elizabeth Farr",
    "sex": "F",
    "gen": 9,
    "slot": 23,
    "side": "paternal",
    "birthplace": "unknown",
    "childId": "AQI262",
    "birthYear": null,
    "deathYear": null,
    "birthDate": null,
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "28 Mar 1735",
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Walberton, Sussex, England",
    "fsId": "MN9N-YSH",
    "photo": "/ancestors/bubbles/0535_MN9N-YSH.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0535_MN9N-YSH.jpg"
  },
  {
    "id": "AQI483",
    "name": "Thomas Chessel",
    "sex": "M",
    "gen": 9,
    "slot": 24,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI263",
    "birthYear": 1730,
    "deathYear": 1796,
    "birthDate": "Abt 1730",
    "deathDate": "Abt 1796",
    "burialDate": null,
    "christeningDate": "19 Apr 1731",
    "birthPlace": "Angmering, Sussex, England, United Kingdom",
    "deathPlace": "Taunton, Somerset, England, United Kingdom",
    "burialPlace": null,
    "christeningPlace": "Carisbrooke, Isle of Wight, Hampshire, England, United Kingdom",
    "fsId": "GMS1-MGF",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Tom Chessell",
      "Thos Chessell",
      "Thomas Phessel",
      "Thomas Chessell"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI484",
    "name": "Mary Compton",
    "sex": "F",
    "gen": 9,
    "slot": 25,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI263",
    "birthYear": 1731,
    "deathYear": 1830,
    "birthDate": "Abt 1731",
    "deathDate": "17 Oct 1830",
    "burialDate": null,
    "christeningDate": "17 Jan 1731",
    "birthPlace": "Angmering, Sussex, England, United Kingdom",
    "deathPlace": "Angmering, Sussex, England, United Kingdom",
    "burialPlace": null,
    "christeningPlace": "Angmering, Sussex, England, United Kingdom",
    "fsId": "L8T2-5DQ",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI485",
    "name": "Thomas Suter",
    "sex": "M",
    "gen": 9,
    "slot": 26,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI264",
    "birthYear": 1736,
    "deathYear": 1789,
    "birthDate": "1736",
    "deathDate": "26 Apr 1789",
    "burialDate": "28 Apr 1789",
    "christeningDate": "4 Apr 1736",
    "birthPlace": "Easebourne, Sussex, England, United Kingdom",
    "deathPlace": "Walberton, Sussex, England, United Kingdom",
    "burialPlace": "St Mary's Church, Walberton, Sussex, England, United Kingdom",
    "christeningPlace": "Easebourne, Sussex, England, United Kingdom",
    "fsId": "LZ8T-PH3",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Thomas Sowter",
      "Thomas Sutter",
      "Thos Suter",
      "Thos Sutor"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI486",
    "name": "Mary Fogden",
    "sex": "F",
    "gen": 9,
    "slot": 27,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI264",
    "birthYear": 1736,
    "deathYear": 1795,
    "birthDate": "1736",
    "deathDate": "18 Jan 1795",
    "burialDate": "10 Aug 1808",
    "christeningDate": "28 Jan 1739",
    "birthPlace": "Easebourne, Sussex, England, United Kingdom",
    "deathPlace": "Walberton, Sussex, England, United Kingdom",
    "burialPlace": "Holborn, Camden, London, England, United Kingdom",
    "christeningPlace": "Easebourne, Sussex, England, United Kingdom",
    "fsId": "L4M9-MXG",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Mary",
      "Mary Hagden"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI487",
    "name": "William Ashley",
    "sex": "M",
    "gen": 9,
    "slot": 28,
    "side": "paternal",
    "birthplace": "unknown",
    "childId": "AQI266",
    "birthYear": null,
    "deathYear": null,
    "birthDate": null,
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "PFF3-5V5",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI488",
    "name": "Hans Lehmann",
    "sex": "M",
    "gen": 9,
    "slot": 32,
    "side": "paternal",
    "birthplace": "unknown",
    "childId": "AQI268",
    "birthYear": null,
    "deathYear": null,
    "birthDate": null,
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "1 Aug 1697",
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Worb, Bern, Switzerland",
    "fsId": "LHWZ-NGW",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Hans",
      "Hans Leemann",
      "Hans Leman"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI489",
    "name": "Christine Locher",
    "sex": "F",
    "gen": 9,
    "slot": 33,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI268",
    "birthYear": 1695,
    "deathYear": 1760,
    "birthDate": "2 Jan 1695",
    "deathDate": "9 Apr 1760",
    "burialDate": "9 Apr 1760",
    "christeningDate": null,
    "birthPlace": "Hasle bei Burgdorf, Bern, Switzerland",
    "deathPlace": "Worb, Bern, Switzerland",
    "burialPlace": "Worb, Bern, Switzerland",
    "christeningPlace": null,
    "fsId": "KLBQ-RG5",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Christine Lehmann Locher",
      "Chrigeli Locher"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI490",
    "name": "Vinzenz Schindler",
    "sex": "M",
    "gen": 9,
    "slot": 34,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI269",
    "birthYear": 1697,
    "deathYear": 1779,
    "birthDate": "29 Aug 1697",
    "deathDate": "23 Mar 1779",
    "burialDate": "23 Mar 1779",
    "christeningDate": "29 Aug 1697",
    "birthPlace": "Röthenbach im Emmental, Bern, Switzerland",
    "deathPlace": null,
    "burialPlace": "Röthenbach im Emmental, Bern, Switzerland",
    "christeningPlace": "Röthenbach im Emmental, Bern, Switzerland",
    "fsId": "KNSH-3JL",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI491",
    "name": "Barbara Oppliger",
    "sex": "F",
    "gen": 9,
    "slot": 35,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI269",
    "birthYear": 1712,
    "deathYear": 1759,
    "birthDate": "19 May 1712",
    "deathDate": "5 Jan 1759",
    "burialDate": "5 Jan 1759",
    "christeningDate": "5 May 1712",
    "birthPlace": "Signau, Bern, Switzerland",
    "deathPlace": "Röthenbach im Emmental, Bern, Switzerland",
    "burialPlace": "Röthenbach im Emmental, Bern, Switzerland",
    "christeningPlace": "Rothenbach, Bern, Switzerland",
    "fsId": "K8NW-FXF",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI492",
    "name": "Niklaus Leuenberger",
    "sex": "M",
    "gen": 9,
    "slot": 36,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI270",
    "birthYear": 1696,
    "deathYear": 1736,
    "birthDate": "21 Apr 1696",
    "deathDate": "10 Feb 1736",
    "burialDate": null,
    "christeningDate": "26 Apr 1696",
    "birthPlace": "Lützelflüh, Bern, Switzerland",
    "deathPlace": "Lützelflüh, Bern, Switzerland",
    "burialPlace": null,
    "christeningPlace": "Lützelflüh, Bern, Switzerland",
    "fsId": "KD1Y-VPP",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI493",
    "name": "Verena Gammeter",
    "sex": "F",
    "gen": 9,
    "slot": 37,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI270",
    "birthYear": 1700,
    "deathYear": 1772,
    "birthDate": "Abt Oct 1700",
    "deathDate": "3 Nov 1772",
    "burialDate": null,
    "christeningDate": "13 Oct 1700",
    "birthPlace": "Lützelflüh, Bern, Switzerland",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Lützelflüh, Bern, Switzerland",
    "fsId": "K84D-9YS",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Verena Gammether",
      "Vrena Gammeter"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI494",
    "name": "Hans Maurer",
    "sex": "M",
    "gen": 9,
    "slot": 40,
    "side": "paternal",
    "birthplace": "unknown",
    "childId": "AQI272",
    "birthYear": 1695,
    "deathYear": 1751,
    "birthDate": "1695",
    "deathDate": "21 Feb 1751",
    "burialDate": "21 Feb 1751",
    "christeningDate": "9 Aug 1695",
    "birthPlace": null,
    "deathPlace": "Vechigen, Bern, Switzerland",
    "burialPlace": "Vechigen, Bern, Switzerland",
    "christeningPlace": "Vechigen, Bern, Switzerland",
    "fsId": "LCGN-G2K",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI495",
    "name": "Magdalena Schwyzer",
    "sex": "F",
    "gen": 9,
    "slot": 41,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI272",
    "birthYear": 1695,
    "deathYear": 1781,
    "birthDate": "1695",
    "deathDate": "6 Jan 1781",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Vechigen, Bern, Switzerland",
    "deathPlace": "Vechigen, Bern, Switzerland",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "2RB7-BW2",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Magdalena Schwyzer Maurer"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI497",
    "name": "Peter Krähenbühl",
    "sex": "M",
    "gen": 9,
    "slot": 44,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI274",
    "birthYear": 1721,
    "deathYear": null,
    "birthDate": "27 Jun 1721",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Grosshöchstetten, Bern, Switzerland",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "KDQQ-27X",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Peter Krahenbuhl"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI498",
    "name": "Anna Dubi",
    "sex": "F",
    "gen": 9,
    "slot": 45,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI274",
    "birthYear": 1724,
    "deathYear": null,
    "birthDate": "Abt 1724",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Belp, Bern, Switzerland",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "KC6Z-XS5",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Anna Dubi Krahenbuhl"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI499",
    "name": "Hans Aebi",
    "sex": "M",
    "gen": 9,
    "slot": 46,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI275",
    "birthYear": 1709,
    "deathYear": 1787,
    "birthDate": "28 Jul 1709",
    "deathDate": "19 Feb 1787",
    "burialDate": "19 Feb 1787",
    "christeningDate": "28 Jul 1709",
    "birthPlace": "Kirchberg, Bern, Switzerland",
    "deathPlace": null,
    "burialPlace": "Kirchdorf, Bern, Switzerland",
    "christeningPlace": "Kirchberg, Bern, Switzerland",
    "fsId": "GFJN-P8F",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI500",
    "name": "Anna Bracher",
    "sex": "F",
    "gen": 9,
    "slot": 47,
    "side": "paternal",
    "birthplace": "unknown",
    "childId": "AQI275",
    "birthYear": 1711,
    "deathYear": 1787,
    "birthDate": "1 Nov 1711",
    "deathDate": "17 Dec 1787",
    "burialDate": "17 Dec 1787",
    "christeningDate": null,
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": "Kirchdorf, Bern, Switzerland",
    "christeningPlace": null,
    "fsId": "GFJN-C1X",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI501",
    "name": "Christian Krebs",
    "sex": "M",
    "gen": 9,
    "slot": 48,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI276",
    "birthYear": 1734,
    "deathYear": 1761,
    "birthDate": "3 Jan 1734",
    "deathDate": "29 Jul 1761",
    "burialDate": null,
    "christeningDate": "3 Jun 1734",
    "birthPlace": "Kirchdorf, Bern, Switzerland",
    "deathPlace": "Kirchdorf, Bern, Switzerland",
    "burialPlace": null,
    "christeningPlace": "Mühledorf, Solothurn, Switzerland",
    "fsId": "KZX9-NYS",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Cristian Krebs",
      "Christen Krebs"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI502",
    "name": "Maria Meyer",
    "sex": "F",
    "gen": 9,
    "slot": 49,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI276",
    "birthYear": 1735,
    "deathYear": 1792,
    "birthDate": "18 Sep 1735",
    "deathDate": "27 Feb 1792",
    "burialDate": "29 Feb 1792",
    "christeningDate": "18 Sep 1735",
    "birthPlace": "Kirchdorf, Bern, Switzerland",
    "deathPlace": "Kirchdorf, Bern, Switzerland",
    "burialPlace": "Kirchdorf, Bern, Switzerland",
    "christeningPlace": "Kirchdorf, Bern, Switzerland",
    "fsId": "KZWG-J2B",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Marie Meyer"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI503",
    "name": "Bendicht Riem",
    "sex": "M",
    "gen": 9,
    "slot": 50,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI277",
    "birthYear": 1724,
    "deathYear": 1762,
    "birthDate": "Abt 1724",
    "deathDate": "29 Aug 1762",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Kirchdorf, Bern, Switzerland",
    "deathPlace": "Burgistein, Bern, Switzerland",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LHQV-J78",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Mr. Riem",
      "Mr. Biern",
      "Benedikt Riem"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI504",
    "name": "Anna Grünig",
    "sex": "F",
    "gen": 9,
    "slot": 51,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI277",
    "birthYear": 1718,
    "deathYear": 1769,
    "birthDate": "Aug 1718",
    "deathDate": "8 Apr 1769",
    "burialDate": "10 Apr 1769",
    "christeningDate": "28 Aug 1718",
    "birthPlace": "Burgistein, Bern, Switzerland",
    "deathPlace": "Burgistein, Bern, Switzerland",
    "burialPlace": "Burgistein, Bern, Switzerland",
    "christeningPlace": "Rüeggisberg, Bern, Switzerland",
    "fsId": "K6QH-16H",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Anna Grunig"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI505",
    "name": "Bendicht Joss",
    "sex": "M",
    "gen": 9,
    "slot": 52,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI278",
    "birthYear": 1720,
    "deathYear": null,
    "birthDate": "18 Feb 1720",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "5 Jun 1718",
    "birthPlace": "Münsingen, Bern, Switzerland",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Bolligen, Bern, Switzerland",
    "fsId": "LCJ5-65W",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Benedikt Joss",
      "Ulrich Joss",
      "Ulrich Or Bendicht Joss"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI506",
    "name": "Barbara Maurer",
    "sex": "F",
    "gen": 9,
    "slot": 53,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI278",
    "birthYear": 1729,
    "deathYear": 1802,
    "birthDate": "20 Mar 1729",
    "deathDate": "25 Aug 1802",
    "burialDate": "25 Aug 1802",
    "christeningDate": null,
    "birthPlace": "Münsingen, Bern, Switzerland",
    "deathPlace": "Herolfingen, Konolfingen, Bern, Switzerland",
    "burialPlace": "Münsingen, Bern, Switzerland",
    "christeningPlace": null,
    "fsId": "KNS5-NP9",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Barbara Maurer Joss"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI507",
    "name": "Niklaus Keller",
    "sex": "M",
    "gen": 9,
    "slot": 54,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI279",
    "birthYear": 1744,
    "deathYear": null,
    "birthDate": "12 Jun 1744",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Oberthal, Bern, Switzerland",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LCJ6-RQF",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI508",
    "name": "Elisabeth Joss",
    "sex": "F",
    "gen": 9,
    "slot": 55,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI279",
    "birthYear": 1747,
    "deathYear": null,
    "birthDate": "Abt 1747",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Münsingen, Bern, Switzerland",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LC7P-682",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Elisabeth Joss Keller",
      "Elisabetha Joss",
      "Elisabetha Joss Keller",
      "Elizabeth Joss"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI509",
    "name": "Jacob Probst",
    "sex": "M",
    "gen": 9,
    "slot": 56,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI280",
    "birthYear": 1730,
    "deathYear": 1803,
    "birthDate": "4 Mar 1730",
    "deathDate": "1 Nov 1803",
    "burialDate": "4 Nov 1803",
    "christeningDate": null,
    "birthPlace": "Lützelflüh, Bern, Switzerland",
    "deathPlace": "Lützelflüh, Bern, Switzerland",
    "burialPlace": "Lützelflüh, Bern, Switzerland",
    "christeningPlace": "Lützelflüh, Bern, Switzerland",
    "fsId": "L4L5-BKW",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Jakob Probst",
      "Jakob"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI510",
    "name": "Verena Schindler",
    "sex": "F",
    "gen": 9,
    "slot": 57,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI280",
    "birthYear": 1732,
    "deathYear": 1802,
    "birthDate": "1732",
    "deathDate": "19 Nov 1802",
    "burialDate": "22 Nov 1802",
    "christeningDate": "13 Jul 1732",
    "birthPlace": "Langnau im Emmental, Bern, Switzerland",
    "deathPlace": "Sumiswald, Bern, Switzerland",
    "burialPlace": "Sumiswald, Bern, Switzerland",
    "christeningPlace": "Langnau im Emmental, Bern, Switzerland",
    "fsId": "9K9V-5VR",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Verena Sckindler"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI511",
    "name": "Christen Schertenleib",
    "sex": "M",
    "gen": 9,
    "slot": 58,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI281",
    "birthYear": 1729,
    "deathYear": 1786,
    "birthDate": "13 Nov 1729",
    "deathDate": "1 Feb 1786",
    "burialDate": null,
    "christeningDate": "13 Nov 1729",
    "birthPlace": "Krauchthal, Bern, Switzerland",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Lützelflüh, Bern, Switzerland",
    "fsId": "LCM4-1Q6",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI512",
    "name": "Magdalena Buetikofer",
    "sex": "F",
    "gen": 9,
    "slot": 59,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI281",
    "birthYear": 1730,
    "deathYear": 1818,
    "birthDate": "Abt 1730",
    "deathDate": "15 Apr 1818",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Krauchthal, Bern, Switzerland",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "L4LR-M9B",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI513",
    "name": "Niklaus Steiner",
    "sex": "M",
    "gen": 9,
    "slot": 60,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI282",
    "birthYear": 1750,
    "deathYear": 1824,
    "birthDate": "8 Feb 1750",
    "deathDate": "1824",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Trachselwald, Bern, Switzerland",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "2MP5-S1X",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Nicklous Steiner",
      "Niclaus Steiner"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI514",
    "name": "Maria Zuercher",
    "sex": "F",
    "gen": 9,
    "slot": 61,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI282",
    "birthYear": 1754,
    "deathYear": 1826,
    "birthDate": "Abt 1754",
    "deathDate": "1826",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Trachselwald, Bern, Switzerland",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "2MP5-3S3",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Maria Zuercher Steiner",
      "Maria Zurcher",
      "Marie Zurcher Steiner",
      "Marta ( Maria) Zuercher",
      "Marta Zuercher"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI515",
    "name": "David Aeschbacher",
    "sex": "M",
    "gen": 9,
    "slot": 62,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI283",
    "birthYear": 1730,
    "deathYear": 1778,
    "birthDate": "8 Apr 1730",
    "deathDate": "20 Aug 1778",
    "burialDate": null,
    "christeningDate": "9 Mar 1732",
    "birthPlace": "Trachselwald, Bern, Switzerland",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Oberdiessbach, Bern, Switzerland",
    "fsId": "LH8B-ZXY",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI516",
    "name": "Elisabeth Blaser",
    "sex": "F",
    "gen": 9,
    "slot": 63,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI283",
    "birthYear": 1734,
    "deathYear": 1792,
    "birthDate": "Abt 1734",
    "deathDate": "14 Jan 1792",
    "burialDate": "16 Jan 1792",
    "christeningDate": null,
    "birthPlace": "Lauperswil, Bern, Switzerland",
    "deathPlace": null,
    "burialPlace": "Trachselwald, Bern, Switzerland",
    "christeningPlace": null,
    "fsId": "LH67-9MF",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Elsbeth Blaser",
      "Elsbeth Blaser Aeschbacher"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI525",
    "name": "John Stuart",
    "sex": "M",
    "gen": 9,
    "slot": 64,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI288",
    "birthYear": 1703,
    "deathYear": null,
    "birthDate": "Abt 1703",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Lancaster, Lancashire, England, United Kingdom",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "K845-T5Y",
    "photo": "/ancestors/bubbles/0576_K845-T5Y.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0576_K845-T5Y.jpg"
  },
  {
    "id": "AQI526",
    "name": "John Stuart",
    "sex": "F",
    "gen": 9,
    "slot": 65,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI288",
    "birthYear": 1707,
    "deathYear": null,
    "birthDate": "Abt 1707",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Lancaster, Lancashire, England, United Kingdom",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "MMQW-JPG",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI527",
    "name": "Adam Huddleston",
    "sex": "M",
    "gen": 9,
    "slot": 72,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI293",
    "birthYear": 1738,
    "deathYear": 1807,
    "birthDate": "Abt 1738",
    "deathDate": "5 Jun 1807",
    "burialDate": "5 Jun 1807",
    "christeningDate": "31 Jan 1738",
    "birthPlace": "Staveley, Westmorland, England",
    "deathPlace": "Kendal, Westmorland, England, United Kingdom",
    "burialPlace": "Kendal Ward, Westmorland, England, United Kingdom",
    "christeningPlace": "Grasmere, Westmorland, England, United Kingdom",
    "fsId": "L4BT-PN9",
    "photo": "/ancestors/bubbles/0584_L4BT-PN9.jpg",
    "living": false,
    "alternateNames": [
      "Adam Huddlestone",
      "Adam Hudleston",
      "Adam Hudlestone"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0584_L4BT-PN9.jpg"
  },
  {
    "id": "AQI528",
    "name": "Margaret Langhorn",
    "sex": "F",
    "gen": 9,
    "slot": 73,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI293",
    "birthYear": 1738,
    "deathYear": 1775,
    "birthDate": "13 Jul 1738",
    "deathDate": "Dec 1775",
    "burialDate": "29 Dec 1775",
    "christeningDate": "6 Aug 1738",
    "birthPlace": "Westmorland, England, United Kingdom",
    "deathPlace": "Westmorland, England, United Kingdom",
    "burialPlace": "Westmorland, England, United Kingdom",
    "christeningPlace": "Kendal, Westmorland, England, United Kingdom",
    "fsId": "L7L5-KKS",
    "photo": "/ancestors/bubbles/0585_L7L5-KKS.jpg",
    "living": false,
    "alternateNames": [
      "Marg't Langhorn Huddlestone",
      "Margaret Langhorne",
      "Margt Langhorn",
      "Margt.",
      "Mgt."
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0585_L7L5-KKS.jpg"
  },
  {
    "id": "AQI529",
    "name": "Thomas Robinson",
    "sex": "M",
    "gen": 9,
    "slot": 74,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI294",
    "birthYear": 1732,
    "deathYear": null,
    "birthDate": "1732",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Staveley, Westmorland, England, United Kingdom",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "KZRS-FSG",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI530",
    "name": "Thomas Robinson",
    "sex": "F",
    "gen": 9,
    "slot": 75,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI294",
    "birthYear": 1735,
    "deathYear": null,
    "birthDate": "Abt 1735",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "England",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "GX3K-67K",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI532",
    "name": "Richard Nelson",
    "sex": "M",
    "gen": 9,
    "slot": 76,
    "side": "paternal",
    "birthplace": "unknown",
    "childId": "AQI295",
    "birthYear": null,
    "deathYear": null,
    "birthDate": null,
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "9KCT-SDN",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI533",
    "name": "George Evans",
    "sex": "M",
    "gen": 9,
    "slot": 80,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI297",
    "birthYear": 1732,
    "deathYear": null,
    "birthDate": "17 Sep 1732",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "17 Sep 1732",
    "birthPlace": "Wybunbury, Cheshire, England, United Kingdom",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Wybunbury, Cheshire, England, United Kingdom",
    "fsId": "GZTG-L6Z",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI534",
    "name": "Jane Poole",
    "sex": "F",
    "gen": 9,
    "slot": 81,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI297",
    "birthYear": 1737,
    "deathYear": null,
    "birthDate": "1737",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Wybunbury, Cheshire, England",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LWG3-ZS2",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI535",
    "name": "Thomas Lewis",
    "sex": "M",
    "gen": 9,
    "slot": 84,
    "side": "paternal",
    "birthplace": "wales",
    "childId": "AQI299",
    "birthYear": 1736,
    "deathYear": null,
    "birthDate": "Abt 1736",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Llangyfelach, Glamorgan, Wales, United Kingdom",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "KGS5-M7K",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI536",
    "name": "Jane Williams",
    "sex": "F",
    "gen": 9,
    "slot": 85,
    "side": "paternal",
    "birthplace": "wales",
    "childId": "AQI299",
    "birthYear": 1742,
    "deathYear": null,
    "birthDate": "4 Jan 1742",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Llangyfelach, Glamorgan, Wales, United Kingdom",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "2HMS-5YR",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Jewan",
      "Jane Lewis"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI537",
    "name": "Morgan John",
    "sex": "M",
    "gen": 9,
    "slot": 98,
    "side": "paternal",
    "birthplace": "unknown",
    "childId": "AQI306",
    "birthYear": null,
    "deathYear": null,
    "birthDate": null,
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "MY33-3ZM",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI538",
    "name": "Sage Griffith",
    "sex": "F",
    "gen": 9,
    "slot": 99,
    "side": "paternal",
    "birthplace": "unknown",
    "childId": "AQI306",
    "birthYear": null,
    "deathYear": 1759,
    "birthDate": null,
    "deathDate": "26 Jan 1759",
    "burialDate": null,
    "christeningDate": "27 Oct 1708",
    "birthPlace": null,
    "deathPlace": "Wales",
    "burialPlace": null,
    "christeningPlace": "Llangendeirne, Carmarthenshire, Wales",
    "fsId": "MY33-3ZC",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI539",
    "name": "John Adams",
    "sex": "M",
    "gen": 9,
    "slot": 108,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI311",
    "birthYear": 1741,
    "deathYear": null,
    "birthDate": "1741",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "31 Jul 1741",
    "birthPlace": "Staffordshire, England, United Kingdom",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Halesowen, Worcestershire, England, United Kingdom",
    "fsId": "MF12-WLH",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI540",
    "name": "Grace Willits",
    "sex": "F",
    "gen": 9,
    "slot": 109,
    "side": "paternal",
    "birthplace": "unknown",
    "childId": "AQI311",
    "birthYear": null,
    "deathYear": null,
    "birthDate": null,
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "M2PC-BMV",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI541",
    "name": "James Siveter",
    "sex": "M",
    "gen": 9,
    "slot": 110,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI312",
    "birthYear": 1740,
    "deathYear": null,
    "birthDate": "Abt 1740",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Halesowen, Worcestershire, England, United Kingdom",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "M25R-VQ1",
    "photo": null,
    "living": false,
    "alternateNames": [
      "James Civiter",
      "James Civeter"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI542",
    "name": "Anne Farmer",
    "sex": "F",
    "gen": 9,
    "slot": 111,
    "side": "paternal",
    "birthplace": "unknown",
    "childId": "AQI312",
    "birthYear": null,
    "deathYear": null,
    "birthDate": null,
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "16 Dec 1750",
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Halesowen, Worcestershire, England, United Kingdom",
    "fsId": "LZGC-1T7",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI543",
    "name": "Richard Dredge",
    "sex": "M",
    "gen": 9,
    "slot": 112,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI313",
    "birthYear": 1725,
    "deathYear": 1825,
    "birthDate": "4 Oct 1725",
    "deathDate": "1825",
    "burialDate": null,
    "christeningDate": "4 Oct 1725",
    "birthPlace": "Frome, Somerset, England, United Kingdom",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Frome, Somerset, England",
    "fsId": "L5NN-NK2",
    "photo": "/ancestors/bubbles/0624_L5NN-NK2.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0624_L5NN-NK2.jpg"
  },
  {
    "id": "AQI544",
    "name": "Miriam Paine",
    "sex": "F",
    "gen": 9,
    "slot": 113,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI313",
    "birthYear": 1729,
    "deathYear": null,
    "birthDate": "1729",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "11 Apr 1729",
    "birthPlace": "Longbridge Deverill, Wiltshire, England",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Lydeard St Lawrence, Somerset, England",
    "fsId": "MBXY-VM8",
    "photo": "/ancestors/bubbles/0625_MBXY-VM8.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0625_MBXY-VM8.jpg"
  },
  {
    "id": "AQI545",
    "name": "William Yeates",
    "sex": "M",
    "gen": 9,
    "slot": 114,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI314",
    "birthYear": 1720,
    "deathYear": null,
    "birthDate": "1720",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "Abt 1720",
    "birthPlace": "England, United Kingdom",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LW6B-J48",
    "photo": null,
    "living": false,
    "alternateNames": [
      "William Yates",
      "William Yeats",
      "William"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI546",
    "name": "Anne",
    "sex": "F",
    "gen": 9,
    "slot": 115,
    "side": "paternal",
    "birthplace": "unknown",
    "childId": "AQI314",
    "birthYear": null,
    "deathYear": null,
    "birthDate": null,
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "GCXV-BFP",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Ann Thornbury",
      "Ann",
      "Mrs. Anne Yeates",
      "Ann Or Nancy Thornburgh",
      "Mrs. Ann Yeates",
      "Mrs. Yates",
      "Anne Yeates"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI547",
    "name": "Sharp",
    "sex": "M",
    "gen": 9,
    "slot": 116,
    "side": "paternal",
    "birthplace": "unknown",
    "childId": "AQI315",
    "birthYear": null,
    "deathYear": null,
    "birthDate": null,
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "PZDZ-DB1",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI548",
    "name": "John Deane",
    "sex": "M",
    "gen": 9,
    "slot": 118,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI316",
    "birthYear": 1761,
    "deathYear": null,
    "birthDate": "Abt 1761",
    "deathDate": null,
    "burialDate": "8 Jul 1823",
    "christeningDate": "24 Jul 1761",
    "birthPlace": "England",
    "deathPlace": null,
    "burialPlace": "Gloucester, Gloucestershire, England, United Kingdom",
    "christeningPlace": "Bristol, England",
    "fsId": "L67W-HG4",
    "photo": null,
    "living": false,
    "alternateNames": [
      "John Dean"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI549",
    "name": "Martha",
    "sex": "F",
    "gen": 9,
    "slot": 119,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI316",
    "birthYear": 1768,
    "deathYear": null,
    "birthDate": "Abt 1768",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Minchinhampton, Gloucestershire, England, United Kingdom",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "L67W-HPP",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI550",
    "name": "Edmund Nelson",
    "sex": "M",
    "gen": 9,
    "slot": 120,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI317",
    "birthYear": 1723,
    "deathYear": 1802,
    "birthDate": "19 Mar 1723",
    "deathDate": "26 Apr 1802",
    "burialDate": "11 May 1802",
    "christeningDate": "29 Mar 1723",
    "birthPlace": "Bradenham, Norfolk, England",
    "deathPlace": "Bath, Somerset, England, United Kingdom",
    "burialPlace": "Burnham Thorpe, Norfolk, England, United Kingdom",
    "christeningPlace": "Bradenham, Norfolk, England",
    "fsId": "L41B-V3W",
    "photo": "/ancestors/bubbles/0632_L41B-V3W.jpg",
    "living": false,
    "alternateNames": [
      "(Rev.) Edmund Nelson",
      "Rev. Edmund Nelson"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0632_L41B-V3W.jpg"
  },
  {
    "id": "AQI551",
    "name": "Catherine Suckling",
    "sex": "F",
    "gen": 9,
    "slot": 121,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI317",
    "birthYear": 1725,
    "deathYear": 1767,
    "birthDate": "9 May 1725",
    "deathDate": "26 Dec 1767",
    "burialDate": "30 Dec 1767",
    "christeningDate": "27 May 1725",
    "birthPlace": "Barsham, Suffolk, England",
    "deathPlace": "Burnham Thorpe, Norfolk, England",
    "burialPlace": "Burnham Thorpe, Norfolk, England",
    "christeningPlace": "Barsham, Suffolk, England",
    "fsId": "KHQV-JPJ",
    "photo": "/ancestors/bubbles/0633_KHQV-JPJ.jpg",
    "living": false,
    "alternateNames": [
      "Catherine Nelson"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0633_KHQV-JPJ.jpg"
  },
  {
    "id": "AQI552",
    "name": "David Rhees",
    "sex": "M",
    "gen": 9,
    "slot": 122,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI318",
    "birthYear": 1752,
    "deathYear": 1784,
    "birthDate": "Abt 1752",
    "deathDate": "Bef 1784",
    "burialDate": null,
    "christeningDate": "23 Jan 1754",
    "birthPlace": "Widcombe, Somerset, England, United Kingdom",
    "deathPlace": "Bath, Somerset, England, United Kingdom",
    "burialPlace": "Bath, Somerset, England, United Kingdom",
    "christeningPlace": "Blaina, Monmouthshire, Wales, United Kingdom",
    "fsId": "LCVX-XSJ",
    "photo": null,
    "living": false,
    "alternateNames": [
      "David Reces",
      "David Rhees ( Rhys)",
      "David Rhees or Rhys",
      "Living"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI553",
    "name": "Elizabeth Nott",
    "sex": "F",
    "gen": 9,
    "slot": 123,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI318",
    "birthYear": 1750,
    "deathYear": null,
    "birthDate": "Abt 1750",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Corsham, Wiltshire, England, United Kingdom",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LB5V-SF3",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Ann Nott",
      "Elizabeth Knott",
      "Elizabeth Nott Rhees Harper"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI554",
    "name": "James Green",
    "sex": "M",
    "gen": 9,
    "slot": 124,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI319",
    "birthYear": 1748,
    "deathYear": 1833,
    "birthDate": "Abt 1748",
    "deathDate": "23 Nov 1833",
    "burialDate": "23 Nov 1833",
    "christeningDate": null,
    "birthPlace": "Walcot, Somerset, England, United Kingdom",
    "deathPlace": "Shaftesbury St James, Dorset, England, United Kingdom",
    "burialPlace": "Bath, Somerset, England, United Kingdom",
    "christeningPlace": null,
    "fsId": "KJZD-D28",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI555",
    "name": "Anne Warbuton",
    "sex": "F",
    "gen": 9,
    "slot": 125,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI319",
    "birthYear": 1750,
    "deathYear": 1831,
    "birthDate": "1750",
    "deathDate": "3 Jan 1831",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Walcot, Somerset, England, United Kingdom",
    "deathPlace": "Shepton Mallet, Somerset, England, United Kingdom",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "K1WV-PNQ",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Mrs. Anne Green"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI556",
    "name": "Daniel Charmbury",
    "sex": "M",
    "gen": 9,
    "slot": 126,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI320",
    "birthYear": 1756,
    "deathYear": 1843,
    "birthDate": "Abt 1756",
    "deathDate": "28 May 1843",
    "burialDate": "28 May 1843",
    "christeningDate": "24 Oct 1763",
    "birthPlace": "South Stoke, Somerset, England, United Kingdom",
    "deathPlace": "South Stoke, Somerset, England, United Kingdom",
    "burialPlace": "Claverton, Somerset, England, United Kingdom",
    "christeningPlace": "Claverton, Somerset, England, United Kingdom",
    "fsId": "LWFZ-VD2",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Charmbury",
      "Daniel",
      "Daniel Charmby",
      "Danl Charmbury",
      "Danl. Charmbury"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI557",
    "name": "Martha Marchant",
    "sex": "F",
    "gen": 9,
    "slot": 127,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI320",
    "birthYear": null,
    "deathYear": 1833,
    "birthDate": null,
    "deathDate": "27 Jan 1833",
    "burialDate": null,
    "christeningDate": "5 Sep 1760",
    "birthPlace": "England",
    "deathPlace": "Bath, Somerset, England, United Kingdom",
    "burialPlace": null,
    "christeningPlace": "Hurstpierpoint, Sussex, England",
    "fsId": "KNYK-LNM",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Martha",
      "Marthar",
      "Mrs Martha Charmbury"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI558",
    "name": "Nathan Hull",
    "sex": "M",
    "gen": 9,
    "slot": 128,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI321",
    "birthYear": 1744,
    "deathYear": 1811,
    "birthDate": "13 May 1744",
    "deathDate": "31 Oct 1811",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Westport, Fairfield, Connecticut, United States",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LJV4-FWX",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI559",
    "name": "Elizabeth Monrow",
    "sex": "F",
    "gen": 9,
    "slot": 129,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI321",
    "birthYear": 1743,
    "deathYear": 1765,
    "birthDate": "13 Mar 1743",
    "deathDate": "Aft 14 Oct 1765",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Salem Center, Westchester, New York Colony, British Colonial America",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LJV4-FZL",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI562",
    "name": "Levi Vinal",
    "sex": "M",
    "gen": 9,
    "slot": 130,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI322",
    "birthYear": 1754,
    "deathYear": 1839,
    "birthDate": "Jun 1754",
    "deathDate": "8 Jan 1839",
    "burialDate": "11 Jan 1839",
    "christeningDate": "28 Jun 1754",
    "birthPlace": "Scituate, Plymouth, Massachusetts, United States",
    "deathPlace": "Scituate, Plymouth, Massachusetts Bay Colony, British Colonial America",
    "burialPlace": "Scituate, Plymouth, Massachusetts, United States",
    "christeningPlace": "Scituate, Plymouth, Massachusetts Bay Colony, British Colonial America",
    "fsId": "K4BT-X9B",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI563",
    "name": "Patience Vinal",
    "sex": "F",
    "gen": 9,
    "slot": 131,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI322",
    "birthYear": 1766,
    "deathYear": 1815,
    "birthDate": "15 Mar 1766",
    "deathDate": "Bef 2 Jul 1815",
    "burialDate": null,
    "christeningDate": "3 Jul 1766",
    "birthPlace": "Scituate, Plymouth, Massachusetts, United States",
    "deathPlace": "Scituate, Plymouth, Massachusetts, United States",
    "burialPlace": "Scituate, Plymouth, Massachusetts, United States",
    "christeningPlace": null,
    "fsId": "LCTJ-2NT",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Patiance",
      "Patience"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI564",
    "name": "Andrew Dewey",
    "sex": "M",
    "gen": 9,
    "slot": 134,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI324",
    "birthYear": 1751,
    "deathYear": 1816,
    "birthDate": "29 Dec 1751",
    "deathDate": "17 Jul 1816",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Lebanon, New London, Connecticut, United States",
    "deathPlace": "Lenox, Madison, New York, United States",
    "burialPlace": "Fenner, Madison, New York, United States",
    "christeningPlace": null,
    "fsId": "2ZS7-2G7",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Andrew Dewy"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI565",
    "name": "Elizabeth ‘Betsy’ Woodworth",
    "sex": "F",
    "gen": 9,
    "slot": 135,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI324",
    "birthYear": 1765,
    "deathYear": 1854,
    "birthDate": "6 Feb 1765",
    "deathDate": "1 Feb 1854",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Lebanon, New London, Connecticut Colony, British Colonial America",
    "deathPlace": "Wesleyville, Erie, Pennsylvania, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LVWG-JSB",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI566",
    "name": "Thomas Lindsay",
    "sex": "M",
    "gen": 9,
    "slot": 136,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI325",
    "birthYear": 1723,
    "deathYear": 1806,
    "birthDate": "Mar 1723",
    "deathDate": "2 Jan 1806",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Dracut, Middlesex, Massachusetts, United States",
    "deathPlace": "Peacham, Caledonia, Vermont, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "L8BN-LG6",
    "photo": "/ancestors/bubbles/0648_L8BN-LG6.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0648_L8BN-LG6.jpg"
  },
  {
    "id": "AQI567",
    "name": "Ruth Foster",
    "sex": "F",
    "gen": 9,
    "slot": 137,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI325",
    "birthYear": 1731,
    "deathYear": 1825,
    "birthDate": "26 Aug 1731",
    "deathDate": "21 Oct 1825",
    "burialDate": null,
    "christeningDate": "27 Sep 1731",
    "birthPlace": "Middleton, Essex, Massachusetts, United States",
    "deathPlace": "Peacham, Caledonia, Vermont, United States",
    "burialPlace": null,
    "christeningPlace": "Middleton, Essex, Massachusetts, United States",
    "fsId": "L5KR-YMH",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI568",
    "name": "Thomas Williams",
    "sex": "M",
    "gen": 9,
    "slot": 138,
    "side": "paternal",
    "birthplace": "unknown",
    "childId": "AQI326",
    "birthYear": 1750,
    "deathYear": 1804,
    "birthDate": "1750",
    "deathDate": "Bef 17 Jan 1804",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": null,
    "deathPlace": "Alfred, York, Maine, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "9XY8-GG9",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI569",
    "name": "Sarah",
    "sex": "F",
    "gen": 9,
    "slot": 139,
    "side": "paternal",
    "birthplace": "unknown",
    "childId": "AQI326",
    "birthYear": null,
    "deathYear": null,
    "birthDate": null,
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "9XY8-GGS",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI570",
    "name": "Clement Bunker",
    "sex": "M",
    "gen": 9,
    "slot": 140,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI327",
    "birthYear": 1714,
    "deathYear": 1787,
    "birthDate": "Abt 1714",
    "deathDate": "Aft 13 Apr 1787",
    "burialDate": "1787",
    "christeningDate": null,
    "birthPlace": "Dover, Strafford, New Hampshire, British Colonial America",
    "deathPlace": "Barnstead, Belknap, New Hampshire, United States",
    "burialPlace": "Durham, Strafford, New Hampshire, United States",
    "christeningPlace": null,
    "fsId": "LH6D-6LV",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI571",
    "name": "Rebeckah Drew",
    "sex": "F",
    "gen": 9,
    "slot": 141,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI327",
    "birthYear": 1716,
    "deathYear": 1817,
    "birthDate": "24 Apr 1716",
    "deathDate": "1817",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Dover, Strafford, New Hampshire, United States",
    "deathPlace": "Barnstead, Belknap, New Hampshire, United States",
    "burialPlace": "Center Harbor, Belknap, New Hampshire, United States",
    "christeningPlace": null,
    "fsId": "GZHP-C81",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI572",
    "name": "Jonathan Benedict",
    "sex": "M",
    "gen": 9,
    "slot": 144,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI329",
    "birthYear": 1723,
    "deathYear": 1800,
    "birthDate": "2 Feb 1723",
    "deathDate": "11 Sep 1800",
    "burialDate": "Sep 1800",
    "christeningDate": null,
    "birthPlace": "Ridgefield, Fairfield, Connecticut, United States",
    "deathPlace": "Manchester, Bennington, Vermont, United States",
    "burialPlace": "Factory Point Cemetery, Manchester, Bennington, Vermont, United States",
    "christeningPlace": null,
    "fsId": "LRS6-XFQ",
    "photo": "/ancestors/bubbles/0656_LRS6-XFQ.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0656_LRS6-XFQ.jpg"
  },
  {
    "id": "AQI573",
    "name": "Lucy Castle",
    "sex": "F",
    "gen": 9,
    "slot": 145,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI329",
    "birthYear": 1731,
    "deathYear": null,
    "birthDate": "2 Aug 1731",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "8 Aug 1731",
    "birthPlace": "Woodbury, Litchfield, Connecticut Colony, British Colonial America",
    "deathPlace": "New Milford, Litchfield, Connecticut, United States",
    "burialPlace": null,
    "christeningPlace": "Woodbury, Litchfield, Connecticut Colony, British Colonial America",
    "fsId": "LHR5-3PR",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI574",
    "name": "Thomas Edgar Bull",
    "sex": "M",
    "gen": 9,
    "slot": 146,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI330",
    "birthYear": 1737,
    "deathYear": 1823,
    "birthDate": "31 Mar 1737",
    "deathDate": "1823",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Dover, Dutchess, New York, United States",
    "deathPlace": "Manchester, Bennington, Vermont, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LCVY-5LS",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI575",
    "name": "Martha A Smith",
    "sex": "F",
    "gen": 9,
    "slot": 147,
    "side": "paternal",
    "birthplace": "unknown",
    "childId": "AQI330",
    "birthYear": 1744,
    "deathYear": 1810,
    "birthDate": "1744",
    "deathDate": "Oct 1810",
    "burialDate": "1810",
    "christeningDate": "14 Oct 1744",
    "birthPlace": null,
    "deathPlace": "Manchester, Bennington, Vermont, United States",
    "burialPlace": "Factory Point Cemetery, Manchester, Bennington, Vermont, United States",
    "christeningPlace": "Holborn, Middlesex, England, United Kingdom",
    "fsId": "LCMG-C88",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Martha Bull"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI576",
    "name": "Gershom Wing",
    "sex": "M",
    "gen": 9,
    "slot": 148,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI331",
    "birthYear": 1744,
    "deathYear": 1825,
    "birthDate": "Abt 2 Dec 1744",
    "deathDate": "Abt 1825",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Wareham, Plymouth, Massachusetts, United States",
    "deathPlace": "Athens, Leeds and Grenville, Ontario, Canada",
    "burialPlace": "Quaker Cemetery, Athens Township, Leeds and Grenville, Ontario, Canada",
    "christeningPlace": null,
    "fsId": "LC8N-8YP",
    "photo": "/ancestors/bubbles/0660_LC8N-8YP.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0660_LC8N-8YP.jpg"
  },
  {
    "id": "AQI577",
    "name": "Rebecca Chase",
    "sex": "F",
    "gen": 9,
    "slot": 149,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI331",
    "birthYear": 1745,
    "deathYear": 1797,
    "birthDate": "Abt 5 Jan 1745",
    "deathDate": "Aft 1797",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Dutchess, New York, United States",
    "deathPlace": "Elizabethtown-Kitley Township, Leeds and Grenville, Ontario, Canada",
    "burialPlace": "Quaker Cemetery, Athens Township, Leeds and Grenville, Ontario, Canada",
    "christeningPlace": null,
    "fsId": "LQR3-PLG",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI578",
    "name": "John Hammar",
    "sex": "M",
    "gen": 9,
    "slot": 152,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI333",
    "birthYear": 1740,
    "deathYear": 1768,
    "birthDate": "1740",
    "deathDate": "1768",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Prince George's, Maryland, British Colonial America",
    "deathPlace": "Maryland, British Colonial America",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LV5N-XX2",
    "photo": "/ancestors/bubbles/0664_LV5N-XX2.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0664_LV5N-XX2.jpg"
  },
  {
    "id": "AQI579",
    "name": "Margaret Wright",
    "sex": "F",
    "gen": 9,
    "slot": 153,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI333",
    "birthYear": 1742,
    "deathYear": 1822,
    "birthDate": "12 Nov 1742",
    "deathDate": "13 Nov 1822",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Prince George's, Maryland, British Colonial America",
    "deathPlace": "Laurens, South Carolina, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LLQB-2QT",
    "photo": "/ancestors/bubbles/0665_LLQB-2QT.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0665_LLQB-2QT.jpg"
  },
  {
    "id": "AQI580",
    "name": "William Jay",
    "sex": "M",
    "gen": 9,
    "slot": 154,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI334",
    "birthYear": 1745,
    "deathYear": 1797,
    "birthDate": "12 Sep 1745",
    "deathDate": "7 Jan 1797",
    "burialDate": "Jan 1797",
    "christeningDate": null,
    "birthPlace": "Westchester, Frederick, Maryland, British Colonial America",
    "deathPlace": "Newberry, Newberry, South Carolina, United States",
    "burialPlace": "Newberry, Newberry, South Carolina, United States",
    "christeningPlace": null,
    "fsId": "LZBR-4BG",
    "photo": "/ancestors/bubbles/0666_LZBR-4BG.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0666_LZBR-4BG.jpg"
  },
  {
    "id": "AQI581",
    "name": "Elizabeth Natherson",
    "sex": "F",
    "gen": 9,
    "slot": 155,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI334",
    "birthYear": 1746,
    "deathYear": 1777,
    "birthDate": "Mar 1746",
    "deathDate": "4 Mar 1777",
    "burialDate": "6 Mar 1777",
    "christeningDate": null,
    "birthPlace": "Frederick, Virginia, British Colonial America",
    "deathPlace": null,
    "burialPlace": "Newberry Memorial Gardens, Newberry, Newberry, South Carolina, United States",
    "christeningPlace": null,
    "fsId": "MRJ3-D91",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Elizabeth Jay"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI582",
    "name": "Shadrach Llewellyn",
    "sex": "M",
    "gen": 9,
    "slot": 156,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI335",
    "birthYear": 1735,
    "deathYear": 1784,
    "birthDate": "1735",
    "deathDate": "10 Feb 1784",
    "burialDate": "1784",
    "christeningDate": null,
    "birthPlace": "Virginia, United States",
    "deathPlace": "Virginia, United States",
    "burialPlace": "Lincoln, Loudoun, Virginia, United States",
    "christeningPlace": null,
    "fsId": "L1ZM-MNS",
    "photo": "/ancestors/bubbles/0668_L1ZM-MNS.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0668_L1ZM-MNS.jpg"
  },
  {
    "id": "AQI583",
    "name": "Deborah Burson",
    "sex": "F",
    "gen": 9,
    "slot": 157,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI335",
    "birthYear": 1737,
    "deathYear": 1801,
    "birthDate": "1737",
    "deathDate": "28 Oct 1801",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Philadelphia, Pennsylvania, United States",
    "deathPlace": "Loudoun, Virginia, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "L8YR-51B",
    "photo": "/ancestors/bubbles/0669_L8YR-51B.jpg",
    "living": false,
    "alternateNames": [
      "Llewelyn"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0669_L8YR-51B.jpg"
  },
  {
    "id": "AQI584",
    "name": "Benjamin Brooks",
    "sex": "M",
    "gen": 9,
    "slot": 158,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI336",
    "birthYear": 1740,
    "deathYear": 1809,
    "birthDate": "29 Jul 1740",
    "deathDate": "1809",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Church Hill, Queen Anne's, Maryland, United States",
    "deathPlace": "Liberty Township, Highland, Ohio, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "MTRX-N8K",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI585",
    "name": "Anne Nancy Armstrong",
    "sex": "F",
    "gen": 9,
    "slot": 159,
    "side": "paternal",
    "birthplace": "unknown",
    "childId": "AQI336",
    "birthYear": 1745,
    "deathYear": 1810,
    "birthDate": "Abt 1745",
    "deathDate": "Aft 1810",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": null,
    "deathPlace": "Highland, Ohio, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "GV4X-8BS",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Anne"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI586",
    "name": "Moses Cranor",
    "sex": "M",
    "gen": 9,
    "slot": 160,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI337",
    "birthYear": 1733,
    "deathYear": 1793,
    "birthDate": "1733",
    "deathDate": "2 Sep 1793",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Talbot, Maryland, United States",
    "deathPlace": "Marlboro, South Carolina, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "MNVQ-72M",
    "photo": "/ancestors/bubbles/0672_MNVQ-72M.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0672_MNVQ-72M.jpg"
  },
  {
    "id": "AQI587",
    "name": "Sarah Lister",
    "sex": "F",
    "gen": 9,
    "slot": 161,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI337",
    "birthYear": 1739,
    "deathYear": 1801,
    "birthDate": "1739",
    "deathDate": "May 1801",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Talbot, Maryland, United States",
    "deathPlace": "Guilford, Guilford, North Carolina, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "M8J4-ND3",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Sarah Cranor"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI588",
    "name": "Josiah B Trotter",
    "sex": "M",
    "gen": 9,
    "slot": 162,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI338",
    "birthYear": 1730,
    "deathYear": 1792,
    "birthDate": "1730",
    "deathDate": "25 Feb 1792",
    "burialDate": "25 Feb 1792",
    "christeningDate": null,
    "birthPlace": "Choptank Hundred, Caroline, Maryland, British Colonial America",
    "deathPlace": "Guilford, North Carolina, United States",
    "burialPlace": "Guilford, North Carolina, United States",
    "christeningPlace": null,
    "fsId": "L4B4-G7L",
    "photo": "/ancestors/bubbles/0674_L4B4-G7L.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0674_L4B4-G7L.jpg"
  },
  {
    "id": "AQI589",
    "name": "Jane Hanna Manlove Russell",
    "sex": "F",
    "gen": 9,
    "slot": 163,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI338",
    "birthYear": 1735,
    "deathYear": 1834,
    "birthDate": "1735",
    "deathDate": "18 Oct 1834",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Dorchester, Maryland, British Colonial America",
    "deathPlace": "Guilford, Guilford, North Carolina, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "L4B4-GCW",
    "photo": "/ancestors/bubbles/0675_L4B4-GCW.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0675_L4B4-GCW.jpg"
  },
  {
    "id": "AQI590",
    "name": "John Stephenson",
    "sex": "M",
    "gen": 9,
    "slot": 164,
    "side": "paternal",
    "birthplace": "unknown",
    "childId": "AQI339",
    "birthYear": 1740,
    "deathYear": 1813,
    "birthDate": "1740",
    "deathDate": "1813",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": null,
    "deathPlace": "Rowan, North Carolina, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "G6X3-4F9",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI591",
    "name": "Jane McCalland",
    "sex": "F",
    "gen": 9,
    "slot": 165,
    "side": "paternal",
    "birthplace": "ireland",
    "childId": "AQI339",
    "birthYear": 1744,
    "deathYear": 1791,
    "birthDate": "Abt 1744",
    "deathDate": "Abt 1791",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "County Antrim, Ireland",
    "deathPlace": "Iredell, North Carolina, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "M74Z-JM9",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI592",
    "name": "Joshua Edwards",
    "sex": "M",
    "gen": 9,
    "slot": 168,
    "side": "paternal",
    "birthplace": "unknown",
    "childId": "AQI341",
    "birthYear": 1735,
    "deathYear": 1824,
    "birthDate": "Abt 1735",
    "deathDate": "1824",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": null,
    "deathPlace": "Chatham, North Carolina, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LKM7-QGL",
    "photo": "/ancestors/bubbles/0680_LKM7-QGL.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0680_LKM7-QGL.jpg"
  },
  {
    "id": "AQI593",
    "name": "Rebecca Ramage",
    "sex": "F",
    "gen": 9,
    "slot": 169,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI341",
    "birthYear": 1732,
    "deathYear": null,
    "birthDate": "1732",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Delaware, British Colonial America",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "G1LW-8XG",
    "photo": "/ancestors/bubbles/0681_G1LW-8XG.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0681_G1LW-8XG.jpg"
  },
  {
    "id": "AQI586s172",
    "name": "Moses Cranor",
    "sex": "M",
    "gen": 9,
    "slot": 172,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI337s86",
    "birthYear": 1733,
    "deathYear": 1793,
    "birthDate": "1733",
    "deathDate": "2 Sep 1793",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Talbot, Maryland, United States",
    "deathPlace": "Marlboro, South Carolina, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "MNVQ-72M",
    "photo": "/ancestors/bubbles/0672_MNVQ-72M.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0672_MNVQ-72M.jpg"
  },
  {
    "id": "AQI587s173",
    "name": "Sarah Lister",
    "sex": "F",
    "gen": 9,
    "slot": 173,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI337s86",
    "birthYear": 1739,
    "deathYear": 1801,
    "birthDate": "1739",
    "deathDate": "May 1801",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Talbot, Maryland, United States",
    "deathPlace": "Guilford, Guilford, North Carolina, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "M8J4-ND3",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Sarah Cranor"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI588s174",
    "name": "Josiah B Trotter",
    "sex": "M",
    "gen": 9,
    "slot": 174,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI338s87",
    "birthYear": 1730,
    "deathYear": 1792,
    "birthDate": "1730",
    "deathDate": "25 Feb 1792",
    "burialDate": "25 Feb 1792",
    "christeningDate": null,
    "birthPlace": "Choptank Hundred, Caroline, Maryland, British Colonial America",
    "deathPlace": "Guilford, North Carolina, United States",
    "burialPlace": "Guilford, North Carolina, United States",
    "christeningPlace": null,
    "fsId": "L4B4-G7L",
    "photo": "/ancestors/bubbles/0674_L4B4-G7L.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0674_L4B4-G7L.jpg"
  },
  {
    "id": "AQI589s175",
    "name": "Jane Hanna Manlove Russell",
    "sex": "F",
    "gen": 9,
    "slot": 175,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI338s87",
    "birthYear": 1735,
    "deathYear": 1834,
    "birthDate": "1735",
    "deathDate": "18 Oct 1834",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Dorchester, Maryland, British Colonial America",
    "deathPlace": "Guilford, Guilford, North Carolina, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "L4B4-GCW",
    "photo": "/ancestors/bubbles/0675_L4B4-GCW.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0675_L4B4-GCW.jpg"
  },
  {
    "id": "AQI594",
    "name": "Jesse Mendenhall",
    "sex": "M",
    "gen": 9,
    "slot": 176,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI342",
    "birthYear": 1753,
    "deathYear": 1832,
    "birthDate": "14 Sep 1753",
    "deathDate": "1832",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Sadsbury Township, Chester, Pennsylvania, British Colonial America",
    "deathPlace": "Crooked Creek Township, McDowell, North Carolina, United States",
    "burialPlace": "Bethel United Methodist Church Cemetery, Old Fort, McDowell, North Carolina, United States",
    "christeningPlace": null,
    "fsId": "LCT7-84Y",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Jesse",
      "Thomas Mendenhall"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI595",
    "name": "Anne Moesley",
    "sex": "F",
    "gen": 9,
    "slot": 177,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI342",
    "birthYear": 1759,
    "deathYear": 1850,
    "birthDate": "1759",
    "deathDate": "1850",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "United States",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LCT7-8Z5",
    "photo": null,
    "living": false,
    "alternateNames": [
      "<Unknown>"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI596",
    "name": "Richard Taliaferro",
    "sex": "M",
    "gen": 9,
    "slot": 178,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI343",
    "birthYear": 1759,
    "deathYear": 1781,
    "birthDate": "25 May 1759",
    "deathDate": "15 Mar 1781",
    "burialDate": "1781",
    "christeningDate": null,
    "birthPlace": "Amherst, Virginia, British Colonial America",
    "deathPlace": "Greensboro, Guilford, North Carolina, United States",
    "burialPlace": "Greensboro, Guilford, North Carolina, United States",
    "christeningPlace": null,
    "fsId": "LTLG-GV1",
    "photo": "/ancestors/bubbles/0690_LTLG-GV1.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0690_LTLG-GV1.jpg"
  },
  {
    "id": "AQI597",
    "name": "Dorcas Perkins",
    "sex": "F",
    "gen": 9,
    "slot": 179,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI343",
    "birthYear": 1754,
    "deathYear": 1791,
    "birthDate": "1754",
    "deathDate": "1791",
    "burialDate": "1791",
    "christeningDate": null,
    "birthPlace": "Buckingham, Arlington, Virginia, United States",
    "deathPlace": "Baldwin, Georgia, United States",
    "burialPlace": "Georgia, United States",
    "christeningPlace": null,
    "fsId": "L71M-6MT",
    "photo": "/ancestors/bubbles/0691_L71M-6MT.jpg",
    "living": false,
    "alternateNames": [
      "Dorcus Ashworth",
      "Dorcas Ashworth"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0691_L71M-6MT.jpg"
  },
  {
    "id": "AQI598",
    "name": "William Bristow",
    "sex": "M",
    "gen": 9,
    "slot": 180,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI344",
    "birthYear": 1747,
    "deathYear": 1792,
    "birthDate": "6 Oct 1747",
    "deathDate": "Mar 1792",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Christchurch, Middlesex, Virginia, British Colonial America",
    "deathPlace": "Patrick, Virginia, United States",
    "burialPlace": "Harmony Grove Baptist Church Cemetery, Topping, Middlesex, Virginia, United States",
    "christeningPlace": null,
    "fsId": "LZ8M-7DX",
    "photo": null,
    "living": false,
    "alternateNames": [
      "William Bristow , Sr.",
      "William Bristoe"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI599",
    "name": "Margaret Powell",
    "sex": "F",
    "gen": 9,
    "slot": 181,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI344",
    "birthYear": 1751,
    "deathYear": 1833,
    "birthDate": "1 Apr 1751",
    "deathDate": "27 Aug 1833",
    "burialDate": "Aug 1833",
    "christeningDate": null,
    "birthPlace": "Prince William, Virginia, United States",
    "deathPlace": "Greenwood, Pleasant Township, Johnson, Indiana, United States",
    "burialPlace": "Mount Pleasant Cemetery, Greenwood, Pleasant Township, Johnson, Indiana, United States",
    "christeningPlace": null,
    "fsId": "LTMR-5W8",
    "photo": "/ancestors/bubbles/0693_LTMR-5W8.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0693_LTMR-5W8.jpg"
  },
  {
    "id": "AQI600",
    "name": "John Van Meter",
    "sex": "M",
    "gen": 9,
    "slot": 188,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI346",
    "birthYear": 1755,
    "deathYear": 1825,
    "birthDate": "1755",
    "deathDate": "12 Jun 1825",
    "burialDate": null,
    "christeningDate": "Abt 24 Aug 1755",
    "birthPlace": "New Jersey, British Colonial America",
    "deathPlace": "Montgomery, New York, United States",
    "burialPlace": null,
    "christeningPlace": "Freehold Borough, Monmouth, New Jersey, United States",
    "fsId": "LW6P-Q34",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Van Mater"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI601",
    "name": "Sarah Hendricks",
    "sex": "F",
    "gen": 9,
    "slot": 189,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI346",
    "birthYear": 1768,
    "deathYear": 1847,
    "birthDate": "Abt 1768",
    "deathDate": "25 Aug 1847",
    "burialDate": "Aug 1847",
    "christeningDate": null,
    "birthPlace": "Middletown Township, Monmouth, New Jersey, United States",
    "deathPlace": "Johnstown, Fulton, New York, United States",
    "burialPlace": "Pine Ridge Cemetery, Navarino, Onondaga, Onondaga, New York, United States",
    "christeningPlace": null,
    "fsId": "LHJT-1XY",
    "photo": "/ancestors/bubbles/0701_LHJT-1XY.jpg",
    "living": false,
    "alternateNames": [
      "Sarah Hendrickson"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0701_LHJT-1XY.jpg"
  },
  {
    "id": "AQI602",
    "name": "Johannes Hagel",
    "sex": "M",
    "gen": 9,
    "slot": 190,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI347",
    "birthYear": 1762,
    "deathYear": 1840,
    "birthDate": "19 Jun 1762",
    "deathDate": "22 Oct 1840",
    "burialDate": "1840",
    "christeningDate": null,
    "birthPlace": "Montgomery, New York, United States",
    "deathPlace": "Fonda, Mohawk, Montgomery, New York, United States",
    "burialPlace": "Johnstown, Fulton, New York, United States",
    "christeningPlace": null,
    "fsId": "KNQZ-K4K",
    "photo": null,
    "living": false,
    "alternateNames": [
      "John Hegel"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI603",
    "name": "Catrina Plantz",
    "sex": "F",
    "gen": 9,
    "slot": 191,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI347",
    "birthYear": 1764,
    "deathYear": 1806,
    "birthDate": "Abt 1764",
    "deathDate": "1806",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Montgomery, New York, United States",
    "deathPlace": "Johnstown, Fulton, New York, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "2QGT-3R4",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Catharina Plants",
      "Catrena Plantz",
      "Catrina Plants",
      "Catherina Plantz"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI604",
    "name": "Blackner",
    "sex": "M",
    "gen": 9,
    "slot": 192,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI348",
    "birthYear": 1742,
    "deathYear": null,
    "birthDate": "Abt 1742",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Hucknall Torkard, Nottinghamshire, England",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "P83H-LX1",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI605",
    "name": "Robert Caunt",
    "sex": "M",
    "gen": 9,
    "slot": 194,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI349",
    "birthYear": 1729,
    "deathYear": 1769,
    "birthDate": "21 Oct 1729",
    "deathDate": "Feb 1769",
    "burialDate": "19 Feb 1769",
    "christeningDate": "21 Dec 1729",
    "birthPlace": "Hucknall Torkard, Nottinghamshire, England, United Kingdom",
    "deathPlace": "Hucknall Torkard, Nottinghamshire, England",
    "burialPlace": "Hucknall Torkard, Nottinghamshire, England",
    "christeningPlace": "Hucknall Torkard, Nottinghamshire, England, United Kingdom",
    "fsId": "LZ2M-HJD",
    "photo": "/ancestors/bubbles/0706_LZ2M-HJD.jpg",
    "living": false,
    "alternateNames": [
      "Robert Cont",
      "Robert Cant"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0706_LZ2M-HJD.jpg"
  },
  {
    "id": "AQI606",
    "name": "Ann Watson",
    "sex": "F",
    "gen": 9,
    "slot": 195,
    "side": "paternal",
    "birthplace": "unknown",
    "childId": "AQI349",
    "birthYear": null,
    "deathYear": null,
    "birthDate": null,
    "deathDate": null,
    "burialDate": "30 Sep 1766",
    "christeningDate": "6 Sep 1738",
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": "Nottingham St Nicholas, Nottinghamshire, England",
    "christeningPlace": "Nottingham, Nottinghamshire, England",
    "fsId": "LZ2L-YVB",
    "photo": "/ancestors/bubbles/0707_LZ2L-YVB.jpg",
    "living": false,
    "alternateNames": [
      "Anne Watson"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0707_LZ2L-YVB.jpg"
  },
  {
    "id": "AQI607",
    "name": "Henry Hall",
    "sex": "M",
    "gen": 9,
    "slot": 196,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI350",
    "birthYear": 1727,
    "deathYear": 1779,
    "birthDate": "24 Sep 1727",
    "deathDate": "3 Aug 1779",
    "burialDate": "3 Aug 1779",
    "christeningDate": null,
    "birthPlace": "Osbournby, Lincolnshire, England",
    "deathPlace": "Great Hale, Lincolnshire, England",
    "burialPlace": "Great Hale, Lincolnshire, England",
    "christeningPlace": null,
    "fsId": "LZ87-1WN",
    "photo": "/ancestors/bubbles/0708_LZ87-1WN.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0708_LZ87-1WN.jpg"
  },
  {
    "id": "AQI608",
    "name": "Elizabeth Winfrew",
    "sex": "F",
    "gen": 9,
    "slot": 197,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI350",
    "birthYear": 1729,
    "deathYear": 1782,
    "birthDate": "22 Sep 1729",
    "deathDate": "28 Aug 1782",
    "burialDate": null,
    "christeningDate": "22 Sep 1729",
    "birthPlace": "Swineshead, Lincolnshire, England",
    "deathPlace": "Great Hale, Lincolnshire, England",
    "burialPlace": null,
    "christeningPlace": "Swineshead, Lincolnshire, England",
    "fsId": "2N3W-CQP",
    "photo": "/ancestors/bubbles/0709_2N3W-CQP.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0709_2N3W-CQP.jpg"
  },
  {
    "id": "AQI609",
    "name": "William Ingram",
    "sex": "M",
    "gen": 9,
    "slot": 198,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI351",
    "birthYear": 1739,
    "deathYear": 1779,
    "birthDate": "27 Dec 1739",
    "deathDate": "Nov 1779",
    "burialDate": "14 Nov 1779",
    "christeningDate": "27 Dec 1739",
    "birthPlace": "Evedon, Lincolnshire, England",
    "deathPlace": "Kirkby on Bain, Lincolnshire, England",
    "burialPlace": "Kirkby on Bain, Lincolnshire, England",
    "christeningPlace": "Evedon, Lincolnshire, England, United Kingdom",
    "fsId": "M7HS-W5F",
    "photo": "/ancestors/bubbles/0710_M7HS-W5F.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0710_M7HS-W5F.jpg"
  },
  {
    "id": "AQI610",
    "name": "Elizabeth Harmstone",
    "sex": "F",
    "gen": 9,
    "slot": 199,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI351",
    "birthYear": 1740,
    "deathYear": 1766,
    "birthDate": "Abt 1740",
    "deathDate": "15 Feb 1766",
    "burialDate": "15 Feb 1766",
    "christeningDate": null,
    "birthPlace": "Evedon, Lincolnshire, England",
    "deathPlace": "Evedon, Lincolnshire, England",
    "burialPlace": "Evedon, Lincolnshire, England",
    "christeningPlace": null,
    "fsId": "9VC7-TSH",
    "photo": "/ancestors/bubbles/0711_9VC7-TSH.jpg",
    "living": false,
    "alternateNames": [
      "Elizabeth Harmston"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0711_9VC7-TSH.jpg"
  },
  {
    "id": "AQI612",
    "name": "Robert Allen",
    "sex": "M",
    "gen": 9,
    "slot": 200,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI352",
    "birthYear": 1756,
    "deathYear": 1825,
    "birthDate": "Sep 1756",
    "deathDate": "Jan 1825",
    "burialDate": "10 Jan 1825",
    "christeningDate": "30 Sep 1756",
    "birthPlace": "Sheffield, Yorkshire, England, United Kingdom",
    "deathPlace": "Sheffield, Yorkshire, England, United Kingdom",
    "burialPlace": "Sheffield, Yorkshire, England, United Kingdom",
    "christeningPlace": "Sheffield, Yorkshire, England, United Kingdom",
    "fsId": "M5P7-Y9V",
    "photo": "/ancestors/bubbles/0712_M5P7-Y9V.jpg",
    "living": false,
    "alternateNames": [
      "Robert Allin"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0712_M5P7-Y9V.jpg"
  },
  {
    "id": "AQI613",
    "name": "Elizabeth Allin",
    "sex": "F",
    "gen": 9,
    "slot": 201,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI352",
    "birthYear": 1758,
    "deathYear": 1784,
    "birthDate": "Abt 1758",
    "deathDate": "Jun 1784",
    "burialDate": "2 Jun 1784",
    "christeningDate": "29 May 1758",
    "birthPlace": "Yorkshire, England, United Kingdom",
    "deathPlace": "Sheffield, Yorkshire, England, United Kingdom",
    "burialPlace": "Sheffield, Yorkshire, England, United Kingdom",
    "christeningPlace": "Sheffield St Peter and St Paul, Yorkshire, England, United Kingdom",
    "fsId": "4TS5-FX8",
    "photo": "/ancestors/bubbles/0713_4TS5-FX8.jpg",
    "living": false,
    "alternateNames": [
      "Elizabeth"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0713_4TS5-FX8.jpg"
  },
  {
    "id": "AQI614",
    "name": "Leonard Mawson",
    "sex": "M",
    "gen": 9,
    "slot": 202,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI353",
    "birthYear": 1759,
    "deathYear": 1832,
    "birthDate": "Abt 1759",
    "deathDate": "Sep 1832",
    "burialDate": "9 Sep 1832",
    "christeningDate": "4 Feb 1759",
    "birthPlace": "Hawksworth near Guiseley, Yorkshire, England",
    "deathPlace": "Sheffield, Yorkshire, England, United Kingdom",
    "burialPlace": "Sheffield, Yorkshire, England",
    "christeningPlace": "Otley, Yorkshire, England",
    "fsId": "LHVF-TXN",
    "photo": "/ancestors/bubbles/0714_LHVF-TXN.jpg",
    "living": false,
    "alternateNames": [
      "Leonard Marson",
      "Leonard Morson"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0714_LHVF-TXN.jpg"
  },
  {
    "id": "AQI615",
    "name": "Hannah Bevers",
    "sex": "F",
    "gen": 9,
    "slot": 203,
    "side": "paternal",
    "birthplace": "unknown",
    "childId": "AQI353",
    "birthYear": null,
    "deathYear": 1825,
    "birthDate": null,
    "deathDate": "Jan 1825",
    "burialDate": "25 Jan 1825",
    "christeningDate": "27 Dec 1753",
    "birthPlace": null,
    "deathPlace": "Sheffield, Yorkshire, England",
    "burialPlace": "Sheffield, Yorkshire, England",
    "christeningPlace": "Rawmarsh, Yorkshire, England",
    "fsId": "LC7W-LYL",
    "photo": "/ancestors/bubbles/0715_LC7W-LYL.jpg",
    "living": false,
    "alternateNames": [
      "Hannah Beever"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0715_LC7W-LYL.jpg"
  },
  {
    "id": "AQI616",
    "name": "Sarah Ottiwell",
    "sex": "F",
    "gen": 9,
    "slot": 205,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI354",
    "birthYear": 1737,
    "deathYear": 1785,
    "birthDate": "Abt 1737",
    "deathDate": "May 1785",
    "burialDate": "7 May 1785",
    "christeningDate": "9 Feb 1746",
    "birthPlace": "Nottingham, Nottinghamshire, England",
    "deathPlace": "Nottingham, Nottinghamshire, England, United Kingdom",
    "burialPlace": "Nottingham, Nottinghamshire, England, United Kingdom",
    "christeningPlace": "Saint Mary the Virgin, Nottingham, Nottinghamshire, England, United Kingdom",
    "fsId": "M7C3-H63",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI617",
    "name": "William Keeling",
    "sex": "M",
    "gen": 9,
    "slot": 206,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI355",
    "birthYear": 1744,
    "deathYear": 1794,
    "birthDate": "Abt 1744",
    "deathDate": "11 Jan 1794",
    "burialDate": null,
    "christeningDate": "15 Jun 1746",
    "birthPlace": "Birchover, Derbyshire, England, United Kingdom",
    "deathPlace": "Edwinstowe, Nottinghamshire, England, United Kingdom",
    "burialPlace": null,
    "christeningPlace": "Birchover, Derbyshire, England, United Kingdom",
    "fsId": "MH1N-49S",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI618",
    "name": "Sarah Smith",
    "sex": "F",
    "gen": 9,
    "slot": 207,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI355",
    "birthYear": 1737,
    "deathYear": 1831,
    "birthDate": "Abt 1737",
    "deathDate": "Jan 1831",
    "burialDate": "14 Jan 1831",
    "christeningDate": null,
    "birthPlace": "Nottingham, Nottinghamshire, England, United Kingdom",
    "deathPlace": "Worksop, Nottinghamshire, England, United Kingdom",
    "burialPlace": "Worksop, Nottinghamshire, England, United Kingdom",
    "christeningPlace": null,
    "fsId": "K64Q-6QT",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Sarah"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI619",
    "name": "Richard Hare",
    "sex": "M",
    "gen": 9,
    "slot": 208,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI356",
    "birthYear": 1724,
    "deathYear": 1800,
    "birthDate": "5 Jun 1724",
    "deathDate": "11 Aug 1800",
    "burialDate": "11 Aug 1800",
    "christeningDate": "5 Jun 1724",
    "birthPlace": "Barrowby, Lincolnshire, England, United Kingdom",
    "deathPlace": "Great Gonerby, Lincolnshire, England, United Kingdom",
    "burialPlace": "Great Gonerby, Lincolnshire, England, United Kingdom",
    "christeningPlace": "Barrowby, England",
    "fsId": "LZKQ-LFP",
    "photo": "/ancestors/bubbles/0720_LZKQ-LFP.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0720_LZKQ-LFP.jpg"
  },
  {
    "id": "AQI620",
    "name": "Elizabeth Bronson Or Braunson",
    "sex": "F",
    "gen": 9,
    "slot": 209,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI356",
    "birthYear": 1727,
    "deathYear": 1766,
    "birthDate": "2 Feb 1727",
    "deathDate": "Jan 1766",
    "burialDate": "29 Jan 1766",
    "christeningDate": "2 Feb 1727",
    "birthPlace": "Denton, Lincolnshire, England, United Kingdom",
    "deathPlace": "Great Gonerby, Lincolnshire, England, United Kingdom",
    "burialPlace": "Great Gonerby, Lincolnshire, England, United Kingdom",
    "christeningPlace": "Denton, Lincolnshire, England",
    "fsId": "M6VR-TFY",
    "photo": "/ancestors/bubbles/0721_M6VR-TFY.jpg",
    "living": false,
    "alternateNames": [
      "Elizabeth Bronston"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0721_M6VR-TFY.jpg"
  },
  {
    "id": "AQI621",
    "name": "John Elsey",
    "sex": "M",
    "gen": 9,
    "slot": 210,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI357",
    "birthYear": 1732,
    "deathYear": 1804,
    "birthDate": "1732",
    "deathDate": "May 1804",
    "burialDate": "20 May 1804",
    "christeningDate": "14 Nov 1732",
    "birthPlace": "Rippingale, Lincolnshire, England, United Kingdom",
    "deathPlace": "Rippingale, Lincolnshire, England, United Kingdom",
    "burialPlace": "Rippingale, Lincolnshire, England, United Kingdom",
    "christeningPlace": "Rippingale, Lincolnshire, England",
    "fsId": "9VW5-HHV",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI622",
    "name": "Rebecca TOWNS",
    "sex": "F",
    "gen": 9,
    "slot": 211,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI357",
    "birthYear": 1727,
    "deathYear": 1811,
    "birthDate": "14 Oct 1727",
    "deathDate": "14 Jan 1811",
    "burialDate": "14 Jan 1811",
    "christeningDate": "14 Oct 1733",
    "birthPlace": "Lincolnshire, England, United Kingdom",
    "deathPlace": "Rippingale, Lincolnshire, England, United Kingdom",
    "burialPlace": "Rippingale, Lincolnshire, England, United Kingdom",
    "christeningPlace": "Irnham, Irnham, Lincolnshire, England",
    "fsId": "LZLS-4WJ",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Rebecca Elsey"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI623",
    "name": "Simon Naylor, Jr",
    "sex": "M",
    "gen": 9,
    "slot": 212,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI358",
    "birthYear": 1734,
    "deathYear": 1793,
    "birthDate": "4 Jan 1734",
    "deathDate": "4 Oct 1793",
    "burialDate": "4 Oct 1793",
    "christeningDate": "4 Jan 1735",
    "birthPlace": "Scott Willoughby, Lincolnshire, England, United Kingdom",
    "deathPlace": "Aunsby, Lincolnshire, England, United Kingdom",
    "burialPlace": "Aunsby, Lincolnshire, England, United Kingdom",
    "christeningPlace": "Scott Willoughby, Lincolnshire, England",
    "fsId": "LZGM-34V",
    "photo": "/ancestors/bubbles/0724_LZGM-34V.jpg",
    "living": false,
    "alternateNames": [
      "Simon Nayler"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0724_LZGM-34V.jpg"
  },
  {
    "id": "AQI624",
    "name": "Sarah Cock",
    "sex": "F",
    "gen": 9,
    "slot": 213,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI358",
    "birthYear": 1734,
    "deathYear": 1776,
    "birthDate": "1 Oct 1734",
    "deathDate": "9 Nov 1776",
    "burialDate": "9 Nov 1776",
    "christeningDate": "1 Oct 1734",
    "birthPlace": "Helpringham, Lincolnshire, England, United Kingdom",
    "deathPlace": "Helpringham, Lincolnshire, England, United Kingdom",
    "burialPlace": "Helpringham, Lincolnshire, England, United Kingdom",
    "christeningPlace": "Helpringham, Lincolnshire, England",
    "fsId": "LZGS-Z8G",
    "photo": "/ancestors/bubbles/0725_LZGS-Z8G.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0725_LZGS-Z8G.jpg"
  },
  {
    "id": "AQI625",
    "name": "James Taylor",
    "sex": "M",
    "gen": 9,
    "slot": 214,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI359",
    "birthYear": 1739,
    "deathYear": 1779,
    "birthDate": "1739",
    "deathDate": "Nov 1779",
    "burialDate": "25 Nov 1779",
    "christeningDate": "2 Dec 1739",
    "birthPlace": "Lincolnshire, England",
    "deathPlace": "Donington, Lincolnshire, England, United Kingdom",
    "burialPlace": "Donington, Lincolnshire, England, United Kingdom",
    "christeningPlace": "Middleton by Oldham, Lancashire, England, United Kingdom",
    "fsId": "L8P5-WG8",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI626",
    "name": "Sarah Kitching",
    "sex": "F",
    "gen": 9,
    "slot": 215,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI359",
    "birthYear": 1742,
    "deathYear": null,
    "birthDate": "10 Oct 1742",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "21 Nov 1743",
    "birthPlace": "Kirkstead, Lincolnshire, England, United Kingdom",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Worth, Sussex, England, United Kingdom",
    "fsId": "LZNC-88Q",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Sarah E Kitching"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI627",
    "name": "John Hopkins",
    "sex": "M",
    "gen": 9,
    "slot": 216,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI360",
    "birthYear": 1756,
    "deathYear": 1808,
    "birthDate": "1756",
    "deathDate": "13 Nov 1808",
    "burialDate": "16 Nov 1808",
    "christeningDate": null,
    "birthPlace": "Wakefield, Yorkshire, England",
    "deathPlace": null,
    "burialPlace": "Brighouse, Yorkshire, England, United Kingdom",
    "christeningPlace": null,
    "fsId": "LHZS-TH6",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI628",
    "name": "Mary Gidlow",
    "sex": "F",
    "gen": 9,
    "slot": 217,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI360",
    "birthYear": 1767,
    "deathYear": null,
    "birthDate": "1767",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "14 Sep 1778",
    "birthPlace": "Wakefield, Yorkshire, England",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Wakefield, Yorkshire, England",
    "fsId": "LHZS-T4P",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI629",
    "name": "George Kershaw",
    "sex": "M",
    "gen": 9,
    "slot": 218,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI361",
    "birthYear": 1753,
    "deathYear": null,
    "birthDate": "Abt 1753",
    "deathDate": null,
    "burialDate": "10 Jul 1804",
    "christeningDate": "24 Nov 1753",
    "birthPlace": "Wakefield, Yorkshire, England",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "All Saints, Wakefield, Yorkshire, England",
    "fsId": "LCPB-LF4",
    "photo": null,
    "living": false,
    "alternateNames": [
      "George Kirshaw"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI630",
    "name": "Sarah Goldthorpe",
    "sex": "F",
    "gen": 9,
    "slot": 219,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI361",
    "birthYear": 1755,
    "deathYear": null,
    "birthDate": "1755",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "11 Oct 1755",
    "birthPlace": "Wakefield, Yorkshire, England",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "All Saints, Wakefield, Yorkshire, England",
    "fsId": "LHXK-DSY",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Sarah Goldthorp"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI631",
    "name": "Joseph Marrison",
    "sex": "M",
    "gen": 9,
    "slot": 220,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI362",
    "birthYear": 1750,
    "deathYear": null,
    "birthDate": "Abt 1750",
    "deathDate": null,
    "burialDate": "10 Apr 1826",
    "christeningDate": null,
    "birthPlace": "Castleton, Derbyshire, England",
    "deathPlace": null,
    "burialPlace": "Castleton, Derbyshire, England, United Kingdom",
    "christeningPlace": null,
    "fsId": "LHZS-T77",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Joseph Morrison"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI632",
    "name": "Ann Eyre",
    "sex": "F",
    "gen": 9,
    "slot": 221,
    "side": "paternal",
    "birthplace": "unknown",
    "childId": "AQI362",
    "birthYear": null,
    "deathYear": null,
    "birthDate": null,
    "deathDate": null,
    "burialDate": "18 Jan 1852",
    "christeningDate": "28 Aug 1752",
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": "Castleton, Derbyshire, England, United Kingdom",
    "christeningPlace": "Buckworth, Huntingdonshire, England",
    "fsId": "2NBG-4SF",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Nanny Marrison"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI633",
    "name": "James Wright",
    "sex": "M",
    "gen": 9,
    "slot": 222,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI363",
    "birthYear": 1748,
    "deathYear": 1834,
    "birthDate": "1748",
    "deathDate": "13 Mar 1834",
    "burialDate": "26 May 1834",
    "christeningDate": "5 May 1748",
    "birthPlace": "Castleton, Derbyshire, England",
    "deathPlace": null,
    "burialPlace": "Castleton, Derbyshire, England, United Kingdom",
    "christeningPlace": "Castleton, Derbyshire, England, United Kingdom",
    "fsId": "L83S-QNN",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI634",
    "name": "Hannah Needham",
    "sex": "F",
    "gen": 9,
    "slot": 223,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI363",
    "birthYear": 1759,
    "deathYear": 1830,
    "birthDate": "1759",
    "deathDate": "1830",
    "burialDate": "14 Sep 1830",
    "christeningDate": "8 Oct 1759",
    "birthPlace": "Castleton, Derbyshire, England",
    "deathPlace": "England, United Kingdom",
    "burialPlace": "Castleton, Derbyshire, England, United Kingdom",
    "christeningPlace": "Castleton, Derbyshire, England",
    "fsId": "K4XY-214",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI635",
    "name": "Thomas Briggs",
    "sex": "M",
    "gen": 9,
    "slot": 224,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI364",
    "birthYear": 1717,
    "deathYear": null,
    "birthDate": "25 Jan 1717",
    "deathDate": null,
    "burialDate": "9 Jul 1759",
    "christeningDate": "25 Jan 1718",
    "birthPlace": "Sawley, Yorkshire, England",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Bolton by Bowland, Yorkshire, England, United Kingdom",
    "fsId": "MJH8-QWL",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI636",
    "name": "Mary Wilson",
    "sex": "F",
    "gen": 9,
    "slot": 225,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI364",
    "birthYear": 1718,
    "deathYear": null,
    "birthDate": "6 Apr 1718",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "6 Apr 1718",
    "birthPlace": "Downham, Lancashire, England",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Downham, Lancashire, England",
    "fsId": "LJKQ-1D2",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI639",
    "name": "Johnathan Parkinson",
    "sex": "M",
    "gen": 9,
    "slot": 226,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI365",
    "birthYear": 1714,
    "deathYear": 1781,
    "birthDate": "1714",
    "deathDate": "27 Nov 1781",
    "burialDate": null,
    "christeningDate": "26 Feb 1709",
    "birthPlace": "Bolton, Yorkshire, England, United Kingdom",
    "deathPlace": "Bolton by Bowland, Yorkshire, England, United Kingdom",
    "burialPlace": null,
    "christeningPlace": "Bolton, Yorkshire, England, United Kingdom",
    "fsId": "LH76-86W",
    "photo": null,
    "living": false,
    "alternateNames": [
      "John Parkinson",
      "Jon. Parkinson",
      "Jonathan Parkinson"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI640",
    "name": "Ann Atkinson",
    "sex": "F",
    "gen": 9,
    "slot": 227,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI365",
    "birthYear": 1714,
    "deathYear": 1773,
    "birthDate": "Abt 1714",
    "deathDate": "11 Dec 1773",
    "burialDate": "11 Dec 1773",
    "christeningDate": "25 Apr 1714",
    "birthPlace": "Ripley, Yorkshire, England, United Kingdom",
    "deathPlace": "Bolton by Bowland, Yorkshire, England, United Kingdom",
    "burialPlace": "Bolton by Bowland, Yorkshire, England, United Kingdom",
    "christeningPlace": "Ripley, Yorkshire, England",
    "fsId": "LH76-4KK",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Anne Atkinson"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI641",
    "name": "Peter Haworth",
    "sex": "M",
    "gen": 9,
    "slot": 228,
    "side": "paternal",
    "birthplace": "unknown",
    "childId": "AQI366",
    "birthYear": 1738,
    "deathYear": null,
    "birthDate": "Abt 1738",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "GZBX-TJZ",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI642",
    "name": "Mary",
    "sex": "F",
    "gen": 9,
    "slot": 229,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI366",
    "birthYear": 1741,
    "deathYear": null,
    "birthDate": "Abt 1741",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Accrington, Lancashire, England, United Kingdom",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "GZBF-D4S",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Mary Howarth"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI643",
    "name": "John Riley",
    "sex": "M",
    "gen": 9,
    "slot": 230,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI367",
    "birthYear": 1735,
    "deathYear": 1775,
    "birthDate": "7 Oct 1735",
    "deathDate": "Mar 1775",
    "burialDate": "24 Dec 1751",
    "christeningDate": null,
    "birthPlace": "Oswaldtwistle, Lancashire, England, United Kingdom",
    "deathPlace": "Haslingden, Lancashire, England, United Kingdom",
    "burialPlace": "Lancashire, England",
    "christeningPlace": null,
    "fsId": "GK9Y-1F8",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI644",
    "name": "Elizabeth Duckworth",
    "sex": "F",
    "gen": 9,
    "slot": 231,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI367",
    "birthYear": 1735,
    "deathYear": 1807,
    "birthDate": "23 May 1735",
    "deathDate": "Jan 1807",
    "burialDate": null,
    "christeningDate": "26 May 1735",
    "birthPlace": "Haslingden, Lancashire, England, United Kingdom",
    "deathPlace": "Stonefold, Haslingden, Lancashire, England",
    "burialPlace": null,
    "christeningPlace": "Great Harwood, Lancashire, England, United Kingdom",
    "fsId": "GK9Y-H44",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI645",
    "name": "Thomas Fielden",
    "sex": "M",
    "gen": 9,
    "slot": 232,
    "side": "paternal",
    "birthplace": "unknown",
    "childId": "AQI368",
    "birthYear": null,
    "deathYear": null,
    "birthDate": null,
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "PXPP-7BP",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI646",
    "name": "Martha Duckworth",
    "sex": "F",
    "gen": 9,
    "slot": 233,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI368",
    "birthYear": 1757,
    "deathYear": null,
    "birthDate": "Abt 1757",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "4 Jun 1758",
    "birthPlace": "Great Harwood, Lancashire, England, United Kingdom",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Blackburn, Lancashire, England, United Kingdom",
    "fsId": "K8NY-43R",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI649",
    "name": "Thomas Leaver",
    "sex": "M",
    "gen": 9,
    "slot": 234,
    "side": "paternal",
    "birthplace": "unknown",
    "childId": "AQI369",
    "birthYear": 1725,
    "deathYear": 1816,
    "birthDate": "Abt 1725",
    "deathDate": "1816",
    "burialDate": "16 Dec 1816",
    "christeningDate": "31 Jan 1725",
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": "Blackburn, Lancashire, England, United Kingdom",
    "christeningPlace": "Preston, Lancashire, England, United Kingdom",
    "fsId": "GDTR-L25",
    "photo": "/ancestors/bubbles/0746_GDTR-L25.jpg",
    "living": false,
    "alternateNames": [
      "Thos. Leaver"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0746_GDTR-L25.jpg"
  },
  {
    "id": "AQI650",
    "name": "Margaret Aldersay",
    "sex": "F",
    "gen": 9,
    "slot": 235,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI369",
    "birthYear": 1730,
    "deathYear": null,
    "birthDate": "Abt 1730",
    "deathDate": null,
    "burialDate": "19 Oct 1784",
    "christeningDate": null,
    "birthPlace": "Lancashire, England",
    "deathPlace": null,
    "burialPlace": "Blackburn, Lancashire, England, United Kingdom",
    "christeningPlace": null,
    "fsId": "GDTR-XQN",
    "photo": "/ancestors/bubbles/0747_GDTR-XQN.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0747_GDTR-XQN.jpg"
  },
  {
    "id": "AQI651",
    "name": "John Holden",
    "sex": "M",
    "gen": 9,
    "slot": 236,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI370",
    "birthYear": 1738,
    "deathYear": 1795,
    "birthDate": "7 May 1738",
    "deathDate": "24 May 1795",
    "burialDate": "26 May 1795",
    "christeningDate": "24 May 1738",
    "birthPlace": "Bury, Lancashire, England",
    "deathPlace": "Bury, Lancashire, England, United Kingdom",
    "burialPlace": "Bury, Lancashire, England, United Kingdom",
    "christeningPlace": "Bury, Lancashire, England",
    "fsId": "MCSR-RQ4",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI652",
    "name": "Margaret Fletcher",
    "sex": "F",
    "gen": 9,
    "slot": 237,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI370",
    "birthYear": 1754,
    "deathYear": null,
    "birthDate": "26 Sep 1754",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "11 Oct 1754",
    "birthPlace": "Bury, Lancashire, England, United Kingdom",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "St Mary The Virgin's Church, Bury, Lancashire, England, United Kingdom",
    "fsId": "9Q1D-VZ2",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI653",
    "name": "John Thompson",
    "sex": "M",
    "gen": 9,
    "slot": 238,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI371",
    "birthYear": 1750,
    "deathYear": 1810,
    "birthDate": "Abt 1750",
    "deathDate": "22 Mar 1810",
    "burialDate": "22 Mar 1810",
    "christeningDate": null,
    "birthPlace": "Lancashire, England",
    "deathPlace": "Liverpool, Lancashire, England, United Kingdom",
    "burialPlace": "Liverpool, Lancashire, England, United Kingdom",
    "christeningPlace": null,
    "fsId": "GQPK-MCB",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI654",
    "name": "Alice Schofield",
    "sex": "F",
    "gen": 9,
    "slot": 239,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI371",
    "birthYear": 1754,
    "deathYear": 1825,
    "birthDate": "1754",
    "deathDate": "1825",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Lancashire, England, United Kingdom",
    "deathPlace": "Wardleworth, Lancashire, England, United Kingdom",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "G36Z-F2D",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Mrs. Alice Thompson"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI655",
    "name": "Jacob Sørensen",
    "sex": "M",
    "gen": 9,
    "slot": 248,
    "side": "paternal",
    "birthplace": "denmark",
    "childId": "AQI372",
    "birthYear": 1748,
    "deathYear": 1806,
    "birthDate": "Abt 1748",
    "deathDate": "26 Apr 1806",
    "burialDate": null,
    "christeningDate": "24 Mar 1748",
    "birthPlace": "Smidstrup, Koldinghus, Denmark",
    "deathPlace": "Kalvehave, Vordingborg, Denmark",
    "burialPlace": null,
    "christeningPlace": "Smidstrup, Koldinghus, Denmark",
    "fsId": "MKKL-R6W",
    "photo": "/ancestors/bubbles/0760_MKKL-R6W.jpg",
    "living": false,
    "alternateNames": [
      "Jacob Sorensen"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0760_MKKL-R6W.jpg"
  },
  {
    "id": "AQI656",
    "name": "Ann Hendrichsdatter",
    "sex": "F",
    "gen": 9,
    "slot": 249,
    "side": "paternal",
    "birthplace": "denmark",
    "childId": "AQI372",
    "birthYear": 1752,
    "deathYear": 1825,
    "birthDate": "17 Sep 1752",
    "deathDate": "1825",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Sønder Bjert, Koldinghus, Denmark",
    "deathPlace": "Denmark",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "L878-TF7",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI657",
    "name": "Anne Margeret Schoder",
    "sex": "F",
    "gen": 9,
    "slot": 253,
    "side": "paternal",
    "birthplace": "unknown",
    "childId": "AQI374",
    "birthYear": null,
    "deathYear": null,
    "birthDate": null,
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "GQBW-XB4",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI658",
    "name": "Hans Christian Schroder",
    "sex": "M",
    "gen": 9,
    "slot": 254,
    "side": "paternal",
    "birthplace": "denmark",
    "childId": "AQI375",
    "birthYear": 1718,
    "deathYear": null,
    "birthDate": "1718",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Vor Frelsers, Nim, Stjernholm, Denmark",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "9KMW-GKG",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Hans Schroder"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI659",
    "name": "Dorothea Elizabeth Kierstine",
    "sex": "F",
    "gen": 9,
    "slot": 255,
    "side": "paternal",
    "birthplace": "denmark",
    "childId": "AQI375",
    "birthYear": 1720,
    "deathYear": null,
    "birthDate": "Abt 1720",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Vor Frelsers, Nim, Stjernholm, Denmark",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "M979-6JS",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI669",
    "name": "Heck",
    "sex": "M",
    "gen": 9,
    "slot": 256,
    "side": "maternal",
    "birthplace": "unknown",
    "childId": "AQI384",
    "birthYear": 1730,
    "deathYear": null,
    "birthDate": "Abt 1730",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "GGNP-BYS",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI670",
    "name": "George Duryea or Deery",
    "sex": "M",
    "gen": 9,
    "slot": 260,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI386",
    "birthYear": 1719,
    "deathYear": 1760,
    "birthDate": "1719",
    "deathDate": "1760",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "United States",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "94CD-XN2",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI671",
    "name": "Hannah Hudson",
    "sex": "F",
    "gen": 9,
    "slot": 261,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI386",
    "birthYear": 1727,
    "deathYear": null,
    "birthDate": "1727",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Chester, Pennsylvania, United States",
    "deathPlace": "Chester, Pennsylvania, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "HZ3Q-66G",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI672",
    "name": "Johannes Michael Hippel",
    "sex": "M",
    "gen": 9,
    "slot": 262,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI387",
    "birthYear": 1726,
    "deathYear": 1760,
    "birthDate": "18 Nov 1726",
    "deathDate": "24 Nov 1760",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Germany",
    "deathPlace": "Chester, Pennsylvania, United States",
    "burialPlace": "East Vincent United Church of Christ Cemetery, Spring City, Chester, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "2QK8-LM3",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI673",
    "name": "Maria Catherina Elizabeth Hass",
    "sex": "F",
    "gen": 9,
    "slot": 263,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI387",
    "birthYear": 1730,
    "deathYear": 1816,
    "birthDate": "20 May 1730",
    "deathDate": "6 Sep 1816",
    "burialDate": null,
    "christeningDate": "20 May 1730",
    "birthPlace": "Germany",
    "deathPlace": "Norristown, Montgomery, Pennsylvania, United States",
    "burialPlace": "Saint John Episcopal Church Cemetery, Norristown, Montgomery, Pennsylvania, United States",
    "christeningPlace": "Münster, Oberamt Mergentheim, Württemberg, Germany",
    "fsId": "MR1H-HF3",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Maria Elizabeth Hipple"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI674",
    "name": "Thomas Yarnall",
    "sex": "M",
    "gen": 9,
    "slot": 272,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI388",
    "birthYear": 1724,
    "deathYear": 1759,
    "birthDate": "27 Feb 1724",
    "deathDate": "Jun 1759",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Goshen Township, Chester, Pennsylvania, British Colonial America",
    "deathPlace": "Thornbury Township, Chester, Pennsylvania, British Colonial America",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "G868-V8C",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI675",
    "name": "Margaret Hill",
    "sex": "F",
    "gen": 9,
    "slot": 273,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI388",
    "birthYear": 1721,
    "deathYear": 1811,
    "birthDate": "1721",
    "deathDate": "25 Jun 1811",
    "burialDate": "1811",
    "christeningDate": null,
    "birthPlace": "Aston Township, Delaware, Pennsylvania, United States",
    "deathPlace": "Aston Township, Delaware, Pennsylvania, United States",
    "burialPlace": "Middletown Monthly Meeting, Chester, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LYB7-31Z",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI676",
    "name": "Thomas Noble",
    "sex": "M",
    "gen": 9,
    "slot": 288,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI390",
    "birthYear": 1696,
    "deathYear": 1775,
    "birthDate": "10 Sep 1696",
    "deathDate": "18 Feb 1775",
    "burialDate": null,
    "christeningDate": "11 Oct 1696",
    "birthPlace": "Westfield, Hampshire, Massachusetts Bay Colony, British Colonial America",
    "deathPlace": "Westfield, Hampshire, Massachusetts Bay Colony, British Colonial America",
    "burialPlace": "Old Burying Ground, Westfield, Hampden, Massachusetts, United States",
    "christeningPlace": "Westfield, Hampshire, Massachusetts Bay Colony, British Colonial America",
    "fsId": "LVQX-6CN",
    "photo": "/ancestors/bubbles/0800_LVQX-6CN.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0800_LVQX-6CN.jpg"
  },
  {
    "id": "AQI677",
    "name": "Sarah Root",
    "sex": "F",
    "gen": 9,
    "slot": 289,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI390",
    "birthYear": 1702,
    "deathYear": 1760,
    "birthDate": "9 Mar 1702",
    "deathDate": "9 Jul 1760",
    "burialDate": "1760",
    "christeningDate": "5 Jul 1702",
    "birthPlace": "Westfield, Hampshire, Massachusetts Bay Colony, British Colonial America",
    "deathPlace": "Westfield, Hampshire, Massachusetts Bay Colony, British Colonial America",
    "burialPlace": "Blandford, Hampshire, Massachusetts Bay Colony, British Colonial America",
    "christeningPlace": "Westfield, Hampshire, Massachusetts Bay Colony, British Colonial America",
    "fsId": "LC9N-G5W",
    "photo": "/ancestors/bubbles/0801_LC9N-G5W.jpg",
    "living": false,
    "alternateNames": [
      "Sarah Noble"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0801_LC9N-G5W.jpg"
  },
  {
    "id": "AQI678",
    "name": "Daniel Sexton",
    "sex": "M",
    "gen": 9,
    "slot": 290,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI391",
    "birthYear": 1700,
    "deathYear": 1792,
    "birthDate": "26 Nov 1700",
    "deathDate": "8 Oct 1792",
    "burialDate": "Oct 1792",
    "christeningDate": "30 Nov 1700",
    "birthPlace": "Westfield, Hampshire, Massachusetts Bay Colony, British Colonial America",
    "deathPlace": "Somers, Tolland, Connecticut, United States",
    "burialPlace": "First Luthern Cemetery, New Britain, Hartford, Connecticut, United States",
    "christeningPlace": "Westfield, Hampshire, Massachusetts Bay Colony, British Colonial America",
    "fsId": "KVJL-WLC",
    "photo": "/ancestors/bubbles/0802_KVJL-WLC.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0802_KVJL-WLC.jpg"
  },
  {
    "id": "AQI679",
    "name": "Mary Douglas",
    "sex": "F",
    "gen": 9,
    "slot": 291,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI391",
    "birthYear": 1715,
    "deathYear": 1806,
    "birthDate": "13 Feb 1715",
    "deathDate": "27 Apr 1806",
    "burialDate": "29 Apr 1806",
    "christeningDate": "15 Apr 1716",
    "birthPlace": "New London, New London, Connecticut Colony, British Colonial America",
    "deathPlace": "Somers, Tolland, Connecticut, United States",
    "burialPlace": "Somers, Tolland, Connecticut, United States",
    "christeningPlace": "New London, Connecticut Colony, British Colonial America",
    "fsId": "LZBV-HCF",
    "photo": "/ancestors/bubbles/0803_LZBV-HCF.jpg",
    "living": false,
    "alternateNames": [
      "Mary",
      "Mary D... ...lass",
      "Mary Doughlas",
      "Mary Douglass",
      "Sexton, Daniel"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0803_LZBV-HCF.jpg"
  },
  {
    "id": "AQI680",
    "name": "John Buell",
    "sex": "M",
    "gen": 9,
    "slot": 292,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI392",
    "birthYear": 1698,
    "deathYear": 1785,
    "birthDate": "1 Feb 1698",
    "deathDate": "1785",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Windsor, Hartford, Connecticut Colony, British Colonial America",
    "deathPlace": "Lebanon, New London, Connecticut, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LC5H-GNM",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI681",
    "name": "Freedom Strong",
    "sex": "F",
    "gen": 9,
    "slot": 293,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI392",
    "birthYear": 1704,
    "deathYear": 1776,
    "birthDate": "16 May 1704",
    "deathDate": "18 Jul 1776",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Lebanon, New London, Connecticut Colony, British Colonial America",
    "deathPlace": "Norwichtown, Norwich, New London, Connecticut Colony, British Colonial America",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "K87N-M58",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI682",
    "name": "Nehemiah Fisher",
    "sex": "M",
    "gen": 9,
    "slot": 294,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI393",
    "birthYear": 1727,
    "deathYear": 1788,
    "birthDate": "3 Dec 1727",
    "deathDate": "Bef 29 Sep 1788",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Norton, Bristol, Massachusetts Bay Colony, British Colonial America",
    "deathPlace": "New Milford, Litchfield, Connecticut, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LC9L-JWC",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI683",
    "name": "Frances Beecher",
    "sex": "F",
    "gen": 9,
    "slot": 295,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI393",
    "birthYear": 1730,
    "deathYear": null,
    "birthDate": "5 Jul 1730",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "New Milford, Litchfield, Connecticut, United States",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "K21F-DBB",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Frances Beacher",
      "Francis Beecher"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI684",
    "name": "John Garratt",
    "sex": "M",
    "gen": 9,
    "slot": 296,
    "side": "maternal",
    "birthplace": "unknown",
    "childId": "AQI394",
    "birthYear": null,
    "deathYear": null,
    "birthDate": null,
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "10 Mar 1735",
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Nuneaton, Warwickshire, England, United Kingdom",
    "fsId": "L2DF-ZW9",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI685",
    "name": "Hannah Longslough",
    "sex": "F",
    "gen": 9,
    "slot": 297,
    "side": "maternal",
    "birthplace": "unknown",
    "childId": "AQI394",
    "birthYear": null,
    "deathYear": null,
    "birthDate": null,
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "2 Nov 1735",
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Nuneaton, Warwickshire, England, United Kingdom",
    "fsId": "MJ9H-JZG",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI686",
    "name": "Jeremiah Kelsey",
    "sex": "M",
    "gen": 9,
    "slot": 298,
    "side": "maternal",
    "birthplace": "england",
    "childId": "AQI395",
    "birthYear": 1730,
    "deathYear": 1792,
    "birthDate": "1730",
    "deathDate": "1792",
    "burialDate": "2 Jan 1792",
    "christeningDate": "29 Mar 1730",
    "birthPlace": "Ansley, Warwickshire, England",
    "deathPlace": "Nuneaton, Warwickshire, England, United Kingdom",
    "burialPlace": "Nuneaton, Warwickshire, England, United Kingdom",
    "christeningPlace": "Ansley, Warwickshire, England",
    "fsId": "LM1Z-9DJ",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI687",
    "name": "Alice Jefcote",
    "sex": "F",
    "gen": 9,
    "slot": 299,
    "side": "maternal",
    "birthplace": "england",
    "childId": "AQI395",
    "birthYear": 1725,
    "deathYear": null,
    "birthDate": "26 Jan 1725",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "27 Mar 1725",
    "birthPlace": "Nuneaton, Warwickshire, England, United Kingdom",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Nuneaton, Warwickshire, England",
    "fsId": "G9YC-17Z",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Alice"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI688",
    "name": "Samuel Albro",
    "sex": "M",
    "gen": 9,
    "slot": 300,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI396",
    "birthYear": 1749,
    "deathYear": 1817,
    "birthDate": "12 Oct 1749",
    "deathDate": "4 Dec 1817",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Exeter, Kings, Rhode Island, British Colonial America",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "L6LN-TZY",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI689",
    "name": "Patience Bull",
    "sex": "F",
    "gen": 9,
    "slot": 301,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI396",
    "birthYear": 1745,
    "deathYear": null,
    "birthDate": "13 Aug 1745",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "South Kingstown, Kings, Rhode Island, British Colonial America",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LTGF-B4Z",
    "photo": "/ancestors/bubbles/0813_LTGF-B4Z.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0813_LTGF-B4Z.jpg"
  },
  {
    "id": "AQI690",
    "name": "Jan John Tice",
    "sex": "M",
    "gen": 9,
    "slot": 302,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI397",
    "birthYear": 1746,
    "deathYear": 1822,
    "birthDate": "1746",
    "deathDate": "29 Mar 1822",
    "burialDate": "2 Apr 1822",
    "christeningDate": null,
    "birthPlace": "Philipsburg Manor, Westchester, New York Colony, British Colonial America",
    "deathPlace": "Schaghticoke, Rensselaer, New York, United States",
    "burialPlace": "Bottskill Baptist Church Cemetery, Greenwich, Washington, New York, United States",
    "christeningPlace": null,
    "fsId": "GV4S-LLP",
    "photo": null,
    "living": false,
    "alternateNames": [
      "John Tice",
      "John Tyse"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI691",
    "name": "Catrina Van Tassel",
    "sex": "F",
    "gen": 9,
    "slot": 303,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI397",
    "birthYear": 1748,
    "deathYear": 1816,
    "birthDate": "25 Sep 1748",
    "deathDate": "29 Mar 1816",
    "burialDate": "2 Apr 1816",
    "christeningDate": "25 Oct 1748",
    "birthPlace": "Philipsburg Manor, Westchester, New York Colony, British Colonial America",
    "deathPlace": "Greenwich, Washington, New York, United States",
    "burialPlace": "Bottskill Baptist Church Cemetery, Greenwich, Washington, New York, United States",
    "christeningPlace": "Tarrytown, Greenburgh, Westchester, New York, United States",
    "fsId": "GSNM-L1J",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Catriena, Tice, van Tassel ( Tys)",
      "Catriena Tys Van Tassel",
      "Catrina Van Texel"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI692",
    "name": "Johann Franciscus Moser",
    "sex": "M",
    "gen": 9,
    "slot": 328,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI398",
    "birthYear": 1733,
    "deathYear": 1799,
    "birthDate": "10 Jun 1733",
    "deathDate": "Abt 1799",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "District Township, Berks, Pennsylvania, United States",
    "deathPlace": "Earl Township, Berks, Pennsylvania, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "MYYL-BMK",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Johann Franz Moser"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI693",
    "name": "Maria Elizabeth Busch",
    "sex": "F",
    "gen": 9,
    "slot": 329,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI398",
    "birthYear": 1740,
    "deathYear": 1790,
    "birthDate": "2 Aug 1740",
    "deathDate": "18 Jan 1790",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Berks, Pennsylvania, British Colonial America",
    "deathPlace": "Earl Township, Berks, Pennsylvania, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LWXR-37S",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Maria Elizabetha Busch",
      "Mrs Maria Elisabeth Moser"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI694",
    "name": "Jacob Endy",
    "sex": "M",
    "gen": 9,
    "slot": 330,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI399",
    "birthYear": 1736,
    "deathYear": 1788,
    "birthDate": "1736",
    "deathDate": "25 Feb 1788",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Germany",
    "deathPlace": "Earl Township, Berks, Pennsylvania, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "K2Q6-V2H",
    "photo": "/ancestors/bubbles/0842_K2Q6-V2H.jpg",
    "living": false,
    "alternateNames": [
      "Jacob ENDI (Ende)",
      "Endy or Enty"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0842_K2Q6-V2H.jpg"
  },
  {
    "id": "AQI695",
    "name": "Anna Maria Knohr",
    "sex": "F",
    "gen": 9,
    "slot": 331,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI399",
    "birthYear": 1737,
    "deathYear": 1780,
    "birthDate": "27 Jan 1737",
    "deathDate": "12 Mar 1780",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Nürtingen, Esslingen, Baden-Württemberg, Germany",
    "deathPlace": "Berks, Pennsylvania, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LZ86-43N",
    "photo": "/ancestors/bubbles/0843_LZ86-43N.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0843_LZ86-43N.jpg"
  },
  {
    "id": "AQI696",
    "name": "Elias Wygandt",
    "sex": "M",
    "gen": 9,
    "slot": 332,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI400",
    "birthYear": 1721,
    "deathYear": 1807,
    "birthDate": "3 Apr 1721",
    "deathDate": "Oct 1807",
    "burialDate": "Oct 1807",
    "christeningDate": "6 Apr 1721",
    "birthPlace": "Freinsheim, Bad Dürkheim, Rhineland-Palatinate, Germany",
    "deathPlace": "New Hanover, New Hanover Township, Montgomery, Pennsylvania, United States",
    "burialPlace": "Falkner Swamp Reformed Church Cemetery, New Hanover Township, Montgomery, Pennsylvania, United States",
    "christeningPlace": "Freinsheim, Bad Dürkheim, Rhineland-Palatinate, Germany",
    "fsId": "LZJY-8X1",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI697",
    "name": "Jacobaea Scharlotta Reck",
    "sex": "F",
    "gen": 9,
    "slot": 333,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI400",
    "birthYear": 1730,
    "deathYear": null,
    "birthDate": "9 May 1730",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "14 May 1730",
    "birthPlace": "Freinsheim, Bad Dürkheim, Rhineland-Palatinate, Germany",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Palatinate, Bavaria, Germany",
    "fsId": "MYYB-FFM",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI698",
    "name": "Adam Hatfield",
    "sex": "M",
    "gen": 9,
    "slot": 336,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI402",
    "birthYear": 1720,
    "deathYear": 1752,
    "birthDate": "1720",
    "deathDate": "1752",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Washington, Pennsylvania, United States",
    "deathPlace": "Bullskin Township, Fayette, Pennsylvania, United States",
    "burialPlace": "Augustus Lutheran Church Cemetery, Trappe, Montgomery, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "L6JB-XG6",
    "photo": "/ancestors/bubbles/0848_L6JB-XG6.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0848_L6JB-XG6.jpg"
  },
  {
    "id": "AQI699",
    "name": "Martha Cleaver",
    "sex": "F",
    "gen": 9,
    "slot": 337,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI402",
    "birthYear": 1726,
    "deathYear": 1758,
    "birthDate": "1726",
    "deathDate": "Abt 1758",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Pennsylvania, British Colonial America",
    "deathPlace": "Berks, Pennsylvania, British Colonial America",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "GRP5-B9W",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI700",
    "name": "Henry Yergey",
    "sex": "M",
    "gen": 9,
    "slot": 338,
    "side": "maternal",
    "birthplace": "unknown",
    "childId": "AQI403",
    "birthYear": 1727,
    "deathYear": 1814,
    "birthDate": "1727",
    "deathDate": "1814",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "GZ7F-BLL",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI701",
    "name": "Mary A Hatfield",
    "sex": "F",
    "gen": 9,
    "slot": 339,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI403",
    "birthYear": 1801,
    "deathYear": null,
    "birthDate": "1801",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Pennsylvania, United States",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "GZ7N-988",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI702",
    "name": "Carl Geiger",
    "sex": "M",
    "gen": 9,
    "slot": 340,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI404",
    "birthYear": 1749,
    "deathYear": 1828,
    "birthDate": "2 Aug 1749",
    "deathDate": "May 1828",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "New Hanover Township, Philadelphia, Pennsylvania, British Colonial America",
    "deathPlace": "Pottsgrove Township, Montgomery, Pennsylvania, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "KHQL-C3J",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Charles ( Carl) Geiger",
      "Charles Geiger",
      "Chas Geiger",
      "Johann Carl Geiger"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI703",
    "name": "Anna Maria Mary Dilbone",
    "sex": "F",
    "gen": 9,
    "slot": 341,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI404",
    "birthYear": 1757,
    "deathYear": 1795,
    "birthDate": "Abt 1757",
    "deathDate": "Abt 1795",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Rockland Township, Berks, Pennsylvania, United States",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "KH1F-PG3",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Anna Maria Dilbon",
      "Ann Maria\" Mary\" Dilbone"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI704",
    "name": "Andreas Schoener",
    "sex": "M",
    "gen": 9,
    "slot": 342,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI405",
    "birthYear": 1749,
    "deathYear": 1806,
    "birthDate": "31 Jul 1749",
    "deathDate": "10 May 1806",
    "burialDate": "1806",
    "christeningDate": "26 Sep 1749",
    "birthPlace": "New Hanover Township, Philadelphia, Pennsylvania, United States",
    "deathPlace": "Pottstown, Montgomery, Pennsylvania, United States",
    "burialPlace": "Zion Reformed Church Cemetery, Pottstown, Montgomery, Pennsylvania, United States",
    "christeningPlace": "New Hanover Township, Philadelphia, Pennsylvania, United States",
    "fsId": "LHTQ-ZJV",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Andreas",
      "Andreas Jr. Schoener",
      "Andreas or Andrew Shoner",
      "Andreas Schoner",
      "Andrew",
      "Andreas or Andrew Schoener or Shaner Jr",
      "Andreas (Andrew) Schoener"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI705",
    "name": "Julianna Reifschneider",
    "sex": "F",
    "gen": 9,
    "slot": 343,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI405",
    "birthYear": 1749,
    "deathYear": 1830,
    "birthDate": "28 Oct 1749",
    "deathDate": "28 Apr 1830",
    "burialDate": "1830",
    "christeningDate": null,
    "birthPlace": "New Hanover Township, Philadelphia, Pennsylvania, United States",
    "deathPlace": "Pottstown, Montgomery, Pennsylvania, United States",
    "burialPlace": "Zion Reformed Church Cemetery, Pottstown, Montgomery, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LVKT-8N3",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI706",
    "name": "Jacob Liebengut",
    "sex": "M",
    "gen": 9,
    "slot": 344,
    "side": "maternal",
    "birthplace": "france",
    "childId": "AQI406",
    "birthYear": 1721,
    "deathYear": 1784,
    "birthDate": "8 Jun 1721",
    "deathDate": "15 Jan 1784",
    "burialDate": null,
    "christeningDate": "8 Jun 1721",
    "birthPlace": "Langensoultzbach, Bas-Rhin, France",
    "deathPlace": "Berks, Pennsylvania, United States",
    "burialPlace": "Emmanuel Lutheran Old Burial Ground, Pottstown, Montgomery, Pennsylvania, United States",
    "christeningPlace": "Langensoultzbach, Bas-Rhin, France",
    "fsId": "K19W-D3H",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Hans Jacob Levengood",
      "Hans Jacob Livengood"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI707",
    "name": "Christine Brand",
    "sex": "F",
    "gen": 9,
    "slot": 345,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI406",
    "birthYear": 1723,
    "deathYear": 1800,
    "birthDate": "18 Nov 1723",
    "deathDate": "12 Aug 1800",
    "burialDate": "Aug 1800",
    "christeningDate": null,
    "birthPlace": "Douglass Township, Philadelphia, Pennsylvania, British Colonial America",
    "deathPlace": "Berks, Pennsylvania, United States",
    "burialPlace": "Pottstown, Montgomery, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "GS66-2P4",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Christine Gansertine",
      "Christina Gansert",
      "Christina Conser",
      "Christiana Brand"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI708",
    "name": "Johannes Becker",
    "sex": "M",
    "gen": 9,
    "slot": 346,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI407",
    "birthYear": 1735,
    "deathYear": 1811,
    "birthDate": "22 Mar 1735",
    "deathDate": "23 Jan 1811",
    "burialDate": "Jan 1811",
    "christeningDate": "27 Mar 1735",
    "birthPlace": "Siegen, Siegen-Wittgenstein, North Rhine-Westphalia, Germany",
    "deathPlace": "Douglass Township, Berks, Pennsylvania, United States",
    "burialPlace": "Pottstown, Montgomery, Pennsylvania, United States",
    "christeningPlace": "Siegen, Westphalia, Prussia, Germany",
    "fsId": "GXPD-8MH",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Baker",
      "Beacher",
      "John Becher",
      "Johannes (\"John\") Bechtel",
      "John Becker"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI709",
    "name": "Catherine Levengood",
    "sex": "F",
    "gen": 9,
    "slot": 347,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI407",
    "birthYear": 1745,
    "deathYear": 1817,
    "birthDate": "16 Apr 1745",
    "deathDate": "3 Jan 1817",
    "burialDate": null,
    "christeningDate": "3 Jun 1775",
    "birthPlace": "Douglass Township, Berks, Pennsylvania, United States",
    "deathPlace": "Douglass Township, Berks, Pennsylvania, United States",
    "burialPlace": "Pottstown, Montgomery, Pennsylvania, United States",
    "christeningPlace": "York, Pennsylvania, British Colonial America",
    "fsId": "GXP5-33M",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Christina Liebengut",
      "Katharina Liebengut"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI710",
    "name": "George Klingman Bechtel",
    "sex": "M",
    "gen": 9,
    "slot": 348,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI408",
    "birthYear": 1744,
    "deathYear": 1818,
    "birthDate": "12 Nov 1744",
    "deathDate": "29 Apr 1818",
    "burialDate": "1 May 1818",
    "christeningDate": null,
    "birthPlace": "Douglass Township, Berks, Pennsylvania, British Colonial America",
    "deathPlace": "Pottsgrove, Lower Pottsgrove Township, Montgomery, Pennsylvania, United States",
    "burialPlace": "Pottstown, Montgomery, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LZKR-G2L",
    "photo": null,
    "living": false,
    "alternateNames": [
      "George Bechtel",
      "George K. Bechtel"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI711",
    "name": "Hannah Yocum",
    "sex": "F",
    "gen": 9,
    "slot": 349,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI408",
    "birthYear": 1748,
    "deathYear": 1822,
    "birthDate": "12 Jan 1748",
    "deathDate": "13 Oct 1822",
    "burialDate": null,
    "christeningDate": "4 Dec 1748",
    "birthPlace": "Douglass Township, Berks, Pennsylvania, British Colonial America",
    "deathPlace": "Pottstown, Montgomery, Pennsylvania, United States",
    "burialPlace": "Pottstown, Montgomery, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LZJV-97S",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Hannah Yokom",
      "Hannah Yocom",
      "Hannah"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI712",
    "name": "Johannes Swinehart",
    "sex": "M",
    "gen": 9,
    "slot": 350,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI409",
    "birthYear": 1735,
    "deathYear": 1798,
    "birthDate": "1735",
    "deathDate": "12 Feb 1798",
    "burialDate": "1798",
    "christeningDate": null,
    "birthPlace": "Nesselbach, Langenburg, Schwäbisch Hall, Baden-Württemberg, Germany",
    "deathPlace": "Knauertown, East Nantmeal Township, Chester, Pennsylvania, United States",
    "burialPlace": "Knauertown, East Nantmeal Township, Chester, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LV6N-RVW",
    "photo": "/ancestors/bubbles/0862_LV6N-RVW.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0862_LV6N-RVW.jpg"
  },
  {
    "id": "AQI713",
    "name": "Johanna Reichart",
    "sex": "F",
    "gen": 9,
    "slot": 351,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI409",
    "birthYear": 1739,
    "deathYear": 1800,
    "birthDate": "Abt 1739",
    "deathDate": "Aft 1800",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Montgomery, Pennsylvania, United States",
    "deathPlace": "Montgomery, Pennsylvania, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LV6N-LC9",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Johanna Richards",
      "Hanna"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI714",
    "name": "Heinrich Heilmann",
    "sex": "M",
    "gen": 9,
    "slot": 360,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI410",
    "birthYear": 1716,
    "deathYear": 1803,
    "birthDate": "14 May 1716",
    "deathDate": "10 Oct 1803",
    "burialDate": "Oct 1803",
    "christeningDate": null,
    "birthPlace": "Lower Saxony, Germany",
    "deathPlace": "Skippack, Skippack Township, Montgomery, Pennsylvania, United States",
    "burialPlace": "Lower Skippack Mennonite Cemetery, Skippack, Skippack Township, Montgomery, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LVM6-SMF",
    "photo": "/ancestors/bubbles/0872_LVM6-SMF.jpg",
    "living": false,
    "alternateNames": [
      "Henrich Heilman",
      "Henry Hallman"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0872_LVM6-SMF.jpg"
  },
  {
    "id": "AQI715",
    "name": "Anna Maria Bersons",
    "sex": "F",
    "gen": 9,
    "slot": 361,
    "side": "maternal",
    "birthplace": "austria",
    "childId": "AQI410",
    "birthYear": 1734,
    "deathYear": 1792,
    "birthDate": "5 Oct 1734",
    "deathDate": "5 Dec 1792",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Groß, Hollabrunn, Lower Austria, Austria",
    "deathPlace": "Montgomery, Lycoming, Pennsylvania, United States",
    "burialPlace": "Skippack, Skippack Township, Montgomery, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "9NH2-Z3D",
    "photo": "/ancestors/bubbles/0873_9NH2-Z3D.jpg",
    "living": false,
    "alternateNames": [
      "Anna Maria Berson",
      "Anna Maria Burson"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0873_9NH2-Z3D.jpg"
  },
  {
    "id": "AQI716",
    "name": "Frederich Kuntz",
    "sex": "M",
    "gen": 9,
    "slot": 362,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI411",
    "birthYear": 1744,
    "deathYear": 1823,
    "birthDate": "6 Jul 1744",
    "deathDate": "19 Aug 1823",
    "burialDate": "1823",
    "christeningDate": null,
    "birthPlace": "Frederick Township, Philadelphia, Pennsylvania, British Colonial America",
    "deathPlace": "Linfield, Limerick Township, Montgomery, Pennsylvania, United States",
    "burialPlace": "Frederick Township, Montgomery, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LT1P-5G9",
    "photo": "/ancestors/bubbles/0874_LT1P-5G9.jpg",
    "living": false,
    "alternateNames": [
      "Kuntz"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0874_LT1P-5G9.jpg"
  },
  {
    "id": "AQI717",
    "name": "Mary Kendall",
    "sex": "F",
    "gen": 9,
    "slot": 363,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI411",
    "birthYear": 1750,
    "deathYear": 1825,
    "birthDate": "7 Apr 1750",
    "deathDate": "31 Jul 1825",
    "burialDate": "1825",
    "christeningDate": null,
    "birthPlace": "Linfield, Limerick Township, Montgomery, Pennsylvania, United States",
    "deathPlace": "Linfield, Limerick Township, Montgomery, Pennsylvania, United States",
    "burialPlace": "Frederick Township, Montgomery, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LX1V-V8C",
    "photo": "/ancestors/bubbles/0875_LX1V-V8C.jpg",
    "living": false,
    "alternateNames": [
      "Maria Or Mary Kendall",
      "Marie",
      "Maria Kendel"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0875_LX1V-V8C.jpg"
  },
  {
    "id": "AQI718",
    "name": "Samuel Sands",
    "sex": "M",
    "gen": 9,
    "slot": 366,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI413",
    "birthYear": 1736,
    "deathYear": 1792,
    "birthDate": "13 Jun 1736",
    "deathDate": "12 Feb 1792",
    "burialDate": "1792",
    "christeningDate": null,
    "birthPlace": "Amityville, Amity Township, Berks, Pennsylvania, United States",
    "deathPlace": "Montgomery, Pennsylvania, United States",
    "burialPlace": "Emmanuel Lutheran Old Burial Ground, Pottstown, Montgomery, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "KNHP-73T",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Samuel"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI719",
    "name": "Catharine Klingman Bechtel",
    "sex": "F",
    "gen": 9,
    "slot": 367,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI413",
    "birthYear": 1745,
    "deathYear": 1813,
    "birthDate": "15 Jul 1745",
    "deathDate": "17 Oct 1813",
    "burialDate": "1813",
    "christeningDate": "5 Jul 1745",
    "birthPlace": "Montgomery Township, Philadelphia, Pennsylvania, British Colonial America",
    "deathPlace": "Montgomery, Pennsylvania, United States",
    "burialPlace": "Emmanuel Lutheran Old Burial Ground, Pottstown, Montgomery, Pennsylvania, United States",
    "christeningPlace": "Gilbertsville, Douglass Township, Philadelphia, Pennsylvania, British Colonial America",
    "fsId": "KNHP-GZB",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Catharine",
      "Catharine Bechtol",
      "Catherine Bechtel",
      "Catherine Bechtel Sands",
      "Catherine Betchel",
      "Cathering Bechtol",
      "Katharine Bechtel",
      "Mrs. Catherine Sands",
      "Catharine Betchel"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI720",
    "name": "William Hartranft",
    "sex": "M",
    "gen": 9,
    "slot": 368,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI414",
    "birthYear": 1764,
    "deathYear": 1797,
    "birthDate": "23 Nov 1764",
    "deathDate": "From 1797 to 1830",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Oley Township, Berks, Pennsylvania, British Colonial America",
    "deathPlace": "Oley Township, Berks, Pennsylvania, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "2JQQ-V6M",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI721",
    "name": "Anna Hartranft",
    "sex": "F",
    "gen": 9,
    "slot": 369,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI414",
    "birthYear": 1769,
    "deathYear": 1862,
    "birthDate": "Bef 1769",
    "deathDate": "15 Jul 1862",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Oley Township, Berks, Pennsylvania, British Colonial America",
    "deathPlace": "Oley Township, Berks, Pennsylvania, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "KZS8-RBJ",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI722",
    "name": "Henry Heinrich Davidheiser",
    "sex": "M",
    "gen": 9,
    "slot": 372,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI416",
    "birthYear": 1735,
    "deathYear": 1797,
    "birthDate": "Abt 1735",
    "deathDate": "Abt 1797",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Germany",
    "deathPlace": "Berks, Pennsylvania, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "GBPJ-QP9",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Henry Debertshauser",
      "Heinrich Deberthauser"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI723",
    "name": "Anna Catharina Lichty",
    "sex": "F",
    "gen": 9,
    "slot": 373,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI416",
    "birthYear": 1735,
    "deathYear": 1795,
    "birthDate": "16 May 1735",
    "deathDate": "25 Nov 1795",
    "burialDate": "1795",
    "christeningDate": null,
    "birthPlace": "Pennsylvania, United States",
    "deathPlace": "Berks, Pennsylvania, United States",
    "burialPlace": "New Hanover Township, Montgomery, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "9V41-25G",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI724",
    "name": "Adam Weidner",
    "sex": "M",
    "gen": 9,
    "slot": 374,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI417",
    "birthYear": 1739,
    "deathYear": 1776,
    "birthDate": "1739",
    "deathDate": "5 Nov 1776",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Philadelphia, Pennsylvania, United States",
    "deathPlace": "Robeson Township, Berks, Pennsylvania, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LH8J-8YC",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Johan Adam Weidner",
      "Hans Adam Weidner"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI725",
    "name": "Anna Maria Walter",
    "sex": "F",
    "gen": 9,
    "slot": 375,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI417",
    "birthYear": 1746,
    "deathYear": null,
    "birthDate": "23 Jun 1746",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "Aug 1746",
    "birthPlace": "New Hanover, New Hanover Township, Montgomery, Pennsylvania, United States",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "New Hanover Township, Montgomery, Pennsylvania, United States",
    "fsId": "MR1D-M1Q",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Mary Walther"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI728",
    "name": "Joh. Heinrich Freyer",
    "sex": "M",
    "gen": 9,
    "slot": 376,
    "side": "maternal",
    "birthplace": "holy-roman-empire",
    "childId": "AQI418",
    "birthYear": 1717,
    "deathYear": 1813,
    "birthDate": "24 Dec 1717",
    "deathDate": "4 Oct 1813",
    "burialDate": "1813",
    "christeningDate": null,
    "birthPlace": "Holy Roman Empire",
    "deathPlace": "New Hanover Township, Philadelphia, Pennsylvania, United States",
    "burialPlace": "Gilbertsville, Douglass Township, Montgomery, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "L5XK-XSZ",
    "photo": "/ancestors/bubbles/0888_L5XK-XSZ.jpg",
    "living": false,
    "alternateNames": [
      "Henry Freyer"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0888_L5XK-XSZ.jpg"
  },
  {
    "id": "AQI729",
    "name": "Maria Catharina Kurtz Hilbard",
    "sex": "F",
    "gen": 9,
    "slot": 377,
    "side": "maternal",
    "birthplace": "unknown",
    "childId": "AQI418",
    "birthYear": 1720,
    "deathYear": 1814,
    "birthDate": "Dec 1720",
    "deathDate": "Oct 1814",
    "burialDate": "Oct 1814",
    "christeningDate": null,
    "birthPlace": null,
    "deathPlace": "New Hanover Township, Montgomery, Pennsylvania, United States",
    "burialPlace": "Swamp Lutheran Church Cemetery, New Hanover Township, Montgomery, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "L5XK-9BB",
    "photo": "/ancestors/bubbles/0889_L5XK-9BB.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0889_L5XK-9BB.jpg"
  },
  {
    "id": "AQI730",
    "name": "George Sebastian Eichelberger",
    "sex": "M",
    "gen": 9,
    "slot": 378,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI419",
    "birthYear": 1721,
    "deathYear": 1777,
    "birthDate": "10 Feb 1721",
    "deathDate": "3 Mar 1777",
    "burialDate": null,
    "christeningDate": "17 Feb 1721",
    "birthPlace": "Rhineland-Palatinate, Germany",
    "deathPlace": "New Hanover Township, Philadelphia, Pennsylvania, United States",
    "burialPlace": "Philadelphia, Pennsylvania, United States",
    "christeningPlace": "Leistadt, Bad Dürkheim, Bezirksamt Neustadt, Bavaria, Germany",
    "fsId": "K2NL-S31",
    "photo": "/ancestors/bubbles/0890_K2NL-S31.jpg",
    "living": false,
    "alternateNames": [
      "Georg Sebastian Eichenberger",
      "Sebastian Eigelberger",
      "Bastian Eigelberger",
      "George Sebastian Eikelberger",
      "Eichelberger"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0890_K2NL-S31.jpg"
  },
  {
    "id": "AQI731",
    "name": "Anna Catharina Hauserin or Hauser",
    "sex": "F",
    "gen": 9,
    "slot": 379,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI419",
    "birthYear": 1714,
    "deathYear": 1800,
    "birthDate": "27 Oct 1714",
    "deathDate": "1800",
    "burialDate": null,
    "christeningDate": "28 Oct 1714",
    "birthPlace": "Palatinate, Bavaria, Germany",
    "deathPlace": "Montgomery, Pennsylvania, United States",
    "burialPlace": null,
    "christeningPlace": "Palatinate, Bavaria, Germany",
    "fsId": "LRMZ-YX7",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Eichelberger",
      "Anna Catharina Hausser"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI732",
    "name": "Peter Möck",
    "sex": "M",
    "gen": 9,
    "slot": 384,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI422",
    "birthYear": 1727,
    "deathYear": 1812,
    "birthDate": "1 May 1727",
    "deathDate": "3 Apr 1812",
    "burialDate": "Apr 1812",
    "christeningDate": null,
    "birthPlace": "Württemberg",
    "deathPlace": "Taneytown, Carroll, Maryland, United States",
    "burialPlace": "Baust Cemetery, Carroll, Maryland, United States",
    "christeningPlace": null,
    "fsId": "LNJY-PD4",
    "photo": "/ancestors/bubbles/0896_LNJY-PD4.jpg",
    "living": false,
    "alternateNames": [
      "Peter Mock"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0896_LNJY-PD4.jpg"
  },
  {
    "id": "AQI733",
    "name": "Mary Magdalena Erb",
    "sex": "F",
    "gen": 9,
    "slot": 385,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI422",
    "birthYear": 1734,
    "deathYear": 1780,
    "birthDate": "1734",
    "deathDate": "1780",
    "burialDate": "1780",
    "christeningDate": "15 Aug 1756",
    "birthPlace": "Palatinate, Bavaria, Germany",
    "deathPlace": "Silver Run, Carroll, Maryland, United States",
    "burialPlace": "Saint Marys Cemetery, Silver Run, Carroll, Maryland, United States",
    "christeningPlace": "North Codorus Township, York, Pennsylvania, United States",
    "fsId": "L4QL-J59",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI735",
    "name": "Cunningham Sample",
    "sex": "M",
    "gen": 9,
    "slot": 386,
    "side": "maternal",
    "birthplace": "scotland",
    "childId": "AQI423",
    "birthYear": 1723,
    "deathYear": 1803,
    "birthDate": "2 May 1723",
    "deathDate": "13 Oct 1803",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Renfrew, Renfrewshire, Scotland, United Kingdom",
    "deathPlace": "Peach Bottom Township, York, Pennsylvania, United States",
    "burialPlace": "Slate Ridge Cemetery, Delta, York, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LZ5T-D3J",
    "photo": "/ancestors/bubbles/0898_LZ5T-D3J.jpg",
    "living": false,
    "alternateNames": [
      "Cunningham Semple",
      "Esquire Cunningham Sample"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0898_LZ5T-D3J.jpg"
  },
  {
    "id": "AQI736",
    "name": "Agnes Welch",
    "sex": "F",
    "gen": 9,
    "slot": 387,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI423",
    "birthYear": 1730,
    "deathYear": 1783,
    "birthDate": "1 May 1730",
    "deathDate": "18 Oct 1783",
    "burialDate": "1783",
    "christeningDate": null,
    "birthPlace": "York, York, Pennsylvania, British Colonial America",
    "deathPlace": "Delta, York, Pennsylvania, British Colonial America",
    "burialPlace": "Slate Ridge Cemetery, Delta, York, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "K2YT-M1W",
    "photo": "/ancestors/bubbles/0899_K2YT-M1W.jpg",
    "living": false,
    "alternateNames": [
      "Agnes Welcher",
      "Mrs. Agnes Sample"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0899_K2YT-M1W.jpg"
  },
  {
    "id": "AQI737",
    "name": "Johann Heinrich Christ",
    "sex": "M",
    "gen": 9,
    "slot": 392,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI424",
    "birthYear": 1721,
    "deathYear": 1789,
    "birthDate": "27 Jan 1721",
    "deathDate": "13 Aug 1789",
    "burialDate": "Aug 1789",
    "christeningDate": null,
    "birthPlace": "York, Pennsylvania, British Colonial America",
    "deathPlace": "Reading, Berks, Pennsylvania, United States",
    "burialPlace": "Trinity Lutheran Church Cemetery, Reading, Berks, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LHKW-K6R",
    "photo": "/ancestors/bubbles/0904_LHKW-K6R.jpg",
    "living": false,
    "alternateNames": [
      "Johann Heinrich Jr Christ",
      "Johan Heinrich Christ",
      "Heinrich Christ",
      "Hendrick Christ",
      "Johannes Heinrich Christ"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0904_LHKW-K6R.jpg"
  },
  {
    "id": "AQI738",
    "name": "Appolonia Richter",
    "sex": "F",
    "gen": 9,
    "slot": 393,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI424",
    "birthYear": 1721,
    "deathYear": 1805,
    "birthDate": "30 Jan 1721",
    "deathDate": "8 Jul 1805",
    "burialDate": "Jul 1805",
    "christeningDate": "30 Jan 1721",
    "birthPlace": "Germany",
    "deathPlace": "Reading, Berks, Pennsylvania, United States",
    "burialPlace": "Trinity Lutheran Church Cemetery, Reading, Berks, Pennsylvania, United States",
    "christeningPlace": "Bas-Rhin, France",
    "fsId": "KVG3-D3P",
    "photo": "/ancestors/bubbles/0905_KVG3-D3P.jpg",
    "living": false,
    "alternateNames": [
      "Appolonia Richert",
      "Appollonia Richter",
      "Appalonia Richter",
      "Mrs. Henry Christ"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0905_KVG3-D3P.jpg"
  },
  {
    "id": "AQI739",
    "name": "Johann Jacob Shoemaker",
    "sex": "M",
    "gen": 9,
    "slot": 394,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI425",
    "birthYear": 1730,
    "deathYear": 1783,
    "birthDate": "3 Oct 1730",
    "deathDate": "13 Sep 1783",
    "burialDate": "Oct 1783",
    "christeningDate": "7 Oct 1730",
    "birthPlace": "Landkreis Zweibrücken, Rhineland-Palatinate, Germany",
    "deathPlace": "Reading, Berks, Pennsylvania, United States",
    "burialPlace": "Reading, Berks, Pennsylvania, United States",
    "christeningPlace": "Palatinate, Bavaria, Germany",
    "fsId": "LKLL-8BG",
    "photo": "/ancestors/bubbles/0906_LKLL-8BG.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0906_LKLL-8BG.jpg"
  },
  {
    "id": "AQI740",
    "name": "Maria Magdalena Loescher",
    "sex": "F",
    "gen": 9,
    "slot": 395,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI425",
    "birthYear": 1739,
    "deathYear": 1773,
    "birthDate": "1739",
    "deathDate": "1773",
    "burialDate": null,
    "christeningDate": "21 Feb 1757",
    "birthPlace": "Zweibrücken, Rhineland-Palatinate, Germany",
    "deathPlace": "Berks, Pennsylvania, United States",
    "burialPlace": null,
    "christeningPlace": "Moselem, Richmond Township, Berks, Pennsylvania, United States",
    "fsId": "MRZ8-TB7",
    "photo": "/ancestors/bubbles/0907_MRZ8-TB7.jpg",
    "living": false,
    "alternateNames": [
      "Maria Magdalena Shoemaker",
      "Maria Magdalena Schumacker",
      "Maria Magdalena Lescher"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0907_MRZ8-TB7.jpg"
  },
  {
    "id": "AQI741",
    "name": "Joseph William Hann",
    "sex": "M",
    "gen": 9,
    "slot": 396,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI426",
    "birthYear": 1720,
    "deathYear": 1780,
    "birthDate": "1720",
    "deathDate": "2 Jul 1780",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Frankfurt, Hesse, Germany",
    "deathPlace": "Carroll, Maryland, United States",
    "burialPlace": "Taneytown, Carroll, Maryland, United States",
    "christeningPlace": null,
    "fsId": "G9ZQ-LQV",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI742",
    "name": "Margerette Dorthea Bischoff",
    "sex": "F",
    "gen": 9,
    "slot": 397,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI426",
    "birthYear": 1720,
    "deathYear": 1796,
    "birthDate": "Abt 1720",
    "deathDate": "1796",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Frankfurt, Hesse, Germany",
    "deathPlace": "Taneytown, Carroll, Maryland, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "G9ZQ-W7Q",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Margarette Dorthea Bischoff",
      "Margarette Bischoff Hann"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI743",
    "name": "Johann Michael Burger",
    "sex": "M",
    "gen": 9,
    "slot": 400,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI428",
    "birthYear": 1745,
    "deathYear": 1800,
    "birthDate": "5 Mar 1745",
    "deathDate": "Abt 1800",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Ottersweier, Rastatt, Baden-Württemberg, Germany",
    "deathPlace": "Maryland, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LC86-K85",
    "photo": "/ancestors/bubbles/0912_LC86-K85.jpg",
    "living": false,
    "alternateNames": [
      "Johannes Hans Michel Burger"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0912_LC86-K85.jpg"
  },
  {
    "id": "AQI744",
    "name": "Anna Catharina Schele",
    "sex": "F",
    "gen": 9,
    "slot": 401,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI428",
    "birthYear": 1745,
    "deathYear": 1804,
    "birthDate": "Abt 1745",
    "deathDate": "21 Nov 1804",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Hochsauerlandkreis, North Rhine-Westphalia, Germany",
    "deathPlace": "Johnson, Georgia, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "K1VK-9GT",
    "photo": "/ancestors/bubbles/0913_K1VK-9GT.jpg",
    "living": false,
    "alternateNames": [
      "Anna Burger"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0913_K1VK-9GT.jpg"
  },
  {
    "id": "AQI745",
    "name": "George Puterbaugh",
    "sex": "M",
    "gen": 9,
    "slot": 402,
    "side": "maternal",
    "birthplace": "holy-roman-empire",
    "childId": "AQI429",
    "birthYear": 1735,
    "deathYear": 1800,
    "birthDate": "Abt 1735",
    "deathDate": "21 Sep 1800",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Holy Roman Empire",
    "deathPlace": "Woodbury Township, Bedford, Pennsylvania, United States",
    "burialPlace": "Sacfest Cemetery, Montgomery Township, Franklin, Ohio, United States",
    "christeningPlace": null,
    "fsId": "LZV4-R27",
    "photo": "/ancestors/bubbles/0914_LZV4-R27.jpg",
    "living": false,
    "alternateNames": [
      "George Puderbaugh",
      "George Pooderbach",
      "George Butterbaugh",
      "Georg Puderbach"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0914_LZV4-R27.jpg"
  },
  {
    "id": "AQI746",
    "name": "Christina Adam",
    "sex": "F",
    "gen": 9,
    "slot": 403,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI429",
    "birthYear": 1736,
    "deathYear": 1814,
    "birthDate": "17 Aug 1736",
    "deathDate": "14 Oct 1814",
    "burialDate": "Oct 1814",
    "christeningDate": "5 Sep 1736",
    "birthPlace": "Lancaster, Pennsylvania, British Colonial America",
    "deathPlace": "Montgomery Township, Franklin, Pennsylvania, United States",
    "burialPlace": "Secrest Cemetery, Franklin, Pennsylvania, United States",
    "christeningPlace": "Bowmansville, Brecknock Township, Lancaster, Pennsylvania, British Colonial America",
    "fsId": "LV96-S56",
    "photo": "/ancestors/bubbles/0915_LV96-S56.jpg",
    "living": false,
    "alternateNames": [
      "Christina Schweikhardt Adam Puterbaugh"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0915_LV96-S56.jpg"
  },
  {
    "id": "AQI747",
    "name": "Jacob Bachman Zug",
    "sex": "M",
    "gen": 9,
    "slot": 408,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI431",
    "birthYear": 1724,
    "deathYear": 1792,
    "birthDate": "24 Jan 1724",
    "deathDate": "17 Jan 1792",
    "burialDate": "1792",
    "christeningDate": null,
    "birthPlace": "Heidelberg, Baden",
    "deathPlace": "Fairplay, Washington, Maryland, United States",
    "burialPlace": "Washington, Maryland, United States",
    "christeningPlace": null,
    "fsId": "LBH6-TDQ",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI748",
    "name": "Mary Elizabeth Willaner",
    "sex": "F",
    "gen": 9,
    "slot": 409,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI431",
    "birthYear": 1735,
    "deathYear": 1785,
    "birthDate": "1735",
    "deathDate": "1785",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Frederick, Maryland, British Colonial America",
    "deathPlace": "Keedysville, Washington, Maryland, United States",
    "burialPlace": "Mount Hebron Cemetery, Keedysville, Washington, Maryland, United States",
    "christeningPlace": null,
    "fsId": "L78J-Z1L",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI749",
    "name": "Johannes Bentz",
    "sex": "M",
    "gen": 9,
    "slot": 416,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI433",
    "birthYear": 1706,
    "deathYear": 1778,
    "birthDate": "5 Jan 1706",
    "deathDate": "1778",
    "burialDate": null,
    "christeningDate": "5 Jan 1706",
    "birthPlace": "Schopfheim, Lörrach, Baden-Württemberg, Germany",
    "deathPlace": "Manchester Township, York, Pennsylvania, United States",
    "burialPlace": null,
    "christeningPlace": "Schopfheim, Lörrach, Baden-Württemberg, Germany",
    "fsId": "LHDR-SZV",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Philip Wentz",
      "John Philip Wentz",
      "John Pentz",
      "John Pens",
      "John Bentz",
      "Johannes Pentz",
      "Johannes Benz",
      "Johannes Bentz \\ Pens",
      "Johannes Bens",
      "Johannes",
      "Johann Philip Wentz",
      "Johann Pentz",
      "Johann",
      "Johan Pens"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI750",
    "name": "Maria Magdalene Hatt",
    "sex": "F",
    "gen": 9,
    "slot": 417,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI433",
    "birthYear": 1713,
    "deathYear": 1783,
    "birthDate": "1713",
    "deathDate": "13 Jul 1783",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Dover, York, Pennsylvania, United States",
    "deathPlace": "Upper Salford Township, Montgomery, Pennsylvania, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "PSKZ-G4K",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Wintz"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI753",
    "name": "Gottfried Kirschner",
    "sex": "M",
    "gen": 9,
    "slot": 418,
    "side": "maternal",
    "birthplace": "unknown",
    "childId": "AQI434",
    "birthYear": null,
    "deathYear": null,
    "birthDate": null,
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "PQXZ-858",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI754",
    "name": "Elisabeth Schwartz",
    "sex": "F",
    "gen": 9,
    "slot": 419,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI434",
    "birthYear": 1836,
    "deathYear": null,
    "birthDate": "Abt 1836",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Baden, Baden, Baden, Germany",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "9HHN-N8T",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI759",
    "name": "Johann Peter Ickes",
    "sex": "M",
    "gen": 9,
    "slot": 424,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI439",
    "birthYear": 1717,
    "deathYear": 1765,
    "birthDate": "18 Sep 1717",
    "deathDate": "11 Jul 1765",
    "burialDate": "11 Jul 1765",
    "christeningDate": null,
    "birthPlace": "Schoharie, Albany, New York Colony, British Colonial America",
    "deathPlace": "Philadelphia, Pennsylvania, United States",
    "burialPlace": "Swamp Lutheran Church Cemetery, New Hanover Township, Montgomery, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LW7N-5HF",
    "photo": "/ancestors/bubbles/0936_LW7N-5HF.jpg",
    "living": false,
    "alternateNames": [
      "Johannes Ickes",
      "John Peter Ickes",
      "Peter Ickes",
      "John"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0936_LW7N-5HF.jpg"
  },
  {
    "id": "AQI760",
    "name": "Barbara B Fickes",
    "sex": "F",
    "gen": 9,
    "slot": 425,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI439",
    "birthYear": 1718,
    "deathYear": 1808,
    "birthDate": "2 Sep 1718",
    "deathDate": "27 Jan 1808",
    "burialDate": "27 Jan 1808",
    "christeningDate": null,
    "birthPlace": "Limerick Township, Montgomery, Pennsylvania, United States",
    "deathPlace": "Limerick Township, Montgomery, Pennsylvania, United States",
    "burialPlace": "Limerick Township, Montgomery, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LCTR-RQ6",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI761",
    "name": "Johann Jacob Stambach",
    "sex": "M",
    "gen": 9,
    "slot": 426,
    "side": "maternal",
    "birthplace": "france",
    "childId": "AQI440",
    "birthYear": 1719,
    "deathYear": 1800,
    "birthDate": "9 Jan 1719",
    "deathDate": "6 Jun 1800",
    "burialDate": null,
    "christeningDate": "11 Jan 1719",
    "birthPlace": "Alsace, France",
    "deathPlace": "Strasbourg, Bas-Rhin, France",
    "burialPlace": "Moulstown Cemetery, Moulstown, Heidelberg Township, York, Pennsylvania, United States",
    "christeningPlace": "Kutzenhausen, Bas-Rhin, France",
    "fsId": "LHZV-JQ2",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI762",
    "name": "Margaret",
    "sex": "F",
    "gen": 9,
    "slot": 427,
    "side": "maternal",
    "birthplace": "france",
    "childId": "AQI440",
    "birthYear": 1719,
    "deathYear": 1752,
    "birthDate": "Abt 1719",
    "deathDate": "Abt 1752",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "France",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "GXFG-PGV",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Margaret Stambach"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI445",
    "name": "Thomas Oldham",
    "sex": "M",
    "gen": 9,
    "slot": 432,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI441",
    "birthYear": 1748,
    "deathYear": 1812,
    "birthDate": "Abt 1748",
    "deathDate": "26 Sep 1812",
    "burialDate": "Sep 1812",
    "christeningDate": null,
    "birthPlace": "Pennsylvania, British Colonial America",
    "deathPlace": "St. Clair Township, Bedford, Pennsylvania, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "GS1B-2DV",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI446",
    "name": "Elizabeth Rebecca Blackburn",
    "sex": "F",
    "gen": 9,
    "slot": 433,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI441",
    "birthYear": 1753,
    "deathYear": 1785,
    "birthDate": "Abt 1753",
    "deathDate": "18 Aug 1785",
    "burialDate": "Aug 1784",
    "christeningDate": null,
    "birthPlace": "York, Pennsylvania, United States",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "MC4R-QJT",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI764",
    "name": "Thomas C Callihan",
    "sex": "M",
    "gen": 9,
    "slot": 434,
    "side": "maternal",
    "birthplace": "ireland",
    "childId": "AQI442",
    "birthYear": 1757,
    "deathYear": 1841,
    "birthDate": "31 Mar 1757",
    "deathDate": "3 Apr 1841",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Ireland",
    "deathPlace": "Alum Bank, Pleasantville, Bedford, Pennsylvania, United States",
    "burialPlace": "Thomas Callihan Family Cemetery, Alum Bank, Pleasantville, Bedford, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "KLL4-KRV",
    "photo": "/ancestors/bubbles/0946_KLL4-KRV.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0946_KLL4-KRV.jpg"
  },
  {
    "id": "AQI765",
    "name": "Mary Proctor",
    "sex": "F",
    "gen": 9,
    "slot": 435,
    "side": "maternal",
    "birthplace": "england",
    "childId": "AQI442",
    "birthYear": 1759,
    "deathYear": 1839,
    "birthDate": "1759",
    "deathDate": "30 Jan 1839",
    "burialDate": "Feb 1839",
    "christeningDate": null,
    "birthPlace": "England, United Kingdom",
    "deathPlace": "Alum Bank, Pleasantville, Bedford, Pennsylvania, British Colonial America",
    "burialPlace": "St. Clair Township, Allegheny, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "P3M4-T3L",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Mary Brocter",
      "Mary Broctor or Proctor"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI766",
    "name": "Jonathan Bowen",
    "sex": "M",
    "gen": 9,
    "slot": 436,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI443",
    "birthYear": 1756,
    "deathYear": 1822,
    "birthDate": "11 Jun 1756",
    "deathDate": "Bef 11 Oct 1822",
    "burialDate": "Bef 11 Oct 1822",
    "christeningDate": "11 Jun 1756",
    "birthPlace": "Nottingham MM, Chester, Pennsylvania, United States",
    "deathPlace": "St. Clair Township, Bedford, Pennsylvania, United States",
    "burialPlace": "St. Clair Township, Bedford, Pennsylvania, United States",
    "christeningPlace": "Chester, Pennsylvania, British Colonial America",
    "fsId": "LJ2Z-LMV",
    "photo": "/ancestors/bubbles/0948_LJ2Z-LMV.jpg",
    "living": false,
    "alternateNames": [
      "Johnathan Bowen"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0948_LJ2Z-LMV.jpg"
  },
  {
    "id": "AQI767",
    "name": "Ann Blackburn",
    "sex": "F",
    "gen": 9,
    "slot": 437,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI443",
    "birthYear": 1750,
    "deathYear": 1837,
    "birthDate": "1750",
    "deathDate": "1837",
    "burialDate": "1837",
    "christeningDate": null,
    "birthPlace": "York, Pennsylvania, United States",
    "deathPlace": "Bedford, Bedford, Pennsylvania, United States",
    "burialPlace": "Bedford, Bedford, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LHY9-RVN",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI768",
    "name": "Isaac Fisher",
    "sex": "M",
    "gen": 9,
    "slot": 438,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI444",
    "birthYear": 1755,
    "deathYear": 1811,
    "birthDate": "Abt 1755",
    "deathDate": "before about 17 September 1811",
    "burialDate": "Sep 1811",
    "christeningDate": null,
    "birthPlace": "Chester, Pennsylvania, United States",
    "deathPlace": "St. Clair Township, Bedford, Pennsylvania, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "K8HR-4G4",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Issac Fisher"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI769",
    "name": "Elizabeth Morton",
    "sex": "F",
    "gen": 9,
    "slot": 439,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI444",
    "birthYear": 1755,
    "deathYear": 1793,
    "birthDate": "25 Apr 1755",
    "deathDate": "11 May 1793",
    "burialDate": "May 1793",
    "christeningDate": null,
    "birthPlace": "York, Pennsylvania, British Colonial America",
    "deathPlace": "Bedford, Pennsylvania, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "KLBD-JV4",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Elizabeth Fisher"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI778",
    "name": "Michaelis Geyer",
    "sex": "M",
    "gen": 9,
    "slot": 448,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI449",
    "birthYear": 1730,
    "deathYear": 1801,
    "birthDate": "1 Oct 1730",
    "deathDate": "9 Nov 1801",
    "burialDate": null,
    "christeningDate": "2 Oct 1730",
    "birthPlace": "Adenau, Ahrweiler, Rhineland-Palatinate, Germany",
    "deathPlace": "Westmoreland, Pennsylvania, United States",
    "burialPlace": null,
    "christeningPlace": "Adenau, Rhineland, Prussia",
    "fsId": "MJZD-GBH",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Michaelis Geyr"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI779",
    "name": "Maria Anna Michaels",
    "sex": "F",
    "gen": 9,
    "slot": 449,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI449",
    "birthYear": 1727,
    "deathYear": 1783,
    "birthDate": "1727",
    "deathDate": "Mar 1783",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Regierungsbezirk Koblenz, Rhineland-Palatinate, Germany",
    "deathPlace": "Koblenz, Rhineland-Palatinate, Germany",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LTLP-6YM",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Annae Mariae Michaels",
      "Annae Mariae Michels"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI780",
    "name": "Ulrich Snowberger",
    "sex": "M",
    "gen": 9,
    "slot": 464,
    "side": "maternal",
    "birthplace": "unknown",
    "childId": "AQI451",
    "birthYear": null,
    "deathYear": 1811,
    "birthDate": null,
    "deathDate": "21 May 1811",
    "burialDate": null,
    "christeningDate": "10 Jan 1734",
    "birthPlace": null,
    "deathPlace": "Snowberger Cemetery, Roadside, Washington Township, Franklin, Pennsylvania, United States",
    "burialPlace": "Franklin, Pennsylvania, United States",
    "christeningPlace": "Herzogenbuchsee, Bern, Switzerland",
    "fsId": "L1SZ-MJW",
    "photo": "/ancestors/bubbles/0976_L1SZ-MJW.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0976_L1SZ-MJW.jpg"
  },
  {
    "id": "AQI781",
    "name": "Barbara Ingold",
    "sex": "F",
    "gen": 9,
    "slot": 465,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI451",
    "birthYear": 1743,
    "deathYear": 1829,
    "birthDate": "10 Sep 1743",
    "deathDate": "10 Jan 1829",
    "burialDate": "Jan 1829",
    "christeningDate": null,
    "birthPlace": "Waynesboro, Franklin, Pennsylvania, United States",
    "deathPlace": "Waynesboro, Franklin, Pennsylvania, United States",
    "burialPlace": "Waynesboro, Franklin, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LC5P-S32",
    "photo": "/ancestors/bubbles/0977_LC5P-S32.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0977_LC5P-S32.jpg"
  },
  {
    "id": "AQI782",
    "name": "Isaac Eshelman",
    "sex": "M",
    "gen": 9,
    "slot": 466,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI452",
    "birthYear": 1745,
    "deathYear": 1807,
    "birthDate": "6 Dec 1745",
    "deathDate": "9 May 1807",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Rapho Township, Lancaster, Pennsylvania, United States",
    "deathPlace": "Rapho Township, Lancaster, Pennsylvania, United States",
    "burialPlace": "Lancaster, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LHVF-4ZQ",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Jacob Eshleman",
      "Jacob Eshelman",
      "Issac Eshleman",
      "Issac Eshelman",
      "Isaac Eshlemen",
      "Isaac ESHLEMAN Eshleman",
      "Isaac Eshleman",
      "Isaac Eschelman",
      "Isaac Eschlman"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI783",
    "name": "Christiana Stauffer",
    "sex": "F",
    "gen": 9,
    "slot": 467,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI452",
    "birthYear": 1748,
    "deathYear": 1814,
    "birthDate": "21 Jan 1748",
    "deathDate": "17 Feb 1814",
    "burialDate": "Abt 18 Feb 1814",
    "christeningDate": null,
    "birthPlace": "Warwick Township, Lancaster, Pennsylvania, United States",
    "deathPlace": "Rapho Township, Lancaster, Pennsylvania, United States",
    "burialPlace": "Lancaster, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LCQ2-MSR",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI784",
    "name": "Jacob Ludwig Snider",
    "sex": "M",
    "gen": 9,
    "slot": 468,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI453",
    "birthYear": 1732,
    "deathYear": 1790,
    "birthDate": "26 Apr 1732",
    "deathDate": "3 Mar 1790",
    "burialDate": "Mar 1790",
    "christeningDate": null,
    "birthPlace": "Weißenburg in Bayern, Weißenburg-Gunzenhausen, Bavaria, Germany",
    "deathPlace": "Berkeley, West Virginia, United States",
    "burialPlace": "Snider Cemetery, Jones Springs, Berkeley, West Virginia, United States",
    "christeningPlace": null,
    "fsId": "K698-K5G",
    "photo": "/ancestors/bubbles/0980_K698-K5G.jpg",
    "living": false,
    "alternateNames": [
      "Jacob Snider"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0980_K698-K5G.jpg"
  },
  {
    "id": "AQI785",
    "name": "Margaret Mary Studebaker",
    "sex": "F",
    "gen": 9,
    "slot": 469,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI453",
    "birthYear": 1735,
    "deathYear": 1813,
    "birthDate": "9 Aug 1735",
    "deathDate": "1813",
    "burialDate": "1813",
    "christeningDate": null,
    "birthPlace": "Solingen, North Rhine-Westphalia, Germany",
    "deathPlace": "Snake Spring Township, Bedford, Pennsylvania, United States",
    "burialPlace": "Ritchey Cemetery, Snake Spring Township, Bedford, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "MQ1L-K71",
    "photo": "/ancestors/bubbles/0981_MQ1L-K71.jpg",
    "living": false,
    "alternateNames": [
      "Margaretha Mary Studebaker",
      "Margaretha Maria Studebaker Staudenbecker Margaretha Maria Studebaker Staudenbecker"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0981_MQ1L-K71.jpg"
  },
  {
    "id": "AQI786",
    "name": "Andreas Andrew Bostetter",
    "sex": "M",
    "gen": 9,
    "slot": 470,
    "side": "maternal",
    "birthplace": "france",
    "childId": "AQI454",
    "birthYear": 1728,
    "deathYear": 1806,
    "birthDate": "26 Nov 1728",
    "deathDate": "15 Jun 1806",
    "burialDate": "1808",
    "christeningDate": null,
    "birthPlace": "Kauffenheim, Bas-Rhin, France",
    "deathPlace": "Hagerstown, Washington, Maryland, United States",
    "burialPlace": "Broadfording, Washington, Maryland, United States",
    "christeningPlace": null,
    "fsId": "LTQB-52L",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Andrew Bostetter"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI787",
    "name": "Elizabeth Long",
    "sex": "F",
    "gen": 9,
    "slot": 471,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI454",
    "birthYear": 1728,
    "deathYear": 1806,
    "birthDate": "1728",
    "deathDate": "1806",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Washington, Maryland, United States",
    "deathPlace": "Hagerstown, Washington, Maryland, United States",
    "burialPlace": "Broadfording Cemetery, Hagerstown, Washington, Maryland, United States",
    "christeningPlace": null,
    "fsId": "MKXT-MHR",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Elizabeth",
      "Mrs Elizabeth Bostetter"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI743s472",
    "name": "Johann Michael Burger",
    "sex": "M",
    "gen": 9,
    "slot": 472,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI455",
    "birthYear": 1745,
    "deathYear": 1800,
    "birthDate": "5 Mar 1745",
    "deathDate": "Abt 1800",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Ottersweier, Rastatt, Baden-Württemberg, Germany",
    "deathPlace": "Maryland, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LC86-K85",
    "photo": "/ancestors/bubbles/0912_LC86-K85.jpg",
    "living": false,
    "alternateNames": [
      "Johannes Hans Michel Burger"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0912_LC86-K85.jpg"
  },
  {
    "id": "AQI744s473",
    "name": "Anna Catharina Schele",
    "sex": "F",
    "gen": 9,
    "slot": 473,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI455",
    "birthYear": 1745,
    "deathYear": 1804,
    "birthDate": "Abt 1745",
    "deathDate": "21 Nov 1804",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Hochsauerlandkreis, North Rhine-Westphalia, Germany",
    "deathPlace": "Johnson, Georgia, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "K1VK-9GT",
    "photo": "/ancestors/bubbles/0913_K1VK-9GT.jpg",
    "living": false,
    "alternateNames": [
      "Anna Burger"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0913_K1VK-9GT.jpg"
  },
  {
    "id": "AQI788",
    "name": "Daniel Whetstone",
    "sex": "M",
    "gen": 9,
    "slot": 474,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI456",
    "birthYear": 1750,
    "deathYear": 1839,
    "birthDate": "1750",
    "deathDate": "1839",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Funkstown, Washington, Maryland, United States",
    "deathPlace": "Caesar Creek Township, Dearborn, Indiana, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "PQ9L-R1W",
    "photo": "/ancestors/bubbles/0986_PQ9L-R1W.jpg",
    "living": false,
    "alternateNames": [
      "Daniel Wetzstein"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0986_PQ9L-R1W.jpg"
  },
  {
    "id": "AQI789",
    "name": "Maria Catharina Bund",
    "sex": "F",
    "gen": 9,
    "slot": 475,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI456",
    "birthYear": 1752,
    "deathYear": 1800,
    "birthDate": "1 Mar 1752",
    "deathDate": "Abt 1800",
    "burialDate": null,
    "christeningDate": "5 Mar 1752",
    "birthPlace": "Schleswig, Schleswig-Holstein, Germany",
    "deathPlace": "Caesar Creek Township, Dearborn, Indiana, United States",
    "burialPlace": null,
    "christeningPlace": "Schleswig, Schleswig-Holstein, Germany",
    "fsId": "LZVG-9T6",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Maria Catharina Whetstone"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI790",
    "name": "Henry Brown",
    "sex": "M",
    "gen": 9,
    "slot": 476,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI457",
    "birthYear": 1744,
    "deathYear": 1816,
    "birthDate": "1744",
    "deathDate": "Aft 5 Oct 1816",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Germany",
    "deathPlace": "Nimishillen Township, Stark, Ohio, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "GXHB-HTG",
    "photo": "/ancestors/bubbles/0988_GXHB-HTG.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0988_GXHB-HTG.jpg"
  },
  {
    "id": "AQI791",
    "name": "Maria Salome Hoerner",
    "sex": "F",
    "gen": 9,
    "slot": 477,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI457",
    "birthYear": 1745,
    "deathYear": 1810,
    "birthDate": "16 Sep 1745",
    "deathDate": "1810",
    "burialDate": null,
    "christeningDate": "16 Sep 1745",
    "birthPlace": "Mengen, Baden",
    "deathPlace": "Woodbury, Bedford, Pennsylvania, United States",
    "burialPlace": null,
    "christeningPlace": "Ihringen, Breisach, Baden",
    "fsId": "MTT1-7QP",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Maria Salome Hörnerin",
      "Maria Salome Hörner"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI792",
    "name": "Rev. Samuel Ulery",
    "sex": "M",
    "gen": 9,
    "slot": 478,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI458",
    "birthYear": 1754,
    "deathYear": 1822,
    "birthDate": "1754",
    "deathDate": "1822",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Maryland, United States",
    "deathPlace": "New Enterprise, South Woodbury Township, Bedford, Pennsylvania, United States",
    "burialPlace": "New Enterprise Cemetery, New Enterprise, South Woodbury Township, Bedford, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LDMJ-N7X",
    "photo": "/ancestors/bubbles/0990_LDMJ-N7X.jpg",
    "living": false,
    "alternateNames": [
      "Samuel Ulrich",
      "Samual Ulry",
      "Samuel Ullery",
      "Samuel Cripe Ullery Ulrich"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0990_LDMJ-N7X.jpg"
  },
  {
    "id": "AQI793",
    "name": "Mary Elizabeth Brumbaugh",
    "sex": "F",
    "gen": 9,
    "slot": 479,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI458",
    "birthYear": 1767,
    "deathYear": 1849,
    "birthDate": "1767",
    "deathDate": "1849",
    "burialDate": "1849",
    "christeningDate": null,
    "birthPlace": "Frederick, Maryland, British Colonial America",
    "deathPlace": "New Enterprise, South Woodbury Township, Bedford, Pennsylvania, United States",
    "burialPlace": "New Enterprise, South Woodbury Township, Bedford, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LHDQ-H68",
    "photo": "/ancestors/bubbles/0991_LHDQ-H68.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0991_LHDQ-H68.jpg"
  },
  {
    "id": "AQI794",
    "name": "Jacob Gochenour",
    "sex": "M",
    "gen": 9,
    "slot": 480,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI459",
    "birthYear": 1719,
    "deathYear": 1800,
    "birthDate": "1719",
    "deathDate": "1800",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Kohlhof, Bad Rappenau, Heilbronn, Baden-Württemberg, Germany",
    "deathPlace": "Leesburg, Loudoun, Virginia, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LRTX-TGV",
    "photo": "/ancestors/bubbles/0992_LRTX-TGV.jpg",
    "living": false,
    "alternateNames": [
      "Jacob Cocghnower"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0992_LRTX-TGV.jpg"
  },
  {
    "id": "AQI795",
    "name": "Mary Rosseau Sheetz",
    "sex": "F",
    "gen": 9,
    "slot": 481,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI459",
    "birthYear": 1732,
    "deathYear": 1803,
    "birthDate": "1732",
    "deathDate": "1803",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Lancaster, Lancaster, Pennsylvania, British Colonial America",
    "deathPlace": "Clover Creek, North Woodbury Township, Blair, Pennsylvania, United States",
    "burialPlace": "Lancaster, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "MVQL-C7Z",
    "photo": "/ancestors/bubbles/0993_MVQL-C7Z.jpg",
    "living": false,
    "alternateNames": [
      "Mary Sheets",
      "Mary Gochenour"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0993_MVQL-C7Z.jpg"
  },
  {
    "id": "AQI796",
    "name": "Israel Burket",
    "sex": "M",
    "gen": 9,
    "slot": 496,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI461",
    "birthYear": 1723,
    "deathYear": 1805,
    "birthDate": "1723",
    "deathDate": "19 Feb 1805",
    "burialDate": "1805",
    "christeningDate": null,
    "birthPlace": "Württemberg",
    "deathPlace": "Stonycreek Township, Somerset, Pennsylvania, United States",
    "burialPlace": "Daley Cemetery, Daley, Shade Township, Somerset, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LD5H-KD3",
    "photo": "/ancestors/bubbles/1008_LD5H-KD3.jpg",
    "living": false,
    "alternateNames": [
      "Israel Burchart"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1008_LD5H-KD3.jpg"
  },
  {
    "id": "AQI797",
    "name": "Anna Maria Barbara Stauch",
    "sex": "F",
    "gen": 9,
    "slot": 497,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI461",
    "birthYear": 1726,
    "deathYear": 1805,
    "birthDate": "6 May 1726",
    "deathDate": "Aft 1805",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Württemberg",
    "deathPlace": "Pennsylvania, United States",
    "burialPlace": "Daley Cemetery, Daley, Shade Township, Somerset, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "L1WW-HLS",
    "photo": "/ancestors/bubbles/1009_L1WW-HLS.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1009_L1WW-HLS.jpg"
  },
  {
    "id": "AQI798",
    "name": "Peter Swoveland",
    "sex": "M",
    "gen": 9,
    "slot": 500,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI463",
    "birthYear": 1714,
    "deathYear": null,
    "birthDate": "Abt 1714",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Baden-Württemberg, Germany",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "PMGH-DMS",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Peter Swoveland (Schwabeland)",
      "Peter Schwabeland",
      "Peter Swoveland Schwabenland",
      "Peter Schwabbeland\\swoveland"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI799",
    "name": "Anna Catherine Mummert",
    "sex": "F",
    "gen": 9,
    "slot": 501,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI463",
    "birthYear": 1730,
    "deathYear": 1797,
    "birthDate": "20 Jan 1730",
    "deathDate": "11 Aug 1797",
    "burialDate": null,
    "christeningDate": "22 Jan 1730",
    "birthPlace": "Mußbach, Bezirksamt Neustadt, Bavaria, Germany",
    "deathPlace": "Bedford, Pennsylvania, United States",
    "burialPlace": null,
    "christeningPlace": "Mußbach, Bezirksamt Neustadt, Bavaria, Germany",
    "fsId": "GRPK-4D1",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Anna Katherine Mummert"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI800",
    "name": "John Henry Bausser",
    "sex": "M",
    "gen": 9,
    "slot": 502,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI464",
    "birthYear": 1726,
    "deathYear": 1809,
    "birthDate": "19 Dec 1726",
    "deathDate": "19 May 1809",
    "burialDate": "1809",
    "christeningDate": null,
    "birthPlace": "Rhineland-Palatinate, Germany",
    "deathPlace": "St. Clair Township, Bedford, Pennsylvania, United States",
    "burialPlace": "Bowser Farm Cemetery, Oppenheimer, Bedford Township, Bedford, Pennsylvania, United States",
    "christeningPlace": "Lancaster, Pennsylvania, United States",
    "fsId": "LZVY-566",
    "photo": "/ancestors/bubbles/1014_LZVY-566.jpg",
    "living": false,
    "alternateNames": [
      "John Bowser",
      "John Lancaster Bausser\\Bowser",
      "Hans Ulrich Bausser"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1014_LZVY-566.jpg"
  },
  {
    "id": "AQI801",
    "name": "Eve Maria Schellenberg",
    "sex": "F",
    "gen": 9,
    "slot": 503,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI464",
    "birthYear": 1728,
    "deathYear": 1802,
    "birthDate": "18 Dec 1728",
    "deathDate": "18 Dec 1802",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Manheim, Lancaster, Pennsylvania, United States",
    "deathPlace": "Bedford, Bedford, Pennsylvania, United States",
    "burialPlace": "Oppenheimer, Bedford Township, Bedford, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "GXGY-9BK",
    "photo": "/ancestors/bubbles/1015_GXGY-9BK.jpg",
    "living": false,
    "alternateNames": [
      "Eva Bausser",
      "Eva Maria Schellenberg",
      "Eva Maria Bowser",
      "Mary Eva Bowser"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1015_GXGY-9BK.jpg"
  },
  {
    "id": "AQI802",
    "name": "Johann Simon Claar",
    "sex": "M",
    "gen": 9,
    "slot": 504,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI465",
    "birthYear": 1732,
    "deathYear": 1812,
    "birthDate": "12 Dec 1732",
    "deathDate": "19 Sep 1812",
    "burialDate": null,
    "christeningDate": "12 Dec 1732",
    "birthPlace": "Mimbach, Blieskastel, Landkreis Zweibrücken, Rhineland-Palatinate, Germany",
    "deathPlace": "Bedford, Bedford, Pennsylvania, United States",
    "burialPlace": "Bedford, Bedford, Pennsylvania, United States",
    "christeningPlace": "Webenheim, Blieskastel, Landkreis Zweibrücken, Rhineland-Palatinate, Germany",
    "fsId": "LC77-FD8",
    "photo": "/ancestors/bubbles/1016_LC77-FD8.jpg",
    "living": false,
    "alternateNames": [
      "Johan Simon Clar",
      "Simon Clar",
      "John Claar",
      "Simon Claar",
      "Simon Claar Captain Joh",
      "Johann Klaar",
      "Johan Simon Claar"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1016_LC77-FD8.jpg"
  },
  {
    "id": "AQI803",
    "name": "Anna Margaretha Klee",
    "sex": "F",
    "gen": 9,
    "slot": 505,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI465",
    "birthYear": 1741,
    "deathYear": 1790,
    "birthDate": "9 Mar 1741",
    "deathDate": "24 Nov 1790",
    "burialDate": "24 Nov 1790",
    "christeningDate": null,
    "birthPlace": "York, Pennsylvania, British Colonial America",
    "deathPlace": "Hanover, York, Pennsylvania, United States",
    "burialPlace": "Saint Matthews Evangelical Lutheran Cemetery, Hanover, York, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LYWJ-YZP",
    "photo": "/ancestors/bubbles/1017_LYWJ-YZP.jpg",
    "living": false,
    "alternateNames": [
      "Ann Margaretha Klee",
      "Anna Margaretha",
      "Anna Margaret Elizabeth Klee",
      "Claar"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1017_LYWJ-YZP.jpg"
  },
  {
    "id": "AQI804",
    "name": "Mathias Walter",
    "sex": "M",
    "gen": 9,
    "slot": 506,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI466",
    "birthYear": 1728,
    "deathYear": 1780,
    "birthDate": "1 May 1728",
    "deathDate": "19 Sep 1780",
    "burialDate": "1780",
    "christeningDate": null,
    "birthPlace": "Dutch Corner, Bedford, Pennsylvania, British Colonial America",
    "deathPlace": "Dutch Corner, Bedford Township, Bedford, Pennsylvania, United States",
    "burialPlace": "Upper Claar Church, Kimmel Township, Bedford, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LXX1-VK5",
    "photo": "/ancestors/bubbles/1018_LXX1-VK5.jpg",
    "living": false,
    "alternateNames": [
      "Mathias Walter Walters",
      "Mathias Rudolph Walter",
      "Walters"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1018_LXX1-VK5.jpg"
  },
  {
    "id": "AQI805",
    "name": "Barbara Hannah Imler",
    "sex": "F",
    "gen": 9,
    "slot": 507,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI466",
    "birthYear": 1734,
    "deathYear": 1812,
    "birthDate": "13 Sep 1734",
    "deathDate": "27 Aug 1812",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "New Hanover Township, Philadelphia, Pennsylvania, British Colonial America",
    "deathPlace": "Greenfield Township, Bedford, Pennsylvania, United States",
    "burialPlace": "Upper Claar Cemetery, Queen, Kimmel Township, Bedford, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LCT4-SXT",
    "photo": "/ancestors/bubbles/1019_LCT4-SXT.jpg",
    "living": false,
    "alternateNames": [
      "Barbara"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1019_LCT4-SXT.jpg"
  },
  {
    "id": "AQI439s508",
    "name": "Johann Christian Heinrich Ickes",
    "sex": "M",
    "gen": 9,
    "slot": 508,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI235s254",
    "birthYear": 1742,
    "deathYear": 1829,
    "birthDate": "23 Aug 1742",
    "deathDate": "19 Jan 1829",
    "burialDate": "Jan 1829",
    "christeningDate": null,
    "birthPlace": "Hanover, York, Pennsylvania, United States",
    "deathPlace": "King Township, Bedford, Pennsylvania, United States",
    "burialPlace": "Old Union Cemetery, Buffalo Mills, Harrison Township, Bedford, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LH88-MB8",
    "photo": "/ancestors/bubbles/0468_LH88-MB8.jpg",
    "living": false,
    "alternateNames": [
      "Johann Ickes",
      "Johannes Ickes",
      "John Henry Ickes Sr"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0468_LH88-MB8.jpg"
  },
  {
    "id": "AQI440s509",
    "name": "Maria Elizabeth Stambaugh",
    "sex": "F",
    "gen": 9,
    "slot": 509,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI235s254",
    "birthYear": 1750,
    "deathYear": 1823,
    "birthDate": "17 Jun 1750",
    "deathDate": "27 Aug 1823",
    "burialDate": "Aug 1823",
    "christeningDate": "17 Jun 1750",
    "birthPlace": "Hanover, York, Pennsylvania, British Colonial America",
    "deathPlace": "Bedford, Pennsylvania, United States",
    "burialPlace": "Old Union Cemetery, Osterburg, East Saint Clair Township, Bedford, Pennsylvania, United States",
    "christeningPlace": "York, Pennsylvania, United States",
    "fsId": "LH8R-CQX",
    "photo": "/ancestors/bubbles/0469_LH8R-CQX.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0469_LH8R-CQX.jpg"
  },
  {
    "id": "AQI806",
    "name": "Richard Bourn",
    "sex": "M",
    "gen": 10,
    "slot": 2,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI468",
    "birthYear": null,
    "deathYear": null,
    "birthDate": null,
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "16 Aug 1658",
    "birthPlace": "England, United Kingdom",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Horsham, Sussex, England, United Kingdom",
    "fsId": "M917-LRM",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI807",
    "name": "Elizabeth Caffin",
    "sex": "F",
    "gen": 10,
    "slot": 3,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI468",
    "birthYear": 1665,
    "deathYear": null,
    "birthDate": "14 Sep 1665",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "14 Sep 1665",
    "birthPlace": "Horsham, Sussex, England",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Horsham, Sussex, England",
    "fsId": "LZJG-T86",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI808",
    "name": "William Wiltshire",
    "sex": "M",
    "gen": 10,
    "slot": 4,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI469",
    "birthYear": 1672,
    "deathYear": 1761,
    "birthDate": "13 Feb 1672",
    "deathDate": "1761",
    "burialDate": "23 Jun 1721",
    "christeningDate": "13 Feb 1672",
    "birthPlace": "Sutton, Sussex, England",
    "deathPlace": "Lillington, Dorset, England, United Kingdom",
    "burialPlace": null,
    "christeningPlace": "Sutton, Sussex, England, United Kingdom",
    "fsId": "G39V-M3X",
    "photo": null,
    "living": false,
    "alternateNames": [
      "William Wilshere",
      "William Wilshire"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI809",
    "name": "Elizabeth Woods",
    "sex": "F",
    "gen": 10,
    "slot": 5,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI469",
    "birthYear": 1671,
    "deathYear": null,
    "birthDate": "1671",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "28 Sep 1671",
    "birthPlace": "Sidlesham, Sussex, England",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Sidlesham, Sussex, England",
    "fsId": "LH75-1K7",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Elisabeth Woods",
      "Elizabeth"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI810",
    "name": "Thomas Howard",
    "sex": "M",
    "gen": 10,
    "slot": 6,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI470",
    "birthYear": 1682,
    "deathYear": 1725,
    "birthDate": "7 Jul 1682",
    "deathDate": "10 Jul 1725",
    "burialDate": "Aft 10 Jul 1725",
    "christeningDate": null,
    "birthPlace": "Devon, England",
    "deathPlace": "Lingfield, Surrey, England",
    "burialPlace": "Lingfield, Surrey, England",
    "christeningPlace": null,
    "fsId": "LZDK-47K",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI811",
    "name": "Mary Wentworth",
    "sex": "F",
    "gen": 10,
    "slot": 7,
    "side": "paternal",
    "birthplace": "unknown",
    "childId": "AQI470",
    "birthYear": null,
    "deathYear": 1718,
    "birthDate": null,
    "deathDate": "29 May 1718",
    "burialDate": "4 Jun 1718",
    "christeningDate": "20 Sep 1681",
    "birthPlace": null,
    "deathPlace": "Surrey, England",
    "burialPlace": "Lingfield, Surrey, England",
    "christeningPlace": "Chartham, Kent, England, United Kingdom",
    "fsId": "LWVB-184",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Mary",
      "Mrs. Mary Heward",
      "Mrs. Mary Howard"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI812",
    "name": "John Hammon",
    "sex": "M",
    "gen": 10,
    "slot": 12,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI471",
    "birthYear": 1708,
    "deathYear": 1749,
    "birthDate": "1 Jan 1708",
    "deathDate": "19 Jan 1749",
    "burialDate": "19 Aug 1749",
    "christeningDate": null,
    "birthPlace": "South Bersted, Sussex, England",
    "deathPlace": "Selsey, Sussex, England",
    "burialPlace": "Waldron, Sussex, England, United Kingdom",
    "christeningPlace": null,
    "fsId": "9VT9-HZY",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI813",
    "name": "Anne Alchorne",
    "sex": "F",
    "gen": 10,
    "slot": 13,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI471",
    "birthYear": 1714,
    "deathYear": 1786,
    "birthDate": "1 Jan 1714",
    "deathDate": "1 Sep 1786",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Uckfield, Sussex, England",
    "deathPlace": "Waldron, Sussex, England",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "GH92-HDD",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI814",
    "name": "William Coles",
    "sex": "M",
    "gen": 10,
    "slot": 16,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI473",
    "birthYear": 1667,
    "deathYear": 1738,
    "birthDate": "1667",
    "deathDate": "4 Apr 1738",
    "burialDate": "4 Apr 1738",
    "christeningDate": null,
    "birthPlace": "Funtington, Sussex, England",
    "deathPlace": "Funtington, Sussex, England, United Kingdom",
    "burialPlace": "Funtington, Sussex, England, United Kingdom",
    "christeningPlace": null,
    "fsId": "K89H-XPK",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Rich. Coles",
      "Richard Coles"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI815",
    "name": "Elizabeth Wilton",
    "sex": "F",
    "gen": 10,
    "slot": 17,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI473",
    "birthYear": 1674,
    "deathYear": 1729,
    "birthDate": "22 Oct 1674",
    "deathDate": "25 Feb 1729",
    "burialDate": "25 Feb 1730",
    "christeningDate": "22 Oct 1674",
    "birthPlace": "Westbourne, Sussex, England",
    "deathPlace": "Funtington, Sussex, England, United Kingdom",
    "burialPlace": "Funtington, Sussex, England, United Kingdom",
    "christeningPlace": "Sussex, England, United Kingdom",
    "fsId": "MPRV-KDV",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Elizabeth",
      "Elizabeth Willton"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI816",
    "name": "Thomas Williamson",
    "sex": "M",
    "gen": 10,
    "slot": 18,
    "side": "paternal",
    "birthplace": "unknown",
    "childId": "AQI474",
    "birthYear": 1674,
    "deathYear": null,
    "birthDate": "1674",
    "deathDate": null,
    "burialDate": "Abt 1734",
    "christeningDate": "23 Mar 1674",
    "birthPlace": null,
    "deathPlace": "Harting, Sussex, England",
    "burialPlace": "Harting, Sussex, England, United Kingdom",
    "christeningPlace": "Rogate, Sussex, England",
    "fsId": "2737-79Q",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Thos Williamson",
      "Thomas",
      "Tho Williamson"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI817",
    "name": "Rebecca Woldridge",
    "sex": "F",
    "gen": 10,
    "slot": 19,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI474",
    "birthYear": 1681,
    "deathYear": null,
    "birthDate": "27 Nov 1681",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "27 Nov 1681",
    "birthPlace": "Sussex, England",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Sussex, England, United Kingdom",
    "fsId": "LZJG-TPT",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Rebecca Wooldridge",
      "Rebecka",
      "Rebecka Wouldrige"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI818",
    "name": "Stephenson",
    "sex": "M",
    "gen": 10,
    "slot": 28,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI477",
    "birthYear": 1675,
    "deathYear": null,
    "birthDate": "1675",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "England",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "PH93-19C",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI819",
    "name": "Stephenson",
    "sex": "F",
    "gen": 10,
    "slot": 29,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI477",
    "birthYear": 1695,
    "deathYear": null,
    "birthDate": "1695",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "England",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "PH93-BXJ",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI820",
    "name": "Pawson",
    "sex": "M",
    "gen": 10,
    "slot": 30,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI478",
    "birthYear": 1685,
    "deathYear": null,
    "birthDate": "1685",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "England",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "PH93-KS5",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI821",
    "name": "Pawson",
    "sex": "F",
    "gen": 10,
    "slot": 31,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI478",
    "birthYear": 1705,
    "deathYear": null,
    "birthDate": "1705",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "England",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "PH93-G1Z",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI822",
    "name": "Richard Irish",
    "sex": "M",
    "gen": 10,
    "slot": 44,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI481",
    "birthYear": 1702,
    "deathYear": 1774,
    "birthDate": "Apr 1702",
    "deathDate": "Nov 1774",
    "burialDate": null,
    "christeningDate": "7 Apr 1702",
    "birthPlace": "Eartham, Sussex, England",
    "deathPlace": "Sussex, England, United Kingdom",
    "burialPlace": null,
    "christeningPlace": "Eartham, Sussex, England",
    "fsId": "LK2S-HWG",
    "photo": "/ancestors/bubbles/1068_LK2S-HWG.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1068_LK2S-HWG.jpg"
  },
  {
    "id": "AQI823",
    "name": "Elizabeth Bennett",
    "sex": "F",
    "gen": 10,
    "slot": 45,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI481",
    "birthYear": 1714,
    "deathYear": 1797,
    "birthDate": "1714",
    "deathDate": "Abt 1797",
    "burialDate": "15 Dec 1797",
    "christeningDate": "16 Sep 1714",
    "birthPlace": "Westbourne, Sussex, England",
    "deathPlace": "Sussex, England, United Kingdom",
    "burialPlace": "Boxgrove, Sussex, England",
    "christeningPlace": "Warnham, Sussex, England, United Kingdom",
    "fsId": "LK2S-HX8",
    "photo": "/ancestors/bubbles/1069_LK2S-HX8.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1069_LK2S-HX8.jpg"
  },
  {
    "id": "AQI824",
    "name": "William Far",
    "sex": "M",
    "gen": 10,
    "slot": 46,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI482",
    "birthYear": 1708,
    "deathYear": null,
    "birthDate": "5 Apr 1708",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "5 Apr 1708",
    "birthPlace": "Pagham, Sussex, England, United Kingdom",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Pagham, Sussex, England, United Kingdom",
    "fsId": "KCMS-S93",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Wm. Far"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI825",
    "name": "Anne Ball",
    "sex": "F",
    "gen": 10,
    "slot": 47,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI482",
    "birthYear": 1713,
    "deathYear": 1773,
    "birthDate": "1713",
    "deathDate": "1773",
    "burialDate": "19 Oct 1773",
    "christeningDate": "Dec 1713",
    "birthPlace": "Walberton, Sussex, England, United Kingdom",
    "deathPlace": "Walberton, Sussex, England, United Kingdom",
    "burialPlace": "Walberton, Sussex, England, United Kingdom",
    "christeningPlace": "Walberton, Sussex, England, United Kingdom",
    "fsId": "MNVR-F4R",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI826",
    "name": "Richard Chessell",
    "sex": "M",
    "gen": 10,
    "slot": 48,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI483",
    "birthYear": 1705,
    "deathYear": null,
    "birthDate": "Abt 1705",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Angmering, Sussex, England, United Kingdom",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "9KNS-3VJ",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI827",
    "name": "Mary Amos",
    "sex": "F",
    "gen": 10,
    "slot": 49,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI483",
    "birthYear": 1705,
    "deathYear": null,
    "birthDate": "Abt 1705",
    "deathDate": null,
    "burialDate": "19 Jan 1743",
    "christeningDate": null,
    "birthPlace": "Angmering, Sussex, England, United Kingdom",
    "deathPlace": null,
    "burialPlace": "Brook, Hampshire, England, United Kingdom",
    "christeningPlace": null,
    "fsId": "MN2C-NFR",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI828",
    "name": "Edward Compton",
    "sex": "M",
    "gen": 10,
    "slot": 50,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI484",
    "birthYear": 1675,
    "deathYear": null,
    "birthDate": "Abt 1675",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Angmering, Sussex, England, United Kingdom",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "MFRT-YGN",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI829",
    "name": "Jane Sturt",
    "sex": "F",
    "gen": 10,
    "slot": 51,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI484",
    "birthYear": 1699,
    "deathYear": null,
    "birthDate": "Abt 1699",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "10 Jul 1699",
    "birthPlace": "Westbourne, Sussex, England, United Kingdom",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Westbourne, Sussex, England, United Kingdom",
    "fsId": "4XDY-NLC",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Jane"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI831",
    "name": "Anthony Suter",
    "sex": "M",
    "gen": 10,
    "slot": 52,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI485",
    "birthYear": 1686,
    "deathYear": 1759,
    "birthDate": "4 Jul 1686",
    "deathDate": "1759",
    "burialDate": "28 Oct 1759",
    "christeningDate": "4 Jul 1686",
    "birthPlace": "Easebourne, Sussex, England, United Kingdom",
    "deathPlace": "Eastbourne, Sussex, England, United Kingdom",
    "burialPlace": "Easebourne, Sussex, England, United Kingdom",
    "christeningPlace": "Easebourne, Sussex, England, United Kingdom",
    "fsId": "LD7Z-28K",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Souter",
      "Anthony Souter"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI832",
    "name": "Elizabeth Mersh",
    "sex": "F",
    "gen": 10,
    "slot": 53,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI485",
    "birthYear": 1687,
    "deathYear": null,
    "birthDate": "1687",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "29 Mar 1691",
    "birthPlace": "Godalming, Surrey, England, United Kingdom",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Godalming, Surrey, England",
    "fsId": "LZKV-GHS",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI833",
    "name": "John Fogden",
    "sex": "M",
    "gen": 10,
    "slot": 54,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI486",
    "birthYear": 1705,
    "deathYear": 1778,
    "birthDate": "22 Mar 1705",
    "deathDate": "10 Sep 1778",
    "burialDate": "10 Sep 1778",
    "christeningDate": "Abt 1705",
    "birthPlace": "Boxgrove, Sussex, England, United Kingdom",
    "deathPlace": "Boxgrove, Sussex, England, United Kingdom",
    "burialPlace": "Boxgrove, Sussex, England, United Kingdom",
    "christeningPlace": "Boxgrove, Sussex, England, United Kingdom",
    "fsId": "L4GF-YCX",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI834",
    "name": "Elizabeth Trott",
    "sex": "F",
    "gen": 10,
    "slot": 55,
    "side": "paternal",
    "birthplace": "unknown",
    "childId": "AQI486",
    "birthYear": 1705,
    "deathYear": null,
    "birthDate": "3 Mar 1705",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "5 Mar 1705",
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Aldingbourne, Sussex, England, United Kingdom",
    "fsId": "MN36-D6X",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Vogden"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI835",
    "name": "Hans Lehmann",
    "sex": "M",
    "gen": 10,
    "slot": 64,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI488",
    "birthYear": 1672,
    "deathYear": null,
    "birthDate": "1672",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Worb, Bern, Switzerland",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "L1JP-YSF",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI836",
    "name": "Christina Thuner",
    "sex": "F",
    "gen": 10,
    "slot": 65,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI488",
    "birthYear": 1674,
    "deathYear": null,
    "birthDate": "1674",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Bern, Switzerland",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "L1JP-1G5",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Christina Thüner"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI837",
    "name": "Niklaus Locher",
    "sex": "M",
    "gen": 10,
    "slot": 66,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI489",
    "birthYear": 1650,
    "deathYear": 1732,
    "birthDate": "17 May 1650",
    "deathDate": "10 Oct 1732",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Hasle bei Burgdorf, Bern, Switzerland",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "KHNZ-DLL",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI838",
    "name": "Magdalena Burri",
    "sex": "F",
    "gen": 10,
    "slot": 67,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI489",
    "birthYear": 1660,
    "deathYear": 1732,
    "birthDate": "25 Dec 1660",
    "deathDate": "29 May 1732",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Hasle bei Burgdorf, Bern, Switzerland",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "K4VP-294",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI839",
    "name": "Hans Schindler",
    "sex": "M",
    "gen": 10,
    "slot": 68,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI490",
    "birthYear": 1647,
    "deathYear": 1728,
    "birthDate": "25 Jul 1647",
    "deathDate": "26 Apr 1728",
    "burialDate": "26 Apr 1728",
    "christeningDate": "25 Jul 1647",
    "birthPlace": "Röthenbach im Emmental, Bern, Switzerland",
    "deathPlace": "Röthenbach im Emmental, Bern, Switzerland",
    "burialPlace": "Röthenbach im Emmental, Bern, Switzerland",
    "christeningPlace": "Röthenbach im Emmental, Bern, Switzerland",
    "fsId": "K4PS-VMT",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI840",
    "name": "Ana Egli",
    "sex": "F",
    "gen": 10,
    "slot": 69,
    "side": "paternal",
    "birthplace": "unknown",
    "childId": "AQI490",
    "birthYear": null,
    "deathYear": null,
    "birthDate": null,
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "1650",
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Röthenbach im Emmental, Bern, Switzerland",
    "fsId": "GKF6-3JQ",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Anna Schindler Egli",
      "Anna Egli"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI841",
    "name": "Niclaus Oppliger",
    "sex": "M",
    "gen": 10,
    "slot": 70,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI491",
    "birthYear": 1678,
    "deathYear": 1745,
    "birthDate": "7 Apr 1678",
    "deathDate": "Oct 1745",
    "burialDate": null,
    "christeningDate": "7 Apr 1678",
    "birthPlace": "Röthenbach im Emmental, Bern, Switzerland",
    "deathPlace": "Signau, Bern, Switzerland",
    "burialPlace": null,
    "christeningPlace": "Röthenbach im Emmental, Bern, Switzerland",
    "fsId": "LZ2V-Z9N",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Claus Oppliger"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI842",
    "name": "Verena Niedershauser",
    "sex": "F",
    "gen": 10,
    "slot": 71,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI491",
    "birthYear": null,
    "deathYear": null,
    "birthDate": null,
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Signau, Bern, Switzerland",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "L55J-M1J",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Verena Nidershüeser"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI843",
    "name": "Niklaus Leuenberger",
    "sex": "M",
    "gen": 10,
    "slot": 72,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI492",
    "birthYear": 1646,
    "deathYear": 1736,
    "birthDate": "21 Apr 1646",
    "deathDate": "10 Feb 1736",
    "burialDate": null,
    "christeningDate": "23 Feb 1655",
    "birthPlace": "Lützelflüh, Bern, Switzerland",
    "deathPlace": "Lützelflüh, Bern, Switzerland",
    "burialPlace": null,
    "christeningPlace": "Lützelflüh, Bern, Switzerland",
    "fsId": "KZ8D-N43",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI844",
    "name": "Christine Neuhaus",
    "sex": "F",
    "gen": 10,
    "slot": 73,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI492",
    "birthYear": 1662,
    "deathYear": null,
    "birthDate": "Abt Oct 1662",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "17 Oct 1662",
    "birthPlace": "Lützelflüh, Bern, Switzerland",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Lützelflüh, Bern, Switzerland",
    "fsId": "K8CY-YC8",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Stina"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI845",
    "name": "Hans Gammeter",
    "sex": "M",
    "gen": 10,
    "slot": 74,
    "side": "paternal",
    "birthplace": "unknown",
    "childId": "AQI493",
    "birthYear": null,
    "deathYear": null,
    "birthDate": null,
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "9 Aug 1674",
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Lützelflüh, Bern, Switzerland",
    "fsId": "LCJB-KJN",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Hans",
      "Hans Bammeter",
      "Johannes Gammater",
      "Hans Gemmeter"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI846",
    "name": "Barbara Flükiger",
    "sex": "F",
    "gen": 10,
    "slot": 75,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI493",
    "birthYear": 1673,
    "deathYear": 1749,
    "birthDate": "1673",
    "deathDate": "14 Oct 1749",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Lützelflüh, Bern, Switzerland",
    "deathPlace": "Lützelflüh, Bern, Switzerland",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LCJB-K2P",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Barbara Fluckiger",
      "Barbara Fluckiger Gammeter",
      "Barbara Flueckiger"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI847",
    "name": "Hans Maurer",
    "sex": "M",
    "gen": 10,
    "slot": 80,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI494",
    "birthYear": 1671,
    "deathYear": 1740,
    "birthDate": "1 Sep 1671",
    "deathDate": "13 Mar 1740",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Vechigen, Bern, Switzerland",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "2Z38-T2W",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI848",
    "name": "Verena Burkhalter",
    "sex": "F",
    "gen": 10,
    "slot": 81,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI494",
    "birthYear": 1672,
    "deathYear": null,
    "birthDate": "Abt 1672",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Hasle bei Burgdorf, Bern, Switzerland",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "27S5-46H",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Verena Burkholter",
      "Verena Burkholter Maurer"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI851",
    "name": "Hans Schweizer",
    "sex": "M",
    "gen": 10,
    "slot": 82,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI495",
    "birthYear": 1655,
    "deathYear": 1735,
    "birthDate": "25 Mar 1655",
    "deathDate": "22 Jan 1735",
    "burialDate": null,
    "christeningDate": "Abt 1675",
    "birthPlace": "Hasle bei Burgdorf, Bern, Switzerland",
    "deathPlace": "Hasle bei Burgdorf, Bern, Switzerland",
    "burialPlace": null,
    "christeningPlace": "Bern, Switzerland",
    "fsId": "G1FD-8B5",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI852",
    "name": "Barbara Bigler",
    "sex": "F",
    "gen": 10,
    "slot": 83,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI495",
    "birthYear": 1672,
    "deathYear": 1743,
    "birthDate": "8 Dec 1672",
    "deathDate": "27 Jan 1743",
    "burialDate": null,
    "christeningDate": "24 May 1695",
    "birthPlace": "Münsingen, Bern, Switzerland",
    "deathPlace": "Münsingen, Bern, Switzerland",
    "burialPlace": null,
    "christeningPlace": "Hasle bei Burgdorf, Bern, Switzerland",
    "fsId": "P626-HVM",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI853",
    "name": "Niklaus Krähenbühl",
    "sex": "M",
    "gen": 10,
    "slot": 88,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI497",
    "birthYear": 1687,
    "deathYear": 1757,
    "birthDate": "13 Mar 1687",
    "deathDate": "18 Jan 1757",
    "burialDate": null,
    "christeningDate": "13 Mar 1687",
    "birthPlace": "Grosshöchstetten, Bern, Switzerland",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Grosshöchstetten, Bern, Switzerland",
    "fsId": "K8MZ-VWF",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Niklaus Krahenbuhl"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI854",
    "name": "Katharina Luginbühl",
    "sex": "F",
    "gen": 10,
    "slot": 89,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI497",
    "birthYear": 1689,
    "deathYear": null,
    "birthDate": "1689",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Höchstetten, Bern, Switzerland",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "KZD7-CD2",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Katharina Luginbuhl",
      "Katharina Luginbuhl Krahenbuhl"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI855",
    "name": "Hans Rudolf Aebi",
    "sex": "M",
    "gen": 10,
    "slot": 92,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI499",
    "birthYear": 1670,
    "deathYear": null,
    "birthDate": "Abt 1670",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Kirchberg, Bern, Switzerland",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "KHYG-5HC",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI856",
    "name": "Elsbeth Pauli",
    "sex": "F",
    "gen": 10,
    "slot": 93,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI499",
    "birthYear": 1679,
    "deathYear": null,
    "birthDate": "20 Jan 1679",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "20 Jan 1679",
    "birthPlace": "Bern, Switzerland",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Kirchberg, Bern, Switzerland",
    "fsId": "GFJN-VFL",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI857",
    "name": "Nicolaus Bracher",
    "sex": "M",
    "gen": 10,
    "slot": 94,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI500",
    "birthYear": null,
    "deathYear": null,
    "birthDate": null,
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "23 Dec 1667",
    "birthPlace": "Bern, Bern, Switzerland",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Rohrbach, Bern, Switzerland",
    "fsId": "96HS-6FD",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI858",
    "name": "Elsbeth Schwartzwald",
    "sex": "F",
    "gen": 10,
    "slot": 95,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI500",
    "birthYear": 1672,
    "deathYear": null,
    "birthDate": "11 Aug 1672",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "11 Aug 1672",
    "birthPlace": "Oberösch, Bern, Switzerland",
    "deathPlace": "Bern, Switzerland",
    "burialPlace": null,
    "christeningPlace": "Ersigen, Bern, Switzerland",
    "fsId": "GFJN-J2F",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI860",
    "name": "Johannes Krebs",
    "sex": "M",
    "gen": 10,
    "slot": 96,
    "side": "paternal",
    "birthplace": "france",
    "childId": "AQI501",
    "birthYear": 1703,
    "deathYear": 1749,
    "birthDate": "Abt 1703",
    "deathDate": "Abt 13 Sep 1749",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Calais, Pas-de-Calais, France",
    "deathPlace": "Kirchdorf, Bern, Switzerland",
    "burialPlace": null,
    "christeningPlace": "Mühledorf, Solothurn, Switzerland",
    "fsId": "M62P-QK9",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Hans Krebs"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI861",
    "name": "Elisabeth Meyer",
    "sex": "F",
    "gen": 10,
    "slot": 97,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI501",
    "birthYear": 1705,
    "deathYear": 1750,
    "birthDate": "Abt 1705",
    "deathDate": "18 Sep 1750",
    "burialDate": null,
    "christeningDate": "30 May 1705",
    "birthPlace": "Bern, Switzerland",
    "deathPlace": "Kirchdorf, Bern, Switzerland",
    "burialPlace": "Kirchdorf, Bern, Switzerland",
    "christeningPlace": "Kirchdorf, Bern, Switzerland",
    "fsId": "KC5M-8WZ",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Elsbeth Meyer"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI862",
    "name": "Abraham Meyer",
    "sex": "M",
    "gen": 10,
    "slot": 98,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI502",
    "birthYear": 1702,
    "deathYear": 1784,
    "birthDate": "6 Apr 1702",
    "deathDate": "22 Apr 1784",
    "burialDate": "24 Apr 1784",
    "christeningDate": "4 Jun 1702",
    "birthPlace": "Kirchdorf, Bern, Switzerland",
    "deathPlace": "Kirchdorf, Bern, Switzerland",
    "burialPlace": "Kirchdorf, Bern, Switzerland",
    "christeningPlace": "Kirchdorf, Bern, Switzerland",
    "fsId": "LB2W-8GD",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI863",
    "name": "Maria Kormann",
    "sex": "F",
    "gen": 10,
    "slot": 99,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI502",
    "birthYear": 1708,
    "deathYear": 1767,
    "birthDate": "1708",
    "deathDate": "19 Jun 1767",
    "burialDate": "21 Sep 1767",
    "christeningDate": "25 Nov 1708",
    "birthPlace": "Bern, Switzerland",
    "deathPlace": "Kirchdorf, Bern, Switzerland",
    "burialPlace": "Kirchdorf, Bern, Switzerland",
    "christeningPlace": "Gerzensee, Bern, Switzerland",
    "fsId": "MSFX-JH4",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Maria Kormann or Kornmann"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI864",
    "name": "Christian Grünig",
    "sex": "M",
    "gen": 10,
    "slot": 102,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI504",
    "birthYear": 1688,
    "deathYear": 1757,
    "birthDate": "1688",
    "deathDate": "Bef 1757",
    "burialDate": null,
    "christeningDate": "23 Sep 1688",
    "birthPlace": "Mühlethurnen, Bern, Switzerland",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Mühlethurnen, Bern, Switzerland",
    "fsId": "LJY6-N7D",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Christian Grunig"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI865",
    "name": "Anna Fischer",
    "sex": "F",
    "gen": 10,
    "slot": 103,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI504",
    "birthYear": 1685,
    "deathYear": 1764,
    "birthDate": "1685",
    "deathDate": "10 Feb 1764",
    "burialDate": "12 Feb 1764",
    "christeningDate": "25 Jan 1685",
    "birthPlace": "Niederbütschel, Rüeggisberg, Bern, Switzerland",
    "deathPlace": "Mühlethurnen, Bern, Switzerland",
    "burialPlace": "Mühlethurnen, Bern, Switzerland",
    "christeningPlace": "Rüeggisberg, Bern, Switzerland",
    "fsId": "LJYF-VNR",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI866",
    "name": "Hans Joss",
    "sex": "M",
    "gen": 10,
    "slot": 104,
    "side": "paternal",
    "birthplace": "unknown",
    "childId": "AQI505",
    "birthYear": null,
    "deathYear": 1769,
    "birthDate": null,
    "deathDate": "12 Mar 1769",
    "burialDate": null,
    "christeningDate": "19 Jul 1685",
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Herolfingen, Konolfingen, Bern, Switzerland",
    "fsId": "KNS1-LRH",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI867",
    "name": "Margreth Gehrig",
    "sex": "F",
    "gen": 10,
    "slot": 105,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI505",
    "birthYear": 1695,
    "deathYear": null,
    "birthDate": "Abt 1695",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Münsingen, Bern, Switzerland",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "KNS5-NGB",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Margreth Guhrig"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI494s106",
    "name": "Hans Maurer",
    "sex": "M",
    "gen": 10,
    "slot": 106,
    "side": "paternal",
    "birthplace": "unknown",
    "childId": "AQI506",
    "birthYear": 1695,
    "deathYear": 1751,
    "birthDate": "1695",
    "deathDate": "21 Feb 1751",
    "burialDate": "21 Feb 1751",
    "christeningDate": "9 Aug 1695",
    "birthPlace": null,
    "deathPlace": "Vechigen, Bern, Switzerland",
    "burialPlace": "Vechigen, Bern, Switzerland",
    "christeningPlace": "Vechigen, Bern, Switzerland",
    "fsId": "LCGN-G2K",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI495s107",
    "name": "Magdalena Schwyzer",
    "sex": "F",
    "gen": 10,
    "slot": 107,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI506",
    "birthYear": 1695,
    "deathYear": 1781,
    "birthDate": "1695",
    "deathDate": "6 Jan 1781",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Vechigen, Bern, Switzerland",
    "deathPlace": "Vechigen, Bern, Switzerland",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "2RB7-BW2",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Magdalena Schwyzer Maurer"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI870",
    "name": "Hans Keller",
    "sex": "M",
    "gen": 10,
    "slot": 108,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI507",
    "birthYear": 1715,
    "deathYear": 1782,
    "birthDate": "Abt 1715",
    "deathDate": "6 Mar 1782",
    "burialDate": "6 Mar 1782",
    "christeningDate": null,
    "birthPlace": "Oberthal, Bern, Switzerland",
    "deathPlace": "Münsingen, Bern, Switzerland",
    "burialPlace": "Münsingen, Bern, Switzerland",
    "christeningPlace": null,
    "fsId": "KH79-Q1Y",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI871",
    "name": "Elizabeth Bluem",
    "sex": "F",
    "gen": 10,
    "slot": 109,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI507",
    "birthYear": 1723,
    "deathYear": null,
    "birthDate": "Abt 1723",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Oberthal, Bern, Switzerland",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "KCGQ-GYZ",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Elizabetha Blum Keller"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI872",
    "name": "Hans Ulrich Probst",
    "sex": "M",
    "gen": 10,
    "slot": 112,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI509",
    "birthYear": 1695,
    "deathYear": 1744,
    "birthDate": "1695",
    "deathDate": "19 Dec 1744",
    "burialDate": null,
    "christeningDate": "14 Jan 1695",
    "birthPlace": "Lützelflüh, Bern, Switzerland",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Lützelflüh, Bern, Switzerland",
    "fsId": "L4QG-81S",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Hans Ulrich",
      "Christian Probst"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI873",
    "name": "Elisbeth Dietschi",
    "sex": "F",
    "gen": 10,
    "slot": 113,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI509",
    "birthYear": 1697,
    "deathYear": 1746,
    "birthDate": "1697",
    "deathDate": "2 Jan 1746",
    "burialDate": null,
    "christeningDate": "7 Feb 1697",
    "birthPlace": "Oberburg, Bern, Switzerland",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Oberburg, Bern, Switzerland",
    "fsId": "LQRX-1NB",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Elisbeth Dietsch",
      "Elsbeth Dielschi",
      "Elsbeth Dietsch",
      "Elsbeth Dietschi",
      "Elsbeth Dietschi Probst",
      "Elsbeth Diettsch",
      "Elsbetha Rychard",
      "Elsbeth Rychard Probst"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI874",
    "name": "Steffan Schindler",
    "sex": "M",
    "gen": 10,
    "slot": 114,
    "side": "paternal",
    "birthplace": "unknown",
    "childId": "AQI510",
    "birthYear": 1676,
    "deathYear": 1760,
    "birthDate": "1676",
    "deathDate": "29 Aug 1760",
    "burialDate": "31 Aug 1760",
    "christeningDate": null,
    "birthPlace": null,
    "deathPlace": "Langnau im Emmental, Bern, Switzerland",
    "burialPlace": "Langnau im Emmental, Bern, Switzerland",
    "christeningPlace": "Langnau im Emmental, Bern, Switzerland",
    "fsId": "K2XS-TWY",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI875",
    "name": "Ursula Koeppli",
    "sex": "F",
    "gen": 10,
    "slot": 115,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI510",
    "birthYear": 1691,
    "deathYear": null,
    "birthDate": "Abt 1691",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Herzogenbuchsee, Bern, Switzerland",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "L7JV-4DN",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI876",
    "name": "Michel Schertenleib",
    "sex": "M",
    "gen": 10,
    "slot": 116,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI511",
    "birthYear": 1704,
    "deathYear": null,
    "birthDate": "8 Jun 1704",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "8 Jun 1704",
    "birthPlace": "Krauchthal, Bern, Switzerland",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Lützelflüh, Bern, Switzerland",
    "fsId": "MR9D-443",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI877",
    "name": "Katharina Hirsel",
    "sex": "F",
    "gen": 10,
    "slot": 117,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI511",
    "birthYear": 1705,
    "deathYear": null,
    "birthDate": "Abt 1705",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Biglen, Bern, Switzerland",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "KF5B-L75",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Katharina Hirzel"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI878",
    "name": "Hans Jakob Rufer",
    "sex": "M",
    "gen": 10,
    "slot": 118,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI512",
    "birthYear": 1712,
    "deathYear": null,
    "birthDate": "Abt 1712",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Bern, Switzerland",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "GVM6-SZT",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI879",
    "name": "Christen Steiner",
    "sex": "M",
    "gen": 10,
    "slot": 120,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI513",
    "birthYear": 1716,
    "deathYear": 1797,
    "birthDate": "13 Jun 1716",
    "deathDate": "21 Jan 1797",
    "burialDate": null,
    "christeningDate": "13 Jun 1716",
    "birthPlace": "Trachselwald, Bern, Switzerland",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Trachselwald, Bern, Switzerland",
    "fsId": "KZLM-WKQ",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Christian Steiner"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI880",
    "name": "Anna Hofer",
    "sex": "F",
    "gen": 10,
    "slot": 121,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI513",
    "birthYear": 1709,
    "deathYear": 1784,
    "birthDate": "1709",
    "deathDate": "23 Dec 1784",
    "burialDate": "26 Dec 1784",
    "christeningDate": null,
    "birthPlace": "Bern, Switzerland",
    "deathPlace": "Trachselwald, Bern, Switzerland",
    "burialPlace": "Trachselwald, Bern, Switzerland",
    "christeningPlace": null,
    "fsId": "2MBY-2LJ",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Elisa Hofer",
      "Anna Elisa Hofer"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI881",
    "name": "Peter Aeschbacher",
    "sex": "M",
    "gen": 10,
    "slot": 124,
    "side": "paternal",
    "birthplace": "switzerland",
    "childId": "AQI515",
    "birthYear": 1698,
    "deathYear": null,
    "birthDate": "Abt 1698",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Lauperswil, Bern, Switzerland",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LH8Y-RFW",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Peter"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI882",
    "name": "Barbara Buhlman",
    "sex": "F",
    "gen": 10,
    "slot": 125,
    "side": "paternal",
    "birthplace": "germany",
    "childId": "AQI515",
    "birthYear": 1698,
    "deathYear": 1777,
    "birthDate": "5 Jun 1698",
    "deathDate": "1 May 1777",
    "burialDate": null,
    "christeningDate": "5 Jun 1698",
    "birthPlace": "Degernau, Waldshut, Baden, Germany",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Schwerzen, Wutöschingen, Waldshut, Baden, Germany",
    "fsId": "K8ZG-HJ9",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Barbara Buhlman Aeschbacher",
      "Barbara Buhlmann"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI893",
    "name": "Henry Huddleston",
    "sex": "M",
    "gen": 10,
    "slot": 144,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI527",
    "birthYear": 1690,
    "deathYear": null,
    "birthDate": "1690",
    "deathDate": null,
    "burialDate": "11 Dec 1766",
    "christeningDate": "15 Sep 1690",
    "birthPlace": "Grasmere, Westmorland, England",
    "deathPlace": null,
    "burialPlace": "Hawkshead, Lancashire, England",
    "christeningPlace": "Grasmere, Westmorland, England",
    "fsId": "L7G9-BRY",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Henery Hudlestone",
      "Henry Huddlestone",
      "Henry Hudleston",
      "Henry Hudlestone"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI894",
    "name": "Bridget Banks",
    "sex": "F",
    "gen": 10,
    "slot": 145,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI527",
    "birthYear": 1699,
    "deathYear": 1760,
    "birthDate": "Abt 1699",
    "deathDate": "Abt 1760",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Grasmere, Westmorland, England",
    "deathPlace": "Lancashire, England",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "GZPC-PXN",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI895",
    "name": "William Langhorn",
    "sex": "M",
    "gen": 10,
    "slot": 146,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI528",
    "birthYear": 1715,
    "deathYear": null,
    "birthDate": "Abt 1715",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "8 Feb 1714",
    "birthPlace": "Westmorland, England, United Kingdom",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Kirkby Thore, Westmorland, England, United Kingdom",
    "fsId": "L754-SS6",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Wm Langhorn",
      "Wm Langhorne",
      "Wm. Langhorn",
      "William Langhorne"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI896",
    "name": "Elizabeth Bownas",
    "sex": "F",
    "gen": 10,
    "slot": 147,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI528",
    "birthYear": 1715,
    "deathYear": null,
    "birthDate": "Abt 1715",
    "deathDate": null,
    "burialDate": "25 Nov 1787",
    "christeningDate": null,
    "birthPlace": "Westmorland, England, United Kingdom",
    "deathPlace": null,
    "burialPlace": "Cumbria, England, United Kingdom",
    "christeningPlace": null,
    "fsId": "MKVG-JGF",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Eliz",
      "Eliza.",
      "Elizabeth"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI897",
    "name": "Robert Evans",
    "sex": "M",
    "gen": 10,
    "slot": 160,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI533",
    "birthYear": 1693,
    "deathYear": null,
    "birthDate": "Abt 1693",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Bridgemere, Cheshire, England, United Kingdom",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "KZF3-29P",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI898",
    "name": "Martha Matthews",
    "sex": "F",
    "gen": 10,
    "slot": 161,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI533",
    "birthYear": 1697,
    "deathYear": null,
    "birthDate": "Abt 1697",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Bridgemere, Cheshire, England, United Kingdom",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "MFQD-QFR",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI899",
    "name": "David Lewis",
    "sex": "M",
    "gen": 10,
    "slot": 168,
    "side": "paternal",
    "birthplace": "wales",
    "childId": "AQI535",
    "birthYear": 1700,
    "deathYear": null,
    "birthDate": "1700",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Glamorgan, Wales",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "G1X7-6KR",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI900",
    "name": "Mary Powell",
    "sex": "F",
    "gen": 10,
    "slot": 169,
    "side": "paternal",
    "birthplace": "wales",
    "childId": "AQI535",
    "birthYear": 1700,
    "deathYear": null,
    "birthDate": "1700",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "26 Dec 1700",
    "birthPlace": "Glamorgan, Wales",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Kenfig, Glamorgan, Wales",
    "fsId": "G1X7-WKG",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Mary Powel",
      "Mrs David Lewis"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI901",
    "name": "Jenkin Williams",
    "sex": "M",
    "gen": 10,
    "slot": 170,
    "side": "paternal",
    "birthplace": "wales",
    "childId": "AQI536",
    "birthYear": 1703,
    "deathYear": 1767,
    "birthDate": "Apr 1703",
    "deathDate": "Apr 1767",
    "burialDate": "10 Apr 1767",
    "christeningDate": "26 Apr 1703",
    "birthPlace": "Cray, Breconshire, Wales, United Kingdom",
    "deathPlace": "Llywel, Breconshire, Wales, United Kingdom",
    "burialPlace": "Llywel, Breconshire, Wales, United Kingdom",
    "christeningPlace": "Devynock, Breconshire, Wales, United Kingdom",
    "fsId": "LCQH-M5K",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI902",
    "name": "Jennett Llewelyn",
    "sex": "F",
    "gen": 10,
    "slot": 171,
    "side": "paternal",
    "birthplace": "wales",
    "childId": "AQI536",
    "birthYear": 1710,
    "deathYear": null,
    "birthDate": "Abt 1710",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Llangyfelach, Glamorgan, Wales, United Kingdom",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "L66Z-CHL",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI903",
    "name": "Henry Griffiths",
    "sex": "M",
    "gen": 10,
    "slot": 198,
    "side": "paternal",
    "birthplace": "wales",
    "childId": "AQI538",
    "birthYear": 1682,
    "deathYear": null,
    "birthDate": "Abt 1682",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Llangendeirne, Carmarthenshire, Wales",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "GD3P-SJ5",
    "photo": "/ancestors/bubbles/1222_GD3P-SJ5.jpg",
    "living": false,
    "alternateNames": [
      "Henry Griffith"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1222_GD3P-SJ5.jpg"
  },
  {
    "id": "AQI904",
    "name": "Jane John",
    "sex": "F",
    "gen": 10,
    "slot": 199,
    "side": "paternal",
    "birthplace": "unknown",
    "childId": "AQI538",
    "birthYear": null,
    "deathYear": null,
    "birthDate": null,
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "29 Jun 1687",
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Llangendeirne, Carmarthenshire, Wales",
    "fsId": "K69M-F67",
    "photo": "/ancestors/bubbles/1223_K69M-F67.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1223_K69M-F67.jpg"
  },
  {
    "id": "AQI905",
    "name": "George Adams",
    "sex": "M",
    "gen": 10,
    "slot": 216,
    "side": "paternal",
    "birthplace": "unknown",
    "childId": "AQI539",
    "birthYear": null,
    "deathYear": null,
    "birthDate": null,
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "5 Sep 1715",
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Halesowen, Worcestershire, England, United Kingdom",
    "fsId": "M2PG-YG9",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI906",
    "name": "Jane Partridge",
    "sex": "F",
    "gen": 10,
    "slot": 217,
    "side": "paternal",
    "birthplace": "unknown",
    "childId": "AQI539",
    "birthYear": null,
    "deathYear": null,
    "birthDate": null,
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "16 Sep 1721",
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Halesowen, Worcestershire, England, United Kingdom",
    "fsId": "MF1K-68F",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI907",
    "name": "Samuel Farmer",
    "sex": "M",
    "gen": 10,
    "slot": 222,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI542",
    "birthYear": 1725,
    "deathYear": null,
    "birthDate": "Abt 1725",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Halesowen, Worcestershire, England, United Kingdom",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "M25X-HNK",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI908",
    "name": "Ann Thompson",
    "sex": "F",
    "gen": 10,
    "slot": 223,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI542",
    "birthYear": 1729,
    "deathYear": null,
    "birthDate": "Abt 1729",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Halesowen, Worcestershire, England, United Kingdom",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LZGZ-MST",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI909",
    "name": "Edward Dredge",
    "sex": "M",
    "gen": 10,
    "slot": 224,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI543",
    "birthYear": null,
    "deathYear": 1757,
    "birthDate": null,
    "deathDate": "31 Aug 1757",
    "burialDate": null,
    "christeningDate": "16 Mar 1697",
    "birthPlace": "Frome, Somerset, England, United Kingdom",
    "deathPlace": "Marston Bigot, Somerset, England, United Kingdom",
    "burialPlace": null,
    "christeningPlace": "Frome, Somerset, England, United Kingdom",
    "fsId": "L5NN-2M3",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Ederd Dredg"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI910",
    "name": "Jane Hipstone",
    "sex": "F",
    "gen": 10,
    "slot": 225,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI543",
    "birthYear": 1700,
    "deathYear": 1733,
    "birthDate": "Abt 1700",
    "deathDate": "Dec 1733",
    "burialDate": "27 Dec 1733",
    "christeningDate": "5 Sep 1702",
    "birthPlace": "Frome, Somerset, England, United Kingdom",
    "deathPlace": "Frome, Somerset, England",
    "burialPlace": "Frome, Somerset, England",
    "christeningPlace": "Frome, Somerset, England, United Kingdom",
    "fsId": "MBX5-CH7",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI911",
    "name": "John Payne",
    "sex": "M",
    "gen": 10,
    "slot": 226,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI544",
    "birthYear": 1682,
    "deathYear": null,
    "birthDate": "1682",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "12 Jul 1682",
    "birthPlace": "England",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Warminster, Wiltshire, England",
    "fsId": "K8TS-V8B",
    "photo": null,
    "living": false,
    "alternateNames": [
      "John Pain"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI912",
    "name": "Anne Waters",
    "sex": "F",
    "gen": 10,
    "slot": 227,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI544",
    "birthYear": 1688,
    "deathYear": 1729,
    "birthDate": "24 Apr 1688",
    "deathDate": "14 May 1729",
    "burialDate": "14 May 1729",
    "christeningDate": "24 Apr 1688",
    "birthPlace": "Longbridge Deverill, Wiltshire, England, United Kingdom",
    "deathPlace": "Longbridge Deverill, Wiltshire, England, United Kingdom",
    "burialPlace": "Longbridge Deverill, Wiltshire, England",
    "christeningPlace": "Longbridge Deverill, Wiltshire, England, United Kingdom",
    "fsId": "LHK7-74R",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI913",
    "name": "George Yeates",
    "sex": "M",
    "gen": 10,
    "slot": 228,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI545",
    "birthYear": 1681,
    "deathYear": 1744,
    "birthDate": "1681",
    "deathDate": "Dec 1744",
    "burialDate": "10 Dec 1744",
    "christeningDate": "26 May 1681",
    "birthPlace": "Heytesbury, Wiltshire, England, United Kingdom",
    "deathPlace": null,
    "burialPlace": "Heytesbury, Wiltshire, England, United Kingdom",
    "christeningPlace": "Heytesbury, Wiltshire, England, United Kingdom",
    "fsId": "L7TP-FWD",
    "photo": null,
    "living": false,
    "alternateNames": [
      "George",
      "George Yates"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI914",
    "name": "Margaret James",
    "sex": "F",
    "gen": 10,
    "slot": 229,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI545",
    "birthYear": 1685,
    "deathYear": 1757,
    "birthDate": "1685",
    "deathDate": "Sep 1757",
    "burialDate": "6 Sep 1757",
    "christeningDate": "Abt 9 Aug 1691",
    "birthPlace": "Heytesbury, Wiltshire, England, United Kingdom",
    "deathPlace": null,
    "burialPlace": "Heytesbury, Wiltshire, England, United Kingdom",
    "christeningPlace": "West Lavington, Wiltshire, England, United Kingdom",
    "fsId": "K2F1-3XQ",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Margaret",
      "Mrs. Margaret Yeates"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI915",
    "name": "Edmund Nelson",
    "sex": "M",
    "gen": 10,
    "slot": 240,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI550",
    "birthYear": 1693,
    "deathYear": 1747,
    "birthDate": "4 Nov 1693",
    "deathDate": "23 Oct 1747",
    "burialDate": "23 Oct 1747",
    "christeningDate": "4 Nov 1693",
    "birthPlace": "Sporle, Norfolk, England",
    "deathPlace": "Hilborough, Norfolk, England",
    "burialPlace": "Hilborough, Norfolk, England, United Kingdom",
    "christeningPlace": "Little Dunham, Norfolk, England",
    "fsId": "K25K-LB5",
    "photo": "/ancestors/bubbles/1264_K25K-LB5.jpg",
    "living": false,
    "alternateNames": [
      "Rector of Hillborough Norfolk Edmund Nelson"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1264_K25K-LB5.jpg"
  },
  {
    "id": "AQI916",
    "name": "Mary Bland",
    "sex": "F",
    "gen": 10,
    "slot": 241,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI550",
    "birthYear": 1698,
    "deathYear": 1789,
    "birthDate": "24 Aug 1698",
    "deathDate": "4 Jul 1789",
    "burialDate": "8 Jul 1789",
    "christeningDate": null,
    "birthPlace": "Cambridge, Cambridgeshire, England",
    "deathPlace": "Hilborough, Norfolk, England",
    "burialPlace": "Hilborough, Norfolk, England",
    "christeningPlace": null,
    "fsId": "LHFD-HS1",
    "photo": "/ancestors/bubbles/1265_LHFD-HS1.jpg",
    "living": false,
    "alternateNames": [
      "Mrs- Edmund Nelson",
      "Mary Bland Nelson",
      "Mary"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1265_LHFD-HS1.jpg"
  },
  {
    "id": "AQI917",
    "name": "Maurice Suckling",
    "sex": "M",
    "gen": 10,
    "slot": 242,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI551",
    "birthYear": 1676,
    "deathYear": 1730,
    "birthDate": "1676",
    "deathDate": "21 Sep 1730",
    "burialDate": "23 Sep 1730",
    "christeningDate": "15 May 1676",
    "birthPlace": "Woodton, Norfolk, England",
    "deathPlace": "Burnham Thorpe, Norfolk, England, United Kingdom",
    "burialPlace": "West Barsham, Norfolk, England, United Kingdom",
    "christeningPlace": "Woodton, Norfolk, England",
    "fsId": "M6QS-YTN",
    "photo": "/ancestors/bubbles/1266_M6QS-YTN.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1266_M6QS-YTN.jpg"
  },
  {
    "id": "AQI918",
    "name": "Mary Anne Turner",
    "sex": "F",
    "gen": 10,
    "slot": 243,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI551",
    "birthYear": 1693,
    "deathYear": 1768,
    "birthDate": "28 Apr 1693",
    "deathDate": "5 Jul 1768",
    "burialDate": "5 Jul 1768",
    "christeningDate": "30 Apr 1693",
    "birthPlace": "Warham, Norfolk, England",
    "deathPlace": "Burnham Thorpe, Norfolk, England",
    "burialPlace": null,
    "christeningPlace": "Houghton, Norfolk, England",
    "fsId": "MRHV-17M",
    "photo": "/ancestors/bubbles/1267_MRHV-17M.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1267_MRHV-17M.jpg"
  },
  {
    "id": "AQI919",
    "name": "Nicholas Rhees",
    "sex": "M",
    "gen": 10,
    "slot": 244,
    "side": "paternal",
    "birthplace": "unknown",
    "childId": "AQI552",
    "birthYear": null,
    "deathYear": 1776,
    "birthDate": null,
    "deathDate": "30 Dec 1776",
    "burialDate": null,
    "christeningDate": "29 Dec 1720",
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Castle, Montgomeryshire, Wales, United Kingdom",
    "fsId": "KNZL-XDT",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI920",
    "name": "Margaret",
    "sex": "F",
    "gen": 10,
    "slot": 245,
    "side": "paternal",
    "birthplace": "unknown",
    "childId": "AQI552",
    "birthYear": null,
    "deathYear": null,
    "birthDate": null,
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "Abt 1725",
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Blaina, Monmouthshire, Wales, United Kingdom",
    "fsId": "KNZG-7TG",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Mrs Margaret Rhees"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI921",
    "name": "James Green",
    "sex": "M",
    "gen": 10,
    "slot": 248,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI554",
    "birthYear": 1724,
    "deathYear": null,
    "birthDate": "1724",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "16 Aug 1724",
    "birthPlace": "England",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Bath, Somerset, England",
    "fsId": "M4TY-FV5",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI922",
    "name": "James Green",
    "sex": "F",
    "gen": 10,
    "slot": 249,
    "side": "paternal",
    "birthplace": "unknown",
    "childId": "AQI554",
    "birthYear": null,
    "deathYear": null,
    "birthDate": null,
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LDL5-9Z6",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Mrs James Green"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI923",
    "name": "William Warburton",
    "sex": "M",
    "gen": 10,
    "slot": 250,
    "side": "paternal",
    "birthplace": "unknown",
    "childId": "AQI555",
    "birthYear": null,
    "deathYear": null,
    "birthDate": null,
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "K2RW-VPX",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI924",
    "name": "Ann",
    "sex": "F",
    "gen": 10,
    "slot": 251,
    "side": "paternal",
    "birthplace": "unknown",
    "childId": "AQI555",
    "birthYear": null,
    "deathYear": null,
    "birthDate": null,
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "9KQW-ZZS",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI925",
    "name": "Daniel Charmbury",
    "sex": "M",
    "gen": 10,
    "slot": 252,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI556",
    "birthYear": 1730,
    "deathYear": 1780,
    "birthDate": "Abt 1730",
    "deathDate": "13 Jul 1780",
    "burialDate": "13 Jul 1780",
    "christeningDate": null,
    "birthPlace": "Monkton Combe, Somerset, England, United Kingdom",
    "deathPlace": "Somerset, England",
    "burialPlace": "Claverton, Somerset, England",
    "christeningPlace": null,
    "fsId": "KNYK-WQ1",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Daniel",
      "Daniel Charmby"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI926",
    "name": "Mary Matthews",
    "sex": "F",
    "gen": 10,
    "slot": 253,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI556",
    "birthYear": 1733,
    "deathYear": 1774,
    "birthDate": "Abt 1733",
    "deathDate": "5 Jun 1774",
    "burialDate": "13 Jun 1774",
    "christeningDate": "15 Feb 1733",
    "birthPlace": "Bath, Somerset, England, United Kingdom",
    "deathPlace": "Somerset, England, United Kingdom",
    "burialPlace": "Claverton, Somerset, England, United Kingdom",
    "christeningPlace": "Bath, Somerset, England, United Kingdom",
    "fsId": "KNYK-LVN",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Mary Lydiat"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI927",
    "name": "Peter Marchant",
    "sex": "M",
    "gen": 10,
    "slot": 254,
    "side": "paternal",
    "birthplace": "unknown",
    "childId": "AQI557",
    "birthYear": null,
    "deathYear": null,
    "birthDate": null,
    "deathDate": null,
    "burialDate": "6 Nov 1762",
    "christeningDate": "2 Mar 1735",
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": "Hurstpierpoint, Sussex, England, United Kingdom",
    "christeningPlace": "Horsham, Sussex, England, United Kingdom",
    "fsId": "KH1W-52F",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI928",
    "name": "Sarah Longhurst",
    "sex": "F",
    "gen": 10,
    "slot": 255,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI557",
    "birthYear": 1738,
    "deathYear": 1793,
    "birthDate": "Abt 1738",
    "deathDate": "6 Sep 1793",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Lyminster, Sussex, England, United Kingdom",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "MNV4-D3S",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI929",
    "name": "Jabez Hull",
    "sex": "M",
    "gen": 10,
    "slot": 256,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI558",
    "birthYear": 1706,
    "deathYear": 1771,
    "birthDate": "1706",
    "deathDate": "Bef 4 Oct 1771",
    "burialDate": null,
    "christeningDate": "10 Feb 1706",
    "birthPlace": "Fairfield, Fairfield, Connecticut Colony, British Colonial America",
    "deathPlace": "Salem Center, Westchester, New York Colony, British Colonial America",
    "burialPlace": null,
    "christeningPlace": "Fairfield, Connecticut Colony, British Colonial America",
    "fsId": "2MRX-KYD",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Hull",
      "Jabesh Hull",
      "Jabez"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI930",
    "name": "Mary Thorpe",
    "sex": "F",
    "gen": 10,
    "slot": 257,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI558",
    "birthYear": 1705,
    "deathYear": null,
    "birthDate": "17 Feb 1705",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "24 Mar 1705",
    "birthPlace": "Westport, Fairfield, Connecticut Colony, British Colonial America",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Greenfield Hill, Fairfield, Fairfield, Connecticut Colony, British Colonial America",
    "fsId": "LD8F-VRF",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Mary Thorpe Hull"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI931",
    "name": "Joseph Munroe",
    "sex": "M",
    "gen": 10,
    "slot": 258,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI559",
    "birthYear": 1727,
    "deathYear": 1796,
    "birthDate": "Abt 1727",
    "deathDate": "Abt 1796",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Norwalk, Fairfield, Connecticut Colony, British Colonial America",
    "deathPlace": "Salem Center, North Salem, Westchester, New York, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "9KLB-VK7",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI932",
    "name": "Deborah Beers",
    "sex": "F",
    "gen": 10,
    "slot": 259,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI559",
    "birthYear": 1728,
    "deathYear": 1755,
    "birthDate": "1728",
    "deathDate": "Dec 1755",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Westport, Fairfield, Connecticut, United States",
    "deathPlace": "Lewisboro, Westchester, New York, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LHL3-9CT",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Deborah Monroe"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI938",
    "name": "Jacob Vinal",
    "sex": "M",
    "gen": 10,
    "slot": 260,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI562",
    "birthYear": 1719,
    "deathYear": 1783,
    "birthDate": "15 Apr 1719",
    "deathDate": "from 1 April 1783 to 19 December 1786",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Scituate, Plymouth, Massachusetts Bay Colony, British Colonial America",
    "deathPlace": "Scituate, Plymouth, Massachusetts, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LBFG-9SD",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI939",
    "name": "Lydia Holbrook",
    "sex": "F",
    "gen": 10,
    "slot": 261,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI562",
    "birthYear": 1722,
    "deathYear": 1750,
    "birthDate": "13 Jun 1722",
    "deathDate": "13 Oct 1750",
    "burialDate": "Oct 1750",
    "christeningDate": "14 Jul 1723",
    "birthPlace": "Scituate, Plymouth, Massachusetts, United States",
    "deathPlace": "Scituate, Plymouth, Massachusetts, United States",
    "burialPlace": "Groveland Cemetery, Scituate, Plymouth, Massachusetts, United States",
    "christeningPlace": "Scituate, Plymouth, Massachusetts, United States",
    "fsId": "LW5M-64Z",
    "photo": "/ancestors/bubbles/1285_LW5M-64Z.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1285_LW5M-64Z.jpg"
  },
  {
    "id": "AQI942",
    "name": "Ignatias Vinal",
    "sex": "M",
    "gen": 10,
    "slot": 262,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI563",
    "birthYear": 1717,
    "deathYear": 1796,
    "birthDate": "30 Oct 1717",
    "deathDate": "1796",
    "burialDate": "1796",
    "christeningDate": "30 Jun 1745",
    "birthPlace": "Scituate, Plymouth, Massachusetts, United States",
    "deathPlace": "Scituate, Plymouth, Massachusetts, United States",
    "burialPlace": "Scituate, Plymouth, Massachusetts, United States",
    "christeningPlace": null,
    "fsId": "KP71-7H9",
    "photo": "/ancestors/bubbles/1286_KP71-7H9.jpg",
    "living": false,
    "alternateNames": [
      "Ignatious Vinal",
      "Ignatius Vinal"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1286_KP71-7H9.jpg"
  },
  {
    "id": "AQI943",
    "name": "Patience Elmes",
    "sex": "F",
    "gen": 10,
    "slot": 263,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI563",
    "birthYear": 1737,
    "deathYear": 1773,
    "birthDate": "27 Mar 1737",
    "deathDate": "27 Mar 1773",
    "burialDate": "1773",
    "christeningDate": "27 Mar 1737",
    "birthPlace": "Scituate, Plymouth, Massachusetts, United States",
    "deathPlace": "Scituate, Plymouth, Massachusetts Bay Colony, British Colonial America",
    "burialPlace": "Men Of Kent Cemetery, Scituate, Plymouth, Massachusetts, United States",
    "christeningPlace": "Scituate, Plymouth, Massachusetts Bay Colony, British Colonial America",
    "fsId": "KP7B-TH5",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Patience Ellms",
      "Patience Elms",
      "Patience Elmes Vinal"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI944",
    "name": "Solomon Dewey",
    "sex": "M",
    "gen": 10,
    "slot": 268,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI564",
    "birthYear": 1724,
    "deathYear": 1819,
    "birthDate": "29 Apr 1724",
    "deathDate": "2 May 1819",
    "burialDate": "May 1819",
    "christeningDate": null,
    "birthPlace": "Lebanon, New London, Connecticut Colony, British Colonial America",
    "deathPlace": "Lebanon, New London, Connecticut, United States",
    "burialPlace": "Old Yard Cemetery, Columbia, Tolland, Connecticut, United States",
    "christeningPlace": null,
    "fsId": "LTLK-FNS",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI945",
    "name": "Anna Downer",
    "sex": "F",
    "gen": 10,
    "slot": 269,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI564",
    "birthYear": 1729,
    "deathYear": 1768,
    "birthDate": "18 Mar 1729",
    "deathDate": "31 Dec 1768",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Norwich, New London, Connecticut Colony, British Colonial America",
    "deathPlace": "Norwich, New London, Connecticut Colony, British Colonial America",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LTLK-6RL",
    "photo": "/ancestors/bubbles/1293_LTLK-6RL.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1293_LTLK-6RL.jpg"
  },
  {
    "id": "AQI946",
    "name": "Lemuel Woodworth",
    "sex": "M",
    "gen": 10,
    "slot": 270,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI565",
    "birthYear": 1735,
    "deathYear": 1808,
    "birthDate": "25 Jun 1735",
    "deathDate": "15 Aug 1808",
    "burialDate": "Aug 1808",
    "christeningDate": null,
    "birthPlace": "Lebanon, New London, Connecticut Colony, British Colonial America",
    "deathPlace": "Fenner, Fenner, Madison, New York, United States",
    "burialPlace": "Fenner, Madison, New York, United States",
    "christeningPlace": null,
    "fsId": "LH7Q-NKF",
    "photo": "/ancestors/bubbles/1294_LH7Q-NKF.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1294_LH7Q-NKF.jpg"
  },
  {
    "id": "AQI947",
    "name": "Elizabeth Hunt",
    "sex": "F",
    "gen": 10,
    "slot": 271,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI565",
    "birthYear": 1741,
    "deathYear": 1794,
    "birthDate": "2 Jan 1741",
    "deathDate": "29 Nov 1794",
    "burialDate": "1794",
    "christeningDate": "1741",
    "birthPlace": "Norwich, New London, Connecticut Colony, British Colonial America",
    "deathPlace": "Fenner, Fenner, Madison, New York, United States",
    "burialPlace": "Woodworth Cemetery, Ruby Corner, Macomb, St. Lawrence, New York, United States",
    "christeningPlace": "Ipswich, Essex, Massachusetts Bay Colony, British Colonial America",
    "fsId": "LH7Q-NL3",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI948",
    "name": "Alexander Lindsay",
    "sex": "M",
    "gen": 10,
    "slot": 272,
    "side": "paternal",
    "birthplace": "scotland",
    "childId": "AQI566",
    "birthYear": 1679,
    "deathYear": 1758,
    "birthDate": "9 Nov 1679",
    "deathDate": "Aft 1758",
    "burialDate": null,
    "christeningDate": "9 Nov 1679",
    "birthPlace": "Forfarshire, Scotland",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Forfarshire, Scotland",
    "fsId": "L8BN-GXS",
    "photo": "/ancestors/bubbles/1296_L8BN-GXS.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1296_L8BN-GXS.jpg"
  },
  {
    "id": "AQI949",
    "name": "Lydia Cross",
    "sex": "F",
    "gen": 10,
    "slot": 273,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI566",
    "birthYear": 1698,
    "deathYear": 1728,
    "birthDate": "Abt 1698",
    "deathDate": "Aft 1728",
    "burialDate": "Aft 1728",
    "christeningDate": "Abt 1698",
    "birthPlace": "Portsmouth, Rockingham, New Hampshire, British Colonial America",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Portsmouth, Rockingham, New Hampshire, British Colonial America",
    "fsId": "L6W9-FGG",
    "photo": "/ancestors/bubbles/1297_L6W9-FGG.jpg",
    "living": false,
    "alternateNames": [
      "Lyda Cross",
      "Lydia Croos",
      "MRS. Alexander Lindsay",
      "Lindsay"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1297_L6W9-FGG.jpg"
  },
  {
    "id": "AQI950",
    "name": "John Foster",
    "sex": "M",
    "gen": 10,
    "slot": 274,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI567",
    "birthYear": 1711,
    "deathYear": 1770,
    "birthDate": "31 Aug 1711",
    "deathDate": "1770",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Marblehead, Essex, Massachusetts, United States",
    "deathPlace": "Pelham, Hampshire, Massachusetts, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LR8C-V9D",
    "photo": null,
    "living": false,
    "alternateNames": [
      "James"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI951",
    "name": "Katherine Ragin",
    "sex": "F",
    "gen": 10,
    "slot": 275,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI567",
    "birthYear": 1707,
    "deathYear": 1770,
    "birthDate": "Abt 1707",
    "deathDate": "Aft 1770",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Middleton, Essex, Massachusetts, United States",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "L8BN-G6M",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Catharine",
      "Catharine Ragin",
      "Catherin Ragin",
      "Catherine",
      "Katehrin Ragin",
      "Foster",
      "Catharine Regan",
      "Catherine Ragin"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI952",
    "name": "James Bunker",
    "sex": "M",
    "gen": 10,
    "slot": 280,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI570",
    "birthYear": 1665,
    "deathYear": 1722,
    "birthDate": "1665",
    "deathDate": "1722",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "New Hampshire, British Colonial America",
    "deathPlace": "New Hampshire, British Colonial America",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "97Z2-9CJ",
    "photo": "/ancestors/bubbles/1304_97Z2-9CJ.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1304_97Z2-9CJ.jpg"
  },
  {
    "id": "AQI953",
    "name": "Anne Thomas",
    "sex": "F",
    "gen": 10,
    "slot": 281,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI570",
    "birthYear": 1675,
    "deathYear": 1718,
    "birthDate": "1675",
    "deathDate": "Abt 1718",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Durham, New Hampshire, British Colonial America",
    "deathPlace": "Dover, New Hampshire, British Colonial America",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LWF6-VJR",
    "photo": "/ancestors/bubbles/1305_LWF6-VJR.jpg",
    "living": false,
    "alternateNames": [
      "Anne"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1305_LWF6-VJR.jpg"
  },
  {
    "id": "AQI954",
    "name": "John Drew",
    "sex": "M",
    "gen": 10,
    "slot": 282,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI571",
    "birthYear": 1651,
    "deathYear": 1723,
    "birthDate": "1651",
    "deathDate": "23 Oct 1723",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Dover, Strafford, New Hampshire, British Colonial America",
    "deathPlace": "Dover, Strafford, New Hampshire, British Colonial America",
    "burialPlace": "Dover MM, Strafford, New Hampshire, British Colonial America",
    "christeningPlace": null,
    "fsId": "KCGL-8S7",
    "photo": "/ancestors/bubbles/1306_KCGL-8S7.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1306_KCGL-8S7.jpg"
  },
  {
    "id": "AQI955",
    "name": "Rebecca Cook",
    "sex": "F",
    "gen": 10,
    "slot": 283,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI571",
    "birthYear": 1693,
    "deathYear": 1758,
    "birthDate": "1693",
    "deathDate": "1758",
    "burialDate": null,
    "christeningDate": "11 Apr 1742",
    "birthPlace": "Dover, Strafford, New Hampshire, British Colonial America",
    "deathPlace": "Dover, Strafford, New Hampshire, British Colonial America",
    "burialPlace": null,
    "christeningPlace": "Dover, Strafford, New Hampshire, British Colonial America",
    "fsId": "LHZS-YY6",
    "photo": "/ancestors/bubbles/1307_LHZS-YY6.jpg",
    "living": false,
    "alternateNames": [
      "Rebecca Downs Cook",
      "Rebecca Starbuck",
      "Rebekah Cook"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1307_LHZS-YY6.jpg"
  },
  {
    "id": "AQI956",
    "name": "Joseph Benedict",
    "sex": "M",
    "gen": 10,
    "slot": 288,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI572",
    "birthYear": 1680,
    "deathYear": 1761,
    "birthDate": "1680",
    "deathDate": "4 Jul 1761",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Norwalk, Fairfield, Connecticut, United States",
    "deathPlace": "Litchfield, Litchfield, Connecticut Colony, British Colonial America",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LZPN-F9Y",
    "photo": "/ancestors/bubbles/1312_LZPN-F9Y.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1312_LZPN-F9Y.jpg"
  },
  {
    "id": "AQI957",
    "name": "Mary Groom",
    "sex": "F",
    "gen": 10,
    "slot": 289,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI572",
    "birthYear": 1690,
    "deathYear": null,
    "birthDate": "19 Nov 1690",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Stratford, Fairfield, Connecticut Colony, British Colonial America",
    "deathPlace": "New Milford, Litchfield, Connecticut, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LTVC-FJR",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI958",
    "name": "Samuel Castle",
    "sex": "M",
    "gen": 10,
    "slot": 290,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI573",
    "birthYear": 1704,
    "deathYear": 1781,
    "birthDate": "9 Aug 1704",
    "deathDate": "17 Nov 1781",
    "burialDate": "1781",
    "christeningDate": null,
    "birthPlace": "Woodbury, Litchfield, Connecticut Colony, British Colonial America",
    "deathPlace": "Woodbury, Litchfield, Connecticut, United States",
    "burialPlace": "Woodbury, Litchfield, Connecticut, United States",
    "christeningPlace": null,
    "fsId": "LKKM-C8W",
    "photo": "/ancestors/bubbles/1314_LKKM-C8W.jpg",
    "living": false,
    "alternateNames": [
      "Samuel Castle Sr."
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1314_LKKM-C8W.jpg"
  },
  {
    "id": "AQI959",
    "name": "Martha Seeley",
    "sex": "F",
    "gen": 10,
    "slot": 291,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI573",
    "birthYear": 1706,
    "deathYear": 1787,
    "birthDate": "30 Jun 1706",
    "deathDate": "28 Mar 1787",
    "burialDate": null,
    "christeningDate": "7 Jul 1706",
    "birthPlace": "Stratford, Fairfield, Connecticut Colony, British Colonial America",
    "deathPlace": "Roxbury, Litchfield, Connecticut, United States",
    "burialPlace": null,
    "christeningPlace": "Bridgeport, Fairfield, Connecticut Colony, British Colonial America",
    "fsId": "LKKM-C84",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI960",
    "name": "Isaac Bull",
    "sex": "M",
    "gen": 10,
    "slot": 292,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI574",
    "birthYear": 1708,
    "deathYear": 1789,
    "birthDate": "22 Jul 1708",
    "deathDate": "7 Oct 1789",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Jamestown, Newport, Rhode Island, United States",
    "deathPlace": "Quaker Hill, Pawling, Dutchess, New York, United States",
    "burialPlace": "Quaker Cemetery, Quaker Hill, Pawling, Dutchess, New York, United States",
    "christeningPlace": null,
    "fsId": "LHH9-77N",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI961",
    "name": "Rebecca Browning",
    "sex": "F",
    "gen": 10,
    "slot": 293,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI574",
    "birthYear": 1710,
    "deathYear": 1790,
    "birthDate": "Abt 1710",
    "deathDate": "Abt 1790",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "South Kingstown, Kings, Rhode Island, British Colonial America",
    "deathPlace": "Dutchess, New York Colony, British Colonial America",
    "burialPlace": "Quaker Cemetery, Quaker Hill, Pawling, Dutchess, New York, United States",
    "christeningPlace": null,
    "fsId": "LHH9-7WR",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI962",
    "name": "Josiah Smith",
    "sex": "M",
    "gen": 10,
    "slot": 294,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI575",
    "birthYear": 1706,
    "deathYear": 1776,
    "birthDate": "16 Sep 1706",
    "deathDate": "21 Feb 1776",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Milford, New Haven, Connecticut Colony, British Colonial America",
    "deathPlace": "New Milford, Litchfield, Connecticut, United States",
    "burialPlace": "Winsted, Litchfield, Connecticut, United States",
    "christeningPlace": null,
    "fsId": "L293-RSR",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Josiah Smith Sr."
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI963",
    "name": "Mary Oviatt",
    "sex": "F",
    "gen": 10,
    "slot": 295,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI575",
    "birthYear": 1706,
    "deathYear": 1775,
    "birthDate": "1 Apr 1706",
    "deathDate": "28 Feb 1775",
    "burialDate": "1775",
    "christeningDate": "24 Jun 1711",
    "birthPlace": "Milford, New Haven, Connecticut, United States",
    "deathPlace": "New Milford, Litchfield, Connecticut, United States",
    "burialPlace": "Paugasset, New Haven, Connecticut Colony, British Colonial America",
    "christeningPlace": "Milford, New Haven, Connecticut, United States",
    "fsId": "LZ86-NS1",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Martha Smith"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI966",
    "name": "Jedediah Wing",
    "sex": "M",
    "gen": 10,
    "slot": 296,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI576",
    "birthYear": 1697,
    "deathYear": 1763,
    "birthDate": "29 Jan 1697",
    "deathDate": "Abt 1763",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Rochester, Plymouth, Massachusetts, United States",
    "deathPlace": "Dutchess, New York, United States",
    "burialPlace": "Quaker Cemetery, Quaker Hill, Pawling, Dutchess, New York, United States",
    "christeningPlace": null,
    "fsId": "LH6G-9FQ",
    "photo": "/ancestors/bubbles/1320_LH6G-9FQ.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1320_LH6G-9FQ.jpg"
  },
  {
    "id": "AQI967",
    "name": "Elizabeth Gifford",
    "sex": "F",
    "gen": 10,
    "slot": 297,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI576",
    "birthYear": 1711,
    "deathYear": 1787,
    "birthDate": "Abt 1711",
    "deathDate": "5 Jan 1787",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Falmouth, Barnstable, Massachusetts, United States",
    "deathPlace": "Quaker Hill, Pawling, Dutchess, New York, United States",
    "burialPlace": "Quaker Hill, Pawling, Dutchess, New York, United States",
    "christeningPlace": null,
    "fsId": "LZR1-72J",
    "photo": "/ancestors/bubbles/1321_LZR1-72J.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1321_LZR1-72J.jpg"
  },
  {
    "id": "AQI968",
    "name": "Daniel Chase",
    "sex": "M",
    "gen": 10,
    "slot": 298,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI577",
    "birthYear": 1720,
    "deathYear": 1811,
    "birthDate": "9 Jan 1720",
    "deathDate": "1811",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Freetown, Bristol, Massachusetts, United States",
    "deathPlace": "Providence, Saratoga, New York, United States",
    "burialPlace": "Mapletown Cemetery, Hoosick, Rensselaer, New York, United States",
    "christeningPlace": null,
    "fsId": "LH14-DWT",
    "photo": "/ancestors/bubbles/1322_LH14-DWT.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1322_LH14-DWT.jpg"
  },
  {
    "id": "AQI969",
    "name": "Hannah Tallman",
    "sex": "F",
    "gen": 10,
    "slot": 299,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI577",
    "birthYear": 1715,
    "deathYear": 1758,
    "birthDate": "24 Nov 1715",
    "deathDate": "1758",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Tiverton, Newport, Rhode Island, United States",
    "deathPlace": "Pawling, Dutchess, New York, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "KNZS-QYS",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI970",
    "name": "John Wright",
    "sex": "M",
    "gen": 10,
    "slot": 306,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI579",
    "birthYear": 1717,
    "deathYear": 1790,
    "birthDate": "4 Jan 1717",
    "deathDate": "8 Jun 1790",
    "burialDate": "Jun 1790",
    "christeningDate": null,
    "birthPlace": "Chester Township, Chester, Pennsylvania, British Colonial America",
    "deathPlace": "Bush River, Newberry, South Carolina, United States",
    "burialPlace": "Bush River Baptist Church Cemetery, Newberry, South Carolina, United States",
    "christeningPlace": null,
    "fsId": "LBJT-232",
    "photo": "/ancestors/bubbles/1330_LBJT-232.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1330_LBJT-232.jpg"
  },
  {
    "id": "AQI971",
    "name": "Rachel Wells",
    "sex": "F",
    "gen": 10,
    "slot": 307,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI579",
    "birthYear": 1720,
    "deathYear": 1771,
    "birthDate": "27 May 1720",
    "deathDate": "23 Dec 1771",
    "burialDate": "23 Dec 1771",
    "christeningDate": "12 Jul 1721",
    "birthPlace": "Queen Anne, Prince George's, Maryland, British Colonial America",
    "deathPlace": "Bush River, Newberry, South Carolina, United States",
    "burialPlace": "Quaker Cemetery, Camden, Camden District, South Carolina, British Colonial America",
    "christeningPlace": "Westminster Parish, Anne Arundel, Maryland, British Colonial America",
    "fsId": "LZKP-4YG",
    "photo": "/ancestors/bubbles/1331_LZKP-4YG.jpg",
    "living": false,
    "alternateNames": [
      "Rachel Wright"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1331_LZKP-4YG.jpg"
  },
  {
    "id": "AQI972",
    "name": "William Jay",
    "sex": "M",
    "gen": 10,
    "slot": 308,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI580",
    "birthYear": 1720,
    "deathYear": 1773,
    "birthDate": "5 Sep 1720",
    "deathDate": "4 Mar 1773",
    "burialDate": "1773",
    "christeningDate": null,
    "birthPlace": "Westchester, Frederick, Maryland, British Colonial America",
    "deathPlace": "District 96, South Carolina, British Colonial America",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LXS1-J91",
    "photo": "/ancestors/bubbles/1332_LXS1-J91.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1332_LXS1-J91.jpg"
  },
  {
    "id": "AQI973",
    "name": "Mary Vestal",
    "sex": "F",
    "gen": 10,
    "slot": 309,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI580",
    "birthYear": 1723,
    "deathYear": 1819,
    "birthDate": "1 Jan 1723",
    "deathDate": "1819",
    "burialDate": "1819",
    "christeningDate": null,
    "birthPlace": "Chester, Pennsylvania, British Colonial America",
    "deathPlace": "Lawrence, Ohio, United States",
    "burialPlace": "Dillon Cemetery, Dillon Falls, Muskingum, Ohio, United States",
    "christeningPlace": null,
    "fsId": "LD1B-24M",
    "photo": "/ancestors/bubbles/1333_LD1B-24M.jpg",
    "living": false,
    "alternateNames": [
      "Mary Jay"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1333_LD1B-24M.jpg"
  },
  {
    "id": "AQI974",
    "name": "David Natherson",
    "sex": "M",
    "gen": 10,
    "slot": 310,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI581",
    "birthYear": 1720,
    "deathYear": 1805,
    "birthDate": "18 Feb 1720",
    "deathDate": "6 Oct 1805",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Frederick's Town, Frederick, Virginia, British Colonial America",
    "deathPlace": "Newberry, Newberry, South Carolina, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LV96-WLQ",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI975",
    "name": "Sarah Layton",
    "sex": "F",
    "gen": 10,
    "slot": 311,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI581",
    "birthYear": 1722,
    "deathYear": 1815,
    "birthDate": "15 Jul 1722",
    "deathDate": "9 Dec 1815",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Somerset, Maryland, British Colonial America",
    "deathPlace": "Bush River, Newberry, South Carolina, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "G95D-5J3",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Sarah Natherson"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI976",
    "name": "Jesse John Llewellyn",
    "sex": "M",
    "gen": 10,
    "slot": 312,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI582",
    "birthYear": 1689,
    "deathYear": 1778,
    "birthDate": "1689",
    "deathDate": "17 Jun 1778",
    "burialDate": "1778",
    "christeningDate": null,
    "birthPlace": "Frederick, Virginia, United States",
    "deathPlace": "Charles City, Charles City County, Virginia, United States",
    "burialPlace": "Charles City, Charles City County, Virginia, United States",
    "christeningPlace": null,
    "fsId": "LBFB-XD5",
    "photo": "/ancestors/bubbles/1336_LBFB-XD5.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1336_LBFB-XD5.jpg"
  },
  {
    "id": "AQI977",
    "name": "Mary Anne Owens",
    "sex": "F",
    "gen": 10,
    "slot": 313,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI582",
    "birthYear": 1698,
    "deathYear": 1777,
    "birthDate": "1698",
    "deathDate": "18 Feb 1777",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Prince Edward, Virginia, United States",
    "deathPlace": "Chesterfield, Chesterfield, Virginia, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "GT25-HYB",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI978",
    "name": "Joseph Burson",
    "sex": "M",
    "gen": 10,
    "slot": 314,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI583",
    "birthYear": 1689,
    "deathYear": 1769,
    "birthDate": "25 Dec 1689",
    "deathDate": "19 Oct 1769",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Abington Township, Philadelphia, Pennsylvania, British Colonial America",
    "deathPlace": "Loudoun, Virginia, British Colonial America",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LKGV-1ST",
    "photo": "/ancestors/bubbles/1338_LKGV-1ST.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1338_LKGV-1ST.jpg"
  },
  {
    "id": "AQI979",
    "name": "Rachel Potts",
    "sex": "F",
    "gen": 10,
    "slot": 315,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI583",
    "birthYear": 1702,
    "deathYear": 1752,
    "birthDate": "25 Dec 1702",
    "deathDate": "10 Oct 1752",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Potts Grove, East Chillisquaque Township, Northumberland, Pennsylvania, British Colonial America",
    "deathPlace": "Loudoun, Virginia, British Colonial America",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LBRQ-ZVH",
    "photo": "/ancestors/bubbles/1339_LBRQ-ZVH.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1339_LBRQ-ZVH.jpg"
  },
  {
    "id": "AQI980",
    "name": "Aaron Brooks",
    "sex": "M",
    "gen": 10,
    "slot": 316,
    "side": "paternal",
    "birthplace": "unknown",
    "childId": "AQI584",
    "birthYear": 1710,
    "deathYear": null,
    "birthDate": "From 1710 to 1720",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "MTRX-ND9",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI981",
    "name": "Hannah Brooks",
    "sex": "F",
    "gen": 10,
    "slot": 317,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI584",
    "birthYear": 1717,
    "deathYear": 1758,
    "birthDate": "1717",
    "deathDate": "Bef 1758",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Chanceford Township, York, Pennsylvania, United States",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "MTRX-ND4",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Mrs. Brooks"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI982",
    "name": "Poss James Armstrong",
    "sex": "M",
    "gen": 10,
    "slot": 318,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI585",
    "birthYear": 1715,
    "deathYear": null,
    "birthDate": "Abt 1715",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Ohio, United States",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "GV4X-2MD",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI983",
    "name": "Elizabeth Maybe McCord",
    "sex": "F",
    "gen": 10,
    "slot": 319,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI585",
    "birthYear": 1720,
    "deathYear": null,
    "birthDate": "Abt 1720",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Ohio, United States",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "GV4X-KXH",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI984",
    "name": "Thomas Cranor",
    "sex": "M",
    "gen": 10,
    "slot": 320,
    "side": "paternal",
    "birthplace": "ireland",
    "childId": "AQI586",
    "birthYear": 1714,
    "deathYear": 1756,
    "birthDate": "1714",
    "deathDate": "13 Nov 1756",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Ireland",
    "deathPlace": "Queen Anne's, Maryland, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LZFB-2QT",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI985",
    "name": "Elizabeth Trotter Ashmore",
    "sex": "F",
    "gen": 10,
    "slot": 321,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI586",
    "birthYear": 1718,
    "deathYear": 1801,
    "birthDate": "1718",
    "deathDate": "May 1801",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Talbot, Maryland, United States",
    "deathPlace": "United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "GGPB-JFL",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Elizabeth Cranor"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI986",
    "name": "William Lister",
    "sex": "M",
    "gen": 10,
    "slot": 322,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI587",
    "birthYear": 1709,
    "deathYear": null,
    "birthDate": "1709",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Maryland, British Colonial America",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "G251-4DK",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI987",
    "name": "William Trotter",
    "sex": "M",
    "gen": 10,
    "slot": 324,
    "side": "paternal",
    "birthplace": "scotland",
    "childId": "AQI588",
    "birthYear": 1690,
    "deathYear": 1745,
    "birthDate": "1690",
    "deathDate": "1745",
    "burialDate": "1745",
    "christeningDate": null,
    "birthPlace": "Jedburgh, Roxburghshire, Scotland, United Kingdom",
    "deathPlace": "Maryland, British Colonial America",
    "burialPlace": "Maryland, United States",
    "christeningPlace": null,
    "fsId": "L657-M2B",
    "photo": "/ancestors/bubbles/1348_L657-M2B.jpg",
    "living": false,
    "alternateNames": [
      "Robert Trotter I"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1348_L657-M2B.jpg"
  },
  {
    "id": "AQI988",
    "name": "Caroline Dill",
    "sex": "F",
    "gen": 10,
    "slot": 325,
    "side": "paternal",
    "birthplace": "scotland",
    "childId": "AQI588",
    "birthYear": 1690,
    "deathYear": 1760,
    "birthDate": "1690",
    "deathDate": "1760",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Dunfermline, Fife, Scotland, United Kingdom",
    "deathPlace": "North Carolina, British Colonial America",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LC6R-939",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI991",
    "name": "John Russell",
    "sex": "M",
    "gen": 10,
    "slot": 326,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI589",
    "birthYear": 1704,
    "deathYear": null,
    "birthDate": "Abt 1704",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Maryland, British Colonial America",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "GSP6-TYK",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI992",
    "name": "Dorathy",
    "sex": "F",
    "gen": 10,
    "slot": 327,
    "side": "paternal",
    "birthplace": "unknown",
    "childId": "AQI589",
    "birthYear": null,
    "deathYear": null,
    "birthDate": null,
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "GSP6-GMF",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI993",
    "name": "Matthew Stephenson",
    "sex": "M",
    "gen": 10,
    "slot": 328,
    "side": "paternal",
    "birthplace": "unknown",
    "childId": "AQI590",
    "birthYear": 1715,
    "deathYear": 1788,
    "birthDate": "1715",
    "deathDate": "Abt 1788",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": null,
    "deathPlace": "Guilford, North Carolina, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "P6WN-WW9",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI994",
    "name": "Ann",
    "sex": "F",
    "gen": 10,
    "slot": 329,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI590",
    "birthYear": 1715,
    "deathYear": null,
    "birthDate": "1715",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Craven, North Carolina, British Colonial America",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "GKS7-K6X",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Ann Mill",
      "Mrs Ann Stephenson"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI995",
    "name": "John McCalland",
    "sex": "M",
    "gen": 10,
    "slot": 330,
    "side": "paternal",
    "birthplace": "ireland",
    "childId": "AQI591",
    "birthYear": 1725,
    "deathYear": null,
    "birthDate": "Abt 1725",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Ireland",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "M74Z-VSD",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI996",
    "name": "?",
    "sex": "F",
    "gen": 10,
    "slot": 331,
    "side": "paternal",
    "birthplace": "unknown",
    "childId": "AQI591",
    "birthYear": null,
    "deathYear": null,
    "birthDate": null,
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "4SJS-3ZP",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI997",
    "name": "Thomas Nathaniel Edwards",
    "sex": "M",
    "gen": 10,
    "slot": 336,
    "side": "paternal",
    "birthplace": "wales",
    "childId": "AQI592",
    "birthYear": 1690,
    "deathYear": 1781,
    "birthDate": "14 Oct 1690",
    "deathDate": "2 Nov 1781",
    "burialDate": "1781",
    "christeningDate": null,
    "birthPlace": "Denbighshire, Wales",
    "deathPlace": "Montgomery, Maryland, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "GGL5-8VY",
    "photo": "/ancestors/bubbles/1360_GGL5-8VY.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1360_GGL5-8VY.jpg"
  },
  {
    "id": "AQI998",
    "name": "Elizabeth Isabelle Downing",
    "sex": "F",
    "gen": 10,
    "slot": 337,
    "side": "paternal",
    "birthplace": "wales",
    "childId": "AQI592",
    "birthYear": 1686,
    "deathYear": 1783,
    "birthDate": "12 Mar 1686",
    "deathDate": "8 Jun 1783",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Llandaff, Glamorgan, Wales",
    "deathPlace": "Savannah, Chatham, Georgia, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LZWQ-ZXB",
    "photo": "/ancestors/bubbles/1361_LZWQ-ZXB.jpg",
    "living": false,
    "alternateNames": [
      "Sarah Isabella"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1361_LZWQ-ZXB.jpg"
  },
  {
    "id": "AQI984s344",
    "name": "Thomas Cranor",
    "sex": "M",
    "gen": 10,
    "slot": 344,
    "side": "paternal",
    "birthplace": "ireland",
    "childId": "AQI586s172",
    "birthYear": 1714,
    "deathYear": 1756,
    "birthDate": "1714",
    "deathDate": "13 Nov 1756",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Ireland",
    "deathPlace": "Queen Anne's, Maryland, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LZFB-2QT",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI985s345",
    "name": "Elizabeth Trotter Ashmore",
    "sex": "F",
    "gen": 10,
    "slot": 345,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI586s172",
    "birthYear": 1718,
    "deathYear": 1801,
    "birthDate": "1718",
    "deathDate": "May 1801",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Talbot, Maryland, United States",
    "deathPlace": "United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "GGPB-JFL",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Elizabeth Cranor"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI986s346",
    "name": "William Lister",
    "sex": "M",
    "gen": 10,
    "slot": 346,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI587s173",
    "birthYear": 1709,
    "deathYear": null,
    "birthDate": "1709",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Maryland, British Colonial America",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "G251-4DK",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI987s348",
    "name": "William Trotter",
    "sex": "M",
    "gen": 10,
    "slot": 348,
    "side": "paternal",
    "birthplace": "scotland",
    "childId": "AQI588s174",
    "birthYear": 1690,
    "deathYear": 1745,
    "birthDate": "1690",
    "deathDate": "1745",
    "burialDate": "1745",
    "christeningDate": null,
    "birthPlace": "Jedburgh, Roxburghshire, Scotland, United Kingdom",
    "deathPlace": "Maryland, British Colonial America",
    "burialPlace": "Maryland, United States",
    "christeningPlace": null,
    "fsId": "L657-M2B",
    "photo": "/ancestors/bubbles/1348_L657-M2B.jpg",
    "living": false,
    "alternateNames": [
      "Robert Trotter I"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1348_L657-M2B.jpg"
  },
  {
    "id": "AQI988s349",
    "name": "Caroline Dill",
    "sex": "F",
    "gen": 10,
    "slot": 349,
    "side": "paternal",
    "birthplace": "scotland",
    "childId": "AQI588s174",
    "birthYear": 1690,
    "deathYear": 1760,
    "birthDate": "1690",
    "deathDate": "1760",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Dunfermline, Fife, Scotland, United Kingdom",
    "deathPlace": "North Carolina, British Colonial America",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LC6R-939",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI991s350",
    "name": "John Russell",
    "sex": "M",
    "gen": 10,
    "slot": 350,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI589s175",
    "birthYear": 1704,
    "deathYear": null,
    "birthDate": "Abt 1704",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Maryland, British Colonial America",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "GSP6-TYK",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI992s351",
    "name": "Dorathy",
    "sex": "F",
    "gen": 10,
    "slot": 351,
    "side": "paternal",
    "birthplace": "unknown",
    "childId": "AQI589s175",
    "birthYear": null,
    "deathYear": null,
    "birthDate": null,
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "GSP6-GMF",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1000",
    "name": "Stephen C. Mendenhall",
    "sex": "M",
    "gen": 10,
    "slot": 352,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI594",
    "birthYear": 1721,
    "deathYear": 1779,
    "birthDate": "19 Oct 1721",
    "deathDate": "4 Feb 1779",
    "burialDate": "Feb 1779",
    "christeningDate": null,
    "birthPlace": "East Caln Township, Chester, Pennsylvania, United States",
    "deathPlace": "High Point Township, Guilford, North Carolina, United States",
    "burialPlace": "Deep River Friends Meeting Cemetery, High Point, Guilford, North Carolina, United States",
    "christeningPlace": null,
    "fsId": "LZ28-HHP",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Steven Mendenhall"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1001",
    "name": "Sarah Martin",
    "sex": "F",
    "gen": 10,
    "slot": 353,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI594",
    "birthYear": 1721,
    "deathYear": 1795,
    "birthDate": "1721",
    "deathDate": "3 Aug 1795",
    "burialDate": "Aft 3 Aug 1795",
    "christeningDate": null,
    "birthPlace": "Chester, Pennsylvania, British Colonial America",
    "deathPlace": "Deep River Township, Guilford, North Carolina, United States",
    "burialPlace": "Deep River Friends Meeting Cemetery, High Point, Guilford, North Carolina, United States",
    "christeningPlace": null,
    "fsId": "G6TJ-8XG",
    "photo": "/ancestors/bubbles/1377_G6TJ-8XG.jpg",
    "living": false,
    "alternateNames": [
      "Sally",
      "Sarah Mendenhall"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1377_G6TJ-8XG.jpg"
  },
  {
    "id": "AQI1002",
    "name": "Hardin Perkins",
    "sex": "M",
    "gen": 10,
    "slot": 358,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI597",
    "birthYear": 1730,
    "deathYear": 1795,
    "birthDate": "1730",
    "deathDate": "1795",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Henrico, Virginia, British Colonial America",
    "deathPlace": "Buckingham, Virginia, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "L6JX-BC7",
    "photo": "/ancestors/bubbles/1382_L6JX-BC7.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1382_L6JX-BC7.jpg"
  },
  {
    "id": "AQI1003",
    "name": "Sarah Price",
    "sex": "F",
    "gen": 10,
    "slot": 359,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI597",
    "birthYear": 1740,
    "deathYear": 1820,
    "birthDate": "29 Sep 1740",
    "deathDate": "from 31 January 1820 to 26 February 1821",
    "burialDate": null,
    "christeningDate": "1 Dec 1754",
    "birthPlace": "Berks, Pennsylvania, British Colonial America",
    "deathPlace": "Fluvanna, Virginia, United States",
    "burialPlace": null,
    "christeningPlace": "Douglassville, Amity Township, Berks, Pennsylvania, United States",
    "fsId": "KP3R-MZS",
    "photo": "/ancestors/bubbles/1383_KP3R-MZS.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1383_KP3R-MZS.jpg"
  },
  {
    "id": "AQI1004",
    "name": "John Bristow",
    "sex": "M",
    "gen": 10,
    "slot": 360,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI598",
    "birthYear": 1721,
    "deathYear": 1801,
    "birthDate": "25 Jun 1721",
    "deathDate": "Feb 1801",
    "burialDate": null,
    "christeningDate": "16 Jul 1721",
    "birthPlace": "Middlesex, Virginia, British Colonial America",
    "deathPlace": "Tazewell, Tazewell, Virginia, United States",
    "burialPlace": null,
    "christeningPlace": "Middlesex, Virginia, British Colonial America",
    "fsId": "GJ8Z-9L2",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1005",
    "name": "Mary Carter",
    "sex": "F",
    "gen": 10,
    "slot": 361,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI598",
    "birthYear": 1725,
    "deathYear": null,
    "birthDate": "Abt 1725",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Middlesex, Virginia, British Colonial America",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "GZFN-8RH",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Mary Bristow"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1006",
    "name": "William Powell",
    "sex": "M",
    "gen": 10,
    "slot": 362,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI599",
    "birthYear": 1705,
    "deathYear": 1787,
    "birthDate": "1705",
    "deathDate": "24 Feb 1787",
    "burialDate": "1787",
    "christeningDate": null,
    "birthPlace": "Pocomoke City, Somerset, Maryland, British Colonial America",
    "deathPlace": "Loudoun, Virginia, United States",
    "burialPlace": "Loudoun, Virginia, United States",
    "christeningPlace": null,
    "fsId": "LC8B-HMJ",
    "photo": "/ancestors/bubbles/1386_LC8B-HMJ.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1386_LC8B-HMJ.jpg"
  },
  {
    "id": "AQI1007",
    "name": "Elenor Waller Douglas Peyton",
    "sex": "F",
    "gen": 10,
    "slot": 363,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI599",
    "birthYear": 1720,
    "deathYear": 1788,
    "birthDate": "Apr 1720",
    "deathDate": "9 May 1788",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Stony Point, Albemarle, Virginia, British Colonial America",
    "deathPlace": "Prince William, Virginia, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "L6T5-VT4",
    "photo": "/ancestors/bubbles/1387_L6T5-VT4.jpg",
    "living": false,
    "alternateNames": [
      "Eleanor Powell"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1387_L6T5-VT4.jpg"
  },
  {
    "id": "AQI1008",
    "name": "Richard Derrick Van Meter",
    "sex": "M",
    "gen": 10,
    "slot": 376,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI600",
    "birthYear": 1720,
    "deathYear": 1785,
    "birthDate": "16 Apr 1720",
    "deathDate": "1785",
    "burialDate": null,
    "christeningDate": "17 Jul 1720",
    "birthPlace": "Middletown Township, Monmouth, New Jersey, United States",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "New Utrecht, Kings, New York Colony, British Colonial America",
    "fsId": "GVYT-YZQ",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Ryck Van Metre",
      "Ryck Richard VanMetre",
      "Ryck Richard Vanmater",
      "Derick Van Metren",
      "Richard Van Mater",
      "Rijck Van Metre",
      "Ryck V Meteren",
      "Ryke Van Mater",
      "Ryke Van Matren"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1009",
    "name": "Moycha Mercy Osborn",
    "sex": "F",
    "gen": 10,
    "slot": 377,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI600",
    "birthYear": 1731,
    "deathYear": null,
    "birthDate": "1731",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Monmouth, New Jersey, British Colonial America",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LCF3-ZVM",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Maycah Martha Osborn",
      "Maycah (Martha Mercy) Osborn",
      "Martha Osbourne",
      "Martha Osborne",
      "Van Mater",
      "Micah or Martha"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1010",
    "name": "Hendrick Hendrickson",
    "sex": "M",
    "gen": 10,
    "slot": 378,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI601",
    "birthYear": 1730,
    "deathYear": 1783,
    "birthDate": "20 Jun 1730",
    "deathDate": "28 Jul 1783",
    "burialDate": null,
    "christeningDate": "20 Jan 1731",
    "birthPlace": "Middletown Village, Monmouth, New Jersey, British Colonial America",
    "deathPlace": "North Carolina, United States",
    "burialPlace": null,
    "christeningPlace": "Middletown Township, Monmouth, New Jersey, United States",
    "fsId": "L7BF-LJP",
    "photo": "/ancestors/bubbles/1402_L7BF-LJP.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1402_L7BF-LJP.jpg"
  },
  {
    "id": "AQI1011",
    "name": "Sarah Thompson",
    "sex": "F",
    "gen": 10,
    "slot": 379,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI601",
    "birthYear": 1732,
    "deathYear": 1783,
    "birthDate": "1732",
    "deathDate": "28 Jul 1783",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Middletown Township, Monmouth, New Jersey, British Colonial America",
    "deathPlace": "Rowan, North Carolina, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "GMWF-1YH",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Hendricks",
      "Sarah Thompson Hendrickson"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1012",
    "name": "Michael Baltus Heagle",
    "sex": "M",
    "gen": 10,
    "slot": 380,
    "side": "paternal",
    "birthplace": "netherlands",
    "childId": "AQI602",
    "birthYear": 1733,
    "deathYear": 1814,
    "birthDate": "1733",
    "deathDate": "12 Feb 1814",
    "burialDate": "Feb 1814",
    "christeningDate": null,
    "birthPlace": "Amsterdam, Holland, Netherlands",
    "deathPlace": "Johnstown, Fulton, New York, United States",
    "burialPlace": "Johnstown, Fulton, New York, United States",
    "christeningPlace": null,
    "fsId": "277C-V34",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1013",
    "name": "Anna Eva Rose Plantz",
    "sex": "F",
    "gen": 10,
    "slot": 381,
    "side": "paternal",
    "birthplace": "germany",
    "childId": "AQI602",
    "birthYear": 1730,
    "deathYear": 1814,
    "birthDate": "22 Sep 1730",
    "deathDate": "Abt 1814",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Baden-Baden, Baden-Württemberg, Germany",
    "deathPlace": "Johnson, Minisink, Orange, New York, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "L7R8-FP4",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1014",
    "name": "Johannes Mathias Plantz",
    "sex": "M",
    "gen": 10,
    "slot": 382,
    "side": "paternal",
    "birthplace": "germany",
    "childId": "AQI603",
    "birthYear": 1715,
    "deathYear": 1786,
    "birthDate": "30 Jun 1715",
    "deathDate": "16 Aug 1786",
    "burialDate": "1786",
    "christeningDate": "2 Jul 1715",
    "birthPlace": "Kirn, Bad Kreuznach, Rhineland-Palatinate, Germany",
    "deathPlace": "Montgomery, New York, United States",
    "burialPlace": "Montgomery, New York, United States",
    "christeningPlace": "Palatinate, Bavaria, Germany",
    "fsId": "LJ5R-795",
    "photo": "/ancestors/bubbles/1406_LJ5R-795.jpg",
    "living": false,
    "alternateNames": [
      "John Plantz"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1406_LJ5R-795.jpg"
  },
  {
    "id": "AQI1015",
    "name": "Anna Maria Margarietta Gunterman",
    "sex": "F",
    "gen": 10,
    "slot": 383,
    "side": "paternal",
    "birthplace": "united-states",
    "childId": "AQI603",
    "birthYear": 1730,
    "deathYear": 1777,
    "birthDate": "1730",
    "deathDate": "1777",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Johnstown, Fulton, New York, United States",
    "deathPlace": "Albany, Albany, New York, United States",
    "burialPlace": "Johnstown, Montgomery, New York, United States",
    "christeningPlace": null,
    "fsId": "GH7L-FMQ",
    "photo": "/ancestors/bubbles/1407_GH7L-FMQ.jpg",
    "living": false,
    "alternateNames": [
      "Anna Margaretha Countryman",
      "Maria Margreth Contreman",
      "Maria Margaretha Gondermann"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1407_GH7L-FMQ.jpg"
  },
  {
    "id": "AQI1016",
    "name": "William Caunt",
    "sex": "M",
    "gen": 10,
    "slot": 388,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI605",
    "birthYear": 1691,
    "deathYear": 1743,
    "birthDate": "24 Oct 1691",
    "deathDate": "16 Sep 1743",
    "burialDate": "16 Sep 1743",
    "christeningDate": "24 Oct 1691",
    "birthPlace": "Lambley, Nottinghamshire, England, United Kingdom",
    "deathPlace": "Hucknall, Hucknall Torkard, Nottinghamshire, England, United Kingdom",
    "burialPlace": "Hucknall, Hucknall Torkard, Nottinghamshire, England, United Kingdom",
    "christeningPlace": "Lambley, Nottinghamshire, England, United Kingdom",
    "fsId": "LZ87-GH6",
    "photo": "/ancestors/bubbles/1412_LZ87-GH6.jpg",
    "living": false,
    "alternateNames": [
      "William Cont",
      "Will Cont"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1412_LZ87-GH6.jpg"
  },
  {
    "id": "AQI1017",
    "name": "Anne Jamson",
    "sex": "F",
    "gen": 10,
    "slot": 389,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI605",
    "birthYear": 1696,
    "deathYear": 1738,
    "birthDate": "Apr 1696",
    "deathDate": "Abt 1738",
    "burialDate": "20 May 1738",
    "christeningDate": null,
    "birthPlace": "Lowdham, Nottinghamshire, England",
    "deathPlace": "Hucknall Torkard, Nottinghamshire, England",
    "burialPlace": "Hucknall Torkard, Nottinghamshire, England, United Kingdom",
    "christeningPlace": null,
    "fsId": "LZ87-GW7",
    "photo": "/ancestors/bubbles/1413_LZ87-GW7.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1413_LZ87-GW7.jpg"
  },
  {
    "id": "AQI1018",
    "name": "Thomas Watson",
    "sex": "M",
    "gen": 10,
    "slot": 390,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI606",
    "birthYear": 1707,
    "deathYear": null,
    "birthDate": "1707",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Weedon Bec, Northamptonshire, England, United Kingdom",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LQ6F-W45",
    "photo": "/ancestors/bubbles/1414_LQ6F-W45.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1414_LQ6F-W45.jpg"
  },
  {
    "id": "AQI1019",
    "name": "Sarah Linnel",
    "sex": "F",
    "gen": 10,
    "slot": 391,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI606",
    "birthYear": 1711,
    "deathYear": null,
    "birthDate": "1711",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Nether Heyford, Northamptonshire, England, United Kingdom",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "2Z4D-ZLC",
    "photo": "/ancestors/bubbles/1415_2Z4D-ZLC.jpg",
    "living": false,
    "alternateNames": [
      "Sarah ( Mrs) Watson"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1415_2Z4D-ZLC.jpg"
  },
  {
    "id": "AQI1020",
    "name": "John Hall",
    "sex": "M",
    "gen": 10,
    "slot": 392,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI607",
    "birthYear": 1702,
    "deathYear": 1752,
    "birthDate": "2 Aug 1702",
    "deathDate": "28 Mar 1752",
    "burialDate": "28 Mar 1752",
    "christeningDate": "2 Aug 1702",
    "birthPlace": "Folkingham, Lincolnshire, England",
    "deathPlace": "Osbournby, Lincolnshire, England",
    "burialPlace": "Osbournby, Lincolnshire, England",
    "christeningPlace": "Folkingham, Lincolnshire, England",
    "fsId": "LZ22-H2V",
    "photo": "/ancestors/bubbles/1416_LZ22-H2V.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1416_LZ22-H2V.jpg"
  },
  {
    "id": "AQI1021",
    "name": "Mary Bromfield",
    "sex": "F",
    "gen": 10,
    "slot": 393,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI607",
    "birthYear": 1699,
    "deathYear": 1760,
    "birthDate": "26 Mar 1699",
    "deathDate": "29 Jul 1760",
    "burialDate": "29 Jul 1760",
    "christeningDate": "26 Mar 1699",
    "birthPlace": "Osbournby, Lincolnshire, England",
    "deathPlace": "Osbournby, Lincolnshire, England",
    "burialPlace": "Osbournby, Lincolnshire, England",
    "christeningPlace": "Morton by Bourne, Lincolnshire, England",
    "fsId": "LZKY-KQZ",
    "photo": "/ancestors/bubbles/1417_LZKY-KQZ.jpg",
    "living": false,
    "alternateNames": [
      "Mrs. Mary Hall",
      "Mrs Mary Hill"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1417_LZKY-KQZ.jpg"
  },
  {
    "id": "AQI1022",
    "name": "Anthony Wimfrey",
    "sex": "M",
    "gen": 10,
    "slot": 394,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI608",
    "birthYear": 1683,
    "deathYear": 1772,
    "birthDate": "Mar 1683",
    "deathDate": "6 May 1772",
    "burialDate": "6 May 1772",
    "christeningDate": null,
    "birthPlace": "Helpringham, Lincolnshire, England",
    "deathPlace": "Great Hale, Lincolnshire, England",
    "burialPlace": "Great Hale, Lincolnshire, England, United Kingdom",
    "christeningPlace": null,
    "fsId": "LZ22-4MN",
    "photo": "/ancestors/bubbles/1418_LZ22-4MN.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1418_LZ22-4MN.jpg"
  },
  {
    "id": "AQI1023",
    "name": "Frances Dean",
    "sex": "F",
    "gen": 10,
    "slot": 395,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI608",
    "birthYear": 1698,
    "deathYear": null,
    "birthDate": "11 Sep 1698",
    "deathDate": null,
    "burialDate": "8 Sep 1771",
    "christeningDate": "11 Sep 1698",
    "birthPlace": "Swineshead, Lincolnshire, England",
    "deathPlace": null,
    "burialPlace": "Great Hale, Lincolnshire, England, United Kingdom",
    "christeningPlace": "Swineshead, Lincolnshire, England",
    "fsId": "2XM9-2FQ",
    "photo": "/ancestors/bubbles/1419_2XM9-2FQ.jpg",
    "living": false,
    "alternateNames": [
      "Frances",
      "Frances Deen",
      "Frances Deen Or Dean",
      "Frances. Deen",
      "Francies"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1419_2XM9-2FQ.jpg"
  },
  {
    "id": "AQI1024",
    "name": "Valentine Ingram",
    "sex": "M",
    "gen": 10,
    "slot": 396,
    "side": "paternal",
    "birthplace": "unknown",
    "childId": "AQI609",
    "birthYear": null,
    "deathYear": null,
    "birthDate": null,
    "deathDate": null,
    "burialDate": "16 Aug 1762",
    "christeningDate": "Feb 1707",
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": "Evedon, Lincolnshire, England",
    "christeningPlace": "Ancaster, Lincolnshire, England",
    "fsId": "ML8X-S4K",
    "photo": "/ancestors/bubbles/1420_ML8X-S4K.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1420_ML8X-S4K.jpg"
  },
  {
    "id": "AQI1025",
    "name": "Dinah Cupper",
    "sex": "F",
    "gen": 10,
    "slot": 397,
    "side": "paternal",
    "birthplace": "unknown",
    "childId": "AQI609",
    "birthYear": null,
    "deathYear": null,
    "birthDate": null,
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "KCYN-67Y",
    "photo": "/ancestors/bubbles/1421_KCYN-67Y.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1421_KCYN-67Y.jpg"
  },
  {
    "id": "AQI1028",
    "name": "Harmstone",
    "sex": "M",
    "gen": 10,
    "slot": 398,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI610",
    "birthYear": 1720,
    "deathYear": null,
    "birthDate": "Abt 1720",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Lincolnshire, England, United Kingdom",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "PWJT-BBV",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1030",
    "name": "Richard Allen",
    "sex": "M",
    "gen": 10,
    "slot": 400,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI612",
    "birthYear": 1735,
    "deathYear": null,
    "birthDate": "1735",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "15 Jan 1735",
    "birthPlace": "Sheffield, Yorkshire, England",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Sheffield, Yorkshire, England, United Kingdom",
    "fsId": "L4HD-469",
    "photo": "/ancestors/bubbles/1424_L4HD-469.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1424_L4HD-469.jpg"
  },
  {
    "id": "AQI1031",
    "name": "Martha Gascoigne",
    "sex": "F",
    "gen": 10,
    "slot": 401,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI612",
    "birthYear": 1730,
    "deathYear": null,
    "birthDate": "Abt 1730",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "18 Dec 1730",
    "birthPlace": "Sheffield, Yorkshire, England, United Kingdom",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Sheffield, Yorkshire, England, United Kingdom",
    "fsId": "L4JL-S1T",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Martha Gascoine",
      "Martha Gascoyne",
      "Mary Gascoigne",
      "Mary Gascoine"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1032",
    "name": "Robert Allin",
    "sex": "M",
    "gen": 10,
    "slot": 402,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI613",
    "birthYear": 1733,
    "deathYear": 1812,
    "birthDate": "Abt 1733",
    "deathDate": "Aug 1812",
    "burialDate": "2 Aug 1812",
    "christeningDate": "13 Jun 1733",
    "birthPlace": "Sheffield, Yorkshire, England, United Kingdom",
    "deathPlace": "Sheffield, Yorkshire, England, United Kingdom",
    "burialPlace": "Sheffield St Peter and St Paul, Yorkshire, England, United Kingdom",
    "christeningPlace": "Sheffield, Yorkshire, England, United Kingdom",
    "fsId": "LLWW-VWN",
    "photo": "/ancestors/bubbles/1426_LLWW-VWN.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1426_LLWW-VWN.jpg"
  },
  {
    "id": "AQI1033",
    "name": "Sarah Nicholson",
    "sex": "F",
    "gen": 10,
    "slot": 403,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI613",
    "birthYear": 1729,
    "deathYear": 1790,
    "birthDate": "Abt 1729",
    "deathDate": "Apr 1790",
    "burialDate": "4 Apr 1790",
    "christeningDate": "26 Nov 1729",
    "birthPlace": "Sheffield, Yorkshire, England, United Kingdom",
    "deathPlace": "Sheffield, Yorkshire, England, United Kingdom",
    "burialPlace": "Sheffield St Peter and St Paul, Yorkshire, England, United Kingdom",
    "christeningPlace": "Sheffield St Peter and St Paul, Yorkshire, England, United Kingdom",
    "fsId": "MV37-R68",
    "photo": "/ancestors/bubbles/1427_MV37-R68.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1427_MV37-R68.jpg"
  },
  {
    "id": "AQI1034",
    "name": "William Mawson",
    "sex": "M",
    "gen": 10,
    "slot": 404,
    "side": "paternal",
    "birthplace": "unknown",
    "childId": "AQI614",
    "birthYear": null,
    "deathYear": 1776,
    "birthDate": null,
    "deathDate": "Feb 1776",
    "burialDate": "15 Feb 1776",
    "christeningDate": null,
    "birthPlace": null,
    "deathPlace": "Hawksworth near Guiseley, Yorkshire, England",
    "burialPlace": "Otley, Yorkshire, England, United Kingdom",
    "christeningPlace": null,
    "fsId": "LHJ8-7N4",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1035",
    "name": "Anne Kirby",
    "sex": "F",
    "gen": 10,
    "slot": 405,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI614",
    "birthYear": 1724,
    "deathYear": null,
    "birthDate": "Abt 1724",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "1 Nov 1724",
    "birthPlace": "Hawksworth near Guiseley, Yorkshire, England",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Otley, Yorkshire, England, United Kingdom",
    "fsId": "L43W-Y5T",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1036",
    "name": "Aaron Beever",
    "sex": "M",
    "gen": 10,
    "slot": 406,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI615",
    "birthYear": 1715,
    "deathYear": 1784,
    "birthDate": "1715",
    "deathDate": "Jan 1784",
    "burialDate": "20 Jan 1784",
    "christeningDate": null,
    "birthPlace": "Mexborough, Yorkshire, England, United Kingdom",
    "deathPlace": "Mexborough, Yorkshire, England, United Kingdom",
    "burialPlace": "Mexborough, Yorkshire, England",
    "christeningPlace": null,
    "fsId": "LBFV-42S",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Aaron Bevers",
      "Aaron Bever",
      "Aaron Beaver",
      "Aron Bevers"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1037",
    "name": "Anne Addy",
    "sex": "F",
    "gen": 10,
    "slot": 407,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI615",
    "birthYear": 1725,
    "deathYear": 1766,
    "birthDate": "Abt 1725",
    "deathDate": "Nov 1766",
    "burialDate": "25 Nov 1766",
    "christeningDate": "1 Aug 1725",
    "birthPlace": "Fulstone, Yorkshire, England",
    "deathPlace": null,
    "burialPlace": "Mexborough, Yorkshire, England",
    "christeningPlace": "Kirkburton, Yorkshire, England, United Kingdom",
    "fsId": "LBFV-C6H",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1038",
    "name": "William Keeling",
    "sex": "M",
    "gen": 10,
    "slot": 412,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI617",
    "birthYear": 1722,
    "deathYear": 1780,
    "birthDate": "1722",
    "deathDate": "1780",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Derbyshire, England, United Kingdom",
    "deathPlace": "Derbyshire, England, United Kingdom",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "GVR2-SNF",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1039",
    "name": "Elizabeth Bayley",
    "sex": "F",
    "gen": 10,
    "slot": 413,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI617",
    "birthYear": 1725,
    "deathYear": 1792,
    "birthDate": "1725",
    "deathDate": "1792",
    "burialDate": "16 Jun 1792",
    "christeningDate": null,
    "birthPlace": "England, United Kingdom",
    "deathPlace": "England, United Kingdom",
    "burialPlace": "Repton, Derbyshire, England, United Kingdom",
    "christeningPlace": null,
    "fsId": "G87Z-4NY",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1040",
    "name": "Thomas Hare",
    "sex": "M",
    "gen": 10,
    "slot": 416,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI619",
    "birthYear": 1688,
    "deathYear": 1731,
    "birthDate": "24 Mar 1688",
    "deathDate": "30 Jun 1731",
    "burialDate": "30 Jun 1731",
    "christeningDate": "24 Mar 1689",
    "birthPlace": "Belton, Lincolnshire, England",
    "deathPlace": "Barrowby, Lincolnshire, England, United Kingdom",
    "burialPlace": "Barrowby, Lincolnshire, England, United Kingdom",
    "christeningPlace": "Belton, Lincolnshire, England, United Kingdom",
    "fsId": "L78H-M3V",
    "photo": "/ancestors/bubbles/1440_L78H-M3V.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1440_L78H-M3V.jpg"
  },
  {
    "id": "AQI1041",
    "name": "Jane Turner",
    "sex": "F",
    "gen": 10,
    "slot": 417,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI619",
    "birthYear": 1691,
    "deathYear": 1747,
    "birthDate": "1691",
    "deathDate": "7 Feb 1747",
    "burialDate": "7 Feb 1748",
    "christeningDate": null,
    "birthPlace": "Barrowby, England",
    "deathPlace": "Barrowby, England",
    "burialPlace": "Barrowby, England",
    "christeningPlace": null,
    "fsId": "L78R-JPZ",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Mrs Jane Hare"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1042",
    "name": "William Braunson",
    "sex": "M",
    "gen": 10,
    "slot": 418,
    "side": "paternal",
    "birthplace": "unknown",
    "childId": "AQI620",
    "birthYear": null,
    "deathYear": null,
    "birthDate": null,
    "deathDate": null,
    "burialDate": "2 Jul 1744",
    "christeningDate": "26 Oct 1690",
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": "Denton, Lincolnshire, England",
    "christeningPlace": "Denton, Lincolnshire, England",
    "fsId": "MWQG-L1S",
    "photo": "/ancestors/bubbles/1442_MWQG-L1S.jpg",
    "living": false,
    "alternateNames": [
      "William Bronson",
      "William Bronston",
      "William Branson",
      "William Brownson"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1442_MWQG-L1S.jpg"
  },
  {
    "id": "AQI1043",
    "name": "Alice Harwood",
    "sex": "F",
    "gen": 10,
    "slot": 419,
    "side": "paternal",
    "birthplace": "unknown",
    "childId": "AQI620",
    "birthYear": null,
    "deathYear": null,
    "birthDate": null,
    "deathDate": null,
    "burialDate": "14 Jan 1730",
    "christeningDate": "1 Aug 1687",
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": "Denton, Lincolnshire, England",
    "christeningPlace": "Leverton, Lincolnshire, England",
    "fsId": "LDYH-17K",
    "photo": "/ancestors/bubbles/1443_LDYH-17K.jpg",
    "living": false,
    "alternateNames": [
      "Alice Braunson",
      "Alice"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1443_LDYH-17K.jpg"
  },
  {
    "id": "AQI1044",
    "name": "Edward Elsey",
    "sex": "M",
    "gen": 10,
    "slot": 420,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI621",
    "birthYear": null,
    "deathYear": 1774,
    "birthDate": null,
    "deathDate": "1774",
    "burialDate": null,
    "christeningDate": "16 Feb 1701",
    "birthPlace": "Rippingale, Lincolnshire, England, United Kingdom",
    "deathPlace": "Rippingale, Lincolnshire, England, United Kingdom",
    "burialPlace": null,
    "christeningPlace": "Rippingale, Lincolnshire, England",
    "fsId": "LVFP-S1P",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1045",
    "name": "Lucy ELSEY",
    "sex": "F",
    "gen": 10,
    "slot": 421,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI621",
    "birthYear": 1698,
    "deathYear": 1749,
    "birthDate": "Abt 1698",
    "deathDate": "Aug 1749",
    "burialDate": "28 Aug 1749",
    "christeningDate": null,
    "birthPlace": "England",
    "deathPlace": "Rippingale, Lincolnshire, England, United Kingdom",
    "burialPlace": "Rippingale, Lincolnshire, England, United Kingdom",
    "christeningPlace": null,
    "fsId": "L8R9-V61",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1046",
    "name": "Christopher Townes",
    "sex": "M",
    "gen": 10,
    "slot": 422,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI622",
    "birthYear": 1686,
    "deathYear": 1763,
    "birthDate": "Sep 1686",
    "deathDate": "Feb 1763",
    "burialDate": "8 Feb 1763",
    "christeningDate": "19 Sep 1686",
    "birthPlace": "Castle Bytham, Lincolnshire, England",
    "deathPlace": "Rippingale, Lincolnshire, England, United Kingdom",
    "burialPlace": "Rippingale, Lincolnshire, England, United Kingdom",
    "christeningPlace": "Castle Bytham, Lincolnshire, England, United Kingdom",
    "fsId": "L7GR-72V",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Christopher Towns"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1047",
    "name": "Elisabeth Bantin",
    "sex": "F",
    "gen": 10,
    "slot": 423,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI622",
    "birthYear": 1692,
    "deathYear": 1758,
    "birthDate": "Abt 1692",
    "deathDate": "1758",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Irnham, Irnham, Lincolnshire, England",
    "deathPlace": "Lincolnshire, England",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LHGS-C92",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Elizabeth Bantin"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1048",
    "name": "Simon Naylor",
    "sex": "M",
    "gen": 10,
    "slot": 424,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI623",
    "birthYear": 1709,
    "deathYear": 1744,
    "birthDate": "25 Nov 1709",
    "deathDate": "26 Feb 1744",
    "burialDate": "26 Feb 1744",
    "christeningDate": "25 Nov 1708",
    "birthPlace": "Scott Willoughby, Lincolnshire, England",
    "deathPlace": "Scott Willoughby, Lincolnshire, England",
    "burialPlace": "Scott Willoughby, Lincolnshire, England, United Kingdom",
    "christeningPlace": "Scott Willoughby, Lincolnshire, England, United Kingdom",
    "fsId": "MWNC-96Y",
    "photo": "/ancestors/bubbles/1448_MWNC-96Y.jpg",
    "living": false,
    "alternateNames": [
      "Simon Nayler"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1448_MWNC-96Y.jpg"
  },
  {
    "id": "AQI1049",
    "name": "Mary Huddleston",
    "sex": "F",
    "gen": 10,
    "slot": 425,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI623",
    "birthYear": 1710,
    "deathYear": 1752,
    "birthDate": "20 Feb 1710",
    "deathDate": "Nov 1752",
    "burialDate": null,
    "christeningDate": "Abt 1710",
    "birthPlace": "Bassingthorpe, Lincolnshire, England, United Kingdom",
    "deathPlace": "Scott Willoughby, Lincolnshire, England, United Kingdom",
    "burialPlace": null,
    "christeningPlace": "Lincolnshire, England, United Kingdom",
    "fsId": "GQ3M-LG1",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1050",
    "name": "John COCK (born Cock)",
    "sex": "M",
    "gen": 10,
    "slot": 426,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI624",
    "birthYear": 1695,
    "deathYear": null,
    "birthDate": "16 Jan 1695",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "16 Jan 1696",
    "birthPlace": "Horbling, Lincolnshire, England, United Kingdom",
    "deathPlace": "Helpringham, Lincolnshire, England, United Kingdom",
    "burialPlace": null,
    "christeningPlace": "Horbling, Lincolnshire, England, United Kingdom",
    "fsId": "LCTH-G9B",
    "photo": null,
    "living": false,
    "alternateNames": [
      "John Cock"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1051",
    "name": "Elizabeth Fletcher",
    "sex": "F",
    "gen": 10,
    "slot": 427,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI624",
    "birthYear": 1699,
    "deathYear": 1759,
    "birthDate": "1 Oct 1699",
    "deathDate": "1759",
    "burialDate": null,
    "christeningDate": "11 Oct 1699",
    "birthPlace": "Lincolnshire, England, United Kingdom",
    "deathPlace": "Lincolnshire, England, United Kingdom",
    "burialPlace": null,
    "christeningPlace": "Heckington, Lincolnshire, England, United Kingdom",
    "fsId": "LZNT-1H8",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Elisabeth Fletcher",
      "Mrs. Elizabeth Cock"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1052",
    "name": "James Taylor",
    "sex": "M",
    "gen": 10,
    "slot": 428,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI625",
    "birthYear": 1709,
    "deathYear": null,
    "birthDate": "1709",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Donington, Lincolnshire, England, United Kingdom",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "P97Q-CWH",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1053",
    "name": "Rachell Sleight",
    "sex": "F",
    "gen": 10,
    "slot": 429,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI625",
    "birthYear": 1700,
    "deathYear": 1767,
    "birthDate": "15 Oct 1700",
    "deathDate": "10 Aug 1767",
    "burialDate": "10 Aug 1767",
    "christeningDate": "15 Oct 1700",
    "birthPlace": "Metheringham, Lincolnshire, England",
    "deathPlace": "Donington, Lincolnshire, England",
    "burialPlace": "Metheringham, Lincolnshire, England, United Kingdom",
    "christeningPlace": "Metheringham, Lincolnshire, England",
    "fsId": "L6VD-Y8T",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1054",
    "name": "John Kitchin",
    "sex": "M",
    "gen": 10,
    "slot": 430,
    "side": "paternal",
    "birthplace": "unknown",
    "childId": "AQI626",
    "birthYear": null,
    "deathYear": 1757,
    "birthDate": null,
    "deathDate": "3 Sep 1757",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": null,
    "deathPlace": "Kirkstead, Lincolnshire, England, United Kingdom",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "GV2B-52Q",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1055",
    "name": "Mary Hall",
    "sex": "F",
    "gen": 10,
    "slot": 431,
    "side": "paternal",
    "birthplace": "unknown",
    "childId": "AQI626",
    "birthYear": 1715,
    "deathYear": null,
    "birthDate": "1715",
    "deathDate": null,
    "burialDate": "3 Feb 1751",
    "christeningDate": null,
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": "Kirkstead, Lincolnshire, England, United Kingdom",
    "christeningPlace": null,
    "fsId": "GV21-MQB",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1056",
    "name": "Thomas Gidlow",
    "sex": "M",
    "gen": 10,
    "slot": 434,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI628",
    "birthYear": 1715,
    "deathYear": null,
    "birthDate": "3 Feb 1715",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "19 Feb 1715",
    "birthPlace": "Yorkshire, England",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Yorkshire, England",
    "fsId": "M5KR-997",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1057",
    "name": "John Gidlow",
    "sex": "F",
    "gen": 10,
    "slot": 435,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI628",
    "birthYear": 1755,
    "deathYear": null,
    "birthDate": "Bef 1755",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "England",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "4RL4-CK9",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1058",
    "name": "John Kershaw",
    "sex": "M",
    "gen": 10,
    "slot": 436,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI629",
    "birthYear": 1714,
    "deathYear": null,
    "birthDate": "Jun 1714",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "24 Jun 1714",
    "birthPlace": "Wakefield, Yorkshire, England",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "All Saints, Wakefield, Yorkshire, England",
    "fsId": "LD5K-HSN",
    "photo": null,
    "living": false,
    "alternateNames": [
      "John Kirshaw",
      "Jno. Kershaw"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1059",
    "name": "Elizabeth Wharton",
    "sex": "F",
    "gen": 10,
    "slot": 437,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI629",
    "birthYear": 1715,
    "deathYear": null,
    "birthDate": "15 Sep 1715",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "15 Sep 1715",
    "birthPlace": "Aldenham, Hertfordshire, England, United Kingdom",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Aldenham, Hertfordshire, England, United Kingdom",
    "fsId": "K4P9-N7Q",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1060",
    "name": "Joseph Goldthorpe",
    "sex": "M",
    "gen": 10,
    "slot": 438,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI630",
    "birthYear": 1725,
    "deathYear": null,
    "birthDate": "Abt 1725",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "2 May 1725",
    "birthPlace": "All Saints, Wakefield, Yorkshire, England",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "All Saints, Wakefield, Yorkshire, England",
    "fsId": "LHXK-DC3",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Jo. Goldthorp",
      "Joseph Goldthorp"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1061",
    "name": "Martha Bedford",
    "sex": "F",
    "gen": 10,
    "slot": 439,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI630",
    "birthYear": 1727,
    "deathYear": null,
    "birthDate": "Abt 1727",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "York, Yorkshire, England, United Kingdom",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LCCF-4LY",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1062",
    "name": "William Marison",
    "sex": "M",
    "gen": 10,
    "slot": 440,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI631",
    "birthYear": 1728,
    "deathYear": 1778,
    "birthDate": "Abt 1728",
    "deathDate": "31 Aug 1778",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Castleton, Derbyshire, England, United Kingdom",
    "deathPlace": "Castleton, Derbyshire, England, United Kingdom",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "MNNL-GQF",
    "photo": null,
    "living": false,
    "alternateNames": [
      "William Marrison"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1063",
    "name": "Mary",
    "sex": "F",
    "gen": 10,
    "slot": 441,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI631",
    "birthYear": 1727,
    "deathYear": null,
    "birthDate": "1727",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Castleton, Derbyshire, England, United Kingdom",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "MNNL-G7Z",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Mary Marrison"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1064",
    "name": "Richard Eyre",
    "sex": "M",
    "gen": 10,
    "slot": 442,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI632",
    "birthYear": 1720,
    "deathYear": 1789,
    "birthDate": "1720",
    "deathDate": "10 Oct 1789",
    "burialDate": null,
    "christeningDate": "12 Feb 1726",
    "birthPlace": "Huntingdonshire, England",
    "deathPlace": "Buckworth, Huntingdonshire, England",
    "burialPlace": null,
    "christeningPlace": "Castleton, Derbyshire, England, United Kingdom",
    "fsId": "G95R-GRF",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1065",
    "name": "Mary Witherow",
    "sex": "F",
    "gen": 10,
    "slot": 443,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI632",
    "birthYear": 1710,
    "deathYear": 1775,
    "birthDate": "1 Oct 1710",
    "deathDate": "10 May 1775",
    "burialDate": null,
    "christeningDate": "13 Jan 1711",
    "birthPlace": "Farcet, Cambridgeshire, England, United Kingdom",
    "deathPlace": "Buckworth, Huntingdonshire, England",
    "burialPlace": null,
    "christeningPlace": "Farcet, Huntingdonshire, England, United Kingdom",
    "fsId": "9WJZ-X91",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Mary Whitherow",
      "Mary"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1066",
    "name": "Joseph Wright",
    "sex": "M",
    "gen": 10,
    "slot": 444,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI633",
    "birthYear": 1701,
    "deathYear": 1763,
    "birthDate": "1701",
    "deathDate": "Dec 1763",
    "burialDate": "28 Dec 1763",
    "christeningDate": "12 May 1701",
    "birthPlace": "Castleton, Derbyshire, England, United Kingdom",
    "deathPlace": "Castleton, Derbyshire, England, United Kingdom",
    "burialPlace": "Castleton, Derbyshire, England, United Kingdom",
    "christeningPlace": "Castleton, Derbyshire, England, United Kingdom",
    "fsId": "L846-NMF",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1067",
    "name": "Jane Hall",
    "sex": "F",
    "gen": 10,
    "slot": 445,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI633",
    "birthYear": 1706,
    "deathYear": 1763,
    "birthDate": "1706",
    "deathDate": "27 Jan 1763",
    "burialDate": "27 Jan 1763",
    "christeningDate": "Oct 1706",
    "birthPlace": "Folkingham, Lincolnshire, England",
    "deathPlace": "Derbyshire, England, United Kingdom",
    "burialPlace": "Castleton, Derbyshire, England",
    "christeningPlace": "Folkingham, Lincolnshire, England",
    "fsId": "LTH7-BSQ",
    "photo": "/ancestors/bubbles/1469_LTH7-BSQ.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1469_LTH7-BSQ.jpg"
  },
  {
    "id": "AQI1068",
    "name": "Thomas Needham",
    "sex": "M",
    "gen": 10,
    "slot": 446,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI634",
    "birthYear": 1724,
    "deathYear": null,
    "birthDate": "Abt Feb 1724",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "21 Mar 1724",
    "birthPlace": "Castleton, Derbyshire, England, United Kingdom",
    "deathPlace": null,
    "burialPlace": "Castleton, Derbyshire, England, United Kingdom",
    "christeningPlace": "Castleton, Derbyshire, England",
    "fsId": "K6QH-2W5",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1069",
    "name": "Anna Burdikin",
    "sex": "F",
    "gen": 10,
    "slot": 447,
    "side": "paternal",
    "birthplace": "unknown",
    "childId": "AQI634",
    "birthYear": null,
    "deathYear": null,
    "birthDate": null,
    "deathDate": null,
    "burialDate": "4 Jan 1805",
    "christeningDate": "30 Mar 1725",
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": "Castleton, Derbyshire, England, United Kingdom",
    "christeningPlace": "Castleton, Derbyshire, England, United Kingdom",
    "fsId": "93RX-B2F",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Ann"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1070",
    "name": "Robert Briggs",
    "sex": "M",
    "gen": 10,
    "slot": 448,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI635",
    "birthYear": 1676,
    "deathYear": 1741,
    "birthDate": "17 Dec 1676",
    "deathDate": "26 Oct 1741",
    "burialDate": "26 Oct 1741",
    "christeningDate": "16 Dec 1676",
    "birthPlace": "Bolton by Bowland, Yorkshire, England, United Kingdom",
    "deathPlace": "Bolton by Bowland, Yorkshire, England",
    "burialPlace": "Bolton by Bowland, Yorkshire, England, United Kingdom",
    "christeningPlace": "Bolton by Bowland, Yorkshire, England",
    "fsId": "2WX5-TZZ",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1071",
    "name": "Ellen Read",
    "sex": "F",
    "gen": 10,
    "slot": 449,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI635",
    "birthYear": 1680,
    "deathYear": 1767,
    "birthDate": "Abt 1680",
    "deathDate": "5 Nov 1767",
    "burialDate": "6 Nov 1767",
    "christeningDate": null,
    "birthPlace": "Bolton by Bowland, Yorkshire, England, United Kingdom",
    "deathPlace": "Lancaster, Lancashire, England",
    "burialPlace": "Lancashire, England, United Kingdom",
    "christeningPlace": null,
    "fsId": "LH7N-M29",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Mrs. Robert Briggs",
      "Mrs. Robert Brigge"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1072",
    "name": "James Wilson",
    "sex": "M",
    "gen": 10,
    "slot": 450,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI636",
    "birthYear": 1670,
    "deathYear": 1726,
    "birthDate": "1670",
    "deathDate": "1726",
    "burialDate": "4 Aug 1727",
    "christeningDate": "18 Aug 1684",
    "birthPlace": "Dalton in Furness, Lancashire, England, United Kingdom",
    "deathPlace": "Lancashire, England, United Kingdom",
    "burialPlace": "Downham, Lancashire, England, United Kingdom",
    "christeningPlace": "Downham, Lancashire, England",
    "fsId": "MMN3-HBK",
    "photo": null,
    "living": false,
    "alternateNames": [
      "James Wilson Jr.",
      "Jas. Wilson"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1073",
    "name": "Ann Bond",
    "sex": "F",
    "gen": 10,
    "slot": 451,
    "side": "paternal",
    "birthplace": "unknown",
    "childId": "AQI636",
    "birthYear": null,
    "deathYear": null,
    "birthDate": null,
    "deathDate": null,
    "burialDate": "8 Mar 1737",
    "christeningDate": "25 Sep 1681",
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": "Downham, Lancashire, England",
    "christeningPlace": "Gargrave, Yorkshire, England",
    "fsId": "G389-M77",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1076",
    "name": "Thomas Parkinson",
    "sex": "M",
    "gen": 10,
    "slot": 452,
    "side": "paternal",
    "birthplace": "canada",
    "childId": "AQI639",
    "birthYear": 1672,
    "deathYear": 1744,
    "birthDate": "12 Jan 1672",
    "deathDate": "21 Feb 1744",
    "burialDate": "21 Feb 1744",
    "christeningDate": "12 Jan 1672",
    "birthPlace": "Bolton, Brome, Quebec, Canada",
    "deathPlace": "Bolton by Bowland, Yorkshire, England, United Kingdom",
    "burialPlace": "Bolton, Yorkshire, England, United Kingdom",
    "christeningPlace": "Bolton by Bowland, Yorkshire, England, United Kingdom",
    "fsId": "LH76-86B",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Tho. Parkinson"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1077",
    "name": "Ellin Battersby",
    "sex": "F",
    "gen": 10,
    "slot": 453,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI639",
    "birthYear": 1686,
    "deathYear": 1738,
    "birthDate": "18 Mar 1686",
    "deathDate": "1738",
    "burialDate": "10 Apr 1738",
    "christeningDate": "18 Mar 1686",
    "birthPlace": "Yorkshire, England",
    "deathPlace": "Bolton by Bowland, Yorkshire, England, United Kingdom",
    "burialPlace": "Bolton by Bowland, Yorkshire, England, United Kingdom",
    "christeningPlace": "Bolton, Yorkshire, England, United Kingdom",
    "fsId": "MBSN-WHB",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Ellen",
      "Ellen Battersbie",
      "Ellen Battersby",
      "Ellin Battersbie"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1078",
    "name": "Robert Atkinson",
    "sex": "M",
    "gen": 10,
    "slot": 454,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI640",
    "birthYear": 1685,
    "deathYear": null,
    "birthDate": "Abt 1685",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Ripley, Yorkshire, England, United Kingdom",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "G1WZ-JL6",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1079",
    "name": "Alice Smurthet",
    "sex": "F",
    "gen": 10,
    "slot": 455,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI640",
    "birthYear": 1670,
    "deathYear": null,
    "birthDate": "Abt 1670",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Darley, Yorkshire, England, United Kingdom",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LZWW-M4M",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Alice Smarthet"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1080",
    "name": "John Riley",
    "sex": "M",
    "gen": 10,
    "slot": 460,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI643",
    "birthYear": 1702,
    "deathYear": 1768,
    "birthDate": "Nov 1702",
    "deathDate": "4 May 1768",
    "burialDate": "4 May 1768",
    "christeningDate": "24 Nov 1702",
    "birthPlace": "Oswaldtwistle, Lancashire, England, United Kingdom",
    "deathPlace": "Church Kirk, Lancashire, England, United Kingdom",
    "burialPlace": "Church Kirk, Lancashire, England, United Kingdom",
    "christeningPlace": "Church Kirk, Lancashire, England, United Kingdom",
    "fsId": "KZVG-H1P",
    "photo": null,
    "living": false,
    "alternateNames": [
      "John Ryley"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1081",
    "name": "Agnes Kemp",
    "sex": "F",
    "gen": 10,
    "slot": 461,
    "side": "paternal",
    "birthplace": "unknown",
    "childId": "AQI643",
    "birthYear": 1704,
    "deathYear": 1775,
    "birthDate": "1704",
    "deathDate": "1775",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "H4SJ-L42",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1082",
    "name": "William Duckworth",
    "sex": "M",
    "gen": 10,
    "slot": 462,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI644",
    "birthYear": 1713,
    "deathYear": 1790,
    "birthDate": "1713",
    "deathDate": "23 Jan 1790",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Clayton le Moors, Lancashire, England, United Kingdom",
    "deathPlace": "Great Harwood, Lancashire, England, United Kingdom",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "GK9Y-1FR",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1083",
    "name": "John Duckworth",
    "sex": "M",
    "gen": 10,
    "slot": 466,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI646",
    "birthYear": 1735,
    "deathYear": null,
    "birthDate": "Abt 1735",
    "deathDate": null,
    "burialDate": "7 Mar 1802",
    "christeningDate": null,
    "birthPlace": "of Blackburn, Lancs, Eng.",
    "deathPlace": null,
    "burialPlace": "Blackburn, Lancashire, England, United Kingdom",
    "christeningPlace": null,
    "fsId": "LVXY-4LH",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1084",
    "name": "Betty",
    "sex": "F",
    "gen": 10,
    "slot": 467,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI646",
    "birthYear": 1739,
    "deathYear": null,
    "birthDate": "Abt 1739",
    "deathDate": null,
    "burialDate": "27 Dec 1761",
    "christeningDate": null,
    "birthPlace": "Lancashire, England",
    "deathPlace": null,
    "burialPlace": "St Mary the Virgin Church, Eccleston, Lancashire, England, United Kingdom",
    "christeningPlace": null,
    "fsId": "LVXY-4GF",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Betty Abbott",
      "Betty Abbott Duckworth",
      "Betty Duckworth"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1085",
    "name": "Thomas Leaver",
    "sex": "M",
    "gen": 10,
    "slot": 468,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI649",
    "birthYear": 1698,
    "deathYear": null,
    "birthDate": "Abt 1698",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Benson, Oxfordshire, England",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "L7GP-Y2D",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Thomas Leever",
      "Thomas Lever"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1086",
    "name": "Elizabeth Burgess",
    "sex": "F",
    "gen": 10,
    "slot": 469,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI649",
    "birthYear": 1698,
    "deathYear": null,
    "birthDate": "Abt 1698",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Bolton, Lancashire, England, United Kingdom",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LCM8-LDL",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Elizabeth"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1089",
    "name": "Daniel Holden",
    "sex": "M",
    "gen": 10,
    "slot": 472,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI651",
    "birthYear": 1700,
    "deathYear": 1745,
    "birthDate": "Abt 1700",
    "deathDate": "18 Mar 1745",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Bury, Lancashire, England, United Kingdom",
    "deathPlace": "Holcombe, Lancashire, England, United Kingdom",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "PF6F-CM8",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1090",
    "name": "Esther Holt",
    "sex": "F",
    "gen": 10,
    "slot": 473,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI651",
    "birthYear": 1706,
    "deathYear": null,
    "birthDate": "10 Mar 1706",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "17 Mar 1706",
    "birthPlace": "Turton, Lancashire, England",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Bolton, Lancashire, England, United Kingdom",
    "fsId": "MNH1-Y5D",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1091",
    "name": "Willam Fletcher",
    "sex": "M",
    "gen": 10,
    "slot": 474,
    "side": "paternal",
    "birthplace": "unknown",
    "childId": "AQI652",
    "birthYear": null,
    "deathYear": null,
    "birthDate": null,
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "GSBN-J31",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1092",
    "name": "Mary Ainsworth",
    "sex": "F",
    "gen": 10,
    "slot": 475,
    "side": "paternal",
    "birthplace": "england",
    "childId": "AQI652",
    "birthYear": 1730,
    "deathYear": null,
    "birthDate": "16 Sep 1730",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "26 Sep 1730",
    "birthPlace": "Bury, Lancashire, England, United Kingdom",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "St Mary The Virgin's Church, Bury, Lancashire, England, United Kingdom",
    "fsId": "GSBN-2SM",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1094",
    "name": "William Thompson",
    "sex": "M",
    "gen": 10,
    "slot": 476,
    "side": "paternal",
    "birthplace": "unknown",
    "childId": "AQI653",
    "birthYear": null,
    "deathYear": null,
    "birthDate": null,
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "G2T4-7FT",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1095",
    "name": "Mary Thompson",
    "sex": "F",
    "gen": 10,
    "slot": 477,
    "side": "paternal",
    "birthplace": "unknown",
    "childId": "AQI653",
    "birthYear": null,
    "deathYear": null,
    "birthDate": null,
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "G2T4-NYL",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1096",
    "name": "Sören Hansen",
    "sex": "M",
    "gen": 10,
    "slot": 496,
    "side": "paternal",
    "birthplace": "unknown",
    "childId": "AQI655",
    "birthYear": null,
    "deathYear": null,
    "birthDate": null,
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "K8V6-KXT",
    "photo": "/ancestors/bubbles/1520_K8V6-KXT.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1520_K8V6-KXT.jpg"
  },
  {
    "id": "AQI1097",
    "name": "Giertrüd Pedersdatter",
    "sex": "F",
    "gen": 10,
    "slot": 497,
    "side": "paternal",
    "birthplace": "unknown",
    "childId": "AQI655",
    "birthYear": null,
    "deathYear": null,
    "birthDate": null,
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "KZPK-KN6",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Gjertrüd Pedersdatter"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1098",
    "name": "Henrich Jørgensen",
    "sex": "M",
    "gen": 10,
    "slot": 498,
    "side": "paternal",
    "birthplace": "unknown",
    "childId": "AQI656",
    "birthYear": null,
    "deathYear": null,
    "birthDate": null,
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "L878-TFJ",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1099",
    "name": "Maren Jacobsdatter",
    "sex": "F",
    "gen": 10,
    "slot": 499,
    "side": "paternal",
    "birthplace": "unknown",
    "childId": "AQI656",
    "birthYear": null,
    "deathYear": null,
    "birthDate": null,
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "L878-TFV",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1108",
    "name": "Johannes Hipple",
    "sex": "M",
    "gen": 10,
    "slot": 524,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI672",
    "birthYear": 1698,
    "deathYear": 1749,
    "birthDate": "1698",
    "deathDate": "Apr 1749",
    "burialDate": "1749",
    "christeningDate": null,
    "birthPlace": "Germany",
    "deathPlace": "Vincent Township, Chester, Pennsylvania, United States",
    "burialPlace": "Vincent Mennonite Church, Vincent Township, Chester, Pennsylvania, British Colonial America",
    "christeningPlace": null,
    "fsId": "LKVF-CCC",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1109",
    "name": "Elisabetha Catharina",
    "sex": "F",
    "gen": 10,
    "slot": 525,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI672",
    "birthYear": 1701,
    "deathYear": null,
    "birthDate": "Abt 1701",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Germany",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "GDSX-BTM",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1110",
    "name": "Matthes Haaß",
    "sex": "M",
    "gen": 10,
    "slot": 526,
    "side": "maternal",
    "birthplace": "unknown",
    "childId": "AQI673",
    "birthYear": null,
    "deathYear": null,
    "birthDate": null,
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "PCY2-Q6W",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1111",
    "name": "Anna Catherina Elizabeth Herrmann",
    "sex": "F",
    "gen": 10,
    "slot": 527,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI673",
    "birthYear": 1707,
    "deathYear": 1784,
    "birthDate": "12 Nov 1707",
    "deathDate": "8 Sep 1784",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Nister, Oberwesterwaldkreis, Hesse-Nassau, Prussia, Germany",
    "deathPlace": "Homberg, Hesse-Nassau, Prussia, Germany",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "GZTR-NLR",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1112",
    "name": "John Yarnall",
    "sex": "M",
    "gen": 10,
    "slot": 544,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI674",
    "birthYear": 1695,
    "deathYear": 1749,
    "birthDate": "5 Jan 1695",
    "deathDate": "5 Sep 1749",
    "burialDate": "Sep 1749",
    "christeningDate": null,
    "birthPlace": "Chester, Pennsylvania, British Colonial America",
    "deathPlace": "Wilmington, New Castle, Delaware, United States",
    "burialPlace": "Wilmington, New Castle, Delaware, United States",
    "christeningPlace": null,
    "fsId": "LHPP-7VC",
    "photo": "/ancestors/bubbles/1568_LHPP-7VC.jpg",
    "living": false,
    "alternateNames": [
      "John",
      "John Yarnell",
      "John Yornall"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1568_LHPP-7VC.jpg"
  },
  {
    "id": "AQI1113",
    "name": "Abigail Williamson",
    "sex": "F",
    "gen": 10,
    "slot": 545,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI674",
    "birthYear": 1702,
    "deathYear": 1775,
    "birthDate": "16 Jul 1702",
    "deathDate": "28 Dec 1775",
    "burialDate": "Dec 1775",
    "christeningDate": null,
    "birthPlace": "Newtown Monthly Meeting, Chester, Pennsylvania, British Colonial America",
    "deathPlace": "Edgemont MM, Chester, Pennsylvania, United States",
    "burialPlace": "Edgemont MM, Chester, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LCTF-KR6",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1114",
    "name": "William Hill",
    "sex": "M",
    "gen": 10,
    "slot": 546,
    "side": "maternal",
    "birthplace": "england",
    "childId": "AQI675",
    "birthYear": 1684,
    "deathYear": 1756,
    "birthDate": "1684",
    "deathDate": "17 Apr 1756",
    "burialDate": null,
    "christeningDate": "16 Nov 1684",
    "birthPlace": "St Bride's Church Fleet Street, London, England, United Kingdom",
    "deathPlace": "Middletown, Dauphin, Pennsylvania, United States",
    "burialPlace": "Dauphin, Pennsylvania, United States",
    "christeningPlace": "St Bride's Church Fleet Street, London, England, United Kingdom",
    "fsId": "LDJL-XSK",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1115",
    "name": "Mary Hunter",
    "sex": "F",
    "gen": 10,
    "slot": 547,
    "side": "maternal",
    "birthplace": "ireland",
    "childId": "AQI675",
    "birthYear": 1693,
    "deathYear": 1770,
    "birthDate": "Abt 1693",
    "deathDate": "1770",
    "burialDate": null,
    "christeningDate": "17 Mar 1692",
    "birthPlace": "Rathdrum, Rathdrum, County Wicklow, Ireland",
    "deathPlace": "Chester, Pennsylvania, United States",
    "burialPlace": "Saint Davids, Radnor, Radnor Township, Welsh Tract, Pennsylvania, British Colonial America",
    "christeningPlace": "Medomsley, Durham, England",
    "fsId": "9NWK-1F4",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Mary Hunter Hill",
      "Mary Hunter Bennett"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1116",
    "name": "Thomas Noble",
    "sex": "M",
    "gen": 10,
    "slot": 576,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI676",
    "birthYear": 1665,
    "deathYear": 1750,
    "birthDate": "14 Jan 1665",
    "deathDate": "29 Jul 1750",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Springfield, Hampden, Massachusetts, United States",
    "deathPlace": "Westfield, Hampshire, Massachusetts Bay Colony, British Colonial America",
    "burialPlace": "Westfield, Hampshire, Massachusetts Bay Colony, British Colonial America",
    "christeningPlace": null,
    "fsId": "9WFC-FM8",
    "photo": "/ancestors/bubbles/1600_9WFC-FM8.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1600_9WFC-FM8.jpg"
  },
  {
    "id": "AQI1117",
    "name": "Elizabeth Dewey",
    "sex": "F",
    "gen": 10,
    "slot": 577,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI676",
    "birthYear": 1677,
    "deathYear": 1757,
    "birthDate": "10 Jan 1677",
    "deathDate": "2 Oct 1757",
    "burialDate": "1757",
    "christeningDate": "17 Jun 1677",
    "birthPlace": "Westfield, Hampshire, Massachusetts Bay Colony, British Colonial America",
    "deathPlace": "Westfield, Hampshire, Massachusetts Bay Colony, British Colonial America",
    "burialPlace": "Westfield, Hampshire, Massachusetts Bay Colony, British Colonial America",
    "christeningPlace": "Westfield, Hampshire, Massachusetts Bay Colony, British Colonial America",
    "fsId": "LZ87-GSD",
    "photo": "/ancestors/bubbles/1601_LZ87-GSD.jpg",
    "living": false,
    "alternateNames": [
      "Elizabeth Noble"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1601_LZ87-GSD.jpg"
  },
  {
    "id": "AQI1118",
    "name": "John Root",
    "sex": "M",
    "gen": 10,
    "slot": 578,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI677",
    "birthYear": 1672,
    "deathYear": 1731,
    "birthDate": "28 Dec 1672",
    "deathDate": "1 May 1731",
    "burialDate": null,
    "christeningDate": "5 Dec 1680",
    "birthPlace": "Westfield, Hampshire, Massachusetts Bay Colony, British Colonial America",
    "deathPlace": "Westfield, Hampshire, Massachusetts Bay Colony, British Colonial America",
    "burialPlace": null,
    "christeningPlace": "Westfield, Hampshire, Massachusetts Bay Colony, British Colonial America",
    "fsId": "9HGL-6KZ",
    "photo": "/ancestors/bubbles/1602_9HGL-6KZ.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1602_9HGL-6KZ.jpg"
  },
  {
    "id": "AQI1119",
    "name": "Sarah Stebbins",
    "sex": "F",
    "gen": 10,
    "slot": 579,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI677",
    "birthYear": 1681,
    "deathYear": 1713,
    "birthDate": "20 Feb 1681",
    "deathDate": "1 May 1713",
    "burialDate": "1713",
    "christeningDate": "20 Feb 1681",
    "birthPlace": "Springfield, Hampshire, Massachusetts Bay Colony, British Colonial America",
    "deathPlace": "Westfield, Hampshire, Massachusetts Bay Colony, British Colonial America",
    "burialPlace": "Springfield, Hampshire, Massachusetts Bay Colony, British Colonial America",
    "christeningPlace": "Springfield, Hampshire, Massachusetts Bay Colony, British Colonial America",
    "fsId": "LCZD-2JS",
    "photo": "/ancestors/bubbles/1603_LCZD-2JS.jpg",
    "living": false,
    "alternateNames": [
      "Sarah Stebbin",
      "Sarah Stebbein"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1603_LCZD-2JS.jpg"
  },
  {
    "id": "AQI1120",
    "name": "Joseph Sexton",
    "sex": "M",
    "gen": 10,
    "slot": 580,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI678",
    "birthYear": 1666,
    "deathYear": 1742,
    "birthDate": "3 Feb 1666",
    "deathDate": "3 May 1742",
    "burialDate": "May 1742",
    "christeningDate": "14 Jan 1682",
    "birthPlace": "Windsor, Hartford, Connecticut Colony, British Colonial America",
    "deathPlace": "Enfield, Hartford, Connecticut Colony, British Colonial America",
    "burialPlace": "Enfield Street Cemetery, Enfield, Hartford, Connecticut, United States",
    "christeningPlace": "Westfield, Hampshire, Massachusetts Bay Colony, British Colonial America",
    "fsId": "LTFJ-J5G",
    "photo": "/ancestors/bubbles/1604_LTFJ-J5G.jpg",
    "living": false,
    "alternateNames": [
      "Captain Joseph Sexton"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1604_LTFJ-J5G.jpg"
  },
  {
    "id": "AQI1121",
    "name": "Hannah Wright",
    "sex": "F",
    "gen": 10,
    "slot": 581,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI678",
    "birthYear": 1669,
    "deathYear": 1742,
    "birthDate": "28 Jul 1669",
    "deathDate": "26 Nov 1742",
    "burialDate": "1742",
    "christeningDate": "23 Feb 1694",
    "birthPlace": "Springfield, Hampshire, Massachusetts Bay Colony, British Colonial America",
    "deathPlace": "Enfield, Massachusetts Bay Colony, British Colonial America",
    "burialPlace": "Enfield Street Cemetery, Enfield, Hartford, Connecticut, United States",
    "christeningPlace": "Westfield, Hampshire, Massachusetts Bay Colony, British Colonial America",
    "fsId": "L41Y-5JX",
    "photo": "/ancestors/bubbles/1605_L41Y-5JX.jpg",
    "living": false,
    "alternateNames": [
      "Hannah Sexton"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1605_L41Y-5JX.jpg"
  },
  {
    "id": "AQI1122",
    "name": "Thomas Douglas",
    "sex": "M",
    "gen": 10,
    "slot": 582,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI679",
    "birthYear": 1679,
    "deathYear": 1724,
    "birthDate": "15 May 1679",
    "deathDate": "3 Mar 1724",
    "burialDate": "1724",
    "christeningDate": "22 Jun 1679",
    "birthPlace": "New London, New London, Connecticut Colony, British Colonial America",
    "deathPlace": "Ancient Cemetery, New London, New London, Connecticut, United States",
    "burialPlace": "Ancient Cemetery, New London, New London, Connecticut, United States",
    "christeningPlace": "New London, New London, Connecticut Colony, British Colonial America",
    "fsId": "LB3J-663",
    "photo": "/ancestors/bubbles/1606_LB3J-663.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1606_LB3J-663.jpg"
  },
  {
    "id": "AQI1123",
    "name": "Hannah Sperry",
    "sex": "F",
    "gen": 10,
    "slot": 583,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI679",
    "birthYear": 1685,
    "deathYear": 1758,
    "birthDate": "4 Jan 1685",
    "deathDate": "4 Nov 1758",
    "burialDate": null,
    "christeningDate": "17 Jan 1685",
    "birthPlace": "Newhaven Towne, New Haven, Connecticut Colony, British Colonial America",
    "deathPlace": "New Haven, Connecticut Colony, British Colonial America",
    "burialPlace": "New London, New London, Connecticut, United States",
    "christeningPlace": "Newhaven Towne, New Haven, Connecticut Colony, British Colonial America",
    "fsId": "L83D-B3M",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1124",
    "name": "John Buell",
    "sex": "M",
    "gen": 10,
    "slot": 584,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI680",
    "birthYear": 1671,
    "deathYear": 1746,
    "birthDate": "17 Feb 1671",
    "deathDate": "9 Apr 1746",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Killingworth, Middlesex, Connecticut, United States",
    "deathPlace": "Litchfield, Litchfield, Connecticut, United States",
    "burialPlace": "West Cemetery, Litchfield, Litchfield, Connecticut, United States",
    "christeningPlace": null,
    "fsId": "LYLP-HVP",
    "photo": "/ancestors/bubbles/1608_LYLP-HVP.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1608_LYLP-HVP.jpg"
  },
  {
    "id": "AQI1125",
    "name": "Mary Loomis",
    "sex": "F",
    "gen": 10,
    "slot": 585,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI680",
    "birthYear": 1672,
    "deathYear": 1768,
    "birthDate": "20 Mar 1672",
    "deathDate": "4 Nov 1768",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Windsor, Hartford, Connecticut, United States",
    "deathPlace": "Killingworth, Middlesex, Connecticut, United States",
    "burialPlace": "West Cemetery, Litchfield, Litchfield, Connecticut, United States",
    "christeningPlace": null,
    "fsId": "LYLP-HSC",
    "photo": "/ancestors/bubbles/1609_LYLP-HSC.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1609_LYLP-HSC.jpg"
  },
  {
    "id": "AQI1126",
    "name": "Jedediah Strong",
    "sex": "M",
    "gen": 10,
    "slot": 586,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI681",
    "birthYear": 1667,
    "deathYear": 1709,
    "birthDate": "7 Aug 1667",
    "deathDate": "12 Oct 1709",
    "burialDate": "Oct 1709",
    "christeningDate": "7 Oct 1667",
    "birthPlace": "Northampton, Hampshire, Massachusetts Bay Colony, British Colonial America",
    "deathPlace": "Lebanon, New London, Connecticut Colony, British Colonial America",
    "burialPlace": "Exeter, Lebanon, New London, Connecticut Colony, British Colonial America",
    "christeningPlace": "Northampton, Hampshire, Massachusetts Bay Colony, British Colonial America",
    "fsId": "KNC6-1N8",
    "photo": "/ancestors/bubbles/1610_KNC6-1N8.jpg",
    "living": false,
    "alternateNames": [
      "Jedediah Strong Jr"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1610_KNC6-1N8.jpg"
  },
  {
    "id": "AQI1127",
    "name": "Abijah Ingersoll",
    "sex": "F",
    "gen": 10,
    "slot": 587,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI681",
    "birthYear": 1663,
    "deathYear": 1732,
    "birthDate": "24 Aug 1663",
    "deathDate": "20 Nov 1732",
    "burialDate": "21 Nov 1732",
    "christeningDate": "24 Aug 1663",
    "birthPlace": "Northampton, Hampshire, Massachusetts Bay Colony, British Colonial America",
    "deathPlace": "Lebanon, Connecticut Colony, British Colonial America",
    "burialPlace": "Lebanon, New London, Connecticut Colony, British Colonial America",
    "christeningPlace": "Northampton, Hampshire, Massachusetts Bay Colony, British Colonial America",
    "fsId": "LY5M-1S7",
    "photo": "/ancestors/bubbles/1611_LY5M-1S7.jpg",
    "living": false,
    "alternateNames": [
      "Abiah Ingersoll"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1611_LY5M-1S7.jpg"
  },
  {
    "id": "AQI1128",
    "name": "Nehemiah Fisher",
    "sex": "M",
    "gen": 10,
    "slot": 588,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI682",
    "birthYear": 1703,
    "deathYear": 1751,
    "birthDate": "3 Sep 1703",
    "deathDate": "Aft 28 Oct 1751",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Norton, Bristol, Massachusetts Bay Colony, British Colonial America",
    "deathPlace": "Norton, Bristol, Massachusetts Bay Colony, British Colonial America",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "K235-8NR",
    "photo": "/ancestors/bubbles/1612_K235-8NR.jpg",
    "living": false,
    "alternateNames": [
      "Nemiah Fisher"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1612_K235-8NR.jpg"
  },
  {
    "id": "AQI1129",
    "name": "Sarah Morse",
    "sex": "F",
    "gen": 10,
    "slot": 589,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI682",
    "birthYear": 1708,
    "deathYear": 1744,
    "birthDate": "3 Jun 1708",
    "deathDate": "6 May 1744",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Watertown, Middlesex, Massachusetts Bay Colony, British Colonial America",
    "deathPlace": "Norton, Bristol, Massachusetts Bay Colony, British Colonial America",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LZR5-23B",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Sarah Morss",
      "Sarah Moye"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1130",
    "name": "Eleazer Beecher",
    "sex": "M",
    "gen": 10,
    "slot": 590,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI683",
    "birthYear": 1707,
    "deathYear": 1797,
    "birthDate": "4 Nov 1707",
    "deathDate": "23 Dec 1797",
    "burialDate": "1797",
    "christeningDate": null,
    "birthPlace": "New Milford, Litchfield, Connecticut, United States",
    "deathPlace": "New Milford, Litchfield, Connecticut, United States",
    "burialPlace": "Center Cemetery, New Milford, Litchfield, Connecticut, United States",
    "christeningPlace": null,
    "fsId": "LH8X-1B4",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1131",
    "name": "Frances Oviatt",
    "sex": "F",
    "gen": 10,
    "slot": 591,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI683",
    "birthYear": 1709,
    "deathYear": 1791,
    "birthDate": "1709",
    "deathDate": "6 Sep 1791",
    "burialDate": "Sep 1791",
    "christeningDate": "25 Jul 1725",
    "birthPlace": "New Milford, Litchfield, Connecticut Colony, British Colonial America",
    "deathPlace": "New Milford, Litchfield, Connecticut, United States",
    "burialPlace": "Center Cemetery, New Milford, Litchfield, Connecticut, United States",
    "christeningPlace": "Milford, New Haven, Connecticut, United States",
    "fsId": "LCQQ-MVD",
    "photo": "/ancestors/bubbles/1615_LCQQ-MVD.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1615_LCQQ-MVD.jpg"
  },
  {
    "id": "AQI1132",
    "name": "John Garrott",
    "sex": "M",
    "gen": 10,
    "slot": 592,
    "side": "maternal",
    "birthplace": "england",
    "childId": "AQI684",
    "birthYear": 1714,
    "deathYear": null,
    "birthDate": "1714",
    "deathDate": null,
    "burialDate": "5 Dec 1731",
    "christeningDate": "26 Feb 1715",
    "birthPlace": "Dunchurch, Warwickshire, England, United Kingdom",
    "deathPlace": null,
    "burialPlace": "Fillongley, Warwickshire, England, United Kingdom",
    "christeningPlace": "Dunchurch, Warwickshire, England, United Kingdom",
    "fsId": "L2DF-ZN4",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1133",
    "name": "Mary Garrott",
    "sex": "F",
    "gen": 10,
    "slot": 593,
    "side": "maternal",
    "birthplace": "england",
    "childId": "AQI684",
    "birthYear": 1714,
    "deathYear": null,
    "birthDate": "Abt 1714",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "England, United Kingdom",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "L2DF-ZPN",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Mary"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1134",
    "name": "George Longslough",
    "sex": "M",
    "gen": 10,
    "slot": 594,
    "side": "maternal",
    "birthplace": "unknown",
    "childId": "AQI685",
    "birthYear": null,
    "deathYear": null,
    "birthDate": null,
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "MJ9T-TY9",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1135",
    "name": "Hannah",
    "sex": "F",
    "gen": 10,
    "slot": 595,
    "side": "maternal",
    "birthplace": "unknown",
    "childId": "AQI685",
    "birthYear": null,
    "deathYear": null,
    "birthDate": null,
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "MJ9T-TYD",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1136",
    "name": "Jeremiah Kelsey",
    "sex": "M",
    "gen": 10,
    "slot": 596,
    "side": "maternal",
    "birthplace": "unknown",
    "childId": "AQI686",
    "birthYear": null,
    "deathYear": null,
    "birthDate": null,
    "deathDate": null,
    "burialDate": "9 Sep 1764",
    "christeningDate": "18 Feb 1693",
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": "Ansley, Warwickshire, England, United Kingdom",
    "christeningPlace": "Ansley, Warwickshire, England, United Kingdom",
    "fsId": "LM1Z-88V",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Jeremy Kelsey"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1137",
    "name": "Elizabeth Robson",
    "sex": "F",
    "gen": 10,
    "slot": 597,
    "side": "maternal",
    "birthplace": "unknown",
    "childId": "AQI686",
    "birthYear": null,
    "deathYear": 1770,
    "birthDate": null,
    "deathDate": "28 Jan 1770",
    "burialDate": "28 Jan 1770",
    "christeningDate": "20 Oct 1700",
    "birthPlace": null,
    "deathPlace": "Ansley, Warwickshire, England, United Kingdom",
    "burialPlace": "Ansley, Warwickshire, England, United Kingdom",
    "christeningPlace": "Ansley, Warwickshire, England, United Kingdom",
    "fsId": "LM1Z-C6H",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Eliz",
      "Eliz Robson"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1138",
    "name": "Richard Jeffcote",
    "sex": "M",
    "gen": 10,
    "slot": 598,
    "side": "maternal",
    "birthplace": "england",
    "childId": "AQI687",
    "birthYear": 1686,
    "deathYear": 1746,
    "birthDate": "1 Apr 1686",
    "deathDate": "1746",
    "burialDate": "7 Dec 1746",
    "christeningDate": "23 Jan 1686",
    "birthPlace": "Mancetter, Warwickshire, England, United Kingdom",
    "deathPlace": null,
    "burialPlace": "Nuneaton, Warwickshire, England, United Kingdom",
    "christeningPlace": "Nuneaton, Warwickshire, England, United Kingdom",
    "fsId": "MJS7-YD4",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Richard Jefcote"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1139",
    "name": "Alice Davis",
    "sex": "F",
    "gen": 10,
    "slot": 599,
    "side": "maternal",
    "birthplace": "england",
    "childId": "AQI687",
    "birthYear": 1693,
    "deathYear": 1758,
    "birthDate": "1693",
    "deathDate": "Jan 1758",
    "burialDate": "30 Jan 1758",
    "christeningDate": null,
    "birthPlace": "Nuneaton, Warwickshire, England, United Kingdom",
    "deathPlace": "Nuneaton, Warwickshire, England, United Kingdom",
    "burialPlace": "Nuneaton, Warwickshire, England, United Kingdom",
    "christeningPlace": null,
    "fsId": "MJ94-SM3",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1140",
    "name": "Samuel Albro",
    "sex": "M",
    "gen": 10,
    "slot": 600,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI688",
    "birthYear": 1716,
    "deathYear": 1767,
    "birthDate": "10 Oct 1716",
    "deathDate": "29 Mar 1767",
    "burialDate": "1767",
    "christeningDate": null,
    "birthPlace": "Portsmouth, Newport, Rhode Island, British Colonial America",
    "deathPlace": "North Kingstown, Kings, Rhode Island, British Colonial America",
    "burialPlace": "Old Baptist Meetinghouse Yard, North Kingstown, Washington, Rhode Island, United States",
    "christeningPlace": null,
    "fsId": "LB52-FDB",
    "photo": "/ancestors/bubbles/1624_LB52-FDB.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1624_LB52-FDB.jpg"
  },
  {
    "id": "AQI1141",
    "name": "Alice Waite Rogers",
    "sex": "F",
    "gen": 10,
    "slot": 601,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI688",
    "birthYear": 1719,
    "deathYear": 1787,
    "birthDate": "16 Mar 1719",
    "deathDate": "20 Mar 1787",
    "burialDate": "Mar 1787",
    "christeningDate": null,
    "birthPlace": "West Greenwich, Kent, Rhode Island, British Colonial America",
    "deathPlace": "Exeter, Washington, Rhode Island, United States",
    "burialPlace": "Old Baptist Meetinghouse Yard, North Kingstown, Washington, Rhode Island, United States",
    "christeningPlace": null,
    "fsId": "LCV8-V7J",
    "photo": "/ancestors/bubbles/1625_LCV8-V7J.jpg",
    "living": false,
    "alternateNames": [
      "Alice"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1625_LCV8-V7J.jpg"
  },
  {
    "id": "AQI1142",
    "name": "Ephraim Bull",
    "sex": "M",
    "gen": 10,
    "slot": 602,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI689",
    "birthYear": 1702,
    "deathYear": 1774,
    "birthDate": "18 Apr 1702",
    "deathDate": "Aft 1774",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Kings Towne, King's Province, Rhode Island, British Colonial America",
    "deathPlace": "South Kingstown, Kings, Rhode Island, British Colonial America",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "M24S-S8C",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1143",
    "name": "Patience Rodman",
    "sex": "F",
    "gen": 10,
    "slot": 603,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI689",
    "birthYear": 1709,
    "deathYear": 1739,
    "birthDate": "22 Mar 1709",
    "deathDate": "9 May 1739",
    "burialDate": "May 1739",
    "christeningDate": null,
    "birthPlace": "South Kingstown, Kings, Rhode Island, British Colonial America",
    "deathPlace": "Rhode Island, United States",
    "burialPlace": "Middletown, Newport, Rhode Island, British Colonial America",
    "christeningPlace": null,
    "fsId": "L6LF-P3Q",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1144",
    "name": "John Tice",
    "sex": "M",
    "gen": 10,
    "slot": 604,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI690",
    "birthYear": 1705,
    "deathYear": null,
    "birthDate": "1705",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Westchester, New York, United States",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "M58N-7FM",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1145",
    "name": "Catharine VAN TEXEL",
    "sex": "F",
    "gen": 10,
    "slot": 605,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI690",
    "birthYear": 1710,
    "deathYear": 1795,
    "birthDate": "1710",
    "deathDate": "Aft 1795",
    "burialDate": null,
    "christeningDate": "17 Apr 1733",
    "birthPlace": "Westchester, New York, United States",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "K2T1-GY1",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Catriena Van Tassel"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1148",
    "name": "Abraham Van Tassell",
    "sex": "M",
    "gen": 10,
    "slot": 606,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI691",
    "birthYear": 1714,
    "deathYear": null,
    "birthDate": "19 May 1714",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "25 May 1714",
    "birthPlace": "Philipsburg Manor, Westchester, New York Colony, British Colonial America",
    "deathPlace": "Westchester, New York Colony, British Colonial America",
    "burialPlace": null,
    "christeningPlace": "Westchester, New York Colony, British Colonial America",
    "fsId": "GV4S-P46",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Van Tassel, Van Thessel, Van Taxel, Van Texel"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1149",
    "name": "Cornelia Delamater",
    "sex": "F",
    "gen": 10,
    "slot": 607,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI691",
    "birthYear": 1718,
    "deathYear": null,
    "birthDate": "1718",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "New York County, New York Colony, British Colonial America",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LHR8-NBT",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1150",
    "name": "Johann Paul Moser",
    "sex": "M",
    "gen": 10,
    "slot": 656,
    "side": "maternal",
    "birthplace": "france",
    "childId": "AQI692",
    "birthYear": 1697,
    "deathYear": 1780,
    "birthDate": "29 Mar 1697",
    "deathDate": "19 Aug 1780",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Wingen, Bas-Rhin, France",
    "deathPlace": null,
    "burialPlace": "Oley Township, Berks, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "L24P-3NL",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Johan Paul Moser"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1151",
    "name": "Maria Barbara Cassel",
    "sex": "F",
    "gen": 10,
    "slot": 657,
    "side": "maternal",
    "birthplace": "france",
    "childId": "AQI692",
    "birthYear": 1702,
    "deathYear": 1772,
    "birthDate": "1 May 1702",
    "deathDate": "1772",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Zittersheim, Bas-Rhin, France",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "2DXN-PY7",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Maria Barbara Cassel Moser"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1152",
    "name": "Johann Jacob Busch",
    "sex": "M",
    "gen": 10,
    "slot": 658,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI693",
    "birthYear": 1709,
    "deathYear": 1767,
    "birthDate": "14 Jan 1709",
    "deathDate": "1767",
    "burialDate": null,
    "christeningDate": "4 Jan 1709",
    "birthPlace": "Schwaigern, Brackenheim, Württemberg, Germany",
    "deathPlace": "Berks, Pennsylvania, United States",
    "burialPlace": "Philadelphia, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "G7HC-KZ5",
    "photo": null,
    "living": false,
    "alternateNames": [
      "J Jacob Busch",
      "Jacob Busch",
      "John Jacob Bush",
      "Living"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1153",
    "name": "Anna Elisabeth Essig",
    "sex": "F",
    "gen": 10,
    "slot": 659,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI693",
    "birthYear": 1708,
    "deathYear": 1779,
    "birthDate": "8 Oct 1708",
    "deathDate": "1779",
    "burialDate": null,
    "christeningDate": "18 Oct 1708",
    "birthPlace": "Massenbach, Brackenheim, Württemberg, Germany",
    "deathPlace": "Berks, Pennsylvania, United States",
    "burialPlace": null,
    "christeningPlace": "Massenbach, Brackenheim, Württemberg, Germany",
    "fsId": "LWXR-3M2",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Anna Elisabetha Essig",
      "Anna Elisabethe Essig",
      "Anna Elizabeth Essig",
      "Anna Maria Elizabeth Essig",
      "Busch"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1154",
    "name": "Michael Handte",
    "sex": "M",
    "gen": 10,
    "slot": 660,
    "side": "maternal",
    "birthplace": "unknown",
    "childId": "AQI694",
    "birthYear": 1693,
    "deathYear": 1755,
    "birthDate": "1693",
    "deathDate": "1755",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "GLMY-YBX",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1155",
    "name": "Catharina Geiger",
    "sex": "F",
    "gen": 10,
    "slot": 661,
    "side": "maternal",
    "birthplace": "unknown",
    "childId": "AQI694",
    "birthYear": 1693,
    "deathYear": 1736,
    "birthDate": "1693",
    "deathDate": "1736",
    "burialDate": null,
    "christeningDate": "18 Sep 1693",
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Täferrot, Gmünd, Württemberg, Germany",
    "fsId": "MJC7-VYD",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1156",
    "name": "Johann Georg Knoehr",
    "sex": "M",
    "gen": 10,
    "slot": 662,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI695",
    "birthYear": 1696,
    "deathYear": 1742,
    "birthDate": "14 Feb 1696",
    "deathDate": "1742",
    "burialDate": "5 Jun 1742",
    "christeningDate": "14 Feb 1696",
    "birthPlace": "Bempflingen, Urach, Württemberg, Germany",
    "deathPlace": "Altdorf, Oberamt Böblingen, Württemberg, Germany",
    "burialPlace": "Altdorf, Oberamt Nürtingen, Württemberg, Germany",
    "christeningPlace": "Kleinbettlingen, Bempflingen, Esslingen, Baden-Württemberg, Germany",
    "fsId": "KNSD-D7Q",
    "photo": "/ancestors/bubbles/1686_KNSD-D7Q.jpg",
    "living": false,
    "alternateNames": [
      "Johann Georg Luöhr"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1686_KNSD-D7Q.jpg"
  },
  {
    "id": "AQI1157",
    "name": "Anna Barbara Eisinger",
    "sex": "F",
    "gen": 10,
    "slot": 663,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI695",
    "birthYear": 1703,
    "deathYear": 1747,
    "birthDate": "11 Dec 1703",
    "deathDate": "24 Jul 1747",
    "burialDate": "26 Jul 1747",
    "christeningDate": "11 Dec 1703",
    "birthPlace": "Altdorf, Oberamt Nürtingen, Württemberg, Germany",
    "deathPlace": "Altdorf, Oberamt Nürtingen, Württemberg, Germany",
    "burialPlace": "Holy Roman Empire",
    "christeningPlace": "Neckartailfingen, Oberamt Nürtingen, Württemberg, Germany",
    "fsId": "GCZK-Z8F",
    "photo": "/ancestors/bubbles/1687_GCZK-Z8F.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1687_GCZK-Z8F.jpg"
  },
  {
    "id": "AQI1158",
    "name": "Johan Jost Wigandt",
    "sex": "M",
    "gen": 10,
    "slot": 664,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI696",
    "birthYear": 1672,
    "deathYear": 1758,
    "birthDate": "6 Nov 1672",
    "deathDate": "12 Feb 1758",
    "burialDate": "14 Feb 1758",
    "christeningDate": null,
    "birthPlace": "Palatinate, Bavaria, Germany",
    "deathPlace": "Freinsheim, Bad Dürkheim, Rhineland-Palatinate, Germany",
    "burialPlace": "Freinsheim, Bad Dürkheim, Rhineland-Palatinate, Germany",
    "christeningPlace": null,
    "fsId": "LYH9-4DW",
    "photo": "/ancestors/bubbles/1688_LYH9-4DW.jpg",
    "living": false,
    "alternateNames": [
      "Jost Wygandt",
      "Jost Wigand",
      "Jost Wiegand"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1688_LYH9-4DW.jpg"
  },
  {
    "id": "AQI1159",
    "name": "Catharina Philippina Isenbarth",
    "sex": "F",
    "gen": 10,
    "slot": 665,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI696",
    "birthYear": 1699,
    "deathYear": 1767,
    "birthDate": "6 Mar 1699",
    "deathDate": "17 Oct 1767",
    "burialDate": "18 Oct 1767",
    "christeningDate": "6 Mar 1699",
    "birthPlace": "Kleinkarlbach, Leiningerland Verbandsgemeinde, Bad Dürkheim, Rhineland-Palatinate, Germany",
    "deathPlace": "Freinsheim, Bad Dürkheim, Rhineland-Palatinate, Germany",
    "burialPlace": "Freinsheim, Bad Dürkheim, Rhineland-Palatinate, Germany",
    "christeningPlace": "Kleinkarlbach, Leiningerland Verbandsgemeinde, Bad Dürkheim, Rhineland-Palatinate, Germany",
    "fsId": "LZJY-3V1",
    "photo": "/ancestors/bubbles/1689_LZJY-3V1.jpg",
    "living": false,
    "alternateNames": [
      "Catharina Philippina Ißabart"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1689_LZJY-3V1.jpg"
  },
  {
    "id": "AQI1160",
    "name": "David Reck",
    "sex": "M",
    "gen": 10,
    "slot": 666,
    "side": "maternal",
    "birthplace": "unknown",
    "childId": "AQI697",
    "birthYear": 1683,
    "deathYear": null,
    "birthDate": "Abt 1683",
    "deathDate": null,
    "burialDate": "15 Nov 1744",
    "christeningDate": null,
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": "Freinsheim, Bad Dürkheim, Rhineland-Palatinate, Germany",
    "christeningPlace": null,
    "fsId": "MYYB-FFZ",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1161",
    "name": "Anna Catharina",
    "sex": "F",
    "gen": 10,
    "slot": 667,
    "side": "maternal",
    "birthplace": "unknown",
    "childId": "AQI697",
    "birthYear": 1692,
    "deathYear": 1756,
    "birthDate": "Abt 1692",
    "deathDate": "27 Sep 1756",
    "burialDate": "27 Sep 1756",
    "christeningDate": null,
    "birthPlace": null,
    "deathPlace": "Freinsheim, Bad Dürkheim, Rhineland-Palatinate, Germany",
    "burialPlace": "Freinsheim, Bezirksamt Neustadt, Bavaria, Germany",
    "christeningPlace": null,
    "fsId": "MYBM-C4X",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1162",
    "name": "John Hatfield",
    "sex": "M",
    "gen": 10,
    "slot": 672,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI698",
    "birthYear": 1686,
    "deathYear": 1756,
    "birthDate": "1686",
    "deathDate": "1756",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Loudoun, Virginia, British Colonial America",
    "deathPlace": "Montgomery Township, Philadelphia, Pennsylvania, British Colonial America",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "G15H-B99",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1163",
    "name": "Elizabeth Travis",
    "sex": "F",
    "gen": 10,
    "slot": 673,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI698",
    "birthYear": 1693,
    "deathYear": 1750,
    "birthDate": "1693",
    "deathDate": "27 Jun 1750",
    "burialDate": "1750",
    "christeningDate": null,
    "birthPlace": "Rye, Westchester, New York Colony, British Colonial America",
    "deathPlace": "Pennsylvania, British Colonial America",
    "burialPlace": "Redstone Cemetery, Grindstone, Redstone Township, Fayette, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LCXQ-VZ4",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1164",
    "name": "Derrick Cleaver",
    "sex": "M",
    "gen": 10,
    "slot": 674,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI699",
    "birthYear": 1702,
    "deathYear": 1768,
    "birthDate": "1702",
    "deathDate": "Feb 1768",
    "burialDate": "Feb 1768",
    "christeningDate": null,
    "birthPlace": "Delaware Township, Philadelphia, Pennsylvania, United States",
    "deathPlace": "Berks, Pennsylvania, British Colonial America",
    "burialPlace": "Berks, Pennsylvania, British Colonial America",
    "christeningPlace": null,
    "fsId": "LHNY-Z7J",
    "photo": "/ancestors/bubbles/1698_LHNY-Z7J.jpg",
    "living": false,
    "alternateNames": [
      "John Cleaver",
      "Derrick Or Valentine Cleaver",
      "Derrick Clever",
      "Derrick Cleaver klever"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1698_LHNY-Z7J.jpg"
  },
  {
    "id": "AQI1165",
    "name": "Mary Potts",
    "sex": "F",
    "gen": 10,
    "slot": 675,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI699",
    "birthYear": 1708,
    "deathYear": 1762,
    "birthDate": "1708",
    "deathDate": "1762",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Philadelphia, Pennsylvania, United States",
    "deathPlace": "Abington Township, Philadelphia, Pennsylvania, British Colonial America",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LVM8-J1R",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1166",
    "name": "Johann Valentin Geiger",
    "sex": "M",
    "gen": 10,
    "slot": 680,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI702",
    "birthYear": 1685,
    "deathYear": 1762,
    "birthDate": "21 Dec 1685",
    "deathDate": "1 Dec 1762",
    "burialDate": "3 Dec 1762",
    "christeningDate": "21 Dec 1685",
    "birthPlace": "Daudenzell, Aglasterhausen, Neckar-Odenwald-Kreis, Baden-Württemberg, Germany",
    "deathPlace": "New Hanover Township, Philadelphia, Pennsylvania, British Colonial America",
    "burialPlace": "New Hanover Township, Philadelphia, Pennsylvania, British Colonial America",
    "christeningPlace": "Ittlingen, Eppingen, Baden, Germany",
    "fsId": "LHBL-BT4",
    "photo": "/ancestors/bubbles/1704_LHBL-BT4.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1704_LHBL-BT4.jpg"
  },
  {
    "id": "AQI1167",
    "name": "Maria Elizabeth Schmidt",
    "sex": "F",
    "gen": 10,
    "slot": 681,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI702",
    "birthYear": 1719,
    "deathYear": 1764,
    "birthDate": "3 Mar 1719",
    "deathDate": "19 Mar 1764",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Montgomery Township, Philadelphia, Pennsylvania, British Colonial America",
    "deathPlace": "New Hanover Township, Philadelphia, Pennsylvania, British Colonial America",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "KZYG-NY4",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Maria Elizabeth Geiger"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1168",
    "name": "Johann Heinrich Bohn or Dilbon",
    "sex": "M",
    "gen": 10,
    "slot": 682,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI703",
    "birthYear": 1724,
    "deathYear": 1785,
    "birthDate": "13 Dec 1724",
    "deathDate": "Jun 1785",
    "burialDate": null,
    "christeningDate": "19 Dec 1724",
    "birthPlace": "Palatinate, Bavaria, Germany",
    "deathPlace": "Rockland Township, Berks, Pennsylvania, United States",
    "burialPlace": null,
    "christeningPlace": "Palatinate, Bavaria, Germany",
    "fsId": "KL6C-HMV",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Johann Heinrich Bohn",
      "Johann Henrich Bohne or Dilbon",
      "Johann Henrich Diehl Bohn",
      "Johann Henrich Diehlmann Bohn",
      "Johannes Henrich Bon",
      "Henry Dilbon"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1169",
    "name": "Eve Wegerlinx",
    "sex": "F",
    "gen": 10,
    "slot": 683,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI703",
    "birthYear": 1743,
    "deathYear": null,
    "birthDate": "Abt 1743",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Maxatawny, Maxatawny Township, Berks, Pennsylvania, United States",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Maxatawny, Maxatawny Township, Berks, Pennsylvania, United States",
    "fsId": "KL6C-HS7",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Eve"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1170",
    "name": "Johann Melchior Schöner",
    "sex": "M",
    "gen": 10,
    "slot": 684,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI704",
    "birthYear": 1711,
    "deathYear": 1778,
    "birthDate": "14 Sep 1711",
    "deathDate": "20 Jun 1778",
    "burialDate": "1778",
    "christeningDate": null,
    "birthPlace": "Ehrstädt, Sinsheim, Rhein-Neckar-Kreis, Baden-Württemberg, Germany",
    "deathPlace": "New Hanover Township, Montgomery, Pennsylvania, United States",
    "burialPlace": "Swamp Lutheran Church Cemetery, New Hanover Township, Montgomery, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "K2NK-L94",
    "photo": "/ancestors/bubbles/1708_K2NK-L94.jpg",
    "living": false,
    "alternateNames": [
      "Johann Melchior Schoner",
      "Melchior",
      "Johann Melcher Schoener",
      "Johann Melchoir Schoener",
      "Melchoir Schoener",
      "Melchior Schoener",
      "John Melchoir Schoener",
      "Melcher",
      "Johann Melchior Schoener"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1708_K2NK-L94.jpg"
  },
  {
    "id": "AQI1171",
    "name": "Anna Maria Geiger",
    "sex": "F",
    "gen": 10,
    "slot": 685,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI704",
    "birthYear": 1717,
    "deathYear": 1801,
    "birthDate": "2 Dec 1717",
    "deathDate": "26 Jul 1801",
    "burialDate": "1801",
    "christeningDate": null,
    "birthPlace": "Ehrstädt, Sinsheim, Rhein-Neckar-Kreis, Baden-Württemberg, Germany",
    "deathPlace": "New Hanover Township, Philadelphia, Pennsylvania, United States",
    "burialPlace": "Swamp Lutheran Church Cemetery, New Hanover Township, Montgomery, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LVKT-XK3",
    "photo": "/ancestors/bubbles/1709_LVKT-XK3.jpg",
    "living": false,
    "alternateNames": [
      "Anna Maria Geisser SCHOENER"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1709_LVKT-XK3.jpg"
  },
  {
    "id": "AQI1172",
    "name": "Andreas Reifschneider",
    "sex": "M",
    "gen": 10,
    "slot": 686,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI705",
    "birthYear": 1704,
    "deathYear": 1787,
    "birthDate": "1704",
    "deathDate": "11 Jan 1787",
    "burialDate": "Jan 1787",
    "christeningDate": null,
    "birthPlace": "Frederick Township, Montgomery, Pennsylvania, United States",
    "deathPlace": "Montgomery, Pennsylvania, United States",
    "burialPlace": "Falkner Swamp Reformed Church Cemetery, New Hanover Township, Montgomery, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "L66X-GXH",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Andrew Reiffschneider"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1173",
    "name": "Anna Clara",
    "sex": "F",
    "gen": 10,
    "slot": 687,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI705",
    "birthYear": 1725,
    "deathYear": null,
    "birthDate": "Abt 1725",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "New Hanover Township, Montgomery, Pennsylvania, United States",
    "deathPlace": "New Hanover Township, Montgomery, Pennsylvania, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "G2NZ-9F1",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1174",
    "name": "Ulrich Phillip Leibenguth",
    "sex": "M",
    "gen": 10,
    "slot": 688,
    "side": "maternal",
    "birthplace": "switzerland",
    "childId": "AQI706",
    "birthYear": 1688,
    "deathYear": 1745,
    "birthDate": "1688",
    "deathDate": "1745",
    "burialDate": "1745",
    "christeningDate": "2 Feb 1690",
    "birthPlace": "Melchnau, Bern, Switzerland",
    "deathPlace": "Douglass Township, Berks, Pennsylvania, British Colonial America",
    "burialPlace": "Levengood Burial Ground, Douglassville, Philadelphia, Pennsylvania, British Colonial America",
    "christeningPlace": "Melchnau, Bern, Switzerland",
    "fsId": "L684-44D",
    "photo": "/ancestors/bubbles/1712_L684-44D.jpg",
    "living": false,
    "alternateNames": [
      "Ulrich Lybundgut",
      "Ulrich Liebenguth",
      "Ulrich Lÿb und Gut"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1712_L684-44D.jpg"
  },
  {
    "id": "AQI1175",
    "name": "Anna Susanna Henni",
    "sex": "F",
    "gen": 10,
    "slot": 689,
    "side": "maternal",
    "birthplace": "switzerland",
    "childId": "AQI706",
    "birthYear": 1690,
    "deathYear": 1736,
    "birthDate": "13 Mar 1690",
    "deathDate": "1736",
    "burialDate": "1736",
    "christeningDate": "23 Mar 1690",
    "birthPlace": "Homberg, Bern, Switzerland",
    "deathPlace": "Douglass Township, Philadelphia, Pennsylvania, British Colonial America",
    "burialPlace": "Douglassville, Amity Township, Berks, Pennsylvania, British Colonial America",
    "christeningPlace": "Steffisburg, Bern, Switzerland",
    "fsId": "L89F-XRJ",
    "photo": "/ancestors/bubbles/1713_L89F-XRJ.jpg",
    "living": false,
    "alternateNames": [
      "Anna Liebengut",
      "Anna Hanni",
      "Anna Henni"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1713_L89F-XRJ.jpg"
  },
  {
    "id": "AQI1176",
    "name": "Philip Brandt",
    "sex": "M",
    "gen": 10,
    "slot": 690,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI707",
    "birthYear": 1696,
    "deathYear": 1744,
    "birthDate": "1696",
    "deathDate": "Jul 1744",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Düdelsheim, Büdingen, Hesse, Germany",
    "deathPlace": "Gilbertsville, Douglass Township, Philadelphia, Pennsylvania, British Colonial America",
    "burialPlace": "Gilbertsville, Douglass Township, Philadelphia, Pennsylvania, British Colonial America",
    "christeningPlace": null,
    "fsId": "P3TW-K21",
    "photo": "/ancestors/bubbles/1714_P3TW-K21.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1714_P3TW-K21.jpg"
  },
  {
    "id": "AQI1177",
    "name": "Elizabeth Meyer Fink",
    "sex": "F",
    "gen": 10,
    "slot": 691,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI707",
    "birthYear": 1705,
    "deathYear": 1767,
    "birthDate": "1705",
    "deathDate": "7 Dec 1767",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "New Hanover Township, Philadelphia, Pennsylvania, British Colonial America",
    "deathPlace": "New Hanover, New Hanover Township, Montgomery, Pennsylvania, United States",
    "burialPlace": "New Hanover, New Hanover Township, Montgomery, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "L7KQ-MZS",
    "photo": "/ancestors/bubbles/1715_L7KQ-MZS.jpg",
    "living": false,
    "alternateNames": [
      "Elizabeth"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1715_L7KQ-MZS.jpg"
  },
  {
    "id": "AQI1179",
    "name": "Johannes Becker",
    "sex": "M",
    "gen": 10,
    "slot": 692,
    "side": "maternal",
    "birthplace": "unknown",
    "childId": "AQI708",
    "birthYear": 1704,
    "deathYear": null,
    "birthDate": "15 Jan 1704",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "20 Jan 1704",
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Siegen, Westphalia, Prussia, Germany",
    "fsId": "M2F8-CQG",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1180",
    "name": "Anna Margretha Jung",
    "sex": "F",
    "gen": 10,
    "slot": 693,
    "side": "maternal",
    "birthplace": "unknown",
    "childId": "AQI708",
    "birthYear": 1709,
    "deathYear": null,
    "birthDate": "31 Jul 1709",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "4 Aug 1709",
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Siegen, Westphalia, Prussia, Germany",
    "fsId": "M2XG-XHQ",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1183",
    "name": "Johann Peter Liebengut",
    "sex": "M",
    "gen": 10,
    "slot": 694,
    "side": "maternal",
    "birthplace": "france",
    "childId": "AQI709",
    "birthYear": 1716,
    "deathYear": 1768,
    "birthDate": "12 Jul 1716",
    "deathDate": "29 Feb 1768",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Langensoultzbach, Bas-Rhin, France",
    "deathPlace": "Douglass Township, Berks, Pennsylvania, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "K8SG-RDV",
    "photo": "/ancestors/bubbles/1718_K8SG-RDV.jpg",
    "living": false,
    "alternateNames": [
      "Hans Peter Liebengut"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1718_K8SG-RDV.jpg"
  },
  {
    "id": "AQI1184",
    "name": "Christina Mohn",
    "sex": "F",
    "gen": 10,
    "slot": 695,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI709",
    "birthYear": 1728,
    "deathYear": 1767,
    "birthDate": "1728",
    "deathDate": "1767",
    "burialDate": "1767",
    "christeningDate": null,
    "birthPlace": "New Hanover Township, Philadelphia, Pennsylvania, United States",
    "deathPlace": "Douglass Township, Berks, Pennsylvania, British Colonial America",
    "burialPlace": "New Hanover Township, Philadelphia, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "438X-NGY",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1185",
    "name": "Joannes Bechtel",
    "sex": "M",
    "gen": 10,
    "slot": 696,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI710",
    "birthYear": 1718,
    "deathYear": 1748,
    "birthDate": "1718",
    "deathDate": "1748",
    "burialDate": null,
    "christeningDate": "10 Jul 1718",
    "birthPlace": "Germany",
    "deathPlace": "At Sea",
    "burialPlace": null,
    "christeningPlace": "Kappelwindeck, Bühl, Bühl, Baden, Germany",
    "fsId": "P4NZ-NKB",
    "photo": "/ancestors/bubbles/1720_P4NZ-NKB.jpg",
    "living": false,
    "alternateNames": [
      "Johann George Bechtel"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1720_P4NZ-NKB.jpg"
  },
  {
    "id": "AQI1186",
    "name": "Anna Maria Klingman",
    "sex": "F",
    "gen": 10,
    "slot": 697,
    "side": "maternal",
    "birthplace": "unknown",
    "childId": "AQI710",
    "birthYear": 1724,
    "deathYear": null,
    "birthDate": "Abt 1724",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LZKR-PS6",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Anna Mary Klingmann"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1187",
    "name": "Johann Jacob Yocum",
    "sex": "M",
    "gen": 10,
    "slot": 698,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI711",
    "birthYear": 1721,
    "deathYear": 1757,
    "birthDate": "1721",
    "deathDate": "14 Feb 1757",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Berks, Pennsylvania, United States",
    "deathPlace": "Amityville, Amity Township, Berks, Pennsylvania, United States",
    "burialPlace": "Douglassville, Philadelphia, Pennsylvania, British Colonial America",
    "christeningPlace": null,
    "fsId": "LC77-5BX",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Jonas",
      "Jonas Yocom",
      "Jonas Yocum",
      "Jonas Yocum Yocom"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1188",
    "name": "Margaret Jones",
    "sex": "F",
    "gen": 10,
    "slot": 699,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI711",
    "birthYear": 1724,
    "deathYear": 1801,
    "birthDate": "1724",
    "deathDate": "4 Nov 1801",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Berks, Pennsylvania, United States",
    "deathPlace": "Amityville, Amity Township, Berks, Pennsylvania, United States",
    "burialPlace": "Douglassville, Philadelphia, Pennsylvania, British Colonial America",
    "christeningPlace": null,
    "fsId": "M9K5-9H1",
    "photo": "/ancestors/bubbles/1723_M9K5-9H1.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1723_M9K5-9H1.jpg"
  },
  {
    "id": "AQI1190",
    "name": "Georg Michel Schwenhardt",
    "sex": "M",
    "gen": 10,
    "slot": 700,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI712",
    "birthYear": 1695,
    "deathYear": 1760,
    "birthDate": "17 Aug 1695",
    "deathDate": "10 Nov 1760",
    "burialDate": "12 Nov 1760",
    "christeningDate": null,
    "birthPlace": "Jungholzhausen, Braunsbach, Schwäbisch Hall, Baden-Württemberg, Germany",
    "deathPlace": "New Hanover Township, Philadelphia, Pennsylvania, British Colonial America",
    "burialPlace": "New Hanover Evangelical Lutheran Church, New Hanover Township, Montgomery, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "L5BR-12X",
    "photo": "/ancestors/bubbles/1724_L5BR-12X.jpg",
    "living": false,
    "alternateNames": [
      "George Michael Schweinhard",
      "Georg Schweinhard",
      "Jeorg Michael Schweinhard",
      "George Michael Schweinhart"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1724_L5BR-12X.jpg"
  },
  {
    "id": "AQI1191",
    "name": "Elenora Magdalena Eckert",
    "sex": "F",
    "gen": 10,
    "slot": 701,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI712",
    "birthYear": 1701,
    "deathYear": 1784,
    "birthDate": "6 May 1701",
    "deathDate": "17 Dec 1784",
    "burialDate": "Dec 1784",
    "christeningDate": "6 May 1701",
    "birthPlace": "Nesselbach, Langenburg, Gerabronn, Württemberg, Germany",
    "deathPlace": "Montgomery, Pennsylvania, United States",
    "burialPlace": "New Hanover Evangelical Lutheran Church, New Hanover Township, Montgomery, Pennsylvania, United States",
    "christeningPlace": "Bächlingen, Gerabronn, Württemberg, Germany",
    "fsId": "L7FX-R24",
    "photo": "/ancestors/bubbles/1725_L7FX-R24.jpg",
    "living": false,
    "alternateNames": [
      "Eleonora Magdalena Eckert"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1725_L7FX-R24.jpg"
  },
  {
    "id": "AQI1192",
    "name": "Johan \"Casper\" Reichart Richard",
    "sex": "M",
    "gen": 10,
    "slot": 702,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI713",
    "birthYear": 1715,
    "deathYear": 1774,
    "birthDate": "10 Feb 1715",
    "deathDate": "15 Mar 1774",
    "burialDate": "1774",
    "christeningDate": null,
    "birthPlace": "Augsburg, Bavaria, Germany",
    "deathPlace": "Colebrookdale Township, Berks, Pennsylvania, British Colonial America",
    "burialPlace": "Swamp Lutheran Church Cemetery, New Hanover Township, Philadelphia, Pennsylvania, British Colonial America",
    "christeningPlace": null,
    "fsId": "LZJT-CJ1",
    "photo": "/ancestors/bubbles/1726_LZJT-CJ1.jpg",
    "living": false,
    "alternateNames": [
      "Casper Reichert",
      "Caspar Reichert",
      "Casper Reichard",
      "Johannes Caspar Reichard"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1726_LZJT-CJ1.jpg"
  },
  {
    "id": "AQI1193",
    "name": "Christena Imler",
    "sex": "F",
    "gen": 10,
    "slot": 703,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI713",
    "birthYear": 1720,
    "deathYear": 1801,
    "birthDate": "Mar 1720",
    "deathDate": "11 Aug 1801",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Waldangelloch, Sinsheim, Rhein-Neckar-Kreis, Baden-Württemberg, Germany",
    "deathPlace": "Clinton, Pennsylvania, United States",
    "burialPlace": "Presbyterian Cemetery, Lock Haven, Clinton, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "GXHT-7DW",
    "photo": "/ancestors/bubbles/1727_GXHT-7DW.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1727_GXHT-7DW.jpg"
  },
  {
    "id": "AQI1194",
    "name": "Anthonius Heilmann",
    "sex": "M",
    "gen": 10,
    "slot": 720,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI714",
    "birthYear": 1671,
    "deathYear": 1759,
    "birthDate": "Abt 1671",
    "deathDate": "13 Jul 1759",
    "burialDate": "16 Jul 1759",
    "christeningDate": null,
    "birthPlace": "Kleinniedesheim, Ludwigshafen, Rhineland-Palatinate, Germany",
    "deathPlace": "Philadelphia, Pennsylvania, British Colonial America",
    "burialPlace": "Philadelphia, Pennsylvania, British Colonial America",
    "christeningPlace": null,
    "fsId": "LZKM-2VD",
    "photo": "/ancestors/bubbles/1744_LZKM-2VD.jpg",
    "living": false,
    "alternateNames": [
      "Antonius Anthon Heylmann Heilman",
      "Anthony Hallman"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1744_LZKM-2VD.jpg"
  },
  {
    "id": "AQI1195",
    "name": "Maria Salome",
    "sex": "F",
    "gen": 10,
    "slot": 721,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI714",
    "birthYear": 1673,
    "deathYear": 1745,
    "birthDate": "1673",
    "deathDate": "Bef 26 Sep 1745",
    "burialDate": "26 Sep 1745",
    "christeningDate": null,
    "birthPlace": "Germany",
    "deathPlace": "Philadelphia, Pennsylvania, British Colonial America",
    "burialPlace": "Skippack Township, Philadelphia, Pennsylvania, British Colonial America",
    "christeningPlace": null,
    "fsId": "LJJQ-JRR",
    "photo": "/ancestors/bubbles/1745_LJJQ-JRR.jpg",
    "living": false,
    "alternateNames": [
      "Mrs Maria Salome Heilmann"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1745_LJJQ-JRR.jpg"
  },
  {
    "id": "AQI1196",
    "name": "Heinrich Berson",
    "sex": "M",
    "gen": 10,
    "slot": 722,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI715",
    "birthYear": 1700,
    "deathYear": null,
    "birthDate": "Abt 1700",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Easthampton, Hampshire, Massachusetts, United States",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "L1BF-HN7",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Heinrich Burson"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1197",
    "name": "Hannah Parsons",
    "sex": "F",
    "gen": 10,
    "slot": 723,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI715",
    "birthYear": 1700,
    "deathYear": null,
    "birthDate": "Abt 1700",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Easthampton, Hampshire, Massachusetts, United States",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "9S32-8VD",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1198",
    "name": "George Michael Kuntz",
    "sex": "M",
    "gen": 10,
    "slot": 724,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI716",
    "birthYear": 1700,
    "deathYear": 1759,
    "birthDate": "2 Mar 1700",
    "deathDate": "10 Aug 1759",
    "burialDate": "1759",
    "christeningDate": null,
    "birthPlace": "Saarbrücken, Saarbrücken, Saarland, Germany",
    "deathPlace": "Philadelphia, Philadelphia, Pennsylvania, British Colonial America",
    "burialPlace": "Leidichs Burial Ground, Frederick, Frederick Township, Montgomery, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "G33Z-6JX",
    "photo": "/ancestors/bubbles/1748_G33Z-6JX.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1748_G33Z-6JX.jpg"
  },
  {
    "id": "AQI1199",
    "name": "Eva Engelhart",
    "sex": "F",
    "gen": 10,
    "slot": 725,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI716",
    "birthYear": 1714,
    "deathYear": 1772,
    "birthDate": "1714",
    "deathDate": "27 Jun 1772",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Germany",
    "deathPlace": "Montgomery, Pennsylvania, United States",
    "burialPlace": "Frederick Township, Montgomery, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LHPV-WQF",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Eva Eglehart",
      "Eve Engelhart",
      "Eve Englehart",
      "Eva Englehart"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1200",
    "name": "Joseph Kendall",
    "sex": "M",
    "gen": 10,
    "slot": 726,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI717",
    "birthYear": 1720,
    "deathYear": 1757,
    "birthDate": "1720",
    "deathDate": "Jul 1757",
    "burialDate": "1757",
    "christeningDate": null,
    "birthPlace": "Linfield, Limerick Township, Montgomery, Pennsylvania, United States",
    "deathPlace": "Linfield, Limerick Township, Montgomery, Pennsylvania, United States",
    "burialPlace": "Limerick Township, Montgomery, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LB91-NC5",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1201",
    "name": "Anne Evans",
    "sex": "F",
    "gen": 10,
    "slot": 727,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI717",
    "birthYear": 1725,
    "deathYear": 1805,
    "birthDate": "14 Jun 1725",
    "deathDate": "1805",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Linfield, Limerick Township, Montgomery, Pennsylvania, United States",
    "deathPlace": "Berks, Pennsylvania, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "GBVF-KG4",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1202",
    "name": "John Sands",
    "sex": "M",
    "gen": 10,
    "slot": 732,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI718",
    "birthYear": 1710,
    "deathYear": 1775,
    "birthDate": "28 Apr 1710",
    "deathDate": "1 Jul 1775",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Sands Point, North Hempstead, Nassau, New York, United States",
    "deathPlace": "Pottstown, Montgomery, Pennsylvania, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LKRC-C4X",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1203",
    "name": "Maria Catharina Greiner",
    "sex": "F",
    "gen": 10,
    "slot": 733,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI718",
    "birthYear": 1712,
    "deathYear": 1775,
    "birthDate": "1 Jan 1712",
    "deathDate": "17 Jul 1775",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "New York Colony, British Colonial America",
    "deathPlace": "Amity Township, Berks, Pennsylvania, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LKRC-CD8",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1185s734",
    "name": "Joannes Bechtel",
    "sex": "M",
    "gen": 10,
    "slot": 734,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI719",
    "birthYear": 1718,
    "deathYear": 1748,
    "birthDate": "1718",
    "deathDate": "1748",
    "burialDate": null,
    "christeningDate": "10 Jul 1718",
    "birthPlace": "Germany",
    "deathPlace": "At Sea",
    "burialPlace": null,
    "christeningPlace": "Kappelwindeck, Bühl, Bühl, Baden, Germany",
    "fsId": "P4NZ-NKB",
    "photo": "/ancestors/bubbles/1720_P4NZ-NKB.jpg",
    "living": false,
    "alternateNames": [
      "Johann George Bechtel"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1720_P4NZ-NKB.jpg"
  },
  {
    "id": "AQI1186s735",
    "name": "Anna Maria Klingman",
    "sex": "F",
    "gen": 10,
    "slot": 735,
    "side": "maternal",
    "birthplace": "unknown",
    "childId": "AQI719",
    "birthYear": 1724,
    "deathYear": null,
    "birthDate": "Abt 1724",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LZKR-PS6",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Anna Mary Klingmann"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1204",
    "name": "Abraham Yeakel Hartranft",
    "sex": "M",
    "gen": 10,
    "slot": 736,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI720",
    "birthYear": 1723,
    "deathYear": 1766,
    "birthDate": "1723",
    "deathDate": "12 Dec 1766",
    "burialDate": "Dec 1776",
    "christeningDate": null,
    "birthPlace": "Germany",
    "deathPlace": "Somerset, Pennsylvania, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "L6ZF-PFR",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1205",
    "name": "Susanna Hoellin Schubert",
    "sex": "F",
    "gen": 10,
    "slot": 737,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI720",
    "birthYear": 1725,
    "deathYear": 1779,
    "birthDate": "11 Feb 1725",
    "deathDate": "12 Dec 1779",
    "burialDate": "29 Dec 1779",
    "christeningDate": null,
    "birthPlace": "Armenruh, Goldberg, Silesia, Prussia, Germany",
    "deathPlace": "Philadelphia, Philadelphia, Pennsylvania, United States",
    "burialPlace": "Philadelphia, Philadelphia, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "L6ZF-PVL",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Susanna Schubert"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1206",
    "name": "George Adam Weidner",
    "sex": "M",
    "gen": 10,
    "slot": 748,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI724",
    "birthYear": 1710,
    "deathYear": 1780,
    "birthDate": "1710",
    "deathDate": "7 Aug 1780",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Schwäbisch Hall, Schwäbisch Hall, Baden-Württemberg, Germany",
    "deathPlace": "District Township, Berks, Pennsylvania, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LDQP-MX6",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1207",
    "name": "Dorothea Greiner",
    "sex": "F",
    "gen": 10,
    "slot": 749,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI724",
    "birthYear": 1715,
    "deathYear": 1806,
    "birthDate": "Abt 1715",
    "deathDate": "17 Mar 1806",
    "burialDate": "19 Mar 1806",
    "christeningDate": null,
    "birthPlace": "Bonfeld, Heilbronn, Baden-Württemberg, Germany",
    "deathPlace": "Amity Township, Berks, Pennsylvania, United States",
    "burialPlace": "Amity Township, Berks, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "L6XM-228",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Dorothy Greiner",
      "Weidner",
      "Catherina Dorothea Greiner"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1208",
    "name": "Michael Walter",
    "sex": "M",
    "gen": 10,
    "slot": 750,
    "side": "maternal",
    "birthplace": "unknown",
    "childId": "AQI725",
    "birthYear": null,
    "deathYear": null,
    "birthDate": null,
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "MR1D-M1J",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1209",
    "name": "Elizabeth",
    "sex": "F",
    "gen": 10,
    "slot": 751,
    "side": "maternal",
    "birthplace": "unknown",
    "childId": "AQI725",
    "birthYear": null,
    "deathYear": null,
    "birthDate": null,
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "MR1D-9MM",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1214",
    "name": "Henrich Freÿer",
    "sex": "M",
    "gen": 10,
    "slot": 752,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI728",
    "birthYear": 1680,
    "deathYear": null,
    "birthDate": "1680",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Battenberg, Battenberg (Pfalz), Bad Dürkheim, Rhineland-Palatinate, Germany",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "MYBY-ZWN",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1215",
    "name": "Maria Elisabetha Gerling",
    "sex": "F",
    "gen": 10,
    "slot": 753,
    "side": "maternal",
    "birthplace": "unknown",
    "childId": "AQI728",
    "birthYear": 1680,
    "deathYear": null,
    "birthDate": "1680",
    "deathDate": null,
    "burialDate": "1 Nov 1757",
    "christeningDate": null,
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": "Hochspeyer, Kaiserslautern, Bavaria, Germany",
    "christeningPlace": null,
    "fsId": "MY19-5WW",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1216",
    "name": "Joh. Peter Kurtz",
    "sex": "M",
    "gen": 10,
    "slot": 754,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI729",
    "birthYear": 1699,
    "deathYear": 1731,
    "birthDate": "Abt 1699",
    "deathDate": "Abt 1731",
    "burialDate": null,
    "christeningDate": "3 Dec 1699",
    "birthPlace": "Schornbach, Oberamt Schorndorf, Württemberg, Germany",
    "deathPlace": "Pennsylvania, British Colonial America",
    "burialPlace": null,
    "christeningPlace": "Schornbach, Oberamt Schorndorf, Württemberg, Germany",
    "fsId": "MTQ2-YBG",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1217",
    "name": "Anna Maria Renn",
    "sex": "F",
    "gen": 10,
    "slot": 755,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI729",
    "birthYear": 1700,
    "deathYear": 1785,
    "birthDate": "Abt 1700",
    "deathDate": "25 Feb 1785",
    "burialDate": "25 Feb 1785",
    "christeningDate": null,
    "birthPlace": "Germany",
    "deathPlace": "New Hanover, New Hanover Township, Montgomery, Pennsylvania, United States",
    "burialPlace": "Swamp Lutheran Church Cemetery, New Hanover Township, Montgomery, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "MQSW-BDK",
    "photo": "/ancestors/bubbles/1779_MQSW-BDK.jpg",
    "living": false,
    "alternateNames": [
      "Anna Maria Hillibard",
      "Anna Maria Hilbert",
      "Anna Maria Kurtz"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1779_MQSW-BDK.jpg"
  },
  {
    "id": "AQI1219",
    "name": "Rudolph Eichelberger",
    "sex": "M",
    "gen": 10,
    "slot": 756,
    "side": "maternal",
    "birthplace": "switzerland",
    "childId": "AQI730",
    "birthYear": 1696,
    "deathYear": 1735,
    "birthDate": "1696",
    "deathDate": "1735",
    "burialDate": "1735",
    "christeningDate": null,
    "birthPlace": "Beinwil (Freiamt), Aargau, Switzerland",
    "deathPlace": "Bavaria, Germany",
    "burialPlace": "Großbockenheim, Bockenheim an der Weinstraße, Bad Dürkheim, Rhineland-Palatinate, Germany",
    "christeningPlace": null,
    "fsId": "GX3C-54Q",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1220",
    "name": "Anna Catharina Schaff",
    "sex": "F",
    "gen": 10,
    "slot": 757,
    "side": "maternal",
    "birthplace": "switzerland",
    "childId": "AQI730",
    "birthYear": 1697,
    "deathYear": 1757,
    "birthDate": "5 Dec 1697",
    "deathDate": "18 Apr 1757",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Beinwil (Freiamt), Aargau, Switzerland",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "MV88-2QF",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Mrs. Anna Eichenberger"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1222",
    "name": "Johann Adam Hauffer",
    "sex": "M",
    "gen": 10,
    "slot": 758,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI731",
    "birthYear": 1694,
    "deathYear": 1756,
    "birthDate": "12 Jun 1694",
    "deathDate": "30 May 1756",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Flörsheim am Main, Wiesbaden, Hesse-Nassau, Prussia, Germany",
    "deathPlace": "Flörsheim am Main, Wiesbaden, Hesse-Nassau, Prussia, Germany",
    "burialPlace": "Flörsheim am Main, Wiesbaden, Hesse-Nassau, Prussia, Germany",
    "christeningPlace": null,
    "fsId": "LY4R-BS6",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Johann Hauser",
      "Johann Adam Hauser"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1223",
    "name": "Barbara Wothly",
    "sex": "F",
    "gen": 10,
    "slot": 759,
    "side": "maternal",
    "birthplace": "unknown",
    "childId": "AQI731",
    "birthYear": null,
    "deathYear": null,
    "birthDate": null,
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "G9T6-XBP",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1225",
    "name": "Peter Erb",
    "sex": "M",
    "gen": 10,
    "slot": 770,
    "side": "maternal",
    "birthplace": "switzerland",
    "childId": "AQI733",
    "birthYear": 1712,
    "deathYear": 1778,
    "birthDate": "Feb 1712",
    "deathDate": "6 Nov 1778",
    "burialDate": "Nov 1778",
    "christeningDate": "Jul 1712",
    "birthPlace": "Worb, Bern, Switzerland",
    "deathPlace": "Frederick, Maryland, United States",
    "burialPlace": "Saint Marys Cemetery, Silver Run, Carroll, Maryland, United States",
    "christeningPlace": "Röthenbach im Emmental, Bern, Switzerland",
    "fsId": "LL4D-FM4",
    "photo": "/ancestors/bubbles/1794_LL4D-FM4.jpg",
    "living": false,
    "alternateNames": [
      "Peter Erb Sr."
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1794_LL4D-FM4.jpg"
  },
  {
    "id": "AQI1226",
    "name": "Maria Louis",
    "sex": "F",
    "gen": 10,
    "slot": 771,
    "side": "maternal",
    "birthplace": "switzerland",
    "childId": "AQI733",
    "birthYear": 1712,
    "deathYear": 1788,
    "birthDate": "Abt 1712",
    "deathDate": "1788",
    "burialDate": "1788",
    "christeningDate": null,
    "birthPlace": "Bern, Switzerland",
    "deathPlace": "Frederick, Maryland, United States",
    "burialPlace": "Saint Marys Cemetery, Silver Run, Carroll, Maryland, United States",
    "christeningPlace": null,
    "fsId": "27MN-6BT",
    "photo": "/ancestors/bubbles/1795_27MN-6BT.jpg",
    "living": false,
    "alternateNames": [
      "Maria Lowis Erb"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1795_27MN-6BT.jpg"
  },
  {
    "id": "AQI1227",
    "name": "John Sample",
    "sex": "M",
    "gen": 10,
    "slot": 772,
    "side": "maternal",
    "birthplace": "ireland",
    "childId": "AQI735",
    "birthYear": 1700,
    "deathYear": 1755,
    "birthDate": "1700",
    "deathDate": "Abt 1755",
    "burialDate": null,
    "christeningDate": "28 Jan 1700",
    "birthPlace": "Ireland",
    "deathPlace": "Peach Bottom Township, York, Pennsylvania, United States",
    "burialPlace": null,
    "christeningPlace": "Holborn, Camden, London, England, United Kingdom",
    "fsId": "GJT5-H5H",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1228",
    "name": "Agnes Hollingsted",
    "sex": "F",
    "gen": 10,
    "slot": 773,
    "side": "maternal",
    "birthplace": "unknown",
    "childId": "AQI735",
    "birthYear": 1700,
    "deathYear": 1750,
    "birthDate": "1700",
    "deathDate": "5 May 1750",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": null,
    "deathPlace": "St Luke, Middlesex, England, United Kingdom",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LJRC-8S7",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1229",
    "name": "Nathaniel Welch",
    "sex": "M",
    "gen": 10,
    "slot": 774,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI736",
    "birthYear": 1700,
    "deathYear": null,
    "birthDate": "8 Mar 1700",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Suffolk, Massachusetts Bay Colony, British Colonial America",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "L2L6-9SD",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1230",
    "name": "Elizabeth Skinner",
    "sex": "F",
    "gen": 10,
    "slot": 775,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI736",
    "birthYear": 1705,
    "deathYear": 1783,
    "birthDate": "1705",
    "deathDate": "20 Oct 1783",
    "burialDate": null,
    "christeningDate": "8 May 1709",
    "birthPlace": "Boston, Suffolk, Massachusetts Bay Colony, British Colonial America",
    "deathPlace": "York, Pennsylvania, British Colonial America",
    "burialPlace": null,
    "christeningPlace": "Church of St Andrew, Holborn, Camden, London, England, United Kingdom",
    "fsId": "LZ5T-DQL",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1231",
    "name": "Johann Heinrich Christ",
    "sex": "M",
    "gen": 10,
    "slot": 784,
    "side": "maternal",
    "birthplace": "switzerland",
    "childId": "AQI737",
    "birthYear": 1691,
    "deathYear": 1732,
    "birthDate": "1691",
    "deathDate": "11 Sep 1732",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Bern, Switzerland",
    "deathPlace": "Maxatawny Township, Berks, Pennsylvania, United States",
    "burialPlace": "Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LB95-W1M",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1232",
    "name": "Anna Goetz",
    "sex": "F",
    "gen": 10,
    "slot": 785,
    "side": "maternal",
    "birthplace": "france",
    "childId": "AQI737",
    "birthYear": 1696,
    "deathYear": 1732,
    "birthDate": "10 Nov 1696",
    "deathDate": "11 Sep 1732",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Hatten, Bas-Rhin, France",
    "deathPlace": "West Hamburg, Tilden Township, Berks, Pennsylvania, United States",
    "burialPlace": "Saint James Cemetery, Pleasant Mount, Mount Pleasant Township, Wayne, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "L1QG-PR6",
    "photo": "/ancestors/bubbles/1809_L1QG-PR6.jpg",
    "living": false,
    "alternateNames": [
      "Anna Goetz or Gotz"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1809_L1QG-PR6.jpg"
  },
  {
    "id": "AQI1233",
    "name": "Joannes Georgis Richter",
    "sex": "M",
    "gen": 10,
    "slot": 786,
    "side": "maternal",
    "birthplace": "france",
    "childId": "AQI738",
    "birthYear": 1687,
    "deathYear": 1742,
    "birthDate": "1687",
    "deathDate": "30 Dec 1742",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Néewiller-près-Lauterbourg, Bas-Rhin, France",
    "deathPlace": "Néewiller-près-Lauterbourg, Bas-Rhin, France",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LH14-BJM",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1234",
    "name": "Anne Catherine Bogner",
    "sex": "F",
    "gen": 10,
    "slot": 787,
    "side": "maternal",
    "birthplace": "france",
    "childId": "AQI738",
    "birthYear": 1696,
    "deathYear": 1765,
    "birthDate": "Abt 6 Mar 1696",
    "deathDate": "8 Dec 1765",
    "burialDate": null,
    "christeningDate": "6 Mar 1696",
    "birthPlace": "Niederlauterbach, Bas-Rhin, France",
    "deathPlace": "Néewiller-près-Lauterbourg, Bas-Rhin, France",
    "burialPlace": null,
    "christeningPlace": "Kaidenbourg, Bas-Rhin, France",
    "fsId": "9SGX-GLK",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Рихтер",
      "Anna"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1236",
    "name": "Simon Schumacher",
    "sex": "M",
    "gen": 10,
    "slot": 788,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI739",
    "birthYear": 1710,
    "deathYear": null,
    "birthDate": "Abt 1710",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Germany",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "GL7R-XHM",
    "photo": "/ancestors/bubbles/1812_GL7R-XHM.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1812_GL7R-XHM.jpg"
  },
  {
    "id": "AQI1237",
    "name": "Ann Elizabeth Klees",
    "sex": "F",
    "gen": 10,
    "slot": 789,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI739",
    "birthYear": 1710,
    "deathYear": null,
    "birthDate": "Abt 1710",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Germany",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "GL7R-WVM",
    "photo": "/ancestors/bubbles/1813_GL7R-WVM.jpg",
    "living": false,
    "alternateNames": [
      "Ann Elizabeth Schumacker",
      "Ann Elizabeth Shoemaker",
      "Anna Elizabeth Kless"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1813_GL7R-WVM.jpg"
  },
  {
    "id": "AQI1238",
    "name": "John Nicolaus Loescher",
    "sex": "M",
    "gen": 10,
    "slot": 790,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI740",
    "birthYear": 1695,
    "deathYear": 1744,
    "birthDate": "Abt 1695",
    "deathDate": "23 Mar 1744",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Heidelberg, Baden-Württemberg, Germany",
    "deathPlace": "Oley Township, Berks, Pennsylvania, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "MR19-269",
    "photo": null,
    "living": false,
    "alternateNames": [
      "John Nicolas Lasher",
      "John Nicolaus -LESCHER LOESCHER"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1239",
    "name": "Anna Clara Bender",
    "sex": "F",
    "gen": 10,
    "slot": 791,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI740",
    "birthYear": 1708,
    "deathYear": 1766,
    "birthDate": "4 Oct 1708",
    "deathDate": "May 1766",
    "burialDate": null,
    "christeningDate": "4 Oct 1708",
    "birthPlace": "Lambsheim, Frankenthal, Bavaria, Germany",
    "deathPlace": "Oley Township, Berks, Pennsylvania, United States",
    "burialPlace": null,
    "christeningPlace": "Frankenthal, Bavaria, Germany",
    "fsId": "9J57-4RL",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Anna Clara"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1240",
    "name": "Joannes Theobald Burger",
    "sex": "M",
    "gen": 10,
    "slot": 800,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI743",
    "birthYear": 1684,
    "deathYear": 1760,
    "birthDate": "18 Jun 1684",
    "deathDate": "10 Jun 1760",
    "burialDate": "10 Jun 1760",
    "christeningDate": "18 Jun 1684",
    "birthPlace": "Ottersweier, Rastatt, Baden-Württemberg, Germany",
    "deathPlace": null,
    "burialPlace": "Ottersweier, Rastatt, Baden-Württemberg, Germany",
    "christeningPlace": "Ottersweier, Rastatt, Baden-Württemberg, Germany",
    "fsId": "LT3C-QR3",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Theobald Burger"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1241",
    "name": "Barbara Junger",
    "sex": "F",
    "gen": 10,
    "slot": 801,
    "side": "maternal",
    "birthplace": "unknown",
    "childId": "AQI743",
    "birthYear": null,
    "deathYear": null,
    "birthDate": null,
    "deathDate": null,
    "burialDate": "9 Dec 1772",
    "christeningDate": "4 Dec 1687",
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": "Ottersweier, Rastatt, Baden-Württemberg, Germany",
    "christeningPlace": "Ottersweier, Rastatt, Baden-Württemberg, Germany",
    "fsId": "LKQX-ZDJ",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1242",
    "name": "Puderbach",
    "sex": "M",
    "gen": 10,
    "slot": 804,
    "side": "maternal",
    "birthplace": "unknown",
    "childId": "AQI745",
    "birthYear": null,
    "deathYear": null,
    "birthDate": null,
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "PZD4-FHR",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1243",
    "name": "unknown",
    "sex": "F",
    "gen": 10,
    "slot": 805,
    "side": "maternal",
    "birthplace": "unknown",
    "childId": "AQI745",
    "birthYear": null,
    "deathYear": null,
    "birthDate": null,
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "L6W7-PLG",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1244",
    "name": "Johannes Nicolaus Adam",
    "sex": "M",
    "gen": 10,
    "slot": 806,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI746",
    "birthYear": 1696,
    "deathYear": 1754,
    "birthDate": "1696",
    "deathDate": "Bef 5 Mar 1754",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Eichtersheim, Angelbachtal, Rhein-Neckar-Kreis, Baden-Württemberg, Germany",
    "deathPlace": "Lancaster, Pennsylvania, British Colonial America",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LKR4-QJQ",
    "photo": "/ancestors/bubbles/1830_LKR4-QJQ.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1830_LKR4-QJQ.jpg"
  },
  {
    "id": "AQI1245",
    "name": "Juliana Bernardina Schweickhardt",
    "sex": "F",
    "gen": 10,
    "slot": 807,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI746",
    "birthYear": 1701,
    "deathYear": null,
    "birthDate": "5 Oct 1701",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "7 Oct 1701",
    "birthPlace": "Eichtersheim, Angelbachtal, Rhein-Neckar-Kreis, Baden-Württemberg, Germany",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Eichtersheim, Angelbachtal, Rhein-Neckar-Kreis, Baden-Württemberg, Germany",
    "fsId": "LKRW-LTY",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1246",
    "name": "Ulrich Zug",
    "sex": "M",
    "gen": 10,
    "slot": 816,
    "side": "maternal",
    "birthplace": "switzerland",
    "childId": "AQI747",
    "birthYear": 1690,
    "deathYear": 1758,
    "birthDate": "1690",
    "deathDate": "27 Sep 1758",
    "burialDate": "Sep 1758",
    "christeningDate": "13 Aug 1689",
    "birthPlace": "Switzerland",
    "deathPlace": "Warwick Township, Lancaster, Pennsylvania, British Colonial America",
    "burialPlace": "Zug Family Cemetery, Penryn, Penn Township, Lancaster, Pennsylvania, United States",
    "christeningPlace": "Oberamt Schorndorf, Württemberg, Germany",
    "fsId": "L85V-51R",
    "photo": "/ancestors/bubbles/1840_L85V-51R.jpg",
    "living": false,
    "alternateNames": [
      "Ulrich Zuck"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1840_L85V-51R.jpg"
  },
  {
    "id": "AQI1247",
    "name": "Anna Barbara Bachman",
    "sex": "F",
    "gen": 10,
    "slot": 817,
    "side": "maternal",
    "birthplace": "switzerland",
    "childId": "AQI747",
    "birthYear": 1697,
    "deathYear": 1758,
    "birthDate": "21 Feb 1697",
    "deathDate": "Sep 1758",
    "burialDate": "Abt 1759",
    "christeningDate": null,
    "birthPlace": "Oberdiessbach, Bern, Switzerland",
    "deathPlace": "Warwick Township, Lancaster, Pennsylvania, United States",
    "burialPlace": "Penryn, Penn Township, Lancaster, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LBH6-FTR",
    "photo": "/ancestors/bubbles/1841_LBH6-FTR.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1841_LBH6-FTR.jpg"
  },
  {
    "id": "AQI1248",
    "name": "John Reinhard Willener",
    "sex": "M",
    "gen": 10,
    "slot": 818,
    "side": "maternal",
    "birthplace": "switzerland",
    "childId": "AQI748",
    "birthYear": 1700,
    "deathYear": 1760,
    "birthDate": "1700",
    "deathDate": "1760",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Switzerland, Marion, Oregon, United States",
    "deathPlace": "Lancaster, Pennsylvania, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "G2P5-PBZ",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1249",
    "name": "Barbara Elizabeth Langacker",
    "sex": "F",
    "gen": 10,
    "slot": 819,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI748",
    "birthYear": 1700,
    "deathYear": 1760,
    "birthDate": "1700",
    "deathDate": "1760",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Masonic Cemetery, Columbia City, Columbia, Oregon, United States",
    "deathPlace": "Lancaster, Pennsylvania, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "G2P5-B8X",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1250",
    "name": "Martin Bentz",
    "sex": "M",
    "gen": 10,
    "slot": 832,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI749",
    "birthYear": 1676,
    "deathYear": 1756,
    "birthDate": "3 Apr 1676",
    "deathDate": "19 Nov 1756",
    "burialDate": null,
    "christeningDate": "3 Apr 1676",
    "birthPlace": "Weitenau, Lörrach, Baden-Württemberg, Germany",
    "deathPlace": "Lehnacker, Steinen, Lörrach, Baden, Germany",
    "burialPlace": null,
    "christeningPlace": "Weitenau, Schopfheim, Baden, Germany",
    "fsId": "KLC9-WNZ",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1251",
    "name": "Catharina Langendorf",
    "sex": "F",
    "gen": 10,
    "slot": 833,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI749",
    "birthYear": 1678,
    "deathYear": 1757,
    "birthDate": "21 Jul 1678",
    "deathDate": "4 Dec 1757",
    "burialDate": null,
    "christeningDate": "22 Jul 1678",
    "birthPlace": "Tegernau, Lörrach, Baden-Württemberg, Germany",
    "deathPlace": "Lehnacker, Steinen, Lörrach, Baden",
    "burialPlace": null,
    "christeningPlace": "Tegernau, Schopfheim, Baden",
    "fsId": "KLC9-Z2P",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Pentz",
      "Katharina Langendorf",
      "Katharina Langendoerffin",
      "Catharina Langendorff",
      "Catarina Langendorff",
      "Catarina Langendoerffin"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1252",
    "name": "Hatt",
    "sex": "M",
    "gen": 10,
    "slot": 834,
    "side": "maternal",
    "birthplace": "unknown",
    "childId": "AQI750",
    "birthYear": null,
    "deathYear": 1713,
    "birthDate": null,
    "deathDate": "Aft 1713",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": null,
    "deathPlace": "Pennsylvania, British Colonial America",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "P3KV-THX",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1253",
    "name": "Susanna Charlotta Gimmel",
    "sex": "F",
    "gen": 10,
    "slot": 835,
    "side": "maternal",
    "birthplace": "unknown",
    "childId": "AQI750",
    "birthYear": 1690,
    "deathYear": 1771,
    "birthDate": "1690",
    "deathDate": "1771",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": null,
    "deathPlace": "Pennsylvania, British Colonial America",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "PSKZ-R6K",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Jacobs"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1258",
    "name": "John Schwartz",
    "sex": "M",
    "gen": 10,
    "slot": 838,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI754",
    "birthYear": null,
    "deathYear": null,
    "birthDate": null,
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Germany",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "9HHN-F33",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Schwartz"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1259",
    "name": "Kathryn Estelman",
    "sex": "F",
    "gen": 10,
    "slot": 839,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI754",
    "birthYear": 1820,
    "deathYear": null,
    "birthDate": "Bef 1820",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Germany",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "KLQR-M7Z",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1268",
    "name": "Johann Christian Ickes",
    "sex": "M",
    "gen": 10,
    "slot": 848,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI759",
    "birthYear": 1690,
    "deathYear": 1738,
    "birthDate": "1690",
    "deathDate": "Aug 1738",
    "burialDate": "1738",
    "christeningDate": null,
    "birthPlace": "Biebergemünd, Main-Kinzig-Kreis, Hesse, Germany",
    "deathPlace": "Limerick Township, Montgomery, Pennsylvania, United States",
    "burialPlace": "Old Union Cemetery, Buffalo Mills, Harrison Township, Bedford, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "L4SD-H6Q",
    "photo": "/ancestors/bubbles/1872_L4SD-H6Q.jpg",
    "living": false,
    "alternateNames": [
      "John Adam Ickes",
      "John Christian Ickes"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1872_L4SD-H6Q.jpg"
  },
  {
    "id": "AQI1269",
    "name": "Margretha Lentz",
    "sex": "F",
    "gen": 10,
    "slot": 849,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI759",
    "birthYear": 1692,
    "deathYear": 1728,
    "birthDate": "22 Jan 1692",
    "deathDate": "1728",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Schoharie, Schoharie, New York, United States",
    "deathPlace": "Schoharie, Schoharie, New York, United States",
    "burialPlace": null,
    "christeningPlace": "Kornwestheim, Landkreis Ludwigsburg, Baden-Württemberg, Germany",
    "fsId": "GRWB-HXB",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1271",
    "name": "Valentine Ficus",
    "sex": "M",
    "gen": 10,
    "slot": 850,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI760",
    "birthYear": 1685,
    "deathYear": 1780,
    "birthDate": "1685",
    "deathDate": "1780",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Rhineland-Palatinate, Germany",
    "deathPlace": "York, Pennsylvania, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "GDWZ-4YB",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Valentine Fickas I"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1272",
    "name": "Anna Margreth Weydebach",
    "sex": "F",
    "gen": 10,
    "slot": 851,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI760",
    "birthYear": 1688,
    "deathYear": null,
    "birthDate": "1688",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Rhineland-Palatinate, Germany",
    "deathPlace": "Pennsylvania, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "GDWZ-WY5",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Anna Margreth Weydebach Ficus"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1273",
    "name": "Johannes Jacob Stambach",
    "sex": "M",
    "gen": 10,
    "slot": 852,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI761",
    "birthYear": 1676,
    "deathYear": 1733,
    "birthDate": "22 Jul 1676",
    "deathDate": "17 Jan 1733",
    "burialDate": "19 Jan 1733",
    "christeningDate": null,
    "birthPlace": "Stambach, Contwig, Landkreis Zweibrücken, Rhineland-Palatinate, Germany",
    "deathPlace": "Hanau-Lichtenberg, Alsace, France",
    "burialPlace": "Kutzenhausen, Bas-Rhin, France",
    "christeningPlace": null,
    "fsId": "L6BJ-5RJ",
    "photo": "/ancestors/bubbles/1876_L6BJ-5RJ.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1876_L6BJ-5RJ.jpg"
  },
  {
    "id": "AQI1274",
    "name": "Maria Catharina Meyer",
    "sex": "F",
    "gen": 10,
    "slot": 853,
    "side": "maternal",
    "birthplace": "holy-roman-empire",
    "childId": "AQI761",
    "birthYear": 1687,
    "deathYear": 1739,
    "birthDate": "22 Nov 1687",
    "deathDate": "17 Nov 1739",
    "burialDate": "1739",
    "christeningDate": null,
    "birthPlace": "Lorraine, Holy Roman Empire",
    "deathPlace": "York, Pennsylvania, British Colonial America",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LTB1-DPH",
    "photo": "/ancestors/bubbles/1877_LTB1-DPH.jpg",
    "living": false,
    "alternateNames": [
      "Maria Catharina Meyer Stambach",
      "Maria Catharina Meyer Honig"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1877_LTB1-DPH.jpg"
  },
  {
    "id": "AQI770",
    "name": "William Oldham",
    "sex": "M",
    "gen": 10,
    "slot": 864,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI445",
    "birthYear": 1705,
    "deathYear": 1749,
    "birthDate": "5 Nov 1705",
    "deathDate": "1749",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Bethel Township, Chester, Pennsylvania, British Colonial America",
    "deathPlace": "Lancaster, Pennsylvania, British Colonial America",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LVKW-24P",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI771",
    "name": "Sarah Dicks",
    "sex": "F",
    "gen": 10,
    "slot": 865,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI445",
    "birthYear": 1712,
    "deathYear": 1777,
    "birthDate": "1712",
    "deathDate": "1777",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Chester, Pennsylvania, British Colonial America",
    "deathPlace": "Pennsylvania, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LDT2-5DK",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Sarah Dix"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI772",
    "name": "Thomas Blackburn",
    "sex": "M",
    "gen": 10,
    "slot": 866,
    "side": "maternal",
    "birthplace": "ireland",
    "childId": "AQI446",
    "birthYear": 1702,
    "deathYear": 1794,
    "birthDate": "13 Aug 1702",
    "deathDate": "Sep 1794",
    "burialDate": "Sep 1794",
    "christeningDate": null,
    "birthPlace": "County Armagh, Ireland",
    "deathPlace": "York, Pennsylvania, United States",
    "burialPlace": "York, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "L849-YDJ",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Thomas J. Blackburn"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI773",
    "name": "Alice Hewitt",
    "sex": "F",
    "gen": 10,
    "slot": 867,
    "side": "maternal",
    "birthplace": "ireland",
    "childId": "AQI446",
    "birthYear": 1720,
    "deathYear": 1799,
    "birthDate": "1720",
    "deathDate": "Aft 30 Oct 1799",
    "burialDate": "Nov 1799",
    "christeningDate": null,
    "birthPlace": "County Armagh, Northern Ireland, United Kingdom",
    "deathPlace": "York, Pennsylvania, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LDLT-CZG",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Alice Hewitt Blackburn"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1276",
    "name": "James Callihan",
    "sex": "M",
    "gen": 10,
    "slot": 868,
    "side": "maternal",
    "birthplace": "ireland",
    "childId": "AQI764",
    "birthYear": 1735,
    "deathYear": null,
    "birthDate": "1735",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Ireland",
    "deathPlace": "Ireland",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "L16P-P3J",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1277",
    "name": "James Callihan",
    "sex": "F",
    "gen": 10,
    "slot": 869,
    "side": "maternal",
    "birthplace": "ireland",
    "childId": "AQI764",
    "birthYear": 1740,
    "deathYear": null,
    "birthDate": "Abt 1740",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Ireland",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "P6N8-YHK",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI772s870",
    "name": "Thomas Blackburn",
    "sex": "M",
    "gen": 10,
    "slot": 870,
    "side": "maternal",
    "birthplace": "ireland",
    "childId": "AQI765",
    "birthYear": 1702,
    "deathYear": 1794,
    "birthDate": "13 Aug 1702",
    "deathDate": "Sep 1794",
    "burialDate": "Sep 1794",
    "christeningDate": null,
    "birthPlace": "County Armagh, Ireland",
    "deathPlace": "York, Pennsylvania, United States",
    "burialPlace": "York, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "L849-YDJ",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Thomas J. Blackburn"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI773s871",
    "name": "Alice Hewitt",
    "sex": "F",
    "gen": 10,
    "slot": 871,
    "side": "maternal",
    "birthplace": "ireland",
    "childId": "AQI765",
    "birthYear": 1720,
    "deathYear": 1799,
    "birthDate": "1720",
    "deathDate": "Aft 30 Oct 1799",
    "burialDate": "Nov 1799",
    "christeningDate": null,
    "birthPlace": "County Armagh, Northern Ireland, United Kingdom",
    "deathPlace": "York, Pennsylvania, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LDLT-CZG",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Alice Hewitt Blackburn"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1278",
    "name": "Thomas Bowen",
    "sex": "M",
    "gen": 10,
    "slot": 872,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI766",
    "birthYear": 1721,
    "deathYear": 1800,
    "birthDate": "9 Mar 1721",
    "deathDate": "3 Jan 1800",
    "burialDate": "5 Jan 1800",
    "christeningDate": null,
    "birthPlace": "West Nottingham Township, Chester, Pennsylvania, United States",
    "deathPlace": "Menallen MM, Adams, Pennsylvania, United States",
    "burialPlace": "Menallen Township, Adams, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LJ2C-YQL",
    "photo": "/ancestors/bubbles/1896_LJ2C-YQL.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1896_LJ2C-YQL.jpg"
  },
  {
    "id": "AQI1279",
    "name": "Jane Edwards",
    "sex": "F",
    "gen": 10,
    "slot": 873,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI766",
    "birthYear": 1721,
    "deathYear": 1803,
    "birthDate": "9 Jan 1721",
    "deathDate": "17 Feb 1803",
    "burialDate": "21 Feb 1803",
    "christeningDate": null,
    "birthPlace": "Chester, Pennsylvania, British Colonial America",
    "deathPlace": "York, Pennsylvania, United States",
    "burialPlace": "York, Pennsylvania, United States",
    "christeningPlace": "Chester, Pennsylvania, United States",
    "fsId": "LJ2C-YC6",
    "photo": "/ancestors/bubbles/1897_LJ2C-YC6.jpg",
    "living": false,
    "alternateNames": [
      "Jean Bowen"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1897_LJ2C-YC6.jpg"
  },
  {
    "id": "AQI772s874",
    "name": "Thomas Blackburn",
    "sex": "M",
    "gen": 10,
    "slot": 874,
    "side": "maternal",
    "birthplace": "ireland",
    "childId": "AQI767",
    "birthYear": 1702,
    "deathYear": 1794,
    "birthDate": "13 Aug 1702",
    "deathDate": "Sep 1794",
    "burialDate": "Sep 1794",
    "christeningDate": null,
    "birthPlace": "County Armagh, Ireland",
    "deathPlace": "York, Pennsylvania, United States",
    "burialPlace": "York, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "L849-YDJ",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Thomas J. Blackburn"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI773s875",
    "name": "Alice Hewitt",
    "sex": "F",
    "gen": 10,
    "slot": 875,
    "side": "maternal",
    "birthplace": "ireland",
    "childId": "AQI767",
    "birthYear": 1720,
    "deathYear": 1799,
    "birthDate": "1720",
    "deathDate": "Aft 30 Oct 1799",
    "burialDate": "Nov 1799",
    "christeningDate": null,
    "birthPlace": "County Armagh, Northern Ireland, United Kingdom",
    "deathPlace": "York, Pennsylvania, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LDLT-CZG",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Alice Hewitt Blackburn"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1280",
    "name": "James Fisher",
    "sex": "M",
    "gen": 10,
    "slot": 876,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI768",
    "birthYear": 1714,
    "deathYear": 1775,
    "birthDate": "13 Dec 1714",
    "deathDate": "15 Feb 1775",
    "burialDate": "Feb 1775",
    "christeningDate": "21 Mar 1714",
    "birthPlace": "Chester Township, Chester, Pennsylvania, British Colonial America",
    "deathPlace": "Monaghan Township, York, Pennsylvania, British Colonial America",
    "burialPlace": null,
    "christeningPlace": "Liverpool, Lancashire, England, United Kingdom",
    "fsId": "L5FT-GBN",
    "photo": null,
    "living": false,
    "alternateNames": [
      "James Fisher Senior"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1281",
    "name": "Alice Ealie Stanfield",
    "sex": "F",
    "gen": 10,
    "slot": 877,
    "side": "maternal",
    "birthplace": "ireland",
    "childId": "AQI768",
    "birthYear": 1718,
    "deathYear": 1800,
    "birthDate": "2 May 1718",
    "deathDate": "2 May 1800",
    "burialDate": "May 1800",
    "christeningDate": "1718",
    "birthPlace": "Antrim, County Antrim, Northern Ireland, United Kingdom",
    "deathPlace": "York, Pennsylvania, United States",
    "burialPlace": "Pennsylvania, United States",
    "christeningPlace": "Pennsylvania, United States",
    "fsId": "LH6F-ZBH",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Alice Standfield",
      "Alice Stansfield",
      "Alice Stansfield Fisher",
      "Allice Or Alice Standfield",
      "Jane Standfield",
      "Jane Stanfield",
      "Fisher",
      "Stanfield Alice",
      "Alice ( Ealie) Standfield",
      "Alice"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1282",
    "name": "John Morton",
    "sex": "M",
    "gen": 10,
    "slot": 878,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI769",
    "birthYear": 1724,
    "deathYear": 1810,
    "birthDate": "10 Apr 1724",
    "deathDate": "4 Jul 1810",
    "burialDate": "Jul 1810",
    "christeningDate": null,
    "birthPlace": "Chester, Pennsylvania, British Colonial America",
    "deathPlace": "Menallen Township, Adams, Pennsylvania, United States",
    "burialPlace": "Butler Township, Adams, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "9H26-MNQ",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1283",
    "name": "Mary Todd Sketchley",
    "sex": "F",
    "gen": 10,
    "slot": 879,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI769",
    "birthYear": 1729,
    "deathYear": 1802,
    "birthDate": "8 May 1729",
    "deathDate": "5 May 1802",
    "burialDate": "8 May 1802",
    "christeningDate": null,
    "birthPlace": "London Grove Township, Chester, Pennsylvania, British Colonial America",
    "deathPlace": "Menallen Township, Adams, Pennsylvania, United States",
    "burialPlace": "Butler Township, Adams, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "KZ6L-ZY3",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Mary Archer Todd Morton"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1303",
    "name": "Heinrich John Geyer",
    "sex": "M",
    "gen": 10,
    "slot": 896,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI778",
    "birthYear": 1677,
    "deathYear": 1761,
    "birthDate": "1677",
    "deathDate": "7 Oct 1761",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Leimen, Pirmasens, Rhineland-Palatinate, Germany",
    "deathPlace": "Niederwörresbach, Birkenfeld, Rhineland-Palatinate, Germany",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LWBF-DXB",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1304",
    "name": "Elisabethae Engels",
    "sex": "F",
    "gen": 10,
    "slot": 897,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI778",
    "birthYear": 1685,
    "deathYear": 1735,
    "birthDate": "1685",
    "deathDate": "1735",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Germany",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "MJZD-GTR",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1307",
    "name": "Gorgen Michaels",
    "sex": "M",
    "gen": 10,
    "slot": 898,
    "side": "maternal",
    "birthplace": "unknown",
    "childId": "AQI779",
    "birthYear": null,
    "deathYear": null,
    "birthDate": null,
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "MJZD-G16",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1308",
    "name": "Catharina Gertrudis Michelss",
    "sex": "F",
    "gen": 10,
    "slot": 899,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI779",
    "birthYear": 1690,
    "deathYear": null,
    "birthDate": "22 Feb 1690",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Germany",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "G9Z7-RYS",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1309",
    "name": "Hans Johann Schneeberger",
    "sex": "M",
    "gen": 10,
    "slot": 928,
    "side": "maternal",
    "birthplace": "switzerland",
    "childId": "AQI780",
    "birthYear": 1704,
    "deathYear": 1780,
    "birthDate": "3 Feb 1704",
    "deathDate": "1780",
    "burialDate": "1780",
    "christeningDate": "3 Feb 1704",
    "birthPlace": "Ochlenberg, Bern, Switzerland",
    "deathPlace": "Glen Forney, Washington Township, Franklin, Pennsylvania, United States",
    "burialPlace": "Quincy Township, Franklin, Pennsylvania, United States",
    "christeningPlace": "Herzogenbuchsee, Bern, Switzerland",
    "fsId": "LH6X-XQ3",
    "photo": "/ancestors/bubbles/1952_LH6X-XQ3.jpg",
    "living": false,
    "alternateNames": [
      "Hans Schneeberger"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1952_LH6X-XQ3.jpg"
  },
  {
    "id": "AQI1310",
    "name": "Christina Übersox",
    "sex": "F",
    "gen": 10,
    "slot": 929,
    "side": "maternal",
    "birthplace": "switzerland",
    "childId": "AQI780",
    "birthYear": 1704,
    "deathYear": null,
    "birthDate": "1704",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Bern, Switzerland",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "GPW7-7W8",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Christina Übersax"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1311",
    "name": "Theodore Ingold",
    "sex": "M",
    "gen": 10,
    "slot": 930,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI781",
    "birthYear": 1723,
    "deathYear": 1829,
    "birthDate": "1723",
    "deathDate": "1829",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Waynesboro, Franklin, Pennsylvania, United States",
    "deathPlace": "United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "KZ6D-BLD",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1312",
    "name": "Elisabeth Muhlethaler",
    "sex": "F",
    "gen": 10,
    "slot": 931,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI781",
    "birthYear": 1710,
    "deathYear": 1747,
    "birthDate": "1710",
    "deathDate": "1747",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Waynesboro, Franklin, Pennsylvania, United States",
    "deathPlace": "United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "KVJL-1R3",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1313",
    "name": "Heinrich Eshelman",
    "sex": "M",
    "gen": 10,
    "slot": 932,
    "side": "maternal",
    "birthplace": "switzerland",
    "childId": "AQI782",
    "birthYear": 1707,
    "deathYear": 1778,
    "birthDate": "6 Dec 1707",
    "deathDate": "31 Oct 1778",
    "burialDate": "1778",
    "christeningDate": null,
    "birthPlace": "Langnau im Emmental, Bern, Switzerland",
    "deathPlace": "Rapho Township, Lancaster, Pennsylvania, United States",
    "burialPlace": "Mastersonville, Rapho Township, Lancaster, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LHTV-CKH",
    "photo": "/ancestors/bubbles/1956_LHTV-CKH.jpg",
    "living": false,
    "alternateNames": [
      "Heinrich ( Eshleman) Aeschlimann",
      "Heinrich ( Henry) Eshelman",
      "Heinrich Eshelman ;Sr",
      "Heinrich or Henry Eshelman",
      "Heinrich Eschelman",
      "Henrich Eshleman",
      "Heinreich Ashleman"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1956_LHTV-CKH.jpg"
  },
  {
    "id": "AQI1314",
    "name": "Barbara Kendig",
    "sex": "F",
    "gen": 10,
    "slot": 933,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI782",
    "birthYear": 1725,
    "deathYear": 1754,
    "birthDate": "1725",
    "deathDate": "Bef May 1754",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Conestoga Township, Lancaster, Pennsylvania, British Colonial America",
    "deathPlace": "Lancaster, Pennsylvania, British Colonial America",
    "burialPlace": "Lancaster, Pennsylvania, British Colonial America",
    "christeningPlace": null,
    "fsId": "L7FW-XQM",
    "photo": "/ancestors/bubbles/1957_L7FW-XQM.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1957_L7FW-XQM.jpg"
  },
  {
    "id": "AQI1315",
    "name": "Johannes Stauffer",
    "sex": "M",
    "gen": 10,
    "slot": 934,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI783",
    "birthYear": 1715,
    "deathYear": 1767,
    "birthDate": "6 Aug 1715",
    "deathDate": "16 Jan 1767",
    "burialDate": "Jan 1767",
    "christeningDate": null,
    "birthPlace": "Wartenberg-Rohrbach, Donnersbergkreis, Rhineland-Palatinate, Germany",
    "deathPlace": "Warwick Township, Lancaster, Pennsylvania, United States",
    "burialPlace": "Warwick Township, Lancaster, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LJLQ-JZR",
    "photo": "/ancestors/bubbles/1958_LJLQ-JZR.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1958_LJLQ-JZR.jpg"
  },
  {
    "id": "AQI1316",
    "name": "Catharina Schenk",
    "sex": "F",
    "gen": 10,
    "slot": 935,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI783",
    "birthYear": 1720,
    "deathYear": 1760,
    "birthDate": "7 Apr 1720",
    "deathDate": "29 Nov 1760",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Conestoga Township, Lancaster, Pennsylvania, United States",
    "deathPlace": "Warwick Township, Lancaster, Pennsylvania, British Colonial America",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "KCJ9-Y91",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Katrina",
      "Stauffer"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1317",
    "name": "Johann Jacob Christian Schneider",
    "sex": "M",
    "gen": 10,
    "slot": 936,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI784",
    "birthYear": 1702,
    "deathYear": 1778,
    "birthDate": "Sep 1702",
    "deathDate": "15 Jul 1778",
    "burialDate": "1778",
    "christeningDate": "Sep 1702",
    "birthPlace": "Rothenstein, Grönenbach, Unterallgäu, Bavaria, Germany",
    "deathPlace": "Strasburg, Shenandoah, Virginia, United States",
    "burialPlace": "Riverview Cemetery, Woodstock, Shenandoah, Virginia, United States",
    "christeningPlace": "Laasphe, Kreis Wittgenstein, Westphalia, Prussia, Germany",
    "fsId": "KHMK-N73",
    "photo": "/ancestors/bubbles/1960_KHMK-N73.jpg",
    "living": false,
    "alternateNames": [
      "Jacob Christian Schneider Sr.",
      "Jacobi Schneider"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1960_KHMK-N73.jpg"
  },
  {
    "id": "AQI1318",
    "name": "Anna Margaretha Seffer",
    "sex": "F",
    "gen": 10,
    "slot": 937,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI784",
    "birthYear": 1714,
    "deathYear": 1785,
    "birthDate": "3 Mar 1714",
    "deathDate": "6 Apr 1785",
    "burialDate": "1785",
    "christeningDate": "3 Mar 1714",
    "birthPlace": "Biewer, Pfalzel, Trier, Rhineland, Prussia",
    "deathPlace": "Strasburg, Shenandoah, Virginia, United States",
    "burialPlace": "Riverview Cemetery, Woodstock, Shenandoah, Virginia, United States",
    "christeningPlace": "Pfalzel, Trier, Rhineland, Prussia",
    "fsId": "LT2Z-T79",
    "photo": "/ancestors/bubbles/1961_LT2Z-T79.jpg",
    "living": false,
    "alternateNames": [
      "Anna Maria Seffer"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1961_LT2Z-T79.jpg"
  },
  {
    "id": "AQI1319",
    "name": "Johannes Peter Studebaker",
    "sex": "M",
    "gen": 10,
    "slot": 938,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI785",
    "birthYear": 1695,
    "deathYear": 1754,
    "birthDate": "16 Oct 1695",
    "deathDate": "8 Jun 1754",
    "burialDate": "1754",
    "christeningDate": "16 Oct 1695",
    "birthPlace": "Solingen, North Rhine-Westphalia, Germany",
    "deathPlace": "Reisterstown, Baltimore, Maryland, British Colonial America",
    "burialPlace": "Long Family Cemetery, Broadfording, Washington, Maryland, United States",
    "christeningPlace": "Solingen, North Rhine-Westphalia, Germany",
    "fsId": "MSCJ-QSH",
    "photo": "/ancestors/bubbles/1962_MSCJ-QSH.jpg",
    "living": false,
    "alternateNames": [
      "Johan Peter Studebaker",
      "Peter Studebaker",
      "Johann Peter Stutenbaker"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1962_MSCJ-QSH.jpg"
  },
  {
    "id": "AQI1320",
    "name": "Anna Margaretha Aschauer",
    "sex": "F",
    "gen": 10,
    "slot": 939,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI785",
    "birthYear": 1702,
    "deathYear": 1740,
    "birthDate": "24 May 1702",
    "deathDate": "1740",
    "burialDate": "1740",
    "christeningDate": null,
    "birthPlace": "Rhineland-Palatinate, Germany",
    "deathPlace": "Broadfording, Washington, Maryland, United States",
    "burialPlace": "Long Family Cemetery, Broadfording, Washington, Maryland, United States",
    "christeningPlace": "Reinland, Marienburg, West Prussia, Prussia, Germany",
    "fsId": "LVRN-YT2",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1321",
    "name": "Johann Michael Bostetter",
    "sex": "M",
    "gen": 10,
    "slot": 940,
    "side": "maternal",
    "birthplace": "france",
    "childId": "AQI786",
    "birthYear": 1700,
    "deathYear": 1732,
    "birthDate": "1700",
    "deathDate": "9 Nov 1732",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Kauffenheim, Bas-Rhin, France",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "KGVN-YR1",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1322",
    "name": "Anna Catharina Gress",
    "sex": "F",
    "gen": 10,
    "slot": 941,
    "side": "maternal",
    "birthplace": "france",
    "childId": "AQI786",
    "birthYear": 1702,
    "deathYear": 1784,
    "birthDate": "1 Oct 1702",
    "deathDate": "21 Jan 1784",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Kauffenheim, Bas-Rhin, France",
    "deathPlace": "Kauffenheim, Bas-Rhin, France",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "KGVN-YBM",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Anna Catharine Gress"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1323",
    "name": "Johan Nicholas Long",
    "sex": "M",
    "gen": 10,
    "slot": 942,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI787",
    "birthYear": 1702,
    "deathYear": 1776,
    "birthDate": "6 Feb 1702",
    "deathDate": "1776",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Solingen, North Rhine-Westphalia, Germany",
    "deathPlace": "Frederick, Maryland, British Colonial America",
    "burialPlace": "Frederick, Maryland, British Colonial America",
    "christeningPlace": null,
    "fsId": "LZ46-MPJ",
    "photo": null,
    "living": false,
    "alternateNames": [
      "John Nicholas Long",
      "Johann Nicholas Long",
      "Johann Lang",
      "John Nicholas Long I",
      "Nicholas Lang"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1324",
    "name": "Anna Maria Studebaker Staudenbecker Stutenbecker",
    "sex": "F",
    "gen": 10,
    "slot": 943,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI787",
    "birthYear": 1702,
    "deathYear": 1776,
    "birthDate": "10 Oct 1702",
    "deathDate": "Bef 1776",
    "burialDate": "Jun 1776",
    "christeningDate": "15 Oct 1702",
    "birthPlace": "Hagen, North Rhine-Westphalia, Germany",
    "deathPlace": "Broadfording, Washington, Maryland, United States",
    "burialPlace": "Long Family Cemetery, Broadfording, Washington, Maryland, United States",
    "christeningPlace": "Lüttringhausen, Lennep, Rhineland, Prussia",
    "fsId": "LZL7-MR7",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Anna Marie Stutenbecker",
      "Long"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1240s944",
    "name": "Joannes Theobald Burger",
    "sex": "M",
    "gen": 10,
    "slot": 944,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI743s472",
    "birthYear": 1684,
    "deathYear": 1760,
    "birthDate": "18 Jun 1684",
    "deathDate": "10 Jun 1760",
    "burialDate": "10 Jun 1760",
    "christeningDate": "18 Jun 1684",
    "birthPlace": "Ottersweier, Rastatt, Baden-Württemberg, Germany",
    "deathPlace": null,
    "burialPlace": "Ottersweier, Rastatt, Baden-Württemberg, Germany",
    "christeningPlace": "Ottersweier, Rastatt, Baden-Württemberg, Germany",
    "fsId": "LT3C-QR3",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Theobald Burger"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1241s945",
    "name": "Barbara Junger",
    "sex": "F",
    "gen": 10,
    "slot": 945,
    "side": "maternal",
    "birthplace": "unknown",
    "childId": "AQI743s472",
    "birthYear": null,
    "deathYear": null,
    "birthDate": null,
    "deathDate": null,
    "burialDate": "9 Dec 1772",
    "christeningDate": "4 Dec 1687",
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": "Ottersweier, Rastatt, Baden-Württemberg, Germany",
    "christeningPlace": "Ottersweier, Rastatt, Baden-Württemberg, Germany",
    "fsId": "LKQX-ZDJ",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1325",
    "name": "Johann Peter Wetzstein",
    "sex": "M",
    "gen": 10,
    "slot": 948,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI788",
    "birthYear": 1700,
    "deathYear": 1778,
    "birthDate": "1 Feb 1700",
    "deathDate": "Dec 1778",
    "burialDate": null,
    "christeningDate": "1 Feb 1700",
    "birthPlace": "Wollenberg, Sinsheim, Baden, Germany",
    "deathPlace": "Conococheague, Washington, Maryland, United States",
    "burialPlace": null,
    "christeningPlace": "Hüffenhardt, Mosbach, Baden, Germany",
    "fsId": "LXQJ-RRQ",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Peter Whetstone"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1326",
    "name": "Anna Ursula Heilig",
    "sex": "F",
    "gen": 10,
    "slot": 949,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI788",
    "birthYear": 1714,
    "deathYear": 1778,
    "birthDate": "1714",
    "deathDate": "Bef 1778",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Sigmaringen, Baden-Württemberg, Germany",
    "deathPlace": "Funkstown, Washington, Maryland, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LHHS-8HN",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Anna Ursula Heilig Helig ()",
      "Anna Ursula Heilig/ Helig ()",
      "Anna Ursula Heilig?",
      "Whetstone",
      "Whetstine"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1327",
    "name": "Gertraud Erich Bund",
    "sex": "M",
    "gen": 10,
    "slot": 950,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI789",
    "birthYear": 1730,
    "deathYear": 1790,
    "birthDate": "Abt 1730",
    "deathDate": "Abt 1790",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Baden",
    "deathPlace": "Washington, Maryland, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LW6G-WZ2",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Gertraud Bund"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1328",
    "name": "Catharina Margaretha Carter",
    "sex": "F",
    "gen": 10,
    "slot": 951,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI789",
    "birthYear": 1727,
    "deathYear": 1753,
    "birthDate": "23 Jun 1727",
    "deathDate": "Aft 1753",
    "burialDate": null,
    "christeningDate": "24 Jun 1727",
    "birthPlace": "Oberamt Weinsberg, Württemberg",
    "deathPlace": "Bertie, North Carolina, British Colonial America",
    "burialPlace": null,
    "christeningPlace": "Weinsberg, Oberamt Weinsberg, Württemberg",
    "fsId": "G745-QTT",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Catharina Margaretha Bund"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1329",
    "name": "Heinrich Braun",
    "sex": "M",
    "gen": 10,
    "slot": 952,
    "side": "maternal",
    "birthplace": "unknown",
    "childId": "AQI790",
    "birthYear": null,
    "deathYear": 1750,
    "birthDate": null,
    "deathDate": "28 Mar 1750",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": null,
    "deathPlace": "Woodbury Township, Bedford, Pennsylvania, British Colonial America",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "PSNT-PCH",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1330",
    "name": "Catharina",
    "sex": "F",
    "gen": 10,
    "slot": 953,
    "side": "maternal",
    "birthplace": "unknown",
    "childId": "AQI790",
    "birthYear": null,
    "deathYear": null,
    "birthDate": null,
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "PSNY-J37",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1331",
    "name": "Friedrich Carl Hörner",
    "sex": "M",
    "gen": 10,
    "slot": 954,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI791",
    "birthYear": 1703,
    "deathYear": null,
    "birthDate": "1703",
    "deathDate": null,
    "burialDate": "24 Mar 1788",
    "christeningDate": null,
    "birthPlace": "Germany",
    "deathPlace": null,
    "burialPlace": "Berks, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "M41R-CF6",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1332",
    "name": "Anna Catharina Schaub",
    "sex": "F",
    "gen": 10,
    "slot": 955,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI791",
    "birthYear": 1710,
    "deathYear": 1781,
    "birthDate": "1 Jan 1710",
    "deathDate": "10 Mar 1781",
    "burialDate": "11 Mar 1781",
    "christeningDate": null,
    "birthPlace": "Gallenweiler, Staufen, Baden, Germany",
    "deathPlace": null,
    "burialPlace": "Karlsruhe, Baden",
    "christeningPlace": null,
    "fsId": "9J3J-P2H",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1333",
    "name": "Stephen Waggoner Ulrich",
    "sex": "M",
    "gen": 10,
    "slot": 956,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI792",
    "birthYear": 1710,
    "deathYear": 1785,
    "birthDate": "Apr 1710",
    "deathDate": "1785",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Mannheim, Baden-Württemberg, Germany",
    "deathPlace": "Leitersburg, Washington, Maryland, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LD27-DRF",
    "photo": "/ancestors/bubbles/1980_LD27-DRF.jpg",
    "living": false,
    "alternateNames": [
      "Stephen Ulderey",
      "Stephen Ulrich",
      "Stefan Ulrich"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1980_LD27-DRF.jpg"
  },
  {
    "id": "AQI1334",
    "name": "Elizabeth Falgues",
    "sex": "F",
    "gen": 10,
    "slot": 957,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI792",
    "birthYear": 1720,
    "deathYear": 1782,
    "birthDate": "1720",
    "deathDate": "1782",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Baden-Württemberg, Germany",
    "deathPlace": "Washington, Maryland, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LD27-YCZ",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Elizabeth Cripe or Greib"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1335",
    "name": "Jacob \"Jockel\" Brumbaugh",
    "sex": "M",
    "gen": 10,
    "slot": 958,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI793",
    "birthYear": 1734,
    "deathYear": 1816,
    "birthDate": "27 Nov 1734",
    "deathDate": "13 Aug 1816",
    "burialDate": "Aug 1816",
    "christeningDate": "5 Dec 1734",
    "birthPlace": "Bockenbach, Kreuztal, Siegen-Wittgenstein, North Rhine-Westphalia, Germany",
    "deathPlace": "Hopewell Township, Huntingdon, Pennsylvania, United States",
    "burialPlace": "Union Cemetery, Marklesburg, Huntingdon, Pennsylvania, United States",
    "christeningPlace": "Krombach, Siegen, Westphalia, Prussia, Germany",
    "fsId": "L6R5-11R",
    "photo": "/ancestors/bubbles/1982_L6R5-11R.jpg",
    "living": false,
    "alternateNames": [
      "Jacob B. Brumbaugh",
      "Jockel Brumbaugh",
      "Jacob Bromback",
      "Johann Jacob Brombach"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1982_L6R5-11R.jpg"
  },
  {
    "id": "AQI1336",
    "name": "Mary Elizabeth Engel",
    "sex": "F",
    "gen": 10,
    "slot": 959,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI793",
    "birthYear": 1740,
    "deathYear": 1806,
    "birthDate": "1740",
    "deathDate": "28 Jan 1806",
    "burialDate": "1806",
    "christeningDate": null,
    "birthPlace": "Washington, Maryland, United States",
    "deathPlace": "Bedford, Pennsylvania, United States",
    "burialPlace": "Hagerstown, Washington, Maryland, United States",
    "christeningPlace": null,
    "fsId": "G3L6-NW4",
    "photo": "/ancestors/bubbles/1983_G3L6-NW4.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1983_G3L6-NW4.jpg"
  },
  {
    "id": "AQI1337",
    "name": "John Jacob Gochenauer",
    "sex": "M",
    "gen": 10,
    "slot": 960,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI794",
    "birthYear": 1696,
    "deathYear": 1758,
    "birthDate": "1696",
    "deathDate": "11 Nov 1758",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Kohlhof, Bad Rappenau, Heilbronn, Baden-Württemberg, Germany",
    "deathPlace": "Manheim, Lancaster, Pennsylvania, British Colonial America",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "L2MQ-HNG",
    "photo": "/ancestors/bubbles/1984_L2MQ-HNG.jpg",
    "living": false,
    "alternateNames": [
      "Jacob Cochnauer",
      "Jacob Gochenour",
      "Jacob Gochnower"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1984_L2MQ-HNG.jpg"
  },
  {
    "id": "AQI1338",
    "name": "Elizabeth Catharina Post",
    "sex": "F",
    "gen": 10,
    "slot": 961,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI794",
    "birthYear": 1699,
    "deathYear": 1735,
    "birthDate": "15 Jun 1699",
    "deathDate": "1735",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Lünern, Unna, Hamm, Westphalia, Prussia, Germany",
    "deathPlace": "Manheim, Lancaster, Pennsylvania, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "GHVZ-DYW",
    "photo": "/ancestors/bubbles/1985_GHVZ-DYW.jpg",
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/1985_GHVZ-DYW.jpg"
  },
  {
    "id": "AQI1339",
    "name": "Charles Sheetz",
    "sex": "M",
    "gen": 10,
    "slot": 962,
    "side": "maternal",
    "birthplace": "switzerland",
    "childId": "AQI795",
    "birthYear": 1710,
    "deathYear": null,
    "birthDate": "Abt 1710",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Switzerland",
    "deathPlace": "Pennsylvania, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "9H6G-WFP",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1340",
    "name": "Georgene Rosseau",
    "sex": "F",
    "gen": 10,
    "slot": 963,
    "side": "maternal",
    "birthplace": "belgium",
    "childId": "AQI795",
    "birthYear": 1715,
    "deathYear": 1748,
    "birthDate": "1715",
    "deathDate": "1748",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Wallonia, Belgium",
    "deathPlace": "Berks, Pennsylvania, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "L1PL-RFK",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1341",
    "name": "Andreas Stauch",
    "sex": "M",
    "gen": 10,
    "slot": 994,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI797",
    "birthYear": 1682,
    "deathYear": 1749,
    "birthDate": "30 Nov 1682",
    "deathDate": "8 Nov 1749",
    "burialDate": "8 Nov 1749",
    "christeningDate": "30 Nov 1682",
    "birthPlace": "Malmsheim, Oberamt Leonberg, Württemberg, Germany",
    "deathPlace": "Malmsheim, Oberamt Leonberg, Württemberg, Germany",
    "burialPlace": "Malmsheim, Oberamt Leonberg, Württemberg, Germany",
    "christeningPlace": "Malmsheim, Oberamt Leonberg, Württemberg, Germany",
    "fsId": "LK5R-K19",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1342",
    "name": "Maria Barbara Geÿers",
    "sex": "F",
    "gen": 10,
    "slot": 995,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI797",
    "birthYear": 1680,
    "deathYear": null,
    "birthDate": "Abt 1680",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Magstadt, Oberamt Böblingen, Württemberg, Germany",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "9KBT-HW5",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1343",
    "name": "William Mummert",
    "sex": "M",
    "gen": 10,
    "slot": 1002,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI799",
    "birthYear": 1680,
    "deathYear": 1760,
    "birthDate": "Abt 1680",
    "deathDate": "Abt 1760",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Germany",
    "deathPlace": "Germany",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "GXPC-G9C",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1344",
    "name": "Gertrudi Mittler",
    "sex": "F",
    "gen": 10,
    "slot": 1003,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI799",
    "birthYear": 1685,
    "deathYear": null,
    "birthDate": "1685",
    "deathDate": null,
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Germany",
    "deathPlace": "Germany",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "PZ1Y-566",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1349",
    "name": "Mathias Bausser",
    "sex": "M",
    "gen": 10,
    "slot": 1004,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI800",
    "birthYear": 1670,
    "deathYear": 1733,
    "birthDate": "27 Sep 1670",
    "deathDate": "Sep 1733",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Palatinate, Bavaria, Germany",
    "deathPlace": "Lancaster, Pennsylvania, British Colonial America",
    "burialPlace": "Lancaster, Pennsylvania, British Colonial America",
    "christeningPlace": null,
    "fsId": "LKPS-PGM",
    "photo": "/ancestors/bubbles/2028_LKPS-PGM.jpg",
    "living": false,
    "alternateNames": [
      "Mathias Bauser",
      "Mathias Bouser",
      "Mathias Mattheus Bowser Bausser",
      "Mathias BOWSER Sr.",
      "Bausser Mathias Sr",
      "Bowser",
      "Mathias Imm Bausser Bowser",
      "Matthew Bauser Sr.",
      "Mathias Imm Bausser Sr."
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/2028_LKPS-PGM.jpg"
  },
  {
    "id": "AQI1350",
    "name": "Esther Borth",
    "sex": "F",
    "gen": 10,
    "slot": 1005,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI800",
    "birthYear": 1684,
    "deathYear": 1733,
    "birthDate": "1684",
    "deathDate": "Aft Sep 1733",
    "burialDate": "Aft 28 Sep 1733",
    "christeningDate": null,
    "birthPlace": "Palatinate, Bavaria, Germany",
    "deathPlace": "Lancaster, Pennsylvania, British Colonial America",
    "burialPlace": "Lancaster, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LV79-4PG",
    "photo": "/ancestors/bubbles/2029_LV79-4PG.jpg",
    "living": false,
    "alternateNames": [
      "Esther BAUSSER",
      "Esther"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/2029_LV79-4PG.jpg"
  },
  {
    "id": "AQI1351",
    "name": "Martin Schellenberg",
    "sex": "M",
    "gen": 10,
    "slot": 1006,
    "side": "maternal",
    "birthplace": "unknown",
    "childId": "AQI801",
    "birthYear": null,
    "deathYear": null,
    "birthDate": null,
    "deathDate": null,
    "burialDate": null,
    "christeningDate": "28 Nov 1706",
    "birthPlace": null,
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": "Wallisellen, Zürich, Switzerland",
    "fsId": "KNHS-414",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1352",
    "name": "Veronica Bentz",
    "sex": "F",
    "gen": 10,
    "slot": 1007,
    "side": "maternal",
    "birthplace": "switzerland",
    "childId": "AQI801",
    "birthYear": 1713,
    "deathYear": 1798,
    "birthDate": "Abt 13 Apr 1713",
    "deathDate": "Abt 12 Nov 1798",
    "burialDate": "12 Nov 1798",
    "christeningDate": "13 Apr 1713",
    "birthPlace": "Switzerland",
    "deathPlace": "Lancaster, Pennsylvania, United States",
    "burialPlace": null,
    "christeningPlace": "Wallisellen, Zürich, Switzerland",
    "fsId": "KCNQ-7HY",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Feronica",
      "Verena"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1353",
    "name": "Johann Jacob Clar",
    "sex": "M",
    "gen": 10,
    "slot": 1008,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI802",
    "birthYear": 1699,
    "deathYear": 1740,
    "birthDate": "23 Nov 1699",
    "deathDate": "Nov 1740",
    "burialDate": "Nov 1740",
    "christeningDate": "23 Nov 1699",
    "birthPlace": "Palatinate, Bavaria, Germany",
    "deathPlace": "At Sea",
    "burialPlace": "At Sea",
    "christeningPlace": "Palatinate, Bavaria, Germany",
    "fsId": "LC87-RFX",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Jacob ( Clar) Claar",
      "Jacob ( imm) Clar",
      "Jacob Claar",
      "Jacob Clar",
      "Joh. Jacob Clar",
      "Joh. Jacob Clar , (Klar, Claar)",
      "Johan Jakob Claar",
      "Johann Jacob Claar",
      "Johann Jacob Klahr",
      "Johann Jacob Klar"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1354",
    "name": "Anna Maria Raber",
    "sex": "F",
    "gen": 10,
    "slot": 1009,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI802",
    "birthYear": 1701,
    "deathYear": 1740,
    "birthDate": "13 Mar 1701",
    "deathDate": "Nov 1740",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Winterlingen, Kreis Balingen, Württemberg, Germany",
    "deathPlace": "At Sea",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "LBFF-CC5",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Anna Raber",
      "Anna Maria Reber"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1355",
    "name": "Johannes Nicholas Klee",
    "sex": "M",
    "gen": 10,
    "slot": 1010,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI803",
    "birthYear": 1708,
    "deathYear": 1763,
    "birthDate": "20 Jan 1708",
    "deathDate": "Aug 1763",
    "burialDate": "7 Nov 1763",
    "christeningDate": "20 Jan 1708",
    "birthPlace": "Oldenburg, Steyerberg, Nienburg, Lower Saxony, Germany",
    "deathPlace": "Berne, Tilden Township, Berks, Pennsylvania, United States",
    "burialPlace": "Bern Township, Berks, Pennsylvania, United States",
    "christeningPlace": "Wolfersweiler, Nohfelden, Sankt Wendel, Saarland, Germany",
    "fsId": "LCVQ-BZT",
    "photo": "/ancestors/bubbles/2034_LCVQ-BZT.jpg",
    "living": false,
    "alternateNames": [
      "Joanni Kley",
      "Johann Nickel Klee",
      "Nicholas Klea",
      "Nicholas Clay",
      "Johann Nicholas Klee",
      "Johan Nickell Klee",
      "Nickell. Nicholas AKA Hans"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/2034_LCVQ-BZT.jpg"
  },
  {
    "id": "AQI1356",
    "name": "Elisabeth “Lisa” Margaretha Staudt",
    "sex": "F",
    "gen": 10,
    "slot": 1011,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI803",
    "birthYear": 1715,
    "deathYear": 1786,
    "birthDate": "Bef 24 Mar 1715",
    "deathDate": "1786",
    "burialDate": "1786",
    "christeningDate": "24 Mar 1715",
    "birthPlace": "Gimbweiler, Birkenfeld, Rhineland-Palatinate, Germany",
    "deathPlace": "Bernville, Berks, Pennsylvania, United States",
    "burialPlace": "Leesport, Berks, Pennsylvania, United States",
    "christeningPlace": "Wolfersweiler, Nohfelden, Sankt Wendel, Saarland, Germany",
    "fsId": "M3NF-4TH",
    "photo": "/ancestors/bubbles/2035_M3NF-4TH.jpg",
    "living": false,
    "alternateNames": [
      "Liza Margarete Staudt",
      "Klee",
      "Liza Margarete Klee"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/2035_M3NF-4TH.jpg"
  },
  {
    "id": "AQI1357",
    "name": "Rudolph Imm Walter",
    "sex": "M",
    "gen": 10,
    "slot": 1012,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI804",
    "birthYear": 1695,
    "deathYear": 1795,
    "birthDate": "12 Feb 1695",
    "deathDate": "12 Feb 1795",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Palatinate, Holy Roman Empire",
    "deathPlace": "Montgomery Township, Montgomery, Pennsylvania, United States",
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "GJLB-GV6",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1358",
    "name": "Hannah Barbara Imler",
    "sex": "F",
    "gen": 10,
    "slot": 1013,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI804",
    "birthYear": 1690,
    "deathYear": 1747,
    "birthDate": "1690",
    "deathDate": "13 Nov 1747",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "Waldangelloch, Sinsheim, Rhein-Neckar-Kreis, Baden-Württemberg, Germany",
    "deathPlace": "Philadelphia, Montgomery, Pennsylvania",
    "burialPlace": "Lansdale, Montgomery, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "GJLB-FNZ",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Hannah Walter"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1360",
    "name": "Georg Mark Imler",
    "sex": "M",
    "gen": 10,
    "slot": 1014,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI805",
    "birthYear": 1706,
    "deathYear": 1788,
    "birthDate": "30 Jun 1706",
    "deathDate": "1788",
    "burialDate": "1788",
    "christeningDate": "1706",
    "birthPlace": "Karlsruhe, Baden",
    "deathPlace": "Paradise Township, York, Pennsylvania, United States",
    "burialPlace": "Bedford, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LBD8-Q2L",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI1361",
    "name": "Esther Anna Teresia Schaber",
    "sex": "F",
    "gen": 10,
    "slot": 1015,
    "side": "maternal",
    "birthplace": "germany",
    "childId": "AQI805",
    "birthYear": 1709,
    "deathYear": 1743,
    "birthDate": "13 Oct 1709",
    "deathDate": "1743",
    "burialDate": null,
    "christeningDate": "13 Oct 1709",
    "birthPlace": "Waldangelloch, Sinsheim, Rhein-Neckar-Kreis, Baden-Württemberg, Germany",
    "deathPlace": "Dutch Corner, Bedford Township, Bedford, Pennsylvania, United States",
    "burialPlace": null,
    "christeningPlace": "Waldangelloch, Sinsheim, Baden, Germany",
    "fsId": "LCDQ-8XD",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Ester Ana Immler (Schabert)",
      "Imler",
      "Ester Anna Teresia Shaber Imler",
      "Ester Anna Schaber\\Schabert",
      "Schaber"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI759s1016",
    "name": "Johann Peter Ickes",
    "sex": "M",
    "gen": 10,
    "slot": 1016,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI439s508",
    "birthYear": 1717,
    "deathYear": 1765,
    "birthDate": "18 Sep 1717",
    "deathDate": "11 Jul 1765",
    "burialDate": "11 Jul 1765",
    "christeningDate": null,
    "birthPlace": "Schoharie, Albany, New York Colony, British Colonial America",
    "deathPlace": "Philadelphia, Pennsylvania, United States",
    "burialPlace": "Swamp Lutheran Church Cemetery, New Hanover Township, Montgomery, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LW7N-5HF",
    "photo": "/ancestors/bubbles/0936_LW7N-5HF.jpg",
    "living": false,
    "alternateNames": [
      "Johannes Ickes",
      "John Peter Ickes",
      "Peter Ickes",
      "John"
    ],
    "facts": [],
    "sketch": "",
    "sources": [],
    "portrait": "/ancestors/portraits/0936_LW7N-5HF.jpg"
  },
  {
    "id": "AQI760s1017",
    "name": "Barbara B Fickes",
    "sex": "F",
    "gen": 10,
    "slot": 1017,
    "side": "maternal",
    "birthplace": "united-states",
    "childId": "AQI439s508",
    "birthYear": 1718,
    "deathYear": 1808,
    "birthDate": "2 Sep 1718",
    "deathDate": "27 Jan 1808",
    "burialDate": "27 Jan 1808",
    "christeningDate": null,
    "birthPlace": "Limerick Township, Montgomery, Pennsylvania, United States",
    "deathPlace": "Limerick Township, Montgomery, Pennsylvania, United States",
    "burialPlace": "Limerick Township, Montgomery, Pennsylvania, United States",
    "christeningPlace": null,
    "fsId": "LCTR-RQ6",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI761s1018",
    "name": "Johann Jacob Stambach",
    "sex": "M",
    "gen": 10,
    "slot": 1018,
    "side": "maternal",
    "birthplace": "france",
    "childId": "AQI440s509",
    "birthYear": 1719,
    "deathYear": 1800,
    "birthDate": "9 Jan 1719",
    "deathDate": "6 Jun 1800",
    "burialDate": null,
    "christeningDate": "11 Jan 1719",
    "birthPlace": "Alsace, France",
    "deathPlace": "Strasbourg, Bas-Rhin, France",
    "burialPlace": "Moulstown Cemetery, Moulstown, Heidelberg Township, York, Pennsylvania, United States",
    "christeningPlace": "Kutzenhausen, Bas-Rhin, France",
    "fsId": "LHZV-JQ2",
    "photo": null,
    "living": false,
    "alternateNames": [],
    "facts": [],
    "sketch": "",
    "sources": []
  },
  {
    "id": "AQI762s1019",
    "name": "Margaret",
    "sex": "F",
    "gen": 10,
    "slot": 1019,
    "side": "maternal",
    "birthplace": "france",
    "childId": "AQI440s509",
    "birthYear": 1719,
    "deathYear": 1752,
    "birthDate": "Abt 1719",
    "deathDate": "Abt 1752",
    "burialDate": null,
    "christeningDate": null,
    "birthPlace": "France",
    "deathPlace": null,
    "burialPlace": null,
    "christeningPlace": null,
    "fsId": "GXFG-PGV",
    "photo": null,
    "living": false,
    "alternateNames": [
      "Margaret Stambach"
    ],
    "facts": [],
    "sketch": "",
    "sources": []
  }
];

function ordinal(n) {
  if (n === 2) return '2nd';
  if (n === 3) return '3rd';
  return n + 'th';
}

export function ancestorRelationship(person) {
  if (!person || person.gen === 0) return 'Self';
  const side = person.gen >= 2 ? (person.side === 'maternal' ? 'Maternal ' : 'Paternal ') : '';
  const male = person.sex !== 'F';
  if (person.gen === 1) return male ? 'Father' : 'Mother';
  if (person.gen === 2) return side + (male ? 'grandfather' : 'grandmother');
  if (person.gen === 3) return side + (male ? 'great-grandfather' : 'great-grandmother');
  const noun = male ? 'great-grandfather' : 'great-grandmother';
  return side + ordinal(person.gen - 2) + ' ' + noun;
}

function lifeEvent(kind, date, place, note) {
  if (!date && !place && !note) return null;
  return { kind: kind, date: date || null, place: place || null, note: note || null };
}

function specificPlace(place, fallback) {
  if (!place) return fallback;
  const parts = place.split(',').map(function (part) { return part.trim(); }).filter(function (part) {
    return part && part.toLowerCase() !== 'of';
  });
  if (!parts.length) return fallback;
  const countries = {
    'united states': 1,
    'united kingdom': 1,
    usa: 1,
    us: 1,
    england: 1,
    wales: 1,
    switzerland: 1,
    schweiz: 1,
    denmark: 1,
    ireland: 1,
    germany: 1,
    'british colonial america': 1,
    france: 1,
    netherlands: 1,
    holland: 1,
    austria: 1,
    belgium: 1,
    'holy roman empire': 1,
  };
  const city = parts[0];
  let region = '';
  for (let i = parts.length - 1; i >= 0; i -= 1) {
    const part = parts[i];
    if (part !== city && !countries[part.toLowerCase()]) {
      region = part;
      break;
    }
  }
  region = region.replace(' Territory', '');
  if (region && region.toLowerCase() !== city.toLowerCase()) return city + ', ' + region;
  return city;
}

export function ancestorDetail(id) {
  const person = ANCESTORS.find((p) => p.id === id);
  if (!person) return null;
  const place = BIRTHPLACE_BY_ID[person.birthplace] || { label: 'Unrecorded', color: '#6e756f' };
  const events = [
    lifeEvent('Born', person.birthDate || (person.birthYear ? String(person.birthYear) : null), person.birthPlace, null),
    lifeEvent('Christened', person.christeningDate, person.christeningPlace, null),
    lifeEvent('Died', person.deathDate || (person.deathYear ? String(person.deathYear) : null), person.deathPlace, null),
    lifeEvent('Buried', person.burialDate, person.burialPlace, null),
  ].concat((person.facts || []).map(function (fact) {
    return lifeEvent(fact.kind, fact.date, fact.place, fact.note);
  })).filter(Boolean);
  events.sort(function (a, b) {
    const year = function (event) {
      const match = String(event.date || '').match(/\d{3,4}/g);
      return match ? Number(match[match.length - 1]) : 9999;
    };
    const rank = function (event) {
      if (event.kind === 'Born') return 0;
      if (event.kind === 'Christened') return 1;
      if (event.kind === 'Died') return 8;
      if (event.kind === 'Buried') return 9;
      return 4;
    };
    return (year(a) - year(b)) || (rank(a) - rank(b));
  });
  const links = person.fsId
    ? [
        { label: 'FamilySearch', href: 'https://www.familysearch.org/tree/person/details/' + person.fsId },
      ]
    : [];
  let date = null;
  if (person.birthYear && person.deathYear) date = person.birthYear + ' – ' + person.deathYear;
  else if (person.birthYear) date = 'b. ' + person.birthYear;
  else if (person.deathYear) date = 'd. ' + person.deathYear;
  return {
    id: person.id,
    title: person.name,
    subtitle: ancestorRelationship(person),
    status: specificPlace(person.birthPlace, place.label),
    accent: place.color,
    date: date,
    description: person.sketch || '',
    events: events,
    images: [],
    portrait: person.portrait || person.photo || null,
    fsId: person.fsId || null,
    alsoKnown: person.alternateNames || [],
    sources: person.sources || [],
    links: links,
  };
}
